// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
/* eslint-disable @typescript-eslint/naming-convention */
const DMC_AlscoMetals = {
  Alsco_034_Linen: 21111,
  Alsco_045_Wicker: 21112,
  Alsco_049_Champagne: 21113,
  Alsco_050_Beige: 21114,
  Alsco_054_Tan: 21115,
  Alsco_055_Gray: 21116,
  Alsco_056_Silver: 21117,
  Alsco_062_VintageSage: 21118,
  Alsco_066_SandDune: 21119,
  Alsco_067_JeffersonTan: 21120,
  Alsco_073_Cornsilk: 21121,
  Alsco_126_MidnightShadow: 21122,
  Alsco_127_GardenSage: 21123,
  Alsco_128_HoneyHarvesy: 21124,
  Alsco_15_Mocha: 21125,
  Alsco_155_LightMaple: 21126,
  Alsco_169_SableBrown: 21127,
  Alsco_17_Stone: 21128,
  Alsco_174_StormGray: 21129,
  Alsco_177_SandyBeige: 21130,
  Alsco_20_AntiqueAlmond: 21131,
  Alsco_200_Black: 21132,
  Alsco_202_RoyalBrown: 21133,
  Alsco_204_GrecianGreen: 21134,
  Alsco_22_SlateGrey: 21135,
  Alsco_249_Bronze: 21136,
  Alsco_250_MusketBrown: 21137,
  Alsco_253_Terratone: 21138,
  Alsco_255_Cypress: 21139,
  Alsco_309_MusketBrown: 21140,
  Alsco_315_BarnRed: 21141,
  Alsco_319_PacificBlue: 21142,
  Alsco_331_Flagstone: 21143,
  Alsco_361_LightMist: 21144,
  Alsco_362_MontereyTaupe: 21145,
  Alsco_38_Sungold: 21146,
  Alsco_409_Granite: 21147,
  Alsco_411_Seagrass: 21148,
  Alsco_441_Shamrock: 21149,
  Alsco_445_ToastedAlmond: 21150,
  Alsco_447_Ironstone: 21151,
  Alsco_448_WeatheredGray: 21152,
  Alsco_45_ForestGreen: 21153,
  Alsco_47_CottageWhite: 21154,
  Alsco_471_BlueRidge: 21155,
  Alsco_472_Onyx: 21156,
  Alsco_473_Woodland: 21157,
  Alsco_474_CoffeeBean: 21158,
  Alsco_476_Flint: 21159,
  Alsco_478_SilverMist: 21160,
  Alsco_509_CountryBeige: 21161,
  Alsco_60_Carmel: 21162,
  Alsco_61_Acorn: 21163,
  Alsco_627_GraniteGray: 21164,
  Alsco_632_SunnyMaize: 21165,
  Alsco_680_HamptonBlue: 21166,
  Alsco_682_GraniteGray: 21167,
  Alsco_683_HeritageCream: 21168,
  Alsco_685_SavannahWicker: 21169,
  Alsco_689_TimberBlend: 21170,
  Alsco_692_RichmondRed: 21171,
  Alsco_707_NightGray: 21172,
  Alsco_708_DeepOcean: 21173,
  Alsco_713_Almond: 21174,
  Alsco_714_Sierra: 21175,
  Alsco_717_OxfordBlue: 21176,
  Alsco_722_Meadow: 21177,
  Alsco_736_ChelseaBlueWhite: 21178,
  Alsco_742_Wicker: 21179,
  Alsco_745_Almond: 21180,
  Alsco_750_Sandstone: 21181,
  Alsco_752_PebbleClay: 21182,
  Alsco_767_Twilight: 21183,
  Alsco_789_Linen: 21184,
  Alsco_805_Sierra: 21185,
  Alsco_806_GrecianGreen: 21186,
  Alsco_812_ConcordGreen: 21187,
  Alsco_827_Tan: 21188,
  Alsco_850_Beige: 21189,
  Alsco_851_Cream: 21190,
  Alsco_852_Wheat: 21191,
  Alsco_855_Gray: 21192,
  Alsco_856_Silver: 21193,
  Alsco_857_OakMoss: 21194,
  Alsco_858_Sand: 21195,
  Alsco_865_VintageSage: 21196,
  Alsco_878_White: 10708,
  Alsco_879_DesertSand: 21197,
  Alsco_889_RoyalBrown: 21198,
  Alsco_897_SterlingGray: 21199,
  Alsco_900_WoodstockBrown: 21200,
  Alsco_902_CobbleStone: 21201,
  Alsco_903_KhakiBrown: 21202,
  Alsco_904_ArcticWhite: 21203,
  Alsco_905_NavajoBeige: 21204,
  Alsco_907_EveningBlue: 21205,
  Alsco_909_MusketBrown: 21206,
  Alsco_90R_GraniteGray: 21207,
  Alsco_910_BoothbayBlue: 21208,
  Alsco_919_IronGray: 21209,
  Alsco_91R_Bronze: 10709,
  Alsco_921_PearlGray: 21210,
  Alsco_928_AutumnTaupe: 21211,
  Alsco_92R_IronGray: 21212,
  Alsco_930_SummerWheat: 21213,
  Alsco_93R_EmberGray: 21214,
  Alsco_94R_AntiqueAlmond: 21215,
  Alsco_95R_ChocolateBrown: 21216,
  Alsco_969_TimberBark: 21217,
  Alsco_96R_RoyalBrown: 21218,
  Alsco_978_Sandcastle: 21219,
  Alsco_97R_CobbleStone: 21220,
  Alsco_981_Wicker: 21221,
  Alsco_98R_MountainSage: 21222,
  Alsco_999_Sandalwood: 21223,
  Alsco_99R_Willow: 21224,
  Alsco_B50_SavannahBlue: 21225,
  Alsco_B51_Flint: 21226,
  Alsco_C08_HearthstoneBrown: 21227,
  Alsco_C10_Rockslide: 21228,
  Alsco_C14_Regatta: 21229,
  Alsco_C18_LighthouseRed: 21230,
  Alsco_C20_Espresso: 21231,
  Alsco_C30_Sterling: 21232,
  Alsco_C36_Almond: 21233,
  Alsco_D20_FAWhite: 21234,
  Alsco_D23_Tan: 21235,
  Alsco_D24_Clay: 21236,
  Alsco_D26_CharcoalGray: 21237,
  Alsco_D33_HeritageBlue: 21238,
  Alsco_E04_Wicker: 21239,
  Alsco_E05_PebbleClay: 21240,
  Alsco_FinishSmooth: 21241,
  Alsco_L23_QuarryGray: 21242,
  Alsco_N15_CanyonGreen: 21243,
  Alsco_N27_GraniteGray: 21244,
  Alsco_N29_WedgewoodBlue: 21245,
  Alsco_N32_SunnyMaize: 21246,
  Alsco_N35_ProvidenceYellow: 21247,
  Alsco_N75_Java: 21248,
  Alsco_N80_HamptonBlue: 21249,
  Alsco_N84_Herringbone: 21250,
  Alsco_N92_HeritageRed: 21251,
  Alsco_N95_Brownstone: 21252,
  Alsco_P15_LightMaple: 21253,
  Alsco_P91_Champagne: 21254,
  Alsco_R01_WhiteDove: 21255,
  Alsco_R02_WarmTaupe: 21256,
  Alsco_R03_BoothbayBlue: 21257,
  Alsco_R22_Meadow: 21258,
  Alsco_R30_CountrylaneRed: 21259,
  Alsco_R50_Sandtone: 21260,
  Alsco_R52_ArtisanClay: 21261,
  Alsco_R61_BlueWhite: 21262,
  Alsco_R67_Twilight: 21263,
  Alsco_R69_CanyonRidge: 21264,
  Alsco_R90_DeepOcean: 21265,
  Alsco_R91_Timber: 21266,
  Alsco_R92_SandDune: 21267,
  Alsco_T41_GrayFlannel: 21268,
  Alsco_TAD_Almond: 10710,
  Alsco_TCS_Fern: 21269,
  Alsco_THO_HickoryOak: 21270,
  Alsco_TMK_Musket: 21271,
  Alsco_TSA_Sandstone: 21272,
  Alsco_V17_Topaz: 21273,
  Alsco_V62_Seagrass: 21274,
  Alsco_V74_Keystone: 21275,
  Alsco_VAD_Almond: 21276,
  Alsco_VSA_Sandstone: 21277,
  Alsco_VUU_NewLinen: 21278,
};

const DMC_Alside = {
  Alside_AdobeCream: 10314,
  Alside_AgelessSlate: 10315,
  Alside_AntiqueParchment: 10316,
  Alside_Black: 10317,
  Alside_Bronze: 10986,
  Alside_CanyonClay: 10318,
  Alside_CanyonDrift: 10319,
  Alside_CapeCodGray: 10320,
  Alside_CastIron: 10321,
  Alside_CharcoalSmoke: 10322,
  Alside_CoastalSage: 10323,
  Alside_CottageYellow: 21279,
  Alside_DeepEspresso: 10324,
  Alside_DeepMoss: 10325,
  Alside_DuneGrass: 21280,
  Alside_FireBrick: 21281,
  Alside_FiredBrick: 10326,
  Alside_FlagshipBrown: 10327,
  Alside_GlacierWhite: 10328,
  Alside_HarborBlue: 10329,
  Alside_JuniperRidge: 10330,
  Alside_LagunaBlue: 10331,
  Alside_Maple: 10332,
  Alside_MidnightBlue: 10333,
  Alside_MontereySand: 10334,
  Alside_MountainFern: 10335,
  Alside_MusketBrown: 10336,
  Alside_MysticBlue: 10337,
  Alside_NaturalLinen: 10338,
  Alside_PlatinumGray: 10339,
  Alside_RivieraDusk: 10340,
  Alside_RusticTimber: 10341,
  Alside_SandBar: 21282,
  Alside_SeaMist: 21283,
  Alside_SterlingGray: 10342,
  Alside_Storm: 10343,
  Alside_TerratoneBronze: 10987,
  Alside_TuscanClay: 10344,
  Alside_VintageWicker: 10345,
};

const DMC_Ascend = {
  Ascend_AgelessSlate: 1756,
  Ascend_Almond: 1757,
  Ascend_CanyonDrift: 1758,
  Ascend_CapeCodGray: 1759,
  Ascend_CastIron: 1760,
  Ascend_CharcoalSmoke: 1761,
  Ascend_DeepMoss: 1762,
  Ascend_DoverGray: 21284,
  Ascend_FiredBrick: 1763,
  Ascend_FlagshipBrown: 1764,
  Ascend_GlacierWhite: 1765,
  Ascend_HarborBlue: 1766,
  Ascend_LagunaBlue: 1767,
  Ascend_MidnightBlue: 1768,
  Ascend_MontereySand: 1769,
  Ascend_MountainFern: 1770,
  Ascend_Pebble: 1771,
  Ascend_RivieraDusk: 1772,
  Ascend_RusticTimber: 1773,
  Ascend_SterlingGray: 1774,
  Ascend_Storm: 1775,
};

const DMC_Behr = {
  Behr_12_SwissCoffee: 21285,
  Behr_13_CottageWhite: 21286,
  Behr_170E3_BridalRose: 1805,
  Behr_22_NavajoWhite: 21287,
  Behr_23_AntiqueWhite: 21288,
  Behr_230D4_PecosSpice: 1806,
  Behr_250F4_StoneBrown: 21289,
  Behr_270F4_PeanutButter: 21290,
  Behr_280F4_BurntAlmond: 21291,
  Behr_290C2_CreamyBeige: 1807,
  Behr_290E1_WeatheredSandstone: 21292,
  Behr_310E3_RipeWheat: 1808,
  Behr_320E1_PopcornBall: 21293,
  Behr_340F7_WovenBasket: 1809,
  Behr_350F4_QuietVeranda: 1810,
  Behr_400F4_Restful: 1811,
  Behr_420F6_EgyptianNile: 1812,
  Behr_460D7_SabalPalm: 1813,
  Behr_470F5_Garland: 1814,
  Behr_500D4_JamaicaBay: 1815,
  Behr_52_White: 21294,
  Behr_57_Frost: 21295,
  Behr_570A3_PacificPanorama: 1816,
  Behr_590D6_WickfordBay: 1817,
  Behr_70_LinenWhite: 21296,
  Behr_700D4_BrownTeepee: 21297,
  Behr_700D5_ToffeeCrunch: 21298,
  Behr_700D7_SouthKingston: 1818,
  Behr_710C2_RaffiaCream: 21299,
  Behr_710C3_GobiDesert: 21300,
  Behr_710D4_HarvestBrown: 1819,
  Behr_710E1_SnowLeopard: 1820,
  Behr_710E3_Rhino: 1821,
  Behr_710F4_SageGray: 21301,
  Behr_720C2_ChocolateFroth: 21302,
  Behr_720C3_WheatBread: 21303,
  Behr_720D4_Ashwood: 1822,
  Behr_720D5_MochaAccent: 21304,
  Behr_720D6_ToastedWalnut: 1823,
  Behr_720F5_HiddenPeak: 1824,
  Behr_720F6_Paramount: 1825,
  Behr_73_OffWhite: 21305,
  Behr_730C3_CastlePath: 1826,
  Behr_730D4_GardenWall: 21306,
  Behr_730F4_FlintSmoke: 21307,
  Behr_730F6_Amphibian: 1827,
  Behr_740D6_MountainElk: 1828,
  Behr_740F4_DarkStormCloud: 21308,
  Behr_75_PolarBear: 21309,
  Behr_750C2_HazelnutCream: 21310,
  Behr_750C3_SandstoneCliff: 21311,
  Behr_770C2_BelvedereCream: 1829,
  Behr_770C3_SandFossil: 1830,
  Behr_770D4_ClayPeble: 1831,
  Behr_770F5_DarkAsh: 21312,
  Behr_780E1_BillowyDown: 21313,
  Behr_780F4_Sparrow: 21314,
  Behr_780F5_Anonymous: 21315,
  Behr_790C2_SilverDrop: 21316,
  Behr_790C3_DolphinFin: 21317,
  Behr_790D4_GraniteBoulder: 21318,
  Behr_790F4_CreekBend: 21319,
  Behr_BLACK_Black: 21320,
  Behr_BLW01_Calm: 21321,
  Behr_BLW02_IceSculpture: 21322,
  Behr_BLW03_BlueBirdDay: 21323,
  Behr_BLW04_EtherealWhite: 21324,
  Behr_BLW05_DustingPowder: 21325,
  Behr_BLW06_WhisperingWaterfall: 21326,
  Behr_BLW07_WindChill: 21327,
  Behr_BLW08_FrothySurf: 21328,
  Behr_BLW09_BakeryBox: 21329,
  Behr_BLW10_MauiMist: 21330,
  Behr_BLW11_Tinsmith: 21331,
  Behr_BLW12_CanyonWind: 21332,
  Behr_BLW13_SilverPolish: 21333,
  Behr_ClearTransparent: 11453,
  Behr_GRW01_WhiteWool: 21334,
  Behr_GRW02_AtriumWhite: 21335,
  Behr_GRW05_Unwind: 21336,
  Behr_GRW06_WindsBreath: 21337,
  Behr_GRW07_AngelFeather: 21338,
  Behr_GRW08_ArcadeWhite: 21339,
  Behr_GRW09_SnowfallWhite: 21340,
  Behr_GRW10_Calcium: 21341,
  Behr_GRW11_SilverAsh: 21342,
  Behr_GRW12_ConfidentWhite: 21343,
  Behr_GRW13_PolishedMarble: 21344,
  Behr_GRW14_CoconutTwist: 21345,
  Behr_GRW15_PalaisWhite: 21346,
  Behr_HDCAC04_AvenueTan: 21347,
  Behr_HDCAC07_OakCreek: 21348,
  Behr_HDCAC09_ConcordBuff: 21349,
  Behr_HDCAC10_BungalowBeige: 21350,
  Behr_HDCAC11_CleanCanvas: 21351,
  Behr_HDCAC12_CraftBrown: 21352,
  Behr_HDCAC13_ButterNut: 21353,
  Behr_HDCAC14_BristolBeige: 21354,
  Behr_HDCAC17A_WeldedIron: 21355,
  Behr_HDCAC19_GrantGray: 21356,
  Behr_HDCAC20_HallsOfIvy: 21357,
  Behr_HDCAC21_KeystoneGray: 21358,
  Behr_HDCAC23_ProvenceBlue: 21359,
  Behr_HDCAC24_LyricBlue: 21360,
  Behr_HDCAC25_BlueMetal: 21361,
  Behr_HDCAC26_Sarsaparilla: 21362,
  Behr_HDCCL01_TimelessRuby: 21363,
  Behr_HDCCL11_JanuaryGarnet: 21364,
  Behr_HDCCL14A_WarmOnyx: 21365,
  Behr_HDCCL17_CeylonCream: 21366,
  Behr_HDCCL18_CelliniGold: 21367,
  Behr_HDCCL21A_DarkEverglade: 21368,
  Behr_HDCCL22_SophisticatedTeal: 21369,
  Behr_HDCCL26_ChamplainBlue: 21370,
  Behr_HDCCL26A_IndigoInk: 21371,
  Behr_HDCCL27_CalypsoBlue: 21372,
  Behr_HDCCL28_NocturneBlue: 21373,
  Behr_HDCCT01_AmberMoon: 21374,
  Behr_HDCCT02_GardenRoseWhite: 21375,
  Behr_HDCCT03_Candlewick: 21376,
  Behr_HDCCT05_PalePalomino: 21377,
  Behr_HDCCT06_CountryLinens: 21378,
  Behr_HDCCT07A_VintageTeaRose: 21379,
  Behr_HDCCT16_BillowingClouds: 21380,
  Behr_HDCCT16A_EnglishHollyhock: 21381,
  Behr_HDCCT16B_Waterfall: 21382,
  Behr_HDCCT19_Windrush: 21383,
  Behr_HDCCT20_Greywood: 21384,
  Behr_HDCCT21_GreyMist: 21385,
  Behr_HDCCT25_BayberryFrost: 21386,
  Behr_HDCCT26_Watery: 21387,
  Behr_HDCCT26A_Seaglass: 21388,
  Behr_HDCCT27_SwissCream: 21389,
  Behr_HDCCT28_CottageHill: 21390,
  Behr_HDCMD03_Citronette: 21391,
  Behr_HDCMD04_TotallyBlack: 21392,
  Behr_HDCMD05_DesertCoral: 21393,
  Behr_HDCMD06_NanoWhite: 21394,
  Behr_HDCMD08_WhisperWhite: 21395,
  Behr_HDCMD10A_SweetChrysanthemum: 21396,
  Behr_HDCMD11_ExclusiveIvory: 21397,
  Behr_HDCMD12_TiramisuCream: 21398,
  Behr_HDCMD13_RaveRaisin: 21399,
  Behr_HDCMD17_MinimumBeige: 21400,
  Behr_HDCMD18_PeachMimosa: 21401,
  Behr_HDCMD19_SoftMint: 21402,
  Behr_HDCMD21_Dove: 21403,
  Behr_HDCMD22_TropicalSea: 21404,
  Behr_HDCMD23_IceMist: 21405,
  Behr_HDCMD25_VirtualViolet: 21406,
  Behr_HDCMD26_SonicSilver: 21407,
  Behr_HDCMD27_TartOrange: 21408,
  Behr_HDCMD28_Cordite: 21409,
  Behr_HDCNT01_WoodlandSage: 21410,
  Behr_HDCNT03_ChenilleSpread: 21411,
  Behr_HDCNT04_CremeDeCaramel: 21412,
  Behr_HDCNT04A_Clay: 21413,
  Behr_HDCNT05_AgedOlive: 21414,
  Behr_HDCNT08_PapierBlanc: 21415,
  Behr_HDCNT09_BasicKhaki: 21416,
  Behr_HDCNT10A_DolphinGray: 21417,
  Behr_HDCNT11A_WarmMarshmallow: 21418,
  Behr_HDCNT12_CurlyWillow: 21419,
  Behr_HDCNT13_MerinoWool: 21420,
  Behr_HDCNT14_SmokedTan: 21421,
  Behr_HDCNT15_RococoBeige: 21422,
  Behr_HDCNT17_NewCream: 21423,
  Behr_HDCNT18_YumaSand: 21424,
  Behr_HDCNT20_CottonGrey: 21425,
  Behr_HDCNT21_WeatheredWhite: 21426,
  Behr_HDCNT23_WetCement: 21427,
  Behr_HDCNT24_GlacierValley: 21428,
  Behr_HDCNT27_MillenniumSilver: 21429,
  Behr_HDCNT27B_WildTruffle: 21430,
  Behr_ICC22_Haze: 21431,
  Behr_M1002_SeedlessGrape: 21432,
  Behr_M1003_Svelte: 21433,
  Behr_M1004_AgedToPerfection: 21434,
  Behr_M1005_PassionFruit: 21435,
  Behr_M1006_Vintner: 21436,
  Behr_M1007_DeepMerlot: 21437,
  Behr_M1102_CassiaBuds: 21438,
  Behr_M1103_Bedazzled: 21439,
  Behr_M1104_Cherished: 21440,
  Behr_M1105_AmazonianOrchid: 21441,
  Behr_M1106_SophisticatedLilac: 21442,
  Behr_M1107_EuphoricMagenta: 21443,
  Behr_M1201_PinkProposal: 21444,
  Behr_M1202_KissGoodNight: 21445,
  Behr_M1203_PinkWink: 21446,
  Behr_M1204_HeartToHeart: 21447,
  Behr_M1205_Rosy: 21448,
  Behr_M1206_LovePoem: 21449,
  Behr_M1207_RaspberryCrush: 21450,
  Behr_M1301_PinkPosies: 21451,
  Behr_M1302_CreamyFreesia: 21452,
  Behr_M1303_WildGeranium: 21453,
  Behr_M1304_RaspberrySmoothie: 21454,
  Behr_M1305_Cabaret: 21455,
  Behr_M1306_TropicalHibiscus: 21456,
  Behr_M1307_SugarBeet: 21457,
  Behr_M1401_Funhouse: 21458,
  Behr_M1402_FunnyFace: 21459,
  Behr_M1403_PremiumPink: 21460,
  Behr_M1404_FruitCocktail: 21461,
  Behr_M1405_CherryFizz: 21462,
  Behr_M1407_DarkCrimson: 21463,
  Behr_M1501_LotusPetal: 21464,
  Behr_M1502_PeppermintStick: 21465,
  Behr_M1503_AppleBlossom: 21466,
  Behr_M1504_GlowPink: 21467,
  Behr_M1505_Enamored: 21468,
  Behr_M1506_LingonberryPunch: 21469,
  Behr_M1601_CupcakePink: 21470,
  Behr_M1602_TaffyTwist: 21471,
  Behr_M1604A_SunsetPink: 21472,
  Behr_M1701_PinkElephant: 21473,
  Behr_M1702_PrairieRose: 21474,
  Behr_M1704_PassionFruitPunch: 21475,
  Behr_M1705_IndianSunset: 21476,
  Behr_M1706_DashOfCurry: 21477,
  Behr_M1801_IslandHopping: 21478,
  Behr_M1802_ResortSunrise: 21479,
  Behr_M1803_FlamingoFeather: 21480,
  Behr_M1804_PricelessCoral: 21481,
  Behr_M1805_KingSalmon: 21482,
  Behr_M1806_TikiTorch: 21483,
  Behr_M1807_DeepFire: 21484,
  Behr_M1901_PinkSeaSalt: 21485,
  Behr_M1902_Everblooming: 21486,
  Behr_M1903_PinkAbalone: 21487,
  Behr_M1904_CaliforniaCoral: 21488,
  Behr_M1905_FireplaceGlow: 21489,
  Behr_M1906_BeforeWinter: 21490,
  Behr_M1907_ColorfulLeaves: 21491,
  Behr_M2001_PeachSachet: 21492,
  Behr_M2002_FruitSalad: 21493,
  Behr_M2003_SunsetDrive: 21494,
  Behr_M2004_CoralCloud: 21495,
  Behr_M2005_TerraCottaClay: 21496,
  Behr_M2006_Oxide: 21497,
  Behr_M2007_RustyGate: 21498,
  Behr_M2101_SeedPearl: 21499,
  Behr_M2102_PaperHeart: 21500,
  Behr_M2105_CandiedYams: 21501,
  Behr_M2106_OrangeLiqueur: 21502,
  Behr_M2201_MarshmallowWhip: 21503,
  Behr_M2202_PumpkinEssence: 21504,
  Behr_M2203_CarvingParty: 21505,
  Behr_M2204_TrickOrTreat: 21506,
  Behr_M2205_RoastedSeeds: 21507,
  Behr_M2206A_BlazingAutumn: 21508,
  Behr_M2301_SweetCoconutMilk: 21509,
  Behr_M2302_FairIvory: 21510,
  Behr_M2304_CactusBlooms: 21511,
  Behr_M2305_SweetCurry: 21512,
  Behr_M2307_RumbaOrange: 21513,
  Behr_M2401_BayScallop: 21514,
  Behr_M2402_PinchOfPearl: 21515,
  Behr_M2403_IceCreamParlour: 21516,
  Behr_M2404_SheerApricot: 21517,
  Behr_M2405_SquashBisque: 21518,
  Behr_M2501_FrostingCream: 21519,
  Behr_M2502_GoldenPastel: 21520,
  Behr_M2503_AppleTurnover: 21521,
  Behr_M2505_BurntPumpkin: 21522,
  Behr_M2506_ToffeeTart: 21523,
  Behr_M2507_BlondeWood: 21524,
  Behr_M2601_StringCheese: 21525,
  Behr_M2602_LightNougat: 21526,
  Behr_M2603_TimeOut: 21527,
  Behr_M2607_BackToSchool: 21528,
  Behr_M2701_PearlyWhite: 21529,
  Behr_M2702_Risotto: 21530,
  Behr_M2703_CreamCustard: 21531,
  Behr_M2704_FilteredMoon: 21532,
  Behr_M2705_Beehive: 21533,
  Behr_M2706_GlazedPears: 21534,
  Behr_M2707_WildGinger: 21535,
  Behr_M2801_TwinklingLights: 21536,
  Behr_M2802_Lunaria: 21537,
  Behr_M2803_ChampagneWishes: 21538,
  Behr_M2804_RoyalGold: 21539,
  Behr_M2806_SolidGold: 21540,
  Behr_M2807_24Karat: 21541,
  Behr_M2901_ThickenedCream: 21542,
  Behr_M2902_Frittata: 21543,
  Behr_M2903_CornStalk: 21544,
  Behr_M2905_EnglishCustard: 21545,
  Behr_M2906_PlantainChips: 21546,
  Behr_M2907_Turmeric: 21547,
  Behr_M3001_Sumatra: 21548,
  Behr_M3002_TajMahal: 21549,
  Behr_M3003_HarmoniousGold: 21550,
  Behr_M3004_Gilded: 21551,
  Behr_M3005_GingerJar: 21552,
  Behr_M3006_IndianSpice: 21553,
  Behr_M3007A_RetroGold: 21554,
  Behr_M3101_TibetanJasmine: 21555,
  Behr_M3102_ProperTemperature: 21556,
  Behr_M3104_Almondine: 21557,
  Behr_M3105_ChilledWine: 21558,
  Behr_M3106_BitterLemon: 21559,
  Behr_M3107_ValleyVineyards: 21560,
  Behr_M3202_RiceWine: 21561,
  Behr_M3204_Abstract: 21562,
  Behr_M3205_DriedChamomile: 21563,
  Behr_M3206_TangyGreen: 21564,
  Behr_M3207_ThaiCurry: 21565,
  Behr_M3301_Chanoyu: 21566,
  Behr_M3302_Flowery: 21567,
  Behr_M3303_SweetJasmine: 21568,
  Behr_M3304_MorningTea: 21569,
  Behr_M3305_FreshBrew: 21570,
  Behr_M3306_Keemun: 21571,
  Behr_M3307_GreenTeaLeaf: 21572,
  Behr_M3401_Cauliflower: 21573,
  Behr_M3402_FloatingLily: 21574,
  Behr_M3403A_ModernZen: 21575,
  Behr_M3404_Wasabi: 21576,
  Behr_M3405_FreshArtichoke: 21577,
  Behr_M3406_SpinachDip: 21578,
  Behr_M3407_ClassicAvocado: 21579,
  Behr_M3501_GrassRoot: 21580,
  Behr_M3502_AloeNectar: 21581,
  Behr_M3503_SapGreen: 21582,
  Behr_M3504_SweetGrass: 21583,
  Behr_M3505_MossyCavern: 21584,
  Behr_M3506_Frog: 21585,
  Behr_M3507_HealingPlant: 21586,
  Behr_M3601_GlistenGreen: 21587,
  Behr_M3603_AvocadoWhip: 21588,
  Behr_M3604_Marjoram: 21589,
  Behr_M3605_FreshGuacamole: 21590,
  Behr_M3606_BoldAvocado: 21591,
  Behr_M3607_RockwallVine: 21592,
  Behr_M3701_FreshDew: 21593,
  Behr_M3702_CabbageLeaf: 21594,
  Behr_M3703_SpiceGarden: 21595,
  Behr_M3704_ChervilLeaves: 21596,
  Behr_M3706_SnipOfParsley: 21597,
  Behr_M3707_MownGrass: 21598,
  Behr_M3801_Cavan: 21599,
  Behr_M3802_GladeGreen: 21600,
  Behr_M3803_GrowingSeason: 21601,
  Behr_M3804_ChoppedDill: 21602,
  Behr_M3805_HillsideGrove: 21603,
  Behr_M3806_FernCanopy: 21604,
  Behr_M3807_AlfalfaExtract: 21605,
  Behr_M3901_MayfairWhite: 21606,
  Behr_M3902_MistyMeadow: 21607,
  Behr_M3903_Galway: 21608,
  Behr_M3904_Gingko: 21609,
  Behr_M3905_SageGarden: 21610,
  Behr_M3906_Belfast: 21611,
  Behr_M3907_HillsOfIreland: 21612,
  Behr_M4001_EstablishMint: 21613,
  Behr_M4002_GlassTile: 21614,
  Behr_M4003_BokChoy: 21615,
  Behr_M4004_Brookview: 21616,
  Behr_M4005_BabySpinach: 21617,
  Behr_M4006A_MossedOpportunity: 21618,
  Behr_M4007_GardenCucumber: 21619,
  Behr_M4101_JadeMist: 21620,
  Behr_M4102_WishfulGreen: 21621,
  Behr_M4103_EnchantedMeadow: 21622,
  Behr_M4104_GardenSwing: 21623,
  Behr_M4105_GreenBank: 21624,
  Behr_M4106_TurtleCreek: 21625,
  Behr_M4107_PerennialGreen: 21626,
  Behr_M4201_SparklingBrook: 21627,
  Behr_M4202_GreenAqua: 21628,
  Behr_M4203_Mirador: 21629,
  Behr_M4204_JadeMountain: 21630,
  Behr_M4205_FreeGreen: 21631,
  Behr_M4206_TournamentField: 21632,
  Behr_M4207_BilliardGreen: 21633,
  Behr_M4301_Snowbound: 21634,
  Behr_M4302_IceRink: 21635,
  Behr_M4303_WintergreenDream: 21636,
  Behr_M4305_RegalView: 21637,
  Behr_M4306_ParkBench: 21638,
  Behr_M4307_GreenAgate: 21639,
  Behr_M4403_BabyAqua: 21640,
  Behr_M4404_SummerDragonfly: 21641,
  Behr_M4405_LunarTide: 21642,
  Behr_M4406_TrellisVine: 21643,
  Behr_M4407_Rainforest: 21644,
  Behr_M4501_DewPointe: 21645,
  Behr_M4502_Tidewater: 21646,
  Behr_M4503_WaveTop: 21647,
  Behr_M4504_Undine: 21648,
  Behr_M4505_AquaRapids: 21649,
  Behr_M4506_BubbleTurquoise: 21650,
  Behr_M4507_BetaFish: 21651,
  Behr_M4601_TahitianSky: 21652,
  Behr_M4602_BeachsideDrive: 21653,
  Behr_M4603_BigSurf: 21654,
  Behr_M4604_PureTurquoise: 21655,
  Behr_M4605_AquaFresco: 21656,
  Behr_M4606_ThaiTeal: 21657,
  Behr_M4607_Antigua: 21658,
  Behr_M4702_BasinBlue: 21659,
  Behr_M4704_AzureLake: 21660,
  Behr_M4705_ExplorerBlue: 21661,
  Behr_M4801_Helium: 21662,
  Behr_M4802A_Winterscape: 21663,
  Behr_M4803_BengalBlue: 21664,
  Behr_M4804_BelowZero: 21665,
  Behr_M4805A_NorthPoleBlue: 21666,
  Behr_M4806_ValleyOfGlaciers: 21667,
  Behr_M4807_IceCave: 21668,
  Behr_M4901_BreezyBlue: 21669,
  Behr_M4902_CarefreeSky: 21670,
  Behr_M4903_Speedboat: 21671,
  Behr_M4904_FriskyBlue: 21672,
  Behr_M4905_JetSki: 21673,
  Behr_M4906_LivingStream: 21674,
  Behr_M4907_ShastaLake: 21675,
  Behr_M5001_TintedIce: 21676,
  Behr_M5002_EarlySeptember: 21677,
  Behr_M5003_BlueChalk: 21678,
  Behr_M5004_Hemisphere: 21679,
  Behr_M5005_SojournBlue: 21680,
  Behr_M5006_ExpressBlue: 21681,
  Behr_M5007_VeryNavy: 21682,
  Behr_M5101_BlueMeAway: 21683,
  Behr_M5102_LifeAtSea: 21684,
  Behr_M5104_BrittanyBlue: 21685,
  Behr_M5106_Tidal: 21686,
  Behr_M5107_Inked: 21687,
  Behr_M5201A_SoftCloud: 21688,
  Behr_M5202_AfterRain: 21689,
  Behr_M5203_CharismaticSky: 21690,
  Behr_M5204_MirrorLake: 21691,
  Behr_M5206_NationalAnthem: 21692,
  Behr_M5207_AdmiralBlue: 21693,
  Behr_M5301_IceDrop: 21694,
  Behr_M5303_PerennialBlue: 21695,
  Behr_M5304_WashedDenim: 21696,
  Behr_M5305_CowgirlBlue: 21697,
  Behr_M5306_CharterBlue: 21698,
  Behr_M5307_ElegantNavy: 21699,
  Behr_M5401_BellflowerBlue: 21700,
  Behr_M5402_AngelicBlue: 21701,
  Behr_M5403_EternalElegance: 21702,
  Behr_M5404_HopefulDream: 21703,
  Behr_M5405_BlueSatin: 21704,
  Behr_M5407_OptimumBlue: 21705,
  Behr_M5501_WhiteLavender: 21706,
  Behr_M5502_LavenderMemory: 21707,
  Behr_M5503_Foxglove: 21708,
  Behr_M5504_WisteriaBlue: 21709,
  Behr_M5505_VioletAura: 21710,
  Behr_M5506_KimonoViolet: 21711,
  Behr_M5507_StrongIris: 21712,
  Behr_M5701_InTheSpotlight: 21713,
  Behr_M5702_Monologue: 21714,
  Behr_M5703_OnLocation: 21715,
  Behr_M5704_CyberGrape: 21716,
  Behr_M5705_CelebCity: 21717,
  Behr_M5706_Notorious: 21718,
  Behr_M5707_Paparazzi: 21719,
  Behr_MQ102_WineNot: 21720,
  Behr_MQ109_HauteCouture: 21721,
  Behr_MQ110_RedMyMind: 21722,
  Behr_MQ111_DramaQueen: 21723,
  Behr_MQ114_Twinberry: 21724,
  Behr_MQ115_Rumors: 21725,
  Behr_MQ125_KalahariSunset: 21726,
  Behr_MQ128_OrangeFlambe: 21727,
  Behr_MQ131_Cockleshell: 21728,
  Behr_MQ132_CinemaScreen: 21729,
  Behr_MQ135_OffBroadway: 21730,
  Behr_MQ154_DeathByChocolate: 21731,
  Behr_MQ155_LiteCocoa: 21732,
  Behr_MQ156_Elkhound: 21733,
  Behr_MQ158_ChocolateSoul: 21734,
  Behr_MQ203_KeyToTheCity: 21735,
  Behr_MQ205A_AuthenticBrown: 21736,
  Behr_MQ206_GildedGlamour: 21737,
  Behr_MQ208_IrishCream: 21738,
  Behr_MQ211_OutdoorLand: 21739,
  Behr_MQ218_HoneyTea: 21740,
  Behr_MQ220_SafariChic: 21741,
  Behr_MQ221_ElementalTan: 21742,
  Behr_MQ222_Hayloft: 21743,
  Behr_MQ223_AlmondButter: 21744,
  Behr_MQ225_BritishKhaki: 21745,
  Behr_MQ226_WindsorTan: 21746,
  Behr_MQ227_StudioClay: 21747,
  Behr_MQ231_Scribe: 21748,
  Behr_MQ232_MinkHaze: 21749,
  Behr_MQ233_ParisianCafe: 21750,
  Behr_MQ235_CabinInTheWoods: 21751,
  Behr_MQ236_ElusiveDawn: 21752,
  Behr_MQ237_EiffelForYou: 21753,
  Behr_MQ238_Grizzly: 21754,
  Behr_MQ239_RareWood: 21755,
  Behr_MQ244_Museum: 21756,
  Behr_MQ245_CraftJuggler: 21757,
  Behr_MQ246_Basswood: 21758,
  Behr_MQ247_Midtown: 21759,
  Behr_MQ248_SturdyBrown: 21760,
  Behr_MQ249_Kaffee: 21761,
  Behr_MQ250_Gravelstone: 21762,
  Behr_MQ251_PashaBrown: 21763,
  Behr_MQ252_Roadside: 21764,
  Behr_MQ253_SmokyTrout: 21765,
  Behr_MQ255_ParkAvenue: 21766,
  Behr_MQ256_AbbeyStone: 21767,
  Behr_MQ257_ArtDistrict: 21768,
  Behr_MQ258_UnpredictableHue: 21769,
  Behr_MQ259_SilverCity: 21770,
  Behr_MQ260_IronGate: 21771,
  Behr_MQ261_Magnet: 21772,
  Behr_MQ262_Peppery: 21773,
  Behr_MQ306_GraniteDust: 21774,
  Behr_MQ309_LoftLight: 21775,
  Behr_MQ310_FrenchBeige: 21776,
  Behr_MQ311_DaintyLace: 21777,
  Behr_MQ312_IvoryPaper: 21778,
  Behr_MQ313_CrispLinen: 21779,
  Behr_MQ315_BellTower: 21780,
  Behr_MQ316_Limescent: 21781,
  Behr_MQ318_GingerSugar: 21782,
  Behr_MQ319_MistyIsle: 21783,
  Behr_MQ321_Breezeway: 21784,
  Behr_MQ322_Curio: 21785,
  Behr_MQ323_Statuesque: 21786,
  Behr_MQ324_CelestialLight: 21787,
  Behr_MQ325_GrayShimmer: 21788,
  Behr_MQ326_Mainsail: 21789,
  Behr_MQ327_EtchedGlass: 21790,
  Behr_MQ328_RockCrystal: 21791,
  Behr_MQ330_PetalTip: 21792,
  Behr_MQ331_DutchWhite: 21793,
  Behr_MQ332_CameoWhite: 21794,
  Behr_MQ333_CremeDeLaCreme: 21795,
  Behr_MQ334_StolenKiss: 21796,
  Behr_MQ335_Moxie: 21797,
  Behr_MQ336_TranslucentSilk: 21798,
  Behr_MQ338_SuedeBeige: 21799,
  Behr_MQ339_SweetPastel: 21800,
  Behr_MQ340_VarnishedIvory: 21801,
  Behr_MQ341_Moongaze: 21802,
  Behr_MQ342_HoneyMist: 21803,
  Behr_MQ343_CeramicBeige: 21804,
  Behr_MQ344_AncientScroll: 21805,
  Behr_MQ345_LookingGlass: 21806,
  Behr_MQ346_Folly: 21807,
  Behr_MQ347_AiryGreen: 21808,
  Behr_MQ348_ShyGreen: 21809,
  Behr_MQ349_JadeTinge: 21810,
  Behr_MQ350_RiverVeil: 21811,
  Behr_MQ351_CrystallineFalls: 21812,
  Behr_MQ352_EtherealMood: 21813,
  Behr_MQ353_SkyLightView: 21814,
  Behr_MQ354_Dayflower: 21815,
  Behr_MQ355_WhiteLie: 21816,
  Behr_MQ356_Era: 21817,
  Behr_MQ357_SiberianIce: 21818,
  Behr_MQ358_AliceWhite: 21819,
  Behr_MQ359_WillOTheWisp: 21820,
  Behr_MQ361_MoonlitSnow: 21821,
  Behr_MQ403_CoralFountain: 21822,
  Behr_MQ404_NobleBlush: 21823,
  Behr_MQ407_Radiance: 21824,
  Behr_MQ408_GoldenAura: 21825,
  Behr_MQ410_AmberBrew: 21826,
  Behr_MQ411_Lamplit: 21827,
  Behr_MQ412_DandelionWish: 21828,
  Behr_MQ413A_Celebration: 21829,
  Behr_MQ421_CaicosTurquoise: 21830,
  Behr_MQ422_KeyLargo: 21831,
  Behr_MQ423_Aloha: 21832,
  Behr_MQ424_ElectricBlue: 21833,
  Behr_MQ435_TorchRed: 21834,
  Behr_MQ438_BalconySunset: 21835,
  Behr_MQ442_Pistachio: 21836,
  Behr_MQ445_SpringGlow: 21837,
  Behr_MQ446_EarlySpring: 21838,
  Behr_MQ449_EmeraldForest: 21839,
  Behr_MQ451_Adonis: 21840,
  Behr_MQ455_Balboa: 21841,
  Behr_MQ457_CelebrationBlue: 21842,
  Behr_MQ459_PurpleGladiola: 21843,
  Behr_MQ460_JoieDeVivre: 21844,
  Behr_MQ504_Classy: 21845,
  Behr_MQ505_LimousineLeather: 21846,
  Behr_MQ508_Masterpiece: 21847,
  Behr_MQ51_Extravagance: 21848,
  Behr_MQ510_SecretSociety: 21849,
  Behr_MQ514_BonNuit: 21850,
  Behr_MQ518_PaparazziFlash: 21851,
  Behr_MQ520_ColdSteel: 21852,
  Behr_MQ521_RadiantSilver: 21853,
  Behr_MQ522_Rainmaster: 21854,
  Behr_MQ523_IntercoastalGray: 21855,
  Behr_MQ525_RushHour: 21856,
  Behr_MQ527_RainySeason: 21857,
  Behr_MQ528_DawnGray: 21858,
  Behr_MQ529_GothamGray: 21859,
  Behr_MQ530_SilentFilm: 21860,
  Behr_MQ531_DistantStar: 21861,
  Behr_MQ536_Audition: 21862,
  Behr_MQ554_CompassBlue: 21863,
  Behr_MQ558_VelvetRope: 21864,
  Behr_MQ559_Ovation: 21865,
  Behr_MQ601_OceanAbyss: 21866,
  Behr_MQ604_GrayWool: 21867,
  Behr_MQ611_MossyBench: 21868,
  Behr_MQ616_GazeboGreen: 21869,
  Behr_MQ618_RecycledGlass: 21870,
  Behr_MQ620_CoastalStorm: 21871,
  Behr_MQ622_GatewayGray: 21872,
  Behr_MQ623_Pumice: 21873,
  Behr_MQ627_SageWisdom: 21874,
  Behr_MQ630_BambooShoot: 21875,
  Behr_MQ631_ShorelineHaze: 21876,
  Behr_MQ633_VintageTeal: 21877,
  Behr_MQ635_TealMotif: 21878,
  Behr_MQ638_Patina: 21879,
  Behr_MQ644_BlackEvergreen: 21880,
  Behr_MQ649_Chard: 21881,
  Behr_MQ651_FernLeaf: 21882,
  Behr_MQ653_HerbCornucopia: 21883,
  Behr_MQ654_RiverForest: 21884,
  Behr_MQ658_FigTree: 21885,
  Behr_MQ660_Everglade: 21886,
  Behr_N1004_Fortune: 21887,
  Behr_N1005_PlushVelvet: 21888,
  Behr_N1006_UrbanLegend: 21889,
  Behr_N1007_Aubergine: 21890,
  Behr_N1101_DustyLilac: 21891,
  Behr_N1102_MulberryStain: 21892,
  Behr_N1103_FigPreserves: 21893,
  Behr_N1104_GothicPurple: 21894,
  Behr_N1105_RoyalRaisin: 21895,
  Behr_N1106_DignifiedPurple: 21896,
  Behr_N1107_BlackGarnet: 21897,
  Behr_N1201_Parasol: 21898,
  Behr_N1203_MauveIt: 21899,
  Behr_N1204_RoaringTwenties: 21900,
  Behr_N1205_Plumville: 21901,
  Behr_N1206_RaisinInTheSun: 21902,
  Behr_N1301_PearlsLace: 21903,
  Behr_N1302_AshRose: 21904,
  Behr_N1304_PlumTaupe: 21905,
  Behr_N1305_Mystere: 21906,
  Behr_N1402_ChicagoFog: 21907,
  Behr_N1403_Metropolis: 21908,
  Behr_N1404_TavernTaupe: 21909,
  Behr_N1405_ComplexGray: 21910,
  Behr_N1406_WrightBrown: 21911,
  Behr_N1407_TimberBrown: 21912,
  Behr_N1501_MochaIce: 21913,
  Behr_N1502_SmokeyPink: 21914,
  Behr_N1503_CocoaCraving: 21915,
  Behr_N1504_ModernMocha: 21916,
  Behr_N1505_FrenchTruffle: 21917,
  Behr_N1506_CoffeeBeans: 21918,
  Behr_N1507_ChocolateTherapy: 21919,
  Behr_N1601_CameoStone: 21920,
  Behr_N1602_Malted: 21921,
  Behr_N1603_VintageCharm: 21922,
  Behr_N1604_SonoraRose: 21923,
  Behr_N1605_ChocolateDelight: 21924,
  Behr_N1606_SpanishChestnut: 21925,
  Behr_N1607_BrownVelvet: 21926,
  Behr_N1702_RosePearl: 21927,
  Behr_N1703_GrayAshlar: 21928,
  Behr_N1704_CoffeeWithCream: 21929,
  Behr_N1705_ChocolateHeart: 21930,
  Behr_N1706_NaturalBark: 21931,
  Behr_N1707_BaronialBrown: 21932,
  Behr_N1801_BarelyBrown: 21933,
  Behr_N1802_JodhpurTan: 21934,
  Behr_N1803_RaceTrack: 21935,
  Behr_N1804_Moleskin: 21936,
  Behr_N1805_BridleLeather: 21937,
  Behr_N1806_Derby: 21938,
  Behr_N1807_OiledTeak: 21939,
  Behr_N1901_SmokeyCream: 21940,
  Behr_N1902_StonewashedBrown: 21941,
  Behr_N1903_WindriftBeige: 21942,
  Behr_N1904_RuggedTan: 21943,
  Behr_N1905_FrontierBrown: 21944,
  Behr_N1906_NutBrown: 21945,
  Behr_N1907_MooseTrail: 21946,
  Behr_N2001_MothGray: 21947,
  Behr_N2002_DoeskinGray: 21948,
  Behr_N2003_NightingaleGray: 21949,
  Behr_N2004_RusticTaupe: 21950,
  Behr_N2005_Woodcraft: 21951,
  Behr_N2006_Kindling: 21952,
  Behr_N2007_Underground: 21953,
  Behr_N2101_TaupeTease: 21954,
  Behr_N2102_CappuccinoFroth: 21955,
  Behr_N2103_Barista: 21956,
  Behr_N2104_EspressoMartini: 21957,
  Behr_N2105_Caffeine: 21958,
  Behr_N2106_SwissBrown: 21959,
  Behr_N2107_HavanaCoffee: 21960,
  Behr_N2201_SpunWool: 21961,
  Behr_N2202_AshenTan: 21962,
  Behr_N2203_Smokestack: 21963,
  Behr_N2204_Shiitake: 21964,
  Behr_N2205_Ottertail: 21965,
  Behr_N2206_LandmarkBrown: 21966,
  Behr_N2207_CavalryBrown: 21967,
  Behr_N2301_CastleBeige: 21968,
  Behr_N2302_OldMap: 21969,
  Behr_N2303_Armadillo: 21970,
  Behr_N2304_ChicTaupe: 21971,
  Behr_N2305_DryBrown: 21972,
  Behr_N2306_WhiskeyBarrel: 21973,
  Behr_N2307_RusticTobacco: 21974,
  Behr_N2401_CascadeBeige: 21975,
  Behr_N2402_AdobeSand: 21976,
  Behr_N2403_SonoranDesert: 21977,
  Behr_N2404_Sierra: 21978,
  Behr_N2405_RodeoTan: 21979,
  Behr_N2406_WildMustang: 21980,
  Behr_N2407_JoshuaTree: 21981,
  Behr_N2501_ClayDust: 21982,
  Behr_N2502A_BaliSand: 21983,
  Behr_N2503_PotteryWheel: 21984,
  Behr_N2504_ArtisanCrafts: 21985,
  Behr_N2505_AncientPottery: 21986,
  Behr_N2506_SplitRail: 21987,
  Behr_N2507_MissionBrown: 21988,
  Behr_N2601_VanillaMocha: 21989,
  Behr_N2602_AlmondLatte: 21990,
  Behr_N2603_PoloTan: 21991,
  Behr_N2604_Merino: 21992,
  Behr_N2605_DistantLand: 21993,
  Behr_N2606_OutdoorCafe: 21994,
  Behr_N2701_HighStyleBeige: 21995,
  Behr_N2702_Lentil: 21996,
  Behr_N2703_Coco: 21997,
  Behr_N2704_OxfordStreet: 21998,
  Behr_N2705_RiverRoad: 21999,
  Behr_N2706_Westminster: 22000,
  Behr_N2707_LibraryOak: 22001,
  Behr_N2801_Scroll: 22002,
  Behr_N2803_Louvre: 22003,
  Behr_N2804_PerfectTan: 22004,
  Behr_N2805_AntiqueTreasure: 22005,
  Behr_N2806_TempleTile: 22006,
  Behr_N2807_BrassButton: 22007,
  Behr_N2901_OriginalWhite: 22008,
  Behr_N2902_AuthenticTan: 22009,
  Behr_N2903_ComfyBeige: 22010,
  Behr_N2905_PocketWatch: 22011,
  Behr_N2906_TrinketGold: 22012,
  Behr_N2907_MarrakechBrown: 22013,
  Behr_N3001_SailCloth: 22014,
  Behr_N3002_CanvasLuggage: 22015,
  Behr_N3003_CasualKhaki: 22016,
  Behr_N3004_OpenCanyon: 22017,
  Behr_N3005_HiddenTreasure: 22018,
  Behr_N3006_ArchaeologicalSite: 22019,
  Behr_N3007_MayanRuins: 22020,
  Behr_N3101_SandDrift: 22021,
  Behr_N3102_AridLandscape: 22022,
  Behr_N3103_Sandstorm: 22023,
  Behr_N3104_DesertKhaki: 22024,
  Behr_N3105_WeatheredFossil: 22025,
  Behr_N3106_PalmDesert: 22026,
  Behr_N3107_ClassicBronze: 22027,
  Behr_N3201_CampfireAsh: 22028,
  Behr_N3202_ToastyGray: 22029,
  Behr_N3203_Tanglewood: 22030,
  Behr_N3204_CampingTent: 22031,
  Behr_N3205_GraySquirrel: 22032,
  Behr_N3206A_AshBrown: 22033,
  Behr_N3301_MilkPaint: 22034,
  Behr_N3302_PrairieDust: 22035,
  Behr_N3303_UnmarkedTrail: 22036,
  Behr_N3304_ExplorerKhaki: 22037,
  Behr_N3305_Livingston: 22038,
  Behr_N3306_LagoonMoss: 22039,
  Behr_N3307_Adventurer: 22040,
  Behr_N3401_LightGranite: 22041,
  Behr_N3402_DuneGrass: 22042,
  Behr_N3403_BonsaiPot: 22043,
  Behr_N3405_GrassySavannah: 22044,
  Behr_N3406_SorrelLeaf: 22045,
  Behr_N3407_Kilimanjaro: 22046,
  Behr_N3501_HazyTrail: 22047,
  Behr_N3502_Sawgrass: 22048,
  Behr_N3503_BikingTrail: 22049,
  Behr_N3504_JungleCamouflage: 22050,
  Behr_N3505_MutedSage: 22051,
  Behr_N3506_Peppergrass: 22052,
  Behr_N3507A_MountainOlive: 22053,
  Behr_N3601_SeagullGray: 22054,
  Behr_N3602_SilverMarlin: 22055,
  Behr_N3603_StillGray: 22056,
  Behr_N3604_BattleshipGray: 22057,
  Behr_N3605A_WoodAsh: 22058,
  Behr_N3606_PatioStone: 22059,
  Behr_N3607_PottingSoil: 22060,
  Behr_N3701_RoadsterWhite: 22061,
  Behr_N3702_Eon: 22062,
  Behr_N3703_LightYear: 22063,
  Behr_N3704A_HistoricalGray: 22064,
  Behr_N3705_Incognito: 22065,
  Behr_N3706_GladiatorGray: 22066,
  Behr_N3707_NightMission: 22067,
  Behr_N3801_Mortar: 22068,
  Behr_N3802_HeathGray: 22069,
  Behr_N3803_WeatheredMoss: 22070,
  Behr_N3804_StrongWinds: 22071,
  Behr_N3805_NaturalistGray: 22072,
  Behr_N3806_BonsaiTrunk: 22073,
  Behr_N3807_BlackBamboo: 22074,
  Behr_N3901_LightMist: 22075,
  Behr_N3902_Flora: 22076,
  Behr_N3903_Jojoba: 22077,
  Behr_N3904_BitterSage: 22078,
  Behr_N3905_EucalyptusWreath: 22079,
  Behr_N3906_LaurelGarland: 22080,
  Behr_N3907_CypressVine: 22081,
  Behr_N4001_MountainMorn: 22082,
  Behr_N4002_FrostedSage: 22083,
  Behr_N4003_FlagstaffGreen: 22084,
  Behr_N4004_ForestPath: 22085,
  Behr_N4005_ThaiBasil: 22086,
  Behr_N4006_Terrarium: 22087,
  Behr_N4101_Silence: 22088,
  Behr_N4102_BrookGreen: 22089,
  Behr_N4103_Riverdale: 22090,
  Behr_N4105_VillageGreen: 22091,
  Behr_N4106_PineconeHill: 22092,
  Behr_N4107_NorthWoods: 22093,
  Behr_N4201_JuniperBreeze: 22094,
  Behr_N4202_MountainFalls: 22095,
  Behr_N4203_MistyMoss: 22096,
  Behr_N4204_UndergroundGardens: 22097,
  Behr_N4205_Boreal: 22098,
  Behr_N4206_PineMountain: 22099,
  Behr_N4207_AlpineTrail: 22100,
  Behr_N4301_MountainPeakWhite: 22101,
  Behr_N4303_GardenVista: 22102,
  Behr_N4304_RainyAfternoon: 22103,
  Behr_N4305_AspenValley: 22104,
  Behr_N4306A_HiddenGem: 22105,
  Behr_N4307_SilkenPine: 22106,
  Behr_N4401_Streetwise: 22107,
  Behr_N4402_UrbanRaincoat: 22108,
  Behr_N4403_GreenwichVillage: 22109,
  Behr_N4404_OctoberSky: 22110,
  Behr_N4405_ConeyIsland: 22111,
  Behr_N4406_Brooklyn: 22112,
  Behr_N4407_MidnightInNy: 22113,
  Behr_N4501_Evaporation: 22114,
  Behr_N4502_ZeroGravity: 22115,
  Behr_N4503_MeteorShower: 22116,
  Behr_N4504_Moonquake: 22117,
  Behr_N4505_Intergalactic: 22118,
  Behr_N4506_BinaryStar: 22119,
  Behr_N4507_Astronomical: 22120,
  Behr_N4601_EveningWhite: 22121,
  Behr_N4602_PlanetarySilver: 22122,
  Behr_N4603_LunarSurface: 22123,
  Behr_N4604_CosmicQuest: 22124,
  Behr_N4605_SlateRock: 22125,
  Behr_N4606_Hematite: 22126,
  Behr_N4607_SpaceBlack: 22127,
  Behr_N4701_AshBlue: 22128,
  Behr_N4702A_DustedBlue: 22129,
  Behr_N4703_HalfSeaFog: 22130,
  Behr_N4705_NorwegianBlue: 22131,
  Behr_N4706_WhaleGray: 22132,
  Behr_N4707_SubmarineGray: 22133,
  Behr_N4801_LightDrizzle: 22134,
  Behr_N4802_FlowingBreeze: 22135,
  Behr_N4803_ShadowBlue: 22136,
  Behr_N4804A_DustyDenim: 22137,
  Behr_N4805_AdirondackBlue: 22138,
  Behr_N4806_Nypd: 22139,
  Behr_N4807_MidnightBlue: 22140,
  Behr_N4901_AbsoluteZero: 22141,
  Behr_N4902_Icicles: 22142,
  Behr_N4903_ShavedIce: 22143,
  Behr_N4904_TetonBlue: 22144,
  Behr_N4905_CharcoalBlue: 22145,
  Behr_N4906_Calligraphy: 22146,
  Behr_N4907_InkBlack: 22147,
  Behr_N5001_ShinyLuster: 22148,
  Behr_N5002_LoftSpace: 22149,
  Behr_N5003_TinFoil: 22150,
  Behr_N5004_PencilSketch: 22151,
  Behr_N5005_MagneticGray: 22152,
  Behr_N5006_GraphicCharcoal: 22153,
  Behr_N5007_NightClub: 22154,
  Behr_N5101_SilverShadow: 22155,
  Behr_N5102_GalacticTint: 22156,
  Behr_N5103_Stargazer: 22157,
  Behr_N5104_Supernova: 22158,
  Behr_N5105_LiquidMercury: 22159,
  Behr_N5106_OrionGray: 22160,
  Behr_N5107_Blackout: 22161,
  Behr_N5201_WhiteMetal: 22162,
  Behr_N5202_SilverBullet: 22163,
  Behr_N5203_FlannelGray: 22164,
  Behr_N5204_CoolAshes: 22165,
  Behr_N5205_IronMountain: 22166,
  Behr_N5206_AsphaltGray: 22167,
  Behr_N5207_Carbon: 22168,
  Behr_N5301_PixelWhite: 22169,
  Behr_N5302_DoubleClick: 22170,
  Behr_N5303_HighSpeedAccess: 22171,
  Behr_N5304_PowerGray: 22172,
  Behr_N5305_MissionControl: 22173,
  Behr_N5306_Digital: 22174,
  Behr_N5307_PrivateBlack: 22175,
  Behr_N5401_ScriptWhite: 22176,
  Behr_N5402_Glitter: 22177,
  Behr_N5403_Vanity: 22178,
  Behr_N5404_Silhouette: 22179,
  Behr_N5405_Infamous: 22180,
  Behr_N5406_ScriptInk: 22181,
  Behr_N5407_CoalMine: 22182,
  Behr_N5502_CentreStage: 22183,
  Behr_N5503_BestInShow: 22184,
  Behr_N5504_Ashberry: 22185,
  Behr_N5505_BoxOffice: 22186,
  Behr_N5506_AlterEgo: 22187,
  Behr_N5507_Catwalk: 22188,
  Behr_N5601_PosturePose: 22189,
  Behr_N5602_CovetedGem: 22190,
  Behr_N5603_LuxeLilac: 22191,
  Behr_N5604_EveningInParis: 22192,
  Behr_N5605_Solitaire: 22193,
  Behr_N5606_Fashionista: 22194,
  Behr_N5701_Opera: 22195,
  Behr_N5702_StandingOvation: 22196,
  Behr_N5703_ArtNouveauGlass: 22197,
  Behr_N5704_ClassyPlum: 22198,
  Behr_N5705_CurtainCall: 22199,
  Behr_N5706_Virtuoso: 22200,
  Behr_N5707_BlackElegance: 22201,
  Behr_ORW01_WhiteBlush: 22202,
  Behr_ORW02_SoMuchFawn: 22203,
  Behr_ORW03_MannequinCream: 22204,
  Behr_ORW04_NiceCream: 22205,
  Behr_ORW05_AlmondMilk: 22206,
  Behr_ORW06_CoconutIce: 22207,
  Behr_ORW07_SpanishSand: 22208,
  Behr_ORW08_CocoMalt: 22209,
  Behr_ORW10_WhiteFlour: 22210,
  Behr_ORW11_WhiteMocha: 22211,
  Behr_ORW12_MourningDove: 22212,
  Behr_ORW13_Shoelace: 22213,
  Behr_ORW14_WhiteVeil: 22214,
  Behr_ORW15_SleekWhite: 22215,
  Behr_P1002_SweetRomance: 22216,
  Behr_P1003_Epiphany: 22217,
  Behr_P1005_IHeartPotion: 22218,
  Behr_P1006_Chakra: 22219,
  Behr_P1007_Sultana: 22220,
  Behr_P1102_GirlTalk: 22221,
  Behr_P1103_Bff: 22222,
  Behr_P1105A_EccentricMagenta: 22223,
  Behr_P1106_WildBerry: 22224,
  Behr_P1107_XOXO: 22225,
  Behr_P1201_StarletPink: 22226,
  Behr_P1202_Gumball: 22227,
  Behr_P1203_HighMaintenance: 22228,
  Behr_P1204_HeartBreaker: 22229,
  Behr_P1205_BeautyQueen: 22230,
  Behr_P1206_DivaGlam: 22231,
  Behr_P1207_Glitterati: 22232,
  Behr_P1301_PiggyBank: 22233,
  Behr_P1302A_DaintyPink: 22234,
  Behr_P1303_LittlePrincess: 22235,
  Behr_P1305_LittleBowPink: 22236,
  Behr_P1306_BallerinaTutu: 22237,
  Behr_P1307_Glamorous: 22238,
  Behr_P1401_SummerCrush: 22239,
  Behr_P1402_Sweetheart: 22240,
  Behr_P1403_LoveAtFirstSight: 22241,
  Behr_P1404_IPinkICan: 22242,
  Behr_P1405_Lovebirds: 22243,
  Behr_P1406_HibiscusFlower: 22244,
  Behr_P1407_NoMoreDrama: 22245,
  Behr_P1501_BlowingKisses: 22246,
  Behr_P1502_EnergeticPink: 22247,
  Behr_P1503_Pinque: 22248,
  Behr_P1504_HotGossip: 22249,
  Behr_P1505A_StrawberryTaffy: 22250,
  Behr_P1506_WhipLash: 22251,
  Behr_P1507_FlirtAlert: 22252,
  Behr_P1601_AngelKiss: 22253,
  Behr_P1602_BlushRush: 22254,
  Behr_P1603_AllDressedUp: 22255,
  Behr_P1604_JuicyDetails: 22256,
  Behr_P1605_Pinkadelic: 22257,
  Behr_P1606_Intrigue: 22258,
  Behr_P1607_StilettoLove: 22259,
  Behr_P1701A_PinkyPromise: 22260,
  Behr_P1702_OldFlame: 22261,
  Behr_P1703_Infatuation: 22262,
  Behr_P1704_SugarPoppy: 22263,
  Behr_P1705_Roulette: 22264,
  Behr_P1706_RaceCarStripe: 22265,
  Behr_P1707_100Mph: 22266,
  Behr_P1801_DecoShell: 22267,
  Behr_P1802_SherbetFruit: 22268,
  Behr_P1804_GuavaJelly: 22269,
  Behr_P1805_WatermelonSlice: 22270,
  Behr_P1806_Pimento: 22271,
  Behr_P1807_TopTomato: 22272,
  Behr_P1901_FireMist: 22273,
  Behr_P1902_Fahrenheit: 22274,
  Behr_P1903_MelonSorbet: 22275,
  Behr_P1904_Siren: 22276,
  Behr_P1905_Orioles: 22277,
  Behr_P1906_EmergencyZone: 22278,
  Behr_P1907_Inferno: 22279,
  Behr_P2001_MeltedMarshmallow: 22280,
  Behr_P2004_Carotene: 22281,
  Behr_P2005_BurningCoals: 22282,
  Behr_P2006_SizzlingSunset: 22283,
  Behr_P2007_BonfireNight: 22284,
  Behr_P2101_SourCandy: 22285,
  Behr_P2102_CitrusDelight: 22286,
  Behr_P2103_Gumdrops: 22287,
  Behr_P2104_Lollipop: 22288,
  Behr_P2105_CheerfulTangerine: 22289,
  Behr_P2106_Mandarin: 22290,
  Behr_P2107_JapaneseKoi: 22291,
  Behr_P2201_FrostyMelon: 22292,
  Behr_P2202_Peche: 22293,
  Behr_P2203_TropicalFruit: 22294,
  Behr_P2204_DaintyApricot: 22295,
  Behr_P2205_FuzzyPeach: 22296,
  Behr_P2206_BergamotOrange: 22297,
  Behr_P2207_ConstructionZone: 22298,
  Behr_P2301_WhiteGrapefruit: 22299,
  Behr_P2302_SourTarts: 22300,
  Behr_P2303_VitaminC: 22301,
  Behr_P2304_CitrusPunch: 22302,
  Behr_P2305_FloridaSunrise: 22303,
  Behr_P2306_Toucan: 22304,
  Behr_P2307_AcapulcoSun: 22305,
  Behr_P2401_CheesePowder: 22306,
  Behr_P2402_PeachGlow: 22307,
  Behr_P2403_MangoNectar: 22308,
  Behr_P2404_MangoTango: 22309,
  Behr_P2405_CheesePuff: 22310,
  Behr_P2406_ExoticBlossom: 22311,
  Behr_P2407_JoyfulOrange: 22312,
  Behr_P2501_PapayaSorbet: 22313,
  Behr_P2502_GoldenNectar: 22314,
  Behr_P2503_MarshMarigold: 22315,
  Behr_P2504_Equatorial: 22316,
  Behr_P2505_SolarStorm: 22317,
  Behr_P2506_SplendorGold: 22318,
  Behr_P2507_BlazingBonfire: 22319,
  Behr_P2601_GlassOfMilk: 22320,
  Behr_P2602_Yogurt: 22321,
  Behr_P2603_VanillaIceCream: 22322,
  Behr_P2604_BananaMania: 22323,
  Behr_P2605_YellowJubilee: 22324,
  Behr_P2606_SmileyFace: 22325,
  Behr_P2607_ExtremeYellow: 22326,
  Behr_P2701_HoneyInfusion: 22327,
  Behr_P2702_SeptemberMorning: 22328,
  Behr_P2703_SunflowerSeed: 22329,
  Behr_P2704_EggCream: 22330,
  Behr_P2706_SoftBoiled: 22331,
  Behr_P2707_SunnySideUp: 22332,
  Behr_P2801_SummerBliss: 22333,
  Behr_P2802_GoldThread: 22334,
  Behr_P2803_PolkaDotSkirt: 22335,
  Behr_P2804_SurfboardYellow: 22336,
  Behr_P2805_LittleSunDress: 22337,
  Behr_P2806_BlingBling: 22338,
  Behr_P2807_MidsummerGold: 22339,
  Behr_P2901_SoftButtercup: 22340,
  Behr_P2902_SweetAsHoney: 22341,
  Behr_P2903_RoastedCorn: 22342,
  Behr_P2904_SpiritedYellow: 22343,
  Behr_P2905_SquashBlossom: 22344,
  Behr_P2906_EnglishDaisy: 22345,
  Behr_P2907_LaserLemon: 22346,
  Behr_P3001_LemonWhite: 22347,
  Behr_P3002_Meringue: 22348,
  Behr_P3003_RiteOfSpring: 22349,
  Behr_P3004_RiseAndShine: 22350,
  Behr_P3005_Upbeat: 22351,
  Behr_P3006_BuzzIn: 22352,
  Behr_P3007_UnmellowYellow: 22353,
  Behr_P3101_Effervescent: 22354,
  Behr_P3102_NaturalLight: 22355,
  Behr_P3103_Firefly: 22356,
  Behr_P3104_StormLightning: 22357,
  Behr_P3105_SolarEnergy: 22358,
  Behr_P3106_RadiantSun: 22359,
  Behr_P3107_Solarium: 22360,
  Behr_P3201_Flashpoint: 22361,
  Behr_P3202_LanternLight: 22362,
  Behr_P3203_LilyBulb: 22363,
  Behr_P3204_PineappleCrush: 22364,
  Behr_P3205_GreenPapaya: 22365,
  Behr_P3206A_FlusteredMustard: 22366,
  Behr_P3207_SweetSour: 22367,
  Behr_P3301_TartGelato: 22368,
  Behr_P3302_LimeBright: 22369,
  Behr_P3303A_Flourish: 22370,
  Behr_P3304_Starfruit: 22371,
  Behr_P3305_Midori: 22372,
  Behr_P3307_LusciousLime: 22373,
  Behr_P3401_Admiration: 22374,
  Behr_P3402_Invigorating: 22375,
  Behr_P3403_RevivingGreen: 22376,
  Behr_P3404_LimeTree: 22377,
  Behr_P3405A_CilantroLime: 22378,
  Behr_P3406_GreenNeon: 22379,
  Behr_P3407_Venom: 22380,
  Behr_P3501_BitOfLime: 22381,
  Behr_P3502_MayApple: 22382,
  Behr_P3503_GreenCharm: 22383,
  Behr_P3504_SpringGrass: 22384,
  Behr_P3506_Laser: 22385,
  Behr_P3507_LazyLizard: 22386,
  Behr_P3601_BuddingLeaf: 22387,
  Behr_P3602_IcedGreenApple: 22388,
  Behr_P3603_Tonic: 22389,
  Behr_P3604_SodaPop: 22390,
  Behr_P3605_CitrusPeel: 22391,
  Behr_P3607_SassyGrass: 22392,
  Behr_P3702_PrayingMantis: 22393,
  Behr_P3705_LazyCaterpillar: 22394,
  Behr_P3706_Salamander: 22395,
  Behr_P3707_SunValley: 22396,
  Behr_P3801_MagicMint: 22397,
  Behr_P3802_MistedFern: 22398,
  Behr_P3803_IrishFolklore: 22399,
  Behr_P3804_FourLeafClover: 22400,
  Behr_P3805_Gleeful: 22401,
  Behr_P3806_SpringviewGreen: 22402,
  Behr_P3807_LuckOfTheIrish: 22403,
  Behr_P3901_Frostini: 22404,
  Behr_P3902_ChilledMint: 22405,
  Behr_P3903_MintParfait: 22406,
  Behr_P3904_YoungGreen: 22407,
  Behr_P3905_GardenStroll: 22408,
  Behr_P3906_LawnParty: 22409,
  Behr_P3907_ParkPicnic: 22410,
  Behr_P4001_Mischievous: 22411,
  Behr_P4002_EndOfTheRainbow: 22412,
  Behr_P4003_FolkTale: 22413,
  Behr_P4004_GoodLuck: 22414,
  Behr_P4005_WinterShamrock: 22415,
  Behr_P4006_CloverPatch: 22416,
  Behr_P4007_ParadiseOfGreenery: 22417,
  Behr_P4101_Pondscape: 22418,
  Behr_P4102_Spearmints: 22419,
  Behr_P4103_ShanghaiJade: 22420,
  Behr_P4104_WillowHedge: 22421,
  Behr_P4105_LilyPads: 22422,
  Behr_P4106_SolitaryTree: 22423,
  Behr_P4107_Grasslands: 22424,
  Behr_P4201_SpringFrost: 22425,
  Behr_P4202_CrystalRapids: 22426,
  Behr_P4203_TropicalTrail: 22427,
  Behr_P4204A_GemSilica: 22428,
  Behr_P4205_ShamrockGreen: 22429,
  Behr_P4206_ExquisiteEmerald: 22430,
  Behr_P4207_CrownJewel: 22431,
  Behr_P4301_SummerHouse: 22432,
  Behr_P4302_AquaWish: 22433,
  Behr_P4303_GreenParakeet: 22434,
  Behr_P4304_Kauai: 22435,
  Behr_P4305_EnchantedWells: 22436,
  Behr_P4306A_CelticQueen: 22437,
  Behr_P4307_SparklingEmerald: 22438,
  Behr_P4401_ShimmeringPool: 22439,
  Behr_P4402_ClearAqua: 22440,
  Behr_P4403_FishPond: 22441,
  Behr_P4404_MarchAquamarine: 22442,
  Behr_P4405_WaterPark: 22443,
  Behr_P4406_Esmeralda: 22444,
  Behr_P4407_MermaidSea: 22445,
  Behr_P4501_SeaIce: 22446,
  Behr_P4502_TahitianBreeze: 22447,
  Behr_P4503_Rainwater: 22448,
  Behr_P4504_HiddenSeaGlass: 22449,
  Behr_P4505_IslandAqua: 22450,
  Behr_P4506_Tropics: 22451,
  Behr_P4507_MysticTurquoise: 22452,
  Behr_P4601_MorningSky: 22453,
  Behr_P4602_TropicalWaterfall: 22454,
  Behr_P4603_SoftTurquoise: 22455,
  Behr_P4605_Fiji: 22456,
  Behr_P4606_ParadiseLandscape: 22457,
  Behr_P4607_CaribbeanCurrent: 22458,
  Behr_P4701_SilentBreeze: 22459,
  Behr_P4702_SereneThought: 22460,
  Behr_P4703_SeaOfTranquility: 22461,
  Behr_P4704_ParadiseSky: 22462,
  Behr_P4705_PlacidSea: 22463,
  Behr_P4706_BellaVista: 22464,
  Behr_P4707_TheRealTeal: 22465,
  Behr_P4801_NiagaraMist: 22466,
  Behr_P4802_CrystalFalls: 22467,
  Behr_P4803_CoolWaterLake: 22468,
  Behr_P4804_RushingStream: 22469,
  Behr_P4805_HighDive: 22470,
  Behr_P4806_ArubaBlue: 22471,
  Behr_P4807_Striking: 22472,
  Behr_P4901_OceanFront: 22473,
  Behr_P4902_BlueSarong: 22474,
  Behr_P4903_BigChill: 22475,
  Behr_P4904_AztecSky: 22476,
  Behr_P4905_Yucatan: 22477,
  Behr_P4906_HaciendaBlue: 22478,
  Behr_P4907_MayanTreasure: 22479,
  Behr_P5001_SpaciousSkies: 22480,
  Behr_P5002_SeashoreDreams: 22481,
  Behr_P5003_SpaBlue: 22482,
  Behr_P5004_LifeForce: 22483,
  Behr_P5005_PeacefulRiver: 22484,
  Behr_P5006_DeepRiver: 22485,
  Behr_P5007_CosmicCobalt: 22486,
  Behr_P5101_GreekIsles: 22487,
  Behr_P5102_MediterraneanCharm: 22488,
  Behr_P5103_Rhodes: 22489,
  Behr_P5104_Electra: 22490,
  Behr_P5105_PerfectSky: 22491,
  Behr_P5106_BrilliantBlue: 22492,
  Behr_P5107_BeaconBlue: 22493,
  Behr_P5201_FirstRain: 22494,
  Behr_P5202_FrenchPorcelain: 22495,
  Behr_P5204_Cornflower: 22496,
  Behr_P5205_BoatHouse: 22497,
  Behr_P5206_MegaBlue: 22498,
  Behr_P5207_FlashySapphire: 22499,
  Behr_P5301_Loyal: 22500,
  Behr_P5302_PromiseKeeping: 22501,
  Behr_P5303_Honest: 22502,
  Behr_P5304_Periwinkle: 22503,
  Behr_P5305_Integrity: 22504,
  Behr_P5306_IndigoBatik: 22505,
  Behr_P5307_Tanzanite: 22506,
  Behr_P5401_VaguelyViolet: 22507,
  Behr_P5402_GardenFairy: 22508,
  Behr_P5403_CanterburyBells: 22509,
  Behr_P5404_LavenderSky: 22510,
  Behr_P5405_PansyGarden: 22511,
  Behr_P5406_WildPansy: 22512,
  Behr_P5407_CanyonIris: 22513,
  Behr_P5501_Imagination: 22514,
  Behr_P5502_ArtisticViolet: 22515,
  Behr_P5503_LavenderCloud: 22516,
  Behr_P5504_WaterHyacinth: 22517,
  Behr_P5505_CarriageRide: 22518,
  Behr_P5507_PurplePrince: 22519,
  Behr_P5701_TearyEyed: 22520,
  Behr_P5702_Confetti: 22521,
  Behr_P5703_FlowerGirl: 22522,
  Behr_P5704_ClassicBouquet: 22523,
  Behr_P5705_RomanticMoment: 22524,
  Behr_P5706_ClassicWaltz: 22525,
  Behr_P5707_ProperPurple: 22526,
  Behr_PPU1001_Scallion: 22527,
  Behr_PPU1003_GreenEnergy: 22528,
  Behr_PPU1004_NewBamboo: 22529,
  Behr_PPU1008_MintedLemon: 22530,
  Behr_PPU1009_ChineseJade: 22531,
  Behr_PPU1011_SlicedCucumber: 22532,
  Behr_PPU1012_WhitenedSage: 22533,
  Behr_PPU1013_SnowyPine: 22534,
  Behr_PPU1014_IvoryPalace: 22535,
  Behr_PPU1016_SimplySage: 22536,
  Behr_PPU1017_AloeThorn: 22537,
  Behr_PPU1019_ConiferGreen: 22538,
  Behr_PPU102_DivineWine: 22539,
  Behr_PPU1020_Pastoral: 22540,
  Behr_PPU104A_WatermelonPunch: 22541,
  Behr_PPU110_ForbiddenRed: 22542,
  Behr_PPU1101_RoyalOrchard: 22543,
  Behr_PPU1105_PestoGreen: 22544,
  Behr_PPU1107_ClarySage: 22545,
  Behr_PPU1108_MossPrint: 22546,
  Behr_PPU1109_Environmental: 22547,
  Behr_PPU1110_WhitewaterBay: 22548,
  Behr_PPU1111_SummerGreen: 22549,
  Behr_PPU1112_MildMint: 22550,
  Behr_PPU1113_FrostedJade: 22551,
  Behr_PPU1114_Zen: 22552,
  Behr_PPU1115_GreenBalsam: 22553,
  Behr_PPU1117_HillsideGreen: 22554,
  Behr_PPU1118_CactusGarden: 22555,
  Behr_PPU1120_Congo: 22556,
  Behr_PPU113_SpicedWine: 22557,
  Behr_PPU114_FormalMaroon: 22558,
  Behr_PPU1203_Dragonfly: 22559,
  Behr_PPU1204_Agave: 22560,
  Behr_PPU1205_LotusLeaf: 22561,
  Behr_PPU1207_SpringStream: 22562,
  Behr_PPU1208_OpalSilk: 22563,
  Behr_PPU1210_MistyMorn: 22564,
  Behr_PPU1211_SaltGlaze: 22565,
  Behr_PPU1212_GalleryWhite: 22566,
  Behr_PPU1213_UrbanMist: 22567,
  Behr_PPU1214_Verdigris: 22568,
  Behr_PPU1215_Atmospheric: 22569,
  Behr_PPU1216_JuniperAsh: 22570,
  Behr_PPU1217_CameroonGreen: 22571,
  Behr_PPU1218_HeritagePark: 22572,
  Behr_PPU1219_MountainPine: 22573,
  Behr_PPU1220_Underwater: 22574,
  Behr_PPU1301_Caribe: 22575,
  Behr_PPU1302_JuniperBerries: 22576,
  Behr_PPU1303_CatalinaCoast: 22577,
  Behr_PPU1307_Voyage: 22578,
  Behr_PPU1308_VenusTeal: 22579,
  Behr_PPU1309_TahoeBlue: 22580,
  Behr_PPU1310_OceanBoulevard: 22581,
  Behr_PPU1311_ClearVista: 22582,
  Behr_PPU1312_Harmonious: 22583,
  Behr_PPU1313_OsloBlue: 22584,
  Behr_PPU1314_Ozone: 22585,
  Behr_PPU1315_ClearPond: 22586,
  Behr_PPU1316_OffshoreMist: 22587,
  Behr_PPU1317_FreshDay: 22588,
  Behr_PPU1320_RestlessSea: 22589,
  Behr_PPU134_AtlanticShoreline: 22590,
  Behr_PPU1401_ArrowheadLake: 22591,
  Behr_PPU1402_GlassSapphire: 22592,
  Behr_PPU1405_ForeverDenim: 22593,
  Behr_PPU1412_HazySkies: 22594,
  Behr_PPU1418_LagunaBlue: 22595,
  Behr_PPU1419_EnglishChannel: 22596,
  Behr_PPU1420_StarlessNight: 22597,
  Behr_PPU1503_DarkCobaltBlue: 22598,
  Behr_PPU1504_MosaicBlue: 22599,
  Behr_PPU1505_NewAgeBlue: 22600,
  Behr_PPU1506_NeonBlue: 22601,
  Behr_PPU1510_ChinaSilk: 22602,
  Behr_PPU1512_Bluebird: 22603,
  Behr_PPU1515_SweetJuliet: 22604,
  Behr_PPU1516_SimplyBlue: 22605,
  Behr_PPU1517_Monet: 22606,
  Behr_PPU1518_VintageVelvet: 22607,
  Behr_PPU1519_BlackSapphire: 22608,
  Behr_PPU1520_PoppySeed: 22609,
  Behr_PPU1702_OrientalEggplant: 22610,
  Behr_PPU1801_CrackedPepper: 22611,
  Behr_PPU1802_PencilPoint: 22612,
  Behr_PPU1803_AntiqueTin: 22613,
  Behr_PPU1804_DarkPewter: 22614,
  Behr_PPU1805_FrenchSilver: 22615,
  Behr_PPU1807_FallingSnow: 22616,
  Behr_PPU1809_BurnishedClay: 22617,
  Behr_PPU1810_NaturalGray: 22618,
  Behr_PPU1811_ClassicSilver: 22619,
  Behr_PPU1812_GracefulGray: 22620,
  Behr_PPU1813_PerfectTaupe: 22621,
  Behr_PPU1814_CathedralGray: 22622,
  Behr_PPU1815_FashionGray: 22623,
  Behr_PPU1816_ElephantSkin: 22624,
  Behr_PPU1817_SuedeGray: 22625,
  Behr_PPU1818_MinedCoal: 22626,
  Behr_PPU1819_Intellectual: 22627,
  Behr_PPU1820_Broadway: 22628,
  Behr_PPU201_ChipotlePaste: 22629,
  Behr_PPU202_RedPepper: 22630,
  Behr_PPU203_Allure: 22631,
  Behr_PPU204_PaleCashmere: 22632,
  Behr_PPU205_SheerScarf: 22633,
  Behr_PPU211_MarsRed: 22634,
  Behr_PPU212_TerraCottaUrn: 22635,
  Behr_PPU214_TibetanOrange: 22636,
  Behr_PPU215_CajunRed: 22637,
  Behr_PPU216_FireCracker: 22638,
  Behr_PPU217_MoroccoRed: 22639,
  Behr_PPU218_Spice: 22640,
  Behr_PPU219_RoyalLiqueur: 22641,
  Behr_PPU220_Oxblood: 22642,
  Behr_PPU2401_BlackMocha: 22643,
  Behr_PPU2402_BerryBrown: 22644,
  Behr_PPU2403_Chinchilla: 22645,
  Behr_PPU2404_BurnishedPewter: 22646,
  Behr_PPU2405_Ancestral: 22647,
  Behr_PPU2406_SlipperyShale: 22648,
  Behr_PPU2407_BarnwoodGray: 22649,
  Behr_PPU2408_ParadorStone: 22650,
  Behr_PPU2409_TrueTaupewood: 22651,
  Behr_PPU2410_DowntownGray: 22652,
  Behr_PPU2411_Greige: 22653,
  Behr_PPU2412_WhitewashOak: 22654,
  Behr_PPU2413_WhitePepper: 22655,
  Behr_PPU2414_WhiteModerne: 22656,
  Behr_PPU2415_MissionWhite: 22657,
  Behr_PPU2416_Titanium: 22658,
  Behr_PPU2417_HailstormGray: 22659,
  Behr_PPU2418_GreatGraphite: 22660,
  Behr_PPU2419_SharkFin: 22661,
  Behr_PPU2420_LetterGray: 22662,
  Behr_PPU2421_Greyhound: 22663,
  Behr_PPU2422_ShadowMountain: 22664,
  Behr_PPU2423_LittleBlackDress: 22665,
  Behr_PPU2501_CarbonCopy: 22666,
  Behr_PPU2502_BlackLocust: 22667,
  Behr_PPU2503_Shadows: 22668,
  Behr_PPU2504_Sharkskin: 22669,
  Behr_PPU2505_OldCeladon: 22670,
  Behr_PPU2506_WellsGray: 22671,
  Behr_PPU2507_AridPlains: 22672,
  Behr_PPU2508_HeirloomSilver: 22673,
  Behr_PPU2509_FoggyLondon: 22674,
  Behr_PPU2510_SoftSecret: 22675,
  Behr_PPU2511_SaltCellar: 22676,
  Behr_PPU2512_Minimalistic: 22677,
  Behr_PPU2513_MistyCoast: 22678,
  Behr_PPU2514_EngagementSilver: 22679,
  Behr_PPU2515_Flipper: 22680,
  Behr_PPU2516_ChainReaction: 22681,
  Behr_PPU2517_EuroGray: 22682,
  Behr_PPU2518_ShutterGray: 22683,
  Behr_PPU2519_OceanSwell: 22684,
  Behr_PPU2520_LeLuxe: 22685,
  Behr_PPU2521_CityRain: 22686,
  Behr_PPU2522_Chimney: 22687,
  Behr_PPU2523_WinterWay: 22688,
  Behr_PPU2601_SatinBlack: 22689,
  Behr_PPU2602_ImperialGray: 22690,
  Behr_PPU2603_LegendaryGray: 22691,
  Behr_PPU2604_FalconGray: 22692,
  Behr_PPU2605_FlintGray: 22693,
  Behr_PPU2606_ElementalGray: 22694,
  Behr_PPU2607_SmokeyWings: 22695,
  Behr_PPU2608_Silverstone: 22696,
  Behr_PPU2609_Graycloth: 22697,
  Behr_PPU2610_ChicGray: 22698,
  Behr_PPU2611_Platinum: 22699,
  Behr_PPU2612_SolemnSilence: 22700,
  Behr_PPU2613_SilentWhite: 22701,
  Behr_PPU2614_Drizzle: 22702,
  Behr_PPU2615_Halation: 22703,
  Behr_PPU2616_Hush: 22704,
  Behr_PPU2617_FastAsTheWind: 22705,
  Behr_PPU2618_SilverMine: 22706,
  Behr_PPU2619_ChanceOfRain: 22707,
  Behr_PPU2620_SmokeyLilac: 22708,
  Behr_PPU2621_Overcast: 22709,
  Behr_PPU2622_SummerStorm: 22710,
  Behr_PPU2623_BlackBoudoir: 22711,
  Behr_PPU2623A_DarkSecret: 22712,
  Behr_PPU301_MoroccanSky: 22713,
  Behr_PPU303_FlamingTorch: 22714,
  Behr_PPU304_BalletWhite: 22715,
  Behr_PPU308_SiennaDust: 22716,
  Behr_PPU309_PumpkinCream: 22717,
  Behr_PPU310_NairobiDusk: 22718,
  Behr_PPU311_AutumnAir: 22719,
  Behr_PPU312_EgyptianPyramid: 22720,
  Behr_PPU313_GlazedGinger: 22721,
  Behr_PPU314_TribalPottery: 22722,
  Behr_PPU315_GlazedPot: 22723,
  Behr_PPU316_MapleGlaze: 22724,
  Behr_PPU317_ClayPot: 22725,
  Behr_PPU318_Artisan: 22726,
  Behr_PPU319_MoroccanHenna: 22727,
  Behr_PPU320_Cinnabark: 22728,
  Behr_PPU401_CaramelSwirl: 22729,
  Behr_PPU402_CocoRum: 22730,
  Behr_PPU403_ButterRum: 22731,
  Behr_PPU404_SoftChamois: 22732,
  Behr_PPU405_Basketry: 22733,
  Behr_PPU406_Teatime: 22734,
  Behr_PPU407_MushroomBisque: 22735,
  Behr_PPU408_Plateau: 22736,
  Behr_PPU409_CafeCream: 22737,
  Behr_PPU410A_SandyBeige: 22738,
  Behr_PPU411_PorcelainPeach: 22739,
  Behr_PPU412_NaturalAlmond: 22740,
  Behr_PPU413_SandMotif: 22741,
  Behr_PPU414_RenoirBisque: 22742,
  Behr_PPU415_JasperCane: 22743,
  Behr_PPU416_Kenya: 22744,
  Behr_PPU420_AncientRoot: 22745,
  Behr_PPU501_EspressoBeans: 22746,
  Behr_PPU502_AgingBarrel: 22747,
  Behr_PPU503_AntiqueEarth: 22748,
  Behr_PPU504_MochaLatte: 22749,
  Behr_PPU505_CoconutShell: 22750,
  Behr_PPU506A_LightTruffle: 22751,
  Behr_PPU507_StudioTaupe: 22752,
  Behr_PPU508_SculptorClay: 22753,
  Behr_PPU509_BleachedLinen: 22754,
  Behr_PPU510_HeavyCream: 22755,
  Behr_PPU511_DelicateLace: 22756,
  Behr_PPU512_AlmondWisp: 22757,
  Behr_PPU513_CreamyMushroom: 22758,
  Behr_PPU514_MesaTaupe: 22759,
  Behr_PPU515_PostmodernMauve: 22760,
  Behr_PPU516_Earthnut: 22761,
  Behr_PPU517_CardamomSpice: 22762,
  Behr_PPU518_ChocolateSwirl: 22763,
  Behr_PPU519_DarkTruffle: 22764,
  Behr_PPU520_SweetMolasses: 22765,
  Behr_PPU602_SaffronStrands: 22766,
  Behr_PPU603_Sunburst: 22767,
  Behr_PPU605_Cork: 22768,
  Behr_PPU606_HoneyLocust: 22769,
  Behr_PPU607_Jackfruit: 22770,
  Behr_PPU608_PaleHoney: 22771,
  Behr_PPU609_PolishedPearl: 22772,
  Behr_PPU610_CreamPuff: 22773,
  Behr_PPU611_Hummus: 22774,
  Behr_PPU612_Calla: 22775,
  Behr_PPU613_HawaiianPineapple: 22776,
  Behr_PPU614_Charismatic: 22777,
  Behr_PPU705_PureEarth: 22778,
  Behr_PPU706_Chateau: 22779,
  Behr_PPU707_RivieraBeach: 22780,
  Behr_PPU708_Baja: 22781,
  Behr_PPU709_AgedBeige: 22782,
  Behr_PPU710_RomanPlaster: 22783,
  Behr_PPU711_CottonKnit: 22784,
  Behr_PPU712_SilkyWhite: 22785,
  Behr_PPU713_CoastalBeige: 22786,
  Behr_PPU714_AppleCore: 22787,
  Behr_PPU715_IvoryLace: 22788,
  Behr_PPU716_VintageLinen: 22789,
  Behr_PPU717_WaxSculpture: 22790,
  Behr_PPU718_SandPearl: 22791,
  Behr_PPU719_Crepe: 22792,
  Behr_PPU720_RaffiaRibbon: 22793,
  Behr_PPU721_WovenStraw: 22794,
  Behr_PPU722_SafariVest: 22795,
  Behr_PPU723_RollingPebble: 22796,
  Behr_PPU724A_HikingTrail: 22797,
  Behr_PPU725_CloveBrown: 22798,
  Behr_PPU810_RyeBread: 22799,
  Behr_PPU814_SilkyBamboo: 22800,
  Behr_PPU815_Stonewashed: 22801,
  Behr_PPU816_ColiseumMarble: 22802,
  Behr_PPU817_FortressStone: 22803,
  Behr_PPU819_StoneWalls: 22804,
  Behr_PPU820_DustyOlive: 22805,
  Behr_PPU822_Pier: 22806,
  Behr_PPU823_Manuscript: 22807,
  Behr_PPU903_RetroAvocado: 22808,
  Behr_PPU907_FreshSprout: 22809,
  Behr_PPU909_Seedling: 22810,
  Behr_PPU921_Sanctuary: 22811,
  Behr_PPU922_Cricket: 22812,
  Behr_PPU923_OreganoSpice: 22813,
  Behr_PPU924_AmazonJungle: 22814,
  Behr_PPU925_EasternBamboo: 22815,
  Behr_PRW03_MelodicWhite: 22816,
  Behr_PRW04_OpulentOpal: 22817,
  Behr_PRW05_SweetRoses: 22818,
  Behr_PRW07_FadingFog: 22819,
  Behr_PRW08_AmbienceWhite: 22820,
  Behr_PRW09_NimbusCloud: 22821,
  Behr_PRW10_SwirlingWater: 22822,
  Behr_PRW11_Patience: 22823,
  Behr_PRW12_TimidWhite: 22824,
  Behr_PRW13_CrystalCut: 22825,
  Behr_PRW14_BitOfSugar: 22826,
  Behr_RDW01_PinkPrism: 22827,
  Behr_RDW02_CandyFloss: 22828,
  Behr_RDW03_MySweetheart: 22829,
  Behr_RDW05_MoonlitBeach: 22830,
  Behr_RDW08_PinkMirage: 22831,
  Behr_RDW09_Shea: 22832,
  Behr_RDW10_NewHouseWhite: 22833,
  Behr_RDW14_AriaIvory: 22834,
  Behr_RDW15_CottonSheets: 22835,
  Behr_S1003_CourtlyPurple: 22836,
  Behr_S1004_AncestryViolet: 22837,
  Behr_S1005_PurplePotion: 22838,
  Behr_S1006_BlackberryJam: 22839,
  Behr_S1007_MedievalWine: 22840,
  Behr_S1102_OrchidHaze: 22841,
  Behr_S1104_HighlandThistle: 22842,
  Behr_S1105_GardenPlum: 22843,
  Behr_S1106_PlumRoyale: 22844,
  Behr_S1107_ExoticEggplant: 22845,
  Behr_S1201_WinePairing: 22846,
  Behr_S1202_Etiquette: 22847,
  Behr_S1203_CandlelightDinner: 22848,
  Behr_S1204_Decanting: 22849,
  Behr_S1205_Reserve: 22850,
  Behr_S1206_FullGlass: 22851,
  Behr_S1207_FineWine: 22852,
  Behr_S1301_BelovedPink: 22853,
  Behr_S1302_ShySmile: 22854,
  Behr_S1303_BalletRose: 22855,
  Behr_S1304_CherryJuice: 22856,
  Behr_S1305_HeirloomRose: 22857,
  Behr_S1306_SpicedPotpourri: 22858,
  Behr_S1307_CherryCola: 22859,
  Behr_S1401_RadiantRose: 22860,
  Behr_S1402_CranappleCream: 22861,
  Behr_S1403_BerryCrush: 22862,
  Behr_S1404A_DustyRose: 22863,
  Behr_S1405_RedGerbera: 22864,
  Behr_S1406_MoroccanRuby: 22865,
  Behr_S1407_DecoRed: 22866,
  Behr_S1501_Cherubic: 22867,
  Behr_S1502_TeaRoom: 22868,
  Behr_S1503_RosePottery: 22869,
  Behr_S1504_RedClover: 22870,
  Behr_S1505_Vermilion: 22871,
  Behr_S1506_SpicedBerry: 22872,
  Behr_S1507_FireRoasted: 22873,
  Behr_S1601_IcedCherry: 22874,
  Behr_S1602_PinkQuartz: 22875,
  Behr_S1603_BubbleShell: 22876,
  Behr_S1604_PortugueseDawn: 22877,
  Behr_S1606_RedPotato: 22878,
  Behr_S1607_RedChipotle: 22879,
  Behr_S1702_Rosewater: 22880,
  Behr_S1703_CastilianPink: 22881,
  Behr_S1704_RetroPink: 22882,
  Behr_S1705_SmokeBushRose: 22883,
  Behr_S1706_RedCurry: 22884,
  Behr_S1707_DarkCherryMocha: 22885,
  Behr_S1801_Angelico: 22886,
  Behr_S1802_SunwashedBrick: 22887,
  Behr_S1803_Flowerpot: 22888,
  Behr_S1804_ShinyKettle: 22889,
  Behr_S1805_AuburnGlaze: 22890,
  Behr_S1806_PerfectPenny: 22891,
  Behr_S1807_TrueCopper: 22892,
  Behr_S1901_SeasideVilla: 22893,
  Behr_S1902_SandDance: 22894,
  Behr_S1903_SedonaPink: 22895,
  Behr_S1904_SpicedBrandy: 22896,
  Behr_S1905_CocoaNutmeg: 22897,
  Behr_S1906_RioRust: 22898,
  Behr_S1907_ToastedPecan: 22899,
  Behr_S2001_ConchShell: 22900,
  Behr_S2002_CinnamonTea: 22901,
  Behr_S2003_IcedCopper: 22902,
  Behr_S2004_ChestnutBisque: 22903,
  Behr_S2005_Minestrone: 22904,
  Behr_S2006_TimelessCopper: 22905,
  Behr_S2007_EarthFiredRed: 22906,
  Behr_S2101_NutmegFrost: 22907,
  Behr_S2102_TapestryBeige: 22908,
  Behr_S2103_SweetTea: 22909,
  Behr_S2104_CanyonDusk: 22910,
  Behr_S2105_CiderSpice: 22911,
  Behr_S2106_CinnamonCrunch: 22912,
  Behr_S2107_OctoberLeaves: 22913,
  Behr_S2201_AutumnBlush: 22914,
  Behr_S2202_ArtisanTea: 22915,
  Behr_S2203_Sanderling: 22916,
  Behr_S2205_Nutshell: 22917,
  Behr_S2206_BakedSienna: 22918,
  Behr_S2207_Molasses: 22919,
  Behr_S2301_BuffTone: 22920,
  Behr_S2302_MesquitePowder: 22921,
  Behr_S2303_BeechNut: 22922,
  Behr_S2305_SugarMaple: 22923,
  Behr_S2306_BurntToffee: 22924,
  Behr_S2307_ToastedBagel: 22925,
  Behr_S2401_CremeFraiche: 22926,
  Behr_S2402_RiceCrackers: 22927,
  Behr_S2403_AshBlonde: 22928,
  Behr_S2404_PacificBluffs: 22929,
  Behr_S2405_Poncho: 22930,
  Behr_S2406_RanchBrown: 22931,
  Behr_S2407_LeatherWork: 22932,
  Behr_S2501_MacaroonCream: 22933,
  Behr_S2502_AlmondBiscuit: 22934,
  Behr_S2503_HoneyNougat: 22935,
  Behr_S2504_FreshCroissant: 22936,
  Behr_S2506_DesertClay: 22937,
  Behr_S2507_MoroccanSpice: 22938,
  Behr_S2602_PumpkinSeed: 22939,
  Behr_S2603_DustyGold: 22940,
  Behr_S2604_PelicanTan: 22941,
  Behr_S2605_AlmondRoca: 22942,
  Behr_S2606_CircusPeanut: 22943,
  Behr_S2607_NuggetGold: 22944,
  Behr_S2701_FrostedToffee: 22945,
  Behr_S2702_Chai: 22946,
  Behr_S2703_Tostada: 22947,
  Behr_S2704_Praline: 22948,
  Behr_S2705_Gingersnap: 22949,
  Behr_S2706_AlmondBrittle: 22950,
  Behr_S2707_AntiquePenny: 22951,
  Behr_S2801_BuckwheatFlour: 22952,
  Behr_S2802_BeachGrass: 22953,
  Behr_S2803_PracticalTan: 22954,
  Behr_S2804_RealCork: 22955,
  Behr_S2805_WindsweptLeaves: 22956,
  Behr_S2806_Hazel: 22957,
  Behr_S2807_RoastedSquash: 22958,
  Behr_S2901_VanillaPaste: 22959,
  Behr_S2902_WhiteBeanHummus: 22960,
  Behr_S2904_Summerwood: 22961,
  Behr_S2905_AmberAutumn: 22962,
  Behr_S2906_GoldenRice: 22963,
  Behr_S2907_WaveOfGrain: 22964,
  Behr_S3001_FrenchCreme: 22965,
  Behr_S3002_PowderedGold: 22966,
  Behr_S3004_FlaxStraw: 22967,
  Behr_S3005_SpicedMustard: 22968,
  Behr_S3006_HarvestTime: 22969,
  Behr_S3007_RococoGold: 22970,
  Behr_S3101_WritingPaper: 22971,
  Behr_S3102_JournalWhite: 22972,
  Behr_S3103_NaturalTwine: 22973,
  Behr_S3104_PerennialGold: 22974,
  Behr_S3105_BrazilianCitrine: 22975,
  Behr_S3106_GoldInk: 22976,
  Behr_S3107A_VintageBrass: 22977,
  Behr_S3201_FarmHouse: 22978,
  Behr_S3202_PaleParsnip: 22979,
  Behr_S3203_FinalStraw: 22980,
  Behr_S3205_GingerTea: 22981,
  Behr_S3206_GardenSaltGreen: 22982,
  Behr_S3207_AfricanPlain: 22983,
  Behr_S3301_BabyArtichoke: 22984,
  Behr_S3302_CarawaySeeds: 22985,
  Behr_S3303_SeasonedSalt: 22986,
  Behr_S3304_FennelSeed: 22987,
  Behr_S3305_DriedChive: 22988,
  Behr_S3306_DashOfOregano: 22989,
  Behr_S3307_OliveShade: 22990,
  Behr_S3401_Lychee: 22991,
  Behr_S3402_GreenPower: 22992,
  Behr_S3403_Hybrid: 22993,
  Behr_S3404_BackToNature: 22994,
  Behr_S3405_FarmFresh: 22995,
  Behr_S3406_FertileGreen: 22996,
  Behr_S3407A_Garnish: 22997,
  Behr_S3501A_CoolHoneydew: 22998,
  Behr_S3502_Windmill: 22999,
  Behr_S3503_WashedOlive: 23000,
  Behr_S3504A_DriedRosemary: 23001,
  Behr_S3505_GreenScene: 23002,
  Behr_S3506_TrulyOlive: 23003,
  Behr_S3601_YogaDaze: 23004,
  Behr_S3602_Breathe: 23005,
  Behr_S3603_BalanceGreen: 23006,
  Behr_S3604_MeditationTime: 23007,
  Behr_S3606_SecretMeadow: 23008,
  Behr_S3701_PositiveEnergy: 23009,
  Behr_S3702_FengShui: 23010,
  Behr_S3703_SageBrush: 23011,
  Behr_S3704_Rejuvenation: 23012,
  Behr_S3705_PestoPaste: 23013,
  Behr_S3706_SeaweedSalad: 23014,
  Behr_S3707_OutdoorOasis: 23015,
  Behr_S3801_MossMist: 23016,
  Behr_S3802_MorningZen: 23017,
  Behr_S3803_UrbanNature: 23018,
  Behr_S3804_BayWater: 23019,
  Behr_S3805_MilkweedPod: 23020,
  Behr_S3806_Ecological: 23021,
  Behr_S3807_GlobalGreen: 23022,
  Behr_S3901_SoundsOfNature: 23023,
  Behr_S3902_SpringValley: 23024,
  Behr_S3903_CreamySpinach: 23025,
  Behr_S3904_RoofTopGarden: 23026,
  Behr_S3905_LaurelTree: 23027,
  Behr_S3907_TrailingVine: 23028,
  Behr_S4001_AtEase: 23029,
  Behr_S4002_ComfortingGreen: 23030,
  Behr_S4003_HealingAloe: 23031,
  Behr_S4004_AzaleaLeaf: 23032,
  Behr_S4005_GalleryGreen: 23033,
  Behr_S4006_TuscanHerbs: 23034,
  Behr_S4007_DeepViridian: 23035,
  Behr_S4101_RiverMist: 23036,
  Behr_S4104_CopperPatina: 23037,
  Behr_S4105_TrackGreen: 23038,
  Behr_S4106_GreenerPastures: 23039,
  Behr_S4107_EquestrianGreen: 23040,
  Behr_S4201_NewDay: 23041,
  Behr_S4202_MoonGlass: 23042,
  Behr_S4203_NileRiver: 23043,
  Behr_S4204_AustralianJade: 23044,
  Behr_S4205_SycamoreGrove: 23045,
  Behr_S4206_PineBrook: 23046,
  Behr_S4207_SecludedWoods: 23047,
  Behr_S4301A_ReflectingMoment: 23048,
  Behr_S4302_FreshTone: 23049,
  Behr_S4304_GreenMeetsBlue: 23050,
  Behr_S4305_Longmeadow: 23051,
  Behr_S4306_ForestEdge: 23052,
  Behr_S4401_SunkenPool: 23053,
  Behr_S4402_MalaysianMist: 23054,
  Behr_S4403_AspiringBlue: 23055,
  Behr_S4404_TowerBridge: 23056,
  Behr_S4405_TasmanianSea: 23057,
  Behr_S4407_Thermal: 23058,
  Behr_S4501_BeachFoam: 23059,
  Behr_S4502_WindSpeed: 23060,
  Behr_S4503_SpringStorm: 23061,
  Behr_S4505_OarsmanBlue: 23062,
  Behr_S4506A_RiverRapids: 23063,
  Behr_S4507A_OutToSea: 23064,
  Behr_S4601_AirBlue: 23065,
  Behr_S4602_Drip: 23066,
  Behr_S4603_BlueEcho: 23067,
  Behr_S4604_Snowboard: 23068,
  Behr_S4605_BlueSquare: 23069,
  Behr_S4606_MammothMountain: 23070,
  Behr_S4607_DeepBreath: 23071,
  Behr_S4701_CloudySky: 23072,
  Behr_S4702_GentleSea: 23073,
  Behr_S4703_PeacefulBlue: 23074,
  Behr_S4704_DolphinBlue: 23075,
  Behr_S4705_Blueprint: 23076,
  Behr_S4706_Shipwreck: 23077,
  Behr_S4707_Undersea: 23078,
  Behr_S4801_RainDance: 23079,
  Behr_S4802_SeaWind: 23080,
  Behr_S4803_SydneyHarbour: 23081,
  Behr_S4804_SagaBlue: 23082,
  Behr_S4805_BlueMoonBay: 23083,
  Behr_S4806_Poseidon: 23084,
  Behr_S4807_MidnightInTheTropics: 23085,
  Behr_S4901_Permafrost: 23086,
  Behr_S4902_GlacialStream: 23087,
  Behr_S4903_ReefBlue: 23088,
  Behr_S4904_YachtBlue: 23089,
  Behr_S4905_JayBird: 23090,
  Behr_S4906_BeringWave: 23091,
  Behr_S4907_SuperiorBlue: 23092,
  Behr_S5001_DistantShore: 23093,
  Behr_S5003_PartlyCloudy: 23094,
  Behr_S5004_ChillyBlue: 23095,
  Behr_S5005_TreasureMap: 23096,
  Behr_S5006_Shipyard: 23097,
  Behr_S5007_InfiniteDeepSea: 23098,
  Behr_S5102_BootCut: 23099,
  Behr_S5103_OmbreBlue: 23100,
  Behr_S5104_JeanJacketBlue: 23101,
  Behr_S5105_SkinnyJeans: 23102,
  Behr_S5106_DurangoBlue: 23103,
  Behr_S5107_DarkDenim: 23104,
  Behr_S5201_PaleCornflower: 23105,
  Behr_S5203_PerfectLanding: 23106,
  Behr_S5205_Thundercloud: 23107,
  Behr_S5206_LayersOfOcean: 23108,
  Behr_S5207_NightFlight: 23109,
  Behr_S5303_AerialView: 23110,
  Behr_S5304_JetSet: 23111,
  Behr_S5305_BriskBlue: 23112,
  Behr_S5306_Extreme: 23113,
  Behr_S5307_DarkNavy: 23114,
  Behr_S5401_SoBlueBerry: 23115,
  Behr_S5402_VioletVision: 23116,
  Behr_S5403_MeadowPhlox: 23117,
  Behr_S5404_VintageRibbon: 23118,
  Behr_S5405_VelvetCurtain: 23119,
  Behr_S5406_DangerouslyElegant: 23120,
  Behr_S5501_BlueberryWhip: 23121,
  Behr_S5502_PowderLilac: 23122,
  Behr_S5503_Chivalrous: 23123,
  Behr_S5504_Camelot: 23124,
  Behr_S5505_Fantasia: 23125,
  Behr_S5506_MysteriousNight: 23126,
  Behr_S5701_MistyLavender: 23127,
  Behr_S5702_MagicScent: 23128,
  Behr_S5703_Bohemianism: 23129,
  Behr_S5704_NightMusic: 23130,
  Behr_S5705_LiveJazz: 23131,
  Behr_S5706_NewOrleans: 23132,
  Behr_S5707A_PlushPurple: 23133,
  Behr_SG720_Fireside: 1832,
  Behr_SG790_BearRug: 23134,
  Behr_SH160_SlyFox: 1833,
  Behr_ST129_Chocolate: 11454,
  Behr_UPW_UltraPureWhite: 23135,
  Behr_WF720_SilverLeaf: 1834,
  Behr_YLW01_SpinningSilk: 23136,
  Behr_YLW02_SpanishLace: 23137,
  Behr_YLW03_HoniedWhite: 23138,
  Behr_YLW07_SmoothSilk: 23139,
  Behr_YLW08_YuccaWhite: 23140,
  Behr_YLW09_SpunCotton: 23141,
  Behr_YLW10_NightBloomingJasmine: 23142,
  Behr_YLW11_KhakiShade: 23143,
  Behr_YLW13_SentimentalBeige: 23144,
};

const DMC_BenjaminMoore = {
  BM_1_PinkPowderpuff: 11528,
  BM_10_PinkCanopy: 11529,
  BM_100_GoldenBeige: 11530,
  BM_1000_NorthwoodBrown: 11531,
  BM_1001_NorthCreekBrown: 11532,
  BM_1002_Featherstone: 11533,
  BM_1003_KittenWhiskers: 11534,
  BM_1004_DesertLight: 11535,
  BM_1005_Hazelwood: 11536,
  BM_1006_Creekbed: 11537,
  BM_1007_Beigewood: 11538,
  BM_1008_DevonwoodTaupe: 11539,
  BM_1009_BrideToBe: 11540,
  BM_101_MelonCup: 11541,
  BM_1010_RoseDust: 11542,
  BM_1011_MeadowPink: 11543,
  BM_1012_WhisperingWoods: 11544,
  BM_1013_Taupetone: 11545,
  BM_1014_ChocolatePudding: 11546,
  BM_1015_CowboyBoots: 11547,
  BM_1016_IonicColumn: 11548,
  BM_1017_DustyRoad: 11549,
  BM_1018_ShabbyChic: 11550,
  BM_1019_DellwoodSand: 11551,
  BM_102_Casabella: 11552,
  BM_1020_Woodacres: 11553,
  BM_1021_LongValleyBirch: 11554,
  BM_1022_MapleShadows: 11555,
  BM_1023_CocoaButter: 11556,
  BM_1024_TucsonWinds: 11557,
  BM_1025_ChocolateMousse: 11558,
  BM_1026_BrokenArrow: 11559,
  BM_1027_Firewood: 11560,
  BM_1028_SpanishBrown: 11561,
  BM_1029_CoconutGrove: 11562,
  BM_103_SweetNSour: 11563,
  BM_1030_BrandyCream: 11564,
  BM_1031_CarlisleCream: 11565,
  BM_1032_BarHarborBeige: 11566,
  BM_1033_HillsboroughBeige: 11567,
  BM_1034_Clay: 11568,
  BM_1035_CambridgeRiverbed: 11569,
  BM_1036_DeerTrail: 11570,
  BM_1037_Muslin: 11571,
  BM_1038_Everlasting: 11572,
  BM_1039_StoneHouse: 11573,
  BM_104_SiennaClay: 11574,
  BM_1040_SpiceGold: 11575,
  BM_1041_Scarecrow: 11576,
  BM_1042_CaramelApple: 11577,
  BM_1043_BlueRidgeMountains: 11578,
  BM_1044_LighthouseLanding: 11579,
  BM_1045_LadyFinger: 11580,
  BM_1046_SandyBrown: 11581,
  BM_1047_DeerPath: 11582,
  BM_1048_DeepOchre: 11583,
  BM_1049_ToastedMarshmallow: 11584,
  BM_105_TerraMauve: 11585,
  BM_1050_WeatheredOak: 11586,
  BM_1051_Lambskin: 11587,
  BM_1052_SeaUrchin: 11588,
  BM_1053_SierraHills: 11589,
  BM_1054_SherwoodTan: 11590,
  BM_1055_AlgonquinTrail: 11591,
  BM_1056_EdgewoodRocks: 11592,
  BM_1057_MapleValley: 11593,
  BM_1058_Mohair: 11594,
  BM_1059_Moccasin: 11595,
  BM_106_MelonIce: 11596,
  BM_1060_BlanchedAlmond: 11597,
  BM_1061_BrunswickBeige: 11598,
  BM_1062_BakedCumin: 11599,
  BM_1063_Gingersnaps: 11600,
  BM_1064_GettysburghGold: 11601,
  BM_1065_WoodAsh: 11602,
  BM_1066_BarelyBeige: 11603,
  BM_1067_BlondWood: 11604,
  BM_1068_SquireHillBuff: 11605,
  BM_1069_TwilightGold: 11606,
  BM_107_WellesleyBuff: 11607,
  BM_1070_BarleyHarvest: 11608,
  BM_1071_FairmontGold: 11609,
  BM_1072_SandDunes: 11610,
  BM_1073_Malton: 11611,
  BM_1074_Alpaca: 11612,
  BM_1075_FairwayOaks: 11613,
  BM_1076_CapilanoBridge: 11614,
  BM_1077_GreatPlainsGold: 11615,
  BM_1078_HillcrestTan: 11616,
  BM_1079_BayshoreBeige: 11617,
  BM_108_DesertView: 11618,
  BM_1080_WhiteOaks: 11619,
  BM_1081_KingArthursCourt: 11620,
  BM_1082_CreamSoda: 11621,
  BM_1083_BeachHouseBeige: 11622,
  BM_1084_LakeShoreTrail: 11623,
  BM_1085_VeroBeachTan: 11624,
  BM_1086_FrenchManicure: 11625,
  BM_1087_CreamySatin: 11626,
  BM_1088_HomeSweetHome: 11627,
  BM_1089_ChilledChardonnay: 11628,
  BM_109_Canyonlands: 11629,
  BM_1090_ButternutSquash: 11630,
  BM_1091_WarmAppleCrisp: 11631,
  BM_1092_GlazedPear: 11632,
  BM_1093_FrenchWhite: 11633,
  BM_1094_BarbadosSand: 11634,
  BM_1095_OakwoodManor: 11635,
  BM_1096_BridgewaterTan: 11636,
  BM_1097_SimplePleasures: 11637,
  BM_1098_ToastedAlmond: 11638,
  BM_1099_ByzantineGold: 11639,
  BM_11_ParadisePeach: 11640,
  BM_110_Starfish: 11641,
  BM_1100_Sundial: 11642,
  BM_1101_FennelSeed: 11643,
  BM_1102_Boardwalk: 11644,
  BM_1103_CamelBack: 11645,
  BM_1104_DesertBeach: 11646,
  BM_1105_MapleSyrup: 11647,
  BM_1106_GladstoneTan: 11648,
  BM_1107_HiltonHeadCream: 11649,
  BM_1108_Chamois: 11650,
  BM_1109_MonarchGold: 11651,
  BM_111_RioRanchoClay: 11652,
  BM_1110_TawnyBisque: 11653,
  BM_1111_GingerbreadMan: 11654,
  BM_1112_SandyValley: 11655,
  BM_1113_GrahamCracker: 11656,
  BM_1114_Heartsmere: 11657,
  BM_1115_MohaveDesert: 11658,
  BM_1116_SepiaTan: 11659,
  BM_1117_Guesthouse: 11660,
  BM_1118_ClassicCaramel: 11661,
  BM_1119_FortSumnerTan: 11662,
  BM_112_PeachBrandy: 11663,
  BM_1120_Honeycomb: 11664,
  BM_1121_HavanaTan: 11665,
  BM_1122_CocoaSand: 11666,
  BM_1123_PalmDesertTan: 11667,
  BM_1124_SaddleTan: 11668,
  BM_1125_Acorn: 11669,
  BM_1126_BakedPretzel: 11670,
  BM_1127_SedonaBrown: 1952,
  BM_1128_AdobeBeige: 11671,
  BM_1129_HiddenOaks: 11672,
  BM_113_PumpkinSeeds: 11673,
  BM_1130_CafeRoyal: 11674,
  BM_1131_AutumnLeaf: 11675,
  BM_1132_OldCanal: 11676,
  BM_1133_Maplewood: 11677,
  BM_1134_HiddenValley: 11678,
  BM_1135_OnyxWhite: 11679,
  BM_1136_PointBeach: 11680,
  BM_1137_Sycamore: 11681,
  BM_1138_ToffeeCream: 11682,
  BM_1139_HarborHighlandsTan: 11683,
  BM_114_BeachcrestSand: 11684,
  BM_1140_RunyonCanyonTan: 11685,
  BM_1141_GlenwoodBrown: 11686,
  BM_1142_PaintedSands: 11687,
  BM_1143_PowderPuff: 11688,
  BM_1144_TucsonTan: 11689,
  BM_1145_CreamyCustard: 11690,
  BM_1146_HarvestBronze: 11691,
  BM_1147_ButterscotchSundae: 11692,
  BM_1148_CognacSnifter: 11693,
  BM_1149_GentleRepose: 11694,
  BM_115_PeachComplexion: 11695,
  BM_1150_InnerPeach: 11696,
  BM_1151_Shorewood: 11697,
  BM_1152_NaturesSymphony: 11698,
  BM_1153_DearbornTan: 11699,
  BM_1154_MountainHideaway: 11700,
  BM_1155_CappuccinoMuffin: 11701,
  BM_1156_PuppyPaws: 11702,
  BM_1157_DustyTrail: 11703,
  BM_1158_BaskingRidgeBeige: 11704,
  BM_1159_DeerField: 11705,
  BM_116_CrestwoodTan: 11706,
  BM_1160_ChadwickBrown: 11707,
  BM_1161_Birchwood: 11708,
  BM_1162_WoodedVista: 11709,
  BM_1163_TissuePink: 11710,
  BM_1164_CoastalCottage: 11711,
  BM_1165_MilkShake: 11712,
  BM_1166_GroundhogDay: 11713,
  BM_1167_FoxHedgeTan: 11714,
  BM_1168_WildernessCabin: 11715,
  BM_1169_AntiqueCopper: 11716,
  BM_117_PersianMelon: 11717,
  BM_1170_BeautifulInMyEyes: 11718,
  BM_1171_Bashful: 11719,
  BM_1172_PinkBeach: 11720,
  BM_1173_SouthernCharm: 11721,
  BM_1174_Vintage: 11722,
  BM_1175_LakeHouse: 11723,
  BM_1176_MountainRetreat: 11724,
  BM_1177_RoseAccent: 11725,
  BM_1178_PalePetal: 11726,
  BM_1179_SoulMate: 11727,
  BM_118_GrandCanyon: 11728,
  BM_1180_Rosedale: 11729,
  BM_1181_FoxyBrown: 11730,
  BM_1182_DrenchedSienna: 11731,
  BM_1183_Brindle: 11732,
  BM_1184_PensacolaPink: 11733,
  BM_1185_Sugarcane: 11734,
  BM_1186_Rosetone: 11735,
  BM_1187_CiaoBella: 11736,
  BM_1188_PalmettoPink: 11737,
  BM_1189_SantaRosa: 11738,
  BM_119_CornucopiaTan: 11739,
  BM_1190_CaliforniaRedwood: 11740,
  BM_1191_LoveHappiness: 11741,
  BM_1192_SweetRomance: 11742,
  BM_1193_PalazzoPink: 11743,
  BM_1194_MexicanTile: 11744,
  BM_1195_Patina: 11745,
  BM_1196_BurntSienna: 11746,
  BM_1197_PumiceStone: 11747,
  BM_1198_AntiqueCoral: 11748,
  BM_1199_PeachMousse: 11749,
  BM_12_CoralReef: 11750,
  BM_120_DelicatePeach: 11751,
  BM_1200_MesaPeach: 11752,
  BM_1201_SpicedAppleCider: 11753,
  BM_1202_BakedTerraCotta: 11754,
  BM_1203_WarmSienna: 11755,
  BM_1204_OnondagaClay: 11756,
  BM_1205_ApricotBeige: 11757,
  BM_1206_OuterBanks: 11758,
  BM_1207_SanCarlosTan: 11759,
  BM_1208_Tuscany: 11760,
  BM_1209_ToastedPecan: 11761,
  BM_121_SweetMelon: 11762,
  BM_1210_TenGallonHat: 11763,
  BM_1211_ArizonaCanyon: 11764,
  BM_1212_SunsetHill: 11765,
  BM_1213_LoveStory: 11766,
  BM_1214_CarelessWhispers: 11767,
  BM_1215_CinnamonNSpice: 11768,
  BM_1216_BakersDozen: 1953,
  BM_1217_SuntanBronze: 11769,
  BM_1218_CopperKettle: 11770,
  BM_1219_ClementineRose: 11771,
  BM_122_OrangeSherbet: 11772,
  BM_1220_GrazingFawn: 11773,
  BM_1221_PottersClay: 11774,
  BM_1222_LenapeTrail: 11775,
  BM_1223_Brentwood: 11776,
  BM_1224_CoyoteTrail: 11777,
  BM_1225_AbbeyBrown: 11778,
  BM_1226_Crossroads: 11779,
  BM_1227_Nutmeg: 11780,
  BM_1228_RomanShade: 11781,
  BM_1229_FoxRun: 11782,
  BM_123_CitrusBlossom: 11783,
  BM_1230_OregonTrail: 11784,
  BM_1231_Wynwood: 11785,
  BM_1232_FreshBrew: 10921,
  BM_1233_CedarRidge: 11786,
  BM_1234_BaywoodBrown: 11787,
  BM_1235_FoxHollowBrown: 11788,
  BM_1236_SorrelBrown: 11789,
  BM_1237_Raisin: 11790,
  BM_1238_FalconBrown: 11791,
  BM_1239_RuralEarth: 11792,
  BM_124_OrangeAppeal: 11793,
  BM_1240_WildAster: 11794,
  BM_1241_MorristownCream: 11795,
  BM_1242_SonomaClay: 11796,
  BM_1243_Monet: 11797,
  BM_1244_Barberry: 11798,
  BM_1245_Sequoia: 11799,
  BM_1246_CupOJava: 11800,
  BM_1247_BridalRose: 11801,
  BM_1248_Organdy: 11802,
  BM_1249_HomespunCharm: 11803,
  BM_125_AntelopeCanyon: 11804,
  BM_1250_MagicPotion: 11805,
  BM_1251_MulberryWine: 11806,
  BM_1252_MinkViolet: 11807,
  BM_1253_FrescoUrbain: 11808,
  BM_1254_RoseLace: 11809,
  BM_1255_PinkAttraction: 11810,
  BM_1256_Amaryllis: 11811,
  BM_1257_BourbonStreet: 11812,
  BM_1258_FadingTwilight: 11813,
  BM_1259_Beaujolais: 11814,
  BM_126_PumpkinSpice: 11815,
  BM_1260_ElCajonClay: 11816,
  BM_1261_PaisleyPink: 11817,
  BM_1262_ParisRomance: 11818,
  BM_1263_Victoriana: 11819,
  BM_1264_MauveMist: 11820,
  BM_1265_DeepMauve: 11821,
  BM_1266_LoveAffair: 11822,
  BM_1267_RubyDusk: 11823,
  BM_1268_CottonCandy: 11824,
  BM_1269_UnspokenLove: 11825,
  BM_127_PeachPie: 11826,
  BM_1270_Tara: 11827,
  BM_1271_Hummingbird: 11828,
  BM_1272_Princess: 11829,
  BM_1273_PromDress: 11830,
  BM_1274_WarmEarth: 11831,
  BM_1275_RoseRococo: 11832,
  BM_1276_PetuniaPink: 11833,
  BM_1277_Engagement: 11834,
  BM_1278_PalermoRose: 11835,
  BM_1279_ToastedMauve: 11836,
  BM_128_FloridaSeashells: 11837,
  BM_1280_BurgundyRose: 11838,
  BM_1281_TawnyPort: 11839,
  BM_1282_TippyToes: 11840,
  BM_1283_HeartsDelight: 11841,
  BM_1284_SecretGarden: 11842,
  BM_1285_PinkBuff: 11843,
  BM_1286_CincoDeMayo: 11844,
  BM_1287_SantaFePottery: 11845,
  BM_1288_SegoviaRed: 11846,
  BM_1289_MarryMe: 11847,
  BM_129_TangerineMist: 11848,
  BM_1290_FantasyPink: 11849,
  BM_1291_BrightonRockCandy: 11850,
  BM_1292_VenetianRose: 11851,
  BM_1293_Badlands: 11852,
  BM_1294_PottersWheel: 11853,
  BM_1295_HearthRed: 11854,
  BM_1296_SailorsDelight: 1954,
  BM_1297_MinstrelHeart: 11855,
  BM_1298_CoralBronze: 11856,
  BM_1299_Crimson: 11857,
  BM_13_FanCoral: 11858,
  BM_130_PeachJam: 11859,
  BM_1300_TucsonRed: 11860,
  BM_1301_SpanishRed: 11861,
  BM_1302_SweetRosyBrown: 1955,
  BM_1303_SmashingPink: 11862,
  BM_1304_AllABlaze: 11863,
  BM_1305_BirdOfParadise: 11864,
  BM_1306_HabaneroPepper: 11865,
  BM_1307_Geranium: 11866,
  BM_1308_RedParrot: 11867,
  BM_1309_MoroccanRed: 11868,
  BM_131_SevilleOranges: 11869,
  BM_1310_Sweet16: 11870,
  BM_1311_Confetti: 11871,
  BM_1312_Potpourri: 11872,
  BM_1313_MilanoRed: 11873,
  BM_1314_RyanRed: 11874,
  BM_1315_Poppy: 11875,
  BM_1316_UmbriaRed: 11876,
  BM_1317_YoursTruly: 11877,
  BM_1318_BedOfRoses: 11878,
  BM_1319_Heartbeat: 11879,
  BM_132_TangerineZing: 11880,
  BM_1320_FloridaPink: 11881,
  BM_1321_HollyBerry: 11882,
  BM_1322_LadybugRed: 11883,
  BM_1323_CurrantRed: 11884,
  BM_1324_MayFlowers: 11885,
  BM_1325_PurePink: 11886,
  BM_1326_BubbleBath: 11887,
  BM_1327_RadiantRose: 11888,
  BM_1328_DecoRose: 11889,
  BM_1329_DropDeadGorgeous: 11890,
  BM_133_NewDawn: 11891,
  BM_1330_MyValentine: 11892,
  BM_1331_BalletSlippers: 11893,
  BM_1332_CatsMeow: 11894,
  BM_1333_Romance: 11895,
  BM_1334_PrettyInPink: 11896,
  BM_1335_CactusFlower: 11897,
  BM_1336_SantasSuit: 11898,
  BM_1337_MediterraneanSpice: 11899,
  BM_1338_PowderBlush: 11900,
  BM_1339_MistedRose: 11901,
  BM_134_GeorgiaOnMyMind: 11902,
  BM_1340_PinkRibbon: 11903,
  BM_1341_SecretRendezvous: 11904,
  BM_1342_MardiGras: 11905,
  BM_1343_Fuchsine: 11906,
  BM_1344_NightFlower: 11907,
  BM_1345_BermudaBreeze: 11908,
  BM_1346_IslandSunset: 11909,
  BM_1347_PinkLadies: 11910,
  BM_1348_RazzleDazzle: 11911,
  BM_1349_PinkCorsage: 11912,
  BM_135_PeachCider: 11913,
  BM_1350_AnilineRed: 11914,
  BM_1351_Chinaberry: 11915,
  BM_1352_PinkDynasty: 11916,
  BM_1353_RoseGarden: 11917,
  BM_1354_WildHeart: 11918,
  BM_1355_TropicalRose: 11919,
  BM_1356_FashionRose: 11920,
  BM_1357_BottleOfBordeaux: 11921,
  BM_1358_DarkWalnut: 11922,
  BM_1359_Peppermint: 11923,
  BM_136_ApricotChiffon: 11924,
  BM_1360_MistyRose: 11925,
  BM_1361_CountrysidePink: 11926,
  BM_1362_CranberryIce: 11927,
  BM_1363_MelrosePink: 11928,
  BM_1364_VintageClaret: 11929,
  BM_1365_BordeauxRed: 11930,
  BM_1366_Rosemist: 11931,
  BM_1367_PrimrosePetals: 11932,
  BM_1368_BabysMittens: 11933,
  BM_1369_Luscious: 11934,
  BM_137_PeachPudding: 11935,
  BM_1370_VictorianPurple: 11936,
  BM_1371_PlumPerfect: 11937,
  BM_1372_UltraViolet: 11938,
  BM_1373_SilkySmooth: 11939,
  BM_1374_OrleansViolet: 11940,
  BM_1375_HiddenSanctuary: 11941,
  BM_1376_Angelina: 11942,
  BM_1377_CaribbeanSunset: 11943,
  BM_1378_LazyAfternoon: 11944,
  BM_1379_Eggplant: 11945,
  BM_138_VividBeauty: 11946,
  BM_1380_PeaceAndHappiness: 11947,
  BM_1381_EasterRibbon: 11948,
  BM_1382_VioletPetal: 11949,
  BM_1383_IrisBliss: 11950,
  BM_1384_CarolinaPlum: 11951,
  BM_1385_CupidsDart: 11952,
  BM_1386_Taro: 11953,
  BM_1387_RockHarborViolet: 11954,
  BM_1388_SpringLilac: 11955,
  BM_1389_WishingWell: 11956,
  BM_139_PartyPeach: 11957,
  BM_1390_Hydrangea: 11958,
  BM_1391_NaplesSunset: 11959,
  BM_1392_FireAndIce: 11960,
  BM_1393_Grappa: 11961,
  BM_1394_Sugarplum: 11962,
  BM_1395_GrapeIce: 11963,
  BM_1396_HeatherPlum: 11964,
  BM_1397_MightyAphrodite: 11965,
  BM_1398_CharmedViolet: 11966,
  BM_1399_Seduction: 11967,
  BM_14_SoftGlow: 11968,
  BM_140_FruitPunch: 11969,
  BM_1400_YourMajesty: 11970,
  BM_1401_Nosegay: 11971,
  BM_1402_SpringIris: 11972,
  BM_1403_FrenchLilac: 11973,
  BM_1404_Crocus: 11974,
  BM_1405_Snugglepuss: 11975,
  BM_1406_PurpleHeart: 11976,
  BM_1407_MauveBauhaus: 11977,
  BM_1408_WhiteViolet: 11978,
  BM_1409_VioletDusk: 11979,
  BM_141_CitrusMist: 11980,
  BM_1410_IcedLavender: 11981,
  BM_1411_NorthCascades: 11982,
  BM_1412_CentralMauve: 11983,
  BM_1413_PurpleHaze: 11984,
  BM_1414_SuperNova: 11985,
  BM_1415_LavenderSecret: 11986,
  BM_1416_WhisperingWind: 11987,
  BM_1417_EnglishHyacinth: 11988,
  BM_1418_OrientalIris: 11989,
  BM_1419_PersianViolet: 11990,
  BM_142_PineappleSmoothy: 11991,
  BM_1420_SoftenedViolet: 11992,
  BM_1421_BistroBlue: 11993,
  BM_1422_VioletSparkle: 11994,
  BM_1423_AngelsWings: 11995,
  BM_1424_BlueViola: 11996,
  BM_1425_Dreamy: 11997,
  BM_1426_QueensWreath: 11998,
  BM_1427_FrenchViolet: 11999,
  BM_1428_WoodViolet: 12000,
  BM_1429_CelestiaBlue: 12001,
  BM_143_GoldenLight: 12002,
  BM_1430_SpringFlowers: 12003,
  BM_1431_FeatherSoft: 12004,
  BM_1432_Freesia: 12005,
  BM_1433_BluePearl: 12006,
  BM_1434_InTheTwilight: 12007,
  BM_1435_BlueGaspe: 12008,
  BM_1436_Whirlpool: 12009,
  BM_1437_VioletMist: 12010,
  BM_1438_LavenderBlue: 12011,
  BM_1439_YukonSky: 12012,
  BM_144_HoneyBurst: 12013,
  BM_1440_Irises: 12014,
  BM_1441_AmethystShadow: 12015,
  BM_1442_DeepIndigo: 12016,
  BM_1443_RaindropsOnRoses: 12017,
  BM_1444_NewAge: 12018,
  BM_1445_PianoConcerto: 12019,
  BM_1446_DuskToDawn: 12020,
  BM_1447_AmethystSky: 12021,
  BM_1448_FrozenInTime: 12022,
  BM_1449_PinchOfSpice: 12023,
  BM_145_Honeybell: 12024,
  BM_1450_HampshireRocks: 12025,
  BM_1451_VioletPearl: 12026,
  BM_1452_AfterTheRain: 12027,
  BM_1453_PebbleCreek: 12028,
  BM_1454_SleepyHollow: 12029,
  BM_1455_VintageCharm: 12030,
  BM_1456_MountainRidge: 12031,
  BM_1457_WhiteWingedDove: 12032,
  BM_1458_SilverBells: 12033,
  BM_1459_MetroGray: 12034,
  BM_146_GoldenArchway: 12035,
  BM_1460_SilverDollar: 12036,
  BM_1461_SterlingSilver: 12037,
  BM_1462_GrayMountain: 12038,
  BM_1463_TopekaTaupe: 12039,
  BM_1464_LightPewter: 12040,
  BM_1465_Nimbus: 12041,
  BM_1466_SmokeEmbers: 10977,
  BM_1467_BalticGray: 12042,
  BM_1468_WillowCreek: 12043,
  BM_1469_EagleRock: 12044,
  BM_147_FruityCocktail: 12045,
  BM_1470_BearCreek: 12046,
  BM_1471_Shoreline: 1956,
  BM_1472_SilverChain: 12047,
  BM_1473_GrayHuskie: 12048,
  BM_1474_CapeMayCobblestone: 12049,
  BM_1475_Graystone: 12050,
  BM_1476_SquirrelTail: 12051,
  BM_1477_DeepCreek: 12052,
  BM_1478_Horizon: 12053,
  BM_1479_AlaskanHusky: 12054,
  BM_148_PorterRanchCream: 12055,
  BM_1480_SleighBells: 12056,
  BM_1481_HalfMoonCrest: 12057,
  BM_1482_SabreGray: 12058,
  BM_1483_CosCobStonewall: 12059,
  BM_1484_AshwoodMoss: 12060,
  BM_1485_BrushedAluminum: 12061,
  BM_1486_Winterwood: 12062,
  BM_1487_HerbalEscape: 12063,
  BM_1488_SageMountain: 12064,
  BM_1489_DevonshireGreen: 12065,
  BM_149_SunBlossom: 12066,
  BM_1490_CountryLife: 12067,
  BM_1491_AegeanOlive: 12068,
  BM_1492_SebringWhite: 12069,
  BM_1493_MorningDew: 12070,
  BM_1494_ValeMist: 12071,
  BM_1495_OctoberMist: 1957,
  BM_1496_RaintreeGreen: 12072,
  BM_1497_RollingHills: 12073,
  BM_1498_ForestFloor: 12074,
  BM_1499_WhiteRiver: 12075,
  BM_15_SoftShell: 12076,
  BM_150_PeachYogurt: 12077,
  BM_1500_SweetSpring: 12078,
  BM_1501_ParisRain: 12079,
  BM_1502_CheyenneGreen: 12080,
  BM_1503_TexasSage: 12081,
  BM_1504_PassionVine: 12082,
  BM_1505_TrailingVines: 12083,
  BM_1506_PolarFrost: 12084,
  BM_1507_AprilShowers: 12085,
  BM_1508_SpringThaw: 12086,
  BM_1509_SpanishOlive: 12087,
  BM_151_OrangeFroth: 12088,
  BM_1510_DriedBasil: 12089,
  BM_1511_BedOfFerns: 12090,
  BM_1512_PiningForYou: 12091,
  BM_1513_SnowOnTheMountain: 12092,
  BM_1514_FrenchCanvas: 12093,
  BM_1515_NaturalElements: 12094,
  BM_1516_MoonShadow: 12095,
  BM_1517_MosaicTile: 12096,
  BM_1518_AtHomeWithNature: 12097,
  BM_1519_SmokeBush: 12098,
  BM_152_FloridaOrange: 12099,
  BM_1520_HushedHue: 12100,
  BM_1521_NaturesEssentials: 12101,
  BM_1522_InnerBalance: 12102,
  BM_1523_EmbassyGreen: 12103,
  BM_1524_NaturesScenery: 12104,
  BM_1525_ClevelandGreen: 12105,
  BM_1526_EveningGrove: 12106,
  BM_1527_GoingToTheChapel: 12107,
  BM_1528_EarlyMorningMist: 12108,
  BM_1529_Stingray: 12109,
  BM_153_FreshFruit: 12110,
  BM_1530_SenoraGray: 12111,
  BM_1531_VictorianGarden: 12112,
  BM_1532_MajesticSage: 12113,
  BM_1533_Bayleaf: 12114,
  BM_1534_Rodeo: 12115,
  BM_1535_SeattleMist: 1958,
  BM_1536_NorthernCliffs: 12116,
  BM_1537_RiverGorgeGray: 12117,
  BM_1538_WildwoodCrest: 12118,
  BM_1539_RooseveltTaupe: 12119,
  BM_154_MangoPunch: 12120,
  BM_1540_CabinFever: 12121,
  BM_1541_LondonFog: 12122,
  BM_1542_HimalayanTrek: 12123,
  BM_1543_PlymouthRock: 12124,
  BM_1544_WaynesboroTaupe: 12125,
  BM_1545_IronGate: 12126,
  BM_1546_Gargoyle: 12127,
  BM_1547_DragonsBreath: 10911,
  BM_1548_ClassicGray: 12128,
  BM_1549_BalboaMist: 12129,
  BM_155_PointPleasant: 12130,
  BM_1550_CumulusCloud: 12131,
  BM_1551_LaPalomaGray: 12132,
  BM_1552_RiverReflections: 12133,
  BM_1553_EquestrianGray: 12134,
  BM_1554_DashOfPepper: 12135,
  BM_1555_WinterOrchard: 12136,
  BM_1556_VaporTrails: 12137,
  BM_1557_SilverSong: 12138,
  BM_1558_Fieldstone: 12139,
  BM_1559_ArcticShadows: 12140,
  BM_156_SweetNectar: 12141,
  BM_1560_AntiquePewter: 12142,
  BM_1561_CastlePeakGray: 12143,
  BM_1562_HealingAloe: 12144,
  BM_1563_QuietMoments: 12145,
  BM_1564_BeachGlass: 12146,
  BM_1565_MountSaintAnne: 12147,
  BM_1566_Stonybrook: 12148,
  BM_1567_NightTrain: 12149,
  BM_1568_QuarryRock: 12150,
  BM_1569_NightMist: 12151,
  BM_157_Cantaloupe: 12152,
  BM_1570_GrayWisp: 12153,
  BM_1571_ImperialGray: 12154,
  BM_1572_Raindance: 12155,
  BM_1573_CastleWalls: 12156,
  BM_1574_RushingRiver: 12157,
  BM_1575_RainyAfternoon: 12158,
  BM_1576_IceCap: 12159,
  BM_1577_ArcticGray: 12160,
  BM_1578_IcedMarble: 1959,
  BM_1579_Greyhound: 12161,
  BM_158_PineappleOrange: 12162,
  BM_1580_Intrigue: 12163,
  BM_1581_MillstoneGray: 12164,
  BM_1582_DeepRiver: 1960,
  BM_1583_SilverCrest: 12165,
  BM_1584_PaleSmoke: 12166,
  BM_1585_WalesGray: 12167,
  BM_1586_SilverMink: 12168,
  BM_1587_GibraltarCliffs: 12169,
  BM_1588_GrayPinstripe: 12170,
  BM_1589_KittyGray: 12171,
  BM_159_PeachCrisp: 12172,
  BM_1590_PaperWhite: 12173,
  BM_1591_Sterling: 12174,
  BM_1592_BlueSprings: 12175,
  BM_1593_Adagio: 12176,
  BM_1594_ShakerGray: 12177,
  BM_1595_RockyCoast: 12178,
  BM_1596_Nightfall: 12179,
  BM_1597_PebbleBeach: 12180,
  BM_1598_SilverLake: 12181,
  BM_1599_MarinaGray: 12182,
  BM_16_BermudaPink: 12183,
  BM_160_SoftMarigold: 12184,
  BM_1600_GrayCardigan: 12185,
  BM_1601_Hearthstone: 12186,
  BM_1602_Gunmetal: 12187,
  BM_1603_Graphite: 12188,
  BM_1604_SilveryMoon: 12189,
  BM_1605_WinterSolstice: 12190,
  BM_1606_CobblestonePath: 12191,
  BM_1607_EnglewoodCliffs: 12192,
  BM_1608_AshlandSlate: 12193,
  BM_1609_Temptation: 12194,
  BM_161_BrilliantAmber: 12195,
  BM_1610_FrenchBeret: 12196,
  BM_1611_Graytint: 12197,
  BM_1612_PelicanGray: 12198,
  BM_1613_SilentNight: 12199,
  BM_1614_DelrayGray: 12200,
  BM_1615_RockGray: 12201,
  BM_1616_StormySky: 12202,
  BM_1617_CheatingHeart: 12203,
  BM_1618_FirstSnowfall: 12204,
  BM_1619_SilverMist: 12205,
  BM_162_CorinthianWhite: 12206,
  BM_1620_BlueHeather: 12207,
  BM_1621_LittleFalls: 12208,
  BM_1622_MineralAlloy: 12209,
  BM_1623_BritanniaBlue: 12210,
  BM_1624_WestcottNavy: 12211,
  BM_1625_BlueLace: 12212,
  BM_1626_GentleGray: 12213,
  BM_1627_ManorBlue: 12214,
  BM_1628_Comet: 12215,
  BM_1629_BachelorBlue: 12216,
  BM_163_SomersetPeach: 12217,
  BM_1630_OceanFloor: 12218,
  BM_1631_MidnightOil: 12219,
  BM_1632_GlassSlipper: 12220,
  BM_1633_BrittanyBlue: 12221,
  BM_1634_SantoriniBlue: 12222,
  BM_1635_WatersEdge: 12223,
  BM_1636_ProvidenceBlue: 12224,
  BM_1637_BlueSpruce: 12225,
  BM_1638_MidnightBlue: 12226,
  BM_1639_WindySky: 12227,
  BM_164_BirminghamCream: 12228,
  BM_1640_DuskyBlue: 12229,
  BM_1641_BluePorcelain: 12230,
  BM_1642_CapeBlue: 12231,
  BM_1643_FranklinLakes: 12232,
  BM_1644_BlueDusk: 12233,
  BM_1645_ThousandOceans: 12234,
  BM_1646_LookoutPoint: 12235,
  BM_1647_SilveryBlue: 12236,
  BM_1648_SlateBlue: 12237,
  BM_1649_PolarisBlue: 12238,
  BM_165_GlowingApricot: 12239,
  BM_1650_Stillwater: 12240,
  BM_1651_NewProvidenceNavy: 12241,
  BM_1652_NavyMasterpiece: 12242,
  BM_1653_GlacierBlue: 12243,
  BM_1654_AshwoodGray: 12244,
  BM_1655_BlueBayMarina: 12245,
  BM_1656_AspenSkies: 12246,
  BM_1657_NiagaraFalls: 12247,
  BM_1658_LakesideCabin: 12248,
  BM_1659_Spellbound: 12249,
  BM_166_OrangeIce: 12250,
  BM_1660_PolarIce: 12251,
  BM_1661_HeavenOnEarth: 12252,
  BM_1662_MediterraneanSky: 12253,
  BM_1663_NewBornsEyes: 12254,
  BM_1664_SeaReflections: 12255,
  BM_1665_MozartBlue: 12256,
  BM_1666_InTheMidnightHour: 12257,
  BM_1667_BlueHaze: 12258,
  BM_1668_BlueStream: 12259,
  BM_1669_SaratogaSprings: 12260,
  BM_167_OldGold: 12261,
  BM_1670_LabradorBlue: 12262,
  BM_1671_WestCoast: 12263,
  BM_1672_Alfresco: 12264,
  BM_1673_VermontSlate: 12265,
  BM_1674_PolarSky: 12266,
  BM_1675_UnderTheBigTop: 12267,
  BM_1676_NorthernAir: 12268,
  BM_1677_ColonialBlue: 12269,
  BM_1678_BlueNose: 12270,
  BM_1679_BedfordBlue: 12271,
  BM_168_Amber: 12272,
  BM_1680_HudsonBay: 12273,
  BM_169_Aura: 12274,
  BM_17_PhoenixSand: 12275,
  BM_170_TraditionalYellow: 12276,
  BM_171_SweetButter: 12277,
  BM_172_SunnyDays: 12278,
  BM_173_HappilyEverAfter: 12279,
  BM_174_SunflowerFields: 12280,
  BM_175_MayanGold: 12281,
  BM_176_Goldtone: 12282,
  BM_177_MushroomCap: 12283,
  BM_178_GoldenLab: 12284,
  BM_179_Honeywheat: 12285,
  BM_18_MonticelloPeach: 12286,
  BM_180_BeverlyHills: 12287,
  BM_181_PanForGold: 12288,
  BM_182_GlowingUmber: 12289,
  BM_183_MorningLight: 12290,
  BM_184_IvoryLustre: 12291,
  BM_185_PreciousIvory: 12292,
  BM_186_HarvestTime: 12293,
  BM_187_Goldfinch: 12294,
  BM_188_EyeOfTheTiger: 12295,
  BM_189_MorganHillGold: 12296,
  BM_19_SalmonRun: 12297,
  BM_190_PearlyGates: 12298,
  BM_191_MacadamiaNut: 12299,
  BM_192_KeyWestIvory: 12300,
  BM_193_Dijon: 12301,
  BM_194_HathawayGold: 12302,
  BM_195_FrenchHorn: 12303,
  BM_196_Goldenhurst: 12304,
  BM_197_AmericasHeartland: 12305,
  BM_198_Cornsilk: 12306,
  BM_199_Barley: 12307,
  BM_2_SummerVacation: 12308,
  BM_20_Fresno: 12309,
  BM_200_WestminsterGold: 12310,
  BM_200010_Red: 12311,
  BM_200020_TricycleRed: 12312,
  BM_200030_RedTulip: 12313,
  BM_200040_StrawberryShortcake: 12314,
  BM_200050_BlushTone: 12315,
  BM_200060_LightChiffonPink: 12316,
  BM_200070_VoilePink: 12317,
  BM_200110_RubyRed: 12318,
  BM_200120_Bonfire: 12319,
  BM_200130_SpringTulips: 12320,
  BM_200140_PinkPopsicle: 12321,
  BM_200150_FullBloom: 12322,
  BM_200160_CountryPink: 12323,
  BM_200170_MarshmallowBunny: 12324,
  BM_200210_Vermilion: 12325,
  BM_200220_BullsEyeRed: 12326,
  BM_200230_RoseQuartz: 12327,
  BM_200240_FlamingosDream: 12328,
  BM_200250_TickledPink: 12329,
  BM_200260_Sweet16Pink: 12330,
  BM_200270_SuttonPink: 12331,
  BM_200310_MillionDollarRed: 12332,
  BM_200320_StrawberryRed: 12333,
  BM_200330_BerryWine: 12334,
  BM_200340_TruePink: 12335,
  BM_200350_CoralPink: 12336,
  BM_200360_ExoticPink: 12337,
  BM_200370_PleasingPink: 12338,
  BM_200410_DeepRose: 12339,
  BM_200420_ChiliPepper: 12340,
  BM_200430_RaspberryPudding: 12341,
  BM_200440_FlowerCrown: 12342,
  BM_200450_BabyGirl: 12343,
  BM_200460_PinkParfait: 12344,
  BM_200470_RomanticPink: 12345,
  BM_200510_RedRock: 1961,
  BM_200520_HotAppleSpice: 12346,
  BM_200530_BricktoneRed: 12347,
  BM_200540_GenuinePink: 12348,
  BM_200550_PinkEraser: 12349,
  BM_200560_PinkPearl: 12350,
  BM_200570_WispyPink: 12351,
  BM_200610_MerlotRed: 12352,
  BM_200620_Sangria: 12353,
  BM_200630_RosyApple: 12354,
  BM_200640_GlamourPink: 12355,
  BM_200650_PinkPunch: 12356,
  BM_200660_AuthenticPink: 12357,
  BM_200670_PinkFairy: 12358,
  BM_200710_SmolderingRed: 12359,
  BM_200720_ShyCherry: 12360,
  BM_200730_Rhubarb: 12361,
  BM_200740_CoralEssence: 12362,
  BM_200750_SupplePink: 12363,
  BM_200760_PastelPink: 12364,
  BM_200770_AngelPink: 12365,
  BM_200810_RavishingRed: 12366,
  BM_200820_ClaretRose: 12367,
  BM_200830_RaspberryBlush: 12368,
  BM_200840_HydrangeaFlowers: 12369,
  BM_200850_DelicateRose: 12370,
  BM_200860_LittlePiggy: 12371,
  BM_200870_TouchOfPink: 12372,
  BM_200910_Redstone: 12373,
  BM_200920_Salsa: 12374,
  BM_200930_DarkSalmon: 12375,
  BM_200940_PinkPeach: 12376,
  BM_200950_FashionPink: 12377,
  BM_200960_PinkSeashell: 12378,
  BM_200970_PowderPink: 12379,
  BM_201_GoldLeaf: 12380,
  BM_201010_TomatoRed: 12381,
  BM_201020_WarmComfort: 12382,
  BM_201030_CraftRoom: 12383,
  BM_201040_CoralGables: 12384,
  BM_201050_DawnPink: 12385,
  BM_201060_RosePetal: 12386,
  BM_201070_FrostyPink: 12387,
  BM_201110_Orange: 12388,
  BM_201120_BlazingOrange: 12389,
  BM_201130_HotSpice: 12390,
  BM_201140_OldWorld: 12391,
  BM_201150_MixedFruit: 12392,
  BM_201160_SpringyPeach: 12393,
  BM_201170_LightQuartz: 12394,
  BM_201210_TawnyDayLily: 12395,
  BM_201220_Flame: 12396,
  BM_201230_TangerineDream: 12397,
  BM_201240_SummerSunPink: 12398,
  BM_201250_PerkyPeach: 12399,
  BM_201260_CreamyPeach: 12400,
  BM_201270_SoftPink: 12401,
  BM_201310_OutrageousOrange: 12402,
  BM_201320_OrangeNectar: 12403,
  BM_201330_JeweledPeach: 12404,
  BM_201340_DuskPink: 12405,
  BM_201350_SalmonPeach: 12406,
  BM_201360_PinkHarmony: 12407,
  BM_201370_BridalPink: 12408,
  BM_201410_FestiveOrange: 12409,
  BM_201420_RumbaOrange: 12410,
  BM_201430_TangyOrange: 12411,
  BM_201440_PeachyKeen: 12412,
  BM_201450_SpringtimePeach: 12413,
  BM_201460_WhisperingPeach: 12414,
  BM_201470_Ecru: 12415,
  BM_201510_ElectricOrange: 12416,
  BM_201520_OrangeBurst: 12417,
  BM_201530_CalypsoOrange: 12418,
  BM_201540_PeachSorbet: 12419,
  BM_201550_FunkyFruit: 12420,
  BM_201560_GerberaDaisy: 12421,
  BM_201570_ApricotIce: 12422,
  BM_201610_StartlingOrange: 12423,
  BM_201620_CitrusOrange: 12424,
  BM_201630_CarrotStick: 12425,
  BM_201640_Marmalade: 12426,
  BM_201650_MelonPopsicle: 12427,
  BM_201660_CreamyBeige: 12428,
  BM_201670_CancunSand: 12429,
  BM_201710_OrangeJuice: 12430,
  BM_201720_SharpCheddar: 12431,
  BM_201730_Tangelo: 12432,
  BM_201740_SweetOrange: 12433,
  BM_201750_YellowHaze: 12434,
  BM_201760_PaleDaffodil: 12435,
  BM_201770_WhiteVanilla: 12436,
  BM_201810_OrangeSky: 12437,
  BM_201820_MandarinOrange: 12438,
  BM_201830_CitrusBlast: 12439,
  BM_201840_NachoCheese: 12440,
  BM_201850_MorningSunshine: 12441,
  BM_201860_Lighthouse: 12442,
  BM_201870_Milkyway: 12443,
  BM_201910_MardiGrasGold: 12444,
  BM_201920_GoldenNugget: 12445,
  BM_201930_Sunflower: 12446,
  BM_201940_AmericanCheese: 12447,
  BM_201950_LemonDrops: 12448,
  BM_201960_LemonSorbet: 12449,
  BM_201970_LightningWhite: 12450,
  BM_202_Yellowstone: 12451,
  BM_202010_BumbleBeeYellow: 12452,
  BM_202020_LemonShine: 12453,
  BM_202030_SparklingSun: 12454,
  BM_202040_YellowRaincoat: 12455,
  BM_202050_MellowYellow: 12456,
  BM_202060_SicilianLemon: 12457,
  BM_202070_YellowFreeze: 12458,
  BM_202110_YellowFlash: 12459,
  BM_202120_Lemon: 12460,
  BM_202130_Sunshine: 12461,
  BM_202140_YellowHighlighter: 12462,
  BM_202150_YellowLotus: 12463,
  BM_202160_ProvenceCreme: 12464,
  BM_202170_PaleStraw: 12465,
  BM_202210_Yellow: 12466,
  BM_202220_SunKissedYellow: 12467,
  BM_202230_BrightYellow: 12468,
  BM_202240_BananaYellow: 12469,
  BM_202250_Sundance: 12470,
  BM_202260_LightYellow: 12471,
  BM_202270_CremeBrulee: 12472,
  BM_202310_Yolk: 12473,
  BM_202320_BabyChick: 12474,
  BM_202330_Sunporch: 12475,
  BM_202340_Sunburst: 12476,
  BM_202350_LemonMeringue: 12477,
  BM_202360_Butter: 12478,
  BM_202370_CremeFraiche: 12479,
  BM_202410_Chartreuse: 12480,
  BM_202420_EveGreen: 12481,
  BM_202430_Citron: 12482,
  BM_202440_YellowFinch: 12483,
  BM_202450_JasperYellow: 12484,
  BM_202460_Lemonade: 12485,
  BM_202470_LemonIce: 12486,
  BM_202510_BrightLime: 12487,
  BM_202520_YewGreen: 12488,
  BM_202530_NewLime: 12489,
  BM_202540_Limelight: 12490,
  BM_202550_LemonFreeze: 12491,
  BM_202560_LemonGlow: 12492,
  BM_202570_BarelyYellow: 12493,
  BM_202610_LimeGreen: 12494,
  BM_202620_Margarita: 12495,
  BM_202630_SnowConeGreen: 12496,
  BM_202640_AppleGreen: 12497,
  BM_202650_FreshCutGrass: 12498,
  BM_202660_SummerLime: 12499,
  BM_202670_Eggshell: 12500,
  BM_202710_DarkLime: 12501,
  BM_202720_SpringMoss: 12502,
  BM_202730_EccentricLime: 12503,
  BM_202740_GrapeGreen: 12504,
  BM_202750_Hibiscus: 12505,
  BM_202760_LightDaffodil: 12506,
  BM_202770_AspenWhite: 12507,
  BM_202810_IguanaGreen: 12508,
  BM_202820_DouglasFir: 12509,
  BM_202830_TequilaLime: 12510,
  BM_202840_PearGreen: 12511,
  BM_202850_WalesGreen: 12512,
  BM_202860_CeladonGreen: 12513,
  BM_202870_Seahorse: 12514,
  BM_202910_BasilGreen: 12515,
  BM_202920_BabyFern: 12516,
  BM_202930_RosemaryGreen: 12517,
  BM_202940_StemGreen: 12518,
  BM_202950_PotpourriGreen: 12519,
  BM_202960_PaleVista: 12520,
  BM_202970_FrostyLime: 12521,
  BM_203_FieldsOfGold: 12522,
  BM_203010_LizardGreen: 12523,
  BM_203020_TropicalSeaweedGreen: 12524,
  BM_203030_LuckyCharmGreen: 12525,
  BM_203040_SpringLeaf: 12526,
  BM_203050_ShimmeringLime: 12527,
  BM_203060_CeleryIce: 12528,
  BM_203070_IcedMint: 12529,
  BM_203110_NeonLime: 12530,
  BM_203120_ParadiseGreen: 12531,
  BM_203130_SweetPea: 12532,
  BM_203140_SpringMeadowGreen: 12533,
  BM_203150_KeyLime: 12534,
  BM_203160_NeonCelery: 12535,
  BM_203170_LimeFroth: 12536,
  BM_203210_NeonGreen: 12537,
  BM_203220_TrafficLightGreen: 12538,
  BM_203230_FreshLime: 12539,
  BM_203240_CitrusGreen: 12540,
  BM_203250_EarlySpringGreen: 12541,
  BM_203260_CitraLime: 12542,
  BM_203270_LimeSorbet: 12543,
  BM_203310_YellowGreen: 12544,
  BM_203320_PeppermintLeaf: 12545,
  BM_203330_FreshScentGreen: 12546,
  BM_203340_LimeTart: 12547,
  BM_203350_BudGreen: 12548,
  BM_203360_MantisGreen: 12549,
  BM_203370_SweetHoneydewMelon: 12550,
  BM_203410_CloverGreen: 12551,
  BM_203420_VineGreen: 12552,
  BM_203430_GrassyFields: 12553,
  BM_203440_CedarGreen: 12554,
  BM_203450_AcadiaGreen: 12555,
  BM_203460_LightPistachio: 12556,
  BM_203470_DaiquiriIce: 12557,
  BM_203510_Seaweed: 12558,
  BM_203520_CactusGreen: 12559,
  BM_203530_NileGreen: 12560,
  BM_203540_StokesForestGreen: 12561,
  BM_203550_SpruceGreen: 12562,
  BM_203560_LeisureGreen: 12563,
  BM_203570_ItalianIceGreen: 12564,
  BM_203610_CatsEye: 12565,
  BM_203620_IrishMoss: 12566,
  BM_203630_GreenWithEnvy: 12567,
  BM_203640_MeadowlandsGreen: 12568,
  BM_203650_MarinaBay: 12569,
  BM_203660_SurfGreen: 12570,
  BM_203670_CremeDeMint: 12571,
  BM_203710_AmazonMoss: 12572,
  BM_203720_JadeGreen: 12573,
  BM_203730_KellyGreen: 12574,
  BM_203740_AdamGreen: 12575,
  BM_203750_GreenwoodLake: 12576,
  BM_203760_SantaBarbaraGreen: 12577,
  BM_203770_FreshMint: 12578,
  BM_203810_CelticGreen: 12579,
  BM_203820_IrishClover: 12580,
  BM_203830_PrairieGreen: 12581,
  BM_203840_MonmouthGreen: 12582,
  BM_203850_ReturnToParadise: 12583,
  BM_203860_TropicalPool: 12584,
  BM_203870_IrishSpring: 12585,
  BM_203910_DeepGreen: 12586,
  BM_203920_EmeraldIsle: 12587,
  BM_203930_CabanaGreen: 12588,
  BM_203940_TealBlast: 12589,
  BM_203950_MermaidGreen: 12590,
  BM_203960_SeafoamGreen: 12591,
  BM_203970_RefreshingTeal: 12592,
  BM_204_WoodmontCream: 12593,
  BM_204010_RainforestFoliage: 12594,
  BM_204020_GreenMeadows: 12595,
  BM_204030_VeryGreen: 12596,
  BM_204040_SummerBasketGreen: 12597,
  BM_204050_HazyBlue: 1962,
  BM_204060_AntiguanSky: 12598,
  BM_204070_SpringMint: 12599,
  BM_204110_HunterGreen: 12600,
  BM_204120_FiddleheadGreen: 12601,
  BM_204130_GreenGables: 12602,
  BM_204140_JuneauSpring: 12603,
  BM_204150_SeaMistGreen: 12604,
  BM_204160_SoftMint: 12605,
  BM_204170_IrishMint: 12606,
  BM_204210_TrueGreen: 12607,
  BM_204220_ReefGreen: 12608,
  BM_204230_HummingbirdGreen: 12609,
  BM_204240_MiamiGreen: 12610,
  BM_204250_CaribeGreen: 12611,
  BM_204260_FloridaAqua: 12612,
  BM_204270_MintyGreen: 12613,
  BM_204310_AbsoluteGreen: 12614,
  BM_204320_MingJade: 12615,
  BM_204330_KelpForestGreen: 12616,
  BM_204340_EgyptianGreen: 12617,
  BM_204350_SouthBeach: 12618,
  BM_204360_SummerGreen: 12619,
  BM_204370_FrostyMint: 12620,
  BM_204410_Green: 12621,
  BM_204420_Leprechaun: 12622,
  BM_204430_StPatrick: 12623,
  BM_204440_AmeliaIslandBlue: 12624,
  BM_204450_BermudaTeal: 12625,
  BM_204460_CrystalClear: 12626,
  BM_204470_LightTouch: 12627,
  BM_204510_GreenBay: 12628,
  BM_204520_LawnGreen: 12629,
  BM_204530_GreenLeaf: 12630,
  BM_204540_BahamaGreen: 12631,
  BM_204550_GreenCoral: 12632,
  BM_204560_WinterGreen: 12633,
  BM_204570_SoftGreen: 12634,
  BM_204610_CalypsoGreen: 12635,
  BM_204620_GardenGreen: 12636,
  BM_204630_CaymanLagoon: 12637,
  BM_204640_GreenSponge: 12638,
  BM_204650_ScubaGreen: 12639,
  BM_204660_MistyTeal: 12640,
  BM_204670_LightMint: 12641,
  BM_204710_ForestGreen: 12642,
  BM_204720_ManorGreen: 12643,
  BM_204730_RollingHillGreen: 12644,
  BM_204740_CapriSeas: 12645,
  BM_204750_ShoreHouseGreen: 12646,
  BM_204760_OceanSpray: 12647,
  BM_204770_BabyGreen: 12648,
  BM_204810_SherwoodForest: 12649,
  BM_204820_Juniper: 12650,
  BM_204830_ArubaBlue: 12651,
  BM_204840_PoolsideBlue: 12652,
  BM_204850_TropicanaCabana: 12653,
  BM_204860_JamaicanAqua: 12654,
  BM_204870_BarelyTeal: 12655,
  BM_204910_PacificSeaTeal: 12656,
  BM_204920_OasisBlue: 12657,
  BM_204930_TealOcean: 12658,
  BM_204940_PeacockBlue: 12659,
  BM_204950_SpectraBlue: 12660,
  BM_204960_ForgetMeNot: 12661,
  BM_204970_IcingOnTheCake: 12662,
  BM_205_SimplyIrresistible: 12663,
  BM_205010_Salamander: 12664,
  BM_205020_DollarBillGreen: 12665,
  BM_205030_NewportGreen: 12666,
  BM_205040_FloridaKeysBlue: 12667,
  BM_205050_Waterfall: 12668,
  BM_205060_ArcticBlue: 12669,
  BM_205070_BlueBonnet: 12670,
  BM_205110_YukonGreen: 12671,
  BM_205120_PineGreen: 12672,
  BM_205130_CascoBay: 12673,
  BM_205140_MajesticBlue: 12674,
  BM_205150_TranquilBlue: 12675,
  BM_205160_BirdsEgg: 12676,
  BM_205170_CrystalBlue: 12677,
  BM_205210_OceanTropic: 12678,
  BM_205220_MarineAqua: 12679,
  BM_205230_TropicalTurquoise: 12680,
  BM_205240_BlueSpa: 12681,
  BM_205250_PoolBlue: 12682,
  BM_205260_ChinaBlue: 12683,
  BM_205270_QuietPond: 12684,
  BM_205310_MallardGreen: 12685,
  BM_205320_DarkTeal: 12686,
  BM_205330_NorthSeaGreen: 12687,
  BM_205340_BlueLake: 12688,
  BM_205350_PassionBlue: 12689,
  BM_205360_TeardropBlue: 12690,
  BM_205370_MorningSkyBlue: 12691,
  BM_205410_BavarianForest: 12692,
  BM_205420_BeauGreen: 12693,
  BM_205430_VenezuelanSea: 12694,
  BM_205440_BlueLagoon: 12695,
  BM_205450_SeasideBlue: 12696,
  BM_205460_OldPickupBlue: 12697,
  BM_205470_ClearSkies: 12698,
  BM_205510_Teal: 12699,
  BM_205520_PacificOceanBlue: 12700,
  BM_205530_CaribbeanBlueWater: 12701,
  BM_205540_BahamanSeaBlue: 12702,
  BM_205550_FairyTaleBlue: 12703,
  BM_205560_Serenity: 12704,
  BM_205570_Innocence: 12705,
  BM_205610_TucsonTeal: 12706,
  BM_205620_JadeGarden: 12707,
  BM_205630_SurfBlue: 12708,
  BM_205640_CoolAqua: 12709,
  BM_205650_BabyBoyBlue: 12710,
  BM_205660_BlueSeafoam: 12711,
  BM_205670_IcyMoonDrops: 12712,
  BM_205710_RiverBlue: 12713,
  BM_205720_GalapagosTurquoise: 12714,
  BM_205730_NaplesBlue: 12715,
  BM_205740_AshBlue: 12716,
  BM_205750_TurquoisePowder: 12717,
  BM_205760_BlueFlower: 12718,
  BM_205770_IcyBlue: 12719,
  BM_205810_Twilight: 12720,
  BM_205820_SlateTeal: 12721,
  BM_205830_DeepOcean: 12722,
  BM_205840_CoolBlue: 12723,
  BM_205850_AquariumBlue: 12724,
  BM_205860_OceanBreeze: 12725,
  BM_205870_BlueAngel: 12726,
  BM_205910_MarineBlue: 12727,
  BM_205920_CaribbeanAzure: 12728,
  BM_205930_LagunaBlue: 12729,
  BM_205940_YosemiteBlue: 12730,
  BM_205950_PoolParty: 12731,
  BM_205960_Splash: 12732,
  BM_205970_FountainSpout: 12733,
  BM_206_SummerHarvest: 12734,
  BM_206010_SymphonyBlue: 12735,
  BM_206020_CaliforniaBlue: 12736,
  BM_206030_SeaportBlue: 12737,
  BM_206040_TorontoBlue: 12738,
  BM_206050_CaymanBlue: 12739,
  BM_206060_TurquoiseHaze: 12740,
  BM_206070_Teardrop: 12741,
  BM_206110_DeepRoyal: 12742,
  BM_206120_CefaluBeach: 12743,
  BM_206130_BermudaBlue: 12744,
  BM_206140_ElectricBlue: 12745,
  BM_206150_TidalWave: 12746,
  BM_206160_LittleBoyBlue: 12747,
  BM_206170_CaribbeanMist: 12748,
  BM_206210_ThreePieceSuit: 12749,
  BM_206220_GentlemansGray: 12750,
  BM_206230_BlueDanube: 12751,
  BM_206240_BlueDaisy: 12752,
  BM_206250_BlueJean: 12753,
  BM_206260_BlueHydrangea: 12754,
  BM_206270_HarborFog: 12755,
  BM_206310_WindingWaterway: 12756,
  BM_206320_DownpourBlue: 12757,
  BM_206330_Blueberry: 12758,
  BM_206340_SailorsSeaBlue: 12759,
  BM_206350_BlueMarguerite: 12760,
  BM_206360_Sapphireberry: 12761,
  BM_206370_CumulusCotton: 12762,
  BM_206410_BoldBlue: 12763,
  BM_206420_LauraBay: 12764,
  BM_206430_OlBlueEyes: 12765,
  BM_206440_ClearestOceanBlue: 12766,
  BM_206450_CostaRicaBlue: 12767,
  BM_206460_Bluebelle: 12768,
  BM_206470_BillowyDown: 12769,
  BM_206510_AdmiralBlue: 12770,
  BM_206520_DarkRoyalBlue: 12771,
  BM_206530_BrilliantBlue: 12772,
  BM_206540_UtahSky: 12773,
  BM_206550_BlueWave: 12774,
  BM_206560_CaribbeanCoast: 12775,
  BM_206570_BashfulBlue: 12776,
  BM_206610_Blue: 12777,
  BM_206620_EveningBlue: 12778,
  BM_206630_BigCountryBlue: 12779,
  BM_206640_RockyMountainSky: 12780,
  BM_206650_TrueBlue: 12781,
  BM_206660_HonoluluBlue: 12782,
  BM_206670_LightBlue: 12783,
  BM_206710_MidnightNavy: 12784,
  BM_206720_StarryNightBlue: 12785,
  BM_206730_TwilightBlue: 12786,
  BM_206740_BlueLapis: 12787,
  BM_206750_SummerBlue: 12788,
  BM_206760_WindmillWings: 12789,
  BM_206770_WhiteSatin: 12790,
  BM_206810_MajesticViolet: 12791,
  BM_206820_GrapeGum: 12792,
  BM_206830_ScandinavianBlue: 12793,
  BM_206840_CaliforniaLilac: 12794,
  BM_206850_VictorianTrim: 12795,
  BM_206860_PurpleLace: 12796,
  BM_206870_WhiteHeaven: 12797,
  BM_206910_DeepMulberry: 12798,
  BM_206920_BlackberryWine: 12799,
  BM_206930_DarkestGrape: 12800,
  BM_206940_VioletStone: 12801,
  BM_206950_BlueOrchid: 12802,
  BM_206960_LavenderIce: 12803,
  BM_206970_PolarWhite: 12804,
  BM_207_Vellum: 12805,
  BM_207010_TulsaTwilight: 12806,
  BM_207020_PlumRoyale: 12807,
  BM_207030_DarkLilac: 12808,
  BM_207040_SpringPurple: 12809,
  BM_207050_Enchanted: 12810,
  BM_207060_LavenderMist: 12811,
  BM_207070_WhisperViolet: 12812,
  BM_207110_ExoticPurple: 12813,
  BM_207120_GentleViolet: 12814,
  BM_207130_MysticalGrape: 12815,
  BM_207140_CrocusPetalPurple: 12816,
  BM_207150_AmethystCream: 12817,
  BM_207160_LilyLavender: 12818,
  BM_207170_MistyLilac: 12819,
  BM_207210_DarkBasalt: 12820,
  BM_207220_BlackRaspberry: 12821,
  BM_207230_PurpleLotus: 12822,
  BM_207240_WildOrchid: 12823,
  BM_207250_LavenderLipstick: 12824,
  BM_207260_BeachPlum: 12825,
  BM_207270_RaspberryIce: 12826,
  BM_207310_DarkPurple: 12827,
  BM_207320_AutumnPurple: 12828,
  BM_207330_PassionPlum: 12829,
  BM_207340_PurpleHyacinth: 12830,
  BM_207350_PurpleEasterEgg: 12831,
  BM_207360_PaleIris: 12832,
  BM_207370_PurpleCream: 12833,
  BM_207410_GrapeJuice: 12834,
  BM_207420_SummerPlum: 12835,
  BM_207430_TwilightMagenta: 12836,
  BM_207440_LilacPink: 12837,
  BM_207450_ExoticFuchsia: 12838,
  BM_207460_BunnyNosePink: 12839,
  BM_207470_EasterBonnet: 12840,
  BM_207510_DarkBurgundy: 12841,
  BM_207520_Mulberry: 12842,
  BM_207530_PreDawnSky: 12843,
  BM_207540_PinkRaspberry: 12844,
  BM_207550_PinkTaffy: 12845,
  BM_207560_PassionPink: 12846,
  BM_207570_CharmingPink: 12847,
  BM_207610_CrushedVelvet: 12848,
  BM_207620_RoyalFlush: 12849,
  BM_207630_CrushedBerries: 12850,
  BM_207640_RaspberryMousse: 12851,
  BM_207650_EasterPink: 12852,
  BM_207660_DogsEar: 12853,
  BM_207670_NurseryPink: 12854,
  BM_207710_Magenta: 12855,
  BM_207720_FoxgloveBloom: 12856,
  BM_207730_HotLips: 12857,
  BM_207740_SpringAzalea: 12858,
  BM_207750_PrettyPink: 12859,
  BM_207760_ValentinesDay: 12860,
  BM_207770_ILoveYouPink: 12861,
  BM_207810_Roseate: 12862,
  BM_207820_RaspberryGlaze: 12863,
  BM_207830_RoyalFuchsia: 12864,
  BM_207840_ParadisePink: 12865,
  BM_207850_PinkBegonia: 12866,
  BM_207860_NewbornPink: 12867,
  BM_207870_PinkPeony: 12868,
  BM_207910_CandyCaneRed: 12869,
  BM_207920_BlushingRed: 12870,
  BM_207930_Peony: 12871,
  BM_207940_SpringtimeBloom: 12872,
  BM_207950_Rhododendron: 12873,
  BM_207960_PinkCherub: 12874,
  BM_207970_CandyStripe: 12875,
  BM_208_DaVincisCanvas: 12876,
  BM_208010_RaspberryTruffle: 12877,
  BM_208020_CosmicCrisp: 12878,
  BM_208030_CherryWine: 12879,
  BM_208040_WildPink: 12880,
  BM_208050_Bayberry: 12881,
  BM_208060_PosyPink: 12882,
  BM_208070_AztecLily: 12883,
  BM_208110_BurntPeanutRed: 12884,
  BM_208120_SultansPalace: 12885,
  BM_208130_VibrantBlush: 12886,
  BM_208140_PinkBlossom: 12887,
  BM_208150_PinkRuffle: 12888,
  BM_208160_PinkLace: 12889,
  BM_208170_FlushPink: 12890,
  BM_208210_Chestnut: 12891,
  BM_208220_PlumRaisin: 12892,
  BM_208230_CherokeeBrick: 12893,
  BM_208240_Rosewood: 12894,
  BM_208250_DamaskRose: 12895,
  BM_208260_PinkInnocence: 12896,
  BM_208270_BallerinaPink: 12897,
  BM_208310_RaisinTorte: 12898,
  BM_208320_CranberryCocktail: 12899,
  BM_208330_OldClaret: 12900,
  BM_208340_Begonia: 12901,
  BM_208350_PinkPansy: 12902,
  BM_208360_SweetNaivete: 12903,
  BM_208370_BabyDreams: 12904,
  BM_208410_BrickRed: 12905,
  BM_208420_MapleLeafRed: 12906,
  BM_208430_Rouge: 12907,
  BM_208440_PreciousPink: 12908,
  BM_208450_RosyGlow: 12909,
  BM_208460_EarlySunrise: 12910,
  BM_208470_GentleBlush: 12911,
  BM_208510_ArroyoRed: 12912,
  BM_208520_PotteryRed: 12913,
  BM_208530_FascinatorRose: 12914,
  BM_208540_TasteOfBerry: 12915,
  BM_208550_Strawberry: 12916,
  BM_208560_PinkPetals: 12917,
  BM_208570_BabyPink: 12918,
  BM_208610_ExoticRed: 12919,
  BM_208620_RoseParade: 12920,
  BM_208630_RosyBlush: 12921,
  BM_208640_DeepCarnation: 12922,
  BM_208650_BlushingBride: 12923,
  BM_208660_SweetTaffy: 12924,
  BM_208670_50sPink: 12925,
  BM_208710_NeonRed: 12926,
  BM_208720_WatermelonRed: 12927,
  BM_208730_ItalianoRose: 12928,
  BM_208740_AutumnRed: 12929,
  BM_208750_StrawberrySorbet: 12930,
  BM_208760_RibbonPink: 12931,
  BM_208770_ElephantPink: 12932,
  BM_208810_RedOxide: 12933,
  BM_208820_CountryLane: 12934,
  BM_208830_StrawberryField: 12935,
  BM_208840_Persimmon: 12936,
  BM_208850_CoolLava: 12937,
  BM_208860_FruitShake: 12938,
  BM_208870_FondMemory: 12939,
  BM_208910_IronOreRed: 12940,
  BM_208920_RosyPeach: 12941,
  BM_208930_PinkMix: 12942,
  BM_208940_TomatoCreamSauce: 12943,
  BM_208950_SalmonBerry: 12944,
  BM_208960_PeachKiss: 12945,
  BM_208970_FrostedPetal: 12946,
  BM_209_BuenaVistaGold: 12947,
  BM_209010_GrandCanyonRed: 12948,
  BM_209020_RichChestnut: 12949,
  BM_209030_TerraCottaTile: 12950,
  BM_209040_WildFlower: 12951,
  BM_209050_TenderPink: 12952,
  BM_209060_StrawberryFreeze: 12953,
  BM_209070_SpringPink: 12954,
  BM_209110_Tea: 12955,
  BM_209120_RusticBrick: 12956,
  BM_209130_DeepPoinsettia: 12957,
  BM_209140_RedRiverClay: 12958,
  BM_209150_RosyTan: 12959,
  BM_209160_HeatherPink: 12960,
  BM_209170_AprilPink: 12961,
  BM_209210_ClydesdaleBrown: 12962,
  BM_209220_Sienna: 12963,
  BM_209230_BostonBrick: 12964,
  BM_209240_TexasRose: 12965,
  BM_209250_TitanicRose: 12966,
  BM_209260_GeorgiaPink: 12967,
  BM_209270_FairestPink: 12968,
  BM_209310_Cimarron: 12969,
  BM_209320_FreshClay: 12970,
  BM_209330_ColonialBrick: 12971,
  BM_209340_BelladonnaLily: 12972,
  BM_209350_CamelliaPink: 12973,
  BM_209360_PlayfulPink: 12974,
  BM_209370_PinkBliss: 12975,
  BM_209410_BurntCinnamon: 12976,
  BM_209420_CopperMine: 12977,
  BM_209430_GiantSequoia: 12978,
  BM_209440_SoftCranberry: 12979,
  BM_209450_DesertRose: 12980,
  BM_209460_PleasantPink: 12981,
  BM_209470_MellowPink: 12982,
  BM_209510_AdirondackBrown: 12983,
  BM_209520_AntlerBrown: 12984,
  BM_209530_ButternutBrown: 12985,
  BM_209540_Mudslide: 12986,
  BM_209550_JustBeige: 12987,
  BM_209560_SouthernComfort: 12988,
  BM_209570_MeltedIceCream: 12989,
  BM_209610_SeedBrown: 12990,
  BM_209620_ChocolateTruffle: 12991,
  BM_209630_GrandfatherClockBrown: 12992,
  BM_209640_GauchoBrown: 12993,
  BM_209650_Cappuccino: 12994,
  BM_209660_LightMocha: 12995,
  BM_209670_EarlySunset: 12996,
  BM_209710_ToastedBrown: 12997,
  BM_209720_MorningCoffee: 12998,
  BM_209730_HedgehogBrown: 12999,
  BM_209740_SantaFeTan: 13000,
  BM_209750_HintOfMauve: 13001,
  BM_209760_MistyBlush: 13002,
  BM_209770_WildRice: 13003,
  BM_209810_BarrelBrown: 13004,
  BM_209820_RoastedCoffeeBeans: 13005,
  BM_209830_DarkNutBrown: 13006,
  BM_209840_WeatheredBark: 13007,
  BM_209850_Flax: 13008,
  BM_209860_WispOfMauve: 13009,
  BM_209870_FrostedCafe: 13010,
  BM_209910_Brown: 13011,
  BM_209920_Cupcake: 13012,
  BM_209930_Espresso: 13013,
  BM_209940_AutumnBrown: 13014,
  BM_209950_CafeMocha: 13015,
  BM_209960_MaltedMilk: 13016,
  BM_209970_Wheatberry: 13017,
  BM_21_JupiterGlow: 13018,
  BM_210_LeapOfFaith: 13019,
  BM_210010_MochaMadness: 13020,
  BM_210020_LeatherSaddleBrown: 13021,
  BM_210030_EnglishBrown: 13022,
  BM_210040_AppalachianSpring: 13023,
  BM_210050_PebbleStone: 13024,
  BM_210060_BermudaSands: 13025,
  BM_210070_VictorianLace: 13026,
  BM_210110_SuedeBrown: 13027,
  BM_210120_CocoaBrown: 13028,
  BM_210130_WarmBrownie: 13029,
  BM_210140_AlmondBeige: 13030,
  BM_210150_Allspice: 13031,
  BM_210160_PaleCherryBlossom: 13032,
  BM_210170_TropicalSand: 13033,
  BM_210210_EarthBrown: 13034,
  BM_210220_Pumpernickel: 13035,
  BM_210230_PuebloBrown: 13036,
  BM_210240_BrownTeepee: 13037,
  BM_210250_RoseBisque: 13038,
  BM_210260_HoneyHut: 13039,
  BM_210270_FirstLight: 13040,
  BM_210310_NaturalBrown: 13041,
  BM_210320_EnglishManor: 13042,
  BM_210330_Peatmoss: 13043,
  BM_210340_HickoryStick: 13044,
  BM_210350_Sandblast: 13045,
  BM_210360_PaleBerry: 13046,
  BM_210370_StrawberryNCream: 13047,
  BM_210410_PancakeSyrup: 13048,
  BM_210420_BeaverBrown: 13049,
  BM_210430_HarvestBrown: 13050,
  BM_210440_NewEnglandBrown: 13051,
  BM_210450_CherryMalt: 13052,
  BM_210460_RoseSilk: 13053,
  BM_210470_StrawberryYogurt: 13054,
  BM_210510_ForestBrown: 13055,
  BM_210520_RootBeerCandy: 13056,
  BM_210530_RabbitBrown: 13057,
  BM_210540_DustyRanchBrown: 13058,
  BM_210550_SandPebble: 13059,
  BM_210560_AcapulcoSand: 13060,
  BM_210570_SavoryCream: 13061,
  BM_210610_Java: 13062,
  BM_210620_Auberge: 13063,
  BM_210630_PineCone: 13064,
  BM_210640_CougarBrown: 13065,
  BM_210650_DriftscapeTan: 13066,
  BM_210660_SoftSand: 13067,
  BM_210670_FoggyMorning: 13068,
  BM_2107_MochaBrown: 11336,
  BM_210710_ChocolateCandyBrown: 13069,
  BM_210720_MochaBrown: 13070,
  BM_210730_RockiesBrown: 13071,
  BM_210740_Driftwood: 13072,
  BM_210750_SandlotGray: 13073,
  BM_210760_SeaFroth: 13074,
  BM_210770_CloudyGray: 13075,
  BM_210810_FerretBrown: 13076,
  BM_210820_SierraSpruce: 13077,
  BM_210830_BrownHorse: 13078,
  BM_210840_Stardust: 13079,
  BM_210850_SilverFox: 13080,
  BM_210860_Abalone: 13081,
  BM_210870_LaceyPearl: 13082,
  BM_210910_ClassicBrown: 13083,
  BM_210920_HearthstoneBrown: 13084,
  BM_210930_WoodGrainBrown: 13085,
  BM_210940_SmokedOyster: 13086,
  BM_210950_ElephantGray: 13087,
  BM_210960_PortlandGray: 13088,
  BM_210970_ALaMode: 13089,
  BM_211_FreshAir: 13090,
  BM_211010_Taupe: 13091,
  BM_211020_BrownTar: 13092,
  BM_211030_SaddleSoap: 13093,
  BM_211040_SeasideSand: 13094,
  BM_211050_GobiDesert: 13095,
  BM_211060_PampasGrass: 13096,
  BM_211070_VintageTaupe: 13097,
  BM_211110_DeepTaupe: 13098,
  BM_211120_GrizzlyBearBrown: 13099,
  BM_211130_Mustang: 13100,
  BM_211140_TaosTaupe: 13101,
  BM_211150_StoneHarbor: 13102,
  BM_211160_BarrenPlain: 13103,
  BM_211170_Calm: 13104,
  BM_211210_Mink: 13105,
  BM_211220_BrownSugar: 13106,
  BM_211230_StoneBrown: 13107,
  BM_211240_Stone: 13108,
  BM_211250_StormyMonday: 13109,
  BM_211260_CementGray: 13110,
  BM_211270_GarlicBulb: 13111,
  BM_211310_ChocolateSundae: 13112,
  BM_211320_PineConeBrown: 13113,
  BM_211330_BisonBrown: 13114,
  BM_211340_CinnamonSlate: 13115,
  BM_211350_MauveDesert: 13116,
  BM_211360_Porcelain: 13117,
  BM_211370_AntiquePearl: 13118,
  BM_211410_BittersweetChocolate: 13119,
  BM_211420_MississippiMud: 13120,
  BM_211430_DesertShadows: 13121,
  BM_211440_WetConcrete: 13122,
  BM_211450_VictorianMauve: 13123,
  BM_211460_HintOfViolet: 13124,
  BM_211470_VenetianMarble: 13125,
  BM_211510_AppalachianBrown: 13126,
  BM_211520_IncenseStick: 13127,
  BM_211530_AmazonSoil: 13128,
  BM_211540_MauveBlush: 13129,
  BM_211550_IcedMauve: 13130,
  BM_211560_MajesticMauve: 13131,
  BM_211570_Oyster: 13132,
  BM_211610_NightShade: 13133,
  BM_211620_VintageWine: 13134,
  BM_211630_Cabernet: 13135,
  BM_211640_HazyLilac: 13136,
  BM_211650_AfricanViolet: 13137,
  BM_211660_TouchOfGray: 13138,
  BM_211670_MirageWhite: 13139,
  BM_211710_CarbonCopy: 13140,
  BM_211720_Galaxy: 13141,
  BM_211730_Shadow: 13142,
  BM_211740_TropicalDusk: 13143,
  BM_211750_SpringViolet: 13144,
  BM_211760_WinterGray: 13145,
  BM_211770_DreamyCloud: 13146,
  BM_211810_UniversalBlack: 13147,
  BM_211820_ToucanBlack: 13148,
  BM_211830_EbonySlate: 13149,
  BM_211840_SeaLife: 13150,
  BM_211850_ExcaliburGray: 13151,
  BM_211860_MistyMemories: 13152,
  BM_211870_Heaven: 13153,
  BM_211910_SpaceBlack: 13154,
  BM_211920_BlackBerry: 13155,
  BM_211930_BabySealBlack: 13156,
  BM_211940_SilverStreak: 13157,
  BM_211950_Nickel: 13158,
  BM_211960_SilverLining: 13159,
  BM_211970_FullMoon: 13160,
  BM_212_HappyValley: 13161,
  BM_212010_JetBlack: 13162,
  BM_212020_BlackIron: 13163,
  BM_212030_WitchingHour: 13164,
  BM_212040_SmokeGray: 13165,
  BM_212050_SilverSpring: 13166,
  BM_212060_WhiteWater: 13167,
  BM_212070_StoneWhite: 13168,
  BM_212110_Gray: 13169,
  BM_212120_SteelWool: 13170,
  BM_212130_Pewter: 13171,
  BM_212140_PorringerGray: 13172,
  BM_212150_IceCubeSilver: 13173,
  BM_212160_WhiteDiamond: 13174,
  BM_212170_ChantillyLace: 13175,
  BM_212210_DarkPewter: 13176,
  BM_212220_SteepCliffGray: 13177,
  BM_212230_CloudySky: 13178,
  BM_212240_Smoke: 13179,
  BM_212250_Iceberg: 13180,
  BM_212260_PalestPistachio: 13181,
  BM_212270_SnowWhite: 13182,
  BM_212310_MediterraneanTeal: 13183,
  BM_212320_CaribbeanTeal: 13184,
  BM_212330_SeaStar: 13185,
  BM_212340_GossamerBlue: 13186,
  BM_212350_OceanAir: 13187,
  BM_212360_SeaFoam: 13188,
  BM_212370_IceMist: 13189,
  BM_212410_WroughtIron: 10978,
  BM_212420_TroutGray: 13190,
  BM_212430_DeepSilver: 13191,
  BM_212440_ThundercloudGray: 13192,
  BM_212450_BunnyGray: 13193,
  BM_212460_MistyGray: 13194,
  BM_212470_DistantGray: 11018,
  BM_212510_BlackPanther: 13195,
  BM_212520_DeepSpace: 13196,
  BM_212530_GrayShower: 13197,
  BM_212540_ShadowGray: 13198,
  BM_212550_SweetInnocence: 13199,
  BM_212560_MarilynsDress: 13200,
  BM_212570_WeddingVeil: 13201,
  BM_212610_BlackTar: 13202,
  BM_212620_RaccoonFur: 13203,
  BM_212630_AnchorGray: 13204,
  BM_212640_SweatshirtGray: 13205,
  BM_212650_GrayTimberWolf: 13206,
  BM_212660_GrayCloud: 13207,
  BM_212670_ChalkWhite: 13208,
  BM_212710_TwilightZone: 13209,
  BM_212720_BlackInk: 13210,
  BM_212730_GravelGray: 13211,
  BM_212740_WolfGray: 13212,
  BM_212750_PikesPeakGray: 13213,
  BM_212760_FeatherGray: 13214,
  BM_212770_CascadeWhite: 13215,
  BM_212810_BlackBeauty: 13216,
  BM_212820_Abyss: 13217,
  BM_212830_EveningDove: 13218,
  BM_212840_OxfordGray: 13219,
  BM_212850_NovemberSkies: 13220,
  BM_212860_BeaconGray: 13221,
  BM_212870_LilyWhite: 13222,
  BM_212910_MidnightDream: 13223,
  BM_212920_Soot: 13224,
  BM_212930_BlueNote: 13225,
  BM_212940_Normandy: 13226,
  BM_212950_WinterLake: 13227,
  BM_212960_MtRainierGray: 13228,
  BM_212970_SilverCloud: 13229,
  BM_213_HarpStrings: 1963,
  BM_213010_BlackBeanSoup: 13230,
  BM_213020_DeepCaviar: 13231,
  BM_213030_AlmostBlack: 13232,
  BM_213040_BlackPepper: 13233,
  BM_213050_NewHopeGray: 13234,
  BM_213060_IcedSlate: 13235,
  BM_213070_SeattleGray: 13236,
  BM_213110_BlackSatin: 13237,
  BM_213120_Midnight: 13238,
  BM_213130_LeadGray: 13239,
  BM_213140_SmokestackGray: 1964,
  BM_213150_BeneathTheClouds: 13240,
  BM_213160_SilverGray: 13241,
  BM_213170_GraySky: 13242,
  BM_213210_Black: 10549,
  BM_213220_WireFrameGlasses: 13243,
  BM_213230_BlackHorizon: 13244,
  BM_213240_Eclipse: 13245,
  BM_213250_PilgrimHaze: 13246,
  BM_213260_MetallicSilver: 13247,
  BM_213270_MineralIce: 13248,
  BM_213310_Onyx: 53,
  BM_213320_BlackJack: 13249,
  BM_213330_DaysEnd: 13250,
  BM_213340_CharcoalLinen: 13251,
  BM_213350_PigeonGray: 13252,
  BM_213360_SidewalkGray: 13253,
  BM_213370_Tundra: 13254,
  BM_213410_NightHorizon: 13255,
  BM_213420_MidsummerNight: 13256,
  BM_213430_IronMountain: 217,
  BM_213440_SharkGray: 13257,
  BM_213450_GullWingGray: 13258,
  BM_213460_Whitestone: 13259,
  BM_213470_GenesisWhite: 13260,
  BM_213510_Blacktop: 13261,
  BM_213520_Stonecutter: 13262,
  BM_213530_NocturnalGray: 1965,
  BM_213540_ProvinceBlue: 13263,
  BM_213550_SoftChinchilla: 13264,
  BM_213560_SummerShower: 13265,
  BM_213570_TulleSkirt: 13266,
  BM_213610_BlackKnight: 13267,
  BM_213620_RegentGreen: 13268,
  BM_213630_AmazonGreen: 13269,
  BM_213640_AegeanTeal: 13270,
  BM_213650_ColoradoGray: 13271,
  BM_213660_HarborHaze: 13272,
  BM_213670_WhisperingSpring: 13273,
  BM_213710_OtterBrown: 13274,
  BM_213720_CharBrown: 13275,
  BM_213730_Durango: 13276,
  BM_213740_DesertTwilight: 13277,
  BM_213750_SeaHaze: 13278,
  BM_213760_GrayOwl: 13279,
  BM_213770_WhiteWisp: 13280,
  BM_213810_SouthernVine: 13281,
  BM_213820_GreenGrove: 13282,
  BM_213830_MoheganSage: 13283,
  BM_213840_CarolinaGull: 13284,
  BM_213850_MistedGreen: 13285,
  BM_213860_GrayCashmere: 13286,
  BM_213870_GrayLake: 13287,
  BM_213910_RiverRock: 13288,
  BM_213920_DakotaWoodsGreen: 13289,
  BM_213930_Sharkskin: 13290,
  BM_213940_HeatherGray: 13291,
  BM_213950_SilverMarlin: 13292,
  BM_213960_GreenTint: 13293,
  BM_213970_WhiteIce: 13294,
  BM_214_ValleyView: 13295,
  BM_214010_FatigueGreen: 13296,
  BM_214020_TuscanyGreen: 13297,
  BM_214030_DarkOlive: 13298,
  BM_214040_StormCloudGray: 13299,
  BM_214050_GrayHorse: 13300,
  BM_214060_Moonshine: 13301,
  BM_214070_WinterWhite: 13302,
  BM_214110_Artichoke: 13303,
  BM_214120_CabbagePatch: 13304,
  BM_214130_ArmyGreen: 13305,
  BM_214140_CreeksideGreen: 13306,
  BM_214150_HorizonGray: 13307,
  BM_214160_Titanium: 13308,
  BM_214170_VanillaMilkshake: 13309,
  BM_214210_MediterraneanOlive: 13310,
  BM_214220_TurtleGreen: 13311,
  BM_214230_MountainMoss: 13312,
  BM_214240_DrySage: 13313,
  BM_214250_GrayMirage: 13314,
  BM_214260_NovemberRain: 13315,
  BM_214270_Icicle: 13316,
  BM_214310_Sage: 13317,
  BM_214320_AlligatorGreen: 13318,
  BM_214330_OliveBranch: 13319,
  BM_214340_Camouflage: 13320,
  BM_214350_OldPrairie: 13321,
  BM_214360_MoonlightWhite: 13322,
  BM_214370_SimplyWhite: 13323,
  BM_214410_Guacamole: 13324,
  BM_214420_EucalyptusLeaf: 13325,
  BM_214430_RosemarySprig: 1966,
  BM_214440_SoftFern: 13326,
  BM_214450_SilkenPine: 13327,
  BM_214460_CloudNine: 13328,
  BM_214470_SnowfallWhite: 13329,
  BM_214510_Avocado: 13330,
  BM_214520_TerrapinGreen: 13331,
  BM_214530_BrooksideMoss: 13332,
  BM_214540_FernwoodGreen: 13333,
  BM_214550_Limesicle: 13334,
  BM_214560_MincedOnion: 13335,
  BM_214570_CottonBalls: 13336,
  BM_214610_DarkCelery: 13337,
  BM_214620_ForestMoss: 13338,
  BM_214630_SplitPea: 13339,
  BM_214640_PaleAvocado: 13340,
  BM_214650_RainforestDew: 13341,
  BM_214660_CreamSilk: 13342,
  BM_214670_BavarianCream: 13343,
  BM_214710_Oregano: 13344,
  BM_214720_OliveMoss: 13345,
  BM_214730_JalapenoPepper: 13346,
  BM_214740_DillPickle: 13347,
  BM_214750_PaleSeaMist: 13348,
  BM_214760_DarkLinen: 13349,
  BM_214770_AlpineWhite: 13350,
  BM_214810_FootHills: 13351,
  BM_214820_Thyme: 13352,
  BM_214830_MilitaryTan: 13353,
  BM_214840_LightKhaki: 13354,
  BM_214850_SandyWhite: 1967,
  BM_214860_TimidWhite: 13355,
  BM_214870_MountainPeakWhite: 13356,
  BM_214910_NewtGreen: 13357,
  BM_214920_GIGreen: 13358,
  BM_214930_FreshOlive: 13359,
  BM_214940_TimothyStraw: 13360,
  BM_214950_MellowedIvory: 13361,
  BM_214960_WhiteMarigold: 13362,
  BM_214970_WhiteChocolate: 13363,
  BM_215_YosemiteYellow: 13364,
  BM_215010_WillowGreen: 13365,
  BM_215020_LichenGreen: 13366,
  BM_215030_SavannahGreen: 13367,
  BM_215040_SpringDust: 13368,
  BM_215050_HamptonGreen: 13369,
  BM_215060_PaleCelery: 13370,
  BM_215070_EasterLily: 13371,
  BM_215110_MustardOlive: 13372,
  BM_215120_GoldenChalice: 13373,
  BM_215130_Ochre: 13374,
  BM_215140_SulfurYellow: 13375,
  BM_215150_BronzedBeige: 13376,
  BM_215160_LinenSand: 13377,
  BM_215170_PowderSand: 13378,
  BM_215210_MedievalGold: 13379,
  BM_215220_AztecYellow: 13380,
  BM_215230_AutumnGold: 13381,
  BM_215240_GoldenTan: 13382,
  BM_215250_GoldenStraw: 13383,
  BM_215260_MannequinCream: 13384,
  BM_215270_Mayonnaise: 13385,
  BM_215310_GoldenBark: 13386,
  BM_215320_Corduroy: 13387,
  BM_215330_TapestryGold: 13388,
  BM_215340_Cork: 13389,
  BM_215350_DesertTan: 13390,
  BM_215360_RichCream: 13391,
  BM_215370_IvoryTusk: 13392,
  BM_215410_YellowOxide: 13393,
  BM_215420_SpicyMustard: 13394,
  BM_215430_Buttercup: 13395,
  BM_215440_YorkHarborYellow: 13396,
  BM_215450_Straw: 13397,
  BM_215460_FilteredSunlight: 13398,
  BM_215470_VanillaIceCream: 13399,
  BM_215510_DesertSunset: 13400,
  BM_215520_GoldMine: 13401,
  BM_215530_YellowMarigold: 13402,
  BM_215540_Semolina: 13403,
  BM_215550_SuntanYellow: 13404,
  BM_215560_CreamYellow: 13405,
  BM_215570_CottonTail: 13406,
  BM_215610_AutumnOrange: 13407,
  BM_215620_PumpkinBlush: 13408,
  BM_215630_JackOLantern: 13409,
  BM_215640_AugustMorning: 13410,
  BM_215650_AsburySand: 13411,
  BM_215660_SoftBeige: 13412,
  BM_215670_FineChina: 13413,
  BM_215710_GoldenDunes: 13414,
  BM_215720_GoldenHarvest: 13415,
  BM_215730_Butterscotch: 13416,
  BM_215740_Beeswax: 13417,
  BM_215750_CrispStraw: 13418,
  BM_215760_TudorCream: 13419,
  BM_215770_IvoryTower: 13420,
  BM_215810_DriedMustard: 13421,
  BM_215820_VenetianGold: 13422,
  BM_215830_DelightfulGolden: 13423,
  BM_215840_GoldenMist: 13424,
  BM_215850_Manila: 13425,
  BM_215860_LionYellow: 13426,
  BM_215870_CreamFroth: 13427,
  BM_215910_DashOfCurry: 13428,
  BM_215920_PeanutButter: 13429,
  BM_215930_AppleCrisp: 13430,
  BM_215940_AmberWaves: 13431,
  BM_215950_Wheatfield: 13432,
  BM_215960_Cream: 13433,
  BM_215970_SatinShoes: 13434,
  BM_216_CaliforniaHills: 13435,
  BM_216010_CaramelCorn: 13436,
  BM_216020_Turmeric: 13437,
  BM_216030_MapleSugar: 13438,
  BM_216040_RoastedSesameSeed: 13439,
  BM_216050_OklahomaWheat: 13440,
  BM_216060_KansasGrain: 13441,
  BM_216070_SugarCookie: 13442,
  BM_216110_Coppertone: 13443,
  BM_216120_Tawny: 13444,
  BM_216130_DarkMustard: 13445,
  BM_216140_AcornYellow: 13446,
  BM_216150_YellowSquash: 13447,
  BM_216160_HazelnutCream: 13448,
  BM_216170_WoodlandSnow: 13449,
  BM_216210_AutumnBronze: 13450,
  BM_216220_DesertCamel: 13451,
  BM_216230_WarmTan: 13452,
  BM_216240_PeanutShell: 13453,
  BM_216250_ArizonaTan: 13454,
  BM_216260_MysticBeige: 13455,
  BM_216270_OctoberSky: 13456,
  BM_216310_LogCabin: 13457,
  BM_216320_PonyBrown: 13458,
  BM_216330_Penny: 13459,
  BM_216340_MetallicGold: 13460,
  BM_216350_Burlap: 13461,
  BM_216360_Latte: 13462,
  BM_216370_WinterSky: 13463,
  BM_216410_Cordwainer: 13464,
  BM_216420_MarshBrown: 13465,
  BM_216430_RichClayBrown: 13466,
  BM_216440_SerengetiSand: 13467,
  BM_216450_SaintMartinSand: 13468,
  BM_216460_SoftSatin: 13469,
  BM_216470_CandleWhite: 13470,
  BM_216510_Camel: 13471,
  BM_216520_GoldenMeadow: 13472,
  BM_216530_GoldenRetriever: 13473,
  BM_216540_DarkBeige: 13474,
  BM_216550_NaturalSand: 13475,
  BM_216560_DurangoDust: 13476,
  BM_216570_ButterPecan: 13477,
  BM_216610_GoldRush: 13478,
  BM_216620_CaramelLatte: 13479,
  BM_216630_BronzeTone: 13480,
  BM_216640_SoftPumpkin: 13481,
  BM_216650_CreamyOrange: 13482,
  BM_216660_PaleOats: 13483,
  BM_216670_AdobeWhite: 13484,
  BM_216710_BurntCaramel: 13485,
  BM_216720_PumpkinPie: 13486,
  BM_216730_HarvestMoon: 13487,
  BM_216740_ToffeeOrange: 13488,
  BM_216750_PerfectPeach: 13489,
  BM_216760_SweetSalmon: 13490,
  BM_216770_SummerPeach: 13491,
  BM_216810_FallHarvest: 13492,
  BM_216820_PumpkinCream: 13493,
  BM_216830_OrangeBlossom: 13494,
  BM_216840_Peachland: 13495,
  BM_216850_SummerMelon: 13496,
  BM_216860_PeachNectar: 13497,
  BM_216870_SunKissedPeach: 13498,
  BM_216910_RacingOrange: 13499,
  BM_216920_OrangeParrot: 13500,
  BM_216930_Oriole: 13501,
  BM_216940_PeachCobbler: 13502,
  BM_216950_MalibuPeach: 13503,
  BM_216960_PeachCloud: 13504,
  BM_216970_SunWashed: 13505,
  BM_217_AntiqueBronze: 13506,
  BM_217010_FireballOrange: 13507,
  BM_217020_TropicalOrange: 13508,
  BM_217030_AutumnCover: 13509,
  BM_217040_CoralSpice: 13510,
  BM_217050_TeacupRose: 13511,
  BM_217060_SunlitCoral: 13512,
  BM_217070_SoftWhite: 13513,
  BM_217110_TomatoGalette: 13514,
  BM_217120_FireDance: 13515,
  BM_217130_AdobeOrange: 13516,
  BM_217140_PassionFruit: 13517,
  BM_217150_PearlyPink: 13518,
  BM_217160_RoseReflection: 13519,
  BM_217170_PinkSwirl: 13520,
  BM_217210_CopperClay: 13521,
  BM_217220_MarsRed: 13522,
  BM_217230_VintageRedware: 13523,
  BM_217240_RaspberryParfait: 13524,
  BM_217250_BouquetRose: 13525,
  BM_217260_PinkHibiscus: 13526,
  BM_217270_SpringBlossom: 13527,
  BM_217310_EarthlyRusset: 13528,
  BM_217320_TawnyRose: 13529,
  BM_217330_SalmonStream: 13530,
  BM_217340_AntiqueRose: 13531,
  BM_217350_CoralDust: 13532,
  BM_217360_JustPeachy: 13533,
  BM_217370_GentleButterfly: 13534,
  BM_217410_ToastedChestnut: 13535,
  BM_217420_Cinnamon: 13536,
  BM_217430_SedonaClay: 13537,
  BM_217440_DustyMauve: 13538,
  BM_217450_EraserPink: 13539,
  BM_217460_DreamWhip: 13540,
  BM_217470_CreamPuff: 13541,
  BM_217510_AztecBrick: 13542,
  BM_217520_PilgrimageFoliage: 13543,
  BM_217530_Rust: 13544,
  BM_217540_AdobeDust: 13545,
  BM_217550_PeachBlossom: 13546,
  BM_217560_LightSalmon: 13547,
  BM_217570_PeachParfait: 13548,
  BM_218_BeachHaven: 13549,
  BM_219_CoronadoCream: 13550,
  BM_22_PeachCooler: 13551,
  BM_220_YellowBisque: 13552,
  BM_221_GoldenGarden: 13553,
  BM_222_MustardSeed: 13554,
  BM_223_ElSerenoGold: 13555,
  BM_224_GrecianGold: 13556,
  BM_225_ChatsworthCream: 13557,
  BM_226_TwistedOakPath: 13558,
  BM_227_MarbleCanyon: 13559,
  BM_228_ShakespeareTan: 13560,
  BM_229_GrenadaHillsGold: 13561,
  BM_23_Heirloom: 13562,
  BM_230_PiratesChest: 13563,
  BM_231_AgedBronze: 13564,
  BM_232_WinterWheat: 13565,
  BM_233_CreamFleece: 13566,
  BM_234_CrispKhaki: 13567,
  BM_235_OakRidge: 1968,
  BM_236_GreenTea: 13568,
  BM_237_SilkenMoss: 13569,
  BM_238_UrbanLegend: 13570,
  BM_239_IvoryPorcelain: 13571,
  BM_24_CoralBuff: 13572,
  BM_240_DelawarePutty: 13573,
  BM_241_JonesboroCream: 13574,
  BM_242_LaurelCanyonBeige: 13575,
  BM_243_BaffinIsland: 13576,
  BM_244_StrathmoreManor: 13577,
  BM_245_FreeSpirit: 13578,
  BM_246_WestchesterTan: 13579,
  BM_247_ConsentinoChardonnay: 13580,
  BM_248_MansfieldTan: 13581,
  BM_249_Sombrero: 13582,
  BM_25_VividPeach: 13583,
  BM_250_PorterRidgeTan: 13584,
  BM_251_SevilleTan: 13585,
  BM_252_Olivetone: 13586,
  BM_253_NaturalBeech: 13587,
  BM_254_WovenJacquard: 13588,
  BM_255_HeirloomGold: 13589,
  BM_256_WestwoodTan: 13590,
  BM_257_HoneyOak: 13591,
  BM_258_AcornSquash: 13592,
  BM_259_Brazen: 13593,
  BM_26_CoralGlow: 13594,
  BM_260_SwansMillCream: 13595,
  BM_261_NorfolkCream: 13596,
  BM_262_GoldenHills: 13597,
  BM_263_SpringMorning: 13598,
  BM_264_WanderingHeart: 13599,
  BM_265_Gemstone: 13600,
  BM_266_EgyptianSand: 13601,
  BM_267_Canvas: 13602,
  BM_268_Oatmeal: 13603,
  BM_269_AlmondBisque: 13604,
  BM_27_SanAntonioRose: 13605,
  BM_270_StrawHat: 13606,
  BM_271_BarleyGrass: 13607,
  BM_272_AvantGarde: 13608,
  BM_273_Sandalwood: 13609,
  BM_274_SantoDomingoCream: 13610,
  BM_275_BananaCream: 13611,
  BM_276_CambridgeHeights: 13612,
  BM_277_FreedomTrail: 13613,
  BM_2772_NouveauBlue: 1969,
  BM_278_AngelsTrumpet: 13614,
  BM_279_HollywoodGold: 13615,
  BM_28_RichCoral: 13616,
  BM_280_RenaissanceGold: 13617,
  BM_281_Citronee: 13618,
  BM_282_CountingStars: 13619,
  BM_283_CallaLily: 13620,
  BM_284_Copacabana: 13621,
  BM_285_TreasureTrove: 13622,
  BM_286_LuxuriousGold: 13623,
  BM_287_FrenchQuarterGold: 13624,
  BM_288_NorthStar: 13625,
  BM_289_PaleMoon: 13626,
  BM_29_FruitedPlains: 13627,
  BM_290_FreshButter: 13628,
  BM_291_LagunaYellow: 13629,
  BM_292_Goldfield: 13630,
  BM_293_Showtime: 13631,
  BM_294_GoldenBounty: 13632,
  BM_295_CandlelitDinner: 13633,
  BM_296_GoodVibrations: 13634,
  BM_297_GoldenHoney: 13635,
  BM_298_BroadwayLights: 13636,
  BM_299_Firefly: 13637,
  BM_3_PinkParadise: 13638,
  BM_30_AugustSunrise: 13639,
  BM_300_LuminousDays: 13640,
  BM_301_GlenRidgeGold: 13641,
  BM_302_YouAreMySunshine: 13642,
  BM_303_OldWorldRomance: 13643,
  BM_304_ShootingStar: 13644,
  BM_305_CountryComfort: 13645,
  BM_306_LionHeart: 13646,
  BM_307_CornHusk: 13647,
  BM_308_GoldenVista: 13648,
  BM_309_Ambiance: 13649,
  BM_31_GeorgiaPeach: 13650,
  BM_310_PopcornKernel: 13651,
  BM_311_SquishSquash: 13652,
  BM_312_CrowneHillYellow: 13653,
  BM_313_GoldenGroves: 13654,
  BM_314_ImperialYellow: 13655,
  BM_315_OxfordGold: 13656,
  BM_316_Birdhouse: 13657,
  BM_317_HayStack: 13658,
  BM_318_LittleAngel: 13659,
  BM_319_Dalila: 13660,
  BM_32_CoralRock: 13661,
  BM_320_Amarillo: 13662,
  BM_321_VikingYellow: 13663,
  BM_322_Abstracta: 13664,
  BM_323_LightningBolt: 13665,
  BM_324_LittleDipper: 13666,
  BM_325_VernazzaYellow: 13667,
  BM_326_GoodMorningSunshine: 13668,
  BM_327_PureJoy: 13669,
  BM_328_Sunbeam: 13670,
  BM_329_GoldenOrchards: 13671,
  BM_33_GoldenGate: 13672,
  BM_330_PalmCoastPale: 13673,
  BM_331_LemonSouffle: 13674,
  BM_332_BananAppeal: 13675,
  BM_333_PineappleGrove: 13676,
  BM_334_Limon: 13677,
  BM_335_DelightfulYellow: 13678,
  BM_336_BoldYellow: 13679,
  BM_337_OldStrawHat: 13680,
  BM_338_EarlyDawn: 13681,
  BM_339_LemonGrass: 13682,
  BM_34_SpicedPumpkin: 13683,
  BM_340_LightningBug: 13684,
  BM_341_FiestaYellow: 13685,
  BM_342_Glimmer: 13686,
  BM_343_Sunrays: 13687,
  BM_344_HalifaxCream: 13688,
  BM_345_WinterSunshine: 13689,
  BM_346_YellowLilies: 13690,
  BM_347_SunshineOnTheBay: 13691,
  BM_348_InnerGlow: 13692,
  BM_349_YellowBrickRoad: 13693,
  BM_35_BakedClay: 13694,
  BM_350_SunValley: 13695,
  BM_351_FallingStar: 13696,
  BM_352_SunCity: 13697,
  BM_353_YellowRoses: 13698,
  BM_354_Cheerful: 13699,
  BM_355_MajesticYellow: 13700,
  BM_356_SunnyAfternoon: 13701,
  BM_357_YellowHibiscus: 13702,
  BM_358_FunInTheSun: 13703,
  BM_359_LightningStorm: 13704,
  BM_36_OrchidPink: 13705,
  BM_360_SanFernandoSunshine: 13706,
  BM_361_NoNonsense: 13707,
  BM_362_StElmosFire: 13708,
  BM_363_LemonGrove: 13709,
  BM_364_CitrusBurst: 13710,
  BM_365_LightOfTheMoon: 13711,
  BM_366_SanPedroMorning: 13712,
  BM_367_SunnySideUp: 13713,
  BM_368_CityScapeMorning: 13714,
  BM_369_MulhollandYellow: 13715,
  BM_37_RoseBlush: 13716,
  BM_370_YellowTone: 13717,
  BM_371_BrightGold: 13718,
  BM_372_VanillaCookie: 13719,
  BM_373_YellowIris: 13720,
  BM_374_Luminaire: 13721,
  BM_375_YellowClover: 13722,
  BM_376_MotherEarth: 13723,
  BM_377_MustardField: 13724,
  BM_378_GibsonGold: 13725,
  BM_379_HawthorneGreen: 13726,
  BM_38_Rosetta: 13727,
  BM_380_StanhopeYellow: 13728,
  BM_381_Sesame: 13729,
  BM_382_ArtichokeHearts: 13730,
  BM_383_MeadowView: 13731,
  BM_384_TurningLeaf: 13732,
  BM_385_SavannahMoss: 13733,
  BM_386_GinsengRoot: 13734,
  BM_387_JasperOpal: 13735,
  BM_388_CypressGrove: 13736,
  BM_389_SweetPear: 13737,
  BM_39_SharonRose: 13738,
  BM_390_GoldenDelicious: 13739,
  BM_391_SweetVibrations: 13740,
  BM_392_OliveTree: 13741,
  BM_393_LimeRicky: 13742,
  BM_394_LemonTwist: 13743,
  BM_395_ApplesAndPears: 13744,
  BM_396_ChicLime: 13745,
  BM_397_Chamomile: 13746,
  BM_398_FlowerPower: 13747,
  BM_399_ExoticLime: 13748,
  BM_4_PinkPolkaDot: 13749,
  BM_40_PeachesNCream: 13750,
  BM_400_PolarLights: 13751,
  BM_401_SourApple: 13752,
  BM_402_Neon: 13753,
  BM_403_CandyGreen: 13754,
  BM_404_ElectricSlide: 13755,
  BM_405_Perennial: 13756,
  BM_406_HuntingtonGreen: 13757,
  BM_407_LimeAccent: 13758,
  BM_408_LightGreen: 13759,
  BM_409_AppleFroth: 13760,
  BM_41_SpoonfulOfSugar: 13761,
  BM_410_CitronCocktail: 13762,
  BM_411_CelticFolklore: 13763,
  BM_412_SpringhillGreen: 13764,
  BM_413_BloomingGrove: 13765,
  BM_414_WispyGreen: 13766,
  BM_415_RiverdaleGreen: 13767,
  BM_416_TastyApple: 13768,
  BM_417_FeelTheEnergy: 13769,
  BM_418_WillowSpringsGreen: 13770,
  BM_419_MalachyGreen: 13771,
  BM_42_BurntRusset: 13772,
  BM_420_AppleLimeCocktail: 13773,
  BM_421_GreenCoveSprings: 13774,
  BM_422_NewRetro: 13775,
  BM_423_PineSprigs: 13776,
  BM_424_ScenicView: 13777,
  BM_425_LimeTwist: 13778,
  BM_426_FreshGrass: 13779,
  BM_427_NapaVineyards: 13780,
  BM_428_Cucumber: 13781,
  BM_429_GarlandGreen: 13782,
  BM_43_EastLakeRose: 13783,
  BM_430_Landscape: 13784,
  BM_431_CentralPark: 13785,
  BM_432_GrenadaGreen: 13786,
  BM_433_ForestHillsGreen: 13787,
  BM_434_HerbGarden: 13788,
  BM_435_FreshDew: 13789,
  BM_436_MintChocolateChip: 13790,
  BM_437_PineBarrens: 13791,
  BM_438_SpringValley: 13792,
  BM_439_PalisadesPark: 13793,
  BM_44_FrostedRose: 13794,
  BM_440_LandOfLiberty: 13795,
  BM_441_AlligatorAlley: 13796,
  BM_442_JackAndTheBeanstalk: 13797,
  BM_443_DesertGreen: 13798,
  BM_444_CedarGrove: 13799,
  BM_445_GreenwichVillage: 13800,
  BM_446_Pinelands: 13801,
  BM_447_HolidayWreath: 13802,
  BM_448_DakotaShadow: 13803,
  BM_449_SereneBreeze: 13804,
  BM_45_Romantica: 13805,
  BM_450_NobHillSage: 13806,
  BM_451_PineForest: 13807,
  BM_452_NorwaySpruce: 13808,
  BM_453_AdirondackGreen: 13809,
  BM_454_CedarPath: 13810,
  BM_455_SweetBasil: 13811,
  BM_456_NorthShoreGreen: 13812,
  BM_457_IcyMorn: 13813,
  BM_458_SageTint: 13814,
  BM_459_WoodlandGreen: 13815,
  BM_46_SalmonMousse: 13816,
  BM_460_HerbBouquet: 13817,
  BM_461_Rosepine: 13818,
  BM_462_VintageVogue: 13819,
  BM_463_WoodlandWhite: 13820,
  BM_464_ThorntonSage: 13821,
  BM_465_AntiqueJade: 13822,
  BM_466_GardenPath: 13823,
  BM_467_HighPark: 13824,
  BM_468_CambridgeGreen: 13825,
  BM_469_Backwoods: 13826,
  BM_47_SavannahClay: 13827,
  BM_470_ParFour: 13828,
  BM_471_TeaLight: 13829,
  BM_472_AganthusGreen: 13830,
  BM_473_WeekendGetaway: 13831,
  BM_474_Mistletoe: 13832,
  BM_475_GalapagosGreen: 13833,
  BM_476_JadeRomanesque: 1979,
  BM_477_StolenMoments: 13834,
  BM_478_SweetCaroline: 13835,
  BM_479_AppleBlossom: 13836,
  BM_48_SouthwestPottery: 13837,
  BM_480_LilyPad: 13838,
  BM_481_DillWeed: 13839,
  BM_482_MistedFern: 13840,
  BM_483_HomeOnTheRange: 13841,
  BM_484_GreenFrappe: 13842,
  BM_485_MosaicGlass: 13843,
  BM_486_SpringMeadow: 13844,
  BM_487_LibertyPark: 13845,
  BM_488_MountainLane: 13846,
  BM_489_OakGrove: 13847,
  BM_49_TwilightDreams: 13848,
  BM_490_PineBrook: 13849,
  BM_491_SpringviewGreen: 13850,
  BM_492_DuneGrass: 13851,
  BM_493_HarborTown: 13852,
  BM_494_LewivilleGreen: 13853,
  BM_495_HillsideGreen: 13854,
  BM_496_ChoppedDill: 13855,
  BM_497_ShadyLane: 13856,
  BM_498_GladeGreen: 13857,
  BM_499_GlazedGreen: 13858,
  BM_5_TucsonCoral: 13859,
  BM_50_PinkMoire: 13860,
  BM_500_MaidenhairFern: 13861,
  BM_501_Mesquite: 13862,
  BM_502_Grasslands: 13863,
  BM_503_FraserFir: 13864,
  BM_504_NaturesReflection: 13865,
  BM_505_HintOfMint: 1970,
  BM_506_SilverSage: 13866,
  BM_507_GrecianGreen: 13867,
  BM_508_TreeMoss: 13868,
  BM_509_CypressGreen: 13869,
  BM_51_Precocious: 13870,
  BM_510_SpringfieldSage: 13871,
  BM_511_PineGrove: 13872,
  BM_512_LightBreeze: 13873,
  BM_513_Limestone: 13874,
  BM_514_FloweringHerbs: 13875,
  BM_515_BabyTurtle: 13876,
  BM_516_IvyLeague: 13877,
  BM_517_Greenbrook: 13878,
  BM_518_SterlingForest: 13879,
  BM_519_Olivetint: 13880,
  BM_52_ConchShell: 13881,
  BM_520_SpringBud: 13882,
  BM_521_NantucketBreeze: 13883,
  BM_522_DriedParsley: 13884,
  BM_523_IvyLane: 13885,
  BM_524_HikingPath: 13886,
  BM_525_SavannahShade: 13887,
  BM_526_Chameleon: 13888,
  BM_527_WarrenAcres: 13889,
  BM_528_FolkArt: 13890,
  BM_529_SweetDaphne: 13891,
  BM_53_CrazyForYou: 13892,
  BM_530_MedievalTimes: 13893,
  BM_531_PonderosaPine: 13894,
  BM_532_WindingVines: 13895,
  BM_533_CalmingAloe: 13896,
  BM_534_CrispGreen: 13897,
  BM_535_SoothingGreen: 13898,
  BM_536_SiennaLaurel: 13899,
  BM_537_ShadesOfSpring: 13900,
  BM_538_ViennaGreen: 13901,
  BM_539_SycamoreTree: 13902,
  BM_54_FarmersMarket: 13903,
  BM_540_CountryGreen: 13904,
  BM_541_VerandaView: 13905,
  BM_542_CornStalk: 13906,
  BM_543_WoodlandHillsGreen: 13907,
  BM_544_Kiwi: 13908,
  BM_545_BuckinghamGardens: 13909,
  BM_546_CourtyardGreen: 13910,
  BM_547_MintJulep: 13911,
  BM_548_PastelGreen: 13912,
  BM_549_Honeydew: 13913,
  BM_55_PumpkinPatch: 13914,
  BM_550_ParadiseHillsGreen: 13915,
  BM_551_ExoticBloom: 13916,
  BM_552_PleasantGrove: 13917,
  BM_553_RichmondGreen: 13918,
  BM_554_EasterHunt: 13919,
  BM_555_OReillyGreen: 13920,
  BM_556_SoundsOfNature: 13921,
  BM_557_LeprechaunGreen: 13922,
  BM_558_KillalaGreen: 13923,
  BM_559_ParadiseValley: 13924,
  BM_56_MontanaAgate: 13925,
  BM_560_SullivanGreen: 13926,
  BM_561_Pistachio: 13927,
  BM_562_CucumberSalad: 13928,
  BM_563_DouglasFern: 13929,
  BM_564_Gumdrop: 13930,
  BM_565_AuroraBorealis: 13931,
  BM_566_BunkerHillGreen: 13932,
  BM_567_Balsam: 13933,
  BM_568_ParksideDunes: 13934,
  BM_569_NottinghamGreen: 13935,
  BM_57_OrangeSorbet: 13936,
  BM_570_GrassyMeadows: 13937,
  BM_571_LotusFlower: 13938,
  BM_572_BranchBrookGreen: 13939,
  BM_573_FourLeafClover: 13940,
  BM_574_OnceUponATime: 13941,
  BM_575_TropicalParadise: 13942,
  BM_576_BahamaWaters: 13943,
  BM_577_MermaidsTale: 13944,
  BM_578_FloridaKeys: 13945,
  BM_579_CliffsidePark: 13946,
  BM_58_PumpkinMousse: 13947,
  BM_580_ArlingtonGreen: 13948,
  BM_581_FloradaleIsle: 13949,
  BM_582_CoolMint: 13950,
  BM_583_Mountainview: 13951,
  BM_584_StJohnsBay: 13952,
  BM_585_LadyLiberty: 13953,
  BM_586_NorthernLights: 13954,
  BM_587_ScotchPlainsGreen: 13955,
  BM_588_LuckOfTheIrish: 13956,
  BM_589_GentleBreeze: 13957,
  BM_59_OrangeCreamsicle: 13958,
  BM_590_Celadon: 13959,
  BM_591_SpringFresh: 13960,
  BM_592_RosamiliaGreen: 13961,
  BM_593_IslandGetaway: 13962,
  BM_594_Peridot: 13963,
  BM_595_DeepJungle: 13964,
  BM_596_SpearmintIce: 13965,
  BM_597_QuartzStone: 13966,
  BM_598_SurfNTurf: 13967,
  BM_599_BrookdaleGardens: 13968,
  BM_6_Picante: 13969,
  BM_60_FreshPeach: 13970,
  BM_600_MediciMalachite: 13971,
  BM_601_JuniperGreen: 13972,
  BM_602_GondolaRide: 13973,
  BM_603_SpringBreeze: 13974,
  BM_604_BiscayneShore: 13975,
  BM_605_CalmingGreen: 13976,
  BM_606_IslandParadise: 13977,
  BM_607_AlbuquerqueTeal: 13978,
  BM_608_ErinGreen: 13979,
  BM_609_LuckyShamrock: 13980,
  BM_61_MyrtleBeach: 13981,
  BM_610_AntiguaAqua: 13982,
  BM_611_SpringtimeGreen: 13983,
  BM_612_HillsOfIreland: 13984,
  BM_613_FreshGreen: 13985,
  BM_614_StPattysDay: 13986,
  BM_615_MayanGreen: 13987,
  BM_616_GardenView: 13988,
  BM_617_LidoGreen: 13989,
  BM_618_RobinsNest: 13990,
  BM_619_CopperPatina: 13991,
  BM_62_VegetablePatch: 13992,
  BM_620_KeyLargoGreen: 13993,
  BM_621_Eucalyptus: 13994,
  BM_622_AlpineTrail: 13995,
  BM_623_DeepSea: 13996,
  BM_624_BathSalts: 13997,
  BM_625_FeatherGreen: 13998,
  BM_626_EtchedGlass: 13999,
  BM_627_SpringBreak: 14000,
  BM_628_WinchesterSage: 14001,
  BM_629_WeepingWillow: 14002,
  BM_63_PenniesFromHeaven: 14003,
  BM_630_MarthasVineyard: 1971,
  BM_631_AberdeenGreen: 14004,
  BM_632_BridalBouquet: 14005,
  BM_633_AppalachianTrail: 14006,
  BM_634_ForestValleyGreen: 14007,
  BM_635_ParsleySnips: 14008,
  BM_636_WillowGrove: 14009,
  BM_637_GothicGreen: 14010,
  BM_638_PureEssence: 14011,
  BM_639_LetItRain: 14012,
  BM_64_NautilusShell: 14013,
  BM_640_Dreamcatcher: 14014,
  BM_641_Everglades: 14015,
  BM_642_PalmTrees: 14016,
  BM_643_SteamedSpinach: 14017,
  BM_644_GardenCucumber: 14018,
  BM_645_OuterSphere: 14019,
  BM_646_HannityGreen: 14020,
  BM_647_FunNGames: 14021,
  BM_648_KokopelliTeal: 14022,
  BM_649_CaptivatingTeal: 14023,
  BM_65_Rosebud: 14024,
  BM_650_HighlandsGreen: 14025,
  BM_651_BrazilianRainforest: 14026,
  BM_652_CaribbeanBreeze: 14027,
  BM_653_Seagrove: 14028,
  BM_654_HarborSideTeal: 14029,
  BM_655_CoastalParadise: 14030,
  BM_656_MiamiTeal: 14031,
  BM_657_SeaOfGreen: 14032,
  BM_658_NeptuneGreen: 14033,
  BM_659_WaterDrops: 14034,
  BM_66_ForeverYoung: 14035,
  BM_660_Oceanfront: 14036,
  BM_661_CaribbeanCool: 14037,
  BM_662_MexicaliTurquoise: 14038,
  BM_663_TealTone: 14039,
  BM_664_Poseidon: 14040,
  BM_665_GulfShores: 14041,
  BM_666_AtSea: 14042,
  BM_667_MaritimeBlue: 14043,
  BM_668_LakeVictoria: 14044,
  BM_669_OceanicTeal: 14045,
  BM_67_DelRayPeach: 14046,
  BM_670_GulfStream: 14047,
  BM_671_SoftSpruce: 14048,
  BM_672_IntercoastalGreen: 14049,
  BM_673_IcedGreen: 14050,
  BM_674_SpringSky: 14051,
  BM_675_Thunderbird: 14052,
  BM_676_SpiritInTheSky: 14053,
  BM_677_AzureWater: 14054,
  BM_678_PacificRim: 14055,
  BM_679_OlympusGreen: 14056,
  BM_68_SucculentPeach: 14057,
  BM_680_OpalEssence: 14058,
  BM_681_GreenWave: 14059,
  BM_682_WarmSprings: 14060,
  BM_683_StLuciaTeal: 14061,
  BM_684_Shenandoah: 14062,
  BM_685_Verdigris: 14063,
  BM_686_CrispRomaine: 14064,
  BM_687_AnnapolisGreen: 14065,
  BM_688_SeacliffHeights: 14066,
  BM_689_RhineRiver: 14067,
  BM_69_GoldenCherry: 14068,
  BM_690_GrenadaVilla: 14069,
  BM_691_DartsmouthGreen: 14070,
  BM_692_JackPine: 14071,
  BM_693_UnderTheSea: 14072,
  BM_694_ColonyGreen: 14073,
  BM_695_TurquoiseMist: 14074,
  BM_696_PleasantValley: 14075,
  BM_697_ScenicDrive: 14076,
  BM_698_GrenadierPond: 14077,
  BM_699_GardenOasis: 14078,
  BM_7_Pinata: 14079,
  BM_70_Topaz: 55,
  BM_700_EnchantedForest: 14080,
  BM_701_SweptAway: 14081,
  BM_702_Bali: 14082,
  BM_703_CatalinaBlue: 14083,
  BM_704_DelMarBlue: 14084,
  BM_705_SiouxFalls: 14085,
  BM_706_CedarMountains: 1980,
  BM_707_CalicoBlue: 14086,
  BM_708_WhiteRain: 14087,
  BM_709_HeavenlyBlue: 14088,
  BM_71_CameoRose: 14089,
  BM_710_KensingtonGreen: 14090,
  BM_711_BocaRatonBlue: 14091,
  BM_712_FortPierceGreen: 14092,
  BM_713_PolishedSlate: 14093,
  BM_714_HiddenFalls: 14094,
  BM_715_InYourEyes: 14095,
  BM_716_FantasyBlue: 14096,
  BM_717_Paradiso: 14097,
  BM_718_OceanCityBlue: 14098,
  BM_719_Hemlock: 14099,
  BM_72_SanibelPeach: 14100,
  BM_720_BellaBlue: 14101,
  BM_721_VanderbergBlue: 14102,
  BM_722_DolphinsCove: 14103,
  BM_723_SpringRain: 14104,
  BM_724_PeacockFeathers: 14105,
  BM_725_SeasideResort: 14106,
  BM_726_RendezvousBay: 14107,
  BM_727_CalypsoBlue: 14108,
  BM_728_BermudaTurquoise: 14109,
  BM_729_JackFrost: 14110,
  BM_73_AmberWinds: 14111,
  BM_730_SanClementeTeal: 14112,
  BM_731_SurfCity: 14113,
  BM_732_BurbankBlue: 14114,
  BM_733_PalmCoastTeal: 14115,
  BM_734_TropicalTeal: 14116,
  BM_735_DeepSeaGreen: 14117,
  BM_736_BlueDiamond: 14118,
  BM_737_SonomaSkies: 14119,
  BM_738_Clearlake: 14120,
  BM_739_UnTealWeMeetAgain: 14121,
  BM_74_SausalitoSunset: 14122,
  BM_740_HarborSideBlue: 14123,
  BM_741_SanJoseBlue: 14124,
  BM_742_LargoTeal: 14125,
  BM_743_PicturePerfect: 14126,
  BM_744_Indigo: 14127,
  BM_745_BlueRapids: 14128,
  BM_746_HeavenlyPeace: 14129,
  BM_747_BayvilleBlue: 14130,
  BM_748_BlueToile: 14131,
  BM_749_BainbridgeBlue: 14132,
  BM_75_FlamingoOrange: 14133,
  BM_750_Seabrook: 14134,
  BM_751_SeaIsle: 14135,
  BM_752_HowBlueAmI: 14136,
  BM_753_SantaClara: 14137,
  BM_754_WilmingtonSpruce: 14138,
  BM_755_SalzburgBlue: 14139,
  BM_756_VarsityBlues: 14140,
  BM_757_CaliforniaBreeze: 14141,
  BM_758_RhythmAndBlues: 14142,
  BM_759_MadisonAvenue: 14143,
  BM_76_CorlsbudCanyon: 14144,
  BM_760_BaltimoreSky: 14145,
  BM_761_MeridianBlue: 14146,
  BM_762_PacificPalisades: 14147,
  BM_763_CoatOfArms: 14148,
  BM_764_CrystalSprings: 14149,
  BM_765_Skyscraper: 14150,
  BM_766_DelanoWaters: 14151,
  BM_767_GracefulSea: 14152,
  BM_768_AtlantisBlue: 14153,
  BM_769_DreamICanFly: 14154,
  BM_77_FieryOpal: 14155,
  BM_770_Americana: 14156,
  BM_771_BlueAllure: 14157,
  BM_772_HawaiianBreeze: 14158,
  BM_773_AthenianBlue: 14159,
  BM_774_IveGotTheBlues: 14160,
  BM_775_Poolside: 14161,
  BM_776_SantaMonicaBlue: 14162,
  BM_777_SummerNights: 14163,
  BM_778_SkylarkSong: 14164,
  BM_779_FairviewBlue: 14165,
  BM_78_PeachMelba: 14166,
  BM_780_CrispMorningAir: 14167,
  BM_781_StLuciaSkies: 14168,
  BM_782_BlueBelleIsland: 14169,
  BM_783_LakeTahoe: 14170,
  BM_784_BlueMacaw: 14171,
  BM_785_MorningGlory: 14172,
  BM_786_HighlandBreeze: 14173,
  BM_787_GrandmasSweater: 14174,
  BM_788_Aquarius: 14175,
  BM_789_SeaToShiningSea: 14176,
  BM_79_DaytonaPeach: 14177,
  BM_790_BayberryBlue: 14178,
  BM_791_PaddingtonBlue: 14179,
  BM_792_MysticalBlue: 14180,
  BM_793_WatercolorBlue: 14181,
  BM_794_ParadiseView: 14182,
  BM_795_FadedDenim: 14183,
  BM_796_NovaScotiaBlue: 14184,
  BM_797_AthensBlue: 14185,
  BM_798_BlueSuedeShoes: 14186,
  BM_799_MediterraneanBreeze: 14187,
  BM_8_PalePinkSatin: 14188,
  BM_80_Daylily: 14189,
  BM_800_PalatialSkies: 14190,
  BM_801_BlueBayou: 14191,
  BM_802_SanFranciscoBay: 14192,
  BM_803_LazySunday: 14193,
  BM_804_ChicagoBlues: 14194,
  BM_805_NewYorkStateOfMind: 14195,
  BM_806_BreathOfFreshAir: 14196,
  BM_807_SoftSky: 14197,
  BM_808_SapphireIce: 14198,
  BM_809_SoftJazz: 14199,
  BM_81_IntensePeach: 14200,
  BM_810_BlueDragon: 14201,
  BM_811_OldGlory: 14202,
  BM_812_BlueberryHill: 14203,
  BM_813_SweetBluette: 14204,
  BM_814_JetStream: 14205,
  BM_815_SwissBlue: 14206,
  BM_816_AquaMarina: 14207,
  BM_817_BrazilianBlue: 14208,
  BM_818_Watertown: 14209,
  BM_819_SouthernBelle: 14210,
  BM_82_SunsetBoulevard: 14211,
  BM_820_MistyBlue: 56,
  BM_821_BlueIce: 14212,
  BM_822_RivieraAzure: 14213,
  BM_823_SteelBlue: 14214,
  BM_824_YinYang: 14215,
  BM_825_BlueNova: 1972,
  BM_826_Stunning: 14216,
  BM_827_LakePlacid: 14217,
  BM_828_Airway: 14218,
  BM_829_Sunrise: 14219,
  BM_83_TangerineFusion: 14220,
  BM_830_HarlequinBlue: 14221,
  BM_831_StratfordBlue: 14222,
  BM_832_BlueHeron: 14223,
  BM_833_EveningSky: 14224,
  BM_834_BrightAndEarly: 14225,
  BM_835_GrandRapids: 57,
  BM_836_SeaView: 14226,
  BM_837_SheerRomance: 14227,
  BM_838_DenimWash: 14228,
  BM_839_OldBlueJeans: 14229,
  BM_84_FiestaOrange: 14230,
  BM_840_KensingtonBlue: 14231,
  BM_841_SnowAngel: 14232,
  BM_842_GreenCast: 14233,
  BM_843_TaffetaGreen: 14234,
  BM_844_AloeVera: 14235,
  BM_845_EmeraldVapor: 14236,
  BM_846_ComeSailAway: 14237,
  BM_847_SweetDreams: 14238,
  BM_848_LakeshoreGreen: 14239,
  BM_849_CarriedAway: 14240,
  BM_85_AmeliaBlush: 14241,
  BM_850_Reflection: 14242,
  BM_851_TintOfMint: 14243,
  BM_852_AppalachianGreen: 14244,
  BM_853_GreenEssence: 14245,
  BM_854_SleepingAngel: 14246,
  BM_855_CloudCover: 14247,
  BM_856_SilverSatin: 14248,
  BM_857_SheepsWool: 14249,
  BM_858_Athena: 14250,
  BM_859_Collingwood: 14251,
  BM_86_ApricotTint: 14252,
  BM_860_Apparition: 14253,
  BM_861_Shale: 14254,
  BM_862_CascadeMountains: 14255,
  BM_863_PearlGray: 14256,
  BM_864_Oystershell: 14257,
  BM_865_Stonewashed: 14258,
  BM_866_WinterIce: 14259,
  BM_867_GlacierLake: 14260,
  BM_868_MountainMist: 14261,
  BM_869_OxfordWhite: 14262,
  BM_87_JunoPeach: 14263,
  BM_870_Mountainscape: 14264,
  BM_871_PearlRiver: 14265,
  BM_872_WhiteChristmas: 14266,
  BM_873_BabysBreath: 14267,
  BM_874_Fanfare: 14268,
  BM_875_BlueVeil: 14269,
  BM_876_Alabaster: 14270,
  BM_877_SandDollar: 14271,
  BM_878_MauveHint: 14272,
  BM_879_Opulence: 14273,
  BM_88_SummerPeachTree: 14274,
  BM_880_WhiteZinfandel: 14275,
  BM_881_PinkEssence: 14276,
  BM_882_FeatheredViolet: 14277,
  BM_883_ShellPink: 14278,
  BM_884_HintOfPink: 14279,
  BM_885_KeyPearl: 14280,
  BM_886_BlanchedCoral: 14281,
  BM_887_PinkCloud: 14282,
  BM_888_ValentineMemories: 14283,
  BM_889_PacificGrovePink: 14284,
  BM_89_TootyFruity: 14285,
  BM_890_PinkDamask: 14286,
  BM_891_Opal: 14287,
  BM_892_WarmBlush: 14288,
  BM_893_Ambrosia: 14289,
  BM_894_SheerPink: 14290,
  BM_895_AphroditePink: 14291,
  BM_896_LoveAlways: 14292,
  BM_897_Butterfield: 14293,
  BM_898_CountryWhite: 14294,
  BM_899_SecludedBeach: 14295,
  BM_9_BlushingBrilliance: 14296,
  BM_90_ButterflyWings: 14297,
  BM_900_FloridaBeaches: 14298,
  BM_901_MysticalPowers: 14299,
  BM_902_ButterflyKisses: 14300,
  BM_903_PiratesCoveBeach: 14301,
  BM_904_WhiteBlush: 14302,
  BM_905_LilyOfTheValley: 14303,
  BM_906_WhiteMountains: 14304,
  BM_907_EveningWhite: 14305,
  BM_908_PelicanBeach: 14306,
  BM_909_AntiqueWhite: 14307,
  BM_91_TangerineMelt: 14308,
  BM_910_CremeCaramel: 14309,
  BM_911_ParadiseBeach: 14310,
  BM_912_LinenWhite: 14311,
  BM_913_WindsorCream: 14312,
  BM_914_DevonCream: 14313,
  BM_915_CameoWhite: 14314,
  BM_916_CookieDough: 14315,
  BM_917_VirginiaBeach: 14316,
  BM_918_WhiteRock: 14317,
  BM_919_SoftBiscuit: 14318,
  BM_92_ArizonaPeach: 14319,
  BM_920_HoneyHarbor: 14320,
  BM_921_SanDiegoCream: 14321,
  BM_922_AntiqueLace: 14322,
  BM_923_FrenchVanilla: 14323,
  BM_924_SanMateoBeaches: 14324,
  BM_925_IvoryWhite: 14325,
  BM_926_Seashell: 14326,
  BM_927_WhiteSwan: 14327,
  BM_928_Featherbed: 14328,
  BM_929_AngelsGate: 14329,
  BM_93_WinterMelon: 14330,
  BM_930_Cashmere: 14331,
  BM_931_RoyalLinen: 14332,
  BM_932_LemonChiffon: 14333,
  BM_933_BlossomTint: 14334,
  BM_934_LightAsAFeather: 14335,
  BM_935_AncientIvory: 14336,
  BM_936_MeadowMist: 208,
  BM_937_RockCandy: 14337,
  BM_938_CelerySalt: 14338,
  BM_939_RoyalSilk: 14339,
  BM_94_PeachStone: 14340,
  BM_940_AncientOak: 14341,
  BM_941_Seaspray: 14342,
  BM_942_MarbleWhite: 14343,
  BM_943_SpanishWhite: 14344,
  BM_944_AlbanyWhite: 14345,
  BM_945_PebbleRock: 14346,
  BM_946_SandyBeaches: 14347,
  BM_947_NavajoWhite: 14348,
  BM_948_SandyShores: 14349,
  BM_949_SparklingWine: 14350,
  BM_95_Sunfish: 14351,
  BM_950_NaturalWicker: 14352,
  BM_951_PaleAlmond: 14353,
  BM_952_CaymanIslands: 14354,
  BM_953_FeatherDown: 14355,
  BM_954_SpringInAspen: 14356,
  BM_955_BerberWhite: 14357,
  BM_956_PalaceWhite: 14358,
  BM_957_Papaya: 14359,
  BM_958_OceanBeach: 14360,
  BM_959_AntiqueParchment: 14361,
  BM_96_SoftSalmon: 14362,
  BM_960_DoveWing: 14363,
  BM_961_SeaPearl: 218,
  BM_962_GrayMist: 14364,
  BM_963_MaritimeWhite: 14365,
  BM_964_WhiteSand: 14366,
  BM_965_TemporalSpirit: 14367,
  BM_966_NaturalLinen: 14368,
  BM_967_CloudWhite: 14369,
  BM_968_DuneWhite: 14370,
  BM_969_SoftChamois: 14371,
  BM_97_HugsKisses: 14372,
  BM_970_WhiteDown: 14373,
  BM_971_OlympicMountains: 14374,
  BM_972_AlaskanSkies: 14375,
  BM_973_IceFormations: 14376,
  BM_974_MuskokaTrail: 14377,
  BM_975_TapestryBeige: 14378,
  BM_976_CoastalFog: 1973,
  BM_977_BrandonBeige: 14379,
  BM_978_RaccoonHollow: 14380,
  BM_979_Stampede: 231,
  BM_98_BryceCanyon: 14381,
  BM_980_WoodcliffLake: 1974,
  BM_981_WindsBreath: 14382,
  BM_982_CedarKey: 14383,
  BM_983_SmokeyTaupe: 14384,
  BM_984_StoneHearth: 10912,
  BM_985_IndianRiver: 14385,
  BM_986_SmokyAsh: 14386,
  BM_987_Buckhorn: 14387,
  BM_988_FrostedToffee: 14388,
  BM_989_AlphanoBeige: 14389,
  BM_99_CandleLight: 14390,
  BM_990_HampshireTaupe: 14391,
  BM_991_GregeAvenue: 14392,
  BM_992_TiconderogaTaupe: 14393,
  BM_993_Beachcomber: 14394,
  BM_994_FallenTimber: 14395,
  BM_995_MochaCream: 14396,
  BM_996_AshenTan: 14397,
  BM_997_BajaDunes: 14398,
  BM_998_CabotTrail: 1975,
  BM_999_RusticTaupe: 14399,
  BM_AF10_Gardenia: 14400,
  BM_AF100_Pashmina: 14401,
  BM_AF105_ElkHorn: 14402,
  BM_AF110_CorianderSeed: 14403,
  BM_AF115_Lodge: 14404,
  BM_AF120_Tamarind: 14405,
  BM_AF125_Morrel: 14406,
  BM_AF130_Truffle: 14407,
  BM_AF135_Interlude: 14408,
  BM_AF140_Pensive: 14409,
  BM_AF145_Kangaroo: 14410,
  BM_AF15_Steam: 14411,
  BM_AF150_Cotswold: 14412,
  BM_AF155_Weimaraner: 14413,
  BM_AF160_Carob: 14414,
  BM_AF165_Kona: 14415,
  BM_AF170_FrenchPress: 14416,
  BM_AF175_Barista: 14417,
  BM_AF180_Wenge: 14418,
  BM_AF185_VenetianPortico: 14419,
  BM_AF190_Boudoir: 14420,
  BM_AF195_TerraBella: 14421,
  BM_AF20_Mascarpone: 14422,
  BM_AF200_Lingerie: 14423,
  BM_AF205_Serendipity: 14424,
  BM_AF210_MilkAndHoney: 14425,
  BM_AF215_Italianate: 14426,
  BM_AF220_Masada: 14427,
  BM_AF225_Firenze: 14428,
  BM_AF230_ButteredYam: 14429,
  BM_AF235_WarmedCognac: 14430,
  BM_AF240_Satchel: 14431,
  BM_AF245_Ipanema: 14432,
  BM_AF25_PaperMache: 232,
  BM_AF250_HeadOverHeels: 14433,
  BM_AF255_Fondant: 14434,
  BM_AF260_Proposal: 14435,
  BM_AF265_Charmeuse: 14436,
  BM_AF270_TeaRoom: 14437,
  BM_AF275_Rustique: 14438,
  BM_AF280_SalsaDancing: 14439,
  BM_AF285_MoroccanSpice: 14440,
  BM_AF290_Caliente: 14441,
  BM_AF295_Pomegranate: 14442,
  BM_AF30_DeepInThought: 14443,
  BM_AF300_DinnerParty: 14444,
  BM_AF305_YlangYlang: 14445,
  BM_AF310_Subtle: 14446,
  BM_AF315_Jicama: 14447,
  BM_AF320_Flawless: 14448,
  BM_AF325_Handmade: 14449,
  BM_AF330_Soleil: 14450,
  BM_AF335_Safari: 14451,
  BM_AF340_OatStraw: 14452,
  BM_AF345_Honeymoon: 14453,
  BM_AF35_Vapor: 14454,
  BM_AF350_Kurkuma: 14455,
  BM_AF355_Etruscan: 14456,
  BM_AF360_FarmFresh: 14457,
  BM_AF365_Amulet: 14458,
  BM_AF370_Citrine: 14459,
  BM_AF375_Rattan: 14460,
  BM_AF380_CoastalPath: 14461,
  BM_AF385_Splendor: 14462,
  BM_AF390_GlacialTill: 14463,
  BM_AF395_Meditation: 14464,
  BM_AF40_Lychee: 14465,
  BM_AF400_Elemental: 14466,
  BM_AF405_Thicket: 14467,
  BM_AF410_Lapland: 14468,
  BM_AF415_Grasshopper: 14469,
  BM_AF420_Agave: 14470,
  BM_AF425_AnjouPear: 14471,
  BM_AF430_Wasabi: 14472,
  BM_AF435_Spa: 14473,
  BM_AF440_UrbanNature: 233,
  BM_AF445_Aventurine: 14474,
  BM_AF45_CollectorsItem: 14475,
  BM_AF450_Seedling: 14476,
  BM_AF455_Croquet: 14477,
  BM_AF460_Jojoba: 14478,
  BM_AF465_WindChime: 14479,
  BM_AF470_Flora: 14480,
  BM_AF475_Lush: 14481,
  BM_AF480_BorealForest: 14482,
  BM_AF485_Crystalline: 14483,
  BM_AF490_Tranquility: 14484,
  BM_AF495_Azores: 14485,
  BM_AF5_Frostine: 14486,
  BM_AF50_Etiquette: 14487,
  BM_AF500_Atmospheric: 14488,
  BM_AF505_BlueEcho: 14489,
  BM_AF510_Dragonfly: 14490,
  BM_AF515_Exhale: 14491,
  BM_AF520_Schooner: 14492,
  BM_AF525_Fiji: 14493,
  BM_AF530_Lucerne: 14494,
  BM_AF535_Serenata: 14495,
  BM_AF540_Constellation: 14496,
  BM_AF545_Solitude: 14497,
  BM_AF55_Sonnet: 59,
  BM_AF550_Amsterdam: 14498,
  BM_AF555_Montpelier: 14499,
  BM_AF560_Flint: 14500,
  BM_AF565_Mysterious: 14501,
  BM_AF570_Coastline: 14502,
  BM_AF575_Instinct: 14503,
  BM_AF580_Luxe: 14504,
  BM_AF585_Wisteria: 14505,
  BM_AF590_Tempest: 14506,
  BM_AF595_Inspired: 14507,
  BM_AF60_PeauDeSoie: 14508,
  BM_AF600_Amorous: 14509,
  BM_AF605_Slip: 14510,
  BM_AF610_Batik: 14511,
  BM_AF615_Violetta: 14512,
  BM_AF620_Sanctuary: 14513,
  BM_AF625_Aplomb: 14514,
  BM_AF630_Kalamata: 14515,
  BM_AF635_BonneNuit: 14516,
  BM_AF640_Kasbah: 14517,
  BM_AF645_Chambourd: 14518,
  BM_AF65_Fossil: 14519,
  BM_AF650_Caponata: 14520,
  BM_AF655_Silhouette: 14521,
  BM_AF660_Granite: 14522,
  BM_AF665_Angelica: 14523,
  BM_AF670_Nightingale: 14524,
  BM_AF675_Fusion: 14525,
  BM_AF680_Wish: 14526,
  BM_AF685_Thunder: 14527,
  BM_AF690_Metropolitan: 14528,
  BM_AF695_Eternity: 14529,
  BM_AF70_Battenberg: 14530,
  BM_AF700_Storm: 60,
  BM_AF705_Cinder: 14531,
  BM_AF710_Secret: 14532,
  BM_AF715_Dolphin: 14533,
  BM_AF720_Sparrow: 14534,
  BM_AF75_Refined: 14535,
  BM_AF80_Jute: 14536,
  BM_AF85_Frappe: 14537,
  BM_AF90_Harmony: 14538,
  BM_AF95_Hush: 14539,
  BM_ATC75_PinotNoir: 61,
  BM_CC10_UltraWhite: 14540,
  BM_CC100_Flurry: 14541,
  BM_CC110_Muslin: 14542,
  BM_CC120_StoneHouse: 14543,
  BM_CC122_BoxcarRed: 14544,
  BM_CC124_HandmadeRug: 14545,
  BM_CC126_CoveredBridge: 14546,
  BM_CC128_RedPointSand: 14547,
  BM_CC130_IvoryWhite: 14548,
  BM_CC140_BarelyBeige: 14549,
  BM_CC150_SandyBrown: 14550,
  BM_CC152_LaurentianRed: 14551,
  BM_CC154_SmokedSalmon: 14552,
  BM_CC156_TofinoSunset: 14553,
  BM_CC158_PinkMoire: 14554,
  BM_CC160_WhiteRock: 14555,
  BM_CC170_HoneyHarbor: 14556,
  BM_CC180_Barley: 14557,
  BM_CC182_FrontenacBrick: 14558,
  BM_CC184_BedAndBreakfast: 14559,
  BM_CC186_Casabella: 14560,
  BM_CC188_ButterRum: 14561,
  BM_CC190_SummerHarvest: 14562,
  BM_CC2_Raphael: 14563,
  BM_CC20_DecoratorsWhite: 14564,
  BM_CC200_Vellum: 14565,
  BM_CC210_Dijon: 14566,
  BM_CC212_DanseDuSoleil: 14567,
  BM_CC214_GoldenHoney: 14568,
  BM_CC216_ButterMilk: 14569,
  BM_CC218_CornSilk: 14570,
  BM_CC220_WheatSheaf: 14571,
  BM_CC230_DelawarePutty: 14572,
  BM_CC240_LateWheat: 14573,
  BM_CC242_MapleFudge: 14574,
  BM_CC244_FrenchToast: 14575,
  BM_CC246_Vichyssoise: 14576,
  BM_CC248_Papaya: 14577,
  BM_CC250_Seaspray: 14578,
  BM_CC260_Buttercream: 14579,
  BM_CC270_BaffinIsland: 14580,
  BM_CC272_SpicedRum: 14581,
  BM_CC274_GingerRoot: 14582,
  BM_CC276_SepiaTan: 14583,
  BM_CC278_KitsilanoBeach: 14584,
  BM_CC280_AlmondBisque: 14585,
  BM_CC290_StrawHat: 14586,
  BM_CC30_OxfordWhite: 14587,
  BM_CC300_Sombrero: 14588,
  BM_CC302_Rawhide: 14589,
  BM_CC304_Sisal: 14590,
  BM_CC306_CableKnit: 14591,
  BM_CC308_ThousandIslands: 14592,
  BM_CC310_DustyRoad: 14593,
  BM_CC32_Radicchio: 14594,
  BM_CC320_BarHarborBeige: 14595,
  BM_CC330_HillsboroughBeige: 14596,
  BM_CC332_NorwesterTan: 14597,
  BM_CC334_GreatPlains: 14598,
  BM_CC336_WildMushroom: 14599,
  BM_CC338_Bluffs: 14600,
  BM_CC34_Jester: 14601,
  BM_CC340_Lambskin: 14602,
  BM_CC350_Sycamore: 14603,
  BM_CC36_Peerage: 14604,
  BM_CC360_PottersClay: 14605,
  BM_CC362_Elk: 14606,
  BM_CC364_DellwoodSand: 14607,
  BM_CC366_Nubuck: 14608,
  BM_CC368_SandpiperBeige: 14609,
  BM_CC370_SeaUrchin: 14610,
  BM_CC38_NightfallSky: 14611,
  BM_CC380_ToffeeCream: 14612,
  BM_CC390_RustyNail: 14613,
  BM_CC392_MuddyYork: 14614,
  BM_CC394_Boulevard: 14615,
  BM_CC396_StoneCastle: 14616,
  BM_CC398_OldMontreal: 14617,
  BM_CC4_Camelot: 14618,
  BM_CC40_CloudWhite: 14619,
  BM_CC400_Sundial: 14620,
  BM_CC410_Boardwalk: 14621,
  BM_CC420_MapleSyrup: 14622,
  BM_CC422_PinkPebble: 14623,
  BM_CC424_OldStone: 14624,
  BM_CC426_BoneChina: 14625,
  BM_CC428_IceBreaker: 14626,
  BM_CC430_Moccasin: 14627,
  BM_CC440_CapilanoBridge: 14628,
  BM_CC450_CaramelApple: 14629,
  BM_CC452_DeerGranite: 14630,
  BM_CC454_Cobblestone: 14631,
  BM_CC456_DufferinTerrace: 14632,
  BM_CC458_MochaCream: 14633,
  BM_CC460_Inukshuk: 14634,
  BM_CC470_RockyRoad: 14635,
  BM_CC480_CabotTrail: 14636,
  BM_CC482_ChocolateFondue: 14637,
  BM_CC484_HotChocolate: 14638,
  BM_CC486_Tiramisu: 14639,
  BM_CC488_Biscotti: 14640,
  BM_CC490_StoneHearth: 14641,
  BM_CC50_WhiteDown: 14642,
  BM_CC500_Ranchwood: 14643,
  BM_CC510_Buckhorn: 14644,
  BM_CC512_Marshlands: 14645,
  BM_CC514_HikingTrail: 14646,
  BM_CC516_Flagstone: 14647,
  BM_CC518_Escarpment: 14648,
  BM_CC520_FlorentinePlaster: 14649,
  BM_CC530_BrandonBeige: 14650,
  BM_CC540_Stampede: 14651,
  BM_CC542_Willow: 14652,
  BM_CC544_Overcoat: 14653,
  BM_CC546_Metropolis: 14654,
  BM_CC548_Asphalt: 14655,
  BM_CC550_OctoberMist: 14656,
  BM_CC560_RaintreeGreen: 14657,
  BM_CC570_ForestFloor: 14658,
  BM_CC572_Barnboard: 14659,
  BM_CC574_Mortar: 14660,
  BM_CC576_NordicGray: 14661,
  BM_CC578_HempSeed: 14662,
  BM_CC580_GlazedGreen: 14663,
  BM_CC590_Grasslands: 14664,
  BM_CC6_MuskokaDusk: 14665,
  BM_CC60_BrandyCream: 14666,
  BM_CC600_MossyOak: 14667,
  BM_CC602_StanleyPark: 14668,
  BM_CC604_Turret: 14669,
  BM_CC606_SpanishOlive: 14670,
  BM_CC608_Dewdrop: 14671,
  BM_CC610_TeaLight: 14672,
  BM_CC62_SundriedTomato: 14673,
  BM_CC620_HighPark: 14674,
  BM_CC630_Backwoods: 14675,
  BM_CC632_BedOfFerns: 14676,
  BM_CC634_HerbesDeProvence: 14677,
  BM_CC636_MountainAir: 14678,
  BM_CC638_Sesame: 14679,
  BM_CC64_Bonaparte: 14680,
  BM_CC640_BlueGrass: 14681,
  BM_CC650_GrenadierPond: 14682,
  BM_CC66_Rapture: 14683,
  BM_CC660_JackPine: 14684,
  BM_CC662_NightOwl: 14685,
  BM_CC664_ProvincialPark: 14686,
  BM_CC666_Bonsai: 14687,
  BM_CC668_MistedFern: 14688,
  BM_CC670_GrayWisp: 14689,
  BM_CC68_LyonsRed: 14690,
  BM_CC680_Raindance: 14691,
  BM_CC690_PiedmontGray: 14692,
  BM_CC692_Topsoil: 14693,
  BM_CC694_Tapenade: 14694,
  BM_CC696_Taiga: 14695,
  BM_CC698_Killarney: 14696,
  BM_CC70_DuneWhite: 14697,
  BM_CC700_SmokyGreen: 14698,
  BM_CC710_MountSaintAnne: 14699,
  BM_CC720_NightTrain: 14700,
  BM_CC722_Vineland: 14701,
  BM_CC724_Homestead: 14702,
  BM_CC726_NatureLover: 14703,
  BM_CC728_MaidOfTheMist: 14704,
  BM_CC730_BlueStream: 14705,
  BM_CC740_LabradorBlue: 14706,
  BM_CC750_WestCoast: 14707,
  BM_CC752_Miramichi: 14708,
  BM_CC754_PolarJade: 14709,
  BM_CC756_Avalon: 14710,
  BM_CC758_ScenicDrive: 14711,
  BM_CC760_NorthernAir: 14712,
  BM_CC770_DenimWash: 14713,
  BM_CC780_KensingtonBlue: 14714,
  BM_CC782_GeorgianBay: 14715,
  BM_CC784_ClearSailing: 14716,
  BM_CC786_SummerDay: 14717,
  BM_CC788_Watercolor: 14718,
  BM_CC790_PolarSky: 14719,
  BM_CC8_FrostedBerry: 14720,
  BM_CC80_GrayMist: 14721,
  BM_CC800_BlueNose: 14722,
  BM_CC810_HudsonBay: 14723,
  BM_CC812_FiveDollarBill: 14724,
  BM_CC814_GlaceBay: 14725,
  BM_CC816_Athabasca: 14726,
  BM_CC818_EarlyMorning: 14727,
  BM_CC820_Airway: 14728,
  BM_CC830_StratfordBlue: 14729,
  BM_CC840_BlueHeron: 14730,
  BM_CC842_Mistral: 14731,
  BM_CC844_WintersEve: 14732,
  BM_CC846_LazySunday: 14733,
  BM_CC848_MineralSprings: 14734,
  BM_CC850_BlueIce: 14735,
  BM_CC860_BlueNova: 14736,
  BM_CC870_JetBlue: 14737,
  BM_CC872_Delphinium: 14738,
  BM_CC874_Mosaic: 14739,
  BM_CC876_MarinersTale: 14740,
  BM_CC878_H2O: 14741,
  BM_CC880_VioletMist: 14742,
  BM_CC890_BluePearl: 14743,
  BM_CC90_NaturalLinen: 14744,
  BM_CC900_BlueGaspe: 14745,
  BM_CC902_Waterdrop: 14746,
  BM_CC904_Cascade: 14747,
  BM_CC906_SummerMist: 14748,
  BM_CC908_FrozenCanal: 14749,
  BM_CC910_Whirlpool: 14750,
  BM_CC92_SpanishRed: 14751,
  BM_CC920_YukonSky: 14752,
  BM_CC930_AmethystShadow: 14753,
  BM_CC932_NorthSea: 14754,
  BM_CC934_InTheTwilight: 14755,
  BM_CC936_Citadel: 14756,
  BM_CC938_IceSculpture: 14757,
  BM_CC94_NorthernFire: 14758,
  BM_CC940_BlueViola: 14759,
  BM_CC950_QueensWreath: 14760,
  BM_CC96_FlowerPot: 14761,
  BM_CC960_FrenchViolet: 14762,
  BM_CC962_BlackberryPunch: 14763,
  BM_CC964_BlueGrotto: 14764,
  BM_CC966_Wizard: 14765,
  BM_CC968_BasicBlue: 14766,
  BM_CC970_HeatherField: 14767,
  BM_CC98_PrairieLily: 14768,
  BM_CC980_PurpleHaze: 14769,
  BM_CC990_SuperNova: 14770,
  BM_CSP10_SohoLoft: 14771,
  BM_CSP100_Cosmopolitan: 14772,
  BM_CSP1000_GardenStone: 14773,
  BM_CSP1005_GoldenDivan: 14774,
  BM_CSP1010_CrumbCakereg: 14775,
  BM_CSP1015_CandleGlow: 14776,
  BM_CSP1020_TrenchCoat: 14777,
  BM_CSP1025_IceMilk: 14778,
  BM_CSP1030_HiddenCove: 14779,
  BM_CSP1035_MakeBelieve: 14780,
  BM_CSP1040_ShiitakeMushroom: 14781,
  BM_CSP1045_WetClay: 14782,
  BM_CSP105_SmokeMirrors: 14783,
  BM_CSP1050_HopeChest: 14784,
  BM_CSP1055_CappuccinoFroth: 14785,
  BM_CSP1060_FromTheArchives: 14786,
  BM_CSP1065_NaturalLeather: 14787,
  BM_CSP1070_WarmSunglow: 14788,
  BM_CSP1075_Byzantine: 14789,
  BM_CSP1080_MexicanHotChocolate: 14790,
  BM_CSP1085_EmptyQuarter: 14791,
  BM_CSP1090_ApproachingAutumn: 14792,
  BM_CSP1095_FireGlow: 14793,
  BM_CSP110_VintagePewter: 14794,
  BM_CSP1100_PeruvianChili: 14795,
  BM_CSP1105_Tandoori: 14796,
  BM_CSP1110_14Carrots: 14797,
  BM_CSP1115_TropicalFruit: 14798,
  BM_CSP1120_CanyonRock: 14799,
  BM_CSP1125_Brownberry: 14800,
  BM_CSP1130_TuscanTile: 14801,
  BM_CSP1135_CoralBells: 14802,
  BM_CSP1140_EgyptianClay: 14803,
  BM_CSP1145_TomatoTango: 14804,
  BM_CSP115_Barnwood: 14805,
  BM_CSP1150_PaperLantern: 14806,
  BM_CSP1155_HotTamale: 14807,
  BM_CSP1160_LipGloss: 14808,
  BM_CSP1165_Cinnabar: 14809,
  BM_CSP1170_ParisianRedreg: 14810,
  BM_CSP1175_PinkFlamingo: 14811,
  BM_CSP1180_BubbleTea: 14812,
  BM_CSP1185_HeirloomQuilt: 14813,
  BM_CSP1190_EmbroideredFlower: 14814,
  BM_CSP1195_Flamenco: 14815,
  BM_CSP120_BurntEmber: 14816,
  BM_CSP1200_CherryBurst: 14817,
  BM_CSP125_AllysEarring: 14818,
  BM_CSP130_Doily: 14819,
  BM_CSP135_WornLeatherShoes: 14820,
  BM_CSP140_Chateau: 14821,
  BM_CSP145_SmokedTruffle: 14822,
  BM_CSP15_ArcticSeal: 14823,
  BM_CSP150_WindyCity: 14824,
  BM_CSP155_SkippingStone: 14825,
  BM_CSP160_UrbanSophisticate: 14826,
  BM_CSP165_Downtown: 14827,
  BM_CSP170_GreenwichGate: 14828,
  BM_CSP175_KidGloves: 14829,
  BM_CSP180_RiverSilt: 14830,
  BM_CSP185_PlasterOfParisreg: 14831,
  BM_CSP190_RockyBeach: 14832,
  BM_CSP195_Porcini: 14833,
  BM_CSP20_WallStreet: 14834,
  BM_CSP200_Quicksand: 14835,
  BM_CSP205_CathedralGray: 14836,
  BM_CSP210_CafeDoppio: 14837,
  BM_CSP215_CakeBatter: 14838,
  BM_CSP220_LaceHandkerchief: 14839,
  BM_CSP225_GalleryBuff: 14840,
  BM_CSP230_Quietude: 14841,
  BM_CSP235_ChocolateVelvet: 14842,
  BM_CSP240_Brownstone: 14843,
  BM_CSP245_Stoneware: 14844,
  BM_CSP25_WoolPeacoat: 14845,
  BM_CSP250_DulceDeLeche: 14846,
  BM_CSP255_WickerBasket: 14847,
  BM_CSP260_TaupeFedora: 14848,
  BM_CSP265_KentuckyBirch: 14849,
  BM_CSP270_DarkChocolate: 14850,
  BM_CSP275_BareEssence: 14851,
  BM_CSP280_WarmSand: 14852,
  BM_CSP285_CamelHair: 14853,
  BM_CSP290_CafeAuLait: 14854,
  BM_CSP295_Cattail: 14855,
  BM_CSP30_EspressoBean: 14856,
  BM_CSP300_RidingBoots: 14857,
  BM_CSP305_CrispLinen: 14858,
  BM_CSP310_FirstCrush: 14859,
  BM_CSP315_RoyalFlax: 14860,
  BM_CSP320_DarkBuff: 14861,
  BM_CSP325_Amaretto: 14862,
  BM_CSP330_FallenLeaf: 14863,
  BM_CSP335_FrenchMacaroon: 14864,
  BM_CSP340_PinkySwear: 14865,
  BM_CSP345_CashmereWrap: 14866,
  BM_CSP35_Penthouse: 14867,
  BM_CSP350_WhippedMocha: 14868,
  BM_CSP355_Riverbank: 14869,
  BM_CSP360_TerrazzoBrown: 14870,
  BM_CSP365_GrandmasChina: 14871,
  BM_CSP370_PicketFence: 14872,
  BM_CSP375_EveningGown: 14873,
  BM_CSP380_StudioClay: 14874,
  BM_CSP385_Gotham: 14875,
  BM_CSP390_EspressoBark: 14876,
  BM_CSP395_StrandOfPearlsreg: 14877,
  BM_CSP40_MuseumPiece: 14878,
  BM_CSP400_RockingChair: 14879,
  BM_CSP405_KnittingBasket: 14880,
  BM_CSP410_LostLocket: 14881,
  BM_CSP415_QuietlyViolet: 14882,
  BM_CSP420_VelvetPlum: 14883,
  BM_CSP425_KeptLoveLetters: 14884,
  BM_CSP430_RaspberryGlace: 14885,
  BM_CSP435_ModernRomance: 14886,
  BM_CSP440_BerryFizz: 14887,
  BM_CSP445_CascabelChile: 14888,
  BM_CSP45_StreetChic: 14889,
  BM_CSP450_Bewitched: 14890,
  BM_CSP455_FadedViolet: 14891,
  BM_CSP460_PinotGrigioGrape: 14892,
  BM_CSP465_Purplicious: 14893,
  BM_CSP470_ElderberryWine: 14894,
  BM_CSP475_WildMulberry: 14895,
  BM_CSP480_VelvetCloak: 14896,
  BM_CSP485_PaperDoll: 14897,
  BM_CSP490_LilacHush: 14898,
  BM_CSP495_ThroughTheLookingGlass: 14899,
  BM_CSP5_Perspectivereg: 14900,
  BM_CSP50_Rainstorm: 14901,
  BM_CSP500_Whisper: 14902,
  BM_CSP505_EveningSkyline: 14903,
  BM_CSP510_Mythic: 14904,
  BM_CSP515_LavenderWash: 14905,
  BM_CSP520_PressedViolet: 14906,
  BM_CSP525_FancyPants: 14907,
  BM_CSP530_FlowerBox: 14908,
  BM_CSP535_ApproachingStorm: 14909,
  BM_CSP540_PlumMartini: 14910,
  BM_CSP545_SheerBliss: 14911,
  BM_CSP55_GrayGardens: 14912,
  BM_CSP550_PorcelainGlaze: 14913,
  BM_CSP555_Waterloo: 14914,
  BM_CSP560_NileBlue: 14915,
  BM_CSP565_IndiGoGo: 14916,
  BM_CSP570_NotreDame: 14917,
  BM_CSP575_IceFog: 14918,
  BM_CSP580_SeersuckerSuit: 14919,
  BM_CSP585_SubwayTilereg: 14920,
  BM_CSP590_EarlyFrost: 14921,
  BM_CSP595_FrenchToile: 14922,
  BM_CSP60_CityShadow: 14923,
  BM_CSP600_AndesSummit: 14924,
  BM_CSP605_DustyCornflower: 14925,
  BM_CSP610_Intuition: 14926,
  BM_CSP615_Daydream: 14927,
  BM_CSP620_WildBlueYonder: 14928,
  BM_CSP625_DeepSecretreg: 14929,
  BM_CSP630_AfterMidnight: 14930,
  BM_CSP635_SpaDay: 14931,
  BM_CSP640_InTheTropics: 14932,
  BM_CSP645_AvalonTeal: 14933,
  BM_CSP65_OldSoul: 14934,
  BM_CSP650_CableKnitSweater: 14935,
  BM_CSP655_BellbottomBlues: 14936,
  BM_CSP660_AdriaticSea: 14937,
  BM_CSP665_CoolBreeze: 14938,
  BM_CSP670_SilkenBlue: 14939,
  BM_CSP675_StJohnBlue: 14940,
  BM_CSP680_BalticSea: 14941,
  BM_CSP685_StainedGlass: 14942,
  BM_CSP690_HiddenSapphire: 14943,
  BM_CSP695_AntiqueGlass: 14944,
  BM_CSP70_UpperWestSide: 14945,
  BM_CSP700_Skydive: 14946,
  BM_CSP705_AntiquedAqua: 14947,
  BM_CSP710_TropicalOasis: 14948,
  BM_CSP715_FairIsleBlue: 14949,
  BM_CSP720_DarkHarbor: 14950,
  BM_CSP725_BarelyThere: 14951,
  BM_CSP730_PicnicBasket: 14952,
  BM_CSP735_SeaGlass: 14953,
  BM_CSP740_SylvanMist: 14954,
  BM_CSP745_MysticLake: 14955,
  BM_CSP75_CastleGate: 14956,
  BM_CSP750_PorchSwing: 14957,
  BM_CSP755_DustyMiller: 14958,
  BM_CSP760_Oilcloth: 14959,
  BM_CSP765_RooftopGarden: 14960,
  BM_CSP770_Sagebrush: 14961,
  BM_CSP775_SageWisdom: 14962,
  BM_CSP780_SummersDay: 14963,
  BM_CSP785_SweetCeladon: 14964,
  BM_CSP790_BuddingGreen: 14965,
  BM_CSP795_EstateSale: 14966,
  BM_CSP80_GothicArch: 14967,
  BM_CSP800_SecretPath: 14968,
  BM_CSP805_InTheGarden: 14969,
  BM_CSP810_Chimichurri: 14970,
  BM_CSP815_PistachioIceCream: 14971,
  BM_CSP820_LichenStone: 14972,
  BM_CSP825_ThayerGreen: 14973,
  BM_CSP830_PeacefulGarden: 14974,
  BM_CSP835_SpringHasSprung: 14975,
  BM_CSP840_BarefootInTheGrass: 14976,
  BM_CSP845_LimeSherbet: 14977,
  BM_CSP85_TweedCoat: 14978,
  BM_CSP850_GreenHydrangea: 14979,
  BM_CSP855_Lilianna: 14980,
  BM_CSP860_GrannySmith: 14981,
  BM_CSP865_Limeade: 14982,
  BM_CSP870_GreenThumb: 14983,
  BM_CSP875_HandmadePaper: 14984,
  BM_CSP880_MorningWalk: 14985,
  BM_CSP885_TurkishBayLeaf: 14986,
  BM_CSP890_MartiniOlive: 14987,
  BM_CSP895_PerfectlyPesto: 14988,
  BM_CSP90_CoachmansCapereg: 14989,
  BM_CSP900_JungleCanopy: 14990,
  BM_CSP905_MeltedButter: 14991,
  BM_CSP910_RayOfLight: 14992,
  BM_CSP915_WarmToastyreg: 14993,
  BM_CSP920_GoldenThread: 14994,
  BM_CSP925_SpiceMarket: 14995,
  BM_CSP930_Dragonwell: 14996,
  BM_CSP935_SweetCream: 14997,
  BM_CSP940_Sundress: 14998,
  BM_CSP945_YellowTopaz: 14999,
  BM_CSP95_SeaSalt: 15000,
  BM_CSP950_Honeybee: 15001,
  BM_CSP955_HannahBanana: 15002,
  BM_CSP960_Goldsmith: 15003,
  BM_CSP965_KnittedCape: 15004,
  BM_CSP970_Shortbread: 15005,
  BM_CSP975_WalkOnTheBeachreg: 15006,
  BM_CSP980_GildedBallroom: 15007,
  BM_CSP985_IcedCoffee: 15008,
  BM_CSP990_Bittergreen: 15009,
  BM_CSP995_ButterCookie: 15010,
  BM_CW10_CapitolWhite: 15011,
  BM_CW100_PrentisCream: 15012,
  BM_CW105_BrackenCream: 15013,
  BM_CW110_Calcite: 15014,
  BM_CW115_CorniceTan: 15015,
  BM_CW120_BrackenBiscuit: 15016,
  BM_CW125_BrushBeige: 15017,
  BM_CW130_CoffeehouseTan: 15018,
  BM_CW135_RaleighSorrel: 15019,
  BM_CW140_TimsonSand: 15020,
  BM_CW145_BrickHouseTan: 15021,
  BM_CW15_ParishWhite: 15022,
  BM_CW150_EverardCoffee: 15023,
  BM_CW155_RevolutionaryStorm: 15024,
  BM_CW160_DixonBrown: 15025,
  BM_CW165_CoffeehouseChocolate: 15026,
  BM_CW170_TarpleyBrown: 15027,
  BM_CW175_TuckerChocolate: 15028,
  BM_CW180_BucktroutBrown: 15029,
  BM_CW185_RandolphBisque: 15030,
  BM_CW190_RaleighTan: 15031,
  BM_CW195_ChowningsTan: 15032,
  BM_CW20_GeddyWhite: 15033,
  BM_CW200_FranklinWhite: 15034,
  BM_CW205_RaleighPeach: 15035,
  BM_CW210_GaltPeach: 15036,
  BM_CW215_CustisSalmon: 15037,
  BM_CW220_LightfootSalmon: 15038,
  BM_CW225_WytheRose: 15039,
  BM_CW230_CarterRed: 15040,
  BM_CW235_BrickyardClay: 15041,
  BM_CW240_Walnut: 15042,
  BM_CW245_StGeorgeRed: 15043,
  BM_CW25_WilliamsburgStone: 15044,
  BM_CW250_CarriageRed: 15045,
  BM_CW255_PalaceArmsRed: 15046,
  BM_CW260_ReidBrown: 15047,
  BM_CW265_CharltonBrown: 15048,
  BM_CW270_NicolsonRed: 15049,
  BM_CW275_LudwellWhite: 15050,
  BM_CW280_MoirGold: 15051,
  BM_CW285_Gamboge: 15052,
  BM_CW290_EnglishOchre: 15053,
  BM_CW295_HaleOrange: 15054,
  BM_CW30_MarketSquareShell: 15055,
  BM_CW300_TuckerOrange: 15056,
  BM_CW305_Claret: 15057,
  BM_CW310_ChinaRed: 15058,
  BM_CW315_CornwallisRed: 15059,
  BM_CW320_DragonsBlood: 15060,
  BM_CW325_BrickyardRed: 15061,
  BM_CW330_CochinealRed: 15062,
  BM_CW335_KingsRed: 15063,
  BM_CW340_GreenhowVermillion: 15064,
  BM_CW345_TraversRed: 15065,
  BM_CW35_PalaceTan: 15066,
  BM_CW350_BarrettBrick: 15067,
  BM_CW355_CarterPlum: 15068,
  BM_CW360_PowellSmokehouse: 15069,
  BM_CW365_ByrdBeige: 15070,
  BM_CW370_SweeneyYellow: 15071,
  BM_CW375_TavernOchre: 15072,
  BM_CW380_Massicot: 15073,
  BM_CW385_CoffeehouseOchre: 15074,
  BM_CW390_BryanOchre: 15075,
  BM_CW395_GovernorsGold: 15076,
  BM_CW40_TavernGray: 15077,
  BM_CW400_DamaskYellow: 15078,
  BM_CW405_DamaskGold: 15079,
  BM_CW410_ChamberYellow: 15080,
  BM_CW415_WytheTan: 15081,
  BM_CW420_WytheGold: 15082,
  BM_CW425_PalaceOchre: 15083,
  BM_CW430_ScrivenerGold: 15084,
  BM_CW435_EverardGold: 15085,
  BM_CW440_GloucesterGreen: 15086,
  BM_CW445_BurwellGreen: 15087,
  BM_CW45_YorkGray: 15088,
  BM_CW450_GreenhowMoss: 15089,
  BM_CW455_GreenEarth: 15090,
  BM_CW460_GreenUmber: 15091,
  BM_CW465_ParrotGreen: 15092,
  BM_CW470_TimsonGreen: 15093,
  BM_CW475_PalmerGreen: 15094,
  BM_CW480_BassettHallGreen: 15095,
  BM_CW485_BurgessGreen: 15096,
  BM_CW490_LevingstonGreen: 15097,
  BM_CW495_RussellGreen: 15098,
  BM_CW5_HarwoodPutty: 15099,
  BM_CW50_TylerGray: 15100,
  BM_CW500_NicolsonGreen: 15101,
  BM_CW505_WindsorGreen: 15102,
  BM_CW510_WallerGreen: 15103,
  BM_CW515_SeaGreen: 15104,
  BM_CW520_PalaceGreen: 15105,
  BM_CW525_RaleighGreen: 15106,
  BM_CW530_ColonialVerdigris: 15107,
  BM_CW535_BuffettGreen: 15108,
  BM_CW540_DunmoreGreen: 15109,
  BM_CW545_SpotswoodTeal: 15110,
  BM_CW55_FinnieGray: 15111,
  BM_CW550_GeddyVerdigris: 15112,
  BM_CW555_GoodwinGreen: 15113,
  BM_CW560_GaltBlue: 15114,
  BM_CW565_AndersonBlue: 15115,
  BM_CW570_MayoTeal: 15116,
  BM_CW575_EverardBlue: 15117,
  BM_CW580_WetherburnsBlue: 15118,
  BM_CW585_EwingBlue: 15119,
  BM_CW590_WilliamsburgWytheBlue: 15120,
  BM_CW595_ChesapeakeBlue: 15121,
  BM_CW60_ColeStone: 15122,
  BM_CW600_BrackenBlue: 15123,
  BM_CW605_PalaceBlue: 15124,
  BM_CW610_LafayetteBlue: 15125,
  BM_CW615_RandolphBlue: 15126,
  BM_CW620_FinleyBlue: 15127,
  BM_CW625_PrussianBlue: 15128,
  BM_CW630_WashingtonBlue: 15129,
  BM_CW635_NelsonBlue: 15130,
  BM_CW640_Pearl: 15131,
  BM_CW645_ApolloBlue: 15132,
  BM_CW65_GunsmithGray: 15133,
  BM_CW650_PalacePearl: 15134,
  BM_CW655_GreenhowBlue: 15135,
  BM_CW660_ChiswellBlue: 15136,
  BM_CW665_PowellGray: 15137,
  BM_CW670_Azurite: 15138,
  BM_CW675_BrushBlue: 15139,
  BM_CW680_MopboardBlack: 15140,
  BM_CW685_AmblerSlate: 15141,
  BM_CW690_BrackenSlate: 15142,
  BM_CW695_Lampblack: 15143,
  BM_CW70_PelhamGray: 15144,
  BM_CW700_Slate: 15145,
  BM_CW705_TuckerGray: 15146,
  BM_CW710_BrutonWhite: 15147,
  BM_CW715_BoneBlack: 15148,
  BM_CW720_GeddyGray: 15149,
  BM_CW75_RandolphStone: 15150,
  BM_CW80_CarterGray: 15151,
  BM_CW85_RandolphGray: 15152,
  BM_CW90_TavernCharcoal: 15153,
  BM_CW95_LimeWhite: 15154,
  BM_ES01_ArborWhite: 15155,
  BM_ES10_Natural: 15156,
  BM_ES20_Redwood: 15157,
  BM_ES21_NewPilgrimRed: 15158,
  BM_ES22_BarnRed: 15159,
  BM_ES24_CaliforniaRustic: 15160,
  BM_ES30_Teak: 15161,
  BM_ES31_CelticBlue: 15162,
  BM_ES40_Cedar: 15163,
  BM_ES43_FerndaleGreen: 15164,
  BM_ES44_SpanishMoss: 10550,
  BM_ES45_NaturalCedartone: 15165,
  BM_ES51_BeigeGray: 15166,
  BM_ES60_Mahogany: 15167,
  BM_ES62_CordovanBrown: 15168,
  BM_ES65_ChestnutBrown: 15169,
  BM_ES67_OxfordBrown: 15170,
  BM_ES70_SilverGray: 15171,
  BM_ES72_SeagullGray: 10922,
  BM_ES76_Stonehenge: 10548,
  BM_ES77_GeorgetownGray: 15172,
  BM_ES78_BleachedGray: 15173,
  BM_HC1_CastletonMist: 15174,
  BM_HC10_StuartGold: 15175,
  BM_HC100_GloucesterSage: 15176,
  BM_HC101_HampshireGray: 15177,
  BM_HC102_ClarksvilleGray: 15178,
  BM_HC103_CromwellGray: 15179,
  BM_HC104_CopleyGray: 15180,
  BM_HC105_RockportGray: 15181,
  BM_HC106_CrownsvilleGray: 15182,
  BM_HC107_GettysburgGray: 15183,
  BM_HC108_JockeyHollowGray: 15184,
  BM_HC109_SussexGreen: 15185,
  BM_HC11_MarbleheadGold: 15186,
  BM_HC110_WethersfieldMoss: 15187,
  BM_HC111_NantucketGray: 15188,
  BM_HC112_TateOlive: 15189,
  BM_HC113_LouisburgGreen: 15190,
  BM_HC114_SaybrookSage: 15191,
  BM_HC115_GeorgianGreen: 15192,
  BM_HC116_GuilfordGreen: 15193,
  BM_HC117_HancockGreen: 15194,
  BM_HC118_SherwoodGreen: 15195,
  BM_HC119_KitteryPointGreen: 15196,
  BM_HC12_ConcordIvory: 15197,
  BM_HC120_VanAlenGreen: 15198,
  BM_HC121_PealeGreen: 15199,
  BM_HC122_GreatBarringtonGreen: 15200,
  BM_HC123_KennebunkportGreen: 15201,
  BM_HC124_CaldwellGreen: 15202,
  BM_HC125_CushingGreen: 15203,
  BM_HC126_AvonGreen: 15204,
  BM_HC127_FairmontGreen: 15205,
  BM_HC128_ClearspringGreen: 15206,
  BM_HC129_SouthfieldGreen: 15207,
  BM_HC13_MillingtonGold: 15208,
  BM_HC130_WebsterGreen: 15209,
  BM_HC131_LehighGreen: 15210,
  BM_HC132_HarrisburgGreen: 15211,
  BM_HC133_YorktowneGreen: 15212,
  BM_HC134_TarrytownGreen: 15213,
  BM_HC135_LafayetteGreen: 15214,
  BM_HC136_WaterburyGreen: 15215,
  BM_HC137_MillSpringsBlue: 15216,
  BM_HC138_CovingtonBlue: 15217,
  BM_HC139_SalisburyGreen: 15218,
  BM_HC14_PrincetonGold: 15219,
  BM_HC140_PrescottGreen: 15220,
  BM_HC141_HollingsworthGreen: 15221,
  BM_HC142_StrattonBlue: 15222,
  BM_HC143_WytheBlue: 15223,
  BM_HC144_PalladianBlue: 15224,
  BM_HC145_VanCourtlandBlue: 15225,
  BM_HC146_WedgewoodGray: 15226,
  BM_HC147_WoodlawnBlue: 15227,
  BM_HC148_JamestownBlue: 15228,
  BM_HC149_BuxtonBlue: 15229,
  BM_HC15_HendersonBuff: 15230,
  BM_HC150_YarmouthBlue: 15231,
  BM_HC151_BucklandBlue: 15232,
  BM_HC152_WhippleBlue: 15233,
  BM_HC153_MarlboroBlue: 15234,
  BM_HC154_HaleNavy: 219,
  BM_HC155_NewburyportBlue: 15235,
  BM_HC156_VanDeusenBlue: 15236,
  BM_HC157_NarragansettGreen: 15237,
  BM_HC158_NewburgGreen: 15238,
  BM_HC159_PhilipsburgBlue: 15239,
  BM_HC16_LivingstonGold: 15240,
  BM_HC160_KnoxvilleGray: 15241,
  BM_HC161_TempletonGray: 15242,
  BM_HC162_BrewsterGray: 15243,
  BM_HC163_DuxburyGray: 15244,
  BM_HC164_PuritanGray: 15245,
  BM_HC165_BoothbayGray: 15246,
  BM_HC166_KendallCharcoal: 11019,
  BM_HC167_AmherstGray: 15247,
  BM_HC168_ChelseaGray: 63,
  BM_HC169_CoventryGray: 15248,
  BM_HC17_SummerdaleGold: 15249,
  BM_HC170_StoningtonGray: 15250,
  BM_HC171_WickhamGray: 15251,
  BM_HC172_ReverePewter: 6413,
  BM_HC173_EdgecombGray: 15252,
  BM_HC174_LancasterWhitewash: 15253,
  BM_HC175_Briarwood: 15254,
  BM_HC176_AnnapolisGray: 15255,
  BM_HC177_RichmondBisque: 15256,
  BM_HC178_CharcoalSlate: 15257,
  BM_HC179_PlatinumGray: 15258,
  BM_HC18_AdamsGold: 15259,
  BM_HC180_CliffsideGray: 15260,
  BM_HC181_HeritageRed: 15261,
  BM_HC182_ClassicBurgundy: 15262,
  BM_HC183_CountryRedwood: 15263,
  BM_HC184_CottageRed: 15264,
  BM_HC185_TudorBrown: 15265,
  BM_HC186_CharlestonBrown: 15266,
  BM_HC187_BlackForestGreen: 15267,
  BM_HC188_EssexGreen: 15268,
  BM_HC189_ChromeGreen: 15269,
  BM_HC19_NorwichBrown: 15270,
  BM_HC190_Black: 10923,
  BM_HC191_HamiltonBlue: 15271,
  BM_HC2_BeaconHillDamask: 15272,
  BM_HC20_WoodstockTan: 15273,
  BM_HC21_HuntingtonBeige: 15274,
  BM_HC22_BlairGold: 15275,
  BM_HC23_YorkshireTan: 15276,
  BM_HC24_PittsfieldBuff: 15277,
  BM_HC25_QuincyTan: 15278,
  BM_HC26_MonroeBisque: 15279,
  BM_HC27_MontereyWhite: 15280,
  BM_HC28_ShelburneBuff: 15281,
  BM_HC29_DunmoreCream: 15282,
  BM_HC3_GreenmountSilk: 15283,
  BM_HC30_PhiladelphiaCream: 15284,
  BM_HC31_WaterburyCream: 1976,
  BM_HC32_StandishWhite: 15285,
  BM_HC33_MontgomeryWhite: 15286,
  BM_HC34_WilmingtonTan: 15287,
  BM_HC35_PowellBuff: 15288,
  BM_HC36_HepplewhiteIvory: 15289,
  BM_HC37_MysticGold: 15290,
  BM_HC38_DecaturBuff: 15291,
  BM_HC39_PutnamIvory: 15292,
  BM_HC4_HawthorneYellow: 15293,
  BM_HC40_GreenfieldPumpkin: 15294,
  BM_HC41_RichmondGold: 15295,
  BM_HC42_RoxburyCaramel: 15296,
  BM_HC43_TylerTaupe: 15297,
  BM_HC44_LenoxTan: 15298,
  BM_HC45_ShakerBeige: 15299,
  BM_HC46_JacksonTan: 15300,
  BM_HC47_BrooklineBeige: 15301,
  BM_HC48_BradstreetBeige: 15302,
  BM_HC49_MayflowerRed: 15303,
  BM_HC5_WestonFlax: 15304,
  BM_HC50_GeorgianBrick: 15305,
  BM_HC51_AudubonRusset: 15306,
  BM_HC52_AnsoniaPeach: 15307,
  BM_HC53_HathawayPeach: 15308,
  BM_HC54_JumelPeachtone: 15309,
  BM_HC55_WinthropPeach: 15310,
  BM_HC56_GeorgetownPinkBeige: 15311,
  BM_HC57_SheratonBeige: 1977,
  BM_HC58_ChippendaleRosetone: 15312,
  BM_HC59_OdessaPink: 15313,
  BM_HC6_WindhamCream: 15314,
  BM_HC60_QueenAnnePink: 15315,
  BM_HC61_NewLondonBurgundy: 15316,
  BM_HC62_SomervilleRed: 15317,
  BM_HC63_MonticelloRose: 15318,
  BM_HC64_TownsendHarborBrown: 15319,
  BM_HC65_HodleyRed: 15320,
  BM_HC66_GarrisonRed: 15321,
  BM_HC67_ClintonBrown: 15322,
  BM_HC68_MiddleburyBrown: 15323,
  BM_HC69_WhitallBrown: 15324,
  BM_HC7_BryantGold: 15325,
  BM_HC70_VanBurenBrown: 15326,
  BM_HC71_HasbrouckBrown: 15327,
  BM_HC72_BranchportBrown: 15328,
  BM_HC73_PlymouthBrown: 15329,
  BM_HC74_ValleyForgeBrown: 15330,
  BM_HC75_MaryvilleBrown: 15331,
  BM_HC76_DavenportTan: 15332,
  BM_HC77_AlexandriaBeige: 15333,
  BM_HC78_LitchfieldGray: 15334,
  BM_HC79_GreenbrierBeige: 15335,
  BM_HC8_DorsetGold: 15336,
  BM_HC80_BleekerBeige: 15337,
  BM_HC81_ManchesterTan: 15338,
  BM_HC82_BenningtonGray: 15339,
  BM_HC83_GrantBeige: 15340,
  BM_HC84_ElmiraWhite: 15341,
  BM_HC85_FairviewTaupe: 15342,
  BM_HC86_KingsportGray: 15343,
  BM_HC87_AshleyGray: 10979,
  BM_HC88_JamesboroGold: 15344,
  BM_HC89_NorthamptonPutty: 15345,
  BM_HC9_ChestertownBuff: 15346,
  BM_HC90_CrownPointSand: 15347,
  BM_HC91_DanvilleTan: 15348,
  BM_HC92_WheelingNeutral: 15349,
  BM_HC93_CarringtonBeige: 1978,
  BM_HC94_OldSalemGray: 15350,
  BM_HC95_SagHarborGray: 15351,
  BM_HC96_RichmondGray: 15352,
  BM_HC97_HancockGray: 15353,
  BM_HC98_ProvidenceOlive: 15354,
  BM_HC99_AbingdonPutty: 15355,
  BM_OC1_NaturalWicker: 15356,
  BM_OC10_WhiteSand: 15357,
  BM_OC100_PalaceWhite: 15358,
  BM_OC101_Desolate: 15359,
  BM_OC102_DevonCream: 15360,
  BM_OC103_AntiqueYellow: 15361,
  BM_OC104_AntiqueLace: 15362,
  BM_OC105_CalmingCream: 15363,
  BM_OC106_ManOnTheMoon: 15364,
  BM_OC107_Antiquity: 15365,
  BM_OC108_PaleMoon: 15366,
  BM_OC109_LemonChiffon: 15367,
  BM_OC11_ClayBeige: 15368,
  BM_OC110_Milkyway: 15369,
  BM_OC111_CorinthianWhite: 15370,
  BM_OC112_Goldtone: 15371,
  BM_OC113_PowderSand: 15372,
  BM_OC114_LemonIce: 15373,
  BM_OC115_CreamSilk: 15374,
  BM_OC116_PaleCelery: 15375,
  BM_OC117_SimplyWhite: 15376,
  BM_OC118_SnowfallWhite: 15377,
  BM_OC119_CloudNine: 15378,
  BM_OC12_Muslin: 15379,
  BM_OC120_Seashell: 15380,
  BM_OC121_MountainPeakWhite: 15381,
  BM_OC122_CottonBalls: 15382,
  BM_OC123_BavarianCream: 15383,
  BM_OC124_AlpineWhite: 15384,
  BM_OC125_MoonlightWhite: 15385,
  BM_OC126_EasterLily: 15386,
  BM_OC127_WhiteChocolate: 15387,
  BM_OC128_MincedOnion: 15388,
  BM_OC129_Alabaster: 15389,
  BM_OC13_SoftChamois: 15390,
  BM_OC130_CloudWhite: 15391,
  BM_OC131_WhiteDown: 15392,
  BM_OC132_GrandTetonWhite: 15393,
  BM_OC133_AncientIvory: 15394,
  BM_OC134_MeadowMist: 15395,
  BM_OC135_CreamCloak: 15396,
  BM_OC136_CelerySalt: 15397,
  BM_OC137_SebringWhite: 15398,
  BM_OC138_WhiteDrifts: 15399,
  BM_OC139_SeaWind: 15400,
  BM_OC14_NaturalCream: 15401,
  BM_OC140_MorningDew: 15402,
  BM_OC141_ChinaWhite: 15403,
  BM_OC142_SailCloth: 15404,
  BM_OC143_BoneWhite: 15405,
  BM_OC144_CreamAgate: 15406,
  BM_OC145_AtriumWhite: 15407,
  BM_OC146_LinenWhite: 15408,
  BM_OC147_CameoWhite: 15409,
  BM_OC148_MontgomeryWhite: 15410,
  BM_OC149_DecoratorsWhite: 15411,
  BM_OC15_BabyFawn: 15412,
  BM_OC150_BrilliantWhite: 15413,
  BM_OC151_White: 15414,
  BM_OC152_SuperWhite: 15415,
  BM_OC16_CedarKey: 15416,
  BM_OC17_WhiteDove: 10913,
  BM_OC18_DoveWing: 15417,
  BM_OC19_Seapearl: 15418,
  BM_OC2_PaleAlmond: 15419,
  BM_OC20_PaleOak: 10914,
  BM_OC21_WinterWhite: 15420,
  BM_OC22_Calm: 15421,
  BM_OC23_ClassicGray: 15422,
  BM_OC24_WindsBreath: 15423,
  BM_OC25_CloudCover: 15424,
  BM_OC26_SilverSatin: 11020,
  BM_OC27_BalboaMist: 15425,
  BM_OC28_Collingwood: 15426,
  BM_OC29_FloralWhite: 15427,
  BM_OC3_Lambskin: 15428,
  BM_OC30_GrayMist: 15429,
  BM_OC31_FogMist: 15430,
  BM_OC32_TapestryBeige: 15431,
  BM_OC33_Opaline: 15432,
  BM_OC34_MarbleWhite: 15433,
  BM_OC35_SpanishWhite: 15434,
  BM_OC36_Niveous: 15435,
  BM_OC37_GlacierWhite: 15436,
  BM_OC38_AcadiaWhite: 15437,
  BM_OC39_TimidWhite: 15438,
  BM_OC4_BrandyCream: 15439,
  BM_OC40_Albescent: 15440,
  BM_OC41_FrenchCanvas: 15441,
  BM_OC42_OldPrairie: 15442,
  BM_OC43_Overcast: 15443,
  BM_OC44_MistyAir: 15444,
  BM_OC45_SwissCoffee: 10915,
  BM_OC46_Halo: 15445,
  BM_OC47_Ashwood: 15446,
  BM_OC48_HazySkies: 15447,
  BM_OC49_Titanium: 15448,
  BM_OC5_MaritimeWhite: 15449,
  BM_OC50_NovemberRain: 15450,
  BM_OC51_IntenseWhite: 15451,
  BM_OC52_GrayOwl: 15452,
  BM_OC53_Horizon: 15453,
  BM_OC54_WhiteWisp: 15454,
  BM_OC55_PaperWhite: 15455,
  BM_OC56_Moonshine: 15456,
  BM_OC57_WhiteHeron: 15457,
  BM_OC58_WhiteIce: 15458,
  BM_OC59_VanillaMilkshake: 15459,
  BM_OC6_FeatherDown: 15460,
  BM_OC60_Icicle: 15461,
  BM_OC61_WhiteDiamond: 15462,
  BM_OC62_BabysBreath: 15463,
  BM_OC63_WinterSnow: 15464,
  BM_OC64_PureWhite: 15465,
  BM_OC65_ChantillyLace: 11021,
  BM_OC66_SnowWhite: 15466,
  BM_OC67_IceMist: 15467,
  BM_OC68_DistantGray: 15468,
  BM_OC69_Opulence: 15469,
  BM_OC7_CreamyWhite: 15470,
  BM_OC70_WhitewaterBay: 15471,
  BM_OC71_SandDollar: 15472,
  BM_OC72_PinkDamask: 15473,
  BM_OC73_Opal: 15474,
  BM_OC74_OnyxWhite: 15475,
  BM_OC75_Pristine: 15476,
  BM_OC76_OldCountry: 15477,
  BM_OC77_ColonialCream: 15478,
  BM_OC78_Parchment: 15479,
  BM_OC79_OldFashionedPeach: 15480,
  BM_OC8_ElephantTusk: 15481,
  BM_OC80_PiratesCoveBeach: 15482,
  BM_OC81_EveningWhite: 15483,
  BM_OC82_Pompeii: 15484,
  BM_OC83_AntiqueWhite: 15485,
  BM_OC84_CremeCaramel: 15486,
  BM_OC85_Mayonnaise: 15487,
  BM_OC86_WhiteBlush: 15488,
  BM_OC87_CapriCoast: 15489,
  BM_OC88_SparklingWine: 15490,
  BM_OC89_ButterPecan: 15491,
  BM_OC9_BalletWhite: 15492,
  BM_OC90_VanillaIceCream: 15493,
  BM_OC91_IvoryTusk: 15494,
  BM_OC92_MannequinCream: 15495,
  BM_OC93_SugarCookie: 15496,
  BM_OC94_Windswept: 15497,
  BM_OC95_NavajoWhite: 15498,
  BM_OC96_GentleCream: 15499,
  BM_OC97_CreamFroth: 15500,
  BM_OC98_Bare: 15501,
  BM_OC99_DesertedIsland: 15502,
  BM_PM1_SuperWhite: 15503,
  BM_PM10_ChromeGreen: 15504,
  BM_PM11_EssexGreen: 15505,
  BM_PM12_BlackForestGreen: 15506,
  BM_PM13_AtriumWhite: 15507,
  BM_PM14_AnnapolisGray: 15508,
  BM_PM15_CottageRed: 15509,
  BM_PM16_CountryRedwood: 15510,
  BM_PM17_ClassicBurgundy: 15511,
  BM_PM18_HeritageRed: 15512,
  BM_PM19_WhiteDove: 15513,
  BM_PM2_White: 15514,
  BM_PM20_ChinaWhite: 15515,
  BM_PM21_SailCloth: 15516,
  BM_PM22_AntiqueWhite: 15517,
  BM_PM23_CharlestonBrown: 15518,
  BM_PM24_TudorBrown: 15519,
  BM_PM25_CameoWhite: 15520,
  BM_PM26_MontgomeryWhite: 15521,
  BM_PM27_RichmondBisque: 15522,
  BM_PM28_LinenWhite: 15523,
  BM_PM29_NavajoWhite: 15524,
  BM_PM3_DecoratorsWhite: 15525,
  BM_PM30_BoneWhite: 15526,
  BM_PM31_LancasterWhite: 15527,
  BM_PM32_Briarwood: 15528,
  BM_PM4_BrilliantWhite: 15529,
  BM_PM5_CliffsideGray: 15530,
  BM_PM6_HamiltonBlue: 15531,
  BM_PM7_PlatinumGray: 15532,
  BM_PM8_CharcoalSlate: 15533,
  BM_PM9_Black: 15534,
};

const DMC_BuildersEdge = {
  BuildersEdge_Almond048: 6448,
  BuildersEdge_Almond049: 6449,
  BuildersEdge_Black002: 6450,
  BuildersEdge_Bordeaux167: 6451,
  BuildersEdge_BrightWhite117: 6452,
  BuildersEdge_BurgundyRed027: 6453,
  BuildersEdge_Champagne089: 6454,
  BuildersEdge_ClassicBlue036: 6455,
  BuildersEdge_Clay008: 6456,
  BuildersEdge_Clay085: 6457,
  BuildersEdge_Clay095: 6458,
  BuildersEdge_Clay097: 6459,
  BuildersEdge_Cream020: 6460,
  BuildersEdge_DarkAlmond012: 6461,
  BuildersEdge_FederalBrown009: 6462,
  BuildersEdge_ForestGreen028: 6463,
  BuildersEdge_FrenchRoast385: 6490,
  BuildersEdge_LightAlmond013: 6464,
  BuildersEdge_LightGrey016: 6465,
  BuildersEdge_Linen082: 6466,
  BuildersEdge_MidnightBlue166: 6467,
  BuildersEdge_MidnightGreen122: 6468,
  BuildersEdge_MusketBrown010: 6469,
  BuildersEdge_Paintable030: 6470,
  BuildersEdge_Parchment034: 6471,
  BuildersEdge_Platinum945: 6491,
  BuildersEdge_Sandalwood011: 6472,
  BuildersEdge_SandstoneBeige021: 6473,
  BuildersEdge_SandstoneMaple045: 6474,
  BuildersEdge_StormCloud419: 6492,
  BuildersEdge_Tan069: 6475,
  BuildersEdge_TreatedCedar471: 6493,
  BuildersEdge_TuxedoGrey018: 6476,
  BuildersEdge_WedgewoodBlue004: 6477,
  BuildersEdge_White001: 6478,
  BuildersEdge_White123: 6479,
  BuildersEdge_Wicker023: 6480,
  BuildersEdge_Wineberry078: 6481,
};

const DMC_CHI_Colors = {
  Almond: 2075,
  Black: 2076,
  Bronze: 2077,
  Brown: 2078,
  DesertTan: 2079,
  Evergreen: 2080,
  Graphite: 2081,
  Gray: 2082,
  Sandstone: 2083,
  White: 2084,
};

const DMC_Certainteed = {
  ArborBlend: 10587,
  AutumnRed: 10588,
  Brownstone: 10589,
  CastleStone: 10590,
  CedarBlend: 10591,
  CharcoalGray: 10592,
  ColonialWhite: 10593,
  Cypress: 10594,
  DeepMineral: 10595,
  DesertTan: 10596,
  DriftwoodBlend: 10597,
  Espresso: 10598,
  Flagstone: 10599,
  Forest: 10600,
  FrontierBlend: 10601,
  GraniteGray: 10602,
  Graystone: 10603,
  Hearthstone: 10782,
  HeritageCream: 10604,
  Herringbone: 10605,
  Melrose: 10606,
  MidnightBlue: 10607,
  NaturalBlend: 10608,
  NaturalClay: 10609,
  OliveGrove: 10610,
  OxfordBlue: 10611,
  PacificBlue: 10612,
  RusticBlend: 10613,
  SableBrown: 10614,
  SandstoneBeige: 10615,
  SavannahWicker: 10616,
  Seagrass: 10617,
  Slate: 10618,
  SmokyGray: 10619,
  Sparrow: 10620,
  Spruce: 10621,
  SterlingGray: 10622,
  Tuxedo: 10623,
  WeatheredBlend: 10624,
  WeatheredWood: 10625,
  WedgewoodBlue: 10626,
};

const DMC_Concrete_SherwinWilliams = {
  Concrete_SW_HC157_Sandstone: 10982,
};

const DMC_DiamondKote = {
  DiamondKote_Bedrock: 10711,
  DiamondKote_Beige: 26111,
  DiamondKote_Biscuit: 26112,
  DiamondKote_Bordeaux: 10712,
  DiamondKote_BronzeWalnut: 10713,
  DiamondKote_Canyon: 10714,
  DiamondKote_Caribou: 26113,
  DiamondKote_Cascade: 10715,
  DiamondKote_Chestnut: 10716,
  DiamondKote_Cinnabar: 26114,
  DiamondKote_Clay: 10717,
  DiamondKote_Clove: 26115,
  DiamondKote_Coffee: 10718,
  DiamondKote_CopperOak: 10719,
  DiamondKote_Denali: 10720,
  DiamondKote_Dune: 10721,
  DiamondKote_EbonyPine: 10722,
  DiamondKote_Elkhorn: 10723,
  DiamondKote_Emerald: 10724,
  DiamondKote_FrenchGray: 10725,
  DiamondKote_GlacierFog: 10726,
  DiamondKote_GoldenTeak: 10727,
  DiamondKote_Graphite: 10728,
  DiamondKote_Honeycomb: 10729,
  DiamondKote_IronAsh: 10730,
  DiamondKote_LightGray: 10731,
  DiamondKote_Midnight: 10732,
  DiamondKote_MountainLake: 10733,
  DiamondKote_Olive: 10734,
  DiamondKote_Onyx: 10735,
  DiamondKote_OysterShell: 10736,
  DiamondKote_Pelican: 10737,
  DiamondKote_PewterGreen: 26116,
  DiamondKote_Platinum: 26117,
  DiamondKote_Sand: 10738,
  DiamondKote_Seal: 10739,
  DiamondKote_SmokyAsh: 10740,
  DiamondKote_TerraBronze: 10741,
  DiamondKote_Umber: 10742,
  DiamondKote_White: 10743,
};

const DMC_Dulux = {
  Dulux_00BB_06_017: 6575,
  Dulux_00GY_80_069: 6576,
  Dulux_00YR_08_409: 6577,
  Dulux_00YR_15_510: 6578,
  Dulux_00YR_17_365: 6579,
  Dulux_00YR_18_531: 6580,
  Dulux_00YR_26_490: 6581,
  Dulux_00YY_07_093: 6582,
  Dulux_00YY_09_069: 6583,
  Dulux_00YY_09_186: 6584,
  Dulux_00YY_12_173: 6585,
  Dulux_00YY_12_279: 6586,
  Dulux_00YY_15_371: 6587,
  Dulux_00YY_18_346: 6588,
  Dulux_00YY_19_261: 6589,
  Dulux_00YY_19_464: 6590,
  Dulux_00YY_23_557: 6591,
  Dulux_00YY_26_520: 6592,
  Dulux_00YY_28_650: 6593,
  Dulux_00YY_34_562: 6594,
  Dulux_00YY_41_475: 6595,
  Dulux_00YY_49_387: 6596,
  Dulux_00YY_50_091: 6597,
  Dulux_00YY_62_144: 6598,
  Dulux_00YY_63_067: 6599,
  Dulux_00YY_76_088: 6600,
  Dulux_00YY_83_034: 6601,
  Dulux_00YY_83_046: 6602,
  Dulux_00YY_83_057: 6603,
  Dulux_00YY_83_069: 6604,
  Dulux_00YY_83_080: 6605,
  Dulux_01BB_59_109: 6606,
  Dulux_01BG_11_248: 6607,
  Dulux_01GG_07_070: 6608,
  Dulux_01GG_59_285: 6609,
  Dulux_01RR_16_397: 6610,
  Dulux_01YR_07_180: 6611,
  Dulux_01YR_09_386: 6612,
  Dulux_01YY_36_694: 6613,
  Dulux_01YY_86_034: 6614,
  Dulux_02BB_81_030: 6615,
  Dulux_02GG_21_542: 6616,
  Dulux_02RB_53_171: 6617,
  Dulux_02RR_35_376: 6618,
  Dulux_02YR_09_373: 6619,
  Dulux_02YR_45_229: 6620,
  Dulux_03YR_08_318: 6621,
  Dulux_03YY_59_088: 6622,
  Dulux_03YY_66_085: 6623,
  Dulux_03YY_66_105: 6624,
  Dulux_03YY_82_067: 6625,
  Dulux_04BB_34_244: 6626,
  Dulux_04BB_57_189: 6627,
  Dulux_04BG_71_117: 6628,
  Dulux_04GY_87_028: 6629,
  Dulux_04RB_71_092: 6630,
  Dulux_04YR_24_029: 6631,
  Dulux_04YR_27_258: 6632,
  Dulux_04YR_82_010: 6633,
  Dulux_04YY_39_480: 6634,
  Dulux_04YY_39_638: 6635,
  Dulux_05BB_59_165: 6636,
  Dulux_05RB_32_259: 6637,
  Dulux_05YR_08_272: 6638,
  Dulux_05YR_15_555: 6639,
  Dulux_05YY_42_727: 6640,
  Dulux_05YY_52_658: 6641,
  Dulux_05YY_72_254: 6642,
  Dulux_06BB_39_179: 6643,
  Dulux_06BB_71_091: 6644,
  Dulux_06BB_79_016: 6645,
  Dulux_06GG_12_304: 6646,
  Dulux_06GG_19_406: 6647,
  Dulux_06YR_12_509: 6648,
  Dulux_06YY_21_130: 6649,
  Dulux_06YY_49_797: 6650,
  Dulux_07BB_62_156: 6651,
  Dulux_07GG_08_244: 6652,
  Dulux_07RB_07_079: 6653,
  Dulux_07RR_30_337: 6654,
  Dulux_07YR_10_489: 6655,
  Dulux_07YR_21_415: 6656,
  Dulux_08BB_46_152: 6657,
  Dulux_08GG_72_006: 6658,
  Dulux_08GY_19_067: 6659,
  Dulux_08GY_26_190: 6660,
  Dulux_08GY_32_058: 6661,
  Dulux_08GY_36_175: 6662,
  Dulux_08YR_70_012: 6663,
  Dulux_08YY_55_137: 6664,
  Dulux_08YY_72_077: 6665,
  Dulux_08YY_78_069: 6666,
  Dulux_08YY_82_100: 6667,
  Dulux_08YY_83_117: 6668,
  Dulux_09RB_12_102: 6669,
  Dulux_09RR_21_078: 6670,
  Dulux_09YR_05_305: 6671,
  Dulux_09YY_28_180: 6672,
  Dulux_09YY_45_402: 6673,
  Dulux_09YY_57_689: 6674,
  Dulux_09YY_59_325: 6675,
  Dulux_10BB_07_150: 6676,
  Dulux_10BB_09_250: 6677,
  Dulux_10BB_11_350: 6678,
  Dulux_10BB_13_362: 6679,
  Dulux_10BB_30_203: 6680,
  Dulux_10BB_39_100: 6681,
  Dulux_10BB_55_065: 6682,
  Dulux_10BB_59_176: 6683,
  Dulux_10BB_73_039: 6684,
  Dulux_10BB_83_006: 6685,
  Dulux_10BB_83_014: 6686,
  Dulux_10BG_13_156: 6687,
  Dulux_10BG_22_248: 6688,
  Dulux_10BG_26_134: 6689,
  Dulux_10BG_38_119: 6690,
  Dulux_10BG_39_219: 6691,
  Dulux_10BG_39_244: 6692,
  Dulux_10BG_46_112: 6693,
  Dulux_10BG_54_199: 6694,
  Dulux_10BG_55_223: 6695,
  Dulux_10BG_63_143: 6696,
  Dulux_10BG_63_189: 6697,
  Dulux_10BG_72_092: 6698,
  Dulux_10BG_83_061: 6699,
  Dulux_10GG_15_346: 6700,
  Dulux_10GG_17_239: 6701,
  Dulux_10GG_21_050: 6702,
  Dulux_10GG_23_485: 6703,
  Dulux_10GG_33_404: 6704,
  Dulux_10GG_33_483: 6705,
  Dulux_10GG_38_038: 6706,
  Dulux_10GG_39_152: 6707,
  Dulux_10GG_44_395: 6708,
  Dulux_10GG_49_300: 6709,
  Dulux_10GG_51_125: 6710,
  Dulux_10GG_57_307: 6711,
  Dulux_10GG_66_098: 6712,
  Dulux_10GG_72_022: 6713,
  Dulux_10GG_72_219: 6714,
  Dulux_10GG_76_153: 6715,
  Dulux_10GG_83_018: 6716,
  Dulux_10GG_83_071: 6717,
  Dulux_10GG_83_125: 6718,
  Dulux_10GY_14_135: 6719,
  Dulux_10GY_21_375: 6720,
  Dulux_10GY_29_158: 6721,
  Dulux_10GY_40_296: 6722,
  Dulux_10GY_41_600: 6723,
  Dulux_10GY_52_541: 6724,
  Dulux_10GY_54_238: 6725,
  Dulux_10GY_71_180: 6726,
  Dulux_10GY_74_325: 6727,
  Dulux_10GY_79_231: 6728,
  Dulux_10GY_83_050: 6729,
  Dulux_10GY_83_100: 6730,
  Dulux_10GY_86_138: 6731,
  Dulux_10RB_08_125: 6732,
  Dulux_10RB_10_219: 6733,
  Dulux_10RB_14_049: 6734,
  Dulux_10RB_17_122: 6735,
  Dulux_10RB_17_210: 6736,
  Dulux_10RB_23_061: 6737,
  Dulux_10RB_28_055: 6738,
  Dulux_10RB_35_167: 6739,
  Dulux_10RB_53_115: 6740,
  Dulux_10RB_65_042: 6741,
  Dulux_10RB_68_081: 6742,
  Dulux_10RB_73_024: 6743,
  Dulux_10RB_83_012: 6744,
  Dulux_10RR_08_100: 6745,
  Dulux_10RR_13_250: 6746,
  Dulux_10RR_14_186: 6747,
  Dulux_10RR_18_350: 6748,
  Dulux_10RR_21_325: 6749,
  Dulux_10RR_22_178: 6750,
  Dulux_10RR_25_437: 6751,
  Dulux_10RR_35_133: 6752,
  Dulux_10RR_39_184: 6753,
  Dulux_10RR_39_263: 6754,
  Dulux_10RR_53_087: 6755,
  Dulux_10RR_56_029: 6756,
  Dulux_10RR_56_121: 6757,
  Dulux_10RR_65_023: 6758,
  Dulux_10RR_67_057: 6759,
  Dulux_10RR_68_068: 6760,
  Dulux_10RR_73_016: 6761,
  Dulux_10RR_73_023: 6762,
  Dulux_10RR_83_009: 6763,
  Dulux_10RR_83_026: 6764,
  Dulux_10YR_09_250: 6765,
  Dulux_10YR_17_184: 6766,
  Dulux_10YR_38_318: 6767,
  Dulux_10YR_41_223: 6768,
  Dulux_10YR_50_101: 6769,
  Dulux_10YR_55_037: 6770,
  Dulux_10YR_67_111: 6771,
  Dulux_10YR_83_015: 6772,
  Dulux_10YY_08_093: 6773,
  Dulux_10YY_09_200: 6774,
  Dulux_10YY_11_187: 6775,
  Dulux_10YY_12_300: 6776,
  Dulux_10YY_14_080: 6777,
  Dulux_10YY_17_140: 6778,
  Dulux_10YY_21_500: 6779,
  Dulux_10YY_23_261: 6780,
  Dulux_10YY_26_321: 6781,
  Dulux_10YY_27_600: 6782,
  Dulux_10YY_30_560: 6783,
  Dulux_10YY_33_163: 6784,
  Dulux_10YY_35_543: 6785,
  Dulux_10YY_38_316: 6786,
  Dulux_10YY_40_608: 6787,
  Dulux_10YY_44_215: 6788,
  Dulux_10YY_46_041: 6789,
  Dulux_10YY_46_515: 6790,
  Dulux_10YY_48_071: 6791,
  Dulux_10YY_50_469: 6792,
  Dulux_10YY_53_132: 6793,
  Dulux_10YY_54_034: 6794,
  Dulux_10YY_55_163: 6795,
  Dulux_10YY_58_295: 6796,
  Dulux_10YY_65_285: 6797,
  Dulux_10YY_68_110: 6798,
  Dulux_10YY_69_130: 6799,
  Dulux_10YY_72_172: 6800,
  Dulux_10YY_72_200: 6801,
  Dulux_10YY_74_063: 6802,
  Dulux_10YY_74_192: 6803,
  Dulux_10YY_75_084: 6804,
  Dulux_10YY_77_125: 6805,
  Dulux_10YY_78_188: 6806,
  Dulux_10YY_83_029: 6807,
  Dulux_10YY_83_071: 6808,
  Dulux_11BB_15_359: 6809,
  Dulux_11BB_35_316: 6810,
  Dulux_11GG_26_195: 6811,
  Dulux_11GY_12_072: 6812,
  Dulux_11GY_85_016: 6813,
  Dulux_11RR_29_068: 6814,
  Dulux_11RR_43_050: 6815,
  Dulux_11YY_37_219: 6816,
  Dulux_11YY_38_694: 6817,
  Dulux_11YY_68_269: 6818,
  Dulux_11YY_70_356: 6819,
  Dulux_11YY_78_136: 6820,
  Dulux_11YY_79_170: 6821,
  Dulux_11YY_85_042: 6822,
  Dulux_12BB_35_025: 6823,
  Dulux_12BB_82_058: 6824,
  Dulux_12BG_79_065: 6825,
  Dulux_12GG_10_310: 6826,
  Dulux_12GY_10_087: 6827,
  Dulux_12GY_39_101: 6828,
  Dulux_12RB_18_337: 6829,
  Dulux_12RB_51_169: 6830,
  Dulux_12RR_07_229: 6831,
  Dulux_12YR_45_079: 6832,
  Dulux_12YY_47_184: 6833,
  Dulux_12YY_61_523: 6834,
  Dulux_13BG_72_151: 6835,
  Dulux_13GY_52_120: 6836,
  Dulux_13GY_77_016: 6837,
  Dulux_13RB_32_077: 6838,
  Dulux_13RR_06_179: 6839,
  Dulux_13RR_12_202: 6840,
  Dulux_13RR_72_121: 6841,
  Dulux_13YR_80_033: 6842,
  Dulux_13YY_60_475: 6843,
  Dulux_14BB_39_289: 6844,
  Dulux_14BB_55_113: 6845,
  Dulux_14BG_67_174: 6846,
  Dulux_14GY_12_129: 6847,
  Dulux_14GY_76_113: 6848,
  Dulux_14RB_45_074: 6849,
  Dulux_14RR_09_333: 6850,
  Dulux_14RR_12_349: 6851,
  Dulux_14RR_48_276: 6852,
  Dulux_14YR_10_434: 6853,
  Dulux_14YY_57_556: 6854,
  Dulux_14YY_63_272: 6855,
  Dulux_14YY_88_041: 6856,
  Dulux_15BB_13_261: 6857,
  Dulux_15BB_19_227: 6858,
  Dulux_15GG_53_086: 6859,
  Dulux_15RB_27_316: 6860,
  Dulux_15RB_66_112: 6861,
  Dulux_15RR_27_249: 6862,
  Dulux_15YY_37_276: 6863,
  Dulux_15YY_49_288: 6864,
  Dulux_15YY_57_150: 6865,
  Dulux_15YY_69_080: 6866,
  Dulux_16BB_19_395: 6867,
  Dulux_16BB_25_001: 6868,
  Dulux_16BB_27_091: 6869,
  Dulux_16BG_26_318: 6870,
  Dulux_16BG_27_325: 6871,
  Dulux_16GY_28_295: 6872,
  Dulux_16GY_54_615: 6873,
  Dulux_16GY_66_078: 6874,
  Dulux_16RB_13_349: 6875,
  Dulux_16RB_38_235: 6876,
  Dulux_16RB_69_065: 6877,
  Dulux_16RB_73_058: 6878,
  Dulux_16YR_12_037: 6879,
  Dulux_16YR_13_558: 6880,
  Dulux_16YR_16_594: 6881,
  Dulux_16YR_79_080: 6882,
  Dulux_16YY_76_189: 6883,
  Dulux_16YY_79_040: 6884,
  Dulux_17BB_08_104: 6885,
  Dulux_17BB_54_211: 6886,
  Dulux_17BB_71_069: 6887,
  Dulux_17BB_79_028: 6888,
  Dulux_17BG_08_158: 6889,
  Dulux_17BG_36_333: 6890,
  Dulux_17BG_60_228: 6891,
  Dulux_17GG_40_107: 6892,
  Dulux_17GY_27_098: 6893,
  Dulux_17GY_68_005: 6894,
  Dulux_17RR_18_239: 6895,
  Dulux_17YR_13_463: 6896,
  Dulux_17YR_60_073: 6897,
  Dulux_17YY_16_022: 6898,
  Dulux_17YY_68_203: 6899,
  Dulux_17YY_79_105: 6900,
  Dulux_18BB_18_075: 6901,
  Dulux_18BB_19_153: 6902,
  Dulux_18BB_59_133: 6903,
  Dulux_18GY_18_160: 6904,
  Dulux_18GY_38_328: 6905,
  Dulux_18RB_08_286: 6906,
  Dulux_18YR_05_072: 6907,
  Dulux_18YR_36_386: 6908,
  Dulux_18YR_54_304: 6909,
  Dulux_18YR_78_079: 6910,
  Dulux_18YR_83_042: 6911,
  Dulux_19BG_45_302: 6912,
  Dulux_19BG_61_207: 6913,
  Dulux_19GY_65_110: 6914,
  Dulux_19RR_78_088: 6915,
  Dulux_19YR_13_558: 6916,
  Dulux_19YR_14_629: 6917,
  Dulux_19YR_67_058: 6918,
  Dulux_19YY_15_105: 6919,
  Dulux_19YY_51_758: 6920,
  Dulux_19YY_61_057: 6921,
  Dulux_19YY_71_323: 6922,
  Dulux_20BB_08_051: 6923,
  Dulux_20GY_37_537: 6924,
  Dulux_20GY_39_466: 6925,
  Dulux_20YY_09_175: 6926,
  Dulux_20YY_12_263: 6927,
  Dulux_20YY_22_129: 6928,
  Dulux_20YY_23_246: 6929,
  Dulux_20YY_23_525: 6930,
  Dulux_20YY_24_177: 6931,
  Dulux_20YY_26_490: 6932,
  Dulux_20YY_27_426: 6933,
  Dulux_20YY_28_613: 6934,
  Dulux_20YY_29_095: 6935,
  Dulux_20YY_31_106: 6936,
  Dulux_20YY_31_205: 6937,
  Dulux_20YY_32_494: 6938,
  Dulux_20YY_34_700: 6939,
  Dulux_20YY_37_094: 6940,
  Dulux_20YY_38_225: 6941,
  Dulux_20YY_39_130: 6942,
  Dulux_20YY_40_608: 6943,
  Dulux_20YY_43_200: 6944,
  Dulux_20YY_45_114: 6945,
  Dulux_20YY_46_515: 6946,
  Dulux_20YY_51_306: 6947,
  Dulux_20YY_53_124: 6948,
  Dulux_20YY_57_178: 6949,
  Dulux_20YY_58_082: 6950,
  Dulux_20YY_60_104: 6951,
  Dulux_20YY_61_127: 6952,
  Dulux_20YY_64_171: 6953,
  Dulux_20YY_65_285: 6954,
  Dulux_20YY_67_084: 6955,
  Dulux_20YY_67_216: 6956,
  Dulux_20YY_68_102: 6957,
  Dulux_20YY_69_120: 6958,
  Dulux_20YY_70_138: 6959,
  Dulux_20YY_74_055: 6960,
  Dulux_20YY_77_110: 6961,
  Dulux_20YY_78_146: 6962,
  Dulux_20YY_83_038: 6963,
  Dulux_20YY_83_063: 6964,
  Dulux_21BB_12_077: 6965,
  Dulux_21BB_52_181: 6966,
  Dulux_21BG_45_002: 6967,
  Dulux_21GG_28_387: 6968,
  Dulux_21GY_25_379: 6969,
  Dulux_21GY_28_472: 6970,
  Dulux_21RR_19_459: 6971,
  Dulux_21RR_36_354: 6972,
  Dulux_21YR_13_383: 6973,
  Dulux_21YR_67_074: 6974,
  Dulux_21YR_73_125: 6975,
  Dulux_21YY_18_079: 6976,
  Dulux_21YY_38_102: 6977,
  Dulux_21YY_45_405: 6978,
  Dulux_21YY_60_577: 6979,
  Dulux_21YY_82_053: 6980,
  Dulux_21YY_84_128: 6981,
  Dulux_22BB_08_161: 6982,
  Dulux_22GY_70_140: 6983,
  Dulux_22YR_18_488: 6984,
  Dulux_22YR_50_316: 6985,
  Dulux_22YY_32_156: 6986,
  Dulux_22YY_59_694: 6987,
  Dulux_22YY_80_211: 6988,
  Dulux_23BB_68_102: 6989,
  Dulux_23BG_51_212: 6990,
  Dulux_23RB_11_349: 6991,
  Dulux_23RB_76_036: 6992,
  Dulux_23YR_08_237: 6993,
  Dulux_23YR_10_308: 6994,
  Dulux_23YY_44_541: 6995,
  Dulux_23YY_53_490: 6996,
  Dulux_23YY_62_816: 6997,
  Dulux_23YY_86_081: 6998,
  Dulux_24BB_43_232: 6999,
  Dulux_24GY_85_110: 7000,
  Dulux_24RB_66_037: 7001,
  Dulux_24YY_28_384: 7002,
  Dulux_24YY_39_319: 7003,
  Dulux_24YY_82_118: 7004,
  Dulux_25BG_26_253: 7005,
  Dulux_25GG_07_188: 7006,
  Dulux_25YY_38_510: 7007,
  Dulux_25YY_46_170: 7008,
  Dulux_25YY_49_757: 7009,
  Dulux_25YY_50_592: 7010,
  Dulux_25YY_54_123: 7011,
  Dulux_25YY_57_441: 7012,
  Dulux_25YY_62_353: 7013,
  Dulux_25YY_70_365: 7014,
  Dulux_25YY_77_087: 7015,
  Dulux_25YY_79_240: 7016,
  Dulux_25YY_81_177: 7017,
  Dulux_25YY_83_103: 7018,
  Dulux_25YY_85_108: 7019,
  Dulux_26BB_10_008: 7020,
  Dulux_26GG_19_130: 7021,
  Dulux_26GY_68_322: 7022,
  Dulux_26RR_14_332: 7023,
  Dulux_26RR_73_037: 7024,
  Dulux_26YR_18_404: 7025,
  Dulux_26YR_30_511: 7026,
  Dulux_26YY_52_359: 7027,
  Dulux_27YY_77_042: 7028,
  Dulux_27YY_78_255: 7029,
  Dulux_28GG_08_229: 7030,
  Dulux_28GG_22_002: 7031,
  Dulux_28GG_82_048: 7032,
  Dulux_28YR_25_461: 7033,
  Dulux_28YR_29_561: 7034,
  Dulux_28YR_67_165: 7035,
  Dulux_29YY_79_033: 7036,
  Dulux_30BB_08_188: 7037,
  Dulux_30BB_08_225: 7038,
  Dulux_30BB_08_263: 7039,
  Dulux_30BB_10_337: 7040,
  Dulux_30BB_11_244: 7041,
  Dulux_30BB_14_242: 7042,
  Dulux_30BB_17_158: 7043,
  Dulux_30BB_23_291: 7044,
  Dulux_30BB_27_236: 7045,
  Dulux_30BB_31_043: 7046,
  Dulux_30BB_33_235: 7047,
  Dulux_30BB_47_179: 7048,
  Dulux_30BB_53_012: 7049,
  Dulux_30BB_54_120: 7050,
  Dulux_30BB_62_004: 7051,
  Dulux_30BB_63_084: 7052,
  Dulux_30BB_63_097: 7053,
  Dulux_30BB_73_052: 7054,
  Dulux_30BB_83_013: 7055,
  Dulux_30BB_83_018: 7056,
  Dulux_30BG_08_200: 7057,
  Dulux_30BG_10_111: 7058,
  Dulux_30BG_14_248: 7059,
  Dulux_30BG_15_322: 7060,
  Dulux_30BG_16_133: 7061,
  Dulux_30BG_21_301: 7062,
  Dulux_30BG_23_124: 7063,
  Dulux_30BG_33_269: 7064,
  Dulux_30BG_37_110: 7065,
  Dulux_30BG_56_097: 7066,
  Dulux_30BG_64_072: 7067,
  Dulux_30BG_64_140: 7068,
  Dulux_30BG_72_017: 7069,
  Dulux_30BG_72_051: 7070,
  Dulux_30BG_72_069: 7071,
  Dulux_30BG_72_103: 7072,
  Dulux_30BG_76_107: 7073,
  Dulux_30GG_10_050: 7074,
  Dulux_30GG_10_225: 7075,
  Dulux_30GG_16_137: 7076,
  Dulux_30GG_16_394: 7077,
  Dulux_30GG_18_450: 7078,
  Dulux_30GG_19_370: 7079,
  Dulux_30GG_21_423: 7080,
  Dulux_30GG_29_196: 7081,
  Dulux_30GG_33_275: 7082,
  Dulux_30GG_37_423: 7083,
  Dulux_30GG_40_290: 7084,
  Dulux_30GG_47_180: 7085,
  Dulux_30GG_49_211: 7086,
  Dulux_30GG_52_011: 7087,
  Dulux_30GG_55_302: 7088,
  Dulux_30GG_57_217: 7089,
  Dulux_30GG_60_143: 7090,
  Dulux_30GG_61_168: 7091,
  Dulux_30GG_72_008: 7092,
  Dulux_30GG_72_212: 7093,
  Dulux_30GG_75_095: 7094,
  Dulux_30GG_75_111: 7095,
  Dulux_30GG_76_127: 7096,
  Dulux_30GG_83_025: 7097,
  Dulux_30GG_83_075: 7098,
  Dulux_30GG_83_088: 7099,
  Dulux_30GG_83_100: 7100,
  Dulux_30GY_09_171: 7101,
  Dulux_30GY_11_076: 7102,
  Dulux_30GY_12_257: 7103,
  Dulux_30GY_15_242: 7104,
  Dulux_30GY_16_343: 7105,
  Dulux_30GY_19_323: 7106,
  Dulux_30GY_21_429: 7107,
  Dulux_30GY_23_232: 7108,
  Dulux_30GY_31_202: 7109,
  Dulux_30GY_34_249: 7110,
  Dulux_30GY_40_029: 7111,
  Dulux_30GY_40_531: 7112,
  Dulux_30GY_41_173: 7113,
  Dulux_30GY_50_183: 7114,
  Dulux_30GY_51_294: 7115,
  Dulux_30GY_56_023: 7116,
  Dulux_30GY_58_375: 7117,
  Dulux_30GY_61_245: 7118,
  Dulux_30GY_62_159: 7119,
  Dulux_30GY_62_344: 7120,
  Dulux_30GY_72_196: 7121,
  Dulux_30GY_73_053: 7122,
  Dulux_30GY_75_105: 7123,
  Dulux_30GY_75_251: 7124,
  Dulux_30GY_76_017: 7125,
  Dulux_30GY_83_064: 7126,
  Dulux_30GY_83_107: 7127,
  Dulux_30GY_83_150: 7128,
  Dulux_30RB_10_214: 7129,
  Dulux_30RB_11_250: 7130,
  Dulux_30RB_13_199: 7131,
  Dulux_30RB_16_144: 7132,
  Dulux_30RB_19_261: 7133,
  Dulux_30RB_22_215: 7134,
  Dulux_30RB_26_067: 7135,
  Dulux_30RB_33_103: 7136,
  Dulux_30RB_35_166: 7137,
  Dulux_30RB_36_055: 7138,
  Dulux_30RB_49_042: 7139,
  Dulux_30RB_50_072: 7140,
  Dulux_30RB_53_117: 7141,
  Dulux_30RB_56_036: 7142,
  Dulux_30RB_64_030: 7143,
  Dulux_30RB_68_084: 7144,
  Dulux_30RB_73_016: 7145,
  Dulux_30RB_73_027: 7146,
  Dulux_30RB_74_038: 7147,
  Dulux_30RR_09_187: 7148,
  Dulux_30RR_10_321: 7149,
  Dulux_30RR_12_281: 7150,
  Dulux_30RR_15_375: 7151,
  Dulux_30RR_17_140: 7152,
  Dulux_30RR_23_270: 7153,
  Dulux_30RR_26_335: 7154,
  Dulux_30RR_30_103: 7155,
  Dulux_30RR_31_223: 7156,
  Dulux_30RR_42_198: 7157,
  Dulux_30RR_54_145: 7158,
  Dulux_30RR_61_195: 7159,
  Dulux_30RR_67_093: 7160,
  Dulux_30RR_74_058: 7161,
  Dulux_30RR_83_020: 7162,
  Dulux_30YR_07_157: 7163,
  Dulux_30YR_07_354: 7164,
  Dulux_30YR_08_236: 7165,
  Dulux_30YR_10_314: 7166,
  Dulux_30YR_11_219: 7167,
  Dulux_30YR_12_122: 7168,
  Dulux_30YR_12_292: 7169,
  Dulux_30YR_15_112: 7170,
  Dulux_30YR_15_550: 7171,
  Dulux_30YR_16_162: 7172,
  Dulux_30YR_18_212: 7173,
  Dulux_30YR_20_595: 7174,
  Dulux_30YR_21_505: 7175,
  Dulux_30YR_29_118: 7176,
  Dulux_30YR_31_154: 7177,
  Dulux_30YR_38_337: 7178,
  Dulux_30YR_40_061: 7179,
  Dulux_30YR_43_295: 7180,
  Dulux_30YR_48_074: 7181,
  Dulux_30YR_53_188: 7182,
  Dulux_30YR_63_031: 7183,
  Dulux_30YR_64_044: 7184,
  Dulux_30YR_67_113: 7185,
  Dulux_30YR_68_127: 7186,
  Dulux_30YR_74_045: 7187,
  Dulux_30YR_83_023: 7188,
  Dulux_30YR_83_029: 7189,
  Dulux_30YR_83_040: 7190,
  Dulux_30YY_05_044: 7191,
  Dulux_30YY_08_082: 7192,
  Dulux_30YY_09_175: 7193,
  Dulux_30YY_12_263: 7194,
  Dulux_30YY_17_209: 7195,
  Dulux_30YY_20_029: 7196,
  Dulux_30YY_20_193: 7197,
  Dulux_30YY_21_438: 7198,
  Dulux_30YY_23_246: 7199,
  Dulux_30YY_24_177: 7200,
  Dulux_30YY_27_226: 7201,
  Dulux_30YY_28_161: 7202,
  Dulux_30YY_33_613: 7203,
  Dulux_30YY_35_249: 7204,
  Dulux_30YY_36_185: 7205,
  Dulux_30YY_39_225: 7206,
  Dulux_30YY_41_700: 7207,
  Dulux_30YY_44_114: 7208,
  Dulux_30YY_46_036: 7209,
  Dulux_30YY_46_608: 7210,
  Dulux_30YY_47_145: 7211,
  Dulux_30YY_51_098: 7212,
  Dulux_30YY_53_124: 7213,
  Dulux_30YY_58_082: 7214,
  Dulux_30YY_58_178: 7215,
  Dulux_30YY_60_104: 7216,
  Dulux_30YY_62_127: 7217,
  Dulux_30YY_63_231: 7218,
  Dulux_30YY_64_149: 7219,
  Dulux_30YY_64_331: 7220,
  Dulux_30YY_65_171: 7221,
  Dulux_30YY_69_048: 7222,
  Dulux_30YY_69_216: 7223,
  Dulux_30YY_70_455: 7224,
  Dulux_30YY_71_073: 7225,
  Dulux_30YY_71_138: 7226,
  Dulux_30YY_72_018: 7227,
  Dulux_30YY_75_145: 7228,
  Dulux_30YY_77_169: 7229,
  Dulux_30YY_78_035: 7230,
  Dulux_30YY_79_070: 7231,
  Dulux_30YY_80_088: 7232,
  Dulux_30YY_81_123: 7233,
  Dulux_30YY_82_039: 7234,
  Dulux_30YY_83_026: 7235,
  Dulux_31BB_15_212: 7236,
  Dulux_31BG_10_240: 7237,
  Dulux_31BG_26_004: 7238,
  Dulux_31RR_21_462: 7239,
  Dulux_31YR_50_290: 7240,
  Dulux_31YR_84_056: 7241,
  Dulux_32BB_10_296: 7242,
  Dulux_32BB_33_133: 7243,
  Dulux_32BG_72_122: 7244,
  Dulux_32GY_51_432: 7245,
  Dulux_32RR_50_280: 7246,
  Dulux_32YR_38_392: 7247,
  Dulux_33BB_61_174: 7248,
  Dulux_33BG_43_240: 7249,
  Dulux_33RR_74_111: 7250,
  Dulux_33YR_48_037: 7251,
  Dulux_33YY_69_519: 7252,
  Dulux_33YY_74_360: 7253,
  Dulux_34BG_79_053: 7254,
  Dulux_34GG_81_080: 7255,
  Dulux_34YR_35_025: 7256,
  Dulux_34YY_31_502: 7257,
  Dulux_34YY_55_802: 7258,
  Dulux_34YY_61_672: 7259,
  Dulux_34YY_71_404: 7260,
  Dulux_34YY_76_174: 7261,
  Dulux_34YY_81_209: 7262,
  Dulux_35BG_42_331: 7263,
  Dulux_35YY_59_533: 7264,
  Dulux_35YY_61_431: 7265,
  Dulux_35YY_76_110: 7266,
  Dulux_35YY_78_269: 7267,
  Dulux_35YY_88_050: 7268,
  Dulux_36BB_46_231: 7269,
  Dulux_36GG_87_038: 7270,
  Dulux_36RR_14_002: 7271,
  Dulux_36RR_75_114: 7272,
  Dulux_36YY_59_230: 7273,
  Dulux_37BG_26_349: 7274,
  Dulux_37YY_38_594: 7275,
  Dulux_37YY_39_443: 7276,
  Dulux_37YY_61_867: 7277,
  Dulux_37YY_78_312: 7278,
  Dulux_37YY_79_086: 7279,
  Dulux_38BB_69_096: 7280,
  Dulux_38BG_30_352: 7281,
  Dulux_38GY_26_456: 7282,
  Dulux_38RB_15_086: 7283,
  Dulux_38RR_15_026: 7284,
  Dulux_38YR_17_442: 7285,
  Dulux_38YR_40_290: 7286,
  Dulux_38YY_72_117: 7287,
  Dulux_38YY_81_256: 7288,
  Dulux_38YY_85_096: 7289,
  Dulux_39BB_81_032: 7290,
  Dulux_39BG_21_339: 7291,
  Dulux_39GY_77_179: 7292,
  Dulux_39RR_07_029: 7293,
  Dulux_39YR_11_342: 7294,
  Dulux_39YY_52_691: 7295,
  Dulux_39YY_53_067: 7296,
  Dulux_39YY_71_413: 7297,
  Dulux_39YY_74_175: 7298,
  Dulux_39YY_77_091: 7299,
  Dulux_39YY_84_095: 7300,
  Dulux_39YY_85_046: 7301,
  Dulux_39YY_85_156: 7302,
  Dulux_40BB_83_017: 7303,
  Dulux_40GY_18_372: 7304,
  Dulux_40RB_36_264: 7305,
  Dulux_40RB_43_233: 7306,
  Dulux_40RR_57_045: 7307,
  Dulux_40YR_75_107: 7308,
  Dulux_40YY_38_107: 7309,
  Dulux_40YY_41_152: 7310,
  Dulux_40YY_41_603: 7311,
  Dulux_40YY_46_587: 7312,
  Dulux_40YY_49_546: 7313,
  Dulux_40YY_58_565: 7314,
  Dulux_40YY_64_903: 7315,
  Dulux_40YY_67_087: 7316,
  Dulux_40YY_67_196: 7317,
  Dulux_40YY_69_112: 7318,
  Dulux_40YY_69_666: 7319,
  Dulux_40YY_70_138: 7320,
  Dulux_40YY_74_056: 7321,
  Dulux_40YY_75_216: 7322,
  Dulux_40YY_77_267: 7323,
  Dulux_40YY_83_021: 7324,
  Dulux_40YY_83_043: 7325,
  Dulux_40YY_83_086: 7326,
  Dulux_40YY_83_107: 7327,
  Dulux_40YY_83_129: 7328,
  Dulux_40YY_83_150: 7329,
  Dulux_41GG_67_162: 7330,
  Dulux_41RB_19_322: 7331,
  Dulux_41RB_24_309: 7332,
  Dulux_41RB_30_290: 7333,
  Dulux_41YY_77_065: 7334,
  Dulux_41YY_82_071: 7335,
  Dulux_42BB_23_348: 7336,
  Dulux_42GG_08_250: 7337,
  Dulux_42GY_09_205: 7338,
  Dulux_42RB_14_320: 7339,
  Dulux_42RB_21_094: 7340,
  Dulux_42RB_53_176: 7341,
  Dulux_42RB_63_137: 7342,
  Dulux_42RR_26_194: 7343,
  Dulux_42YR_43_439: 7344,
  Dulux_42YY_64_745: 7345,
  Dulux_42YY_84_095: 7346,
  Dulux_42YY_87_084: 7347,
  Dulux_43BG_75_043: 7348,
  Dulux_43GY_24_566: 7349,
  Dulux_43RB_07_249: 7350,
  Dulux_43RB_09_077: 7351,
  Dulux_43RR_19_444: 7352,
  Dulux_43YY_65_687: 7353,
  Dulux_43YY_69_543: 7354,
  Dulux_43YY_71_540: 7355,
  Dulux_43YY_74_339: 7356,
  Dulux_43YY_81_051: 7357,
  Dulux_44BB_54_129: 7358,
  Dulux_44BB_62_134: 7359,
  Dulux_44GG_08_039: 7360,
  Dulux_44GG_12_299: 7361,
  Dulux_44YY_23_330: 7362,
  Dulux_44YY_65_034: 7363,
  Dulux_44YY_69_069: 7364,
  Dulux_44YY_69_140: 7365,
  Dulux_44YY_80_106: 7366,
  Dulux_44YY_84_042: 7367,
  Dulux_44YY_87_118: 7368,
  Dulux_45BB_18_339: 7369,
  Dulux_45BB_37_281: 7370,
  Dulux_45GG_81_022: 7371,
  Dulux_45GY_83_023: 7372,
  Dulux_45GY_83_149: 7373,
  Dulux_45YR_11_240: 7374,
  Dulux_45YR_83_076: 7375,
  Dulux_45YY_20_168: 7376,
  Dulux_45YY_61_368: 7377,
  Dulux_45YY_62_805: 7378,
  Dulux_45YY_65_334: 7379,
  Dulux_45YY_65_710: 7380,
  Dulux_45YY_66_512: 7381,
  Dulux_45YY_71_426: 7382,
  Dulux_45YY_73_519: 7383,
  Dulux_45YY_77_424: 7384,
  Dulux_45YY_82_098: 7385,
  Dulux_45YY_83_094: 7386,
  Dulux_45YY_83_125: 7387,
  Dulux_45YY_83_156: 7388,
  Dulux_45YY_83_250: 7389,
  Dulux_46BG_63_190: 7390,
  Dulux_46GG_31_446: 7391,
  Dulux_46GY_21_423: 7392,
  Dulux_46YR_12_287: 7393,
  Dulux_46YR_69_173: 7394,
  Dulux_46YY_53_062: 7395,
  Dulux_46YY_63_147: 7396,
  Dulux_47BB_74_091: 7397,
  Dulux_47BG_62_184: 7398,
  Dulux_47GG_57_246: 7399,
  Dulux_47RR_10_045: 7400,
  Dulux_47RR_33_395: 7401,
  Dulux_47RR_55_175: 7402,
  Dulux_47YR_18_085: 7403,
  Dulux_47YY_62_143: 7404,
  Dulux_47YY_86_047: 7405,
  Dulux_48BB_33_169: 7406,
  Dulux_48BB_56_162: 7407,
  Dulux_48BG_54_244: 7408,
  Dulux_48GG_19_309: 7409,
  Dulux_48YR_06_091: 7410,
  Dulux_48YR_09_077: 7411,
  Dulux_48YR_26_519: 7412,
  Dulux_48YY_12_123: 7413,
  Dulux_48YY_12_177: 7414,
  Dulux_48YY_73_573: 7415,
  Dulux_48YY_80_346: 7416,
  Dulux_49BB_14_046: 7417,
  Dulux_49BB_19_182: 7418,
  Dulux_49BB_51_186: 7419,
  Dulux_49BB_63_056: 7420,
  Dulux_49GG_52_001: 7421,
  Dulux_49GG_77_014: 7422,
  Dulux_49RR_17_416: 7423,
  Dulux_49RR_39_161: 7424,
  Dulux_49RR_50_250: 7425,
  Dulux_49YR_27_627: 7426,
  Dulux_49YR_59_226: 7427,
  Dulux_49YY_46_310: 7428,
  Dulux_49YY_54_251: 7429,
  Dulux_49YY_69_406: 7430,
  Dulux_49YY_75_130: 7431,
  Dulux_50BB_06_163: 7432,
  Dulux_50BB_08_257: 7433,
  Dulux_50BB_17_126: 7434,
  Dulux_50BB_18_276: 7435,
  Dulux_50BB_27_232: 7436,
  Dulux_50BB_39_188: 7437,
  Dulux_50BB_45_185: 7438,
  Dulux_50BB_54_079: 7439,
  Dulux_50BB_72_045: 7440,
  Dulux_50BB_83_006: 7441,
  Dulux_50BG_10_175: 7442,
  Dulux_50BG_11_123: 7443,
  Dulux_50BG_18_350: 7444,
  Dulux_50BG_19_144: 7445,
  Dulux_50BG_20_230: 7446,
  Dulux_50BG_30_235: 7447,
  Dulux_50BG_30_384: 7448,
  Dulux_50BG_32_114: 7449,
  Dulux_50BG_41_312: 7450,
  Dulux_50BG_44_094: 7451,
  Dulux_50BG_44_184: 7452,
  Dulux_50BG_62_133: 7453,
  Dulux_50BG_64_028: 7454,
  Dulux_50BG_74_020: 7455,
  Dulux_50BG_74_130: 7456,
  Dulux_50BG_76_023: 7457,
  Dulux_50BG_76_079: 7458,
  Dulux_50GG_05_063: 7459,
  Dulux_50GG_09_189: 7460,
  Dulux_50GG_28_273: 7461,
  Dulux_50GG_61_154: 7462,
  Dulux_50GG_63_042: 7463,
  Dulux_50GG_69_134: 7464,
  Dulux_50GG_71_180: 7465,
  Dulux_50GG_73_031: 7466,
  Dulux_50GG_75_092: 7467,
  Dulux_50GG_82_115: 7468,
  Dulux_50GG_83_011: 7469,
  Dulux_50GG_83_023: 7470,
  Dulux_50GG_83_034: 7471,
  Dulux_50GY_08_153: 7472,
  Dulux_50GY_15_289: 7473,
  Dulux_50GY_16_383: 7474,
  Dulux_50GY_18_178: 7475,
  Dulux_50GY_23_280: 7476,
  Dulux_50GY_26_155: 7477,
  Dulux_50GY_37_335: 7478,
  Dulux_50GY_39_536: 7479,
  Dulux_50GY_43_120: 7480,
  Dulux_50GY_44_248: 7481,
  Dulux_50GY_51_437: 7482,
  Dulux_50GY_52_263: 7483,
  Dulux_50GY_55_207: 7484,
  Dulux_50GY_65_084: 7485,
  Dulux_50GY_66_111: 7486,
  Dulux_50GY_70_192: 7487,
  Dulux_50GY_70_259: 7488,
  Dulux_50GY_72_012: 7489,
  Dulux_50GY_74_073: 7490,
  Dulux_50GY_75_122: 7491,
  Dulux_50GY_77_195: 7492,
  Dulux_50GY_83_040: 7493,
  Dulux_50GY_83_060: 7494,
  Dulux_50RB_09_156: 7495,
  Dulux_50RB_10_219: 7496,
  Dulux_50RB_13_107: 7497,
  Dulux_50RB_20_199: 7498,
  Dulux_50RB_34_153: 7499,
  Dulux_50RB_35_067: 7500,
  Dulux_50RB_48_051: 7501,
  Dulux_50RB_52_107: 7502,
  Dulux_50RB_66_066: 7503,
  Dulux_50RB_69_097: 7504,
  Dulux_50RB_73_024: 7505,
  Dulux_50RB_74_033: 7506,
  Dulux_50RB_83_005: 7507,
  Dulux_50RR_10_229: 7508,
  Dulux_50RR_12_305: 7509,
  Dulux_50RR_17_372: 7510,
  Dulux_50RR_19_203: 7511,
  Dulux_50RR_26_431: 7512,
  Dulux_50RR_32_029: 7513,
  Dulux_50RR_32_262: 7514,
  Dulux_50RR_49_195: 7515,
  Dulux_50RR_51_109: 7516,
  Dulux_50RR_54_018: 7517,
  Dulux_50RR_61_129: 7518,
  Dulux_50RR_65_065: 7519,
  Dulux_50RR_72_010: 7520,
  Dulux_50RR_74_048: 7521,
  Dulux_50RR_83_006: 7522,
  Dulux_50RR_83_029: 7523,
  Dulux_50RR_83_034: 7524,
  Dulux_50YR_07_162: 7525,
  Dulux_50YR_09_244: 7526,
  Dulux_50YR_12_406: 7527,
  Dulux_50YR_15_377: 7528,
  Dulux_50YR_16_127: 7529,
  Dulux_50YR_22_052: 7530,
  Dulux_50YR_23_365: 7531,
  Dulux_50YR_32_460: 7532,
  Dulux_50YR_47_057: 7533,
  Dulux_50YR_55_201: 7534,
  Dulux_50YR_62_008: 7535,
  Dulux_50YR_65_056: 7536,
  Dulux_50YR_66_091: 7537,
  Dulux_50YR_68_114: 7538,
  Dulux_50YR_73_022: 7539,
  Dulux_50YR_74_043: 7540,
  Dulux_50YR_75_111: 7541,
  Dulux_50YR_76_087: 7542,
  Dulux_50YR_78_064: 7543,
  Dulux_50YR_83_003: 7544,
  Dulux_50YR_83_020: 7545,
  Dulux_50YR_83_025: 7546,
  Dulux_50YR_83_035: 7547,
  Dulux_50YR_83_040: 7548,
  Dulux_50YY_37_519: 7549,
  Dulux_50YY_53_687: 7550,
  Dulux_50YY_60_538: 7551,
  Dulux_50YY_62_309: 7552,
  Dulux_50YY_65_454: 7553,
  Dulux_50YY_75_254: 7554,
  Dulux_50YY_77_173: 7555,
  Dulux_50YY_80_242: 7556,
  Dulux_50YY_83_029: 7557,
  Dulux_50YY_83_114: 7558,
  Dulux_50YY_83_171: 7559,
  Dulux_51BB_11_311: 7560,
  Dulux_51BB_27_310: 7561,
  Dulux_51GG_12_132: 7562,
  Dulux_51YR_48_101: 7563,
  Dulux_51YR_83_054: 7564,
  Dulux_51YY_61_792: 7565,
  Dulux_51YY_74_066: 7566,
  Dulux_51YY_78_444: 7567,
  Dulux_51YY_83_060: 7568,
  Dulux_51YY_84_121: 7569,
  Dulux_52BB_08_128: 7570,
  Dulux_52BG_38_320: 7571,
  Dulux_52YR_18_350: 7572,
  Dulux_52YR_21_567: 7573,
  Dulux_52YY_55_131: 7574,
  Dulux_52YY_72_661: 7575,
  Dulux_52YY_83_223: 7576,
  Dulux_52YY_89_117: 7577,
  Dulux_53BB_36_004: 7578,
  Dulux_53GG_50_360: 7579,
  Dulux_53RR_83_031: 7580,
  Dulux_53YR_17_504: 7581,
  Dulux_53YY_26_275: 7582,
  Dulux_53YY_77_064: 7583,
  Dulux_53YY_82_133: 7584,
  Dulux_53YY_83_348: 7585,
  Dulux_54BB_39_103: 7586,
  Dulux_54BB_66_088: 7587,
  Dulux_54BG_56_236: 7588,
  Dulux_54GG_16_017: 7589,
  Dulux_54GG_47_053: 7590,
  Dulux_54RB_78_038: 7591,
  Dulux_54RR_09_276: 7592,
  Dulux_54RR_52_260: 7593,
  Dulux_54YR_12_074: 7594,
  Dulux_54YR_22_344: 7595,
  Dulux_54YY_22_044: 7596,
  Dulux_54YY_46_065: 7597,
  Dulux_54YY_63_072: 7598,
  Dulux_54YY_69_747: 7599,
  Dulux_55BG_74_117: 7600,
  Dulux_55GG_46_244: 7601,
  Dulux_55RR_11_401: 7602,
  Dulux_55RR_75_106: 7603,
  Dulux_55YR_36_590: 7604,
  Dulux_55YR_83_024: 7605,
  Dulux_56BB_07_196: 7606,
  Dulux_56BG_23_355: 7607,
  Dulux_56BG_81_023: 7608,
  Dulux_56GG_64_258: 7609,
  Dulux_56GG_77_156: 7610,
  Dulux_56RB_09_302: 7611,
  Dulux_56YY_87_037: 7612,
  Dulux_57GY_28_292: 7613,
  Dulux_57RR_62_183: 7614,
  Dulux_57YR_27_226: 7615,
  Dulux_57YR_32_176: 7616,
  Dulux_57YY_86_073: 7617,
  Dulux_58BB_12_390: 7618,
  Dulux_58YR_49_379: 7619,
  Dulux_58YY_72_095: 7620,
  Dulux_58YY_88_180: 7621,
  Dulux_59GY_20_482: 7622,
  Dulux_59YR_53_163: 7623,
  Dulux_59YR_70_153: 7624,
  Dulux_60BG_17_341: 7625,
  Dulux_60GG_22_204: 7626,
  Dulux_60GG_79_056: 7627,
  Dulux_60RR_07_002: 7628,
  Dulux_60RR_62_086: 7629,
  Dulux_60YR_07_093: 7630,
  Dulux_60YR_08_186: 7631,
  Dulux_60YR_16_464: 7632,
  Dulux_60YR_24_439: 7633,
  Dulux_60YR_30_094: 7634,
  Dulux_60YR_33_047: 7635,
  Dulux_60YR_40_297: 7636,
  Dulux_60YR_40_423: 7637,
  Dulux_60YR_41_072: 7638,
  Dulux_60YR_55_271: 7639,
  Dulux_60YR_70_151: 7640,
  Dulux_60YR_75_075: 7641,
  Dulux_60YR_83_009: 7642,
  Dulux_60YR_83_017: 7643,
  Dulux_60YR_83_026: 7644,
  Dulux_60YR_83_034: 7645,
  Dulux_60YR_83_060: 7646,
  Dulux_60YY_28_443: 7647,
  Dulux_60YY_33_130: 7648,
  Dulux_60YY_34_461: 7649,
  Dulux_60YY_39_654: 7650,
  Dulux_60YY_47_608: 7651,
  Dulux_60YY_48_748: 7652,
  Dulux_60YY_62_755: 7653,
  Dulux_60YY_69_583: 7654,
  Dulux_60YY_71_409: 7655,
  Dulux_60YY_72_225: 7656,
  Dulux_60YY_77_332: 7657,
  Dulux_60YY_79_367: 7658,
  Dulux_60YY_80_288: 7659,
  Dulux_60YY_83_156: 7660,
  Dulux_60YY_83_187: 7661,
  Dulux_61BB_28_291: 7662,
  Dulux_61BG_68_049: 7663,
  Dulux_61GG_08_119: 7664,
  Dulux_61GY_11_019: 7665,
  Dulux_61GY_12_190: 7666,
  Dulux_61YR_60_282: 7667,
  Dulux_61YR_61_229: 7668,
  Dulux_61YY_39_443: 7669,
  Dulux_61YY_86_159: 7670,
  Dulux_61YY_89_040: 7671,
  Dulux_61YY_89_135: 7672,
  Dulux_62GY_18_260: 7673,
  Dulux_62RR_09_009: 7674,
  Dulux_62YR_13_217: 7675,
  Dulux_62YR_18_397: 7676,
  Dulux_62YR_22_051: 7677,
  Dulux_62YY_27_282: 7678,
  Dulux_62YY_83_382: 7679,
  Dulux_63GY_83_021: 7680,
  Dulux_63RR_19_405: 7681,
  Dulux_63RR_39_350: 7682,
  Dulux_63YR_26_584: 7683,
  Dulux_63YR_50_340: 7684,
  Dulux_63YY_53_710: 7685,
  Dulux_63YY_79_219: 7686,
  Dulux_63YY_80_051: 7687,
  Dulux_64BB_46_254: 7688,
  Dulux_64BG_78_058: 7689,
  Dulux_64RB_37_284: 7690,
  Dulux_64RB_55_192: 7691,
  Dulux_64RR_12_436: 7692,
  Dulux_64YY_10_021: 7693,
  Dulux_64YY_38_505: 7694,
  Dulux_64YY_39_108: 7695,
  Dulux_64YY_65_071: 7696,
  Dulux_64YY_83_058: 7697,
  Dulux_64YY_84_180: 7698,
  Dulux_65BG_17_353: 7699,
  Dulux_65RB_62_156: 7700,
  Dulux_65YR_11_146: 7701,
  Dulux_65YR_35_659: 7702,
  Dulux_65YY_27_444: 7703,
  Dulux_65YY_68_572: 7704,
  Dulux_65YY_70_540: 7705,
  Dulux_65YY_72_399: 7706,
  Dulux_65YY_79_118: 7707,
  Dulux_65YY_84_081: 7708,
  Dulux_65YY_87_039: 7709,
  Dulux_65YY_89_088: 7710,
  Dulux_65YY_90_062: 7711,
  Dulux_66BG_68_157: 7712,
  Dulux_66RR_67_091: 7713,
  Dulux_66YR_33_286: 7714,
  Dulux_66YY_83_272: 7715,
  Dulux_66YY_85_231: 7716,
  Dulux_66YY_88_114: 7717,
  Dulux_67BB_14_216: 7718,
  Dulux_67RB_75_030: 7719,
  Dulux_67YR_56_055: 7720,
  Dulux_67YR_77_081: 7721,
  Dulux_67YY_51_608: 7722,
  Dulux_67YY_88_044: 7723,
  Dulux_67YY_89_124: 7724,
  Dulux_68GG_53_098: 7725,
  Dulux_68YR_28_701: 7726,
  Dulux_68YY_16_179: 7727,
  Dulux_68YY_83_339: 7728,
  Dulux_69BB_23_271: 7729,
  Dulux_69BG_77_076: 7730,
  Dulux_69GY_47_391: 7731,
  Dulux_69YR_39_474: 7732,
  Dulux_70BB_09_241: 7733,
  Dulux_70BB_21_147: 7734,
  Dulux_70BB_28_080: 7735,
  Dulux_70BB_33_202: 7736,
  Dulux_70BB_35_108: 7737,
  Dulux_70BB_40_062: 7738,
  Dulux_70BB_44_144: 7739,
  Dulux_70BB_49_082: 7740,
  Dulux_70BB_55_044: 7741,
  Dulux_70BB_64_035: 7742,
  Dulux_70BB_65_056: 7743,
  Dulux_70BB_67_096: 7744,
  Dulux_70BB_73_020: 7745,
  Dulux_70BB_73_030: 7746,
  Dulux_70BB_73_035: 7747,
  Dulux_70BB_83_020: 7748,
  Dulux_70BG_07_086: 7749,
  Dulux_70BG_10_214: 7750,
  Dulux_70BG_13_300: 7751,
  Dulux_70BG_14_243: 7752,
  Dulux_70BG_24_380: 7753,
  Dulux_70BG_28_060: 7754,
  Dulux_70BG_31_332: 7755,
  Dulux_70BG_32_238: 7756,
  Dulux_70BG_40_050: 7757,
  Dulux_70BG_40_284: 7758,
  Dulux_70BG_44_129: 7759,
  Dulux_70BG_47_182: 7760,
  Dulux_70BG_53_164: 7761,
  Dulux_70BG_59_124: 7762,
  Dulux_70BG_67_126: 7763,
  Dulux_70BG_70_113: 7764,
  Dulux_70BG_70_131: 7765,
  Dulux_70GG_09_223: 7766,
  Dulux_70GG_39_088: 7767,
  Dulux_70GG_39_303: 7768,
  Dulux_70GG_60_251: 7769,
  Dulux_70GG_72_045: 7770,
  Dulux_70GG_83_023: 7771,
  Dulux_70GY_10_136: 7772,
  Dulux_70GY_11_300: 7773,
  Dulux_70GY_11_387: 7774,
  Dulux_70GY_13_324: 7775,
  Dulux_70GY_14_187: 7776,
  Dulux_70GY_27_154: 7777,
  Dulux_70GY_30_254: 7778,
  Dulux_70GY_38_330: 7779,
  Dulux_70GY_49_201: 7780,
  Dulux_70GY_63_098: 7781,
  Dulux_70GY_65_166: 7782,
  Dulux_70GY_66_200: 7783,
  Dulux_70GY_72_025: 7784,
  Dulux_70GY_73_074: 7785,
  Dulux_70GY_73_124: 7786,
  Dulux_70GY_74_149: 7787,
  Dulux_70GY_74_173: 7788,
  Dulux_70GY_83_060: 7789,
  Dulux_70GY_83_080: 7790,
  Dulux_70GY_83_100: 7791,
  Dulux_70RB_16_220: 7792,
  Dulux_70RB_18_117: 7793,
  Dulux_70RB_23_280: 7794,
  Dulux_70RB_31_090: 7795,
  Dulux_70RB_50_062: 7796,
  Dulux_70RB_65_044: 7797,
  Dulux_70RB_67_067: 7798,
  Dulux_70RB_83_017: 7799,
  Dulux_70RB_83_026: 7800,
  Dulux_70RR_10_140: 7801,
  Dulux_70RR_10_250: 7802,
  Dulux_70RR_13_233: 7803,
  Dulux_70RR_13_380: 7804,
  Dulux_70RR_16_116: 7805,
  Dulux_70RR_19_190: 7806,
  Dulux_70RR_24_096: 7807,
  Dulux_70RR_25_338: 7808,
  Dulux_70RR_32_139: 7809,
  Dulux_70RR_38_246: 7810,
  Dulux_70RR_43_104: 7811,
  Dulux_70RR_52_120: 7812,
  Dulux_70RR_57_070: 7813,
  Dulux_70RR_66_072: 7814,
  Dulux_70RR_73_025: 7815,
  Dulux_70RR_74_051: 7816,
  Dulux_70RR_83_040: 7817,
  Dulux_70YR_07_093: 7818,
  Dulux_70YR_08_186: 7819,
  Dulux_70YR_09_086: 7820,
  Dulux_70YR_12_077: 7821,
  Dulux_70YR_13_140: 7822,
  Dulux_70YR_18_184: 7823,
  Dulux_70YR_19_432: 7824,
  Dulux_70YR_31_135: 7825,
  Dulux_70YR_45_261: 7826,
  Dulux_70YR_46_069: 7827,
  Dulux_70YR_56_190: 7828,
  Dulux_70YR_65_054: 7829,
  Dulux_70YR_68_118: 7830,
  Dulux_70YR_83_026: 7831,
  Dulux_70YR_83_034: 7832,
  Dulux_70YY_09_175: 7833,
  Dulux_70YY_18_152: 7834,
  Dulux_70YY_21_335: 7835,
  Dulux_70YY_26_137: 7836,
  Dulux_70YY_34_180: 7837,
  Dulux_70YY_37_296: 7838,
  Dulux_70YY_46_160: 7839,
  Dulux_70YY_50_383: 7840,
  Dulux_70YY_53_638: 7841,
  Dulux_70YY_55_299: 7842,
  Dulux_70YY_65_090: 7843,
  Dulux_70YY_66_130: 7844,
  Dulux_70YY_66_265: 7845,
  Dulux_70YY_66_510: 7846,
  Dulux_70YY_70_209: 7847,
  Dulux_70YY_73_288: 7848,
  Dulux_70YY_75_124: 7849,
  Dulux_70YY_79_407: 7850,
  Dulux_70YY_83_037: 7851,
  Dulux_70YY_83_150: 7852,
  Dulux_71BB_10_202: 7853,
  Dulux_71GG_07_179: 7854,
  Dulux_71GY_59_307: 7855,
  Dulux_71GY_65_301: 7856,
  Dulux_71RR_58_199: 7857,
  Dulux_71YY_87_078: 7858,
  Dulux_72BB_07_288: 7859,
  Dulux_72RR_07_173: 7860,
  Dulux_72RR_13_253: 7861,
  Dulux_72RR_78_058: 7862,
  Dulux_73BB_16_259: 7863,
  Dulux_73BG_64_122: 7864,
  Dulux_73GY_56_241: 7865,
  Dulux_73RB_08_259: 7866,
  Dulux_73YR_32_063: 7867,
  Dulux_74BB_58_090: 7868,
  Dulux_74BG_61_206: 7869,
  Dulux_74BG_73_042: 7870,
  Dulux_74GG_60_059: 7871,
  Dulux_74GY_15_043: 7872,
  Dulux_74RR_05_092: 7873,
  Dulux_74RR_28_432: 7874,
  Dulux_74RR_76_023: 7875,
  Dulux_74YR_68_064: 7876,
  Dulux_74YR_71_141: 7877,
  Dulux_75GG_27_095: 7878,
  Dulux_75GG_77_065: 7879,
  Dulux_75GY_81_005: 7880,
  Dulux_75YR_18_393: 7881,
  Dulux_75YR_27_487: 7882,
  Dulux_75YR_64_102: 7883,
  Dulux_75YY_55_509: 7884,
  Dulux_75YY_87_137: 7885,
  Dulux_76BG_72_113: 7886,
  Dulux_76RR_40_294: 7887,
  Dulux_76YR_27_558: 7888,
  Dulux_76YY_27_439: 7889,
  Dulux_76YY_39_616: 7890,
  Dulux_77BG_24_246: 7891,
  Dulux_77BG_57_234: 7892,
  Dulux_77GG_46_139: 7893,
  Dulux_77GG_82_044: 7894,
  Dulux_77GY_32_058: 7895,
  Dulux_77GY_33_506: 7896,
  Dulux_77GY_68_066: 7897,
  Dulux_77RR_16_420: 7898,
  Dulux_77RR_67_177: 7899,
  Dulux_77YR_14_306: 7900,
  Dulux_77YR_26_391: 7901,
  Dulux_77YY_19_297: 7902,
  Dulux_77YY_47_629: 7903,
  Dulux_77YY_52_604: 7904,
  Dulux_77YY_86_032: 7905,
  Dulux_78BG_12_032: 7906,
  Dulux_78GG_15_104: 7907,
  Dulux_78GG_19_160: 7908,
  Dulux_78GG_19_378: 7909,
  Dulux_78GG_21_381: 7910,
  Dulux_78GG_72_138: 7911,
  Dulux_78GG_79_109: 7912,
  Dulux_78RB_08_163: 7913,
  Dulux_78RR_54_274: 7914,
  Dulux_78RR_71_148: 7915,
  Dulux_78YR_39_576: 7916,
  Dulux_78YR_74_155: 7917,
  Dulux_78YY_83_048: 7918,
  Dulux_79BG_27_391: 7919,
  Dulux_79BG_66_110: 7920,
  Dulux_79GG_27_362: 7921,
  Dulux_79GG_53_131: 7922,
  Dulux_79GG_75_125: 7923,
  Dulux_79GY_36_106: 7924,
  Dulux_79GY_57_120: 7925,
  Dulux_79GY_59_017: 7926,
  Dulux_79RB_76_076: 7927,
  Dulux_79YR_19_096: 7928,
  Dulux_79YR_76_064: 7929,
  Dulux_79YY_27_188: 7930,
  Dulux_80BB_08_225: 7931,
  Dulux_80BG_39_354: 7932,
  Dulux_80GG_08_135: 7933,
  Dulux_80GG_09_164: 7934,
  Dulux_80GG_12_182: 7935,
  Dulux_80GG_19_231: 7936,
  Dulux_80GG_39_220: 7937,
  Dulux_80GG_63_184: 7938,
  Dulux_80GG_67_036: 7939,
  Dulux_80GY_11_195: 7940,
  Dulux_80GY_12_245: 7941,
  Dulux_80GY_50_031: 7942,
  Dulux_80RR_07_260: 7943,
  Dulux_80RR_10_306: 7944,
  Dulux_80RR_77_083: 7945,
  Dulux_80YR_11_151: 7946,
  Dulux_80YR_13_325: 7947,
  Dulux_80YR_17_129: 7948,
  Dulux_80YR_19_378: 7949,
  Dulux_80YR_20_488: 7950,
  Dulux_80YR_21_118: 7951,
  Dulux_80YR_27_147: 7952,
  Dulux_80YR_31_508: 7953,
  Dulux_80YR_32_489: 7954,
  Dulux_80YR_34_468: 7955,
  Dulux_80YR_35_383: 7956,
  Dulux_80YR_45_427: 7957,
  Dulux_80YR_46_243: 7958,
  Dulux_80YR_55_266: 7959,
  Dulux_80YR_57_179: 7960,
  Dulux_80YR_65_185: 7961,
  Dulux_80YR_67_085: 7962,
  Dulux_80YR_74_043: 7963,
  Dulux_80YR_75_057: 7964,
  Dulux_80YR_76_086: 7965,
  Dulux_80YR_83_026: 7966,
  Dulux_80YY_75_423: 7967,
  Dulux_81BB_22_273: 7968,
  Dulux_81BB_29_221: 7969,
  Dulux_81BG_09_241: 7970,
  Dulux_81BG_17_262: 7971,
  Dulux_81BG_60_128: 7972,
  Dulux_81GG_67_099: 7973,
  Dulux_81GY_15_202: 7974,
  Dulux_81RB_75_080: 7975,
  Dulux_81RR_47_323: 7976,
  Dulux_81RR_51_067: 7977,
  Dulux_81YR_06_003: 7978,
  Dulux_81YR_38_111: 7979,
  Dulux_81YR_77_022: 7980,
  Dulux_81YR_85_004: 7981,
  Dulux_81YY_73_041: 7982,
  Dulux_81YY_81_016: 7983,
  Dulux_82BG_79_062: 7984,
  Dulux_82GG_12_289: 7985,
  Dulux_82GY_19_152: 7986,
  Dulux_82GY_75_111: 7987,
  Dulux_82RB_53_154: 7988,
  Dulux_82RR_10_097: 7989,
  Dulux_82RR_18_114: 7990,
  Dulux_82RR_76_111: 7991,
  Dulux_82YR_55_140: 7992,
  Dulux_82YR_81_106: 7993,
  Dulux_82YY_67_046: 7994,
  Dulux_82YY_74_446: 7995,
  Dulux_83BB_07_202: 7996,
  Dulux_83BB_27_352: 7997,
  Dulux_83BG_55_097: 7998,
  Dulux_83GY_33_173: 7999,
  Dulux_83RB_13_268: 8000,
  Dulux_83RR_12_377: 8001,
  Dulux_83YR_44_540: 8002,
  Dulux_83YR_54_381: 8003,
  Dulux_83YR_62_211: 8004,
  Dulux_83YY_45_055: 8005,
  Dulux_83YY_88_033: 8006,
  Dulux_83YY_89_055: 8007,
  Dulux_84BB_53_136: 8008,
  Dulux_84BG_18_143: 8009,
  Dulux_84BG_66_028: 8010,
  Dulux_84RB_60_175: 8011,
  Dulux_84RB_69_108: 8012,
  Dulux_84RR_05_082: 8013,
  Dulux_84YR_46_409: 8014,
  Dulux_84YR_49_139: 8015,
  Dulux_85BG_59_064: 8016,
  Dulux_85GG_76_039: 8017,
  Dulux_85GY_10_193: 8018,
  Dulux_85RB_53_237: 8019,
  Dulux_85RR_75_032: 8020,
  Dulux_85YR_32_167: 8021,
  Dulux_85YR_38_700: 8022,
  Dulux_85YR_60_336: 8023,
  Dulux_85YY_74_012: 8024,
  Dulux_85YY_86_166: 8025,
  Dulux_85YY_89_109: 8026,
  Dulux_86BB_15_237: 8027,
  Dulux_86BG_43_321: 8028,
  Dulux_86RB_47_274: 8029,
  Dulux_86YR_49_493: 8030,
  Dulux_86YR_70_136: 8031,
  Dulux_86YY_77_295: 8032,
  Dulux_87BB_80_036: 8033,
  Dulux_87RR_12_095: 8034,
  Dulux_87YR_12_005: 8035,
  Dulux_87YR_67_204: 8036,
  Dulux_87YY_13_208: 8037,
  Dulux_87YY_85_110: 8038,
  Dulux_88BG_08_179: 8039,
  Dulux_88GG_32_346: 8040,
  Dulux_88RB_37_328: 8041,
  Dulux_88RR_18_464: 8042,
  Dulux_88YY_66_447: 8043,
  Dulux_88YY_71_380: 8044,
  Dulux_89BG_70_116: 8045,
  Dulux_89BG_72_060: 8046,
  Dulux_89RB_72_119: 8047,
  Dulux_89RB_79_040: 8048,
  Dulux_89YY_62_494: 8049,
  Dulux_89YY_78_269: 8050,
  Dulux_89YY_80_039: 8051,
  Dulux_90BB_09_186: 8052,
  Dulux_90BB_19_165: 8053,
  Dulux_90BB_19_267: 8054,
  Dulux_90BB_21_220: 8055,
  Dulux_90BB_26_227: 8056,
  Dulux_90BB_32_126: 8057,
  Dulux_90BB_34_167: 8058,
  Dulux_90BB_46_132: 8059,
  Dulux_90BB_53_129: 8060,
  Dulux_90BB_62_139: 8061,
  Dulux_90BB_73_022: 8062,
  Dulux_90BB_83_011: 8063,
  Dulux_90BB_83_020: 8064,
  Dulux_90BG_08_075: 8065,
  Dulux_90BG_11_262: 8066,
  Dulux_90BG_14_337: 8067,
  Dulux_90BG_17_120: 8068,
  Dulux_90BG_21_302: 8069,
  Dulux_90BG_28_213: 8070,
  Dulux_90BG_30_073: 8071,
  Dulux_90BG_31_124: 8072,
  Dulux_90BG_35_068: 8073,
  Dulux_90BG_42_106: 8074,
  Dulux_90BG_44_049: 8075,
  Dulux_90BG_56_125: 8076,
  Dulux_90BG_63_043: 8077,
  Dulux_90BG_72_088: 8078,
  Dulux_90BG_72_100: 8079,
  Dulux_90GG_15_398: 8080,
  Dulux_90GG_28_133: 8081,
  Dulux_90GG_30_195: 8082,
  Dulux_90GG_38_242: 8083,
  Dulux_90GG_40_115: 8084,
  Dulux_90GG_43_338: 8085,
  Dulux_90GG_51_211: 8086,
  Dulux_90GG_57_146: 8087,
  Dulux_90GG_74_092: 8088,
  Dulux_90GG_74_108: 8089,
  Dulux_90GG_83_011: 8090,
  Dulux_90GG_83_057: 8091,
  Dulux_90GG_83_069: 8092,
  Dulux_90GY_08_187: 8093,
  Dulux_90GY_16_151: 8094,
  Dulux_90GY_16_354: 8095,
  Dulux_90GY_21_472: 8096,
  Dulux_90GY_28_319: 8097,
  Dulux_90GY_29_121: 8098,
  Dulux_90GY_33_408: 8099,
  Dulux_90GY_35_238: 8100,
  Dulux_90GY_36_453: 8101,
  Dulux_90GY_46_056: 8102,
  Dulux_90GY_47_328: 8103,
  Dulux_90GY_48_234: 8104,
  Dulux_90GY_54_334: 8105,
  Dulux_90GY_64_072: 8106,
  Dulux_90GY_65_275: 8107,
  Dulux_90GY_67_146: 8108,
  Dulux_90GY_70_221: 8109,
  Dulux_90GY_72_040: 8110,
  Dulux_90GY_73_059: 8111,
  Dulux_90GY_76_158: 8112,
  Dulux_90GY_82_028: 8113,
  Dulux_90GY_83_033: 8114,
  Dulux_90GY_83_098: 8115,
  Dulux_90GY_83_104: 8116,
  Dulux_90RB_08_113: 8117,
  Dulux_90RB_12_225: 8118,
  Dulux_90RB_23_228: 8119,
  Dulux_90RB_37_175: 8120,
  Dulux_90RB_68_085: 8121,
  Dulux_90RB_75_051: 8122,
  Dulux_90RB_83_015: 8123,
  Dulux_90RB_83_023: 8124,
  Dulux_90RB_83_026: 8125,
  Dulux_90RB_83_030: 8126,
  Dulux_90RR_11_257: 8127,
  Dulux_90RR_16_298: 8128,
  Dulux_90RR_16_386: 8129,
  Dulux_90RR_28_245: 8130,
  Dulux_90RR_31_100: 8131,
  Dulux_90RR_31_403: 8132,
  Dulux_90RR_35_060: 8133,
  Dulux_90RR_41_258: 8134,
  Dulux_90RR_52_214: 8135,
  Dulux_90RR_55_138: 8136,
  Dulux_90RR_58_177: 8137,
  Dulux_90RR_62_124: 8138,
  Dulux_90RR_64_025: 8139,
  Dulux_90RR_69_101: 8140,
  Dulux_90RR_73_027: 8141,
  Dulux_90RR_76_062: 8142,
  Dulux_90RR_83_009: 8143,
  Dulux_90RR_83_013: 8144,
  Dulux_90RR_83_021: 8145,
  Dulux_90RR_83_030: 8146,
  Dulux_90YR_06_001: 8147,
  Dulux_90YR_10_151: 8148,
  Dulux_90YR_19_487: 8149,
  Dulux_90YR_26_147: 8150,
  Dulux_90YR_31_605: 8151,
  Dulux_90YR_33_167: 8152,
  Dulux_90YR_34_084: 8153,
  Dulux_90YR_34_468: 8154,
  Dulux_90YR_34_561: 8155,
  Dulux_90YR_41_179: 8156,
  Dulux_90YR_41_472: 8157,
  Dulux_90YR_43_101: 8158,
  Dulux_90YR_46_346: 8159,
  Dulux_90YR_51_109: 8160,
  Dulux_90YR_53_132: 8161,
  Dulux_90YR_54_440: 8162,
  Dulux_90YR_55_266: 8163,
  Dulux_90YR_57_293: 8164,
  Dulux_90YR_59_108: 8165,
  Dulux_90YR_64_040: 8166,
  Dulux_90YR_64_166: 8167,
  Dulux_90YR_67_085: 8168,
  Dulux_90YR_72_159: 8169,
  Dulux_90YR_74_057: 8170,
  Dulux_90YR_77_115: 8171,
  Dulux_90YR_81_058: 8172,
  Dulux_90YR_83_044: 8173,
  Dulux_90YR_83_070: 8174,
  Dulux_90YY_07_093: 8175,
  Dulux_90YY_15_279: 8176,
  Dulux_90YY_19_075: 8177,
  Dulux_90YY_21_371: 8178,
  Dulux_90YY_35_304: 8179,
  Dulux_90YY_48_255: 8180,
  Dulux_90YY_48_500: 8181,
  Dulux_90YY_54_254: 8182,
  Dulux_90YY_58_424: 8183,
  Dulux_90YY_67_117: 8184,
  Dulux_90YY_69_419: 8185,
  Dulux_90YY_72_225: 8186,
  Dulux_90YY_83_107: 8187,
  Dulux_90YY_83_143: 8188,
  Dulux_90YY_83_179: 8189,
  Dulux_91BB_07_263: 8190,
  Dulux_91RR_51_304: 8191,
  Dulux_91YR_10_089: 8192,
  Dulux_91YY_23_374: 8193,
  Dulux_91YY_40_628: 8194,
  Dulux_91YY_82_235: 8195,
  Dulux_91YY_88_072: 8196,
  Dulux_92BG_08_031: 8197,
  Dulux_92GG_59_245: 8198,
  Dulux_92YY_46_608: 8199,
  Dulux_92YY_51_593: 8200,
  Dulux_92YY_59_547: 8201,
  Dulux_92YY_69_401: 8202,
  Dulux_93BG_18_066: 8203,
  Dulux_93GY_24_024: 8204,
  Dulux_93RB_27_376: 8205,
  Dulux_93RR_70_157: 8206,
  Dulux_93YR_22_305: 8207,
  Dulux_93YR_80_033: 8208,
  Dulux_93YR_86_030: 8209,
  Dulux_93YY_52_598: 8210,
  Dulux_93YY_89_012: 8211,
  Dulux_94RB_60_214: 8212,
  Dulux_94RR_28_490: 8213,
  Dulux_94YR_40_219: 8214,
  Dulux_94YY_83_072: 8215,
  Dulux_95BG_23_044: 8216,
  Dulux_95BG_49_025: 8217,
  Dulux_95GG_78_054: 8218,
  Dulux_95RB_56_237: 8219,
  Dulux_95RB_71_132: 8220,
  Dulux_95RR_07_271: 8221,
  Dulux_95RR_36_390: 8222,
  Dulux_95YY_39_329: 8223,
  Dulux_96RB_22_393: 8224,
  Dulux_96YR_09_033: 8225,
  Dulux_96YR_46_065: 8226,
  Dulux_96YR_46_632: 8227,
  Dulux_96YY_53_200: 8228,
  Dulux_96YY_66_036: 8229,
  Dulux_97GY_07_135: 8230,
  Dulux_97RB_77_086: 8231,
  Dulux_97YR_39_118: 8232,
  Dulux_97YR_54_511: 8233,
  Dulux_97YY_83_090: 8234,
  Dulux_98BG_45_237: 8235,
  Dulux_98YR_26_291: 8236,
  Dulux_98YR_53_235: 8237,
  Dulux_98YR_78_041: 8238,
  Dulux_99BG_22_432: 8239,
  Dulux_99BG_62_159: 8240,
  Dulux_99YR_23_456: 8241,
  Dulux_99YR_61_205: 8242,
  Dulux_99YR_63_283: 8243,
  Dulux_99YR_83_059: 8244,
  Dulux_99YR_85_075: 8245,
  Dulux_99YY_77_080: 8246,
  Dulux_99YY_82_124: 8247,
  Dulux_AbaloneSands: 8248,
  Dulux_AbsoluteWhite: 8249,
  Dulux_AcaiBerry: 8250,
  Dulux_AcornCap: 8251,
  Dulux_ActiveOrange: 8252,
  Dulux_AgedBronze: 8253,
  Dulux_AgedIvory: 8254,
  Dulux_AlabasterWhite: 8255,
  Dulux_Almond: 8256,
  Dulux_AlmondButter: 8257,
  Dulux_AlmondWhite: 8258,
  Dulux_AlmostBlack: 8259,
  Dulux_AlmostOyster: 8260,
  Dulux_Alpine: 8261,
  Dulux_AlpineFlowers: 8262,
  Dulux_AlpineForest: 8263,
  Dulux_AltaVista: 8264,
  Dulux_AmazonianGreen: 8265,
  Dulux_AmberSpirit: 8266,
  Dulux_AmethystStarling: 26118,
  Dulux_AncientArtefact: 8267,
  Dulux_AncientSandstone: 8268,
  Dulux_Angora: 8269,
  Dulux_AngoraBlanket: 8270,
  Dulux_AntarcticStorm: 8271,
  Dulux_Antelope: 8272,
  Dulux_AntiqueMap: 26119,
  Dulux_Appledore: 8273,
  Dulux_AppleWhite: 8274,
  Dulux_Apricot: 8275,
  Dulux_ApricotCrush: 8276,
  Dulux_ApricotWhite: 8277,
  Dulux_AprilPosy: 8278,
  Dulux_AqSpanishBrown: 8279,
  Dulux_AquaSash: 8280,
  Dulux_ArchivePapers: 8281,
  Dulux_ArcticPebble: 8282,
  Dulux_ArizonaTumbleweed: 8283,
  Dulux_ArtistsBrush: 8284,
  Dulux_AshenWhite: 26120,
  Dulux_AshRose: 8285,
  Dulux_AshWhite: 8286,
  Dulux_AtlanticBlue: 26121,
  Dulux_AtlasBlue: 8287,
  Dulux_Atmosphere: 8288,
  Dulux_AubergineKiss: 8289,
  Dulux_AuburnEmbers: 8290,
  Dulux_AutumnEmbrace: 8291,
  Dulux_Aviator: 8292,
  Dulux_Azalea: 8293,
  Dulux_Aztec: 8294,
  Dulux_BakedAubergine: 8295,
  Dulux_BakersFlour: 8296,
  Dulux_BallerinaDance: 8297,
  Dulux_Balsa: 8298,
  Dulux_Bamboo: 8299,
  Dulux_BambooStem: 8300,
  Dulux_BananaSplit: 8301,
  Dulux_BarleyTwist: 26122,
  Dulux_BarleyWhite: 8302,
  Dulux_Barleywood: 8303,
  Dulux_BasicallyBlack: 8304,
  Dulux_BathstoneBeige: 8305,
  Dulux_BayHorse: 8306,
  Dulux_BayView: 8307,
  Dulux_BeachBlue: 8308,
  Dulux_BeachcombGrey: 8309,
  Dulux_BeachGrass: 8310,
  Dulux_BeachWalk: 8311,
  Dulux_BeaumontBlue: 8312,
  Dulux_Beaver: 8313,
  Dulux_BerryBlast: 8314,
  Dulux_BerryKiss: 8315,
  Dulux_BerryPop: 8316,
  Dulux_BerrySmoothie: 8317,
  Dulux_BerryWhip: 8318,
  Dulux_Billow: 8319,
  Dulux_BirchRoot: 8320,
  Dulux_BiscuitBeige: 8321,
  Dulux_Bison: 8322,
  Dulux_Black: 8323,
  Dulux_BlackAsh: 8324,
  Dulux_BlackberryBush: 8325,
  Dulux_BlackcurrantJam: 8326,
  Dulux_BlackOpal: 8327,
  Dulux_BlackthornBlue: 8328,
  Dulux_BlanketBox: 8329,
  Dulux_Bleaches: 10308,
  Dulux_BlissfulBlue: 8330,
  Dulux_BloodOrange: 8331,
  Dulux_BlossomTree: 8332,
  Dulux_BlossomWhite: 8333,
  Dulux_Blue: 26123,
  Dulux_BlueAgave: 8334,
  Dulux_BlueBabe: 8335,
  Dulux_Bluebell: 8336,
  Dulux_Blueberry: 8337,
  Dulux_BlueberryIcing: 8338,
  Dulux_BlueberrySurprise: 8339,
  Dulux_BlueberryWhite: 8340,
  Dulux_BluebirdSkies: 8341,
  Dulux_BlueChalk: 8342,
  Dulux_BlueDelphinium: 8343,
  Dulux_BlueIncense: 8344,
  Dulux_BlueLagoon: 26124,
  Dulux_BlueReflection: 26125,
  Dulux_BlueRibbon: 8345,
  Dulux_BlueSaturn: 8346,
  Dulux_BlueSlate: 8347,
  Dulux_BlueThistle: 8348,
  Dulux_BlueView: 8349,
  Dulux_BlushedPearl: 8350,
  Dulux_BlushPink: 8351,
  Dulux_BoathouseBlue: 8352,
  Dulux_BohoBlush: 8353,
  Dulux_Bombe: 8354,
  Dulux_BoneChina: 26126,
  Dulux_BorrowedBlue: 8355,
  Dulux_BoutiqueCream: 26127,
  Dulux_BowlerHat: 26128,
  Dulux_Bracken: 8356,
  Dulux_Braemar: 8357,
  Dulux_BrambleRamble: 8358,
  Dulux_BrassBell: 8359,
  Dulux_BrassBuckle: 8360,
  Dulux_BraveGround: 8361,
  Dulux_BretonBlue: 26129,
  Dulux_BrickRed: 26130,
  Dulux_BrightSkies: 8362,
  Dulux_Brownstone: 8363,
  Dulux_BrushedBuckle: 8364,
  Dulux_BrushedGold: 8365,
  Dulux_Buckingham: 26131,
  Dulux_Buff: 8366,
  Dulux_BuriedTreasure: 8367,
  Dulux_BurnishedBrass: 8368,
  Dulux_BurnishedCopper: 8369,
  Dulux_ButterBiscuit: 26132,
  Dulux_ButterCup: 8370,
  Dulux_ButtercupBlast: 8371,
  Dulux_ButteredCorn: 8372,
  Dulux_Buttermilk: 8373,
  Dulux_ButterscotchSyrup: 8374,
  Dulux_CacaoNibs: 8375,
  Dulux_Calendula: 8376,
  Dulux_CaliforniaCool: 8377,
  Dulux_CaliforniaDays: 8378,
  Dulux_CalmClouds: 8379,
  Dulux_CalmingMeadow: 8380,
  Dulux_Cameo: 8381,
  Dulux_CandiedOrange: 8382,
  Dulux_CandleCream: 8383,
  Dulux_CandyCream: 8384,
  Dulux_Candytuft: 8385,
  Dulux_CannonBall: 8386,
  Dulux_CaperGreen: 8387,
  Dulux_CapeSalmon: 8388,
  Dulux_Capricorn: 8389,
  Dulux_CaramelCream: 26133,
  Dulux_CaramelCrunch: 8390,
  Dulux_CaramelFudge: 8391,
  Dulux_CaramelLatte: 8392,
  Dulux_CardamomPod: 8393,
  Dulux_CashewNut: 8394,
  Dulux_Catkin: 8395,
  Dulux_CedarGlow: 8396,
  Dulux_CeleryLeaf: 8397,
  Dulux_CelticCream: 26134,
  Dulux_CeremonialBlue: 8398,
  Dulux_ChalkDust: 8399,
  Dulux_ChalkWhite: 8400,
  Dulux_Champagne: 8401,
  Dulux_ChampagneGlory: 8402,
  Dulux_Champignon: 10311,
  Dulux_CherishedGold: 8403,
  Dulux_CherishedRibbon: 8404,
  Dulux_CherryChocolate: 8405,
  Dulux_CherryPlum: 8406,
  Dulux_CherryTruffle: 8407,
  Dulux_ChicShadow: 8408,
  Dulux_ChiffonSilk: 8409,
  Dulux_ChilliPepper: 8410,
  Dulux_ChilternWhite: 8411,
  Dulux_ChinaWhite: 8412,
  Dulux_ChineseApple: 8413,
  Dulux_ChineseMulberry: 8414,
  Dulux_Chive: 8415,
  Dulux_ChocolateBombe: 8416,
  Dulux_ChocolateFountain: 8417,
  Dulux_Cinnamon: 8418,
  Dulux_CinnamonSprinkle: 8419,
  Dulux_CinnamonStick: 8420,
  Dulux_Cirrus: 8421,
  Dulux_Citrine: 8422,
  Dulux_CitronPeel: 8423,
  Dulux_CitrusSorbet: 8424,
  Dulux_CitrusZing: 8425,
  Dulux_CityFog: 8426,
  Dulux_ClassicCream: 26135,
  Dulux_ClearSkies: 8427,
  Dulux_CliffWalk: 8428,
  Dulux_ClockFace: 8429,
  Dulux_CloudedDawn: 8430,
  Dulux_CloudlessSky: 8431,
  Dulux_CloudyDreams: 8432,
  Dulux_CoastalBreeze: 8433,
  Dulux_CoastalGlow: 8434,
  Dulux_CoastalGrey: 8435,
  Dulux_CoastalMist: 8436,
  Dulux_CobaltEmbrace: 8437,
  Dulux_CobaltNight: 8438,
  Dulux_CobbleCove: 8439,
  Dulux_CocoaButter: 8440,
  Dulux_CocoaMist: 8441,
  Dulux_CocoaPod: 8442,
  Dulux_CocoaPowder: 26136,
  Dulux_CollectiveCoral: 26137,
  Dulux_CommonDormouse: 8443,
  Dulux_CommonLand: 8444,
  Dulux_ConcreteGrey: 8445,
  Dulux_ConfettiPaper: 8446,
  Dulux_Conifer: 8447,
  Dulux_Conker: 26138,
  Dulux_CookieDough: 8448,
  Dulux_CoolMarble: 8449,
  Dulux_CopenhagenBlue: 8450,
  Dulux_Copperbeech: 8451,
  Dulux_CopperBlush: 8452,
  Dulux_CopperBrown: 8453,
  Dulux_CopperGlow: 8454,
  Dulux_CoralCaress: 8455,
  Dulux_CoralCharm: 8456,
  Dulux_CoralFlair: 8457,
  Dulux_CoralLustre: 8458,
  Dulux_CoralPink: 8459,
  Dulux_CoralPolka: 8460,
  Dulux_CoralSplash: 8461,
  Dulux_Cornflower: 8462,
  Dulux_CornflowerBunch: 8463,
  Dulux_CornflowerWhite: 8464,
  Dulux_CornishClay: 8465,
  Dulux_CornishCream: 26139,
  Dulux_CosmosFlower: 8466,
  Dulux_CosyCashmere: 8467,
  Dulux_CottonBreeze: 8468,
  Dulux_CottonCream: 26140,
  Dulux_CottonSoft: 8469,
  Dulux_CottonThread: 8470,
  Dulux_CountryBoots: 8471,
  Dulux_CountryCream: 8472,
  Dulux_CountrySky: 8473,
  Dulux_CountryTweed: 8474,
  Dulux_CountyCream: 8475,
  Dulux_CowslipFlower: 8476,
  Dulux_CoyoteGrey: 8477,
  Dulux_CranberryCrunch: 8478,
  Dulux_Cream: 8479,
  Dulux_CreamBun: 8480,
  Dulux_CreamRose: 8481,
  Dulux_CreamTea: 26141,
  Dulux_CrispyCrumble: 26142,
  Dulux_CroatianStones: 8482,
  Dulux_CrushedAloe: 8483,
  Dulux_CrushedChilli: 8484,
  Dulux_CucumberWater: 8485,
  Dulux_CustardCream: 8486,
  Dulux_CygnetFeather: 8487,
  Dulux_CyprusGreen: 8488,
  Dulux_DaffodilWhite: 8489,
  Dulux_DamsonDusk: 8490,
  Dulux_Dancetime: 8491,
  Dulux_DanishBlue: 8492,
  Dulux_DarkAcacia: 8493,
  Dulux_DarkAubergine: 8494,
  Dulux_DarkGarnet: 8495,
  Dulux_DarkHickory: 8496,
  Dulux_DarkMaple: 8497,
  Dulux_DarkPoplar: 8498,
  Dulux_DarkStone: 8499,
  Dulux_DawnZest: 8500,
  Dulux_DazzlingYellow: 8501,
  Dulux_DecadentDamson: 8502,
  Dulux_DeepAubergine: 26143,
  Dulux_DeepestAmethyst: 8503,
  Dulux_DeepFossil: 8504,
  Dulux_DeepRouge: 8505,
  Dulux_DeepRusset: 8506,
  Dulux_DeepUltramarine: 8507,
  Dulux_DelftChina: 8508,
  Dulux_DelicateCornflower: 8509,
  Dulux_DelicateSeashell: 26144,
  Dulux_DelicateVeil: 8510,
  Dulux_DenimDrift: 8511,
  Dulux_DesertDusk: 8512,
  Dulux_DesertWind: 8513,
  Dulux_DewyLawn: 8514,
  Dulux_DHBlossom: 8515,
  Dulux_DHDrab: 8516,
  Dulux_DHGrassGreen: 8517,
  Dulux_DHIndigo: 8518,
  Dulux_DHLinenColour: 8519,
  Dulux_DHOxfordBlue_Heritage: 8520,
  Dulux_DHPearlColour: 8521,
  Dulux_DHSlate: 8522,
  Dulux_DHStone: 8523,
  Dulux_DHWhite: 8524,
  Dulux_Dieskau: 10310,
  Dulux_DippedChocolate: 8525,
  Dulux_Dollshouse: 8526,
  Dulux_Dolphin: 8527,
  Dulux_DomPedro: 8528,
  Dulux_Dove: 8529,
  Dulux_DoveSlate: 26145,
  Dulux_DoveWhite: 8530,
  Dulux_Dresden: 8531,
  Dulux_DriedLavender: 8532,
  Dulux_DriedRoses: 8533,
  Dulux_DriedSage: 8534,
  Dulux_DriftingCloud: 8535,
  Dulux_DrumHide: 8536,
  Dulux_Duckegg: 8537,
  Dulux_DuluxAmericanMahogany: 8538,
  Dulux_DuluxAntiqueMahogany: 8539,
  Dulux_DuluxAntiquePine: 8540,
  Dulux_DuluxAntiqueRosewood: 8541,
  Dulux_DuluxAntiqueWalnut: 8542,
  Dulux_DuluxBrazilianRosewood: 8543,
  Dulux_DuluxCherryMahogany: 8544,
  Dulux_DuluxEbony: 8545,
  Dulux_DuluxHeritageOak: 8546,
  Dulux_DuluxLightOak: 8547,
  Dulux_DuluxMahogany: 8548,
  Dulux_DuluxNewPine: 8549,
  Dulux_DuluxNewRosewood: 8550,
  Dulux_DuluxPine: 8551,
  Dulux_DuluxRichMahogany: 8552,
  Dulux_DuluxRichOak: 8553,
  Dulux_DuluxRichPine: 8554,
  Dulux_DuluxRichTeak: 8555,
  Dulux_DuluxRosewood: 8556,
  Dulux_DuluxTeak: 8557,
  Dulux_DuluxWalnut: 8558,
  Dulux_DuneGrass: 8559,
  Dulux_DuskyGem: 8560,
  Dulux_DustedCappuccino: 26146,
  Dulux_DustedDamson: 26147,
  Dulux_DustedFondant: 8561,
  Dulux_DustedHeather: 8562,
  Dulux_DustyDenim: 8563,
  Dulux_DynamiteRed: 8564,
  Dulux_EarlBlue: 8565,
  Dulux_EarthsCore: 8566,
  Dulux_EasternSilks: 8567,
  Dulux_EbonyForest: 8568,
  Dulux_EdelweissWhite: 8569,
  Dulux_EgyptianCotton: 8570,
  Dulux_ElderberryWine: 8571,
  Dulux_Elderflower: 8572,
  Dulux_ElderflowerTea: 8573,
  Dulux_ElectricStorm: 8574,
  Dulux_EmbassyPurple: 8575,
  Dulux_EmeraldGlade: 8576,
  Dulux_EmeraldSlate: 8577,
  Dulux_EmeraldStone: 8578,
  Dulux_Empathy: 8579,
  Dulux_EnchantedEden: 26148,
  Dulux_EnglishBarn: 8580,
  Dulux_EnglishElm: 8581,
  Dulux_EngravedLocket: 26149,
  Dulux_EnrichedEarths: 8582,
  Dulux_EveningBarley: 26150,
  Dulux_EvergladeForest: 8583,
  Dulux_Extravagance: 8584,
  Dulux_FadedBloom: 8585,
  Dulux_FadedDamson: 8586,
  Dulux_FadedIndigo: 8587,
  Dulux_FadedLeaf: 8588,
  Dulux_FadedPetal: 8589,
  Dulux_FadedSky: 8590,
  Dulux_Fairfields: 8591,
  Dulux_FallenBurr: 8592,
  Dulux_FallenWildflower: 8593,
  Dulux_FandangoFun: 8594,
  Dulux_FantasyLand: 8595,
  Dulux_FeatherFlock: 26151,
  Dulux_FennelWhite: 8596,
  Dulux_FernGully: 8597,
  Dulux_FineCream: 8598,
  Dulux_FinestBurgundy: 8599,
  Dulux_FinestTurquoise: 8600,
  Dulux_FiresideEmbers: 8601,
  Dulux_FireWood: 8602,
  Dulux_FirForest: 8603,
  Dulux_FirstDawn: 8604,
  Dulux_FirstFrost: 26152,
  Dulux_FirstLeaves: 8605,
  Dulux_FitzroviaRed: 8606,
  Dulux_FjordBlue: 8607,
  Dulux_FlakeGrey: 8608,
  Dulux_FlamingoFlock: 8609,
  Dulux_Flax: 8610,
  Dulux_FlaxSeed: 8611,
  Dulux_Flint: 8612,
  Dulux_FlintArrow: 8613,
  Dulux_FloatingPetal: 8614,
  Dulux_FlorentineRed: 8615,
  Dulux_Florida: 8616,
  Dulux_FolkTales: 8617,
  Dulux_Fontana: 8618,
  Dulux_ForestDusks: 8619,
  Dulux_ForestFestival: 8620,
  Dulux_ForestGrey: 8621,
  Dulux_ForestMushroom: 8622,
  Dulux_ForestPine: 8623,
  Dulux_ForestShade: 8624,
  Dulux_ForgetMeNot: 8625,
  Dulux_Forsythia: 8626,
  Dulux_FortuneGreen: 8627,
  Dulux_FossilHunting: 8628,
  Dulux_FossilTrace: 8629,
  Dulux_Fragile: 8630,
  Dulux_FragileBlossom: 8631,
  Dulux_FragrantHerb: 8632,
  Dulux_FragrantPeony: 8633,
  Dulux_Francesca: 8634,
  Dulux_FreeDive: 8635,
  Dulux_FrenchOak: 8636,
  Dulux_FrenchTruffle: 8637,
  Dulux_FreshAloe: 8638,
  Dulux_FreshArtichoke: 8639,
  Dulux_FreshCitrusMint: 8640,
  Dulux_FreshDaisy: 8641,
  Dulux_FreshFlour: 8642,
  Dulux_FreshFoliage: 8643,
  Dulux_FreshPea: 8644,
  Dulux_FreshPine: 8645,
  Dulux_FreshPlaster: 8646,
  Dulux_FreshRosemary: 8647,
  Dulux_FreshSage: 26153,
  Dulux_FreshSlate: 26154,
  Dulux_FreshStem: 8648,
  Dulux_FreshSurf: 8649,
  Dulux_FrostedDawn: 8650,
  Dulux_FrostedGlass: 8651,
  Dulux_FrostedGrape: 8652,
  Dulux_FrostedLake: 26155,
  Dulux_FrostedPapaya: 8653,
  Dulux_FrostedSteel: 8654,
  Dulux_FuschiaLily: 26156,
  Dulux_GallantGrey: 26157,
  Dulux_GardenGrey: 8655,
  Dulux_Gardenia: 8656,
  Dulux_Garland: 8657,
  Dulux_GatedForest: 8658,
  Dulux_GentleFawn: 8659,
  Dulux_GentleLavender: 8660,
  Dulux_GentleMoon: 8661,
  Dulux_GingernutCrumb: 8662,
  Dulux_GlacialFlow: 8663,
  Dulux_GlacialSpring: 8664,
  Dulux_Goldcup: 8665,
  Dulux_GoldenBrick: 8666,
  Dulux_GoldenCookie: 8667,
  Dulux_GoldenEgg: 8668,
  Dulux_GoldenIvory: 8669,
  Dulux_GoldenLight: 8670,
  Dulux_GoldenSands: 8671,
  Dulux_GooseDown: 8672,
  Dulux_Goosewing: 8673,
  Dulux_GracefulGreen: 26158,
  Dulux_GrasshopperGreen: 8674,
  Dulux_GrecianWhite: 8675,
  Dulux_Green: 26159,
  Dulux_GreenClay: 8676,
  Dulux_GreenEarth: 8677,
  Dulux_GreenGlade: 26160,
  Dulux_GreenIvy: 26161,
  Dulux_GreenMarl: 8678,
  Dulux_GreenOrchid: 8679,
  Dulux_GreenOxide: 8680,
  Dulux_GreenSlate: 8681,
  Dulux_Greyfriar: 8682,
  Dulux_GreySplendor: 8683,
  Dulux_GreyTaupe: 8684,
  Dulux_GreyWisp: 8685,
  Dulux_GroundNutmeg: 8686,
  Dulux_GuildGreen: 8687,
  Dulux_Gypsophila: 8688,
  Dulux_HamptonsSummer: 8689,
  Dulux_HarvestDusk: 8690,
  Dulux_HayBale: 26162,
  Dulux_HayLoft: 8691,
  Dulux_HazelnutTruffle: 26163,
  Dulux_HazyMorning: 8692,
  Dulux_HealingSpice: 8693,
  Dulux_HeartWood: 8694,
  Dulux_Heather: 8695,
  Dulux_HeatherClimb: 26164,
  Dulux_HeatherSolstice: 8696,
  Dulux_Heathland: 26165,
  Dulux_HempCloth: 8697,
  Dulux_Heron: 8698,
  Dulux_HighlandGreen: 26166,
  Dulux_HighlandMarsh: 8699,
  Dulux_HighlandMist: 8700,
  Dulux_HighSummer: 8701,
  Dulux_Highwire: 8702,
  Dulux_Holly: 8703,
  Dulux_Hollybush: 8704,
  Dulux_HonestIndigo: 8705,
  Dulux_HoneyBeam: 8706,
  Dulux_HoneyBrown: 8707,
  Dulux_HoneyMango: 8708,
  Dulux_Honeymoon: 8709,
  Dulux_HoneyMustard: 8710,
  Dulux_HoneyNut: 8711,
  Dulux_Honeysuckle: 8712,
  Dulux_Hopsack: 8713,
  Dulux_HorizonView: 8714,
  Dulux_Hullabaloo: 8715,
  Dulux_IcedFrappe: 8716,
  Dulux_IcedGem: 8717,
  Dulux_IcingSugar: 8718,
  Dulux_ImminentDawn: 8719,
  Dulux_IncaOrange: 8720,
  Dulux_IndianSandstone: 8721,
  Dulux_IndianWhite: 8722,
  Dulux_IndigoShade: 8723,
  Dulux_InkWash: 8724,
  Dulux_InkWell: 8725,
  Dulux_InkyStone: 8726,
  Dulux_IntenseChestnut: 26167,
  Dulux_IntenseTruffle: 26168,
  Dulux_Iris: 8727,
  Dulux_IrisBouquet: 8728,
  Dulux_Ironstone: 8729,
  Dulux_Ivory: 8730,
  Dulux_IvoryLace: 8731,
  Dulux_IvyLeaf: 8732,
  Dulux_JadeWhite: 8733,
  Dulux_JapaneseBlossom: 8734,
  Dulux_JasmineBlush: 8735,
  Dulux_JasmineShimmer: 8736,
  Dulux_JasmineWhite: 8737,
  Dulux_Javelin: 8738,
  Dulux_JennyWren: 8739,
  Dulux_Jonquil: 8740,
  Dulux_JuicyGrape: 8741,
  Dulux_JuicyPear: 8742,
  Dulux_JungleLagoon: 8743,
  Dulux_JungleTrail: 8744,
  Dulux_Juniper: 8745,
  Dulux_JurassicStone: 26169,
  Dulux_JustWalnut: 8746,
  Dulux_KalahariSands: 8747,
  Dulux_KiwiCrush: 8748,
  Dulux_KiwiGreen: 8749,
  Dulux_KnottedTwine: 8750,
  Dulux_LabradorBrown: 8751,
  Dulux_LadyPenelope: 8752,
  Dulux_LagoonFalls: 8753,
  Dulux_LakeSunset: 8754,
  Dulux_LambsWool: 8755,
  Dulux_Larkspur: 8756,
  Dulux_Lavender: 8757,
  Dulux_LavenderChalk: 8758,
  Dulux_LavenderDrop: 8759,
  Dulux_LavenderFrost: 8760,
  Dulux_LavenderGrey: 8761,
  Dulux_LavenderQuartz: 8762,
  Dulux_LavishLilac: 8763,
  Dulux_LeadGrey: 8764,
  Dulux_LeadWhite: 8765,
  Dulux_LeapFrog: 8766,
  Dulux_LeatherCase: 8767,
  Dulux_LemonJester: 8768,
  Dulux_LemonPeel: 8769,
  Dulux_LemonPie: 8770,
  Dulux_LemonPunch: 8771,
  Dulux_LemonSlice: 8772,
  Dulux_LemonSpirit: 8773,
  Dulux_LemonSyllabub: 8774,
  Dulux_LemonTropics: 8775,
  Dulux_LemonZest: 8776,
  Dulux_LettersUnread: 8777,
  Dulux_Lido: 8778,
  Dulux_LightCobalt: 8779,
  Dulux_LightFrenchGrey: 8780,
  Dulux_LightTeal: 8781,
  Dulux_LilacEcho: 8782,
  Dulux_LilacFancy: 8783,
  Dulux_LilacGrey: 8784,
  Dulux_LilacOrchid: 8785,
  Dulux_LilacRose: 8786,
  Dulux_LilacSapphire: 8787,
  Dulux_LilacSkies: 8788,
  Dulux_Lime: 26170,
  Dulux_LimeCordial: 8789,
  Dulux_LimeJelly: 8790,
  Dulux_Limelight: 8791,
  Dulux_LimePeel: 8792,
  Dulux_LimeSoda: 8793,
  Dulux_Limoncella: 8794,
  Dulux_Linden: 8795,
  Dulux_LinenWhite: 8796,
  Dulux_LinnetWhite: 8797,
  Dulux_Lizard: 8798,
  Dulux_Loganberry: 8799,
  Dulux_LostCoral: 8800,
  Dulux_LostLagoon: 8801,
  Dulux_LostLake: 26171,
  Dulux_LoveLetter: 8802,
  Dulux_LoveNote: 26172,
  Dulux_LuckyPenny: 8803,
  Dulux_LunaLight: 8804,
  Dulux_LunarFalls: 8805,
  Dulux_LunarLanding: 8806,
  Dulux_LusciousLime: 8807,
  Dulux_LushGrass: 8808,
  Dulux_Mace: 8809,
  Dulux_Magnolia: 8810,
  Dulux_MaldiveDream: 8811,
  Dulux_MallardGreen: 8812,
  Dulux_Mallow: 8813,
  Dulux_MallowWhite: 8814,
  Dulux_MaltChocolate: 8815,
  Dulux_MaltedBarley: 8816,
  Dulux_MaltedCaramel: 8817,
  Dulux_ManukaHoneybee: 8818,
  Dulux_MaplewoodTrail: 8819,
  Dulux_MarbleWhite: 8820,
  Dulux_MarigoldCheer: 8821,
  Dulux_MarineSplash: 8822,
  Dulux_MaritimeTeal: 8823,
  Dulux_MarmaladePreserve: 8824,
  Dulux_MaskedBall: 8825,
  Dulux_MastersGold: 8826,
  Dulux_MatchaGrey: 8827,
  Dulux_Mauve: 8828,
  Dulux_MauveCloud: 8829,
  Dulux_MauveMist: 8830,
  Dulux_Meadowsweet: 8831,
  Dulux_MediterraneanGlaze: 8832,
  Dulux_MediterraneanGreen: 8833,
  Dulux_MellowMocha: 8834,
  Dulux_MellowMoss: 8835,
  Dulux_MelonSorbet: 8836,
  Dulux_Merlin: 8837,
  Dulux_Midnight: 8838,
  Dulux_MidnightGarden: 8839,
  Dulux_MidnightJazz: 8840,
  Dulux_MidnightSecret: 8841,
  Dulux_MidnightTeal: 8842,
  Dulux_MidUmber: 8843,
  Dulux_MidwinterTide: 8844,
  Dulux_MilkyPail: 26173,
  Dulux_MilledFlour: 8845,
  Dulux_MineralMist: 8846,
  Dulux_MineralMud: 8847,
  Dulux_MintedGrey: 8848,
  Dulux_MintMacaroon: 8849,
  Dulux_MintWhisper: 8850,
  Dulux_Mistress: 8851,
  Dulux_MistyLake: 8852,
  Dulux_MistyLawn: 8853,
  Dulux_MistyMirror: 8854,
  Dulux_MistyMorning: 8855,
  Dulux_MistyMountain: 26174,
  Dulux_MistySky: 26175,
  Dulux_MoleGrey: 10307,
  Dulux_MoltenYellow: 8856,
  Dulux_Monarch: 8857,
  Dulux_Monument: 10313,
  Dulux_MonumentGrey: 26176,
  Dulux_MoonCloud: 8858,
  Dulux_MoonShimmer: 8859,
  Dulux_Moorland: 8860,
  Dulux_MorningBreeze: 8861,
  Dulux_MorningLight: 8862,
  Dulux_MorningOats: 8863,
  Dulux_MoroccanFlame: 8864,
  Dulux_MossyStone: 8865,
  Dulux_MostlyMoonstone: 8866,
  Dulux_MountainAir: 8867,
  Dulux_MountainMoss: 8868,
  Dulux_MouseTail: 8869,
  Dulux_MuddyPuddle: 8870,
  Dulux_MudLark: 8871,
  Dulux_MulberryBurst: 8872,
  Dulux_MustardBlanket: 8873,
  Dulux_MutedAmber: 8874,
  Dulux_MutedBlush: 8875,
  Dulux_MutedClay: 8876,
  Dulux_MutedGold: 26177,
  Dulux_MutedMint: 8877,
  Dulux_MutedStone: 26178,
  Dulux_MysteriousTeal: 8878,
  Dulux_MysticalNight: 8879,
  Dulux_MysticRivers: 8880,
  Dulux_Namadji: 10312,
  Dulux_NarrowLane: 8881,
  Dulux_NaturalBreeze: 8882,
  Dulux_NaturalCalico: 8883,
  Dulux_NaturalHessian: 8884,
  Dulux_NaturalSlate: 8885,
  Dulux_NaturalStone: 8886,
  Dulux_NaturalWicker: 8887,
  Dulux_NectarBlush: 8888,
  Dulux_Nectarine: 8889,
  Dulux_NeptuneSeas: 8890,
  Dulux_NewMeringue: 8891,
  Dulux_NightMoth: 8892,
  Dulux_NightSeas: 8893,
  Dulux_NobleGrey: 8894,
  Dulux_NordicHills: 8895,
  Dulux_NordicSeas: 8896,
  Dulux_NordicSky: 8897,
  Dulux_NordicSpa: 8898,
  Dulux_NotebookOrange: 8899,
  Dulux_NutCookie: 8900,
  Dulux_NutmegWhite: 8901,
  Dulux_NuttyCrunch: 8902,
  Dulux_OceanRipple: 8903,
  Dulux_OceanSapphire: 8904,
  Dulux_OceanStone: 8905,
  Dulux_Ochre: 8906,
  Dulux_OchreGlow: 8907,
  Dulux_OchreSands: 8908,
  Dulux_OchreWhite: 8909,
  Dulux_OldEnglishGreen: 8910,
  Dulux_OldTimeOlive: 8911,
  Dulux_Olive: 8912,
  Dulux_OliveGarden: 8913,
  Dulux_OliveGrove: 26179,
  Dulux_OliveTapanade: 8914,
  Dulux_OliveTree: 8915,
  Dulux_OpaqueHoney: 8916,
  Dulux_Orange: 26180,
  Dulux_OrangeFizz: 8917,
  Dulux_Orchard: 8918,
  Dulux_OrchidWhite: 8919,
  Dulux_Orion: 8920,
  Dulux_OvertlyOlive: 8921,
  Dulux_OxfordBlue: 26181,
  Dulux_OysterPearl: 8922,
  Dulux_Pageant: 8923,
  Dulux_PaleCitrus: 26182,
  Dulux_PaleCream: 8924,
  Dulux_PaleJasmine: 8925,
  Dulux_PaleNutmeg: 8926,
  Dulux_PaleOlivine: 8927,
  Dulux_PaleOpal: 8928,
  Dulux_PalePeony: 8929,
  Dulux_PaleSlate: 26183,
  Dulux_PaleTaupe: 8930,
  Dulux_PaleThistle: 8931,
  Dulux_PaleWalnut: 8932,
  Dulux_PalmNight: 8933,
  Dulux_PanelWhite: 8934,
  Dulux_PaperChain: 8935,
  Dulux_PapyrusPaper: 8936,
  Dulux_ParrotsPlume: 8937,
  Dulux_PartyBalloons: 8938,
  Dulux_PassionFlower: 8939,
  Dulux_PastelGrey: 8940,
  Dulux_PatisseriePink: 8941,
  Dulux_PeachBlossom: 8942,
  Dulux_PeachPosset: 8943,
  Dulux_PeachSouffle: 8944,
  Dulux_PeanutButter: 8945,
  Dulux_PearlBarley: 8946,
  Dulux_PearlGrey: 26184,
  Dulux_Peasblossom: 8947,
  Dulux_PeaShoot: 8948,
  Dulux_PebbleGrey: 8949,
  Dulux_PebbleShore: 8950,
  Dulux_PebbleTrail: 8951,
  Dulux_PenFriend: 8952,
  Dulux_PeppermintCandy: 8953,
  Dulux_PeppermintRock: 8954,
  Dulux_PepperRed: 8955,
  Dulux_PerfectlyTaupe: 8956,
  Dulux_Petal: 8957,
  Dulux_PetalCaress: 8958,
  Dulux_PetalPerfection: 8959,
  Dulux_PewterPlate: 8960,
  Dulux_PianoWhite: 8961,
  Dulux_Pigeon: 8962,
  Dulux_PineappleSlice: 8963,
  Dulux_PineCone: 8964,
  Dulux_Pinefrost: 8965,
  Dulux_PineNeedle: 8966,
  Dulux_PinkGinger: 8967,
  Dulux_PinkHoneysuckle: 8968,
  Dulux_PinkLady: 8969,
  Dulux_PinkParchment: 8970,
  Dulux_PinkProse: 8971,
  Dulux_PinkSandstone: 8972,
  Dulux_PinkSkies: 8973,
  Dulux_PinkWafer: 8974,
  Dulux_PistachioCreme: 8975,
  Dulux_PistachioWhip: 26185,
  Dulux_PixieGreen: 26186,
  Dulux_Plum: 8976,
  Dulux_PlumCompote: 8977,
  Dulux_PlumCustard: 8978,
  Dulux_PlumTruffle: 8979,
  Dulux_PoachedPeach: 8980,
  Dulux_PocketStone: 8981,
  Dulux_PoisonApple: 8982,
  Dulux_PoisonIvy: 8983,
  Dulux_PolishedPebble: 8984,
  Dulux_Pollen: 8985,
  Dulux_PollenYellow: 8986,
  Dulux_Pompadour: 8987,
  Dulux_Poppy: 8988,
  Dulux_PorcelainBlush: 8989,
  Dulux_PorcelainDoll: 8990,
  Dulux_Portland: 8991,
  Dulux_PottersPink: 8992,
  Dulux_PottersWheel: 8993,
  Dulux_PowderBlush: 8994,
  Dulux_PowderColour: 8995,
  Dulux_PowderyMint: 8996,
  Dulux_PralineMelt: 8997,
  Dulux_PreciousPeat: 8998,
  Dulux_PressedBlueberry: 8999,
  Dulux_PressedPetal: 9000,
  Dulux_PressedPutty: 9001,
  Dulux_PressedThistle: 26187,
  Dulux_PrettyPink: 9002,
  Dulux_PrimroseWhite: 9003,
  Dulux_PromQueen: 9004,
  Dulux_ProudPeacock: 9005,
  Dulux_PuginRed: 9006,
  Dulux_PumiceBrown: 9007,
  Dulux_PumiceGrey: 9008,
  Dulux_PureBrilliantWhite: 26188,
  Dulux_PurplePansy: 9009,
  Dulux_PurplePout: 9010,
  Dulux_PurpleSlate: 9011,
  Dulux_PuttingGreen: 26189,
  Dulux_QuarryTile: 9012,
  Dulux_QuartzGrey: 9013,
  Dulux_QuintessentialBlue: 26190,
  Dulux_RailCloth: 9014,
  Dulux_RainforestCanopy: 9015,
  Dulux_RainyDays: 9016,
  Dulux_Raisin: 9017,
  Dulux_RaisinCake: 9018,
  Dulux_RAL1000: 9019,
  Dulux_RAL1001: 9020,
  Dulux_RAL1002: 9021,
  Dulux_RAL1003: 9022,
  Dulux_RAL1004: 9023,
  Dulux_RAL1005: 9024,
  Dulux_RAL1006: 9025,
  Dulux_RAL1007: 9026,
  Dulux_RAL1011: 9027,
  Dulux_RAL1012: 9028,
  Dulux_RAL1013: 9029,
  Dulux_RAL1014: 9030,
  Dulux_RAL1015: 9031,
  Dulux_RAL1016: 9032,
  Dulux_RAL1017: 9033,
  Dulux_RAL1018: 9034,
  Dulux_RAL1019: 9035,
  Dulux_RAL1020: 9036,
  Dulux_RAL1021: 9037,
  Dulux_RAL1023: 9038,
  Dulux_RAL1024: 9039,
  Dulux_RAL1027: 9040,
  Dulux_RAL1028: 9041,
  Dulux_RAL1032: 9042,
  Dulux_RAL1033: 9043,
  Dulux_RAL1034: 9044,
  Dulux_RAL1037: 9045,
  Dulux_RAL2000: 9046,
  Dulux_RAL2001: 9047,
  Dulux_RAL2002: 9048,
  Dulux_RAL2003: 9049,
  Dulux_RAL2004: 9050,
  Dulux_RAL2008: 9051,
  Dulux_RAL2009: 9052,
  Dulux_RAL2010: 9053,
  Dulux_RAL2011: 9054,
  Dulux_RAL2012: 9055,
  Dulux_RAL3000: 9056,
  Dulux_RAL3001: 9057,
  Dulux_RAL3002: 9058,
  Dulux_RAL3003: 9059,
  Dulux_RAL3004: 9060,
  Dulux_RAL3005: 9061,
  Dulux_RAL3007: 9062,
  Dulux_RAL3009: 9063,
  Dulux_RAL3011: 9064,
  Dulux_RAL3012: 9065,
  Dulux_RAL3013: 9066,
  Dulux_RAL3014: 9067,
  Dulux_RAL3015: 9068,
  Dulux_RAL3016: 9069,
  Dulux_RAL3017: 9070,
  Dulux_RAL3018: 9071,
  Dulux_RAL3020: 9072,
  Dulux_RAL3022: 9073,
  Dulux_RAL3027: 9074,
  Dulux_RAL3031: 9075,
  Dulux_RAL4001: 9076,
  Dulux_RAL4002: 9077,
  Dulux_RAL4003: 9078,
  Dulux_RAL4004: 9079,
  Dulux_RAL4005: 9080,
  Dulux_RAL4006: 9081,
  Dulux_RAL4007: 9082,
  Dulux_RAL4008: 9083,
  Dulux_RAL4009: 9084,
  Dulux_RAL4010: 9085,
  Dulux_RAL5000: 9086,
  Dulux_RAL5001: 9087,
  Dulux_RAL5002: 9088,
  Dulux_RAL5003: 9089,
  Dulux_RAL5004: 9090,
  Dulux_RAL5005: 9091,
  Dulux_RAL5007: 9092,
  Dulux_RAL5008: 9093,
  Dulux_RAL5009: 9094,
  Dulux_RAL5010: 9095,
  Dulux_RAL5011: 9096,
  Dulux_RAL5012: 9097,
  Dulux_RAL5013: 9098,
  Dulux_RAL5014: 9099,
  Dulux_RAL5015: 9100,
  Dulux_RAL5017: 9101,
  Dulux_RAL5018: 9102,
  Dulux_RAL5019: 9103,
  Dulux_RAL5020: 9104,
  Dulux_RAL5021: 9105,
  Dulux_RAL5022: 9106,
  Dulux_RAL5023: 9107,
  Dulux_RAL5024: 9108,
  Dulux_RAL6000: 9109,
  Dulux_RAL6001: 9110,
  Dulux_RAL6002: 9111,
  Dulux_RAL6003: 9112,
  Dulux_RAL6004: 9113,
  Dulux_RAL6005: 9114,
  Dulux_RAL6006: 9115,
  Dulux_RAL6007: 9116,
  Dulux_RAL6008: 9117,
  Dulux_RAL6009: 9118,
  Dulux_RAL6010: 9119,
  Dulux_RAL6011: 9120,
  Dulux_RAL6012: 9121,
  Dulux_RAL6013: 9122,
  Dulux_RAL6014: 9123,
  Dulux_RAL6015: 9124,
  Dulux_RAL6016: 9125,
  Dulux_RAL6017: 9126,
  Dulux_RAL6018: 9127,
  Dulux_RAL6019: 9128,
  Dulux_RAL6020: 9129,
  Dulux_RAL6021: 9130,
  Dulux_RAL6022: 9131,
  Dulux_RAL6024: 9132,
  Dulux_RAL6025: 9133,
  Dulux_RAL6026: 9134,
  Dulux_RAL6027: 9135,
  Dulux_RAL6028: 9136,
  Dulux_RAL6029: 9137,
  Dulux_RAL6032: 9138,
  Dulux_RAL6033: 9139,
  Dulux_RAL6034: 9140,
  Dulux_RAL7000: 9141,
  Dulux_RAL7001: 9142,
  Dulux_RAL7002: 9143,
  Dulux_RAL7003: 9144,
  Dulux_RAL7004: 9145,
  Dulux_RAL7005: 9146,
  Dulux_RAL7006: 9147,
  Dulux_RAL7008: 9148,
  Dulux_RAL7009: 9149,
  Dulux_RAL7010: 9150,
  Dulux_RAL7011: 9151,
  Dulux_RAL7012: 9152,
  Dulux_RAL7013: 9153,
  Dulux_RAL7015: 9154,
  Dulux_RAL7016: 9155,
  Dulux_RAL7021: 9156,
  Dulux_RAL7022: 9157,
  Dulux_RAL7023: 9158,
  Dulux_RAL7024: 9159,
  Dulux_RAL7026: 9160,
  Dulux_RAL7030: 9161,
  Dulux_RAL7031: 9162,
  Dulux_RAL7032: 9163,
  Dulux_RAL7033: 9164,
  Dulux_RAL7034: 9165,
  Dulux_RAL7035: 9166,
  Dulux_RAL7036: 9167,
  Dulux_RAL7037: 9168,
  Dulux_RAL7038: 9169,
  Dulux_RAL7039: 9170,
  Dulux_RAL7040: 9171,
  Dulux_RAL7042: 9172,
  Dulux_RAL7043: 9173,
  Dulux_RAL7044: 9174,
  Dulux_RAL7045: 9175,
  Dulux_RAL7046: 9176,
  Dulux_RAL7047: 9177,
  Dulux_RAL8000: 9178,
  Dulux_RAL8001: 9179,
  Dulux_RAL8002: 9180,
  Dulux_RAL8003: 9181,
  Dulux_RAL8004: 9182,
  Dulux_RAL8007: 9183,
  Dulux_RAL8008: 9184,
  Dulux_RAL8011: 9185,
  Dulux_RAL8012: 9186,
  Dulux_RAL8014: 9187,
  Dulux_RAL8015: 9188,
  Dulux_RAL8016: 9189,
  Dulux_RAL8017: 9190,
  Dulux_RAL8019: 9191,
  Dulux_RAL8022: 9192,
  Dulux_RAL8023: 9193,
  Dulux_RAL8024: 9194,
  Dulux_RAL8025: 9195,
  Dulux_RAL8028: 9196,
  Dulux_RAL9001: 9197,
  Dulux_RAL9002: 9198,
  Dulux_RAL9003: 9199,
  Dulux_RAL9004: 9200,
  Dulux_RAL9005: 9201,
  Dulux_RAL9010: 9202,
  Dulux_RAL9011: 9203,
  Dulux_RAL9016: 9204,
  Dulux_RAL9017: 9205,
  Dulux_RAL9018: 9206,
  Dulux_Raspberry: 9207,
  Dulux_RaspberryBellini: 9208,
  Dulux_RaspberryDiva: 9209,
  Dulux_RaspberryRipple: 9210,
  Dulux_RaspberrySorbet: 9211,
  Dulux_Raven: 9212,
  Dulux_RavensFlight: 9213,
  Dulux_RawCashmere: 9214,
  Dulux_Razamatazz: 9215,
  Dulux_Red: 26191,
  Dulux_RedAcer: 9216,
  Dulux_RedcurrantGlory: 9217,
  Dulux_RedOchre: 9218,
  Dulux_RedRock: 9219,
  Dulux_RedRusset: 9220,
  Dulux_RedSand: 9221,
  Dulux_Regalia: 9222,
  Dulux_RegalPurple: 9223,
  Dulux_RegalSilk: 9224,
  Dulux_Regatta: 9225,
  Dulux_RestfulSlumber: 9226,
  Dulux_Rhino: 9227,
  Dulux_RhubarbCompote: 9228,
  Dulux_RichBerry: 9229,
  Dulux_RichBlack: 9230,
  Dulux_RichBlueberry: 9231,
  Dulux_RichEarth: 9232,
  Dulux_RichJuniper: 9233,
  Dulux_RichRoads: 9234,
  Dulux_RiverBed: 9235,
  Dulux_Riverbed_BS4800: 9236,
  Dulux_RiverPearl: 9237,
  Dulux_Riverstone: 9238,
  Dulux_RiverValley: 9239,
  Dulux_RoastedChestnut: 9240,
  Dulux_RoastedCoffee: 26192,
  Dulux_RoastedRed: 9241,
  Dulux_RocketFire: 9242,
  Dulux_RockingHorse: 9243,
  Dulux_RockpoolRipple: 9244,
  Dulux_RockSalt: 9245,
  Dulux_RocksaltRose: 9246,
  Dulux_RolledOats: 9247,
  Dulux_RomanticReverie: 9248,
  Dulux_RomanWhite: 9249,
  Dulux_RomneyWool: 9250,
  Dulux_RopeKnot: 9251,
  Dulux_RopeLadder: 9252,
  Dulux_RopeSwing: 26193,
  Dulux_RoseBark: 9253,
  Dulux_RoseCanopy: 9254,
  Dulux_RosemaryLeaf: 9255,
  Dulux_Rosepetal: 9256,
  Dulux_Rosetan: 9257,
  Dulux_Rosevale: 9258,
  Dulux_RoseWhite: 9259,
  Dulux_RougeNoir: 9260,
  Dulux_RoyalBerry: 26194,
  Dulux_RoyalPeacock: 9261,
  Dulux_RubbleRoad: 9262,
  Dulux_RubyStarlet: 9263,
  Dulux_Rune: 9264,
  Dulux_RusticBrick: 9265,
  Dulux_Saddle: 9266,
  Dulux_SaddleBrown: 9267,
  Dulux_SafariSong: 9268,
  Dulux_SafariSpice: 9269,
  Dulux_SaffronSizzle: 9270,
  Dulux_Sage: 9271,
  Dulux_SageGreen: 9272,
  Dulux_SalsaMix: 9273,
  Dulux_SalsaRed: 26195,
  Dulux_Sandstone: 9274,
  Dulux_SandyShallows: 9275,
  Dulux_SandyShell: 9276,
  Dulux_SandySteps: 26196,
  Dulux_SapphireSalute: 9277,
  Dulux_SapphireSplendour: 9278,
  Dulux_SashBlue: 9279,
  Dulux_SatchelTan: 9280,
  Dulux_SatinBow: 26197,
  Dulux_SatsumaSpice: 9281,
  Dulux_SavanaBrown: 9282,
  Dulux_Savannah: 9283,
  Dulux_Scarab: 9284,
  Dulux_ScentBottle: 26198,
  Dulux_ScottishLoch: 9285,
  Dulux_SeaBlue: 26199,
  Dulux_Seafoam: 9286,
  Dulux_Seagrass: 9287,
  Dulux_SeaHolly: 9288,
  Dulux_SeaNettle: 9289,
  Dulux_SeashellGrey: 9290,
  Dulux_SeasonedOak: 9291,
  Dulux_Seine: 9292,
  Dulux_SereneWaters: 9293,
  Dulux_SesameSeed: 26200,
  Dulux_SettingStone: 9294,
  Dulux_ShadedGlen: 9295,
  Dulux_Shell: 9296,
  Dulux_ShellStories: 9297,
  Dulux_Sherwood: 9298,
  Dulux_ShiftingSands: 9299,
  Dulux_ShingleSteps: 9300,
  Dulux_SiberianSteppes: 9301,
  Dulux_SicilianLime: 9302,
  Dulux_Sierra: 9303,
  Dulux_SilkenClay: 9304,
  Dulux_SilverAsh: 9305,
  Dulux_SilverBirch: 9306,
  Dulux_SilverCloud: 9307,
  Dulux_SilverFern: 9308,
  Dulux_SilverLichen: 9309,
  Dulux_SilverRow: 9310,
  Dulux_SilverShingle: 9311,
  Dulux_SilverShores: 9312,
  Dulux_SimplyPearl: 9313,
  Dulux_SkyBlue: 9314,
  Dulux_SkyReflection: 9315,
  Dulux_SkyView: 9316,
  Dulux_SlateGreen: 9317,
  Dulux_SloeFlower: 9318,
  Dulux_SlumberSeed: 9319,
  Dulux_SmokeyQuartz: 9320,
  Dulux_SmokeySeas: 9321,
  Dulux_SmoothFlint: 26201,
  Dulux_SmoothMaple: 9322,
  Dulux_SmoothPebble: 9323,
  Dulux_SnailTrail: 9324,
  Dulux_Snowman: 9325,
  Dulux_SnowTracks: 9326,
  Dulux_SnowySummit: 9327,
  Dulux_SoBlue: 9328,
  Dulux_SodaPink: 9329,
  Dulux_SoftApple: 9330,
  Dulux_SoftCoral: 9331,
  Dulux_SoftMuslin: 9332,
  Dulux_SoftPeach: 9333,
  Dulux_SoftPeriwinkle: 9334,
  Dulux_SoftStone: 9335,
  Dulux_SoftTruffle: 9336,
  Dulux_SoftVanilla: 26202,
  Dulux_SomersetGreen: 9337,
  Dulux_SophisticatedSage: 26203,
  Dulux_Sorbet: 26204,
  Dulux_SouthernBelle: 9338,
  Dulux_SpicedHoney: 9339,
  Dulux_SpicyPaprika: 9340,
  Dulux_SpidersWeb: 9341,
  Dulux_Spindrift: 9342,
  Dulux_SpinningWheel: 9343,
  Dulux_SpringBlush: 9344,
  Dulux_SpringCrocus: 9345,
  Dulux_SpringGlow: 9346,
  Dulux_SpringHyacinth: 9347,
  Dulux_Springleaf: 9348,
  Dulux_SpringMeadow: 26205,
  Dulux_SpringRose: 9349,
  Dulux_SpringShoots: 9350,
  Dulux_SpunMohair: 9351,
  Dulux_StableGates: 9352,
  Dulux_SteelParade: 26206,
  Dulux_StillWater: 9353,
  Dulux_StolenRose: 9354,
  Dulux_StoneGreen: 9355,
  Dulux_StonewashedBlue: 9356,
  Dulux_StormClearing: 9357,
  Dulux_StormDay: 9358,
  Dulux_StormSea: 9359,
  Dulux_StrawBale: 9360,
  Dulux_StrikingCyan: 9361,
  Dulux_Studio: 9362,
  Dulux_SubtleSeashell: 26207,
  Dulux_SugaredLilac: 26208,
  Dulux_SulphurSunrise: 9363,
  Dulux_SummerBreeze: 9364,
  Dulux_SummerDamson: 9365,
  Dulux_SummerDusk: 9366,
  Dulux_SummerFizz: 9367,
  Dulux_SummerLinen: 9368,
  Dulux_SummerSage: 26209,
  Dulux_SumptuousPlum: 9369,
  Dulux_SunbakedTerracotta: 9370,
  Dulux_SunblushPeach: 9371,
  Dulux_SunFlare: 9372,
  Dulux_SunnyDay: 26210,
  Dulux_SunnyLime: 9373,
  Dulux_SunsetKiss: 9374,
  Dulux_SunsetSands: 9375,
  Dulux_Surfmist: 10309,
  Dulux_SurrenderedSkies: 9376,
  Dulux_Swansdown: 9377,
  Dulux_SwedishWhite: 9378,
  Dulux_SweetBlueberry: 9379,
  Dulux_SweetCinnamon: 9380,
  Dulux_SweetCitrus: 9381,
  Dulux_SweetEmbrace: 9382,
  Dulux_SweetFondant: 9383,
  Dulux_SweetNougat: 9384,
  Dulux_SweetPea: 9385,
  Dulux_SweetPink: 9386,
  Dulux_SweetPlum: 9387,
  Dulux_SweetSundae: 9388,
  Dulux_TailorsChalk: 9389,
  Dulux_TangerineTwist: 9390,
  Dulux_Tawny: 9391,
  Dulux_TawnyOwl: 9392,
  Dulux_Teal: 26211,
  Dulux_TealFacade: 26212,
  Dulux_TealRipple: 26213,
  Dulux_TealTension: 9393,
  Dulux_TealTouch: 9394,
  Dulux_TealVelvet: 9395,
  Dulux_TealVoyage: 9396,
  Dulux_Tearose: 9397,
  Dulux_TeaTree: 9398,
  Dulux_TemperedChocolate: 9399,
  Dulux_Terracotta: 9400,
  Dulux_TerracottaArmy: 9401,
  Dulux_TerraOmbra: 9402,
  Dulux_ThimbleCase: 26214,
  Dulux_Thistledown: 9403,
  Dulux_ThunderClouds: 9404,
  Dulux_Tideway: 9405,
  Dulux_Timeless: 9406,
  Dulux_TingeOfSilver: 9407,
  Dulux_TissuePaper: 9408,
  Dulux_ToastedMeringue: 9409,
  Dulux_ToastyGrey: 9410,
  Dulux_Trafalgar: 9411,
  Dulux_TrafalgarGrey: 9412,
  Dulux_TranquilDawn: 9413,
  Dulux_TranquilDepths: 9414,
  Dulux_TranquilMist: 9415,
  Dulux_TreasureChest: 9416,
  Dulux_TreasuredCoral: 9417,
  Dulux_TreasuredMemory: 9418,
  Dulux_TrenchCoat: 26215,
  Dulux_TudorBrown: 9419,
  Dulux_TumbledGlass: 9420,
  Dulux_TurloghGreen: 9421,
  Dulux_TurquoiseJewel: 9422,
  Dulux_Turtle: 9423,
  Dulux_TurtledoveGrey: 9424,
  Dulux_TuscanNights: 9425,
  Dulux_TuscanTerracotta: 26216,
  Dulux_UrbanObsession: 9426,
  Dulux_UrbanSlate: 9427,
  Dulux_UrbanWalk: 9428,
  Dulux_ValleyRock: 26217,
  Dulux_Vandyke: 9429,
  Dulux_VanillaScoop: 26218,
  Dulux_VanillaSkies: 9430,
  Dulux_VanillaSundae: 9431,
  Dulux_VanillaWhite: 9432,
  Dulux_VanillaWisp: 9433,
  Dulux_VastLake: 26219,
  Dulux_VeiledViolet: 9434,
  Dulux_VelvetCake: 9435,
  Dulux_VelvetRobe: 9436,
  Dulux_VenusFlytrap: 9437,
  Dulux_VerandaGreen: 9438,
  Dulux_Verona: 9439,
  Dulux_VeryBerry: 9440,
  Dulux_VeryVanilla: 9441,
  Dulux_View: 26220,
  Dulux_Viking: 9442,
  Dulux_VillageMaze: 9443,
  Dulux_VillaMexicana: 9444,
  Dulux_VineLeaf: 9445,
  Dulux_VintageChandelier: 26221,
  Dulux_VintageCoins: 9446,
  Dulux_VintageRose: 9447,
  Dulux_VintageSmoke: 9448,
  Dulux_Violet: 9449,
  Dulux_VioletDream: 9450,
  Dulux_VioletJewel: 9451,
  Dulux_VioletKiss: 9452,
  Dulux_VioletMorning: 9453,
  Dulux_VioletNight: 9454,
  Dulux_VioletStorm: 9455,
  Dulux_VioletWhite: 9456,
  Dulux_VoileWhite: 9457,
  Dulux_VolcanicRed: 26222,
  Dulux_WarmAlmond: 9458,
  Dulux_WarmFlax: 9459,
  Dulux_WarmFoliage: 9460,
  Dulux_WarmGraphite: 26223,
  Dulux_WarmGrey: 9461,
  Dulux_WarmPewter: 9462,
  Dulux_WarmStraw: 9463,
  Dulux_WarmTruffle: 26224,
  Dulux_WaterSky: 9464,
  Dulux_WaveBlue: 9465,
  Dulux_WaxedKhaki: 9466,
  Dulux_WaxedWood: 9467,
  Dulux_WeatheredCopper: 9468,
  Dulux_WeatheredGlass: 9469,
  Dulux_WeatheredPenny: 9470,
  Dulux_Wellbeing: 9471,
  Dulux_WelshFlint: 9472,
  Dulux_WelshStone: 9473,
  Dulux_White: 26225,
  Dulux_White_BS4800: 9474,
  Dulux_WhiteChiffon: 26226,
  Dulux_WhiteCotton: 9475,
  Dulux_WhiteDaisy: 9476,
  Dulux_WhiteDew: 9477,
  Dulux_WhiteMist: 9478,
  Dulux_WhiteWhisper: 9479,
  Dulux_Wild_Wonder_COTY23: 9480,
  Dulux_WildBlackberry: 9481,
  Dulux_WildCactus: 9482,
  Dulux_WildEucalyptus: 9483,
  Dulux_WildMushroom: 9484,
  Dulux_WildPoppy: 9485,
  Dulux_WildPrimrose: 9486,
  Dulux_WildThyme: 9487,
  Dulux_WildWonder: 9488,
  Dulux_Willow: 9489,
  Dulux_WillowTree: 9490,
  Dulux_WillowTwig: 9491,
  Dulux_WiltshireWhite: 9492,
  Dulux_WinsomeLily: 9493,
  Dulux_WinterAvenue: 9494,
  Dulux_WinterBlue: 9495,
  Dulux_WinterPumkin: 9496,
  Dulux_WinterRabbit: 9497,
  Dulux_WintersNight: 9498,
  Dulux_WintersSky: 9499,
  Dulux_WintersWell: 9500,
  Dulux_WiseDiamond: 9501,
  Dulux_WishboneWhite: 9502,
  Dulux_WishingWell: 26227,
  Dulux_WisteriaCascade: 9503,
  Dulux_WoadWalk: 9504,
  Dulux_Woodash: 9505,
  Dulux_WoodedSolace: 9506,
  Dulux_WoodedWalk: 9507,
  Dulux_WoodlandMink: 9508,
  Dulux_WoodlandMist: 9509,
  Dulux_WoodlandTrail: 9510,
  Dulux_WovenHemp: 9511,
  Dulux_WovenNest: 9512,
  Dulux_WovenWillow: 9513,
  Dulux_WritersDesk: 9514,
  Dulux_WyomingGrass: 9515,
  Dulux_Yellow: 26228,
  Dulux_YorkWhite: 9516,
  Dulux_ZanzibarDream: 9517,
  Dulux_ZingyLime: 9518,
};

const DMC_DunnEdwards = {
  DunnEdwards_DE1925_ViridianOdyssey: 31140,
  DunnEdwards_DE5000_Bashful: 31141,
  DunnEdwards_DE5001_SpringLilac: 31142,
  DunnEdwards_DE5002_LightLavender: 31143,
  DunnEdwards_DE5003_ExoticViolet: 31144,
  DunnEdwards_DE5004_PeruvianLily: 31145,
  DunnEdwards_DE5005_Brandywine: 31146,
  DunnEdwards_DE5006_PlumPassion: 31147,
  DunnEdwards_DE5007_PaleBlossom: 31148,
  DunnEdwards_DE5008_PinkLily: 31149,
  DunnEdwards_DE5009_SoftCashmere: 31150,
  DunnEdwards_DE5010_Gumdrop: 31151,
  DunnEdwards_DE5011_DeepCarnation: 31152,
  DunnEdwards_DE5012_VividViolet: 31153,
  DunnEdwards_DE5013_DeepMagenta: 31154,
  DunnEdwards_DE5014_SpunSugar: 31155,
  DunnEdwards_DE5015_MinimalRose: 31156,
  DunnEdwards_DE5016_MuddyMauve: 31157,
  DunnEdwards_DE5017_ExoticLilac: 31158,
  DunnEdwards_DE5018_FirstPlum: 31159,
  DunnEdwards_DE5019_Rosewine: 31160,
  DunnEdwards_DE5020_MahoganyCherry: 31161,
  DunnEdwards_DE5021_BunnyTail: 31162,
  DunnEdwards_DE5022_SweetSachet: 31163,
  DunnEdwards_DE5023_PrettyInPink: 31164,
  DunnEdwards_DE5024_VioletKiss: 31165,
  DunnEdwards_DE5025_FuchsiaBlush: 31166,
  DunnEdwards_DE5026_CrushedBerries: 31167,
  DunnEdwards_DE5027_RazzleDazzle: 31168,
  DunnEdwards_DE5028_FairyWings: 31169,
  DunnEdwards_DE5029_BerryFrost: 31170,
  DunnEdwards_DE5030_Sweetheart: 31171,
  DunnEdwards_DE5031_ThinkPink: 31172,
  DunnEdwards_DE5032_HeirloomRose: 31173,
  DunnEdwards_DE5033_RaspberryParfait: 31174,
  DunnEdwards_DE5034_CherryBerry: 31175,
  DunnEdwards_DE5035_FairyDust: 31176,
  DunnEdwards_DE5036_Ballerina: 31177,
  DunnEdwards_DE5037_FlamingoFeather: 31178,
  DunnEdwards_DE5038_BeMyValentine: 31179,
  DunnEdwards_DE5039_RealRaspberry: 31180,
  DunnEdwards_DE5040_Lipstick: 31181,
  DunnEdwards_DE5041_Sangria: 31182,
  DunnEdwards_DE5042_Cherubic: 31183,
  DunnEdwards_DE5043_RoseGlow: 31184,
  DunnEdwards_DE5044_SweetRomance: 31185,
  DunnEdwards_DE5045_TaffyPink: 31186,
  DunnEdwards_DE5046_Carnation: 31187,
  DunnEdwards_DE5047_LoveLetter: 31188,
  DunnEdwards_DE5048_PinkPunch: 31189,
  DunnEdwards_DE5049_EarlyBlossom: 31190,
  DunnEdwards_DE5050_CreamyStrawberry: 31191,
  DunnEdwards_DE5051_BerriesNCream: 31192,
  DunnEdwards_DE5052_LovePotion: 31193,
  DunnEdwards_DE5053_FirstLove: 31194,
  DunnEdwards_DE5054_CandiedApple: 31195,
  DunnEdwards_DE5055_Merlot: 31196,
  DunnEdwards_DE5056_Sweetly: 31197,
  DunnEdwards_DE5057_BalletSlipper: 31198,
  DunnEdwards_DE5058_CherryBlush: 31199,
  DunnEdwards_DE5059_Heartfelt: 31200,
  DunnEdwards_DE5060_RockNRose: 31201,
  DunnEdwards_DE5061_CupidsArrow: 31202,
  DunnEdwards_DE5062_RosyCheeks: 31203,
  DunnEdwards_DE5063_PowderPuff: 31204,
  DunnEdwards_DE5064_PinkPerfume: 31205,
  DunnEdwards_DE5065_SweetSerenade: 31206,
  DunnEdwards_DE5066_Tutu: 31207,
  DunnEdwards_DE5067_PosyPetal: 31208,
  DunnEdwards_DE5068_SliceOfWatermelon: 31209,
  DunnEdwards_DE5069_CherryHill: 31210,
  DunnEdwards_DE5070_Nosegay: 31211,
  DunnEdwards_DE5071_BabyGirl: 31212,
  DunnEdwards_DE5072_Bubblegum: 31213,
  DunnEdwards_DE5073_BabysBlanket: 31214,
  DunnEdwards_DE5074_CharmingCherry: 31215,
  DunnEdwards_DE5075_FieryFlamingo: 31216,
  DunnEdwards_DE5076_StrawberryJam: 31217,
  DunnEdwards_DE5077_RoseWater: 31218,
  DunnEdwards_DE5078_PinkPleasure: 31219,
  DunnEdwards_DE5079_SweetSixteen: 31220,
  DunnEdwards_DE5080_PoodleSkirt: 31221,
  DunnEdwards_DE5081_StrawberryShortcake: 31222,
  DunnEdwards_DE5082_Redstone: 31223,
  DunnEdwards_DE5083_DeepHibiscus: 31224,
  DunnEdwards_DE5084_PinkSparkle: 31225,
  DunnEdwards_DE5085_SatinRibbon: 31226,
  DunnEdwards_DE5086_Piglet: 31227,
  DunnEdwards_DE5087_SimplePink: 31228,
  DunnEdwards_DE5088_AppleValley: 31229,
  DunnEdwards_DE5089_GeraniumRed: 31230,
  DunnEdwards_DE5090_Pomegranate: 31231,
  DunnEdwards_DE5091_JustPinkEnough: 31232,
  DunnEdwards_DE5092_FirstCrush: 31233,
  DunnEdwards_DE5093_RoseReminder: 31234,
  DunnEdwards_DE5094_BerryRiche: 31235,
  DunnEdwards_DE5095_VictorianRouge: 31236,
  DunnEdwards_DE5096_TerraRosa: 31237,
  DunnEdwards_DE5097_RedRock: 31238,
  DunnEdwards_DE5098_GlimpseOfPink: 31239,
  DunnEdwards_DE5099_Camellia: 31240,
  DunnEdwards_DE5100_NoNeedToBlush: 31241,
  DunnEdwards_DE5101_LoveAffair: 31242,
  DunnEdwards_DE5102_StrawberryFrappe: 31243,
  DunnEdwards_DE5103_PinkGlamour: 31244,
  DunnEdwards_DE5104_Amour: 31245,
  DunnEdwards_DE5105_BabysBottom: 31246,
  DunnEdwards_DE5106_PinkLemonade: 31247,
  DunnEdwards_DE5107_StrawberryBlonde: 31248,
  DunnEdwards_DE5108_PinkAndSleek: 31249,
  DunnEdwards_DE5109_SalmonUpstream: 31250,
  DunnEdwards_DE5110_PrimePink: 31251,
  DunnEdwards_DE5111_RoseFusion: 31252,
  DunnEdwards_DE5112_SheerRosebud: 31253,
  DunnEdwards_DE5113_FairytaleDream: 31254,
  DunnEdwards_DE5114_MesaRose: 31255,
  DunnEdwards_DE5115_DustyCedar: 31256,
  DunnEdwards_DE5116_Rouge: 31257,
  DunnEdwards_DE5117_RedwoodCity: 31258,
  DunnEdwards_DE5118_Bbq: 31259,
  DunnEdwards_DE5119_PinkTheory: 31260,
  DunnEdwards_DE5120_ForgottenPink: 31261,
  DunnEdwards_DE5121_Ladylike: 31262,
  DunnEdwards_DE5122_Roseberry: 31263,
  DunnEdwards_DE5123_CulturedRose: 31264,
  DunnEdwards_DE5124_SouthwesternClay: 31265,
  DunnEdwards_DE5125_RedRiver: 31266,
  DunnEdwards_DE5126_SoftPeachMist: 31267,
  DunnEdwards_DE5127_RoseFrost: 31268,
  DunnEdwards_DE5128_PeachyKeen: 31269,
  DunnEdwards_DE5129_Peachtree: 31270,
  DunnEdwards_DE5130_AmberTide: 31271,
  DunnEdwards_DE5131_OrangeAura: 31272,
  DunnEdwards_DE5132_OftenOrange: 31273,
  DunnEdwards_DE5133_PolishedPink: 31274,
  DunnEdwards_DE5134_FirstKiss: 31275,
  DunnEdwards_DE5135_Girlie: 31276,
  DunnEdwards_DE5136_CherryChip: 31277,
  DunnEdwards_DE5137_AdobeAvenue: 31278,
  DunnEdwards_DE5138_Orangeville: 31279,
  DunnEdwards_DE5139_SpicyTomato: 31280,
  DunnEdwards_DE5140_PeachBreeze: 31281,
  DunnEdwards_DE5141_SoftOrangeBloom: 31282,
  DunnEdwards_DE5142_PeachFuzz: 31283,
  DunnEdwards_DE5143_DiscreetOrange: 31284,
  DunnEdwards_DE5144_PouringCopper: 31285,
  DunnEdwards_DE5145_OrangeDaylily: 31286,
  DunnEdwards_DE5146_Campfire: 31287,
  DunnEdwards_DE5147_TranslucentSilk: 31288,
  DunnEdwards_DE5148_PaleJasper: 31289,
  DunnEdwards_DE5149_Rustique: 31290,
  DunnEdwards_DE5150_RoseDusk: 31291,
  DunnEdwards_DE5151_CinnamonStick: 31292,
  DunnEdwards_DE5152_CedarGrove: 31293,
  DunnEdwards_DE5153_IronOre: 31294,
  DunnEdwards_DE5154_PaleNectar: 31295,
  DunnEdwards_DE5155_SoftCoral: 31296,
  DunnEdwards_DE5156_AutumnBloom: 31297,
  DunnEdwards_DE5157_TenderPeach: 31298,
  DunnEdwards_DE5158_Dreamsicle: 31299,
  DunnEdwards_DE5159_FreshCantaloupe: 31300,
  DunnEdwards_DE5160_TangerineDream: 31301,
  DunnEdwards_DE5161_ApricotIce: 31302,
  DunnEdwards_DE5162_DesertDawn: 31303,
  DunnEdwards_DE5163_PaleApricot: 31304,
  DunnEdwards_DE5164_PapayaWhip: 31305,
  DunnEdwards_DE5165_SavannahSun: 31306,
  DunnEdwards_DE5166_Nectarine: 31307,
  DunnEdwards_DE5167_ValleyOfFire: 31308,
  DunnEdwards_DE5168_PinkGlow: 31309,
  DunnEdwards_DE5169_GlazedSugar: 31310,
  DunnEdwards_DE5170_AntiqueCoral: 31311,
  DunnEdwards_DE5171_OctoberHaze: 31312,
  DunnEdwards_DE5172_LaTerra: 31313,
  DunnEdwards_DE5173_DeepCoral: 31314,
  DunnEdwards_DE5174_ClayPot: 31315,
  DunnEdwards_DE5175_OrganicFiber: 31316,
  DunnEdwards_DE5176_PeacefulPeach: 31317,
  DunnEdwards_DE5177_CoralBisque: 31318,
  DunnEdwards_DE5178_AlohaSunset: 31319,
  DunnEdwards_DE5179_BronzedOrange: 31320,
  DunnEdwards_DE5180_SpanishPeanut: 31321,
  DunnEdwards_DE5181_GeorgiaClay: 31322,
  DunnEdwards_DE5182_RosyCloud: 31323,
  DunnEdwards_DE5183_LightCarob: 31324,
  DunnEdwards_DE5184_BrilliantBeige: 31325,
  DunnEdwards_DE5185_Cedarville: 31326,
  DunnEdwards_DE5186_SecludedCanyon: 31327,
  DunnEdwards_DE5187_WeatheredSaddle: 31328,
  DunnEdwards_DE5188_RuddyOak: 31329,
  DunnEdwards_DE5189_SweetFrosting: 31330,
  DunnEdwards_DE5190_MalibuSun: 31331,
  DunnEdwards_DE5191_CandleGlow: 31332,
  DunnEdwards_DE5192_FreshApricot: 31333,
  DunnEdwards_DE5193_SpicedNectarine: 31334,
  DunnEdwards_DE5194_TangerineTango: 31335,
  DunnEdwards_DE5195_BrightMango: 31336,
  DunnEdwards_DE5196_FlickeringLight: 31337,
  DunnEdwards_DE5197_SatinBlush: 31338,
  DunnEdwards_DE5198_OpalescentCoral: 31339,
  DunnEdwards_DE5199_MarketMelon: 31340,
  DunnEdwards_DE5200_Yams: 31341,
  DunnEdwards_DE5201_SweetPotato: 31342,
  DunnEdwards_DE5202_DesertSpice: 31343,
  DunnEdwards_DE5203_Doeskin: 31344,
  DunnEdwards_DE5204_MoodLighting: 31345,
  DunnEdwards_DE5205_PrairieDune: 31346,
  DunnEdwards_DE5206_TanTemptation: 31347,
  DunnEdwards_DE5207_PecanVeneer: 31348,
  DunnEdwards_DE5208_HarvestTime: 31349,
  DunnEdwards_DE5209_Cinnabar: 31350,
  DunnEdwards_DE5210_AmbrosiaIvory: 31351,
  DunnEdwards_DE5211_GuidingStar: 31352,
  DunnEdwards_DE5212_NaturalTan: 31353,
  DunnEdwards_DE5213_SeasonalBeige: 31354,
  DunnEdwards_DE5214_TawnyAmber: 31355,
  DunnEdwards_DE5215_CaramelApple: 31356,
  DunnEdwards_DE5216_AutumnUmber: 31357,
  DunnEdwards_DE5217_BlendedLight: 31358,
  DunnEdwards_DE5218_BeamingSun: 31359,
  DunnEdwards_DE5219_GoldenImpression: 31360,
  DunnEdwards_DE5220_Organza: 31361,
  DunnEdwards_DE5221_OrangeGlass: 31362,
  DunnEdwards_DE5222_OrangeMarmalade: 31363,
  DunnEdwards_DE5223_EnergyOrange: 31364,
  DunnEdwards_DE5224_RadiantGlow: 31365,
  DunnEdwards_DE5225_NeutralPeach: 31366,
  DunnEdwards_DE5226_NevadaMorning: 31367,
  DunnEdwards_DE5227_RichHoney: 31368,
  DunnEdwards_DE5228_PumpkinPie: 31369,
  DunnEdwards_DE5229_ClayTerrace: 31370,
  DunnEdwards_DE5230_CarrotCake: 31371,
  DunnEdwards_DE5231_StellarLight: 31372,
  DunnEdwards_DE5232_BarelyPeach: 31373,
  DunnEdwards_DE5233_PeachCider: 31374,
  DunnEdwards_DE5234_ApricotAppeal: 31375,
  DunnEdwards_DE5235_BlazingAutumn: 31376,
  DunnEdwards_DE5236_ColoradoPeach: 31377,
  DunnEdwards_DE5237_Flame: 31378,
  DunnEdwards_DE5238_Tofu: 31379,
  DunnEdwards_DE5239_DelightfulPeach: 31380,
  DunnEdwards_DE5240_TahitianTan: 31381,
  DunnEdwards_DE5241_SicilianVilla: 31382,
  DunnEdwards_DE5242_Beeswax: 31383,
  DunnEdwards_DE5243_BrushedClay: 31384,
  DunnEdwards_DE5244_MeltedCopper: 31385,
  DunnEdwards_DE5245_DelicateSeashell: 31386,
  DunnEdwards_DE5246_WildMaple: 31387,
  DunnEdwards_DE5247_Allspice: 31388,
  DunnEdwards_DE5248_RustyOrange: 31389,
  DunnEdwards_DE5249_Coyote: 31390,
  DunnEdwards_DE5250_CaramelBar: 31391,
  DunnEdwards_DE5251_SpiceCake: 31392,
  DunnEdwards_DE5252_SugarGlaze: 31393,
  DunnEdwards_DE5253_MacaroonCream: 31394,
  DunnEdwards_DE5254_FreshBakedBread: 31395,
  DunnEdwards_DE5255_MadridBeige: 31396,
  DunnEdwards_DE5256_SoftLeather: 31397,
  DunnEdwards_DE5257_FallFoliage: 31398,
  DunnEdwards_DE5258_BurntAlmond: 31399,
  DunnEdwards_DE5259_BlanchedAlmond: 31400,
  DunnEdwards_DE5260_SandyBeach: 31401,
  DunnEdwards_DE5261_CashewNut: 31402,
  DunnEdwards_DE5262_FieldOfWheat: 31403,
  DunnEdwards_DE5263_SonoraShade: 31404,
  DunnEdwards_DE5264_SaddleBrown: 31405,
  DunnEdwards_DE5265_BrownEyes: 31406,
  DunnEdwards_DE5266_CrushedCashew: 31407,
  DunnEdwards_DE5267_Almondine: 31408,
  DunnEdwards_DE5268_Sundown: 31409,
  DunnEdwards_DE5269_Yucatan: 31410,
  DunnEdwards_DE5270_AppleCider: 31411,
  DunnEdwards_DE5271_GingerSpice: 31412,
  DunnEdwards_DE5272_SedonaAtSunset: 31413,
  DunnEdwards_DE5273_DownFeathers: 31414,
  DunnEdwards_DE5274_CandlestickPoint: 31415,
  DunnEdwards_DE5275_PeachSmoothie: 31416,
  DunnEdwards_DE5276_DreamsOfPeach: 31417,
  DunnEdwards_DE5277_AmberDawn: 31418,
  DunnEdwards_DE5278_RoastedSquash: 31419,
  DunnEdwards_DE5279_SuedeVest: 31420,
  DunnEdwards_DE5280_StillMorning: 31421,
  DunnEdwards_DE5281_Hazelwood: 31422,
  DunnEdwards_DE5282_CreamyApricot: 31423,
  DunnEdwards_DE5283_AugustMorning: 31424,
  DunnEdwards_DE5284_JustPeachy: 31425,
  DunnEdwards_DE5285_AntiqueBrass: 31426,
  DunnEdwards_DE5286_PavilionPeach: 31427,
  DunnEdwards_DE5287_AlluringLight: 31428,
  DunnEdwards_DE5288_SummerHue: 31429,
  DunnEdwards_DE5289_MiddaySun: 31430,
  DunnEdwards_DE5290_ApricotGlow: 31431,
  DunnEdwards_DE5291_Marigold: 31432,
  DunnEdwards_DE5292_AcornSquash: 31433,
  DunnEdwards_DE5293_Persimmon: 31434,
  DunnEdwards_DE5294_BlankCanvas: 31435,
  DunnEdwards_DE5295_Sandstorm: 31436,
  DunnEdwards_DE5296_Granola: 31437,
  DunnEdwards_DE5297_PalomaTan: 31438,
  DunnEdwards_DE5298_ButterscotchSyrup: 31439,
  DunnEdwards_DE5299_SlightlyGolden: 31440,
  DunnEdwards_DE5300_BurmeseGold: 31441,
  DunnEdwards_DE5301_TatamiMat: 31442,
  DunnEdwards_DE5302_WarmLight: 31443,
  DunnEdwards_DE5303_CreamyCorn: 31444,
  DunnEdwards_DE5304_SunDrenched: 31445,
  DunnEdwards_DE5305_YumaGold: 31446,
  DunnEdwards_DE5306_OrangeDelight: 31447,
  DunnEdwards_DE5307_RipePumpkin: 31448,
  DunnEdwards_DE5308_Buttermilk: 31449,
  DunnEdwards_DE5309_Cheesecake: 31450,
  DunnEdwards_DE5310_SpringButtercup: 31451,
  DunnEdwards_DE5311_BabyChick: 31452,
  DunnEdwards_DE5312_SummerDaffodil: 31453,
  DunnEdwards_DE5313_MeltedButter: 31454,
  DunnEdwards_DE5314_VibrantHoney: 31455,
  DunnEdwards_DE5315_Daystar: 31456,
  DunnEdwards_DE5316_RichIvory: 31457,
  DunnEdwards_DE5317_PreciousNectar: 31458,
  DunnEdwards_DE5318_GoldenRetriever: 31459,
  DunnEdwards_DE5319_LionsMane: 31460,
  DunnEdwards_DE5320_CopperCove: 31461,
  DunnEdwards_DE5321_Jackpot: 31462,
  DunnEdwards_DE5322_PalePearl: 31463,
  DunnEdwards_DE5323_QuietSplendor: 31464,
  DunnEdwards_DE5324_FineSand: 31465,
  DunnEdwards_DE5325_RegencyCream: 31466,
  DunnEdwards_DE5326_RootBeerFloat: 31467,
  DunnEdwards_DE5327_GhostTown: 31468,
  DunnEdwards_DE5328_Driftwood: 31469,
  DunnEdwards_DE5329_ParchmentPaper: 31470,
  DunnEdwards_DE5330_Biscuit: 31471,
  DunnEdwards_DE5331_Pasta: 31472,
  DunnEdwards_DE5332_BurmeseTan: 31473,
  DunnEdwards_DE5333_BurstOfGold: 31474,
  DunnEdwards_DE5334_GingerbreadHouse: 31475,
  DunnEdwards_DE5335_GoldenSlumber: 31476,
  DunnEdwards_DE5336_LemonIce: 31477,
  DunnEdwards_DE5337_Lit: 31478,
  DunnEdwards_DE5338_TwinklingLights: 31479,
  DunnEdwards_DE5339_FireflyGlow: 31480,
  DunnEdwards_DE5340_BananaPeel: 31481,
  DunnEdwards_DE5341_TuscanSun: 31482,
  DunnEdwards_DE5342_Bumblebee: 31483,
  DunnEdwards_DE5343_SheerSunlight: 31484,
  DunnEdwards_DE5344_CreamedButter: 31485,
  DunnEdwards_DE5345_Afterglow: 31486,
  DunnEdwards_DE5346_QuackQuack: 31487,
  DunnEdwards_DE5347_GoldenNectar: 31488,
  DunnEdwards_DE5348_CornHarvest: 31489,
  DunnEdwards_DE5349_HotSun: 31490,
  DunnEdwards_DE5350_PaleRays: 31491,
  DunnEdwards_DE5351_AztecAura: 31492,
  DunnEdwards_DE5352_SunKissed: 31493,
  DunnEdwards_DE5353_GoldenCrest: 31494,
  DunnEdwards_DE5354_HoneyGlow: 31495,
  DunnEdwards_DE5355_FortuneCookie: 31496,
  DunnEdwards_DE5356_RomanGold: 31497,
  DunnEdwards_DE5357_CreamPuff: 31498,
  DunnEdwards_DE5358_IvoryOats: 31499,
  DunnEdwards_DE5359_Crossroads: 31500,
  DunnEdwards_DE5360_WheatBread: 31501,
  DunnEdwards_DE5361_CaribouHerd: 31502,
  DunnEdwards_DE5362_MapleSyrup: 31503,
  DunnEdwards_DE5363_WalnutShell: 31504,
  DunnEdwards_DE5364_CoffeeCream: 31505,
  DunnEdwards_DE5365_BurnishedCream: 31506,
  DunnEdwards_DE5366_MidlandTan: 31507,
  DunnEdwards_DE5367_DesertedPath: 31508,
  DunnEdwards_DE5368_BrownWood: 31509,
  DunnEdwards_DE5369_LaredoRoad: 31510,
  DunnEdwards_DE5370_BreadCrust: 31511,
  DunnEdwards_DE5371_WhiteBeach: 31512,
  DunnEdwards_DE5372_Sheepskin: 31513,
  DunnEdwards_DE5373_ClayDust: 31514,
  DunnEdwards_DE5374_AlmondCookie: 31515,
  DunnEdwards_DE5375_SantaFeTan: 31516,
  DunnEdwards_DE5376_Chipmunk: 31517,
  DunnEdwards_DE5377_TradingPost: 31518,
  DunnEdwards_DE5378_CottonTail: 31519,
  DunnEdwards_DE5379_CrownPointCream: 31520,
  DunnEdwards_DE5380_DurangoDust: 31521,
  DunnEdwards_DE5381_Summertime: 31522,
  DunnEdwards_DE5382_GoldenAppeal: 31523,
  DunnEdwards_DE5383_HoneyGrove: 31524,
  DunnEdwards_DE5384_SpicyMustard: 31525,
  DunnEdwards_DE5385_BrightStar: 31526,
  DunnEdwards_DE5386_RicePaper: 31527,
  DunnEdwards_DE5387_LemonChiffonPie: 31528,
  DunnEdwards_DE5388_SourLemon: 31529,
  DunnEdwards_DE5389_RipePineapple: 31530,
  DunnEdwards_DE5390_RubberDucky: 31531,
  DunnEdwards_DE5391_Sunflower: 31532,
  DunnEdwards_DE5392_LambsWool: 31533,
  DunnEdwards_DE5393_PoeticYellow: 31534,
  DunnEdwards_DE5394_BreakOfDay: 31535,
  DunnEdwards_DE5395_BananaCream: 31536,
  DunnEdwards_DE5396_FuzzyDuckling: 31537,
  DunnEdwards_DE5397_RadiantSunrise: 31538,
  DunnEdwards_DE5398_LemonPunch: 31539,
  DunnEdwards_DE5399_Candlelight: 31540,
  DunnEdwards_DE5400_Parmesan: 31541,
  DunnEdwards_DE5401_GoldenWash: 31542,
  DunnEdwards_DE5402_LemonSlice: 31543,
  DunnEdwards_DE5403_Chickadee: 31544,
  DunnEdwards_DE5404_Highlighter: 31545,
  DunnEdwards_DE5405_SummerSun: 31546,
  DunnEdwards_DE5406_LaLuna: 31547,
  DunnEdwards_DE5407_PumpkinSeed: 31548,
  DunnEdwards_DE5408_LemonSorbet: 31549,
  DunnEdwards_DE5409_SunSurprise: 31550,
  DunnEdwards_DE5410_GoldenGlitter: 31551,
  DunnEdwards_DE5411_FreshPineapple: 31552,
  DunnEdwards_DE5412_LemonZest: 31553,
  DunnEdwards_DE5413_CottonPuff: 31554,
  DunnEdwards_DE5414_SunCity: 31555,
  DunnEdwards_DE5415_IcedLemon: 31556,
  DunnEdwards_DE5416_CandleFlame: 31557,
  DunnEdwards_DE5417_Dandelion: 31558,
  DunnEdwards_DE5418_Gilded: 31559,
  DunnEdwards_DE5419_Soleil: 31560,
  DunnEdwards_DE5420_CountrySummer: 31561,
  DunnEdwards_DE5421_GentleYellow: 31562,
  DunnEdwards_DE5422_EggNog: 31563,
  DunnEdwards_DE5423_GoldenRays: 31564,
  DunnEdwards_DE5424_YellowBrickRoad: 31565,
  DunnEdwards_DE5425_WovenGold: 31566,
  DunnEdwards_DE5426_MustardSeed: 31567,
  DunnEdwards_DE5427_BavarianCream: 31568,
  DunnEdwards_DE5428_SilentIvory: 31569,
  DunnEdwards_DE5429_GoldSand: 31570,
  DunnEdwards_DE5430_BeachHouse: 31571,
  DunnEdwards_DE5431_Candelabra: 31572,
  DunnEdwards_DE5432_Haystacks: 31573,
  DunnEdwards_DE5433_GoldenHistory: 31574,
  DunnEdwards_DE5434_DesertLily: 31575,
  DunnEdwards_DE5435_CookieDough: 31576,
  DunnEdwards_DE5436_Tortilla: 31577,
  DunnEdwards_DE5437_Biscotti: 31578,
  DunnEdwards_DE5438_FilteredRays: 31579,
  DunnEdwards_DE5439_BrownRum: 31580,
  DunnEdwards_DE5440_ArrowRock: 31581,
  DunnEdwards_DE5441_NaturalWool: 31582,
  DunnEdwards_DE5442_CandleInTheWind: 31583,
  DunnEdwards_DE5443_HazyMoon: 31584,
  DunnEdwards_DE5444_WaffleCone: 31585,
  DunnEdwards_DE5445_TanamiDesert: 31586,
  DunnEdwards_DE5446_Underbrush: 31587,
  DunnEdwards_DE5447_PeanutBrittle: 31588,
  DunnEdwards_DE5448_Supernova: 31589,
  DunnEdwards_DE5449_Moonstruck: 31590,
  DunnEdwards_DE5450_SugarCookie: 31591,
  DunnEdwards_DE5451_DijonMustard: 31592,
  DunnEdwards_DE5452_GoldGleam: 31593,
  DunnEdwards_DE5453_TikiTorch: 31594,
  DunnEdwards_DE5454_SullenGold: 31595,
  DunnEdwards_DE5455_CottonCloth: 31596,
  DunnEdwards_DE5456_SandyShore: 31597,
  DunnEdwards_DE5457_BambooMat: 31598,
  DunnEdwards_DE5458_MarshField: 31599,
  DunnEdwards_DE5459_MackCreek: 31600,
  DunnEdwards_DE5460_18thCenturyGreen: 31601,
  DunnEdwards_DE5461_EdenPrairie: 31602,
  DunnEdwards_DE5462_SweetButter: 31603,
  DunnEdwards_DE5463_YellowYarn: 31604,
  DunnEdwards_DE5464_LemonGelato: 31605,
  DunnEdwards_DE5465_LightningBug: 31606,
  DunnEdwards_DE5466_CitrusSpice: 31607,
  DunnEdwards_DE5467_YellowStone: 31608,
  DunnEdwards_DE5468_PickleJuice: 31609,
  DunnEdwards_DE5469_FocusOnLight: 31610,
  DunnEdwards_DE5470_FineLinen: 31611,
  DunnEdwards_DE5471_ShadedSun: 31612,
  DunnEdwards_DE5472_LustrousYellow: 31613,
  DunnEdwards_DE5473_Citron: 31614,
  DunnEdwards_DE5474_Pesto: 31615,
  DunnEdwards_DE5475_Martian: 31616,
  DunnEdwards_DE5476_LightMist: 31617,
  DunnEdwards_DE5477_FreshHoneydew: 31618,
  DunnEdwards_DE5478_BreathOfSpring: 31619,
  DunnEdwards_DE5479_HayDay: 31620,
  DunnEdwards_DE5480_BabyFrog: 31621,
  DunnEdwards_DE5481_MossStone: 31622,
  DunnEdwards_DE5482_Gecko: 31623,
  DunnEdwards_DE5483_LightOfTheMoon: 31624,
  DunnEdwards_DE5484_Limesicle: 31625,
  DunnEdwards_DE5485_RussetGreen: 31626,
  DunnEdwards_DE5486_TropicalMoss: 31627,
  DunnEdwards_DE5487_SpringMarsh: 31628,
  DunnEdwards_DE5488_QueenPalm: 31629,
  DunnEdwards_DE5489_Jalapeno: 31630,
  DunnEdwards_DE5490_AntiqueChina: 31631,
  DunnEdwards_DE5491_GlistenGreen: 31632,
  DunnEdwards_DE5492_SilverFern: 31633,
  DunnEdwards_DE5493_FloatingLilyPad: 31634,
  DunnEdwards_DE5494_EvenGrowth: 31635,
  DunnEdwards_DE5495_GrapeLeaves: 31636,
  DunnEdwards_DE5496_AgedEucalyptus: 31637,
  DunnEdwards_DE5497_TaperingLight: 31638,
  DunnEdwards_DE5498_CallaLily: 31639,
  DunnEdwards_DE5499_DullSage: 31640,
  DunnEdwards_DE5500_OliveHint: 31641,
  DunnEdwards_DE5501_Twine: 31642,
  DunnEdwards_DE5502_Serpentine: 31643,
  DunnEdwards_DE5503_ShadedGlen: 31644,
  DunnEdwards_DE5504_SummerPear: 31645,
  DunnEdwards_DE5505_NaturalLight: 31646,
  DunnEdwards_DE5506_OliveOil: 31647,
  DunnEdwards_DE5507_SourApple: 31648,
  DunnEdwards_DE5508_PalmLeaf: 31649,
  DunnEdwards_DE5509_OrganicMatter: 31650,
  DunnEdwards_DE5510_CiderMill: 31651,
  DunnEdwards_DE5511_IceGlow: 31652,
  DunnEdwards_DE5512_HintOfSpring: 31653,
  DunnEdwards_DE5513_LemonLime: 31654,
  DunnEdwards_DE5514_LeafBud: 31655,
  DunnEdwards_DE5515_RipePear: 31656,
  DunnEdwards_DE5516_Limelight: 31657,
  DunnEdwards_DE5517_FluorescentLime: 31658,
  DunnEdwards_DE5518_LimeBlossom: 31659,
  DunnEdwards_DE5519_PerfectPear: 31660,
  DunnEdwards_DE5520_CrocodileTears: 31661,
  DunnEdwards_DE5521_GrassRoot: 31662,
  DunnEdwards_DE5522_PalmFrond: 31663,
  DunnEdwards_DE5523_LazyLizard: 31664,
  DunnEdwards_DE5524_VegetableGarden: 31665,
  DunnEdwards_DE5525_PaleView: 31666,
  DunnEdwards_DE5526_DuskyMoon: 31667,
  DunnEdwards_DE5527_WovenReed: 31668,
  DunnEdwards_DE5528_Watercress: 31669,
  DunnEdwards_DE5529_StuffedOlive: 31670,
  DunnEdwards_DE5530_MilitaryGreen: 31671,
  DunnEdwards_DE5531_DarkCavern: 31672,
  DunnEdwards_DE5532_Applemint: 31673,
  DunnEdwards_DE5533_WhisperingRain: 31674,
  DunnEdwards_DE5534_PineMist: 31675,
  DunnEdwards_DE5535_LightPine: 31676,
  DunnEdwards_DE5536_DillGrass: 31677,
  DunnEdwards_DE5537_WoodlandWalk: 31678,
  DunnEdwards_DE5538_Bonsai: 31679,
  DunnEdwards_DE5539_FragileFern: 31680,
  DunnEdwards_DE5540_TintedMint: 31681,
  DunnEdwards_DE5541_TrailingVine: 31682,
  DunnEdwards_DE5542_EarlyHarvest: 31683,
  DunnEdwards_DE5543_SpanishOlive: 31684,
  DunnEdwards_DE5544_Topiary: 31685,
  DunnEdwards_DE5545_FreshArtichoke: 31686,
  DunnEdwards_DE5546_LemonJuice: 31687,
  DunnEdwards_DE5547_PaleMorning: 31688,
  DunnEdwards_DE5548_FreshGrown: 31689,
  DunnEdwards_DE5549_WedgeOfLime: 31690,
  DunnEdwards_DE5550_LimeSorbet: 31691,
  DunnEdwards_DE5551_AsparagusFern: 31692,
  DunnEdwards_DE5552_ClippedGrass: 31693,
  DunnEdwards_DE5553_SpringtimeDew: 31694,
  DunnEdwards_DE5554_AppleMartini: 31695,
  DunnEdwards_DE5555_KiwiKiss: 31696,
  DunnEdwards_DE5556_MintJulep: 31697,
  DunnEdwards_DE5557_Celery: 31698,
  DunnEdwards_DE5558_CitrusLeaf: 31699,
  DunnEdwards_DE5559_Chive: 31700,
  DunnEdwards_DE5560_HazyGrove: 31701,
  DunnEdwards_DE5561_LazyCaterpillar: 31702,
  DunnEdwards_DE5562_OliveMartini: 31703,
  DunnEdwards_DE5563_AloePlant: 31704,
  DunnEdwards_DE5564_CocktailOlive: 31705,
  DunnEdwards_DE5565_CrocodileSmile: 31706,
  DunnEdwards_DE5566_TarasDrapes: 31707,
  DunnEdwards_DE5567_SnowyEvergreen: 31708,
  DunnEdwards_DE5568_MistyHillside: 31709,
  DunnEdwards_DE5569_HiddenHills: 31710,
  DunnEdwards_DE5570_Gardening: 31711,
  DunnEdwards_DE5571_IvyEnchantment: 31712,
  DunnEdwards_DE5572_SageLeaves: 31713,
  DunnEdwards_DE5573_DillPickle: 31714,
  DunnEdwards_DE5574_Herbal: 31715,
  DunnEdwards_DE5575_Pastoral: 31716,
  DunnEdwards_DE5576_EnviousPastel: 31717,
  DunnEdwards_DE5577_FieldDay: 31718,
  DunnEdwards_DE5578_Wasabi: 31719,
  DunnEdwards_DE5579_CabbagePatch: 31720,
  DunnEdwards_DE5580_Parakeet: 31721,
  DunnEdwards_DE5581_MorningFrost: 31722,
  DunnEdwards_DE5582_FlowerBulb: 31723,
  DunnEdwards_DE5583_JadeBracelet: 31724,
  DunnEdwards_DE5584_Shrubbery: 31725,
  DunnEdwards_DE5585_Kale: 31726,
  DunnEdwards_DE5586_PeasInAPod: 31727,
  DunnEdwards_DE5587_ShadedSpruce: 31728,
  DunnEdwards_DE5588_HerbGarden: 31729,
  DunnEdwards_DE5589_GreenhouseGlass: 31730,
  DunnEdwards_DE5590_Nature: 31731,
  DunnEdwards_DE5591_PrayingMantis: 31732,
  DunnEdwards_DE5592_Salad: 31733,
  DunnEdwards_DE5593_FourLeafClover: 31734,
  DunnEdwards_DE5594_JollyGreen: 31735,
  DunnEdwards_DE5595_CremeDeMenthe: 31736,
  DunnEdwards_DE5596_FrostedGarden: 31737,
  DunnEdwards_DE5597_Margarita: 31738,
  DunnEdwards_DE5598_Jealousy: 31739,
  DunnEdwards_DE5599_FreshCutGrass: 31740,
  DunnEdwards_DE5600_PalmTree: 31741,
  DunnEdwards_DE5601_GolfCourse: 31742,
  DunnEdwards_DE5602_WinterOasis: 31743,
  DunnEdwards_DE5603_Mojito: 31744,
  DunnEdwards_DE5604_ButterLettuce: 31745,
  DunnEdwards_DE5605_FlowerStem: 31746,
  DunnEdwards_DE5606_RollingHills: 31747,
  DunnEdwards_DE5607_GardenOfEden: 31748,
  DunnEdwards_DE5608_IrishCharm: 31749,
  DunnEdwards_DE5609_DistantLandscape: 31750,
  DunnEdwards_DE5610_SoftMoss: 31751,
  DunnEdwards_DE5611_SpinachDip: 31752,
  DunnEdwards_DE5612_Foliage: 31753,
  DunnEdwards_DE5613_Money: 31754,
  DunnEdwards_DE5614_TeeOff: 31755,
  DunnEdwards_DE5615_ClimbingIvy: 31756,
  DunnEdwards_DE5616_GardenDawn: 31757,
  DunnEdwards_DE5617_WinterShamrock: 31758,
  DunnEdwards_DE5618_Endive: 31759,
  DunnEdwards_DE5619_SpringFields: 31760,
  DunnEdwards_DE5620_MistletoeKiss: 31761,
  DunnEdwards_DE5621_WildThyme: 31762,
  DunnEdwards_DE5622_Thicket: 31763,
  DunnEdwards_DE5623_AfterDinnerMint: 31764,
  DunnEdwards_DE5624_GardenShed: 31765,
  DunnEdwards_DE5625_MotherNature: 31766,
  DunnEdwards_DE5626_PottedPlant: 31767,
  DunnEdwards_DE5627_Verde: 31768,
  DunnEdwards_DE5628_Leafy: 31769,
  DunnEdwards_DE5629_EmeraldRing: 31770,
  DunnEdwards_DE5630_LimeSlice: 31771,
  DunnEdwards_DE5631_MistyLawn: 31772,
  DunnEdwards_DE5632_CreamyMint: 31773,
  DunnEdwards_DE5633_WeekendGardener: 31774,
  DunnEdwards_DE5634_SnowPea: 31775,
  DunnEdwards_DE5635_ArtificialTurf: 31776,
  DunnEdwards_DE5636_GetUpAndGo: 31777,
  DunnEdwards_DE5637_GlacierIvy: 31778,
  DunnEdwards_DE5638_CottageGreen: 31779,
  DunnEdwards_DE5639_MistyAfternoon: 31780,
  DunnEdwards_DE5640_SpringLeaves: 31781,
  DunnEdwards_DE5641_MermaidsCove: 31782,
  DunnEdwards_DE5642_ForestPath: 31783,
  DunnEdwards_DE5643_Seaweed: 31784,
  DunnEdwards_DE5644_StonePath: 31785,
  DunnEdwards_DE5645_Toadstool: 31786,
  DunnEdwards_DE5646_GardenStatue: 31787,
  DunnEdwards_DE5647_Reeds: 31788,
  DunnEdwards_DE5648_Vineyard: 31789,
  DunnEdwards_DE5649_EnglishHolly: 31790,
  DunnEdwards_DE5650_GreenBayou: 31791,
  DunnEdwards_DE5651_Trellis: 31792,
  DunnEdwards_DE5652_DecemberForest: 31793,
  DunnEdwards_DE5653_GreenLane: 31794,
  DunnEdwards_DE5654_FreshThyme: 31795,
  DunnEdwards_DE5655_FreshSod: 31796,
  DunnEdwards_DE5656_Wreath: 31797,
  DunnEdwards_DE5657_MidnightGarden: 31798,
  DunnEdwards_DE5658_WinterMist: 31799,
  DunnEdwards_DE5659_KeyLimePie: 31800,
  DunnEdwards_DE5660_MintOLicious: 31801,
  DunnEdwards_DE5661_PeacefulPastures: 31802,
  DunnEdwards_DE5662_CloverMist: 31803,
  DunnEdwards_DE5663_Parsley: 31804,
  DunnEdwards_DE5664_ShamrockField: 31805,
  DunnEdwards_DE5665_PeacefulRain: 31806,
  DunnEdwards_DE5666_AloeMist: 31807,
  DunnEdwards_DE5667_MintSmoothie: 31808,
  DunnEdwards_DE5668_GlenwoodGreen: 31809,
  DunnEdwards_DE5669_ForestFrolic: 31810,
  DunnEdwards_DE5670_Growth: 31811,
  DunnEdwards_DE5671_SpringGarden: 31812,
  DunnEdwards_DE5672_MintChiffon: 31813,
  DunnEdwards_DE5673_PaleCactus: 31814,
  DunnEdwards_DE5674_FaintClover: 31815,
  DunnEdwards_DE5675_SprigOfMint: 31816,
  DunnEdwards_DE5676_Vegetation: 31817,
  DunnEdwards_DE5677_Jungle: 31818,
  DunnEdwards_DE5678_LaterGator: 31819,
  DunnEdwards_DE5679_MintCondition: 31820,
  DunnEdwards_DE5680_ShallowEnd: 31821,
  DunnEdwards_DE5681_PaleJade: 31822,
  DunnEdwards_DE5682_StarGrass: 31823,
  DunnEdwards_DE5683_Jadeite: 31824,
  DunnEdwards_DE5684_RainForest: 31825,
  DunnEdwards_DE5685_IrishBeauty: 31826,
  DunnEdwards_DE5686_SoftMint: 31827,
  DunnEdwards_DE5687_MintyFresh: 31828,
  DunnEdwards_DE5688_OdeToGreen: 31829,
  DunnEdwards_DE5689_Wintermint: 31830,
  DunnEdwards_DE5690_Arboretum: 31831,
  DunnEdwards_DE5691_InspirationPeak: 31832,
  DunnEdwards_DE5692_FernGully: 31833,
  DunnEdwards_DE5693_MidspringMorning: 31834,
  DunnEdwards_DE5694_EastCape: 31835,
  DunnEdwards_DE5695_Seafoam: 31836,
  DunnEdwards_DE5696_SweetGarden: 31837,
  DunnEdwards_DE5697_JadeMountain: 31838,
  DunnEdwards_DE5698_TropicalKelp: 31839,
  DunnEdwards_DE5699_EmeraldPool: 31840,
  DunnEdwards_DE5700_FrostyMint: 31841,
  DunnEdwards_DE5701_WhisperOfGrass: 31842,
  DunnEdwards_DE5702_JadedClouds: 31843,
  DunnEdwards_DE5703_TranquilTeal: 31844,
  DunnEdwards_DE5704_TurtleLake: 31845,
  DunnEdwards_DE5705_CrispLettuce: 31846,
  DunnEdwards_DE5706_PineNeedle: 31847,
  DunnEdwards_DE5707_MistOfGreen: 31848,
  DunnEdwards_DE5708_DewNotDisturb: 31849,
  DunnEdwards_DE5709_SteamySpring: 31850,
  DunnEdwards_DE5710_Treetop: 31851,
  DunnEdwards_DE5711_UpNorth: 31852,
  DunnEdwards_DE5712_StatelyStems: 31853,
  DunnEdwards_DE5713_PineHaven: 31854,
  DunnEdwards_DE5714_SilentBreath: 31855,
  DunnEdwards_DE5715_Fizzle: 31856,
  DunnEdwards_DE5716_RollingWaves: 31857,
  DunnEdwards_DE5717_PistachioIceCream: 31858,
  DunnEdwards_DE5718_MotherEarth: 31859,
  DunnEdwards_DE5719_Ecological: 31860,
  DunnEdwards_DE5720_DeepInTheJungle: 31861,
  DunnEdwards_DE5721_AirOfMint: 31862,
  DunnEdwards_DE5722_TropicalWaterfall: 31863,
  DunnEdwards_DE5723_FountainCity: 31864,
  DunnEdwards_DE5724_PolishedAqua: 31865,
  DunnEdwards_DE5725_DragonBay: 31866,
  DunnEdwards_DE5726_RoyalPalm: 31867,
  DunnEdwards_DE5727_ImperialDynasty: 31868,
  DunnEdwards_DE5728_TintedIce: 31869,
  DunnEdwards_DE5729_Spearmint: 31870,
  DunnEdwards_DE5730_IslandOasis: 31871,
  DunnEdwards_DE5731_PortHope: 31872,
  DunnEdwards_DE5732_TealMeNoLies: 31873,
  DunnEdwards_DE5733_ReefEncounter: 31874,
  DunnEdwards_DE5734_EmperorJade: 31875,
  DunnEdwards_DE5735_MorningCalm: 31876,
  DunnEdwards_DE5736_SoaringSky: 31877,
  DunnEdwards_DE5737_AquaBloom: 31878,
  DunnEdwards_DE5738_Castaway: 31879,
  DunnEdwards_DE5739_MontegoBay: 31880,
  DunnEdwards_DE5740_DeepLagoon: 31881,
  DunnEdwards_DE5741_PeacockPlume: 31882,
  DunnEdwards_DE5742_ThawedOut: 31883,
  DunnEdwards_DE5743_SilverSpruce: 31884,
  DunnEdwards_DE5744_Seaport: 31885,
  DunnEdwards_DE5745_BarrierReef: 31886,
  DunnEdwards_DE5746_AspenHush: 31887,
  DunnEdwards_DE5747_StoneBridge: 31888,
  DunnEdwards_DE5748_LochNess: 31889,
  DunnEdwards_DE5749_Windswept: 31890,
  DunnEdwards_DE5750_WinterEscape: 31891,
  DunnEdwards_DE5751_PlungingWaterfall: 31892,
  DunnEdwards_DE5752_FadedJeans: 31893,
  DunnEdwards_DE5753_Riviera: 31894,
  DunnEdwards_DE5754_TropicalTeal: 31895,
  DunnEdwards_DE5755_CarnivalNight: 31896,
  DunnEdwards_DE5756_LetItSnow: 31897,
  DunnEdwards_DE5757_AcrossTheBay: 31898,
  DunnEdwards_DE5758_WinterChill: 31899,
  DunnEdwards_DE5759_GulfStream: 31900,
  DunnEdwards_DE5760_CaribbeanCruise: 31901,
  DunnEdwards_DE5761_RiverFountain: 31902,
  DunnEdwards_DE5762_TealFury: 31903,
  DunnEdwards_DE5763_SparklingRiver: 31904,
  DunnEdwards_DE5764_BlueMoon: 31905,
  DunnEdwards_DE5765_Surfside: 31906,
  DunnEdwards_DE5766_WatsonLake: 31907,
  DunnEdwards_DE5767_StarCity: 31908,
  DunnEdwards_DE5768_MysteriousBlue: 31909,
  DunnEdwards_DE5769_AfterTheStorm: 31910,
  DunnEdwards_DE5770_SmokeAndMirrors: 31911,
  DunnEdwards_DE5771_Shark: 31912,
  DunnEdwards_DE5772_BlueSpruce: 31913,
  DunnEdwards_DE5773_StoneSilver: 31914,
  DunnEdwards_DE5774_Thundercloud: 31915,
  DunnEdwards_DE5775_IronCreek: 31916,
  DunnEdwards_DE5776_LunarEclipse: 31917,
  DunnEdwards_DE5777_Frostproof: 31918,
  DunnEdwards_DE5778_CrystalRiver: 31919,
  DunnEdwards_DE5779_Bayshore: 31920,
  DunnEdwards_DE5780_WaterBaby: 31921,
  DunnEdwards_DE5781_TropicalLagoon: 31922,
  DunnEdwards_DE5782_ByTheBayou: 31923,
  DunnEdwards_DE5783_NocturnalSea: 31924,
  DunnEdwards_DE5784_IceCold: 31925,
  DunnEdwards_DE5785_GlacierPoint: 31926,
  DunnEdwards_DE5786_EasternSky: 31927,
  DunnEdwards_DE5787_PacificPalisade: 31928,
  DunnEdwards_DE5788_AegeanSea: 31929,
  DunnEdwards_DE5789_EnglishRiver: 31930,
  DunnEdwards_DE5790_Atlantis: 31931,
  DunnEdwards_DE5791_SidewalkChalk: 31932,
  DunnEdwards_DE5792_FallingTears: 31933,
  DunnEdwards_DE5793_FrozenTundra: 31934,
  DunnEdwards_DE5794_LakeWinnipeg: 31935,
  DunnEdwards_DE5795_SpiritMountain: 31936,
  DunnEdwards_DE5796_BeforeTheStorm: 31937,
  DunnEdwards_DE5797_SlateWall: 31938,
  DunnEdwards_DE5798_PolarIce: 31939,
  DunnEdwards_DE5799_SnowLodge: 31940,
  DunnEdwards_DE5800_PeaceRiver: 31941,
  DunnEdwards_DE5801_SilverSkate: 31942,
  DunnEdwards_DE5802_ChinaClay: 31943,
  DunnEdwards_DE5803_TurbulentSea: 31944,
  DunnEdwards_DE5804_Nightfall: 31945,
  DunnEdwards_DE5805_PaleFrost: 31946,
  DunnEdwards_DE5806_Dockside: 31947,
  DunnEdwards_DE5807_BonnieBlue: 31948,
  DunnEdwards_DE5808_LakeLucerne: 31949,
  DunnEdwards_DE5809_RagingTide: 31950,
  DunnEdwards_DE5810_CrashingWaves: 31951,
  DunnEdwards_DE5811_SummerNight: 31952,
  DunnEdwards_DE5812_DreamyBlue: 31953,
  DunnEdwards_DE5813_TwoHarbors: 31954,
  DunnEdwards_DE5814_AnchorsAway: 31955,
  DunnEdwards_DE5815_FrozenLake: 31956,
  DunnEdwards_DE5816_SealPup: 31957,
  DunnEdwards_DE5817_StormySea: 31958,
  DunnEdwards_DE5818_MidnightHaze: 31959,
  DunnEdwards_DE5819_PearlCity: 31960,
  DunnEdwards_DE5820_PolishedSilver: 31961,
  DunnEdwards_DE5821_OvercastSky: 31962,
  DunnEdwards_DE5822_SilverStorm: 31963,
  DunnEdwards_DE5823_MicaCreek: 31964,
  DunnEdwards_DE5824_OuterSpace: 31965,
  DunnEdwards_DE5825_DeepestSea: 31966,
  DunnEdwards_DE5826_FrostyDay: 31967,
  DunnEdwards_DE5827_SpringShower: 31968,
  DunnEdwards_DE5828_WinterChime: 31969,
  DunnEdwards_DE5829_FrozenWave: 31970,
  DunnEdwards_DE5830_MediterraneanSea: 31971,
  DunnEdwards_DE5831_TealTune: 31972,
  DunnEdwards_DE5832_NavyTeal: 31973,
  DunnEdwards_DE5833_Teardrops: 31974,
  DunnEdwards_DE5834_AzureSky: 31975,
  DunnEdwards_DE5835_BelowZero: 31976,
  DunnEdwards_DE5836_SailAway: 31977,
  DunnEdwards_DE5837_PoolParty: 31978,
  DunnEdwards_DE5838_SummerLake: 31979,
  DunnEdwards_DE5839_InkBlotch: 31980,
  DunnEdwards_DE5840_IceCastle: 31981,
  DunnEdwards_DE5841_ArcticParadise: 31982,
  DunnEdwards_DE5842_LightAzure: 31983,
  DunnEdwards_DE5843_SanctuarySpa: 31984,
  DunnEdwards_DE5844_SplishSplash: 31985,
  DunnEdwards_DE5845_Americana: 31986,
  DunnEdwards_DE5846_Lapis: 31987,
  DunnEdwards_DE5847_IceFishing: 31988,
  DunnEdwards_DE5848_IslandView: 31989,
  DunnEdwards_DE5849_JanuaryFrost: 31990,
  DunnEdwards_DE5850_WanderingRiver: 31991,
  DunnEdwards_DE5851_BlueberryMuffin: 31992,
  DunnEdwards_DE5852_RainyLake: 31993,
  DunnEdwards_DE5853_BlueEarth: 31994,
  DunnEdwards_DE5854_FreshWater: 31995,
  DunnEdwards_DE5855_WildBlueYonder: 31996,
  DunnEdwards_DE5856_Astral: 31997,
  DunnEdwards_DE5857_Marina: 31998,
  DunnEdwards_DE5858_WalkerLake: 31999,
  DunnEdwards_DE5859_TheBlues: 32000,
  DunnEdwards_DE5860_Slumber: 32001,
  DunnEdwards_DE5861_Cloudless: 32002,
  DunnEdwards_DE5862_OhBoy: 32003,
  DunnEdwards_DE5863_SailToTheSea: 32004,
  DunnEdwards_DE5864_Cornflower: 32005,
  DunnEdwards_DE5865_SafeHarbor: 32006,
  DunnEdwards_DE5866_DoverStraits: 32007,
  DunnEdwards_DE5867_BlueChip: 32008,
  DunnEdwards_DE5868_WinterSolstice: 32009,
  DunnEdwards_DE5869_OceanaDrive: 32010,
  DunnEdwards_DE5870_NorthernPond: 32011,
  DunnEdwards_DE5871_Downpour: 32012,
  DunnEdwards_DE5872_Lakeville: 32013,
  DunnEdwards_DE5873_Periscope: 32014,
  DunnEdwards_DE5874_DeepReservoir: 32015,
  DunnEdwards_DE5875_ClearVision: 32016,
  DunnEdwards_DE5876_AlaskanSkies: 32017,
  DunnEdwards_DE5877_AfternoonSky: 32018,
  DunnEdwards_DE5878_BachelorBlue: 32019,
  DunnEdwards_DE5879_OceanCity: 32020,
  DunnEdwards_DE5880_CleanSlate: 32021,
  DunnEdwards_DE5881_NewburyPort: 32022,
  DunnEdwards_DE5882_HarborAfternoon: 32023,
  DunnEdwards_DE5883_DrenchedRain: 32024,
  DunnEdwards_DE5884_MistedEve: 32025,
  DunnEdwards_DE5885_DenimTradition: 32026,
  DunnEdwards_DE5886_BayView: 32027,
  DunnEdwards_DE5887_AdmiralBlue: 32028,
  DunnEdwards_DE5888_LunaPier: 32029,
  DunnEdwards_DE5889_RainyDay: 32030,
  DunnEdwards_DE5890_FlyAKite: 32031,
  DunnEdwards_DE5891_SkyHigh: 32032,
  DunnEdwards_DE5892_BlueCue: 32033,
  DunnEdwards_DE5893_BodegaBay: 32034,
  DunnEdwards_DE5894_Starstruck: 32035,
  DunnEdwards_DE5895_DiveIn: 32036,
  DunnEdwards_DE5896_CrystalFalls: 32037,
  DunnEdwards_DE5897_SnowyShadow: 32038,
  DunnEdwards_DE5898_PrimBlue: 32039,
  DunnEdwards_DE5899_SapphireFog: 32040,
  DunnEdwards_DE5900_EnchantingSky: 32041,
  DunnEdwards_DE5901_OceanNight: 32042,
  DunnEdwards_DE5902_BlueReview: 32043,
  DunnEdwards_DE5903_IcyLilac: 32044,
  DunnEdwards_DE5904_FlaxBloom: 32045,
  DunnEdwards_DE5905_LarkspurBud: 32046,
  DunnEdwards_DE5906_Periwinkle: 32047,
  DunnEdwards_DE5907_TwilightTwinkle: 32048,
  DunnEdwards_DE5908_Bellflower: 32049,
  DunnEdwards_DE5909_BeadedBlue: 32050,
  DunnEdwards_DE5910_WhisperBlue: 32051,
  DunnEdwards_DE5911_ChillInTheAir: 32052,
  DunnEdwards_DE5912_HazySky: 32053,
  DunnEdwards_DE5913_MidnightBlush: 32054,
  DunnEdwards_DE5914_BossaNovaBlue: 32055,
  DunnEdwards_DE5915_ChampionBlue: 32056,
  DunnEdwards_DE5916_Intergalactic: 32057,
  DunnEdwards_DE5917_FrostyFog: 32058,
  DunnEdwards_DE5918_PaleShale: 32059,
  DunnEdwards_DE5919_SpaciousSky: 32060,
  DunnEdwards_DE5920_LondonFog: 32061,
  DunnEdwards_DE5921_YourShadow: 32062,
  DunnEdwards_DE5922_PencilLead: 32063,
  DunnEdwards_DE5923_DeepMystery: 32064,
  DunnEdwards_DE5924_IcyLavender: 32065,
  DunnEdwards_DE5925_Hailstorm: 32066,
  DunnEdwards_DE5926_MadderBlue: 32067,
  DunnEdwards_DE5927_CharcoalDust: 32068,
  DunnEdwards_DE5928_BlueIntrigue: 32069,
  DunnEdwards_DE5929_PurpleDaze: 32070,
  DunnEdwards_DE5930_LegendaryPurple: 32071,
  DunnEdwards_DE5931_CoolFrost: 32072,
  DunnEdwards_DE5932_TranquilSea: 32073,
  DunnEdwards_DE5933_WinterDusk: 32074,
  DunnEdwards_DE5934_BayFog: 32075,
  DunnEdwards_DE5935_SoftCharcoal: 32076,
  DunnEdwards_DE5936_Graphite: 32077,
  DunnEdwards_DE5937_NightNight: 32078,
  DunnEdwards_DE5938_Dusk: 32079,
  DunnEdwards_DE5939_LavenderSky: 32080,
  DunnEdwards_DE5940_VioletGems: 32081,
  DunnEdwards_DE5941_SimplyViolet: 32082,
  DunnEdwards_DE5942_FarawaySky: 32083,
  DunnEdwards_DE5943_MardiGras: 32084,
  DunnEdwards_DE5944_FreshEggplant: 32085,
  DunnEdwards_DE5945_ModestViolet: 32086,
  DunnEdwards_DE5946_VioletCrush: 32087,
  DunnEdwards_DE5947_PlayfulPurple: 32088,
  DunnEdwards_DE5948_GrapeGatsby: 32089,
  DunnEdwards_DE5949_GrapeJam: 32090,
  DunnEdwards_DE5950_PurpleGumball: 32091,
  DunnEdwards_DE5951_ExoticEvening: 32092,
  DunnEdwards_DE5952_TranquilEve: 32093,
  DunnEdwards_DE5953_AlpineMoon: 32094,
  DunnEdwards_DE5954_SoftPurple: 32095,
  DunnEdwards_DE5955_PurpleSprings: 32096,
  DunnEdwards_DE5956_PaleEggplant: 32097,
  DunnEdwards_DE5957_PrincelyViolet: 32098,
  DunnEdwards_DE5958_PurplePotion: 32099,
  DunnEdwards_DE5959_LingeringLilac: 32100,
  DunnEdwards_DE5960_ShimmeringSky: 32101,
  DunnEdwards_DE5961_TintedIris: 32102,
  DunnEdwards_DE5962_OdeToPurple: 32103,
  DunnEdwards_DE5963_SmashedGrape: 32104,
  DunnEdwards_DE5964_ConcordJam: 32105,
  DunnEdwards_DE5965_RomanPurple: 32106,
  DunnEdwards_DE5966_PerfumeHaze: 32107,
  DunnEdwards_DE5967_PoutyPurple: 32108,
  DunnEdwards_DE5968_YorkPlum: 32109,
  DunnEdwards_DE5969_PurplePremiere: 32110,
  DunnEdwards_DE5970_LushLilac: 32111,
  DunnEdwards_DE5971_Jubilee: 32112,
  DunnEdwards_DE5972_RoyalRobe: 32113,
  DunnEdwards_DE5973_SnowPlum: 32114,
  DunnEdwards_DE5974_SoftLilac: 32115,
  DunnEdwards_DE5975_AntiqueHeather: 32116,
  DunnEdwards_DE5976_VeiledViolet: 32117,
  DunnEdwards_DE5977_MutedBerry: 32118,
  DunnEdwards_DE5978_PlumWine: 32119,
  DunnEdwards_DE5979_PurpleTrinket: 32120,
  DunnEdwards_DE5980_SheerLavender: 32121,
  DunnEdwards_DE5981_FirstLilac: 32122,
  DunnEdwards_DE5982_PlumPoint: 32123,
  DunnEdwards_DE5983_PurpleProphet: 32124,
  DunnEdwards_DE5984_CloudyPlum: 32125,
  DunnEdwards_DE5985_PlumPower: 32126,
  DunnEdwards_DE5986_YourMajesty: 32127,
  DunnEdwards_DE5987_SoftLavender: 32128,
  DunnEdwards_DE5988_LavenderPrincess: 32129,
  DunnEdwards_DE5989_PrettyPetunia: 32130,
  DunnEdwards_DE5990_AmethystShow: 32131,
  DunnEdwards_DE5991_PurplePride: 32132,
  DunnEdwards_DE5992_Cabaret: 32133,
  DunnEdwards_DE5993_PalacePurple: 32134,
  DunnEdwards_DE5994_PartialPink: 32135,
  DunnEdwards_DE5995_GrapeTaffy: 32136,
  DunnEdwards_DE5996_PromCorsage: 32137,
  DunnEdwards_DE5997_FavoriteLavender: 32138,
  DunnEdwards_DE5998_LavenderSweater: 32139,
  DunnEdwards_DE5999_RoyalPretender: 32140,
  DunnEdwards_DE6000_VibrantOrchid: 32141,
  DunnEdwards_DE6001_CherryBlossoms: 32142,
  DunnEdwards_DE6002_Infatuation: 32143,
  DunnEdwards_DE6003_SweetiePie: 32144,
  DunnEdwards_DE6004_PrizeWinningOrchid: 32145,
  DunnEdwards_DE6005_VictorianViolet: 32146,
  DunnEdwards_DE6006_PlumPerfect: 32147,
  DunnEdwards_DE6007_OldFashionedPurple: 32148,
  DunnEdwards_DE6008_CrystalClear: 32149,
  DunnEdwards_DE6009_BillowingClouds: 32150,
  DunnEdwards_DE6010_ElusiveViolet: 32151,
  DunnEdwards_DE6011_MagicalMauve: 32152,
  DunnEdwards_DE6012_Plumville: 32153,
  DunnEdwards_DE6013_AmazingAmethyst: 32154,
  DunnEdwards_DE6014_DarkChocolate: 32155,
  DunnEdwards_DE6015_FirstImpression: 32156,
  DunnEdwards_DE6016_DesertMauve: 32157,
  DunnEdwards_DE6017_MeltingViolet: 32158,
  DunnEdwards_DE6018_PlayfulPlum: 32159,
  DunnEdwards_DE6019_BohemianJazz: 32160,
  DunnEdwards_DE6020_RipePlum: 32161,
  DunnEdwards_DE6021_OuterBoundary: 32162,
  DunnEdwards_DE6022_MarshmallowRose: 32163,
  DunnEdwards_DE6023_ShortAndSweet: 32164,
  DunnEdwards_DE6024_PencilEraser: 32165,
  DunnEdwards_DE6025_RoseMeadow: 32166,
  DunnEdwards_DE6026_HandmadeRed: 32167,
  DunnEdwards_DE6027_AntiqueGarnet: 32168,
  DunnEdwards_DE6028_DarkRuby: 32169,
  DunnEdwards_DE6029_MotherOfPearl: 32170,
  DunnEdwards_DE6030_Whirlwind: 32171,
  DunnEdwards_DE6031_WaftingGray: 32172,
  DunnEdwards_DE6032_Hazelnut: 32173,
  DunnEdwards_DE6033_PorcupineNeedles: 32174,
  DunnEdwards_DE6034_RaisinInTheSun: 32175,
  DunnEdwards_DE6035_Lynx: 32176,
  DunnEdwards_DE6036_CloudyGray: 32177,
  DunnEdwards_DE6037_Geyser: 32178,
  DunnEdwards_DE6038_YoungFawn: 32179,
  DunnEdwards_DE6039_Monsoon: 32180,
  DunnEdwards_DE6040_CaveOfTheWinds: 32181,
  DunnEdwards_DE6041_MissingLink: 32182,
  DunnEdwards_DE6042_BearInMind: 32183,
  DunnEdwards_DE6043_Mannequin: 32184,
  DunnEdwards_DE6044_MistyBlush: 32185,
  DunnEdwards_DE6045_WispyMauve: 32186,
  DunnEdwards_DE6046_AshHollow: 32187,
  DunnEdwards_DE6047_EclecticPlum: 32188,
  DunnEdwards_DE6048_PineCone: 32189,
  DunnEdwards_DE6049_Chaps: 32190,
  DunnEdwards_DE6050_WhiteRussian: 32191,
  DunnEdwards_DE6051_PaleBerries: 32192,
  DunnEdwards_DE6052_DustyTrail: 32193,
  DunnEdwards_DE6053_PlushSuede: 32194,
  DunnEdwards_DE6054_PrairieDog: 32195,
  DunnEdwards_DE6055_WildWest: 32196,
  DunnEdwards_DE6056_BuffaloHerd: 32197,
  DunnEdwards_DE6057_Raindrops: 32198,
  DunnEdwards_DE6058_ThickFog: 32199,
  DunnEdwards_DE6059_ChocolateMilk: 32200,
  DunnEdwards_DE6060_TwilightTaupe: 32201,
  DunnEdwards_DE6061_RiverRocks: 32202,
  DunnEdwards_DE6062_TeaBag: 32203,
  DunnEdwards_DE6063_BlackWalnut: 32204,
  DunnEdwards_DE6064_Windmill: 32205,
  DunnEdwards_DE6065_StudioWhite: 32206,
  DunnEdwards_DE6066_DesertRock: 32207,
  DunnEdwards_DE6067_CrushedStone: 32208,
  DunnEdwards_DE6068_CobblestonePath: 32209,
  DunnEdwards_DE6069_BannisterBrown: 32210,
  DunnEdwards_DE6070_ChocolateChunk: 32211,
  DunnEdwards_DE6071_SpooledWhite: 32212,
  DunnEdwards_DE6072_GalleryGray: 32213,
  DunnEdwards_DE6073_NewWool: 32214,
  DunnEdwards_DE6074_FrontierLand: 32215,
  DunnEdwards_DE6075_WoodLake: 32216,
  DunnEdwards_DE6076_WanderingRoad: 32217,
  DunnEdwards_DE6077_DeepBrown: 32218,
  DunnEdwards_DE6078_FadedLight: 32219,
  DunnEdwards_DE6079_TouchOfTan: 32220,
  DunnEdwards_DE6080_TravelingTan: 32221,
  DunnEdwards_DE6081_RoseBisque: 32222,
  DunnEdwards_DE6082_HickoryBranch: 32223,
  DunnEdwards_DE6083_BadlandsSunset: 32224,
  DunnEdwards_DE6084_RoxyBrown: 32225,
  DunnEdwards_DE6085_RosyTan: 32226,
  DunnEdwards_DE6086_TanWhirl: 32227,
  DunnEdwards_DE6087_MuddyRose: 32228,
  DunnEdwards_DE6088_Musk: 32229,
  DunnEdwards_DE6089_BrickFence: 32230,
  DunnEdwards_DE6090_WesternRed: 32231,
  DunnEdwards_DE6091_RedHook: 32232,
  DunnEdwards_DE6092_AncientScroll: 32233,
  DunnEdwards_DE6093_BlushingBride: 32234,
  DunnEdwards_DE6094_CanyonDusk: 32235,
  DunnEdwards_DE6095_HowdyPartner: 32236,
  DunnEdwards_DE6096_Homestead: 32237,
  DunnEdwards_DE6097_MontereyBrown: 32238,
  DunnEdwards_DE6098_BurnsCave: 32239,
  DunnEdwards_DE6099_VanillaBlush: 32240,
  DunnEdwards_DE6100_Canyonville: 32241,
  DunnEdwards_DE6101_GalvestonTan: 32242,
  DunnEdwards_DE6102_Hayride: 32243,
  DunnEdwards_DE6103_CopperLake: 32244,
  DunnEdwards_DE6104_ChicBrick: 32245,
  DunnEdwards_DE6105_WeatheredLeather: 32246,
  DunnEdwards_DE6106_PaleWheat: 32247,
  DunnEdwards_DE6107_BreakfastBiscuit: 32248,
  DunnEdwards_DE6108_EnglishScone: 32249,
  DunnEdwards_DE6109_KraftPaper: 32250,
  DunnEdwards_DE6110_WarmHearth: 32251,
  DunnEdwards_DE6111_Smores: 32252,
  DunnEdwards_DE6112_CedarChest: 32253,
  DunnEdwards_DE6113_AlpacaWool: 32254,
  DunnEdwards_DE6114_DryDune: 32255,
  DunnEdwards_DE6115_PracticalTan: 32256,
  DunnEdwards_DE6116_DoverPlains: 32257,
  DunnEdwards_DE6117_ColoradoTrail: 32258,
  DunnEdwards_DE6118_Sandpit: 32259,
  DunnEdwards_DE6119_NeutralValley: 32260,
  DunnEdwards_DE6120_TeaBiscuit: 32261,
  DunnEdwards_DE6121_SiameseKitten: 32262,
  DunnEdwards_DE6122_DryCreek: 32263,
  DunnEdwards_DE6123_TrailDust: 32264,
  DunnEdwards_DE6124_WholeWheat: 32265,
  DunnEdwards_DE6125_CarvedWood: 32266,
  DunnEdwards_DE6126_Stockhorse: 32267,
  DunnEdwards_DE6127_FinestSilk: 32268,
  DunnEdwards_DE6128_SandDune: 32269,
  DunnEdwards_DE6129_RusticTaupe: 32270,
  DunnEdwards_DE6130_WoodedAcre: 32271,
  DunnEdwards_DE6131_TeddyBear: 32272,
  DunnEdwards_DE6132_BigStoneBeach: 32273,
  DunnEdwards_DE6133_OldBoot: 32274,
  DunnEdwards_DE6134_Shortbread: 32275,
  DunnEdwards_DE6135_VeronaBeach: 32276,
  DunnEdwards_DE6136_TerracottaSand: 32277,
  DunnEdwards_DE6137_TanPlan: 32278,
  DunnEdwards_DE6138_DarkSepia: 32279,
  DunnEdwards_DE6139_SummervilleBrown: 32280,
  DunnEdwards_DE6140_BrownBear: 32281,
  DunnEdwards_DE6141_SaltBox: 32282,
  DunnEdwards_DE6142_FloatingFeather: 32283,
  DunnEdwards_DE6143_AlmondLatte: 32284,
  DunnEdwards_DE6144_GrahamCracker: 32285,
  DunnEdwards_DE6145_RockyRidge: 32286,
  DunnEdwards_DE6146_LonelyRoad: 32287,
  DunnEdwards_DE6147_ChesterBrown: 32288,
  DunnEdwards_DE6148_AntiqueLinen: 32289,
  DunnEdwards_DE6149_CreamWashed: 32290,
  DunnEdwards_DE6150_GourmetHoney: 32291,
  DunnEdwards_DE6151_WarmButterscotch: 32292,
  DunnEdwards_DE6152_MapleView: 32293,
  DunnEdwards_DE6153_Pyramid: 32294,
  DunnEdwards_DE6154_CubanCigar: 32295,
  DunnEdwards_DE6155_SoftIvory: 32296,
  DunnEdwards_DE6156_MarbleDust: 32297,
  DunnEdwards_DE6157_BisqueTan: 32298,
  DunnEdwards_DE6158_Buckskin: 32299,
  DunnEdwards_DE6159_BreadPudding: 32300,
  DunnEdwards_DE6160_FallHarvest: 32301,
  DunnEdwards_DE6161_BronzedBrass: 32302,
  DunnEdwards_DE6162_AntiqueLace: 32303,
  DunnEdwards_DE6163_MeltedWax: 32304,
  DunnEdwards_DE6164_CanaryIsland: 32305,
  DunnEdwards_DE6165_ToastedMarshmallow: 32306,
  DunnEdwards_DE6166_FlickeringGold: 32307,
  DunnEdwards_DE6167_AntiqueHoney: 32308,
  DunnEdwards_DE6168_GoldenHarmony: 32309,
  DunnEdwards_DE6169_MilkMustache: 32310,
  DunnEdwards_DE6170_RiceBowl: 32311,
  DunnEdwards_DE6171_SandDollar: 32312,
  DunnEdwards_DE6172_BungalowTaupe: 32313,
  DunnEdwards_DE6173_PaperSack: 32314,
  DunnEdwards_DE6174_Ridgecrest: 32315,
  DunnEdwards_DE6175_Burlap: 32316,
  DunnEdwards_DE6176_CreamyCameo: 32317,
  DunnEdwards_DE6177_ThatchedRoof: 32318,
  DunnEdwards_DE6178_BoutiqueBeige: 32319,
  DunnEdwards_DE6179_OakHarbor: 32320,
  DunnEdwards_DE6180_NewCork: 32321,
  DunnEdwards_DE6181_BannerGold: 32322,
  DunnEdwards_DE6182_BeaumontBrown: 32323,
  DunnEdwards_DE6183_HomePlate: 32324,
  DunnEdwards_DE6184_Sailcloth: 32325,
  DunnEdwards_DE6185_LightAspiration: 32326,
  DunnEdwards_DE6186_DesertFloor: 32327,
  DunnEdwards_DE6187_VerandaGold: 32328,
  DunnEdwards_DE6188_SpaciousPlain: 32329,
  DunnEdwards_DE6189_Mossy: 32330,
  DunnEdwards_DE6190_BallOfString: 32331,
  DunnEdwards_DE6191_ExclusiveIvory: 32332,
  DunnEdwards_DE6192_NomadicTaupe: 32333,
  DunnEdwards_DE6193_BambooScreen: 32334,
  DunnEdwards_DE6194_NaturalBridge: 32335,
  DunnEdwards_DE6195_PrairieGrove: 32336,
  DunnEdwards_DE6196_CoveredWagon: 32337,
  DunnEdwards_DE6197_ModernIvory: 32338,
  DunnEdwards_DE6198_CreamWave: 32339,
  DunnEdwards_DE6199_PaleBeach: 32340,
  DunnEdwards_DE6200_Handwoven: 32341,
  DunnEdwards_DE6201_RattanBasket: 32342,
  DunnEdwards_DE6202_CoconutShell: 32343,
  DunnEdwards_DE6203_EssentialBrown: 32344,
  DunnEdwards_DE6204_TriteWhite: 32345,
  DunnEdwards_DE6205_StuccoTan: 32346,
  DunnEdwards_DE6206_DesertSuede: 32347,
  DunnEdwards_DE6207_EgyptianSand: 32348,
  DunnEdwards_DE6208_TuscanMosaic: 32349,
  DunnEdwards_DE6209_RockNOak: 32350,
  DunnEdwards_DE6210_MidnightBrown: 32351,
  DunnEdwards_DE6211_LightBeige: 32352,
  DunnEdwards_DE6212_CrispMuslin: 32353,
  DunnEdwards_DE6213_FineGrain: 32354,
  DunnEdwards_DE6214_PigeonGray: 32355,
  DunnEdwards_DE6215_WoodenPeg: 32356,
  DunnEdwards_DE6216_BarrelStove: 32357,
  DunnEdwards_DE6217_AncientEarth: 32358,
  DunnEdwards_DE6218_AntiquePaper: 32359,
  DunnEdwards_DE6219_CrystalHaze: 32360,
  DunnEdwards_DE6220_PorousStone: 32361,
  DunnEdwards_DE6221_Flintstone: 32362,
  DunnEdwards_DE6222_WeatherBoard: 32363,
  DunnEdwards_DE6223_MissionTrail: 32364,
  DunnEdwards_DE6224_TreasureChest: 32365,
  DunnEdwards_DE6225_Fossil: 32366,
  DunnEdwards_DE6226_FoggyDay: 32367,
  DunnEdwards_DE6227_Muslin: 32368,
  DunnEdwards_DE6228_PlayOnGray: 32369,
  DunnEdwards_DE6229_CalicoRock: 32370,
  DunnEdwards_DE6230_CenterRidge: 32371,
  DunnEdwards_DE6231_ShakerGray: 32372,
  DunnEdwards_DE6232_AbstractWhite: 32373,
  DunnEdwards_DE6233_Limestone: 32374,
  DunnEdwards_DE6234_SereneThought: 32375,
  DunnEdwards_DE6235_NorthgateGreen: 32376,
  DunnEdwards_DE6236_Wilderness: 32377,
  DunnEdwards_DE6237_DenaliGreen: 32378,
  DunnEdwards_DE6238_SpruceWoods: 32379,
  DunnEdwards_DE6239_LatteFroth: 32380,
  DunnEdwards_DE6240_Watermist: 32381,
  DunnEdwards_DE6241_LunarLanding: 32382,
  DunnEdwards_DE6242_WellsGray: 32383,
  DunnEdwards_DE6243_UnionSprings: 32384,
  DunnEdwards_DE6244_SmokyForest: 32385,
  DunnEdwards_DE6245_AgedJade: 32386,
  DunnEdwards_DE6246_Moonlight: 32387,
  DunnEdwards_DE6247_GardenPebble: 32388,
  DunnEdwards_DE6248_Spooky: 32389,
  DunnEdwards_DE6249_TrinityIslands: 32390,
  DunnEdwards_DE6250_FairbankGreen: 32391,
  DunnEdwards_DE6251_GreenScene: 32392,
  DunnEdwards_DE6252_SecretPath: 32393,
  DunnEdwards_DE6253_CottonField: 32394,
  DunnEdwards_DE6254_LightSprinkle: 32395,
  DunnEdwards_DE6255_WishingWell: 32396,
  DunnEdwards_DE6256_TurtleTrail: 32397,
  DunnEdwards_DE6257_BattleHarbor: 32398,
  DunnEdwards_DE6258_IvyGarden: 32399,
  DunnEdwards_DE6259_SecludedGreen: 32400,
  DunnEdwards_DE6260_WishfulWhite: 32401,
  DunnEdwards_DE6261_IcePalace: 32402,
  DunnEdwards_DE6262_GlassTile: 32403,
  DunnEdwards_DE6263_PistachioShell: 32404,
  DunnEdwards_DE6264_FairSpring: 32405,
  DunnEdwards_DE6265_MossCovered: 32406,
  DunnEdwards_DE6266_BijouxGreen: 32407,
  DunnEdwards_DE6267_DovesWing: 32408,
  DunnEdwards_DE6268_PearlyStar: 32409,
  DunnEdwards_DE6269_ParticularMint: 32410,
  DunnEdwards_DE6270_AntiqueCoin: 32411,
  DunnEdwards_DE6271_ElementalGreen: 32412,
  DunnEdwards_DE6272_DriedChive: 32413,
  DunnEdwards_DE6273_GreenGate: 32414,
  DunnEdwards_DE6274_Frostbite: 32415,
  DunnEdwards_DE6275_SilverCreek: 32416,
  DunnEdwards_DE6276_Silhouette: 32417,
  DunnEdwards_DE6277_PebbleWalk: 32418,
  DunnEdwards_DE6278_StoneCreek: 32419,
  DunnEdwards_DE6279_ArmoredSteel: 32420,
  DunnEdwards_DE6280_EnglishForest: 32421,
  DunnEdwards_DE6281_ShadowWhite: 32422,
  DunnEdwards_DE6282_DistantHaze: 32423,
  DunnEdwards_DE6283_Granite: 32424,
  DunnEdwards_DE6284_GracefulGreen: 32425,
  DunnEdwards_DE6285_LindenSpear: 32426,
  DunnEdwards_DE6286_Greenland: 32427,
  DunnEdwards_DE6287_ItalianBasil: 32428,
  DunnEdwards_DE6288_WindySky: 32429,
  DunnEdwards_DE6289_SilverFox: 32430,
  DunnEdwards_DE6290_Ashwood: 32431,
  DunnEdwards_DE6291_CastingShadow: 32432,
  DunnEdwards_DE6292_StoneCraft: 32433,
  DunnEdwards_DE6293_VelvetClover: 32434,
  DunnEdwards_DE6294_MidnightSpruce: 32435,
  DunnEdwards_DE6295_LightningBolt: 32436,
  DunnEdwards_DE6296_SculpturalSilver: 32437,
  DunnEdwards_DE6297_PatinaCreek: 32438,
  DunnEdwards_DE6298_AgateGreen: 32439,
  DunnEdwards_DE6299_Limerick: 32440,
  DunnEdwards_DE6300_Windrock: 32441,
  DunnEdwards_DE6301_HiddenForest: 32442,
  DunnEdwards_DE6302_MistSpirit: 32443,
  DunnEdwards_DE6303_SkyGlass: 32444,
  DunnEdwards_DE6304_BlusteryWind: 32445,
  DunnEdwards_DE6305_GalwayBay: 32446,
  DunnEdwards_DE6306_Armor: 32447,
  DunnEdwards_DE6307_ArtisticStone: 32448,
  DunnEdwards_DE6308_BlackSpruce: 32449,
  DunnEdwards_DE6309_GrayWonder: 32450,
  DunnEdwards_DE6310_RainySeason: 32451,
  DunnEdwards_DE6311_HazeBlue: 32452,
  DunnEdwards_DE6312_DustyDream: 32453,
  DunnEdwards_DE6313_EnchantedEve: 32454,
  DunnEdwards_DE6314_DarkPewter: 32455,
  DunnEdwards_DE6315_BlackPool: 32456,
  DunnEdwards_DE6316_ColdWater: 32457,
  DunnEdwards_DE6317_MountSterling: 32458,
  DunnEdwards_DE6318_LakePlacid: 32459,
  DunnEdwards_DE6319_GrayFlannel: 32460,
  DunnEdwards_DE6320_PikeLake: 32461,
  DunnEdwards_DE6321_Soot: 32462,
  DunnEdwards_DE6322_BlackLead: 32463,
  DunnEdwards_DE6323_WhiteLake: 32464,
  DunnEdwards_DE6324_VeiledSpotlight: 32465,
  DunnEdwards_DE6325_Crestline: 32466,
  DunnEdwards_DE6326_SoftPumice: 32467,
  DunnEdwards_DE6327_Rhinoceros: 32468,
  DunnEdwards_DE6328_AnchorGray: 32469,
  DunnEdwards_DE6329_CoverOfNight: 32470,
  DunnEdwards_DE6330_Waterloo: 32471,
  DunnEdwards_DE6331_BayOfHope: 32472,
  DunnEdwards_DE6332_GlenFalls: 32473,
  DunnEdwards_DE6333_HamiltonBlue: 32474,
  DunnEdwards_DE6334_LongLake: 32475,
  DunnEdwards_DE6335_NoveltyNavy: 32476,
  DunnEdwards_DE6336_Stargazing: 32477,
  DunnEdwards_DE6337_SilverCity: 32478,
  DunnEdwards_DE6338_ShinyNickel: 32479,
  DunnEdwards_DE6339_Adirondack: 32480,
  DunnEdwards_DE6340_CanadianLake: 32481,
  DunnEdwards_DE6341_Vulcan: 32482,
  DunnEdwards_DE6342_BlueSteel: 32483,
  DunnEdwards_DE6343_SalemBlack: 32484,
  DunnEdwards_DE6344_WispOfSmoke: 32485,
  DunnEdwards_DE6345_SparklingFrost: 32486,
  DunnEdwards_DE6346_SilverSprings: 32487,
  DunnEdwards_DE6347_ShiningKnight: 32488,
  DunnEdwards_DE6348_DrawYourSword: 32489,
  DunnEdwards_DE6349_EdgeOfBlack: 32490,
  DunnEdwards_DE6350_DarkEngine: 32491,
  DunnEdwards_DE6351_ColdWind: 32492,
  DunnEdwards_DE6352_DecemberSky: 32493,
  DunnEdwards_DE6353_SilverLined: 32494,
  DunnEdwards_DE6354_GrayWolf: 32495,
  DunnEdwards_DE6355_TarnishedSilver: 32496,
  DunnEdwards_DE6356_SheetMetal: 32497,
  DunnEdwards_DE6357_BlackTie: 32498,
  DunnEdwards_DE6358_Vapor: 32499,
  DunnEdwards_DE6359_SilverSetting: 32500,
  DunnEdwards_DE6360_Foil: 32501,
  DunnEdwards_DE6361_BabySeal: 32502,
  DunnEdwards_DE6362_StormCloud: 32503,
  DunnEdwards_DE6363_PointedRock: 32504,
  DunnEdwards_DE6364_Cavernous: 32505,
  DunnEdwards_DE6365_ColdMorning: 32506,
  DunnEdwards_DE6366_SilverSpoon: 32507,
  DunnEdwards_DE6367_CoveredInPlatinum: 32508,
  DunnEdwards_DE6368_Walrus: 32509,
  DunnEdwards_DE6369_LegendaryGray: 32510,
  DunnEdwards_DE6370_CharcoalSmudge: 32511,
  DunnEdwards_DE6371_BlackJack: 32512,
  DunnEdwards_DE6372_LaceVeil: 32513,
  DunnEdwards_DE6373_Porpoise: 32514,
  DunnEdwards_DE6374_SilverPolish: 32515,
  DunnEdwards_DE6375_Castlerock: 32516,
  DunnEdwards_DE6376_LookingGlass: 32517,
  DunnEdwards_DE6377_BoatAnchor: 32518,
  DunnEdwards_DE6378_Jet: 32519,
  DunnEdwards_DE6379_SilverLake: 32520,
  DunnEdwards_DE6380_CloudedVision: 32521,
  DunnEdwards_DE6381_SilverBullet: 32522,
  DunnEdwards_DE6382_FormalGray: 32523,
  DunnEdwards_DE6383_BankVault: 32524,
  DunnEdwards_DE6384_IronFixture: 32525,
  DunnEdwards_DE6385_BlackBean: 32526,
  DunnEdwards_DE6386_SnowPeak: 32527,
  DunnEdwards_DE6387_DangerousRobot: 32528,
  DunnEdwards_DE6388_SmokyMountain: 32529,
  DunnEdwards_DE6389_FallenRock: 32530,
  DunnEdwards_DE6390_ChocolatePudding: 32531,
  DunnEdwards_DE6391_BlackRussian: 32532,
  DunnEdwards_DE6392_Mink: 32533,
  DunnEdwards_DE6393_MountainAir: 32534,
  DunnEdwards_DE6394_EaglesView: 32535,
  DunnEdwards_DE6395_AntiqueMauve: 32536,
  DunnEdwards_DE6396_AshenPlum: 32537,
  DunnEdwards_DE6397_HickoryCliff: 32538,
  DunnEdwards_DE6398_LouisianaMud: 32539,
  DunnEdwards_DE6399_Molasses: 32540,
  DunnEdwards_DEA002_Black: 32541,
  DunnEdwards_DEA100_PutnamPlum: 32542,
  DunnEdwards_DEA101_FieryFuchsia: 32543,
  DunnEdwards_DEA102_CrimsonStrawberry: 32544,
  DunnEdwards_DEA103_StrikingRed: 32545,
  DunnEdwards_DEA104_RedIcon: 32546,
  DunnEdwards_DEA105_CherryBomb: 32547,
  DunnEdwards_DEA106_RedContrast: 32548,
  DunnEdwards_DEA107_HotJazz: 32549,
  DunnEdwards_DEA108_RedPower: 32550,
  DunnEdwards_DEA109_BonfireFlame: 32551,
  DunnEdwards_DEA110_UntamedOrange: 32552,
  DunnEdwards_DEA111_BurningTomato: 32553,
  DunnEdwards_DEA112_ExuberantOrange: 32554,
  DunnEdwards_DEA113_OrangeBurst: 32555,
  DunnEdwards_DEA114_InstantOrange: 32556,
  DunnEdwards_DEA115_OrangeJewel: 32557,
  DunnEdwards_DEA116_FlashOfOrange: 32558,
  DunnEdwards_DEA117_ConfidentYellow: 32559,
  DunnEdwards_DEA118_YellowSummer: 32560,
  DunnEdwards_DEA119_ElectricGlow: 32561,
  DunnEdwards_DEA120_Goldenrod: 32562,
  DunnEdwards_DEA121_GoldenLock: 32563,
  DunnEdwards_DEA122_Brassy: 32564,
  DunnEdwards_DEA123_Chartreuse: 32565,
  DunnEdwards_DEA124_LimeTwist: 32566,
  DunnEdwards_DEA125_InTheTropics: 32567,
  DunnEdwards_DEA126_Leprechaun: 32568,
  DunnEdwards_DEA127_WildForest: 32569,
  DunnEdwards_DEA128_SpringJuniper: 32570,
  DunnEdwards_DEA129_CharmedGreen: 32571,
  DunnEdwards_DEA130_LuckyClover: 32572,
  DunnEdwards_DEA131_TealWaters: 32573,
  DunnEdwards_DEA132_OceanOasis: 32574,
  DunnEdwards_DEA133_RareTurquoise: 32575,
  DunnEdwards_DEA134_Aquatic: 32576,
  DunnEdwards_DEA135_DeepOcean: 32577,
  DunnEdwards_DEA136_BeautifulBlue: 32578,
  DunnEdwards_DEA137_DeepSapphire: 32579,
  DunnEdwards_DEA138_IndigoNight: 32580,
  DunnEdwards_DEA139_Nautical: 32581,
  DunnEdwards_DEA140_Cobalt: 32582,
  DunnEdwards_DEA141_GrandPurple: 32583,
  DunnEdwards_DEA142_VioletMajesty: 32584,
  DunnEdwards_DEA143_PurpleOdyssey: 32585,
  DunnEdwards_DEA144_PassionatePlum: 32586,
  DunnEdwards_DEA145_WineStain: 32587,
  DunnEdwards_DEA146_ScarletApple: 32588,
  DunnEdwards_DEA147_GarnetEvening: 32589,
  DunnEdwards_DEA148_SunkenShip: 32590,
  DunnEdwards_DEA149_SpicedBerry: 32591,
  DunnEdwards_DEA150_ScarletPast: 32592,
  DunnEdwards_DEA151_RedInk: 32593,
  DunnEdwards_DEA152_DeepCrimson: 32594,
  DunnEdwards_DEA153_GlitzyRed: 32595,
  DunnEdwards_DEA154_RedRevival: 32596,
  DunnEdwards_DEA155_ArabianRed: 32597,
  DunnEdwards_DEA156_CherryCola: 32598,
  DunnEdwards_DEA157_CellarDoor: 32599,
  DunnEdwards_DEA158_NorthernTerritory: 32600,
  DunnEdwards_DEA159_RichMocha: 32601,
  DunnEdwards_DEA160_HopeChest: 32602,
  DunnEdwards_DEA161_WildMustang: 32603,
  DunnEdwards_DEA162_LogCabin: 32604,
  DunnEdwards_DEA163_Rodeo: 32605,
  DunnEdwards_DEA164_AutumnBark: 32606,
  DunnEdwards_DEA165_HearthGold: 32607,
  DunnEdwards_DEA166_TavernCreek: 32608,
  DunnEdwards_DEA167_AntiquePenny: 32609,
  DunnEdwards_DEA168_PiratesGold: 32610,
  DunnEdwards_DEA169_PepperedMoss: 32611,
  DunnEdwards_DEA170_SeaTurtle: 32612,
  DunnEdwards_DEA171_BayLeaf: 32613,
  DunnEdwards_DEA172_Camouflage: 32614,
  DunnEdwards_DEA173_Frond: 32615,
  DunnEdwards_DEA174_OliveCourt: 32616,
  DunnEdwards_DEA175_BlackForest: 32617,
  DunnEdwards_DEA176_IronRiver: 32618,
  DunnEdwards_DEA177_HollyBush: 32619,
  DunnEdwards_DEA178_BilliardTable: 32620,
  DunnEdwards_DEA179_EnchantingIvy: 32621,
  DunnEdwards_DEA180_DeepPine: 32622,
  DunnEdwards_DEA181_RefinedGreen: 32623,
  DunnEdwards_DEA182_EncoreTeal: 32624,
  DunnEdwards_DEA183_DarkShadows: 32625,
  DunnEdwards_DEA184_ParisianNight: 32626,
  DunnEdwards_DEA185_OldMill: 32627,
  DunnEdwards_DEA186_BlackPearl: 32628,
  DunnEdwards_DEA188_BlackBay: 32629,
  DunnEdwards_DEA189_BlackRiverFalls: 32630,
  DunnEdwards_DEA190_BlueSuedeShoes: 32631,
  DunnEdwards_DEA191_MagicNight: 32632,
  DunnEdwards_DEA192_VioletShadow: 32633,
  DunnEdwards_DEA193_Preserve: 32634,
  DunnEdwards_DEA194_Mulberry: 32635,
  DunnEdwards_DEA195_PrimitivePlum: 32636,
  DunnEdwards_DEB001_GunmetalBronze: 32637,
  DunnEdwards_DEB002_AntiqueBronze: 32638,
  DunnEdwards_DEB003_SmokedBronze: 32639,
  DunnEdwards_DEB004_LiquidBronze: 32640,
  DunnEdwards_DEB005_SamsonBronze: 32641,
  DunnEdwards_DEB006_JavaBronze: 32642,
  DunnEdwards_DEB007_ChocolateBronze: 32643,
  DunnEdwards_DEB008_FiredBronze: 32644,
  DunnEdwards_DEBN01_LetsGetCozy: 32645,
  DunnEdwards_DEBN02_WarmEmbrace: 32646,
  DunnEdwards_DEBN03_AncientGrain: 32647,
  DunnEdwards_DEBN04_HomespunCharm: 32648,
  DunnEdwards_DEBN05_ButteredCroissant: 32649,
  DunnEdwards_DEBN06_BookBinding: 32650,
  DunnEdwards_DEBN07_FrenchPressCoffee: 32651,
  DunnEdwards_DEBN08_CloudsInMyCoffee: 32652,
  DunnEdwards_DEBN09_DoeEyed: 32653,
  DunnEdwards_DEBN10_OrganicCoffee: 32654,
  DunnEdwards_DEBN11_ColdBrew: 32655,
  DunnEdwards_DEBN12_Brownstone: 32656,
  DunnEdwards_DEBN13_BistrePigment: 32657,
  DunnEdwards_DEBN14_CafeNoir: 32658,
  DunnEdwards_DEBN15_RosyTaupe: 32659,
  DunnEdwards_DEBN16_TripleChocolateMousse: 32660,
  DunnEdwards_DEBN17_LeatherBound: 32661,
  DunnEdwards_DEBN18_PorciniMushroom: 32662,
  DunnEdwards_DEBN19_ChicoryCoffee: 32663,
  DunnEdwards_DEBN20_DeepTaupe: 32664,
  DunnEdwards_DEBN21_WildBuffalo: 32665,
  DunnEdwards_DEBN22_CasselEarth: 32666,
  DunnEdwards_DEBN23_SauteedCremini: 32667,
  DunnEdwards_DEBN24_WildMaitake: 32668,
  DunnEdwards_DEBN25_StoneGround: 32669,
  DunnEdwards_DEBN26_DesertNomad: 32670,
  DunnEdwards_DEBN27_DustyCobblestone: 32671,
  DunnEdwards_DEBN28_StoneCottage: 32672,
  DunnEdwards_DEBN29_GoQuietly: 32673,
  DunnEdwards_DEBN30_ElusiveMorel: 32674,
  DunnEdwards_DEBN31_RoadLessTraveled: 32675,
  DunnEdwards_DEBN32_RuggedIndividual: 32676,
  DunnEdwards_DEBN33_MediumRoast: 32677,
  DunnEdwards_DEBN34_ThreeBears: 32678,
  DunnEdwards_DEBN35_VintageFinds: 32679,
  DunnEdwards_DEBN36_CanoeClub: 32680,
  DunnEdwards_DEBN37_KickinItOldSchool: 32681,
  DunnEdwards_DEBN38_RuggedlyHandsome: 32682,
  DunnEdwards_DEBN39_AlpineChamoisee: 32683,
  DunnEdwards_DEBN40_AfternoonTeaService: 32684,
  DunnEdwards_DEBN41_Distillery: 32685,
  DunnEdwards_DEBN42_RawCacaoBean: 32686,
  DunnEdwards_DEBN43_Haberdashery: 32687,
  DunnEdwards_DEBN44_DoubleFudge: 32688,
  DunnEdwards_DEBN45_CoffeePurveyors: 32689,
  DunnEdwards_DEBN46_AppleCinnamon: 32690,
  DunnEdwards_DEBN47_TastyTiramisu: 32691,
  DunnEdwards_DEBN48_IcedCoffee: 32692,
  DunnEdwards_DEBN49_QuinoaBowl: 32693,
  DunnEdwards_DEBN50_Campsite: 32694,
  DunnEdwards_DEBN51_SugarShack: 32695,
  DunnEdwards_DEBN52_EntryCoatRack: 32696,
  DunnEdwards_DEBN53_ToTheManorBrown: 32697,
  DunnEdwards_DEBN54_OpenSesame: 32698,
  DunnEdwards_DEBN55_SkeinOfYarn: 32699,
  DunnEdwards_DEBN56_StonePedestal: 32700,
  DunnEdwards_DEBN57_Pigeonhole: 32701,
  DunnEdwards_DEBN58_BasketWeaving: 32702,
  DunnEdwards_DEBN59_CattailMarsh: 32703,
  DunnEdwards_DEBN60_Outdoorsy: 32704,
  DunnEdwards_DEBN61_RoamWild: 32705,
  DunnEdwards_DEBN62_MoonstoneBeach: 32706,
  DunnEdwards_DEBN63_MacrameKnot: 32707,
  DunnEdwards_DEBN64_StuccoRelief: 32708,
  DunnEdwards_DEBN65_RockyMountainClay: 32709,
  DunnEdwards_DEBN66_CountryRubbleStone: 32710,
  DunnEdwards_DEBN67_ThrowingClay: 32711,
  DunnEdwards_DEBN68_TwistedSisalRope: 32712,
  DunnEdwards_DEBN69_TimberWolf: 32713,
  DunnEdwards_DEBN70_SquirrelsTail: 32714,
  DunnEdwards_DEBN71_SteppingStone: 32715,
  DunnEdwards_DEBN72_AromaticCloves: 32716,
  DunnEdwards_DEBN73_IncenseStick: 32717,
  DunnEdwards_DEBN74_ZestyCoriander: 32718,
  DunnEdwards_DEBN75_CoffeeGrinds: 32719,
  DunnEdwards_DEBN76_SmokedOakBrown: 32720,
  DunnEdwards_DEBN77_PruneTheTree: 32721,
  DunnEdwards_DEBN78_Chiaroscuro: 32722,
  DunnEdwards_DEBN79_TobaccoIncense: 32723,
  DunnEdwards_DEBN80_ChocolateFix: 32724,
  DunnEdwards_DEC700_TeatimeMauve: 32725,
  DunnEdwards_DEC701_RevivalRose: 32726,
  DunnEdwards_DEC702_AntiqueRose: 32727,
  DunnEdwards_DEC703_RetroPeach: 32728,
  DunnEdwards_DEC704_MoenkopiTan: 32729,
  DunnEdwards_DEC705_BurntCrimson: 32730,
  DunnEdwards_DEC706_Rosewood: 32731,
  DunnEdwards_DEC707_Foxtail: 32732,
  DunnEdwards_DEC708_SunsetCove: 32733,
  DunnEdwards_DEC709_AdobeSouth: 32734,
  DunnEdwards_DEC710_Peach: 32735,
  DunnEdwards_DEC711_CliffBrown: 32736,
  DunnEdwards_DEC712_Briar: 32737,
  DunnEdwards_DEC713_RomanBrick: 32738,
  DunnEdwards_DEC714_FriarTuck: 32739,
  DunnEdwards_DEC715_Sandal: 32740,
  DunnEdwards_DEC716_StonishBeige: 32741,
  DunnEdwards_DEC717_BakedPotato: 32742,
  DunnEdwards_DEC718_MesaTan: 32743,
  DunnEdwards_DEC719_CoralClay: 32744,
  DunnEdwards_DEC720_CliffsView: 32745,
  DunnEdwards_DEC721_Slopes: 32746,
  DunnEdwards_DEC722_BajaWhite: 32747,
  DunnEdwards_DEC723_Champagne: 32748,
  DunnEdwards_DEC724_SpanishWhite: 32749,
  DunnEdwards_DEC725_WeatheredCoral: 32750,
  DunnEdwards_DEC726_Adobe: 32751,
  DunnEdwards_DEC727_ValleyFlower: 32752,
  DunnEdwards_DEC728_Madera: 32753,
  DunnEdwards_DEC729_Medallion: 32754,
  DunnEdwards_DEC730_AlluringUmber: 32755,
  DunnEdwards_DEC731_HighlightGold: 32756,
  DunnEdwards_DEC732_AspenYellow: 32757,
  DunnEdwards_DEC733_SolarWind: 32758,
  DunnEdwards_DEC734_Jasmine: 32759,
  DunnEdwards_DEC735_Flaxen: 32760,
  DunnEdwards_DEC736_Flaxseed: 32761,
  DunnEdwards_DEC737_Jakarta: 32762,
  DunnEdwards_DEC738_Travertine: 32763,
  DunnEdwards_DEC739_GoldenGate: 32764,
  DunnEdwards_DEC740_Sandcastle: 32765,
  DunnEdwards_DEC741_BoneWhite: 32766,
  DunnEdwards_DEC742_Cameo: 32767,
  DunnEdwards_DEC743_HighNoon: 32768,
  DunnEdwards_DEC744_CelticLinen: 32769,
  DunnEdwards_DEC745_Chaparral: 32770,
  DunnEdwards_DEC746_ApacheTan: 32771,
  DunnEdwards_DEC747_Sahara: 32772,
  DunnEdwards_DEC748_Oyster: 32773,
  DunnEdwards_DEC749_LinenWhite: 32774,
  DunnEdwards_DEC750_BisonBeige: 32775,
  DunnEdwards_DEC751_AshGray: 32776,
  DunnEdwards_DEC752_Birchwood: 32777,
  DunnEdwards_DEC753_Almond: 32778,
  DunnEdwards_DEC754_Quicksand: 32779,
  DunnEdwards_DEC755_Cocoa: 32780,
  DunnEdwards_DEC756_WeatheredBrown: 32781,
  DunnEdwards_DEC757_RinconCove: 32782,
  DunnEdwards_DEC758_Cashmere: 32783,
  DunnEdwards_DEC759_Hickory: 32784,
  DunnEdwards_DEC760_DesertGray: 32785,
  DunnEdwards_DEC761_Cochise: 32786,
  DunnEdwards_DEC762_Milkweed: 32787,
  DunnEdwards_DEC763_OatmealCookie: 32788,
  DunnEdwards_DEC764_InsidePassage: 32789,
  DunnEdwards_DEC765_Bone: 32790,
  DunnEdwards_DEC766_StevearenoBeige: 32791,
  DunnEdwards_DEC767_Riverbed: 32792,
  DunnEdwards_DEC768_WinterLite: 32793,
  DunnEdwards_DEC769_RanierWhite: 32794,
  DunnEdwards_DEC770_Drifting: 32795,
  DunnEdwards_DEC771_ShaggyBarked: 32796,
  DunnEdwards_DEC772_NavajoWhite: 32797,
  DunnEdwards_DEC773_Heather: 32798,
  DunnEdwards_DEC774_Shady: 32799,
  DunnEdwards_DEC775_SeaGlass: 32800,
  DunnEdwards_DEC776_CourtyardGreen: 32801,
  DunnEdwards_DEC777_Meadowood: 32802,
  DunnEdwards_DEC778_Boxwood: 32803,
  DunnEdwards_DEC779_WoodlawnGreen: 32804,
  DunnEdwards_DEC780_TickledCrow: 32805,
  DunnEdwards_DEC781_SycamoreStand: 32806,
  DunnEdwards_DEC782_BelizeGreen: 32807,
  DunnEdwards_DEC783_Opaline: 32808,
  DunnEdwards_DEC784_GreenMirror: 32809,
  DunnEdwards_DEC785_WhisperGray: 32810,
  DunnEdwards_DEC786_MinersDust: 32811,
  DunnEdwards_DEC787_MythicalBlue: 32812,
  DunnEdwards_DEC788_DarkLagoon: 32813,
  DunnEdwards_DEC789_LightGray: 32814,
  DunnEdwards_DEC790_IceGray: 32815,
  DunnEdwards_DEC791_Cloud: 32816,
  DunnEdwards_DEC792_CapeCodBlue: 32817,
  DunnEdwards_DEC793_Chalky: 32818,
  DunnEdwards_DEC794_SalinaSprings: 32819,
  DunnEdwards_DEC795_GrayPearl: 32820,
  DunnEdwards_DEC796_IrogonBlue: 32821,
  DunnEdwards_DEC797_BattleshipGray: 32822,
  DunnEdwards_DEC798_TaliesinBlue: 32823,
  DunnEdwards_DEC799_WharfView: 32824,
  DunnEdwards_DEFD01_StarOfPersia: 32825,
  DunnEdwards_DEFD02_Sentimental: 32826,
  DunnEdwards_DEFD03_EnglishViolet: 32827,
  DunnEdwards_DEFD04_PeppyPurple: 32828,
  DunnEdwards_DEFD05_ParisianPlum: 32829,
  DunnEdwards_DEFD06_InAMaroonMood: 32830,
  DunnEdwards_DEFD07_WineTasting: 32831,
  DunnEdwards_DEFD08_CherryHarvest: 32832,
  DunnEdwards_DEFD09_JaipurDream: 32833,
  DunnEdwards_DEFD10_NeonPink: 32834,
  DunnEdwards_DEFD11_SpanishCarmine: 32835,
  DunnEdwards_DEFD12_ResplendentRose: 32836,
  DunnEdwards_DEFD13_CandyCrush: 32837,
  DunnEdwards_DEFD14_RedYForFun: 32838,
  DunnEdwards_DEFD15_SpikedPunch: 32839,
  DunnEdwards_DEFD16_BerryInspired: 32840,
  DunnEdwards_DEFD17_RoseApothecary: 32841,
  DunnEdwards_DEFD18_CrushingOnCoral: 32842,
  DunnEdwards_DEFD19_CoralCharisma: 32843,
  DunnEdwards_DEFD20_Amaranth: 32844,
  DunnEdwards_DEFD21_ChilesDeArbol: 32845,
  DunnEdwards_DEFD22_Vermilion: 32846,
  DunnEdwards_DEFD23_PumpkinSpiceLatte: 32847,
  DunnEdwards_DEFD24_SmoothLikeButter: 32848,
  DunnEdwards_DEFD25_ZestyYellow: 32849,
  DunnEdwards_DEFD26_LemonCurry: 32850,
  DunnEdwards_DEFD27_LemonMacaron: 32851,
  DunnEdwards_DEFD28_BourbonSweetTea: 32852,
  DunnEdwards_DEFD29_DesertLime: 32853,
  DunnEdwards_DEFD30_GrassyKnoll: 32854,
  DunnEdwards_DEFD31_AmazonParrot: 32855,
  DunnEdwards_DEFD32_SlightlyJaded: 32856,
  DunnEdwards_DEFD33_PunchyPeridot: 32857,
  DunnEdwards_DEFD34_SummerSeagrass: 32858,
  DunnEdwards_DEFD35_GinkgoLeaf: 32859,
  DunnEdwards_DEFD36_VerdigrisGreen: 32860,
  DunnEdwards_DEFD37_MalachiteGreen: 32861,
  DunnEdwards_DEFD38_DanceTealDawn: 32862,
  DunnEdwards_DEFD39_DayInTheShade: 32863,
  DunnEdwards_DEFD40_VerdeNice: 32864,
  DunnEdwards_DEFD41_HiTechTurquoise: 32865,
  DunnEdwards_DEFD42_ComeToCostaRica: 32866,
  DunnEdwards_DEFD43_SirenSong: 32867,
  DunnEdwards_DEFD44_BalineseRetreat: 32868,
  DunnEdwards_DEFD45_AgeOfAquarius: 32869,
  DunnEdwards_DEFD46_IslandHop: 32870,
  DunnEdwards_DEFD47_BlueInBarbados: 32871,
  DunnEdwards_DEFD48_LaAtNight: 32872,
  DunnEdwards_DEFD49_KineticEnergy: 32873,
  DunnEdwards_DEFD50_EmboldenedBlue: 32874,
  DunnEdwards_DEFD51_AmIBlue: 32875,
  DunnEdwards_DEFD52_FollowMyBlueBliss: 32876,
  DunnEdwards_DEFD53_SummerAtTheShore: 32877,
  DunnEdwards_DEFD54_HimalayanBluePoppy: 32878,
  DunnEdwards_DEFD55_MoreWaterPlease: 32879,
  DunnEdwards_DEFD56_ShorelineDrive: 32880,
  DunnEdwards_DEFD57_BerryBerryBlue: 32881,
  DunnEdwards_DEFD58_Jodhpur: 32882,
  DunnEdwards_DEFD59_IndigoWash: 32883,
  DunnEdwards_DEFD60_StillWatersRunDeep: 32884,
  DunnEdwards_DEFD61_WindingRoad: 32885,
  DunnEdwards_DEFD62_TotalEclipse: 32886,
  DunnEdwards_DEGR01_WinterTwig: 32887,
  DunnEdwards_DEGR02_LongWindingRoad: 32888,
  DunnEdwards_DEGR03_Moonbeam: 32889,
  DunnEdwards_DEGR04_DustYourselfOff: 32890,
  DunnEdwards_DEGR05_MushroomForaging: 32891,
  DunnEdwards_DEGR06_SubtletyIsBest: 32892,
  DunnEdwards_DEGR07_BeachwoodDrive: 32893,
  DunnEdwards_DEGR08_StayCalm: 32894,
  DunnEdwards_DEGR09_FreeSpirited: 32895,
  DunnEdwards_DEGR10_WindInTheWillows: 32896,
  DunnEdwards_DEGR11_ZennedOut: 32897,
  DunnEdwards_DEGR12_FieldstoneLodge: 32898,
  DunnEdwards_DEGR13_GraphiteSketches: 32899,
  DunnEdwards_DEGR14_HazyGray: 32900,
  DunnEdwards_DEGR15_FauxBois: 32901,
  DunnEdwards_DEGR16_StonewareClay: 32902,
  DunnEdwards_DEGR17_HeartOfStone: 32903,
  DunnEdwards_DEGR18_DovesCry: 32904,
  DunnEdwards_DEGR19_ComfortZone: 32905,
  DunnEdwards_DEGR20_YesItsGreige: 32906,
  DunnEdwards_DEGR21_OrganicGreige: 32907,
  DunnEdwards_DEGR22_BoneDry: 32908,
  DunnEdwards_DEGR23_NaturalProcess: 32909,
  DunnEdwards_DEGR24_NaturallySourced: 32910,
  DunnEdwards_DEGR25_ShaleStone: 32911,
  DunnEdwards_DEGR26_WellBalanced: 32912,
  DunnEdwards_DEGR27_Countryside: 32913,
  DunnEdwards_DEGR28_HaresTailGrass: 32914,
  DunnEdwards_DEGR29_Petrichor: 32915,
  DunnEdwards_DEGR30_ShaggyDog: 32916,
  DunnEdwards_DEGR31_Feldspar: 32917,
  DunnEdwards_DEGR32_PumiceStone: 32918,
  DunnEdwards_DEGR33_SycamoreBark: 32919,
  DunnEdwards_DEGR34_Rooted: 32920,
  DunnEdwards_DEGR35_WellCrafted: 32921,
  DunnEdwards_DEGR36_RiverBirch: 32922,
  DunnEdwards_DEGR37_CreekBed: 32923,
  DunnEdwards_DEGR38_FishingNet: 32924,
  DunnEdwards_DEGR39_HighlandCountry: 32925,
  DunnEdwards_DEGR40_SageHeather: 32926,
  DunnEdwards_DEGR41_MistyLake: 32927,
  DunnEdwards_DEGR42_FoggySeascape: 32928,
  DunnEdwards_DEGR43_RestEasy: 32929,
  DunnEdwards_DEGR44_CloudCover: 32930,
  DunnEdwards_DEGR45_ThrowingShade: 32931,
  DunnEdwards_DEGR46_DistantDusk: 32932,
  DunnEdwards_DEGR47_GardenWarbler: 32933,
  DunnEdwards_DEGR48_ShouSugiBan: 32934,
  DunnEdwards_DEGR49_DolphinPod: 32935,
  DunnEdwards_DEGR50_GreatGrayOwl: 32936,
  DunnEdwards_DEGR51_ChateauGray: 32937,
  DunnEdwards_DEGR52_BlowinInTheWind: 32938,
  DunnEdwards_DEGR53_GraySoapstone: 32939,
  DunnEdwards_DEGR54_Marengo: 32940,
  DunnEdwards_DEGR55_FleurDeSel: 32941,
  DunnEdwards_DEGR56_NeutralTerritory: 32942,
  DunnEdwards_DEGR57_NeutralWave: 32943,
  DunnEdwards_DEGR58_MiddleGray: 32944,
  DunnEdwards_DEGR59_StoneGray: 32945,
  DunnEdwards_DEGR60_DarkGray: 32946,
  DunnEdwards_DEGR61_CloudComputing: 32947,
  DunnEdwards_DEGR62_HeatherGray: 32948,
  DunnEdwards_DEGR63_CarbonFiber: 32949,
  DunnEdwards_DEGR64_MutedGray: 32950,
  DunnEdwards_DEGR65_ColdEmbrace: 32951,
  DunnEdwards_DEGR66_SilverChalice: 32952,
  DunnEdwards_DEGR67_Gris: 32953,
  DunnEdwards_DEGR68_ConcreteJungle: 32954,
  DunnEdwards_DEGR69_Artemisia: 32955,
  DunnEdwards_DEGR70_DigitalNomad: 32956,
  DunnEdwards_DEGR71_Metaverse: 32957,
  DunnEdwards_DEGR72_KickTheCan: 32958,
  DunnEdwards_DEGR73_SlateGray: 32959,
  DunnEdwards_DEGR74_WeatheredGray: 32960,
  DunnEdwards_DEGR75_MistySeascape: 32961,
  DunnEdwards_DEGR76_GustavianGray: 32962,
  DunnEdwards_DEGR77_Marinescape: 32963,
  DunnEdwards_DEGR78_HeliotropeGray: 32964,
  DunnEdwards_DEGR79_Winterfell: 32965,
  DunnEdwards_DEGR80_Charred: 32966,
  DunnEdwards_DEHW01_AlmondMilk: 32967,
  DunnEdwards_DEHW02_WhiteDaisy: 32968,
  DunnEdwards_DEHW03_CoconutGrove: 32969,
  DunnEdwards_DEHW04_SwissMeringue: 32970,
  DunnEdwards_DEHW05_AtFirstLight: 32971,
  DunnEdwards_DEHW06_NorthToAlaska: 32972,
  DunnEdwards_DEHW07_SugarSwizzle: 32973,
  DunnEdwards_DEHW08_ClassicWhite: 32974,
  DunnEdwards_DEHW09_BeCool: 32975,
  DunnEdwards_DEHW10_IcyWhite: 32976,
  DunnEdwards_DEPF01_BedrockGray: 32977,
  DunnEdwards_DEPF02_Shadow: 32978,
  DunnEdwards_DEPF03_WindsweptWillow: 32979,
  DunnEdwards_DEPF04_TideAtDusk: 32980,
  DunnEdwards_DEPF05_CanyonSunset: 32981,
  DunnEdwards_DEPF06_FallenBark: 32982,
  DunnEdwards_DEPF07_VintageLeather: 32983,
  DunnEdwards_DEPF08_SundriedTomato: 32984,
  DunnEdwards_DESS01_PlumPuddingMahogany: 32985,
  DunnEdwards_DESS02_GiantSequoiaGrove: 32986,
  DunnEdwards_DESS03_RedwoodForestCathedral: 32987,
  DunnEdwards_DESS04_ICutTheCherryTree: 32988,
  DunnEdwards_DESS05_FiresideChat: 32989,
  DunnEdwards_DESS06_SedonaSandstone: 32990,
  DunnEdwards_DESS07_Redwood: 32991,
  DunnEdwards_DESS08_SecretTreeHouse: 32992,
  DunnEdwards_DESS09_ChocolateBrown: 32993,
  DunnEdwards_DESS10_OakBrown: 32994,
  DunnEdwards_DESS11_ChestnutBrown: 32995,
  DunnEdwards_DESS12_JacobeanRenaissance: 32996,
  DunnEdwards_DESS13_GoldenOak: 32997,
  DunnEdwards_DESS14_RedCedar: 32998,
  DunnEdwards_DESS15_Handcrafted: 32999,
  DunnEdwards_DESS16_IntoTheWild: 33000,
  DunnEdwards_DESS17_SmokedOak: 33001,
  DunnEdwards_DESS18_NewCedar: 33002,
  DunnEdwards_DESS19_CabinInCandlelight: 33003,
  DunnEdwards_DESS20_SweetHoneyMaple: 33004,
  DunnEdwards_DESS21_OliveWoodBranch: 33005,
  DunnEdwards_DESS22_RawBalsaWood: 33006,
  DunnEdwards_DESS23_HikingTrails: 33007,
  DunnEdwards_DESS24_ScrublandsHabitat: 33008,
  DunnEdwards_DESS25_PrairieGrassland: 33009,
  DunnEdwards_DESS26_RuralWoodlands: 33010,
  DunnEdwards_DESS27_SmokyBrushland: 33011,
  DunnEdwards_DESS28_SageSmudgeStick: 33012,
  DunnEdwards_DESS29_WalkInThePark: 33013,
  DunnEdwards_DESS30_SecretGarden: 33014,
  DunnEdwards_DESS31_SearedAsh: 33015,
  DunnEdwards_DESS32_NavalShipyard: 33016,
  DunnEdwards_DESS33_StormsAhead: 33017,
  DunnEdwards_DESS34_FadedBlueClapboard: 33018,
  DunnEdwards_DESS35_FossilizedWood: 33019,
  DunnEdwards_DESS36_ColdAndRainy: 33020,
  DunnEdwards_DESS37_BracingWinds: 33021,
  DunnEdwards_DESS38_MushroomCaps: 33022,
  DunnEdwards_DESS39_PreservedPewter: 33023,
  DunnEdwards_DESS40_WintersEdge: 33024,
  DunnEdwards_DESS41_VintageOak: 33025,
  DunnEdwards_DESS42_SunBleachedPine: 33026,
  DunnEdwards_DESS43_EarlyAmericanClassic: 33027,
  DunnEdwards_DESS44_SteepEscarpment: 33028,
  DunnEdwards_DESS45_SilverMining: 33029,
  DunnEdwards_DESS46_CollectingDriftwood: 33030,
  DunnEdwards_DESS47_WinterBranches: 33031,
  DunnEdwards_DESS48_FranciscanWalnut: 33032,
  DunnEdwards_DESS49_CordovanBrown: 33033,
  DunnEdwards_DESS50_CarbonizedWood: 33034,
  DunnEdwards_DET400_WineGoblet: 33035,
  DunnEdwards_DET401_JazzBerryJam: 33036,
  DunnEdwards_DET402_MauveALish: 33037,
  DunnEdwards_DET403_RoseMauve: 33038,
  DunnEdwards_DET404_CaliforniaDreamin: 33039,
  DunnEdwards_DET405_PurpleProse: 33040,
  DunnEdwards_DET406_Eventide: 33041,
  DunnEdwards_DET407_Nightshade: 33042,
  DunnEdwards_DET408_Grapevine: 33043,
  DunnEdwards_DET409_GrapesOfWrath: 33044,
  DunnEdwards_DET410_Floriography: 33045,
  DunnEdwards_DET411_CharlestonCherry: 33046,
  DunnEdwards_DET412_HeartThrob: 33047,
  DunnEdwards_DET413_Folklore: 33048,
  DunnEdwards_DET414_HomesteadRed: 33049,
  DunnEdwards_DET415_RenniesRose: 33050,
  DunnEdwards_DET416_LaVieEnRose: 33051,
  DunnEdwards_DET417_HollyhockBloom: 33052,
  DunnEdwards_DET418_RaspberryPatch: 33053,
  DunnEdwards_DET419_PinkDahlia: 33054,
  DunnEdwards_DET420_LadyInRed: 33055,
  DunnEdwards_DET421_LeCorbusierCrush: 33056,
  DunnEdwards_DET422_AttarOfRose: 33057,
  DunnEdwards_DET423_RedCraft: 33058,
  DunnEdwards_DET424_BarnRed: 33059,
  DunnEdwards_DET425_RoyalRedFlush: 33060,
  DunnEdwards_DET426_FieryCoral: 33061,
  DunnEdwards_DET427_VintageRed: 33062,
  DunnEdwards_DET428_RosesAreRed: 33063,
  DunnEdwards_DET429_PasadenaRose: 33064,
  DunnEdwards_DET430_MesaRed: 33065,
  DunnEdwards_DET431_CottonClub: 33066,
  DunnEdwards_DET432_RoseDeMai: 33067,
  DunnEdwards_DET433_TiffanyRose: 33068,
  DunnEdwards_DET434_CityOfPinkAngels: 33069,
  DunnEdwards_DET435_PresidioPeach: 33070,
  DunnEdwards_DET436_OkCoral: 33071,
  DunnEdwards_DET437_PotteryClay: 33072,
  DunnEdwards_DET438_PuebloRose: 33073,
  DunnEdwards_DET439_SpiceOfLife: 33074,
  DunnEdwards_DET440_RussetLeather: 33075,
  DunnEdwards_DET441_RevivalRed: 33076,
  DunnEdwards_DET442_RockyMountainRed: 33077,
  DunnEdwards_DET443_RedMapleLeaf: 33078,
  DunnEdwards_DET444_HappyTrails: 33079,
  DunnEdwards_DET445_OakleyApricot: 33080,
  DunnEdwards_DET446_YoureBlushing: 33081,
  DunnEdwards_DET447_RedClay: 33082,
  DunnEdwards_DET448_Saddlebag: 33083,
  DunnEdwards_DET449_CitrusNotes: 33084,
  DunnEdwards_DET450_PrairieClay: 33085,
  DunnEdwards_DET451_PeachesNCream: 33086,
  DunnEdwards_DET452_GypsumRose: 33087,
  DunnEdwards_DET453_MajolicaEarthenware: 33088,
  DunnEdwards_DET454_ArizonaClay: 33089,
  DunnEdwards_DET455_CopperMining: 33090,
  DunnEdwards_DET456_ChinookSalmon: 33091,
  DunnEdwards_DET457_HalfMoonBayBlush: 33092,
  DunnEdwards_DET458_SantaFeSunset: 33093,
  DunnEdwards_DET459_RedRooster: 33094,
  DunnEdwards_DET460_OBrienOrange: 33095,
  DunnEdwards_DET461_CitrusHoney: 33096,
  DunnEdwards_DET462_Bittersweet: 33097,
  DunnEdwards_DET463_PrairieSun: 33098,
  DunnEdwards_DET464_Cognac: 33099,
  DunnEdwards_DET465_OutlawedOrange: 33100,
  DunnEdwards_DET466_MonarchMigration: 33101,
  DunnEdwards_DET467_HarrisonRust: 33102,
  DunnEdwards_DET468_SantaFeSunrise: 33103,
  DunnEdwards_DET469_WesternSunrise: 33104,
  DunnEdwards_DET470_HoneyNectar: 33105,
  DunnEdwards_DET471_SonomaChardonnay: 33106,
  DunnEdwards_DET472_OchreRevival: 33107,
  DunnEdwards_DET473_Maize: 33108,
  DunnEdwards_DET474_Sunstitch: 33109,
  DunnEdwards_DET475_HoneyBeehive: 33110,
  DunnEdwards_DET476_PeachBellini: 33111,
  DunnEdwards_DET477_ArtsCraftsGold: 33112,
  DunnEdwards_DET478_ZucchiniFlower: 33113,
  DunnEdwards_DET479_CaliforniaPeach: 33114,
  DunnEdwards_DET480_WhereBuffaloRoam: 33115,
  DunnEdwards_DET481_SunnyDisposition: 33116,
  DunnEdwards_DET482_AlamedaOchre: 33117,
  DunnEdwards_DET483_BurntButter: 33118,
  DunnEdwards_DET484_BungalowGold: 33119,
  DunnEdwards_DET485_AntiquarianGold: 33120,
  DunnEdwards_DET486_WildflowerHoney: 33121,
  DunnEdwards_DET487_SuffragetteYellow: 33122,
  DunnEdwards_DET488_GoldenWest: 33123,
  DunnEdwards_DET489_PrairieLand: 33124,
  DunnEdwards_DET490_LemonCaipirinha: 33125,
  DunnEdwards_DET491_LazyDaisy: 33126,
  DunnEdwards_DET492_SummerSolstice: 33127,
  DunnEdwards_DET493_HollywoodStarlet: 33128,
  DunnEdwards_DET494_Beachcombing: 33129,
  DunnEdwards_DET495_SunnysideUp: 33130,
  DunnEdwards_DET496_GatsbyGlitter: 33131,
  DunnEdwards_DET497_VivaLasVegas: 33132,
  DunnEdwards_DET498_CornsilkYellow: 33133,
  DunnEdwards_DET499_Beekeeper: 33134,
  DunnEdwards_DET500_LimePeel: 33135,
  DunnEdwards_DET501_CatalinaGreen: 33136,
  DunnEdwards_DET502_HuntingtonGarden: 33137,
  DunnEdwards_DET503_FamilyTree: 33138,
  DunnEdwards_DET504_ThatsAtomic: 33139,
  DunnEdwards_DET505_DesertSage: 33140,
  DunnEdwards_DET506_EastlakeOlive: 33141,
  DunnEdwards_DET507_GothicRevivalGreen: 33142,
  DunnEdwards_DET508_VerdantViews: 33143,
  DunnEdwards_DET509_Hinterland: 33144,
  DunnEdwards_DET510_Gunsmoke: 33145,
  DunnEdwards_DET511_DappleGray: 33146,
  DunnEdwards_DET512_WhaleWatching: 33147,
  DunnEdwards_DET513_CaliforniaSagebrush: 33148,
  DunnEdwards_DET514_SmokeAsh: 33149,
  DunnEdwards_DET515_HarborMistGray: 33150,
  DunnEdwards_DET516_LichenGreen: 33151,
  DunnEdwards_DET517_FlagstoneQuartzite: 33152,
  DunnEdwards_DET518_BotanicalGarden: 33153,
  DunnEdwards_DET519_Shutters: 33154,
  DunnEdwards_DET520_MowTheLawn: 33155,
  DunnEdwards_DET521_ArizonaTreeFrog: 33156,
  DunnEdwards_DET522_SonomaSage: 33157,
  DunnEdwards_DET523_CloisteredGarden: 33158,
  DunnEdwards_DET524_GreenTourmaline: 33159,
  DunnEdwards_DET525_DavanzoGreen: 33160,
  DunnEdwards_DET526_KempKelly: 33161,
  DunnEdwards_DET527_JoshuaTree: 33162,
  DunnEdwards_DET528_EatYourPeas: 33163,
  DunnEdwards_DET529_GreenerPastures: 33164,
  DunnEdwards_DET530_MorrisArtichoke: 33165,
  DunnEdwards_DET531_StanfordGreen: 33166,
  DunnEdwards_DET532_VictorianGreenhouse: 33167,
  DunnEdwards_DET533_GoGoGreen: 33168,
  DunnEdwards_DET534_EvergreenForest: 33169,
  DunnEdwards_DET535_MidCenturyGem: 33170,
  DunnEdwards_DET536_PalmSpringsSplash: 33171,
  DunnEdwards_DET537_EarhartEmerald: 33172,
  DunnEdwards_DET538_HuntingtonWoods: 33173,
  DunnEdwards_DET539_MissionJewel: 33174,
  DunnEdwards_DET540_TreeLined: 33175,
  DunnEdwards_DET541_Rainsong: 33176,
  DunnEdwards_DET542_TranquilSeashore: 33177,
  DunnEdwards_DET543_Veranda: 33178,
  DunnEdwards_DET544_TheGreenHour: 33179,
  DunnEdwards_DET545_BlueTapestry: 33180,
  DunnEdwards_DET546_Oasis: 33181,
  DunnEdwards_DET547_NavajoTurquoise: 33182,
  DunnEdwards_DET548_FiestaBlue: 33183,
  DunnEdwards_DET549_LittleBeauxBlue: 33184,
  DunnEdwards_DET550_HeritageBlue: 33185,
  DunnEdwards_DET551_BidwellBlue: 33186,
  DunnEdwards_DET552_Avalon: 33187,
  DunnEdwards_DET553_EasyBreezyBlue: 33188,
  DunnEdwards_DET554_BellBlue: 33189,
  DunnEdwards_DET555_Aquamarine: 33190,
  DunnEdwards_DET556_LakeReflection: 33191,
  DunnEdwards_DET557_SanGabrielBlue: 33192,
  DunnEdwards_DET558_RagtimeBlues: 33193,
  DunnEdwards_DET559_BlueVelvet: 33194,
  DunnEdwards_DET560_WeatheredBlue: 33195,
  DunnEdwards_DET561_SummerShade: 33196,
  DunnEdwards_DET562_SaltBoxBlue: 33197,
  DunnEdwards_DET563_MissionBayBlue: 33198,
  DunnEdwards_DET564_EamesForBlue: 33199,
  DunnEdwards_DET565_BerryMojito: 33200,
  DunnEdwards_DET566_PowderMill: 33201,
  DunnEdwards_DET567_SkippingStones: 33202,
  DunnEdwards_DET568_BlueMonday: 33203,
  DunnEdwards_DET569_SanMiguelBlue: 33204,
  DunnEdwards_DET570_SmokyBlue: 33205,
  DunnEdwards_DET571_MorroBay: 33206,
  DunnEdwards_DET572_DarkStormy: 33207,
  DunnEdwards_DET573_MountainBluebird: 33208,
  DunnEdwards_DET574_JazzAgeBlues: 33209,
  DunnEdwards_DET575_BluePrint: 33210,
  DunnEdwards_DET576_SingingTheBlues: 33211,
  DunnEdwards_DET577_BigSurBlueJade: 33212,
  DunnEdwards_DET578_YankeeDoodle: 33213,
  DunnEdwards_DET579_MackintoshMidnight: 33214,
  DunnEdwards_DET580_MidnightSun: 33215,
  DunnEdwards_DET581_CountryAir: 33216,
  DunnEdwards_DET582_TriedTrueBlue: 33217,
  DunnEdwards_DET583_SurfsUp: 33218,
  DunnEdwards_DET584_PostwarBoom: 33219,
  DunnEdwards_DET585_BlueCalico: 33220,
  DunnEdwards_DET586_PacificBlues: 33221,
  DunnEdwards_DET587_ClematisBlue: 33222,
  DunnEdwards_DET588_Maritime: 33223,
  DunnEdwards_DET589_GenteelBlue: 33224,
  DunnEdwards_DET590_MoodyBlues: 33225,
  DunnEdwards_DET591_SilverScreen: 33226,
  DunnEdwards_DET592_CarbonDating: 33227,
  DunnEdwards_DET593_MadeOfSteel: 33228,
  DunnEdwards_DET594_Yreka: 33229,
  DunnEdwards_DET595_RhythmBlues: 33230,
  DunnEdwards_DET596_Nightlife: 33231,
  DunnEdwards_DET597_ShadowEffect: 33232,
  DunnEdwards_DET598_GoodNight: 33233,
  DunnEdwards_DET599_MarineLayer: 33234,
  DunnEdwards_DET600_DolphinTales: 33235,
  DunnEdwards_DET601_CharcoalBriquette: 33236,
  DunnEdwards_DET602_GrayMonument: 33237,
  DunnEdwards_DET603_ChurchMouse: 33238,
  DunnEdwards_DET604_BroodingStorm: 33239,
  DunnEdwards_DET605_DriftingDownstream: 33240,
  DunnEdwards_DET606_MeekMossGreen: 33241,
  DunnEdwards_DET607_LifeAquatic: 33242,
  DunnEdwards_DET608_MossCottage: 33243,
  DunnEdwards_DET609_DecoGray: 33244,
  DunnEdwards_DET610_Wolverine: 33245,
  DunnEdwards_DET611_IronIc: 33246,
  DunnEdwards_DET612_StieglitzSilver: 33247,
  DunnEdwards_DET613_CoalMiner: 33248,
  DunnEdwards_DET614_SoChic: 33249,
  DunnEdwards_DET615_StoneMason: 33250,
  DunnEdwards_DET616_Equinox: 33251,
  DunnEdwards_DET617_WinterMorn: 33252,
  DunnEdwards_DET618_IndustrialAge: 33253,
  DunnEdwards_DET619_Celluloid: 33254,
  DunnEdwards_DET620_BarnwoodGray: 33255,
  DunnEdwards_DET621_PalominoPony: 33256,
  DunnEdwards_DET622_PortobelloMushroom: 33257,
  DunnEdwards_DET623_EnPleinAir: 33258,
  DunnEdwards_DET624_SorrelFelt: 33259,
  DunnEdwards_DET625_ReclaimedWood: 33260,
  DunnEdwards_DET626_MetalFringe: 33261,
  DunnEdwards_DET627_PewterPatter: 33262,
  DunnEdwards_DET628_CharcoalSketch: 33263,
  DunnEdwards_DET629_FadeToBlack: 33264,
  DunnEdwards_DET630_RenwickBrown: 33265,
  DunnEdwards_DET631_CocoaPowder: 33266,
  DunnEdwards_DET632_FlourSack: 33267,
  DunnEdwards_DET633_TrailBlazer: 33268,
  DunnEdwards_DET634_DowningToEarth: 33269,
  DunnEdwards_DET635_EcruWealth: 33270,
  DunnEdwards_DET636_FloweringReed: 33271,
  DunnEdwards_DET637_SeagullWail: 33272,
  DunnEdwards_DET638_SepiaTone: 33273,
  DunnEdwards_DET639_MapleBrownSugar: 33274,
  DunnEdwards_DET640_TawnyOwl: 33275,
  DunnEdwards_DET641_DoricWhite: 33276,
  DunnEdwards_DET642_BaySalt: 33277,
  DunnEdwards_DET643_GreenLacewing: 33278,
  DunnEdwards_DET644_CrepePapier: 33279,
  DunnEdwards_DET645_AngelicStarlet: 33280,
  DunnEdwards_DET646_WarmAndToasty: 33281,
  DunnEdwards_DET647_TradeWinds: 33282,
  DunnEdwards_DET648_WhitePicketFence: 33283,
  DunnEdwards_DET649_Carrara: 33284,
  DunnEdwards_DET650_CelestialMoon: 33285,
  DunnEdwards_DET651_WaxPoetic: 33286,
  DunnEdwards_DET652_SunbakedAdobe: 33287,
  DunnEdwards_DET653_HistoricWhite: 33288,
  DunnEdwards_DET654_CremeFraiche: 33289,
  DunnEdwards_DET655_MeltWithYou: 33290,
  DunnEdwards_DET656_HeartOfGold: 33291,
  DunnEdwards_DET657_BakeliteYellow: 33292,
  DunnEdwards_DET658_RawUmber: 33293,
  DunnEdwards_DET659_SchindlerBrown: 33294,
  DunnEdwards_DET660_NaturalRadiance: 33295,
  DunnEdwards_DET661_Equestrian: 33296,
  DunnEdwards_DET662_ButtercreamFrosting: 33297,
  DunnEdwards_DET663_ClamUp: 33298,
  DunnEdwards_DET664_DavanzoBeige: 33299,
  DunnEdwards_DET665_GrainMill: 33300,
  DunnEdwards_DET666_JeffersonCream: 33301,
  DunnEdwards_DET667_HollywoodGoldenAge: 33302,
  DunnEdwards_DET668_WithTheGrain: 33303,
  DunnEdwards_DET669_ChampagneBubbles: 33304,
  DunnEdwards_DET670_VintageEphemera: 33305,
  DunnEdwards_DET671_CameoRole: 33306,
  DunnEdwards_DET672_InstantClassic: 33307,
  DunnEdwards_DET673_MissionWhite: 33308,
  DunnEdwards_DET674_Gunnysack: 33309,
  DunnEdwards_DET675_PuebloWhite: 33310,
  DunnEdwards_DET676_MuscatBlanc: 33311,
  DunnEdwards_DET677_WhiteBlossom: 33312,
  DunnEdwards_DET678_Daydreaming: 33313,
  DunnEdwards_DET679_FreshSnow: 33314,
  DunnEdwards_DET680_EspressoMacchiato: 33315,
  DunnEdwards_DET681_ModerneClass: 33316,
  DunnEdwards_DET682_ArtAndCraft: 33317,
  DunnEdwards_DET683_WildHorses: 33318,
  DunnEdwards_DET684_CrackledLeather: 33319,
  DunnEdwards_DET685_MissionGold: 33320,
  DunnEdwards_DET686_AgedWhisky: 33321,
  DunnEdwards_DET687_Caramelized: 33322,
  DunnEdwards_DET688_WildBillBrown: 33323,
  DunnEdwards_DET689_CowboyTrails: 33324,
  DunnEdwards_DET690_SaddleUp: 33325,
  DunnEdwards_DET691_SpicedHotChocolate: 33326,
  DunnEdwards_DET692_KilnDried: 33327,
  DunnEdwards_DET693_MayanChocolate: 33328,
  DunnEdwards_DET694_CarmelMission: 33329,
  DunnEdwards_DET695_GrangeHall: 33330,
  DunnEdwards_DET696_StanfordStone: 33331,
  DunnEdwards_DET697_Nomad: 33332,
  DunnEdwards_DET698_BidwellBrown: 33333,
  DunnEdwards_DET699_BourbonTruffle: 33334,
  DunnEdwards_DEW300_Coy: 33335,
  DunnEdwards_DEW301_StrawberryDust: 33336,
  DunnEdwards_DEW302_Romantic: 33337,
  DunnEdwards_DEW303_Dogwood: 33338,
  DunnEdwards_DEW304_WhatsLeft: 33339,
  DunnEdwards_DEW305_SatinPurse: 33340,
  DunnEdwards_DEW306_SheerPeach: 33341,
  DunnEdwards_DEW307_Rosarian: 33342,
  DunnEdwards_DEW308_PoppyCrepe: 33343,
  DunnEdwards_DEW309_AjoLily: 33344,
  DunnEdwards_DEW310_Alabaster: 33345,
  DunnEdwards_DEW311_FrenchWhite: 33346,
  DunnEdwards_DEW312_TotalRecall: 33347,
  DunnEdwards_DEW313_EarlySnow: 33348,
  DunnEdwards_DEW314_DesertStar: 33349,
  DunnEdwards_DEW315_WhiteZin: 33350,
  DunnEdwards_DEW316_Powdered: 33351,
  DunnEdwards_DEW317_DayLily: 33352,
  DunnEdwards_DEW318_CottageWhite: 33353,
  DunnEdwards_DEW319_Damask: 33354,
  DunnEdwards_DEW320_PinchOfPearl: 33355,
  DunnEdwards_DEW321_SparklingCider: 33356,
  DunnEdwards_DEW322_Magnolia: 33357,
  DunnEdwards_DEW323_IvoryCharm: 33358,
  DunnEdwards_DEW324_PhoenixVilla: 33359,
  DunnEdwards_DEW325_VanillaShake: 33360,
  DunnEdwards_DEW326_BirchWhite: 33361,
  DunnEdwards_DEW327_Lily: 33362,
  DunnEdwards_DEW328_PearlWhite: 33363,
  DunnEdwards_DEW329_WaxWing: 33364,
  DunnEdwards_DEW330_SnugCottage: 33365,
  DunnEdwards_DEW331_WeddingDress: 33366,
  DunnEdwards_DEW332_LeadGlass: 33367,
  DunnEdwards_DEW333_Diamond: 33368,
  DunnEdwards_DEW334_ClearDay: 33369,
  DunnEdwards_DEW335_Icicle: 33370,
  DunnEdwards_DEW336_WhiteSand: 33371,
  DunnEdwards_DEW337_Gardenia: 33372,
  DunnEdwards_DEW338_WhiteHeat: 33373,
  DunnEdwards_DEW339_BoneChina: 33374,
  DunnEdwards_DEW340_Whisper: 33375,
  DunnEdwards_DEW341_SwissCoffee: 33376,
  DunnEdwards_DEW342_BabysBreath: 33377,
  DunnEdwards_DEW343_PearlNecklace: 33378,
  DunnEdwards_DEW344_FrostingCream: 33379,
  DunnEdwards_DEW345_WhiteFever: 33380,
  DunnEdwards_DEW346_SwanWhite: 33381,
  DunnEdwards_DEW347_Luminary: 33382,
  DunnEdwards_DEW348_GlamourWhite: 33383,
  DunnEdwards_DEW349_Shyness: 33384,
  DunnEdwards_DEW350_Clearview: 33385,
  DunnEdwards_DEW351_AntiqueWhite: 33386,
  DunnEdwards_DEW352_Cumulus: 33387,
  DunnEdwards_DEW353_IvoryKeys: 33388,
  DunnEdwards_DEW354_VanDeCane: 33389,
  DunnEdwards_DEW355_GreenTea: 33390,
  DunnEdwards_DEW356_BeanSprout: 33391,
  DunnEdwards_DEW357_WhiteCrest: 33392,
  DunnEdwards_DEW358_MilkGlass: 33393,
  DunnEdwards_DEW359_SoftSilver: 33394,
  DunnEdwards_DEW360_SpringFrost: 33395,
  DunnEdwards_DEW361_RefinedMint: 33396,
  DunnEdwards_DEW362_GrassValley: 33397,
  DunnEdwards_DEW363_SpringWhite: 33398,
  DunnEdwards_DEW364_WhiteSulfur: 33399,
  DunnEdwards_DEW365_FogTown: 33400,
  DunnEdwards_DEW366_SoftPetals: 33401,
  DunnEdwards_DEW367_TouchOfMint: 33402,
  DunnEdwards_DEW368_MeltingGlacier: 33403,
  DunnEdwards_DEW369_WindChill: 33404,
  DunnEdwards_DEW370_DistantCloud: 33405,
  DunnEdwards_DEW371_HurricaneMist: 33406,
  DunnEdwards_DEW372_Catalina: 33407,
  DunnEdwards_DEW373_CalmWaters: 33408,
  DunnEdwards_DEW374_CoastalBreeze: 33409,
  DunnEdwards_DEW375_ClearSkies: 33410,
  DunnEdwards_DEW376_EveningShadow: 33411,
  DunnEdwards_DEW377_DistantHorizon: 33412,
  DunnEdwards_DEW378_WornDenim: 33413,
  DunnEdwards_DEW379_Igloo: 33414,
  DunnEdwards_DEW380_WarmWhite: 33415,
  DunnEdwards_DEW381_Droplets: 33416,
  DunnEdwards_DEW382_FadedGray: 33417,
  DunnEdwards_DEW383_CoolDecember: 33418,
  DunnEdwards_DEW384_Snowflake: 33419,
  DunnEdwards_DEW385_Lighthouse: 33420,
  DunnEdwards_DEW386_PreciousPearls: 33421,
  DunnEdwards_DEW387_CottonBall: 33422,
  DunnEdwards_DEW388_MorningMist: 33423,
  DunnEdwards_DEW389_SpringtimeRain: 33424,
  DunnEdwards_DEW390_FirstSnow: 33425,
  DunnEdwards_DEW391_BoysenberryShadow: 33426,
  DunnEdwards_DEW392_CrystalBell: 33427,
  DunnEdwards_DEW393_VioletClues: 33428,
  DunnEdwards_DEW394_CascadingWhite: 33429,
  DunnEdwards_DEW395_HeirloomShade: 33430,
  DunnEdwards_DEW396_EssenceOfViolet: 33431,
  DunnEdwards_DEW397_AngelFeather: 33432,
  DunnEdwards_DEW398_Abalone: 33433,
  DunnEdwards_DEW399_SentimentalPink: 33434,
  DunnEdwards_Sahara: 1983,
};

const DMC_DuraSeal_Stains = {
  DS_Stain_Jacobean: 11069,
  DS_Stain_RusticBeige: 10679,
  DS_Stain_WeatheredOak: 10634,
};

const DMC_FloridaPaints = {
  FP_0001_HintOfVanilla: 15535,
  FP_0002_ElusiveWhite: 15536,
  FP_0003_NillaVanilla: 15537,
  FP_0004_ChildOfHeaven: 15538,
  FP_0005_Kiara: 15539,
  FP_0006_LittleDove: 11070,
  FP_0007_CottonBall: 15540,
  FP_0008_CasaBlanca: 15541,
  FP_0009_ChapelWall: 15542,
  FP_0010_Petticoat: 15543,
  FP_0011_SugarDust: 15544,
  FP_0012_BunnyCake: 15545,
  FP_0013_Sphere: 15546,
  FP_0014_Twill: 15547,
  FP_0015_WhiteGlove: 15548,
  FP_0016_PumiceStone: 15549,
  FP_0017_LunaMoon: 11071,
  FP_0018_DoveWhite: 15550,
  FP_0019_MysticFog: 11072,
  FP_0020_Bonaire: 15551,
  FP_0021_BarelyWhite: 15552,
  FP_0022_WhiteKitten: 15553,
  FP_0023_ShellTint: 15554,
  FP_0024_JustAboutWhite: 11073,
  FP_0025_PrismaticPearl: 15555,
  FP_0026_MoonDrop: 15556,
  FP_0027_WhiteFence: 15557,
  FP_0028_BannisterWhite: 15558,
  FP_0029_CherishIsTheWord: 15559,
  FP_0030_LadyNicole: 15560,
  FP_0031_ItalianIce: 15561,
  FP_0032_IceDream: 15562,
  FP_0033_ChafedWheat: 15563,
  FP_0034_HereComesTheSun: 15564,
  FP_0035_WeekendRetreat: 15565,
  FP_0036_FortunesPrize: 15566,
  FP_0037_MoneyTree: 15567,
  FP_0038_AutumnsHill: 15568,
  FP_0039_MandalayRoad: 15569,
  FP_0040_AntiqueCandleLight: 15570,
  FP_0041_ChineseCherry: 15571,
  FP_0042_AntoinettePink: 15572,
  FP_0043_AngelBreath: 15573,
  FP_0044_Calliope: 15574,
  FP_0045_SizzlingHot: 15575,
  FP_0046_Valentino: 15576,
  FP_0047_SandIsland: 15577,
  FP_0048_Embrace: 15578,
  FP_0049_AuburnWave: 15579,
  FP_0050_SimmeringRidge: 15580,
  FP_0051_CaramelCandy: 15581,
  FP_0052_SpicedCarrot: 15582,
  FP_0053_RemainingEmbers: 15583,
  FP_0054_WinkPink: 15584,
  FP_0055_StrawberryWhip: 15585,
  FP_0056_DaintyDebutante: 15586,
  FP_0057_MarblePink: 15587,
  FP_0058_AngelicChoir: 15588,
  FP_0059_Quintessential: 15589,
  FP_0060_ParlorRose: 15590,
  FP_0061_Pinkathon: 15591,
  FP_0062_BloomingPerfect: 15592,
  FP_0063_ImpatientHeart: 15593,
  FP_0064_LordBaltimore: 15594,
  FP_0065_PoppyProse: 15595,
  FP_0066_WildRose: 15596,
  FP_0067_LoversKiss: 15597,
  FP_0068_SummerBlush: 15598,
  FP_0069_EmpireRose: 15599,
  FP_0070_OFortuna: 15600,
  FP_0071_RubyEye: 15601,
  FP_0072_NoticeMe: 15602,
  FP_0073_Corazon: 15603,
  FP_0074_EmperorsRobe: 15604,
  FP_0075_PinkDuet: 15605,
  FP_0076_FantasticPink: 15606,
  FP_0077_PinkSoftness: 15607,
  FP_0078_BeMine: 15608,
  FP_0079_Prophetess: 15609,
  FP_0080_AbraCadabra: 15610,
  FP_0081_BerryCrush: 15611,
  FP_0082_RoseShadow: 15612,
  FP_0083_PinkCoral: 15613,
  FP_0084_QuietPink: 15614,
  FP_0085_FragrantSatchel: 15615,
  FP_0086_KingsCloak: 15616,
  FP_0087_Cinnapink: 15617,
  FP_0088_Casandra: 15618,
  FP_0089_StarOfMorning: 15619,
  FP_0090_MoonGoddess: 15620,
  FP_0091_GarnetShadow: 15621,
  FP_0092_FreshDay: 15622,
  FP_0093_HeraldOfSpring: 15623,
  FP_0094_Starlet: 15624,
  FP_0095_QueensRose: 15625,
  FP_0096_MorningSide: 15626,
  FP_0097_OdysseyPlum: 15627,
  FP_0098_Lockhart: 15628,
  FP_0099_LoversTryst: 15629,
  FP_0100_Whimsy: 15630,
  FP_0101_FruitfulOrchard: 15631,
  FP_0102_EarthlyPleasure: 15632,
  FP_0103_Hosanna: 15633,
  FP_0104_VictorianCottage: 15634,
  FP_0105_HarvestBlessing: 15635,
  FP_0106_RareFind: 15636,
  FP_0107_Prosperity: 15637,
  FP_0108_Exotica: 15638,
  FP_0109_KungFu: 15639,
  FP_0110_BabyBunting: 15640,
  FP_0111_AcadiaBloom: 15641,
  FP_0112_LadyFlower: 15642,
  FP_0113_PunchOfPink: 15643,
  FP_0114_MontroseRose: 15644,
  FP_0115_Sophistication: 15645,
  FP_0116_CordovaBurgundy: 15646,
  FP_0117_SatinSlipper: 15647,
  FP_0118_MiniaturePosey: 15648,
  FP_0119_AngelaCanyon: 15649,
  FP_0120_SummersEve: 15650,
  FP_0121_Savanna: 15651,
  FP_0122_Outrageous: 15652,
  FP_0123_MontereyChestnut: 15653,
  FP_0124_MerlinsBeard: 15654,
  FP_0125_Pout: 15655,
  FP_0126_Sauterne: 15656,
  FP_0127_AndesAsh: 15657,
  FP_0128_RockyMountain: 15658,
  FP_0129_Arrowhead: 15659,
  FP_0130_Evolution: 15660,
  FP_0131_Cliffswallow: 15661,
  FP_0132_SummerBeige: 15662,
  FP_0133_Natchez: 15663,
  FP_0134_BabySprout: 15664,
  FP_0135_EmergingLeaf: 15665,
  FP_0136_AmazonMist: 15666,
  FP_0137_Hideaway: 15667,
  FP_0138_CoconutMacaroon: 15668,
  FP_0139_Souffle: 15669,
  FP_0140_CozyCover: 15670,
  FP_0141_BushBuck: 15671,
  FP_0142_RanchHouse: 15672,
  FP_0143_Connoisseur: 15673,
  FP_0144_FilmNoir: 15674,
  FP_0145_FlaxFlower: 15675,
  FP_0146_Truffles: 15676,
  FP_0147_CavePainting: 15677,
  FP_0148_OakPlank: 15678,
  FP_0149_PavilionTan: 15679,
  FP_0150_Temptation: 15680,
  FP_0151_CoffeeShop: 15681,
  FP_0152_Flirt: 15682,
  FP_0153_TakeOut: 15683,
  FP_0154_Romulus: 15684,
  FP_0155_Cowhide: 15685,
  FP_0156_SkinnyDip: 15686,
  FP_0157_DodgePole: 15687,
  FP_0158_MoverAndShaker: 15688,
  FP_0159_SeniorMoment: 15689,
  FP_0160_KingdomsKeys: 15690,
  FP_0161_TinyCalf: 15691,
  FP_0162_ApplePie: 15692,
  FP_0163_CamelTrain: 15693,
  FP_0164_Veldrift: 15694,
  FP_0165_CavernSand: 15695,
  FP_0166_PastelDay: 15696,
  FP_0167_FirstDate: 15697,
  FP_0168_CandleLight: 15698,
  FP_0169_FossilTan: 15699,
  FP_0170_BlondeShell: 15700,
  FP_0171_GoldenGlove: 15701,
  FP_0172_Chasm: 15702,
  FP_0173_PaleGingersnap: 15703,
  FP_0174_MaplePecan: 15704,
  FP_0175_amLatte: 15705,
  FP_0176_CountryDweller: 15706,
  FP_0177_WeaversTool: 15707,
  FP_0178_Cupcake: 15708,
  FP_0179_FallInSeason: 15709,
  FP_0180_FreshLinen: 15710,
  FP_0181_Ageless: 15711,
  FP_0182_IvoryRidge: 15712,
  FP_0183_MothWing: 15713,
  FP_0184_MacadamiaBrown: 15714,
  FP_0185_NobleCrown: 15715,
  FP_0186_ChristmasOrnament: 15716,
  FP_0187_WhiteLightning: 15717,
  FP_0188_Baguette: 15718,
  FP_0189_DelicateHoneysweet: 15719,
  FP_0190_VillageCrier: 11074,
  FP_0191_DustyPath: 15720,
  FP_0192_Dapper: 15721,
  FP_0193_AlphaMale: 15722,
  FP_0194_AugustMoon: 11075,
  FP_0195_MossyShade: 15723,
  FP_0196_Overgrown: 15724,
  FP_0197_ThistleGray: 15725,
  FP_0198_YoungColt: 15726,
  FP_0199_SandyShoes: 11076,
  FP_0200_StonyField: 11077,
  FP_0201_SparklingChampagne: 15727,
  FP_0202_PowderCake: 15728,
  FP_0203_WhaleBone: 15729,
  FP_0204_MarshyHabitat: 15730,
  FP_0205_WoodShadow: 15731,
  FP_0206_ThatchedCottage: 15732,
  FP_0207_AresShadow: 15733,
  FP_0208_UmberStyle: 15734,
  FP_0209_Polished: 15735,
  FP_0210_HiddenCove: 15736,
  FP_0211_LightLichen: 11078,
  FP_0212_BigSpender: 15737,
  FP_0213_CoastalFog: 15738,
  FP_0214_Wildwood: 11079,
  FP_0215_HerareWhite: 15739,
  FP_0216_Earthling: 15740,
  FP_0217_OakTone: 15741,
  FP_0218_DriftingSand: 15742,
  FP_0219_CamelsHump: 15743,
  FP_0220_MonksCloth: 15744,
  FP_0221_BrownSuede: 15745,
  FP_0222_AuNatural: 15746,
  FP_0223_WhiteElephant: 15747,
  FP_0224_Pebblebrook: 15748,
  FP_0225_RomanRuins: 15749,
  FP_0226_Sedge: 15750,
  FP_0227_Moonscape: 15751,
  FP_0228_HannoverHills: 15752,
  FP_0229_FeatherStone: 15753,
  FP_0230_HarrowGate: 11080,
  FP_0231_DesertMirage: 15754,
  FP_0232_Frond: 15755,
  FP_0233_DeepMarsh: 15756,
  FP_0234_IndustrialStrength: 15757,
  FP_0235_BlackHeath: 15758,
  FP_0236_SundayGloves: 15759,
  FP_0237_Flan: 15760,
  FP_0238_CrownedOne: 15761,
  FP_0239_TailoredTan: 15762,
  FP_0240_SpicedRum: 15763,
  FP_0241_PrinceParis: 15764,
  FP_0242_RareHappening: 15765,
  FP_0243_FrozenCustard: 15766,
  FP_0244_MulledCider: 15767,
  FP_0245_CaramelCloud: 15768,
  FP_0246_CinnamonToast: 15769,
  FP_0247_AppleCrisp: 15770,
  FP_0248_SafariSun: 15771,
  FP_0249_ButterscotchMousse: 15772,
  FP_0250_PumpkinSpice: 15773,
  FP_0251_Alchemy: 15774,
  FP_0252_OctoberBounty: 15775,
  FP_0253_HoneyGlow: 15776,
  FP_0254_LivingLarge: 15777,
  FP_0255_BackToBasics: 15778,
  FP_0256_CrazyHorse: 15779,
  FP_0257_Shortbread: 15780,
  FP_0258_ClassicTerra: 15781,
  FP_0259_PersianFable: 15782,
  FP_0260_CocoaNib: 15783,
  FP_0261_TanHide: 15784,
  FP_0262_LogCabin: 15785,
  FP_0263_CountryCharm: 15786,
  FP_0264_PalestOfLemon: 15787,
  FP_0265_MarshmallowMist: 15788,
  FP_0266_OctoberHarvest: 15789,
  FP_0267_SeasonFinale: 15790,
  FP_0268_RichOak: 15791,
  FP_0269_SaharaWind: 15792,
  FP_0270_GrahamCrust: 15793,
  FP_0271_CloverHoney: 15794,
  FP_0272_MineralWater: 15795,
  FP_0273_SandstonePalette: 15796,
  FP_0274_PolishedMarble: 15797,
  FP_0275_Highlight: 15798,
  FP_0276_GoldTaffeta: 15799,
  FP_0277_GoldenFreesia: 15800,
  FP_0278_BarberrySand: 15801,
  FP_0279_GardenCountry: 11081,
  FP_0280_WickerBasket: 15802,
  FP_0281_OliveGold: 15803,
  FP_0282_VintageGold: 15804,
  FP_0283_HistoricTown: 15805,
  FP_0284_QueenLioness: 15806,
  FP_0285_Eugenia: 15807,
  FP_0286_YellowPage: 15808,
  FP_0287_MuslinTint: 15809,
  FP_0288_GoldenBuff: 15810,
  FP_0289_PrairieSand: 15811,
  FP_0290_KeyKeeper: 15812,
  FP_0291_Rutherford: 15813,
  FP_0292_PrivateWhite: 15814,
  FP_0293_WhatInheritance: 15815,
  FP_0294_RubElbows: 15816,
  FP_0295_SpanishCream: 15817,
  FP_0296_OnlyYesterday: 15818,
  FP_0297_GoldSeason: 15819,
  FP_0298_Brocade: 15820,
  FP_0299_AllisonLace: 15821,
  FP_0300_IvoryParchment: 15822,
  FP_0301_CorinthianPillar: 15823,
  FP_0302_RichReward: 15824,
  FP_0303_BauhausGold: 15825,
  FP_0304_GoldTangiers: 15826,
  FP_0305_GoldenSummer: 15827,
  FP_0306_SaffronTint: 15828,
  FP_0307_PuttingBench: 15829,
  FP_0308_CoconutCrumble: 15830,
  FP_0309_PalmettoBluff: 15831,
  FP_0310_Sassafras: 15832,
  FP_0311_LifeExotic: 15833,
  FP_0312_SeptemberGold: 15834,
  FP_0313_ChicMagnet: 15835,
  FP_0314_TradeSecret: 15836,
  FP_0315_PeaceableKingdom: 15837,
  FP_0316_GoldenLake: 15838,
  FP_0317_GreenGold: 15839,
  FP_0318_TheresNoPlaceLikeHome: 15840,
  FP_0319_HeraldsTrumpet: 15841,
  FP_0320_FloatingIsland: 15842,
  FP_0321_Hephaestus: 15843,
  FP_0322_GabrielsLight: 15844,
  FP_0323_StarOfGold: 15845,
  FP_0324_UponReflection: 15846,
  FP_0325_WelcomeHome: 15847,
  FP_0326_Bambino: 15848,
  FP_0327_TawnyDaylilly: 15849,
  FP_0328_LandOfTrees: 15850,
  FP_0329_KnitCardigan: 15851,
  FP_0330_CastawayBeach: 15852,
  FP_0331_Refined: 15853,
  FP_0332_AllNighter: 15854,
  FP_0333_Grasslands: 15855,
  FP_0334_Sedona: 15856,
  FP_0335_IllusiveDream: 15857,
  FP_0336_SoftLeather: 15858,
  FP_0337_UrbanCharm: 15859,
  FP_0338_Whipcord: 15860,
  FP_0339_CeramicPot: 15861,
  FP_0340_Nightfall: 15862,
  FP_0341_LochNess: 15863,
  FP_0342_VelumSmoke: 15864,
  FP_0343_Cantera: 15865,
  FP_0344_Courtyard: 15866,
  FP_0345_TravertinePath: 15867,
  FP_0346_NortheastTrail: 15868,
  FP_0347_JungleCover: 15869,
  FP_0348_DriedGrass: 15870,
  FP_0349_Reseda: 15871,
  FP_0350_HelenOfTroy: 15872,
  FP_0351_Mohalla: 15873,
  FP_0352_ShagbarkOlive: 15874,
  FP_0353_BeckerGold: 15875,
  FP_0354_Austere: 15876,
  FP_0355_TwinkleTwinkle: 11082,
  FP_0356_MothMist: 15877,
  FP_0357_MossIsland: 15878,
  FP_0358_SilkyGreen: 15879,
  FP_0359_GreenSleeves: 15880,
  FP_0360_LandBeforeTime: 15881,
  FP_0361_GeorgiaOnMyMind: 15882,
  FP_0362_PaleQuartz: 15883,
  FP_0363_MissionHills: 15884,
  FP_0364_StoneHearth: 15885,
  FP_0365_AbbeyStone: 15886,
  FP_0366_Owlet: 15887,
  FP_0367_ChocolateVelvet: 15888,
  FP_0368_FolkTales: 15889,
  FP_0369_Saturnia: 15890,
  FP_0370_Palatine: 15891,
  FP_0371_Fiorito: 11083,
  FP_0372_HistoricShade: 15892,
  FP_0373_BurningIdea: 15893,
  FP_0374_CandleWax: 15894,
  FP_0375_AfricanQueen: 15895,
  FP_0376_BleachedMeadow: 15896,
  FP_0377_Montezuma: 15897,
  FP_0378_GardenHedge: 15898,
  FP_0379_Orestes: 15899,
  FP_0380_MirroredWillow: 15900,
  FP_0381_Sonata: 15901,
  FP_0382_MountOlive: 15902,
  FP_0383_NaturalWhisper: 15903,
  FP_0384_CheesePlease: 15904,
  FP_0385_HowdyNeighbor: 15905,
  FP_0386_Hippolita: 15906,
  FP_0387_GoldieOldie: 15907,
  FP_0388_ShinyGold: 15908,
  FP_0389_GoldSparkle: 15909,
  FP_0390_OliveTint: 15910,
  FP_0391_Crispa: 15911,
  FP_0392_AlsotOlive: 15912,
  FP_0393_InvitingGesture: 15913,
  FP_0394_Highway: 15914,
  FP_0395_CrackWillow: 15915,
  FP_0396_WingMan: 15916,
  FP_0397_HiddenParadise: 15917,
  FP_0398_IslandEmbrace: 15918,
  FP_0399_SawgrassCottage: 15919,
  FP_0400_NewFoliage: 15920,
  FP_0401_BambooForest: 15921,
  FP_0402_SaboGarden: 15922,
  FP_0403_TropicalTwist: 15923,
  FP_0404_TranslucentVision: 15924,
  FP_0405_PlanetEarth: 15925,
  FP_0406_HomeBody: 15926,
  FP_0407_Vapor: 15927,
  FP_0408_Rediscover: 15928,
  FP_0409_GreenCast: 15929,
  FP_0410_OldSchool: 15930,
  FP_0411_CyprusSpring: 15931,
  FP_0412_Sublime: 15932,
  FP_0413_SpeakToMe: 15933,
  FP_0414_PlumeGrass: 15934,
  FP_0415_FrenchPear: 15935,
  FP_0416_TaffetaSheen: 15936,
  FP_0417_AloeLeaf: 15937,
  FP_0418_OnionSkin: 15938,
  FP_0419_PoseidonsBeard: 15939,
  FP_0420_DavesDen: 15940,
  FP_0421_SilveradoRanch: 15941,
  FP_0422_EverlastingSage: 15942,
  FP_0423_EyeOfTheStorm: 15943,
  FP_0424_Monogram: 15944,
  FP_0425_PaleGreenTea: 15945,
  FP_0426_SeptemberSong: 15946,
  FP_0427_ArborVitae: 15947,
  FP_0428_LuckyDay: 15948,
  FP_0429_PendulaGarden: 15949,
  FP_0430_Vegetarian: 15950,
  FP_0431_CloverPatch: 15951,
  FP_0432_SweetSpring: 15952,
  FP_0433_GrassyGlade: 15953,
  FP_0434_LushMeadow: 15954,
  FP_0435_BigFish: 11084,
  FP_0436_FernGully: 15955,
  FP_0437_BowlingGreen: 15956,
  FP_0438_Delicious: 15957,
  FP_0439_NumeroUno: 15958,
  FP_0440_PaleLoden: 15959,
  FP_0441_SlateStone: 15960,
  FP_0442_Dowager: 11085,
  FP_0443_Serpentine: 15961,
  FP_0444_Grime: 15962,
  FP_0445_DeepShadow: 15963,
  FP_0446_SealskinShadow: 15964,
  FP_0447_MetalFlake: 15965,
  FP_0448_IceFlow: 15966,
  FP_0449_CannonBall: 15967,
  FP_0450_RiverGod: 15968,
  FP_0451_EveningDove: 15969,
  FP_0452_RuggeroGrey: 15970,
  FP_0453_FeatherFern: 15971,
  FP_0454_MarbleGreen: 15972,
  FP_0455_FavoredOne: 11086,
  FP_0456_FairMaiden: 15973,
  FP_0457_HeavenlyGarden: 15974,
  FP_0458_Malarca: 15975,
  FP_0459_PleasantHill: 15976,
  FP_0460_JustALittle: 15977,
  FP_0461_CalmBreeze: 15978,
  FP_0462_RestingPlace: 15979,
  FP_0463_GaelicGarden: 15980,
  FP_0464_KathleensGarden: 11087,
  FP_0465_EarthenCheer: 15981,
  FP_0466_GreenColumn: 15982,
  FP_0467_SweetAriel: 15983,
  FP_0468_MellowBlue: 15984,
  FP_0469_DejaVu: 15985,
  FP_0470_DreamingOfTheDay: 15986,
  FP_0471_MiracleBay: 11088,
  FP_0472_Micropolis: 11089,
  FP_0473_AtlanticWaves: 15987,
  FP_0474_Raindance: 15988,
  FP_0475_FoggyMist: 15989,
  FP_0476_LighthouseView: 15990,
  FP_0477_OceanCruise: 15991,
  FP_0478_SingingInTheRain: 15992,
  FP_0479_StairwayToHeaven: 15993,
  FP_0480_DeepSeaShadow: 15994,
  FP_0481_DreamCatcher: 15995,
  FP_0482_PowderedPool: 15996,
  FP_0483_Indulgence: 15997,
  FP_0484_StormyBay: 15998,
  FP_0485_NorthBeachBlue: 15999,
  FP_0486_ParadiseCity: 11090,
  FP_0487_DeepSpace: 11091,
  FP_0488_LunaLight: 16000,
  FP_0489_Whirlwind: 16001,
  FP_0490_BeaconFog: 11092,
  FP_0491_SmokyDay: 11093,
  FP_0492_PolarPond: 16002,
  FP_0493_Spacebox: 16003,
  FP_0494_DarkRiver: 11094,
  FP_0495_Breakwaters: 11095,
  FP_0496_CapeHope: 16004,
  FP_0497_RestfulRetreat: 11096,
  FP_0498_WonderLand: 16005,
  FP_0499_OceanMelody: 11097,
  FP_0500_BowmanBlue: 16006,
  FP_0501_CalmInterlude: 16007,
  FP_0502_OceanCrest: 16008,
  FP_0503_WaterDroplet: 16009,
  FP_0504_InTheBlue: 16010,
  FP_0505_InGoodTaste: 16011,
  FP_0506_OceanStorms: 16012,
  FP_0507_DeepLagoon: 11098,
  FP_0508_MidnightMagic: 16013,
  FP_0509_BerylPearl: 16014,
  FP_0510_SacredSpring: 11099,
  FP_0511_Cystern: 11100,
  FP_0512_OvercastDay: 16015,
  FP_0513_Backwater: 16016,
  FP_0514_Thunderstorm: 11101,
  FP_0515_SilentSea: 11102,
  FP_0516_DiamondStud: 16017,
  FP_0517_CoolElegance: 16018,
  FP_0518_LetItRain: 16019,
  FP_0519_BabySeal: 16020,
  FP_0520_SlateTint: 16021,
  FP_0521_DolphinDream: 16022,
  FP_0522_Octavius: 16023,
  FP_0523_Felicity: 11103,
  FP_0524_NomadicTravels: 16024,
  FP_0525_Marseilles: 11104,
  FP_0526_MetropolisMood: 16025,
  FP_0527_LondonRoad: 11105,
  FP_0528_Greybeard: 11337,
  FP_0529_BlackLicorice: 11106,
  FP_0530_Metro: 11107,
  FP_0531_Snowglory: 16026,
  FP_0532_RandMoon: 16027,
  FP_0533_Techile: 16028,
  FP_0534_SubtleShadow: 16029,
  FP_0535_ZenRetreat: 16030,
  FP_0536_Subway: 16031,
  FP_0537_DovesWing: 16032,
  FP_0538_Santo: 16033,
  FP_0539_PlaceOfDust: 11108,
  FP_0540_PraiseGiving: 11109,
  FP_0541_SmokyTone: 16034,
  FP_0542_CaptainNemo: 11110,
  FP_0543_NovemberStorms: 16035,
  FP_0544_VenetianWall: 16036,
  FP_0545_OldGreyMare: 16037,
  FP_0546_Paternoster: 11111,
  FP_0547_TinMan: 16038,
  FP_0548_JetGray: 16039,
  FP_0549_Emu: 16040,
  FP_0550_Gargoyle: 16041,
  FP_0551_OrchidShadow: 16042,
  FP_0552_NorthIsland: 16043,
  FP_0553_SmokyWings: 16044,
  FP_0554_Sparrow: 16045,
  FP_0555_OceanFrigate: 16046,
  FP_0556_Smokescreen: 16047,
  FP_0557_Evermore: 16048,
  FP_0558_QueenAnnesLace: 11112,
  FP_0559_AlwaysNeutral: 16049,
  FP_0560_Awakening: 11113,
  FP_0561_InTheHills: 16050,
  FP_0562_SultryCastle: 11114,
  FP_0563_Vigilant: 16051,
  FP_0564_BadHairDay: 16052,
  FP_0565_ElkSkin: 11115,
  FP_0566_Sheepskin: 16053,
  FP_0567_Hearthstone: 16054,
  FP_0568_CloudyToday: 16055,
  FP_0569_FireplaceMantel: 16056,
  FP_0570_GreyLocks: 16057,
  FP_0571_TerraPin: 16058,
  FP_0572_PowerLunch: 11116,
  FP_0573_Chintz: 16059,
  FP_0574_SharkFin: 11117,
  FP_0575_Greystoke: 16060,
  FP_0576_StormyWeather: 16061,
  FP_0577_KingFischer: 16062,
  FP_0578_PhilosophicallySpeaking: 16063,
  FP_0579_TurkishTower: 11118,
  FP_0580_RippledRock: 16064,
  FP_0581_Fossilized: 11119,
  FP_0582_PavedPath: 11120,
  FP_0583_BillowingSmoke: 16065,
  FP_0584_TornadoWind: 11121,
  FP_0585_OysterCatch: 11122,
  FP_0586_WindBlown: 16066,
  FP_0587_AtmosphericPressure: 16067,
  FP_0588_BabblingCreek: 16068,
  FP_0589_CelestialHorizon: 16069,
  FP_0590_MadonnaBlue: 16070,
  FP_0591_BlueJacket: 16071,
  FP_0592_QuietPeace: 16072,
  FP_0593_SurfsSurprise: 16073,
  FP_0594_SimplySparkling: 16074,
  FP_0595_SailIntoTheHorizon: 16075,
  FP_0596_LazyDay: 16076,
  FP_0597_HimalayaSky: 16077,
  FP_0598_CaribbeanCurrent: 16078,
  FP_0599_FloridaWaters: 11123,
  FP_0600_MeltingGlacier: 11124,
  FP_0601_CoolSky: 16079,
  FP_0602_FluidBlue: 16080,
  FP_0603_AngelaBay: 16081,
  FP_0604_BlueSkiesToday: 16082,
  FP_0605_CapriIsle: 16083,
  FP_0606_FrozenBlue: 16084,
  FP_0607_BrushBlue: 16085,
  FP_0608_ModernBlue: 16086,
  FP_0609_Innuendo: 16087,
  FP_0610_BlueParlor: 16088,
  FP_0611_BashfulBlue: 16089,
  FP_0612_Parkwater: 16090,
  FP_0613_BlueHighlight: 16091,
  FP_0614_SimpleSerenity: 16092,
  FP_0615_BlueBayou: 16093,
  FP_0616_Bluette: 16094,
  FP_0617_JohnsBlue: 16095,
  FP_0618_HeavenlySky: 16096,
  FP_0619_HonkyTonkBlue: 16097,
  FP_0620_StarStudded: 16098,
  FP_0621_Nuance: 16099,
  FP_0622_SereneSetting: 16100,
  FP_0623_PompeiiRuins: 16101,
  FP_0624_BluePot: 16102,
  FP_0625_NorthSea: 16103,
  FP_0626_BlueDepths: 16104,
  FP_0627_IntoTheStratosphere: 16105,
  FP_0628_IlluminatingExperience: 16106,
  FP_0629_PolishedCotton: 16107,
  FP_0630_StarMist: 16108,
  FP_0631_ChicagoSkyline: 16109,
  FP_0632_BreathTakingView: 16110,
  FP_0633_CapeCodBay: 11125,
  FP_0634_DaySpa: 16111,
  FP_0635_Aquafir: 16112,
  FP_0636_EmpressLila: 16113,
  FP_0637_MarzenaDream: 16114,
  FP_0638_WaterySea: 16115,
  FP_0639_AcapulcoDive: 16116,
  FP_0640_Skylla: 16117,
  FP_0641_DancingSea: 16118,
  FP_0642_SeaFoamMist: 16119,
  FP_0643_AbstractIdea: 16120,
  FP_0644_DancingInTheRain: 16121,
  FP_0645_CalmTint: 16122,
  FP_0646_KeyWestZenith: 16123,
  FP_0647_Zenith: 16124,
  FP_0648_HappyTune: 16125,
  FP_0649_DivineInspiration: 16126,
  FP_0650_BridgewaterBay: 16127,
  FP_0651_SoftBlue: 16128,
  FP_0652_MountainMain: 16129,
  FP_0653_SeaOfAtlantis: 16130,
  FP_0654_Peninsula: 16131,
  FP_0655_QueenOfTheNight: 16132,
  FP_0656_RomanWhite: 16133,
  FP_0657_Kyoto: 16134,
  FP_0658_OrleansTune: 16135,
  FP_0659_LastingThoughts: 16136,
  FP_0660_Epimethius: 16137,
  FP_0661_Charybdis: 16138,
  FP_0662_OceanSpray: 16139,
  FP_0663_FallingTears: 16140,
  FP_0664_ZirconIce: 16141,
  FP_0665_MonetMagic: 16142,
  FP_0666_TrishasEyes: 16143,
  FP_0667_BlessedBlue: 16144,
  FP_0668_WishUponAStar: 16145,
  FP_0669_FrozenStream: 16146,
  FP_0670_DriftingTide: 16147,
  FP_0671_EggBlue: 16148,
  FP_0672_QuietPond: 16149,
  FP_0673_EnchantedEvening: 16150,
  FP_0674_SarahsGarden: 16151,
  FP_0675_BlueBliss: 16152,
  FP_0676_JobsTears: 16153,
  FP_0677_EasternWind: 16154,
  FP_0678_LuxorBlue: 16155,
  FP_0679_Everest: 16156,
  FP_0680_AndesSky: 16157,
  FP_0681_CyanSky: 16158,
  FP_0682_PleasantStream: 16159,
  FP_0683_JoyfulTears: 16160,
  FP_0684_SnowDrift: 16161,
  FP_0685_DillardsBlue: 16162,
  FP_0686_Outerspace: 16163,
  FP_0687_Stillwater: 16164,
  FP_0688_ColdNorth: 16165,
  FP_0689_Atmosphere: 16166,
  FP_0690_BluePeriod: 16167,
  FP_0691_Paradise: 16168,
  FP_0692_BarelyAqua: 16169,
  FP_0693_IslandBreeze: 16170,
  FP_0694_TurkishTeal: 16171,
  FP_0695_IslandMoment: 16172,
  FP_0696_Meringue: 16173,
  FP_0697_ArizonaStone: 16174,
  FP_0698_CalmThoughts: 16175,
  FP_0699_LicketySplit: 16176,
  FP_0700_Uninhibited: 16177,
  FP_0701_Plunge: 16178,
  FP_0702_PegsPromise: 16179,
  FP_0703_MountainMeadows: 11126,
  FP_0704_Plateau: 16180,
  FP_0705_BayGreen: 16181,
  FP_0706_FilteredForest: 16182,
  FP_0707_ShimmeringGlade: 16183,
  FP_0708_CatarinaGreen: 16184,
  FP_0709_Calmness: 16185,
  FP_0710_OnTheNile: 16186,
  FP_0711_CutePixie: 16187,
  FP_0712_TealTreat: 16188,
  FP_0713_MediterraneanMist: 16189,
  FP_0714_TurquoiseTower: 16190,
  FP_0715_AquamarineOcean: 16191,
  FP_0716_BlueGreenScene: 16192,
  FP_0717_TropicalTale: 16193,
  FP_0718_Aquadazzle: 16194,
  FP_0719_MintGrasshopper: 16195,
  FP_0720_SilkyMint: 16196,
  FP_0721_LeavesOfSpring: 16197,
  FP_0722_Liliana: 16198,
  FP_0723_GoddessGreen: 16199,
  FP_0724_WildnessMint: 16200,
  FP_0725_Melbourne: 16201,
  FP_0726_HiddenJade: 16202,
  FP_0727_GracefulMint: 16203,
  FP_0728_CelticSpring: 16204,
  FP_0729_GardenGoddess: 16205,
  FP_0730_Lucerne: 16206,
  FP_0731_Aqueous: 16207,
  FP_0732_Tingle: 16208,
  FP_0733_LeafPrint: 16209,
  FP_0734_VineyardGreen: 16210,
  FP_0735_CoolSpring: 16211,
  FP_0736_MiniGreen: 16212,
  FP_0737_BuenosAires: 16213,
  FP_0738_SpringForest: 16214,
  FP_0739_JungleAdventure: 16215,
  FP_0740_JustAboutGreen: 16216,
  FP_0741_TurningLeaf: 16217,
  FP_0742_IsleOfDreams: 16218,
  FP_0743_BelladonnasLeaf: 16219,
  FP_0744_HiddenGlade: 16220,
  FP_0745_ChicShade: 16221,
  FP_0746_MotherNature: 16222,
  FP_0747_Whitewash: 16223,
  FP_0748_Balance: 16224,
  FP_0749_Perspective: 16225,
  FP_0750_WispyMint: 16226,
  FP_0751_GreenGlass: 16227,
  FP_0752_CactusValley: 16228,
  FP_0753_BabyVegetable: 16229,
  FP_0754_ColleenGreen: 16230,
  FP_0755_CreamyMint: 16231,
  FP_0756_MeadowGrass: 16232,
  FP_0757_GarlandPine: 16233,
  FP_0758_Glendale: 16234,
  FP_0759_PerennialGarden: 16235,
  FP_0760_GreenKnoll: 16236,
  FP_0761_MaisonVerte: 16237,
  FP_0762_GreenSong: 16238,
  FP_0763_GracefulFlower: 16239,
  FP_0764_GreenSheen: 16240,
  FP_0765_Sweetness: 16241,
  FP_0766_GentleCaress: 16242,
  FP_0767_GolfDay: 16243,
  FP_0768_RestfulRain: 16244,
  FP_0769_EarthHappiness: 16245,
  FP_0770_WoodlandNymph: 16246,
  FP_0771_GreenLime: 16247,
  FP_0772_WonderWoods: 16248,
  FP_0773_GlassBottle: 16249,
  FP_0774_GreenGoneWild: 16250,
  FP_0775_ElfinMagic: 16251,
  FP_0776_GreenMist: 16252,
  FP_0777_Envy: 16253,
  FP_0778_VacationIsland: 16254,
  FP_0779_FrogGreen: 16255,
  FP_0780_Hyper: 16256,
  FP_0781_ScienceExperiment: 16257,
  FP_0782_TenderShoot: 16258,
  FP_0783_CleanAir: 16259,
  FP_0784_FreshStart: 16260,
  FP_0785_MistyValley: 16261,
  FP_0786_PeterPan: 16262,
  FP_0787_TotallyCool: 16263,
  FP_0788_GreenGlow: 16264,
  FP_0789_GardenSeat: 16265,
  FP_0790_ForestFound: 16266,
  FP_0791_Origin: 16267,
  FP_0792_FootiePajamas: 16268,
  FP_0793_Motherland: 16269,
  FP_0794_TheGoods: 16270,
  FP_0795_MartinaOlive: 16271,
  FP_0796_Spotlight: 16272,
  FP_0797_BermudaSon: 16273,
  FP_0798_LemonAppeal: 16274,
  FP_0799_FireDance: 16275,
  FP_0800_YellowUmbrella: 16276,
  FP_0801_RainSlicker: 16277,
  FP_0802_RainBoots: 16278,
  FP_0803_PerkyTint: 16279,
  FP_0804_SweetiePie: 16280,
  FP_0805_MellaYella: 16281,
  FP_0806_SweetAngelica: 16282,
  FP_0807_BrightIdea: 16283,
  FP_0808_YellowLupine: 16284,
  FP_0809_HairRibbon: 16285,
  FP_0810_Annabel: 16286,
  FP_0811_Martica: 16287,
  FP_0812_GoldStrand: 16288,
  FP_0813_Glistening: 16289,
  FP_0814_GoldenGlow: 16290,
  FP_0815_LemonSurprise: 16291,
  FP_0816_SinCity: 16292,
  FP_0817_BestOfSummer: 16293,
  FP_0818_DayAtTheZoo: 16294,
  FP_0819_LemonTint: 16295,
  FP_0820_SignOfTheCrown: 11127,
  FP_0821_SunTouched: 16296,
  FP_0822_SunnyMood: 16297,
  FP_0823_SunDrops: 16298,
  FP_0824_Hush: 16299,
  FP_0825_FrozenBanana: 16300,
  FP_0826_BananaCustard: 16301,
  FP_0827_RayOfLight: 16302,
  FP_0828_GoGoGlow: 16303,
  FP_0829_DandyLion: 16304,
  FP_0830_WarmFuzzies: 16305,
  FP_0831_LavishLemon: 16306,
  FP_0832_LemonSpongeCake: 16307,
  FP_0833_SceneStealer: 16308,
  FP_0834_LemonDrizzle: 16309,
  FP_0835_GlitterYellow: 16310,
  FP_0836_BasketOfGold: 16311,
  FP_0837_FreshScent: 16312,
  FP_0838_FreshCream: 16313,
  FP_0839_Butterball: 16314,
  FP_0840_LemonZest: 16315,
  FP_0841_SunsGlory: 16316,
  FP_0842_Sunnyside: 16317,
  FP_0843_ButteredPopcorn: 16318,
  FP_0844_Yolk: 16319,
  FP_0845_LemonStick: 16320,
  FP_0846_PureLaughter: 16321,
  FP_0847_YellowBlitz: 16322,
  FP_0848_YellowTail: 16323,
  FP_0849_LemonPeel: 16324,
  FP_0850_Citron: 16325,
  FP_0851_HappyFace: 16326,
  FP_0852_TouchOfSun: 16327,
  FP_0853_LemonLilly: 16328,
  FP_0854_CrocusTint: 16329,
  FP_0855_ButterTart: 16330,
  FP_0856_BroadwayLights: 16331,
  FP_0857_Peeps: 16332,
  FP_0858_LookAtTheBrightSide: 16333,
  FP_0859_DaylillyYellow: 16334,
  FP_0860_HawaiianCream: 16335,
  FP_0861_LemonFilling: 16336,
  FP_0862_YellowTrumpet: 16337,
  FP_0863_ImALocal: 16338,
  FP_0864_Lioness: 16339,
  FP_0865_LemonBar: 16340,
  FP_0866_AppleSauce: 16341,
  FP_0867_EggNoodle: 16342,
  FP_0868_Shortcake: 16343,
  FP_0869_FrozenFruit: 16344,
  FP_0870_LemonSlice: 16345,
  FP_0871_GoldFinch: 16346,
  FP_0872_SaffronValley: 16347,
  FP_0873_WashedInLight: 16348,
  FP_0874_KettleCorn: 16349,
  FP_0875_NothingLess: 16350,
  FP_0876_CornChowder: 16351,
  FP_0877_GoldDigger: 16352,
  FP_0878_GloriousGold: 16353,
  FP_0879_GoldenCadillac: 16354,
  FP_0880_CauliflowerCream: 16355,
  FP_0881_GoldenSyrup: 16356,
  FP_0882_Marzipan: 16357,
  FP_0883_FollowTheLeader: 16358,
  FP_0884_GoldTweed: 16359,
  FP_0885_JungleExpedition: 16360,
  FP_0886_GoldEstate: 16361,
  FP_0887_Haystack: 16362,
  FP_0888_GoldenWeave: 16363,
  FP_0889_RusseauGold: 16364,
  FP_0890_Dubloon: 16365,
  FP_0891_SilenceIsGolden: 16366,
  FP_0892_GoldRansom: 16367,
  FP_0893_RichAndRare: 16368,
  FP_0894_MistyMustard: 16369,
  FP_0895_RotundaGold: 16370,
  FP_0896_CoinPurse: 16371,
  FP_0897_BagOfGold: 16372,
  FP_0898_GobyDesert: 16373,
  FP_0899_BugleBoy: 16374,
  FP_0900_UnforgettablyGold: 16375,
  FP_0901_SpinningWheel: 16376,
  FP_0902_Soleil: 16377,
  FP_0903_DaintyFlower: 16378,
  FP_0904_SundayAfternoon: 16379,
  FP_0905_EgyptianGold: 16380,
  FP_0906_CatsEyeMarble: 16381,
  FP_0907_Millionaire: 16382,
  FP_0908_GodGiven: 16383,
  FP_0909_AutumnChild: 16384,
  FP_0910_WesternSky: 16385,
  FP_0911_SunsetInItaly: 16386,
  FP_0912_TropicalDream: 16387,
  FP_0913_AngelFoodCake: 16388,
  FP_0914_ChildOfTheMoon: 16389,
  FP_0915_QueenlyLaugh: 16390,
  FP_0916_HoneyCream: 16391,
  FP_0917_CanyonSand: 16392,
  FP_0918_GoodLooking: 16393,
  FP_0919_VeniceSquare: 16394,
  FP_0920_SunriseHeat: 16395,
  FP_0921_WaxenMoon: 16396,
  FP_0922_Cheesecake: 16397,
  FP_0923_TiffanyLight: 16398,
  FP_0924_FirstDayOfSchool: 16399,
  FP_0925_JonquilTrail: 16400,
  FP_0926_PerkyYellow: 16401,
  FP_0927_LemonPoppy: 16402,
  FP_0928_YellowWarning: 16403,
  FP_0929_YellowBonnet: 16404,
  FP_0930_MarshmallowFluff: 16405,
  FP_0931_LemonBubble: 16406,
  FP_0932_SunSplashed: 16407,
  FP_0933_SassyYellow: 16408,
  FP_0934_LemonEssence: 16409,
  FP_0935_YellowShout: 16410,
  FP_0936_Diantha: 16411,
  FP_0937_EggNog: 16412,
  FP_0938_PrimrosePath: 16413,
  FP_0939_BigBusYellow: 16414,
  FP_0940_GrilledCheese: 16415,
  FP_0941_GlowingLantern: 16416,
  FP_0942_LemonDream: 16417,
  FP_0943_PicturePerfect: 16418,
  FP_0944_SunriseGlow: 16419,
  FP_0945_TreasureSeeker: 16420,
  FP_0946_HotSpot: 16421,
  FP_0947_BrightHalo: 16422,
  FP_0948_BrightBubble: 16423,
  FP_0949_Frenzy: 16424,
  FP_0950_IvoryCoast: 16425,
  FP_0951_PoundCake: 16426,
  FP_0952_RichGlow: 16427,
  FP_0953_EveningStar: 16428,
  FP_0954_MacNCheese: 16429,
  FP_0955_LemonWhisper: 16430,
  FP_0956_ILoveToBoogie: 16431,
  FP_0957_PaleNarcissus: 16432,
  FP_0958_HolyGrail: 16433,
  FP_0959_EssentiallyBright: 16434,
  FP_0960_BreadNButter: 16435,
  FP_0961_GoldsGreatTouch: 16436,
  FP_0962_PiecesOfEight: 16437,
  FP_0963_Zambia: 16438,
  FP_0964_CapetownCream: 16439,
  FP_0965_GoldOfMidas: 16440,
  FP_0966_Starburst: 16441,
  FP_0967_Endearment: 16442,
  FP_0968_MangoMadness: 16443,
  FP_0969_AuGratin: 16444,
  FP_0970_OrangeYouHappy: 16445,
  FP_0971_MaySun: 16446,
  FP_0972_AppleCider: 16447,
  FP_0973_AtollSand: 16448,
  FP_0974_Goosebill: 16449,
  FP_0975_DownyFeather: 16450,
  FP_0976_CocktailHour: 16451,
  FP_0977_CheddarCheese: 16452,
  FP_0978_CityOfDiamonds: 16453,
  FP_0979_Liveliness: 16454,
  FP_0980_SouthernBreeze: 16455,
  FP_0981_TuscanWall: 16456,
  FP_0982_TasteOfSummer: 16457,
  FP_0983_Japonica: 16458,
  FP_0984_MexicanSpirit: 16459,
  FP_0985_Whiskers: 16460,
  FP_0986_MineralGlow: 16461,
  FP_0987_Tallow: 16462,
  FP_0988_MomsApplePie: 16463,
  FP_0989_Impulse: 16464,
  FP_0990_ButterscotchGlaze: 16465,
  FP_0991_BeeswaxCandle: 16466,
  FP_0992_TouchOfTopaz: 16467,
  FP_0993_IncanTreasure: 16468,
  FP_0994_SparkleGlow: 16469,
  FP_0995_BreadPudding: 16470,
  FP_0996_SpiceCookie: 16471,
  FP_0997_GatesOfGold: 16472,
  FP_0998_GoldMetal: 16473,
  FP_0999_IvoryTassel: 16474,
  FP_1000_FlowerOfOahu: 16475,
  FP_1001_CheddarCorn: 16476,
  FP_1002_TeaCookie: 16477,
  FP_1003_SweetSue: 16478,
  FP_1004_PeaceOfMind: 16479,
  FP_1005_FlickeringFlame: 16480,
  FP_1006_Turkscap: 16481,
  FP_1007_PastelPeach: 16482,
  FP_1008_MangoTango: 16483,
  FP_1009_BedtimeStory: 16484,
  FP_1010_PeanutBrittle: 16485,
  FP_1011_Semolina: 16486,
  FP_1012_HamptonBeach: 16487,
  FP_1013_WarmBread: 16488,
  FP_1014_MuffinMagic: 16489,
  FP_1015_CanterPeach: 16490,
  FP_1016_NovemberLeaf: 16491,
  FP_1017_SummersEnd: 16492,
  FP_1018_SunnyHorizon: 16493,
  FP_1019_OrangeBallad: 16494,
  FP_1020_RapturesLight: 16495,
  FP_1021_SweetButtermilk: 16496,
  FP_1022_DelicateDawn: 16497,
  FP_1023_MellowGlow: 16498,
  FP_1024_PumpkinHue: 16499,
  FP_1025_HeatOfSummer: 16500,
  FP_1026_CasaDeOro: 16501,
  FP_1027_AbstractWhite: 16502,
  FP_1028_Verve: 16503,
  FP_1029_PaleBlossom: 16504,
  FP_1030_WispyWhite: 16505,
  FP_1031_Chickadee: 16506,
  FP_1032_BoredomBuster: 16507,
  FP_1033_LavaLamp: 16508,
  FP_1034_AutumnWind: 16509,
  FP_1035_SpicedCider: 16510,
  FP_1036_ApricotSpring: 16511,
  FP_1037_TrumpetFlower: 11128,
  FP_1038_JackOLantern: 16512,
  FP_1039_PrettyParasol: 11129,
  FP_1040_DarkMarmalade: 16513,
  FP_1041_Flowerbed: 16514,
  FP_1042_PeakSeason: 16515,
  FP_1043_MomsLove: 16516,
  FP_1044_ShootingStar: 16517,
  FP_1045_CreamyOrangeBlush: 16518,
  FP_1046_BalletCream: 16519,
  FP_1047_Starfish: 16520,
  FP_1048_PaleShrimp: 16521,
  FP_1049_SalmonMousse: 16522,
  FP_1050_SalmonBeauty: 16523,
  FP_1051_StuccoWall: 16524,
  FP_1052_SummerMemory: 16525,
  FP_1053_SunsRage: 16526,
  FP_1054_CarrotCake: 16527,
  FP_1055_WhiteMeadow: 16528,
  FP_1056_ElizabethRose: 16529,
  FP_1057_PinkSatin: 16530,
  FP_1058_PaleTerra: 16531,
  FP_1059_AlexandraPeach: 16532,
  FP_1060_FirstLady: 16533,
  FP_1061_AprilLove: 16534,
  FP_1062_Albino: 16535,
  FP_1063_TinyPink: 16536,
  FP_1064_MysticTulip: 16537,
  FP_1065_RoseEssence: 16538,
  FP_1066_Sari: 16539,
  FP_1067_SweetBabyRose: 16540,
  FP_1068_BestOfTheBunch: 16541,
  FP_1069_PinkTouch: 16542,
  FP_1070_PeonyPrize: 16543,
  FP_1071_CloudNumberNine: 16544,
  FP_1072_LustyOrange: 16545,
  FP_1073_GracefulBallerina: 16546,
  FP_1074_ItsMyParty: 16547,
  FP_1075_CherryBlink: 16548,
  FP_1076_BabyBlossom: 16549,
  FP_1077_LadyAnne: 16550,
  FP_1078_AromaticBreeze: 16551,
  FP_1079_WildflowerBouquet: 16552,
  FP_1080_CherishedOne: 16553,
  FP_1081_EndlessPossibilities: 16554,
  FP_1082_TropicalHeat: 16555,
  FP_1083_MorningBlush: 16556,
  FP_1084_GoGoPink: 16557,
  FP_1085_TintOfRose: 16558,
  FP_1086_Nosegay: 16559,
  FP_1087_BayCoral: 16560,
  FP_1088_ChildhoodCrush: 16561,
  FP_1089_Chuckles: 16562,
  FP_1090_Tartlet: 16563,
  FP_1091_AllDressedUp: 16564,
  FP_1092_PetalsUnfolding: 16565,
  FP_1093_WoodNymph: 16566,
  FP_1094_PorcelainRose: 16567,
  FP_1095_Empower: 16568,
  FP_1096_TheEgoHasLanded: 16569,
  FP_1097_PalePetunia: 16570,
  FP_1098_BubblegumPink: 16571,
  FP_1099_Dimple: 16572,
  FP_1100_HeartToHeart: 16573,
  FP_1101_MullenPink: 16574,
  FP_1102_PreciousPeony: 16575,
  FP_1103_Moonrose: 16576,
  FP_1104_Valerie: 16577,
  FP_1105_ItsAGirl: 16578,
  FP_1106_GardenGlory: 16579,
  FP_1107_BunnyFluff: 16580,
  FP_1108_PinkExplosion: 16581,
  FP_1109_PartyTime: 16582,
  FP_1110_UnmatchedBeauty: 16583,
  FP_1111_RoyalWedding: 16584,
  FP_1112_WishfulThinking: 16585,
  FP_1113_Fruitbowl: 16586,
  FP_1114_ALotOfLove: 16587,
  FP_1115_Dollie: 16588,
  FP_1116_MovieStar: 16589,
  FP_1117_Siren: 16590,
  FP_1118_CottonCandy: 16591,
  FP_1119_SweetPea: 16592,
  FP_1120_SummerCosmos: 16593,
  FP_1121_DahliaDelight: 16594,
  FP_1122_RoseMallow: 16595,
  FP_1123_Groovy: 16596,
  FP_1124_VelvetCake: 16597,
  FP_1125_Hepatica: 16598,
  FP_1126_SeashellPink: 16599,
  FP_1127_Pepto: 16600,
  FP_1128_Minuette: 16601,
  FP_1129_PunkyPink: 16602,
  FP_1130_Obsession: 16603,
  FP_1131_CanCan: 16604,
  FP_1132_SullivansHeart: 16605,
  FP_1133_ChristysSmile: 16606,
  FP_1134_PegeenPeony: 16607,
  FP_1135_Glam: 16608,
  FP_1136_Romp: 16609,
  FP_1137_OdeToJoy: 16610,
  FP_1138_RomanticNight: 16611,
  FP_1139_Tutu: 16612,
  FP_1140_FirstDaughter: 16613,
  FP_1141_DecoPink: 16614,
  FP_1142_VintageVictorian: 16615,
  FP_1143_RamblingRose: 16616,
  FP_1144_Temptress: 16617,
  FP_1145_RomeoORomeo: 16618,
  FP_1146_MorningShine: 16619,
  FP_1147_Columbine: 16620,
  FP_1148_PersianDelight: 16621,
  FP_1149_ParrotTulip: 16622,
  FP_1150_PinkBeauty: 16623,
  FP_1151_FusciaFizz: 16624,
  FP_1152_BerryPatch: 16625,
  FP_1153_ViennaDawn: 16626,
  FP_1154_Viola: 16627,
  FP_1155_LittleSmile: 16628,
  FP_1156_PinkHeath: 16629,
  FP_1157_BlossomsInSpring: 16630,
  FP_1158_PurpleHollyhock: 16631,
  FP_1159_Bridesmaid: 16632,
  FP_1160_PetalPoise: 16633,
  FP_1161_NurseryPink: 16634,
  FP_1162_VenetianRose: 16635,
  FP_1163_TiaraPink: 16636,
  FP_1164_CarnationRose: 16637,
  FP_1165_PinkParade: 16638,
  FP_1166_NobleHonor: 16639,
  FP_1167_DreamState: 16640,
  FP_1168_MarvelousMagic: 16641,
  FP_1169_BabyGirl: 16642,
  FP_1170_LavenderQuartz: 16643,
  FP_1171_TeenQueen: 16644,
  FP_1172_Immortality: 16645,
  FP_1173_PurpleStiletto: 16646,
  FP_1174_LittlePinky: 16647,
  FP_1175_TaffetaTint: 16648,
  FP_1176_PoodlePink: 16649,
  FP_1177_RosyCheeks: 16650,
  FP_1178_RoseSouvenir: 16651,
  FP_1179_MoonlightMelody: 16652,
  FP_1180_BerryLight: 16653,
  FP_1181_VioletAsh: 16654,
  FP_1182_LilacsInSpring: 16655,
  FP_1183_RomanticBallad: 16656,
  FP_1184_GracefulGarden: 16657,
  FP_1185_SatinFlower: 16658,
  FP_1186_PleasantDream: 16659,
  FP_1187_JoyousSong: 16660,
  FP_1188_MaidenOfTheMist: 16661,
  FP_1189_LittleTouch: 16662,
  FP_1190_GlitteringGemstone: 16663,
  FP_1191_CherishTheMoment: 16664,
  FP_1192_CutVelvet: 16665,
  FP_1193_CrownJewels: 16666,
  FP_1194_MagentaRedLips: 16667,
  FP_1195_RosiePosie: 16668,
  FP_1196_NaughtyMarietta: 16669,
  FP_1197_LavenderVeil: 16670,
  FP_1198_HeatherFeather: 16671,
  FP_1199_EnthronedAbove: 16672,
  FP_1200_Felicia: 16673,
  FP_1201_DreamyHeaven: 16674,
  FP_1202_DaringDeception: 16675,
  FP_1203_Etcetera: 16676,
  FP_1204_Noteworthy: 16677,
  FP_1205_FashionablyPlum: 16678,
  FP_1206_ScreenGem: 16679,
  FP_1207_OrchidOrchestra: 16680,
  FP_1208_CrowdPleaser: 16681,
  FP_1209_PrincessIrene: 16682,
  FP_1210_FrenchLavender: 16683,
  FP_1211_LavenderBlessing: 16684,
  FP_1212_PansyPosie: 16685,
  FP_1213_BerryBright: 16686,
  FP_1214_MajesticPlum: 16687,
  FP_1215_PurpleShadow: 16688,
  FP_1216_Aimee: 16689,
  FP_1217_VelvetBlush: 16690,
  FP_1218_OdysseyLilac: 16691,
  FP_1219_Desiree: 16692,
  FP_1220_PlayTime: 16693,
  FP_1221_CharmingViolet: 16694,
  FP_1222_GrapeSoda: 16695,
  FP_1223_OstrichTail: 16696,
  FP_1224_FragrantSnowbell: 16697,
  FP_1225_Velour: 16698,
  FP_1226_ImagineThat: 16699,
  FP_1227_VividVision: 16700,
  FP_1228_PetuniaPatty: 16701,
  FP_1229_EleanorAnn: 11130,
  FP_1230_CrescentMoon: 16702,
  FP_1231_HostaFlower: 16703,
  FP_1232_FlowersOfMay: 16704,
  FP_1233_PlumCake: 16705,
  FP_1234_GrapesTreasure: 16706,
  FP_1235_Yolanda: 16707,
  FP_1236_SunsetSerenade: 16708,
  FP_1237_EasterBunny: 16709,
  FP_1238_Fairytale: 16710,
  FP_1239_PlumsTheWord: 16711,
  FP_1240_DriftingDream: 16712,
  FP_1241_GrapeIllusion: 16713,
  FP_1242_GorgeousHydrangea: 16714,
  FP_1243_WhenRedMetBlue: 16715,
  FP_1244_WhiteBud: 16716,
  FP_1245_Perfection: 16717,
  FP_1246_PurplePurity: 16718,
  FP_1247_MayMist: 16719,
  FP_1248_VelvetCrest: 16720,
  FP_1249_PurpleSpire: 16721,
  FP_1250_TrueRomance: 16722,
  FP_1251_MountainsMajesty: 16723,
  FP_1252_LavenderBliss: 16724,
  FP_1253_PetuniaTrail: 16725,
  FP_1254_PurpleVision: 16726,
  FP_1255_PurpleHaze: 16727,
  FP_1256_PlumPreserve: 16728,
  FP_1257_Voldemort: 16729,
  FP_1258_SweetFlower: 16730,
  FP_1259_Eyeshadow: 16731,
  FP_1260_PrettyPosie: 16732,
  FP_1261_ChildishWonder: 16733,
  FP_1262_BaileyBells: 16734,
  FP_1263_Medieval: 16735,
  FP_1264_AltarOfHeaven: 16736,
  FP_1265_WhiteShoulders: 16737,
  FP_1266_Penelope: 16738,
  FP_1267_CasaDelMar: 16739,
  FP_1268_SpoiledRotten: 16740,
  FP_1269_MoodMode: 16741,
  FP_1270_WindStar: 16742,
  FP_1271_HotSauna: 16743,
  FP_1272_AngelKiss: 16744,
  FP_1273_WildflowerPrairie: 16745,
  FP_1274_Genevieve: 16746,
  FP_1275_HighStyle: 16747,
  FP_1276_VelvetRobe: 16748,
  FP_1277_RegalAzure: 16749,
  FP_1278_FreshTake: 16750,
  FP_1279_HeLovesMe: 16751,
  FP_1280_LilacLuster: 16752,
  FP_1281_Collensia: 16753,
  FP_1282_ButterflyBush: 16754,
  FP_1283_LavenderSpectacle: 16755,
  FP_1284_GrapesOfWrath: 16756,
  FP_1285_Jazlyn: 16757,
  FP_1286_LavenderPizzazz: 16758,
  FP_1287_OrchidFragrance: 16759,
  FP_1288_VioletCrush: 16760,
  FP_1289_LilacBlossom: 16761,
  FP_1290_VioletVibes: 16762,
  FP_1291_DancingInTheSpring: 16763,
  FP_1292_PlumPerfect: 16764,
  FP_1293_VioletPearl: 16765,
  FP_1294_LavenderScent: 16766,
  FP_1295_GypsyCaravan: 16767,
  FP_1296_VioletBeauty: 16768,
  FP_1297_RoyalProclamation: 16769,
  FP_1298_QueenOfSheba: 16770,
  FP_1299_SoulTrain: 16771,
  FP_1300_WingedVictory: 16772,
  FP_1301_LavenderBikini: 16773,
  FP_1302_HeatherHill: 16774,
  FP_1303_CutHeather: 16775,
  FP_1304_IcedOrchid: 16776,
  FP_1305_VictorianViolet: 16777,
  FP_1306_RoyalVelvet: 16778,
  FP_1307_Clytemnestra: 16779,
  FP_1308_StardustBallroom: 16780,
  FP_1309_SoDainty: 16781,
  FP_1310_VelvetDawn: 16782,
  FP_1311_GypsysGown: 16783,
  FP_1312_SouthernBelle: 16784,
  FP_1313_MyPlaceOrYours: 16785,
  FP_1314_DesiredDawn: 16786,
  FP_1315_Calamities: 16787,
  FP_1316_Savoy: 16788,
  FP_1317_BuffedPlum: 16789,
  FP_1318_DuskyMood: 16790,
  FP_1319_Overlook: 16791,
  FP_1320_Blackwater: 16792,
  FP_BenningtonGray: 11131,
  FP_Black: 11132,
  FP_DoveWing: 11133,
  FP_GreyCloud: 11134,
  FP_NavajoWhite: 11135,
  FP_R001_SlightlyHued: 11136,
  FP_R002_TipOfTheIceberg: 11137,
  FP_R003_SkiersView: 11138,
  FP_R004_GreekPebbles: 16793,
  FP_R005_FreshenedUp: 11139,
  FP_R006_SoftGreige: 16794,
  FP_R007_TintedOrNot: 16795,
  FP_R008_SnowWhite: 11140,
  FP_R009_ZeaFlour: 16796,
  FP_R010_Blurred: 16797,
  FP_R011_WhitePepper: 11141,
  FP_R012_Mushroom: 16798,
  FP_R013_EtherealMist: 16799,
  FP_R014_Enigma: 16800,
  FP_R015_EveningTraveller: 16801,
  FP_R016_GloomyWeather: 16802,
  FP_R017_MidnightWanderer: 16803,
  FP_R018_CoalBlack: 11142,
  FP_R019_SilverLining: 16804,
  FP_R020_OnTheRoad: 11143,
  FP_R021_Lapilli: 16805,
  FP_R022_InTheDark: 11338,
  FP_R023_SpaceDive: 11144,
  FP_R024_AmbiguousBlack: 16806,
  FP_R025_RiverPebbleGray: 16807,
  FP_R026_StoneFence: 16808,
  FP_R027_WinterWood: 16809,
  FP_R028_CountryMarket: 16810,
  FP_R029_BarnRafter: 16811,
  FP_R030_ChocolateBark: 16812,
  FP_R031_UrbanCalm: 16813,
  FP_R032_LimestoneCoping: 16814,
  FP_R033_TumbledTravertine: 16815,
  FP_R034_WhiskeyBarrel: 11145,
  FP_R035_LeatherOttoman: 16816,
  FP_R036_CaffeAmericana: 11146,
  FP_R037_ClassicParchment: 16817,
  FP_R038_StonewareClay: 16818,
  FP_R039_SoftMapleWood: 16819,
  FP_R040_GardenChalet: 16820,
  FP_R041_RusticTimber: 16821,
  FP_R042_LeatherPanel: 16822,
  FP_R043_CoastalDriftwood: 16823,
  FP_R044_ChiseledShale: 16824,
  FP_R045_AgedCedar: 11147,
  FP_R046_VintageShutter: 16825,
  FP_R047_BronzeLantern: 16826,
  FP_R048_GardenMoss: 16827,
  FP_R049_Luna: 16828,
  FP_R050_HeatheredHerb: 16829,
  FP_R051_Aberdeen: 16830,
  FP_R052_DurumWheat: 11148,
  FP_R053_Bronzite: 16831,
  FP_R054_Handcrafted: 16832,
  FP_R055_Glacier: 11149,
  FP_R056_LambsEar: 16833,
  FP_R057_BuriedFossil: 16834,
  FP_R058_Verde: 16835,
  FP_R059_ForestWalk: 16836,
  FP_R060_Trillion: 16837,
  FP_R061_SilverShine: 11150,
  FP_R062_SoftSeaGlass: 16838,
  FP_R063_Foliage: 16839,
  FP_R064_MossyDriftwood: 16840,
  FP_R065_Haven: 16841,
  FP_R066_Foundation: 16842,
  FP_R067_IceBreaker: 16843,
  FP_R068_SecretArbor: 16844,
  FP_R069_OnTheRocks: 11151,
  FP_R070_Artifact: 11152,
  FP_R071_FallenFir: 11153,
  FP_R072_RavenGrass: 11154,
  FP_R073_DuskCloud: 11155,
  FP_R074_DriedHydrangea: 11156,
  FP_R075_ShadyPier: 11157,
  FP_R076_FreshWater: 11158,
  FP_R077_StellarFeather: 16845,
  FP_R078_LagoonLullaby: 11159,
  FP_R079_WinterAir: 11160,
  FP_R080_SilverLake: 16846,
  FP_R081_WhaleMigration: 11161,
  FP_R082_SpruceShadow: 11162,
  FP_R083_ShallowMoon: 16847,
  FP_R084_BedtimeBlue: 16848,
  FP_R085_DreamWhisper: 16849,
  FP_R086_ShimmeringWave: 16850,
  FP_R087_SheerClouds: 16851,
  FP_R088_EveningTide: 16852,
  FP_R089_DeepPlunge: 16853,
  FP_R090_DarkAges: 11163,
  FP_R091_StillPool: 16854,
  FP_R092_Ebb: 11164,
  FP_R093_FleetingDaylight: 16855,
  FP_R094_DecemberSky: 16856,
  FP_R095_MidnightSurf: 11165,
  FP_R096_IndigoLeaves: 16857,
  FP_R097_Kefi: 16858,
  FP_R098_Duende: 16859,
  FP_R099_Wanderlust: 16860,
  FP_R100_WabiSabi: 11166,
  FP_R101_DeepWell: 11167,
  FP_R102_Chance: 11168,
  FP_R103_OnceUponATime: 16861,
  FP_R104_WildAndFree: 16862,
  FP_R105_MoodyHue: 16863,
  FP_R106_Violaceous: 11169,
  FP_R107_AvantGothic: 16864,
  FP_R108_Meraki: 16865,
  FP_R109_Hygge: 16866,
  FP_R110_Bohemia: 16867,
  FP_R111_Exquisite: 16868,
  FP_R112_DuskTilDawn: 16869,
  FP_R113_Bombastic: 16870,
  FP_R114_Mulberry: 11170,
  FP_R115_HueIsTheArtist: 16871,
  FP_R116_Reimagined: 16872,
  FP_R117_Essence: 16873,
  FP_R118_Hypnotic: 16874,
  FP_R119_AfterParty: 11171,
  FP_R120_MissionFig: 11172,
  FP_R121_PointeShoes: 16875,
  FP_R122_KindKiss: 16876,
  FP_R123_RedAgave: 16877,
  FP_R124_ArdentRed: 16878,
  FP_R125_AppleOfGrenada: 16879,
  FP_R126_RumCherry: 16880,
  FP_R127_VanillaSoy: 16881,
  FP_R128_ChickpeaPlease: 16882,
  FP_R129_Unity: 16883,
  FP_R130_ChocolateOpal: 16884,
  FP_R131_MoscowMule: 16885,
  FP_R132_TannicTea: 16886,
  FP_ShadowGray: 11173,
  FP_StoneHarbor: 11174,
};

const DMC_FoundrySiding = {
  Foundry_ArizonaClay_891: 4600,
  Foundry_Cocoa_248: 4601,
  Foundry_ColonialGrey_837: 4602,
  Foundry_DeepGranite_692: 4603,
  Foundry_Denim_888: 4604,
  Foundry_EasternGrey_258: 4605,
  Foundry_Eggshell_034: 4606,
  Foundry_ForestGreen_152: 4607,
  Foundry_GoldenStraw_816: 4608,
  Foundry_GraySkies_907: 4609,
  Foundry_HarvestWheat_832: 4610,
  Foundry_Ironstone_672: 4611,
  Foundry_LightMoss_112: 4612,
  Foundry_LiteKhaki_095: 4613,
  Foundry_MarineBlue_908: 4614,
  Foundry_MidnightCloud_889: 4615,
  Foundry_ModernSlate_941: 4616,
  Foundry_Moonlight_017: 4617,
  Foundry_MoonRock_836: 4618,
  Foundry_MusketBrown_594: 4619,
  Foundry_Oatmeal_069: 4620,
  Foundry_Oceanside_202: 4621,
  Foundry_ReclaimedCedar_890: 4622,
  Foundry_RedCedar_844: 4623,
  Foundry_Russet_278: 4624,
  Foundry_RusticBrown_838: 4625,
  Foundry_RusticCedar_819: 4626,
  Foundry_Sahara_048: 4627,
  Foundry_Sandalwood_831: 4628,
  Foundry_Shadow_008: 4629,
  Foundry_SmokeGrey_528: 4630,
  Foundry_Snow_123: 4631,
  Foundry_VanillaBean_814: 4632,
  Foundry_VintageTaupe_830: 4633,
};

const DMC_Garaga = {
  Garaga_Almond: 2615,
  Garaga_Black: 2616,
  Garaga_BlackIce: 2617,
  Garaga_Brown: 2618,
  Garaga_Charcoal: 2619,
  Garaga_Claystone: 2620,
  Garaga_DarkSand: 2621,
  Garaga_DesertSand: 2622,
  Garaga_Evergreen: 2623,
  Garaga_IceWhite: 2624,
  Garaga_MokaBrown: 2625,
  Garaga_Sahara: 2626,
  Garaga_Sandstone: 2627,
  Garaga_Terrastone: 2628,
  Garaga_White: 2629,
};

const DMC_Garage_Amarr = {
  Amarr_Almond: 6562,
  Amarr_Black: 6563,
  Amarr_CharcoalGray: 6564,
  Amarr_DarkBrown: 6565,
  Amarr_Sandtone: 6566,
  Amarr_Terratone: 6567,
  Amarr_TrueWhite: 6568,
  Amarr_WickerTan: 6569,
};

const DMC_Garage_Clopay = {
  Almond: 10475,
  Beige: 10476,
  Black: 10477,
  Bronze: 10478,
  Brown: 10479,
  Burgundy: 10480,
  Charcoal: 10582,
  ChocolateBrown: 10481,
  Clay: 10482,
  DesertTan: 10483,
  Gray: 10484,
  HunterGreen: 10485,
  MochaBrown: 11339,
  NavyBlue: 10486,
  NewEnglandBlue: 10487,
  RusticRed: 10488,
  Sandtone: 10489,
  Taupe: 10490,
  Vanilla: 10491,
  White: 10492,
};

const DMC_Garage_Colors = {
  GarageTaupe: 235,
  GarageWhite: 236,
  GarageWhiteMist: 1800,
};

const DMC_Garage_DoorLink = {
  Garage_DoorLink_Almond: 10870,
  Garage_DoorLink_Black: 10871,
  Garage_DoorLink_Gray: 10872,
  Garage_DoorLink_White: 10873,
};

const DMC_Garage_GeneralDoors = {
  Almond: 4643,
  ArticWhite: 4644,
  Black: 4645,
  Bronze: 4646,
  Brown: 4647,
  Cafe: 4648,
  DesertTan: 4649,
  Gray: 4650,
  Sandtone: 4651,
};

const DMC_Garage_Hormann = {
  Hormann_Almond: 6482,
  Hormann_Black: 6483,
  Hormann_Brown: 6484,
  Hormann_DesertTan: 6485,
  Hormann_HunterGreen: 6486,
  Hormann_Sandstone: 6487,
  Hormann_Teratone: 6488,
  Hormann_White: 6489,
};

const DMC_Garage_Martin = {
  Martin_Bronze: 10798,
  Martin_CarbonBlack: 10799,
  Martin_DarkBrown: 10800,
  Martin_DesertTaupe: 10801,
  Martin_LightAlmond: 10802,
  Martin_WhiteMist: 10803,
};

const DMC_Garage_OverheadDoor = {
  Overhead_Almond: 10661,
  Overhead_Black: 10662,
  Overhead_Brown: 10663,
  Overhead_DesertTan: 10664,
  Overhead_ForestGreen: 10665,
  Overhead_Gray: 10666,
  Overhead_Sandstone: 10667,
  Overhead_TerraBronze: 10668,
  Overhead_White: 10669,
};

const DMC_Garage_Windsor = {
  Windsor_Almond: 10956,
  Windsor_Black: 10957,
  Windsor_Brown: 10962,
  Windsor_DesertTan: 10963,
  Windsor_PolarWhite: 10958,
  Windsor_Sandstone: 10959,
  Windsor_SlateGray: 10964,
  Windsor_TerraBronze: 10965,
};

const DMC_GeorgiaPacific = {
  GP_Almond: 11176,
  GP_Beige: 26229,
  GP_Blue: 26230,
  GP_Clay: 26231,
  GP_ClayPlus: 11177,
  GP_Cream: 11178,
  GP_Flint: 26232,
  GP_Gray: 11179,
  GP_Mist: 11180,
  GP_MossGreen: 26233,
  GP_Olive: 11181,
  GP_Pearl: 11182,
  GP_Tan: 11183,
  GP_White: 11184,
};

const DMC_Glidden = {
  Glidden_00NN05000_OnyxBlack: 16887,
  Glidden_00NN07000_DeepOnyx: 16888,
  Glidden_00NN10000_GreyMetal: 16889,
  Glidden_00NN16000_GreyTabby: 16890,
  Glidden_00NN20000_ElegantCharcoal: 16891,
  Glidden_00NN25000_SealGrey: 16892,
  Glidden_00NN37000_GraniteGrey: 16893,
  Glidden_00NN53000_PebbleGrey: 16894,
  Glidden_00NN62000_UniversalGrey: 16895,
  Glidden_00NN72000_SnowfieldWhite: 16896,
  Glidden_00YR08409_RedDelicious: 16897,
  Glidden_00YR15510_CherryRed: 16898,
  Glidden_00YY07093_EarthBrown: 16899,
  Glidden_00YY09186_RichMocha: 16900,
  Glidden_00YY12173_BrownStudy: 16901,
  Glidden_00YY12279_WarmSpiceBrown: 16902,
  Glidden_00YY16201_NewBedfordBrown: 16903,
  Glidden_00YY19261_Goldstone: 16904,
  Glidden_00YY22241_CopperHaypenny: 16905,
  Glidden_00YY26220_GentleFawn: 16906,
  Glidden_00YY30200_SandyCove: 16907,
  Glidden_00YY35180_TantalizingTan: 16908,
  Glidden_00YY37221_OnionskinTan: 16909,
  Glidden_00YY40159_WorstedTan: 16910,
  Glidden_00YY43196_FamilyLegacyTan: 16911,
  Glidden_00YY48171_TanSuedeGloves: 16912,
  Glidden_00YY50306_Peachwood: 16913,
  Glidden_00YY52119_DesertSand: 16914,
  Glidden_00YY54146_CastawayShoreBeige: 16915,
  Glidden_00YY56173_AntiqueBisque: 16916,
  Glidden_00YY59098_PinkBeige: 16917,
  Glidden_00YY62144_TeaHoney: 16918,
  Glidden_00YY62255_GlazedPeach: 16919,
  Glidden_00YY63024_CanyonEcho: 16920,
  Glidden_00YY65189_VenusStar: 16921,
  Glidden_00YY67212_OrangePekoe: 16922,
  Glidden_00YY71150_PavilionPeach: 16923,
  Glidden_01BB69098_EverclearBlue: 16924,
  Glidden_02RB53171_LilacBouquet: 16925,
  Glidden_02YY55518_JuicyCantaloupe: 16926,
  Glidden_03RB42220_NightMagicViolet: 16927,
  Glidden_03RB63122_IcedPurple: 16928,
  Glidden_04BB22402_ClipperShipBlue: 16929,
  Glidden_04BB57189_TranquilBlue: 16930,
  Glidden_04RB71082_AmethystIce: 16931,
  Glidden_04YY51583_EgyptianSun: 16932,
  Glidden_05YR15555_PoinsettiaRed: 16933,
  Glidden_05YY42727_MarigoldPetals: 16934,
  Glidden_05YY72254_OrangeBlossom: 16935,
  Glidden_06RB76056_VioletTinge: 16936,
  Glidden_07YR10489_RaptureRed: 16937,
  Glidden_08YY56528_SummerLilyOrange: 16938,
  Glidden_09BB51218_BlueCollar: 16939,
  Glidden_09YR05305_ClassicBurgundy: 16940,
  Glidden_10BB07150_DeepArcticNightBlue: 16941,
  Glidden_10BB11126_AmericasCupNavy: 16942,
  Glidden_10BB18106_MountainSlateBlue: 16943,
  Glidden_10BB22096_ShadyBlue: 16944,
  Glidden_10BB25193_RomanceBlue: 16945,
  Glidden_10BB30203_GinghamBlue: 16946,
  Glidden_10BB34103_EnchantedEveningBlue: 16947,
  Glidden_10BB40090_OxfordBlue: 16948,
  Glidden_10BB42159_ParisSkyBlue: 16949,
  Glidden_10BB43206_HorizonBlue: 16950,
  Glidden_10BB47077_SilverNightBlue: 16951,
  Glidden_10BB50177_AristocraticBlue: 16952,
  Glidden_10BB55065_FadedDenim: 16953,
  Glidden_10BB64052_SilverBluePearl: 16954,
  Glidden_10BB66121_BonnieBlueEyes: 16955,
  Glidden_10BB73026_CloudMotifGrey: 16956,
  Glidden_10BB73045_IcyWaterfall: 16957,
  Glidden_10BB83014_DriftingSnow: 16958,
  Glidden_10BB83017_NovaWhite: 16959,
  Glidden_10BB83020_DoveWhite: 16960,
  Glidden_10BG83018_GlisteningMoonlight: 16961,
  Glidden_10BG83053_BlueFrost: 16962,
  Glidden_10GG53030_MistyGreyGreen: 16963,
  Glidden_10GG62026_BarelyJade: 16964,
  Glidden_10GG72022_HuskyGrey: 16965,
  Glidden_10GY36096_MonsoonGreen: 16966,
  Glidden_10GY49081_SilverGreenVine: 16967,
  Glidden_10RB10219_FreshGrapeJuice: 16968,
  Glidden_10RB14132_NightshadeViolet: 16969,
  Glidden_10RB17122_AncientViolet: 16970,
  Glidden_10RB17210_GardenViolets: 16971,
  Glidden_10RB21218_AmethystWisteria: 16972,
  Glidden_10RB24081_SoftGreyedHeather: 16973,
  Glidden_10RB24179_SecretLavender: 16974,
  Glidden_10RB25102_GreyedAmethyst: 16975,
  Glidden_10RB31204_LavenderFlowers: 16976,
  Glidden_10RB36082_MineralViolet: 16977,
  Glidden_10RB41166_SoftOrchidViolet: 16978,
  Glidden_10RB42072_SoftDustyViolet: 16979,
  Glidden_10RB60098_IcedViolet: 16980,
  Glidden_10RR16300_HushedCranberry: 16981,
  Glidden_10RR21325_AntiqueFuchsia: 16982,
  Glidden_10RR31317_PinkZinniaBloom: 16983,
  Glidden_10RR32258_PinkMauve: 16984,
  Glidden_10RR43236_PinkGazebo: 16985,
  Glidden_10RR48209_BashfulPink: 16986,
  Glidden_10RR59156_PerennialPink: 16987,
  Glidden_10RR60072_MistyMauve: 16988,
  Glidden_10RR60197_BubblegumPink: 16989,
  Glidden_10RR67057_MineralMauve: 16990,
  Glidden_10RR75039_FloralTwistPink: 16991,
  Glidden_10YR09250_ColonialRed: 16992,
  Glidden_10YR10312_RustyRed: 16993,
  Glidden_10YR12375_SparklingGarnet: 16994,
  Glidden_10YR14348_SalsaRed: 16995,
  Glidden_10YR16407_TerraCottaRose: 16996,
  Glidden_10YR17295_CountryBakedBeans: 16997,
  Glidden_10YR17465_FrenchStripeRed: 16998,
  Glidden_10YR19389_AntiqueBrickRed: 16999,
  Glidden_10YR21313_PotteryRose: 17000,
  Glidden_10YR24399_CoralBerry: 17001,
  Glidden_10YR26442_LegacyRose: 17002,
  Glidden_10YR27323_MadeiraRose: 17003,
  Glidden_10YR30400_TemptationRose: 17004,
  Glidden_10YR32324_Berrydale: 17005,
  Glidden_10YR38318_CoralBeach: 17006,
  Glidden_10YY08093_BittersweetChocolate: 17007,
  Glidden_10YY11087_CedarBrown: 17008,
  Glidden_10YY11187_TallTreeBarkBrown: 17009,
  Glidden_10YY14080_MontereyCliffs: 17010,
  Glidden_10YY16217_GroundNutmeg: 17011,
  Glidden_10YY18074_FaunaBrown: 17012,
  Glidden_10YY23184_CanvasbackBrown: 17013,
  Glidden_10YY30106_WrightStoneTan: 17014,
  Glidden_10YY31218_HotMustardSeed: 17015,
  Glidden_10YY35094_NeutralWheat: 17016,
  Glidden_10YY35196_WarmCaramel: 17017,
  Glidden_10YY41083_CastleRock: 17018,
  Glidden_10YY41175_HighlandPlainsNeutral: 17019,
  Glidden_10YY42460_Gingerglow: 17020,
  Glidden_10YY45419_WoodThrushGold: 17021,
  Glidden_10YY46154_FortressStone: 17022,
  Glidden_10YY48071_StoneHarborGreige: 17023,
  Glidden_10YY54034_RomaHazeGrey: 17024,
  Glidden_10YY55163_DapperTan: 17025,
  Glidden_10YY56060_ShadowboxBeige: 17026,
  Glidden_10YY57377_Amberwave: 17027,
  Glidden_10YY63162_MayanTan: 17028,
  Glidden_10YY67089_SafariBisqueBeige: 17029,
  Glidden_10YY67213_KivaGlow: 17030,
  Glidden_10YY69130_SummerSandcastle: 17031,
  Glidden_10YY74192_SandyFeet: 17032,
  Glidden_10YY75084_EternalBeige: 17033,
  Glidden_10YY76104_PorcelainPeach: 17034,
  Glidden_10YY78188_PeachPowder: 17035,
  Glidden_10YY83071_WhitePeach: 17036,
  Glidden_10YY83100_PeachOrchid: 17037,
  Glidden_11BB64135_PaleWildflowerBlue: 17038,
  Glidden_12RR07229_DeepPlum: 17039,
  Glidden_12YR07279_CaliforniaClaret: 17040,
  Glidden_13BB17399_BrightBayBlue: 17041,
  Glidden_14RR09333_BrightBlackRaspberry: 17042,
  Glidden_14RR48276_ValentinePink: 17043,
  Glidden_16BB41268_BlueMarina: 17044,
  Glidden_16BG17342_KingfisherBlue: 17045,
  Glidden_16BG24357_HawaiianTeal: 17046,
  Glidden_16BG29350_MilanoTeal: 17047,
  Glidden_16YR18587_OldGloryRed: 17048,
  Glidden_17BG36333_SplashOfTeal: 17049,
  Glidden_17BG60218_SeaFaringClearBlue: 17050,
  Glidden_17BG65182_SausalitoSky: 17051,
  Glidden_17YY65420_PaleOrange: 17052,
  Glidden_18BG47282_PacificCoastBlue: 17053,
  Glidden_19BG61207_TrueTurquoise: 17054,
  Glidden_19YR14629_RedGeranium: 17055,
  Glidden_19YY83140_PeachSatin: 17056,
  Glidden_20YY18140_LeChateauBrown: 17057,
  Glidden_20YY19266_OliveTree: 17058,
  Glidden_20YY23246_DeepBentwoodGold: 17059,
  Glidden_20YY24177_DarkLegacyGold: 17060,
  Glidden_20YY29161_ReindeerFur: 17061,
  Glidden_20YY29351_GigisGoldenLocket: 17062,
  Glidden_20YY30274_TraditionGold: 17063,
  Glidden_20YY31106_BrushwoodTan: 17064,
  Glidden_20YY31205_GoldenBasketry: 17065,
  Glidden_20YY33145_KhakiBronze: 17066,
  Glidden_20YY36185_SoftHoneyGold: 17067,
  Glidden_20YY36370_MonarchGold: 17068,
  Glidden_20YY37094_HeronGrey: 17069,
  Glidden_20YY37293_ATouchOfGold: 17070,
  Glidden_20YY39130_PalmSpringsTan: 17071,
  Glidden_20YY39419_FoolsGold: 17072,
  Glidden_20YY41264_GoldenNeedles: 17073,
  Glidden_20YY43083_ScrollBeige: 17074,
  Glidden_20YY43200_SatinGold: 17075,
  Glidden_20YY44304_HaymarketStraw: 17076,
  Glidden_20YY46236_CookieCrumb: 17077,
  Glidden_20YY46425_GoldStrike: 17078,
  Glidden_20YY47145_TraditionalTan: 17079,
  Glidden_20YY49071_DovetailGrey: 17080,
  Glidden_20YY49176_BonjourBeige: 17081,
  Glidden_20YY49271_GrandCanyonGold: 17082,
  Glidden_20YY53124_SaharaDesertSand: 17083,
  Glidden_20YY53238_TuscanTan: 17084,
  Glidden_20YY55151_MushroomCap: 17085,
  Glidden_20YY57178_ClassicIvory: 17086,
  Glidden_20YY60104_AntiqueAlenconLace: 17087,
  Glidden_20YY63149_BrazilNut: 17088,
  Glidden_20YY63258_FarmersAlmanacCream: 17089,
  Glidden_20YY67216_JustPeachy: 17090,
  Glidden_20YY69120_DesertIvory: 17091,
  Glidden_20YY77128_PeachColonnade: 17092,
  Glidden_20YY78146_TaffyPullCream: 17093,
  Glidden_20YY83075_AlmondWisp: 17094,
  Glidden_20YY83100_ShellCreekWhite: 17095,
  Glidden_21RR36354_RaspberryPink: 17096,
  Glidden_21YR57250_CoralFlower: 17097,
  Glidden_22BB34304_HarborBlue: 17098,
  Glidden_22YR50316_BayCoral: 17099,
  Glidden_22YY71347_GingerPeachy: 17100,
  Glidden_23GY85031_GrannySmithWhite: 17101,
  Glidden_23YR45369_FreshSalmon: 17102,
  Glidden_23YR66193_LightCoralSunset: 17103,
  Glidden_24YR72146_FairytalePink: 17104,
  Glidden_25BB30318_BrightSailingSkyBlue: 17105,
  Glidden_25YR34473_CelebrationOrange: 17106,
  Glidden_25YY62353_PalominoGold: 17107,
  Glidden_25YY78232_VenetianStucco: 17108,
  Glidden_27YY78255_PeachesAndCream: 17109,
  Glidden_28YR29561_OrangeTigerLily: 17110,
  Glidden_28YY86106_IcyPeach: 17111,
  Glidden_29YY66537_SunRays: 17112,
  Glidden_29YY76275_ChampagneMimosa: 17113,
  Glidden_30BB10075_SophisticatedNavy: 17114,
  Glidden_30BB13034_DarkGreySilk: 17115,
  Glidden_30BB13068_BlueGreySlate: 17116,
  Glidden_30BB14173_MidshipBlue: 17117,
  Glidden_30BB16031_CharcoalCoast: 17118,
  Glidden_30BB17094_FavoriteDenimBlue: 17119,
  Glidden_30BB17158_DeepBlueShadow: 17120,
  Glidden_30BB21056_EveningShadow: 17121,
  Glidden_30BB22144_PrairieKitchenBlue: 17122,
  Glidden_30BB26025_SilversmithGrey: 17123,
  Glidden_30BB26076_DarkWinterSkyBlue: 17124,
  Glidden_30BB27156_AtPeaceBlue: 17125,
  Glidden_30BB27209_CenturionBlue: 17126,
  Glidden_30BB32067_BlueGreySky: 17127,
  Glidden_30BB32139_FlorentineBlue: 17128,
  Glidden_30BB33163_SteelBlue: 17129,
  Glidden_30BB33187_NewWorldBlue: 17130,
  Glidden_30BB33235_PeriwinkleBlue: 17131,
  Glidden_30BB39122_ContemplativeBlue: 17132,
  Glidden_30BB39165_CharismaBlue: 17133,
  Glidden_30BB45049_SilverSwordplay: 17134,
  Glidden_30BB46124_AntwerpBlue: 17135,
  Glidden_30BB47179_DuchessBlue: 17136,
  Glidden_30BB53040_DistantOceanGrey: 17137,
  Glidden_30BB55152_BlueStemware: 17138,
  Glidden_30BB62004_FineSilver: 17139,
  Glidden_30BB63084_IcedPeriwinkle: 17140,
  Glidden_30BB63124_QuietBlue: 17141,
  Glidden_30BB72003_TouchOfGrey: 17142,
  Glidden_30BB83018_PearlDrop: 17143,
  Glidden_30BG10055_TundraPond: 17144,
  Glidden_30BG10111_MallardTrekTurquoise: 17145,
  Glidden_30BG15062_DeepIronCreek: 17146,
  Glidden_30BG18060_GreyGreenWetland: 17147,
  Glidden_30BG22057_WesternSkyBlue: 17148,
  Glidden_30BG23124_SmokedTurquoise: 17149,
  Glidden_30BG24224_DarkWestwindBlue: 17150,
  Glidden_30BG27119_OldNantucketTeal: 17151,
  Glidden_30BG31053_NocturnalCreek: 17152,
  Glidden_30BG33207_DeepestAqua: 17153,
  Glidden_30BG36051_WinteryGrey: 17154,
  Glidden_30BG37110_HazySeacliffTeal: 17155,
  Glidden_30BG38199_SailingSeaBlue: 17156,
  Glidden_30BG42049_ShadedBrook: 17157,
  Glidden_30BG49047_CanadianSkyBlue: 17158,
  Glidden_30BG50183_SoftBahamaBlue: 17159,
  Glidden_30BG56045_SilverBlueSea: 17160,
  Glidden_30BG56097_SeaSpray: 17161,
  Glidden_30BG57149_TropicalLagoon: 17162,
  Glidden_30BG64036_MistyEveningSilver: 17163,
  Glidden_30BG64054_SimplyBlue: 17164,
  Glidden_30BG64072_ClearSailing: 17165,
  Glidden_30BG64108_BiscayneBlue: 17166,
  Glidden_30BG64126_AfternoonSiestaBlue: 17167,
  Glidden_30BG72017_SwissWhite: 17168,
  Glidden_30BG72034_CloudNineBlue: 17169,
  Glidden_30BG72069_TropicalSurf: 17170,
  Glidden_30BG72120_HarborsideSky: 17171,
  Glidden_30BG76107_WinterscapeBlue: 17172,
  Glidden_30GG83006_RaindropWhite: 17173,
  Glidden_30GG83013_WinterWalkWhite: 17174,
  Glidden_30GG83025_SoftGreen: 17175,
  Glidden_30GY07051_EnchantedForestGreen: 17176,
  Glidden_30GY13045_DeepestValleyGreen: 17177,
  Glidden_30GY73053_MistyChinaRainGreen: 17178,
  Glidden_30GY76017_StoneWhite: 17179,
  Glidden_30GY83021_ExtremeWhite: 17180,
  Glidden_30GY88014_WhiteOnWhite: 17181,
  Glidden_30RB07071_BlackAmethyst: 17182,
  Glidden_30RB07107_BlackTulip: 17183,
  Glidden_30RB10100_NightVineyard: 17184,
  Glidden_30RB40150_LilacLattice: 17185,
  Glidden_30RB53117_QuaintPurpleRose: 17186,
  Glidden_30RB67073_ScentOfPurple: 17187,
  Glidden_30RB68084_PalePurpleClouds: 17188,
  Glidden_30RB83011_InnocentWhite: 17189,
  Glidden_30RR07094_BlackCurrant: 17190,
  Glidden_30RR09187_RichRaisin: 17191,
  Glidden_30RR10321_SoftCranberry: 17192,
  Glidden_30RR11175_CurrantBerry: 17193,
  Glidden_30RR21127_DustyBerry: 17194,
  Glidden_30RR26335_RosePetalPink: 17195,
  Glidden_30RR30103_SonataMauve: 17196,
  Glidden_30RR36091_SoftMauve: 17197,
  Glidden_30RR42079_HintOfMauve: 17198,
  Glidden_30RR46018_HazyGrey: 17199,
  Glidden_30RR49067_SoftWine: 17200,
  Glidden_30RR56055_TurtledoveRose: 17201,
  Glidden_30RR63011_WisdomGrey: 17202,
  Glidden_30YR08236_OldRedwood: 17203,
  Glidden_30YR11219_SweetTea: 17204,
  Glidden_30YR14232_BoothillBrown: 17205,
  Glidden_30YR17341_CharredClay: 17206,
  Glidden_30YR20313_BurntClay: 17207,
  Glidden_30YR20595_SkyrocketRed: 17208,
  Glidden_30YR26330_IndianSummerOrange: 17209,
  Glidden_30YR33379_Roseland: 17210,
  Glidden_30YR35264_FadedRose: 17211,
  Glidden_30YY07041_DeepestEarthGreen: 17212,
  Glidden_30YY08082_BurntBark: 17213,
  Glidden_30YY10038_ForestBlack: 17214,
  Glidden_30YY11076_WildTruffle: 17215,
  Glidden_30YY14070_GreySquirrel: 17216,
  Glidden_30YY16032_GreyHearth: 17217,
  Glidden_30YY18064_WallStreetGrey: 17218,
  Glidden_30YY20029_MansardStone: 17219,
  Glidden_30YY20193_DarkHammeredGold: 17220,
  Glidden_30YY22059_GreyTweed: 17221,
  Glidden_30YY27053_CastleWallGrey: 17222,
  Glidden_30YY27226_KhakiMoss: 17223,
  Glidden_30YY31024_StoneGrey: 17224,
  Glidden_30YY31205_MojaveGold: 17225,
  Glidden_30YY33047_OldMontereyGrey: 17226,
  Glidden_30YY35249_OldSalemGold: 17227,
  Glidden_30YY36185_OldSurreyBeige: 17228,
  Glidden_30YY39041_SongSparrow: 17229,
  Glidden_30YY39225_SummerwoodGold: 17230,
  Glidden_30YY41165_SoftSuede: 17231,
  Glidden_30YY42337_KingsRansomGold: 17232,
  Glidden_30YY44509_BrassRail: 17233,
  Glidden_30YY46036_CandlestickSilver: 17234,
  Glidden_30YY46304_WildHoney: 17235,
  Glidden_30YY47145_JeffersonHouseTan: 17236,
  Glidden_30YY47236_GoldenRice: 17237,
  Glidden_30YY49071_SilverClamshell: 17238,
  Glidden_30YY49562_GoldenRae: 17239,
  Glidden_30YY50176_HistoricTan: 17240,
  Glidden_30YY50425_GoldDoubloon: 17241,
  Glidden_30YY52207_DesertValleyGold: 17242,
  Glidden_30YY52515_WheatStalk: 17243,
  Glidden_30YY53125_SudanSandBeige: 17244,
  Glidden_30YY54030_SuttonPlaceGrey: 17245,
  Glidden_30YY54306_FlaxenHair: 17246,
  Glidden_30YY54383_RapunzelsGoldenLocks: 17247,
  Glidden_30YY55469_CornMoon: 17248,
  Glidden_30YY58178_WhisperingWheat: 17249,
  Glidden_30YY60104_BuffedTan: 17250,
  Glidden_30YY60205_PrairieHouseCream: 17251,
  Glidden_30YY63024_SilverCloud: 17252,
  Glidden_30YY63231_GoldenBamboo: 17253,
  Glidden_30YY64331_SoftGold: 17254,
  Glidden_30YY65171_TawnyBirch: 17255,
  Glidden_30YY67084_NaturalWicker: 17256,
  Glidden_30YY67194_IvoryCream: 17257,
  Glidden_30YY69048_WhitecliffBeige: 17258,
  Glidden_30YY72009_SilverScreen: 17259,
  Glidden_30YY72018_LightPelicanGrey: 17260,
  Glidden_30YY74121_CrewelworkIvory: 17261,
  Glidden_30YY75145_MacadamiaWhite: 17262,
  Glidden_30YY77169_PeachyCream: 17263,
  Glidden_30YY78035_KittenWhite: 17264,
  Glidden_30YY79070_ToastedOatmeal: 17265,
  Glidden_30YY81123_IvoryFresco: 17266,
  Glidden_30YY83006_QueenAnnesLace: 23145,
  Glidden_30YY83012_MarshmallowWhite: 17267,
  Glidden_31BB23340_BrightPreludeBlue: 17268,
  Glidden_31YR10591_CrimsonRed: 17269,
  Glidden_32YR78106_PinkMimosa: 17270,
  Glidden_33BB32308_FrenchBlueRoom: 17271,
  Glidden_35YY59533_WarmGold: 17272,
  Glidden_35YY61431_PrairieGrassGold: 17273,
  Glidden_35YY78269_FrostedLemon: 17274,
  Glidden_36BB46231_FrenchCountryBlue: 17275,
  Glidden_36YY66349_ApricotNectar: 17276,
  Glidden_39YY77091_ElegantIvoryCream: 17277,
  Glidden_39YY85046_EgretWhite: 17278,
  Glidden_40RB36264_ConfettiPurple: 17279,
  Glidden_40RB43233_SugaredPlum: 17280,
  Glidden_40RR11430_VeryBerry: 17281,
  Glidden_40YY28130_CanyonFloorTan: 17282,
  Glidden_40YY33118_GrandCanyonTan: 17283,
  Glidden_40YY38107_PottersClayBeige: 17284,
  Glidden_40YY41384_DeepGoldenStraw: 17285,
  Glidden_40YY44095_DryGoodsNeutral: 17286,
  Glidden_40YY48321_SpinningStrawGold: 17287,
  Glidden_40YY49408_DustyGold: 17288,
  Glidden_40YY51084_BurmeseBeige: 17289,
  Glidden_40YY53119_ChathamGreen: 17290,
  Glidden_40YY55611_SundaySunshine: 17291,
  Glidden_40YY57335_LionsDanceGold: 17292,
  Glidden_40YY58565_GoldenMoment: 17293,
  Glidden_40YY60103_NaturalLinen: 17294,
  Glidden_40YY60519_Sunshower: 17295,
  Glidden_40YY61299_SunnybrookYellow: 17296,
  Glidden_40YY62134_GeorgianIvory: 17297,
  Glidden_40YY63473_GingerAle: 17298,
  Glidden_40YY64035_OldFossilstoneGrey: 17299,
  Glidden_40YY64165_IvoryCoast: 17300,
  Glidden_40YY64340_GoldenRapture: 17301,
  Glidden_40YY65427_MayappleYellow: 17302,
  Glidden_40YY67087_PillarBeige: 17303,
  Glidden_40YY69112_NavajoSand: 17304,
  Glidden_40YY70138_Parchment: 17305,
  Glidden_40YY71258_FairestOfGold: 17306,
  Glidden_40YY71335_JonquilYellow: 17307,
  Glidden_40YY72164_CountryCream: 17308,
  Glidden_40YY73028_ToastedWhite: 17309,
  Glidden_40YY75084_SeedPearl: 17310,
  Glidden_40YY76112_LightNavajo: 17311,
  Glidden_40YY78140_GoldCoastWhite: 17312,
  Glidden_40YY83021_MinimalistWhite: 17313,
  Glidden_40YY83064_PebbleWhite: 17314,
  Glidden_40YY83107_CurrierCreme: 17315,
  Glidden_41BG76025_WhiteLagoon: 17316,
  Glidden_41RB19322_UpTempoViolet: 17317,
  Glidden_41RB24309_OrchidBlush: 17318,
  Glidden_41RB30290_VioletIllusion: 17319,
  Glidden_42RB53176_SoftViolet: 17320,
  Glidden_42YR43439_TropicalCoral: 17321,
  Glidden_42YY84095_SugaredAlmond: 17322,
  Glidden_42YY87084_ArizonaWhite: 17323,
  Glidden_43RB07249_RoyalIris: 17324,
  Glidden_43RR19444_AzaleaPink: 17325,
  Glidden_43YY69543_MayTulipYellow: 17326,
  Glidden_44BB62134_PearlViolet: 17327,
  Glidden_44GG24451_MiamiJade: 17328,
  Glidden_44YY80106_ShellWhiteRm: 17329,
  Glidden_44YY87118_SummerHazeLight: 17330,
  Glidden_45BB22347_BrightCornflowerBlue: 17331,
  Glidden_45YY32211_OliveTwig: 17332,
  Glidden_45YY36196_TarnishedGoldHeirloom: 17333,
  Glidden_45YY41181_DustyKhaki: 17334,
  Glidden_45YY43536_PirateGold: 17335,
  Glidden_45YY44115_StorybookStraw: 17336,
  Glidden_45YY51105_TawnyGrey: 17337,
  Glidden_45YY58094_RiverBirchBeige: 17338,
  Glidden_45YY61368_VintageYellow: 17339,
  Glidden_45YY62288_SoftFlaxenGold: 17340,
  Glidden_45YY65334_CrispGingerAle: 17341,
  Glidden_45YY65710_FestivalYellow: 17342,
  Glidden_45YY67120_AutumnHaze: 17343,
  Glidden_45YY67259_CostaMesaYellow: 17344,
  Glidden_45YY69469_ShorelightYellow: 17345,
  Glidden_45YY71567_Sunspot: 17346,
  Glidden_45YY72230_SpringMagnoliaCream: 17347,
  Glidden_45YY72342_YellowDuckling: 17348,
  Glidden_45YY73519_YellowRose: 17349,
  Glidden_45YY74073_CappuccinoWhite: 17350,
  Glidden_45YY74383_ButteredSweetCorn: 17351,
  Glidden_45YY75472_Yellowbird: 17352,
  Glidden_45YY77424_Sunny: 17353,
  Glidden_45YY83094_ShellWhite: 17354,
  Glidden_45YY83250_SweetButtercup: 17355,
  Glidden_46YR69173_PeachDaiquiri: 17356,
  Glidden_46YY86166_PopcornWhite: 17357,
  Glidden_47BB14349_DeepSapphireBlue: 17358,
  Glidden_48BB56162_SpringBluebell: 17359,
  Glidden_48GG36428_BrightTealSurprise: 17360,
  Glidden_48YR50372_ApricotIce: 17361,
  Glidden_49BB51186_RoslynsPeriwinkleBlue: 17362,
  Glidden_49BB76037_MingDynastyWhite: 17363,
  Glidden_50BB08129_FederalBlue: 17364,
  Glidden_50BB08171_RichNavy: 17365,
  Glidden_50BB10112_RoyalNavy: 17366,
  Glidden_50BB10147_InTheNavy: 17367,
  Glidden_50BB13104_BlueHeron: 17368,
  Glidden_50BB14169_BlueberryHill: 17369,
  Glidden_50BB18216_NobleBlue: 17370,
  Glidden_50BB22143_DeepEmpireBlue: 17371,
  Glidden_50BB22199_CreamyBlueberry: 17372,
  Glidden_50BB26130_WindmillBlue: 17373,
  Glidden_50BB27181_PeriwinklePetal: 17374,
  Glidden_50BB32117_ByzantineBlue: 17375,
  Glidden_50BB33164_ExquisiteBlueGrey: 17376,
  Glidden_50BB39146_FrostedBlueberry: 17377,
  Glidden_50BB46091_AntiqueViolet: 17378,
  Glidden_50BB46110_TwilightBlue: 17379,
  Glidden_50BB46129_GlacierBayBlue: 17380,
  Glidden_50BB54079_FadedViolet: 17381,
  Glidden_50BB54111_PaintersPeriwinkle: 17382,
  Glidden_50BB63066_SmokeyViolet: 17383,
  Glidden_50BB63107_PromDressBlue: 17384,
  Glidden_50BB72039_LightBlueDusk: 17385,
  Glidden_50BB72045_EveningLight: 17386,
  Glidden_50BB83017_IceMist: 17387,
  Glidden_50BB83020_MajesticMountainWhite: 17388,
  Glidden_50BG11123_GlobalWaters: 17389,
  Glidden_50BG22030_FlagstoneGrey: 17390,
  Glidden_50BG33025_CoolMetalworkGrey: 17391,
  Glidden_50BG33360_StickyNoteBlue: 17392,
  Glidden_50BG39022_PhilosophicalGrey: 17393,
  Glidden_50BG41312_BrightBlue: 17394,
  Glidden_50BG46020_MediciGrey: 17395,
  Glidden_50BG47039_SoftFeatherGrey: 17396,
  Glidden_50BG50265_ByTheSea: 17397,
  Glidden_50BG54017_SilverReflection: 17398,
  Glidden_50BG57173_SeaglassBlue: 17399,
  Glidden_50BG63014_SilveryMoonlight: 17400,
  Glidden_50BG64028_QuietRain: 17401,
  Glidden_50BG70032_MoonlightRendezvous: 17402,
  Glidden_50BG72011_NorthBeach: 17403,
  Glidden_50BG72170_FreshWaterBlue: 17404,
  Glidden_50BG76023_SilverStreak: 17405,
  Glidden_50BG76034_ShimmeringSky: 17406,
  Glidden_50BG76068_SnowShadowBlue: 17407,
  Glidden_50BG76090_ArcticBlue: 17408,
  Glidden_50BG83009_CrystalClearWhite: 17409,
  Glidden_50GG05063_DeepestWoodlandGreen: 17410,
  Glidden_50GG09118_HemlockGreen: 17411,
  Glidden_50GG15099_DarkStormySkyGreen: 17412,
  Glidden_50GG33253_MoroccanMint: 17413,
  Glidden_50GG43213_CapriTeal: 17414,
  Glidden_50GG47057_FrostedBriarwoodGreen: 17415,
  Glidden_50GG48194_SoftSchoonerGreen: 17416,
  Glidden_50GG55049_IcyTeal: 17417,
  Glidden_50GG61154_WashedTeal: 17418,
  Glidden_50GG63042_GreyLeaf: 17419,
  Glidden_50GG69134_LimeFoam: 17420,
  Glidden_50GY26050_RockspringGreen: 17421,
  Glidden_50GY32046_Greycliffe: 17422,
  Glidden_50GY38042_Woodlawn: 17423,
  Glidden_50GY43503_LollipopLime: 17424,
  Glidden_50GY45037_DustyMiller: 17425,
  Glidden_50GY48075_GreenSmoke: 17426,
  Glidden_50GY51141_FrondGreen: 17427,
  Glidden_50GY51437_JungleVine: 17428,
  Glidden_50GY53033_JadeFrost: 17429,
  Glidden_50GY55066_DistantHazeGreen: 17430,
  Glidden_50GY55404_LuckyLime: 17431,
  Glidden_50GY59371_FrostedLime: 17432,
  Glidden_50GY64057_SilverMaple: 17433,
  Glidden_50GY65084_LightSpringDew: 17434,
  Glidden_50GY66111_SoftestJuniper: 17435,
  Glidden_50GY69306_WindowGardenGreen: 17436,
  Glidden_50GY73049_OrientalIvory: 17437,
  Glidden_50GY74073_ItalianateVillaGreen: 17438,
  Glidden_50GY74273_FreshArboretumGreen: 17439,
  Glidden_50GY77195_MintShake: 17440,
  Glidden_50GY83040_HintOfGreen: 17441,
  Glidden_50GY83060_FrostedMintGreen: 17442,
  Glidden_50GY83160_EarlyFrost: 17443,
  Glidden_50RB10219_CaliforniaRaisin: 17444,
  Glidden_50RB14232_AmethystJewel: 17445,
  Glidden_50RB19268_VividViolet: 17446,
  Glidden_50RB20199_GrapeSurprise: 17447,
  Glidden_50RB23161_PurpleFoxgloveFlower: 17448,
  Glidden_50RB32114_TwilightViolet: 17449,
  Glidden_50RB37102_HighSocietyViolet: 17450,
  Glidden_50RB39138_LightFrenchLilac: 17451,
  Glidden_50RB45122_NorthernLightPurple: 17452,
  Glidden_50RB50079_SoftAmuletViolet: 17453,
  Glidden_50RB52107_VioletBlusher: 17454,
  Glidden_50RB59092_WinteryViolet: 17455,
  Glidden_50RB74033_BarelyLilac: 17456,
  Glidden_50RB83017_PinkPetalWhite: 17457,
  Glidden_50RR06057_DeepRumRaisin: 17458,
  Glidden_50RR08053_DeepRaspberryShadow: 17459,
  Glidden_50RR11049_BerryBrown: 17460,
  Glidden_50RR11286_RoyalCranberry: 17461,
  Glidden_50RR14045_BlackFrostedPlum: 17462,
  Glidden_50RR14266_RaspberryKiss: 17463,
  Glidden_50RR18041_DarkRaspberryTaupe: 17464,
  Glidden_50RR27033_GreyedRoseQuartz: 17465,
  Glidden_50RR32029_WarmGreyFlannel: 17466,
  Glidden_50RR39025_TrulyTaupe: 17467,
  Glidden_50RR54018_UrbanGrey: 17468,
  Glidden_50RR74048_FragilePink: 17469,
  Glidden_50RR75068_RomanticPink: 17470,
  Glidden_50RR83029_DelightfulPink: 17471,
  Glidden_50RR83040_HeirloomPink: 17472,
  Glidden_50YR06041_WesternCharcoal: 17473,
  Glidden_50YR06081_StewartHouseBrown: 17474,
  Glidden_50YR13139_SpicewoodBrown: 17475,
  Glidden_50YR16127_AudreysAuburn: 17476,
  Glidden_50YR16295_ClassicBrickRed: 17477,
  Glidden_50YR20116_OldLeatherBook: 17478,
  Glidden_50YR23365_AmberCoast: 17479,
  Glidden_50YR32460_Cinnabar: 17480,
  Glidden_50YR32551_HibiscusBloom: 17481,
  Glidden_50YR44287_DesertDawn: 17482,
  Glidden_50YR55201_LotusBlossom: 17483,
  Glidden_50YR56221_Seascape: 17484,
  Glidden_50YR62173_DuchessPeach: 17485,
  Glidden_50YY09101_OliveBlack: 17486,
  Glidden_50YY12095_BronzedIvy: 17487,
  Glidden_50YY15089_DarkMossyTrail: 17488,
  Glidden_50YY26289_VintageOlive: 17489,
  Glidden_50YY28071_StoneCastleGreige: 17490,
  Glidden_50YY30270_Teagreen: 17491,
  Glidden_50YY33065_DriftwoodGrey: 17492,
  Glidden_50YY34250_SpringAwakening: 17493,
  Glidden_50YY39230_KhakiSage: 17494,
  Glidden_50YY39308_GoldenCactusFlower: 17495,
  Glidden_50YY40059_CityLoftGrey: 17496,
  Glidden_50YY43284_GoldenSage: 17497,
  Glidden_50YY44211_GiftOfGoldenStraw: 17498,
  Glidden_50YY47053_PewterGrey: 17499,
  Glidden_50YY47337_GoldenValley: 17500,
  Glidden_50YY49191_CyprusGrass: 17501,
  Glidden_50YY51519_ExtraVirginOliveOil: 17502,
  Glidden_50YY55047_GreyrockInn: 17503,
  Glidden_50YY55171_SoftBronzeGlow: 17504,
  Glidden_50YY55623_GoldenAnniversary: 17505,
  Glidden_50YY60538_SpicyBananaPepper: 17506,
  Glidden_50YY61152_ShyGold: 17507,
  Glidden_50YY61251_GoldenHeirloom: 17508,
  Glidden_50YY63041_SmoothStone: 17509,
  Glidden_50YY65071_PapyrusPaper: 17510,
  Glidden_50YY65454_GoldenBell: 17511,
  Glidden_50YY71369_HurricaneLampGlow: 17512,
  Glidden_50YY74069_MeetingHouseWhite: 17513,
  Glidden_50YY75254_NaturalStraw: 17514,
  Glidden_50YY77173_BostonCream: 17515,
  Glidden_50YY77285_FrenchLemon: 17516,
  Glidden_50YY80455_FreshPineapple: 17517,
  Glidden_50YY83029_NaturalWhite: 17518,
  Glidden_50YY83057_SwissCoffee: 17519,
  Glidden_50YY83200_YellowAcaciaBloom: 17520,
  Glidden_51RR62190_GumdropPink: 17521,
  Glidden_51YR83054_SubtlePeach: 17522,
  Glidden_51YY83060_PacificMist: 17523,
  Glidden_52YR37501_SunbakedOrange: 17524,
  Glidden_53GG50360_ThaiTeal: 17525,
  Glidden_53RR27417_FiestaPink: 17526,
  Glidden_53YY83348_Buttercup: 17527,
  Glidden_53YY87070_TerraceWhite: 17528,
  Glidden_54BB41237_FreshHyacinth: 17529,
  Glidden_54BG28351_MosaicBlue: 17530,
  Glidden_54RR09276_BoldSangria: 17531,
  Glidden_54RR52260_PinkCarnation: 17532,
  Glidden_54YY85291_EarlyMorningSun: 17533,
  Glidden_55RR75106_PrincessPink: 17534,
  Glidden_55YR24666_FreshTangerines: 17535,
  Glidden_56BG23355_CaribbeanSea: 17536,
  Glidden_56GG64258_BaliHaiTeal: 17537,
  Glidden_56GG77156_AquaSky: 17538,
  Glidden_56RB09302_RegalPurple: 17539,
  Glidden_56YR48398_PeachPunch: 17540,
  Glidden_56YY86241_LemonIce: 17541,
  Glidden_57YR77102_LightBlush: 17542,
  Glidden_58BB33270_BluePhlox: 17543,
  Glidden_58GG71202_TealZeal: 17544,
  Glidden_58RR45306_AFunLittlePink: 17545,
  Glidden_58YR53342_ChristmasCactusCoral: 17546,
  Glidden_59BB81022_BarcelonaRain: 17547,
  Glidden_60BG17341_PacificTurquoise: 17548,
  Glidden_60YR09086_AuthenticBrown: 17549,
  Glidden_60YR19432_OldCopperKettle: 17550,
  Glidden_60YR23650_CalypsoCoral: 17551,
  Glidden_60YR24439_PekingOrange: 17552,
  Glidden_60YR29318_DustyTerraCotta: 17553,
  Glidden_60YR30094_MochaMauve: 17554,
  Glidden_60YR31368_NewTerraCotta: 17555,
  Glidden_60YR33287_PompeiiClay: 17556,
  Glidden_60YR33514_OrangeChineseLantern: 17557,
  Glidden_60YR34418_CanyonStone: 17558,
  Glidden_60YR35083_MourningDove: 17559,
  Glidden_60YR40297_ButteredSalmon: 17560,
  Glidden_60YR40423_RipeApricot: 17561,
  Glidden_60YR43225_LondonderryCoral: 17562,
  Glidden_60YR57216_CoralCove: 17563,
  Glidden_60YR65196_PeachCrayon: 17564,
  Glidden_60YR69135_SweetClover: 17565,
  Glidden_60YR76105_BeautifulBisque: 17566,
  Glidden_60YR83043_FrostyPeachRibbon: 17567,
  Glidden_60YY28139_DeepRavineGreen: 17568,
  Glidden_60YY33130_KhakiGreen: 17569,
  Glidden_60YY38120_WhisperingWillow: 17570,
  Glidden_60YY44110_ChimayoSage: 17571,
  Glidden_60YY51101_GreyBirch: 17572,
  Glidden_60YY53330_PickledSage: 17573,
  Glidden_60YY57304_GoldenKiwi: 17574,
  Glidden_60YY58091_FrostedAlmond: 17575,
  Glidden_60YY61352_ButteryWillow: 17576,
  Glidden_60YY65082_WhiteSage: 17577,
  Glidden_60YY65321_IllusionOfGold: 17578,
  Glidden_60YY67251_SoftBurnishedGold: 17579,
  Glidden_60YY69153_SunlitMeadow: 17580,
  Glidden_60YY70189_BrocadeCream: 17581,
  Glidden_60YY72225_HoneyFrost: 17582,
  Glidden_60YY74072_ElegantLace: 17583,
  Glidden_60YY74371_HarvestMoon: 17584,
  Glidden_60YY75108_MistySummerDay: 17585,
  Glidden_60YY75296_SummerCottageYellow: 17586,
  Glidden_60YY76144_SpringWisp: 17587,
  Glidden_60YY78216_Haystack: 17588,
  Glidden_60YY80288_ChicYellow: 17589,
  Glidden_60YY83062_ParchmentWhite: 17590,
  Glidden_60YY83125_VanillaCustard: 17591,
  Glidden_60YY83219_DaisyYellow: 17592,
  Glidden_61BB28291_PurePeriwinkle: 17593,
  Glidden_61YR60282_PeachMedley: 17594,
  Glidden_61YY85050_FloralWhite: 17595,
  Glidden_61YY89040_CrispLinenWhite: 17596,
  Glidden_61YY89135_SoftCandlelight: 17597,
  Glidden_62RR21444_KissablePink: 17598,
  Glidden_63RR39350_PinketyPink: 17599,
  Glidden_64BB23310_HeatherHighland: 17600,
  Glidden_64RR12436_RacyRed: 17601,
  Glidden_66YY77407_MeadowFlowerYellow: 17602,
  Glidden_66YY83272_FreshcutHoneydew: 17603,
  Glidden_66YY85231_AugustMoon: 17604,
  Glidden_67YY87169_CandlelightYellow: 17605,
  Glidden_67YY89124_NorthStarWhite: 17606,
  Glidden_68YY86042_AngelsHaloWhite: 17607,
  Glidden_69BG77076_BlueIceAge: 17608,
  Glidden_70BG15076_UnionBlue: 17609,
  Glidden_70BG17116_VillageBlue: 17610,
  Glidden_70BG19071_FrenchGrey: 17611,
  Glidden_70BG20196_PersianTurquoise: 17612,
  Glidden_70BG23065_SlateRidge: 17613,
  Glidden_70BG25100_StormySkyBlue: 17614,
  Glidden_70BG28169_BlueJay: 17615,
  Glidden_70BG31124_BrittanyInn: 17616,
  Glidden_70BG32238_HiddenHarborBlue: 17617,
  Glidden_70BG34055_HeritageHomeBlue: 17618,
  Glidden_70BG38143_BrusselsBlue: 17619,
  Glidden_70BG40050_WinterSkyGrey: 17620,
  Glidden_70BG41076_SoftTraditionalBlue: 17621,
  Glidden_70BG41201_MayflowerBlue: 17622,
  Glidden_70BG43103_HarpersBlue: 17623,
  Glidden_70BG44129_SoftRococoBlue: 17624,
  Glidden_70BG47045_DownyGrey: 17625,
  Glidden_70BG51116_CaptainsWalk: 17626,
  Glidden_70BG53164_AtlantisBlue: 17627,
  Glidden_70BG56061_MildWindBlue: 17628,
  Glidden_70BG58103_StencilBlue: 17629,
  Glidden_70BG59124_BlueHydrangea: 17630,
  Glidden_70BG60145_MillRunBlue: 17631,
  Glidden_70BG66108_ClearSummerSky: 17632,
  Glidden_70BG67126_SiestaKeyBlue: 17633,
  Glidden_70BG68038_PalestMorningBlue: 17634,
  Glidden_70BG68163_AftonBlue: 17635,
  Glidden_70BG69094_ClerestoryBlue: 17636,
  Glidden_70BG70131_ClearBlueSky: 17637,
  Glidden_70BG72043_BlueLight: 17638,
  Glidden_70BG72100_CrystalBlueWaters: 17639,
  Glidden_70GG17269_Seawall: 17640,
  Glidden_70GG25242_NiagaraReefJade: 17641,
  Glidden_70GG31228_DarkTourmaline: 17642,
  Glidden_70GG32067_BlueGrassField: 17643,
  Glidden_70GG38059_SilverMountainCreekGreen: 17644,
  Glidden_70GG45052_SummerShowerGreen: 17645,
  Glidden_70GY22165_AwningStripeGreen: 17646,
  Glidden_70GY25272_EmeraldLeafGreen: 17647,
  Glidden_70GY27154_LusciousMoss: 17648,
  Glidden_70GY30254_MistyEmeraldLake: 17649,
  Glidden_70GY33143_FoggyField: 17650,
  Glidden_70GY35237_CulturalGardenGreen: 17651,
  Glidden_70GY42219_ForumGreen: 17652,
  Glidden_70GY46120_PaleJade: 17653,
  Glidden_70GY49201_SeaGlassGreen: 17654,
  Glidden_70GY65166_PastoraleJade: 17655,
  Glidden_70GY73124_SoftGreenMeadow: 17656,
  Glidden_70GY74149_MorningDewDropGreen: 17657,
  Glidden_70GY83060_TranquilLightGreen: 17658,
  Glidden_70GY83100_FrostyMint: 17659,
  Glidden_70RB13095_PlumShadow: 17660,
  Glidden_70RB18117_FrostedMulberry: 17661,
  Glidden_70RB22108_HeathersPlum: 17662,
  Glidden_70RR10140_ChristophersBurgundy: 17663,
  Glidden_70RR15400_FranklyScarlet: 17664,
  Glidden_70RR16207_ColonialBrickRed: 17665,
  Glidden_70RR17372_CanterburyLaneRed: 17666,
  Glidden_70RR19190_CapriRose: 17667,
  Glidden_70RR23173_DustyBrick: 17668,
  Glidden_70RR23409_RubyBlush: 17669,
  Glidden_70RR25338_ArborRose: 17670,
  Glidden_70RR27375_SavannahRose: 17671,
  Glidden_70RR28186_VintageRougeRed: 17672,
  Glidden_70RR32139_ColonyRose: 17673,
  Glidden_70RR39272_LightRoseyBlush: 17674,
  Glidden_70RR41192_QuartzPink: 17675,
  Glidden_70RR43104_SoftMulberryMauve: 17676,
  Glidden_70RR48184_FreshPeonies: 17677,
  Glidden_70RR50087_Mauvedust: 17678,
  Glidden_70RR57070_WinterMauve: 17679,
  Glidden_70RR61136_SweetheartRose: 17680,
  Glidden_70RR64034_ExecutiveTaupe: 17681,
  Glidden_70RR65053_PowderBlush: 17682,
  Glidden_70RR83040_AlmostPink: 17683,
  Glidden_70YR08186_BronzeAmulet: 17684,
  Glidden_70YR13259_FreshBakedPumpernickel: 17685,
  Glidden_70YR17260_ArtistsCopper: 17686,
  Glidden_70YR23650_FieryOrange: 17687,
  Glidden_70YR25106_RowhouseBrown: 17688,
  Glidden_70YR33287_FrostedCopper: 17689,
  Glidden_70YR45261_CozyMelon: 17690,
  Glidden_70YR49332_DramaticCoral: 17691,
  Glidden_70YR50225_AsianApricot: 17692,
  Glidden_70YY18220_EuropeanOlive: 17693,
  Glidden_70YY21210_AntiqueOlive: 17694,
  Glidden_70YY25200_AlligatorPear: 17695,
  Glidden_70YY33310_PreciousOlive: 17696,
  Glidden_70YY37296_SpanishOlive: 17697,
  Glidden_70YY39057_SkippingStoneGrey: 17698,
  Glidden_70YY46053_AgedStuccoGrey: 17699,
  Glidden_70YY46160_FreshThymeGreen: 17700,
  Glidden_70YY46332_TreeFrogGreen: 17701,
  Glidden_70YY49106_SacredOliveGreen: 17702,
  Glidden_70YY51669_BaliBamboo: 17703,
  Glidden_70YY54049_EasternLighthouse: 17704,
  Glidden_70YY55299_SoothingGreenTea: 17705,
  Glidden_70YY55613_FreshenUpLime: 17706,
  Glidden_70YY57098_PacificKhaki: 17707,
  Glidden_70YY59140_SilentFog: 17708,
  Glidden_70YY61561_FreshLemonLime: 17709,
  Glidden_70YY63045_NaturalSilverWool: 17710,
  Glidden_70YY65090_SoftHerbalSage: 17711,
  Glidden_70YY66130_WhiteAmber: 17712,
  Glidden_70YY66265_SpringWillowGreen: 17713,
  Glidden_70YY66510_LemonLimeFizz: 17714,
  Glidden_70YY69484_CitrusLimePunch: 17715,
  Glidden_70YY72041_SilverBirch: 17716,
  Glidden_70YY73083_AntarcticIce: 17717,
  Glidden_70YY73288_CandleGlow: 17718,
  Glidden_70YY73458_BrightHummingbirdYellow: 17719,
  Glidden_70YY75124_ChardonnayWhite: 17720,
  Glidden_70YY75328_FirefliesGlow: 17721,
  Glidden_70YY76165_LoireValleySunrise: 17722,
  Glidden_70YY77207_LimelightYellow: 17723,
  Glidden_70YY83037_WeddingWhite: 17724,
  Glidden_70YY83075_SoftLimeWhite: 17725,
  Glidden_70YY83112_PineappleSorbet: 17726,
  Glidden_70YY83187_CarriageLight: 17727,
  Glidden_70YY83300_GinFizz: 17728,
  Glidden_71YY87078_LinwoodBeachWhite: 17729,
  Glidden_72BG75023_SkatersPond: 17730,
  Glidden_74BG61206_WildBlueYonder: 17731,
  Glidden_74RR28432_WatermelonSmoothie: 17732,
  Glidden_75RR06129_DeepWine: 17733,
  Glidden_75RR63207_CottonCandyPink: 17734,
  Glidden_75YY87137_SpringPearWhite: 17735,
  Glidden_77BG57234_BlueChiffon: 17736,
  Glidden_77YY83073_MorningDaylight: 17737,
  Glidden_78RR54274_PinkFlamingo: 17738,
  Glidden_78RR71148_PinwheelPink: 17739,
  Glidden_78YR39593_DesertOrange: 17740,
  Glidden_79BG53259_PoolParty: 17741,
  Glidden_80YR16193_ToastBrown: 17742,
  Glidden_80YR25206_CopperRoad: 17743,
  Glidden_80YR26323_AutumnBlush: 17744,
  Glidden_80YR29371_BrightCopperCoin: 17745,
  Glidden_80YR32339_SaddleTan: 17746,
  Glidden_80YR35383_MaplewoodTrail: 17747,
  Glidden_80YR36084_CreamyHotCocoa: 17748,
  Glidden_80YR37307_CreamyButterscotch: 17749,
  Glidden_80YR38427_TimeForOrange: 17750,
  Glidden_80YR39347_CaramelizedOrange: 17751,
  Glidden_80YR42073_MidDayMocha: 17752,
  Glidden_80YR44311_ToastedCoconut: 17753,
  Glidden_80YR48274_SoftCopperOrange: 17754,
  Glidden_80YR49062_ClassicTan: 17755,
  Glidden_80YR49382_RipePeach: 17756,
  Glidden_80YR53338_GeorgiaPeach: 17757,
  Glidden_80YR55266_CoralDawn: 17758,
  Glidden_80YR57293_TruePeach: 17759,
  Glidden_80YR65185_AntelopeTan: 17760,
  Glidden_80YR67204_AllysPerfectPeach: 17761,
  Glidden_80YR77115_PeachSilk: 17762,
  Glidden_81RR47323_PinkTigerLily: 17763,
  Glidden_81YY87031_FencepostWhite: 17764,
  Glidden_82RR76111_PowderPink: 17765,
  Glidden_82YY85038_MuslinWhite: 17766,
  Glidden_83YR44540_OrangeSlice: 17767,
  Glidden_83YY85056_BubbleMint: 17768,
  Glidden_84RR13471_CherriesJubilee: 17769,
  Glidden_84RR42368_PrettiestPink: 17770,
  Glidden_84YY87135_PineWhite: 17771,
  Glidden_85GG74144_BayBlue: 17772,
  Glidden_85RR05082_RanchHouseBrown: 17773,
  Glidden_86BG43321_BlueNote: 17774,
  Glidden_86YY77295_LemonGrass: 17775,
  Glidden_87GG60239_EchoLakeAqua: 17776,
  Glidden_88GG32346_MarineBlue: 17777,
  Glidden_88GG68184_IslandShores: 17778,
  Glidden_88YY66447_GreenGrape: 17779,
  Glidden_88YY71380_SpringLeaf: 17780,
  Glidden_89BG37353_AzureAfternoon: 17781,
  Glidden_89BG70116_WindsweptBlue: 17782,
  Glidden_89RR36416_CabanaCoral: 17783,
  Glidden_89YR36694_JackOLantern: 17784,
  Glidden_90BB14242_MajestyViolet: 17785,
  Glidden_90BB19267_DustyViolet: 17786,
  Glidden_90BB21220_PurpleTwilight: 17787,
  Glidden_90BB22247_PlayhousePurple: 17788,
  Glidden_90BB31208_DewyIris: 17789,
  Glidden_90BB41168_AshleysHeather: 17790,
  Glidden_90BB43082_MorningViolet: 17791,
  Glidden_90BB47149_EmpressLilac: 17792,
  Glidden_90BB53129_VioletShimmer: 17793,
  Glidden_90BB58072_IcySpringViolet: 17794,
  Glidden_90BB60109_HintOfHeather: 17795,
  Glidden_90BB67069_LavenderCloud: 17796,
  Glidden_90BB74038_IcyLilac: 17797,
  Glidden_90BG08075_KrimsonLakeBlue: 17798,
  Glidden_90BG11101_ApproachingStorm: 17799,
  Glidden_90BG17090_ConnecticutBlue: 17800,
  Glidden_90BG18150_PacificRimBlue: 17801,
  Glidden_90BG22141_BentonHarbor: 17802,
  Glidden_90BG25079_NightSkyGrey: 17803,
  Glidden_90BG29048_WintersBlueGreySky: 17804,
  Glidden_90BG30073_SmokeGrey: 17805,
  Glidden_90BG31124_LakefrontBlue: 17806,
  Glidden_90BG32199_SecretCoveBlue: 17807,
  Glidden_90BG35068_BlueGreyShadow: 17808,
  Glidden_90BG38185_CountryHouseBlue: 17809,
  Glidden_90BG41040_AscotBlue: 17810,
  Glidden_90BG41062_IslandView: 17811,
  Glidden_90BG43171_BabyBlueEyes: 17812,
  Glidden_90BG48057_SanctuaryBlue: 17813,
  Glidden_90BG50157_JordansBlue: 17814,
  Glidden_90BG56106_IslandMorningBlue: 17815,
  Glidden_90BG57143_TinyBrookBlue: 17816,
  Glidden_90BG63043_FostoriaGlassBlue: 17817,
  Glidden_90BG63072_BlueVeil: 17818,
  Glidden_90BG64101_BastilleBlue: 17819,
  Glidden_90BG72038_EtherealBlue: 17820,
  Glidden_90BG72063_BigChill: 17821,
  Glidden_90BG72088_SoftCloudBlue: 17822,
  Glidden_90GG12168_NassauNight: 17823,
  Glidden_90GG17082_DarkTealWoods: 17824,
  Glidden_90GG19151_TealLagoon: 17825,
  Glidden_90GG21076_BlueForest: 17826,
  Glidden_90GG21219_BatikGreen: 17827,
  Glidden_90GG23142_DeepOceanTeal: 17828,
  Glidden_90GG24174_TealRiviera: 17829,
  Glidden_90GG24323_SailingShipTeal: 17830,
  Glidden_90GG26070_GreyedTealGreen: 17831,
  Glidden_90GG29164_IslandTurquoise: 17832,
  Glidden_90GG30195_TealLake: 17833,
  Glidden_90GG35153_BlueGreenSea: 17834,
  Glidden_90GG37212_SeaOfTurquoise: 17835,
  Glidden_90GG39272_CaribbeanTeal: 17836,
  Glidden_90GG41143_GentleTurquoise: 17837,
  Glidden_90GG42171_PrinceEdwardTeal: 17838,
  Glidden_90GG45254_TimberlakeTeal: 17839,
  Glidden_90GG48132_TrattoriaTeal: 17840,
  Glidden_90GG51211_BermudaBay: 17841,
  Glidden_90GG56122_EveningAquaSky: 17842,
  Glidden_90GG57146_AquaChintz: 17843,
  Glidden_90GG58171_SoftAquaStone: 17844,
  Glidden_90GG59196_GlisteningTeal: 17845,
  Glidden_90GG66134_Freshwater: 17846,
  Glidden_90GG66157_AquaSeawind: 17847,
  Glidden_90GG68203_SeaBreezeTeal: 17848,
  Glidden_90GG74092_LagoonGreen: 17849,
  Glidden_90GG83069_AlpineAirAqua: 17850,
  Glidden_90GY42355_WhimsicalGreen: 17851,
  Glidden_90GY47328_Ferndale: 17852,
  Glidden_90GY54334_PillowMint: 17853,
  Glidden_90GY65275_JacobsJade: 17854,
  Glidden_90GY70221_GracefulGreen: 17855,
  Glidden_90GY72040_MintShadow: 17856,
  Glidden_90GY75139_NewMintGreen: 17857,
  Glidden_90GY76158_ElfHatGreen: 17858,
  Glidden_90GY82028_GlacierLake: 17859,
  Glidden_90GY83114_SublimeLime: 17860,
  Glidden_90RB07075_NighttimePurple: 17861,
  Glidden_90RB08113_DeliciousPlum: 17862,
  Glidden_90RB10105_LegacyPlum: 17863,
  Glidden_90RB75051_ScentOfLilac: 17864,
  Glidden_90RB83030_ElizabethanIcePink: 17865,
  Glidden_90RR10119_WildCranberry: 17866,
  Glidden_90RR11257_TomahawkRed: 17867,
  Glidden_90RR13321_RoseWine: 17868,
  Glidden_90RR14151_AtticTrunkRed: 17869,
  Glidden_90RR16298_PaintedDesertRed: 17870,
  Glidden_90RR16386_BrightGarnet: 17871,
  Glidden_90RR18139_SmokeyClaretMauve: 17872,
  Glidden_90RR18450_RedRedRose: 17873,
  Glidden_90RR20296_RedBluff: 17874,
  Glidden_90RR21418_RetroRose: 17875,
  Glidden_90RR22126_DustyMauve: 17876,
  Glidden_90RR22344_CandystripeRed: 17877,
  Glidden_90RR27440_StrawberryRouge: 17878,
  Glidden_90RR28359_Lipstick: 17879,
  Glidden_90RR30285_FashionFrontRose: 17880,
  Glidden_90RR31100_VioletHush: 17881,
  Glidden_90RR31403_CheeryCherry: 17882,
  Glidden_90RR36087_PinkCupola: 17883,
  Glidden_90RR39327_PolkaDotPink: 17884,
  Glidden_90RR43290_FloridaPink: 17885,
  Glidden_90RR44197_PinkCadillac: 17886,
  Glidden_90RR46225_SoftFrenchPink: 17887,
  Glidden_90RR49061_GreyFuchsia: 17888,
  Glidden_90RR52214_VassarRose: 17889,
  Glidden_90RR56048_ModerneMauve: 17890,
  Glidden_90RR58177_BlushingPink: 17891,
  Glidden_90RR63139_TudorRose: 17892,
  Glidden_90RR64036_WhiteLilac: 17893,
  Glidden_90RR68090_PrincessPearlPink: 17894,
  Glidden_90RR69101_PinkLemonade: 17895,
  Glidden_90RR73027_WoodAnemonePink: 17896,
  Glidden_90YR31131_WoodruffBeige: 17897,
  Glidden_90YR31227_LightAutumnBrown: 17898,
  Glidden_90YR31605_SunlitTopaz: 17899,
  Glidden_90YR36203_BrowningtonCourt: 17900,
  Glidden_90YR43101_CouncilBluffTan: 17901,
  Glidden_90YR45427_MightySpicy: 17902,
  Glidden_90YR46346_SanMateoPeach: 17903,
  Glidden_90YR49085_MochaBisque: 17904,
  Glidden_90YR49382_ColoradoDawn: 17905,
  Glidden_90YR53338_CoralSpice: 17906,
  Glidden_90YR54440_OrangeCantaloupe: 17907,
  Glidden_90YR55051_KennettSquareTaupe: 17908,
  Glidden_90YR55266_SweetMelon: 17909,
  Glidden_90YR57293_Apricot: 17910,
  Glidden_90YR64040_ClayBisque: 17911,
  Glidden_90YR67204_PeachChiffon: 17912,
  Glidden_90YR73029_Heatherbelle: 17913,
  Glidden_90YY10186_DeepMossyForest: 17914,
  Glidden_90YY22200_TrulyOlive: 17915,
  Glidden_90YY26189_HedgerowOlive: 17916,
  Glidden_90YY27336_OliveCountry: 17917,
  Glidden_90YY35169_PacificPinesSage: 17918,
  Glidden_90YY40158_AlwaysAvocado: 17919,
  Glidden_90YY43271_SpringBudGreen: 17920,
  Glidden_90YY46148_SandaracSage: 17921,
  Glidden_90YY48500_EnglishApple: 17922,
  Glidden_90YY52138_PrairieSage: 17923,
  Glidden_90YY52303_EssenceOfSpring: 17924,
  Glidden_90YY55049_GreyNuance: 17925,
  Glidden_90YY58424_GrannySmithApple: 17926,
  Glidden_90YY59127_JuniperBerrySage: 17927,
  Glidden_90YY62264_SpringCactus: 17928,
  Glidden_90YY63044_PolishedLimestone: 17929,
  Glidden_90YY67117_FrostedGreenGrape: 17930,
  Glidden_90YY72225_CelerySticks: 17931,
  Glidden_90YY72390_Limefrost: 17932,
  Glidden_90YY73040_LightSilverSage: 17933,
  Glidden_90YY74080_CatGrass: 17934,
  Glidden_90YY80281_AspenGlen: 17935,
  Glidden_90YY83071_ShamrockWhite: 17936,
  Glidden_90YY83143_LightSpringBlossomGreen: 17937,
  Glidden_95RB71132_FrostedPink: 17938,
  Glidden_96RR08311_OrientalBerry: 17939,
  Glidden_97YR44642_Carotene: 17940,
  Glidden_98BG26393_BlueSapphire: 17941,
  Glidden_98RR06206_OldMahogany: 17942,
  Glidden_98RR12480_RedRoseBouquet: 17943,
  Glidden_98RR80078_BarelyBlush: 17944,
  Glidden_98YR65333_OrangeSherbet: 17945,
  Glidden_98YY82022_SwanWhite: 17946,
  Glidden_99BG62159_SweetBabyBoy: 17947,
  Glidden_99RR27498_PinkSalmon: 17948,
  Glidden_99YR85075_AdorablePeach: 17949,
  Glidden_A0110_MountainMist: 1835,
  Glidden_A0129_WintersDay: 1836,
  Glidden_A0298_MochaTreat: 1837,
  Glidden_A0413_FudgeCookie: 1838,
  Glidden_A0443_Embrace: 1839,
  Glidden_A0551_Sonora: 1840,
  Glidden_A0577_Peachlight: 1841,
  Glidden_A0741_Bentwood: 1842,
  Glidden_A0744_LuminaryYellow: 1843,
  Glidden_A0752_SandDune: 1844,
  Glidden_A0863_EloquentIvory: 1845,
  Glidden_A0865_BellcourtCastle: 1846,
  Glidden_A0950_ArtichokeLeaf: 1847,
  Glidden_A0980_PlantationGreen: 1848,
  Glidden_A1134_StWilliamsStreet: 1849,
  Glidden_A1228_BermudaPool: 1850,
  Glidden_A1416_FinnishBlue: 1851,
  Glidden_A1441_MoonlightDrive: 1852,
  Glidden_A1813_ThatchedCottage: 1853,
  Glidden_A1817_Camelcoat: 1854,
  Glidden_A1826_DeaconsBench: 1855,
  Glidden_A1827_HaleVillage: 1856,
  Glidden_A1836_FossilGrey: 1857,
  Glidden_A1844_Manuscript: 1858,
  Glidden_A1848_OliveBrown: 1859,
  Glidden_A1868_KingsCanyonGrey: 1860,
  Glidden_A1892_MillersCove: 1861,
  Glidden_A1908_Etching: 1862,
  Glidden_A1924_Bicentennial: 1863,
  Glidden_A1945_GreatGrey: 1864,
  Glidden_A1952_MysterySound: 1865,
  Glidden_A2014_ObsidianGlass: 1866,
  Glidden_PPG0993_1_Peregrine: 17950,
  Glidden_PPG0993_2_Train: 17951,
  Glidden_PPG0993_3_GoslingGray: 17952,
  Glidden_PPG0993_4_GraySuit: 17953,
  Glidden_PPG0993_5_SuperheroGray: 17954,
  Glidden_PPG0993_6_OldSilk: 17955,
  Glidden_PPG0993_7_MoodySky: 17956,
  Glidden_PPG0994_1_AfraidOfTheDark: 17957,
  Glidden_PPG0994_2_PittsburghGray: 17958,
  Glidden_PPG0994_3_HalfDome: 17959,
  Glidden_PPG0994_4_Hippopotamus: 17960,
  Glidden_PPG0994_5_SteelCurtain: 17961,
  Glidden_PPG0994_6_HuskyGray: 17962,
  Glidden_PPG0994_7_Pencilpoint: 17963,
  Glidden_PPG0995_1_ShadedWhisper: 17964,
  Glidden_PPG0995_2_AncientCloud: 17965,
  Glidden_PPG0995_3_SilverBand: 17966,
  Glidden_PPG0995_4_PigeonFeather: 17967,
  Glidden_PPG0995_5_BurnishedBlade: 17968,
  Glidden_PPG0995_6_CitySkyline: 17969,
  Glidden_PPG0995_7_StarlessSky: 17970,
  Glidden_PPG0996_1_ShiningScale: 17971,
  Glidden_PPG0996_2_SteelyGaze: 17972,
  Glidden_PPG0996_3_StatueGarden: 17973,
  Glidden_PPG0996_4_CloudySlate: 17974,
  Glidden_PPG0996_5_Steamship: 17975,
  Glidden_PPG0996_6_SlateMine: 17976,
  Glidden_PPG0996_7_SummerShadow: 17977,
  Glidden_PPG0997_1_AlleghenyRiver: 17978,
  Glidden_PPG0997_2_FeltedWool: 17979,
  Glidden_PPG0997_3_FreshGranite: 17980,
  Glidden_PPG0997_4_Precipitation: 17981,
  Glidden_PPG0997_5_PlayingPossum: 17982,
  Glidden_PPG0997_6_IndustrialRevolution: 17983,
  Glidden_PPG0997_7_BlackWidow: 17984,
  Glidden_PPG0998_1_CottonTail: 17985,
  Glidden_PPG0998_2_HikersParadise: 17986,
  Glidden_PPG0998_3_Kalispell: 17987,
  Glidden_PPG0998_4_Shadowy: 17988,
  Glidden_PPG0998_5_MtRainier: 17989,
  Glidden_PPG0998_6_OnTheEdge: 17990,
  Glidden_PPG0998_7_Undercover: 1984,
  Glidden_PPG0999_1_InTheCloud: 17991,
  Glidden_PPG0999_2_RabbitsEar: 23146,
  Glidden_PPG0999_2RabbitsEar: 17992,
  Glidden_PPG0999_3_BoulderCreek: 17993,
  Glidden_PPG0999_4_SteepedTea: 17994,
  Glidden_PPG0999_5_SweaterWeather: 17995,
  Glidden_PPG0999_6_StolenRock: 17996,
  Glidden_PPG0999_7_DarkWoods: 17997,
  Glidden_PPG10_01_Oceania: 17998,
  Glidden_PPG10_02_SorcerersSpell: 23147,
  Glidden_PPG10_02SorcerersSpell: 17999,
  Glidden_PPG10_03_TwilightStroll: 18000,
  Glidden_PPG10_04_Polaris: 18001,
  Glidden_PPG10_05_OysterWhite: 18002,
  Glidden_PPG10_06_Thunderbolt: 18003,
  Glidden_PPG10_07_BayOfFundy: 18004,
  Glidden_PPG10_08_GaleForce: 18005,
  Glidden_PPG10_09_SoothingSapphire: 18006,
  Glidden_PPG10_10_HatterasGray: 18007,
  Glidden_PPG10_11_Seastone: 18008,
  Glidden_PPG10_12_CoolGray: 18009,
  Glidden_PPG10_13_Foretell: 18010,
  Glidden_PPG10_14_Stormy: 18011,
  Glidden_PPG10_15_Quest: 18012,
  Glidden_PPG10_16_Artifact: 18013,
  Glidden_PPG10_17_BlueOpal: 18014,
  Glidden_PPG10_19_FavoriteFlannel: 18015,
  Glidden_PPG10_20_CoastOfMaine: 18016,
  Glidden_PPG10_21_Acceleration: 18017,
  Glidden_PPG10_22_LicenseToDream: 18018,
  Glidden_PPG10_23_AsterPetal: 18019,
  Glidden_PPG10_24_Inevitable: 18020,
  Glidden_PPG10_25_WintersBreath: 23148,
  Glidden_PPG10_25WintersBreath: 18021,
  Glidden_PPG10_26_SimplyElegant: 18022,
  Glidden_PPG10_27_Tradewinds: 18023,
  Glidden_PPG10_28_Peace: 18024,
  Glidden_PPG10_29_DustyAqua: 18025,
  Glidden_PPG10_30_NiagaraMist: 18026,
  Glidden_PPG10_31_WhiteClover: 18027,
  Glidden_PPG10_32_BlueTang: 18028,
  Glidden_PPG1000_1_DustBunny: 18029,
  Glidden_PPG1000_2_RockyRoad: 18030,
  Glidden_PPG1000_3_Fieldstone: 18031,
  Glidden_PPG1000_4_WinterCocoa: 18032,
  Glidden_PPG1000_5_BearCub: 18033,
  Glidden_PPG1000_6_Thunderstruck: 18034,
  Glidden_PPG1000_7_ChocolateLab: 18035,
  Glidden_PPG1001_1_DelicateWhite: 18036,
  Glidden_PPG1001_2_Aria: 18037,
  Glidden_PPG1001_3_ThinIce: 18038,
  Glidden_PPG1001_4_Flagstone: 18039,
  Glidden_PPG1001_5_DoverGray: 18040,
  Glidden_PPG1001_6_KnightsArmor: 23149,
  Glidden_PPG1001_6KnightsArmor: 18041,
  Glidden_PPG1001_7_BlackMagic: 1985,
  Glidden_PPG1002_1_SilverFeather: 18042,
  Glidden_PPG1002_2_ArcticCotton: 18043,
  Glidden_PPG1002_3_CoolSlate: 18044,
  Glidden_PPG1002_4_GrayMarble: 18045,
  Glidden_PPG1002_5_AntiqueSilver: 18046,
  Glidden_PPG1002_6_GibraltarGray: 18047,
  Glidden_PPG1002_7_PhantomMist: 18048,
  Glidden_PPG1003_1_FallChill: 18049,
  Glidden_PPG1003_2_Balanced: 18050,
  Glidden_PPG1003_3_SilverBells: 18051,
  Glidden_PPG1003_4_Equilibrium: 18052,
  Glidden_PPG1003_5_ShiningArmor: 18053,
  Glidden_PPG1003_6_CrackedSlate: 18054,
  Glidden_PPG1003_7_Blackhearth: 18055,
  Glidden_PPG1004_1_GoToGray: 18056,
  Glidden_PPG1004_2_FreeReign: 18057,
  Glidden_PPG1004_3_Hush: 18058,
  Glidden_PPG1004_4_SilverService: 18059,
  Glidden_PPG1004_5_PewterMug: 18060,
  Glidden_PPG1004_6_PhantomHue: 18061,
  Glidden_PPG1004_7_BlackElegance: 18062,
  Glidden_PPG1005_1_DuskyDawn: 18063,
  Glidden_PPG1005_2_Elusion: 18064,
  Glidden_PPG1005_3_GrayShadows: 18065,
  Glidden_PPG1005_4_SlatePebble: 18066,
  Glidden_PPG1005_5_ElephantGray: 18067,
  Glidden_PPG1005_6_OswegoTea: 18068,
  Glidden_PPG1005_7_DarkGranite: 18069,
  Glidden_PPG1006_1_Gypsum: 1986,
  Glidden_PPG1006_2_Shark: 1987,
  Glidden_PPG1006_3_EarlyEvening: 1988,
  Glidden_PPG1006_4_Mercurial: 18070,
  Glidden_PPG1006_5_SoSublime: 18071,
  Glidden_PPG1006_6_Deconstruction: 18072,
  Glidden_PPG1006_7_Metropolis: 18073,
  Glidden_PPG1007_1_WillowSprings: 18074,
  Glidden_PPG1007_2_SwirlingSmoke: 18075,
  Glidden_PPG1007_3_GhostWriter: 18076,
  Glidden_PPG1007_4_HotStone: 1989,
  Glidden_PPG1007_5_LazyAfternoon: 18077,
  Glidden_PPG1007_6_CoolCharcoal: 1990,
  Glidden_PPG1007_7_Bark: 18078,
  Glidden_PPG1008_1_Focus: 18079,
  Glidden_PPG1008_2_StormsComing: 23150,
  Glidden_PPG1008_2StormsComing: 18080,
  Glidden_PPG1008_3_Greyhound: 18081,
  Glidden_PPG1008_4_GrayByMe: 18082,
  Glidden_PPG1008_5_RollerCoaster: 18083,
  Glidden_PPG1008_6_Artillery: 18084,
  Glidden_PPG1008_7_StonesThrow: 23151,
  Glidden_PPG1008_7StonesThrow: 18085,
  Glidden_PPG1009_1_TundraFrost: 18086,
  Glidden_PPG1009_2_Tornado: 18087,
  Glidden_PPG1009_3_SolitaryState: 18088,
  Glidden_PPG1009_4_GrayStone: 18089,
  Glidden_PPG1009_5_PhoenixFossil: 18090,
  Glidden_PPG1009_6_Armory: 18091,
  Glidden_PPG1009_7_Licorice: 18092,
  Glidden_PPG1010_1_Pegasus: 18093,
  Glidden_PPG1010_2_Fog: 18094,
  Glidden_PPG1010_3_Solstice: 18095,
  Glidden_PPG1010_4_SteppingStone: 18096,
  Glidden_PPG1010_5_Downpour: 18097,
  Glidden_PPG1010_6_UpInSmoke: 1991,
  Glidden_PPG1010_7_Zombie: 18098,
  Glidden_PPG1011_1_PacificPearl: 18099,
  Glidden_PPG1011_2_Elemental: 18100,
  Glidden_PPG1011_3_Stargazer: 18101,
  Glidden_PPG1011_4_Ufo: 18102,
  Glidden_PPG1011_5_Improbable: 18103,
  Glidden_PPG1011_6_GlazedGranite: 18104,
  Glidden_PPG1011_7_Onyx: 18105,
  Glidden_PPG1012_1_IcyBay: 18106,
  Glidden_PPG1012_2_InvernessGray: 18107,
  Glidden_PPG1012_3_Tinsel: 18108,
  Glidden_PPG1012_4_GrayFrost: 18109,
  Glidden_PPG1012_5_SteepleGray: 18110,
  Glidden_PPG1012_6_VolcanicAsh: 18111,
  Glidden_PPG1012_7_BlackForest: 18112,
  Glidden_PPG1013_1_Radisson: 18113,
  Glidden_PPG1013_2_SpringThaw: 18114,
  Glidden_PPG1013_3_Whirlwind: 18115,
  Glidden_PPG1013_4_SilverCharm: 18116,
  Glidden_PPG1013_5_VictorianPewter: 18117,
  Glidden_PPG1013_6_GrayFlannel: 18118,
  Glidden_PPG1013_7_Napoleon: 18119,
  Glidden_PPG1014_1_GlacialIce: 18120,
  Glidden_PPG1014_2_GrayWhisper: 18121,
  Glidden_PPG1014_4_JackRabbit: 18122,
  Glidden_PPG1014_5_GrayViolet: 18123,
  Glidden_PPG1014_6_EagleEye: 18124,
  Glidden_PPG1014_7_BlackWalnut: 18125,
  Glidden_PPG1015_1_VanillaMilkshake: 18126,
  Glidden_PPG1015_2_StoneQuarry: 18127,
  Glidden_PPG1015_3_Warmstone: 18128,
  Glidden_PPG1015_4_Subdued: 18129,
  Glidden_PPG1015_5_Heliotrope: 18130,
  Glidden_PPG1015_6_GraniteBoulder: 18131,
  Glidden_PPG1015_7_Mustang: 18132,
  Glidden_PPG1016_1_BerryFrost: 18133,
  Glidden_PPG1016_2_BlossomPink: 18134,
  Glidden_PPG1016_3_CheerfulHeart: 18135,
  Glidden_PPG1016_4_ForeverFairytale: 18136,
  Glidden_PPG1016_5_IrisMauve: 18137,
  Glidden_PPG1016_6_Woodchuck: 18138,
  Glidden_PPG1016_7_SpicedWine: 18139,
  Glidden_PPG1017_1_Touchable: 18140,
  Glidden_PPG1017_2_FirstKiss: 18141,
  Glidden_PPG1017_3_FondMemory: 18142,
  Glidden_PPG1017_4_RiveterRose: 18143,
  Glidden_PPG1017_5_CinnamonToast: 18144,
  Glidden_PPG1017_6_BoldBrandy: 18145,
  Glidden_PPG1017_7_ChocolatePretzel: 18146,
  Glidden_PPG1018_1_SteelMe: 18147,
  Glidden_PPG1018_2_MyAlibi: 18148,
  Glidden_PPG1018_4_WintersNap: 23152,
  Glidden_PPG1018_4WintersNap: 18149,
  Glidden_PPG1018_5_Talavera: 18150,
  Glidden_PPG1018_6_Flipper: 18151,
  Glidden_PPG1018_7_Sarsaparilla: 18152,
  Glidden_PPG1019_1_ToastedMarshmallow: 18153,
  Glidden_PPG1019_2_InTheBuff: 18154,
  Glidden_PPG1019_3_Legendary: 18155,
  Glidden_PPG1019_4_SimmeringSmoke: 18156,
  Glidden_PPG1019_5_WildWilderness: 18157,
  Glidden_PPG1019_6_TattleTail: 18158,
  Glidden_PPG1019_7_Intrigue: 18159,
  Glidden_PPG1020_1_AtriumWhite: 18160,
  Glidden_PPG1020_2_MaybeMushroom: 18161,
  Glidden_PPG1020_3_Whippet: 18162,
  Glidden_PPG1020_5_EarlGray: 18163,
  Glidden_PPG1020_6_WickerBasket: 18164,
  Glidden_PPG1020_7_Dolce: 18165,
  Glidden_PPG1021_1_MountainGray: 18166,
  Glidden_PPG1021_2_Synchronicity: 18167,
  Glidden_PPG1021_3_Discover: 18168,
  Glidden_PPG1021_4_Diversion: 18169,
  Glidden_PPG1021_5_Thunderbird: 18170,
  Glidden_PPG1021_7_CabinFever: 18171,
  Glidden_PPG1022_1_Hourglass: 18172,
  Glidden_PPG1022_2_Intuitive: 18173,
  Glidden_PPG1022_3_SilverDollar: 18174,
  Glidden_PPG1022_4_RockSlide: 18175,
  Glidden_PPG1022_5_EiffelTower: 18176,
  Glidden_PPG1022_6_Granite: 18177,
  Glidden_PPG1022_7_StarAnise: 18178,
  Glidden_PPG1023_1_Oatmeal: 18179,
  Glidden_PPG1023_2_CoolConcrete: 18180,
  Glidden_PPG1023_3_Ashen: 18181,
  Glidden_PPG1023_4_DesertDune: 1992,
  Glidden_PPG1023_5_StoneGray: 18182,
  Glidden_PPG1023_6_ClamShell: 18183,
  Glidden_PPG1023_7_AfternoonTea: 18184,
  Glidden_PPG1024_1_OffWhite: 18185,
  Glidden_PPG1024_2_AntiqueWhite: 18186,
  Glidden_PPG1024_3_CrushedSilk: 18187,
  Glidden_PPG1024_4_MothGray: 1993,
  Glidden_PPG1024_5_StonehengeGreige: 18188,
  Glidden_PPG1024_6_Patches: 18189,
  Glidden_PPG1024_7_FriarsBrown: 23153,
  Glidden_PPG1024_7FriarsBrown: 18190,
  Glidden_PPG1025_1_CommercialWhite: 1994,
  Glidden_PPG1025_2_SilentSmoke: 18191,
  Glidden_PPG1025_3_Whiskers: 18192,
  Glidden_PPG1025_4_Sharkskin: 18193,
  Glidden_PPG1025_5_DarkAsh: 18194,
  Glidden_PPG1025_6_SleepingGiant: 18195,
  Glidden_PPG1025_7_CoffeeBean: 18196,
  Glidden_PPG1026_1_Namaste: 18197,
  Glidden_PPG1026_2_Sanctuary: 18198,
  Glidden_PPG1026_3_Easy: 18199,
  Glidden_PPG1026_4_Karma: 18200,
  Glidden_PPG1026_5_Gristmill: 18201,
  Glidden_PPG1026_6_BronzeStatue: 18202,
  Glidden_PPG1026_7_HipWaders: 18203,
  Glidden_PPG1027_1_Cocoon: 18204,
  Glidden_PPG1027_2_SkippingStone: 18205,
  Glidden_PPG1027_3_HeavyHammock: 18206,
  Glidden_PPG1027_4_OliveGray: 18207,
  Glidden_PPG1027_5_RattanPalm: 18208,
  Glidden_PPG1027_6_Conservation: 18209,
  Glidden_PPG1027_7_Grapevine: 18210,
  Glidden_PPG1028_1_HintOfPine: 18211,
  Glidden_PPG1028_2_WithATwist: 18212,
  Glidden_PPG1028_3_PineCrush: 18213,
  Glidden_PPG1028_4_SmokySlate: 18214,
  Glidden_PPG1028_5_AutumnGray: 18215,
  Glidden_PPG1028_6_Momentum: 18216,
  Glidden_PPG1028_7_WalnutGrove: 18217,
  Glidden_PPG1029_1_SilveryMoon: 18218,
  Glidden_PPG1029_2_VeilOfDusk: 18219,
  Glidden_PPG1029_3_FrenchGrayLinen: 18220,
  Glidden_PPG1029_4_PhotoGray: 18221,
  Glidden_PPG1029_5_Meander: 18222,
  Glidden_PPG1029_6_Organic: 18223,
  Glidden_PPG1029_7_PlungePool: 18224,
  Glidden_PPG1030_1_Brainstorm: 18225,
  Glidden_PPG1030_2_PalePine: 18226,
  Glidden_PPG1030_3_MellowMood: 18227,
  Glidden_PPG1030_4_Edamame: 18228,
  Glidden_PPG1030_5_Mesmerize: 18229,
  Glidden_PPG1030_6_PositivelyPalm: 18230,
  Glidden_PPG1030_7_DoubleDuty: 18231,
  Glidden_PPG1031_1_MixOrMatch: 18232,
  Glidden_PPG1031_2_MistyMeadow: 18233,
  Glidden_PPG1031_3_WanderingWillow: 18234,
  Glidden_PPG1031_4_Restoration: 18235,
  Glidden_PPG1031_5_SeaweedWrap: 18236,
  Glidden_PPG1031_6_Nevergreen: 18237,
  Glidden_PPG1031_7_Osiris: 18238,
  Glidden_PPG1032_1_MetallicMist: 18239,
  Glidden_PPG1032_2_HurricaneHaze: 18240,
  Glidden_PPG1032_3_OliveIt: 18241,
  Glidden_PPG1032_4_Sylvan: 18242,
  Glidden_PPG1032_5_Tortuga: 18243,
  Glidden_PPG1032_6_KingsCourt: 23154,
  Glidden_PPG1032_6KingsCourt: 18244,
  Glidden_PPG1032_7_MossRock: 18245,
  Glidden_PPG1033_1_SaltyBreeze: 18246,
  Glidden_PPG1033_2_WaywardWillow: 18247,
  Glidden_PPG1033_3_SilentStorm: 18248,
  Glidden_PPG1033_4_LightDrizzle: 1995,
  Glidden_PPG1033_5_GrayHeron: 18249,
  Glidden_PPG1033_6_GunmetalGray: 18250,
  Glidden_PPG1033_7_CharcoalSmoke: 18251,
  Glidden_PPG1034_1_MorningSong: 18252,
  Glidden_PPG1034_2_Honesty: 18253,
  Glidden_PPG1034_3_PristinePetal: 18254,
  Glidden_PPG1034_4_MistySurf: 18255,
  Glidden_PPG1034_5_AquaSmoke: 18256,
  Glidden_PPG1034_6_BlueBlood: 18257,
  Glidden_PPG1034_7_MountainPine: 18258,
  Glidden_PPG1035_1_WateryBlue: 18259,
  Glidden_PPG1035_2_SkyDiving: 18260,
  Glidden_PPG1035_3_BlueByYou: 18261,
  Glidden_PPG1035_4_SymphonyOfBlue: 18262,
  Glidden_PPG1035_5_PuddleJumper: 18263,
  Glidden_PPG1035_6_Superstition: 18264,
  Glidden_PPG1035_7_Obsidian: 18265,
  Glidden_PPG1036_1_GrayGlimpse: 18266,
  Glidden_PPG1036_2_WinterChill: 18267,
  Glidden_PPG1036_3_NauticalStar: 18268,
  Glidden_PPG1036_4_AfterTheStorm: 18269,
  Glidden_PPG1036_5_RoughRide: 18270,
  Glidden_PPG1036_6_Phantom: 18271,
  Glidden_PPG1036_7_MostlyMetal: 18272,
  Glidden_PPG1037_1_SeaFrost: 18273,
  Glidden_PPG1037_2_SkySplash: 18274,
  Glidden_PPG1037_3_SpecialDelivery: 18275,
  Glidden_PPG1037_4_Symmetry: 18276,
  Glidden_PPG1037_5_NightRendezvous: 18277,
  Glidden_PPG1037_6_Mysterious: 18278,
  Glidden_PPG1037_7_Witchcraft: 18279,
  Glidden_PPG1038_1_EveningMist: 18280,
  Glidden_PPG1038_2_Dewdrop: 18281,
  Glidden_PPG1038_3_WintersBreath: 23155,
  Glidden_PPG1038_4_SmokeScreen: 18282,
  Glidden_PPG1038_5_Feldspar: 18283,
  Glidden_PPG1038_6_LavaGray: 18284,
  Glidden_PPG1038_7_MidnightHour: 18285,
  Glidden_PPG1039_1_GhostWhisperer: 18286,
  Glidden_PPG1039_2_MaidenMist: 18287,
  Glidden_PPG1039_3_MirrorMirror: 18288,
  Glidden_PPG1039_4_Pachyderm: 18289,
  Glidden_PPG1039_5_GarrisonGray: 18290,
  Glidden_PPG1039_6_InTheShadows: 18291,
  Glidden_PPG1039_7_HighSalute: 18292,
  Glidden_PPG1040_1_Zen: 18293,
  Glidden_PPG1040_2_Keepsakes: 18294,
  Glidden_PPG1040_3_OceanDrive: 18295,
  Glidden_PPG1040_4_SetInStone: 18296,
  Glidden_PPG1040_5_LostAtSea: 18297,
  Glidden_PPG1040_6_FreedomFound: 18298,
  Glidden_PPG1040_7_Goblin: 18299,
  Glidden_PPG1041_1_MoonlitSnow: 18300,
  Glidden_PPG1041_2_CityLights: 18301,
  Glidden_PPG1041_3_BillowingClouds: 18302,
  Glidden_PPG1041_4_BlueDolphin: 18303,
  Glidden_PPG1041_5_Quicksilver: 18304,
  Glidden_PPG1041_6_SheffieldGray: 18305,
  Glidden_PPG1041_7_Cavalry: 1996,
  Glidden_PPG1042_1_CallaLily: 18306,
  Glidden_PPG1042_2_WinterHaven: 18307,
  Glidden_PPG1042_3_OceanDream: 18308,
  Glidden_PPG1042_4_BlueBeard: 18309,
  Glidden_PPG1042_5_PropheticSea: 18310,
  Glidden_PPG1042_6_BlueZephyr: 18311,
  Glidden_PPG1042_7_Admiralty: 18312,
  Glidden_PPG1043_1_Snowbank: 18313,
  Glidden_PPG1043_2_Moondance: 18314,
  Glidden_PPG1043_3_WaywardWinds: 18315,
  Glidden_PPG1043_4_GlisteningGray: 18316,
  Glidden_PPG1043_5_FlannelPajamas: 18317,
  Glidden_PPG1043_6_AlleyCat: 18318,
  Glidden_PPG1043_7_BlackFlame: 18319,
  Glidden_PPG1044_1_LoveBird: 18320,
  Glidden_PPG1044_2_MauveWisp: 18321,
  Glidden_PPG1044_3_TintedRosewood: 18322,
  Glidden_PPG1044_4_Mauvelous: 18323,
  Glidden_PPG1044_5_WinsomeRose: 18324,
  Glidden_PPG1044_6_WildStrawberry: 18325,
  Glidden_PPG1044_7_WildPlum: 18326,
  Glidden_PPG1045_1_MagicalMoonlight: 18327,
  Glidden_PPG1045_2_BarelyRose: 18328,
  Glidden_PPG1045_3_SantolinaBlooms: 18329,
  Glidden_PPG1045_4_PinkPotion: 18330,
  Glidden_PPG1045_5_KeepsakeRose: 18331,
  Glidden_PPG1045_6_WildGeranium: 18332,
  Glidden_PPG1045_7_ChilledWine: 18333,
  Glidden_PPG1046_1_MilkAndCookies: 18334,
  Glidden_PPG1046_2_MagicMoments: 18335,
  Glidden_PPG1046_3_OldMissionPink: 18336,
  Glidden_PPG1046_4_HighSociety: 18337,
  Glidden_PPG1046_5_GothicAmethyst: 18338,
  Glidden_PPG1046_6_VelvetSlipper: 18339,
  Glidden_PPG1046_7_PurpleBasil: 18340,
  Glidden_PPG1047_1_ForeverFaithful: 18341,
  Glidden_PPG1047_2_LostLove: 18342,
  Glidden_PPG1047_3_JustGorgeous: 18343,
  Glidden_PPG1047_4_Ancestral: 18344,
  Glidden_PPG1047_5_CoffeeCustard: 18345,
  Glidden_PPG1047_6_ChooChoo: 18346,
  Glidden_PPG1047_7_CarobChip: 18347,
  Glidden_PPG1048_1_LaurensLace: 23156,
  Glidden_PPG1048_1LaurensLace: 18348,
  Glidden_PPG1048_2_SilkSheets: 18349,
  Glidden_PPG1048_3_RoseCloud: 18350,
  Glidden_PPG1048_4_RoseStain: 18351,
  Glidden_PPG1048_5_CoffeeRose: 18352,
  Glidden_PPG1048_6_ChocolateSparkle: 18353,
  Glidden_PPG1048_7_Gooseberry: 18354,
  Glidden_PPG1049_1_SnowyMount: 18355,
  Glidden_PPG1049_2_SweetBianca: 18356,
  Glidden_PPG1049_3_Nostalgia: 18357,
  Glidden_PPG1049_4_LightheartedRose: 18358,
  Glidden_PPG1049_5_MauveMadness: 18359,
  Glidden_PPG1049_6_Cabernet: 18360,
  Glidden_PPG1049_7_RedRedWine: 18361,
  Glidden_PPG1050_1_BarePink: 18362,
  Glidden_PPG1050_2_PinkPail: 18363,
  Glidden_PPG1050_3_LoveInAMist: 18364,
  Glidden_PPG1050_4_MadagascarPink: 18365,
  Glidden_PPG1050_5_BriarRose: 18366,
  Glidden_PPG1050_6_HeartsContent: 23157,
  Glidden_PPG1050_6HeartsContent: 18367,
  Glidden_PPG1050_7_Magenta: 18368,
  Glidden_PPG1051_1_CozyCottage: 18369,
  Glidden_PPG1051_2_PinkCardoon: 18370,
  Glidden_PPG1051_3_StrawberryMousse: 18371,
  Glidden_PPG1051_4_PinkClayPot: 18372,
  Glidden_PPG1051_5_Cranberry: 18373,
  Glidden_PPG1051_6_Grenadine: 18374,
  Glidden_PPG1051_7_AppleADay: 18375,
  Glidden_PPG1052_1_GingerCream: 18376,
  Glidden_PPG1052_2_BrandyAlexander: 18377,
  Glidden_PPG1052_3_Strawflower: 18378,
  Glidden_PPG1052_4_FloralTapestry: 18379,
  Glidden_PPG1052_5_HorizonGlow: 18380,
  Glidden_PPG1052_6_MesaRed: 18381,
  Glidden_PPG1052_7_RubyLips: 18382,
  Glidden_PPG1053_1_CowsMilk: 23158,
  Glidden_PPG1053_1CowsMilk: 18383,
  Glidden_PPG1053_2_ShangriLa: 18384,
  Glidden_PPG1053_3_PowderedPetals: 18385,
  Glidden_PPG1053_4_RadiantRouge: 18386,
  Glidden_PPG1053_5_BrandySnaps: 18387,
  Glidden_PPG1053_6_ClayRidge: 18388,
  Glidden_PPG1053_7_BurgundyWine: 18389,
  Glidden_PPG1054_1_WinterWedding: 18390,
  Glidden_PPG1054_2_SweetTruffle: 18391,
  Glidden_PPG1054_3_Whirligig: 18392,
  Glidden_PPG1054_4_TeaTime: 18393,
  Glidden_PPG1054_5_TawnyMushroom: 18394,
  Glidden_PPG1054_6_OakwoodBrown: 18395,
  Glidden_PPG1054_7_ChocolateEclair: 18396,
  Glidden_PPG1055_1_FreshDough: 18397,
  Glidden_PPG1055_2_HawaiianShell: 18398,
  Glidden_PPG1055_3_RoseHip: 18399,
  Glidden_PPG1055_4_Pepperberry: 18400,
  Glidden_PPG1055_5_CinnamonDiamonds: 18401,
  Glidden_PPG1055_6_BarnDoor: 18402,
  Glidden_PPG1055_7_Bordeaux: 18403,
  Glidden_PPG1056_1_SeaAnemone: 18404,
  Glidden_PPG1056_2_Romeo: 18405,
  Glidden_PPG1056_3_AshesOfRoses: 18406,
  Glidden_PPG1056_4_RaffiaCream: 18407,
  Glidden_PPG1056_5_EarthRose: 18408,
  Glidden_PPG1056_6_FireWeed: 18409,
  Glidden_PPG1056_7_BrickDust: 18410,
  Glidden_PPG1057_1_MacadamiaNut: 18411,
  Glidden_PPG1057_2_CoolMelon: 18412,
  Glidden_PPG1057_3_RosePetal: 18413,
  Glidden_PPG1057_5_ChiliPepper: 18414,
  Glidden_PPG1057_6_SiennaRed: 18415,
  Glidden_PPG1057_7_BurningBush: 18416,
  Glidden_PPG1058_1_Potpourri: 18417,
  Glidden_PPG1058_2_CameoPeach: 18418,
  Glidden_PPG1058_3_TangyTaffy: 18419,
  Glidden_PPG1058_4_MesaPink: 18420,
  Glidden_PPG1058_5_Sunstone: 18421,
  Glidden_PPG1058_6_PizzaPie: 18422,
  Glidden_PPG1058_7_AutumnRidge: 18423,
  Glidden_PPG1059_1_ApricotCream: 18424,
  Glidden_PPG1059_2_BirthdayCake: 18425,
  Glidden_PPG1059_3_Reindeer: 18426,
  Glidden_PPG1059_4_Parfait: 18427,
  Glidden_PPG1059_5_FerrisWheel: 18428,
  Glidden_PPG1059_7_SweetSpiceberry: 18429,
  Glidden_PPG1060_1_WinterPeach: 18430,
  Glidden_PPG1060_2_ChinaSilk: 18431,
  Glidden_PPG1060_3_KangarooPaw: 18432,
  Glidden_PPG1060_4_VelveteenCrush: 18433,
  Glidden_PPG1060_5_BedfordBrown: 18434,
  Glidden_PPG1060_6_RaspberryTruffle: 18435,
  Glidden_PPG1060_7_WarmMahogany: 18436,
  Glidden_PPG1061_1_IrishCream: 18437,
  Glidden_PPG1061_2_WistfulBeige: 18438,
  Glidden_PPG1061_3_BelleOfTheBall: 18439,
  Glidden_PPG1061_4_JustRosey: 18440,
  Glidden_PPG1061_5_CappucinoBombe: 18441,
  Glidden_PPG1061_6_SafariBrown: 18442,
  Glidden_PPG1061_7_Bigfoot: 18443,
  Glidden_PPG1062_1_ButterIcing: 18444,
  Glidden_PPG1062_2_CoralCream: 18445,
  Glidden_PPG1062_3_GingerShortbread: 18446,
  Glidden_PPG1062_4_Sandpaper: 18447,
  Glidden_PPG1062_5_BigCypress: 18448,
  Glidden_PPG1062_6_AppleBrownBetty: 18449,
  Glidden_PPG1062_7_WarmWassail: 18450,
  Glidden_PPG1063_1_PoloTan: 18451,
  Glidden_PPG1063_2_SpiceCookie: 18452,
  Glidden_PPG1063_3_PaleCoral: 18453,
  Glidden_PPG1063_5_OrangeEssential: 18454,
  Glidden_PPG1063_7_AncientCopper: 18455,
  Glidden_PPG1064_1_Aubergine: 18456,
  Glidden_PPG1064_2_PinkChablis: 18457,
  Glidden_PPG1064_3_TexasRose: 18458,
  Glidden_PPG1064_4_PeachBeige: 18459,
  Glidden_PPG1064_5_HollandTile: 18460,
  Glidden_PPG1064_6_SaharaSun: 18461,
  Glidden_PPG1064_7_RumRaisin: 18462,
  Glidden_PPG1065_1_ChantillyLace: 18463,
  Glidden_PPG1065_2_Fiesta: 18464,
  Glidden_PPG1065_3_Honeysweet: 18465,
  Glidden_PPG1065_4_SweetPeach: 18466,
  Glidden_PPG1065_5_LongWeekend: 18467,
  Glidden_PPG1065_7_CedarChest: 18468,
  Glidden_PPG1066_1_SiestaSands: 18469,
  Glidden_PPG1066_2_SlightlyPeach: 18470,
  Glidden_PPG1066_3_CoolCantaloupe: 18471,
  Glidden_PPG1066_6_Amaretto: 18472,
  Glidden_PPG1066_7_BakedBean: 18473,
  Glidden_PPG1067_1_PineHutch: 18474,
  Glidden_PPG1067_2_Boardwalk: 18475,
  Glidden_PPG1067_3_AuNaturel: 18476,
  Glidden_PPG1067_4_Thankfully: 18477,
  Glidden_PPG1067_5_CopperBeech: 18478,
  Glidden_PPG1067_6_WarmUp: 18479,
  Glidden_PPG1067_7_BurledRedwood: 18480,
  Glidden_PPG1068_1_SweetGardenia: 18481,
  Glidden_PPG1068_2_Sablewood: 18482,
  Glidden_PPG1068_3_SultanSand: 18483,
  Glidden_PPG1068_4_LazySummer: 18484,
  Glidden_PPG1068_5_TerrazzoTan: 18485,
  Glidden_PPG1068_6_Nutmeg: 18486,
  Glidden_PPG1068_7_SpicedCider: 18487,
  Glidden_PPG1069_1_Nosegay: 18488,
  Glidden_PPG1069_2_Scotchtone: 18489,
  Glidden_PPG1069_3_Starfish: 18490,
  Glidden_PPG1069_4_OrangeMaple: 18491,
  Glidden_PPG1069_5_HoneyGraham: 18492,
  Glidden_PPG1069_6_FoxfireBrown: 18493,
  Glidden_PPG1069_7_CinnamonSpice: 18494,
  Glidden_PPG1070_1_CanyonPeach: 18495,
  Glidden_PPG1070_2_BlushBeige: 18496,
  Glidden_PPG1070_3_BeachVibes: 18497,
  Glidden_PPG1070_4_ClayFire: 18498,
  Glidden_PPG1070_5_HitchingPost: 18499,
  Glidden_PPG1070_6_GingerSpice: 18500,
  Glidden_PPG1070_7_CinnamonStick: 18501,
  Glidden_PPG1071_1_SouthPeak: 18502,
  Glidden_PPG1071_2_Enjoy: 18503,
  Glidden_PPG1071_3_ChampagneWishes: 18504,
  Glidden_PPG1071_4_CinnamonIce: 18505,
  Glidden_PPG1071_5_CoolClay: 18506,
  Glidden_PPG1071_6_PrairieFire: 18507,
  Glidden_PPG1071_7_SpicedCinnamon: 18508,
  Glidden_PPG1072_1_AlmondRoca: 18509,
  Glidden_PPG1072_2_SandyBeach: 18510,
  Glidden_PPG1072_3_WildRice: 18511,
  Glidden_PPG1072_4_TaupeTapestry: 18512,
  Glidden_PPG1072_5_TatteredTeddy: 18513,
  Glidden_PPG1072_6_SuedeLeather: 18514,
  Glidden_PPG1072_7_BirdHouseBrown: 18515,
  Glidden_PPG1073_2_MaltedMilk: 18516,
  Glidden_PPG1073_3_PaleTaupe: 18517,
  Glidden_PPG1073_4_Pueblo: 18518,
  Glidden_PPG1073_5_Tanglewood: 18519,
  Glidden_PPG1073_6_DerbyBrown: 18520,
  Glidden_PPG1073_7_Fudge: 18521,
  Glidden_PPG1074_1_PearlsAndLace: 18522,
  Glidden_PPG1074_2_MoroccanMoonlight: 18523,
  Glidden_PPG1074_3_BermudaSand: 18524,
  Glidden_PPG1074_4_Notorious: 18525,
  Glidden_PPG1074_5_PepperedPecan: 18526,
  Glidden_PPG1074_6_CaramelizedWalnut: 18527,
  Glidden_PPG1074_7_LittleBear: 1997,
  Glidden_PPG1075_1_LinenRuffle: 18528,
  Glidden_PPG1075_2_AlleyCaty: 18529,
  Glidden_PPG1075_3_CasualElegance: 18530,
  Glidden_PPG1075_4_Thumper: 18531,
  Glidden_PPG1075_5_RanchMink: 18532,
  Glidden_PPG1075_6_PoppyPods: 18533,
  Glidden_PPG1075_7_FudgeTruffle: 18534,
  Glidden_PPG1076_1_FuzzyUnicorn: 18535,
  Glidden_PPG1076_2_Ash: 18536,
  Glidden_PPG1076_3_GottaHaveIt: 18537,
  Glidden_PPG1076_4_CuppaCoffee: 18538,
  Glidden_PPG1076_5_Locomotion: 18539,
  Glidden_PPG1076_6_Warrior: 18540,
  Glidden_PPG1076_7_GroundCoffee: 18541,
  Glidden_PPG1077_1_BerkshireLace: 18542,
  Glidden_PPG1077_2_Sandpiper: 18543,
  Glidden_PPG1077_3_Persuasion: 18544,
  Glidden_PPG1077_4_WeatheredWood: 18545,
  Glidden_PPG1077_5_ChocolateMoment: 18546,
  Glidden_PPG1077_6_SaltedPretzel: 18547,
  Glidden_PPG1077_7_CoffeeHouse: 18548,
  Glidden_PPG1078_1_CreamPuff: 18549,
  Glidden_PPG1078_2_WaterChestnut: 18550,
  Glidden_PPG1078_3_Comfort: 18551,
  Glidden_PPG1078_5_Confidence: 18552,
  Glidden_PPG1078_6_CocoaDelight: 18553,
  Glidden_PPG1078_7_ChocolateRipple: 18554,
  Glidden_PPG1079_1_StringOfPearls: 18555,
  Glidden_PPG1079_2_StoneHarbor: 18556,
  Glidden_PPG1079_3_CocoaCream: 18557,
  Glidden_PPG1079_4_Transcend: 18558,
  Glidden_PPG1079_5_Cocoloco: 18559,
  Glidden_PPG1079_6_CaravelBrown: 18560,
  Glidden_PPG1079_7_Molasses: 18561,
  Glidden_PPG1080_1_OatmealCookie: 18562,
  Glidden_PPG1080_2_PumpkinCream: 18563,
  Glidden_PPG1080_3_NutmegGlow: 18564,
  Glidden_PPG1080_4_SiestaDreams: 18565,
  Glidden_PPG1080_5_WheatToast: 18566,
  Glidden_PPG1080_6_CinnamonCrunch: 18567,
  Glidden_PPG1080_7_SlipperyStone: 18568,
  Glidden_PPG1081_1_ElegantIvory: 18569,
  Glidden_PPG1081_2_BeachyKeen: 18570,
  Glidden_PPG1081_3_MyLove: 18571,
  Glidden_PPG1081_4_CinnamonFrost: 18572,
  Glidden_PPG1081_5_FireDust: 18573,
  Glidden_PPG1081_6_CinnamonTwist: 18574,
  Glidden_PPG1081_7_CopperPot: 18575,
  Glidden_PPG1082_1_Honeysuckle: 18576,
  Glidden_PPG1082_2_Shoreland: 18577,
  Glidden_PPG1082_3_IceCreamCone: 18578,
  Glidden_PPG1082_4_WeatheredSandstone: 18579,
  Glidden_PPG1082_5_Doeskin: 18580,
  Glidden_PPG1082_6_CowboyHat: 18581,
  Glidden_PPG1082_7_Ginger: 18582,
  Glidden_PPG1083_1_Percale: 18583,
  Glidden_PPG1083_2_EuroLinen: 18584,
  Glidden_PPG1083_3_OakBuff: 18585,
  Glidden_PPG1083_4_MalibuDune: 18586,
  Glidden_PPG1083_5_CheddarBiscuit: 18587,
  Glidden_PPG1083_6_CaramelKiss: 18588,
  Glidden_PPG1083_7_Bourbon: 18589,
  Glidden_PPG1084_1_SugarSoap: 18590,
  Glidden_PPG1084_2_OnionPowder: 18591,
  Glidden_PPG1084_3_Sourdough: 18592,
  Glidden_PPG1084_4_HappyTrails: 18593,
  Glidden_PPG1084_5_CoffeeKiss: 18594,
  Glidden_PPG1084_6_CocoaPecan: 18595,
  Glidden_PPG1084_7_MapleSyrup: 18596,
  Glidden_PPG1085_1_BlankCanvas: 18597,
  Glidden_PPG1085_2_BoneWhite: 18598,
  Glidden_PPG1085_3_SeriouslySand: 18599,
  Glidden_PPG1085_4_BestBeige: 18600,
  Glidden_PPG1085_5_SauteedMushroom: 18601,
  Glidden_PPG1085_6_HatBoxBrown: 18602,
  Glidden_PPG1085_7_FigBranches: 18603,
  Glidden_PPG1086_1_Horseradish: 18604,
  Glidden_PPG1086_2_BrandiedPears: 18605,
  Glidden_PPG1086_3_AlmondCream: 18606,
  Glidden_PPG1086_4_PonyTail: 18607,
  Glidden_PPG1086_5_EarthyOcher: 18608,
  Glidden_PPG1086_6_CoffeeWithCream: 18609,
  Glidden_PPG1086_7_CocoaCupcake: 18610,
  Glidden_PPG1087_1_MadonnaLily: 18611,
  Glidden_PPG1087_2_Pearl: 18612,
  Glidden_PPG1087_3_AntiqueParchment: 18613,
  Glidden_PPG1087_4_Chalkware: 18614,
  Glidden_PPG1087_5_CrackerBitz: 18615,
  Glidden_PPG1087_6_BreadBasket: 18616,
  Glidden_PPG1087_7_ChewyCaramel: 18617,
  Glidden_PPG1088_1_AngelFood: 18618,
  Glidden_PPG1088_2_Ethereal: 18619,
  Glidden_PPG1088_3_SugaredPears: 18620,
  Glidden_PPG1088_4_SplashOfHoney: 18621,
  Glidden_PPG1088_5_Outback: 18622,
  Glidden_PPG1088_6_CoolCopper: 18623,
  Glidden_PPG1088_7_SaharaSplendor: 18624,
  Glidden_PPG1089_1_PitaBread: 18625,
  Glidden_PPG1089_2_MagnoliaSpray: 18626,
  Glidden_PPG1089_3_ChaiTeaLatte: 18627,
  Glidden_PPG1089_4_FaintFawn: 18628,
  Glidden_PPG1089_5_BleachedMaple: 18629,
  Glidden_PPG1089_6_HoneyHaven: 18630,
  Glidden_PPG1089_7_CaramelizedPecan: 18631,
  Glidden_PPG1090_1_MagnoliaBlossom: 18632,
  Glidden_PPG1090_2_SpiceIsNice: 18633,
  Glidden_PPG1090_3_HoneyBunny: 18634,
  Glidden_PPG1090_4_DropsOfHoney: 18635,
  Glidden_PPG1090_5_GoodLife: 18636,
  Glidden_PPG1090_6_Allegro: 18637,
  Glidden_PPG1090_7_SugarMaple: 18638,
  Glidden_PPG1091_1_Candlewick: 18639,
  Glidden_PPG1091_2_CrescentMoon: 18640,
  Glidden_PPG1091_3_Limitless: 18641,
  Glidden_PPG1091_4_Halo: 18642,
  Glidden_PPG1091_5_MoreMaple: 18643,
  Glidden_PPG1091_6_DownToEarth: 18644,
  Glidden_PPG1091_7_LookAtMe: 18645,
  Glidden_PPG1092_1_QueenAnnesLace: 23159,
  Glidden_PPG1092_1QueenAnnesLace: 18646,
  Glidden_PPG1092_2_MesaBeige: 18647,
  Glidden_PPG1092_3_TuscanBread: 18648,
  Glidden_PPG1092_4_CraftsmanGold: 18649,
  Glidden_PPG1092_5_WelcomeHome: 18650,
  Glidden_PPG1092_6_ItWorks: 18651,
  Glidden_PPG1092_7_WeatheredWicker: 18652,
  Glidden_PPG1093_1_PerfectSolution: 18653,
  Glidden_PPG1093_4_Somber: 18654,
  Glidden_PPG1093_6_TangledTwine: 18655,
  Glidden_PPG1093_7_TattleTan: 18656,
  Glidden_PPG1094_1_Irresistible: 18657,
  Glidden_PPG1094_2_Loofah: 18658,
  Glidden_PPG1094_3_BirchBeige: 18659,
  Glidden_PPG1094_4_Crepe: 18660,
  Glidden_PPG1094_5_GoldenGranola: 18661,
  Glidden_PPG1094_6_Imagine: 18662,
  Glidden_PPG1094_7_MolassesCookie: 18663,
  Glidden_PPG1095_1_ParchmentPaper: 18664,
  Glidden_PPG1095_2_GlazedPears: 18665,
  Glidden_PPG1095_3_AlmondBrittle: 18666,
  Glidden_PPG1095_4_GoldenEcru: 18667,
  Glidden_PPG1095_5_ApplesauceCake: 18668,
  Glidden_PPG1095_6_Chicory: 18669,
  Glidden_PPG1095_7_ShakerPeg: 18670,
  Glidden_PPG1096_1_InstantRelief: 18671,
  Glidden_PPG1096_2_MoroccoSand: 18672,
  Glidden_PPG1096_3_CookieDough: 18673,
  Glidden_PPG1096_4_RealSimple: 18674,
  Glidden_PPG1096_5_CreamyCaramel: 18675,
  Glidden_PPG1096_6_TimberBeam: 18676,
  Glidden_PPG1096_7_SeasonedAcorn: 18677,
  Glidden_PPG1097_1_ColdFoam: 18678,
  Glidden_PPG1097_2_SouthernBreeze: 18679,
  Glidden_PPG1097_3_ToastedAlmond: 18680,
  Glidden_PPG1097_4_DustyTrail: 18681,
  Glidden_PPG1097_5_StonyCreek: 18682,
  Glidden_PPG1097_6_RainBarrel: 18683,
  Glidden_PPG1097_7_OliveWood: 18684,
  Glidden_PPG1098_1_MilkPaint: 18685,
  Glidden_PPG1098_2_HeavyCream: 18686,
  Glidden_PPG1098_3_SandFossil: 18687,
  Glidden_PPG1098_4_SpicedVinegar: 18688,
  Glidden_PPG1098_5_Jute: 18689,
  Glidden_PPG1098_6_Tweed: 18690,
  Glidden_PPG1098_7_MuddyRiver: 18691,
  Glidden_PPG1099_1_AlwaysAlmond: 18692,
  Glidden_PPG1099_2_VanillaLove: 18693,
  Glidden_PPG1099_3_LovelyLinen: 18694,
  Glidden_PPG1099_4_SubtleSuede: 18695,
  Glidden_PPG1099_5_ToastedSesame: 18696,
  Glidden_PPG1099_6_IcedCappuccino: 18697,
  Glidden_PPG1099_7_FavoriteFudge: 18698,
  Glidden_PPG11_01_Demeter: 18699,
  Glidden_PPG11_02_TaintedGold: 18700,
  Glidden_PPG11_03_Grassroots: 18701,
  Glidden_PPG11_04_CountryStyle: 18702,
  Glidden_PPG11_05_OldTimesSake: 18703,
  Glidden_PPG11_06_SafariScene: 18704,
  Glidden_PPG11_07_Gobbledygook: 18705,
  Glidden_PPG11_08_OliveOrchard: 18706,
  Glidden_PPG11_09_MistyMoor: 18707,
  Glidden_PPG11_10_InTheDale: 18708,
  Glidden_PPG11_11_TotallyTickled: 18709,
  Glidden_PPG11_12_SecretScribbles: 18710,
  Glidden_PPG11_13_SparrowSong: 18711,
  Glidden_PPG11_14_LeafyRomaine: 18712,
  Glidden_PPG11_15_WistfulWalk: 18713,
  Glidden_PPG11_16_SpinachSalad: 18714,
  Glidden_PPG11_17_MossyGold: 18715,
  Glidden_PPG11_18_FoggyBeach: 18716,
  Glidden_PPG11_19_DistantValley: 18717,
  Glidden_PPG11_20_ScottishMoor: 18718,
  Glidden_PPG11_21_Breezeway: 18719,
  Glidden_PPG11_24_SmokeySage: 18720,
  Glidden_PPG11_26_Wilderness: 18721,
  Glidden_PPG11_27_Safari: 18722,
  Glidden_PPG11_28_OnlyOregano: 18723,
  Glidden_PPG11_29_GreenGrayMist: 18724,
  Glidden_PPG11_30_LivelyIvy: 18725,
  Glidden_PPG11_31_ThimbleberryLeaf: 18726,
  Glidden_PPG11_32_Tapenade: 18727,
  Glidden_PPG1100_1_MotherOfPearl: 18728,
  Glidden_PPG1100_2_AdobeWhite: 18729,
  Glidden_PPG1100_3_BakedBread: 18730,
  Glidden_PPG1100_4_SailorsKnot: 23160,
  Glidden_PPG1100_4SailorsKnot: 18731,
  Glidden_PPG1100_5_SweetSparrow: 18732,
  Glidden_PPG1100_6_TwistedTail: 18733,
  Glidden_PPG1100_7_PaddleWheel: 18734,
  Glidden_PPG1101_1_ChinaWhite: 18735,
  Glidden_PPG1101_2_SugarCookie: 18736,
  Glidden_PPG1101_3_Stylish: 18737,
  Glidden_PPG1101_5_BearHug: 18738,
  Glidden_PPG1101_6_LeatherLoafers: 18739,
  Glidden_PPG1101_7_Lemur: 18740,
  Glidden_PPG1102_1_EnduringIce: 18741,
  Glidden_PPG1102_2_FossilStone: 18742,
  Glidden_PPG1102_3_DancingDolphin: 18743,
  Glidden_PPG1102_4_PrairieDust: 18744,
  Glidden_PPG1102_5_SaddleSoap: 18745,
  Glidden_PPG1102_6_Woodbridge: 18746,
  Glidden_PPG1102_7_PineCone: 18747,
  Glidden_PPG1103_1_IvoryTower: 18748,
  Glidden_PPG1103_2_AlmondPaste: 18749,
  Glidden_PPG1103_4_EarthyCane: 18750,
  Glidden_PPG1103_5_Rattan: 18751,
  Glidden_PPG1103_6_WoolTweed: 18752,
  Glidden_PPG1103_7_TwigBasket: 18753,
  Glidden_PPG1104_1_WhiteRock: 18754,
  Glidden_PPG1104_2_AbbeyWhite: 18755,
  Glidden_PPG1104_3_DesertedBeach: 18756,
  Glidden_PPG1104_4_SandyPail: 18757,
  Glidden_PPG1104_5_CoolCamel: 18758,
  Glidden_PPG1104_6_RusticRanch: 18759,
  Glidden_PPG1104_7_Outrigger: 18760,
  Glidden_PPG1105_1_CreamyWhite: 18761,
  Glidden_PPG1105_2_FuzzySheep: 18762,
  Glidden_PPG1105_3_CaramelizedPears: 18763,
  Glidden_PPG1105_6_BuffaloHide: 18764,
  Glidden_PPG1105_7_GracefulGazelle: 18765,
  Glidden_PPG1106_1_MaidenHair: 18766,
  Glidden_PPG1106_2_Upbeat: 18767,
  Glidden_PPG1106_3_AutumnGlow: 18768,
  Glidden_PPG1106_4_TurnersYellow: 23161,
  Glidden_PPG1106_4TurnersYellow: 18769,
  Glidden_PPG1106_5_ButterscotchBliss: 18770,
  Glidden_PPG1106_6_AmarettoSours: 18771,
  Glidden_PPG1106_7_ButterscotchRipple: 18772,
  Glidden_PPG1107_1_Minimal: 18773,
  Glidden_PPG1107_2_Joyful: 18774,
  Glidden_PPG1107_3_TurningOakleaf: 18775,
  Glidden_PPG1107_5_TropicalSiesta: 18776,
  Glidden_PPG1107_6_GloriousGold: 18777,
  Glidden_PPG1107_7_GoldenField: 18778,
  Glidden_PPG1108_1_OysterCracker: 18779,
  Glidden_PPG1108_2_SilkStar: 18780,
  Glidden_PPG1108_3_ButterCookie: 18781,
  Glidden_PPG1108_4_WaywardWind: 18782,
  Glidden_PPG1108_5_SpicyMustard: 18783,
  Glidden_PPG1108_6_ShutterBug: 18784,
  Glidden_PPG1108_7_Obsession: 18785,
  Glidden_PPG1109_1_SlicesOfHappy: 18786,
  Glidden_PPG1109_2_StarBright: 18787,
  Glidden_PPG1109_3_TwinkleToes: 18788,
  Glidden_PPG1109_4_CitrusYellow: 18789,
  Glidden_PPG1109_5_SplitPeaSoup: 18790,
  Glidden_PPG1109_6_WoolenMittens: 18791,
  Glidden_PPG1109_7_AutumnFestival: 18792,
  Glidden_PPG1110_1_SeptemberMorn: 18793,
  Glidden_PPG1110_2_SubtleSunshine: 18794,
  Glidden_PPG1110_3_SereneScene: 18795,
  Glidden_PPG1110_4_SecretSafari: 18796,
  Glidden_PPG1110_5_Gremlin: 18797,
  Glidden_PPG1110_6_OffTheGrid: 18798,
  Glidden_PPG1110_7_PeasPlease: 18799,
  Glidden_PPG1111_1_PrairieWinds: 18800,
  Glidden_PPG1111_2_Bamboo: 18801,
  Glidden_PPG1111_3_SafariGreen: 18802,
  Glidden_PPG1111_4_Nettle: 18803,
  Glidden_PPG1111_5_PineappleSage: 18804,
  Glidden_PPG1111_6_PickledOkra: 18805,
  Glidden_PPG1111_7_SphagnumMoss: 18806,
  Glidden_PPG1112_1_LittleLamb: 18807,
  Glidden_PPG1112_2_CozyCream: 18808,
  Glidden_PPG1112_3_OnlyOatmeal: 18809,
  Glidden_PPG1112_4_BeachDune: 18810,
  Glidden_PPG1112_5_WoolenVest: 18811,
  Glidden_PPG1112_6_WillowTree: 18812,
  Glidden_PPG1112_7_RussianOlive: 18813,
  Glidden_PPG1113_1_IMissYou: 18814,
  Glidden_PPG1113_2_SilverSage: 18815,
  Glidden_PPG1113_3_NorthernLandscape: 18816,
  Glidden_PPG1113_5_SweetAnnie: 18817,
  Glidden_PPG1113_6_GreenBriar: 18818,
  Glidden_PPG1113_7_OliveGreen: 18819,
  Glidden_PPG1114_1_Featherstone: 18820,
  Glidden_PPG1114_2_RiverReed: 18821,
  Glidden_PPG1114_3_CanaryGrass: 18822,
  Glidden_PPG1114_4_CressGreen: 18823,
  Glidden_PPG1114_5_PeaSoup: 18824,
  Glidden_PPG1114_6_BronzeGreen: 18825,
  Glidden_PPG1114_7_AutumnFern: 18826,
  Glidden_PPG1115_1_ReallyRain: 18827,
  Glidden_PPG1115_2_SageSplash: 18828,
  Glidden_PPG1115_3_SlowDance: 18829,
  Glidden_PPG1115_4_SageSplendor: 18830,
  Glidden_PPG1115_5_PineTrail: 18831,
  Glidden_PPG1115_6_PaidInFull: 18832,
  Glidden_PPG1115_7_GratefullyGrass: 18833,
  Glidden_PPG1116_1_JustPerfect: 18834,
  Glidden_PPG1116_2_MoreMelon: 18835,
  Glidden_PPG1116_3_ForgiveQuickly: 18836,
  Glidden_PPG1116_5_GraciousGlow: 18837,
  Glidden_PPG1116_6_LoveliestLeaves: 18838,
  Glidden_PPG1116_7_FrogsLegs: 23162,
  Glidden_PPG1116_7FrogsLegs: 18839,
  Glidden_PPG1117_1_DelicateDaisy: 18840,
  Glidden_PPG1117_2_Awareness: 18841,
  Glidden_PPG1117_3_Charming: 18842,
  Glidden_PPG1117_4_FloralBouquet: 18843,
  Glidden_PPG1117_5_BeachBag: 18844,
  Glidden_PPG1117_6_DoNotDisturb: 18845,
  Glidden_PPG1117_7_EnoughIsEnough: 18846,
  Glidden_PPG1118_1_MoreMint: 18847,
  Glidden_PPG1118_2_AprilShowers: 18848,
  Glidden_PPG1118_3_TrueToYou: 18849,
  Glidden_PPG1118_4_Jitterbug: 18850,
  Glidden_PPG1118_5_AlwaysApple: 18851,
  Glidden_PPG1118_6_VintageVibe: 18852,
  Glidden_PPG1118_7_Lucky: 18853,
  Glidden_PPG1119_1_MagicalMelon: 18854,
  Glidden_PPG1119_2_FountainFrolic: 18855,
  Glidden_PPG1119_3_BeachGrass: 18856,
  Glidden_PPG1119_4_DancingKite: 18857,
  Glidden_PPG1119_5_FancyFlirt: 18858,
  Glidden_PPG1119_6_GoldenGrass: 18859,
  Glidden_PPG1119_7_GladeGreen: 18860,
  Glidden_PPG1120_1_MentalNote: 18861,
  Glidden_PPG1120_2_Gratitude: 18862,
  Glidden_PPG1120_3_GreatJoy: 18863,
  Glidden_PPG1120_4_PistachioPudding: 18864,
  Glidden_PPG1120_5_Harmonious: 18865,
  Glidden_PPG1120_6_LusciousLime: 18866,
  Glidden_PPG1120_7_MintLeaves: 18867,
  Glidden_PPG1121_1_Milkweed: 18868,
  Glidden_PPG1121_2_LimeSpritz: 18869,
  Glidden_PPG1121_3_PaleMossGreen: 18870,
  Glidden_PPG1121_4_QuakingGrass: 18871,
  Glidden_PPG1121_5_Guacamole: 18872,
  Glidden_PPG1121_6_MossPointGreen: 18873,
  Glidden_PPG1121_7_GlobeArtichoke: 18874,
  Glidden_PPG1122_1_WhiteSmoke: 18875,
  Glidden_PPG1122_2_LimeWash: 18876,
  Glidden_PPG1122_3_PicklingSpice: 18877,
  Glidden_PPG1122_4_BahiaGrass: 18878,
  Glidden_PPG1122_5_Dill: 18879,
  Glidden_PPG1122_6_Oregano: 18880,
  Glidden_PPG1122_7_Oakmoss: 18881,
  Glidden_PPG1123_1_Ageless: 18882,
  Glidden_PPG1123_2_MagicalStardust: 18883,
  Glidden_PPG1123_3_WildWheat: 18884,
  Glidden_PPG1123_4_OnlyOlive: 18885,
  Glidden_PPG1123_5_Envy: 18886,
  Glidden_PPG1123_6_PlayingHooky: 18887,
  Glidden_PPG1123_7_RustlingLeaves: 18888,
  Glidden_PPG1124_1_TouchOfLime: 18889,
  Glidden_PPG1124_2_PaleVista: 18890,
  Glidden_PPG1124_3_FrostyPine: 18891,
  Glidden_PPG1124_4_LightSage: 18892,
  Glidden_PPG1124_5_CavernMoss: 18893,
  Glidden_PPG1124_6_DarkSage: 18894,
  Glidden_PPG1124_7_GrapeLeaves: 18895,
  Glidden_PPG1125_1_RainCloud: 18896,
  Glidden_PPG1125_3_WhisperingPine: 18897,
  Glidden_PPG1125_4_OliveSprig: 18898,
  Glidden_PPG1125_5_Hemlock: 18899,
  Glidden_PPG1125_6_ToyTankGreen: 18900,
  Glidden_PPG1125_7_Pinetop: 18901,
  Glidden_PPG1126_1_SterlingShadow: 18902,
  Glidden_PPG1126_2_TwilightTwist: 18903,
  Glidden_PPG1126_3_PinchOfPistachio: 18904,
  Glidden_PPG1126_4_SideKick: 18905,
  Glidden_PPG1126_5_ZebraGrass: 18906,
  Glidden_PPG1126_6_PineGarland: 18907,
  Glidden_PPG1126_7_AllAboutOlive: 18908,
  Glidden_PPG1127_1_LimeDaiquiri: 18909,
  Glidden_PPG1127_2_LiberatedLime: 18910,
  Glidden_PPG1127_3_MerryMusic: 18911,
  Glidden_PPG1127_4_Gargoyle: 18912,
  Glidden_PPG1127_5_Shebang: 18913,
  Glidden_PPG1127_6_WinningTicket: 18914,
  Glidden_PPG1127_7_FreshBasil: 18915,
  Glidden_PPG1128_1_Anonymous: 18916,
  Glidden_PPG1128_2_FrivolousFolly: 18917,
  Glidden_PPG1128_3_LifeLesson: 18918,
  Glidden_PPG1128_4_Balsam: 18919,
  Glidden_PPG1128_5_GreenTeaLeaf: 18920,
  Glidden_PPG1128_6_ThymeGreen: 18921,
  Glidden_PPG1128_7_CastleStone: 18922,
  Glidden_PPG1129_1_CloudyDay: 18923,
  Glidden_PPG1129_2_FallingStar: 18924,
  Glidden_PPG1129_3_Castaway: 18925,
  Glidden_PPG1129_4_CoastalCrush: 18926,
  Glidden_PPG1129_5_FarmFresh: 18927,
  Glidden_PPG1129_6_LotteryWinnings: 18928,
  Glidden_PPG1129_7_EvergreenBoughs: 18929,
  Glidden_PPG1130_1_SummerRain: 18930,
  Glidden_PPG1130_2_MintWafer: 18931,
  Glidden_PPG1130_3_StAugustine: 18932,
  Glidden_PPG1130_4_LimeTaffy: 18933,
  Glidden_PPG1130_5_PearCactus: 18934,
  Glidden_PPG1130_6_MossRing: 18935,
  Glidden_PPG1130_7_MountainForest: 18936,
  Glidden_PPG1131_1_GreenWhisper: 18937,
  Glidden_PPG1131_2_HerbalMist: 18938,
  Glidden_PPG1131_3_Dreamcatcher: 18939,
  Glidden_PPG1131_4_FrenchMarket: 18940,
  Glidden_PPG1131_5_ChattyCricket: 18941,
  Glidden_PPG1131_6_SucculentLeaves: 18942,
  Glidden_PPG1131_7_CloverLeaf: 18943,
  Glidden_PPG1132_1_ClairDeLune: 18944,
  Glidden_PPG1132_2_Solitaire: 18945,
  Glidden_PPG1132_3_TaffyTwist: 18946,
  Glidden_PPG1132_4_GrandGusto: 18947,
  Glidden_PPG1132_5_Plumosa: 18948,
  Glidden_PPG1132_6_MallardGreen: 18949,
  Glidden_PPG1132_7_Brunswick: 18950,
  Glidden_PPG1133_1_Icicle: 18951,
  Glidden_PPG1133_2_Tenderness: 18952,
  Glidden_PPG1133_3_Limelight: 18953,
  Glidden_PPG1133_4_SilverLeaf: 18954,
  Glidden_PPG1133_5_SlateGreen: 18955,
  Glidden_PPG1133_6_PaintedTurtle: 18956,
  Glidden_PPG1133_7_RoyalHunterGreen: 18957,
  Glidden_PPG1134_1_HydrangeaFloret: 18958,
  Glidden_PPG1134_2_TidalFoam: 18959,
  Glidden_PPG1134_3_PineFrost: 18960,
  Glidden_PPG1134_4_PineWhisper: 18961,
  Glidden_PPG1134_5_BirchForest: 18962,
  Glidden_PPG1134_6_EnglishIvy: 18963,
  Glidden_PPG1134_7_PineForest: 18964,
  Glidden_PPG1135_1_PoeticLicense: 18965,
  Glidden_PPG1135_2_MorningRush: 18966,
  Glidden_PPG1135_3_SecretCrush: 18967,
  Glidden_PPG1135_4_AquamarineDream: 18968,
  Glidden_PPG1135_5_ParadiseFound: 18969,
  Glidden_PPG1135_6_CalabashClash: 18970,
  Glidden_PPG1135_7_Obligation: 18971,
  Glidden_PPG1136_1_SeaPearl: 18972,
  Glidden_PPG1136_2_Rainsong: 18973,
  Glidden_PPG1136_3_MorningBreeze: 18974,
  Glidden_PPG1136_4_BlueShamrock: 18975,
  Glidden_PPG1136_5_SpruceShade: 18976,
  Glidden_PPG1136_6_DwarfSpruce: 18977,
  Glidden_PPG1136_7_DarkGreenVelvet: 18978,
  Glidden_PPG1137_1_SpringRain: 18979,
  Glidden_PPG1137_2_NorthernLights: 18980,
  Glidden_PPG1137_3_Waterscape: 18981,
  Glidden_PPG1137_4_Copenhagen: 18982,
  Glidden_PPG1137_5_SilverLaurel: 18983,
  Glidden_PPG1137_6_SalalLeaves: 18984,
  Glidden_PPG1137_7_BlackSpruce: 18985,
  Glidden_PPG1138_1_CactusBlossom: 18986,
  Glidden_PPG1138_2_Geyser: 18987,
  Glidden_PPG1138_3_CrystalOasis: 18988,
  Glidden_PPG1138_4_Donnegal: 18989,
  Glidden_PPG1138_5_PineRidge: 18990,
  Glidden_PPG1138_6_ChristmasIvy: 18991,
  Glidden_PPG1138_7_MidnightClover: 18992,
  Glidden_PPG1139_1_SummerBreeze: 18993,
  Glidden_PPG1139_2_MaltedMint: 18994,
  Glidden_PPG1139_3_GreenSilk: 18995,
  Glidden_PPG1139_4_Catnip: 18996,
  Glidden_PPG1139_5_Sheffield: 18997,
  Glidden_PPG1139_6_CountryClub: 18998,
  Glidden_PPG1139_7_BilliardGreen: 18999,
  Glidden_PPG1140_1_Echo: 19000,
  Glidden_PPG1140_2_SweetNothings: 19001,
  Glidden_PPG1140_3_Tarreyton: 19002,
  Glidden_PPG1140_4_KeyLargo: 19003,
  Glidden_PPG1140_5_DerbyGreen: 19004,
  Glidden_PPG1140_6_Pinehurst: 19005,
  Glidden_PPG1140_7_PeacockGreen: 19006,
  Glidden_PPG1141_1_IceFloe: 19007,
  Glidden_PPG1141_2_GreenWave: 19008,
  Glidden_PPG1141_3_Cassiopeia: 19009,
  Glidden_PPG1141_4_CaribbeanGreen: 19010,
  Glidden_PPG1141_5_TreasureIsle: 19011,
  Glidden_PPG1141_6_Carlisle: 19012,
  Glidden_PPG1141_7_DeepVeridian: 19013,
  Glidden_PPG1142_1_PeacefulNight: 19014,
  Glidden_PPG1142_2_BigSky: 19015,
  Glidden_PPG1142_3_VeridianGreen: 19016,
  Glidden_PPG1142_4_PitterPatter: 19017,
  Glidden_PPG1142_5_Catalina: 19018,
  Glidden_PPG1142_6_JerichoJade: 19019,
  Glidden_PPG1142_7_EmpressTeal: 19020,
  Glidden_PPG1143_1_DelicateMist: 19021,
  Glidden_PPG1143_2_BlueLullaby: 19022,
  Glidden_PPG1143_3_SeaSprite: 19023,
  Glidden_PPG1143_4_ParakeetPete: 19024,
  Glidden_PPG1143_5_Yucca: 19025,
  Glidden_PPG1143_6_SmokyEmerald: 19026,
  Glidden_PPG1143_7_HollyLeaf: 19027,
  Glidden_PPG1144_2_ThunderBay: 19028,
  Glidden_PPG1144_3_BabblingBrook: 19029,
  Glidden_PPG1144_4_HollyGlen: 19030,
  Glidden_PPG1144_5_GreenGranite: 19031,
  Glidden_PPG1144_6_EveningEmerald: 19032,
  Glidden_PPG1144_7_CrystalBall: 19033,
  Glidden_PPG1145_1_RainDrop: 19034,
  Glidden_PPG1145_2_JackFrost: 19035,
  Glidden_PPG1145_3_CavePearl: 19036,
  Glidden_PPG1145_4_BlueWillow: 19037,
  Glidden_PPG1145_5_Scarborough: 19038,
  Glidden_PPG1145_6_JuniperBerry: 19039,
  Glidden_PPG1145_7_NightWatch: 19040,
  Glidden_PPG1146_1_MildMint: 19041,
  Glidden_PPG1146_2_SpringMist: 19042,
  Glidden_PPG1146_3_JulepGreen: 19043,
  Glidden_PPG1146_4_FrostyGlade: 19044,
  Glidden_PPG1146_5_Palmetto: 19045,
  Glidden_PPG1146_6_LuckyShamrock: 19046,
  Glidden_PPG1146_7_EmeraldPool: 19047,
  Glidden_PPG1147_1_CameoGreen: 19048,
  Glidden_PPG1147_2_MountainDew: 19049,
  Glidden_PPG1147_3_MistyAqua: 19050,
  Glidden_PPG1147_4_AquaFiesta: 19051,
  Glidden_PPG1147_5_TealBayou: 19052,
  Glidden_PPG1147_6_JadeJewel: 19053,
  Glidden_PPG1147_7_TahitianTreat: 19054,
  Glidden_PPG1148_1_MeadowsweetMist: 19055,
  Glidden_PPG1148_2_PistachioCream: 19056,
  Glidden_PPG1148_3_CosmicRays: 19057,
  Glidden_PPG1148_4_LazyRiver: 19058,
  Glidden_PPG1148_5_CathedralGlass: 19059,
  Glidden_PPG1148_6_ViningIvy: 19060,
  Glidden_PPG1148_7_DeepEmerald: 19061,
  Glidden_PPG1149_1_AlpineBlue: 19062,
  Glidden_PPG1149_2_HighSierra: 19063,
  Glidden_PPG1149_3_ScandinavianSky: 19064,
  Glidden_PPG1149_4_MountainStream: 19065,
  Glidden_PPG1149_5_Baritone: 19066,
  Glidden_PPG1149_6_AzaleaLeaf: 19067,
  Glidden_PPG1149_7_BlueBayberry: 19068,
  Glidden_PPG1150_1_AquaSparkle: 19069,
  Glidden_PPG1150_2_WaterLily: 19070,
  Glidden_PPG1150_3_EvergladeMist: 19071,
  Glidden_PPG1150_4_KingstonAqua: 19072,
  Glidden_PPG1150_5_AcapulcoCliffs: 19073,
  Glidden_PPG1150_6_Bermuda: 19074,
  Glidden_PPG1150_7_CaribbeanSplash: 19075,
  Glidden_PPG1151_1_Beachcomber: 19076,
  Glidden_PPG1151_2_Embellishment: 19077,
  Glidden_PPG1151_3_MidsummersDream: 23163,
  Glidden_PPG1151_3MidsummersDream: 19078,
  Glidden_PPG1151_4_CrystalLake: 19079,
  Glidden_PPG1151_5_AquaBlue: 19080,
  Glidden_PPG1151_6_Adventure: 19081,
  Glidden_PPG1151_7_JamaicanDream: 19082,
  Glidden_PPG1152_1_SubtleBlue: 19083,
  Glidden_PPG1152_2_Breakwater: 19084,
  Glidden_PPG1152_3_Graceful: 19085,
  Glidden_PPG1152_4_Americana: 19086,
  Glidden_PPG1152_5_GraniteFalls: 19087,
  Glidden_PPG1152_6_Brigade: 19088,
  Glidden_PPG1152_7_ShimmeringSea: 19089,
  Glidden_PPG1153_1_IceCastles: 19090,
  Glidden_PPG1153_2_Artemesia: 19091,
  Glidden_PPG1153_3_BlueSmoke: 19092,
  Glidden_PPG1153_4_Chambray: 19093,
  Glidden_PPG1153_5_ChalkyBlue: 19094,
  Glidden_PPG1153_6_SilentNight: 19095,
  Glidden_PPG1153_7_SailorsCoat: 23164,
  Glidden_PPG1153_7SailorsCoat: 19096,
  Glidden_PPG1154_1_ShootingStar: 19097,
  Glidden_PPG1154_2_Aloof: 19098,
  Glidden_PPG1154_3_DartmoorMist: 19099,
  Glidden_PPG1154_4_Twinkle: 19100,
  Glidden_PPG1154_5_SereneStream: 19101,
  Glidden_PPG1154_6_PrussianBlue: 19102,
  Glidden_PPG1154_7_RegattaBay: 19103,
  Glidden_PPG1155_1_SummerShower: 19104,
  Glidden_PPG1155_2_Prelude: 19105,
  Glidden_PPG1155_4_Constellation: 19106,
  Glidden_PPG1155_5_DresdenDream: 19107,
  Glidden_PPG1155_6_CanyonBlue: 19108,
  Glidden_PPG1155_7_BlueLava: 19109,
  Glidden_PPG1156_1_AustrianIce: 19110,
  Glidden_PPG1156_2_BitOfHeaven: 19111,
  Glidden_PPG1156_3_AlwaysBlue: 19112,
  Glidden_PPG1156_4_AmericanAnthem: 19113,
  Glidden_PPG1156_5_SmokeBlue: 19114,
  Glidden_PPG1156_6_MountainLake: 19115,
  Glidden_PPG1156_7_CelestialBlue: 19116,
  Glidden_PPG1157_1_Glassine: 19117,
  Glidden_PPG1157_2_BluePearl: 19118,
  Glidden_PPG1157_3_Sonata: 19119,
  Glidden_PPG1157_4_Arabella: 19120,
  Glidden_PPG1157_5_Vanity: 19121,
  Glidden_PPG1157_6_CosmicDust: 19122,
  Glidden_PPG1157_7_BlueFlame: 19123,
  Glidden_PPG1158_1_BabysBreath: 23165,
  Glidden_PPG1158_1BabysBreath: 19124,
  Glidden_PPG1158_2_MagicWand: 19125,
  Glidden_PPG1158_3_BlueBows: 19126,
  Glidden_PPG1158_4_SereneSea: 19127,
  Glidden_PPG1158_5_Cosmopolitan: 19128,
  Glidden_PPG1158_6_BlueOasis: 19129,
  Glidden_PPG1158_7_StunningSapphire: 19130,
  Glidden_PPG1159_1_Filigree: 19131,
  Glidden_PPG1159_2_CalmSea: 19132,
  Glidden_PPG1159_3_HeavenlyBlue: 19133,
  Glidden_PPG1159_4_WaldenPond: 19134,
  Glidden_PPG1159_5_StormyRidge: 19135,
  Glidden_PPG1159_6_Animation: 19136,
  Glidden_PPG1159_7_SingingTheBlues: 19137,
  Glidden_PPG1160_1_HarborMist: 19138,
  Glidden_PPG1160_2_Magical: 19139,
  Glidden_PPG1160_3_Rendezvous: 19140,
  Glidden_PPG1160_4_Kaleidoscope: 19141,
  Glidden_PPG1160_5_BlueBeads: 19142,
  Glidden_PPG1160_6_ChinesePorcelain: 19143,
  Glidden_PPG1161_1_Cityscape: 19144,
  Glidden_PPG1161_2_CestLaVie: 23166,
  Glidden_PPG1161_2CestLaVie: 19145,
  Glidden_PPG1161_3_Everlasting: 19146,
  Glidden_PPG1161_4_BluePromise: 19147,
  Glidden_PPG1161_5_ShipsHarbor: 23167,
  Glidden_PPG1161_5ShipsHarbor: 19148,
  Glidden_PPG1161_6_StarryNight: 19149,
  Glidden_PPG1161_7_BrilliantBlue: 19150,
  Glidden_PPG1162_1_HarborLight: 19151,
  Glidden_PPG1162_2_Stratosphere: 19152,
  Glidden_PPG1162_3_BlueThistle: 19153,
  Glidden_PPG1162_4_AlaskanBlue: 19154,
  Glidden_PPG1162_5_ShrinkingViolet: 19155,
  Glidden_PPG1162_6_TeenyBikini: 19156,
  Glidden_PPG1162_7_Dragonfly: 19157,
  Glidden_PPG1163_1_ElusiveBlue: 19158,
  Glidden_PPG1163_2_MemoryLane: 19159,
  Glidden_PPG1163_3_PageantSong: 19160,
  Glidden_PPG1163_4_SterlingSilver: 19161,
  Glidden_PPG1163_5_SilverBlueberry: 19162,
  Glidden_PPG1163_6_BlueFjord: 19163,
  Glidden_PPG1163_7_BlueberryPie: 19164,
  Glidden_PPG1164_1_Windswept: 19165,
  Glidden_PPG1164_2_Iceberg: 19166,
  Glidden_PPG1164_3_BlusteryDay: 19167,
  Glidden_PPG1164_4_Dreamy: 19168,
  Glidden_PPG1164_5_BlueberryMuffin: 19169,
  Glidden_PPG1164_6_BlueCloud: 19170,
  Glidden_PPG1164_7_AnnapolisBlue: 19171,
  Glidden_PPG1165_1_JanuaryDawn: 19172,
  Glidden_PPG1165_2_TwinkleBlue: 19173,
  Glidden_PPG1165_3_NorthernExposure: 19174,
  Glidden_PPG1165_4_Innuendo: 19175,
  Glidden_PPG1165_5_EveningHush: 19176,
  Glidden_PPG1165_6_StainedGlass: 19177,
  Glidden_PPG1165_7_VictoryBlue: 19178,
  Glidden_PPG1166_1_BrightStar: 19179,
  Glidden_PPG1166_4_FreshViolet: 19180,
  Glidden_PPG1166_5_Kimono: 19181,
  Glidden_PPG1166_6_BlueOdyssey: 19182,
  Glidden_PPG1166_7_DaringIndigo: 19183,
  Glidden_PPG1167_1_ArcticDawn: 19184,
  Glidden_PPG1167_2_WindsorHaze: 19185,
  Glidden_PPG1167_3_Debonaire: 19186,
  Glidden_PPG1167_4_LovelyLilac: 19187,
  Glidden_PPG1167_5_SkysailBlue: 19188,
  Glidden_PPG1167_6_BlueberryPatch: 19189,
  Glidden_PPG1167_7_BlueJewel: 19190,
  Glidden_PPG1168_1_MoonLily: 19191,
  Glidden_PPG1168_2_CumberlandFog: 19192,
  Glidden_PPG1168_3_PaleViolet: 19193,
  Glidden_PPG1168_4_LilacTime: 19194,
  Glidden_PPG1168_5_VioletAura: 19195,
  Glidden_PPG1168_6_GrapeHaze: 19196,
  Glidden_PPG1168_7_EgyptianViolet: 19197,
  Glidden_PPG1169_1_WindsweptBeach: 19198,
  Glidden_PPG1169_2_RareOrchid: 19199,
  Glidden_PPG1169_3_GlacierPearl: 19200,
  Glidden_PPG1169_4_TimelessLilac: 19201,
  Glidden_PPG1169_5_VioletVerbena: 19202,
  Glidden_PPG1169_6_GreatGrape: 19203,
  Glidden_PPG1169_7_RoyalHyacinth: 19204,
  Glidden_PPG1170_1_WaterIris: 19205,
  Glidden_PPG1170_2_MonetsLavender: 23168,
  Glidden_PPG1170_2MonetsLavender: 19206,
  Glidden_PPG1170_3_VioletShadow: 19207,
  Glidden_PPG1170_4_SpringLilac: 19208,
  Glidden_PPG1170_5_FreshLavender: 19209,
  Glidden_PPG1170_6_WildWisteria: 19210,
  Glidden_PPG1170_7_RomanViolet: 19211,
  Glidden_PPG1171_1_SilentDelight: 19212,
  Glidden_PPG1171_2_LittleDipper: 19213,
  Glidden_PPG1171_3_IrradiantIris: 19214,
  Glidden_PPG1171_4_Cosmic: 19215,
  Glidden_PPG1171_5_CottonFlannel: 19216,
  Glidden_PPG1171_6_OldMillBlue: 19217,
  Glidden_PPG1171_7_Chinaberry: 19218,
  Glidden_PPG1172_1_SnowStorm: 19219,
  Glidden_PPG1172_2_WinterMorn: 19220,
  Glidden_PPG1172_3_JamSession: 19221,
  Glidden_PPG1172_4_AshGrove: 19222,
  Glidden_PPG1172_5_TinLizzie: 19223,
  Glidden_PPG1172_6_Silverado: 19224,
  Glidden_PPG1172_7_Blackberry: 19225,
  Glidden_PPG1173_1_VioletEcho: 19226,
  Glidden_PPG1173_2_FebruaryFrost: 19227,
  Glidden_PPG1173_3_FrostedLilac: 19228,
  Glidden_PPG1173_4_Silverberry: 19229,
  Glidden_PPG1173_5_PurpleSurf: 19230,
  Glidden_PPG1173_6_PlumShade: 19231,
  Glidden_PPG1173_7_MagicSpell: 19232,
  Glidden_PPG1174_1_OrchidBlossom: 19233,
  Glidden_PPG1174_2_VioletWhimsey: 19234,
  Glidden_PPG1174_3_SilverChalice: 19235,
  Glidden_PPG1174_4_Cloudberry: 19236,
  Glidden_PPG1174_5_SmokyGrape: 19237,
  Glidden_PPG1174_6_PurpleRain: 19238,
  Glidden_PPG1174_7_RoyalIndigo: 19239,
  Glidden_PPG1175_2_PaleOrchid: 19240,
  Glidden_PPG1175_3_LavenderHaze: 19241,
  Glidden_PPG1175_4_WildLilac: 19242,
  Glidden_PPG1175_5_FrenchViolet: 19243,
  Glidden_PPG1175_6_PurpleGrapes: 19244,
  Glidden_PPG1175_7_ImperialPurple: 19245,
  Glidden_PPG1176_1_Peekaboo: 19246,
  Glidden_PPG1176_2_OrchidLane: 19247,
  Glidden_PPG1176_3_DuskyLilac: 19248,
  Glidden_PPG1176_4_PurpleEssence: 19249,
  Glidden_PPG1176_5_VioletEclipse: 19250,
  Glidden_PPG1176_6_Mirabella: 19251,
  Glidden_PPG1176_7_PerfectlyPurple: 19252,
  Glidden_PPG1177_1_OrchidPetal: 19253,
  Glidden_PPG1177_2_LittleLilac: 19254,
  Glidden_PPG1177_3_ShyViolet: 19255,
  Glidden_PPG1177_4_LavishLavender: 19256,
  Glidden_PPG1177_5_PalePlum: 19257,
  Glidden_PPG1177_6_GrapeJelly: 19258,
  Glidden_PPG1177_7_PansyPetal: 19259,
  Glidden_PPG1178_1_LavenderTwilight: 19260,
  Glidden_PPG1178_2_WineFrost: 19261,
  Glidden_PPG1178_3_PaleMauve: 19262,
  Glidden_PPG1178_4_SoftAmethyst: 19263,
  Glidden_PPG1178_5_PalisadeOrchid: 19264,
  Glidden_PPG1178_6_BlackberryJam: 19265,
  Glidden_PPG1178_7_RoyalPlum: 19266,
  Glidden_PPG1179_1_MistyMorn: 19267,
  Glidden_PPG1179_2_SmokyOrchid: 19268,
  Glidden_PPG1179_3_SilverMauve: 19269,
  Glidden_PPG1179_4_RoseMarble: 19270,
  Glidden_PPG1179_5_Ashberry: 19271,
  Glidden_PPG1179_6_VictorianPlum: 19272,
  Glidden_PPG1179_7_LovePotion: 19273,
  Glidden_PPG1180_1_VioletVapor: 19274,
  Glidden_PPG1180_2_RajahRose: 19275,
  Glidden_PPG1180_3_SummerClover: 19276,
  Glidden_PPG1180_4_LightMulberry: 19277,
  Glidden_PPG1180_5_MauveMagic: 19278,
  Glidden_PPG1180_6_FloweringRaspberry: 19279,
  Glidden_PPG1180_7_MagicMagenta: 19280,
  Glidden_PPG1181_1_CandyMix: 19281,
  Glidden_PPG1181_2_BrittanysBow: 23169,
  Glidden_PPG1181_2BrittanysBow: 19282,
  Glidden_PPG1181_3_MountainLaurel: 19283,
  Glidden_PPG1181_4_TickledPink: 19284,
  Glidden_PPG1181_5_RoseGlory: 19285,
  Glidden_PPG1181_6_ParisPink: 19286,
  Glidden_PPG1181_7_PanamaRose: 19287,
  Glidden_PPG1182_1_FullBloom: 19288,
  Glidden_PPG1182_2_Taffy: 19289,
  Glidden_PPG1182_3_PalePrimrose: 19290,
  Glidden_PPG1182_4_GardenParty: 19291,
  Glidden_PPG1182_5_Primrose: 19292,
  Glidden_PPG1182_6_GeraniumPink: 19293,
  Glidden_PPG1182_7_FuchsiaFlock: 19294,
  Glidden_PPG1183_1_Ballerina: 19295,
  Glidden_PPG1183_2_Beauteous: 19296,
  Glidden_PPG1183_3_RoseMelody: 19297,
  Glidden_PPG1183_4_Brandywine: 19298,
  Glidden_PPG1183_5_Razzberries: 19299,
  Glidden_PPG1183_6_CherryPink: 19300,
  Glidden_PPG1183_7_HeartsDesire: 23170,
  Glidden_PPG1183_7HeartsDesire: 19301,
  Glidden_PPG1184_1_Gaiety: 19302,
  Glidden_PPG1184_2_PleasingPink: 19303,
  Glidden_PPG1184_3_PowderRose: 19304,
  Glidden_PPG1184_4_PinkPunch: 19305,
  Glidden_PPG1184_5_CherryBrandy: 19306,
  Glidden_PPG1184_6_KennysKiss: 23171,
  Glidden_PPG1184_6KennysKiss: 19307,
  Glidden_PPG1184_7_CaliforniaWine: 19308,
  Glidden_PPG1185_1_Fresco: 19309,
  Glidden_PPG1185_2_KendallRose: 19310,
  Glidden_PPG1185_3_PreciousPink: 19311,
  Glidden_PPG1185_4_PrimroseGarden: 19312,
  Glidden_PPG1185_5_BleedingHeart: 19313,
  Glidden_PPG1185_6_CranberrySplash: 19314,
  Glidden_PPG1185_7_CalypsoBerry: 19315,
  Glidden_PPG1186_1_LoversKnot: 23172,
  Glidden_PPG1186_1LoversKnot: 19316,
  Glidden_PPG1186_2_PinkySwear: 19317,
  Glidden_PPG1186_3_JaguarRose: 19318,
  Glidden_PPG1186_4_PinkFlambe: 19319,
  Glidden_PPG1186_5_Obsessed: 19320,
  Glidden_PPG1186_6_SalsaDiane: 19321,
  Glidden_PPG1186_7_RedLicorice: 19322,
  Glidden_PPG1187_1_ScentedValentine: 19323,
  Glidden_PPG1187_2_Adorbs: 19324,
  Glidden_PPG1187_3_SilverStrawberry: 19325,
  Glidden_PPG1187_4_RiverRouge: 19326,
  Glidden_PPG1187_5_RedCedar: 19327,
  Glidden_PPG1187_6_Bonfire: 19328,
  Glidden_PPG1187_7_RedGumball: 19329,
  Glidden_PPG1188_1_BurstYourBubble: 19330,
  Glidden_PPG1188_2_FrostedTulip: 19331,
  Glidden_PPG1188_3_Rosewine: 19332,
  Glidden_PPG1188_4_SalmonPink: 19333,
  Glidden_PPG1188_5_SiestaRose: 19334,
  Glidden_PPG1188_6_Briquette: 19335,
  Glidden_PPG1188_7_BurntRed: 19336,
  Glidden_PPG1189_1_FloralLinen: 19337,
  Glidden_PPG1189_2_PinkSangria: 19338,
  Glidden_PPG1189_3_RosePink: 19339,
  Glidden_PPG1189_4_RivieraRose: 19340,
  Glidden_PPG1189_5_SmokedSalmon: 19341,
  Glidden_PPG1189_6_WetCoral: 19342,
  Glidden_PPG1189_7_TeaberryBlossom: 19343,
  Glidden_PPG1190_1_LimogePink: 19344,
  Glidden_PPG1190_2_BalletSlipper: 19345,
  Glidden_PPG1190_3_SoniaRose: 19346,
  Glidden_PPG1190_4_SoftSalmon: 19347,
  Glidden_PPG1190_5_Cranapple: 19348,
  Glidden_PPG1190_6_Firecracker: 19349,
  Glidden_PPG1190_7_RumPunch: 19350,
  Glidden_PPG1191_1_SummerLily: 19351,
  Glidden_PPG1191_2_PeachTone: 19352,
  Glidden_PPG1191_3_PeachAsh: 19353,
  Glidden_PPG1191_4_CoralBlush: 19354,
  Glidden_PPG1191_5_Freckles: 19355,
  Glidden_PPG1191_6_CajunSpice: 19356,
  Glidden_PPG1191_7_GlowingFirelight: 19357,
  Glidden_PPG1192_1_ChampagneIce: 19358,
  Glidden_PPG1192_2_Peachskin: 19359,
  Glidden_PPG1192_3_ChicPeach: 19360,
  Glidden_PPG1192_4_NewClay: 19361,
  Glidden_PPG1192_5_OpalFire: 19362,
  Glidden_PPG1192_6_SummerSunset: 19363,
  Glidden_PPG1192_7_Tabasco: 19364,
  Glidden_PPG1193_1_ScallopedShell: 19365,
  Glidden_PPG1193_2_FlamingoPeach: 19366,
  Glidden_PPG1193_3_CameoRose: 19367,
  Glidden_PPG1193_4_SweetAngel: 19368,
  Glidden_PPG1193_5_CoralSerenade: 19369,
  Glidden_PPG1193_6_RusticPottery: 19370,
  Glidden_PPG1193_7_CinnamonStone: 19371,
  Glidden_PPG1194_1_JasmineFlower: 19372,
  Glidden_PPG1194_2_LaMinuet: 19373,
  Glidden_PPG1194_3_Ambrosia: 19374,
  Glidden_PPG1194_4_SweetSheba: 19375,
  Glidden_PPG1194_5_WarmWelcome: 19376,
  Glidden_PPG1194_6_ClayPot: 19377,
  Glidden_PPG1194_7_OrangeVermillion: 19378,
  Glidden_PPG1195_1_PaleEcru: 19379,
  Glidden_PPG1195_2_PeachEverlasting: 19380,
  Glidden_PPG1195_3_MelonPink: 19381,
  Glidden_PPG1195_4_CrabBisque: 19382,
  Glidden_PPG1195_5_CoralSilk: 19383,
  Glidden_PPG1195_6_IndianaClay: 19384,
  Glidden_PPG1195_7_FieldPoppy: 19385,
  Glidden_PPG1196_1_Peachtree: 19386,
  Glidden_PPG1196_2_MelonIce: 19387,
  Glidden_PPG1196_3_Dreamsicle: 19388,
  Glidden_PPG1196_4_ShrimpBoat: 19389,
  Glidden_PPG1196_5_CopperRiver: 19390,
  Glidden_PPG1196_6_ChineseLantern: 19391,
  Glidden_PPG1196_7_OrangePoppy: 19392,
  Glidden_PPG1197_1_TangeloCream: 19393,
  Glidden_PPG1197_2_LightPeach: 19394,
  Glidden_PPG1197_3_Bisque: 19395,
  Glidden_PPG1197_4_ShrimpToast: 19396,
  Glidden_PPG1197_5_OrangeMarmalade: 19397,
  Glidden_PPG1197_6_FallLeaf: 19398,
  Glidden_PPG1197_7_CarmelizedOrange: 19399,
  Glidden_PPG1198_1_PecanSandie: 19400,
  Glidden_PPG1198_2_BuddingPeach: 19401,
  Glidden_PPG1198_3_CitrusSachet: 19402,
  Glidden_PPG1198_4_OrangeLiqueur: 19403,
  Glidden_PPG1198_5_CarrotCake: 19404,
  Glidden_PPG1198_6_TigerTail: 19405,
  Glidden_PPG1198_7_SesameCrunch: 19406,
  Glidden_PPG1199_1_Alyssa: 19407,
  Glidden_PPG1199_2_PeachShortcake: 19408,
  Glidden_PPG1199_3_SpicedOrange: 19409,
  Glidden_PPG1199_4_HushPuppy: 19410,
  Glidden_PPG1199_5_CinnamonBrandy: 19411,
  Glidden_PPG1199_6_BrownClay: 19412,
  Glidden_PPG1199_7_FragrantCloves: 19413,
  Glidden_PPG12_01_CornSilk: 19414,
  Glidden_PPG12_02_CordonBleu: 19415,
  Glidden_PPG12_03_SunSalutation: 19416,
  Glidden_PPG12_04_BulletinBoard: 19417,
  Glidden_PPG12_05_WinterWheat: 19418,
  Glidden_PPG12_06_Lira: 19419,
  Glidden_PPG12_07_WavesOfGrain: 19420,
  Glidden_PPG12_08_BoldButterscotch: 19421,
  Glidden_PPG12_09_RiceCake: 19422,
  Glidden_PPG12_10_Millet: 19423,
  Glidden_PPG12_11_AntiqueCream: 19424,
  Glidden_PPG12_12_TrueBlonde: 19425,
  Glidden_PPG12_13_CamelTan: 19426,
  Glidden_PPG12_15_Hearth: 19427,
  Glidden_PPG12_16_DesertCamel: 19428,
  Glidden_PPG12_17_TuscanSun: 19429,
  Glidden_PPG12_18_Hayloft: 19430,
  Glidden_PPG12_19_Antiquity: 19431,
  Glidden_PPG12_20_CanvasSatchel: 19432,
  Glidden_PPG12_21_Foothills: 19433,
  Glidden_PPG12_22_AppalachianTrail: 19434,
  Glidden_PPG12_24_GatheringField: 19435,
  Glidden_PPG12_25_ToTheRescue: 19436,
  Glidden_PPG12_26_AssateagueSand: 19437,
  Glidden_PPG12_27_Soleil: 19438,
  Glidden_PPG12_28_AtTheBeach: 19439,
  Glidden_PPG12_29_FamilyTies: 19440,
  Glidden_PPG12_30_Baguette: 19441,
  Glidden_PPG12_31_NeutralBeige: 19442,
  Glidden_PPG12_32_SandcastleSymphony: 19443,
  Glidden_PPG1200_1_ChinaDoll: 19444,
  Glidden_PPG1200_2_SourpatchPeach: 19445,
  Glidden_PPG1200_3_Siesta: 19446,
  Glidden_PPG1200_4_OrangeClay: 19447,
  Glidden_PPG1200_5_GeorgianLeather: 19448,
  Glidden_PPG1200_6_GingerRoot: 19449,
  Glidden_PPG1200_7_Mincemeat: 19450,
  Glidden_PPG1201_1_UptownTaupe: 19451,
  Glidden_PPG1201_2_TeaBiscuit: 19452,
  Glidden_PPG1201_3_PeachDarling: 19453,
  Glidden_PPG1201_4_GentleDoe: 19454,
  Glidden_PPG1201_5_PumpkinPatch: 19455,
  Glidden_PPG1201_6_Gingerbread: 19456,
  Glidden_PPG1201_7_LuckyPenny: 19457,
  Glidden_PPG1202_1_VanillaTan: 19458,
  Glidden_PPG1202_2_PeachSurprise: 19459,
  Glidden_PPG1202_3_CrispWonTon: 19460,
  Glidden_PPG1202_4_CaramelIce: 19461,
  Glidden_PPG1202_5_BuffaloTrail: 19462,
  Glidden_PPG1202_6_PoloPony: 19463,
  Glidden_PPG1202_7_GingerBeer: 19464,
  Glidden_PPG1203_1_SpunCotton: 19465,
  Glidden_PPG1203_2_Mimosa: 19466,
  Glidden_PPG1203_3_PeachDip: 19467,
  Glidden_PPG1203_4_GingerPeach: 19468,
  Glidden_PPG1203_5_Zing: 19469,
  Glidden_PPG1203_6_Goldfish: 19470,
  Glidden_PPG1203_7_Cornucopia: 19471,
  Glidden_PPG1204_1_SpiceIvory: 19472,
  Glidden_PPG1204_2_VanillaWafer: 19473,
  Glidden_PPG1204_3_CreamyCustard: 19474,
  Glidden_PPG1204_4_Doodle: 19475,
  Glidden_PPG1204_5_ChunkOfCheddar: 19476,
  Glidden_PPG1204_6_GoldenOpportunity: 19477,
  Glidden_PPG1204_7_MangoMargarita: 19478,
  Glidden_PPG1205_1_CombedCotton: 19479,
  Glidden_PPG1205_2_SoftCream: 19480,
  Glidden_PPG1205_3_BarelyButter: 19481,
  Glidden_PPG1205_4_HoneyBee: 19482,
  Glidden_PPG1205_5_EveningGlow: 19483,
  Glidden_PPG1205_6_HoneyPot: 19484,
  Glidden_PPG1205_7_FallGold: 19485,
  Glidden_PPG1206_1_LotusFlower: 19486,
  Glidden_PPG1206_2_SilkSails: 19487,
  Glidden_PPG1206_3_ShinySilk: 19488,
  Glidden_PPG1206_4_Sawdust: 19489,
  Glidden_PPG1206_5_SpicedButternut: 19490,
  Glidden_PPG1206_6_FuzzyNavel: 19491,
  Glidden_PPG1206_7_RiseNShine: 19492,
  Glidden_PPG1207_1_CandlelitBeige: 19493,
  Glidden_PPG1207_2_GoldenMushroom: 19494,
  Glidden_PPG1207_3_HoneyBeige: 19495,
  Glidden_PPG1207_4_ToffeeCrunch: 19496,
  Glidden_PPG1207_5_LionsMane: 23173,
  Glidden_PPG1207_5LionsMane: 19497,
  Glidden_PPG1207_6_Allspice: 19498,
  Glidden_PPG1207_7_CiderToddy: 19499,
  Glidden_PPG1208_1_Accolade: 19500,
  Glidden_PPG1208_2_SpiceDelight: 19501,
  Glidden_PPG1208_3_BelgianWaffle: 19502,
  Glidden_PPG1208_4_GoldBuff: 19503,
  Glidden_PPG1208_5_BrownMustard: 19504,
  Glidden_PPG1208_6_MayanTreasure: 19505,
  Glidden_PPG1208_7_GothicGold: 19506,
  Glidden_PPG1209_1_SatinWeave: 19507,
  Glidden_PPG1209_2_Sausalito: 19508,
  Glidden_PPG1209_3_DustyYellow: 19509,
  Glidden_PPG1209_4_YukonGold: 19510,
  Glidden_PPG1209_5_YellowConeflower: 19511,
  Glidden_PPG1209_6_BrassMesh: 19512,
  Glidden_PPG1209_7_MeccaGold: 19513,
  Glidden_PPG1210_1_CrispCandlelight: 19514,
  Glidden_PPG1210_2_GentleGlow: 19515,
  Glidden_PPG1210_3_Visionary: 19516,
  Glidden_PPG1210_4_MaybeMaui: 19517,
  Glidden_PPG1210_5_BrightIdea: 19518,
  Glidden_PPG1210_6_VaVaVoom: 19519,
  Glidden_PPG1210_7_CurrySauce: 19520,
  Glidden_PPG1211_1_GoodGraces: 19521,
  Glidden_PPG1211_2_HeavenlyHaze: 19522,
  Glidden_PPG1211_3_EasyOnTheEyes: 19523,
  Glidden_PPG1211_4_TwinkleLittleStar: 19524,
  Glidden_PPG1211_5_Firelight: 19525,
  Glidden_PPG1211_6_BeachParty: 19526,
  Glidden_PPG1211_7_BeDaring: 19527,
  Glidden_PPG1212_1_CapriCream: 19528,
  Glidden_PPG1212_2_BananaPudding: 19529,
  Glidden_PPG1212_3_Sunbeam: 19530,
  Glidden_PPG1212_4_LazyDaizy: 19531,
  Glidden_PPG1212_5_CitrusPunch: 19532,
  Glidden_PPG1212_6_AcornSquash: 19533,
  Glidden_PPG1212_7_Flirtatious: 19534,
  Glidden_PPG1213_1_SailCloth: 19535,
  Glidden_PPG1213_2_BlondeBeauty: 19536,
  Glidden_PPG1213_3_Butter: 19537,
  Glidden_PPG1213_4_GoldenStraw: 19538,
  Glidden_PPG1213_5_Calabash: 19539,
  Glidden_PPG1213_6_DillyDally: 19540,
  Glidden_PPG1213_7_CrushedPineapple: 19541,
  Glidden_PPG1214_1_CakeBatter: 19542,
  Glidden_PPG1214_2_GoldenFleece: 19543,
  Glidden_PPG1214_3_BananaBrulee: 19544,
  Glidden_PPG1214_4_ButterflyBush: 19545,
  Glidden_PPG1214_5_ForsythiaBlossom: 19546,
  Glidden_PPG1214_6_GoldenHour: 19547,
  Glidden_PPG1214_7_Yarrow: 19548,
  Glidden_PPG1215_1_ClearYellow: 19549,
  Glidden_PPG1215_2_BrightLaughter: 19550,
  Glidden_PPG1215_3_PineappleDelight: 19551,
  Glidden_PPG1215_4_CanaryYellow: 19552,
  Glidden_PPG1215_5_GoldenYarrow: 19553,
  Glidden_PPG1215_6_GrassDaisy: 19554,
  Glidden_PPG1215_7_Pollination: 19555,
  Glidden_PPG1216_1_MorningFog: 19556,
  Glidden_PPG1216_2_CoolYellow: 19557,
  Glidden_PPG1216_3_SpringBlossom: 19558,
  Glidden_PPG1216_4_LemonPepper: 19559,
  Glidden_PPG1216_5_FreshLemonade: 19560,
  Glidden_PPG1216_6_CitrusSpice: 19561,
  Glidden_PPG1216_7_GoneGiddy: 19562,
  Glidden_PPG1217_1_Giggle: 19563,
  Glidden_PPG1217_2_LimitedLime: 19564,
  Glidden_PPG1217_3_HipHop: 19565,
  Glidden_PPG1217_4_MermaidTears: 19566,
  Glidden_PPG1217_5_LimeSplash: 19567,
  Glidden_PPG1217_6_GreenGecko: 19568,
  Glidden_PPG1217_7_SlapHappy: 19569,
  Glidden_PPG1218_1_OhDahling: 19570,
  Glidden_PPG1218_2_MysticMelon: 19571,
  Glidden_PPG1218_3_LivelyLaugh: 19572,
  Glidden_PPG1218_4_ForceOfNature: 19573,
  Glidden_PPG1218_5_Parachute: 19574,
  Glidden_PPG1218_6_MachineGreen: 19575,
  Glidden_PPG1218_7_BeYourself: 19576,
  Glidden_PPG1219_1_PlainAndSimple: 19577,
  Glidden_PPG1219_2_Daydream: 19578,
  Glidden_PPG1219_3_Curious: 19579,
  Glidden_PPG1219_4_GoodyGumdrop: 19580,
  Glidden_PPG1219_5_BoogieBlast: 19581,
  Glidden_PPG1219_6_Hopscotch: 19582,
  Glidden_PPG1219_7_Lichen: 19583,
  Glidden_PPG1220_1_Memoir: 19584,
  Glidden_PPG1220_2_PassionatePause: 19585,
  Glidden_PPG1220_3_LotsOfBubbles: 19586,
  Glidden_PPG1220_4_HighHopes: 19587,
  Glidden_PPG1220_5_CleanNCrisp: 19588,
  Glidden_PPG1220_6_GlowWorm: 19589,
  Glidden_PPG1220_7_Mojo: 19590,
  Glidden_PPG1221_1_AloeEssence: 19591,
  Glidden_PPG1221_3_MellowMint: 19592,
  Glidden_PPG1221_4_Faith: 19593,
  Glidden_PPG1221_5_LivinLarge: 23174,
  Glidden_PPG1221_5LivinLarge: 19594,
  Glidden_PPG1221_6_BeSpontaneous: 19595,
  Glidden_PPG1221_7_FunkyFrog: 19596,
  Glidden_PPG1222_1_LimeMeringue: 19597,
  Glidden_PPG1222_2_HoneydewMelon: 19598,
  Glidden_PPG1222_3_AloeVera: 19599,
  Glidden_PPG1222_4_LettuceAlone: 19600,
  Glidden_PPG1222_5_LimeGreen: 19601,
  Glidden_PPG1222_6_Asparagus: 19602,
  Glidden_PPG1222_7_AntiqueMoss: 19603,
  Glidden_PPG1223_1_GreenTease: 19604,
  Glidden_PPG1223_2_LilyPond: 19605,
  Glidden_PPG1223_3_LimeFlip: 19606,
  Glidden_PPG1223_4_BleachedSpruce: 19607,
  Glidden_PPG1223_5_HeartyHosta: 19608,
  Glidden_PPG1223_6_GrassyMeadow: 19609,
  Glidden_PPG1223_7_AntiqueGreen: 19610,
  Glidden_PPG1224_1_AlaskanMist: 19611,
  Glidden_PPG1224_2_SpearmintStick: 19612,
  Glidden_PPG1224_3_ChilledMint: 19613,
  Glidden_PPG1224_4_LantanaLime: 19614,
  Glidden_PPG1224_5_AlmostAloe: 19615,
  Glidden_PPG1224_6_CelerySprig: 19616,
  Glidden_PPG1224_7_GreenPear: 19617,
  Glidden_PPG1225_1_HintOfMint: 19618,
  Glidden_PPG1225_2_DewmistDelight: 19619,
  Glidden_PPG1225_3_Applemint: 19620,
  Glidden_PPG1225_4_LimeSorbet: 19621,
  Glidden_PPG1225_5_MayApple: 19622,
  Glidden_PPG1225_6_BermudaGrass: 19623,
  Glidden_PPG1225_7_LeapFrog: 19624,
  Glidden_PPG1226_1_TintOfGreen: 19625,
  Glidden_PPG1226_2_PeppermintPatty: 19626,
  Glidden_PPG1226_3_SpriteTwist: 19627,
  Glidden_PPG1226_4_HeathGreen: 19628,
  Glidden_PPG1226_5_GardenMint: 19629,
  Glidden_PPG1226_6_BasilPesto: 19630,
  Glidden_PPG1226_7_BlarneyStone: 19631,
  Glidden_PPG1227_1_SeaMist: 19632,
  Glidden_PPG1227_2_SweetPea: 19633,
  Glidden_PPG1227_3_MountainMint: 19634,
  Glidden_PPG1227_4_CrystalGem: 19635,
  Glidden_PPG1227_5_AragonGreen: 19636,
  Glidden_PPG1227_6_Beanstalk: 19637,
  Glidden_PPG1227_7_GreenGloss: 19638,
  Glidden_PPG1228_1_MaggiesMagic: 23175,
  Glidden_PPG1228_1MaggiesMagic: 19639,
  Glidden_PPG1228_2_JadeSpell: 19640,
  Glidden_PPG1228_3_FloweringCactus: 19641,
  Glidden_PPG1228_4_GreenBalloon: 19642,
  Glidden_PPG1228_5_LaurelWreath: 19643,
  Glidden_PPG1228_6_Leprechaun: 19644,
  Glidden_PPG1228_7_IvyLeague: 19645,
  Glidden_PPG1229_1_Wintergreen: 19646,
  Glidden_PPG1229_2_WintergreenMint: 19647,
  Glidden_PPG1229_3_AlmostAqua: 19648,
  Glidden_PPG1229_4_TropicalTide: 19649,
  Glidden_PPG1229_5_Aloha: 19650,
  Glidden_PPG1229_6_CongoGreen: 19651,
  Glidden_PPG1229_7_CarolinaGreen: 19652,
  Glidden_PPG1230_1_TropicalDream: 19653,
  Glidden_PPG1230_2_Serendipity: 19654,
  Glidden_PPG1230_3_Whirlpool: 19655,
  Glidden_PPG1230_5_JewelWeed: 19656,
  Glidden_PPG1230_7_MedievalForest: 19657,
  Glidden_PPG1231_1_HallowedHush: 19658,
  Glidden_PPG1231_2_SwanLake: 19659,
  Glidden_PPG1231_3_Minerva: 19660,
  Glidden_PPG1231_4_TropicalHoliday: 19661,
  Glidden_PPG1231_5_ArtesianWell: 19662,
  Glidden_PPG1231_6_AzureTide: 19663,
  Glidden_PPG1231_7_RomanticIsle: 19664,
  Glidden_PPG1232_1_IceBlue: 19665,
  Glidden_PPG1232_2_Cascade: 19666,
  Glidden_PPG1232_3_SilentRipple: 19667,
  Glidden_PPG1232_4_IsleRoyale: 19668,
  Glidden_PPG1232_5_TintOfTurquoise: 19669,
  Glidden_PPG1232_6_GrecianIsle: 19670,
  Glidden_PPG1232_7_TorridTurquoise: 19671,
  Glidden_PPG1233_1_FreeSpirit: 19672,
  Glidden_PPG1233_2_Seaspray: 19673,
  Glidden_PPG1233_3_PaleSeafoam: 19674,
  Glidden_PPG1233_4_SeascapeGreen: 19675,
  Glidden_PPG1233_5_TropicalSplash: 19676,
  Glidden_PPG1233_6_MontegoBay: 19677,
  Glidden_PPG1233_7_RivieraParadise: 19678,
  Glidden_PPG1234_1_AquaTint: 19679,
  Glidden_PPG1234_2_Plateau: 19680,
  Glidden_PPG1234_3_AquaWhisper: 19681,
  Glidden_PPG1234_4_FlingGreen: 19682,
  Glidden_PPG1234_5_BiscayBay: 19683,
  Glidden_PPG1234_6_SeaFantasy: 19684,
  Glidden_PPG1234_7_HypnoticSea: 19685,
  Glidden_PPG1235_1_KissMeKate: 19686,
  Glidden_PPG1235_3_Galactica: 19687,
  Glidden_PPG1235_4_IdyllicIsle: 19688,
  Glidden_PPG1235_5_BlueCalypso: 19689,
  Glidden_PPG1235_6_SafeHarbor: 19690,
  Glidden_PPG1235_7_BiminiBlue: 19691,
  Glidden_PPG1236_1_Breathless: 19692,
  Glidden_PPG1236_2_EnchantedEvening: 19693,
  Glidden_PPG1236_3_SurfsUp: 23176,
  Glidden_PPG1236_3SurfsUp: 19694,
  Glidden_PPG1236_4_OceanCruise: 19695,
  Glidden_PPG1236_5_HighDive: 19696,
  Glidden_PPG1236_6_JamaicanSea: 19697,
  Glidden_PPG1236_7_MediterraneanBlue: 19698,
  Glidden_PPG1237_1_Bashful: 19699,
  Glidden_PPG1237_2_DiamondBlue: 19700,
  Glidden_PPG1237_3_Ariel: 19701,
  Glidden_PPG1237_4_HorizonHaze: 19702,
  Glidden_PPG1237_5_MysticBlue: 19703,
  Glidden_PPG1237_6_Bellflower: 19704,
  Glidden_PPG1237_7_Neptune: 19705,
  Glidden_PPG1238_1_Airy: 19706,
  Glidden_PPG1238_2_Goddess: 19707,
  Glidden_PPG1238_3_FlemishBlue: 19708,
  Glidden_PPG1238_4_HarborSky: 19709,
  Glidden_PPG1238_5_HushABye: 19710,
  Glidden_PPG1238_6_BluePaisley: 19711,
  Glidden_PPG1238_7_PortAuPrince: 19712,
  Glidden_PPG1239_1_Wavecrest: 19713,
  Glidden_PPG1239_2_DucksEggBlue: 23177,
  Glidden_PPG1239_2DucksEggBlue: 19714,
  Glidden_PPG1239_3_WindsorWay: 19715,
  Glidden_PPG1239_4_SalemBlue: 19716,
  Glidden_PPG1239_5_QuietNight: 19717,
  Glidden_PPG1239_6_NorthSea: 19718,
  Glidden_PPG1239_7_RaveRegatta: 19719,
  Glidden_PPG1240_1_OceanBreeze: 19720,
  Glidden_PPG1240_2_NiagaraFalls: 19721,
  Glidden_PPG1240_3_Songbird: 19722,
  Glidden_PPG1240_4_XavierBlue: 19723,
  Glidden_PPG1240_5_Sorcerer: 19724,
  Glidden_PPG1240_6_NewportBlue: 19725,
  Glidden_PPG1240_7_CobaltGlaze: 19726,
  Glidden_PPG1241_1_FirstLight: 19727,
  Glidden_PPG1241_2_VitaminSea: 19728,
  Glidden_PPG1241_3_SweetDreams: 19729,
  Glidden_PPG1241_4_Windjammer: 19730,
  Glidden_PPG1241_5_MagicalMerlin: 19731,
  Glidden_PPG1241_6_ElectricBlue: 19732,
  Glidden_PPG1241_7_CobaltStone: 19733,
  Glidden_PPG1242_1_FirstFrost: 19734,
  Glidden_PPG1242_2_TouchOfBlue: 19735,
  Glidden_PPG1242_3_VivaLaBleu: 19736,
  Glidden_PPG1242_4_Overcast: 19737,
  Glidden_PPG1242_5_KingTriton: 19738,
  Glidden_PPG1242_6_Planetarium: 19739,
  Glidden_PPG1242_7_SuddenlySapphire: 19740,
  Glidden_PPG1243_1_SweetIllusion: 19741,
  Glidden_PPG1243_2_HauntingHue: 19742,
  Glidden_PPG1243_3_SetSail: 19743,
  Glidden_PPG1243_4_VictoriaBlue: 19744,
  Glidden_PPG1243_5_BlueDart: 19745,
  Glidden_PPG1243_6_RoyalPlume: 19746,
  Glidden_PPG1243_7_RainbowBright: 19747,
  Glidden_PPG1244_1_Abyss: 19748,
  Glidden_PPG1244_2_BlueSilk: 19749,
  Glidden_PPG1244_3_Valor: 19750,
  Glidden_PPG1244_4_BoudoirBlue: 19751,
  Glidden_PPG1244_5_BlueberryPopover: 19752,
  Glidden_PPG1244_6_NocturneShade: 19753,
  Glidden_PPG1244_7_FlorentineLapis: 19754,
  Glidden_PPG1245_1_OrchidWhisper: 19755,
  Glidden_PPG1245_2_PaleLilac: 19756,
  Glidden_PPG1245_3_SweetEmily: 19757,
  Glidden_PPG1245_4_LilacSachet: 19758,
  Glidden_PPG1245_5_BlueHyacinth: 19759,
  Glidden_PPG1245_6_KingsRobe: 23178,
  Glidden_PPG1245_6KingsRobe: 19760,
  Glidden_PPG1245_7_CrushedVelvet: 19761,
  Glidden_PPG1246_1_VioletIce: 19762,
  Glidden_PPG1246_2_WeepingWisteria: 19763,
  Glidden_PPG1246_3_GlobeThistle: 19764,
  Glidden_PPG1246_4_FrenchLilac: 19765,
  Glidden_PPG1246_5_MysticIris: 19766,
  Glidden_PPG1246_6_VioletsAreBlue: 19767,
  Glidden_PPG1246_7_BlueCalico: 19768,
  Glidden_PPG1247_1_OrchidMist: 19769,
  Glidden_PPG1247_2_GuardianAngel: 19770,
  Glidden_PPG1247_3_MistyViolet: 19771,
  Glidden_PPG1247_4_PurpleDragon: 19772,
  Glidden_PPG1247_5_GrapeArbor: 19773,
  Glidden_PPG1247_6_PurpleRhapsody: 19774,
  Glidden_PPG1247_7_Eggplant: 19775,
  Glidden_PPG1248_1_Coronation: 19776,
  Glidden_PPG1248_2_IrisIsle: 19777,
  Glidden_PPG1248_3_VelvetScarf: 19778,
  Glidden_PPG1248_4_LilacBreeze: 19779,
  Glidden_PPG1248_5_Puturple: 19780,
  Glidden_PPG1248_6_MagicCarpet: 19781,
  Glidden_PPG1248_7_ReignOverMe: 19782,
  Glidden_PPG1249_1_VioletVogue: 19783,
  Glidden_PPG1249_2_LavenderVista: 19784,
  Glidden_PPG1249_3_GrapeGlimmer: 19785,
  Glidden_PPG1249_4_WindsorPurple: 19786,
  Glidden_PPG1249_5_PurpleStatice: 19787,
  Glidden_PPG1249_6_GrapePopsicle: 19788,
  Glidden_PPG1249_7_CleopatrasGown: 23179,
  Glidden_PPG1249_7CleopatrasGown: 19789,
  Glidden_PPG1250_1_AngoraPink: 19790,
  Glidden_PPG1250_2_LilacFrost: 19791,
  Glidden_PPG1250_3_SyrianViolet: 19792,
  Glidden_PPG1250_4_SeaLavender: 19793,
  Glidden_PPG1250_5_PlumPerfect: 19794,
  Glidden_PPG1250_6_BellHeather: 19795,
  Glidden_PPG1250_7_RoyalLilac: 19796,
  Glidden_PPG1251_1_DreamDust: 19797,
  Glidden_PPG1251_2_Tiara: 19798,
  Glidden_PPG1251_3_SonoraRose: 19799,
  Glidden_PPG1251_4_PinkPeony: 19800,
  Glidden_PPG1251_5_MoorlandHeather: 19801,
  Glidden_PPG1251_6_MulberryBush: 19802,
  Glidden_PPG1251_7_GrapeJuice: 19803,
  Glidden_PPG1252_1_LavenderPearl: 19804,
  Glidden_PPG1252_2_HeavenSent: 19805,
  Glidden_PPG1252_4_SweetAlyssum: 19806,
  Glidden_PPG1252_5_ChateauRose: 19807,
  Glidden_PPG1252_6_DaphneRose: 19808,
  Glidden_PPG1252_7_BermudaOnion: 19809,
  Glidden_PPG13_01_PomegranatePunch: 19810,
  Glidden_PPG13_02_FallingwaterRed: 19811,
  Glidden_PPG13_04_Merlot: 19812,
  Glidden_PPG13_05_OldBurgundy: 19813,
  Glidden_PPG13_06_Chianti: 19814,
  Glidden_PPG13_07_EnchantingEggplant: 19815,
  Glidden_PPG13_08_PositivelyPurple: 19816,
  Glidden_PPG13_09_CrushedTomatoes: 19817,
  Glidden_PPG13_10_CandyApple: 19818,
  Glidden_PPG13_11_MadeiraRed: 19819,
  Glidden_PPG13_12_CrazedCranberry: 19820,
  Glidden_PPG13_13_RoastedPepper: 19821,
  Glidden_PPG13_14_HeartsAfire: 23180,
  Glidden_PPG13_14HeartsAfire: 19822,
  Glidden_PPG13_15_BingeWatch: 19823,
  Glidden_PPG13_16_Blaze: 19824,
  Glidden_PPG13_17_PurpleParlor: 19825,
  Glidden_PPG13_18_PinotNoir: 19826,
  Glidden_PPG13_19_PurpleDusk: 19827,
  Glidden_PPG13_20_PageantPansy: 19828,
  Glidden_PPG13_23_AmethystHaze: 19829,
  Glidden_PPG13_24_MagicDust: 19830,
  Glidden_PPG13_27_PlymouthBlue: 19831,
  Glidden_PPG13_28_CaribbeanHoliday: 19832,
  Glidden_PPG13_29_AntiqueSlate: 19833,
  Glidden_PPG13_30_SeaGlass: 19834,
  Glidden_PPG13_31_StillSearching: 19835,
  Glidden_PPG13_32_EmeraldCity: 19836,
  Glidden_PPG14_01_ShadowTaupe: 19837,
  Glidden_PPG14_02_NutShell: 19838,
  Glidden_PPG14_03_Seagull: 19839,
  Glidden_PPG14_04_CityStreet: 19840,
  Glidden_PPG14_05_DarkAsNight: 19841,
  Glidden_PPG14_06_WinterFeather: 19842,
  Glidden_PPG14_07_ScotchMist: 19843,
  Glidden_PPG14_09_RockCliffs: 19844,
  Glidden_PPG14_10_SummerWheat: 19845,
  Glidden_PPG14_11_Static: 19846,
  Glidden_PPG14_12_JewelWhite: 19847,
  Glidden_PPG14_13_OysterShell: 19848,
  Glidden_PPG14_14_SummerSuede: 19849,
  Glidden_PPG14_15_FrenchCream: 19850,
  Glidden_PPG14_16_WinterMood: 19851,
  Glidden_PPG14_17_Armadillo: 19852,
  Glidden_PPG14_18_Gaia: 19853,
  Glidden_PPG14_19_AlpacaWool: 19854,
  Glidden_PPG14_20_Purity: 19855,
  Glidden_PPG14_21_WheatSheaf: 19856,
  Glidden_PPG14_23_Edelweiss: 19857,
  Glidden_PPG14_24_DogwoodBlossom: 19858,
  Glidden_PPG14_25_FishermansNet: 23181,
  Glidden_PPG14_25FishermansNet: 19859,
  Glidden_PPG14_26_Hideaway: 19860,
  Glidden_PPG14_27_TrueKhaki: 19861,
  Glidden_PPG14_28_Aldabra: 19862,
  Glidden_PPG14_30_GrayBeige: 19863,
  Glidden_PPG14_31_Paraffin: 19864,
  Glidden_PPG14_32_OstrichFeather: 19865,
  Glidden_PPG15_01_MaisonDeCampagne: 19866,
  Glidden_PPG15_02_AppleButter: 19867,
  Glidden_PPG15_03_BroncoBrown: 19868,
  Glidden_PPG15_04_YosemiteTrailhead: 19869,
  Glidden_PPG15_05_MacaroonCream: 19870,
  Glidden_PPG15_06_WhiteChip: 19871,
  Glidden_PPG15_07_YorkIvory: 19872,
  Glidden_PPG15_08_BurntIvory: 19873,
  Glidden_PPG15_09_Antelope: 19874,
  Glidden_PPG15_10_PetalumaDust: 19875,
  Glidden_PPG15_11_Rabbit: 19876,
  Glidden_PPG15_12_Kangaroo: 19877,
  Glidden_PPG15_13_ChocolateTruffle: 19878,
  Glidden_PPG15_14_Leather: 19879,
  Glidden_PPG15_18_Introspective: 19880,
  Glidden_PPG15_19_RapidRock: 19881,
  Glidden_PPG15_20_GhostShip: 19882,
  Glidden_PPG15_21_Curlew: 19883,
  Glidden_PPG15_22_Pumpernickel: 19884,
  Glidden_PPG15_23_Chestnut: 19885,
  Glidden_PPG15_24_FrenchToast: 19886,
  Glidden_PPG15_25_Stonington: 19887,
  Glidden_PPG15_27_BotanyBeige: 19888,
  Glidden_PPG15_28_GreatGray: 19889,
  Glidden_PPG15_29_ElCapitan: 19890,
  Glidden_PPG15_30_RoastedChestnut: 19891,
  Glidden_PPG15_31_BeigeTellin: 19892,
  Glidden_PPG15_32_Portabella: 19893,
  Glidden_PPG16_01_SombreroTan: 19894,
  Glidden_PPG16_02_SummerSpice: 19895,
  Glidden_PPG16_03_BurningSand: 19896,
  Glidden_PPG16_04_Capuccino: 19897,
  Glidden_PPG16_05_CaramelSugar: 19898,
  Glidden_PPG16_06_RedRockFalls: 19899,
  Glidden_PPG16_07_SouthernWood: 19900,
  Glidden_PPG16_08_AntiqueMahogany: 19901,
  Glidden_PPG16_09_LinenTint: 19902,
  Glidden_PPG16_10_Hummus: 19903,
  Glidden_PPG16_11_ApolloGold: 19904,
  Glidden_PPG16_12_ItalianSaffron: 19905,
  Glidden_PPG16_13_PumpkinSpice: 19906,
  Glidden_PPG16_14_BranMuffin: 19907,
  Glidden_PPG16_15_BrownBasket: 19908,
  Glidden_PPG16_16_TreasureHunt: 19909,
  Glidden_PPG16_17_TudorBeige: 19910,
  Glidden_PPG16_18_CoveredWagon: 19911,
  Glidden_PPG16_19_Broomstick: 19912,
  Glidden_PPG16_20_BronzeEucalyptus: 19913,
  Glidden_PPG16_21_FreshPraline: 19914,
  Glidden_PPG16_22_Chaparral: 19915,
  Glidden_PPG16_23_TampicoBrown: 19916,
  Glidden_PPG16_24_ChocolateCroissant: 19917,
  Glidden_PPG16_25_MapleGranola: 19918,
  Glidden_PPG16_27_CopperTrail: 19919,
  Glidden_PPG16_28_CrushedCinnamon: 19920,
  Glidden_PPG16_29_HuntClubRed: 19921,
  Glidden_PPG16_30_MutedCopper: 19922,
  Glidden_PPG16_31_RichClay: 19923,
  Glidden_PPG16_32_RedClay: 19924,
  Glidden_PPG17_01_Suenos: 19925,
  Glidden_PPG17_02_Cenote: 19926,
  Glidden_PPG17_03_HaciendaTalavera: 19927,
  Glidden_PPG17_06_MagicalMoment: 19928,
  Glidden_PPG17_07_CrowningGlory: 19929,
  Glidden_PPG17_08_HeatherGlen: 19930,
  Glidden_PPG17_09_FlorentinePink: 19931,
  Glidden_PPG17_10_TuttiFrutti: 19932,
  Glidden_PPG17_11_Cerise: 19933,
  Glidden_PPG17_12_Granada: 19934,
  Glidden_PPG17_16_CandyCorn: 19935,
  Glidden_PPG17_17_Mariposa: 19936,
  Glidden_PPG17_18_SolDeYucatan: 19937,
  Glidden_PPG17_19_OroDeMaya: 19938,
  Glidden_PPG17_20_Tesoros: 19939,
  Glidden_PPG17_21_SorbeteDeMelon: 19940,
  Glidden_PPG17_22_Dynamo: 19941,
  Glidden_PPG17_23_Cazuela: 19942,
  Glidden_PPG17_24_CopperPenny: 19943,
  Glidden_PPG17_25_GotTheGiggles: 19944,
  Glidden_PPG17_26_WillowHerb: 19945,
  Glidden_PPG17_27_FernGlow: 19946,
  Glidden_PPG17_28_LeafMeBe: 19947,
  Glidden_PPG17_29_SanJuanSpritz: 19948,
  Glidden_PPG17_30_DinnerMint: 19949,
  Glidden_PPG17_31_CaribbeanCrush: 19950,
  Glidden_PPG17_32_TealWeMeetAgain: 19951,
  Glidden_PPG18_01_CrumbCookie: 19952,
  Glidden_PPG18_02_RiverRock: 19953,
  Glidden_PPG18_03_GreyMauve: 19954,
  Glidden_PPG18_04_Luxurious: 19955,
  Glidden_PPG18_05_Awakening: 19956,
  Glidden_PPG18_06_MexicaliRose: 19957,
  Glidden_PPG18_07_LusciousLilac: 19958,
  Glidden_PPG18_08_SmokyQuartz: 19959,
  Glidden_PPG18_09_GarlicClove: 19960,
  Glidden_PPG18_10_LotusPetal: 19961,
  Glidden_PPG18_11_PastelPaper: 19962,
  Glidden_PPG18_12_GranddadsGirl: 23182,
  Glidden_PPG18_12GranddadsGirl: 19963,
  Glidden_PPG18_13_BeigeLlama: 19964,
  Glidden_PPG18_14_SpiceBeige: 19965,
  Glidden_PPG18_15_ShrimpSalad: 19966,
  Glidden_PPG18_16_SalmonEggs: 19967,
  Glidden_PPG18_17_JustBlush: 19968,
  Glidden_PPG18_18_RoseBlush: 19969,
  Glidden_PPG18_19_CrushedRoses: 19970,
  Glidden_PPG18_20_Thornberry: 19971,
  Glidden_PPG18_21_MoodyMauve: 19972,
  Glidden_PPG18_22_MakeMineMauve: 19973,
  Glidden_PPG18_23_BerriesAndCream: 19974,
  Glidden_PPG18_24_PurpleCabbage: 19975,
  Glidden_PPG18_25_Belleek: 19976,
  Glidden_PPG18_26_PeachBrick: 19977,
  Glidden_PPG18_27_PeachBeauty: 19978,
  Glidden_PPG18_28_Adorable: 19979,
  Glidden_PPG18_29_Emberglo: 19980,
  Glidden_PPG18_30_LushRose: 19981,
  Glidden_PPG18_31_RaspberryRipple: 19982,
  Glidden_PPG18_32_BerryPicking: 19983,
};

const DMC_Grout_ProVia = {
  Black: 10470,
  Brown: 10471,
  Buff: 10472,
  Gray: 10473,
  White: 10474,
};

const DMC_GutterHelp = {
  Almond_140: 2132,
  Almond_794: 2133,
  AlmondCream_219: 2134,
  AntiqueIvory_105: 2135,
  AutumnLeaf_560: 2136,
  Black_200: 2137,
  Buckskin_224: 2138,
  Buckskin_841: 2139,
  Cactus_200: 2140,
  Champagne_827: 2141,
  Clay_238: 2142,
  Clay_807: 2143,
  Coppertone_780: 2144,
  CozyCottage_604: 2145,
  Cranberry_820: 2146,
  Cream_817: 2147,
  DarkBronze_339: 2148,
  DarkGray_301: 2149,
  DesertTan_327: 2150,
  EldridgeGray_605: 2151,
  ForestGreen_522: 2152,
  Galvalume_700: 2153,
  Granite_204: 2154,
  GrecianGreen_204: 2155,
  Heather_111: 2156,
  Herringbone_819: 2157,
  ImperialBrown_223: 2158,
  Ivory_901: 2159,
  IvyGreen_821: 2160,
  LightBronze_253: 2161,
  LightMaple_335: 2162,
  Linen_002: 2163,
  LowGlossWhite_130: 2164,
  Mocha_507: 2165,
  MusketBrown_250: 2166,
  Navy_521: 2167,
  Norwood_791: 2168,
  OliveGreen_173: 2169,
  PacificBlue_822: 2170,
  PearlGray_102: 2171,
  Pewter_175: 2172,
  Pewter_801: 2173,
  PrairieSand_538: 2174,
  RoyalBrown_202: 2175,
  Sable_538: 2176,
  Sand_793: 2177,
  SandstoneBeige_325: 2178,
  SandyBeige_177: 2179,
  ScotchRed_209: 2180,
  Shale_810: 2181,
  Shell_138: 2182,
  Snowmist_523: 2183,
  Sun_108: 2184,
  Terratone_360: 2185,
  Terratone_511: 2186,
  TuxedoGray_112: 2187,
  Wicker_712: 2188,
  Wicker_713: 2189,
  Wineberry_604: 2190,
  WoodlandGreen_214: 2191,
};

const DMC_HaasDoor = {
  Almond: 2094,
  Bronze: 2095,
  Brown: 2096,
  CarbonBlack: 2097,
  Charcoal: 2098,
  EnglishOak: 10783,
  Espresso: 10784,
  Gray: 2099,
  Mahogany: 10785,
  PolarWhite: 2100,
  Sandstone: 2101,
  Walnut: 10869,
};

const DMC_Harris = {
  Harris_0001_HintOfVanilla: 23183,
  Harris_0002_ElusiveWhite: 23184,
  Harris_0003_NillaVanilla: 23185,
  Harris_0004_ChildOfHeaven: 23186,
  Harris_0005_Kiara: 23187,
  Harris_0006_LittleDove: 23188,
  Harris_0007_CottonBall: 23189,
  Harris_0008_CasaBlanca: 23190,
  Harris_0009_ChapelWall: 23191,
  Harris_0010_Petticoat: 23192,
  Harris_0011_SugarDust: 23193,
  Harris_0012_BunnyCake: 23194,
  Harris_0013_Sphere: 23195,
  Harris_0014_Twill: 23196,
  Harris_0015_WhiteGlove: 23197,
  Harris_0016_PumiceStone: 23198,
  Harris_0017_LunaMoon: 23199,
  Harris_0018_DoveWhite: 23200,
  Harris_0019_MysticFog: 23201,
  Harris_0020_Bonaire: 23202,
  Harris_0021_BarelyWhite: 23203,
  Harris_0022_WhiteKitten: 23204,
  Harris_0023_ShellTint: 23205,
  Harris_0024_JustAboutWhite: 23206,
  Harris_0025_PrismaticPearl: 23207,
  Harris_0026_MoonDrop: 23208,
  Harris_0027_WhiteFence: 23209,
  Harris_0028_BannisterWhite: 23210,
  Harris_0029_CherishIsTheWord: 23211,
  Harris_0030_LadyNicole: 23212,
  Harris_0031_ItalianIce: 23213,
  Harris_0032_IceDream: 23214,
  Harris_0033_ChafedWheat: 23215,
  Harris_0034_HereComesTheSun: 23216,
  Harris_0035_WeekendRetreat: 23217,
  Harris_0036_FortunesPrize: 23218,
  Harris_0037_MoneyTree: 23219,
  Harris_0038_AutumnsHill: 23220,
  Harris_0039_MandalayRoad: 23221,
  Harris_0040_AntiqueCandleLight: 23222,
  Harris_0041_ChineseCherry: 23223,
  Harris_0042_AntoinettePink: 23224,
  Harris_0043_AngelBreath: 23225,
  Harris_0044_Calliope: 23226,
  Harris_0045_SizzlingHot: 23227,
  Harris_0046_Valentino: 23228,
  Harris_0047_SandIsland: 23229,
  Harris_0048_Embrace: 23230,
  Harris_0049_AuburnWave: 23231,
  Harris_0050_SimmeringRidge: 23232,
  Harris_0051_CaramelCandy: 23233,
  Harris_0052_SpicedCarrot: 23234,
  Harris_0053_RemainingEmbers: 23235,
  Harris_0054_WinkPink: 23236,
  Harris_0055_StrawberryWhip: 23237,
  Harris_0056_DaintyDebutante: 23238,
  Harris_0057_MarblePink: 23239,
  Harris_0058_AngelicChoir: 23240,
  Harris_0059_Quintessential: 23241,
  Harris_0060_ParlorRose: 23242,
  Harris_0061_Pinkathon: 23243,
  Harris_0062_BloomingPerfect: 23244,
  Harris_0063_ImpatientHeart: 23245,
  Harris_0064_LordBaltimore: 23246,
  Harris_0065_PoppyProse: 23247,
  Harris_0066_WildRose: 23248,
  Harris_0067_LoversKiss: 23249,
  Harris_0068_SummerBlush: 23250,
  Harris_0069_EmpireRose: 23251,
  Harris_0070_OFortuna: 23252,
  Harris_0071_RubyEye: 23253,
  Harris_0072_NoticeMe: 23254,
  Harris_0073_Corazon: 23255,
  Harris_0074_EmperorsRobe: 23256,
  Harris_0075_PinkDuet: 23257,
  Harris_0076_FantasticPink: 23258,
  Harris_0077_PinkSoftness: 23259,
  Harris_0078_BeMine: 23260,
  Harris_0079_Prophetess: 23261,
  Harris_0080_AbraCadabra: 23262,
  Harris_0081_BerryCrush: 23263,
  Harris_0082_RoseShadow: 23264,
  Harris_0083_PinkCoral: 23265,
  Harris_0084_QuietPink: 23266,
  Harris_0085_FragrantSatchel: 23267,
  Harris_0086_KingsCloak: 23268,
  Harris_0087_Cinnapink: 23269,
  Harris_0088_Casandra: 23270,
  Harris_0089_StarOfMorning: 23271,
  Harris_0090_MoonGoddess: 23272,
  Harris_0091_GarnetShadow: 23273,
  Harris_0092_FreshDay: 23274,
  Harris_0093_HeraldOfSpring: 23275,
  Harris_0094_Starlet: 23276,
  Harris_0095_QueensRose: 23277,
  Harris_0096_MorningSide: 23278,
  Harris_0097_OdysseyPlum: 23279,
  Harris_0098_Lockhart: 23280,
  Harris_0099_LoversTryst: 23281,
  Harris_0100_Whimsy: 23282,
  Harris_0101_FruitfulOrchard: 23283,
  Harris_0102_EarthlyPleasure: 23284,
  Harris_0103_Hosanna: 23285,
  Harris_0104_VictorianCottage: 23286,
  Harris_0105_HarvestBlessing: 23287,
  Harris_0106_RareFind: 23288,
  Harris_0107_Prosperity: 23289,
  Harris_0108_Exotica: 23290,
  Harris_0109_KungFu: 23291,
  Harris_0110_BabyBunting: 23292,
  Harris_0111_AcadiaBloom: 23293,
  Harris_0112_LadyFlower: 23294,
  Harris_0113_PunchOfPink: 23295,
  Harris_0114_MontroseRose: 23296,
  Harris_0115_Sophistication: 23297,
  Harris_0116_CordovaBurgundy: 23298,
  Harris_0117_SatinSlipper: 23299,
  Harris_0118_MiniaturePosey: 23300,
  Harris_0119_AngelaCanyon: 23301,
  Harris_0120_SummersEve: 23302,
  Harris_0121_Savanna: 23303,
  Harris_0122_Outrageous: 23304,
  Harris_0123_MontereyChestnut: 23305,
  Harris_0124_MerlinsBeard: 23306,
  Harris_0125_Pout: 23307,
  Harris_0126_Sauterne: 23308,
  Harris_0127_AndesAsh: 23309,
  Harris_0128_RockyMountain: 23310,
  Harris_0129_Arrowhead: 23311,
  Harris_0130_Evolution: 23312,
  Harris_0131_Cliffswallow: 23313,
  Harris_0132_SummerBeige: 23314,
  Harris_0133_Natchez: 23315,
  Harris_0134_BabySprout: 23316,
  Harris_0135_EmergingLeaf: 23317,
  Harris_0136_AmazonMist: 23318,
  Harris_0137_Hideaway: 23319,
  Harris_0138_CoconutMacaroon: 23320,
  Harris_0139_Souffle: 23321,
  Harris_0140_CozyCover: 23322,
  Harris_0141_BushBuck: 23323,
  Harris_0142_RanchHouse: 23324,
  Harris_0143_Connoisseur: 23325,
  Harris_0144_FilmNoir: 23326,
  Harris_0145_FlaxFlower: 23327,
  Harris_0146_Truffles: 23328,
  Harris_0147_CavePainting: 23329,
  Harris_0148_OakPlank: 23330,
  Harris_0149_PavilionTan: 23331,
  Harris_0150_Temptation: 23332,
  Harris_0151_CoffeeShop: 23333,
  Harris_0152_Flirt: 23334,
  Harris_0153_TakeOut: 23335,
  Harris_0154_Romulus: 23336,
  Harris_0155_Cowhide: 23337,
  Harris_0156_SkinnyDip: 23338,
  Harris_0157_DodgePole: 23339,
  Harris_0158_MoverAndShaker: 23340,
  Harris_0159_SeniorMoment: 23341,
  Harris_0160_KingdomsKeys: 23342,
  Harris_0161_TinyCalf: 23343,
  Harris_0162_ApplePie: 23344,
  Harris_0163_CamelTrain: 23345,
  Harris_0164_Veldrift: 23346,
  Harris_0165_CavernSand: 23347,
  Harris_0166_PastelDay: 23348,
  Harris_0167_FirstDate: 23349,
  Harris_0168_CandleLight: 23350,
  Harris_0169_FossilTan: 23351,
  Harris_0170_BlondeShell: 23352,
  Harris_0171_GoldenGlove: 23353,
  Harris_0172_Chasm: 23354,
  Harris_0174_MaplePecan: 23355,
  Harris_0175_3amLatte: 23356,
  Harris_0176_CountryDweller: 23357,
  Harris_0177_WeaversTool: 23358,
  Harris_0178_Cupcake: 23359,
  Harris_0179_FallInSeason: 23360,
  Harris_0180_FreshLinen: 23361,
  Harris_0181_Ageless: 23362,
  Harris_0182_IvoryRidge: 23363,
  Harris_0183_MothWing: 23364,
  Harris_0184_MacadamiaBrown: 23365,
  Harris_0185_NobleCrown: 23366,
  Harris_0186_ChristmasOrnament: 23367,
  Harris_0187_WhiteLightning: 23368,
  Harris_0188_Baguette: 23369,
  Harris_0189_DelicateHoneysweet: 23370,
  Harris_0190_VillageCrier: 23371,
  Harris_0191_DustyPath: 23372,
  Harris_0192_Dapper: 23373,
  Harris_0193_AlphaMale: 23374,
  Harris_0194_AugustMoon: 23375,
  Harris_0195_MossyShade: 23376,
  Harris_0196_Overgrown: 23377,
  Harris_0197_ThistleGray: 23378,
  Harris_0198_YoungColt: 23379,
  Harris_0199_SandyShoes: 23380,
  Harris_0200_StonyField: 23381,
  Harris_0201_SparklingChampagne: 23382,
  Harris_0202_PowderCake: 23383,
  Harris_0203_WhaleBone: 23384,
  Harris_0204_MarshyHabitat: 23385,
  Harris_0205_WoodShadow: 23386,
  Harris_0206_ThatchedCottage: 23387,
  Harris_0207_AresShadow: 23388,
  Harris_0208_UmberStyle: 23389,
  Harris_0209_Polished: 23390,
  Harris_0210_HiddenCove: 23391,
  Harris_0211_LightLichen: 23392,
  Harris_0212_BigSpender: 23393,
  Harris_0213_CoastalFog: 23394,
  Harris_0214_Wildwood: 23395,
  Harris_0215_HerareWhite: 23396,
  Harris_0216_Earthling: 23397,
  Harris_0217_OakTone: 23398,
  Harris_0218_DriftingSand: 23399,
  Harris_0219_CamelsHump: 23400,
  Harris_0220_MonksCloth: 23401,
  Harris_0221_BrownSuede: 23402,
  Harris_0222_AuNatural: 23403,
  Harris_0223_WhiteElephant: 23404,
  Harris_0224_Pebblebrook: 23405,
  Harris_0225_RomanRuins: 23406,
  Harris_0226_Sedge: 23407,
  Harris_0227_Moonscape: 23408,
  Harris_0228_HannoverHills: 23409,
  Harris_0229_FeatherStone: 23410,
  Harris_0230_HarrowGate: 23411,
  Harris_0231_DesertMirage: 23412,
  Harris_0232_Frond: 23413,
  Harris_0233_DeepMarsh: 23414,
  Harris_0234_IndustrialStrength: 23415,
  Harris_0235_BlackHeath: 23416,
  Harris_0236_SundayGloves: 23417,
  Harris_0237_Flan: 23418,
  Harris_0238_CrownedOne: 23419,
  Harris_0239_TailoredTan: 23420,
  Harris_0240_SpicedRum: 23421,
  Harris_0241_PrinceParis: 23422,
  Harris_0242_RareHappening: 23423,
  Harris_0243_FrozenCustard: 23424,
  Harris_0244_MulledCider: 23425,
  Harris_0245_CaramelCloud: 23426,
  Harris_0246_CinnamonToast: 23427,
  Harris_0247_AppleCrisp: 23428,
  Harris_0248_SafariSun: 23429,
  Harris_0249_ButterscotchMousse: 23430,
  Harris_0250_PumpkinSpice: 23431,
  Harris_0251_Alchemy: 23432,
  Harris_0252_OctoberBounty: 23433,
  Harris_0253_HoneyGlow: 23434,
  Harris_0254_LivingLarge: 23435,
  Harris_0255_BackToBasics: 23436,
  Harris_0256_CrazyHorse: 23437,
  Harris_0257_Shortbread: 23438,
  Harris_0258_ClassicTerra: 23439,
  Harris_0259_PersianFable: 23440,
  Harris_0260_CocoaNib: 23441,
  Harris_0261_TanHide: 23442,
  Harris_0262_LogCabin: 23443,
  Harris_0263_CountryCharm: 23444,
  Harris_0264_PalestOfLemon: 23445,
  Harris_0265_MarshmallowMist: 23446,
  Harris_0266_OctoberHarvest: 23447,
  Harris_0267_SeasonFinale: 23448,
  Harris_0268_RichOak: 23449,
  Harris_0269_SaharaWind: 23450,
  Harris_0270_GrahamCrust: 23451,
  Harris_0271_CloverHoney: 23452,
  Harris_0272_MineralWater: 23453,
  Harris_0273_SandstonePalette: 23454,
  Harris_0274_PolishedMarble: 23455,
  Harris_0275_Highlight: 23456,
  Harris_0276_GoldTaffeta: 23457,
  Harris_0277_GoldenFreesia: 23458,
  Harris_0278_BarberrySand: 23459,
  Harris_0279_GardenCountry: 23460,
  Harris_0280_WickerBasket: 23461,
  Harris_0281_OliveGold: 23462,
  Harris_0282_VintageGold: 23463,
  Harris_0283_HistoricTown: 23464,
  Harris_0284_QueenLioness: 23465,
  Harris_0285_Eugenia: 23466,
  Harris_0286_YellowPage: 23467,
  Harris_0287_MuslinTint: 23468,
  Harris_0288_GoldenBuff: 23469,
  Harris_0289_PrairieSand: 23470,
  Harris_0290_KeyKeeper: 23471,
  Harris_0291_Rutherford: 23472,
  Harris_0292_PrivateWhite: 23473,
  Harris_0293_WhatInheritance: 23474,
  Harris_0294_RubElbows: 23475,
  Harris_0295_SpanishCream: 23476,
  Harris_0296_OnlyYesterday: 23477,
  Harris_0297_GoldSeason: 23478,
  Harris_0298_Brocade: 23479,
  Harris_0299_AllisonLace: 23480,
  Harris_0300_IvoryParchment: 23481,
  Harris_0301_CorinthianPillar: 23482,
  Harris_0302_RichReward: 23483,
  Harris_0303_BauhausGold: 23484,
  Harris_0304_GoldTangiers: 23485,
  Harris_0305_GoldenSummer: 23486,
  Harris_0306_SaffronTint: 23487,
  Harris_0307_PuttingBench: 23488,
  Harris_0308_CoconutCrumble: 23489,
  Harris_0309_PalmettoBluff: 23490,
  Harris_0310_Sassafras: 23491,
  Harris_0311_LifeExotic: 23492,
  Harris_0312_SeptemberGold: 23493,
  Harris_0313_ChicMagnet: 23494,
  Harris_0314_TradeSecret: 23495,
  Harris_0315_PeaceableKingdom: 23496,
  Harris_0316_GoldenLake: 23497,
  Harris_0317_GreenGold: 23498,
  Harris_0318_TheresNoPlaceLikeHome: 23499,
  Harris_0319_HeraldsTrumpet: 23500,
  Harris_0320_FloatingIsland: 23501,
  Harris_0321_Hephaestus: 23502,
  Harris_0322_GabrielsLight: 23503,
  Harris_0323_StarOfGold: 23504,
  Harris_0324_UponReflection: 23505,
  Harris_0325_WelcomeHome: 23506,
  Harris_0326_Bambino: 23507,
  Harris_0327_TawnyDaylilly: 23508,
  Harris_0328_LandOfTrees: 23509,
  Harris_0329_KnitCardigan: 23510,
  Harris_0330_CastawayBeach: 23511,
  Harris_0331_Refined: 23512,
  Harris_0332_AllNighter: 23513,
  Harris_0333_Grasslands: 23514,
  Harris_0334_Sedona: 23515,
  Harris_0335_IllusiveDream: 23516,
  Harris_0336_SoftLeather: 23517,
  Harris_0337_UrbanCharm: 23518,
  Harris_0338_Whipcord: 23519,
  Harris_0339_CeramicPot: 23520,
  Harris_0340_Nightfall: 23521,
  Harris_0341_LochNess: 23522,
  Harris_0342_VelumSmoke: 23523,
  Harris_0343_Cantera: 23524,
  Harris_0344_Courtyard: 23525,
  Harris_0345_TravertinePath: 23526,
  Harris_0346_NortheastTrail: 23527,
  Harris_0347_JungleCover: 23528,
  Harris_0348_DriedGrass: 23529,
  Harris_0349_Reseda: 23530,
  Harris_0350_HelenOfTroy: 23531,
  Harris_0351_Mohalla: 23532,
  Harris_0352_ShagbarkOlive: 23533,
  Harris_0353_BeckerGold: 23534,
  Harris_0354_Austere: 23535,
  Harris_0355_TwinkleTwinkle: 23536,
  Harris_0356_MothMist: 23537,
  Harris_0357_MossIsland: 23538,
  Harris_0358_SilkyGreen: 23539,
  Harris_0359_GreenSleeves: 23540,
  Harris_0360_LandBeforeTime: 23541,
  Harris_0361_GeorgiaOnMyMind: 23542,
  Harris_0362_PaleQuartz: 23543,
  Harris_0363_MissionHills: 23544,
  Harris_0364_StoneHearth: 23545,
  Harris_0365_AbbeyStone: 23546,
  Harris_0366_Owlet: 23547,
  Harris_0367_ChocolateVelvet: 23548,
  Harris_0368_FolkTales: 23549,
  Harris_0369_Saturnia: 23550,
  Harris_0370_Palatine: 23551,
  Harris_0371_Fiorito: 23552,
  Harris_0372_HistoricShade: 23553,
  Harris_0373_BurningIdea: 23554,
  Harris_0374_CandleWax: 23555,
  Harris_0375_AfricanQueen: 23556,
  Harris_0376_BleachedMeadow: 23557,
  Harris_0377_Montezuma: 23558,
  Harris_0378_GardenHedge: 23559,
  Harris_0379_Orestes: 23560,
  Harris_0380_MirroredWillow: 23561,
  Harris_0381_Sonata: 23562,
  Harris_0382_MountOlive: 23563,
  Harris_0383_NaturalWhisper: 23564,
  Harris_0384_CheesePlease: 23565,
  Harris_0385_HowdyNeighbor: 23566,
  Harris_0386_Hippolita: 23567,
  Harris_0387_GoldieOldie: 23568,
  Harris_0388_ShinyGold: 23569,
  Harris_0389_GoldSparkle: 23570,
  Harris_0390_OliveTint: 23571,
  Harris_0391_Crispa: 23572,
  Harris_0392_AlsotOlive: 23573,
  Harris_0393_InvitingGesture: 23574,
  Harris_0394_Highway: 23575,
  Harris_0395_CrackWillow: 23576,
  Harris_0396_WingMan: 23577,
  Harris_0397_HiddenParadise: 23578,
  Harris_0398_IslandEmbrace: 23579,
  Harris_0399_SawgrassCottage: 23580,
  Harris_0400_NewFoliage: 23581,
  Harris_0401_BambooForest: 23582,
  Harris_0402_SaboGarden: 23583,
  Harris_0403_TropicalTwist: 23584,
  Harris_0404_TranslucentVision: 23585,
  Harris_0405_PlanetEarth: 23586,
  Harris_0406_HomeBody: 23587,
  Harris_0407_Vapor: 23588,
  Harris_0408_Rediscover: 23589,
  Harris_0409_GreenCast: 23590,
  Harris_0410_OldSchool: 23591,
  Harris_0411_CyprusSpring: 23592,
  Harris_0412_Sublime: 23593,
  Harris_0413_SpeakToMe: 23594,
  Harris_0414_PlumeGrass: 23595,
  Harris_0415_FrenchPear: 23596,
  Harris_0416_TaffetaSheen: 23597,
  Harris_0417_AloeLeaf: 23598,
  Harris_0418_OnionSkin: 23599,
  Harris_0419_PoseidonsBeard: 23600,
  Harris_0420_DavesDen: 23601,
  Harris_0421_SilveradoRanch: 23602,
  Harris_0422_EverlastingSage: 23603,
  Harris_0423_EyeOfTheStorm: 23604,
  Harris_0424_Monogram: 23605,
  Harris_0425_PaleGreenTea: 23606,
  Harris_0426_SeptemberSong: 23607,
  Harris_0427_ArborVitae: 23608,
  Harris_0428_LuckyDay: 23609,
  Harris_0429_PendulaGarden: 23610,
  Harris_0430_Vegetarian: 23611,
  Harris_0431_CloverPatch: 23612,
  Harris_0432_SweetSpring: 23613,
  Harris_0433_GrassyGlade: 23614,
  Harris_0434_LushMeadow: 23615,
  Harris_0435_BigFish: 23616,
  Harris_0436_FernGully: 23617,
  Harris_0437_BowlingGreen: 23618,
  Harris_0438_Delicious: 23619,
  Harris_0439_NumeroUno: 23620,
  Harris_0440_PaleLoden: 23621,
  Harris_0441_SlateStone: 23622,
  Harris_0442_Dowager: 23623,
  Harris_0443_Serpentine: 23624,
  Harris_0444_Grime: 23625,
  Harris_0445_DeepShadow: 23626,
  Harris_0446_SealskinShadow: 23627,
  Harris_0447_MetalFlake: 23628,
  Harris_0448_IceFlow: 23629,
  Harris_0449_CannonBall: 23630,
  Harris_0450_RiverGod: 23631,
  Harris_0451_EveningDove: 23632,
  Harris_0452_RuggeroGrey: 23633,
  Harris_0453_FeatherFern: 23634,
  Harris_0454_MarbleGreen: 23635,
  Harris_0455_FavoredOne: 23636,
  Harris_0456_FairMaiden: 23637,
  Harris_0457_HeavenlyGarden: 23638,
  Harris_0458_Malarca: 23639,
  Harris_0459_PleasantHill: 23640,
  Harris_0460_JustALittle: 23641,
  Harris_0461_CalmBreeze: 23642,
  Harris_0462_RestingPlace: 23643,
  Harris_0463_GaelicGarden: 23644,
  Harris_0464_KathleensGarden: 23645,
  Harris_0465_EarthenCheer: 23646,
  Harris_0466_GreenColumn: 23647,
  Harris_0467_SweetAriel: 23648,
  Harris_0468_MellowBlue: 23649,
  Harris_0469_DejaVu: 23650,
  Harris_0470_DreamingOfTheDay: 23651,
  Harris_0471_MiracleBay: 23652,
  Harris_0472_Micropolis: 23653,
  Harris_0473_AtlanticWaves: 23654,
  Harris_0474_Raindance: 23655,
  Harris_0475_FoggyMist: 23656,
  Harris_0476_LighthouseView: 23657,
  Harris_0477_OceanCruise: 23658,
  Harris_0478_SingingInTheRain: 23659,
  Harris_0479_StairwayToHeaven: 23660,
  Harris_0480_DeepSeaShadow: 23661,
  Harris_0481_DreamCatcher: 23662,
  Harris_0482_PowderedPool: 23663,
  Harris_0483_Indulgence: 23664,
  Harris_0484_StormyBay: 23665,
  Harris_0485_NorthBeachBlue: 23666,
  Harris_0486_ParadiseCity: 23667,
  Harris_0487_DeepSpace: 23668,
  Harris_0488_LunaLight: 23669,
  Harris_0489_Whirlwind: 23670,
  Harris_0490_BeaconFog: 23671,
  Harris_0491_SmokyDay: 23672,
  Harris_0492_PolarPond: 23673,
  Harris_0493_Spacebox: 23674,
  Harris_0494_DarkRiver: 23675,
  Harris_0495_Breakwaters: 23676,
  Harris_0496_CapeHope: 23677,
  Harris_0497_RestfulRetreat: 23678,
  Harris_0498_WonderLand: 23679,
  Harris_0499_OceanMelody: 23680,
  Harris_0500_BowmanBlue: 23681,
  Harris_0501_CalmInterlude: 23682,
  Harris_0502_OceanCrest: 23683,
  Harris_0503_WaterDroplet: 23684,
  Harris_0504_InTheBlue: 23685,
  Harris_0505_InGoodTaste: 23686,
  Harris_0506_OceanStorms: 23687,
  Harris_0507_DeepLagoon: 23688,
  Harris_0508_MidnightMagic: 23689,
  Harris_0509_BerylPearl: 23690,
  Harris_0510_SacredSpring: 23691,
  Harris_0511_Cystern: 23692,
  Harris_0512_OvercastDay: 23693,
  Harris_0513_Backwater: 23694,
  Harris_0514_Thunderstorm: 23695,
  Harris_0515_SilentSea: 23696,
  Harris_0516_DiamondStud: 23697,
  Harris_0517_CoolElegance: 23698,
  Harris_0518_LetItRain: 23699,
  Harris_0519_BabySeal: 23700,
  Harris_0520_SlateTint: 23701,
  Harris_0521_DolphinDream: 23702,
  Harris_0522_Octavius: 23703,
  Harris_0523_Felicity: 23704,
  Harris_0524_NomadicTravels: 23705,
  Harris_0525_Marseilles: 23706,
  Harris_0526_MetropolisMood: 23707,
  Harris_0527_LondonRoad: 23708,
  Harris_0528_Greybeard: 23709,
  Harris_0529_BlackLicorice: 23710,
  Harris_0530_Metro: 23711,
  Harris_0531_Snowglory: 23712,
  Harris_0532_RandMoon: 23713,
  Harris_0533_Techile: 23714,
  Harris_0534_SubtleShadow: 23715,
  Harris_0535_ZenRetreat: 23716,
  Harris_0536_Subway: 23717,
  Harris_0537_DovesWing: 23718,
  Harris_0538_Santo: 23719,
  Harris_0539_PlaceOfDust: 23720,
  Harris_0540_PraiseGiving: 23721,
  Harris_0541_SmokyTone: 23722,
  Harris_0542_CaptainNemo: 23723,
  Harris_0543_NovemberStorms: 23724,
  Harris_0544_VenetianWall: 23725,
  Harris_0545_OldGreyMare: 23726,
  Harris_0546_Paternoster: 23727,
  Harris_0547_TinMan: 23728,
  Harris_0548_JetGray: 23729,
  Harris_0549_Emu: 23730,
  Harris_0550_Gargoyle: 23731,
  Harris_0551_OrchidShadow: 23732,
  Harris_0552_NorthIsland: 23733,
  Harris_0553_SmokyWings: 23734,
  Harris_0554_Sparrow: 23735,
  Harris_0555_OceanFrigate: 23736,
  Harris_0556_Smokescreen: 23737,
  Harris_0557_Evermore: 23738,
  Harris_0558_QueenAnnesLace: 23739,
  Harris_0559_AlwaysNeutral: 23740,
  Harris_0560_Awakening: 23741,
  Harris_0561_InTheHills: 23742,
  Harris_0562_SultryCastle: 23743,
  Harris_0563_Vigilant: 23744,
  Harris_0564_BadHairDay: 23745,
  Harris_0565_ElkSkin: 23746,
  Harris_0566_Sheepskin: 23747,
  Harris_0567_Hearthstone: 23748,
  Harris_0568_CloudyToday: 23749,
  Harris_0569_FireplaceMantel: 23750,
  Harris_0570_GreyLocks: 23751,
  Harris_0571_TerraPin: 23752,
  Harris_0572_PowerLunch: 23753,
  Harris_0573_Chintz: 23754,
  Harris_0574_SharkFin: 23755,
  Harris_0575_Greystoke: 23756,
  Harris_0576_StormyWeather: 23757,
  Harris_0577_KingFischer: 23758,
  Harris_0578_PhilosophicallySpeaking: 23759,
  Harris_0579_TurkishTower: 23760,
  Harris_0580_RippledRock: 23761,
  Harris_0581_Fossilized: 23762,
  Harris_0582_PavedPath: 23763,
  Harris_0583_BillowingSmoke: 23764,
  Harris_0584_TornadoWind: 23765,
  Harris_0585_OysterCatch: 23766,
  Harris_0586_WindBlown: 23767,
  Harris_0587_AtmosphericPressure: 23768,
  Harris_0588_BabblingCreek: 23769,
  Harris_0589_CelestialHorizon: 23770,
  Harris_0590_MadonnaBlue: 23771,
  Harris_0591_BlueJacket: 23772,
  Harris_0592_QuietPeace: 23773,
  Harris_0593_SurfsSurprise: 23774,
  Harris_0594_SimplySparkling: 23775,
  Harris_0595_SailIntoTheHorizon: 23776,
  Harris_0596_LazyDay: 23777,
  Harris_0597_HimalayaSky: 23778,
  Harris_0598_CaribbeanCurrent: 23779,
  Harris_0599_FloridaWaters: 23780,
  Harris_0600_MeltingGlacier: 23781,
  Harris_0601_CoolSky: 23782,
  Harris_0602_FluidBlue: 23783,
  Harris_0603_AngelaBay: 23784,
  Harris_0604_BlueSkiesToday: 23785,
  Harris_0605_CapriIsle: 23786,
  Harris_0606_FrozenBlue: 23787,
  Harris_0607_BrushBlue: 23788,
  Harris_0608_ModernBlue: 23789,
  Harris_0609_Innuendo: 23790,
  Harris_0610_BlueParlor: 23791,
  Harris_0611_BashfulBlue: 23792,
  Harris_0612_Parkwater: 23793,
  Harris_0613_BlueHighlight: 23794,
  Harris_0614_SimpleSerenity: 23795,
  Harris_0615_BlueBayou: 23796,
  Harris_0616_Bluette: 23797,
  Harris_0617_JohnsBlue: 23798,
  Harris_0618_HeavenlySky: 23799,
  Harris_0619_HonkyTonkBlue: 23800,
  Harris_0620_StarStudded: 23801,
  Harris_0621_Nuance: 23802,
  Harris_0622_SereneSetting: 23803,
  Harris_0623_PompeiiRuins: 23804,
  Harris_0624_BluePot: 23805,
  Harris_0625_NorthSea: 23806,
  Harris_0626_BlueDepths: 23807,
  Harris_0627_IntoTheStratosphere: 23808,
  Harris_0628_IlluminatingExperience: 23809,
  Harris_0629_PolishedCotton: 23810,
  Harris_0630_StarMist: 23811,
  Harris_0631_ChicagoSkyline: 23812,
  Harris_0632_BreathTakingView: 23813,
  Harris_0633_CapeCodBay: 23814,
  Harris_0634_DaySpa: 23815,
  Harris_0635_Aquafir: 23816,
  Harris_0636_EmpressLila: 23817,
  Harris_0637_MarzenaDream: 23818,
  Harris_0638_WaterySea: 23819,
  Harris_0639_AcapulcoDive: 23820,
  Harris_0640_Skylla: 23821,
  Harris_0641_DancingSea: 23822,
  Harris_0642_SeaFoamMist: 23823,
  Harris_0643_AbstractIdea: 23824,
  Harris_0644_DancingInTheRain: 23825,
  Harris_0645_CalmTint: 23826,
  Harris_0646_KeyWestZenith: 23827,
  Harris_0647_Zenith: 23828,
  Harris_0648_HappyTune: 23829,
  Harris_0649_DivineInspiration: 23830,
  Harris_0650_BridgewaterBay: 23831,
  Harris_0651_SoftBlue: 23832,
  Harris_0652_MountainMain: 23833,
  Harris_0653_SeaOfAtlantis: 23834,
  Harris_0654_Peninsula: 23835,
  Harris_0655_QueenOfTheNight: 23836,
  Harris_0656_RomanWhite: 23837,
  Harris_0657_Kyoto: 23838,
  Harris_0658_OrleansTune: 23839,
  Harris_0659_LastingThoughts: 23840,
  Harris_0660_Epimethius: 23841,
  Harris_0661_Charybdis: 23842,
  Harris_0662_OceanSpray: 23843,
  Harris_0663_FallingTears: 23844,
  Harris_0664_ZirconIce: 23845,
  Harris_0665_MonetMagic: 23846,
  Harris_0666_TrishasEyes: 23847,
  Harris_0667_BlessedBlue: 23848,
  Harris_0668_WishUponAStar: 23849,
  Harris_0669_FrozenStream: 23850,
  Harris_0670_DriftingTide: 23851,
  Harris_0671_EggBlue: 23852,
  Harris_0672_QuietPond: 23853,
  Harris_0673_EnchantedEvening: 23854,
  Harris_0674_SarahsGarden: 23855,
  Harris_0675_BlueBliss: 23856,
  Harris_0676_JobsTears: 23857,
  Harris_0677_EasternWind: 23858,
  Harris_0678_LuxorBlue: 23859,
  Harris_0679_Everest: 23860,
  Harris_0680_AndesSky: 23861,
  Harris_0681_CyanSky: 23862,
  Harris_0682_PleasantStream: 23863,
  Harris_0683_JoyfulTears: 23864,
  Harris_0684_SnowDrift: 23865,
  Harris_0685_DillardsBlue: 23866,
  Harris_0686_Outerspace: 23867,
  Harris_0687_Stillwater: 23868,
  Harris_0688_ColdNorth: 23869,
  Harris_0689_Atmosphere: 23870,
  Harris_0690_BluePeriod: 23871,
  Harris_0691_Paradise: 23872,
  Harris_0692_BarelyAqua: 23873,
  Harris_0693_IslandBreeze: 23874,
  Harris_0694_TurkishTeal: 23875,
  Harris_0695_IslandMoment: 23876,
  Harris_0696_Meringue: 23877,
  Harris_0697_ArizonaStone: 23878,
  Harris_0698_CalmThoughts: 23879,
  Harris_0699_LicketySplit: 23880,
  Harris_0700_Uninhibited: 23881,
  Harris_0701_Plunge: 23882,
  Harris_0702_PegsPromise: 23883,
  Harris_0703_MountainMeadow: 23884,
  Harris_0704_Plateau: 23885,
  Harris_0705_BayGreen: 23886,
  Harris_0706_FilteredForest: 23887,
  Harris_0707_ShimmeringGlade: 23888,
  Harris_0708_CatarinaGreen: 23889,
  Harris_0709_Calmness: 23890,
  Harris_0710_OnTheNile: 23891,
  Harris_0711_CutePixie: 23892,
  Harris_0712_TealTreat: 23893,
  Harris_0713_MediterraneanMist: 23894,
  Harris_0714_TurquoiseTower: 23895,
  Harris_0715_AquamarineOcean: 23896,
  Harris_0716_BlueGreenScene: 23897,
  Harris_0717_TropicalTale: 23898,
  Harris_0718_Aquadazzle: 23899,
  Harris_0719_MintGrasshopper: 23900,
  Harris_0720_SilkyMint: 23901,
  Harris_0721_LeavesOfSpring: 23902,
  Harris_0722_Liliana: 23903,
  Harris_0723_GoddessGreen: 23904,
  Harris_0724_WildnessMint: 23905,
  Harris_0725_Melbourne: 23906,
  Harris_0726_HiddenJade: 23907,
  Harris_0727_GracefulMint: 23908,
  Harris_0728_CelticSpring: 23909,
  Harris_0729_GardenGoddess: 23910,
  Harris_0730_Lucerne: 23911,
  Harris_0731_Aqueous: 23912,
  Harris_0732_Tingle: 23913,
  Harris_0733_LeafPrint: 23914,
  Harris_0734_VineyardGreen: 23915,
  Harris_0735_CoolSpring: 23916,
  Harris_0736_MiniGreen: 23917,
  Harris_0737_BuenosAires: 23918,
  Harris_0738_SpringForest: 23919,
  Harris_0739_JungleAdventure: 23920,
  Harris_0740_JustAboutGreen: 23921,
  Harris_0741_TurningLeaf: 23922,
  Harris_0742_IsleOfDreams: 23923,
  Harris_0743_BelladonnasLeaf: 23924,
  Harris_0744_HiddenGlade: 23925,
  Harris_0745_ChicShade: 23926,
  Harris_0746_MotherNature: 23927,
  Harris_0747_Whitewash: 23928,
  Harris_0748_Balance: 23929,
  Harris_0749_Perspective: 23930,
  Harris_0750_WispyMint: 23931,
  Harris_0751_GreenGlass: 23932,
  Harris_0752_CactusValley: 23933,
  Harris_0753_BabyVegetable: 23934,
  Harris_0754_ColleenGreen: 23935,
  Harris_0755_CreamyMint: 23936,
  Harris_0756_MeadowGrass: 23937,
  Harris_0757_GarlandPine: 23938,
  Harris_0758_Glendale: 23939,
  Harris_0759_PerennialGarden: 23940,
  Harris_0760_GreenKnoll: 23941,
  Harris_0761_MaisonVerte: 23942,
  Harris_0762_GreenSong: 23943,
  Harris_0763_GracefulFlower: 23944,
  Harris_0764_GreenSheen: 23945,
  Harris_0765_Sweetness: 23946,
  Harris_0766_GentleCaress: 23947,
  Harris_0767_GolfDay: 23948,
  Harris_0768_RestfulRain: 23949,
  Harris_0769_EarthHappiness: 23950,
  Harris_0770_WoodlandNymph: 23951,
  Harris_0771_GreenLime: 23952,
  Harris_0772_WonderWoods: 23953,
  Harris_0773_GlassBottle: 23954,
  Harris_0774_GreenGoneWild: 23955,
  Harris_0775_ElfinMagic: 23956,
  Harris_0776_GreenMist: 23957,
  Harris_0777_Envy: 23958,
  Harris_0778_VacationIsland: 23959,
  Harris_0779_FrogGreen: 23960,
  Harris_0780_Hyper: 23961,
  Harris_0781_ScienceExperiment: 23962,
  Harris_0782_TenderShoot: 23963,
  Harris_0783_CleanAir: 23964,
  Harris_0784_FreshStart: 23965,
  Harris_0785_MistyValley: 23966,
  Harris_0786_PeterPan: 23967,
  Harris_0787_TotallyCool: 23968,
  Harris_0788_GreenGlow: 23969,
  Harris_0789_GardenSeat: 23970,
  Harris_0790_ForestFound: 23971,
  Harris_0791_Origin: 23972,
  Harris_0792_FootiePajamas: 23973,
  Harris_0793_Motherland: 23974,
  Harris_0794_TheGoods: 23975,
  Harris_0795_MartinaOlive: 23976,
  Harris_0796_Spotlight: 23977,
  Harris_0797_BermudaSon: 23978,
  Harris_0798_LemonAppeal: 23979,
  Harris_0799_FireDance: 23980,
  Harris_0800_YellowUmbrella: 23981,
  Harris_0801_RainSlicker: 23982,
  Harris_0802_RainBoots: 23983,
  Harris_0803_PerkyTint: 23984,
  Harris_0804_SweetiePie: 23985,
  Harris_0805_MellaYella: 23986,
  Harris_0806_SweetAngelica: 23987,
  Harris_0807_BrightIdea: 23988,
  Harris_0808_YellowLupine: 23989,
  Harris_0809_HairRibbon: 23990,
  Harris_0810_Annabel: 23991,
  Harris_0811_Martica: 23992,
  Harris_0812_GoldStrand: 23993,
  Harris_0813_Glistening: 23994,
  Harris_0814_GoldenGlow: 23995,
  Harris_0815_LemonSurprise: 23996,
  Harris_0816_SinCity: 23997,
  Harris_0817_BestOfSummer: 23998,
  Harris_0818_DayAtTheZoo: 23999,
  Harris_0819_LemonTint: 24000,
  Harris_0820_SignOfTheCrown: 24001,
  Harris_0821_SunTouched: 24002,
  Harris_0822_SunnyMood: 24003,
  Harris_0823_SunDrops: 24004,
  Harris_0824_Hush: 24005,
  Harris_0825_FrozenBanana: 24006,
  Harris_0826_BananaCustard: 24007,
  Harris_0827_RayOfLight: 24008,
  Harris_0828_GoGoGlow: 24009,
  Harris_0829_DandyLion: 24010,
  Harris_0830_WarmFuzzies: 24011,
  Harris_0831_LavishLemon: 24012,
  Harris_0832_LemonSpongeCake: 24013,
  Harris_0833_SceneStealer: 24014,
  Harris_0834_LemonDrizzle: 24015,
  Harris_0835_GlitterYellow: 24016,
  Harris_0836_BasketOfGold: 24017,
  Harris_0837_FreshScent: 24018,
  Harris_0838_FreshCream: 24019,
  Harris_0839_Butterball: 24020,
  Harris_0840_LemonZest: 24021,
  Harris_0841_SunsGlory: 24022,
  Harris_0842_Sunnyside: 24023,
  Harris_0843_ButteredPopcorn: 24024,
  Harris_0844_Yolk: 24025,
  Harris_0845_LemonStick: 24026,
  Harris_0846_PureLaughter: 24027,
  Harris_0847_YellowBlitz: 24028,
  Harris_0848_YellowTail: 24029,
  Harris_0849_LemonPeel: 24030,
  Harris_0850_Citron: 24031,
  Harris_0851_HappyFace: 24032,
  Harris_0852_TouchOfSun: 24033,
  Harris_0853_LemonLilly: 24034,
  Harris_0854_CrocusTint: 24035,
  Harris_0855_ButterTart: 24036,
  Harris_0856_BroadwayLights: 24037,
  Harris_0857_Peeps: 24038,
  Harris_0858_LookAtTheBrightSide: 24039,
  Harris_0859_DaylillyYellow: 24040,
  Harris_0860_HawaiianCream: 24041,
  Harris_0861_LemonFilling: 24042,
  Harris_0862_YellowTrumpet: 24043,
  Harris_0863_ImALocal: 24044,
  Harris_0864_Lioness: 24045,
  Harris_0865_LemonBar: 24046,
  Harris_0866_AppleSauce: 24047,
  Harris_0867_EggNoodle: 24048,
  Harris_0868_Shortcake: 24049,
  Harris_0869_FrozenFruit: 24050,
  Harris_0870_LemonSlice: 24051,
  Harris_0871_GoldFinch: 24052,
  Harris_0872_SaffronValley: 24053,
  Harris_0873_WashedInLight: 24054,
  Harris_0874_KettleCorn: 24055,
  Harris_0875_NothingLess: 24056,
  Harris_0876_CornChowder: 24057,
  Harris_0877_GoldDigger: 24058,
  Harris_0878_GloriousGold: 24059,
  Harris_0879_GoldenCadillac: 24060,
  Harris_0880_CauliflowerCream: 24061,
  Harris_0881_GoldenSyrup: 24062,
  Harris_0882_Marzipan: 24063,
  Harris_0883_FollowTheLeader: 24064,
  Harris_0884_GoldTweed: 24065,
  Harris_0885_JungleExpedition: 24066,
  Harris_0886_GoldEstate: 24067,
  Harris_0887_Haystack: 24068,
  Harris_0888_GoldenWeave: 24069,
  Harris_0889_RusseauGold: 24070,
  Harris_0890_Dubloon: 24071,
  Harris_0891_SilenceIsGolden: 24072,
  Harris_0892_GoldRansom: 24073,
  Harris_0893_RichAndRare: 24074,
  Harris_0894_MistyMustard: 24075,
  Harris_0895_RotundaGold: 24076,
  Harris_0896_CoinPurse: 24077,
  Harris_0897_BagOfGold: 24078,
  Harris_0898_GobyDesert: 24079,
  Harris_0899_BugleBoy: 24080,
  Harris_0900_UnforgettablyGold: 24081,
  Harris_0901_SpinningWheel: 24082,
  Harris_0902_Soleil: 24083,
  Harris_0903_DaintyFlower: 24084,
  Harris_0904_SundayAfternoon: 24085,
  Harris_0905_EgyptianGold: 24086,
  Harris_0906_CatsEyeMarble: 24087,
  Harris_0907_Millionaire: 24088,
  Harris_0908_GodGiven: 24089,
  Harris_0909_AutumnChild: 24090,
  Harris_0910_WesternSky: 24091,
  Harris_0911_SunsetInItaly: 24092,
  Harris_0912_TropicalDream: 24093,
  Harris_0913_AngelFoodCake: 24094,
  Harris_0914_ChildOfTheMoon: 24095,
  Harris_0915_QueenlyLaugh: 24096,
  Harris_0916_HoneyCream: 24097,
  Harris_0917_CanyonSand: 24098,
  Harris_0918_GoodLooking: 24099,
  Harris_0919_VeniceSquare: 24100,
  Harris_0920_SunriseHeat: 24101,
  Harris_0921_WaxenMoon: 24102,
  Harris_0922_Cheesecake: 24103,
  Harris_0923_TiffanyLight: 24104,
  Harris_0924_FirstDayOfSchool: 24105,
  Harris_0925_JonquilTrail: 24106,
  Harris_0926_PerkyYellow: 24107,
  Harris_0927_LemonPoppy: 24108,
  Harris_0928_YellowWarning: 24109,
  Harris_0929_YellowBonnet: 24110,
  Harris_0930_MarshmallowFluff: 24111,
  Harris_0931_LemonBubble: 24112,
  Harris_0932_SunSplashed: 24113,
  Harris_0933_SassyYellow: 24114,
  Harris_0934_LemonEssence: 24115,
  Harris_0935_YellowShout: 24116,
  Harris_0936_Diantha: 24117,
  Harris_0937_EggNog: 24118,
  Harris_0938_PrimrosePath: 24119,
  Harris_0939_BigBusYellow: 24120,
  Harris_0940_GrilledCheese: 24121,
  Harris_0941_GlowingLantern: 24122,
  Harris_0942_LemonDream: 24123,
  Harris_0943_PicturePerfect: 24124,
  Harris_0944_SunriseGlow: 24125,
  Harris_0945_TreasureSeeker: 24126,
  Harris_0946_HotSpot: 24127,
  Harris_0947_BrightHalo: 24128,
  Harris_0948_BrightBubble: 24129,
  Harris_0949_Frenzy: 24130,
  Harris_0950_IvoryCoast: 24131,
  Harris_0951_PoundCake: 24132,
  Harris_0952_RichGlow: 24133,
  Harris_0953_EveningStar: 24134,
  Harris_0954_MacNCheese: 24135,
  Harris_0955_LemonWhisper: 24136,
  Harris_0956_ILoveToBoogie: 24137,
  Harris_0957_PaleNarcissus: 24138,
  Harris_0958_HolyGrail: 24139,
  Harris_0959_EssentiallyBright: 24140,
  Harris_0960_BreadNButter: 24141,
  Harris_0961_GoldsGreatTouch: 24142,
  Harris_0962_PiecesOfEight: 24143,
  Harris_0963_Zambia: 24144,
  Harris_0964_CapetownCream: 24145,
  Harris_0965_GoldOfMidas: 24146,
  Harris_0966_Starburst: 24147,
  Harris_0967_Endearment: 24148,
  Harris_0968_MangoMadness: 24149,
  Harris_0970_OrangeYouHappy: 24150,
  Harris_0971_MaySun: 24151,
  Harris_0972_AppleCider: 24152,
  Harris_0973_AtollSand: 24153,
  Harris_0974_Goosebill: 24154,
  Harris_0975_DownyFeather: 24155,
  Harris_0976_CocktailHour: 24156,
  Harris_0977_CheddarCheese: 24157,
  Harris_0978_CityOfDiamonds: 24158,
  Harris_0979_Liveliness: 24159,
  Harris_0980_SouthernBreeze: 24160,
  Harris_0981_TuscanWall: 24161,
  Harris_0982_TasteOfSummer: 24162,
  Harris_0983_Japonica: 24163,
  Harris_0984_MexicanSpirit: 24164,
  Harris_0985_Whiskers: 24165,
  Harris_0986_MineralGlow: 24166,
  Harris_0987_Tallow: 24167,
  Harris_0988_MomsApplePie: 24168,
  Harris_0989_Impulse: 24169,
  Harris_0990_ButterscotchGlaze: 24170,
  Harris_0991_BeeswaxCandle: 24171,
  Harris_0992_TouchOfTopaz: 24172,
  Harris_0993_IncanTreasure: 24173,
  Harris_0994_SparkleGlow: 24174,
  Harris_0995_BreadPudding: 24175,
  Harris_0996_SpiceCookie: 24176,
  Harris_0997_GatesOfGold: 24177,
  Harris_0998_GoldMetal: 24178,
  Harris_0999_IvoryTassel: 24179,
  Harris_1000_FlowerOfOahu: 24180,
  Harris_1001_CheddarCorn: 24181,
  Harris_1002_TeaCookie: 24182,
  Harris_1003_SweetSue: 24183,
  Harris_1004_PeaceOfMind: 24184,
  Harris_1005_FlickeringFlame: 24185,
  Harris_1006_Turkscap: 24186,
  Harris_1007_PastelPeach: 24187,
  Harris_1008_MangoTango: 24188,
  Harris_1009_BedtimeStory: 24189,
  Harris_1010_PeanutBrittle: 24190,
  Harris_1011_Semolina: 24191,
  Harris_1012_HamptonBeach: 24192,
  Harris_1013_WarmBread: 24193,
  Harris_1014_MuffinMagic: 24194,
  Harris_1015_CanterPeach: 24195,
  Harris_1016_NovemberLeaf: 24196,
  Harris_1017_SummersEnd: 24197,
  Harris_1018_SunnyHorizon: 24198,
  Harris_1019_OrangeBallad: 24199,
  Harris_1020_RapturesLight: 24200,
  Harris_1021_SweetButtermilk: 24201,
  Harris_1022_DelicateDawn: 24202,
  Harris_1023_MellowGlow: 24203,
  Harris_1024_PumpkinHue: 24204,
  Harris_1025_HeatOfSummer: 24205,
  Harris_1026_CasaDeOro: 24206,
  Harris_1027_AbstractWhite: 24207,
  Harris_1028_Verve: 24208,
  Harris_1029_PaleBlossom: 24209,
  Harris_1030_WispyWhite: 24210,
  Harris_1031_Chickadee: 24211,
  Harris_1032_BoredomBuster: 24212,
  Harris_1033_LavaLamp: 24213,
  Harris_1034_AutumnWind: 24214,
  Harris_1035_SpicedCider: 24215,
  Harris_1036_ApricotSpring: 24216,
  Harris_1037_TrumpetFlower: 24217,
  Harris_1038_JackOLantern: 24218,
  Harris_1039_PrettyParasol: 24219,
  Harris_1040_DarkMarmalade: 24220,
  Harris_1041_Flowerbed: 24221,
  Harris_1042_PeakSeason: 24222,
  Harris_1043_MomsLove: 24223,
  Harris_1044_ShootingStar: 24224,
  Harris_1045_CreamyOrangeBlush: 24225,
  Harris_1046_BalletCream: 24226,
  Harris_1047_Starfish: 24227,
  Harris_1048_PaleShrimp: 24228,
  Harris_1049_SalmonMousse: 24229,
  Harris_1050_SalmonBeauty: 24230,
  Harris_1051_StuccoWall: 24231,
  Harris_1052_SummerMemory: 24232,
  Harris_1053_SunsRage: 24233,
  Harris_1054_CarrotCake: 24234,
  Harris_1055_WhiteMeadow: 24235,
  Harris_1056_ElizabethRose: 24236,
  Harris_1057_PinkSatin: 24237,
  Harris_1058_PaleTerra: 24238,
  Harris_1059_AlexandraPeach: 24239,
  Harris_1060_FirstLady: 24240,
  Harris_1061_AprilLove: 24241,
  Harris_1062_Albino: 24242,
  Harris_1063_TinyPink: 24243,
  Harris_1064_MysticTulip: 24244,
  Harris_1065_RoseEssence: 24245,
  Harris_1066_Sari: 24246,
  Harris_1067_SweetBabyRose: 24247,
  Harris_1068_BestOfTheBunch: 24248,
  Harris_1069_PinkTouch: 24249,
  Harris_1070_PeonyPrize: 24250,
  Harris_1071_CloudNumberNine: 24251,
  Harris_1072_LustyOrange: 24252,
  Harris_1073_GracefulBallerina: 24253,
  Harris_1074_ItsMyParty: 24254,
  Harris_1075_CherryBlink: 24255,
  Harris_1076_BabyBlossom: 24256,
  Harris_1077_LadyAnne: 24257,
  Harris_1078_AromaticBreeze: 24258,
  Harris_1079_WildflowerBouquet: 24259,
  Harris_1080_CherishedOne: 24260,
  Harris_1081_EndlessPossibilities: 24261,
  Harris_1082_TropicalHeat: 24262,
  Harris_1083_MorningBlush: 24263,
  Harris_1084_GoGoPink: 24264,
  Harris_1085_TintOfRose: 24265,
  Harris_1086_Nosegay: 24266,
  Harris_1087_BayCoral: 24267,
  Harris_1088_ChildhoodCrush: 24268,
  Harris_1089_Chuckles: 24269,
  Harris_1090_Tartlet: 24270,
  Harris_1091_AllDressedUp: 24271,
  Harris_1092_PetalsUnfolding: 24272,
  Harris_1093_WoodNymph: 24273,
  Harris_1094_PorcelainRose: 24274,
  Harris_1095_Empower: 24275,
  Harris_1096_TheEgoHasLanded: 24276,
  Harris_1097_PalePetunia: 24277,
  Harris_1098_BubblegumPink: 24278,
  Harris_1099_Dimple: 24279,
  Harris_1100_HeartToHeart: 24280,
  Harris_1101_MullenPink: 24281,
  Harris_1102_PreciousPeony: 24282,
  Harris_1103_Moonrose: 24283,
  Harris_1104_Valerie: 24284,
  Harris_1105_ItsAGirl: 24285,
  Harris_1106_GardenGlory: 24286,
  Harris_1107_BunnyFluff: 24287,
  Harris_1108_PinkExplosion: 24288,
  Harris_1109_PartyTime: 24289,
  Harris_1110_UnmatchedBeauty: 24290,
  Harris_1111_RoyalWedding: 24291,
  Harris_1112_WishfulThinking: 24292,
  Harris_1113_Fruitbowl: 24293,
  Harris_1114_ALotOfLove: 24294,
  Harris_1115_Dollie: 24295,
  Harris_1116_MovieStar: 24296,
  Harris_1117_Siren: 24297,
  Harris_1118_CottonCandy: 24298,
  Harris_1119_SweetPea: 24299,
  Harris_1120_SummerCosmos: 24300,
  Harris_1121_DahliaDelight: 24301,
  Harris_1122_RoseMallow: 24302,
  Harris_1123_Groovy: 24303,
  Harris_1124_VelvetCake: 24304,
  Harris_1125_Hepatica: 24305,
  Harris_1126_SeashellPink: 24306,
  Harris_1127_Pepto: 24307,
  Harris_1128_Minuette: 24308,
  Harris_1129_PunkyPink: 24309,
  Harris_1130_Obsession: 24310,
  Harris_1131_CanCan: 24311,
  Harris_1132_SullivansHeart: 24312,
  Harris_1133_ChristysSmile: 24313,
  Harris_1134_PegeenPeony: 24314,
  Harris_1135_Glam: 24315,
  Harris_1136_Romp: 24316,
  Harris_1137_OdeToJoy: 24317,
  Harris_1138_RomanticNight: 24318,
  Harris_1139_Tutu: 24319,
  Harris_1140_FirstDaughter: 24320,
  Harris_1141_DecoPink: 24321,
  Harris_1142_VintageVictorian: 24322,
  Harris_1143_RamblingRose: 24323,
  Harris_1144_Temptress: 24324,
  Harris_1145_RomeoORomeo: 24325,
  Harris_1146_MorningShine: 24326,
  Harris_1147_Columbine: 24327,
  Harris_1148_PersianDelight: 24328,
  Harris_1149_ParrotTulip: 24329,
  Harris_1150_PinkBeauty: 24330,
  Harris_1151_FusciaFizz: 24331,
  Harris_1152_BerryPatch: 24332,
  Harris_1153_ViennaDawn: 24333,
  Harris_1154_Viola: 24334,
  Harris_1155_LittleSmile: 24335,
  Harris_1156_PinkHeath: 24336,
  Harris_1157_BlossomsInSpring: 24337,
  Harris_1158_PurpleHollyhock: 24338,
  Harris_1159_Bridesmaid: 24339,
  Harris_1160_PetalPoise: 24340,
  Harris_1161_NurseryPink: 24341,
  Harris_1162_VenetianRose: 24342,
  Harris_1163_TiaraPink: 24343,
  Harris_1164_CarnationRose: 24344,
  Harris_1165_PinkParade: 24345,
  Harris_1166_NobleHonor: 24346,
  Harris_1167_DreamState: 24347,
  Harris_1168_MarvelousMagic: 24348,
  Harris_1169_BabyGirl: 24349,
  Harris_1170_LavenderQuartz: 24350,
  Harris_1171_TeenQueen: 24351,
  Harris_1172_Immortality: 24352,
  Harris_1173_PurpleStiletto: 24353,
  Harris_1174_LittlePinky: 24354,
  Harris_1175_TaffetaTint: 24355,
  Harris_1176_PoodlePink: 24356,
  Harris_1177_RosyCheeks: 24357,
  Harris_1178_RoseSouvenir: 24358,
  Harris_1179_MoonlightMelody: 24359,
  Harris_1180_BerryLight: 24360,
  Harris_1181_VioletAsh: 24361,
  Harris_1182_LilacsInSpring: 24362,
  Harris_1183_RomanticBallad: 24363,
  Harris_1184_GracefulGarden: 24364,
  Harris_1185_SatinFlower: 24365,
  Harris_1186_PleasantDream: 24366,
  Harris_1187_JoyousSong: 24367,
  Harris_1188_MaidenOfTheMist: 24368,
  Harris_1189_LittleTouch: 24369,
  Harris_1190_GlitteringGemstone: 24370,
  Harris_1191_CherishTheMoment: 24371,
  Harris_1192_CutVelvet: 24372,
  Harris_1193_CrownJewels: 24373,
  Harris_1194_MagentaRedLips: 24374,
  Harris_1195_RosiePosie: 24375,
  Harris_1196_NaughtyMarietta: 24376,
  Harris_1197_LavenderVeil: 24377,
  Harris_1198_HeatherFeather: 24378,
  Harris_1199_EnthronedAbove: 24379,
  Harris_1200_Felicia: 24380,
  Harris_1201_DreamyHeaven: 24381,
  Harris_1202_DaringDeception: 24382,
  Harris_1203_Etcetera: 24383,
  Harris_1204_Noteworthy: 24384,
  Harris_1205_FashionablyPlum: 24385,
  Harris_1206_ScreenGem: 24386,
  Harris_1207_OrchidOrchestra: 24387,
  Harris_1208_CrowdPleaser: 24388,
  Harris_1209_PrincessIrene: 24389,
  Harris_1210_FrenchLavender: 24390,
  Harris_1211_LavenderBlessing: 24391,
  Harris_1212_PansyPosie: 24392,
  Harris_1213_BerryBright: 24393,
  Harris_1214_MajesticPlum: 24394,
  Harris_1215_PurpleShadow: 24395,
  Harris_1216_Aimee: 24396,
  Harris_1217_VelvetBlush: 24397,
  Harris_1218_OdysseyLilac: 24398,
  Harris_1219_Desiree: 24399,
  Harris_1220_PlayTime: 24400,
  Harris_1221_CharmingViolet: 24401,
  Harris_1222_GrapeSoda: 24402,
  Harris_1223_OstrichTail: 24403,
  Harris_1224_FragrantSnowbell: 24404,
  Harris_1225_Velour: 24405,
  Harris_1226_ImagineThat: 24406,
  Harris_1227_VividVision: 24407,
  Harris_1228_PetuniaPatty: 24408,
  Harris_1229_EleanorAnn: 24409,
  Harris_1230_CrescentMoon: 24410,
  Harris_1231_HostaFlower: 24411,
  Harris_1232_FlowersOfMay: 24412,
  Harris_1233_PlumCake: 24413,
  Harris_1234_GrapesTreasure: 24414,
  Harris_1235_Yolanda: 24415,
  Harris_1236_SunsetSerenade: 24416,
  Harris_1237_EasterBunny: 24417,
  Harris_1238_Fairytale: 24418,
  Harris_1239_PlumsTheWord: 24419,
  Harris_1240_DriftingDream: 24420,
  Harris_1241_GrapeIllusion: 24421,
  Harris_1242_GorgeousHydrangea: 24422,
  Harris_1243_WhenRedMetBlue: 24423,
  Harris_1244_WhiteBud: 24424,
  Harris_1245_Perfection: 24425,
  Harris_1246_PurplePurity: 24426,
  Harris_1247_MayMist: 24427,
  Harris_1248_VelvetCrest: 24428,
  Harris_1249_PurpleSpire: 24429,
  Harris_1250_TrueRomance: 24430,
  Harris_1251_MountainsMajesty: 24431,
  Harris_1252_LavenderBliss: 24432,
  Harris_1253_PetuniaTrail: 24433,
  Harris_1254_PurpleVision: 24434,
  Harris_1255_PurpleHaze: 24435,
  Harris_1256_PlumPreserve: 24436,
  Harris_1257_Voldemort: 24437,
  Harris_1258_SweetFlower: 24438,
  Harris_1259_Eyeshadow: 24439,
  Harris_1260_PrettyPosie: 24440,
  Harris_1261_ChildishWonder: 24441,
  Harris_1262_BaileyBells: 24442,
  Harris_1263_Medieval: 24443,
  Harris_1264_AltarOfHeaven: 24444,
  Harris_1265_WhiteShoulders: 24445,
  Harris_1266_Penelope: 24446,
  Harris_1267_CasaDelMar: 24447,
  Harris_1268_SpoiledRotten: 24448,
  Harris_1269_MoodMode: 24449,
  Harris_1270_WindStar: 24450,
  Harris_1271_HotSauna: 24451,
  Harris_1272_AngelKiss: 24452,
  Harris_1273_WildflowerPrairie: 24453,
  Harris_1274_Genevieve: 24454,
  Harris_1275_HighStyle: 24455,
  Harris_1276_VelvetRobe: 24456,
  Harris_1277_RegalAzure: 24457,
  Harris_1278_FreshTake: 24458,
  Harris_1279_HeLovesMe: 24459,
  Harris_1280_LilacLuster: 24460,
  Harris_1281_Collensia: 24461,
  Harris_1282_ButterflyBush: 24462,
  Harris_1283_LavenderSpectacle: 24463,
  Harris_1284_GrapesOfWrath: 24464,
  Harris_1285_Jazlyn: 24465,
  Harris_1286_LavenderPizzazz: 24466,
  Harris_1287_OrchidFragrance: 24467,
  Harris_1288_VioletCrush: 24468,
  Harris_1289_LilacBlossom: 24469,
  Harris_1290_VioletVibes: 24470,
  Harris_1291_DancingInTheSpring: 24471,
  Harris_1292_PlumPerfect: 24472,
  Harris_1293_VioletPearl: 24473,
  Harris_1294_LavenderScent: 24474,
  Harris_1295_GypsyCaravan: 24475,
  Harris_1296_VioletBeauty: 24476,
  Harris_1297_RoyalProclamation: 24477,
  Harris_1298_QueenOfSheba: 24478,
  Harris_1299_SoulTrain: 24479,
  Harris_1300_WingedVictory: 24480,
  Harris_1301_LavenderBikini: 24481,
  Harris_1302_HeatherHill: 24482,
  Harris_1303_CutHeather: 24483,
  Harris_1304_IcedOrchid: 24484,
  Harris_1305_VictorianViolet: 24485,
  Harris_1306_RoyalVelvet: 24486,
  Harris_1307_Clytemnestra: 24487,
  Harris_1308_StardustBallroom: 24488,
  Harris_1309_SoDainty: 24489,
  Harris_1310_VelvetDawn: 24490,
  Harris_1311_GypsysGown: 24491,
  Harris_1312_SouthernBelle: 24492,
  Harris_1313_MyPlaceOrYours: 24493,
  Harris_1314_DesiredDawn: 24494,
  Harris_1315_Calamities: 24495,
  Harris_1316_Savoy: 24496,
  Harris_1317_BuffedPlum: 24497,
  Harris_1318_DuskyMood: 24498,
  Harris_1319_Overlook: 24499,
  Harris_1320_Blackwater: 24500,
  Harris_173_PaleGingersnap: 24501,
  Harris_969_AuGratin: 24502,
  Harris_Almond: 24503,
  Harris_ApricotBloom: 24504,
  Harris_Aquamarine: 24505,
  Harris_AshGrey: 24506,
  Harris_Bamboo: 24507,
  Harris_Black: 24508,
  Harris_BonanzaGold: 24509,
  Harris_BoneWhite: 24510,
  Harris_BrightWhite: 24511,
  Harris_CanaryYellow: 24512,
  Harris_Carnival: 24513,
  Harris_CB1_G1_LimeZest: 24514,
  Harris_CB10_R3_CranberryCrush: 24515,
  Harris_CB11_Y1_YellowBird: 24516,
  Harris_CB12_Y2_HibiscusYellow: 24517,
  Harris_CB13_Y3_Sunflower: 24518,
  Harris_CB14_Y4_SulphurLake: 24519,
  Harris_CB15_V1_Bougainvillea: 24520,
  Harris_CB16_V2_PartyPurple: 24521,
  Harris_CB17_V3_PurpleRain: 24522,
  Harris_CB18_O1_Sunset: 24523,
  Harris_CB19_O2_OrangeFizz: 24524,
  Harris_CB2_G2_GreenScotchBonnet: 24525,
  Harris_CB20_03_Fiesta: 24526,
  Harris_CB3_G3_RainForest: 24527,
  Harris_CB4_G4_Hummingbird: 24528,
  Harris_CB5_B1_BlueHorizon: 24529,
  Harris_CB6_B2_SeaShore: 24530,
  Harris_CB7_B3_ByTheSea: 24531,
  Harris_CB8_R1_BurntCoral: 24532,
  Harris_CB9_R2_RedVillain: 24533,
  Harris_Charcoal: 24534,
  Harris_CoolMint: 24535,
  Harris_Coral: 24536,
  Harris_Corn: 24537,
  Harris_Cream: 24538,
  Harris_DuckEggGreen: 24539,
  Harris_DustyGrey: 24540,
  Harris_FernGully: 24541,
  Harris_FireCoral: 24542,
  Harris_Gardenia: 24543,
  Harris_H0001_Beetroot: 24544,
  Harris_H0002_Madder: 24545,
  Harris_H0003_CoveredBridge: 24546,
  Harris_H0004_AldenTill: 24547,
  Harris_H0005_FloweringChestnut: 24548,
  Harris_H0006_Roseland: 24549,
  Harris_H0007_ShakerRed: 24550,
  Harris_H0008_CodmanClaret: 24551,
  Harris_H0009_Stagecoach: 24552,
  Harris_H0010_RichardsonBrick: 24553,
  Harris_H0011_RedrockCanyon: 24554,
  Harris_H0012_CogswellCedar: 24555,
  Harris_H0013_PortsmouthSpice: 24556,
  Harris_H0014_Clementine: 24557,
  Harris_H0015_IndiaTrade: 24558,
  Harris_H0016_Pumpkin: 24559,
  Harris_H0017_AndoverCream: 24560,
  Harris_H0018_PaleOrganza: 24561,
  Harris_H0019_Emma: 24562,
  Harris_H0020_LadyBanksia: 24563,
  Harris_H0021_Jonquil: 24564,
  Harris_H0022_KnightleyStraw: 24565,
  Harris_H0023_AsianJute: 24566,
  Harris_H0024_GeorgianYellow: 24567,
  Harris_H0025_Goldenrod: 24568,
  Harris_H0026_Curry: 24569,
  Harris_H0027_FarmhouseOchre: 24570,
  Harris_H0028_EnglishBartlett: 24571,
  Harris_H0029_GableGreen: 24572,
  Harris_H0030_DanishPine: 24573,
  Harris_H0031_CanyonGold: 24574,
  Harris_H0032_BarrettQuince: 24575,
  Harris_H0033_YorkBisque: 24576,
  Harris_H0034_LymanCamelia: 24577,
  Harris_H0035_WoodstockRose: 24578,
  Harris_H0036_TailorsBuff: 24579,
  Harris_H0037_BlondeLace: 24580,
  Harris_H0038_MountainLaurel: 24581,
  Harris_H0039_RundletPeach: 24582,
  Harris_H0040_TudorIce: 24583,
  Harris_H0041_Appleton: 24584,
  Harris_H0042_Lucinda: 24585,
  Harris_H0043_BulfinchBlue: 24586,
  Harris_H0044_Emily: 24587,
  Harris_H0045_CitadelBlue: 24588,
  Harris_H0046_MeetinghouseBlue: 24589,
  Harris_H0047_LexingtonBlue: 24590,
  Harris_H0048_StandishBlue: 24591,
  Harris_H0049_PortsmouthBlue: 24592,
  Harris_H0050_RockyHill: 24593,
  Harris_H0051_WinterHarbor: 24594,
  Harris_H0052_SaxonBlue: 10988,
  Harris_H0053_RobinsEgg: 24595,
  Harris_H0054_GlacierBay: 24596,
  Harris_H0055_ChinaAster: 24597,
  Harris_H0056_ToryBlue: 24598,
  Harris_H0057_BoldBolection: 24599,
  Harris_H0058_BiloxiBlue: 24600,
  Harris_H0059_BowenBlue: 24601,
  Harris_H0060_SealBlue: 24602,
  Harris_H0061_NewportIndigo: 24603,
  Harris_H0062_Volute: 24604,
  Harris_H0063_AsherBenjamin: 24605,
  Harris_H0064_MutedMulberry: 24606,
  Harris_H0065_ConcordGrape: 24607,
  Harris_H0066_PlumIsland: 24608,
  Harris_H0067_BeauportAubergine: 24609,
  Harris_H0068_Amelia: 24610,
  Harris_H0069_Hawthorne: 24611,
  Harris_H0070_Elise: 24612,
  Harris_H0071_CottageGreen: 24613,
  Harris_H0072_MarettApple: 24614,
  Harris_H0073_HistoricMorningDew: 24615,
  Harris_H0074_Melville: 24616,
  Harris_H0075_CoralSprings: 24617,
  Harris_H0076_BristolGreen: 24618,
  Harris_H0077_Longfellow: 24619,
  Harris_H0078_Viscaya: 24620,
  Harris_H0079_VenetianGlass: 24621,
  Harris_H0080_GreenBonnet: 24622,
  Harris_H0081_WainscotGreen: 24623,
  Harris_H0082_WhisperingWillow: 24624,
  Harris_H0083_Brookside: 24625,
  Harris_H0084_VerandaBlue: 24626,
  Harris_H0085_Grasshopper: 24627,
  Harris_H0086_BlueWingedTeal: 24628,
  Harris_H0087_GrassyMeadow: 24629,
  Harris_H0088_PhilipsGreen: 24630,
  Harris_H0089_Boardman: 24631,
  Harris_H0090_WarrenTavern: 24632,
  Harris_H0091_Hazelwood: 24633,
  Harris_H0092_NewburyMoss: 24634,
  Harris_H0093_Picholine: 24635,
  Harris_H0094_AmishGreen: 24636,
  Harris_H0095_Baize: 24637,
  Harris_H0096_GedneyGreen: 24638,
  Harris_H0097_PointedFir: 24639,
  Harris_H0098_BrattleSpruce: 24640,
  Harris_H0099_WinterBalsam: 24641,
  Harris_H0100_MossGlen: 24642,
  Harris_H0101_SaywardPine: 24643,
  Harris_H0102_JewettWhite: 24644,
  Harris_H0103_PlymouthBeige: 24645,
  Harris_H0104_WildOats: 24646,
  Harris_H0105_YarmouthOyster: 24647,
  Harris_H0106_Parsnip: 24648,
  Harris_H0107_LangdonDove: 24649,
  Harris_H0108_JacksonAntique: 24650,
  Harris_H0109_PhelpsPutty: 24651,
  Harris_H0110_BayberryWax: 24652,
  Harris_H0111_SandyBluff: 24653,
  Harris_H0112_FlaxenField: 24654,
  Harris_H0113_RainBarrel: 24655,
  Harris_H0114_PettingillSage: 24656,
  Harris_H0115_WoolyThyme: 24657,
  Harris_H0116_BurnishedPewter: 24658,
  Harris_H0117_Milkweed: 24659,
  Harris_H0118_PitchPine: 24660,
  Harris_H0119_SturgisGray: 24661,
  Harris_H0120_Nankeen: 24662,
  Harris_H0121_WinterMeadow: 24663,
  Harris_H0122_CoastalSand: 24664,
  Harris_H0123_Britches: 24665,
  Harris_H0124_Toffee: 24666,
  Harris_H0125_GingerRoot: 24667,
  Harris_H0126_Maple: 24668,
  Harris_H0127_BeanPot: 24669,
  Harris_H0128_Palomino: 24670,
  Harris_H0129_Portobello: 24671,
  Harris_H0130_TankardGray: 24672,
  Harris_H0131_HitchingPost: 24673,
  Harris_H0132_CummingsOak: 24674,
  Harris_H0133_Brownstone: 24675,
  Harris_H0134_OtisMadeira: 24676,
  Harris_H0135_Liberty: 24677,
  Harris_H0136_BurntUmber: 24678,
  Harris_H0137_HickoryNut: 24679,
  Harris_H0138_TysonTaupe: 24680,
  Harris_H0139_WoodenNutmeg: 24681,
  Harris_H0140_BargeboardBrown: 24682,
  Harris_H0141_Rawhide: 24683,
  Harris_H0142_Chocolate: 24684,
  Harris_H0143_QuincyGranite: 24685,
  Harris_H0144_VinalHaven: 24686,
  Harris_H0145_MonumentGray: 24687,
  Harris_H0146_Fieldstone: 24688,
  Harris_H0147_GropiusGray: 24689,
  Harris_H0148_PolishedPewter: 24690,
  Harris_H0149_VermontSlate: 24691,
  Harris_HeatWave: 24692,
  Harris_JunePlum: 24693,
  Harris_LeatherBrown: 24694,
  Harris_Lilac: 24695,
  Harris_MintGreen: 24696,
  Harris_MorningGlory: 24697,
  Harris_NegrilSunset: 24698,
  Harris_OffWhite: 24699,
  Harris_OrangeGlow: 24700,
  Harris_PawPaw: 24701,
  Harris_PostOfficeRed: 24702,
  Harris_PrettyParasol: 24703,
  Harris_Regatta: 24704,
  Harris_SpanishBrown: 24705,
  Harris_SunshineYellow: 24706,
  Harris_SweetCassava: 24707,
  Harris_TerraCotta: 24708,
  Harris_TileGreen: 24709,
  Harris_White: 24710,
  Harris_WindowBlindGreen: 24711,
};

const DMC_JamesHardie = {
  JH_1020_ArcticWhite: 249,
  JH_1030_WoodlandCream: 1925,
  JH_1520_TerraCotta: 1926,
  JH_2010_SailCloth: 1927,
  JH_2020_AutumnTan: 1928,
  JH_2030_KhakiBrown: 253,
  JH_2040_WinslowTaupe: 1929,
  JH_2520_CoralCoast: 1930,
  JH_3010_NavajoBeige: 256,
  JH_3020_SandstoneBeige: 1931,
  JH_3030_WoodstockBrown: 1932,
  JH_3520_AquaMarine: 1933,
  JH_4010_Cobblestone: 209,
  JH_4015_PearlGray: 211,
  JH_4020_MontereyTaupe: 210,
  JH_4030_TimberBark: 226,
  JH_4040_PebbleBrown: 1934,
  JH_4520_CoolBreeze: 1935,
  JH_5010_AlpineFrost: 1936,
  JH_5020_HeatheredMoss: 258,
  JH_5030_MountainSage: 255,
  JH_5520_PinkSand: 1937,
  JH_6010_SoftGreen: 1938,
  JH_6030_ParksidePine: 1939,
  JH_6040_ForestPine: 1940,
  JH_7010_LightMist: 254,
  JH_7020_BoothbayBlue: 203,
  JH_7030_EveningBlue: 250,
  JH_7040_OceanBlue: 1941,
  JH_7050_DeepOcean: 1942,
  JH_7090_GraySlate: 251,
  JH_8010_HarrisCream: 1943,
  JH_8020_TuscanGold: 1944,
  JH_8030_ChestnutBrown: 1945,
  JH_8070_RichEspresso: 1748,
  JH_8080_MulberryWine: 1946,
  JH_9010_TraditionalRed: 1947,
  JH_9020_CountrylaneRed: 1948,
  JH_9030_IronGray: 252,
  JH_9060_AgedPewter: 225,
  JH_9080_NightGray: 257,
  JH_AbbyWhite: 19984,
  JH_AcornBrown: 19985,
  JH_AdirondackWhite: 19986,
  JH_AfricanViolet: 19987,
  JH_AfterDuskBlue: 19988,
  JH_AgedBarnwood: 19989,
  JH_AgedSlate: 19990,
  JH_AllInWhite: 19991,
  JH_AlliumBlossom: 19992,
  JH_AlmostBlack: 19993,
  JH_AloeVeraStem: 19994,
  JH_AlpineWhite: 19995,
  JH_Aluminum: 19996,
  JH_AmberStone: 19997,
  JH_AnchorBlack: 19998,
  JH_AnchorBrown: 19999,
  JH_AnodizedGray: 20000,
  JH_AnointedGray: 20001,
  JH_AntiqueSatin: 20002,
  JH_AntiqueSlate: 20003,
  JH_AnvilBlack: 20004,
  JH_Aquafoam: 20005,
  JH_AquaGrand: 20006,
  JH_AquaSpa: 20007,
  JH_Arborvitae: 20008,
  JH_ArbutusBrown: 20009,
  JH_ArchitecturalBeige: 20010,
  JH_ArcticBlue: 20011,
  JH_ArgentGray: 20012,
  JH_ArizonaDesert: 20013,
  JH_ArtfulClay: 20014,
  JH_ArtistGray: 20015,
  JH_AspenLilac: 20016,
  JH_AsteroidGray: 20017,
  JH_AthenaBlue: 20018,
  JH_AuburnBrown: 20019,
  JH_AuraLights: 20020,
  JH_AuthenticBeige: 20021,
  JH_AutumnBrush: 20022,
  JH_AvalancheWhite: 20023,
  JH_AviationBlue: 20024,
  JH_AwingBlue: 20025,
  JH_AzureWaters: 20026,
  JH_BabyChick: 20027,
  JH_BackBayBlue: 20028,
  JH_BahaShelfTeal: 20029,
  JH_BakedBiscuit: 20030,
  JH_BakedClay: 20031,
  JH_BalsamFir: 20032,
  JH_BalticBlue: 20033,
  JH_BaltimoreTeal: 20034,
  JH_BanyanTree: 20035,
  JH_BarHarborBlue: 20036,
  JH_BarleyBeige: 20037,
  JH_BarrierReef: 20038,
  JH_BayouBlue: 20039,
  JH_BaysideBlue: 20040,
  JH_Beaujolais: 20041,
  JH_BeautifulInBeige: 20042,
  JH_BeavertailBrown: 20043,
  JH_Bedrock: 20044,
  JH_BeigeHighlights: 20045,
  JH_BeingBeige: 20046,
  JH_Bellflower: 20047,
  JH_BeyondViolet: 20048,
  JH_BigSurfBlue: 20049,
  JH_BirchBark: 20050,
  JH_Bittersweet: 20051,
  JH_BlackAsh: 20052,
  JH_BlackDiamond: 20053,
  JH_BlackFig: 20054,
  JH_BlackHyacinth: 20055,
  JH_BlackWalnut: 20056,
  JH_BlackWater: 20057,
  JH_BlanchedAlmond: 20058,
  JH_BleachedCoral: 20059,
  JH_BlueBird: 20060,
  JH_BlueCarnation: 20061,
  JH_BlueFish: 20062,
  JH_BlueHeaven: 20063,
  JH_BlueJeans: 20064,
  JH_BlueLagoon: 20065,
  JH_BlueMarlin: 20066,
  JH_BlueMoon: 20067,
  JH_BlueNote: 20068,
  JH_BlueOpal: 20069,
  JH_BlueOveralls: 20070,
  JH_BluePacific: 20071,
  JH_BluePewter: 20072,
  JH_BlueRhapsody: 20073,
  JH_BlueRibbon: 20074,
  JH_BlueRidge: 20075,
  JH_BlueShadow: 20076,
  JH_BlueSlate: 20077,
  JH_BlueSpruce: 20078,
  JH_Bluestone: 20079,
  JH_BlueVapor: 20080,
  JH_BlueVista: 20081,
  JH_BlueWhisper: 20082,
  JH_BlueZone: 20083,
  JH_BlushingRose: 20084,
  JH_BonbonBlue: 20085,
  JH_BostonBlue: 20086,
  JH_BottleGreen: 20087,
  JH_BouquetGreen: 20088,
  JH_Brandywine: 20089,
  JH_Breakwaters: 20090,
  JH_BreezyCoastal: 20091,
  JH_BrentwoodBeige: 20092,
  JH_BristolGreen: 20093,
  JH_BronzeStar: 20094,
  JH_BrookBlue: 20095,
  JH_BrownBlaze: 20096,
  JH_BrownClay: 20097,
  JH_BrushedBuff: 20098,
  JH_BrushworkRed: 20099,
  JH_BuckarooBrown: 20100,
  JH_BucktownBeige: 20101,
  JH_BurlapBrown: 20102,
  JH_BurlyBrown: 20103,
  JH_BurntToffee: 20104,
  JH_Buttercream: 20105,
  JH_CabanaBlue: 20106,
  JH_CadetGray: 20107,
  JH_CaliforniaTaupe: 20108,
  JH_CalypsoGreen: 20109,
  JH_Camel: 20110,
  JH_CameoIvory: 20111,
  JH_Camouflage: 20112,
  JH_CampfireSmoke: 20113,
  JH_CanvasBeige: 20114,
  JH_CanyonClay: 1949,
  JH_CapeCodBlue: 20115,
  JH_Caramel: 20116,
  JH_CaribbeanSea: 20117,
  JH_CarolinaBlue: 20118,
  JH_CasaGreen: 20119,
  JH_CatfishBlack: 20120,
  JH_CattailFluff: 20121,
  JH_CaulkBlue: 20122,
  JH_CedarBark: 20123,
  JH_CeladonGreen: 20124,
  JH_CeleryWhite: 20125,
  JH_CelestialBlue: 20126,
  JH_ChanteauxBlue: 20127,
  JH_ChantillyLace: 20128,
  JH_Chardonnay: 20129,
  JH_ChesapeakeBay: 20130,
  JH_ChevalTan: 20131,
  JH_ChimayoGold: 20132,
  JH_ChiselGray: 20133,
  JH_CilantroLeaf: 20134,
  JH_CitrineWhite: 20135,
  JH_ClassicBeige: 20136,
  JH_ClassicBlack: 20137,
  JH_ClimbingVine: 20138,
  JH_CloveBrown: 20139,
  JH_CoachLampGray: 20140,
  JH_CoastalFog: 10510,
  JH_Coastline: 20141,
  JH_CocoBeachPier: 20142,
  JH_CoffeeWithCream: 20143,
  JH_ColonialBlue: 20144,
  JH_ColtBrown: 20145,
  JH_ColumbiaRiver: 20146,
  JH_ConcreteGray: 20147,
  JH_ContemporaryGray: 20148,
  JH_CopperPenny: 20149,
  JH_CoralSand: 20150,
  JH_CornflowerBlue: 20151,
  JH_CottonWhite: 20152,
  JH_Cottonwood: 20153,
  JH_CountryGreen: 20154,
  JH_CozyTan: 20155,
  JH_CreamCorn: 20156,
  JH_CrispWhite: 20157,
  JH_CristobalBlue: 20158,
  JH_CrystallineBlue: 20159,
  JH_CuratedCream: 20160,
  JH_CypressYellow: 20161,
  JH_DappleGray: 20162,
  JH_DarkGreige: 20163,
  JH_DaybreakBlue: 20164,
  JH_DemiMauve: 20165,
  JH_DenimBlue: 20166,
  JH_DerbyGreen: 20167,
  JH_DesertDusk: 20168,
  JH_DesertRose: 20169,
  JH_DesertWind: 20170,
  JH_DesignerCream: 20171,
  JH_DiffusedBlue: 20172,
  JH_DistinctiveGold: 20173,
  JH_DolphinGray: 20174,
  JH_DownFeathers: 20175,
  JH_DriedApricot: 20176,
  JH_DriedOregano: 20177,
  JH_DriftwoodGray: 20178,
  JH_DrippingInGold: 20179,
  JH_DrowsyBlue: 20180,
  JH_DulcetGreen: 20181,
  JH_DurableGray: 20182,
  JH_DustedViolet: 20183,
  JH_DustyPeach: 20184,
  JH_EastCoastBlue: 20185,
  JH_EdenGreen: 20186,
  JH_EiderDown: 20187,
  JH_Elderberry: 20188,
  JH_ElegantGreen: 20189,
  JH_ElegantRed: 20190,
  JH_ElmTree: 20191,
  JH_EloquentMauve: 20192,
  JH_EmbellishedCream: 20193,
  JH_EmblemPink: 20194,
  JH_EmpireEmerald: 20195,
  JH_EnglishLavender: 20196,
  JH_EnhancedBeige: 20197,
  JH_EnrichedTan: 20198,
  JH_EstateGray: 20199,
  JH_Eucalyptus: 20200,
  JH_EucalyptusGreen: 20201,
  JH_Everglade: 20202,
  JH_EvergreenForest: 20203,
  JH_ExecutiveGray: 20204,
  JH_FadedMauve: 20205,
  JH_FadingPeach: 20206,
  JH_FadingTan: 20207,
  JH_FarmhouseWhite: 10508,
  JH_FathomBlue: 20208,
  JH_Fawn: 20209,
  JH_FeatherGray: 20210,
  JH_FeltGray: 20211,
  JH_FernGreen: 20212,
  JH_FerryBlue: 20213,
  JH_FilteredGold: 20214,
  JH_Firefly: 20215,
  JH_FirstSpring: 20216,
  JH_FishingBoat: 20217,
  JH_Flax: 20218,
  JH_FleurDeLisBlue: 20219,
  JH_FlintGray: 20220,
  JH_FloraVistaPink: 20221,
  JH_FloridaBlue: 20222,
  JH_FloridaEverglades: 20223,
  JH_FluidBlue: 20224,
  JH_FoggyBlue: 20225,
  JH_ForeverGreen: 20226,
  JH_ForgetMeNotBlue: 20227,
  JH_Fossil: 20228,
  JH_FoundationGray: 20229,
  JH_FourLeafClover: 20230,
  JH_FoxHollowGray: 20231,
  JH_FrenchToast: 20232,
  JH_FreshMelon: 20233,
  JH_FrontLawn: 20234,
  JH_FrozenFrost: 20235,
  JH_GableGreen: 20236,
  JH_GainingGround: 20237,
  JH_GangplankGray: 20238,
  JH_GardenOfEden: 20239,
  JH_GauzeWhite: 20240,
  JH_GazeboWhite: 20241,
  JH_GleamingGray: 20242,
  JH_GlendaleBrown: 20243,
  JH_GoldenBeehive: 20244,
  JH_GoldenDelicious: 20245,
  JH_GoldenHarvest: 20246,
  JH_GoldenLeaves: 20247,
  JH_GoldenLuster: 20248,
  JH_GoldenSpur: 20249,
  JH_GoldLeaf: 20250,
  JH_GoldRush: 20251,
  JH_GoldSpike: 20252,
  JH_GoodFortune: 20253,
  JH_GrandWhite: 20254,
  JH_GraniteGrey: 1950,
  JH_GrayedMauve: 20255,
  JH_GrayFlannel: 20256,
  JH_GrayOwl: 20257,
  JH_GrayRose: 20258,
  JH_GrayShadow: 20259,
  JH_GraySkies: 20260,
  JH_GreatWhite: 20261,
  JH_GreenAcres: 20262,
  JH_GreenAsh: 20263,
  JH_GreenBridge: 20264,
  JH_GreenGrass: 20265,
  JH_Greenhouse: 20266,
  JH_GreenLight: 20267,
  JH_GreenSand: 20268,
  JH_GreigeReflection: 20269,
  JH_Greyhound: 20270,
  JH_GulfOfMaine: 20271,
  JH_GullGray: 20272,
  JH_GypsumWhite: 20273,
  JH_HandsomeGray: 20274,
  JH_HarbourMist: 20275,
  JH_HawthornWhite: 20276,
  JH_HearthGray: 20277,
  JH_HeavenlyBlue: 20278,
  JH_HeirloomTan: 20279,
  JH_Herbal: 20280,
  JH_HeritageBeige: 20281,
  JH_HickoryTan: 20282,
  JH_HighlineWhite: 20283,
  JH_HighPerformanceGray: 20284,
  JH_Highwater: 20285,
  JH_HikingTrail: 20286,
  JH_HintOfRose: 20287,
  JH_HistoricalBrown: 20288,
  JH_HomespunBeige: 20289,
  JH_HomesteadGreen: 20290,
  JH_HonestBeige: 20291,
  JH_HonestGray: 20292,
  JH_Honeycomb: 20293,
  JH_Honeydew: 20294,
  JH_Honeysuckle: 20295,
  JH_HudsonBayBlue: 20296,
  JH_HunterGreen: 20297,
  JH_HuskyGray: 20298,
  JH_IcingBlue: 20299,
  JH_IconicGray: 20300,
  JH_ImperialGreen: 20301,
  JH_IndustrialGray: 6494,
  JH_InkyIndigo: 20302,
  JH_InletBlue: 20303,
  JH_InnerCoastal: 20304,
  JH_InterlockingBlue: 20305,
  JH_IntimateBeige: 20306,
  JH_IntoTheBlue: 20307,
  JH_IrishLowlands: 20308,
  JH_IrisMist: 20309,
  JH_IronGray: 10583,
  JH_Jaded: 20310,
  JH_Jasmine: 20311,
  JH_JetBlack: 20312,
  JH_JuniperBerry: 20313,
  JH_KellyGreen: 20314,
  JH_KentuckyBluegrass: 20315,
  JH_Keylime: 20316,
  JH_KeystoneGray: 20317,
  JH_KeyWestSeaport: 20318,
  JH_KingfisherBlue: 20319,
  JH_LagunaBlue: 20320,
  JH_LahoyaBlue: 20321,
  JH_LakehouseBlue: 20322,
  JH_LakeHuron: 20323,
  JH_LakePowellBlue: 20324,
  JH_LavenderMist: 20325,
  JH_LeafDust: 20326,
  JH_Licorice: 20327,
  JH_LilacWhite: 20328,
  JH_LilyOfTheValley: 20329,
  JH_Limestone: 20330,
  JH_LimeWhite: 20331,
  JH_LindenGreen: 20332,
  JH_LittleBoyBlue: 20333,
  JH_LoftWhite: 20334,
  JH_LondonFog: 20335,
  JH_LostInGray: 6495,
  JH_LotusFlower: 20336,
  JH_LuxuryLavender: 20337,
  JH_MadameRose: 20338,
  JH_Mag_BirchTree: 4471,
  JH_Mag_ChiseledGreen: 4472,
  JH_Mag_DriedEucalyptus: 4473,
  JH_Mag_ItsAboutThyme: 4474,
  JH_Mag_LastEmbers: 4475,
  JH_Mag_MidnightSoot: 4476,
  JH_Mag_Mudflats: 4477,
  JH_Mag_PepperyAsh: 4478,
  JH_Mag_RuggedPath: 4479,
  JH_Mag_RusticRoad: 4480,
  JH_Mag_SlateSteps: 4481,
  JH_Mag_StoneBeach: 4482,
  JH_Mag_StonePaver: 4483,
  JH_Mag_WanderingGreen: 4484,
  JH_Mag_WarmClay: 4485,
  JH_Mag_WeatheredCliffs: 4486,
  JH_MagnoliaWhite: 20339,
  JH_Maize: 20340,
  JH_MajesticMauve: 20341,
  JH_ManorHouseWhite: 20342,
  JH_MansionTan: 20343,
  JH_MasonryGray: 20344,
  JH_MauveDust: 20345,
  JH_MauveWhite: 20346,
  JH_MediterraneanSea: 20347,
  JH_MeltedIce: 20348,
  JH_MeltedTeal: 20349,
  JH_MesaGreen: 20350,
  JH_MidnightBlack: 10464,
  JH_MidnightLake: 20351,
  JH_MilkWhite: 20352,
  JH_MinimalistBrown: 20353,
  JH_MintClover: 20354,
  JH_MintyFresh: 20355,
  JH_MirrorGray: 20356,
  JH_MississippiMoss: 20357,
  JH_MississippiMud: 20358,
  JH_MistyBlue: 20359,
  JH_MistyCoral: 20360,
  JH_MistyEmerald: 20361,
  JH_MistyMorning: 20362,
  JH_MistyMoss: 20363,
  JH_ModernRose: 20364,
  JH_ModernTwistOnMauve: 20365,
  JH_ModestTan: 20366,
  JH_MontanaSky: 20367,
  JH_MoodyIndigo: 20368,
  JH_MoonflowerWhite: 20369,
  JH_Moonstone: 20370,
  JH_MorningMist: 20371,
  JH_MountainAsh: 20372,
  JH_MountainCliff: 20373,
  JH_MuddledBeige: 20374,
  JH_Mulberry: 20375,
  JH_MultiPurposeBeige: 20376,
  JH_Mushroom: 20377,
  JH_MysticMauve: 20378,
  JH_NashvilleGray: 20379,
  JH_NaturalQuartz: 20380,
  JH_NauticalWhite: 20381,
  JH_NavyBlue: 20382,
  JH_NeighborhoodPark: 20383,
  JH_NeptuneBlue: 20384,
  JH_NevadaSand: 20385,
  JH_NewLumber: 20386,
  JH_NewportGreen: 20387,
  JH_NextBigBeige: 20388,
  JH_NocturneBlue: 20389,
  JH_NorthernLights: 20390,
  JH_NostalgicBlue: 20391,
  JH_NotTooGreen: 20392,
  JH_NudeBlush: 20393,
  JH_NutBrown: 20394,
  JH_ObsessionGray: 20395,
  JH_ObviousGray: 20396,
  JH_OceanTide: 20397,
  JH_OldRose: 20398,
  JH_OliveBranch: 20399,
  JH_OliveBrown: 20400,
  JH_OpalGray: 20401,
  JH_OrbBlue: 20402,
  JH_Oregano: 20403,
  JH_OregonTrail: 20404,
  JH_OtterBrown: 20405,
  JH_OutOfTheBlue: 20406,
  JH_OvercastGreen: 20407,
  JH_Overseas: 20408,
  JH_OxfordBlue: 20409,
  JH_Oxygen: 20410,
  JH_OysterShellBeige: 20411,
  JH_PacificBlue: 20412,
  JH_PageWhite: 20413,
  JH_PalePowder: 20414,
  JH_PalermoWhite: 20415,
  JH_PalmGrove: 20416,
  JH_PandaGray: 20417,
  JH_PaperWhite: 20418,
  JH_ParakeetsTeal: 24712,
  JH_Parchment: 20419,
  JH_PassionFlower: 20420,
  JH_PassiveWhite: 20421,
  JH_PeacefulGreen: 20422,
  JH_PeachesCream: 20423,
  JH_PeachNectar: 20424,
  JH_PeachParfait: 20425,
  JH_PeachWhisper: 20426,
  JH_PeachyKeen: 20427,
  JH_Peacock: 20428,
  JH_PearlWhite: 20429,
  JH_PeaShoot: 20430,
  JH_PebbleTan: 20431,
  JH_PecanPie: 20432,
  JH_PerfectPeach: 20433,
  JH_Periwinkle: 20434,
  JH_PinkCarnation: 20435,
  JH_PinkDawn: 20436,
  JH_PinkLace: 20437,
  JH_PinkOrchid: 20438,
  JH_PlankBeige: 20439,
  JH_PlasterWhite: 20440,
  JH_PlatformBeige: 20441,
  JH_PlatinumBeige: 20442,
  JH_PolarIce: 20443,
  JH_PolarisWhite: 20444,
  JH_PoolsideBlue: 20445,
  JH_PoppedCork: 20446,
  JH_PorchWhite: 20447,
  JH_PottersClay: 24713,
  JH_PowderBlue: 20448,
  JH_PowderedSugar: 20449,
  JH_Praline: 20450,
  JH_PreciousPink: 20451,
  JH_PreciselyGreen: 20452,
  JH_PugetSoundGray: 20453,
  JH_PureVanilla: 20454,
  JH_PurpleWisp: 20455,
  JH_PuttingGreen: 20456,
  JH_Pyrite: 20457,
  JH_QuarryGray: 20458,
  JH_RafterBrown: 20459,
  JH_RainfallGreen: 20460,
  JH_RanchTan: 20461,
  JH_RawHoney: 20462,
  JH_RealGray: 20463,
  JH_RegencyBlue: 20464,
  JH_RippleBlue: 20465,
  JH_RiverRock: 20466,
  JH_RoastedPeanut: 20467,
  JH_RobinsEgg: 24714,
  JH_RoboGray: 20468,
  JH_RomancingBeige: 20469,
  JH_RopeOfPearls: 20470,
  JH_RoseCoveredCottage: 20471,
  JH_RoseDust: 20472,
  JH_RosePetal: 20473,
  JH_RoseTippedBeige: 20474,
  JH_Rosewater: 20475,
  JH_Rosewood: 20476,
  JH_RosyCoral: 20477,
  JH_RosyPosy: 20478,
  JH_RougeNoir: 20479,
  JH_RowBoat: 20480,
  JH_RoyalTeal: 20481,
  JH_RubberMeetsTheRoad: 20482,
  JH_RussianOak: 20483,
  JH_RusticRanch: 20484,
  JH_RusticWhite: 20485,
  JH_RustyNail: 20486,
  JH_SaddleBrown: 20487,
  JH_SageBush: 20488,
  JH_Saltwater: 20489,
  JH_Sandbar: 20490,
  JH_SanPedroGreen: 20491,
  JH_SantaMonicaPier: 20492,
  JH_SavaryIslandTeal: 20493,
  JH_SawdustTan: 20494,
  JH_SeaBluGlaze: 20495,
  JH_SeaFoam: 20496,
  JH_SeaGlass: 20497,
  JH_SealGray: 20498,
  JH_SeaMist: 20499,
  JH_SeasideVilla: 20500,
  JH_SeaSpray: 20501,
  JH_SeaweedGreen: 20502,
  JH_SequoiaGreen: 20503,
  JH_SetSailBlue: 20504,
  JH_ShadowedWhite: 10507,
  JH_ShastaDaisy: 20505,
  JH_SherwoodForest: 20506,
  JH_ShiplapWhite: 20507,
  JH_ShouSugiBan: 20508,
  JH_SierraBrown: 1951,
  JH_SilverBells: 20509,
  JH_SilverBirch: 20510,
  JH_SilverBrown: 20511,
  JH_SilverHerring: 20512,
  JH_SilverMarlin: 20513,
  JH_SilverMoon: 20514,
  JH_SilverSand: 20515,
  JH_SimpleElegance: 20516,
  JH_SimpleEmbrace: 20517,
  JH_SimplyBeige: 20518,
  JH_SisalBeige: 20519,
  JH_Skylight: 20520,
  JH_SkyscraperGray: 20521,
  JH_SlatePebble: 20522,
  JH_SleepyTimeBlue: 20523,
  JH_SlumberBrown: 20524,
  JH_SmokedMauve: 20525,
  JH_SmokeySapphire: 20526,
  JH_SnapdragonBlossom: 20527,
  JH_SnowflakeWhite: 20528,
  JH_SnowOwl: 20529,
  JH_SnowyPeak: 20530,
  JH_SodaFountain: 20531,
  JH_SoftMink: 20532,
  JH_SolarEnergy: 20533,
  JH_SomberBrown: 20534,
  JH_SouthernBlue: 20535,
  JH_SouthHamptonGray: 20536,
  JH_SpanishOlive: 20537,
  JH_SpicyMustard: 20538,
  JH_SpringBuds: 20539,
  JH_SpringGreen: 20540,
  JH_SpringLeeks: 20541,
  JH_SpringSprig: 20542,
  JH_SprinkleOfMauve: 20543,
  JH_SpruceGreen: 20544,
  JH_SpunSilk: 20545,
  JH_Squash: 20546,
  JH_StableGray: 20547,
  JH_StandardKhaki: 20548,
  JH_Statement_SmokeCanyon: 11318,
  JH_SteelBlue: 20549,
  JH_SteelGray: 20550,
  JH_StoneGray: 20551,
  JH_StonehavenGray: 20552,
  JH_StormyGray: 20553,
  JH_StrawHat: 20554,
  JH_StudioWhite: 20555,
  JH_SucculentGreen: 20556,
  JH_SugarMaple: 20557,
  JH_SugarPlum: 20558,
  JH_SummerNights: 20559,
  JH_SummerSage: 20560,
  JH_SummerWhite: 20561,
  JH_SunDriedTomatoes: 20562,
  JH_SunKissedKhaki: 20563,
  JH_SunliteBlue: 20564,
  JH_SunTint: 20565,
  JH_SwampGrass: 20566,
  JH_SweetBasil: 20567,
  JH_SweetCream: 20568,
  JH_SweetPea: 20569,
  JH_Sweetwater: 20570,
  JH_SwimmersDream: 24715,
  JH_Sycamore: 20571,
  JH_TahoeTan: 20572,
  JH_TalcWhite: 20573,
  JH_TallGrass: 20574,
  JH_TanglewoodBrown: 20575,
  JH_TawnyGold: 20576,
  JH_Teakwood: 20577,
  JH_TealTide: 20578,
  JH_TenderBlue: 20579,
  JH_Terrain: 20580,
  JH_ThatchedRoof: 20581,
  JH_ThornfieldBeige: 20582,
  JH_Thyme: 20583,
  JH_TidalBlue: 20584,
  JH_TidePool: 20585,
  JH_TimberlineBrown: 20586,
  JH_TimelessKhaki: 20587,
  JH_Titanium: 20588,
  JH_ToastedBrown: 20589,
  JH_TopiaryGreen: 20590,
  JH_TortugasGreen: 20591,
  JH_TouchOfGray: 20592,
  JH_ToulousePink: 20593,
  JH_TradewindGray: 20594,
  JH_TraditionalGray: 20595,
  JH_TransparentBlue: 20596,
  JH_TreeCanopy: 20597,
  JH_TreelinedStreet: 20598,
  JH_TropicalTeal: 20599,
  JH_TrueBlue: 20600,
  JH_TullaBeige: 20601,
  JH_Tumbleweed: 20602,
  JH_Turquoise: 20603,
  JH_TwilightBlue: 20604,
  JH_UnbleachedSilk: 20605,
  JH_UrbanGarden: 20606,
  JH_UrbanGray: 20607,
  JH_VanillaCream: 20608,
  JH_VenetianWhite: 20609,
  JH_VictorianRose: 20610,
  JH_VintagePlum: 20611,
  JH_VolcanoGray: 20612,
  JH_VoyageBlue: 20613,
  JH_WarmBlush: 20614,
  JH_WarmHeartRose: 20615,
  JH_WarmWhisky: 20616,
  JH_WarmWhite: 20617,
  JH_Wasabi: 20618,
  JH_WateringCan: 20619,
  JH_WateringHole: 20620,
  JH_Watertint: 20621,
  JH_WeatheredBronze: 20622,
  JH_WeatheredDock: 20623,
  JH_WeepingWillow: 20624,
  JH_WestminsterBeige: 20625,
  JH_WetConcrete: 20626,
  JH_WhippedCream: 20627,
  JH_WhippetGray: 20628,
  JH_WhisperingPines: 20629,
  JH_WhisperWhite: 20630,
  JH_WhiteAsh: 20631,
  JH_WhiteBungalow: 20632,
  JH_WhiteCanvas: 20633,
  JH_WhiteChocolate: 20634,
  JH_WhiteCliffs: 20635,
  JH_WhiteDiamond: 20636,
  JH_WhiteHeather: 20637,
  JH_WhiteHouse: 20638,
  JH_WhiteJasmine: 20639,
  JH_WhiteMeringue: 20640,
  JH_WhiteOrchid: 20641,
  JH_WhitePicketFence: 20642,
  JH_WhitePine: 20643,
  JH_WhiteSmoke: 20644,
  JH_WhiteWhicker: 20645,
  JH_WildWestBrown: 20646,
  JH_WillowGreen: 20647,
  JH_WinchesterWhite: 20648,
  JH_WindmillGray: 20649,
  JH_WindwardBlue: 20650,
  JH_WinterFrost: 20651,
  JH_WinterWhite: 20652,
  JH_WolfGray: 20653,
  JH_WoodedRavine: 20654,
  JH_WoodenChest: 20655,
  JH_WoodlandPath: 20656,
  JH_Woodpile: 20657,
  JH_Woodtone_AspenRidge: 10397,
  JH_Woodtone_BlackCanyon: 10398,
  JH_Woodtone_CaribouTrails: 10399,
  JH_Woodtone_CascadeSlate: 10400,
  JH_Woodtone_CoastalGray: 10401,
  JH_Woodtone_MidnightTide: 10402,
  JH_Woodtone_MountainCedar: 10403,
  JH_Woodtone_OldCherry: 10404,
  JH_Woodtone_RiverRock: 10405,
  JH_Woodtone_RoastedWalnut: 10406,
  JH_Woodtone_Rosewood: 10407,
  JH_Woodtone_SandCastle: 10408,
  JH_Woodtone_StoneBlue: 10409,
  JH_Woodtone_SummerWheat: 10410,
  JH_Woodtone_WarmEspresso: 10411,
  JH_Woodtone_WhiteGranite: 10412,
  JH_Woodtone_WhiteRapids: 10413,
  JH_Woodtone_WinchesterBrown: 10414,
  JH_WrittenInTheSand: 20658,
  JH_ZenBlue: 10509,
  JH_ZirconWhite: 20659,
};

const DMC_KellyMoore = {
  KM_0012_SierraWhite: 26234,
  KM_0014_Frost: 26235,
  KM_0020_WesternAcoustic: 26236,
  KM_0022_SoftWhite: 26237,
  KM_0023_SwissCoffee: 26238,
  KM_0025_Blanco: 26239,
  KM_0026_Oyster: 26240,
  KM_0027_Bone: 26241,
  KM_0029_NewLinen: 26242,
  KM_0030_GlacierWhite: 26243,
  KM_0032_WhiteDove: 26244,
  KM_0034_DoveWhite: 26245,
  KM_0036_NavajoWhite: 26246,
  KM_0041_SnipOfTannin: 26247,
  KM_0042_WiseOwl: 26248,
  KM_0045_WhiteShadow: 26249,
  KM_0046_Acoustic: 26250,
  KM_0046_AcousticWhite: 26251,
  KM_0049_AntiqueWhite: 26252,
  KM_0052_WhiteChip: 26253,
  KM_0053_RainierWhite: 26254,
  KM_0072_Catalina: 26255,
  KM_0073_Cortez: 26256,
  KM_0074_SeattleRed: 26257,
  KM_0075_Metro: 26258,
  KM_0149_GreenThumb: 26259,
  KM_0150_MallardGreen: 26260,
  KM_0156_Riviera: 26261,
  KM_0157_LaMarina: 26262,
  KM_0159_SequoiaRedwood: 26263,
  KM_0160_Bravado: 26264,
  KM_0163_PacificSand: 26265,
  KM_0168_FullSun: 26266,
  KM_0169_Cashmere: 26267,
  KM_0171_SandPebble: 26268,
  KM_0174_CharcoalGray: 26269,
  KM_0178_PlymouthGray: 26270,
  KM_0186_Keystone: 26271,
  KM_0188_Cypress: 26272,
  KM_0196_Villita: 26273,
  KM_0197_WoodMoss: 26274,
  KM_0200_SaddleBrown: 26275,
  KM_0202_Doeskin: 26276,
  KM_0203_TetonBlue: 26277,
  KM_0204_NorthernHaze: 26278,
  KM_0211_DeltaBlue: 26279,
  KM_0212_Saltillo: 26280,
  KM_0213_Lemongrass: 26281,
  KM_0214_Peppertree: 26282,
  KM_0215_GraysRiver: 26283,
  KM_0216_MalibuBeige: 26284,
  KM_0217_Chadwick: 26285,
  KM_0218_CascadeBeige: 26286,
  KM_0219_PuebloClay: 26287,
  KM_0227_Westwood: 26288,
  KM_0228_Charro: 26289,
  KM_0230_Graystone: 26290,
  KM_0231_SpanishSand: 26291,
  KM_0412_Cargo: 26292,
  KM_0413_Loam: 26293,
  KM_1_L_SummerBlonde: 26294,
  KM_10_M_Salinas: 26295,
  KM_100_M_Shrimporee: 26296,
  KM_101_M_CarnationPink: 26297,
  KM_102_D_Fascination: 26298,
  KM_103_L_Petaluma: 26299,
  KM_104_L_AleahsSong: 26300,
  KM_105_L_Chastity: 26301,
  KM_106_M_LobsterBisque: 26302,
  KM_107_M_BuffaloWing: 26303,
  KM_108_D_GeorgianEarth: 26304,
  KM_109_L_SherryPink: 26305,
  KM_11_M_Nacasio: 26306,
  KM_110_L_PeachPotpourri: 26307,
  KM_111_L_Rosemede: 26308,
  KM_112_M_BakedClay: 26309,
  KM_113_M_Byzantine: 26310,
  KM_114_D_Redhead: 26311,
  KM_115_L_Trinidad: 26312,
  KM_116_L_Elaborate: 26313,
  KM_117_L_SatinRose: 26314,
  KM_118_M_ProvincialRose: 26315,
  KM_119_M_EnglishRose: 26316,
  KM_12_D_Summerland: 26317,
  KM_120_D_HouseOfFire: 26318,
  KM_121_L_Carlotta: 26319,
  KM_122_L_RachelRose: 26320,
  KM_123_L_Teresa: 26321,
  KM_124_L_Piazza: 26322,
  KM_125_M_Crawdad: 26323,
  KM_126_D_Rooster: 26324,
  KM_127_L_Charisma: 26325,
  KM_128_L_AmbroseSplash: 26326,
  KM_129_L_HunnyBunny: 26327,
  KM_13_L_YellowAspire: 26328,
  KM_130_M_RoseHall: 26329,
  KM_131_M_BatonRouge: 26330,
  KM_132_D_Oomph: 26331,
  KM_133_L_TuscanyRose: 26332,
  KM_134_L_LoveNote: 26333,
  KM_135_L_LyricOpera: 26334,
  KM_136_M_RebeccaJo: 26335,
  KM_137_M_OperaHouse: 26336,
  KM_138_D_Braeberry: 26337,
  KM_139_L_PeppermintTwist: 26338,
  KM_14_L_ItalianIce: 26339,
  KM_140_L_DianaPink: 26340,
  KM_141_L_LoveKnot: 26341,
  KM_142_M_Kingly: 26342,
  KM_143_M_PapayaPunch: 26343,
  KM_144_D_Desiree: 26344,
  KM_145_L_PaleGarnet: 26345,
  KM_146_L_SweetTattania: 26346,
  KM_147_L_RoseOfSharon: 26347,
  KM_148_M_FrostedLipstick: 26348,
  KM_149_M_FruitPop: 26349,
  KM_15_L_Mariposa: 26350,
  KM_150_D_WatermelonPink: 26351,
  KM_151_L_BlushedCheeks: 26352,
  KM_152_L_PieceOfCake: 26353,
  KM_153_L_HeartShape: 26354,
  KM_154_M_LoveBallad: 26355,
  KM_155_M_NaturalBeauty: 26356,
  KM_156_D_BerryGood: 26357,
  KM_157_L_BirthdayPresent: 26358,
  KM_158_L_PerfectPink: 26359,
  KM_159_L_Heartbeat: 26360,
  KM_16_M_Glitzy: 26361,
  KM_160_M_BlushingPink: 26362,
  KM_161_M_Constantia: 26363,
  KM_162_D_AwesomeBlossom: 26364,
  KM_163_L_Goosebump: 26365,
  KM_164_L_DelicateFlower: 26366,
  KM_165_L_Enchantment: 26367,
  KM_166_M_PinkCassis: 26368,
  KM_167_M_RedCurrant: 26369,
  KM_168_D_BerryCooler: 26370,
  KM_169_L_Handkerchief: 26371,
  KM_17_M_PineappleLodge: 26372,
  KM_170_L_PaleRubyesque: 26373,
  KM_171_L_Mirth: 26374,
  KM_172_M_Whim: 26375,
  KM_173_M_Berriness: 26376,
  KM_174_D_VerryBerry: 26377,
  KM_175_L_Melodious: 26378,
  KM_176_L_LittleGem: 26379,
  KM_177_L_Flowermarket: 26380,
  KM_178_M_Hospitality: 26381,
  KM_179_M_Renoir: 26382,
  KM_18_D_Eyecatcher: 26383,
  KM_180_D_FieldOfFlowers: 26384,
  KM_181_L_RoyalArbor: 26385,
  KM_182_L_QuartzHaven: 26386,
  KM_183_L_PinkCosmos: 26387,
  KM_184_M_Bellflower: 26388,
  KM_185_M_RoyalGeorge: 26389,
  KM_186_D_DogesPalace: 26390,
  KM_187_L_PurpleAngel: 26391,
  KM_188_L_SavonStar: 26392,
  KM_189_L_Cymbidium: 26393,
  KM_19_L_LemonCreamPie: 26394,
  KM_190_M_ManyFlowers: 26395,
  KM_191_M_FrenchLilac: 26396,
  KM_192_D_Mayflower: 26397,
  KM_193_L_Balinese: 26398,
  KM_194_L_PurpleLoosestrife: 26399,
  KM_195_L_ValeriaPlum: 26400,
  KM_196_M_Montague: 26401,
  KM_197_M_Lilacberry: 26402,
  KM_198_D_WineBlush: 26403,
  KM_199_L_Spirea: 26404,
  KM_2_L_Dogbane: 26405,
  KM_20_L_BeverlyHills: 26406,
  KM_200_L_StHelena: 26407,
  KM_201_L_Windsor: 26408,
  KM_202_M_BehindTheScene: 26409,
  KM_203_M_ValerianViolet: 26410,
  KM_204_D_Swank: 26411,
  KM_205_L_LilacBrook: 26412,
  KM_206_L_Cartier: 26413,
  KM_207_L_Thistle: 26414,
  KM_208_M_EmperorsClothes: 26415,
  KM_209_M_PaleVioletta: 26416,
  KM_21_L_LuxuriousLemon: 26417,
  KM_210_D_Wizard: 26418,
  KM_211_L_BouquetOrchid: 26419,
  KM_212_L_GrapeSlush: 26420,
  KM_213_L_OrchidShadow: 26421,
  KM_214_M_CrushedGrape: 26422,
  KM_215_M_LavenderImpatiens: 26423,
  KM_216_D_VioletHeather: 26424,
  KM_217_L_OrchidPetal: 26425,
  KM_218_L_LonesomeLilac: 26426,
  KM_219_L_Montclair: 26427,
  KM_22_M_YellowOrchid: 26428,
  KM_220_M_Princely: 26429,
  KM_221_M_Vixen: 26430,
  KM_222_D_MountainMajesty: 26431,
  KM_223_L_EasterEgg: 26432,
  KM_224_L_NordicBlue: 26433,
  KM_225_L_JaimeBlue: 26434,
  KM_226_M_AdriaticHaze: 26435,
  KM_227_M_Contemporary: 26436,
  KM_228_D_HaleysComet: 26437,
  KM_229_L_BlueCeleste: 26438,
  KM_23_M_HighNote: 26439,
  KM_230_L_Doodle: 26440,
  KM_231_L_HebronBlue: 26441,
  KM_232_M_DejaVuBlue: 26442,
  KM_233_M_BlueCrab: 26443,
  KM_234_D_Diablo: 26444,
  KM_235_L_NordicSky: 26445,
  KM_236_L_Iceberg: 26446,
  KM_237_L_BlueHarmony: 26447,
  KM_238_M_BruiserBlue: 26448,
  KM_239_M_BlueSteel: 26449,
  KM_24_D_ArcadeLights: 26450,
  KM_240_D_LaTraviata: 26451,
  KM_241_L_SilverLake: 26452,
  KM_242_L_Contralto: 26453,
  KM_243_M_BritonBlue: 26454,
  KM_244_M_RiverBlue: 26455,
  KM_245_M_HiddenHill: 26456,
  KM_246_D_BlueDevil: 26457,
  KM_247_L_PalePeriwinkle: 26458,
  KM_248_L_Chimes: 26459,
  KM_249_L_BluePansy: 26460,
  KM_25_L_Buttercrunch: 26461,
  KM_250_M_Concordia: 26462,
  KM_251_M_NapaValley: 26463,
  KM_252_D_Vineyard: 26464,
  KM_253_L_Covina: 26465,
  KM_254_L_JoshBlue: 26466,
  KM_255_L_CoolShowers: 26467,
  KM_256_M_ChulaVista: 26468,
  KM_257_M_Cardiff: 26469,
  KM_258_D_StockingCap: 26470,
  KM_259_L_ColonelsBlue: 26471,
  KM_26_L_PaleStraw: 26472,
  KM_260_L_BlueLotus: 26473,
  KM_261_L_Nouvelle: 26474,
  KM_262_L_Bach: 26475,
  KM_263_M_Peninsula: 26476,
  KM_264_D_DenimBlue: 26477,
  KM_265_L_BlueFoxfrost: 26478,
  KM_266_L_PrairieSky: 26479,
  KM_267_L_SistineChapel: 26480,
  KM_268_M_Traditional: 26481,
  KM_269_M_ByeByeBirdie: 26482,
  KM_27_L_Sunquest: 26483,
  KM_270_D_Caribe: 26484,
  KM_271_L_AlaskaIce: 26485,
  KM_272_L_OceanBreeze: 26486,
  KM_273_M_SoaringBird: 26487,
  KM_274_M_Waterfront: 26488,
  KM_275_M_MonetBlue: 26489,
  KM_276_D_AmericanBlue: 26490,
  KM_277_L_Amador: 26491,
  KM_278_L_FountainValley: 26492,
  KM_279_L_Lovebird: 26493,
  KM_28_M_MargaretMary: 26494,
  KM_280_L_Halo: 26495,
  KM_281_M_LucerneLake: 26496,
  KM_282_D_MaisonBleu: 26497,
  KM_283_L_BlueHorizon: 26498,
  KM_284_L_ClearLake: 26499,
  KM_285_L_HarborBay: 26500,
  KM_286_M_StellaBlue: 26501,
  KM_287_M_CountryBlue: 26502,
  KM_288_D_DarkSky: 26503,
  KM_289_L_CompassPoint: 26504,
  KM_29_M_HighNoon: 26505,
  KM_290_L_Bellefrost: 26506,
  KM_291_L_LakeVillage: 26507,
  KM_292_M_CaymanIsland: 26508,
  KM_293_M_SeaGem: 26509,
  KM_294_D_KingstonBlue: 26510,
  KM_295_L_PacificSky: 26511,
  KM_296_L_Cozy: 26512,
  KM_297_L_Seafarer: 26513,
  KM_298_M_Grandview: 26514,
  KM_299_M_Lakeview: 26515,
  KM_3_L_SunRunner: 26516,
  KM_30_D_Livewire: 26517,
  KM_300_D_GrandCanal: 26518,
  KM_3001_1_LightLavendar: 26519,
  KM_3002_1_PurplePeace: 26520,
  KM_3003_1_LilacLady: 26521,
  KM_3004_1_MicaelaAbril: 26522,
  KM_3005_2_VeryViolet: 26523,
  KM_3006_2_JapaneseLilac: 26524,
  KM_3007_3_HappyHyacinth: 26525,
  KM_3008_5_IrisImpact: 26526,
  KM_3009_1_LilacFrost: 26527,
  KM_301_L_AncientEye: 26528,
  KM_3010_1_LavenderLaugh: 26529,
  KM_3011_1_LastOfTheLilacs: 26530,
  KM_3012_1_WisteriaWish: 26531,
  KM_3013_2_ItalianIris: 26532,
  KM_3014_3_PandorasPurple: 26533,
  KM_3015_3_Jubilation: 26534,
  KM_3016_5_MidnightAffair: 26535,
  KM_3017_1_LilacLass: 26536,
  KM_3018_1_PalePansy: 26537,
  KM_3019_1_SpringCrocus: 26538,
  KM_302_L_BlueChiffon: 26539,
  KM_3020_1_LavenderLilac: 26540,
  KM_3021_2_TeresasTrueColor: 26541,
  KM_3022_2_LilacGarden: 26542,
  KM_3023_3_RegalJewel: 26543,
  KM_3024_5_RoyalRajah: 26544,
  KM_3025_1_LavenderSplash: 26545,
  KM_3026_1_FancyPansy: 26546,
  KM_3027_1_Violetville: 26547,
  KM_3028_1_PansyPotpourri: 26548,
  KM_3029_2_PurplePossibility: 26549,
  KM_303_L_DewKiss: 26550,
  KM_3030_2_LavenderLegend: 26551,
  KM_3031_3_RoyalRaul: 26552,
  KM_3032_5_IrisIllusion: 26553,
  KM_3033_1_GreekGoddess: 26554,
  KM_3034_1_CarefreeBreeze: 26555,
  KM_3035_1_EvocativeAntonia: 26556,
  KM_3036_2_LilacLake: 26557,
  KM_3037_2_GatewayToParadise: 26558,
  KM_3038_2_Hermosa: 26559,
  KM_3039_3_BloomingLilac: 26560,
  KM_304_L_Bombay: 26561,
  KM_3040_5_DarkTriumph: 26562,
  KM_3041_1_LilacBreeze: 26563,
  KM_3042_1_EasterParty: 26564,
  KM_3043_1_ShyViolet: 26565,
  KM_3044_1_HyacinthHaze: 26566,
  KM_3045_2_LapOfLuxury: 26567,
  KM_3046_2_GardenBeauty: 26568,
  KM_3047_3_PurplePansies: 26569,
  KM_3048_5_QueenVictoria: 26570,
  KM_3049_1_FancyThat: 26571,
  KM_305_M_Blueprint: 26572,
  KM_3050_1_FrostyGlaze: 26573,
  KM_3051_1_Province: 26574,
  KM_3052_2_LusterBlue: 26575,
  KM_3053_2_Barrymore: 26576,
  KM_3054_3_Suzette: 26577,
  KM_3055_3_VintageVelvet: 26578,
  KM_3056_5_RoyalTreatment: 26579,
  KM_3057_1_TentativeDawn: 26580,
  KM_3058_1_PastelPrincess: 26581,
  KM_3059_1_PickOfThePatch: 26582,
  KM_306_D_PortRoyale: 26583,
  KM_3060_2_LinedWithLilacs: 26584,
  KM_3061_2_RoyalGlimmer: 26585,
  KM_3062_3_GrapeGathering: 26586,
  KM_3063_5_PlumBerry: 26587,
  KM_3064_5_RareOrchid: 26588,
  KM_3065_1_PurpleHaze: 26589,
  KM_3066_1_LittleCutie: 26590,
  KM_3067_1_FloraVista: 26591,
  KM_3068_1_PeakOfPerfection: 26592,
  KM_3069_2_PetalSoft: 26593,
  KM_307_L_CountryStyle: 26594,
  KM_3070_2_Adora: 26595,
  KM_3071_3_ExoticBeauty: 26596,
  KM_3072_5_PetulantPat: 26597,
  KM_3073_1_Alicia: 26598,
  KM_3074_1_EdgeOfDawn: 26599,
  KM_3075_1_BeautifulBerry: 26600,
  KM_3076_1_BerryBlush: 26601,
  KM_3077_2_Roswell: 26602,
  KM_3078_2_Florette: 26603,
  KM_3079_3_PurpleWave: 26604,
  KM_308_L_AiryBlue: 26605,
  KM_3080_5_GeorgianCourt: 26606,
  KM_3081_1_Loyalist: 26607,
  KM_3082_1_LittleGrapette: 26608,
  KM_3083_1_VioletVista: 26609,
  KM_3084_2_PurpleParadise: 26610,
  KM_3085_2_PurpleMoon: 26611,
  KM_3086_3_PremierePurple: 26612,
  KM_3087_3_MountainVale: 26613,
  KM_3088_5_GrandGrape: 26614,
  KM_3089_1_RealTime: 26615,
  KM_309_L_PolarMorn: 26616,
  KM_3090_1_RomanceInBloom: 26617,
  KM_3091_1_Kecia: 26618,
  KM_3092_1_FavoriteThings: 26619,
  KM_3093_2_PurpleyPuff: 26620,
  KM_3094_2_TiannasEyes: 26621,
  KM_3095_3_FlirtyFran: 26622,
  KM_3096_5_PantryPlum: 26623,
  KM_3097_1_IcyBlue: 26624,
  KM_3098_1_Moondancing: 26625,
  KM_3099_1_BreezyBlue: 26626,
  KM_31_L_Buttermilk: 26627,
  KM_310_M_BigChill: 26628,
  KM_3100_1_MorningSky: 26629,
  KM_3101_2_PrinceCharming: 26630,
  KM_3102_2_RoyalRegatta: 26631,
  KM_3103_3_BlueBounty: 26632,
  KM_3104_5_EveningMagic: 26633,
  KM_3105_1_BlueBrushStroke: 26634,
  KM_3106_1_BlueDawn: 26635,
  KM_3107_1_ByTheBay: 26636,
  KM_3108_1_ScubaBlue: 26637,
  KM_3109_2_WashedIndigo: 26638,
  KM_311_M_Saturn: 26639,
  KM_3110_2_SouthPort: 26640,
  KM_3111_3_HarborBlue: 26641,
  KM_3112_5_EveningInParis: 26642,
  KM_3113_1_Bluenose: 26643,
  KM_3114_1_SummerSky: 26644,
  KM_3115_1_SailAway: 26645,
  KM_3116_1_BlissfulBlue: 26646,
  KM_3117_2_FarHorizons: 26647,
  KM_3118_2_PostcardPerfect: 26648,
  KM_3119_3_BlueMonday: 26649,
  KM_312_D_NavalOfficer: 26650,
  KM_3120_5_Luxe: 26651,
  KM_3121_1_JuneBreeze: 26652,
  KM_3122_1_PreciousDewDrop: 26653,
  KM_3123_1_QuietRefuge: 26654,
  KM_3124_2_BeecherFalls: 26655,
  KM_3125_2_PieceOfTheSky: 26656,
  KM_3126_3_SeaOfMarma: 26657,
  KM_3127_3_Tahoe: 26658,
  KM_3128_5_BlueMoonBay: 26659,
  KM_3129_1_CalypsoBreeze: 26660,
  KM_313_L_Martinique: 26661,
  KM_3130_1_PrairieDay: 26662,
  KM_3131_1_PyramidLake: 26663,
  KM_3132_1_BlueSky: 26664,
  KM_3133_2_CityOfAtlantis: 26665,
  KM_3134_2_BreathtakingBlue: 26666,
  KM_3135_3_SoothingSapphire: 26667,
  KM_3136_5_CascadeTwilight: 26668,
  KM_3137_1_SpringDew: 26669,
  KM_3138_1_BirdBathBlue: 26670,
  KM_3139_1_BloomingBlue: 26671,
  KM_314_L_PanamaBlue: 26672,
  KM_3140_1_MakeASplash: 26673,
  KM_3141_2_GauginsBlue: 26674,
  KM_3142_2_BirdsEggBlue: 26675,
  KM_3143_3_WakebyBeach: 26676,
  KM_3144_5_PrairieNight: 26677,
  KM_3145_1_DreamySpace: 26678,
  KM_3146_1_HighSpirits: 26679,
  KM_3147_1_SkyWatch: 26680,
  KM_3148_1_LupesLake: 26681,
  KM_3149_2_CascadeBlue: 26682,
  KM_315_L_TwinkleLittle: 26683,
  KM_3150_2_Bonaventure: 26684,
  KM_3151_3_HiddenSprings: 26685,
  KM_3152_5_BlueByYou: 26686,
  KM_3153_1_PhantomLake: 26687,
  KM_3154_1_SwirlingWater: 26688,
  KM_3155_1_OhBoy: 26689,
  KM_3156_1_DresdenFalls: 26690,
  KM_3157_2_ThunderBay: 26691,
  KM_3158_2_StormBlueSky: 26692,
  KM_3159_3_BlueSuedeShoes: 26693,
  KM_316_M_CaptainsChoice: 26694,
  KM_3160_5_BlazerBlue: 26695,
  KM_3161_1_CloudWispedSky: 26696,
  KM_3162_1_SierraSpring: 26697,
  KM_3163_1_HatterasHaze: 26698,
  KM_3164_1_ExoticPort: 26699,
  KM_3165_2_MaracayBay: 26700,
  KM_3166_2_BreezyIndigo: 26701,
  KM_3167_3_SailboatBlue: 26702,
  KM_3168_5_Swoosh: 26703,
  KM_3169_1_WhisperyBreeze: 26704,
  KM_317_M_Simplicity: 26705,
  KM_3170_1_SimplyHeaven: 26706,
  KM_3171_1_NewDaySky: 26707,
  KM_3172_1_ParadiseBay: 26708,
  KM_3173_2_SunriseRiver: 26709,
  KM_3174_2_TrueSkyBlue: 26710,
  KM_3175_3_OldPort: 26711,
  KM_3176_5_CitadelBlue: 26712,
  KM_3177_1_SoftSpoken: 26713,
  KM_3178_1_CaribbeanSky: 26714,
  KM_3179_1_SeasidePleasure: 26715,
  KM_318_D_DreamyBlue: 26716,
  KM_3180_1_GiftOfTheSea: 26717,
  KM_3181_2_TropicalSea: 26718,
  KM_3182_2_WonderfulWorld: 26719,
  KM_3183_3_LakeComo: 26720,
  KM_3184_5_UnderTheSea: 26721,
  KM_3185_1_GypsyWind: 26722,
  KM_3186_1_BrightVision: 26723,
  KM_3187_1_WalkingOnAir: 26724,
  KM_3188_1_JoyfulMorning: 26725,
  KM_3189_2_Skyway: 26726,
  KM_319_L_BrahmsLullaby: 26727,
  KM_3190_2_PatchOfBlue: 26728,
  KM_3191_3_PuertoMio: 26729,
  KM_3192_5_NightEdition: 26730,
  KM_3193_1_Odessa: 26731,
  KM_3194_1_InnerPeace: 26732,
  KM_3195_1_FantasyFlight: 26733,
  KM_3196_1_OceanPark: 26734,
  KM_3197_2_ArizonaTurquoise: 26735,
  KM_3198_2_BountifulBlue: 26736,
  KM_3199_3_NavajoTurquoise: 26737,
  KM_32_L_LemonSherbet: 26738,
  KM_320_L_Adrift: 26739,
  KM_3200_5_SeaOfMidnight: 26740,
  KM_3201_1_CrystalRiver: 26741,
  KM_3202_1_SwimTeam: 26742,
  KM_3203_1_ChristopherCoast: 26743,
  KM_3204_1_PleasantView: 26744,
  KM_3205_2_Aquavit: 26745,
  KM_3206_2_Brookside: 26746,
  KM_3207_3_AquaMarine: 26747,
  KM_3208_5_CaribbeanDream: 26748,
  KM_3209_1_BayBreeze: 26749,
  KM_321_L_Oceanside: 26750,
  KM_3210_1_EssenceOfTheSea: 26751,
  KM_3211_1_AegeanAccent: 26752,
  KM_3212_1_CoastalView: 26753,
  KM_3213_2_TurquoiseTrick: 26754,
  KM_3214_2_SallyO: 26755,
  KM_3215_3_Capitola: 26756,
  KM_3216_5_ErynMichelle: 26757,
  KM_3217_1_BayCruise: 26758,
  KM_3218_1_IcedTeal: 26759,
  KM_3219_1_SeasideAccents: 26760,
  KM_322_M_Marseilles: 26761,
  KM_3220_1_TealTwilight: 26762,
  KM_3221_2_AcapulcoAqua: 26763,
  KM_3222_2_Venus: 26764,
  KM_3223_3_Hustle: 26765,
  KM_3224_5_WoodlandSprings: 26766,
  KM_3225_1_MeadowMist: 26767,
  KM_3226_1_BlueGreenGem: 26768,
  KM_3227_1_NaturesTheme: 26769,
  KM_3228_1_FairFarmington: 26770,
  KM_3229_2_KentuckyEstate: 26771,
  KM_323_M_Watergate: 26772,
  KM_3230_3_PeacefulPond: 26773,
  KM_3231_3_TropicalTeal: 26774,
  KM_3232_5_MonteRoyal: 26775,
  KM_3233_1_TenderTouch: 26776,
  KM_3234_1_BabyAqua: 26777,
  KM_3235_1_AquaInfusion: 26778,
  KM_3236_1_TurquoiseTreat: 26779,
  KM_3237_2_OceansideParadise: 26780,
  KM_3238_2_CoolTurquoise: 26781,
  KM_3239_3_SoothingSong: 26782,
  KM_324_D_BlueLobelia: 26783,
  KM_3240_5_TurquoiseTrinket: 26784,
  KM_3241_1_SpaSprings: 26785,
  KM_3243_1_AgedAegean: 26786,
  KM_3244_1_GloriousGarden: 26787,
  KM_3245_2_MayDay: 26788,
  KM_3246_2_AlexandraValley: 26789,
  KM_3247_3_SoJaded: 26790,
  KM_3248_5_EmeraldAccent: 26791,
  KM_3249_1_Glorianna: 26792,
  KM_325_L_Sassy: 26793,
  KM_3250_1_PrairiePrincess: 26794,
  KM_3251_1_MildMallard: 26795,
  KM_3252_1_Kylemore: 26796,
  KM_3253_2_MeadowGreen: 26797,
  KM_3254_2_PicnicHaven: 26798,
  KM_3255_3_TimeToGrow: 26799,
  KM_3256_5_EnchantedEvergreen: 26800,
  KM_3257_1_MysticGlow: 26801,
  KM_3258_1_SummersSecret: 26802,
  KM_3259_1_IrishLass: 26803,
  KM_326_L_Hemisphere: 26804,
  KM_3260_1_KodiakValley: 26805,
  KM_3261_2_GreenGrace: 26806,
  KM_3262_2_AgedJade: 26807,
  KM_3263_3_EmeraldValley: 26808,
  KM_3264_5_CountryMeadow: 26809,
  KM_3265_1_GardenSprite: 26810,
  KM_3266_1_TealTwist: 26811,
  KM_3267_1_JardinJewel: 26812,
  KM_3268_1_PatinedCopper: 26813,
  KM_3269_2_MyGardenParty: 26814,
  KM_327_L_CupidBlue: 26815,
  KM_3270_2_JoltOfJade: 26816,
  KM_3271_3_EmeraldAcres: 26817,
  KM_3272_5_ShamrockGreen: 26818,
  KM_3273_1_SongOfSummer: 26819,
  KM_3274_1_SpringFolly: 26820,
  KM_3275_1_MermaidMagic: 26821,
  KM_3276_1_FantasyIsle: 26822,
  KM_3277_2_LaurelVillage: 26823,
  KM_3278_2_GardeningGirl: 26824,
  KM_3279_3_JasmineJazz: 26825,
  KM_328_L_Trio: 26826,
  KM_3280_5_WoodlandFern: 26827,
  KM_3281_1_SpringSplendor: 26828,
  KM_3282_1_GardenSoftGreen: 26829,
  KM_3283_1_GlenHaven: 26830,
  KM_3284_1_SummerSonata: 26831,
  KM_3285_2_Esmerelda: 26832,
  KM_3286_2_DayInTheGarden: 26833,
  KM_3287_3_PeacefulThyme: 26834,
  KM_3288_5_CenterField: 26835,
  KM_3289_1_DreamOfGreen: 26836,
  KM_329_M_Eternity: 26837,
  KM_3290_1_IslandSpirit: 26838,
  KM_3292_1_GardenGreenery: 26839,
  KM_3293_2_PioneerPark: 26840,
  KM_3294_2_TarragonTease: 26841,
  KM_3295_3_GardenLeaf: 26842,
  KM_3296_5_TheBackNine: 26843,
  KM_3297_1_Gelatto: 26844,
  KM_3298_1_SubtleSplendor: 26845,
  KM_3299_1_PhillipsField: 26846,
  KM_33_L_Jeune: 26847,
  KM_330_D_LakeInTheHills: 26848,
  KM_3300_1_GreenPastures: 26849,
  KM_3301_2_SageBrushPlace: 26850,
  KM_3302_2_GardenVariety: 26851,
  KM_3303_3_SummerSumac: 26852,
  KM_3304_5_Greenery: 26853,
  KM_3305_1_SoftMint: 26854,
  KM_3306_1_WelcomeSpring: 26855,
  KM_3307_1_WhisperOfPine: 26856,
  KM_3308_1_PinetreeTrail: 26857,
  KM_3309_2_AgedSage: 26858,
  KM_331_L_Prudence: 26859,
  KM_3310_2_LakesidePine: 26860,
  KM_3311_3_WoodlandSage: 26861,
  KM_3312_5_AliciaOhara: 26862,
  KM_3313_1_PreludeToSummer: 26863,
  KM_3314_1_FlowingGreen: 26864,
  KM_3315_1_SpringLeaves: 26865,
  KM_3316_1_AlthorpPark: 26866,
  KM_3317_2_WildWeeds: 26867,
  KM_3318_2_AmazonTrail: 26868,
  KM_3319_3_Elmvale: 26869,
  KM_332_L_PointReyes: 26870,
  KM_3320_5_JollyHolly: 26871,
  KM_3321_1_MistyMeadow: 26872,
  KM_3322_1_SpringSonnet: 26873,
  KM_3323_1_GrassyPath: 26874,
  KM_3324_1_GreenLight: 26875,
  KM_3325_2_SageSensation: 26876,
  KM_3326_2_FrogPrince: 26877,
  KM_3327_3_HiddenHills: 26878,
  KM_3328_5_WildernessRetreat: 26879,
  KM_3329_1_GreenRepublic: 26880,
  KM_333_L_HeavenlySent: 26881,
  KM_3330_1_BuddingLeaf: 26882,
  KM_3331_1_EchoOfSpring: 26883,
  KM_3332_1_LincolnPark: 26884,
  KM_3333_2_GardenStroll: 26885,
  KM_3334_2_GrandValley: 26886,
  KM_3335_3_GreenJeans: 26887,
  KM_3336_5_LilyPadPlace: 26888,
  KM_3337_1_GreenPeace: 26889,
  KM_3338_1_NaturesPalette: 26890,
  KM_3339_1_Springfield: 26891,
  KM_334_M_PorcelainBlue: 26892,
  KM_3340_1_EastOfEden: 26893,
  KM_3341_2_QuietKiwi: 26894,
  KM_3342_2_LittleGreenFrog: 26895,
  KM_3343_3_JungleBirds: 26896,
  KM_3344_5_DarkDrama: 26897,
  KM_3345_1_GardenersDelight: 26898,
  KM_3346_1_VillaGrove: 26899,
  KM_3347_1_LightLoden: 26900,
  KM_3348_2_ChoppedCelery: 26901,
  KM_3349_2_MajesticMountain: 26902,
  KM_335_M_Knickerbocker: 26903,
  KM_3350_3_CedarLake: 26904,
  KM_3351_3_ForestRanger: 26905,
  KM_3352_5_WoodlandPark: 26906,
  KM_3353_1_SpringPromise: 26907,
  KM_3354_1_KiwiKiss: 26908,
  KM_3355_1_GloryOfSpring: 26909,
  KM_3356_1_PointPleasantHeights: 26910,
  KM_3357_2_SnappyGreen: 26911,
  KM_3358_2_LickOfLime: 26912,
  KM_3359_3_SourApple: 26913,
  KM_336_D_AlpineLake: 26914,
  KM_3360_5_LatestLook: 26915,
  KM_3361_1_NewGreen: 26916,
  KM_3362_1_GlimpseOfSpring: 26917,
  KM_3363_1_PickOfTheMeadow: 26918,
  KM_3364_1_GreenOfSpring: 26919,
  KM_3365_2_EnglishCountryside: 26920,
  KM_3366_2_SpringAhead: 26921,
  KM_3367_3_JeansGreens: 26922,
  KM_3368_5_LimerickTrick: 26923,
  KM_3369_1_SoftFern: 26924,
  KM_337_L_PeaceOfMind: 26925,
  KM_3370_1_PerennialPath: 26926,
  KM_3371_1_GreenAcres: 26927,
  KM_3372_1_Squirt: 26928,
  KM_3373_2_SpringHasSprung: 26929,
  KM_3374_2_Limeade: 26930,
  KM_3375_3_GreenApplePeels: 26931,
  KM_3376_5_LusciousLime: 26932,
  KM_3377_1_SoftSpring: 26933,
  KM_3378_1_JoyOfNature: 26934,
  KM_3379_1_SpringGlen: 26935,
  KM_338_L_Plateau: 26936,
  KM_3380_1_ChelseaGarden: 26937,
  KM_3381_2_PeeledPistacchio: 26938,
  KM_3382_2_FreshLettuce: 26939,
  KM_3383_3_BurstOfLime: 26940,
  KM_3384_5_SportingGreen: 26941,
  KM_3385_1_BurstOfSpring: 26942,
  KM_3386_1_SoftShamrock: 26943,
  KM_3387_1_SpringBounty: 26944,
  KM_3388_1_SparklingSpring: 26945,
  KM_3389_2_SpringGardenWalk: 26946,
  KM_339_L_EtherealBlue: 26947,
  KM_3390_2_AlligatorAlley: 26948,
  KM_3391_3_JiveClive: 26949,
  KM_3392_5_ParisanPark: 26950,
  KM_3393_1_GreenWhisp: 26951,
  KM_3394_1_ChipperTint: 26952,
  KM_3395_1_GreenMile: 26953,
  KM_3396_1_FreshSprout: 26954,
  KM_3397_2_NeonLights: 26955,
  KM_3398_3_SubLime: 26956,
  KM_3399_3_Wow: 26957,
  KM_34_M_Sundress: 26958,
  KM_340_M_DreamOn: 26959,
  KM_3400_Y_SourLime: 26960,
  KM_3401_1_A_NewLeaf: 26961,
  KM_3402_1_SpringFrolic: 26962,
  KM_3403_1_GoldenChartreuse: 26963,
  KM_3404_2_GoldenShores: 26964,
  KM_3405_2_PortsmouthOlive: 26965,
  KM_3406_3_AgedAvocado: 26966,
  KM_3407_3_PointVerde: 26967,
  KM_3408_5_TuscanyHillside: 26968,
  KM_3409_1_ArborField: 26969,
  KM_341_M_ProvencePalace: 26970,
  KM_3410_1_VillaNova: 26971,
  KM_3411_1_Hillsmere: 26972,
  KM_3412_2_JungleCane: 26973,
  KM_3413_2_MossyLog: 26974,
  KM_3414_3_RetroAvocado: 26975,
  KM_3415_3_AgedOlive: 26976,
  KM_3416_5_CedarEdge: 26977,
  KM_3417_1_WhiteMarsh: 26978,
  KM_3418_1_SunnyKnoll: 26979,
  KM_3419_1_SpringFarm: 26980,
  KM_342_D_TropicalShore: 26981,
  KM_3420_2_FrontenacHills: 26982,
  KM_3421_2_YoungGreen: 26983,
  KM_3422_3_SweetCelery: 26984,
  KM_3423_3_HallsOfIvy: 26985,
  KM_3424_5_SpringFancy: 26986,
  KM_3425_1_SpiritIsland: 26987,
  KM_3426_1_ProvincialGarden: 26988,
  KM_3427_1_SprigOfSage: 26989,
  KM_3428_2_MeadowMarsh: 26990,
  KM_3429_2_GardenPromenade: 26991,
  KM_343_L_CanadianSky: 26992,
  KM_3430_2_ItalianOlive: 26993,
  KM_3431_3_CactusCafe: 26994,
  KM_3432_5_NationalForest: 26995,
  KM_3433_1_SummerFun: 26996,
  KM_3434_1_GoldenSeason: 26997,
  KM_3435_1_Soya: 26998,
  KM_3436_1_SunFun: 26999,
  KM_3437_2_GoldenTreasure: 27000,
  KM_3438_3_LaHeat: 27001,
  KM_3439_3_SunBright: 27002,
  KM_344_L_BachelorButton: 27003,
  KM_3440_5_MissMarigold: 27004,
  KM_3441_1_AngelKiss: 27005,
  KM_3442_1_KindredSpirit: 27006,
  KM_3443_1_HarmonyHills: 27007,
  KM_3444_1_Meadowland: 27008,
  KM_3445_2_DivineVine: 27009,
  KM_3446_2_Avalon: 27010,
  KM_3447_3_GardenElement: 27011,
  KM_3448_5_OrnamentalGrass: 27012,
  KM_3449_1_WindsweptSails: 27013,
  KM_345_L_Fantasy: 27014,
  KM_3450_1_PalePapyrus: 27015,
  KM_3451_1_BananaCream: 27016,
  KM_3452_2_GoldMountain: 27017,
  KM_3453_2_BambooShoot: 27018,
  KM_3454_3_Sheffield: 27019,
  KM_3455_3_OliveOil: 27020,
  KM_3456_5_Veradale: 27021,
  KM_3457_1_ThickenedCream: 27022,
  KM_3458_1_NaturalLinen: 27023,
  KM_3459_1_HappyHoney: 27024,
  KM_346_M_Skyline: 27025,
  KM_3460_1_HoneyHeaven: 27026,
  KM_3461_2_Goldiluxe: 27027,
  KM_3462_2_AustralianOutlook: 27028,
  KM_3463_3_SeptemberSun: 27029,
  KM_3464_5_TheOpenRange: 27030,
  KM_3465_1_SummerStyle: 27031,
  KM_3466_1_SunnyCompanion: 27032,
  KM_3467_1_Sunshiny: 27033,
  KM_3468_1_RiseAndShine: 27034,
  KM_3469_2_LemonBurst: 27035,
  KM_347_M_TidalWave: 27036,
  KM_3470_2_SummerYellow: 27037,
  KM_3471_3_RajahGold: 27038,
  KM_3472_5_UnderTheSun: 27039,
  KM_3473_1_SoftHoney: 27040,
  KM_3474_1_ShiningBright: 27041,
  KM_3475_1_SunnySanibel: 27042,
  KM_3476_1_LemonRose: 27043,
  KM_3477_2_SaffronSmile: 27044,
  KM_3478_2_CountrySun: 27045,
  KM_3479_3_SunflowerPetal: 27046,
  KM_348_D_Cyberspace: 27047,
  KM_3480_5_GoldenRay: 27048,
  KM_3481_1_CoconutCreamPie: 27049,
  KM_3482_1_YumaSand: 27050,
  KM_3483_1_SunnyDisposition: 27051,
  KM_3484_1_SeaOats: 27052,
  KM_3485_2_HoneyMustard: 27053,
  KM_3486_3_TheOutback: 27054,
  KM_3487_3_SlipIntoSunset: 27055,
  KM_3488_5_GoldenRattan: 27056,
  KM_3489_1_PaleIvory: 27057,
  KM_349_L_Iceman: 27058,
  KM_3490_1_FrenchSonnet: 27059,
  KM_3491_1_SunGlory: 27060,
  KM_3492_2_PalePollen: 27061,
  KM_3493_2_StarFire: 27062,
  KM_3494_3_SunshineYellow: 27063,
  KM_3495_3_BotanicaGold: 27064,
  KM_3496_5_GoldStrike: 27065,
  KM_3497_1_LynneAcres: 27066,
  KM_3498_1_Chiffon: 27067,
  KM_3499_1_AutumnValley: 27068,
  KM_35_M_FlyingHigh: 27069,
  KM_350_L_DelMar: 27070,
  KM_3500_1_CreamCustard: 27071,
  KM_3501_2_SunlitSand: 27072,
  KM_3502_2_TonsOfSun: 27073,
  KM_3503_3_SunlandPark: 27074,
  KM_3504_Y_Devonshire: 27075,
  KM_3505_1_EveningMoon: 27076,
  KM_3506_1_VanillaAlmond: 27077,
  KM_3507_1_FunInTheSun: 27078,
  KM_3508_1_SenegalSun: 27079,
  KM_3509_2_SouthernExposure: 27080,
  KM_351_L_Bayview: 27081,
  KM_3510_2_MayanMaize: 27082,
  KM_3511_3_Somerton: 27083,
  KM_3512_Y_DriedMustard: 27084,
  KM_3513_1_FireflyFlicker: 27085,
  KM_3514_1_LiquidLight: 27086,
  KM_3515_1_Sundrenched: 27087,
  KM_3516_1_GoldenAura: 27088,
  KM_3517_2_SolidGold: 27089,
  KM_3518_2_SkiValley: 27090,
  KM_3519_3_GoldenGirl: 27091,
  KM_352_M_CalmSea: 27092,
  KM_3520_5_IncaGold: 27093,
  KM_3521_1_LunarLuxury: 27094,
  KM_3522_1_SprinkledWithSummer: 27095,
  KM_3523_1_Polenta: 27096,
  KM_3524_1_Sommerset: 27097,
  KM_3525_2_HawaiianHoney: 27098,
  KM_3526_2_BurnishedSun: 27099,
  KM_3527_3_NinersGold: 27100,
  KM_3528_5_GoldenAutumn: 27101,
  KM_3529_1_WashedCanvas: 27102,
  KM_353_M_GoldenPond: 27103,
  KM_3530_1_ShreddedWheat: 27104,
  KM_3531_1_HomeAndHearth: 27105,
  KM_3532_1_NaturalRaffia: 27106,
  KM_3533_2_CreasedKhaki: 27107,
  KM_3534_2_SariSuit: 27108,
  KM_3535_3_SerengetiSong: 27109,
  KM_3536_5_FieldGear: 27110,
  KM_3537_1_IcedChai: 27111,
  KM_3538_1_TortillaChip: 27112,
  KM_3539_1_CleanCanvas: 27113,
  KM_354_D_Waterworld: 27114,
  KM_3540_1_SeaOfSand: 27115,
  KM_3541_2_HaciendaClay: 27116,
  KM_3542_2_WestWarwick: 27117,
  KM_3543_3_GreatGaucho: 27118,
  KM_3544_5_Chapultepec: 27119,
  KM_3545_1_ButteredUp: 27120,
  KM_3546_1_Cornmeal: 27121,
  KM_3547_1_TangerineTwist: 27122,
  KM_3548_1_BeeBalm: 27123,
  KM_3549_2_TiggersTail: 27124,
  KM_355_L_TicTacToe: 27125,
  KM_3550_2_BrightFires: 27126,
  KM_3551_3_Feisty: 27127,
  KM_3552_5_BrightLily: 27128,
  KM_3553_1_ApricotMousse: 27129,
  KM_3554_1_TinkerbellTrail: 27130,
  KM_3555_1_SparkleTint: 27131,
  KM_3556_1_FairyGlitter: 27132,
  KM_3557_2_Dreamsicle: 27133,
  KM_3558_3_OrangeSpark: 27134,
  KM_3559_3_FireflyGlow: 27135,
  KM_356_L_AqueousIllusion: 27136,
  KM_3560_5_FloridaOrange: 27137,
  KM_3561_1_VanillaView: 27138,
  KM_3562_1_Apricotta: 27139,
  KM_3563_1_Zahria: 27140,
  KM_3564_1_ElbertaPeaches: 27141,
  KM_3565_2_SummerSherbert: 27142,
  KM_3566_2_AutumnsCharm: 27143,
  KM_3567_3_PumpkinHarvest: 27144,
  KM_3568_5_MonarchWing: 27145,
  KM_3569_1_SoftShoulders: 27146,
  KM_357_L_HotSprings: 27147,
  KM_3570_1_RaveRachel: 27148,
  KM_3571_1_SuchAPeach: 27149,
  KM_3572_1_CoralBeach: 27150,
  KM_3573_2_LasVegasSunset: 27151,
  KM_3574_2_SevilleOrange: 27152,
  KM_3575_3_AutumnBeauty: 27153,
  KM_3576_5_MandarinGrove: 27154,
  KM_3577_1_ChristiCream: 27155,
  KM_3578_1_QuicheLorraine: 27156,
  KM_3579_1_ProudMary: 27157,
  KM_358_M_MelancholyBaby: 27158,
  KM_3580_1_Ariana: 27159,
  KM_3581_2_MirasolPaula: 27160,
  KM_3582_2_SweetMichelle: 27161,
  KM_3583_3_TangeloAnna: 27162,
  KM_3584_5_MoroOrange: 27163,
  KM_3585_1_MoonMaiden: 27164,
  KM_3586_1_CumberlandCream: 27165,
  KM_3587_1_MoonlightBeach: 27166,
  KM_3588_1_AmberMoon: 27167,
  KM_3589_2_BalticAmber: 27168,
  KM_359_M_Zealous: 27169,
  KM_3590_2_SirenaSun: 27170,
  KM_3591_3_AmberAutumn: 27171,
  KM_3592_5_BergamotOrange: 27172,
  KM_3593_1_VillaNor: 27173,
  KM_3594_1_SimplySunset: 27174,
  KM_3595_1_PeachRose: 27175,
  KM_3596_1_MelonSorbet: 27176,
  KM_3597_2_SweetPotato: 27177,
  KM_3598_2_CoralCanyon: 27178,
  KM_3599_3_AutumnSplendor: 27179,
  KM_36_D_AmazingFruit: 27180,
  KM_360_D_SeaIsland: 27181,
  KM_3600_5_BrightBittersweet: 27182,
  KM_3601_1_ThistleDown: 27183,
  KM_3602_1_PaleDawn: 27184,
  KM_3603_1_BashfulBeige: 27185,
  KM_3604_1_Dunhill: 27186,
  KM_3605_2_FawnFarrah: 27187,
  KM_3606_2_MoroccanSpice: 27188,
  KM_3607_3_CimarronTrail: 27189,
  KM_3608_5_DeepSpice: 27190,
  KM_3609_1_MilkShake: 27191,
  KM_361_L_IcyHaze: 27192,
  KM_3610_1_ToesInTheSand: 27193,
  KM_3611_1_PeachBeach: 27194,
  KM_3612_1_OrangeEssence: 27195,
  KM_3613_2_SunWarmedTile: 27196,
  KM_3614_2_BeachTreasure: 27197,
  KM_3615_3_TuscanTerracotta: 27198,
  KM_3616_5_SunbakedEarth: 27199,
  KM_3617_1_AfricanIvory: 27200,
  KM_3618_1_CoralCloud: 27201,
  KM_3619_1_AustralianApricot: 27202,
  KM_362_L_LakePlacid: 27203,
  KM_3620_1_SalmonRiver: 27204,
  KM_3621_2_CoralCoast: 27205,
  KM_3622_2_Chimenea: 27206,
  KM_3623_3_TimewornTerracotta: 27207,
  KM_3624_5_CopperMoon: 27208,
  KM_3625_1_PeachComplexion: 27209,
  KM_3626_1_PeachCashmere: 27210,
  KM_3627_1_Luminaria: 27211,
  KM_3628_1_TomatoBisque: 27212,
  KM_3629_2_OrangeNectar: 27213,
  KM_363_L_IceBoat: 27214,
  KM_3630_2_OrangeYouGlad: 27215,
  KM_3631_3_MathewsFire: 27216,
  KM_3632_5_HotShot: 27217,
  KM_3633_1_FirstLove: 27218,
  KM_3634_1_PathOfPetals: 27219,
  KM_3635_1_MusselShell: 27220,
  KM_3636_1_YoungGirl: 27221,
  KM_3637_2_ShadeOfShell: 27222,
  KM_3638_2_RosyCoral: 27223,
  KM_3639_3_CoralCove: 27224,
  KM_364_M_CrystalAqua: 27225,
  KM_3640_5_Persimmon: 27226,
  KM_3641_1_Flirty: 27227,
  KM_3642_1_SherryCream: 27228,
  KM_3643_1_RoseHips: 27229,
  KM_3644_1_DecoShell: 27230,
  KM_3645_2_PerfectTouch: 27231,
  KM_3646_2_AdonisGlow: 27232,
  KM_3647_3_AustralianCoral: 27233,
  KM_3648_5_CampfireBlaze: 27234,
  KM_3649_1_DevonDawn: 27235,
  KM_365_M_NorthernLights: 27236,
  KM_3650_1_Morningside: 27237,
  KM_3651_1_Bloomsbury: 27238,
  KM_3652_1_RosePoint: 27239,
  KM_3653_2_HerMajesty: 27240,
  KM_3654_2_BlossomPark: 27241,
  KM_3655_3_FancyNancy: 27242,
  KM_3656_5_GrandDuke: 27243,
  KM_3657_1_WillowCreek: 27244,
  KM_3658_1_MySweetheart: 27245,
  KM_3659_1_PinkPerfection: 27246,
  KM_366_D_Musio: 27247,
  KM_3660_1_SpringRose: 27248,
  KM_3661_2_PatientPink: 27249,
  KM_3662_2_PeacefulPrincess: 27250,
  KM_3663_3_GabrielsGift: 27251,
  KM_3664_5_SalsaDelSol: 27252,
  KM_3665_1_PalePerfection: 27253,
  KM_3666_1_PoufOfPink: 27254,
  KM_3667_1_DulceCrystal: 27255,
  KM_3668_1_DesertBloom: 27256,
  KM_3669_2_PinkCarnation: 27257,
  KM_367_L_HuronSky: 27258,
  KM_3670_2_SweetAmelia: 27259,
  KM_3671_3_MayFair: 27260,
  KM_3672_5_ScarletSumac: 27261,
  KM_3673_1_DubbleBubble: 27262,
  KM_3674_1_SweetMemories: 27263,
  KM_3675_1_Calique: 27264,
  KM_3676_1_BalletSlippers: 27265,
  KM_3677_2_ChelseaRose: 27266,
  KM_3678_2_WildHeather: 27267,
  KM_3679_3_LadyLove: 27268,
  KM_368_L_Airwave: 27269,
  KM_3680_5_RedBaron: 27270,
  KM_3681_1_WingedAngel: 27271,
  KM_3682_1_BethsSmile: 27272,
  KM_3683_1_FuzzySlippers: 27273,
  KM_3684_1_ChenilleSpread: 27274,
  KM_3685_2_ClimbingRose: 27275,
  KM_3686_2_PinkPosey: 27276,
  KM_3687_3_Pjs: 27277,
  KM_3688_5_PaintersRed: 27278,
  KM_3689_1_PalePetals: 27279,
  KM_369_L_BoundingMain: 27280,
  KM_3690_1_CrannyBerries: 27281,
  KM_3691_1_MinuteMauve: 27282,
  KM_3692_2_SpringCheer: 27283,
  KM_3693_2_VintageRose: 27284,
  KM_3694_3_MauveMedley: 27285,
  KM_3695_3_RoseQueen: 27286,
  KM_3696_5_PradoRed: 27287,
  KM_3697_1_BlushOfSpring: 27288,
  KM_3698_1_PrimroseCottage: 27289,
  KM_3699_1_BriarRose: 27290,
  KM_37_L_VelvetCream: 27291,
  KM_370_M_GulfShore: 27292,
  KM_3700_2_SweetHeart: 27293,
  KM_3701_2_WildScottishRose: 27294,
  KM_3702_3_Melita: 27295,
  KM_3703_3_WildBerry: 27296,
  KM_3704_5_FineWine: 27297,
  KM_3705_1_SweetIllusions: 27298,
  KM_3706_1_GoGirl: 27299,
  KM_3707_1_BlossomBeauty: 27300,
  KM_3708_1_PartyPink: 27301,
  KM_3709_2_SusansSmile: 27302,
  KM_371_M_BoulderCreek: 27303,
  KM_3710_2_RoseyBouquet: 27304,
  KM_3711_3_LipstickPink: 27305,
  KM_3712_5_JaysNewToy: 27306,
  KM_3713_1_PaleBlush: 27307,
  KM_3714_1_FirstDawn: 27308,
  KM_3715_1_RoseRhapsody: 27309,
  KM_3716_1_JosiesJoy: 27310,
  KM_3717_2_BuddingRose: 27311,
  KM_3718_2_KarensKiss: 27312,
  KM_3719_3_RichDesires: 27313,
  KM_372_D_Grandeur: 27314,
  KM_3720_5_Francesca: 27315,
  KM_3721_1_PinkIce: 27316,
  KM_3722_1_SweetRoses: 27317,
  KM_3723_1_BabyBlush: 27318,
  KM_3724_1_RoseCamilla: 27319,
  KM_3725_2_BabyYourself: 27320,
  KM_3726_2_EuphoricRose: 27321,
  KM_3727_3_Raisa: 27322,
  KM_3728_5_ItsTheBerries: 27323,
  KM_3729_1_PrettiestPale: 27324,
  KM_373_L_Seasprite: 27325,
  KM_3730_1_Sheridan: 27326,
  KM_3731_1_SmidgenOfCloud: 27327,
  KM_3732_1_RosesInTheSnow: 27328,
  KM_3733_2_HeirloomRose: 27329,
  KM_3734_3_Cosmopolitan: 27330,
  KM_3735_3_TheMarquis: 27331,
  KM_3736_5_FineBurgundy: 27332,
  KM_3737_1_RosyView: 27333,
  KM_3738_1_SpringPetals: 27334,
  KM_3739_1_CabbageRose: 27335,
  KM_374_L_WaterSlide: 27336,
  KM_3740_1_Rosarian: 27337,
  KM_3741_2_FrenchRose: 27338,
  KM_3742_2_AutumnSedum: 27339,
  KM_3743_3_EarthFiredRed: 27340,
  KM_3744_5_CountryCranberry: 27341,
  KM_3745_1_DaybreakMood: 27342,
  KM_3746_1_SweetAndSassy: 27343,
  KM_3747_1_PinkPeace: 27344,
  KM_3748_2_LightRosa: 27345,
  KM_3749_2_LadyLike: 27346,
  KM_375_L_Azurean: 27347,
  KM_3750_3_BeguilingBlossom: 27348,
  KM_3751_3_OrchardPlum: 27349,
  KM_3752_5_SoMerd1lot: 27350,
  KM_3753_1_MagicalMourn: 27351,
  KM_3754_1_PlacidPink: 27352,
  KM_3755_1_PrettyPrincess: 27353,
  KM_3756_2_Michelle: 27354,
  KM_3757_2_LidaRose: 27355,
  KM_3758_3_Rosabella: 27356,
  KM_3759_3_LadyCarlyle: 27357,
  KM_376_M_PaleAquamarine: 27358,
  KM_3760_5_Eggplant: 27359,
  KM_3761_1_GrapeExpectations: 27360,
  KM_3762_1_PlumProud: 27361,
  KM_3763_1_Adina: 27362,
  KM_3764_2_RomanticLight: 27363,
  KM_3765_2_HeatherRidge: 27364,
  KM_3766_3_LavenderRose: 27365,
  KM_3767_3_PlumIsland: 27366,
  KM_3768_5_DarkBerry: 27367,
  KM_3769_1_Calcium: 27368,
  KM_377_M_Penelope: 27369,
  KM_3770_1_SweetMusette: 27370,
  KM_3771_1_Pashmina: 27371,
  KM_3772_2_HeatherHarmony: 27372,
  KM_3773_2_Girgitta: 27373,
  KM_3774_3_LastLight: 27374,
  KM_3775_3_Zuli: 27375,
  KM_3776_5_Balsamic: 27376,
  KM_3777_1_BillowingClouds: 27377,
  KM_3778_1_TuleFog: 27378,
  KM_3779_1_ParlorGames: 27379,
  KM_378_D_AquaPool: 27380,
  KM_3780_2_SterlingWater: 27381,
  KM_3781_2_NovemberRain: 27382,
  KM_3782_3_GrayWhaleCove: 27383,
  KM_3783_3_FiveOclockShadow: 27384,
  KM_3784_5_InTheDark: 27385,
  KM_3785_1_Drizzle: 27386,
  KM_3786_1_HeirloomSilver: 27387,
  KM_3787_1_WhereThereIsSmoke: 27388,
  KM_3788_1_DolphinDance: 27389,
  KM_3789_2_MaddysMood: 27390,
  KM_379_L_GreenIsle: 27391,
  KM_3790_3_MadeInTheShade: 27392,
  KM_3791_3_SmokeyHearth: 27393,
  KM_3792_5_KittyKitty: 27394,
  KM_3793_1_DimSum: 27395,
  KM_3794_1_Moonah: 27396,
  KM_3795_1_BaliBlue: 27397,
  KM_3796_2_WallStreetBlues: 27398,
  KM_3797_2_Mirador: 27399,
  KM_3798_3_RomanticMood: 27400,
  KM_3799_3_BlueLake: 27401,
  KM_38_L_TexasFlame: 27402,
  KM_380_L_QueensWay: 27403,
  KM_3800_5_TheEdge: 27404,
  KM_3801_1_SnippetOfBlue: 27405,
  KM_3802_1_ClearToSee: 27406,
  KM_3803_1_SkysTheLimit: 27407,
  KM_3804_1_GrandBay: 27408,
  KM_3805_2_CubicleBlues: 27409,
  KM_3806_2_Federalist: 27410,
  KM_3807_3_TheBlues: 27411,
  KM_3808_5_BaffinIslandNight: 27412,
  KM_3809_1_GrayRock: 27413,
  KM_381_L_Tabu: 27414,
  KM_3810_1_GreyMare: 27415,
  KM_3811_1_RaiderNation: 27416,
  KM_3812_2_ColdSteel: 27417,
  KM_3813_2_CastleRock: 27418,
  KM_3814_3_FrenchQuarter: 27419,
  KM_3815_3_CharcoalShadow: 27420,
  KM_3816_5_ContessasCape: 27421,
  KM_3817_1_SnowflakeConfetti: 27422,
  KM_3818_1_IceAge: 27423,
  KM_3819_1_SilverQueen: 27424,
  KM_382_M_GreenEverlasting: 27425,
  KM_3820_1_PlatinumPlate: 27426,
  KM_3821_2_DiamondHeights: 27427,
  KM_3822_3_CastInStone: 27428,
  KM_3823_3_DarkShadows: 27429,
  KM_3824_5_CarbonCopy: 27430,
  KM_3825_1_WhisperingSmoke: 27431,
  KM_3826_1_PatchyFog: 27432,
  KM_3827_1_NickelBack: 27433,
  KM_3828_2_Survivor: 27434,
  KM_3829_2_GreyMatters: 27435,
  KM_383_M_GreenPip: 27436,
  KM_3830_3_IronMountain: 27437,
  KM_3831_3_KnappedFlint: 27438,
  KM_3832_5_OpeningNight: 27439,
  KM_3833_1_FirstFrost: 27440,
  KM_3834_1_GreyMist: 27441,
  KM_3835_1_DotCom: 27442,
  KM_3836_2_RawSteel: 27443,
  KM_3837_2_GothicGrey: 27444,
  KM_3838_3_RomanStone: 27445,
  KM_3839_3_Shoreline: 27446,
  KM_384_D_FarEast: 27447,
  KM_3840_5_Shreveport: 27448,
  KM_3841_1_WinterGarden: 27449,
  KM_3842_1_BurbankAura: 27450,
  KM_3843_1_HiHoSilver: 27451,
  KM_3844_2_Beachcomber: 27452,
  KM_3845_2_SlipperyShale: 27453,
  KM_3846_3_BurnishedPewter: 27454,
  KM_3847_3_Castlemare: 27455,
  KM_3848_5_DarkMoon: 27456,
  KM_3849_1_WhisperingWaterfall: 27457,
  KM_385_L_GreenSpark: 27458,
  KM_3850_1_DancingBubbles: 27459,
  KM_3851_1_QuietCove: 27460,
  KM_3852_2_Constance: 27461,
  KM_3853_2_PoolsOfBlue: 27462,
  KM_3854_3_GidgetsSecret: 27463,
  KM_3855_3_CantonJade: 27464,
  KM_3856_5_MoonlessSky: 27465,
  KM_3857_1_WaterSpirit: 27466,
  KM_3858_1_OceanCliffs: 27467,
  KM_3859_1_MistyHarbor: 27468,
  KM_386_L_FrostyMeadow: 27469,
  KM_3860_1_SeaDreams: 27470,
  KM_3861_2_MysticLake: 27471,
  KM_3862_2_ForestFalls: 27472,
  KM_3863_3_JilleneGreen: 27473,
  KM_3864_5_CapeRoyal: 27474,
  KM_3865_1_Fennel: 27475,
  KM_3866_1_Colcannon: 27476,
  KM_3867_1_GlassHouse: 27477,
  KM_3868_2_ArtfulGreen: 27478,
  KM_3869_2_PaytonsCar: 27479,
  KM_387_L_DaiquiriSky: 27480,
  KM_3870_3_LongViewGarden: 27481,
  KM_3871_3_MountainPine: 27482,
  KM_3872_5_SpinachDipped: 27483,
  KM_3873_1_SpinneyMountain: 27484,
  KM_3874_1_TudorGrove: 27485,
  KM_3875_1_Cellulose: 27486,
  KM_3876_2_WhenTwilightFalls: 27487,
  KM_3877_2_GreenSilence: 27488,
  KM_3878_3_MaineMist: 27489,
  KM_3879_3_SpruceSpring: 27490,
  KM_388_M_JamaicanMist: 27491,
  KM_3880_5_GladeCreek: 27492,
  KM_3881_1_Ridgefield: 27493,
  KM_3882_1_WildGrass: 27494,
  KM_3883_1_ManzanitaLeaf: 27495,
  KM_3884_2_HiddenRavine: 27496,
  KM_3885_2_Fern: 27497,
  KM_3886_3_ColfaxPine: 27498,
  KM_3887_3_GlenIvy: 27499,
  KM_3888_5_IrishMoss: 27500,
  KM_3889_1_SageTinged: 27501,
  KM_389_M_Vinci: 27502,
  KM_3890_1_VintageFind: 27503,
  KM_3891_1_Portage: 27504,
  KM_3892_2_SongOfNature: 27505,
  KM_3893_2_Pineview: 27506,
  KM_3894_2_Grasslands: 27507,
  KM_3895_3_SpringsEve: 27508,
  KM_3896_5_Clearfield: 27509,
  KM_3897_1_GlacierValley: 27510,
  KM_3898_1_MysticalMist: 27511,
  KM_3899_1_WaterMagic: 27512,
  KM_39_L_ArielaMist: 27513,
  KM_390_D_EmeraldRibbon: 27514,
  KM_3900_2_DreamWeaver: 27515,
  KM_3901_2_WoodlandWaterfall: 27516,
  KM_3902_3_PortAlice: 27517,
  KM_3903_3_GreenDusk: 27518,
  KM_3904_5_LadiesNight: 27519,
  KM_3905_1_HydePark: 27520,
  KM_3906_1_FraserLake: 27521,
  KM_3907_1_Foresta: 27522,
  KM_3908_2_LambsEar: 27523,
  KM_3909_2_SilverMound: 27524,
  KM_391_L_BayouMist: 27525,
  KM_3910_3_BuchartGardens: 27526,
  KM_3911_3_OldGrowthForest: 27527,
  KM_3912_5_EvergreenTrail: 27528,
  KM_3913_1_GlacierRidge: 27529,
  KM_3914_1_WishingStar: 27530,
  KM_3915_1_Dillard: 27531,
  KM_3916_2_MarbleQuarry: 27532,
  KM_3917_2_RockWall: 27533,
  KM_3918_2_FrenchClay: 27534,
  KM_3919_3_Hampstead: 27535,
  KM_392_L_TidalBreeze: 27536,
  KM_3920_5_FortuneLeaves: 27537,
  KM_3921_1_Columbia: 27538,
  KM_3922_1_PortlandWhitbed: 27539,
  KM_3923_1_Seattle: 27540,
  KM_3924_2_Ashford: 27541,
  KM_3925_2_MartiniShaker: 27542,
  KM_3926_3_Topiary: 27543,
  KM_3927_3_RockOfAges: 27544,
  KM_3928_5_HazelsCoat: 27545,
  KM_3929_1_Couscous: 27546,
  KM_393_L_GulfBreeze: 27547,
  KM_3930_1_SilverPlume: 27548,
  KM_3931_1_WeatheredWhite: 27549,
  KM_3932_2_Zanzibar: 27550,
  KM_3933_2_GraniteCliff: 27551,
  KM_3934_3_HidcoteManor: 27552,
  KM_3935_3_CastleDale: 27553,
  KM_3936_5_PilotRock: 27554,
  KM_3937_1_UnbleachedWood: 27555,
  KM_3938_1_TravertineTrail: 27556,
  KM_3939_1_TumbledStone: 27557,
  KM_394_M_Galaxia: 27558,
  KM_3940_1_Jute: 27559,
  KM_3941_2_CorkBark: 27560,
  KM_3942_2_TropicalTan: 27561,
  KM_3943_3_CremeDeCaramel: 27562,
  KM_3944_5_MochaMousse: 27563,
  KM_3945_1_WildOaks: 27564,
  KM_3946_1_DesertPalm: 27565,
  KM_3947_1_ThatchReed: 27566,
  KM_3948_2_MeadowBrook: 27567,
  KM_3949_2_CedarShingle: 27568,
  KM_395_M_FlorentinoGreen: 27569,
  KM_3950_3_Rockvale: 27570,
  KM_3951_3_CarltonClay: 27571,
  KM_3952_5_StoneWall: 27572,
  KM_3953_1_RiceStraw: 27573,
  KM_3954_1_SierraSnow: 27574,
  KM_3955_1_SandDune: 27575,
  KM_3956_1_Apollodorous: 27576,
  KM_3957_2_GlenAbbey: 27577,
  KM_3958_3_Greyswood: 27578,
  KM_3959_3_FairFieldstone: 27579,
  KM_396_D_Sprucetone: 27580,
  KM_3960_5_Clubhouse: 27581,
  KM_3961_1_PaleFace: 27582,
  KM_3962_1_CreamyNatural: 27583,
  KM_3963_1_SandCastle: 27584,
  KM_3964_1_BeachBum: 27585,
  KM_3965_2_HeadForTheBeach: 27586,
  KM_3966_3_SandalwoodTan: 27587,
  KM_3967_3_ManchesterMood: 27588,
  KM_3968_5_WovenWillow: 27589,
  KM_3969_1_Campiello: 27590,
  KM_397_L_Torrence: 27591,
  KM_3970_1_MeadowDay: 27592,
  KM_3971_1_BleachedBurl: 27593,
  KM_3972_2_EarthStone: 27594,
  KM_3973_2_WestoverHills: 27595,
  KM_3974_3_HighlandGrass: 27596,
  KM_3975_3_AfricanPlain: 27597,
  KM_3976_5_OliveGrove: 27598,
  KM_3977_1_DoverTint: 27599,
  KM_3978_1_BarelyDawn: 27600,
  KM_3979_1_DustryTrail: 27601,
  KM_398_L_PalmSprings: 27602,
  KM_3980_2_WesternWear: 27603,
  KM_3981_2_HappyCamper: 27604,
  KM_3982_3_BarefootBeach: 27605,
  KM_3983_3_Sandhurst: 27606,
  KM_3984_5_BrownMountain: 27607,
  KM_3985_1_CottageWhite: 27608,
  KM_3986_1_CottonLace: 27609,
  KM_3987_1_TropicalStraw: 27610,
  KM_3988_2_PalePortabella: 27611,
  KM_3989_2_SerengetiSafari: 27612,
  KM_399_L_BethelIsland: 27613,
  KM_3990_3_SoftMoccasin: 27614,
  KM_3991_3_Woodriff: 27615,
  KM_3992_5_CozyCabin: 27616,
  KM_3993_1_CloudOfCream: 27617,
  KM_3994_1_AgedParchment: 27618,
  KM_3995_1_SkinLight: 27619,
  KM_3996_2_Ferncliffe: 27620,
  KM_3997_2_BalsamBrown: 27621,
  KM_3998_3_SheerExposure: 27622,
  KM_3999_3_FlaxSeed: 27623,
  KM_4_M_JazzyYellow: 27624,
  KM_40_M_HybridFlower: 27625,
  KM_400_M_ParadiseCity: 27626,
  KM_4000_5_GoldenMist: 27627,
  KM_4001_1_GlazedGinger: 27628,
  KM_4002_1_LimestoneRidge: 27629,
  KM_4003_1_SimplyTan: 27630,
  KM_4004_2_StarOfTheGarden: 27631,
  KM_4005_2_VictorianGold: 27632,
  KM_4006_3_GoldPromise: 27633,
  KM_4007_3_MexicanHills: 27634,
  KM_4008_5_RoyalCrown: 27635,
  KM_4009_1_SanPedro: 27636,
  KM_401_M_Verdant: 27637,
  KM_4010_1_StilwellBeige: 27638,
  KM_4011_1_TimothyTan: 27639,
  KM_4012_2_WashedKhaki: 27640,
  KM_4013_2_BernardBeach: 27641,
  KM_4014_3_TumbleTan: 27642,
  KM_4015_3_CaramelMountain: 27643,
  KM_4016_5_CarmelCandy: 27644,
  KM_4017_1_WhisperOfWhite: 27645,
  KM_4018_1_TenderTan: 27646,
  KM_4019_1_HeritageHills: 27647,
  KM_402_D_DeepJungle: 27648,
  KM_4020_1_PalominoPony: 27649,
  KM_4021_2_SwissCream: 27650,
  KM_4022_2_CushySuede: 27651,
  KM_4023_3_DigIt: 27652,
  KM_4024_5_LattePlease: 27653,
  KM_4025_1_Navarro: 27654,
  KM_4026_1_Julesberg: 27655,
  KM_4027_1_PalaceHill: 27656,
  KM_4028_1_LegatoLane: 27657,
  KM_4029_2_RabbitWarren: 27658,
  KM_403_L_DinnerMint: 27659,
  KM_4030_2_SupremeBean: 27660,
  KM_4031_3_AfricanDesert: 27661,
  KM_4032_5_FallenLeaf: 27662,
  KM_4033_1_SantaFeCream: 27663,
  KM_4034_1_DuneWalk: 27664,
  KM_4035_1_ReginaBeach: 27665,
  KM_4036_2_TuscanTan: 27666,
  KM_4037_2_EarthyTan: 27667,
  KM_4038_3_RusticCharm: 27668,
  KM_4039_3_WildwoodBay: 27669,
  KM_404_L_TeteATete: 27670,
  KM_4040_5_PineconePath: 27671,
  KM_4041_1_BareBone: 27672,
  KM_4042_1_BakedBiscuit: 27673,
  KM_4043_1_Sandunia: 27674,
  KM_4044_2_SoftBuckskin: 27675,
  KM_4045_2_CountryLife: 27676,
  KM_4046_3_Benetello: 27677,
  KM_4047_3_BurnishedCaramel: 27678,
  KM_4048_5_Mochaccino: 27679,
  KM_4049_1_BareEssential: 27680,
  KM_405_L_Verdun: 27681,
  KM_4050_1_FairIvory: 27682,
  KM_4051_1_BigOnBeige: 27683,
  KM_4052_2_Derbyshire: 27684,
  KM_4053_2_SandysShores: 27685,
  KM_4054_3_CarmelValley: 27686,
  KM_4055_3_MapleSugar: 27687,
  KM_4056_5_WesternPursuit: 27688,
  KM_4057_1_CrystalBeach: 27689,
  KM_4058_1_BeachWalk: 27690,
  KM_4059_1_TaffySurprise: 27691,
  KM_406_M_MarineGlow: 27692,
  KM_4060_1_Beachville: 27693,
  KM_4061_2_FreshSawdust: 27694,
  KM_4062_2_VizcainoDesert: 27695,
  KM_4063_3_ChamoisShirt: 27696,
  KM_4064_5_WarriorKing: 27697,
  KM_4065_1_Moongaze: 27698,
  KM_4066_1_SunwashedBeach: 27699,
  KM_4067_1_FaceOfInnocence: 27700,
  KM_4068_2_BeautyAndTheBeach: 27701,
  KM_4069_2_SouthwestSand: 27702,
  KM_407_Carbon: 2031,
  KM_407_M_ShrubberyGreen: 27703,
  KM_4070_3_BrightonBeach: 27704,
  KM_4071_3_TerrificTan: 27705,
  KM_4072_5_SoulOfTheEarth: 27706,
  KM_4073_1_Mariah: 27707,
  KM_4074_1_TangierTan: 27708,
  KM_4075_1_DougsDale: 27709,
  KM_4076_1_AncientInca: 27710,
  KM_4077_2_Copperfield: 27711,
  KM_4078_2_SpiceIsland: 27712,
  KM_4079_3_RusticHills: 27713,
  KM_408_D_JadeMist: 27714,
  KM_4080_5_TruffleTrouble: 27715,
  KM_4081_1_Kensington: 27716,
  KM_4082_1_InTheBuff: 27717,
  KM_4083_1_WasagaBeach: 27718,
  KM_4084_2_SunbakedClay: 27719,
  KM_4085_2_RusticPottery: 27720,
  KM_4086_3_CopperCoast: 27721,
  KM_4087_3_FoxWood: 27722,
  KM_4088_5_OldBrick: 27723,
  KM_4089_1_AbbeyLane: 27724,
  KM_409_L_Everfrost: 27725,
  KM_4090_1_FreshAir: 27726,
  KM_4091_1_StoneyCreek: 27727,
  KM_4092_1_TimberRidge: 27728,
  KM_4093_2_RockyCliff: 27729,
  KM_4094_2_PrairieIsland: 27730,
  KM_4095_3_PottersClay: 27731,
  KM_4096_5_MajesticRidge: 27732,
  KM_4097_1_BleachedIvory: 27733,
  KM_4098_1_AlmondKiss: 27734,
  KM_4099_1_Parma: 27735,
  KM_41_M_AlZulfa: 27736,
  KM_410_L_Tayla: 27737,
  KM_4100_1_WarmSands: 27738,
  KM_4101_2_TopazTease: 27739,
  KM_4102_3_PointSienna: 27740,
  KM_4103_3_SouthwestSpirit: 27741,
  KM_4104_5_RedOchre: 27742,
  KM_4105_1_BeigeBluff: 27743,
  KM_4106_1_BeachBound: 27744,
  KM_4107_1_Sandstorm: 27745,
  KM_4108_2_StreamStone: 27746,
  KM_4109_2_ReubenRidge: 27747,
  KM_411_L_AlmostAqua: 27748,
  KM_4110_3_PalePalamino: 27749,
  KM_4111_3_MochaJava: 27750,
  KM_4112_5_BistroBrown: 27751,
  KM_4113_1_TurkishTowel: 27752,
  KM_4114_1_PaleStarlet: 27753,
  KM_4115_1_Roanoke: 27754,
  KM_4116_1_DancingDeer: 27755,
  KM_4117_2_OpenRoad: 27756,
  KM_4118_3_MochaCafe: 27757,
  KM_4119_3_LightRoast: 27758,
  KM_412_M_GenieBoy: 27759,
  KM_4120_5_BananaLeaf: 27760,
  KM_4121_1_Castleford: 27761,
  KM_4122_1_RogueBluff: 27762,
  KM_4123_1_CoralBells: 27763,
  KM_4124_1_TuscanTrail: 27764,
  KM_4125_2_CinnamonRose: 27765,
  KM_4126_2_GingerJar: 27766,
  KM_4127_3_VegasRedrock: 27767,
  KM_4128_5_AutumnsBronze: 27768,
  KM_4129_1_SoftSunrise: 27769,
  KM_413_M_Barbados: 27770,
  KM_4130_1_MohicanMist: 27771,
  KM_4131_1_ChambordCharm: 27772,
  KM_4132_1_Demetrio: 27773,
  KM_4133_2_TarynHills: 27774,
  KM_4134_2_RoshenRidge: 27775,
  KM_4135_3_ChocolateCherry: 27776,
  KM_4136_5_Bougainvillea: 27777,
  KM_4137_1_Romantique: 27778,
  KM_4138_1_PreludeToPink: 27779,
  KM_4139_1_ThinkAboutIt: 27780,
  KM_414_D_Whitney: 27781,
  KM_4140_1_Giggles: 27782,
  KM_4141_2_PamperedPink: 27783,
  KM_4142_2_DariusDawn: 27784,
  KM_4143_3_SpringBliss: 27785,
  KM_4144_5_CheerfulCherry: 27786,
  KM_4145_1_ArcticLights: 27787,
  KM_4147_1_SpringSprig: 27788,
  KM_4148_1_Laureate: 27789,
  KM_4149_2_NoahsArk: 27790,
  KM_415_L_OceanWaltz: 27791,
  KM_4150_2_RoseAntiqua: 27792,
  KM_4151_3_RoseyGlow: 27793,
  KM_4152_5_VeryBerry: 27794,
  KM_4153_1_PomPom: 27795,
  KM_4154_1_Easterville: 27796,
  KM_4155_1_AndreasAnticipation: 27797,
  KM_4156_1_ShrubRose: 27798,
  KM_4157_2_CosmosKiss: 27799,
  KM_4158_2_MerryMeredith: 27800,
  KM_4159_3_MiAmor: 27801,
  KM_416_L_CucumberSauce: 27802,
  KM_4160_5_Radicchio: 27803,
  KM_4161_1_SoothingSpring: 27804,
  KM_4162_1_Natalia: 27805,
  KM_4163_1_MauveStar: 27806,
  KM_4164_1_ToastedRose: 27807,
  KM_4165_2_Luberon: 27808,
  KM_4166_2_RaveRaisin: 27809,
  KM_4167_3_PowderhornManor: 27810,
  KM_4168_5_CaffeBistro: 27811,
  KM_4169_1_MiguelAngel: 27812,
  KM_417_L_MythicGreen: 27813,
  KM_417_OxfordBrown: 2032,
  KM_4170_1_Avorio: 27814,
  KM_4171_1_Castellina: 27815,
  KM_4172_2_GypsumGap: 27816,
  KM_4173_2_MuffinMix: 27817,
  KM_4174_3_ToastedTaupe: 27818,
  KM_4175_3_MohawkValley: 27819,
  KM_4176_5_Wrightsford: 27820,
  KM_4177_1_Haverstraw: 27821,
  KM_4178_1_ChapelleTint: 27822,
  KM_4179_1_Tortilla: 27823,
  KM_418_M_SpriteGreen: 27824,
  KM_4180_2_BrittanyBeige: 27825,
  KM_4181_2_UnderCover: 27826,
  KM_4182_3_LescamelaVanilla: 27827,
  KM_4183_3_GingerbreadMan: 27828,
  KM_4184_5_FriarsCloak: 27829,
  KM_4185_1_NewZealandWool: 27830,
  KM_4186_1_Bohemian: 27831,
  KM_4187_1_BeigeRage: 27832,
  KM_4188_2_NevadaPeak: 27833,
  KM_4189_2_SteppingStone: 27834,
  KM_419_M_CelticGreen: 27835,
  KM_4190_3_Mocha: 27836,
  KM_4191_3_BrownTown: 27837,
  KM_4192_5_RawEarth: 27838,
  KM_4193_1_SouthernSand: 27839,
  KM_4194_1_CantonCotton: 27840,
  KM_4195_1_WalnutCream: 27841,
  KM_4196_1_BeachParty: 27842,
  KM_4197_2_Ashbury: 27843,
  KM_4198_2_AntiguaRose: 27844,
  KM_4199_3_CameroonBay: 27845,
  KM_42_D_CaliforniaSunset: 27846,
  KM_420_D_ValleDeLoire: 27847,
  KM_4200_5_CranberryCraze: 27848,
  KM_421_L_HintOfSpring: 27849,
  KM_422_L_SerenitySprings: 27850,
  KM_423_L_EgyptianSplendor: 27851,
  KM_424_M_Mchenry: 27852,
  KM_425_M_Villandry: 27853,
  KM_426_D_AcadiaForest: 27854,
  KM_427_L_MermaidMist: 27855,
  KM_428_L_AugustDew: 27856,
  KM_429_L_SheerBeauty: 27857,
  KM_43_L_OrangeShake: 27858,
  KM_430_M_LoroCountry: 27859,
  KM_431_M_LoireValley: 27860,
  KM_432_D_LushGreen: 27861,
  KM_433_L_SpringThaw: 27862,
  KM_434_L_GreenSheen: 27863,
  KM_435_L_WhiteMint: 27864,
  KM_436_M_SanGabriel: 27865,
  KM_437_M_Calaveras: 27866,
  KM_438_D_Frogmore: 27867,
  KM_439_L_Limeside: 27868,
  KM_44_L_Caliope: 27869,
  KM_440_L_Gallery: 27870,
  KM_4401_1_PetalDust: 27871,
  KM_4402_1_DesertMesa: 27872,
  KM_4403_1_CopperBlush: 27873,
  KM_4404_2_NorthRim: 27874,
  KM_4405_3_AfricanBubinga: 27875,
  KM_4406_3_MyrtlePepper: 27876,
  KM_4407_5_VintageCopper: 27877,
  KM_4408_1_PinkScallop: 27878,
  KM_4409_1_Cupid: 27879,
  KM_441_L_Absinthe: 27880,
  KM_4410_1_CalicoRose: 27881,
  KM_4411_1_MontezumasCastle: 27882,
  KM_4412_2_PersianBazaar: 27883,
  KM_4413_3_JsBigHeart: 27884,
  KM_4414_5_ArmadilloEgg: 27885,
  KM_4415_1_IndianClay: 27886,
  KM_4416_1_FallLeaf: 27887,
  KM_4417_2_IndianMesa: 27888,
  KM_4418_2_BlackHillsGold: 27889,
  KM_4419_3_Clovedust: 27890,
  KM_442_M_Citronelle: 27891,
  KM_4420_3_DeerTracks: 27892,
  KM_4421_5_Brickhouse: 27893,
  KM_4422_1_GrandmasCameo: 27894,
  KM_4423_1_FluffyPink: 27895,
  KM_4424_1_BallerinaBag: 27896,
  KM_4425_2_CoralGarden: 27897,
  KM_4426_3_GingerPeach: 27898,
  KM_4427_5_RudrakshaBeads: 27899,
  KM_4428_5_KilaueaLava: 27900,
  KM_4429_1_PinkSachet: 27901,
  KM_443_M_AgouraHills: 27902,
  KM_4430_2_KeelJoy: 27903,
  KM_4431_3_GypsyDancer: 27904,
  KM_4432_3_LastingImpression: 27905,
  KM_4433_3_TuscanClay: 27906,
  KM_4434_5_BindiDot: 27907,
  KM_4435_5_WarmWelcome: 27908,
  KM_4436_1_TouchOfBlush: 27909,
  KM_4437_1_RoseColoredGlasses: 27910,
  KM_4438_2_CherryTree: 27911,
  KM_4439_2_DesertSpice: 27912,
  KM_444_D_SharpGreen: 27913,
  KM_4440_2_BashfulRose: 27914,
  KM_4441_3_CedarRidge: 27915,
  KM_4442_5_TexasSweetTea: 27916,
  KM_4443_1_PinkPetal: 27917,
  KM_4444_1_GirlTalk: 27918,
  KM_4445_1_MysticMauve: 27919,
  KM_4446_2_BeautySecret: 27920,
  KM_4447_2_ShabbyChic: 27921,
  KM_4448_3_VelveteenCrush: 27922,
  KM_4449_5_WineCellar: 27923,
  KM_445_L_LightNile: 27924,
  KM_4450_1_FrenchBustle: 27925,
  KM_4451_1_RoseBud: 27926,
  KM_4452_1_PuppyLove: 27927,
  KM_4453_2_YoungAtHeart: 27928,
  KM_4454_2_StrawberryJubilee: 27929,
  KM_4455_3_AlmondBlossom: 27930,
  KM_4456_5_BoldSangria: 27931,
  KM_4457_1_WindRose: 27932,
  KM_4458_2_FoxyLady: 27933,
  KM_4459_2_DogwoodBloom: 27934,
  KM_446_L_SpringBurst: 27935,
  KM_4460_3_PomegranateTea: 27936,
  KM_4461_3_PizzaPie: 27937,
  KM_4462_5_TibetanTemple: 27938,
  KM_4463_5_AntiqueRosewood: 27939,
  KM_4464_1_BarePink: 27940,
  KM_4465_1_CameoAppearance: 27941,
  KM_4466_2_ItsYourMauve: 27942,
  KM_4467_5_LoversKnot: 27943,
  KM_4468_3_AutumnBloom: 27944,
  KM_4469_5_Kimono: 27945,
  KM_447_L_LightFern: 27946,
  KM_4470_5_WalnutGrove: 27947,
  KM_4471_1_StrawberryGlaze: 27948,
  KM_4472_1_FreshPinkLemonade: 27949,
  KM_4473_2_RoseyMauve: 27950,
  KM_4474_3_SilkenRaspberry: 27951,
  KM_4475_3_CherryCocoa: 27952,
  KM_4476_5_BerryBush: 27953,
  KM_4477_5_ChilledWine: 27954,
  KM_4478_1_OhSoPretty: 27955,
  KM_4479_1_HeartsContent: 27956,
  KM_448_M_SpringTide: 27957,
  KM_4480_2_WhisperOfRose: 27958,
  KM_4481_2_Fireweed: 27959,
  KM_4482_3_NouveauRose: 27960,
  KM_4483_5_CabernetCraving: 27961,
  KM_4484_5_DeepGarnet: 27962,
  KM_4485_1_VaVaBloom: 27963,
  KM_4486_1_BalconyRose: 27964,
  KM_4487_2_FallCanyon: 27965,
  KM_4488_3_WarmWassail: 27966,
  KM_4489_5_PearBlush: 27967,
  KM_449_M_Greenland: 27968,
  KM_4490_5_CountrySleigh: 27969,
  KM_4491_5_AgedTeak: 27970,
  KM_4492_1_DallasDust: 27971,
  KM_4493_1_AncientRuins: 27972,
  KM_4494_1_CrackerCrumbs: 27973,
  KM_4495_2_CocoaMocha: 27974,
  KM_4496_3_SouthRimTrail: 27975,
  KM_4497_3_BabyBurro: 27976,
  KM_4498_5_DancingDogs: 27977,
  KM_4499_1_CrazyHorseMountain: 27978,
  KM_45_L_Creamsicle: 27979,
  KM_450_D_AppleHarvest: 27980,
  KM_4500_1_CountryCottage: 27981,
  KM_4501_2_BigHornMountains: 27982,
  KM_4502_3_EarthBound: 27983,
  KM_4503_3_BuffaloSoldier: 27984,
  KM_4504_3_ChocoLoco: 27985,
  KM_4505_5_ThaiTeak: 27986,
  KM_4506_1_CurlyMaple: 27987,
  KM_4507_1_OspreyNest: 27988,
  KM_4508_2_CupOfTea: 27989,
  KM_4509_3_SnowLodge: 27990,
  KM_451_L_GreenAspen: 27991,
  KM_4510_3_BearHug: 27992,
  KM_4511_5_DarkTavern: 27993,
  KM_4512_5_Americano: 27994,
  KM_4513_1_ToastedMarshmallow: 27995,
  KM_4514_1_WoollyBeige: 27996,
  KM_4515_1_CorkscrewWillow: 27997,
  KM_4516_2_ArrowQuiver: 27998,
  KM_4517_3_CoyoteTracks: 27999,
  KM_4518_3_WildCattail: 28000,
  KM_4519_5_TurkishCoffee: 28001,
  KM_452_L_FadedMoss: 28002,
  KM_4520_1_BelgianWaffle: 28003,
  KM_4521_1_GeyserBasin: 28004,
  KM_4522_1_AdobeBeige: 28005,
  KM_4523_2_LabyrinthWalk: 28006,
  KM_4524_3_MangyMoose: 28007,
  KM_4525_3_Ayrshire: 28008,
  KM_4526_5_CoffeeBar: 28009,
  KM_4527_1_ToastedOatmeal: 28010,
  KM_4528_1_GinsengRoot: 28011,
  KM_4529_1_BrownBagIt: 28012,
  KM_453_L_Chives: 28013,
  KM_4530_2_FriendlyHomestead: 28014,
  KM_4531_3_CantankerousCoyote: 28015,
  KM_4532_3_CowGirlBoots: 28016,
  KM_4533_5_LeatherBound: 28017,
  KM_4534_1_SpunJute: 28018,
  KM_4535_1_WarmCroissant: 28019,
  KM_4536_1_CuriousChipmunk: 28020,
  KM_4537_2_WovenNavajo: 28021,
  KM_4538_3_PaintedPony: 28022,
  KM_4539_5_CigarBox: 28023,
  KM_454_M_EveningPicnic: 28024,
  KM_4540_5_VaqueroBoots: 28025,
  KM_4541_1_ScrolledParchment: 28026,
  KM_4542_1_SoftDoeSkin: 28027,
  KM_4543_2_CoffeeDiva: 28028,
  KM_4544_3_HutchinsPlaza: 28029,
  KM_4545_3_GingerPie: 28030,
  KM_4546_5_AppaloosaSpots: 28031,
  KM_4547_5_CoconutHusk: 28032,
  KM_4548_1_BobcatWhiskers: 28033,
  KM_4549_1_BrigODoon: 28034,
  KM_455_M_Pollydoodle: 28035,
  KM_4550_1_CafeLatte: 28036,
  KM_4551_1_SandyToes: 28037,
  KM_4552_2_AntiqueWindmill: 28038,
  KM_4553_3_Braun: 28039,
  KM_4554_5_BuffaloDance: 28040,
  KM_4555_1_WhitePearl: 28041,
  KM_4556_2_DinosaurEgg: 28042,
  KM_4557_2_WhiteRussian: 28043,
  KM_4558_3_QuickSand: 28044,
  KM_4559_3_Mink: 28045,
  KM_456_D_LaurelLeaf: 28046,
  KM_4560_5_MexicanChocolate: 28047,
  KM_4561_5_BabyBear: 28048,
  KM_4562_1_OysterHaze: 28049,
  KM_4563_1_PorcelainBasin: 28050,
  KM_4564_2_TombstoneGray: 28051,
  KM_4565_1_Sophistication: 28052,
  KM_4566_3_CityLoft: 28053,
  KM_4567_3_DinosaurBone: 28054,
  KM_4568_5_TeaChest: 28055,
  KM_4569_1_ClearSand: 28056,
  KM_457_L_CaliforniaLime: 28057,
  KM_4570_1_ShojiScreen: 28058,
  KM_4571_1_CobblestoneStreet: 28059,
  KM_4572_2_Tungsten: 28060,
  KM_4573_3_SacredVortex: 28061,
  KM_4574_3_DryDock: 28062,
  KM_4575_5_MudRoom: 28063,
  KM_4576_1_YangMist: 28064,
  KM_4577_1_PearlOyster: 28065,
  KM_4578_2_FeatherStone: 28066,
  KM_4579_2_GhostTown: 28067,
  KM_458_L_Botanical: 28068,
  KM_4580_2_FoggyNight: 28069,
  KM_4581_3_BatWing: 28070,
  KM_4582_5_BeaverPelt: 28071,
  KM_4583_1_CanvasCloth: 28072,
  KM_4584_1_UrbanBird: 28073,
  KM_4585_2_LoversHideaway: 28074,
  KM_4586_2_AbbeyRoad: 28075,
  KM_4587_3_SmokyTopaz: 28076,
  KM_4588_5_NeverCryWolf: 28077,
  KM_4589_5_MamaRacoon: 28078,
  KM_459_L_ValleyVista: 28079,
  KM_4590_1_MistyMoonstone: 28080,
  KM_4591_1_WhiteLinen: 28081,
  KM_4592_1_IndianMuslin: 28082,
  KM_4593_2_PolishedStone: 28083,
  KM_4594_2_BayArea: 28084,
  KM_4595_3_ClayBath: 28085,
  KM_4596_5_CityBench: 28086,
  KM_4597_1_TexanAngel: 28087,
  KM_4598_1_MexicanSandDollar: 28088,
  KM_4599_2_Fossil: 28089,
  KM_46_M_Calimesa: 28090,
  KM_460_M_Gimlet: 28091,
  KM_4600_2_AfternoonTea: 28092,
  KM_4601_2_DriedGrass: 28093,
  KM_4602_3_PieSafe: 28094,
  KM_4603_5_GrandAvenue: 28095,
  KM_4604_1_DustStorm: 28096,
  KM_4605_2_PersianFlatbread: 28097,
  KM_4606_2_HikersDelight: 28098,
  KM_4607_3_WoollyMammoth: 28099,
  KM_4608_3_EarthlyDelight: 28100,
  KM_4609_5_TreasureChest: 28101,
  KM_461_M_AppleValley: 28102,
  KM_4610_5_TexasBoots: 28103,
  KM_4611_1_RumCustard: 28104,
  KM_4612_2_DapperDingo: 28105,
  KM_4613_3_ToastAndButter: 28106,
  KM_4614_3_NewFawn: 28107,
  KM_4615_3_CaramelCupcake: 28108,
  KM_4616_3_SacredGround: 28109,
  KM_4617_5_AppleSeeds: 28110,
  KM_4618_1_AnimalCracker: 28111,
  KM_4619_1_SugarShack: 28112,
  KM_462_D_SaladFixins: 28113,
  KM_4620_2_FortuneCookie: 28114,
  KM_4621_2_BananasFoster: 28115,
  KM_4622_2_ButteryLeather: 28116,
  KM_4623_3_Chalet: 28117,
  KM_4624_5_RedTailedHawk: 28118,
  KM_4625_1_WhiteHotChocolate: 28119,
  KM_4626_1_WarmBiscuits: 28120,
  KM_4627_2_CozyWool: 28121,
  KM_4628_3_FrenchOak: 28122,
  KM_4629_3_TradingPost: 28123,
  KM_463_L_Northwind: 28124,
  KM_4630_3_HowlingCoyote: 28125,
  KM_4631_5_CastleMoat: 28126,
  KM_4632_1_WhiteSand: 28127,
  KM_4633_1_CzechBakery: 28128,
  KM_4634_2_Community: 28129,
  KM_4635_3_Tanglewood: 28130,
  KM_4636_3_Cumin: 28131,
  KM_4637_5_EaglesNest: 28132,
  KM_4638_5_BerkeleyHills: 28133,
  KM_4639_1_VanillaFlower: 28134,
  KM_464_L_GreenSpirit: 28135,
  KM_4640_1_OstrichEgg: 28136,
  KM_4641_1_BrownMouse: 28137,
  KM_4642_2_BirdsNest: 28138,
  KM_4643_3_SticksStones: 28139,
  KM_4644_3_SierraFoothills: 28140,
  KM_4645_5_WineCork: 28141,
  KM_4646_1_MagicSail: 28142,
  KM_4647_2_PonyTail: 28143,
  KM_4648_2_BarkingPrairieDog: 28144,
  KM_4649_3_OliveWood: 28145,
  KM_465_L_GreenSigh: 28146,
  KM_4650_3_KingsRansom: 28147,
  KM_4651_3_EarthlyPleasures: 28148,
  KM_4652_5_HighChaparral: 28149,
  KM_4653_1_VintageLace: 28150,
  KM_4654_1_GoldenLotus: 28151,
  KM_4655_1_TatamiMat: 28152,
  KM_4656_2_OatmealBath: 28153,
  KM_4657_3_CappuccinoFroth: 28154,
  KM_4658_3_TotemPole: 28155,
  KM_4659_5_TobaccoLeaf: 28156,
  KM_466_M_FreshHoneydew: 28157,
  KM_4660_1_WeddingDress: 28158,
  KM_4661_1_PalominoMane: 28159,
  KM_4662_1_CreamyChenille: 28160,
  KM_4663_2_GoldWash: 28161,
  KM_4664_3_EarthChi: 28162,
  KM_4665_3_BodhiTree: 28163,
  KM_4666_5_WildSeaweed: 28164,
  KM_4667_1_WhiteFence: 28165,
  KM_4668_1_WeddingCake: 28166,
  KM_4669_1_BraidedRaffia: 28167,
  KM_467_M_Unbelievable: 28168,
  KM_4670_3_TikiHut: 28169,
  KM_4671_3_EmperorsGold: 28170,
  KM_4672_3_GoodLuckCharm: 28171,
  KM_4673_5_BirchForest: 28172,
  KM_4674_1_ImperialIvory: 28173,
  KM_4675_1_WhiteChocolate: 28174,
  KM_4676_2_OrganicBamboo: 28175,
  KM_4677_2_FlierLie: 28176,
  KM_4678_3_HempRope: 28177,
  KM_4679_3_GatheringPlace: 28178,
  KM_468_D_Gloworm: 28179,
  KM_4680_5_TurnedLeaf: 28180,
  KM_4681_1_Origami: 28181,
  KM_4682_1_YellowStonePark: 28182,
  KM_4683_2_SweetDough: 28183,
  KM_4684_2_AloofLama: 28184,
  KM_4685_5_SoftSuede: 28185,
  KM_4686_3_SweetEarth: 28186,
  KM_4687_5_DesertWillow: 28187,
  KM_4688_1_SummerSandcastle: 28188,
  KM_4689_1_GardenLattice: 28189,
  KM_469_L_Mixtura: 28190,
  KM_4690_1_SpaSangria: 28191,
  KM_4691_3_TexasSage: 28192,
  KM_4692_3_VillageCrier: 28193,
  KM_4693_5_SafariGreen: 28194,
  KM_4694_5_MossyShade: 28195,
  KM_4695_1_WaterChestnut: 28196,
  KM_4696_1_SaharaWind: 28197,
  KM_4697_2_ThatchedCottage: 28198,
  KM_4698_2_TumblingTumbleweed: 28199,
  KM_4699_3_WeaversSpool: 28200,
  KM_47_M_EndOfSummer: 28201,
  KM_470_L_Avanti: 28202,
  KM_4700_3_LaurelWreath: 28203,
  KM_4701_5_ShadedFern: 28204,
  KM_4702_1_MoonDance: 28205,
  KM_4703_1_WhirligigGeyser: 28206,
  KM_4704_2_DustyTrailRider: 28207,
  KM_4705_3_KissTheBlarneyStone: 28208,
  KM_4706_3_RusticHacienda: 28209,
  KM_4707_3_HiddenCottage: 28210,
  KM_4708_5_OakPlank: 28211,
  KM_4709_1_CanyonEcho: 28212,
  KM_471_L_Celebration: 28213,
  KM_4710_1_DesertKhaki: 28214,
  KM_4711_1_BauhausTan: 28215,
  KM_4712_2_WindingPath: 28216,
  KM_4713_3_PrairieSage: 28217,
  KM_4714_3_DeepMarsh: 28218,
  KM_4715_5_Overgrown: 28219,
  KM_4716_1_PearlyPutty: 28220,
  KM_4717_1_PrairieDusk: 28221,
  KM_4718_2_WagonWheel: 28222,
  KM_4719_3_HarvestDance: 28223,
  KM_472_M_Seaweed: 28224,
  KM_4720_3_OpenRange: 28225,
  KM_4721_5_AmazonGreen: 28226,
  KM_4722_5_BackToBasics: 28227,
  KM_4723_1_AngelsFeather: 28228,
  KM_4724_1_WeddedBliss: 28229,
  KM_4725_1_TreeMoss: 28230,
  KM_4726_1_ZenEssence: 28231,
  KM_4727_3_CaliforniaRoll: 28232,
  KM_4728_3_CanyonVerde: 28233,
  KM_4729_5_ShadyOak: 28234,
  KM_473_M_EmersonGarden: 28235,
  KM_4730_1_PearlySwirl: 28236,
  KM_4731_1_GrassSkirt: 28237,
  KM_4732_1_CyprusGrass: 28238,
  KM_4733_3_ArtichokeDip: 28239,
  KM_4734_3_WoodChi: 28240,
  KM_4735_5_OliveSprig: 28241,
  KM_4736_5_WillowLeaf: 28242,
  KM_4737_1_SassafrasTea: 28243,
  KM_4738_1_MossIsland: 28244,
  KM_4739_1_LandBeforeTime: 28245,
  KM_474_D_GrandPalm: 28246,
  KM_4740_2_LodgepolePines: 28247,
  KM_4741_3_ExecutiveCourse: 28248,
  KM_4742_5_MysteriousMoss: 28249,
  KM_4743_5_ShagbarkOlive: 28250,
  KM_4744_1_AlabasterBeauty: 28251,
  KM_4745_1_SteamboatGeyser: 28252,
  KM_4746_2_CountyCharm: 28253,
  KM_4747_3_KnockOnWood: 28254,
  KM_4748_3_WesternReserve: 28255,
  KM_4749_5_RainforestZipline: 28256,
  KM_475_L_IvoryTint: 28257,
  KM_4750_5_LochNess: 28258,
  KM_4751_1_BananaPudding: 28259,
  KM_4752_1_StarOfGold: 28260,
  KM_4753_2_CapitalGrains: 28261,
  KM_4754_3_RainforestFern: 28262,
  KM_4755_3_CamoGreen: 28263,
  KM_4756_3_WhisperingGrasslands: 28264,
  KM_4757_5_RacoonEyes: 28265,
  KM_4758_1_ItalianLace: 28266,
  KM_4759_1_AmishBread: 28267,
  KM_476_L_Quince: 28268,
  KM_4760_2_Stardust: 28269,
  KM_4761_2_TangledVines: 28270,
  KM_4762_3_TomatilloSalsa: 28271,
  KM_4763_3_AutumnSage: 28272,
  KM_4764_5_Sycamore: 28273,
  KM_4765_1_BuddingFern: 28274,
  KM_4766_1_RanchoVerde: 28275,
  KM_4767_2_WasabiZing: 28276,
  KM_4768_2_GoodyTwoShoes: 28277,
  KM_4769_3_WindyMeadow: 28278,
  KM_477_L_EasyGoing: 28279,
  KM_4770_5_InAPickle: 28280,
  KM_4771_5_SwampThing: 28281,
  KM_4772_1_PineappleSage: 28282,
  KM_4773_1_GardenGate: 28283,
  KM_4774_1_BitterMelon: 28284,
  KM_4775_2_ChameleonTango: 28285,
  KM_4776_2_GreenTea: 28286,
  KM_4777_5_HulaGirl: 28287,
  KM_4778_5_EatYourGreens: 28288,
  KM_4779_1_Willowside: 28289,
  KM_478_M_Gusto: 28290,
  KM_4780_1_OnionSkin: 28291,
  KM_4781_1_CorinthianColumn: 28292,
  KM_4782_1_BahiaGrass: 28293,
  KM_4783_3_Bonsai: 28294,
  KM_4784_5_WildGinseng: 28295,
  KM_4785_5_WoodsCreek: 28296,
  KM_4786_1_FreshLinen: 28297,
  KM_4787_1_PlumeGrass: 28298,
  KM_4788_1_EveningDove: 28299,
  KM_4789_2_Backdrop: 28300,
  KM_479_M_SeaTurtle: 28301,
  KM_4790_3_VenetianWall: 28302,
  KM_4791_5_DuckWillow: 28303,
  KM_4792_5_FernGully: 28304,
  KM_4793_1_EmergingLeaf: 28305,
  KM_4794_1_WineBottle: 28306,
  KM_4795_2_HealingRetreat: 28307,
  KM_4796_3_AcanthusLeaf: 28308,
  KM_4797_3_KoiPond: 28309,
  KM_4798_5_LonePine: 28310,
  KM_4799_5_TreasureIsland: 28311,
  KM_48_D_CaliforniaDream: 28312,
  KM_480_D_KiwiWinter: 28313,
  KM_4800_1_AmazonMist: 28314,
  KM_4801_1_SilverLaurel: 28315,
  KM_4802_2_GreenDragonSpring: 28316,
  KM_4803_3_MedicineWheel: 28317,
  KM_4804_3_AloeVera: 28318,
  KM_4805_3_DesertChaparral: 28319,
  KM_4806_5_TreeOfLife: 28320,
  KM_4807_1_WaterDroplet: 28321,
  KM_4808_1_WashedGreen: 28322,
  KM_4809_2_SeaPine: 28323,
  KM_481_L_BrightWillow: 28324,
  KM_4810_3_AppalachianForest: 28325,
  KM_4811_5_HaydenValley: 28326,
  KM_4812_5_JungleCover: 28327,
  KM_4813_5_WetSuit: 28328,
  KM_4814_1_CalmBreeze: 28329,
  KM_4815_1_LighthouseView: 28330,
  KM_4816_1_SilkyGreen: 28331,
  KM_4817_2_TrellisedIvy: 28332,
  KM_4818_5_KnitCardigan: 28333,
  KM_4819_5_ForestFloor: 28334,
  KM_482_L_SilverFern: 28335,
  KM_4820_5_CannonBall: 28336,
  KM_4821_1_CaribbeanPleasure: 28337,
  KM_4822_1_ParakeetPete: 28338,
  KM_4823_1_OceanCruise: 28339,
  KM_4824_2_MontezumaHills: 28340,
  KM_4825_2_CavernMoss: 28341,
  KM_4826_3_GardenHedge: 28342,
  KM_4827_5_DeepSeaShadow: 28343,
  KM_4828_1_AngelsWhisper: 28344,
  KM_4829_1_CeladonGlaze: 28345,
  KM_483_L_SoftFeather: 28346,
  KM_4830_1_TreePose: 28347,
  KM_4831_2_DreamCatcher: 28348,
  KM_4832_2_MarbleGreen: 28349,
  KM_4833_3_CampingTrip: 28350,
  KM_4834_5_ParkAvenue: 28351,
  KM_4835_1_TidalMist: 28352,
  KM_4836_1_NightWind: 28353,
  KM_4837_1_SonomaSky: 28354,
  KM_4838_1_GardenGazebo: 28355,
  KM_4839_3_CastawayCove: 28356,
  KM_484_M_ReedYellow: 28357,
  KM_4840_3_Adventurine: 28358,
  KM_4841_5_TheatreDress: 28359,
  KM_4842_1_CrushedLimestone: 28360,
  KM_4843_1_Infusion: 28361,
  KM_4844_1_InvitingVeranda: 28362,
  KM_4845_2_CyprusSpring: 28363,
  KM_4846_2_Tranquility: 28364,
  KM_4847_3_MississippiRiver: 28365,
  KM_4848_5_CapriIsle: 28366,
  KM_4849_1_EyeOfTheStorm: 28367,
  KM_485_M_IcyDew: 28368,
  KM_4850_1_Synchronicity: 28369,
  KM_4851_1_SeaGlass: 28370,
  KM_4852_2_WindJammer: 28371,
  KM_4853_2_ShadedHammock: 28372,
  KM_4854_3_CastawayLagoon: 28373,
  KM_4855_5_AllNighter: 28374,
  KM_4856_1_Rediscover: 28375,
  KM_4857_1_WhisperingWind: 28376,
  KM_4858_2_HorizonGray: 28377,
  KM_4859_3_HarrowsGate: 28378,
  KM_486_D_BellGarden: 28379,
  KM_4860_3_TradeSecret: 28380,
  KM_4861_3_WingMan: 28381,
  KM_4862_5_OldSchool: 28382,
  KM_4863_1_BreezyAqua: 28383,
  KM_4864_1_IcyWaterfall: 28384,
  KM_4865_1_BlueAgave: 28385,
  KM_4866_2_BeachCottage: 28386,
  KM_4867_2_SoulQuenching: 28387,
  KM_4868_3_PorchSwing: 28388,
  KM_4869_5_RockyCreek: 28389,
  KM_487_L_SweetChardonnay: 28390,
  KM_4870_1_DecemberRain: 28391,
  KM_4871_1_GulfWind: 28392,
  KM_4872_1_ElectricSlide: 28393,
  KM_4873_2_ThunderCat: 28394,
  KM_4874_3_OysterBlue: 28395,
  KM_4875_3_MidnightPearl: 28396,
  KM_4876_5_WroughtIronGate: 28397,
  KM_4877_1_NightWhite: 28398,
  KM_4878_1_PorpoiseFin: 28399,
  KM_4879_1_BrilliantSilver: 28400,
  KM_488_L_Cidrada: 28401,
  KM_4880_2_ThunderStorm: 28402,
  KM_4881_3_ApperGreyHound: 28403,
  KM_4882_5_TitaniumGray: 28404,
  KM_4883_5_BlackCat: 28405,
  KM_4884_1_GrayGhost: 28406,
  KM_4885_1_AncestralWater: 28407,
  KM_4886_1_FoggyDay: 28408,
  KM_4887_2_RoughStone: 28409,
  KM_4888_3_CarbonFootprint: 28410,
  KM_4889_3_GraniteCanyon: 28411,
  KM_489_L_Giallo: 28412,
  KM_4890_5_AfterMidnight: 28413,
  KM_4891_1_SwanDive: 28414,
  KM_4892_1_SilverStrandBeach: 28415,
  KM_4893_1_MischiefMouse: 28416,
  KM_4894_2_CavePainting: 28417,
  KM_4895_3_DistantThunder: 28418,
  KM_4896_3_StoneHearth: 28419,
  KM_4897_5_YinMist: 28420,
  KM_4898_1_SlowPerch: 28421,
  KM_4899_1_GraySpell: 28422,
  KM_49_L_Gladsome: 28423,
  KM_490_M_Sulfur: 28424,
  KM_4900_1_MudPots: 28425,
  KM_4901_2_HughsHue: 28426,
  KM_4902_3_MtRushmore: 28427,
  KM_4903_ZincDust: 2033,
  KM_4904_5_BalsamicReduction: 28428,
  KM_4905_1_HushGray: 28429,
  KM_4906_1_CampfireSmoke: 28430,
  KM_4907_1_GalleryGray: 28431,
  KM_4908_1_BashfulEmu: 28432,
  KM_4909_2_MetalChi: 28433,
  KM_491_M_Bakersfield: 28434,
  KM_4910_3_PlatinumGranite: 28435,
  KM_4911_5_DesertShadow: 28436,
  KM_4912_1_ThistleGray: 28437,
  KM_4913_1_FogBeacon: 28438,
  KM_4914_1_GrayDolphin: 28439,
  KM_4915_1_DuctTapeGrey: 28440,
  KM_4916_2_PolishedPewter: 28441,
  KM_4917_3_Newsprint: 28442,
  KM_4918_5_SplitRock: 28443,
  KM_4919_1_InTheShadows: 28444,
  KM_492_D_SpinachSalad: 28445,
  KM_4920_1_SmoothStone: 28446,
  KM_4921_2_AutumnGray: 28447,
  KM_4922_2_FlintRock: 28448,
  KM_4923_3_Submarine: 28449,
  KM_4924_5_Thunderstruck: 28450,
  KM_4925_5_WildTruffle: 28451,
  KM_4926_1_IvoryMist: 28452,
  KM_4927_1_PolishedLimestone: 28453,
  KM_4928_1_LuckyDog: 28454,
  KM_4929_2_WarmGrayFlannel: 28455,
  KM_493_L_BarelyKhaki: 28456,
  KM_4930_3_YoungColt: 28457,
  KM_4931_3_CathedralStone: 28458,
  KM_4932_5_RubElbows: 28459,
  KM_4933_1_MoonShell: 28460,
  KM_4934_1_ZebraFinch: 28461,
  KM_4935_1_SequoiaFog: 28462,
  KM_4936_2_SmokyDay: 28463,
  KM_4937_3_PawPrint: 28464,
  KM_4938_3_GrouchyBadger: 28465,
  KM_4939_5_Arrowhead: 28466,
  KM_494_L_Sausalito: 28467,
  KM_4940_1_Greybeard: 28468,
  KM_4941_2_CityDweller: 28469,
  KM_4942_2_TinMan: 28470,
  KM_4943_3_Subway: 28471,
  KM_4944_3_VikingCastle: 28472,
  KM_4945_3_SecretPassageway: 28473,
  KM_4946_5_SeaweedWrap: 28474,
  KM_4947_1_SubtleShadow: 28475,
  KM_4948_1_BabyBarnOwl: 28476,
  KM_4949_1_OldGreyMare: 28477,
  KM_495_L_Xavier: 28478,
  KM_4950_3_MetalFlake: 28479,
  KM_4951_3_QueenValley: 28480,
  KM_4952_5_PompeiiRuins: 28481,
  KM_4953_5_NaturalPumace: 28482,
  KM_4954_1_CosmicDust: 28483,
  KM_4955_1_StillWaterLake: 28484,
  KM_4956_1_SeascapeBlue: 28485,
  KM_4957_2_Accolade: 28486,
  KM_4958_3_RushingRiver: 28487,
  KM_4959_3_FrenchDiamond: 28488,
  KM_496_M_ThousandPalms: 28489,
  KM_4960_5_EveningGlory: 28490,
  KM_4961_1_LeapOfFaith: 28491,
  KM_4962_1_SummerStorm: 28492,
  KM_4963_1_ClearLakeTrail: 28493,
  KM_4964_2_DockSide: 28494,
  KM_4965_3_DenverRiver: 28495,
  KM_4966_3_Vinca: 28496,
  KM_4967_5_CoastalSurf: 28497,
  KM_49681_ArcticWhite: 227,
  KM_4969_1_MeteorShower: 28498,
  KM_497_M_Mendocino: 28499,
  KM_4970_1_CryBabyBlue: 28500,
  KM_4971_1_ArtesianPool: 28501,
  KM_4972_2_VictoryLake: 28502,
  KM_4973_3_BlueBonnet: 28503,
  KM_4974_5_GoodKarma: 28504,
  KM_4975_1_HazyBlue: 28505,
  KM_4976_1_AngelicEyes: 28506,
  KM_4977_1_AegeanMist: 28507,
  KM_4978_2_BirdieNumNum: 28508,
  KM_4979_3_ZeusTemple: 28509,
  KM_498_D_TerraVerde: 28510,
  KM_4980_3_AshtonBlue: 28511,
  KM_4981_5_Truth: 28512,
  KM_4982_1_WaterMist: 28513,
  KM_4983_1_BigSur: 28514,
  KM_4984_1_BlueCrabEscape: 28515,
  KM_4985_2_OldFaithful: 28516,
  KM_4986_3_GrantVillage: 28517,
  KM_4987_3_SnakeRiver: 28518,
  KM_4988_5_PassionateBlueberry: 28519,
  KM_4989_1_PinwheelGeyser: 28520,
  KM_499_L_Sponge: 28521,
  KM_4990_1_WindWeaver: 28522,
  KM_4991_1_CloudyDay: 28523,
  KM_4992_1_SouringEagle: 28524,
  KM_4993_2_Tsunami: 28525,
  KM_4994_3_SilverBlueberry: 28526,
  KM_4995_5_NavyDamask: 28527,
  KM_4996_1_WhitecapFoam: 28528,
  KM_4997_1_WhalesMouth: 28529,
  KM_4998_1_CracklingLake: 28530,
  KM_4999_1_PacificBliss: 28531,
  KM_5_M_SunnySlope: 28532,
  KM_50_L_Borialis: 28533,
  KM_500_L_PuttyPearl: 28534,
  KM_5000_2_BeachUmbrella: 28535,
  KM_5001_3_LilyPondBlue: 28536,
  KM_5002_5_DarkSecret: 28537,
  KM_5003_1_TetonBreeze: 28538,
  KM_5004_1_Purification: 28539,
  KM_5005_1_Cielo: 28540,
  KM_5006_1_BlueEyedBoy: 28541,
  KM_5007_2_BajaBlue: 28542,
  KM_5008_3_AmalfiCoast: 28543,
  KM_5009_5_Unity: 28544,
  KM_501_L_RichGrove: 28545,
  KM_5010_1_ReflectionPool: 28546,
  KM_5011_1_Mudra: 28547,
  KM_5012_1_ThunderChi: 28548,
  KM_5013_2_WindyDay: 28549,
  KM_5014_2_BlueMountain: 28550,
  KM_5015_3_TechWave: 28551,
  KM_5016_5_WaterChi: 28552,
  KM_5017_1_Windsurfer: 28553,
  KM_5018_1_BluePerennial: 28554,
  KM_5019_1_RainDance: 28555,
  KM_502_M_YuccaValley: 28556,
  KM_5020_1_BlueBird: 28557,
  KM_5021_2_Fate: 28558,
  KM_5022_3_WildBlueYonder: 28559,
  KM_5023_5_Sacrifice: 28560,
  KM_5024_1_SecondWind: 28561,
  KM_5025_1_LaPazSiesta: 28562,
  KM_5026_1_Oceano: 28563,
  KM_5027_1_HawaiianBreeze: 28564,
  KM_5028_2_BlueMartini: 28565,
  KM_5029_3_CelestineSpring: 28566,
  KM_503_M_JoshuaTree: 28567,
  KM_5030_5_WorldPeace: 28568,
  KM_5031_1_GossamerWings: 28569,
  KM_5032_1_SoftBlue: 28570,
  KM_5033_1_AlexandrianSky: 28571,
  KM_5034_2_MallardLake: 28572,
  KM_5035_3_PrincessKate: 28573,
  KM_5036_3_ForTheLoveOfHue: 28574,
  KM_5037_5_SeaOfAtlantis: 28575,
  KM_5038_1_LightWave: 28576,
  KM_5039_1_OnCloudNine: 28577,
  KM_504_D_CountryEstate: 28578,
  KM_5040_1_ExoticEscape: 28579,
  KM_5041_2_ArcticOcean: 28580,
  KM_5042_3_Future: 28581,
  KM_5043_3_Brilliant: 28582,
  KM_5044_5_PrismaticSprings: 28583,
  KM_5045_1_UnderWater: 28584,
  KM_5046_1_PoolParty: 28585,
  KM_5047_1_Spinnaker: 28586,
  KM_5048_1_AquaZing: 28587,
  KM_5049_3_Swagger: 28588,
  KM_505_L_IvanhoeEstate: 28589,
  KM_5050_3_AquaVelvet: 28590,
  KM_5051_5_BarbadosBay: 28591,
  KM_5052_1_CoolIcicle: 28592,
  KM_5053_1_LitlBouyBlew: 28593,
  KM_5054_1_CatchTheWave: 28594,
  KM_5055_2_CabanaBoy: 28595,
  KM_5056_3_BeachGlass: 28596,
  KM_5057_3_EmuEgg: 28597,
  KM_5058_5_EmeraldSpring: 28598,
  KM_5059_1_SnowBallet: 28599,
  KM_506_L_Bathsalt: 28600,
  KM_5060_1_AquaOasis: 28601,
  KM_5061_1_Bambino: 28602,
  KM_5062_2_HawaiianVacation: 28603,
  KM_5063_3_SacredTurquoise: 28604,
  KM_5064_3_Flamboyant: 28605,
  KM_5065_5_DancingDragonFly: 28606,
  KM_5066_1_WindowPane: 28607,
  KM_5067_1_EveningHush: 28608,
  KM_5068_1_QuietDrizzle: 28609,
  KM_5069_2_FolkTales: 28610,
  KM_507_L_ZayDay: 28611,
  KM_5070_2_RareHappening: 28612,
  KM_5071_3_Keepsake: 28613,
  KM_5072_5_JasperPark: 28614,
  KM_5073_1_PersianFable: 28615,
  KM_5074_1_DesertMirage: 28616,
  KM_5075_1_SouthernBelle: 28617,
  KM_5076_2_BellaGreen: 28618,
  KM_5077_3_PeacockPlume: 28619,
  KM_5078_3_AegeanGreen: 28620,
  KM_5079_5_BagPiper: 28621,
  KM_508_M_Quesy: 28622,
  KM_5080_1_GreenBrocade: 28623,
  KM_5081_1_MayPole: 28624,
  KM_5082_1_FabulousFind: 28625,
  KM_5083_2_Marooned: 28626,
  KM_5084_3_CrazyEyes: 28627,
  KM_5085_5_GoGreen: 28628,
  KM_5086_5_SoSari: 28629,
  KM_5087_1_SoftFocus: 28630,
  KM_5088_1_ChicGreen: 28631,
  KM_5089_1_WintergreenMint: 28632,
  KM_509_M_Duplex: 28633,
  KM_5090_2_GoddessOfDawn: 28634,
  KM_5091_3_SummerGarden: 28635,
  KM_5092_5_Abundance: 28636,
  KM_5093_5_AutumnFern: 28637,
  KM_5094_1_Clarity: 28638,
  KM_5095_1_MintShake: 28639,
  KM_5096_2_BigSpender: 28640,
  KM_5097_2_MoverShaker: 28641,
  KM_5098_3_ColorMeGreen: 28642,
  KM_5099_5_VividImagination: 28643,
  KM_51_L_TropicTone: 28644,
  KM_510_D_TableMountain: 28645,
  KM_5100_5_MermaidsTail: 28646,
  KM_5101_1_MineralWater: 28647,
  KM_5102_1_Quintessential: 28648,
  KM_5103_1_Namaste: 28649,
  KM_5104_2_AromaGarden: 28650,
  KM_5105_3_MonarchsCocoon: 28651,
  KM_5106_3_PricklyPearCactus: 28652,
  KM_5107_5_BackWoods: 28653,
  KM_5108_1_HintOfJade: 28654,
  KM_5109_1_PaintedTurtle: 28655,
  KM_511_L_QuaintCottage: 28656,
  KM_5110_1_SucculentGarden: 28657,
  KM_5111_2_WhiteSage: 28658,
  KM_5112_3_BanyanSerenity: 28659,
  KM_5113_3_NewLife: 28660,
  KM_5114_5_JalapenoPoppers: 28661,
  KM_5115_1_WindChimes: 28662,
  KM_5116_1_Zen: 28663,
  KM_5117_1_AprilWedding: 28664,
  KM_5118_2_SeaGrass: 28665,
  KM_5119_2_CasaVerde: 28666,
  KM_512_L_TwinPeaks: 28667,
  KM_5120_3_Edamame: 28668,
  KM_5121_5_GolferGreen: 28669,
  KM_5122_1_BlissfulSerenity: 28670,
  KM_5123_1_GreenParlor: 28671,
  KM_5124_1_HamsterHabitat: 28672,
  KM_5125_2_Spumoni: 28673,
  KM_5126_3_FloralTapestry: 28674,
  KM_5127_3_VirtualForest: 28675,
  KM_5128_5_WoodlandNymph: 28676,
  KM_5129_1_TranslucentVision: 28677,
  KM_513_L_Arroyo: 28678,
  KM_5130_1_SweetSpring: 28679,
  KM_5131_1_BowlingGreen: 28680,
  KM_5132_2_InGoodTaste: 28681,
  KM_5133_3_SagoGarden: 28682,
  KM_5134_5_Envy: 28683,
  KM_5135_5_HiddenParadise: 28684,
  KM_5136_1_TearsOfJoy: 28685,
  KM_5137_1_GreenEggs: 28686,
  KM_5138_1_LastingThoughts: 28687,
  KM_5139_2_LicketySplit: 28688,
  KM_514_M_TempleCity: 28689,
  KM_5140_3_SourFace: 28690,
  KM_5141_3_HappyTune: 28691,
  KM_5142_5_CarolesPurr: 28692,
  KM_5143_1_HoneyDo: 28693,
  KM_5144_1_IcedCelery: 28694,
  KM_5145_1_BitOfLime: 28695,
  KM_5146_3_Limelight: 28696,
  KM_5147_3_CalamansiGreen: 28697,
  KM_5148_5_GreenBananas: 28698,
  KM_5149_5_AppleGreen: 28699,
  KM_515_M_SandAndSable: 28700,
  KM_5150_1_RareWhiteJade: 28701,
  KM_5151_1_SpringThyme: 28702,
  KM_5152_2_CalmingEffect: 28703,
  KM_5153_3_KissAFrog: 28704,
  KM_5154_3_ElfSlippers: 28705,
  KM_5155_5_WeepingWillow: 28706,
  KM_5156_5_ThaiBasil: 28707,
  KM_5157_1_ChildOfHeaven: 28708,
  KM_5158_1_TropicalTale: 28709,
  KM_5159_2_PaleAvocado: 28710,
  KM_516_D_Mercantile: 28711,
  KM_5160_3_FiddleheadFern: 28712,
  KM_5161_3_HiDefLime: 28713,
  KM_5162_5_MintGrasshopper: 28714,
  KM_5163_5_CutePixie: 28715,
  KM_5164_1_PalestOfLemon: 28716,
  KM_5165_1_Chardonnay: 28717,
  KM_5166_2_ChapelWall: 28718,
  KM_5167_3_LeafPrint: 28719,
  KM_5168_3_LemonLimeMojito: 28720,
  KM_5169_5_InchWorm: 28721,
  KM_517_L_ElmPark: 28722,
  KM_5170_5_ShimmeringGlade: 28723,
  KM_5171_1_LemonPopsicle: 28724,
  KM_5172_1_SmoothAsCornSilk: 28725,
  KM_5173_2_SunDeck: 28726,
  KM_5174_3_Alchemy: 28727,
  KM_5175_3_StrikeItRich: 28728,
  KM_5176_5_Grandiose: 28729,
  KM_5177_5_GoldTaffeta: 28730,
  KM_5178_1_BlondeShell: 28731,
  KM_5179_1_LightWorker: 28732,
  KM_518_L_ButtonIvory: 28733,
  KM_5180_2_NorthStar: 28734,
  KM_5181_3_PunchOfYellow: 28735,
  KM_5182_3_BeePollen: 28736,
  KM_5183_3_SunGod: 28737,
  KM_5184_3_KingCreekFalls: 28738,
  KM_5184_5_TigerCat: 28739,
  KM_5185_1_YellowDiamond: 28740,
  KM_5186_1_BreezyBeige: 28741,
  KM_5187_1_HoneysuckleVine: 28742,
  KM_5188_2_AprilSunshine: 28743,
  KM_5189_3_SummerLily: 28744,
  KM_519_L_WillowGreen: 28745,
  KM_5190_5_LookAtMe: 28746,
  KM_5191_5_SunSong: 28747,
  KM_5192_1_PineappleSorbet: 28748,
  KM_5193_1_SweetJasmine: 28749,
  KM_5194_1_AmarilloYellow: 28750,
  KM_5195_1_DropOfLemon: 28751,
  KM_5196_2_DaisyDesi: 28752,
  KM_5197_3_GoBananas: 28753,
  KM_5198_5_Xanthous: 28754,
  KM_5199_1_BananaSplit: 28755,
  KM_52_M_Fallon: 28756,
  KM_520_M_PampasGrass: 28757,
  KM_5200_1_StarStudded: 28758,
  KM_5201_2_SummersHeat: 28759,
  KM_5202_3_BurstingLemon: 28760,
  KM_5203_3_WakeMeUp: 28761,
  KM_5204_5_LemonadeStand: 28762,
  KM_5205_5_RadiantSunrise: 28763,
  KM_5206_1_MiniCake: 28764,
  KM_5207_1_LazySummerDay: 28765,
  KM_5208_2_ButteredPopcorn: 28766,
  KM_5209_3_HereComesTheSun: 28767,
  KM_521_M_Alameda: 28768,
  KM_5210_5_HappyDaze: 28769,
  KM_5211_5_BeachBall: 28770,
  KM_5212_5_BrilliantImpression: 28771,
  KM_5213_1_LemonSplash: 28772,
  KM_5214_1_SpringLily: 28773,
  KM_5215_1_DandelionWine: 28774,
  KM_5216_2_DaisyChain: 28775,
  KM_5217_3_DigitalYellow: 28776,
  KM_5218_5_SunnySideUp: 28777,
  KM_5219_5_BrightSaffron: 28778,
  KM_522_D_CampTent: 28779,
  KM_5220_1_FlickeringFirefly: 28780,
  KM_5221_1_LemonwoodPlace: 28781,
  KM_5222_1_TwinkleTwinkle: 28782,
  KM_5223_2_FirstTulip: 28783,
  KM_5224_3_BananaPeel: 28784,
  KM_5225_5_YellowJacket: 28785,
  KM_5226_5_SunsetStrip: 28786,
  KM_5227_1_BelgianBlonde: 28787,
  KM_5228_1_TamaleMaize: 28788,
  KM_5229_2_BlendedFruit: 28789,
  KM_523_L_Creamrich: 28790,
  KM_5230_3_SunSalutation: 28791,
  KM_5231_3_TawnyDaylilly: 28792,
  KM_5232_5_TigerCub: 28793,
  KM_5233_5_HeraldsTrumpet: 28794,
  KM_5234_1_CandleWax: 28795,
  KM_5235_1_CloverHoney: 28796,
  KM_5236_1_GoldenFleece: 28797,
  KM_5237_2_NomadicTravels: 28798,
  KM_5238_3_MagicLamp: 28799,
  KM_5239_3_OrleansTune: 28800,
  KM_524_L_WildPrairie: 28801,
  KM_5240_5_IndianBrass: 28802,
  KM_5241_1_GabrielsTorch: 28803,
  KM_5242_1_ButterUp: 28804,
  KM_5243_1_HoneyNCream: 28805,
  KM_5244_2_DirtyBlonde: 28806,
  KM_5245_3_LetItRing: 28807,
  KM_5246_3_GoldSpell: 28808,
  KM_5247_5_KissCandy: 28809,
  KM_5248_1_CreamyGelato: 28810,
  KM_5249_1_DuckTail: 28811,
  KM_525_L_Allure: 28812,
  KM_5250_1_MorningWheat: 28813,
  KM_5251_2_ChamomileTea: 28814,
  KM_5252_3_TaiwanGold: 28815,
  KM_5253_5_GoldenEgg: 28816,
  KM_5254_5_HolyGrail: 28817,
  KM_5255_1_BlondeCurl: 28818,
  KM_5256_1_IrishCream: 28819,
  KM_5257_1_Sandbank: 28820,
  KM_5258_3_CamelbackMountain: 28821,
  KM_5259_3_GildedPear: 28822,
  KM_526_M_SuttersGold: 28823,
  KM_5260_5_PiratesPlunder: 28824,
  KM_5261_5_CaliforniaGoldRush: 28825,
  KM_5262_1_Sawdust: 28826,
  KM_5263_1_GingerAleFizz: 28827,
  KM_5264_1_Souffle: 28828,
  KM_5265_3_HoneyRobber: 28829,
  KM_5266_3_Artemis: 28830,
  KM_5267_5_HarvestBlessing: 28831,
  KM_5268_5_RareFind: 28832,
  KM_5269_1_LuckyDuck: 28833,
  KM_527_M_PlunderedGold: 28834,
  KM_5270_1_TahitianSand: 28835,
  KM_5271_1_AntiqueWickerBasket: 28836,
  KM_5272_2_SparklingChampagne: 28837,
  KM_5273_2_CasavaCake: 28838,
  KM_5274_3_SweetHoney: 28839,
  KM_5275_5_Weissbier: 28840,
  KM_5276_1_TigerMath: 28841,
  KM_5277_1_SunStone: 28842,
  KM_5278_1_StellaDora: 28843,
  KM_5279_3_GoldenHominy: 28844,
  KM_528_D_HoneyDijon: 28845,
  KM_5280_3_FireCoral: 28846,
  KM_5281_5_SaffronRice: 28847,
  KM_5282_5_VictorianCrown: 28848,
  KM_5283_1_SoftCandlelight: 28849,
  KM_5284_1_GoldenBuff: 28850,
  KM_5285_1_StrawHat: 28851,
  KM_5286_1_KeyKeeper: 28852,
  KM_5287_2_CozyCover: 28853,
  KM_5288_3_OleYeller: 28854,
  KM_5289_5_AmberRomance: 28855,
  KM_529_L_Vanillin: 28856,
  KM_5290_1_MoonLight: 28857,
  KM_5291_1_BeachTowel: 28858,
  KM_5292_1_PhoenixFossil: 28859,
  KM_5293_2_Emberglow: 28860,
  KM_5294_3_BadHairDay: 28861,
  KM_5295_3_RipCord: 28862,
  KM_5296_5_CalicoCat: 28863,
  KM_5297_1_DiamondDust: 28864,
  KM_5298_1_Stargazer: 28865,
  KM_5299_1_FrozenCustard: 28866,
  KM_53_M_BrightIdea: 28867,
  KM_530_L_SoyBean: 28868,
  KM_5300_2_SunDance: 28869,
  KM_5301_3_ChineseLantern: 28870,
  KM_5302_3_BrassButtons: 28871,
  KM_5303_5_GoldenPheasant: 28872,
  KM_5304_1_TulipPetals: 28873,
  KM_5305_1_FairyDust: 28874,
  KM_5306_1_YellowGeranium: 28875,
  KM_5307_2_WorkoutRoutine: 28876,
  KM_5308_3_AfterShock: 28877,
  KM_5309_5_SquashBlossom: 28878,
  KM_531_L_Windmill: 28879,
  KM_5310_1_RowdyOrange: 28880,
  KM_5311_1_LemonSachet: 28881,
  KM_5312_1_SunKissed: 28882,
  KM_5313_1_YellowCanary: 28883,
  KM_5314_2_CitrusPinch: 28884,
  KM_5315_3_Chickadee: 28885,
  KM_5316_5_NotYoCheese: 28886,
  KM_5317_5_FreshSqueezed: 28887,
  KM_5318_1_WhiteLightning: 28888,
  KM_5319_1_AlexandriasLightHouse: 28889,
  KM_532_M_Facade: 28890,
  KM_5320_2_HelloYellow: 28891,
  KM_5321_3_BumbleBee: 28892,
  KM_5322_5_Sunburst: 28893,
  KM_5323_5_TurmericRoot: 28894,
  KM_5324_5_CaliforniaGirl: 28895,
  KM_5325_1_Tizzy: 28896,
  KM_5326_1_SeniorMoment: 28897,
  KM_5327_1_SouthShoreSun: 28898,
  KM_5328_2_EggYokeYellow: 28899,
  KM_5329_3_SeaBuckthorn: 28900,
  KM_533_M_SesameOil: 28901,
  KM_5330_5_BlissfulOrange: 28902,
  KM_5331_5_CheesePlease: 28903,
  KM_5332_1_Spotlight: 28904,
  KM_5333_1_TigerTail: 28905,
  KM_5334_1_SpeakToMe: 28906,
  KM_5335_2_FuzzyNavel: 28907,
  KM_5336_3_MangoSalsa: 28908,
  KM_5337_5_HyperHibiscus: 28909,
  KM_5338_5_OneryTangerine: 28910,
  KM_5339_1_PeachUmbrella: 28911,
  KM_534_D_ArchGold: 28912,
  KM_5340_1_ThreeRingCircus: 28913,
  KM_5341_2_Sundown: 28914,
  KM_5342_2_GoGoMango: 28915,
  KM_5343_3_CandiedYams: 28916,
  KM_5344_3_Tulips: 28917,
  KM_5345_5_SnappyHappy: 28918,
  KM_5346_1_HowdyNeighbor: 28919,
  KM_5347_1_SpikedApricot: 28920,
  KM_5348_1_Affinity: 28921,
  KM_5349_2_MelonMelody: 28922,
  KM_535_L_Antler: 28923,
  KM_5350_3_CatalinaTile: 28924,
  KM_5351_3_ButternutPiazz: 28925,
  KM_5352_5_PhoenixRising: 28926,
  KM_5353_1_WhitewashedFence: 28927,
  KM_5354_1_FavoredOne: 28928,
  KM_5355_1_TorchLight: 28929,
  KM_5356_3_EyeOfTheTiger: 28930,
  KM_5357_5_ColdPilsner: 28931,
  KM_5358_5_SweetTea: 28932,
  KM_5359_5_TuscanSun: 28933,
  KM_536_L_Alfalfa: 28934,
  KM_5360_1_WarmFuzzies: 28935,
  KM_5361_1_AlluringGerture: 28936,
  KM_5362_1_MissionCourtyard: 28937,
  KM_5363_3_QueenConchShell: 28938,
  KM_5364_3_PrayerFlag: 28939,
  KM_5365_3_NapaSunset: 28940,
  KM_5366_5_ExoticLife: 28941,
  KM_5367_1_BaliSand: 28942,
  KM_5368_1_BuenosAires: 28943,
  KM_5369_1_HomeBody: 28944,
  KM_537_L_LightTigerEye: 28945,
  KM_5370_2_CrossedFingers: 28946,
  KM_5371_2_NativeTan: 28947,
  KM_5372_3_CopperBeach: 28948,
  KM_5373_5_VintagePottery: 28949,
  KM_5374_1_PulledTaffy: 28950,
  KM_5375_1_PeachALaMode: 28951,
  KM_5376_1_ToastedCoconut: 28952,
  KM_5377_2_BootHillGhost: 28953,
  KM_5378_3_TexasHills: 28954,
  KM_5379_5_BakedBeans: 28955,
  KM_538_M_Sourdough: 28956,
  KM_5380_5_ToffeeCrunch: 28957,
  KM_5381_1_FollowTheLeader: 28958,
  KM_5382_1_Sweetness: 28959,
  KM_5383_1_OnlyYesterday: 28960,
  KM_5384_2_PeachNirvana: 28961,
  KM_5385_3_CopperCove: 28962,
  KM_5386_3_ShamanicJourney: 28963,
  KM_5387_5_AfricanSafari: 28964,
  KM_5388_1_SunsGlory: 28965,
  KM_5389_2_MangoCheesecake: 28966,
  KM_539_M_Cornhusk: 28967,
  KM_5390_1_GentleCaress: 28968,
  KM_5391_1_Petticoat: 28969,
  KM_5392_5_BalineseSunset: 28970,
  KM_5393_3_AegeanSky: 28971,
  KM_5394_5_WinterSunset: 28972,
  KM_5395_1_LemonSpongeCake: 28973,
  KM_5396_1_GoGoGlow: 28974,
  KM_5397_1_SinnersCity: 28975,
  KM_5398_2_SunsetCruise: 28976,
  KM_5399_3_DayAtTheZoo: 28977,
  KM_54_D_Bandanna: 28978,
  KM_540_D_TreasureHunt: 28979,
  KM_5400_5_Blaze: 28980,
  KM_5401_5_Deagsy: 28981,
  KM_5402_1_ButterflyWing: 28982,
  KM_5403_1_FlipFlop: 28983,
  KM_5404_2_ApricotPreserves: 28984,
  KM_5405_3_BakedSalmon: 28985,
  KM_5406_5_BrazenOrange: 28986,
  KM_5407_5_BrickABrack: 28987,
  KM_5408_5_MischiefMaker: 28988,
  KM_5409_1_Blossom: 28989,
  KM_541_L_TuftedTan: 28990,
  KM_5410_1_CoralKiss: 28991,
  KM_5411_1_PeachyBonBon: 28992,
  KM_5412_2_IslandGirl: 28993,
  KM_5413_3_UpStreamSalmon: 28994,
  KM_5414_4_BonFire: 28995,
  KM_5415_5_DayGlowOrange: 28996,
  KM_5416_1_SlyShrimp: 28997,
  KM_5417_1_DollHouse: 28998,
  KM_5418_1_ApricotObsession: 28999,
  KM_5419_2_SalmonRun: 29000,
  KM_542_L_CapeHatteras: 29001,
  KM_5420_3_IndianPrincess: 29002,
  KM_5421_5_TexasHeatwave: 29003,
  KM_5422_5_BoyntonCanyon: 29004,
  KM_5423_1_FairMaiden: 29005,
  KM_5424_1_GleamingShells: 29006,
  KM_5425_1_PeachTemptation: 29007,
  KM_5426_2_AgelessBeauty: 29008,
  KM_5427_2_SunburntToast: 29009,
  KM_5428_3_HimalayanSalt: 29010,
  KM_5429_5_GrillMaster: 29011,
  KM_543_L_LasVegas: 29012,
  KM_5430_1_SugarDust: 29013,
  KM_5431_1_GeorgiaOnMyMind: 29014,
  KM_5432_2_FirstDate: 29015,
  KM_5433_2_Whimsy: 29016,
  KM_5434_3_RichGeorgiaClay: 29017,
  KM_5435_5_ChiliSauce: 29018,
  KM_5436_5_BeniShoga: 29019,
  KM_5437_1_PrettyInPink: 29020,
  KM_5438_1_SkinnyDip: 29021,
  KM_5439_1_SidewalkChalk: 29022,
  KM_544_M_Coalinga: 29023,
  KM_5440_1_JoyfulPoppy: 29024,
  KM_5441_3_IslandCoral: 29025,
  KM_5442_3_LivingLarge: 29026,
  KM_5443_5_IndianSummer: 29027,
  KM_5444_1_WhiteRabbit: 29028,
  KM_5445_1_SatinPink: 29029,
  KM_5446_1_PrettyPlease: 29030,
  KM_5447_2_FancyFlamingo: 29031,
  KM_5448_2_FruityLicious: 29032,
  KM_5449_5_DangerouslyRed: 29033,
  KM_545_M_GoldenRule: 29034,
  KM_5450_5_RockinRed: 29035,
  KM_5451_1_ButterIcing: 29036,
  KM_5452_1_JustATease: 29037,
  KM_5453_1_SundayBest: 29038,
  KM_5454_2_CandyHeartPink: 29039,
  KM_5455_3_LivelyCoral: 29040,
  KM_5456_3_NativeBerry: 29041,
  KM_5457_5_NaughtyHottie: 29042,
  KM_5458_1_PinkLotus: 29043,
  KM_5459_1_HappyPiglets: 29044,
  KM_546_D_GoldReward: 29045,
  KM_5460_1_Heliotrope: 29046,
  KM_5461_1_StrawberrySmoothie: 29047,
  KM_5462_3_RhubarbPie: 29048,
  KM_5463_5_JapaneseMaple: 29049,
  KM_5464_5_SweetLychee: 29050,
  KM_5465_1_StrawberryConfection: 29051,
  KM_5466_1_ExclusivelyYours: 29052,
  KM_5467_2_TrueLove: 29053,
  KM_5468_3_TandooriRed: 29054,
  KM_5469_5_CostaRicanPalm: 29055,
  KM_547_L_VanillaBud: 29056,
  KM_5470_5_DragonsBlood: 29057,
  KM_5471_5_EternalFlame: 29058,
  KM_5472_1_PamperedPrincess: 29059,
  KM_5473_1_TootieFruity: 29060,
  KM_5474_1_TasselFlower: 29061,
  KM_5475_2_LoveSpell: 29062,
  KM_5476_3_Xoxo: 29063,
  KM_5477_3_AmbitiousRose: 29064,
  KM_5478_5_ChiGong: 29065,
  KM_5479_1_BridesBlush: 29066,
  KM_548_L_ContinentalCreme: 29067,
  KM_5480_1_BunnysNose: 29068,
  KM_5481_1_RoseyAfterglow: 29069,
  KM_5482_1_PinkBubbleTea: 29070,
  KM_5483_2_WonderLust: 29071,
  KM_5484_5_Relief: 29072,
  KM_5485_5_RubySlippers: 29073,
  KM_5486_1_Nina: 29074,
  KM_5487_1_PinkFrosting: 29075,
  KM_5488_1_BabySteps: 29076,
  KM_5489_2_BunnyCake: 29077,
  KM_549_L_TiffanyTan: 29078,
  KM_5490_3_Hope: 29079,
  KM_5491_3_SurferGirl: 29080,
  KM_5492_5_TimelessBeauty: 29081,
  KM_5493_1_PinkTutu: 29082,
  KM_5494_1_LoversRetreat: 29083,
  KM_5495_2_BlushingTulip: 29084,
  KM_5496_3_DevilishDiva: 29085,
  KM_5497_5_CherryOnTop: 29086,
  KM_5498_5_CranberrySauce: 29087,
  KM_5499_5_ValentinesDay: 29088,
  KM_55_L_Sicily: 29089,
  KM_550_M_TropicBreeze: 29090,
  KM_5500_1_InThePink: 29091,
  KM_5501_1_PinkGrapefruit: 29092,
  KM_5502_2_AlwaysRosey: 29093,
  KM_5503_3_Allyson: 29094,
  KM_5504_5_BananaBlossom: 29095,
  KM_5505_5_EgyptianRed: 29096,
  KM_5506_5_FireChi: 29097,
  KM_5507_1_FairyPrincess: 29098,
  KM_5508_1_PinkCupcake: 29099,
  KM_5509_1_Amaya: 29100,
  KM_551_M_CamelTan: 29101,
  KM_5510_2_ColoradoDawn: 29102,
  KM_5511_3_SpeckledEgg: 29103,
  KM_5512_5_LoveBirds: 29104,
  KM_5513_5_ValentineRed: 29105,
  KM_5514_1_PrincessElle: 29106,
  KM_5515_1_FancyPants: 29107,
  KM_5516_1_CameoRose: 29108,
  KM_5517_1_CherryCordial: 29109,
  KM_5518_2_RoseyPalm: 29110,
  KM_5519_3_PurpleStarburst: 29111,
  KM_552_D_FlemishGold: 29112,
  KM_5520_5_Pleasure: 29113,
  KM_5521_1_PinkPearl: 29114,
  KM_5522_1_FirstCrush: 29115,
  KM_5523_1_SparklingPink: 29116,
  KM_5524_1_BordeauxHint: 29117,
  KM_5525_2_CrepeMyrtle: 29118,
  KM_5526_3_FuschEAh: 29119,
  KM_5527_5_DragonsFire: 29120,
  KM_5528_1_PaleOrchidPetal: 29121,
  KM_5529_1_SamanthasRoom: 29122,
  KM_553_L_Bandshell: 29123,
  KM_5530_1_SweetMurmur: 29124,
  KM_5531_2_BerriesNCream: 29125,
  KM_5532_3_Pomtini: 29126,
  KM_5533_3_VictorianValentine: 29127,
  KM_5534_5_VintageWine: 29128,
  KM_5535_1_CupidsRevenge: 29129,
  KM_5536_1_ExtremeLavender: 29130,
  KM_5537_1_PurplePoodle: 29131,
  KM_5538_3_SunsetHorizon: 29132,
  KM_5539_3_DramaQueen: 29133,
  KM_554_L_Jocobean: 29134,
  KM_5540_5_ThorsThunder: 29135,
  KM_5541_5_Amaranthine: 29136,
  KM_5542_1_BunnyHop: 29137,
  KM_5543_1_MellowFlower: 29138,
  KM_5544_1_EmiliesDream: 29139,
  KM_5545_1_BlackberryYogurt: 29140,
  KM_5546_3_Violaceous: 29141,
  KM_5547_5_BerryBurst: 29142,
  KM_5548_5_WineTour: 29143,
  KM_5549_1_MountainHeather: 29144,
  KM_555_L_WoodPlank: 29145,
  KM_5550_1_SweetyPie: 29146,
  KM_5551_1_FadedViolet: 29147,
  KM_5552_2_ChiveBlossom: 29148,
  KM_5553_3_Prince: 29149,
  KM_5554_3_KarmaChameleon: 29150,
  KM_5555_5_PassionRazz: 29151,
  KM_5556_1_ElfinMagic: 29152,
  KM_5557_1_FootiePajamas: 29153,
  KM_5558_1_SkyBluePink: 29154,
  KM_5559_1_DarlingLilac: 29155,
  KM_556_M_ErwardonHall: 29156,
  KM_5560_3_FleurDeLis: 29157,
  KM_5561_3_Knight: 29158,
  KM_5562_5_GrapePopsicle: 29159,
  KM_5563_1_WinkPink: 29160,
  KM_5564_1_DivaGirl: 29161,
  KM_5565_1_SundayGloves: 29162,
  KM_5566_1_MonetMagic: 29163,
  KM_5567_2_KnightsTable: 29164,
  KM_5568_3_WineStroll: 29165,
  KM_5569_5_Bella: 29166,
  KM_557_M_Gatehouse: 29167,
  KM_5570_1_EchosOfLove: 29168,
  KM_5571_1_BlushedVelvet: 29169,
  KM_5572_1_SpringBoutique: 29170,
  KM_5573_3_Voila: 29171,
  KM_5574_3_RebelRouser: 29172,
  KM_5575_3_PinkNPurple: 29173,
  KM_5576_5_PolkaDotPlum: 29174,
  KM_5577_1_AngelicChair: 29175,
  KM_5578_1_KellieBelle: 29176,
  KM_5579_2_PinkPampas: 29177,
  KM_558_D_TriangleLodge: 29178,
  KM_5580_2_ParlorRose: 29179,
  KM_5581_3_BerryBliss: 29180,
  KM_5582_5_ChichaMorada: 29181,
  KM_5583_5_Vincotto: 29182,
  KM_5584_1_HeartStone: 29183,
  KM_5585_1_HapsburgCourt: 29184,
  KM_5586_1_VictorianCottage: 29185,
  KM_5587_2_BreathtakingView: 29186,
  KM_5588_2_OnTheNile: 29187,
  KM_5589_3_WipedOut: 29188,
  KM_559_L_AlmondTree: 29189,
  KM_5590_5_Indulgence: 29190,
  KM_5591_1_Ethereal: 29191,
  KM_5592_1_FrostedGrape: 29192,
  KM_5593_2_PurpleDragon: 29193,
  KM_5594_3_VioletPersuasion: 29194,
  KM_5595_5_PlushPurple: 29195,
  KM_5596_5_FunkieFriday: 29196,
  KM_5597_5_TreasureSeeker: 29197,
  KM_5598_1_FlowerGirlDress: 29198,
  KM_5599_1_DaintyFlower: 29199,
  KM_56_L_Candelabra: 29200,
  KM_560_L_Bleachedwood: 29201,
  KM_5600_1_CoinPurse: 29202,
  KM_5601_1_Perspective: 29203,
  KM_5602_2JayceysFavorite: 29204,
  KM_5603_3_WizardsBrew: 29205,
  KM_5604_5_WhenBlueMetRed: 29206,
  KM_5605_1_CalmTint: 29207,
  KM_5606_1_Awakened: 29208,
  KM_5607_1_BashfulPansy: 29209,
  KM_5608_1_VikingDiva: 29210,
  KM_5609_2_ArielsDelight: 29211,
  KM_561_L_SnipOfTannin: 29212,
  KM_5610_3_DistinctPurple: 29213,
  KM_5611_5_Amethyst: 29214,
  KM_5612_1_VeiledViolet: 29215,
  KM_5613_1_HeavenlyHaze: 29216,
  KM_5614_1_VioletSweetPea: 29217,
  KM_5615_2_OpulentViolet: 29218,
  KM_5616_3_PurpleAmethyst: 29219,
  KM_5617_3_ThirstyThursday: 29220,
  KM_5618_5_EveningLavender: 29221,
  KM_5619_1_DustyPlum: 29222,
  KM_562_M_WiseOwl: 29223,
  KM_5620_1_AwesomeAura: 29224,
  KM_5621_1_LavenderDream: 29225,
  KM_5622_5_CosmoPurple: 29226,
  KM_5623_3_VisionQuest: 29227,
  KM_5624_3_PurpleMoutainMajesty: 29228,
  KM_5625_5_Geode: 29229,
  KM_5626_1_IrisIce: 29230,
  KM_5627_1_BlissfulMeditation: 29231,
  KM_5628_1_PurplePjs: 29232,
  KM_5629_2_WildOrchid: 29233,
  KM_563_M_FigCookie: 29234,
  KM_5630_2_IndigoChild: 29235,
  KM_5631_3_InnerJourney: 29236,
  KM_5632_5_SpiritDance: 29237,
  KM_5633_1_Whirlwind: 29238,
  KM_5634_1_MoonDust: 29239,
  KM_5635_1_CottonCandy: 29240,
  KM_5636_2_LavenderPhlox: 29241,
  KM_5637_2_RipVanPeriwinkle: 29242,
  KM_5638_3_Orbital: 29243,
  KM_5639_5_JewelCase: 29244,
  KM_564_D_CoffeeOle: 29245,
  KM_5640_1_ChantillyLace: 29246,
  KM_5641_1_PeaceNQuiet: 29247,
  KM_5642_1_BlueHydrangea: 29248,
  KM_5643_1_CalmInterlude: 29249,
  KM_5644_2_HairRibbon: 29250,
  KM_5645_3_MidnightViolet: 29251,
  KM_5646_5_BlueberryMuffin: 29252,
  KM_5647_1_Breathless: 29253,
  KM_5648_1_KundaliniBliss: 29254,
  KM_5649_1_WeddingFlowers: 29255,
  KM_565_L_CrestedButte: 29256,
  KM_5650_2_RoyalMile: 29257,
  KM_5651_2_CosmicEnergy: 29258,
  KM_5652_3_BluePotato: 29259,
  KM_5653_5_VioletsAreBlue: 29260,
  KM_5654_1_CoolingTrend: 29261,
  KM_5655_1_ClarySage: 29262,
  KM_5656_1_WisteriaTrellis: 29263,
  KM_5657_2_JazzTune: 29264,
  KM_5658_3_DuskyGrape: 29265,
  KM_5659_3_EarlyDawn: 29266,
  KM_566_L_SecludedCottage: 29267,
  KM_5660_5_BlackMagic: 29268,
  KM_5661_1_PastelDay: 29269,
  KM_5662_1_TakeThePlunge: 29270,
  KM_5663_1_MoonGoddess: 29271,
  KM_5664_1_VioletBouquet: 29272,
  KM_5665_2_FragrantSatchel: 29273,
  KM_5666_3_GrapeHarvest: 29274,
  KM_5667_5_Excalibur: 29275,
  KM_5668_1_FallingTears: 29276,
  KM_5669_1_StarMagic: 29277,
  KM_567_L_Tassajara: 29278,
  KM_5670_2_DawnDog: 29279,
  KM_5671_3_OutOfPlumb: 29280,
  KM_5672_3_MedievalWine: 29281,
  KM_5673_3_MysticalTrip: 29282,
  KM_5674_5_PurpleHeart: 29283,
  KM_5675_1_BridalVeil: 29284,
  KM_5676_1_Capella: 29285,
  KM_5677_1_SilkChiffon: 29286,
  KM_5678_1_WindowBox: 29287,
  KM_5679_2_WindsorHaze: 29288,
  KM_568_M_Coyote: 29289,
  KM_5680_3_Goosebill: 29290,
  KM_5681_5_BlackDahlia: 29291,
  KM_5682_1_CapeHope: 29292,
  KM_5683_1_DustyGray: 29293,
  KM_5684_1_SilverFox: 29294,
  KM_5685_1_LoveStruckChinchilla: 29295,
  KM_5686_2_AngryGargoyle: 29296,
  KM_5687_3_WindCave: 29297,
  KM_5688_5_BlackDragonsCaldron: 29298,
  KM_5689_1_BonnieDuneBeach: 29299,
  KM_569_M_Hamlet: 29300,
  KM_5690_2_SaltWaterTaffy: 29301,
  KM_5691_1_Clambake: 29302,
  KM_5692_2_Esplanade: 29303,
  KM_5693_3_BeachBoardwalk: 29304,
  KM_5694_3_MeringueTips: 29305,
  KM_5695_3_ToweringCliffs: 29306,
  KM_5696_1_LagunaBeach: 29307,
  KM_5697_2_ShrimpBoudin: 29308,
  KM_5698_3_PresidioPlaza: 29309,
  KM_5699_5_TamarindTart: 29310,
  KM_57_L_Caledonia: 29311,
  KM_570_D_OuterBanks: 29312,
  KM_5700_2_SummerHill: 29313,
  KM_5701_3_RoastedCoconut: 29314,
  KM_5702_5_ArrowCreek: 29315,
  KM_5703_1_ChowderBowl: 29316,
  KM_5704_2_BluffStone: 29317,
  KM_5705_3_PioneerVillage: 29318,
  KM_5706_5_BonniesBench: 29319,
  KM_5707_3_WoodbridgeTrail: 29320,
  KM_5708_3_LoversLeap: 29321,
  KM_5709_5_MillCreek: 29322,
  KM_571_L_PandaBear: 29323,
  KM_5710_1_SundayDrive: 29324,
  KM_5711_2_CountryRubble: 29325,
  KM_5712_3_CookieCrumb: 29326,
  KM_5713_3_MulledCider: 29327,
  KM_5714_2_DunesManor: 29328,
  KM_5715_3_TanOak: 29329,
  KM_5716_3_RodeoRoundup: 29330,
  KM_5717_2_StackedLimestone: 29331,
  KM_5718_3_WavesOfGrain: 29332,
  KM_5719_3_Corkboard: 29333,
  KM_572_L_MagicStone: 29334,
  KM_5720_5_ManCave: 29335,
  KM_5721_3_SugarPie: 29336,
  KM_5722_3_PartridgeKnoll: 29337,
  KM_5723_5_GoldSpike: 29338,
  KM_5724_1_TheGoldenState: 29339,
  KM_5725_2_SanCarlosPlaza: 29340,
  KM_5726_3_GoldenAge: 29341,
  KM_5727_3_Cheers: 29342,
  KM_5728_2_AfternoonStroll: 29343,
  KM_5729_2_FoothillDrive: 29344,
  KM_573_L_WeatheredBranch: 29345,
  KM_5730_3_MotherLode: 29346,
  KM_5731_1_ChampagneBubble: 29347,
  KM_5732_2_VerandaHills: 29348,
  KM_5733_3_SonoraHills: 29349,
  KM_5734_3_GoldCanyon: 29350,
  KM_5735_2_BeachsideVilla: 29351,
  KM_5736_3_QuailValley: 29352,
  KM_5737_5_WovenBasket: 29353,
  KM_5738_1_Cornerstone: 29354,
  KM_5739_1_FabulousForties: 29355,
  KM_574_M_RollingStone: 29356,
  KM_5740_3_Montecito: 29357,
  KM_5741_3_CricketsCross: 29358,
  KM_5742_3_CanyonFalls: 29359,
  KM_5743_5_MossBeach: 29360,
  KM_5744_5_Pinebrook: 29361,
  KM_5745_2_NativeFlora: 29362,
  KM_5746_3_TurtleBay: 29363,
  KM_5747_3_SugarPine: 29364,
  KM_5748_5_NaturesGate: 29365,
  KM_5749_2_LittleValley: 29366,
  KM_575_M_PebblestoneClay: 29367,
  KM_5750_3_MountTam: 29368,
  KM_5751_5_CoastlineTrail: 29369,
  KM_5752_1_NatureSpirits: 29370,
  KM_5753_2_ApplegatePark: 29371,
  KM_5754_3_PaseoVerde: 29372,
  KM_5755_5_LaGrange: 29373,
  KM_5756_2_SunsetMeadow: 29374,
  KM_5757_3_FarmersMarket: 29375,
  KM_5758_5_RollingHills: 29376,
  KM_5759_2_TownhouseTaupe: 29377,
  KM_576_D_Monastery: 29378,
  KM_5760_3_WindmillPark: 29379,
  KM_5761_5_ColusaWetlands: 29380,
  KM_5762_5_HikingBoots: 29381,
  KM_5763_3_CrockerGrove: 29382,
  KM_5764_3_MendocinoHills: 29383,
  KM_5765_3_ElderCreek: 29384,
  KM_5766_1_WhisperRidge: 29385,
  KM_5767_2_Greige: 29386,
  KM_5768_3_SageAdvice: 29387,
  KM_5769_5_Backcountry: 29388,
  KM_577_L_Quiet: 29389,
  KM_5770_2_DigitalGarage: 29390,
  KM_5771_2_AppleHill: 29391,
  KM_5772_3_PalmLane: 29392,
  KM_5773_1_RawSugar: 29393,
  KM_5774_3_WhitneyOaks: 29394,
  KM_5775_3_EmpireRanch: 29395,
  KM_5776_5_BancroftVillage: 29396,
  KM_5777_2_CanneryPark: 29397,
  KM_5778_3_SheepskinGloves: 29398,
  KM_5779_3_EaglesMeadow: 29399,
  KM_578_L_Pufferbilly: 29400,
  KM_5780_2_Stonelake: 29401,
  KM_5781_3_LightTruffle: 29402,
  KM_5782_3_OnTheAvenue: 29403,
  KM_5783_3_VillageSquare: 29404,
  KM_5784_3_CreekBay: 29405,
  KM_5785_3_CountryClub: 29406,
  KM_5786_5_RiverBank: 29407,
  KM_5787_1_ParisianCashmere: 29408,
  KM_5788_2_TranquilTaupe: 29409,
  KM_5789_3_ShadowCliff: 29410,
  KM_579_L_Gavel: 29411,
  KM_5790_5_GrapevineCanyon: 29412,
  KM_5791_3_Northpointe: 29413,
  KM_5792_3_StackedStone: 29414,
  KM_5793_3_JasmineHollow: 29415,
  KM_5794_1_EmilyAnnTan: 29416,
  KM_5795_2_TeddysTaupe: 29417,
  KM_5796_3_EvenEvan: 29418,
  KM_5797_5_WoodwardPark: 29419,
  KM_5798_3_LapDog: 29420,
  KM_5799_5_DowntownBennyBrown: 29421,
  KM_58_M_Aloha: 29422,
  KM_580_M_BeigeTemple: 29423,
  KM_5800_5_SausalitoRidge: 29424,
  KM_5801_1_WinterMorningMist: 29425,
  KM_5802_2_ByTheSea: 29426,
  KM_5803_3_AmericanRiver: 29427,
  KM_5804_5_YachtClub: 29428,
  KM_5805_3_BayWharf: 29429,
  KM_5806_3_FeatherFalls: 29430,
  KM_5807_3_RollingSea: 29431,
  KM_5808_1_SoothingBreeze: 29432,
  KM_5809_1_ChanceOfShowers: 29433,
  KM_581_M_Crossroads: 29434,
  KM_5810_3_LondonSquare: 29435,
  KM_5811_3_BigDaddyBlue: 29436,
  KM_5812_5_WinterSolstice: 29437,
  KM_5813_2_DuskyGrouse: 29438,
  KM_5815_2_ActorsStar: 29439,
  KM_5816_2_HarrisonGray: 29440,
  KM_5817_3_PebbleBeach: 29441,
  KM_5818_5_Kettleman: 29442,
  KM_5819_1_RotundaWhite: 29443,
  KM_582_D_Woodstock: 29444,
  KM_5820_2_AluminumSky: 29445,
  KM_5821_3_SandpiperCove: 29446,
  KM_5822_1_SanFranciscoFog: 29447,
  KM_5823_2_CityTower: 29448,
  KM_5824_3_WintersPark: 29449,
  KM_5825_NotMyFault: 2034,
  KM_5826_VolcanicRock: 2035,
  KM_5827_1_UnionStation: 29450,
  KM_5828_2_BigBand: 29451,
  KM_583_L_FrenchBread: 29452,
  KM_584_L_Tapas: 29453,
  KM_585_L_KenwoodHouse: 29454,
  KM_586_M_Palazetto: 29455,
  KM_587_M_BradfordBrown: 29456,
  KM_588_D_CafeKahlua: 29457,
  KM_589_L_Artiste: 29458,
  KM_59_M_Organza: 29459,
  KM_590_L_SanMarco: 29460,
  KM_591_L_ProspectTower: 29461,
  KM_592_M_Northborough: 29462,
  KM_593_M_BeachPebble: 29463,
  KM_594_D_ClevelandBrown: 29464,
  KM_595_L_Ambria: 29465,
  KM_596_L_CoffeeHouse: 29466,
  KM_597_L_PecanPie: 29467,
  KM_598_M_Lampasas: 29468,
  KM_599_M_CedarChest: 29469,
  KM_6_D_SanLorenzo: 29470,
  KM_60_D_SonoranSunset: 29471,
  KM_600_D_Brownbridge: 29472,
  KM_601_L_Homestead: 29473,
  KM_602_L_HoneyBrown: 29474,
  KM_603_L_EaglesWings: 29475,
  KM_604_M_HighSierra: 29476,
  KM_605_M_Sotheby: 29477,
  KM_606_D_Cola: 29478,
  KM_607_L_Deauville: 29479,
  KM_608_L_MissionViejo: 29480,
  KM_609_L_RosePetals: 29481,
  KM_61_L_AmbrosianAngel: 29482,
  KM_610_M_RedPotato: 29483,
  KM_611_M_AuburnTresses: 29484,
  KM_612_D_Bridgewood: 29485,
  KM_613_L_TwilightMauve: 29486,
  KM_614_L_Tuscano: 29487,
  KM_615_L_WoodenDuck: 29488,
  KM_616_M_Bramblewood: 29489,
  KM_617_M_SlyFox: 29490,
  KM_618_D_CapeProvince: 29491,
  KM_619_L_Candace: 29492,
  KM_62_L_SeptemberBlush: 29493,
  KM_620_L_AmberRose: 29494,
  KM_621_L_RomanMarble: 29495,
  KM_622_M_BooneCounty: 29496,
  KM_623_M_ViennaCake: 29497,
  KM_624_D_Rafael: 29498,
  KM_625_L_OperaRoseBlush: 29499,
  KM_626_L_Vintage: 29500,
  KM_627_L_Veronesia: 29501,
  KM_628_M_Paladio: 29502,
  KM_629_M_Quintescence: 29503,
  KM_63_L_ShulaSatin: 29504,
  KM_630_D_FlemishPainting: 29505,
  KM_631_L_Husky: 29506,
  KM_632_L_DoesEyes: 29507,
  KM_633_L_MauveDrizzle: 29508,
  KM_634_M_Mauvewood: 29509,
  KM_635_M_BeetRoot: 29510,
  KM_636_D_GrouseMountain: 29511,
  KM_637_L_Gibraltar: 29512,
  KM_638_L_OakTerrace: 29513,
  KM_639_L_CocPazzo: 29514,
  KM_64_M_PeachBlossom: 29515,
  KM_640_M_SepiaTone: 29516,
  KM_641_M_QuarryStone: 29517,
  KM_642_D_Chameau: 29518,
  KM_643_L_Whitehall: 29519,
  KM_644_L_AncientEcho: 29520,
  KM_645_L_Esperanza: 29521,
  KM_646_M_RomanArch: 29522,
  KM_647_M_Epoch: 29523,
  KM_648_D_Montica: 29524,
  KM_649_L_CulturedPearl: 29525,
  KM_65_M_PlainPeach: 29526,
  KM_650_L_WhistlerMountain: 29527,
  KM_651_L_LunarRock: 29528,
  KM_652_M_PhoenixAsh: 29529,
  KM_653_M_Chinot: 29530,
  KM_654_D_OldStone: 29531,
  KM_655_L_Tightrope: 29532,
  KM_656_L_ChapelHill: 29533,
  KM_657_L_TweedSuit: 29534,
  KM_658_M_NewHope: 29535,
  KM_659_M_Pinstripe: 29536,
  KM_66_D_TropicalFruit: 29537,
  KM_660_D_SecretCode: 29538,
  KM_661_L_Tinsel: 29539,
  KM_662_L_SilverSpur: 29540,
  KM_663_L_Zinc: 29541,
  KM_664_M_TuxedoGray: 29542,
  KM_665_M_NovemberSky: 29543,
  KM_666_D_DeepMuddy: 29544,
  KM_667_L_Belfry: 29545,
  KM_668_L_Silhouette: 29546,
  KM_669_L_SterlingSilver: 29547,
  KM_67_L_Atascadero: 29548,
  KM_670_M_Conceal: 29549,
  KM_671_M_StormySky: 29550,
  KM_672_D_BlackBerry: 29551,
  KM_673_L_Bog: 29552,
  KM_674_L_Seville: 29553,
  KM_675_L_MirageLake: 29554,
  KM_676_M_HalyardLine: 29555,
  KM_677_M_Ironstone: 29556,
  KM_678_D_DownUnder: 29557,
  KM_679_L_Silverquick: 29558,
  KM_68_L_Escondido: 29559,
  KM_680_L_GrayShade: 29560,
  KM_681_L_SilverKing: 29561,
  KM_682_M_GeoduckClam: 29562,
  KM_683_M_PathOfHope: 29563,
  KM_684_D_Blacksburg: 29564,
  KM_685_L_BlownGlass: 29565,
  KM_686_L_TwentiethCentury: 29566,
  KM_687_L_GondolanMelody: 29567,
  KM_688_M_Sommelier: 29568,
  KM_689_M_PewterCup: 29569,
  KM_69_L_PeachTree: 29570,
  KM_690_D_Dolphin: 29571,
  KM_691_L_FuzzyBear: 29572,
  KM_692_L_ShamCastle: 29573,
  KM_693_L_PewterPot: 29574,
  KM_694_M_PeacefulGrotto: 29575,
  KM_695_M_CraggyBluff: 29576,
  KM_696_D_MadisonAvenue: 29577,
  KM_697_L_VailSnow: 29578,
  KM_698_L_AvanteGarde: 29579,
  KM_699_L_Worcester: 29580,
  KM_7_L_Tia: 29581,
  KM_70_M_FourSeasons: 29582,
  KM_700_M_Citified: 29583,
  KM_701_M_StoneAge: 29584,
  KM_702_D_MuddyCreek: 29585,
  KM_703_L_CliffsOfDover: 29586,
  KM_704_L_SilverCascade: 29587,
  KM_705_L_EtonGray: 29588,
  KM_706_M_GraphiteShadow: 29589,
  KM_707_M_Londoner: 29590,
  KM_708_D_HockeyPuck: 29591,
  KM_709_L_ColorOfLight: 29592,
  KM_71_M_AutumnGlory: 29593,
  KM_710_L_Glisten: 29594,
  KM_711_L_PowderedGraphite: 29595,
  KM_712_M_Masolino: 29596,
  KM_713_M_Everglades: 29597,
  KM_714_D_Landmark: 29598,
  KM_715_L_Brookhaven: 29599,
  KM_716_L_SteamboatSprings: 29600,
  KM_717_L_Tadpole: 29601,
  KM_718_M_HamsteadHeath: 29602,
  KM_719_M_DunbarCastle: 29603,
  KM_72_D_Rialto: 29604,
  KM_720_D_DelCovina: 29605,
  KM_73_L_NovatoPeach: 29606,
  KM_74_L_CrownImperial: 29607,
  KM_75_L_Casaba: 29608,
  KM_76_L_Alhambra: 29609,
  KM_77_M_RioVista: 29610,
  KM_78_D_Torch: 29611,
  KM_79_L_PeachChampagne: 29612,
  KM_8_L_PaleMarigold: 29613,
  KM_80_L_PersianMelon: 29614,
  KM_81_L_AutumnDay: 29615,
  KM_82_M_SoftShell: 29616,
  KM_83_M_Trattoria: 29617,
  KM_84_D_EarthFriendly: 29618,
  KM_85_L_PeachPhlox: 29619,
  KM_86_L_TropicalPeach: 29620,
  KM_87_L_JessicasGarden: 29621,
  KM_88_M_Arleta: 29622,
  KM_89_M_GeorgiaPeach: 29623,
  KM_9_L_Snapdragon: 29624,
  KM_90_D_BurstingOrange: 29625,
  KM_91_L_BarelyPink: 29626,
  KM_92_L_ParasolPink: 29627,
  KM_93_L_SantaRosa: 29628,
  KM_94_M_Rosemonde: 29629,
  KM_95_M_Snowflower: 29630,
  KM_96_D_Intrigue: 29631,
  KM_97_L_MorningSmile: 29632,
  KM_98_L_CherryValley: 29633,
  KM_99_L_Lompoc: 29634,
  KM_A1_Cabaret: 29635,
  KM_A10_CanCan: 29636,
  KM_A100_Blackbird: 29637,
  KM_a105_HappyYipee: 29638,
  KM_A11_Cairo: 29639,
  KM_a115_MadForMango: 29640,
  KM_A12_OlympicTorch: 29641,
  KM_a125_DizzyDays: 29642,
  KM_A13_MagnetRed: 29643,
  KM_a135_OrangeZest: 29644,
  KM_A14_Cockspur: 29645,
  KM_a145_HuntersOrange: 29646,
  KM_a15_BentoBox: 29647,
  KM_A15_StElmosFire: 29648,
  KM_a155_Energized: 29649,
  KM_A16_RedIrene: 29650,
  KM_a165_TreeFrog: 29651,
  KM_A17_Nasturtium: 29652,
  KM_a175_LadyLuck: 29653,
  KM_A18_FrostedApricot: 29654,
  KM_a185_PuttingGreen: 29655,
  KM_A19_Pontiac: 29656,
  KM_a195_OnealGreen: 29657,
  KM_A2_RedSatin: 29658,
  KM_A20_Kahlua: 29659,
  KM_a205_RangerStation: 29660,
  KM_A21_Cinnabar: 29661,
  KM_a215_TuscanOlive: 29662,
  KM_A22_Barbecue: 29663,
  KM_a225_MermaidsKiss: 29664,
  KM_A23_Molasses: 29665,
  KM_a235_SilkSari: 29666,
  KM_A24_TateBrown: 29667,
  KM_a245_TitalPool: 29668,
  KM_A25_AgedWalnut: 29669,
  KM_a25_CrossMyHeart: 29670,
  KM_a255_TropicalForest: 29671,
  KM_A26_Raisin: 29672,
  KM_a265_BellyFlop: 29673,
  KM_A27_Borneo: 29674,
  KM_a275_CaribbeanSwim: 29675,
  KM_A28_Malacca: 29676,
  KM_a285_BayIslePointe: 29677,
  KM_A29_Pinto: 29678,
  KM_a295_PeacockBlue: 29679,
  KM_A3_TartanRed: 29680,
  KM_A30_Thatch: 29681,
  KM_a305_BlueCuracao: 29682,
  KM_A31_TerraOrange: 29683,
  KM_a315_TinyBubbles: 29684,
  KM_A32_Amigo: 29685,
  KM_a325_BlueBirdDay: 29686,
  KM_A33_Halloween: 29687,
  KM_a335_CleosBath: 29688,
  KM_A34_TawnyLily: 29689,
  KM_a345_ElmersEcho: 29690,
  KM_A35_Bengali: 29691,
  KM_a35_HauteCouture: 29692,
  KM_a355_WillowBlue: 29693,
  KM_A36_Oriole: 29694,
  KM_a365_Valentino: 29695,
  KM_A37_BoJangles: 29696,
  KM_a375_OrchidLei: 29697,
  KM_A38_Gaiety: 29698,
  KM_a385_GypsyJewels: 29699,
  KM_A39_BellRinger: 29700,
  KM_a395_AcaiBerry: 29701,
  KM_A4_Poinsettia: 29702,
  KM_A40_Poppycock: 29703,
  KM_a405_Zimidar: 29704,
  KM_A41_Jessica: 29705,
  KM_a415_BellaSera: 29706,
  KM_A42_Lantana: 29707,
  KM_a425_WildIris: 29708,
  KM_A43_BlackEyedSusan: 29709,
  KM_a435_QueesnOfHearts: 29710,
  KM_A44_Forsythia: 29711,
  KM_a445_RoosterComb: 29712,
  KM_A45_Alouette: 29713,
  KM_a45_RebelRed: 29714,
  KM_a455_RedVelvet: 29715,
  KM_A46_Dill: 29716,
  KM_a465_Boxcar: 29717,
  KM_A47_RomneyGold: 29718,
  KM_a475_HeirloomTomato: 29719,
  KM_A48_Bronzeberry: 29720,
  KM_a485_NectarOfTheGods: 29721,
  KM_A49_CarterHouse: 29722,
  KM_a495_FruitYard: 29723,
  KM_A5_WoodpeckerRed: 29724,
  KM_A50_Vireo: 29725,
  KM_a505_MauiMaiTai: 29726,
  KM_A51_Wilderness: 29727,
  KM_a515_MayanGold: 29728,
  KM_A52_OliveGold: 29729,
  KM_a525_GoldenPilsner: 29730,
  KM_A53_Pampas: 29731,
  KM_a535_CopperCreek: 29732,
  KM_A54_AfricanQueen: 29733,
  KM_a545_TopazMountain: 29734,
  KM_A55_Chatsworth: 29735,
  KM_a55_Lolita: 29736,
  KM_a555_LizardLegs: 29737,
  KM_A56_Erin: 29738,
  KM_a565_PinyonPine: 29739,
  KM_A57_TropicBird: 29740,
  KM_a575_HippieTrail: 29741,
  KM_A58_TahitianPalm: 29742,
  KM_a585_SprucedUp: 29743,
  KM_A59_GreenSong: 29744,
  KM_a595_SecondNature: 29745,
  KM_A6_CocktailSauce: 29746,
  KM_A60_JingleBells: 29747,
  KM_a605_OliveLeaf: 29748,
  KM_A61_Kermit: 29749,
  KM_a615_SherwoodForest: 29750,
  KM_A62_GardenParty: 29751,
  KM_a625_Parkview: 29752,
  KM_A63_Glenbrook: 29753,
  KM_a635_GreenValley: 29754,
  KM_A64_DuchessGreen: 29755,
  KM_a645_RidingBoots: 29756,
  KM_a65_Amore: 29757,
  KM_A65_Holly: 29758,
  KM_a655_GroundBean: 29759,
  KM_A66_GreenBark: 29760,
  KM_a665_SantanaSoul: 29761,
  KM_A67_Renaissance: 29762,
  KM_a675_RailroadTies: 29763,
  KM_A68_HascombGreen: 29764,
  KM_a685_LeatherSatchel: 29765,
  KM_A69_ExecutiveSuite: 29766,
  KM_a695_RoastedKona: 29767,
  KM_A7_RedTassel: 29768,
  KM_A70_TropicNight: 29769,
  KM_a705_ZinCluster: 29770,
  KM_A71_Adirondack: 29771,
  KM_a715_TwistedVine: 29772,
  KM_A72_GoyaJade: 29773,
  KM_a725_Barnwood: 29774,
  KM_A73_AliBaba: 29775,
  KM_a735_GingerRoot: 29776,
  KM_A74_FestiveAqua: 29777,
  KM_a745_Stagecoach: 29778,
  KM_A75_NavyTeal: 29779,
  KM_a755_CellarDoor: 29780,
  KM_a75B_icyclette: 29781,
  KM_A76_ShutterBlue: 29782,
  KM_a765_LogCabin: 29783,
  KM_A77_Etude: 29784,
  KM_a775_BrownBear: 29785,
  KM_A78_Alsmeer: 29786,
  KM_a785_CountrySky: 29787,
  KM_A79_VacationBlue: 29788,
  KM_a795_LightsOut: 29789,
  KM_A8_Firebird: 29790,
  KM_A80_DeepNeptune: 29791,
  KM_a805_Urbanite: 29792,
  KM_A81_EveningCityscape: 2036,
  KM_A81_Yachtsman: 29793,
  KM_a815_EveningCityscape: 29794,
  KM_A82_Crusader: 29795,
  KM_a825_LampPost: 29796,
  KM_A83_NavyBlue: 29797,
  KM_a835_MidnightSky: 29798,
  KM_A84_Baronet: 29799,
  KM_a845_StarlitEve: 29800,
  KM_A85_Inferno: 29801,
  KM_a855_FingerPrint: 29802,
  KM_A86_GrapeJelly: 29803,
  KM_a865_MidnightEscape: 29804,
  KM_A87_ScubaDiver: 29805,
  KM_a875_Stiletto: 29806,
  KM_A88_Cobalt: 29807,
  KM_a885_JapaneseSable: 29808,
  KM_A89_ValleyOfStars: 29809,
  KM_a895_BlackOak: 29810,
  KM_A9_GeorgiaClay: 29811,
  KM_A90_Ultramarine: 29812,
  KM_a905_Blackjack: 29813,
  KM_A91_Palazzo: 29814,
  KM_a915_BlackIce: 29815,
  KM_A92_AegeanSong: 29816,
  KM_A93_Andante: 29817,
  KM_A94_OpalBasil: 29818,
  KM_A95_Trianon: 29819,
  KM_a95_YuzuJam: 29820,
  KM_A96_BlackCherry: 29821,
  KM_A97_BlackAngus: 29822,
  KM_A98_Cosmic: 29823,
  KM_A99_Licorice: 29824,
  KM_Ac10Y_BuonGusto: 29825,
  KM_Ac11Y_FireOrange: 29826,
  KM_Ac12Y_RedClay: 29827,
  KM_Ac13N_Pigskin: 29828,
  KM_Ac14N_HenredonHouse: 29829,
  KM_Ac15N_RedBluff: 29830,
  KM_Ac16N_MarsRed: 29831,
  KM_Ac17N_RustyIron: 29832,
  KM_Ac18N_RussetRed: 29833,
  KM_Ac19R_TerraRosa: 29834,
  KM_Ac1Y_SunlitPlaza: 29835,
  KM_Ac201Y_SunlitPlaza: 29836,
  KM_Ac202Y_YellowPepper: 29837,
  KM_Ac2035_MustardField: 29838,
  KM_Ac2045_CancunGold: 29839,
  KM_Ac2055_GoldTrinket: 29840,
  KM_Ac206Y_TreasureGold: 29841,
  KM_Ac2075_EndOfTheRainbow: 29842,
  KM_Ac208Y_HappyHoliday: 29843,
  KM_Ac209Y_Toujours: 29844,
  KM_Ac20R_FireEngine: 29845,
  KM_Ac2105_GildedVision: 29846,
  KM_Ac2115_LightMyFire: 29847,
  KM_Ac2125_MontanaDust: 29848,
  KM_Ac2135_HighSociety: 29849,
  KM_Ac2145_LeafRust: 29850,
  KM_Ac2155_AmericanRose: 29851,
  KM_Ac2165_RedAlert: 29852,
  KM_Ac217R_TerraRosa: 29853,
  KM_Ac218R_FireEngine: 29854,
  KM_Ac219R_ChristmasRed: 29855,
  KM_Ac21R_ChristmasRed: 29856,
  KM_Ac220_RAntoinetteRed: 29857,
  KM_Ac221R_CandyCane: 29858,
  KM_Ac2225_BrightBurgundy: 29859,
  KM_Ac2235_DarkCherryTart: 29860,
  KM_Ac2245_RedRaisin: 29861,
  KM_Ac2255_GrapeRiot: 29862,
  KM_Ac2265_FoolsFuscia: 29863,
  KM_Ac2275_Gailberry: 29864,
  KM_Ac2285_Plumbago: 29865,
  KM_Ac229B_Inspiration: 29866,
  KM_Ac22R_AntoinetteRed: 29867,
  KM_Ac2305_RomanticKnight: 29868,
  KM_Ac231B_RoyalWave: 29869,
  KM_Ac232B_MidnightInterlude: 29870,
  KM_Ac233B_InkySea: 29871,
  KM_Ac234B_WavyNavy: 29872,
  KM_Ac235B_TealShadow: 29873,
  KM_Ac236B_AhoyBlue: 29874,
  KM_Ac2375_SophisticatedTeal: 29875,
  KM_Ac2385_GreatBlueGreen: 29876,
  KM_Ac2395_Equinox: 29877,
  KM_Ac23R_CandyCane: 29878,
  KM_Ac2405_Zaire: 29879,
  KM_Ac241Y_GlobalVillage: 29880,
  KM_Ac2425_LotsOfLime: 29881,
  KM_Ac2435_BabySprout: 29882,
  KM_Ac2445_EmeraldLights: 29883,
  KM_Ac2455_EchoGreen: 29884,
  KM_Ac2465_Greenback: 29885,
  KM_Ac2475_DeepLodenGreen: 29886,
  KM_Ac2485_BayouMistery: 29887,
  KM_Ac2495_RareEarth: 29888,
  KM_Ac24R_KingArthur: 29889,
  KM_Ac2505_UmberShadow: 29890,
  KM_Ac2515_VermeersFields: 29891,
  KM_Ac2525_RockyMountain: 29892,
  KM_Ac2535_DarkNight: 29893,
  KM_Ac2545_Enigma: 29894,
  KM_Ac2555_Draconia: 29895,
  KM_Ac2565_DarkGlasses: 29896,
  KM_Ac2575_IronOre: 29897,
  KM_Ac2585_RomanChariot: 29898,
  KM_Ac2595_Dungeon: 29899,
  KM_Ac25N_Obsession: 29900,
  KM_Ac2605_Defense: 29901,
  KM_Ac26N_JerryBerry: 29902,
  KM_Ac27N_PinotNoir: 29903,
  KM_Ac28N_RegalRose: 29904,
  KM_Ac29N_Trish: 29905,
  KM_Ac2Y_HappyHoliday: 29906,
  KM_Ac30N_Roxbury: 29907,
  KM_Ac31N_MastersWork: 29908,
  KM_Ac32N_SparklingWine: 29909,
  KM_Ac33N_CrushedVelvet: 29910,
  KM_Ac34N_Chateau: 29911,
  KM_Ac35N_PrincelyGrandeur: 29912,
  KM_Ac36N_Mythology: 29913,
  KM_Ac37N_Superstitious: 29914,
  KM_Ac38N_Michelangelo: 29915,
  KM_Ac39N_RomanticKnight: 29916,
  KM_Ac3Y_YellowPepper: 29917,
  KM_Ac40N_VividViolet: 29918,
  KM_Ac41N_Encore: 29919,
  KM_Ac42N_RealPurple: 29920,
  KM_Ac43N_Crusade: 29921,
  KM_Ac44B_LegendaryFable: 29922,
  KM_Ac45N_DarkNavy: 29923,
  KM_Ac46N_ConnecticutYankee: 29924,
  KM_Ac47N_TourDeFrance: 29925,
  KM_Ac48N_Madagascar: 29926,
  KM_Ac49B_Goya: 29927,
  KM_Ac4Y_FortuneGold: 29928,
  KM_Ac50B_JungleJohn: 29929,
  KM_Ac51N_DiplomatBlue: 29930,
  KM_Ac52B_EllingsonBlue: 29931,
  KM_Ac53B_RegettaStorico: 29932,
  KM_Ac54B_Fusion: 29933,
  KM_Ac55N_ManifestDestiny: 29934,
  KM_Ac56B_Euphoric: 29935,
  KM_Ac57B_BaroqueSplendor: 29936,
  KM_Ac58B_Alcovo: 29937,
  KM_Ac59B_ArabianNight: 29938,
  KM_Ac5Y_TreasureGold: 29939,
  KM_Ac60B_DistantSky: 29940,
  KM_Ac61N_DollarSign: 29941,
  KM_Ac62N_Paradiso: 29942,
  KM_Ac63N_ArtificialTurf: 29943,
  KM_Ac64N_Wimbledon: 29944,
  KM_Ac65N_WildPlanet: 29945,
  KM_Ac66N_Zaire: 29946,
  KM_Ac67N_Futuristic: 29947,
  KM_Ac68N_Atlanta: 29948,
  KM_Ac69N_MatissesDream: 29949,
  KM_Ac6Y_Toujours: 29950,
  KM_Ac70N_Equinox: 29951,
  KM_Ac71N_Mediterranean: 29952,
  KM_Ac72N_JollyFella: 29953,
  KM_Ac73N_Excitement: 29954,
  KM_Ac74N_EchoGreen: 29955,
  KM_Ac75N_MotherNature: 29956,
  KM_Ac76Y_ForeverGreen: 29957,
  KM_Ac77N_DublinGreen: 29958,
  KM_Ac78N_OrientExpress: 29959,
  KM_Ac79Y_ComicStrip: 29960,
  KM_Ac7Y_OrangeJuice: 29961,
  KM_Ac80Y_Eccentric: 29962,
  KM_Ac81Y_RushingGreen: 29963,
  KM_Ac82Y_GlobalVillage: 29964,
  KM_Ac83N_SecretGarden: 29965,
  KM_Ac84N_Greenback: 29966,
  KM_Ac85N_Rockford: 29967,
  KM_Ac86N_RichEarth: 29968,
  KM_Ac87N_RockyMountain: 29969,
  KM_Ac88N_RareEarth: 29970,
  KM_Ac89N_UmberShadow: 29971,
  KM_Ac8Y_Festival: 29972,
  KM_Ac90N_VermeersFields: 29973,
  KM_Ac91N_DarkGlasses: 29974,
  KM_Ac92N_Draconia: 29975,
  KM_Ac93N_DarkNight: 29976,
  KM_Ac94N_RomanChariot: 29977,
  KM_Ac95N_Dungeon: 29978,
  KM_Ac96N_IronOre: 29979,
  KM_Ac9Y_Nuovo: 29980,
  KM_B1_1_LightPeony: 29981,
  KM_B10_3_Bordeaux: 29982,
  KM_B11_1_GeorgieGirl: 29983,
  KM_B12_1_MauveFrost: 29984,
  KM_B13_2_SunsetCloud: 29985,
  KM_B14_3_Othello: 29986,
  KM_B15_3_Plumificent: 29987,
  KM_B16_1_Prelude: 29988,
  KM_B17_2_SmokeRose: 29989,
  KM_B18_2_Winterborn: 29990,
  KM_B19_3_Morocco: 29991,
  KM_B2_1_SugarDaddy: 29992,
  KM_B20_3_JungleRiver: 29993,
  KM_B21_1_LittleGirlPink: 29994,
  KM_B22_1_Hallelujah: 29995,
  KM_B23_2_ScentedGeranium: 29996,
  KM_B24_2_GoodwinRose: 29997,
  KM_B25_3_CanterburyBell: 29998,
  KM_B26_1_CoquettePink: 29999,
  KM_B27_1_DoricRose: 30000,
  KM_B28_2_RaspberryBlush: 30001,
  KM_B29_3_RosyPlum: 30002,
  KM_B3_2_Heartbreak: 30003,
  KM_B30_3_Cyclamen: 30004,
  KM_B31_1_SummerDawn: 30005,
  KM_B32_1_OldRose: 30006,
  KM_B33_2_RoseCloud: 30007,
  KM_B34_3_WineMist: 30008,
  KM_B35_3_BurntTomato: 30009,
  KM_B36_1_DawnCloud: 30010,
  KM_B37_1_SouthernHaze: 30011,
  KM_B38_2_EmberGray: 30012,
  KM_B39_2_ElmBark: 30013,
  KM_B4_3_MilanoFire: 30014,
  KM_B40_3_Pagan: 30015,
  KM_B5_3_Berryessa: 30016,
  KM_B6_1_PiedPiper: 30017,
  KM_B7_1_HelenOfTroy: 30018,
  KM_B8_2_LentenRose: 30019,
  KM_B9_3_WitchOfEndor: 30020,
  KM_C1_1_SherbetIce: 30021,
  KM_C10_3_Clover: 30022,
  KM_C11_1_RoseBeige: 30023,
  KM_C12_1_Snuggles: 30024,
  KM_C13_2_Dunbury: 30025,
  KM_C14_2_Warrior: 30026,
  KM_C15_3_Muscat: 30027,
  KM_C16_1_NeutralBeige: 30028,
  KM_C17_1_MauveShadow: 30029,
  KM_C18_2_Tubac: 30030,
  KM_C19_2_Homewood: 30031,
  KM_C2_1_CandyStripe: 30032,
  KM_C20_3_Brownwood: 30033,
  KM_C21_1_PinkHaze: 30034,
  KM_C22_1_IbisPink: 30035,
  KM_C23_2_Geranium: 30036,
  KM_C24_3_HiDeHo: 30037,
  KM_C25_3_BridalRose: 30038,
  KM_C26_1_FairyPink: 30039,
  KM_C27_2_PhloxPink: 30040,
  KM_C28_2_MadrasRose: 30041,
  KM_C29_3_PepperPot: 30042,
  KM_C3_2_Mallow: 30043,
  KM_C30_3_Thimbleberry: 30044,
  KM_C31_1_OrientPink: 30045,
  KM_C32_1_DesertRose: 30046,
  KM_C33_2_Playmate: 30047,
  KM_C34_2_Wampum: 30048,
  KM_C35_3_RedRover: 30049,
  KM_C36_1_Lisa: 30050,
  KM_C37_1_CourthouseRose: 30051,
  KM_C38_2_SantoDomingo: 30052,
  KM_C39_3_CarltonHouse: 30053,
  KM_C4_3_Raspberry: 30054,
  KM_C40_3_BurntToast: 30055,
  KM_C5_3_KingsConsort: 30056,
  KM_C6_1_PinkHeather: 30057,
  KM_C7_2_Verbena: 30058,
  KM_C8_2_Sharon: 30059,
  KM_C9_3_RoseDelight: 30060,
  KM_D1_1_ChinaDoll: 30061,
  KM_D10_3_TangoRed: 30062,
  KM_D11_1_CoralPastel: 30063,
  KM_D12_2_CandyLily: 30064,
  KM_D13_2_SunsetMesa: 30065,
  KM_D14_3_SpanishTile: 30066,
  KM_D15_3_Gladiator: 30067,
  KM_D16_1_Gossamer: 30068,
  KM_D17_2_Dunwoody: 30069,
  KM_D18_2_ChocolateShake: 30070,
  KM_D19_3_TudorMinstrel: 30071,
  KM_D2_1_MissyPink: 30072,
  KM_D20_3_Muskrat: 30073,
  KM_D21_1_PinkSherry: 30074,
  KM_D22_1_CandyMan: 30075,
  KM_D23_2_Azalea: 30076,
  KM_D24_3_Welcome: 30077,
  KM_D25_3_CoralGeranium: 30078,
  KM_D26_1_CoralCascade: 30079,
  KM_D27_1_Daphne: 30080,
  KM_D28_1_Bridesmaid: 30081,
  KM_D29_2_QuinceBlossom: 30082,
  KM_D3_2_PinkVerbena: 30083,
  KM_D30_3_Pottery: 30084,
  KM_D31_1_LoveBug: 30085,
  KM_D32_1_CoralSand: 30086,
  KM_D33_2_ForeverAmber: 30087,
  KM_D34_3_RedEarth: 30088,
  KM_D35_3_DragonsBreath: 30089,
  KM_D36_1_WarmWhite: 30090,
  KM_D37_1_VeiledRose: 30091,
  KM_D38_2_PaleMauve: 30092,
  KM_D39_2_Katydid: 30093,
  KM_D4_3_Carolina: 30094,
  KM_D40_3_ChocolateChip: 30095,
  KM_D5_3_HolidayCheer: 30096,
  KM_D6_1_Peppermint: 30097,
  KM_D7_2_PrestoPink: 30098,
  KM_D8_2_RoseAmber: 30099,
  KM_D9_3_Tambourine: 30100,
  KM_E1_1_TissuePink: 30101,
  KM_E10_3_AutumnOak: 30102,
  KM_E11_1_PinkDamask: 30103,
  KM_E12_1_ClayPot: 30104,
  KM_E13_2_SirWinston: 30105,
  KM_E14_2_BrownBean: 30106,
  KM_E15_3_CopperBrown: 30107,
  KM_E16_1_Caprice: 30108,
  KM_E17_1_PussyCat: 30109,
  KM_E18_2_DriedMushroom: 30110,
  KM_E19_3_ThrushWing: 30111,
  KM_E2_1_DawnGlow: 30112,
  KM_E20_3_Grizzly: 30113,
  KM_E21_1_PortofinoCoral: 30114,
  KM_E22_2_PeachMelba: 30115,
  KM_E23_2_OrangeIce: 30116,
  KM_E24_3_RussetMum: 30117,
  KM_E25_3_PartyTime: 30118,
  KM_E26_1_MutedPeach: 30119,
  KM_E27_1_Cabana: 30120,
  KM_E28_2_Sizzler: 30121,
  KM_E29_3_CopperHarbor: 30122,
  KM_E3_2_SmokyCoral: 30123,
  KM_E30_3_PracticalTiger: 30124,
  KM_E31_1_Pattycake: 30125,
  KM_E32_1_BlushingTan: 30126,
  KM_E33_2_Longhorn: 30127,
  KM_E34_3_Pathfinder: 30128,
  KM_E35_3_KenyaBrown: 30129,
  KM_E36_1_CookieDough: 30130,
  KM_E37_2_BeigeBlush: 30131,
  KM_E38_2_Partridge: 30132,
  KM_E39_3_Nutmeg: 30133,
  KM_E4_3_Salmon: 30134,
  KM_E40_3_BrownCrisp: 30135,
  KM_E5_3_Zinnia: 30136,
  KM_E6_1_Pancake: 30137,
  KM_E7_2_CoralDust: 30138,
  KM_E8_2_CopperLeaf: 30139,
  KM_E9_3_IndianLegend: 30140,
  KM_F1_1_Pufferbilly: 30141,
  KM_F10_3_Mandarin: 30142,
  KM_F11_1_PinkStuff: 30143,
  KM_F12_2_Triton: 30144,
  KM_F13_2_GrecianChalice: 30145,
  KM_F14_3_MesaVerde: 30146,
  KM_F15_3_Quadroon: 30147,
  KM_F16_1_RuddySmoke: 30148,
  KM_F17_2_LittleWren: 30149,
  KM_F18_2_AdobeBrick: 30150,
  KM_F19_3_CinnamonSuede: 30151,
  KM_F2_1_Canberra: 30152,
  KM_F20_3_TerraCopper: 30153,
  KM_F21_1_Gleam: 30154,
  KM_F22_1_CornNut: 30155,
  KM_F23_2_Saracen: 30156,
  KM_F24_2_HoneyGold: 30157,
  KM_F25_3_Vicuna: 30158,
  KM_F26_1_Sanibel: 30159,
  KM_F27_1_HawksEye: 30160,
  KM_F28_2_WarmSand: 30161,
  KM_F29_3_Tampico: 30162,
  KM_F3_2_FiddlerOnTheRoof: 30163,
  KM_F30_3_TaffyApple: 30164,
  KM_F31_1_Fleshtone: 30165,
  KM_F32_1_MexicanTan: 30166,
  KM_F33_2_Chicorua: 30167,
  KM_F34_2_Trocadero: 30168,
  KM_F35_3_Caramel: 30169,
  KM_F36_1_SoftWing: 30170,
  KM_F37_1_PerfectBeige: 30171,
  KM_F38_2_DeepBeige: 30172,
  KM_F39_2_Quarry: 30173,
  KM_F4_3_Marigold: 30174,
  KM_F40_3_Brownie: 30175,
  KM_F5_3_Rocket: 30176,
  KM_F6_1_CaramelCream: 30177,
  KM_F7_1_JustPeachy: 30178,
  KM_F8_2_Harlequin: 30179,
  KM_F9_2_AuroraOrange: 30180,
  KM_G1_1_Cereal: 30181,
  KM_G10_3_Honeysuckle: 30182,
  KM_G11_1_Fishnet: 30183,
  KM_G12_2_PieCrust: 30184,
  KM_G13_2_WesternSunset: 30185,
  KM_G14_3_Applejack: 30186,
  KM_G15_3_Balalaika: 30187,
  KM_G16_1_BristolFairy: 30188,
  KM_G17_2_AmberGlow: 30189,
  KM_G18_2_Mosque: 30190,
  KM_G19_3_Deerskin: 30191,
  KM_G2_1_RisingMoon: 30192,
  KM_G20_3_Woodgate: 30193,
  KM_G21_1_Manila: 30194,
  KM_G22_1_PotatoChip: 30195,
  KM_G23_2_GoldMaize: 30196,
  KM_G24_2_Goldsmith: 30197,
  KM_G25_3_OrangeBlaze: 30198,
  KM_G26_1_PuffedRice: 30199,
  KM_G27_2_CornCustard: 30200,
  KM_G28_2_SpicedCider: 30201,
  KM_G29_3_Nugget: 30202,
  KM_G3_2_IndianPeach: 30203,
  KM_G30_3_JapaneseLantern: 30204,
  KM_G31_1_CoralSnow: 30205,
  KM_G32_1_Oxmoon: 30206,
  KM_G33_2_Fig: 30207,
  KM_G34_3_GoldenApricot: 30208,
  KM_G35_3_HarvestHome: 30209,
  KM_G36_1_RiceCracker: 30210,
  KM_G37_2_AutumnCornfield: 30211,
  KM_G38_2_DesertDawn: 30212,
  KM_G39_3_LittleCalumet: 30213,
  KM_G4_3_JamaicaOrange: 30214,
  KM_G40_3_WoodChip: 30215,
  KM_G5_3_Tangerine: 30216,
  KM_G6_1_ScrambledEggs: 30217,
  KM_G7_1_DryMustard: 30218,
  KM_G8_2_AppleCider: 30219,
  KM_G9_3_JaffaOrange: 30220,
  KM_H1_1_Saltine: 30221,
  KM_H10_3_Butterfly: 30222,
  KM_H11_1_ChampagneFrost: 30223,
  KM_H12_1_Wheatbury: 30224,
  KM_H13_2_TexasTreasure: 30225,
  KM_H14_2_AmberGold: 30226,
  KM_H15_3_RomanOchre: 30227,
  KM_H16_1_Lunar: 30228,
  KM_H17_2_WindsorCastle: 30229,
  KM_H18_2_RiverRock: 30230,
  KM_H19_3_Teasel: 30231,
  KM_H2_1_Canary: 30232,
  KM_H20_3_HootOwl: 30233,
  KM_H21_1_BrieCrust: 30234,
  KM_H22_1_Cheesecake: 30235,
  KM_H23_2_LemonChiffon: 30236,
  KM_H24_2_Crocus: 30237,
  KM_H25_3_KingAlfred: 30238,
  KM_H26_1_HappyYellow: 30239,
  KM_H27_1_GoldBeam: 30240,
  KM_H28_2_Dandelion: 30241,
  KM_H29_3_YellowRose: 30242,
  KM_H3_2_BabyChick: 30243,
  KM_H30_3_MellowYellow: 30244,
  KM_H31_1_Honeycomb: 30245,
  KM_H32_2_Breadstick: 30246,
  KM_H33_2_Biscuit: 30247,
  KM_H34_3_GoldenBear: 30248,
  KM_H35_3_PharoahsGold: 30249,
  KM_H36_1_CafeAuLait: 30250,
  KM_H37_2_GentleDoe: 30251,
  KM_H38_2_Pronghorn: 30252,
  KM_H39_3_TanneryTan: 30253,
  KM_H4_2_GoldenNugget: 30254,
  KM_H40_3_Gopher: 30255,
  KM_H5_3_DutchYellow: 30256,
  KM_H6_1_ThickCream: 30257,
  KM_H7_1_HiddenHoney: 30258,
  KM_H8_2_LanternGlow: 30259,
  KM_H9_3_GoldGleam: 30260,
  KM_HLS4202_FrankLloydWhite: 2037,
  KM_HLS4208_WoosterSmoke: 2038,
  KM_I1_1_StarOfWonder: 30261,
  KM_I10_3_MuchoGusto: 30262,
  KM_I11_1_ValleyMoon: 30263,
  KM_I12_2_ElephantTusk: 30264,
  KM_I13_2_GoldenGate: 30265,
  KM_I14_3_Goldigger: 30266,
  KM_I15_3_DeepgloGold: 30267,
  KM_I16_1_HappyBeige: 30268,
  KM_I17_1_VelvetBeige: 30269,
  KM_I18_2_SaddleSoap: 30270,
  KM_I19_3_Kraft: 30271,
  KM_I2_2_YellowDelight: 30272,
  KM_I20_3_Brownberry: 30273,
  KM_I21_1_YellowPearl: 30274,
  KM_I22_1_Viceroy: 30275,
  KM_I23_2_SparklePlenty: 30276,
  KM_I24_3_YellowMoon: 30277,
  KM_I25_3_ShiningGold: 30278,
  KM_I26_1_SpunSugar: 30279,
  KM_I27_1_Guernsey: 30280,
  KM_I28_2_HappyFace: 30281,
  KM_I29_3_LightningBug: 30282,
  KM_I3_2_Potentilla: 30283,
  KM_I30_3_GloriosaDaisy: 30284,
  KM_I31_1_PeachLace: 30285,
  KM_I32_1_MincedGarlic: 30286,
  KM_I33_2_GingerCrystal: 30287,
  KM_I34_3_JamaicanBeach: 30288,
  KM_I35_3_Consulate: 30289,
  KM_I36_1_WinterWheat: 30290,
  KM_I37_1_Americe: 30291,
  KM_I38_2_RuffledGrouse: 30292,
  KM_I39_3_BarleyBronze: 30293,
  KM_I4_3_YellowMarigold: 30294,
  KM_I40_3_ApacheTan: 30295,
  KM_I5_3_Butterball: 30296,
  KM_I6_1_Muenster: 30297,
  KM_I7_1_Yogurt: 30298,
  KM_I8_2_Marengo: 30299,
  KM_I9_3_CleopatrasGold: 30300,
  KM_J1_1_SaudiSand: 30301,
  KM_J10_3_BoldGold: 30302,
  KM_J11_1_WarmIvory: 30303,
  KM_J12_1_Oaken: 30304,
  KM_J13_2_BranFlake: 30305,
  KM_J14_3_RussetTan: 30306,
  KM_J15_3_MoonMoth: 30307,
  KM_J16_1_MiamiSand: 30308,
  KM_J17_2_Nougat: 30309,
  KM_J18_2_CountryClassic: 30310,
  KM_J19_3_CamelHair: 30311,
  KM_J2_2_FreshPineapple: 30312,
  KM_J20_3_Folkstone: 30313,
  KM_J21_1_Moonbeam: 30314,
  KM_J22_1_PondLily: 30315,
  KM_J23_2_EasterYellow: 30316,
  KM_J24_2_MadameButterfly: 30317,
  KM_J25_3_KnockOutYellow: 30318,
  KM_J26_1_AngelNook: 30319,
  KM_J27_2_StarChip: 30320,
  KM_J28_2_SummerWheat: 30321,
  KM_J29_3_Bamboo: 30322,
  KM_J3_2_Jocelyn: 30323,
  KM_J30_3_GoldenGlow: 30324,
  KM_J31_1_Beach: 30325,
  KM_J32_2_Hopscotch: 30326,
  KM_J33_2_ShangriLa: 30327,
  KM_J34_3_Astroglo: 30328,
  KM_J35_3_OsakaGold: 30329,
  KM_J36_1_ColonyWhite: 30330,
  KM_J37_1_Arrowwood: 30331,
  KM_J38_2_Camouflage: 30332,
  KM_J39_3_QuincyGold: 30333,
  KM_J4_3_BrightFeather: 30334,
  KM_J40_3_Capers: 30335,
  KM_J5_3_DutchIris: 30336,
  KM_J6_1_AmberYellow: 30337,
  KM_J7_2_CornTassel: 30338,
  KM_J8_2_BitOfHoney: 30339,
  KM_J9_3_AntiqueGold: 30340,
  KM_K1_1_CreamDream: 30341,
  KM_K10_3_GreenGold: 30342,
  KM_K11_1_TitianCream: 30343,
  KM_K12_1_Horseradish: 30344,
  KM_K13_2_GoldenNectar: 30345,
  KM_K14_3_GoldSmoke: 30346,
  KM_K15_3_MarshGold: 30347,
  KM_K16_1_Magnolia: 30348,
  KM_K17_2_Elmwood: 30349,
  KM_K18_2_DustyOlive: 30350,
  KM_K19_3_WinterLeaf: 30351,
  KM_K2_2_Alba: 30352,
  KM_K20_3_Tarragon: 30353,
  KM_K21_1_LightCanary: 30354,
  KM_K22_2_Tinkerbelle: 30355,
  KM_K23_2_Hypericum: 30356,
  KM_K24_3_BrightSulphur: 30357,
  KM_K25_3_BitterLime: 30358,
  KM_K26_1_TrueGrits: 30359,
  KM_K27_2_BleachedCelery: 30360,
  KM_K28_2_Lemonade: 30361,
  KM_K29_3_TroubadorGold: 30362,
  KM_K3_2_TrueYellow: 30363,
  KM_K30_3_BrightOlive: 30364,
  KM_K31_1_SilverBeam: 30365,
  KM_K32_1_SweetDreams: 30366,
  KM_K33_2_Muse: 30367,
  KM_K34_3_Lancer: 30368,
  KM_K35_3_PalmettoGreen: 30369,
  KM_K36_1_Masterpiece: 30370,
  KM_K37_1_Alabaster: 30371,
  KM_K38_2_Stonewall: 30372,
  KM_K39_3_Guardsman: 30373,
  KM_K4_3_Calypso: 30374,
  KM_K40_3_OliveGray: 30375,
  KM_K5_3_YellowDahlia: 30376,
  KM_K6_1_IceCream: 30377,
  KM_K7_1_PaleCitron: 30378,
  KM_K8_2_DorsetHouse: 30379,
  KM_K9_3_GoldenPrairie: 30380,
  KM_L1_1_Greenspan: 30381,
  KM_L10_3_Gretna: 30382,
  KM_L11_1_ChestnutFrost: 30383,
  KM_L12_2_DriedMarjoram: 30384,
  KM_L13_2_GoldShadow: 30385,
  KM_L14_3_Saxony: 30386,
  KM_L15_3_MarshGrass: 30387,
  KM_L16_1_RawSilk: 30388,
  KM_L17_2_LiveOakMoss: 30389,
  KM_L18_2_Verdure: 30390,
  KM_L19_3_Earth: 30391,
  KM_L2_2_Citron: 30392,
  KM_L20_3_Quirt: 30393,
  KM_L21_1_EarlySpring: 30394,
  KM_L22_1_IrishAngel: 30395,
  KM_L23_2_Audacity: 30396,
  KM_L24_3_Parakeet: 30397,
  KM_L25_3_BaronRothschild: 30398,
  KM_L26_1_Honeydew: 30399,
  KM_L27_2_Orchard: 30400,
  KM_L28_2_Springburst: 30401,
  KM_L29_3_Ragamuffin: 30402,
  KM_L3_2_AstroTurf: 30403,
  KM_L30_3_Quiver: 30404,
  KM_L31_1_Rosemary: 30405,
  KM_L32_1_PrairieGrass: 30406,
  KM_L33_2_Winterhaven: 30407,
  KM_L34_3_Evangeline: 30408,
  KM_L35_3_Sirocco: 30409,
  KM_L36_1_Sandpiper: 30410,
  KM_L37_1_Tundra: 30411,
  KM_L38_2_Beechwood: 30412,
  KM_L39_3_GreenSlate: 30413,
  KM_L4_3_TangoMango: 30414,
  KM_L40_3_Tarnished: 30415,
  KM_L5_3_Sprinter: 30416,
  KM_L6_1_LemonRind: 30417,
  KM_L7_1_CelerySeed: 30418,
  KM_L8_2_Eden: 30419,
  KM_L9_3_TenderBud: 30420,
  KM_M1_1_LimeTint: 30421,
  KM_M10_3_ParrotWing: 30422,
  KM_M11_1_CoolGreen: 30423,
  KM_M12_2_Dellwood: 30424,
  KM_M13_2_CedarBerry: 30425,
  KM_M14_3_Herald: 30426,
  KM_M15_3_ScovilleGreen: 30427,
  KM_M16_1_QueenAnnesLace: 30428,
  KM_M17_2_Turnstone: 30429,
  KM_M18_2_ScotchMoor: 30430,
  KM_M19_3_Moleskin: 30431,
  KM_M2_2_Goblin: 30432,
  KM_M20_3_Parody: 30433,
  KM_M21_1_Opaline: 30434,
  KM_M22_2_SpringGlory: 30435,
  KM_M23_2_LittleDuke: 30436,
  KM_M24_3_PepperJelly: 30437,
  KM_M25_3_BrightShamrock: 30438,
  KM_M26_1_Hedgerow: 30439,
  KM_M27_2_CamelotLime: 30440,
  KM_M28_2_WoodleafGreen: 30441,
  KM_M29_3_GreenOasis: 30442,
  KM_M3_2_Siren: 30443,
  KM_M30_3_Harwood: 30444,
  KM_M31_1_GreenWhisper: 30445,
  KM_M32_2_LimaBean: 30446,
  KM_M33_2_Valerie: 30447,
  KM_M34_3_GlenArbor: 30448,
  KM_M35_3_CentralPark: 30449,
  KM_M36_1_Avocet: 30450,
  KM_M37_2_WinterDusk: 30451,
  KM_M38_2_Meteorite: 30452,
  KM_M39_3_Whetstone: 30453,
  KM_M4_3_LimeSong: 30454,
  KM_M40_3_GrayGrotto: 30455,
  KM_M5_3_PineNeedle: 30456,
  KM_M6_1_CucumberSeed: 30457,
  KM_M7_2_MintLime: 30458,
  KM_M8_2_GreenEyes: 30459,
  KM_M9_3_ArkansasGreen: 30460,
  KM_N1_1_PastelPine: 30461,
  KM_N10_3_Edelwieiss: 30462,
  KM_N11_1_Cinderella: 30463,
  KM_N12_2_HeatherMist: 30464,
  KM_N13_2_BrightPromise: 30465,
  KM_N14_3_VeryGreen: 30466,
  KM_N15_3_Hidcote: 30467,
  KM_N16_1_Artemesia: 30468,
  KM_N17_2_SummerSage: 30469,
  KM_N18_2_OldManse: 30470,
  KM_N19_3_NobleHouse: 30471,
  KM_N2_2_TiddleYWink: 30472,
  KM_N20_3_Lindenwood: 30473,
  KM_N21_1_LeafTint: 30474,
  KM_N22_2_Elaine: 30475,
  KM_N23_2_Maypole: 30476,
  KM_N24_3_Cavalier: 30477,
  KM_N25_3_Cucamonga: 30478,
  KM_N26_1_Frosty: 30479,
  KM_N27_1_FreshLime: 30480,
  KM_N28_2_Bravura: 30481,
  KM_N29_3_Hula: 30482,
  KM_N3_2_Serpentine: 30483,
  KM_N30_3_VillageGreen: 30484,
  KM_N31_1_FeatheryGreen: 30485,
  KM_N32_2_SwissChard: 30486,
  KM_N33_2_Cumberland: 30487,
  KM_N34_3_Woodland: 30488,
  KM_N35_3_Moss: 30489,
  KM_N36_1_DovesWing: 30490,
  KM_N37_1_GrayGreen: 30491,
  KM_N38_2_PigeonWing: 30492,
  KM_N39_3_Guinevere: 30493,
  KM_N4_3_VividLime: 30494,
  KM_N40_3_GlenCove: 30495,
  KM_N5_3_Lyric: 30496,
  KM_N6_1_PickADilly: 30497,
  KM_N7_1_Rondelet: 30498,
  KM_N8_2_Belvidere: 30499,
  KM_N9_3_GreenGoddess: 30500,
  KM_Ow2011_SwanWing: 30501,
  KM_Ow2021_Genna: 30502,
  KM_Ow2031_BeyondPale: 30503,
  KM_Ow2041_CountryCotton: 30504,
  KM_Ow2051_SoapSuds: 30505,
  KM_Ow2061_AppleWhite: 30506,
  KM_Ow2071_Wraps: 30507,
  KM_Ow2081_Whitefair: 30508,
  KM_Ow2091_PressedLinen: 30509,
  KM_Ow2101_SunbleachedShell: 30510,
  KM_Ow2111_ChampagneMist: 30511,
  KM_Ow2121_PebbleBluff: 30512,
  KM_Ow2131_ApricotBlush: 30513,
  KM_Ow2141_Encanto: 30514,
  KM_Ow2151_BarelyThere: 30515,
  KM_Ow2161_Plumas: 30516,
  KM_Ow2171_CrystalCathedral: 30517,
  KM_Ow2181_NeutralGround: 30518,
  KM_Ow2191_BareNecessity: 30519,
  KM_Ow2201_CathedralCity: 30520,
  KM_Ow2211_IvoryTurret: 30521,
  KM_Ow2221_ItsACream: 30522,
  KM_Ow2231_ExtremeSnow: 30523,
  KM_Ow2241_DiamondWhite: 30524,
  KM_Ow2251_MashedPotatoes: 30525,
  KM_Ow2261_PapierBlanc: 30526,
  KM_Ow2271_SoftSesame: 30527,
  KM_Ow2281_PristineLinen: 30528,
  KM_Ow2291_DryLake: 30529,
  KM_Ow2301_SandpiperPlace: 30530,
  KM_Ow2311_CoffeeCreamer: 30531,
  KM_Ow2321_DreamNights: 30532,
  KM_Ow2331_Skijour: 30533,
  KM_Ow2341_IvanhoeEstate: 30534,
  KM_Ow2351_Wishbone: 30535,
  KM_Ow2361_Taravel: 30536,
  KM_Ow2371_AngelCloud: 30537,
  KM_Ow2381_LittleFlower: 30538,
  KM_Ow2391_CozyCotton: 30539,
  KM_Ow2401_RicePudding: 30540,
  KM_Ow2411_AlmondSugar: 30541,
  KM_Ow2421_AmazingGrace: 30542,
  KM_Ow2431_Pathos: 30543,
  KM_Ow2441_Ethos: 30544,
  KM_Ow2451_SandDollar: 30545,
  KM_Ow2461_Tantalizing: 30546,
  KM_Ow2471_SauteedScallops: 30547,
  KM_Ow2481_Semolina: 30548,
  KM_Ow2491_EnglishSycamore: 30549,
  KM_Ow2501_DelLaCreme: 30550,
  KM_Ow2511_DubaiSand: 30551,
  KM_Ow2521_Chic: 30552,
  KM_Ow2531_Amberling: 30553,
  KM_Ow2541_BuffBluff: 30554,
  KM_Ow2551_LovelyLace: 30555,
  KM_Ow2561_ArizonaHeat: 30556,
  KM_Ow2571_HomemadeBiscuit: 30557,
  KM_Ow2581_MilkPaint: 30558,
  KM_Ow2591_MovieTime: 30559,
  KM_Ow2601_FuzzySlippers: 30560,
  KM_P1_1_AprilGreen: 30561,
  KM_P10_3_HamptonCourt: 30562,
  KM_P11_1_SweetAir: 30563,
  KM_P12_2_CottageGreen: 30564,
  KM_P13_2_Palladium: 30565,
  KM_P14_3_FableGreen: 30566,
  KM_P15_3_PingPong: 30567,
  KM_P16_1_ElfDen: 30568,
  KM_P17_2_Leander: 30569,
  KM_P18_2_GreenPebble: 30570,
  KM_P19_2_WitchHunt: 30571,
  KM_P2_1_Minstrel: 30572,
  KM_P20_3_Chadbury: 30573,
  KM_P21_1_Pixie: 30574,
  KM_P22_1_PerkyLime: 30575,
  KM_P23_2_MonteCarlo: 30576,
  KM_P24_3_PrincessGrace: 30577,
  KM_P25_3_ImperialGreen: 30578,
  KM_P26_1_MaidOfOrleans: 30579,
  KM_P27_2_Hacienda: 30580,
  KM_P28_2_Yucca: 30581,
  KM_P29_3_Lucerne: 30582,
  KM_P3_2_EveGreen: 30583,
  KM_P30_3_TurquoiseGreen: 30584,
  KM_P31_1_Piquant: 30585,
  KM_P32_2_Elfin: 30586,
  KM_P33_2_EldoradoGreen: 30587,
  KM_P34_3_CandyTuft: 30588,
  KM_P35_3_Holiday: 30589,
  KM_P36_1_LotusHeart: 30590,
  KM_P37_2_Countryside: 30591,
  KM_P38_2_Spruce: 30592,
  KM_P39_3_SpruceGrove: 30593,
  KM_P4_3_StMoritz: 30594,
  KM_P40_3_Glade: 30595,
  KM_P5_3_Balloon: 30596,
  KM_P6_1_HorizonGreen: 30597,
  KM_P7_1_Glendora: 30598,
  KM_P8_2_CricketField: 30599,
  KM_P9_3_Berkshire: 30600,
  KM_R1_1_PoolGreen: 30601,
  KM_R10_3_CottageGarden: 30602,
  KM_R11_1_CouncilBluff: 30603,
  KM_R12_2_GreenDrop: 30604,
  KM_R13_2_GreenEnvy: 30605,
  KM_R14_3_Westmoreland: 30606,
  KM_R15_3_ChristmasHolly: 30607,
  KM_R16_1_GreenCloud: 30608,
  KM_R17_2_Peaceful: 30609,
  KM_R18_2_PoppyLeaf: 30610,
  KM_R19_3_SmokeGreen: 30611,
  KM_R2_1_HaremGirl: 30612,
  KM_R20_3_Nomad: 30613,
  KM_R21_1_Bikini: 30614,
  KM_R22_2_Juliet: 30615,
  KM_R23_2_PlayDay: 30616,
  KM_R24_3_Carioca: 30617,
  KM_R25_3_VividGreen: 30618,
  KM_R26_1_IcyAqua: 30619,
  KM_R27_1_SeaWake: 30620,
  KM_R28_1_HiddenIsle: 30621,
  KM_R29_2_JamaicanJade: 30622,
  KM_R3_2_Capulet: 30623,
  KM_R30_3_HamletGreen: 30624,
  KM_R31_1_Laurie: 30625,
  KM_R32_2_ColonyGreen: 30626,
  KM_R33_2_Interlaken: 30627,
  KM_R34_3_VermeerGreen: 30628,
  KM_R35_3_WatermelonGreen: 30629,
  KM_R36_1_MistGreen: 30630,
  KM_R37_1_SpringWood: 30631,
  KM_R38_2_Papaya: 30632,
  KM_R39_3_DustyLaurel: 30633,
  KM_R4_3_JungleBird: 30634,
  KM_R40_3_MarthasVineyard: 30635,
  KM_R5_3_ImpactGreen: 30636,
  KM_R6_1_AprilTears: 30637,
  KM_R7_2_Halcyon: 30638,
  KM_R8_2_JerichoJade: 30639,
  KM_R9_3_ForestHaze: 30640,
  KM_S1_1_BrightAqua: 30641,
  KM_S10_3_BrightWing: 30642,
  KM_S11_1_Breakwater: 30643,
  KM_S12_1_Camille: 30644,
  KM_S13_2_DukeOfGloucester: 30645,
  KM_S14_2_WildlifeGreen: 30646,
  KM_S15_3_Juniper: 30647,
  KM_S16_1_GrecianUrn: 30648,
  KM_S17_2_Olivia: 30649,
  KM_S18_2_FoxHollow: 30650,
  KM_S19_3_Pine: 30651,
  KM_S2_1_LadyOfTheLake: 30652,
  KM_S20_3_DianthusGreen: 30653,
  KM_S21_1_AquaFrost: 30654,
  KM_S22_1_Capricorn: 30655,
  KM_S23_2_ScubaReef: 30656,
  KM_S24_3_AquaSeas: 30657,
  KM_S25_3_GypsyWagon: 30658,
  KM_S26_1_Pinafore: 30659,
  KM_S27_2_CaribLagoon: 30660,
  KM_S28_2_WingDing: 30661,
  KM_S29_3_Birdsall: 30662,
  KM_S3_2_PeterPan: 30663,
  KM_S30_3_Castanet: 30664,
  KM_S31_1_BirdsEgg: 30665,
  KM_S32_2_TealPlume: 30666,
  KM_S33_2_Fountainhead: 30667,
  KM_S34_3_Glenside: 30668,
  KM_S35_3_IncenseCedar: 30669,
  KM_S36_1_MintFrost: 30670,
  KM_S37_2_PatioGray: 30671,
  KM_S38_2_HeronsCove: 30672,
  KM_S39_3_Vagabond: 30673,
  KM_S4_3_BirdOfParadise: 30674,
  KM_S40_3_Patio: 30675,
  KM_S5_3_DeepJade: 30676,
  KM_S6_1_GreenSmoke: 30677,
  KM_S7_1_BlueNimbus: 30678,
  KM_S8_2_CrystalBlue: 30679,
  KM_S9_2_JadeSmoke: 30680,
  KM_T1_1_AprilSky: 30681,
  KM_T10_3_DarkTurquoise: 30682,
  KM_T11_1_AquaFantasy: 30683,
  KM_T12_1_SquirrelIsland: 30684,
  KM_T13_2_Camelot: 30685,
  KM_T14_2_Versailles: 30686,
  KM_T15_3_Tecumseh: 30687,
  KM_T16_1_Windswept: 30688,
  KM_T17_1_Quaker: 30689,
  KM_T18_2_KnightsLanding: 30690,
  KM_T19_3_FountainGrass: 30691,
  KM_T2_1_Newport: 30692,
  KM_T20_3_RoyalistGreen: 30693,
  KM_T21_1_GardenPool: 30694,
  KM_T22_2_ChungkingBlue: 30695,
  KM_T23_2_Bluebird: 30696,
  KM_T24_3_PennantBlue: 30697,
  KM_T25_3_Aragon: 30698,
  KM_T26_1_AquaCrystal: 30699,
  KM_T27_2_Capistrano: 30700,
  KM_T28_2_CorinthBlue: 30701,
  KM_T29_3_ParliamentHouse: 30702,
  KM_T3_2_BlueJet: 30703,
  KM_T30_3_BrittanyBlue: 30704,
  KM_T31_1_TenderBlue: 30705,
  KM_T32_1_SummerHaze: 30706,
  KM_T33_1_Saga: 30707,
  KM_T34_2_Potomac: 30708,
  KM_T35_3_DeepPool: 30709,
  KM_T36_1_BabysBreath: 30710,
  KM_T37_2_Legend: 30711,
  KM_T38_2_AbbotsCowl: 30712,
  KM_T39_3_Dragonfly: 30713,
  KM_T4_3_TealGreen: 30714,
  KM_T40_3_Catbird: 30715,
  KM_T5_3_EmpressJade: 30716,
  KM_T6_1_LoftyBlue: 30717,
  KM_T7_2_Samoa: 30718,
  KM_T8_2_Biscayne: 30719,
  KM_T9_3_AesopsJade: 30720,
  KM_U1_1_Bouquet: 30721,
  KM_U10_3_Dangerfield: 30722,
  KM_U11_1_Singsong: 30723,
  KM_U12_2_Nantucket: 30724,
  KM_U13_2_BlueChip: 30725,
  KM_U14_3_Gretchen: 30726,
  KM_U15_3_WaltzTime: 30727,
  KM_U16_1_DustyMiller: 30728,
  KM_U17_1_CloudyBlue: 30729,
  KM_U18_2_AncientAbbey: 30730,
  KM_U19_3_WinterBlue: 30731,
  KM_U2_1_BuntingBlue: 30732,
  KM_U20_3_RavenGray: 30733,
  KM_U21_1_BlueReflection: 30734,
  KM_U22_1_Delphinium: 30735,
  KM_U23_2_VirginiaBluebell: 30736,
  KM_U24_3_Viva: 30737,
  KM_U25_3_Newcastle: 30738,
  KM_U26_1_Minuet: 30739,
  KM_U27_1_WingateBlue: 30740,
  KM_U28_2_Melanie: 30741,
  KM_U29_2_IndigoBunting: 30742,
  KM_U3_2_Terrace: 30743,
  KM_U30_3_Barbizon: 30744,
  KM_U31_1_BlueFroth: 30745,
  KM_U32_1_ChinaBlue: 30746,
  KM_U33_2_Williamsburg: 30747,
  KM_U34_3_BlueShadow: 30748,
  KM_U35_3_CopenhagenBlue: 30749,
  KM_U36_1_SmokeSignal: 30750,
  KM_U37_1_Waxwing: 30751,
  KM_U38_2_FriarGray: 30752,
  KM_U39_2_CloudySkies: 30753,
  KM_U4_2_LakeLucerne: 30754,
  KM_U40_3_GoodNight: 30755,
  KM_U5_3_Bluejacket: 30756,
  KM_U6_1_LittlePrincess: 30757,
  KM_U7_2_ClearSkies: 30758,
  KM_U8_2_ForgetMeNot: 30759,
  KM_U9_3_KingCanute: 30760,
  KM_V1_1_BluejayFeather: 30761,
  KM_V10_3_TenFathoms: 30762,
  KM_V11_1_Veronica: 30763,
  KM_V12_1_Campanula: 30764,
  KM_V13_2_Cineraria: 30765,
  KM_V14_3_BeaconHill: 30766,
  KM_V15_3_Bravo: 30767,
  KM_V16_1_Weathered: 30768,
  KM_V17_2_Florentine: 30769,
  KM_V18_2_Grotto: 30770,
  KM_V19_3_BlueNote: 30771,
  KM_V2_1_Lobellia: 30772,
  KM_V20_3_GlenDeep: 30773,
  KM_V21_1_PrettyBaby: 30774,
  KM_V22_1_LightSky: 30775,
  KM_V23_2_IrisQueen: 30776,
  KM_V24_3_SailorsDream: 30777,
  KM_V25_3_BlaringBlue: 30778,
  KM_V26_1_HighBlue: 30779,
  KM_V27_2_BlueAster: 30780,
  KM_V28_2_HortenseBlue: 30781,
  KM_V29_3_SpinnakerBlue: 30782,
  KM_V3_2_SignalBlue: 30783,
  KM_V30_3_JeansBlue: 30784,
  KM_V31_1_Mertensia: 30785,
  KM_V32_1_Stokesia: 30786,
  KM_V33_2_AleahsDream: 30787,
  KM_V34_3_BarHarbor: 30788,
  KM_V35_3_Dreadnaught: 30789,
  KM_V36_1_SheerBlue: 30790,
  KM_V37_2_PrimaDonna: 30791,
  KM_V38_2_MilfordBlue: 30792,
  KM_V39_3_Normandy: 30793,
  KM_V4_3_DeepBlue: 30794,
  KM_V40_3_GobelinBlue: 30795,
  KM_V5_3_CaribQueen: 30796,
  KM_V6_1_Aloft: 30797,
  KM_V7_2_BlueHeaven: 30798,
  KM_V8_2_CornishBlue: 30799,
  KM_V9_3_Lemont: 30800,
  KM_W1_1_BlueRhythm: 30801,
  KM_W10_3_Nordica: 30802,
  KM_w101_PogoSands: 30803,
  KM_W11_1_PearlyBlue: 30804,
  KM_w11_AmbientGlow: 30805,
  KM_w111_Gracious: 30806,
  KM_W12_1_CapetownBlue: 30807,
  KM_w121_HiddenDiary: 30808,
  KM_W13_2_Jubilee: 30809,
  KM_w131_Someday: 30810,
  KM_W14_3_Coriolanus: 30811,
  KM_w141_GarlicClove: 30812,
  KM_W15_3_StormyBlue: 30813,
  KM_w151_BumbleBaby: 30814,
  KM_W16_1_Smokespun: 30815,
  KM_w161_FullMoon: 30816,
  KM_W17_1_DivinityBlue: 30817,
  KM_w171_WhippedCitron: 30818,
  KM_W18_2_Bluestone: 30819,
  KM_w181_CreamFilling: 30820,
  KM_W19_2_Hector: 30821,
  KM_w191_CallaLily: 30822,
  KM_W2_1_Casanova: 30823,
  KM_W20_3_MagicWaters: 30824,
  KM_w201_MorningMoon: 30825,
  KM_W21_1_Nicodemus: 30826,
  KM_w21_Agrodolce: 30827,
  KM_w211_BananaPie: 30828,
  KM_W22_1_Gentian: 30829,
  KM_w221_CreamCheeseFrosting: 30830,
  KM_W23_2_BlueIris: 30831,
  KM_w231_Bechamel: 30832,
  KM_W24_3_DukesConsort: 30833,
  KM_w241_BudsSails: 30834,
  KM_W25_3_BlueSalvia: 30835,
  KM_w251_VaporTrail: 30836,
  KM_W26_1_Northumberland: 30837,
  KM_w261_AbileneLace: 30838,
  KM_W27_1_HyacinthSky: 30839,
  KM_w271_PianoKeys: 30840,
  KM_W28_2_CambridgeBlue: 30841,
  KM_w281_Clam: 30842,
  KM_W29_3_Comstock: 30843,
  KM_w291_KittenWhiskers: 30844,
  KM_W3_2_BlueCrocus: 30845,
  KM_W30_3_Bluebeard: 30846,
  KM_w301_LightFrost: 30847,
  KM_W31_1_Gulfstream: 30848,
  KM_w31_AsianFusion: 30849,
  KM_w311_FranklyEarnest: 30850,
  KM_W32_1_NuthatchGray: 30851,
  KM_w321_ButterCreamFrosting: 30852,
  KM_W33_2_WyomingDusk: 30853,
  KM_w331_PaintersWhite: 30854,
  KM_W34_2_Middlebrook: 30855,
  KM_w341_BetterThanBeige: 30856,
  KM_W35_3_LordNelsonBlue: 30857,
  KM_w351_AdobeSand: 30858,
  KM_W36_1_Innuendo: 30859,
  KM_w361_GlitteryGlow: 30860,
  KM_W37_1_Sheersilver: 30861,
  KM_w371_ReallyLightGreen: 30862,
  KM_W38_2_StellarBlue: 30863,
  KM_w381_CrystalBrooke: 30864,
  KM_W39_3_BavarianBlue: 30865,
  KM_w391_Palmito: 30866,
  KM_W4_2_JamaicaBlue: 30867,
  KM_W40_3_Nightwatch: 30868,
  KM_w401_Hipster: 30869,
  KM_w41_VictorianLace: 30870,
  KM_w411_NurseryGreen: 30871,
  KM_w421_SipOfMint: 30872,
  KM_W43_WhitestWhite: 2039,
  KM_w431_WhitestWhite: 30873,
  KM_w441_PearlyWhite: 30874,
  KM_w451_FeatherWhite: 30875,
  KM_w461_PicketFence: 30876,
  KM_w471_BrokenWhite: 30877,
  KM_w481_WhippedCream: 30878,
  KM_w491_GreatWhite: 30879,
  KM_W5_3_Homecoming: 30880,
  KM_w501_ApolloLanding: 30881,
  KM_w51_StonePillar: 30882,
  KM_w511_WhaleBone: 30883,
  KM_w521_LavenderBreeze: 30884,
  KM_w531_DazzleMe: 30885,
  KM_w541_Serendipity: 30886,
  KM_w551_DiamondsInTheSky: 30887,
  KM_w561_OrcaWhite: 30888,
  KM_w571_CloudWhite: 30889,
  KM_w581_TropicalBreeze: 30890,
  KM_w591_ColdLight: 30891,
  KM_W6_1_MaidMarian: 30892,
  KM_w601_Starburst: 30893,
  KM_w61_LilyWhite: 30894,
  KM_w611_FrostedGlass: 30895,
  KM_w621_TahoeSnow: 30896,
  KM_w631_EskimoBlue: 30897,
  KM_w641_WhiteBlaze: 30898,
  KM_w651_RapierSilver: 30899,
  KM_w661_AppleFlower: 30900,
  KM_w671_MountEden: 30901,
  KM_w681_MollyGreen: 30902,
  KM_w691_Astronomer: 30903,
  KM_W7_1_Cosmos: 30904,
  KM_w701_BlueGreenRules: 30905,
  KM_w71_ChampagneBliss: 30906,
  KM_W8_2_Ageratum: 30907,
  KM_w81_Marshmallow: 30908,
  KM_W9_3_WildLilac: 30909,
  KM_w91_MawmawsPearls: 30910,
  KM_Ws1_CanvasWhite: 30911,
  KM_Ws10_Whitestone: 30912,
  KM_Ws11_IceCream: 30913,
  KM_Ws12_Meringue: 30914,
  KM_Ws13_DivinityWhite: 30915,
  KM_Ws14_Wishbone: 30916,
  KM_Ws15_DelLaCreme: 30917,
  KM_Ws16_LuxuryLinen: 30918,
  KM_Ws17_DryLake: 30919,
  KM_Ws18_SandDollar: 30920,
  KM_Ws19_MirrorImage: 30921,
  KM_Ws2_WhiteAsh: 30922,
  KM_Ws20_AngelsHarp: 30923,
  KM_Ws21_PleasantDreams: 30924,
  KM_Ws22_SunsetBeach: 30925,
  KM_Ws23_CrystalCathedral: 30926,
  KM_Ws24_Encanto: 30927,
  KM_Ws25_WhiteHill: 30928,
  KM_Ws26_CathedralCity: 30929,
  KM_Ws27_DiamondWhite: 30930,
  KM_Ws28_Plumas: 30931,
  KM_Ws29_Wintercrest: 30932,
  KM_Ws3_PreciousPearl: 30933,
  KM_Ws30_Fortuna: 30934,
  KM_Ws31_Waterford: 30935,
  KM_Ws32_Starpower: 30936,
  KM_Ws33_Inglenook: 30937,
  KM_Ws34_AngoranWrap: 30938,
  KM_Ws35_Startime: 30939,
  KM_Ws36_Utopia: 30940,
  KM_Ws37_BonJour: 30941,
  KM_Ws38_PinkAgate: 30942,
  KM_Ws39_DiamondEssence: 30943,
  KM_Ws4_DreamyWhite: 30944,
  KM_Ws40_HeavenlyOrchid: 30945,
  KM_Ws41_Rhapsody: 30946,
  KM_Ws42_PinkFluff: 30947,
  KM_Ws43_LoveLace: 30948,
  KM_Ws44_Rivulet: 30949,
  KM_Ws45_Opalesque: 30950,
  KM_Ws46_Elegance: 30951,
  KM_Ws47_Corona: 30952,
  KM_Ws48_BlueHaze: 30953,
  KM_Ws49_FantasiaDream: 30954,
  KM_Ws5_PearlWhite: 30955,
  KM_Ws50_AlpsPeak: 30956,
  KM_Ws51_Adalia: 30957,
  KM_Ws52_AladineTint: 30958,
  KM_Ws53_Primula: 30959,
  KM_Ws54_BlueWhip: 30960,
  KM_Ws55_CrystalTint: 30961,
  KM_Ws56_WhiteBridge: 30962,
  KM_Ws57_MoonMagic: 30963,
  KM_Ws58_ErmineMist: 30964,
  KM_Ws59_ClearAsCrystal: 30965,
  KM_Ws6_SwanSong: 30966,
  KM_Ws60_Andorra: 30967,
  KM_Ws61_ChinaJewel: 30968,
  KM_Ws62_WhiteRiver: 30969,
  KM_Ws63_Spray: 30970,
  KM_Ws64_Caliph: 30971,
  KM_Ws7_BrusselsLace: 30972,
  KM_Ws8_Taravel: 30973,
  KM_Ws9_WilmingtonWhite: 30974,
  KM_X1_1_SmokyLilac: 30975,
  KM_X10_3_JohnnyJumpUp: 30976,
  KM_X11_1_MistyBlue: 30977,
  KM_X12_1_Hopewell: 30978,
  KM_X13_2_Punchinelli: 30979,
  KM_X14_3_PurpleMartin: 30980,
  KM_X15_3_Regala: 30981,
  KM_X16_1_LullabyBlue: 30982,
  KM_X17_2_AscotHouse: 30983,
  KM_X18_2_Frobisher: 30984,
  KM_X19_3_PilgrimGray: 30985,
  KM_X2_2_Gondola: 30986,
  KM_X20_3_Holystone: 30987,
  KM_X21_1_LavenderQuartz: 30988,
  KM_X22_1_SoftVelvet: 30989,
  KM_X23_2_PassionFlower: 30990,
  KM_X24_2_HotJazz: 30991,
  KM_X25_3_Hostelry: 30992,
  KM_X26_1_Dulcet: 30993,
  KM_X27_1_BlueberryYogurt: 30994,
  KM_X28_2_HoudiniBlue: 30995,
  KM_X29_3_CopleyHouse: 30996,
  KM_X3_2_FlaxFlower: 30997,
  KM_X30_3_Commodore: 30998,
  KM_X31_1_Iolanthe: 30999,
  KM_X32_1_HaremVeil: 31000,
  KM_X33_1_CapricePlum: 31001,
  KM_X34_2_IndigoSkies: 31002,
  KM_X35_3_Pansy: 31003,
  KM_X36_1_Sanderling: 31004,
  KM_X37_2_Brimstone: 31005,
  KM_X38_2_DarkCloud: 31006,
  KM_X39_3_Beaver: 31007,
  KM_X4_3_Tiffany: 31008,
  KM_X40_3_Lava: 31009,
  KM_X5_3_Winkle: 31010,
  KM_X6_1_BlueOnyx: 31011,
  KM_X7_1_FabulousBlue: 31012,
  KM_X8_2_BlueGoddess: 31013,
  KM_X9_3_FestiveBlue: 31014,
  KM_Y1_1_TenderViolet: 31015,
  KM_Y10_3_KingsCourt: 31016,
  KM_Y11_1_Brocade: 31017,
  KM_Y12_1_HeatherPlum: 31018,
  KM_Y13_2_GardenGlory: 31019,
  KM_Y14_3_Plumstone: 31020,
  KM_Y15_3_Casbah: 31021,
  KM_Y16_1_SilverDollar: 31022,
  KM_Y17_1_Silverado: 31023,
  KM_Y18_2_LegendaryGray: 31024,
  KM_Y19_3_LoneRock: 31025,
  KM_Y2_1_PaleLavender: 31026,
  KM_Y20_3_Mockingbird: 31027,
  KM_Y21_1_AshesOfRoses: 31028,
  KM_Y22_1_Cerise: 31029,
  KM_Y23_2_Liatrice: 31030,
  KM_Y24_3_HappyPlum: 31031,
  KM_Y25_3_DragonLady: 31032,
  KM_Y26_1_OpalMist: 31033,
  KM_Y27_1_Flemish: 31034,
  KM_Y28_2_JellyBean: 31035,
  KM_Y29_2_BlueDahlia: 31036,
  KM_Y3_2_Liberace: 31037,
  KM_Y30_3_Salazar: 31038,
  KM_Y31_1_FrostedPlum: 31039,
  KM_Y32_1_PlumGranite: 31040,
  KM_Y33_2_DunsterHouse: 31041,
  KM_Y34_2_EarlOfKent: 31042,
  KM_Y35_3_Scandia: 31043,
  KM_Y36_1_PlumShadow: 31044,
  KM_Y37_1_SmokyPlum: 31045,
  KM_Y38_2_Medici: 31046,
  KM_Y39_3_WarmPebble: 31047,
  KM_Y4_3_Calliope: 31048,
  KM_Y40_3_Smyrna: 31049,
  KM_Y5_3_Triumphant: 31050,
  KM_Y6_1_VioletPastel: 31051,
  KM_Y7_1_Lavendula: 31052,
  KM_Y8_2_Hyacinth: 31053,
  KM_Y9_2_Isabella: 31054,
  KM_Z1_1_CerisePastel: 31055,
  KM_Z10_3_PlumSplendor: 31056,
  KM_Z11_1_BlueberryCream: 31057,
  KM_Z12_1_CelestialPlum: 31058,
  KM_Z13_2_CressendenManor: 31059,
  KM_Z14_2_BurntLava: 31060,
  KM_Z15_3_DeepLavender: 31061,
  KM_Z16_1_Nocturne: 31062,
  KM_Z17_1_NovemberGray: 31063,
  KM_Z18_2_VintageNickel: 31064,
  KM_Z19_2_BlackSable: 31065,
  KM_Z2_2_MoonlitOrchid: 31066,
  KM_Z20_3_BlackIngot: 31067,
  KM_Z3_2_Lavender: 31068,
  KM_Z4_3_CranberryWine: 31069,
  KM_Z5_3_Clematis: 31070,
  KM_Z6_1_FairyQueen: 31071,
  KM_Z7_2_PlumWhisper: 31072,
  KM_Z8_2_Pinocchio: 31073,
  KM_Z9_3_LightAmethyst: 31074,
};

const DMC_LP_SmartSide = {
  LP_AbyssBlack: 1776,
  LP_CanyonBrown: 1777,
  LP_CavernSteel: 1778,
  LP_DesertStone: 1779,
  LP_GardenSage: 6514,
  LP_HarvestHoney: 6515,
  LP_MarshlandMoss: 1780,
  LP_MidnightShadow: 6516,
  LP_PrairieClay: 1781,
  LP_QuarryGray: 1782,
  LP_RapidsBlue: 1783,
  LP_RedwoodRed: 1784,
  LP_SandDunes: 1785,
  LP_ShorelineCream: 1786,
  LP_SnowscapeWhite: 1787,
  LP_SummitBlue: 1788,
  LP_TerraBrown: 1789,
  LP_TimberlandSuede: 1790,
  LP_TundraGray: 1791,
};

const DMC_Lonestar = {
  Lonestar_Black: 37,
  Lonestar_Linen: 38,
  Lonestar_TuxedoGray: 39,
};

const DMC_MW_SherwinWilliamsStains = {
  MW1173_Black: 10707,
  MW409_Carbon: 10465,
  MW415_TidalWood: 10466,
  MW437_CountryPine: 10467,
  MW439_Walnut: 10468,
  MW459_Sagamore: 10469,
};

const DMC_Masonite = {
  Masonite_Black: 4493,
  Masonite_Blue: 4494,
  Masonite_Brown: 4495,
  Masonite_Gray: 4496,
  Masonite_Red: 4497,
  Masonite_White: 4498,
};

const DMC_McCormick = {
  McCormick_0001_HintOfVanilla: 24716,
  McCormick_0002_ElusiveWhite: 24717,
  McCormick_0003_NillaVanilla: 24718,
  McCormick_0004_ChildOfHeaven: 24719,
  McCormick_0005_Kiara: 24720,
  McCormick_0006_LittleDove: 24721,
  McCormick_0007_CottonBall: 24722,
  McCormick_0008_CasaBlanca: 24723,
  McCormick_0009_ChapelWall: 24724,
  McCormick_0010_Petticoat: 24725,
  McCormick_0011_SugarDust: 24726,
  McCormick_0012_BunnyCake: 24727,
  McCormick_0013_Sphere: 24728,
  McCormick_0014_Twill: 24729,
  McCormick_0015_WhiteGlove: 24730,
  McCormick_0016_PumiceStone: 24731,
  McCormick_0017_LunaMoon: 24732,
  McCormick_0018_DoveWhite: 24733,
  McCormick_0019_MysticFog: 24734,
  McCormick_0020_Bonaire: 24735,
  McCormick_0021_BarelyWhite: 24736,
  McCormick_0022_WhiteKitten: 24737,
  McCormick_0023_ShellTint: 24738,
  McCormick_0024_JustAboutWhite: 24739,
  McCormick_0025_PrismaticPearl: 24740,
  McCormick_0026_MoonDrop: 24741,
  McCormick_0027_WhiteFence: 10989,
  McCormick_0028_BannisterWhite: 24742,
  McCormick_0029_CherishIsTheWord: 24743,
  McCormick_0030_LadyNicole: 24744,
  McCormick_0031_ItalianIce: 24745,
  McCormick_0032_IceDream: 24746,
  McCormick_0033_ChafedWheat: 24747,
  McCormick_0034_HereComesTheSun: 24748,
  McCormick_0035_WeekendRetreat: 24749,
  McCormick_0036_FortunesPrize: 24750,
  McCormick_0037_MoneyTree: 24751,
  McCormick_0038_AutumnsHill: 24752,
  McCormick_0039_MandalayRoad: 24753,
  McCormick_0040_AntiqueCandleLight: 24754,
  McCormick_0041_ChineseCherry: 24755,
  McCormick_0042_AntoinettePink: 24756,
  McCormick_0043_AngelBreath: 24757,
  McCormick_0044_Calliope: 24758,
  McCormick_0045_SizzlingHot: 24759,
  McCormick_0046_Valentino: 24760,
  McCormick_0047_SandIsland: 24761,
  McCormick_0048_Embrace: 24762,
  McCormick_0049_AuburnWave: 24763,
  McCormick_0050_SimmeringRidge: 24764,
  McCormick_0051_CaramelCandy: 24765,
  McCormick_0052_SpicedCarrot: 24766,
  McCormick_0053_RemainingEmbers: 24767,
  McCormick_0054_WinkPink: 24768,
  McCormick_0055_StrawberryWhip: 24769,
  McCormick_0056_DaintyDebutante: 24770,
  McCormick_0057_MarblePink: 24771,
  McCormick_0058_AngelicChoir: 24772,
  McCormick_0059_Quintessential: 24773,
  McCormick_0060_ParlorRose: 24774,
  McCormick_0061_Pinkathon: 24775,
  McCormick_0062_BloomingPerfect: 24776,
  McCormick_0063_ImpatientHeart: 24777,
  McCormick_0064_LordBaltimore: 24778,
  McCormick_0065_PoppyProse: 24779,
  McCormick_0066_WildRose: 24780,
  McCormick_0067_LoversKiss: 24781,
  McCormick_0068_SummerBlush: 24782,
  McCormick_0069_EmpireRose: 24783,
  McCormick_0070_OFortuna: 24784,
  McCormick_0071_RubyEye: 24785,
  McCormick_0072_NoticeMe: 24786,
  McCormick_0073_Corazon: 24787,
  McCormick_0074_EmperorsRobe: 24788,
  McCormick_0075_PinkDuet: 24789,
  McCormick_0076_FantasticPink: 24790,
  McCormick_0077_PinkSoftness: 24791,
  McCormick_0078_BeMine: 24792,
  McCormick_0079_Prophetess: 24793,
  McCormick_0080_AbraCadabra: 24794,
  McCormick_0081_BerryCrush: 24795,
  McCormick_0082_RoseShadow: 24796,
  McCormick_0083_PinkCoral: 24797,
  McCormick_0084_QuietPink: 24798,
  McCormick_0085_FragrantSatchel: 24799,
  McCormick_0086_KingsCloak: 24800,
  McCormick_0087_Cinnapink: 24801,
  McCormick_0088_Casandra: 24802,
  McCormick_0089_StarOfMorning: 24803,
  McCormick_0090_MoonGoddess: 24804,
  McCormick_0091_GarnetShadow: 24805,
  McCormick_0092_FreshDay: 24806,
  McCormick_0093_HeraldOfSpring: 24807,
  McCormick_0094_Starlet: 24808,
  McCormick_0095_QueensRose: 24809,
  McCormick_0096_MorningSide: 24810,
  McCormick_0097_OdysseyPlum: 24811,
  McCormick_0098_Lockhart: 24812,
  McCormick_0099_LoversTryst: 24813,
  McCormick_0101_FruitfulOrchard: 24814,
  McCormick_0102_EarthlyPleasure: 24815,
  McCormick_0103_Hosanna: 24816,
  McCormick_0104_VictorianCottage: 24817,
  McCormick_0105_HarvestBlessing: 24818,
  McCormick_0106_RareFind: 24819,
  McCormick_0107_Prosperity: 24820,
  McCormick_0108_Exotica: 24821,
  McCormick_0109_KungFu: 24822,
  McCormick_0110_BabyBunting: 24823,
  McCormick_0111_AcadiaBloom: 24824,
  McCormick_0112_LadyFlower: 24825,
  McCormick_0113_PunchOfPink: 24826,
  McCormick_0114_MontroseRose: 24827,
  McCormick_0115_Sophistication: 24828,
  McCormick_0116_CordovaBurgundy: 24829,
  McCormick_0117_SatinSlipper: 24830,
  McCormick_0118_MiniaturePosey: 24831,
  McCormick_0119_AngelaCanyon: 24832,
  McCormick_0120_SummersEve: 24833,
  McCormick_0121_Savanna: 24834,
  McCormick_0122_Outrageous: 24835,
  McCormick_0123_MontereyChestnut: 24836,
  McCormick_0124_MerlinsBeard: 24837,
  McCormick_0125_Pout: 24838,
  McCormick_0126_Sauterne: 24839,
  McCormick_0127_AndesAsh: 24840,
  McCormick_0128_RockyMountain: 24841,
  McCormick_0129_Arrowhead: 24842,
  McCormick_0130_Evolution: 24843,
  McCormick_0131_Cliffswallow: 24844,
  McCormick_0133_Natchez: 24845,
  McCormick_0134_BabySprout: 24846,
  McCormick_0135_EmergingLeaf: 24847,
  McCormick_0136_AmazonMist: 24848,
  McCormick_0137_Hideaway: 24849,
  McCormick_0138_CoconutMacaroon: 24850,
  McCormick_0139_Souffle: 24851,
  McCormick_0140_CozyCover: 24852,
  McCormick_0141_BushBuck: 24853,
  McCormick_0142_RanchHouse: 24854,
  McCormick_0143_Connoisseur: 24855,
  McCormick_0144_FilmNoir: 10990,
  McCormick_0145_FlaxFlower: 24856,
  McCormick_0146_Truffles: 24857,
  McCormick_0147_CavePainting: 24858,
  McCormick_0148_OakPlank: 24859,
  McCormick_0149_PavilionTan: 24860,
  McCormick_0150_Temptation: 24861,
  McCormick_0151_CoffeeShop: 24862,
  McCormick_0152_Flirt: 24863,
  McCormick_0153_TakeOut: 24864,
  McCormick_0154_Romulus: 24865,
  McCormick_0155_Cowhide: 24866,
  McCormick_0156_SkinnyDip: 24867,
  McCormick_0157_DodgePole: 24868,
  McCormick_0158_MoverAndShaker: 24869,
  McCormick_0159_SeniorMoment: 24870,
  McCormick_0160_KingdomsKeys: 24871,
  McCormick_0161_TinyCalf: 24872,
  McCormick_0162_ApplePie: 24873,
  McCormick_0163_CamelTrain: 24874,
  McCormick_0164_Veldrift: 24875,
  McCormick_0165_CavernSand: 24876,
  McCormick_0166_PastelDay: 24877,
  McCormick_0167_FirstDate: 24878,
  McCormick_0168_CandleLight: 24879,
  McCormick_0169_FossilTan: 24880,
  McCormick_0170_BlondeShell: 24881,
  McCormick_0171_GoldenGlove: 24882,
  McCormick_0172_Chasm: 24883,
  McCormick_0173_PaleGingersnap: 24884,
  McCormick_0174_MaplePecan: 24885,
  McCormick_0175_amLatte: 24886,
  McCormick_0176_CountryDweller: 24887,
  McCormick_0177_WeaversTool: 24888,
  McCormick_0178_Cupcake: 24889,
  McCormick_0179_FallInSeason: 24890,
  McCormick_0180_FreshLinen: 24891,
  McCormick_0181_Ageless: 24892,
  McCormick_0182_IvoryRidge: 24893,
  McCormick_0183_MothWing: 24894,
  McCormick_0184_MacadamiaBrown: 24895,
  McCormick_0185_NobleCrown: 24896,
  McCormick_0186_ChristmasOrnament: 10991,
  McCormick_0187_WhiteLightning: 24897,
  McCormick_0188_Baguette: 24898,
  McCormick_0189_DelicateHoneysweet: 24899,
  McCormick_0190_VillageCrier: 24900,
  McCormick_0191_DustyPath: 24901,
  McCormick_0192_Dapper: 24902,
  McCormick_0193_AlphaMale: 24903,
  McCormick_0194_AugustMoon: 24904,
  McCormick_0195_MossyShade: 24905,
  McCormick_0196_Overgrown: 24906,
  McCormick_0197_ThistleGray: 24907,
  McCormick_0198_YoungColt: 24908,
  McCormick_0199_SandyShoes: 24909,
  McCormick_0201_SparklingChampagne: 24910,
  McCormick_0203_WhaleBone: 24911,
  McCormick_0204_MarshyHabitat: 24912,
  McCormick_0205_WoodShadow: 24913,
  McCormick_0206_ThatchedCottage: 24914,
  McCormick_0207_AresShadow: 24915,
  McCormick_0208_UmberStyle: 24916,
  McCormick_0209_Polished: 24917,
  McCormick_0210_HiddenCove: 24918,
  McCormick_0211_LightLichen: 24919,
  McCormick_0212_BigSpender: 24920,
  McCormick_0213_CoastalFog: 24921,
  McCormick_0214_Wildwood: 10992,
  McCormick_0218_DriftingSand: 24922,
  McCormick_0219_CamelsHump: 24923,
  McCormick_0221_BrownSuede: 10993,
  McCormick_0222_AuNatural: 24924,
  McCormick_0223_WhiteElephant: 24925,
  McCormick_0224_Pebblebrook: 24926,
  McCormick_0225_RomanRuins: 10994,
  McCormick_0226_Sedge: 24927,
  McCormick_0228_HannoverHills: 24928,
  McCormick_0229_FeatherStone: 24929,
  McCormick_0230_HarrowGate: 24930,
  McCormick_0231_DesertMirage: 24931,
  McCormick_0232_Frond: 24932,
  McCormick_0233_DeepMarsh: 10563,
  McCormick_0234_IndustrialStrength: 24933,
  McCormick_0235_BlackHeath: 24934,
  McCormick_0236_SundayGloves: 24935,
  McCormick_0237_Flan: 24936,
  McCormick_0238_CrownedOne: 24937,
  McCormick_0239_TailoredTan: 24938,
  McCormick_0240_SpicedRum: 24939,
  McCormick_0241_PrinceParis: 24940,
  McCormick_0242_RareHappening: 24941,
  McCormick_0243_FrozenCustard: 24942,
  McCormick_0244_MulledCider: 24943,
  McCormick_0245_CaramelCloud: 24944,
  McCormick_0246_CinnamonToast: 24945,
  McCormick_0247_AppleCrisp: 24946,
  McCormick_0248_SafariSun: 24947,
  McCormick_0249_ButterscotchMousse: 24948,
  McCormick_0250_PumpkinSpice: 24949,
  McCormick_0251_Alchemy: 24950,
  McCormick_0252_OctoberBounty: 24951,
  McCormick_0253_HoneyGlow: 24952,
  McCormick_0254_LivingLarge: 24953,
  McCormick_0255_BackToBasics: 24954,
  McCormick_0256_CrazyHorse: 24955,
  McCormick_0257_Shortbread: 24956,
  McCormick_0258_ClassicTerra: 24957,
  McCormick_0259_PersianFable: 24958,
  McCormick_0260_CocoaNib: 24959,
  McCormick_0261_TanHide: 24960,
  McCormick_0262_LogCabin: 24961,
  McCormick_0263_CountryCharm: 24962,
  McCormick_0264_PalestOfLemon: 24963,
  McCormick_0265_MarshmallowMist: 24964,
  McCormick_0266_OctoberHarvest: 24965,
  McCormick_0267_SeasonFinale: 24966,
  McCormick_0268_RichOak: 24967,
  McCormick_0269_SaharaWind: 24968,
  McCormick_0270_GrahamCrust: 24969,
  McCormick_0271_CloverHoney: 24970,
  McCormick_0272_MineralWater: 24971,
  McCormick_0273_SandstonePalette: 24972,
  McCormick_0274_PolishedMarble: 24973,
  McCormick_0275_Highlight: 24974,
  McCormick_0276_GoldTaffeta: 24975,
  McCormick_0277_GoldenFreesia: 24976,
  McCormick_0278_BarberrySand: 24977,
  McCormick_0279_GardenCountry: 24978,
  McCormick_0280_WickerBasket: 24979,
  McCormick_0281_OliveGold: 24980,
  McCormick_0282_VintageGold: 24981,
  McCormick_0283_HistoricTown: 24982,
  McCormick_0284_QueenLioness: 24983,
  McCormick_0285_Eugenia: 24984,
  McCormick_0286_YellowPage: 24985,
  McCormick_0287_MuslinTint: 24986,
  McCormick_0288_GoldenBuff: 24987,
  McCormick_0289_PrairieSand: 24988,
  McCormick_0290_KeyKeeper: 24989,
  McCormick_0291_Rutherford: 24990,
  McCormick_0292_PrivateWhite: 24991,
  McCormick_0293_WhatInheritance: 24992,
  McCormick_0294_RubElbows: 24993,
  McCormick_0295_SpanishCream: 24994,
  McCormick_0296_OnlyYesterday: 24995,
  McCormick_0297_GoldSeason: 24996,
  McCormick_0298_Brocade: 24997,
  McCormick_0299_AllisonLace: 24998,
  McCormick_0300_IvoryParchment: 24999,
  McCormick_0301_CorinthianPillar: 25000,
  McCormick_0302_RichReward: 25001,
  McCormick_0303_BauhausGold: 25002,
  McCormick_0304_GoldTangiers: 25003,
  McCormick_0305_GoldenSummer: 25004,
  McCormick_0306_SaffronTint: 25005,
  McCormick_0307_PuttingBench: 25006,
  McCormick_0308_CoconutCrumble: 25007,
  McCormick_0309_PalmettoBluff: 25008,
  McCormick_0310_Sassafras: 25009,
  McCormick_0311_LifeExotic: 25010,
  McCormick_0312_SeptemberGold: 25011,
  McCormick_0313_ChicMagnet: 25012,
  McCormick_0314_TradeSecret: 25013,
  McCormick_0315_PeaceableKingdom: 25014,
  McCormick_0316_GoldenLake: 25015,
  McCormick_0317_GreenGold: 25016,
  McCormick_0318_TheresNoPlaceLikeHome: 25017,
  McCormick_0319_HeraldsTrumpet: 25018,
  McCormick_0320_FloatingIsland: 25019,
  McCormick_0321_Hephaestus: 25020,
  McCormick_0322_GabrielsLight: 25021,
  McCormick_0323_StarOfGold: 25022,
  McCormick_0324_UponReflection: 25023,
  McCormick_0325_WelcomeHome: 25024,
  McCormick_0326_Bambino: 25025,
  McCormick_0327_TawnyDaylilly: 25026,
  McCormick_0328_LandOfTrees: 25027,
  McCormick_0329_KnitCardigan: 25028,
  McCormick_0330_CastawayBeach: 25029,
  McCormick_0332_AllNighter: 25030,
  McCormick_0333_Grasslands: 25031,
  McCormick_0334_Sedona: 25032,
  McCormick_0335_IllusiveDream: 25033,
  McCormick_0336_SoftLeather: 10995,
  McCormick_0337_UrbanCharm: 25034,
  McCormick_0338_Whipcord: 25035,
  McCormick_0339_CeramicPot: 25036,
  McCormick_0340_Nightfall: 25037,
  McCormick_0341_LochNess: 25038,
  McCormick_0342_VelumSmoke: 25039,
  McCormick_0343_Cantera: 25040,
  McCormick_0344_Courtyard: 25041,
  McCormick_0345_TravertinePath: 25042,
  McCormick_0346_NortheastTrail: 25043,
  McCormick_0347_JungleCover: 25044,
  McCormick_0348_DriedGrass: 25045,
  McCormick_0349_Reseda: 25046,
  McCormick_0350_HelenOfTroy: 25047,
  McCormick_0351_Mohalla: 25048,
  McCormick_0352_ShagbarkOlive: 25049,
  McCormick_0353_BeckerGold: 25050,
  McCormick_0354_Austere: 25051,
  McCormick_0355_TwinkleTwinkle: 25052,
  McCormick_0356_MothMist: 25053,
  McCormick_0357_MossIsland: 25054,
  McCormick_0358_SilkyGreen: 25055,
  McCormick_0359_GreenSleeves: 25056,
  McCormick_0360_LandBeforeTime: 25057,
  McCormick_0361_GeorgiaOnMyMind: 25058,
  McCormick_0362_PaleQuartz: 25059,
  McCormick_0363_MissionHills: 25060,
  McCormick_0364_StoneHearth: 25061,
  McCormick_0365_AbbeyStone: 25062,
  McCormick_0366_Owlet: 25063,
  McCormick_0367_ChocolateVelvet: 25064,
  McCormick_0368_FolkTales: 25065,
  McCormick_0369_Saturnia: 25066,
  McCormick_0370_Palatine: 25067,
  McCormick_0371_Fiorito: 25068,
  McCormick_0372_HistoricShade: 25069,
  McCormick_0373_BurningIdea: 25070,
  McCormick_0374_CandleWax: 25071,
  McCormick_0375_AfricanQueen: 25072,
  McCormick_0376_BleachedMeadow: 25073,
  McCormick_0377_Montezuma: 25074,
  McCormick_0378_GardenHedge: 25075,
  McCormick_0379_Orestes: 25076,
  McCormick_0380_MirroredWillow: 25077,
  McCormick_0381_Sonata: 25078,
  McCormick_0382_MountOlive: 25079,
  McCormick_0383_NaturalWhisper: 25080,
  McCormick_0384_CheesePlease: 25081,
  McCormick_0385_HowdyNeighbor: 25082,
  McCormick_0386_Hippolita: 25083,
  McCormick_0387_GoldieOldie: 25084,
  McCormick_0388_ShinyGold: 25085,
  McCormick_0389_GoldSparkle: 25086,
  McCormick_0390_OliveTint: 25087,
  McCormick_0391_Crispa: 25088,
  McCormick_0392_AlsotOlive: 25089,
  McCormick_0393_InvitingGesture: 25090,
  McCormick_0394_Highway: 25091,
  McCormick_0395_CrackWillow: 25092,
  McCormick_0396_WingMan: 25093,
  McCormick_0397_HiddenParadise: 25094,
  McCormick_0398_IslandEmbrace: 25095,
  McCormick_0399_SawgrassCottage: 25096,
  McCormick_0400_NewFoliage: 25097,
  McCormick_0401_BambooForest: 25098,
  McCormick_0402_SaboGarden: 25099,
  McCormick_0403_TropicalTwist: 25100,
  McCormick_0404_TranslucentVision: 25101,
  McCormick_0405_PlanetEarth: 25102,
  McCormick_0406_HomeBody: 25103,
  McCormick_0407_Vapor: 25104,
  McCormick_0408_Rediscover: 25105,
  McCormick_0409_GreenCast: 25106,
  McCormick_0410_OldSchool: 25107,
  McCormick_0411_CyprusSpring: 25108,
  McCormick_0412_Sublime: 25109,
  McCormick_0413_SpeakToMe: 25110,
  McCormick_0414_PlumeGrass: 25111,
  McCormick_0415_FrenchPear: 25112,
  McCormick_0416_TaffetaSheen: 25113,
  McCormick_0417_AloeLeaf: 25114,
  McCormick_0418_OnionSkin: 10564,
  McCormick_0419_PoseidonsBeard: 25115,
  McCormick_0420_DavesDen: 25116,
  McCormick_0421_SilveradoRanch: 25117,
  McCormick_0422_EverlastingSage: 10565,
  McCormick_0423_EyeOfTheStorm: 10996,
  McCormick_0424_Monogram: 25118,
  McCormick_0425_PaleGreenTea: 25119,
  McCormick_0426_SeptemberSong: 25120,
  McCormick_0427_ArborVitae: 25121,
  McCormick_0428_LuckyDay: 25122,
  McCormick_0429_PendulaGarden: 25123,
  McCormick_0430_Vegetarian: 25124,
  McCormick_0431_CloverPatch: 25125,
  McCormick_0432_SweetSpring: 25126,
  McCormick_0433_GrassyGlade: 25127,
  McCormick_0434_LushMeadow: 25128,
  McCormick_0435_BigFish: 25129,
  McCormick_0436_FernGully: 25130,
  McCormick_0437_BowlingGreen: 25131,
  McCormick_0438_Delicious: 25132,
  McCormick_0439_NumeroUno: 25133,
  McCormick_0440_PaleLoden: 25134,
  McCormick_0441_SlateStone: 10997,
  McCormick_0442_Dowager: 25135,
  McCormick_0443_Serpentine: 25136,
  McCormick_0444_Grime: 25137,
  McCormick_0445_DeepShadow: 25138,
  McCormick_0446_SealskinShadow: 25139,
  McCormick_0447_MetalFlake: 25140,
  McCormick_0448_IceFlow: 25141,
  McCormick_0449_CannonBall: 10998,
  McCormick_0450_RiverGod: 25142,
  McCormick_0451_EveningDove: 25143,
  McCormick_0452_RuggeroGray: 25144,
  McCormick_0453_FeatherFern: 25145,
  McCormick_0454_MarbleGreen: 25146,
  McCormick_0455_DeepShadow: 10573,
  McCormick_0456_FairMaiden: 25147,
  McCormick_0457_HeavenlyGarden: 25148,
  McCormick_0458_Malarca: 25149,
  McCormick_0459_PleasantHill: 25150,
  McCormick_0460_JustALittle: 25151,
  McCormick_0461_CalmBreeze: 25152,
  McCormick_0462_RestingPlace: 25153,
  McCormick_0463_GaelicGarden: 25154,
  McCormick_0464_KathleensGarden: 25155,
  McCormick_0465_EarthenCheer: 25156,
  McCormick_0466_GreenColumn: 25157,
  McCormick_0467_SweetAriel: 25158,
  McCormick_0468_MellowBlue: 25159,
  McCormick_0469_DejaVu: 25160,
  McCormick_0471_MiracleBay: 25161,
  McCormick_0472_Micropolis: 25162,
  McCormick_0473_AtlanticWaves: 25163,
  McCormick_0474_Raindance: 25164,
  McCormick_0475_FoggyMist: 25165,
  McCormick_0476_LighthouseView: 25166,
  McCormick_0477_OceanCruise: 25167,
  McCormick_0478_SingingInTheRain: 25168,
  McCormick_0479_StairwayToHeaven: 10999,
  McCormick_0480_DeepSeaShadow: 11000,
  McCormick_0481_DreamCatcher: 25169,
  McCormick_0482_PowderedPool: 25170,
  McCormick_0483_Indulgence: 25171,
  McCormick_0484_StormyBay: 25172,
  McCormick_0485_NorthBeachBlue: 25173,
  McCormick_0486_ParadiseCity: 25174,
  McCormick_0487_DeepSpace: 11001,
  McCormick_0489_Whirlwind: 25175,
  McCormick_0490_BeaconFog: 25176,
  McCormick_0491_SmokyDay: 25177,
  McCormick_0492_PolarPond: 25178,
  McCormick_0493_Spacebox: 25179,
  McCormick_0494_DarkRiver: 25180,
  McCormick_0495_Breakwaters: 25181,
  McCormick_0496_CapeHope: 25182,
  McCormick_0497_RestfulRetreat: 25183,
  McCormick_0498_WonderLand: 25184,
  McCormick_0499_OceanMelody: 25185,
  McCormick_0500_BowmanBlue: 25186,
  McCormick_0501_CalmInterlude: 11002,
  McCormick_0502_OceanCrest: 25187,
  McCormick_0503_WaterDroplet: 25188,
  McCormick_0504_InTheBlue: 25189,
  McCormick_0505_InGoodTaste: 25190,
  McCormick_0506_OceanStorms: 25191,
  McCormick_0507_DeepLagoon: 25192,
  McCormick_0508_MidnightMagic: 25193,
  McCormick_0509_BerylPearl: 25194,
  McCormick_0510_SacredSpring: 25195,
  McCormick_0511_Cystern: 25196,
  McCormick_0512_OvercastDay: 25197,
  McCormick_0513_Backwater: 25198,
  McCormick_0514_Thunderstorm: 25199,
  McCormick_0515_SilentSea: 11003,
  McCormick_0516_DiamondStud: 25200,
  McCormick_0517_CoolElegance: 25201,
  McCormick_0518_LetItRain: 25202,
  McCormick_0519_BabySeal: 25203,
  McCormick_0520_SlateTint: 25204,
  McCormick_0521_DolphinDream: 25205,
  McCormick_0522_Octavius: 25206,
  McCormick_0523_Felicity: 25207,
  McCormick_0524_NomadicTravels: 25208,
  McCormick_0525_Marseilles: 25209,
  McCormick_0526_MetropolisMood: 25210,
  McCormick_0527_LondonRoad: 11004,
  McCormick_0528_Greybeard: 11005,
  McCormick_0529_BlackLicorice: 25211,
  McCormick_0530_Metro: 25212,
  McCormick_0531_Snowglory: 25213,
  McCormick_0532_RandMoon: 25214,
  McCormick_0533_Techile: 25215,
  McCormick_0534_SubtleShadow: 25216,
  McCormick_0535_ZenRetreat: 25217,
  McCormick_0536_Subway: 25218,
  McCormick_0537_DovesWing: 25219,
  McCormick_0538_Santo: 25220,
  McCormick_0539_PlaceOfDust: 25221,
  McCormick_0540_PraiseGiving: 25222,
  McCormick_0541_SmokyTone: 25223,
  McCormick_0542_CaptainNemo: 25224,
  McCormick_0543_NovemberStorms: 11006,
  McCormick_0544_VenetianWall: 25225,
  McCormick_0545_OldGrayMare: 25226,
  McCormick_0546_Paternoster: 25227,
  McCormick_0547_TinMan: 25228,
  McCormick_0548_JetGray: 25229,
  McCormick_0549_Emu: 25230,
  McCormick_0550_Gargoyle: 25231,
  McCormick_0551_OrchidShadow: 25232,
  McCormick_0552_NorthIsland: 25233,
  McCormick_0553_SmokyWings: 25234,
  McCormick_0554_Sparrow: 25235,
  McCormick_0555_OceanFrigate: 25236,
  McCormick_0556_Smokescreen: 25237,
  McCormick_0557_Evermore: 11007,
  McCormick_0558_QueenAnnesLace: 25238,
  McCormick_0559_AlwaysNeutral: 25239,
  McCormick_0560_Awakening: 25240,
  McCormick_0561_InTheHills: 25241,
  McCormick_0562_SultryCastle: 25242,
  McCormick_0563_Vigilant: 11008,
  McCormick_0564_BadHairDay: 25243,
  McCormick_0565_ElkSkin: 25244,
  McCormick_0566_Sheepskin: 25245,
  McCormick_0567_Hearthstone: 25246,
  McCormick_0568_CloudyToday: 25247,
  McCormick_0569_FireplaceMantel: 25248,
  McCormick_0570_GreyLocks: 11009,
  McCormick_0571_TerraPin: 25249,
  McCormick_0572_PowerLunch: 25250,
  McCormick_0573_Chintz: 11010,
  McCormick_0574_SharkFin: 25251,
  McCormick_0575_Graystoke: 25252,
  McCormick_0576_StormyWeather: 25253,
  McCormick_0577_KingFischer: 25254,
  McCormick_0578_PhilosophicallySpeaking: 11011,
  McCormick_0579_TurkishTower: 11012,
  McCormick_0580_RippledRock: 25255,
  McCormick_0581_Fossilized: 25256,
  McCormick_0582_PavedPath: 25257,
  McCormick_0583_BillowingSmoke: 11017,
  McCormick_0584_TornadoWind: 25258,
  McCormick_0585_OysterCatch: 25259,
  McCormick_0586_WindBlown: 25260,
  McCormick_0587_AtmosphericPressure: 25261,
  McCormick_0588_BabblingCreek: 25262,
  McCormick_0589_CelestialHorizon: 25263,
  McCormick_0590_MadonnaBlue: 25264,
  McCormick_0591_BlueJacket: 25265,
  McCormick_0592_QuietPeace: 25266,
  McCormick_0593_SurfsSurprise: 25267,
  McCormick_0594_SimplySparkling: 25268,
  McCormick_0595_SailIntoTheHorizon: 25269,
  McCormick_0596_LazyDay: 25270,
  McCormick_0597_HimalayaSky: 25271,
  McCormick_0598_CaribbeanCurrent: 25272,
  McCormick_0599_FloridaWaters: 25273,
  McCormick_0600_MeltingGlacier: 25274,
  McCormick_0601_CoolSky: 25275,
  McCormick_0602_FluidBlue: 25276,
  McCormick_0603_AngelaBay: 25277,
  McCormick_0604_BlueSkiesToday: 25278,
  McCormick_0605_CapriIsle: 25279,
  McCormick_0606_FrozenBlue: 25280,
  McCormick_0607_BrushBlue: 25281,
  McCormick_0608_ModernBlue: 25282,
  McCormick_0609_Innuendo: 25283,
  McCormick_0610_BlueParlor: 25284,
  McCormick_0611_BashfulBlue: 25285,
  McCormick_0612_Parkwater: 25286,
  McCormick_0613_BlueHighlight: 25287,
  McCormick_0614_SimpleSerenity: 25288,
  McCormick_0615_BlueBayou: 25289,
  McCormick_0616_Bluette: 25290,
  McCormick_0617_JohnsBlue: 25291,
  McCormick_0618_HeavenlySky: 25292,
  McCormick_0619_HonkyTonkBlue: 25293,
  McCormick_0620_StarStudded: 25294,
  McCormick_0621_Nuance: 25295,
  McCormick_0622_SereneSetting: 25296,
  McCormick_0623_PompeiiRuins: 25297,
  McCormick_0624_BluePot: 25298,
  McCormick_0625_NorthSea: 25299,
  McCormick_0626_BlueDepths: 25300,
  McCormick_0627_IntoTheStratosphere: 25301,
  McCormick_0628_IlluminatingExperience: 25302,
  McCormick_0629_PolishedCotton: 25303,
  McCormick_0630_StarMist: 25304,
  McCormick_0631_ChicagoSkyline: 25305,
  McCormick_0632_BreathTakingView: 25306,
  McCormick_0633_CapeCodBay: 25307,
  McCormick_0634_DaySpa: 11013,
  McCormick_0635_Aquafir: 25308,
  McCormick_0636_EmpressLila: 25309,
  McCormick_0637_MarzenaDream: 25310,
  McCormick_0638_WaterySea: 25311,
  McCormick_0639_AcapulcoDive: 25312,
  McCormick_0640_Skylla: 25313,
  McCormick_0641_DancingSea: 25314,
  McCormick_0642_SeaFoamMist: 25315,
  McCormick_0643_AbstractIdea: 25316,
  McCormick_0644_DancingInTheRain: 25317,
  McCormick_0645_CalmTint: 25318,
  McCormick_0646_KeyWestZenith: 25319,
  McCormick_0647_Zenith: 25320,
  McCormick_0648_HappyTune: 25321,
  McCormick_0649_DivineInspiration: 25322,
  McCormick_0650_BridgewaterBay: 25323,
  McCormick_0651_SoftBlue: 25324,
  McCormick_0652_MountainMain: 25325,
  McCormick_0653_SeaOfAtlantis: 25326,
  McCormick_0654_Peninsula: 25327,
  McCormick_0655_QueenOfTheNight: 25328,
  McCormick_0656_RomanWhite: 25329,
  McCormick_0657_Kyoto: 25330,
  McCormick_0658_OrleansTune: 25331,
  McCormick_0659_LastingThoughts: 25332,
  McCormick_0660_Epimethius: 25333,
  McCormick_0661_Charybdis: 25334,
  McCormick_0662_OceanSpray: 25335,
  McCormick_0663_FallingTears: 25336,
  McCormick_0664_ZirconIce: 25337,
  McCormick_0665_MonetMagic: 25338,
  McCormick_0666_TrishasEyes: 25339,
  McCormick_0667_BlessedBlue: 25340,
  McCormick_0668_WishUponAStar: 25341,
  McCormick_0669_FrozenStream: 25342,
  McCormick_0670_DriftingTide: 25343,
  McCormick_0671_EggBlue: 25344,
  McCormick_0672_QuietPond: 25345,
  McCormick_0673_EnchantedEvening: 25346,
  McCormick_0674_SarahsGarden: 25347,
  McCormick_0675_BlueBliss: 25348,
  McCormick_0676_JobsTears: 25349,
  McCormick_0677_EasternWind: 25350,
  McCormick_0678_LuxorBlue: 25351,
  McCormick_0679_Everest: 25352,
  McCormick_0680_AndesSky: 25353,
  McCormick_0681_CyanSky: 25354,
  McCormick_0682_PleasantStream: 25355,
  McCormick_0683_JoyfulTears: 25356,
  McCormick_0684_SnowDrift: 25357,
  McCormick_0685_DillardsBlue: 25358,
  McCormick_0686_Outerspace: 25359,
  McCormick_0687_Stillwater: 25360,
  McCormick_0688_ColdNorth: 25361,
  McCormick_0689_Atmosphere: 25362,
  McCormick_0690_BluePeriod: 25363,
  McCormick_0691_Paradise: 25364,
  McCormick_0692_BarelyAqua: 25365,
  McCormick_0693_IslandBreeze: 25366,
  McCormick_0694_TurkishTeal: 25367,
  McCormick_0695_IslandMoment: 25368,
  McCormick_0696_Meringue: 25369,
  McCormick_0697_ArizonaStone: 25370,
  McCormick_0698_CalmThoughts: 25371,
  McCormick_0699_LicketySplit: 25372,
  McCormick_0700_Uninhibited: 25373,
  McCormick_0701_Plunge: 25374,
  McCormick_0702_PegsPromise: 25375,
  McCormick_0703_MountainMeadow: 25376,
  McCormick_0704_Plateau: 25377,
  McCormick_0705_BayGreen: 25378,
  McCormick_0706_FilteredForest: 25379,
  McCormick_0707_ShimmeringGlade: 25380,
  McCormick_0708_CatarinaGreen: 25381,
  McCormick_0709_Calmness: 25382,
  McCormick_0710_OnTheNile: 25383,
  McCormick_0711_CutePixie: 25384,
  McCormick_0712_TealTreat: 25385,
  McCormick_0713_MediterraneanMist: 25386,
  McCormick_0714_TurquoiseTower: 25387,
  McCormick_0715_AquamarineOcean: 25388,
  McCormick_0716_BlueGreenScene: 25389,
  McCormick_0717_TropicalTale: 25390,
  McCormick_0718_Aquadazzle: 25391,
  McCormick_0719_MintGrasshopper: 25392,
  McCormick_0720_SilkyMint: 25393,
  McCormick_0721_LeavesOfSpring: 25394,
  McCormick_0722_Liliana: 25395,
  McCormick_0723_GoddessGreen: 25396,
  McCormick_0724_WildnessMint: 25397,
  McCormick_0725_Melbourne: 25398,
  McCormick_0726_HiddenJade: 25399,
  McCormick_0727_GracefulMint: 25400,
  McCormick_0728_CelticSpring: 25401,
  McCormick_0729_GardenGoddess: 25402,
  McCormick_0730_Lucerne: 25403,
  McCormick_0731_Aqueous: 25404,
  McCormick_0732_Tingle: 25405,
  McCormick_0733_LeafPrint: 25406,
  McCormick_0734_VineyardGreen: 25407,
  McCormick_0735_CoolSpring: 25408,
  McCormick_0736_MiniGreen: 25409,
  McCormick_0737_BuenosAires: 25410,
  McCormick_0738_SpringForest: 25411,
  McCormick_0739_JungleAdventure: 25412,
  McCormick_0740_JustAboutGreen: 25413,
  McCormick_0741_TurningLeaf: 25414,
  McCormick_0742_IsleOfDreams: 25415,
  McCormick_0743_BelladonnasLeaf: 25416,
  McCormick_0744_HiddenGlade: 25417,
  McCormick_0745_ChicShade: 25418,
  McCormick_0746_MotherNature: 25419,
  McCormick_0747_Whitewash: 25420,
  McCormick_0748_Balance: 25421,
  McCormick_0749_Perspective: 25422,
  McCormick_0750_WispyMint: 25423,
  McCormick_0751_GreenGlass: 25424,
  McCormick_0752_CactusValley: 25425,
  McCormick_0753_BabyVegetable: 25426,
  McCormick_0754_ColleenGreen: 25427,
  McCormick_0755_CreamyMint: 25428,
  McCormick_0756_MeadowGrass: 25429,
  McCormick_0757_GarlandPine: 25430,
  McCormick_0758_Glendale: 25431,
  McCormick_0759_PerennialGarden: 25432,
  McCormick_0760_GreenKnoll: 25433,
  McCormick_0761_MaisonVerte: 25434,
  McCormick_0762_GreenSong: 25435,
  McCormick_0763_GracefulFlower: 25436,
  McCormick_0764_GreenSheen: 25437,
  McCormick_0765_Sweetness: 25438,
  McCormick_0766_GentleCaress: 25439,
  McCormick_0767_GolfDay: 25440,
  McCormick_0768_RestfulRain: 25441,
  McCormick_0769_EarthHappiness: 25442,
  McCormick_0770_WoodlandNymph: 25443,
  McCormick_0771_GreenLime: 25444,
  McCormick_0772_WonderWoods: 25445,
  McCormick_0773_GlassBottle: 25446,
  McCormick_0774_GreenGoneWild: 25447,
  McCormick_0775_ElfinMagic: 25448,
  McCormick_0776_GreenMist: 25449,
  McCormick_0777_Envy: 25450,
  McCormick_0778_VacationIsland: 25451,
  McCormick_0779_FrogGreen: 25452,
  McCormick_0780_Hyper: 25453,
  McCormick_0781_ScienceExperiment: 25454,
  McCormick_0782_TenderShoot: 25455,
  McCormick_0783_CleanAir: 25456,
  McCormick_0784_FreshStart: 25457,
  McCormick_0785_MistyValley: 25458,
  McCormick_0786_PeterPan: 25459,
  McCormick_0787_TotallyCool: 25460,
  McCormick_0788_GreenGlow: 25461,
  McCormick_0789_GardenSeat: 25462,
  McCormick_0790_ForestFound: 25463,
  McCormick_0791_Origin: 25464,
  McCormick_0792_FootiePajamas: 25465,
  McCormick_0793_Motherland: 25466,
  McCormick_0794_TheGoods: 25467,
  McCormick_0795_MartinaOlive: 25468,
  McCormick_0796_Spotlight: 25469,
  McCormick_0797_BermudaSon: 25470,
  McCormick_0798_LemonAppeal: 25471,
  McCormick_0799_FireDance: 25472,
  McCormick_0800_YellowUmbrella: 25473,
  McCormick_0801_RainSlicker: 25474,
  McCormick_0802_RainBoots: 25475,
  McCormick_0803_PerkyTint: 25476,
  McCormick_0804_SweetiePie: 25477,
  McCormick_0805_MellaYella: 25478,
  McCormick_0806_SweetAngelica: 25479,
  McCormick_0807_BrightIdea: 25480,
  McCormick_0808_YellowLupine: 25481,
  McCormick_0809_HairRibbon: 25482,
  McCormick_0810_Annabel: 25483,
  McCormick_0811_Martica: 25484,
  McCormick_0812_GoldStrand: 25485,
  McCormick_0813_Glistening: 25486,
  McCormick_0814_GoldenGlow: 25487,
  McCormick_0815_LemonSurprise: 25488,
  McCormick_0816_SinCity: 25489,
  McCormick_0817_BestOfSummer: 25490,
  McCormick_0818_DayAtTheZoo: 25491,
  McCormick_0819_LemonTint: 25492,
  McCormick_0820_SignOfTheCrown: 25493,
  McCormick_0821_SunTouched: 25494,
  McCormick_0822_SunnyMood: 25495,
  McCormick_0823_SunDrops: 25496,
  McCormick_0824_Hush: 25497,
  McCormick_0825_FrozenBanana: 25498,
  McCormick_0826_BananaCustard: 25499,
  McCormick_0827_RayOfLight: 25500,
  McCormick_0828_GoGoGlow: 25501,
  McCormick_0829_DandyLion: 25502,
  McCormick_0830_WarmFuzzies: 25503,
  McCormick_0831_LavishLemon: 25504,
  McCormick_0832_LemonSpongeCake: 25505,
  McCormick_0833_SceneStealer: 25506,
  McCormick_0834_LemonDrizzle: 25507,
  McCormick_0835_GlitterYellow: 25508,
  McCormick_0836_BasketOfGold: 25509,
  McCormick_0837_FreshScent: 25510,
  McCormick_0838_FreshCream: 25511,
  McCormick_0839_Butterball: 25512,
  McCormick_0840_LemonZest: 25513,
  McCormick_0841_SunsGlory: 25514,
  McCormick_0842_Sunnyside: 25515,
  McCormick_0843_ButteredPopcorn: 25516,
  McCormick_0844_Yolk: 25517,
  McCormick_0845_LemonStick: 25518,
  McCormick_0846_PureLaughter: 25519,
  McCormick_0847_YellowBlitz: 25520,
  McCormick_0848_YellowTail: 25521,
  McCormick_0849_LemonPeel: 25522,
  McCormick_0850_Citron: 25523,
  McCormick_0851_HappyFace: 25524,
  McCormick_0852_TouchOfSun: 25525,
  McCormick_0853_LemonLilly: 25526,
  McCormick_0854_CrocusTint: 25527,
  McCormick_0855_ButterTart: 25528,
  McCormick_0856_BroadwayLights: 25529,
  McCormick_0857_Peeps: 25530,
  McCormick_0858_LookAtTheBrightSide: 25531,
  McCormick_0859_DaylillyYellow: 25532,
  McCormick_0860_HawaiianCream: 25533,
  McCormick_0861_LemonFilling: 25534,
  McCormick_0862_YellowTrumpet: 25535,
  McCormick_0863_ImALocal: 25536,
  McCormick_0864_Lioness: 25537,
  McCormick_0865_LemonBar: 25538,
  McCormick_0866_AppleSauce: 25539,
  McCormick_0867_EggNoodle: 25540,
  McCormick_0868_Shortcake: 25541,
  McCormick_0869_FrozenFruit: 25542,
  McCormick_0870_LemonSlice: 25543,
  McCormick_0871_GoldFinch: 25544,
  McCormick_0872_SaffronValley: 25545,
  McCormick_0873_WashedInLight: 25546,
  McCormick_0874_KettleCorn: 25547,
  McCormick_0875_NothingLess: 25548,
  McCormick_0876_CornChowder: 25549,
  McCormick_0877_GoldDigger: 25550,
  McCormick_0878_GloriousGold: 25551,
  McCormick_0879_GoldenCadillac: 25552,
  McCormick_0880_CauliflowerCream: 25553,
  McCormick_0881_GoldenSyrup: 25554,
  McCormick_0882_Marzipan: 25555,
  McCormick_0883_FollowTheLeader: 25556,
  McCormick_0884_GoldTweed: 25557,
  McCormick_0885_JungleExpedition: 25558,
  McCormick_0886_GoldEstate: 25559,
  McCormick_0887_Haystack: 25560,
  McCormick_0888_GoldenWeave: 25561,
  McCormick_0889_RusseauGold: 25562,
  McCormick_0890_Dubloon: 25563,
  McCormick_0891_SilenceIsGolden: 25564,
  McCormick_0892_GoldRansom: 25565,
  McCormick_0893_RichAndRare: 25566,
  McCormick_0894_MistyMustard: 25567,
  McCormick_0895_RotundaGold: 25568,
  McCormick_0896_CoinPurse: 25569,
  McCormick_0897_BagOfGold: 25570,
  McCormick_0898_GobyDesert: 25571,
  McCormick_0899_BugleBoy: 25572,
  McCormick_0900_UnforgettablyGold: 25573,
  McCormick_0901_SpinningWheel: 25574,
  McCormick_0902_Soleil: 25575,
  McCormick_0903_DaintyFlower: 25576,
  McCormick_0904_SundayAfternoon: 25577,
  McCormick_0905_EgyptianGold: 25578,
  McCormick_0906_CatsEyeMarble: 25579,
  McCormick_0907_Millionaire: 25580,
  McCormick_0908_GodGiven: 25581,
  McCormick_0909_AutumnChild: 25582,
  McCormick_0910_WesternSky: 25583,
  McCormick_0911_SunsetInItaly: 25584,
  McCormick_0912_TropicalDream: 25585,
  McCormick_0913_AngelFoodCake: 25586,
  McCormick_0914_ChildOfTheMoon: 25587,
  McCormick_0915_QueenlyLaugh: 25588,
  McCormick_0917_CanyonSand: 25589,
  McCormick_0918_GoodLooking: 25590,
  McCormick_0919_VeniceSquare: 25591,
  McCormick_0920_SunriseHeat: 25592,
  McCormick_0921_WaxenMoon: 25593,
  McCormick_0922_Cheesecake: 25594,
  McCormick_0923_TiffanyLight: 25595,
  McCormick_0924_FirstDayOfSchool: 25596,
  McCormick_0925_JonquilTrail: 25597,
  McCormick_0926_PerkyYellow: 25598,
  McCormick_0927_LemonPoppy: 25599,
  McCormick_0928_YellowWarning: 25600,
  McCormick_0929_YellowBonnet: 25601,
  McCormick_0930_MarshmallowFluff: 25602,
  McCormick_0931_LemonBubble: 25603,
  McCormick_0932_SunSplashed: 25604,
  McCormick_0933_SassyYellow: 25605,
  McCormick_0934_LemonEssence: 25606,
  McCormick_0935_YellowShout: 25607,
  McCormick_0936_Diantha: 25608,
  McCormick_0937_EggNog: 25609,
  McCormick_0938_PrimrosePath: 25610,
  McCormick_0939_BigBusYellow: 25611,
  McCormick_0940_GrilledCheese: 25612,
  McCormick_0941_GlowingLantern: 25613,
  McCormick_0942_LemonDream: 25614,
  McCormick_0943_PicturePerfect: 25615,
  McCormick_0944_SunriseGlow: 25616,
  McCormick_0945_TreasureSeeker: 25617,
  McCormick_0946_HotSpot: 25618,
  McCormick_0947_BrightHalo: 25619,
  McCormick_0948_BrightBubble: 25620,
  McCormick_0949_Frenzy: 25621,
  McCormick_0950_IvoryCoast: 25622,
  McCormick_0951_PoundCake: 25623,
  McCormick_0952_RichGlow: 25624,
  McCormick_0953_EveningStar: 25625,
  McCormick_0954_MacNCheese: 25626,
  McCormick_0955_LemonWhisper: 25627,
  McCormick_0956_ILoveToBoogie: 25628,
  McCormick_0957_PaleNarcissus: 25629,
  McCormick_0958_HolyGrail: 25630,
  McCormick_0959_EssentiallyBright: 25631,
  McCormick_0960_BreadNButter: 25632,
  McCormick_0961_GoldsGreatTouch: 25633,
  McCormick_0962_PiecesOfEight: 25634,
  McCormick_0963_Zambia: 25635,
  McCormick_0964_CapetownCream: 25636,
  McCormick_0965_GoldOfMidas: 25637,
  McCormick_0966_Starburst: 25638,
  McCormick_0967_Endearment: 25639,
  McCormick_0968_MangoMadness: 25640,
  McCormick_0969_AuGratin: 25641,
  McCormick_0970_OrangeYouHappy: 25642,
  McCormick_0971_MaySun: 25643,
  McCormick_0972_AppleCider: 25644,
  McCormick_0973_AtollSand: 25645,
  McCormick_0974_Goosebill: 25646,
  McCormick_0975_DownyFeather: 25647,
  McCormick_0976_CocktailHour: 25648,
  McCormick_0977_CheddarCheese: 25649,
  McCormick_0978_CityOfDiamonds: 25650,
  McCormick_0979_Liveliness: 25651,
  McCormick_0980_SouthernBreeze: 25652,
  McCormick_0981_TuscanWall: 25653,
  McCormick_0982_TasteOfSummer: 25654,
  McCormick_0983_Japonica: 25655,
  McCormick_0984_MexicanSpirit: 25656,
  McCormick_0985_Whiskers: 25657,
  McCormick_0986_MineralGlow: 25658,
  McCormick_0987_Tallow: 25659,
  McCormick_0988_MomsApplePie: 25660,
  McCormick_0989_Impulse: 25661,
  McCormick_0990_ButterscotchGlaze: 25662,
  McCormick_0991_BeeswaxCandle: 25663,
  McCormick_0992_TouchOfTopaz: 25664,
  McCormick_0993_IncanTreasure: 25665,
  McCormick_0994_SparkleGlow: 25666,
  McCormick_0995_BreadPudding: 25667,
  McCormick_0996_SpiceCookie: 25668,
  McCormick_0997_GatesOfGold: 25669,
  McCormick_0998_GoldMetal: 25670,
  McCormick_0999_IvoryTassel: 25671,
  McCormick_100_SuperWhite: 11014,
  McCormick_1000_FlowerOfOahu: 25672,
  McCormick_1001_CheddarCorn: 25673,
  McCormick_1002_TeaCookie: 25674,
  McCormick_1003_SweetSue: 25675,
  McCormick_1004_PeaceOfMind: 25676,
  McCormick_1005_FlickeringFlame: 25677,
  McCormick_1006_Turkscap: 25678,
  McCormick_1007_PastelPeach: 25679,
  McCormick_1008_MangoTango: 25680,
  McCormick_1009_BedtimeStory: 25681,
  McCormick_1010_PeanutBrittle: 25682,
  McCormick_1011_Semolina: 25683,
  McCormick_1012_HamptonBeach: 25684,
  McCormick_1013_WarmBread: 25685,
  McCormick_1014_MuffinMagic: 25686,
  McCormick_1015_CanterPeach: 25687,
  McCormick_1016_NovemberLeaf: 25688,
  McCormick_1017_SummersEnd: 25689,
  McCormick_1018_SunnyHorizon: 25690,
  McCormick_1019_OrangeBallad: 25691,
  McCormick_1020_RapturesLight: 25692,
  McCormick_1021_SweetButtermilk: 25693,
  McCormick_1022_DelicateDawn: 25694,
  McCormick_1023_MellowGlow: 25695,
  McCormick_1024_PumpkinHue: 25696,
  McCormick_1025_HeatOfSummer: 25697,
  McCormick_1026_CasaDeOro: 25698,
  McCormick_1027_AbstractWhite: 25699,
  McCormick_1028_Verve: 25700,
  McCormick_1029_PaleBlossom: 25701,
  McCormick_1030_WispyWhite: 25702,
  McCormick_1031_Chickadee: 25703,
  McCormick_1032_BoredomBuster: 25704,
  McCormick_1033_LavaLamp: 25705,
  McCormick_1034_AutumnWind: 25706,
  McCormick_1035_SpicedCider: 25707,
  McCormick_1036_ApricotSpring: 25708,
  McCormick_1037_TrumpetFlower: 25709,
  McCormick_1038_JackOLantern: 25710,
  McCormick_1039_PrettyParasol: 25711,
  McCormick_1040_DarkMarmalade: 25712,
  McCormick_1041_Flowerbed: 25713,
  McCormick_1042_PeakSeason: 25714,
  McCormick_1043_MomsLove: 25715,
  McCormick_1044_ShootingStar: 25716,
  McCormick_1045_CreamyOrangeBlush: 25717,
  McCormick_1046_BalletCream: 25718,
  McCormick_1047_Starfish: 25719,
  McCormick_1048_PaleShrimp: 25720,
  McCormick_1049_SalmonMousse: 25721,
  McCormick_1050_SalmonBeauty: 25722,
  McCormick_1051_StuccoWall: 25723,
  McCormick_1052_SummerMemory: 25724,
  McCormick_1053_SunsRage: 25725,
  McCormick_1054_CarrotCake: 25726,
  McCormick_1055_WhiteMeadow: 25727,
  McCormick_1056_ElizabethRose: 25728,
  McCormick_1057_PinkSatin: 25729,
  McCormick_1058_PaleTerra: 25730,
  McCormick_1059_AlexandraPeach: 25731,
  McCormick_1060_FirstLady: 25732,
  McCormick_1061_AprilLove: 25733,
  McCormick_1062_Albino: 25734,
  McCormick_1063_TinyPink: 25735,
  McCormick_1064_MysticTulip: 25736,
  McCormick_1065_RoseEssence: 25737,
  McCormick_1066_Sari: 25738,
  McCormick_1067_SweetBabyRose: 25739,
  McCormick_1068_BestOfTheBunch: 25740,
  McCormick_1069_PinkTouch: 25741,
  McCormick_1070_PeonyPrize: 25742,
  McCormick_1071_CloudNumberNine: 25743,
  McCormick_1072_LustyOrange: 25744,
  McCormick_1073_GracefulBallerina: 25745,
  McCormick_1074_ItsMyParty: 25746,
  McCormick_1075_CherryBlink: 25747,
  McCormick_1076_BabyBlossom: 25748,
  McCormick_1077_LadyAnne: 25749,
  McCormick_1078_AromaticBreeze: 25750,
  McCormick_1079_WildflowerBouquet: 25751,
  McCormick_1080_CherishedOne: 25752,
  McCormick_1081_EndlessPossibilities: 25753,
  McCormick_1082_TropicalHeat: 25754,
  McCormick_1083_MorningBlush: 25755,
  McCormick_1084_GoGoPink: 25756,
  McCormick_1085_TintOfRose: 25757,
  McCormick_1086_Nosegay: 25758,
  McCormick_1087_BayCoral: 25759,
  McCormick_1088_ChildhoodCrush: 25760,
  McCormick_1089_Chuckles: 25761,
  McCormick_1090_Tartlet: 25762,
  McCormick_1091_AllDressedUp: 25763,
  McCormick_1092_PetalsUnfolding: 25764,
  McCormick_1093_WoodNymph: 25765,
  McCormick_1094_PorcelainRose: 25766,
  McCormick_1095_Empower: 25767,
  McCormick_1096_TheEgoHasLanded: 25768,
  McCormick_1097_PalePetunia: 25769,
  McCormick_1098_BubblegumPink: 25770,
  McCormick_1099_Dimple: 25771,
  McCormick_1100_HeartToHeart: 25772,
  McCormick_1101_MullenPink: 25773,
  McCormick_1102_PreciousPeony: 25774,
  McCormick_1103_Moonrose: 25775,
  McCormick_1104_Valerie: 25776,
  McCormick_1105_ItsAGirl: 25777,
  McCormick_1106_GardenGlory: 25778,
  McCormick_1107_BunnyFluff: 25779,
  McCormick_1108_PinkExplosion: 25780,
  McCormick_1109_PartyTime: 25781,
  McCormick_1110_UnmatchedBeauty: 25782,
  McCormick_1111_RoyalWedding: 25783,
  McCormick_1112_WishfulThinking: 25784,
  McCormick_1113_Fruitbowl: 25785,
  McCormick_1114_ALotOfLove: 25786,
  McCormick_1115_Dollie: 25787,
  McCormick_1116_MovieStar: 25788,
  McCormick_1117_Siren: 25789,
  McCormick_1118_CottonCandy: 25790,
  McCormick_1119_SweetPea: 25791,
  McCormick_1120_SummerCosmos: 25792,
  McCormick_1121_DahliaDelight: 25793,
  McCormick_1122_RoseMallow: 25794,
  McCormick_1123_Groovy: 25795,
  McCormick_1124_VelvetCake: 25796,
  McCormick_1125_Hepatica: 25797,
  McCormick_1126_SeashellPink: 25798,
  McCormick_1127_Pepto: 25799,
  McCormick_1128_Minuette: 25800,
  McCormick_1129_PunkyPink: 25801,
  McCormick_1130_Obsession: 25802,
  McCormick_1131_CanCan: 25803,
  McCormick_1132_SullivansHeart: 25804,
  McCormick_1133_ChristysSmile: 25805,
  McCormick_1134_PegeenPeony: 25806,
  McCormick_1135_Glam: 25807,
  McCormick_1136_Romp: 25808,
  McCormick_1137_OdeToJoy: 25809,
  McCormick_1138_RomanticNight: 25810,
  McCormick_1139_Tutu: 25811,
  McCormick_1140_FirstDaughter: 25812,
  McCormick_1141_DecoPink: 25813,
  McCormick_1142_VintageVictorian: 25814,
  McCormick_1143_RamblingRose: 25815,
  McCormick_1144_Temptress: 25816,
  McCormick_1145_RomeoORomeo: 25817,
  McCormick_1146_MorningShine: 25818,
  McCormick_1147_Columbine: 25819,
  McCormick_1148_PersianDelight: 25820,
  McCormick_1149_ParrotTulip: 25821,
  McCormick_1150_PinkBeauty: 25822,
  McCormick_1151_FusciaFizz: 25823,
  McCormick_1152_BerryPatch: 25824,
  McCormick_1153_ViennaDawn: 25825,
  McCormick_1154_Viola: 25826,
  McCormick_1155_LittleSmile: 25827,
  McCormick_1156_PinkHeath: 25828,
  McCormick_1157_BlossomsInSpring: 25829,
  McCormick_1158_PurpleHollyhock: 25830,
  McCormick_1159_Bridesmaid: 25831,
  McCormick_1160_PetalPoise: 25832,
  McCormick_1161_NurseryPink: 25833,
  McCormick_1162_VenetianRose: 25834,
  McCormick_1163_TiaraPink: 25835,
  McCormick_1164_CarnationRose: 25836,
  McCormick_1165_PinkParade: 25837,
  McCormick_1166_NobleHonor: 25838,
  McCormick_1167_DreamState: 25839,
  McCormick_1168_MarvelousMagic: 25840,
  McCormick_1169_BabyGirl: 25841,
  McCormick_1170_LavenderQuartz: 25842,
  McCormick_1171_TeenQueen: 25843,
  McCormick_1172_Immortality: 25844,
  McCormick_1173_PurpleStiletto: 25845,
  McCormick_1174_LittlePinky: 25846,
  McCormick_1175_TaffetaTint: 25847,
  McCormick_1176_PoodlePink: 25848,
  McCormick_1177_RosyCheeks: 25849,
  McCormick_1178_RoseSouvenir: 25850,
  McCormick_1179_MoonlightMelody: 25851,
  McCormick_1180_BerryLight: 25852,
  McCormick_1181_VioletAsh: 25853,
  McCormick_1182_LilacsInSpring: 25854,
  McCormick_1183_RomanticBallad: 25855,
  McCormick_1184_GracefulGarden: 25856,
  McCormick_1185_SatinFlower: 25857,
  McCormick_1186_PleasantDream: 25858,
  McCormick_1187_JoyousSong: 25859,
  McCormick_1188_MaidenOfTheMist: 25860,
  McCormick_1189_LittleTouch: 25861,
  McCormick_1190_GlitteringGemstone: 25862,
  McCormick_1191_CherishTheMoment: 25863,
  McCormick_1192_CutVelvet: 25864,
  McCormick_1193_CrownJewels: 25865,
  McCormick_1194_MagentaRedLips: 25866,
  McCormick_1195_RosiePosie: 25867,
  McCormick_1196_NaughtyMarietta: 25868,
  McCormick_1197_LavenderVeil: 25869,
  McCormick_1198_HeatherFeather: 25870,
  McCormick_1199_EnthronedAbove: 25871,
  McCormick_1200_Felicia: 25872,
  McCormick_1201_DreamyHeaven: 25873,
  McCormick_1202_DaringDeception: 25874,
  McCormick_1203_Etcetera: 25875,
  McCormick_1204_Noteworthy: 25876,
  McCormick_1205_FashionablyPlum: 25877,
  McCormick_1206_ScreenGem: 25878,
  McCormick_1207_OrchidOrchestra: 25879,
  McCormick_1208_CrowdPleaser: 25880,
  McCormick_1209_PrincessIrene: 25881,
  McCormick_1210_FrenchLavender: 25882,
  McCormick_1211_LavenderBlessing: 25883,
  McCormick_1212_PansyPosie: 25884,
  McCormick_1213_BerryBright: 25885,
  McCormick_1214_MajesticPlum: 25886,
  McCormick_1215_PurpleShadow: 25887,
  McCormick_1216_Aimee: 25888,
  McCormick_1217_VelvetBlush: 25889,
  McCormick_1218_OdysseyLilac: 25890,
  McCormick_1219_Desiree: 25891,
  McCormick_1220_PlayTime: 25892,
  McCormick_1221_CharmingViolet: 25893,
  McCormick_1222_GrapeSoda: 25894,
  McCormick_1223_OstrichTail: 25895,
  McCormick_1224_FragrantSnowbell: 25896,
  McCormick_1225_Velour: 25897,
  McCormick_1226_ImagineThat: 25898,
  McCormick_1227_VividVision: 25899,
  McCormick_1228_PetuniaPatty: 25900,
  McCormick_1229_EleanorAnn: 25901,
  McCormick_1230_CrescentMoon: 25902,
  McCormick_1231_HostaFlower: 25903,
  McCormick_1232_FlowersOfMay: 25904,
  McCormick_1233_PlumCake: 25905,
  McCormick_1234_GrapesTreasure: 25906,
  McCormick_1235_Yolanda: 25907,
  McCormick_1236_SunsetSerenade: 25908,
  McCormick_1237_EasterBunny: 25909,
  McCormick_1238_Fairytale: 25910,
  McCormick_1239_PlumsTheWord: 25911,
  McCormick_1240_DriftingDream: 25912,
  McCormick_1241_GrapeIllusion: 25913,
  McCormick_1242_GorgeousHydrangea: 25914,
  McCormick_1243_WhenRedMetBlue: 25915,
  McCormick_1244_WhiteBud: 25916,
  McCormick_1245_Perfection: 25917,
  McCormick_1246_PurplePurity: 25918,
  McCormick_1247_MayMist: 25919,
  McCormick_1248_VelvetCrest: 25920,
  McCormick_1249_PurpleSpire: 25921,
  McCormick_1250_TrueRomance: 25922,
  McCormick_1251_MountainsMajesty: 25923,
  McCormick_1252_LavenderBliss: 25924,
  McCormick_1253_PetuniaTrail: 25925,
  McCormick_1254_PurpleVision: 25926,
  McCormick_1255_PurpleHaze: 25927,
  McCormick_1256_PlumPreserve: 25928,
  McCormick_1257_Voldemort: 25929,
  McCormick_1258_SweetFlower: 25930,
  McCormick_1259_Eyeshadow: 25931,
  McCormick_1260_PrettyPosie: 25932,
  McCormick_1261_ChildishWonder: 25933,
  McCormick_1262_BaileyBells: 25934,
  McCormick_1263_Medieval: 25935,
  McCormick_1264_AltarOfHeaven: 25936,
  McCormick_1265_WhiteShoulders: 25937,
  McCormick_1266_Penelope: 25938,
  McCormick_1267_CasaDelMar: 25939,
  McCormick_1268_SpoiledRotten: 25940,
  McCormick_1269_MoodMode: 25941,
  McCormick_1270_WindStar: 25942,
  McCormick_1271_HotSauna: 25943,
  McCormick_1272_AngelKiss: 25944,
  McCormick_1273_WildflowerPrairie: 25945,
  McCormick_1274_Genevieve: 25946,
  McCormick_1275_HighStyle: 25947,
  McCormick_1276_VelvetRobe: 25948,
  McCormick_1277_RegalAzure: 25949,
  McCormick_1278_FreshTake: 25950,
  McCormick_1279_HeLovesMe: 25951,
  McCormick_1280_LilacLuster: 25952,
  McCormick_1281_Collensia: 25953,
  McCormick_1282_ButterflyBush: 25954,
  McCormick_1283_LavenderSpectacle: 25955,
  McCormick_1284_GrapesOfWrath: 25956,
  McCormick_1285_Jazlyn: 25957,
  McCormick_1286_LavenderPizzazz: 25958,
  McCormick_1287_OrchidFragrance: 25959,
  McCormick_1288_VioletCrush: 25960,
  McCormick_1289_LilacBlossom: 25961,
  McCormick_1290_VioletVibes: 25962,
  McCormick_1291_DancingInTheSpring: 25963,
  McCormick_1292_PlumPerfect: 25964,
  McCormick_1293_VioletPearl: 25965,
  McCormick_1294_LavenderScent: 25966,
  McCormick_1295_GypsyCaravan: 25967,
  McCormick_1296_VioletBeauty: 25968,
  McCormick_1297_RoyalProclamation: 25969,
  McCormick_1298_QueenOfSheba: 25970,
  McCormick_1299_SoulTrain: 25971,
  McCormick_1300_WingedVictory: 25972,
  McCormick_1301_LavenderBikini: 25973,
  McCormick_1302_HeatherHill: 25974,
  McCormick_1303_CutHeather: 25975,
  McCormick_1304_IcedOrchid: 25976,
  McCormick_1305_VictorianViolet: 25977,
  McCormick_1306_RoyalVelvet: 25978,
  McCormick_1307_Clytemnestra: 25979,
  McCormick_1308_StardustBallroom: 25980,
  McCormick_1309_SoDainty: 25981,
  McCormick_1310_VelvetDawn: 25982,
  McCormick_1311_GypsysGown: 25983,
  McCormick_1312_SouthernBelle: 25984,
  McCormick_1313_MyPlaceOrYours: 25985,
  McCormick_1314_DesiredDawn: 25986,
  McCormick_1315_Calamities: 25987,
  McCormick_1316_Savoy: 25988,
  McCormick_1317_BuffedPlum: 25989,
  McCormick_1318_DuskyMood: 25990,
  McCormick_1319_Overlook: 25991,
  McCormick_132_OceanPines: 10574,
  McCormick_1320_Blackwater: 25992,
  McCormick_200_Black: 10575,
  McCormick_202_FoxhallGreen: 10576,
  McCormick_215_CobblestoneGrey: 10577,
  McCormick_216_Hearthstone: 10578,
  McCormick_217_FarmhouseRed: 10579,
  McCormick_220_GeorgetownGreen: 10580,
  McCormick_227_Williamsburg: 10581,
  McCormick_470_SmokeyPewter: 11015,
  McCormick_488_FederalHill: 10566,
  McCormick_CW0001_WhiteShadow: 25993,
  McCormick_CW0005_CoolPlatinum: 25994,
  McCormick_CW0006_RiverStone: 25995,
  McCormick_CW0007_CityCenter: 25996,
  McCormick_CW0008_Chillax: 25997,
  McCormick_CW0009_OnPoint: 25998,
  McCormick_CW0010_HealthNut: 25999,
  McCormick_CW0014_Lunar: 26000,
  McCormick_CW0015_Metro: 26001,
  McCormick_E0002_Moonmist: 26002,
  McCormick_E0004_OysterWhite: 26003,
  McCormick_E0012_DesignerWhite: 26004,
  McCormick_E0013_ShellWhite: 26005,
  McCormick_E0101_AmberWhite: 26006,
  McCormick_E0102_Kensington: 26007,
  McCormick_E0104_HarnessShopTan: 26008,
  McCormick_E0105_Jefferson: 26009,
  McCormick_E0107_Woodspice: 26010,
  McCormick_E0108_Wheat: 26011,
  McCormick_E0109_NewMarket: 26012,
  McCormick_E0111_TavernBeige: 26013,
  McCormick_E0112_Woodland: 26014,
  McCormick_E0115_SageGreen: 26015,
  McCormick_E0118_ColonialWhite: 26016,
  McCormick_E0119_Newport: 26017,
  McCormick_E0120_KingstonClay: 26018,
  McCormick_E0121_WyeOak: 26019,
  McCormick_E0130_Tidewater: 26020,
  McCormick_E0131_JamesRiverMoss: 26021,
  McCormick_E0141_BloodMoon: 26022,
  McCormick_E0142_Berryville: 26023,
  McCormick_E0143_Sandhills: 26024,
  McCormick_E0145_Jamestown: 26025,
  McCormick_E0146_CaryTown: 26026,
  McCormick_E0147_Clarendon: 26027,
  McCormick_E0148_ThomasPoint: 26028,
  McCormick_E0207_Copperleaf: 26029,
  McCormick_E0219_Doreset: 26030,
  McCormick_E0224_DeepForestBrown: 26031,
  McCormick_E0226_CarolinaState: 26032,
  McCormick_E0228_AnnapolisGray: 26033,
  McCormick_E0229_Alexandria: 26034,
  McCormick_E0230_Camden: 26035,
  McCormick_E0231_RockCreek: 26036,
  McCormick_E0232_Takoma: 26037,
  McCormick_E0234_BayBlue: 26038,
  McCormick_E0235_Potomac: 26039,
  McCormick_E0236_Dominion: 26040,
  McCormick_E0237_GlenEcho: 26041,
  McCormick_E0242_TownHall: 26042,
  McCormick_E0243_Susquehanna: 26043,
  McCormick_E0244_Fenwick: 26044,
  McCormick_E0245_MainStreet: 26045,
  McCormick_E0246_Portsmouth: 26046,
  McCormick_E0440_Sugarloaf: 26047,
  McCormick_E0442_PuttyHill: 26048,
  McCormick_E0443_MtVernonGray: 26049,
  McCormick_E0444_BullRun: 26050,
  McCormick_E0445_GunstonHall: 26051,
  McCormick_E0446_Antietam: 26052,
  McCormick_E0447_PatuxentBlue: 26053,
  McCormick_E0448_FellsPoint: 26054,
  McCormick_E0451_YellowPearl: 26055,
  McCormick_E0452_Flintstone: 26056,
  McCormick_E0471_GrayFlannel: 26057,
  McCormick_E0472_DrumHillGray: 26058,
  McCormick_E0474_Pinewood: 26059,
  McCormick_E0475_McKinneyStone: 26060,
  McCormick_E0476_Skyline: 26061,
  McCormick_E0477_MonumentWhite: 26062,
  McCormick_E0481_CapeCharles: 26063,
  McCormick_E0483_ShenandoahSlate: 26064,
  McCormick_E0484_BallengerBlue: 26065,
  McCormick_E0485_Solomons: 26066,
  McCormick_E0486_NavyYard: 26067,
  McCormick_E0489_OldTown: 26068,
  McCormick_E0490_FoggyBottom: 26069,
  McCormick_E0491_GreatFallsMist: 26070,
  McCormick_MAG008_TrueWhite: 10567,
};

const DMC_MetalPowder_Colors = {
  AntiqueIvory: 42,
  Black: 43,
  Bronze: 1982,
  Slate: 44,
  Terratone: 45,
  VenetianBronze: 2237,
  White: 46,
};

const DMC_Metal_ABC = {
  Metal_ABC_Almond: 10346,
  Metal_ABC_AshGray: 10347,
  Metal_ABC_BoneWhite: 10348,
  Metal_ABC_BrightWhite: 10349,
  Metal_ABC_BriteRed: 10350,
  Metal_ABC_Brownstone: 10351,
  Metal_ABC_BurnishedSlate: 10352,
  Metal_ABC_CharcoalGray: 10353,
  Metal_ABC_ClassicGreen: 10354,
  Metal_ABC_CobaltBlue: 10355,
  Metal_ABC_CoffeeBrown: 10356,
  Metal_ABC_ColonialRed: 10357,
  Metal_ABC_CopperMetallic: 10358,
  Metal_ABC_DeepGray: 10359,
  Metal_ABC_DesertSand: 10360,
  Metal_ABC_Evergreen: 10361,
  Metal_ABC_Galvalume: 10362,
  Metal_ABC_HarborBlue: 10363,
  Metal_ABC_HawaiianBlue: 10364,
  Metal_ABC_HighGlossWhite: 10365,
  Metal_ABC_IvyGreen: 10366,
  Metal_ABC_LightStone: 10367,
  Metal_ABC_MediumBronze: 10368,
  Metal_ABC_MidnightBlack: 10369,
  Metal_ABC_MidnightBronze: 10370,
  Metal_ABC_PacificBlue: 10371,
  Metal_ABC_PolarWhite: 10372,
  Metal_ABC_RusticRed: 10373,
  Metal_ABC_SaddleTan: 10374,
  Metal_ABC_ScarletRed: 10375,
  Metal_ABC_SlateGray: 10376,
  Metal_ABC_SnowWhite: 10377,
  Metal_ABC_StormGray: 10378,
  Metal_ABC_TrueBlack: 10379,
  Metal_ABC_Tundra: 10380,
  Metal_ABC_White: 10381,
  Metal_ABC_WineRed: 10382,
};

const DMC_Metal_ACM = {
  Metal_ACM_Black: 10874,
  Metal_ACM_Frost: 10875,
};

const DMC_Metal_AE = {
  Metal_AE_AshGray: 10744,
  Metal_AE_Berry: 10745,
  Metal_AE_Black: 10746,
  Metal_AE_BrightRed: 10747,
  Metal_AE_BurnishedSlate: 10748,
  Metal_AE_CharcoalGray: 10749,
  Metal_AE_DesertSand: 10750,
  Metal_AE_Evergreen: 10751,
  Metal_AE_GalleryBlue: 10752,
  Metal_AE_HawaiianBlue: 10753,
  Metal_AE_HunterGreen: 10754,
  Metal_AE_Ivory: 10755,
  Metal_AE_KokoBrown: 10756,
  Metal_AE_LightStone: 10757,
  Metal_AE_MetallicCopper: 10758,
  Metal_AE_PolarWhite: 10759,
  Metal_AE_RusticRed: 10760,
  Metal_AE_SaddleTan: 10761,
};

const DMC_Metal_AFCORail = {
  Metal_AFCORail_Black: 11185,
  Metal_AFCORail_Bronze: 11186,
  Metal_AFCORail_Brown: 11187,
  Metal_AFCORail_Clay: 11188,
  Metal_AFCORail_White: 11189,
  Metal_AFCORail_Wicker: 11190,
};

const DMC_Metal_ASC = {
  ASC_ColonialRed: 10681,
  ASC_DarkBronze: 10682,
  ASC_ForestGreen: 10683,
  ASC_LeafGreen: 10684,
  ASC_MatteBlack: 10685,
  ASC_MidnightBronze: 10686,
  ASC_OldTownGray: 10687,
  ASC_Parchment: 10688,
  ASC_Pebble: 10689,
  ASC_RegalBlue: 10690,
  ASC_RegalWhite: 10691,
  ASC_SageGreen: 10692,
  ASC_SierraTan: 10693,
  ASC_SlateGray: 10694,
  ASC_TahoeBlue: 10695,
  ASC_TerraCotta: 10696,
  ASC_Vintage: 10697,
  ASC_Walnut: 10698,
  ASC_WeatheredCopper: 10699,
  ASC_ZincGray: 10700,
};

const DMC_Metal_Amerimax = {
  Metal_Amerimax_White: 11175,
};

const DMC_Metal_BandA = {
  BandA_BarnRed: 11425,
  BandA_Black: 11426,
  BandA_BrightWhite: 11427,
  BandA_Brown: 11428,
  BandA_Burgundy: 11429,
  BandA_BurnishedSlate: 11430,
  BandA_Charcoal: 11431,
  BandA_Clay: 11432,
  BandA_CopperPenny: 11433,
  BandA_DarkRed: 11434,
  BandA_Evergreen: 11435,
  BandA_GalleryBlue: 11436,
  BandA_Gray: 11437,
  BandA_HawaiianBlue: 11438,
  BandA_InteriorWhite: 11439,
  BandA_LightStone: 11440,
  BandA_Tan: 11441,
};

const DMC_Metal_BerridgeColors = {
  AgedBronze: 2048,
  Almond: 2049,
  AwardBlue: 2050,
  BristolBlue: 2051,
  Buckskin: 2052,
  Burgundy: 2053,
  CharcoalGrey: 2054,
  CityScape: 2055,
  ColonialRed: 2056,
  CopperBrown: 2057,
  DarkBronze: 2058,
  DeepRed: 2059,
  Evergreen: 2060,
  ForestGreen: 2061,
  HartfordGreen: 2062,
  HemlockGreen: 2063,
  MatteBlack: 2064,
  MediumBronze: 2065,
  NaturalWhite: 2066,
  Parchment: 2067,
  PatinaGreen: 2068,
  RoyalBlue: 2069,
  ShastaWhite: 2070,
  SierraTan: 2071,
  TealGreen: 2072,
  TerraCotta: 2073,
  ZincGrey: 2074,
};

const DMC_Metal_CMG = {
  CMG_Almond: 11266,
  CMG_AntiqueIvory: 11267,
  CMG_AshGray: 11268,
  CMG_BoneWhite: 11269,
  CMG_BrightWhite: 11270,
  CMG_Burgundy: 11271,
  CMG_BurnishedSlate: 11272,
  CMG_CharcoalGray: 11273,
  CMG_Cityscape: 11274,
  CMG_ClassicGreen: 11275,
  CMG_ColonialRed: 11276,
  CMG_DarkBronze: 11277,
  CMG_DeepBlack: 11222,
  CMG_ExtraDarkBronze: 11278,
  CMG_HartfordGreen: 11279,
  CMG_HemlockGreen: 11280,
  CMG_MansardBrown: 11281,
  CMG_MatteBlack: 10966,
  CMG_MediumBronze: 11282,
  CMG_MusketGray: 11283,
  CMG_PebbleClay: 11284,
  CMG_RegalRed: 11285,
  CMG_RoyalBlue: 11286,
  CMG_Sandstone: 11287,
  CMG_SierraTan: 11288,
  CMG_SlateBlue: 11289,
  CMG_SlateGray: 11290,
  CMG_StoneWhite: 11291,
  CMG_Teal: 11292,
  CMG_TerraCotta: 11293,
};

const DMC_Metal_CascadiaMetals = {
  CM_AntiqueLinen: 11367,
  CM_ApplianceWhite: 11368,
  CM_Black: 11369,
  CM_BoneWhite: 11370,
  CM_BriarwoodTan: 11371,
  CM_BrightRed: 11372,
  CM_BrightWhite: 11373,
  CM_Buckskin: 11374,
  CM_Burgundy: 11375,
  CM_CambridgeWhite: 11376,
  CM_Cashmere: 11377,
  CM_Charcoal: 11378,
  CM_CoffeeBrown: 11379,
  CM_DarkBrown: 11380,
  CM_DarkGraphite: 11381,
  CM_DarkGreen: 11382,
  CM_DarkRed: 11383,
  CM_DeepWaterGreen: 11384,
  CM_ForestGreen: 11385,
  CM_Gold: 11386,
  CM_HeronBlue: 11387,
  CM_IronOre: 11388,
  CM_LabradorBlue: 11389,
  CM_MelchersGreen: 11390,
  CM_MetroBrown: 11391,
  CM_MistGreen: 11392,
  CM_PacificTurquoise: 11393,
  CM_Pebblestone: 11394,
  CM_PolarWhite: 11395,
  CM_RegentGrey: 11396,
  CM_RoyalBlue: 11397,
  CM_SageGreen: 11398,
  CM_SapphireBlue: 11399,
  CM_SlateBlue: 11400,
  CM_SpruceGreen: 11401,
  CM_StoneGrey: 11402,
  CM_SurfWhite: 11403,
  CM_Tan: 11404,
  CM_TileRed: 11405,
  CM_Turquoise: 11406,
  CM_WhiteWhite: 11407,
  CM_Wicker: 11408,
};

const DMC_Metal_CentralStatesColors = {
  CS_Alamo: 4499,
  CS_Basil: 4500,
  CS_Black: 4501,
  CS_Brilliant: 4502,
  CS_Brown: 4503,
  CS_Burgundy: 4504,
  CS_BurnishedSlate: 4505,
  CS_Charcoal: 4506,
  CS_Colony: 4507,
  CS_CopperMetallic: 4508,
  CS_CovertGreen: 4509,
  CS_Cream: 4510,
  CS_Crimson: 4511,
  CS_CrimsonRed: 4512,
  CS_DarkBrown: 4513,
  CS_DeepRed: 4514,
  CS_Desert: 4515,
  CS_Forest: 4516,
  CS_Gallery: 4517,
  CS_Granite: 4518,
  CS_GraniteClay: 4519,
  CS_Gray: 4520,
  CS_HickoryMoss: 4521,
  CS_Hunter: 4522,
  CS_Ivory: 4523,
  CS_LightStone: 4524,
  CS_Linen: 4525,
  CS_LunarGray: 4526,
  CS_Mineral: 4527,
  CS_Ocean: 4528,
  CS_Onyx: 4529,
  CS_Pewter: 4530,
  CS_Polar: 4531,
  CS_Roma: 4532,
  CS_Rustic: 4533,
  CS_Sienna: 4534,
  CS_Sierra: 4535,
  CS_Suede: 4536,
  CS_Sumatra: 4537,
  CS_Tan: 4538,
  CS_Taupe: 4539,
  CS_TrueBlack: 4540,
};

const DMC_Metal_ColorKlad = {
  ColorKlad_AgedCopper: 11294,
  ColorKlad_Almond: 11295,
  ColorKlad_AshGray: 11296,
  ColorKlad_BannerRed: 11297,
  ColorKlad_Black: 11298,
  ColorKlad_BoneWhite: 11299,
  ColorKlad_CharcoalGray: 10924,
  ColorKlad_ClassicGreen: 11300,
  ColorKlad_ColonialRed: 11301,
  ColorKlad_DarkBronze: 11302,
  ColorKlad_DoveGray: 11303,
  ColorKlad_HartfordGreen: 11304,
  ColorKlad_MansardBrown: 11305,
  ColorKlad_MediumBronze: 11306,
  ColorKlad_MusketGray: 11307,
  ColorKlad_PatinaGreen: 11308,
  ColorKlad_RegalWhite: 11309,
  ColorKlad_RoyalBlue: 11310,
  ColorKlad_Sandstone: 11311,
  ColorKlad_SierraTan: 11312,
  ColorKlad_SlateBlue: 11313,
  ColorKlad_SlateGray: 11314,
  ColorKlad_Snowdrift: 11315,
  ColorKlad_StoneWhite: 11316,
  ColorKlad_TerraCotta: 11317,
};

const DMC_Metal_Colors = {
  BurnishedSlate: 4470,
  Charcoal: 178,
  Kabul: 247,
  OldLavender: 248,
  Slate: 179,
  White: 183,
};

const DMC_Metal_DrexelColors = {
  Drexel_AgedBronze: 10511,
  Drexel_Almond: 10512,
  Drexel_AntiqueBronze: 10513,
  Drexel_Black: 10514,
  Drexel_BoneWhite: 10515,
  Drexel_Buckskin: 10516,
  Drexel_Burgundy: 10517,
  Drexel_BurnishedSlate: 10518,
  Drexel_Charcoal: 10519,
  Drexel_Cityscape: 10520,
  Drexel_ColonialRed: 10521,
  Drexel_CopperPenny: 10555,
  Drexel_DarkBronze: 10522,
  Drexel_Evergreen: 10523,
  Drexel_ForestGreen: 10524,
  Drexel_Graphite: 10525,
  Drexel_HartfordGreen: 10526,
  Drexel_HemlockGreen: 10527,
  Drexel_InterstateBlue: 10528,
  Drexel_IronOre: 10529,
  Drexel_MansardBrown: 10530,
  Drexel_MediumBronze: 10531,
  Drexel_MidnightBronze: 10532,
  Drexel_MilitaryBlue: 10533,
  Drexel_MusketGray: 10534,
  Drexel_Onyx: 10535,
  Drexel_PacificBlue: 10536,
  Drexel_PatinaGreen: 10537,
  Drexel_RegalWhite: 10538,
  Drexel_Sandstone: 10539,
  Drexel_SierraTan: 10540,
  Drexel_SlateGray: 10541,
  Drexel_StoneWhite: 10542,
  Drexel_Teal: 10543,
  Drexel_TerraCotta: 10544,
};

const DMC_Metal_Englert = {
  Englert_CharcoalGray: 10568,
  Englert_DarkBronze: 10569,
  Englert_HartfordGreen: 10570,
  Englert_MatteBlack: 10571,
  Englert_MediumBronze: 10572,
  Englert_SlateGrey: 11016,
};

const DMC_Metal_Everlast = {
  Almond: 10428,
  BoneWhite: 10429,
  Burgundy: 10430,
  BurnishedSlate: 10431,
  Charcoal: 10432,
  Cityscape: 10433,
  ClassicBronze: 10434,
  ColonialRed: 10435,
  DarkBronze: 10436,
  DarkGray: 10437,
  ForestGreen: 10438,
  GalleryBlue: 10439,
  HartfordGreen: 10440,
  MansardBrown: 10441,
  MatteBlack: 10442,
  MetallicChampagne: 10443,
  MetallicCopper: 10444,
  MetallicSilver: 10445,
  PatinaGreen: 10446,
  RegalRed: 10447,
  Sandstone: 10448,
  SierraTan: 10449,
  SlateBlue: 10450,
  SlateGray: 10451,
  StoneWhite: 10452,
  TerraCotta: 10453,
};

const DMC_Metal_Fabral = {
  Fabral_Almond: 11341,
  Fabral_BoneWhite: 11342,
  Fabral_BrightSilverS66: 11343,
  Fabral_Charcoal: 11344,
  Fabral_ClassicGreen: 11345,
  Fabral_DarkBronze: 11346,
  Fabral_DoveGray: 11347,
  Fabral_MatteBlack: 11348,
  Fabral_MediumBronze: 11349,
  Fabral_RegalWhite: 11350,
  Fabral_Sandstone: 11351,
  Fabral_SlateGray: 11352,
  Fabral_SurreyBeige: 11353,
};

const DMC_Metal_HomeRail = {
  HomeRail_Black: 11022,
  HomeRail_Linen: 11023,
  HomeRail_Sable: 11024,
  HomeRail_Silver: 11025,
  HomeRail_White: 11026,
  HomeRail_YardBronze: 11027,
};

const DMC_Metal_JetMetals = {
  JM_AgedBronze: 11223,
  JM_AgedCopper: 11224,
  JM_Almond: 11225,
  JM_AntiqueBronze: 11226,
  JM_AwardBlue: 11227,
  JM_Black: 11228,
  JM_BoneWhite: 11229,
  JM_BuckSkin: 11230,
  JM_Burgundy: 11231,
  JM_CardinalRed: 11232,
  JM_Champagne: 11233,
  JM_Charcoal: 11234,
  JM_Cityscape: 11235,
  JM_ColonialRed: 11236,
  JM_CopperPenny: 11237,
  JM_DarkBronze: 11238,
  JM_ForestGreen: 11239,
  JM_Galvalume: 11240,
  JM_Granite: 11241,
  JM_HartfordGreen: 11242,
  JM_HemlockGreen: 11243,
  JM_InterstateBlue: 11244,
  JM_IronOre: 11245,
  JM_MansardBrown: 11246,
  JM_MediumBronze: 11247,
  JM_MidnightBronze: 11248,
  JM_MilitaryBlue: 11249,
  JM_MusketGray: 11250,
  JM_PacificBlue: 11251,
  JM_PatinaGreen: 11252,
  JM_Sandstone: 11253,
  JM_SierraTan: 11254,
  JM_Silver: 11255,
  JM_SlateGray: 11256,
  JM_StoneWhite: 11257,
  JM_Teal: 11258,
  JM_TerraCotta: 11259,
  JM_Zinc: 11260,
};

const DMC_Metal_MBCI = {
  MBCI_TrueBlack: 10804,
};

const DMC_Metal_McElroy = {
  McElroy_MatteBlack: 10642,
  McElroy_PatricianBronze: 10643,
  McElroy_Sandstone: 10644,
  McElroy_SlateGray: 10645,
};

const DMC_Metal_MetalRoofingSystems = {
  MRS_DarkBronze: 10862,
  MRS_MatteBlack: 10863,
};

const DMC_Metal_Mueller = {
  Mueller_CharcoalGray: 10636,
  Mueller_MatteBlack: 10637,
  Mueller_SilverMetallic: 10638,
};

const DMC_Metal_PAC = {
  PAC_BlackAluminum: 10557,
  PAC_BoneWhite: 10558,
  PAC_Charcoal: 10559,
  PAC_DarkBronze: 10560,
  PAC_RegalWhite: 10561,
  PAC_StoneWhite: 10562,
};

const DMC_Metal_ProSnap = {
  ProSnap_CharcoalGray: 10876,
};

const DMC_Metal_ProVia = {
  ProVia_Briarwood: 10646,
  ProVia_Pepperwood: 10647,
  ProVia_Shadewood: 10648,
};

const DMC_Metal_Scheffield = {
  Sheffield_AshGray: 10925,
  Sheffield_Burgundy: 10926,
  Sheffield_BurnishedSlate: 10927,
  Sheffield_CharcoalGray: 10928,
  Sheffield_ColonialRed: 10929,
  Sheffield_DarkBronze: 10930,
  Sheffield_DoveGray: 10931,
  Sheffield_Evergreen: 10932,
  Sheffield_HartfordGreen: 10933,
  Sheffield_HemlockGreen: 10934,
  Sheffield_MansardBrown: 10935,
  Sheffield_MatteBlack: 10936,
  Sheffield_MediumBronze: 10937,
  Sheffield_PatinaGreen: 10938,
  Sheffield_RegalBlue: 10939,
  Sheffield_RegalRed: 10940,
  Sheffield_RegalWhite: 10941,
  Sheffield_Sandstone: 10942,
  Sheffield_SierraTan: 10943,
  Sheffield_SlateBlue: 10944,
  Sheffield_SlateGray: 10945,
  Sheffield_SolarWhite: 10946,
  Sheffield_StoneWhite: 10947,
  Sheffield_SurreyBeige: 10948,
  Sheffield_TerraCotta: 10949,
};

const DMC_Metal_SchellColors = {
  Champagne: 2026,
  CharcoalGray: 2027,
  MatteBlack: 2028,
  SilverMetallic: 2029,
  SlateBlue: 2030,
};

const DMC_Metal_Sentriclad = {
  Metal_Sentriclad_AgedCopperMetallic: 11455,
  Metal_Sentriclad_Almond: 11456,
  Metal_Sentriclad_BannerRed: 11457,
  Metal_Sentriclad_BoneWhite: 11458,
  Metal_Sentriclad_Brandywine: 11459,
  Metal_Sentriclad_BrightCopperS25: 11460,
  Metal_Sentriclad_BrightSilverS66: 11461,
  Metal_Sentriclad_ChampagneS20: 11462,
  Metal_Sentriclad_Charcoal: 11463,
  Metal_Sentriclad_ClassicGreen: 11464,
  Metal_Sentriclad_ColonialRed: 11465,
  Metal_Sentriclad_DarkBronze: 11466,
  Metal_Sentriclad_DoveGray: 11467,
  Metal_Sentriclad_ExtraDarkBronze: 11468,
  Metal_Sentriclad_HartfordGreen: 11469,
  Metal_Sentriclad_MansardBrown: 11470,
  Metal_Sentriclad_MatteBlack: 11471,
  Metal_Sentriclad_MediumBronze: 11472,
  Metal_Sentriclad_PatinaGreen: 11473,
  Metal_Sentriclad_PewterS11: 11474,
  Metal_Sentriclad_RegalBlue: 11475,
  Metal_Sentriclad_RegalWhite: 11476,
  Metal_Sentriclad_Sandstone: 11477,
  Metal_Sentriclad_SierraTan: 11478,
  Metal_Sentriclad_SilversmithS15: 11479,
  Metal_Sentriclad_SlateBlue: 11480,
  Metal_Sentriclad_SlateGray: 11481,
  Metal_Sentriclad_SnowWhite: 11482,
  Metal_Sentriclad_Teal: 11483,
  Metal_Sentriclad_TerraCotta: 11484,
  Metal_Sentriclad_TrueBlack: 11485,
};

const DMC_Metal_SpectraPro = {
  SpectraPro_Black: 11261,
  SpectraPro_Bronze: 11262,
  SpectraPro_ForestGreen: 11263,
  SpectraPro_LowGlossWhite: 11264,
  SpectraPro_MusketBrown: 11265,
};

const DMC_Metal_WesternStatesColors = {
  PVDF_Almond: 4432,
  PVDF_AshGray: 4433,
  PVDF_BoneWhite: 4434,
  PVDF_BurnishedSlate: 4435,
  PVDF_Champagne: 4436,
  PVDF_CharcoalGray: 4437,
  PVDF_ClassicGreen: 4438,
  PVDF_ColonialRed: 4439,
  PVDF_CopperPenny: 4440,
  PVDF_DarkBronze: 4441,
  PVDF_DesertTan: 4442,
  PVDF_DolphinGray: 4443,
  PVDF_DoveGray: 4444,
  PVDF_GunMetalGray: 4445,
  PVDF_MansardBrown: 4446,
  PVDF_MatteBlack: 4447,
  PVDF_MediumBronze: 4448,
  PVDF_RegalBlue: 4449,
  PVDF_RegalRed: 4450,
  PVDF_RegalWhite: 4451,
  PVDF_RoyalBlue: 4452,
  PVDF_Sandstone: 4453,
  PVDF_SilverMetallic: 4454,
  PVDF_SlateBlue: 4455,
  PVDF_SlateGray: 4456,
  PVDF_TerraCotta: 4457,
  PVDF_ZincMetallic: 4458,
};

const DMC_MidAmerica = {
  MA001_White: 10627,
  MA002_Black: 10628,
  MA008_Clay: 11325,
  MA010_MusketBrown: 11326,
  MA018_TuxedoGrey: 10680,
  MA027_BurgundyRed: 11327,
  MA028_ForestGreen: 11328,
  MA030_Paintable: 11329,
  MA036_ClassicBlue: 11330,
  MA078_Wineberry: 11331,
  MA116_MidnightBlue: 11332,
  MA385_FrenchRoast: 11333,
  MA419_StormCloud: 10762,
  MA471_TreatedCedar: 11334,
  MA945_Platinum: 11335,
};

const DMC_Monier = {
  Monier_Aniseed: 9519,
  Monier_Aurora: 31075,
  Monier_Babylon: 9520,
  Monier_Barramundi: 9521,
  Monier_Bedrock: 31076,
  Monier_Camelot: 31077,
  Monier_Caraway: 31078,
  Monier_Chilli: 9522,
  Monier_Comet: 31079,
  Monier_CottageRed: 31080,
  Monier_Earth: 31081,
  Monier_FlorenceRed: 31082,
  Monier_Mars: 31083,
  Monier_MistGrey: 9523,
  Monier_MysticGrey: 31084,
  Monier_Peak: 31085,
  Monier_PotteryBrown: 31086,
  Monier_Ravine: 31087,
  Monier_Riverstone: 31088,
  Monier_Saffron: 9524,
  Monier_SaltSpray: 9525,
  Monier_Sambuca: 9526,
  Monier_Seashell: 9527,
  Monier_SilverPerch: 31089,
  Monier_SohoNight: 31090,
  Monier_Sunset: 31091,
  Monier_Tanbark: 31092,
  Monier_Titan: 31093,
  Monier_TitanGloss: 31094,
  Monier_WildRice: 9528,
  Monier_Wollemi: 31095,
};

const DMC_Mortar_GeneralShale = {
  GS_Mortar_Black: 10916,
  GS_Mortar_Buff: 10917,
  GS_Mortar_Gray: 10918,
  GS_Mortar_Red: 10919,
  GS_Mortar_White: 10920,
};

const DMC_Norandex = {
  Norandex_Almond: 1739,
  Norandex_Beige: 6496,
  Norandex_Cactus: 6497,
  Norandex_CarbonBrown: 6570,
  Norandex_Champagne: 6498,
  Norandex_Cream: 6499,
  Norandex_DeepWater: 6571,
  Norandex_Evergreen: 1740,
  Norandex_Fern: 6500,
  Norandex_Firebrick: 6572,
  Norandex_Granite: 6501,
  Norandex_Graphite: 6502,
  Norandex_Khaki: 6503,
  Norandex_Linen: 1741,
  Norandex_MaverickBrown: 6504,
  Norandex_Mocha: 6505,
  Norandex_MusketBrown: 1742,
  Norandex_Myrtle: 6573,
  Norandex_Olive: 6506,
  Norandex_RoyalBrown: 1743,
  Norandex_Russet: 6507,
  Norandex_RusticCedar: 10877,
  Norandex_Sandstone: 1744,
  Norandex_Seaport: 6508,
  Norandex_Sierra: 1745,
  Norandex_Silver: 6509,
  Norandex_Smoke: 6510,
  Norandex_SteelBlue: 6511,
  Norandex_Tan: 1747,
  Norandex_Tumbleweed: 6512,
  Norandex_Vinyl_AcadiaGreen: 21065,
  Norandex_Vinyl_Beige: 21066,
  Norandex_Vinyl_Black: 21067,
  Norandex_Vinyl_Cactus: 21068,
  Norandex_Vinyl_CarbonBrown: 21069,
  Norandex_Vinyl_Champagne: 21070,
  Norandex_Vinyl_Cobblestone: 21071,
  Norandex_Vinyl_Cream: 21072,
  Norandex_Vinyl_DeepWater: 21073,
  Norandex_Vinyl_DoveGray: 21074,
  Norandex_Vinyl_Fern: 21075,
  Norandex_Vinyl_Firebrick: 21076,
  Norandex_Vinyl_GenevaBlue: 21077,
  Norandex_Vinyl_Granite: 21078,
  Norandex_Vinyl_Graphite: 21079,
  Norandex_Vinyl_HarborFog: 21080,
  Norandex_Vinyl_JamestownBlue: 21081,
  Norandex_Vinyl_Khaki: 21082,
  Norandex_Vinyl_MaverickBrown: 21083,
  Norandex_Vinyl_Mocha: 21084,
  Norandex_Vinyl_MusketBrown: 21085,
  Norandex_Vinyl_Myrtle: 21086,
  Norandex_Vinyl_Olive: 21087,
  Norandex_Vinyl_RoyalBrown: 21088,
  Norandex_Vinyl_Russet: 21089,
  Norandex_Vinyl_RusticCedar: 21090,
  Norandex_Vinyl_Sandstone: 21091,
  Norandex_Vinyl_Seaport: 21092,
  Norandex_Vinyl_Sierra: 21093,
  Norandex_Vinyl_Silver: 21094,
  Norandex_Vinyl_Smoke: 21095,
  Norandex_Vinyl_SteelBlue: 21096,
  Norandex_Vinyl_Tan: 21097,
  Norandex_Vinyl_Tumbleweed: 21098,
  Norandex_Vinyl_VictorianStone: 21099,
  Norandex_Vinyl_VintageGrey: 21100,
  Norandex_Vinyl_Wedgewood: 21101,
  Norandex_Vinyl_Wheat: 21102,
  Norandex_Vinyl_White: 21103,
  Norandex_Vinyl_Yellow: 21104,
  Norandex_Wedgewood: 6513,
  Norandex_Wheat: 10878,
  Norandex_White: 1746,
};

const DMC_Olympic = {
  Olympic_A172_WinterWheat: 1867,
  Olympic_B522_Serenity: 1868,
  Olympic_C142_HeavyCream: 1869,
  Olympic_C143_SpicedVinegar: 1870,
  Olympic_C155_TimberBeam: 1871,
  Olympic_C212_Shoreland: 1872,
  Olympic_C243_SombreroTan: 1873,
  Olympic_C316_WarmMahogany: 1874,
  Olympic_C373_CanyonPink: 1875,
  Olympic_C612_SeaSprite: 1876,
  Olympic_C624_PineRidge: 1877,
  Olympic_C646_RoyalHunterGreen: 1878,
  Olympic_D144_OysterShell: 1879,
  Olympic_D161_WhisperingWind: 1880,
  Olympic_D216_Kodiak: 1881,
  Olympic_D564_Feldspar: 1882,
  Olympic_D565_LavaGray: 1883,
  Olympic_D645_Submarine: 1884,
  Olympic_D673_Balsam: 1885,
  Olympic_D681_RainCloud: 1886,
};

const DMC_Omega_Stucco = {
  O1C020_Snow: 10639,
  O1C035_Quake: 10640,
  O1C315_Featherly: 10641,
  OP010_OmegaWhite: 2192,
  OP012_Chenille: 2193,
  OP015_BirchWhite: 2194,
  OP018_Coconut: 2195,
  OP020_Ivory: 2196,
  OP035_Cloud: 2197,
  OP056_PearlyGrey: 2198,
  OP069_TrueGrey: 2199,
  OP221_HarvestGold: 2200,
  OP232_Sonoma: 2201,
  OP233_Chimayo: 2202,
  OP236_AntiqueGreen: 2203,
  OP237_RockGreen: 2204,
  OP240_JetGrey: 2205,
  OP241_Cobblestone: 2206,
  OP242_Mist: 2207,
  OP243_CastleRock: 2208,
  OP244_Wolf: 2209,
  OP245_Shoreline: 2210,
  OP246_RoyalTaupe: 2211,
  OP247_CoolGrey: 2212,
  OP248_ArticIce: 2213,
  OP249_MorningFog: 2214,
  OP250_Bone: 2215,
  OP251_Lace: 2216,
  OP400_TavernTaupe: 2217,
  OP401_BarnSwallow: 2218,
  OP405_SurreyBeige: 2219,
  OP409_ToffeeCrunch: 2220,
  OP412_BisonBeige: 2221,
  OP414_CloudCover: 2222,
  OP415_OnionSkin: 2223,
  OP416_SafariTan: 2224,
  OP419_LightToast: 2225,
  OP420_FloralWhite: 2226,
  OP422_GreatWall: 2227,
  OP426_StillCreek: 2228,
  OP429_SierraLeone: 2229,
  OP430_Mocha: 2230,
  OP432_MilkyQuartz: 2231,
  OP433_PrairieDog: 2232,
  OP434_VanillaCream: 2233,
  OP435_Butterscotch: 2234,
  OP437_RoughKhaki: 2235,
  OP438_MojaveSunset: 2236,
};

const DMC_PPG = {
  PPG_SOL_528_Driftwood: 21107,
  PPG0993_1_Peregrine: 2271,
  PPG0993_2_Train: 2272,
  PPG0993_3_GoslingGray: 2273,
  PPG0993_4_GraySuit: 2274,
  PPG0993_5_SuperheroGray: 2275,
  PPG0993_6_OldSilk: 2276,
  PPG0993_7_MoodySky: 2277,
  PPG0994_1_AfraidOfTheDark: 2278,
  PPG0994_2_PittsburghGray: 2279,
  PPG0994_3_HalfDome: 2280,
  PPG0994_4_Hippopotamus: 2281,
  PPG0994_5_SteelCurtain: 2282,
  PPG0994_6_HuskyGray: 2283,
  PPG0994_7_Pencilpoint: 2284,
  PPG0995_1_ShadedWhisper: 2285,
  PPG0995_2_AncientCloud: 2286,
  PPG0995_3_SilverBand: 2287,
  PPG0995_4_PigeonFeather: 2288,
  PPG0995_5_BurnishedBlade: 2289,
  PPG0995_6_CitySkyline: 2290,
  PPG0995_7_StarlessSky: 2291,
  PPG0996_1_ShiningScale: 2292,
  PPG0996_2_SteelyGaze: 2293,
  PPG0996_3_StatueGarden: 2294,
  PPG0996_4_CloudySlate: 2295,
  PPG0996_5_Steamship: 2296,
  PPG0996_6_SlateMine: 2297,
  PPG0996_7_SummerShadow: 2298,
  PPG0997_1_AlleghenyRiver: 2299,
  PPG0997_2_FeltedWool: 2300,
  PPG0997_3_FreshGranite: 2301,
  PPG0997_4_Precipitation: 2302,
  PPG0997_5_PlayingPossum: 2303,
  PPG0997_6_IndustrialRevolution: 2304,
  PPG0997_7_BlackWidow: 2305,
  PPG0998_1_CottonTail: 2306,
  PPG0998_2_HikersParadise: 2307,
  PPG0998_3_Kalispell: 2308,
  PPG0998_4_Shadowy: 2309,
  PPG0998_5_MtRainier: 2310,
  PPG0998_6_OnTheEdge: 2311,
  PPG0998_7_Undercover: 2312,
  PPG0999_1_InTheCloud: 2313,
  PPG0999_2_RabbitsEar: 2314,
  PPG0999_3_BoulderCreek: 2315,
  PPG0999_4_SteepedTea: 2316,
  PPG0999_5_SweaterWeather: 2317,
  PPG0999_6_StolenRock: 2318,
  PPG0999_7_DarkWoods: 2319,
  PPG10_01_Oceania: 2662,
  PPG10_02_SorcerersSpell: 2663,
  PPG10_03_TwilightStroll: 2664,
  PPG10_04_Polaris: 2665,
  PPG10_05_OysterWhite: 2666,
  PPG10_06_Thunderbolt: 2667,
  PPG10_07_BayOfFundy: 2668,
  PPG10_08_GaleForce: 2669,
  PPG10_09_SoothingSapphire: 2670,
  PPG10_10_HatterasGray: 2671,
  PPG10_11_Seastone: 2672,
  PPG10_12_CoolGray: 2673,
  PPG10_13_Foretell: 2674,
  PPG10_14_Stormy: 2675,
  PPG10_15_Quest: 2676,
  PPG10_16_Artifact: 2677,
  PPG10_17_BlueOpal: 2678,
  PPG10_18_Debonaire: 2679,
  PPG10_19_FavoriteFlannel: 2680,
  PPG10_20_CoastOfMaine: 2681,
  PPG10_21_Acceleration: 2682,
  PPG10_22_LicenseToDream: 2683,
  PPG10_23_AsterPetal: 2684,
  PPG10_24_Inevitable: 2685,
  PPG10_25_WintersBreath: 2686,
  PPG10_26_SimplyElegant: 2687,
  PPG10_27_Tradewinds: 2688,
  PPG10_28_Peace: 2689,
  PPG10_29_DustyAqua: 2690,
  PPG10_30_NiagaraMist: 2691,
  PPG10_31_WhiteClover: 2692,
  PPG10_32_BlueTang: 2693,
  PPG1000_1_DustBunny: 2320,
  PPG1000_2_RockyRoad: 2321,
  PPG1000_3_Fieldstone: 2322,
  PPG1000_4_WinterCocoa: 2323,
  PPG1000_5_BearCub: 2324,
  PPG1000_6_Thunderstruck: 2325,
  PPG1000_7_ChocolateLab: 2326,
  PPG1001_1_DelicateWhite: 2327,
  PPG1001_2_Aria: 2328,
  PPG1001_3_ThinIce: 2329,
  PPG1001_4_Flagstone: 2330,
  PPG1001_5_DoverGray: 2331,
  PPG1001_6_KnightsArmor: 2332,
  PPG1001_7_BlackMagic: 2333,
  PPG1002_1_SilverFeather: 2334,
  PPG1002_2_ArcticCotton: 2335,
  PPG1002_3_CoolSlate: 2336,
  PPG1002_4_GrayMarble: 2337,
  PPG1002_5_AntiqueSilver: 2338,
  PPG1002_6_GibraltarGray: 2339,
  PPG1002_7_PhantomMist: 2340,
  PPG1003_1_FallChill: 2341,
  PPG1003_2_Balanced: 2342,
  PPG1003_3_SilverBells: 2343,
  PPG1003_4_Equilibrium: 2344,
  PPG1003_5_ShiningArmor: 2345,
  PPG1003_6_CrackedSlate: 2346,
  PPG1003_7_Blackhearth: 2347,
  PPG1004_1_GoToGray: 2348,
  PPG1004_2_FreeReign: 2349,
  PPG1004_3_Hush: 2350,
  PPG1004_4_SilverService: 2351,
  PPG1004_5_PewterMug: 2352,
  PPG1004_6_PhantomHue: 2353,
  PPG1004_7_BlackElegance: 2354,
  PPG1005_1_DuskyDawn: 2355,
  PPG1005_2_Elusion: 2356,
  PPG1005_3_GrayShadows: 2357,
  PPG1005_4_SlatePebble: 2358,
  PPG1005_5_ElephantGray: 2359,
  PPG1005_6_OswegoTea: 2360,
  PPG1005_7_DarkGranite: 2361,
  PPG1006_1_Gypsum: 2362,
  PPG1006_2_Shark: 2363,
  PPG1006_3_EarlyEvening: 2364,
  PPG1006_4_Mercurial: 2365,
  PPG1006_5_SoSublime: 2366,
  PPG1006_6_Deconstruction: 2367,
  PPG1006_7_Metropolis: 2368,
  PPG1007_1_WillowSprings: 2369,
  PPG1007_2_SwirlingSmoke: 2370,
  PPG1007_3_GhostWriter: 2371,
  PPG1007_4_HotStone: 2372,
  PPG1007_5_LazyAfternoon: 2373,
  PPG1007_6_CoolCharcoal: 2374,
  PPG1007_7_Bark: 2375,
  PPG1008_1_Focus: 2376,
  PPG1008_2_StormsComing: 2377,
  PPG1008_3_Greyhound: 2378,
  PPG1008_4_GrayByMe: 2379,
  PPG1008_5_RollerCoaster: 2380,
  PPG1008_6_Artillery: 2381,
  PPG1008_7_StonesThrow: 2382,
  PPG1009_1_TundraFrost: 2383,
  PPG1009_2_Tornado: 2384,
  PPG1009_3_SolitaryState: 2385,
  PPG1009_4_GrayStone: 2386,
  PPG1009_5_PhoenixFossil: 2387,
  PPG1009_6_Armory: 2388,
  PPG1009_7_Licorice: 2389,
  PPG1010_1_Pegasus: 2390,
  PPG1010_2_Fog: 2391,
  PPG1010_3_Solstice: 2392,
  PPG1010_4_SteppingStone: 2393,
  PPG1010_5_Downpour: 2394,
  PPG1010_6_UpInSmoke: 2395,
  PPG1010_7_Zombie: 2396,
  PPG1011_1_PacificPearl: 2397,
  PPG1011_2_Elemental: 2398,
  PPG1011_3_Stargazer: 2399,
  PPG1011_4_Ufo: 2400,
  PPG1011_4_UFO: 31096,
  PPG1011_5_Improbable: 2401,
  PPG1011_6_GlazedGranite: 2402,
  PPG1011_7_Onyx: 2403,
  PPG1012_1_IcyBay: 2404,
  PPG1012_2_InvernessGray: 2405,
  PPG1012_3_Tinsel: 2406,
  PPG1012_4_GrayFrost: 2407,
  PPG1012_5_SteepleGray: 2408,
  PPG1012_6_VolcanicAsh: 2409,
  PPG1012_7_BlackForest: 2410,
  PPG1013_1_Radisson: 2411,
  PPG1013_2_SpringThaw: 2412,
  PPG1013_3_Whirlwind: 2413,
  PPG1013_4_SilverCharm: 2414,
  PPG1013_5_VictorianPewter: 2415,
  PPG1013_6_GrayFlannel: 2416,
  PPG1013_7_Napoleon: 2417,
  PPG1014_1_GlacialIce: 2418,
  PPG1014_2_GrayWhisper: 2419,
  PPG1014_3_SilverScreen: 2420,
  PPG1014_4_JackRabbit: 2421,
  PPG1014_5_GrayViolet: 2422,
  PPG1014_6_EagleEye: 2423,
  PPG1014_7_BlackWalnut: 2424,
  PPG1015_1_VanillaMilkshake: 2425,
  PPG1015_2_StoneQuarry: 2426,
  PPG1015_3_Warmstone: 2427,
  PPG1015_4_Subdued: 2428,
  PPG1015_5_Heliotrope: 2429,
  PPG1015_6_GraniteBoulder: 2430,
  PPG1015_7_Mustang: 2431,
  PPG1016_1_BerryFrost: 2432,
  PPG1016_2_BlossomPink: 2433,
  PPG1016_3_CheerfulHeart: 2434,
  PPG1016_4_ForeverFairytale: 2435,
  PPG1016_5_IrisMauve: 2436,
  PPG1016_6_Woodchuck: 2437,
  PPG1016_7_SpicedWine: 2438,
  PPG1017_1_Touchable: 2439,
  PPG1017_2_FirstKiss: 2440,
  PPG1017_3_FondMemory: 2441,
  PPG1017_4_RiveterRose: 2442,
  PPG1017_5_CinnamonToast: 2443,
  PPG1017_6_BoldBrandy: 2444,
  PPG1017_7_ChocolatePretzel: 2445,
  PPG1018_1_SteelMe: 2446,
  PPG1018_2_MyAlibi: 2447,
  PPG1018_3_CityStreet: 2448,
  PPG1018_4_WintersNap: 2449,
  PPG1018_5_Talavera: 2450,
  PPG1018_6_Flipper: 2451,
  PPG1018_7_Sarsaparilla: 2452,
  PPG1019_1_ToastedMarshmallow: 2453,
  PPG1019_2_InTheBuff: 2454,
  PPG1019_3_Legendary: 2455,
  PPG1019_4_SimmeringSmoke: 2456,
  PPG1019_5_WildWilderness: 2457,
  PPG1019_6_TattleTail: 2458,
  PPG1019_7_Intrigue: 2459,
  PPG1020_1_AtriumWhite: 2460,
  PPG1020_2_MaybeMushroom: 2461,
  PPG1020_3_Whippet: 2462,
  PPG1020_4_ElCapitan: 2463,
  PPG1020_5_EarlGray: 2464,
  PPG1020_6_WickerBasket: 2465,
  PPG1020_7_Dolce: 2466,
  PPG1021_1_MountainGray: 2467,
  PPG1021_2_Synchronicity: 2468,
  PPG1021_3_Discover: 2469,
  PPG1021_4_Diversion: 2470,
  PPG1021_5_Thunderbird: 2471,
  PPG1021_6_Curlew: 2472,
  PPG1021_7_CabinFever: 2473,
  PPG1022_1_Hourglass: 2474,
  PPG1022_2_Intuitive: 2475,
  PPG1022_3_SilverDollar: 2476,
  PPG1022_4_RockSlide: 2477,
  PPG1022_5_EiffelTower: 2478,
  PPG1022_6_Granite: 2479,
  PPG1022_7_StarAnise: 2480,
  PPG1023_1_Oatmeal: 2481,
  PPG1023_2_CoolConcrete: 2482,
  PPG1023_3_Ashen: 2483,
  PPG1023_4_DesertDune: 2484,
  PPG1023_5_StoneGray: 2485,
  PPG1023_6_ClamShell: 2486,
  PPG1023_7_AfternoonTea: 2487,
  PPG1024_1_OffWhite: 2488,
  PPG1024_2_AntiqueWhite: 2489,
  PPG1024_3_CrushedSilk: 2490,
  PPG1024_4_MothGray: 2491,
  PPG1024_5_StonehengeGreige: 2492,
  PPG1024_6_Patches: 2493,
  PPG1024_7_FriarsBrown: 2494,
  PPG1025_1_CommercialWhite: 2495,
  PPG1025_2_SilentSmoke: 2496,
  PPG1025_3_Whiskers: 2497,
  PPG1025_4_Sharkskin: 2498,
  PPG1025_5_DarkAsh: 2499,
  PPG1025_6_SleepingGiant: 2500,
  PPG1025_7_CoffeeBean: 2501,
  PPG1026_1_Namaste: 2502,
  PPG1026_2_Sanctuary: 2503,
  PPG1026_3_Easy: 2504,
  PPG1026_4_Karma: 2505,
  PPG1026_5_Gristmill: 2506,
  PPG1026_6_BronzeStatue: 2507,
  PPG1026_7_HipWaders: 2508,
  PPG1027_1_Cocoon: 2509,
  PPG1027_2_SkippingStone: 2510,
  PPG1027_3_HeavyHammock: 2511,
  PPG1027_4_OliveGray: 2512,
  PPG1027_5_RattanPalm: 2513,
  PPG1027_6_Conservation: 2514,
  PPG1027_7_Grapevine: 2515,
  PPG1028_1_HintOfPine: 2516,
  PPG1028_2_WithATwist: 2517,
  PPG1028_3_PineCrush: 2518,
  PPG1028_4_SmokySlate: 2519,
  PPG1028_5_AutumnGray: 2520,
  PPG1028_6_Momentum: 2521,
  PPG1028_7_WalnutGrove: 2522,
  PPG1029_1_SilveryMoon: 2523,
  PPG1029_2_VeilOfDusk: 2524,
  PPG1029_3_FrenchGrayLinen: 2525,
  PPG1029_4_PhotoGray: 2526,
  PPG1029_5_Meander: 2527,
  PPG1029_6_Organic: 2528,
  PPG1029_7_PlungePool: 2529,
  PPG1030_1_Brainstorm: 2530,
  PPG1030_2_PalePine: 2531,
  PPG1030_3_MellowMood: 2532,
  PPG1030_4_Edamame: 2533,
  PPG1030_5_Mesmerize: 2534,
  PPG1030_6_PositivelyPalm: 2535,
  PPG1030_7_DoubleDuty: 2536,
  PPG1031_1_MixOrMatch: 2537,
  PPG1031_2_MistyMeadow: 2538,
  PPG1031_3_WanderingWillow: 2539,
  PPG1031_4_Restoration: 2540,
  PPG1031_5_SeaweedWrap: 2541,
  PPG1031_6_Nevergreen: 2542,
  PPG1031_7_Osiris: 2543,
  PPG1032_1_MetallicMist: 2544,
  PPG1032_2_HurricaneHaze: 2545,
  PPG1032_3_OliveIt: 2546,
  PPG1032_4_Sylvan: 2547,
  PPG1032_5_Tortuga: 2548,
  PPG1032_6_KingsCourt: 2549,
  PPG1032_7_MossRock: 2550,
  PPG1033_1_SaltyBreeze: 2551,
  PPG1033_2_WaywardWillow: 2552,
  PPG1033_3_SilentStorm: 2553,
  PPG1033_4_LightDrizzle: 2554,
  PPG1033_5_GrayHeron: 2555,
  PPG1033_6_GunmetalGray: 2556,
  PPG1033_7_CharcoalSmoke: 2557,
  PPG1034_1_MorningSong: 2558,
  PPG1034_2_Honesty: 2559,
  PPG1034_3_PristinePetal: 2560,
  PPG1034_4_MistySurf: 2561,
  PPG1034_5_AquaSmoke: 2562,
  PPG1034_6_BlueBlood: 2563,
  PPG1034_7_MountainPine: 2564,
  PPG1035_1_WateryBlue: 2565,
  PPG1035_2_SkyDiving: 2566,
  PPG1035_3_BlueByYou: 2567,
  PPG1035_4_SymphonyOfBlue: 2568,
  PPG1035_5_PuddleJumper: 2569,
  PPG1035_6_Superstition: 2570,
  PPG1035_7_Obsidian: 2571,
  PPG1036_1_GrayGlimpse: 2572,
  PPG1036_2_WinterChill: 2573,
  PPG1036_3_NauticalStar: 2574,
  PPG1036_4_AfterTheStorm: 2575,
  PPG1036_5_RoughRide: 2576,
  PPG1036_6_Phantom: 2577,
  PPG1036_7_MostlyMetal: 2578,
  PPG1037_1_SeaFrost: 2579,
  PPG1037_2_SkySplash: 2580,
  PPG1037_3_SpecialDelivery: 2581,
  PPG1037_4_Symmetry: 2582,
  PPG1037_5_NightRendezvous: 2583,
  PPG1037_6_Mysterious: 2584,
  PPG1037_7_Witchcraft: 2585,
  PPG1038_1_EveningMist: 2586,
  PPG1038_2_Dewdrop: 2587,
  PPG1038_3_WintersBreath: 2588,
  PPG1038_4_SmokeScreen: 2589,
  PPG1038_5_Feldspar: 2590,
  PPG1038_6_LavaGray: 2591,
  PPG1038_7_MidnightHour: 2592,
  PPG1039_1_GhostWhisperer: 2593,
  PPG1039_2_MaidenMist: 2594,
  PPG1039_3_MirrorMirror: 2595,
  PPG1039_4_Pachyderm: 2596,
  PPG1039_5_GarrisonGray: 2597,
  PPG1039_6_InTheShadows: 2598,
  PPG1039_7_HighSalute: 2599,
  PPG1040_1_Zen: 2600,
  PPG1040_2_Keepsakes: 2601,
  PPG1040_3_OceanDrive: 2602,
  PPG1040_4_SetInStone: 2603,
  PPG1040_5_LostAtSea: 2604,
  PPG1040_6_FreedomFound: 2605,
  PPG1040_7_Goblin: 2606,
  PPG1041_1_MoonlitSnow: 2607,
  PPG1041_2_CityLights: 2608,
  PPG1041_3_BillowingClouds: 2609,
  PPG1041_4_BlueDolphin: 2610,
  PPG1041_5_Quicksilver: 2611,
  PPG1041_6_SheffieldGray: 2612,
  PPG1041_7_Cavalry: 2613,
  PPG1042_1_CallaLily: 2614,
  PPG1042_2_WinterHaven: 2694,
  PPG1042_3_OceanDream: 2695,
  PPG1042_4_BlueBeard: 2696,
  PPG1042_5_PropheticSea: 2697,
  PPG1042_6_BlueZephyr: 2698,
  PPG1042_7_Admiralty: 2699,
  PPG1043_1_Snowbank: 2700,
  PPG1043_2_Moondance: 2701,
  PPG1043_3_WaywardWinds: 2702,
  PPG1043_4_GlisteningGray: 2703,
  PPG1043_5_FlannelPajamas: 2704,
  PPG1043_6_AlleyCat: 2705,
  PPG1043_7_BlackFlame: 2706,
  PPG1044_1_LoveBird: 2707,
  PPG1044_2_MauveWisp: 2708,
  PPG1044_3_TintedRosewood: 2709,
  PPG1044_4_Mauvelous: 2710,
  PPG1044_5_WinsomeRose: 2711,
  PPG1044_6_WildStrawberry: 2712,
  PPG1044_7_WildPlum: 2713,
  PPG1045_1_MagicalMoonlight: 2714,
  PPG1045_2_BarelyRose: 2715,
  PPG1045_3_SantolinaBlooms: 2716,
  PPG1045_4_PinkPotion: 2717,
  PPG1045_5_KeepsakeRose: 2718,
  PPG1045_6_WildGeranium: 2719,
  PPG1045_7_ChilledWine: 2720,
  PPG1046_1_MilkAndCookies: 2721,
  PPG1046_2_MagicMoments: 2722,
  PPG1046_3_OldMissionPink: 2723,
  PPG1046_4_HighSociety: 2724,
  PPG1046_5_GothicAmethyst: 2725,
  PPG1046_6_VelvetSlipper: 2726,
  PPG1046_7_PurpleBasil: 2727,
  PPG1047_1_ForeverFaithful: 2728,
  PPG1047_2_LostLove: 2729,
  PPG1047_3_JustGorgeous: 2730,
  PPG1047_4_Ancestral: 2731,
  PPG1047_5_CoffeeCustard: 2732,
  PPG1047_6_ChooChoo: 2733,
  PPG1047_7_CarobChip: 2734,
  PPG1048_1_LaurensLace: 2735,
  PPG1048_2_SilkSheets: 2736,
  PPG1048_3_RoseCloud: 2737,
  PPG1048_4_RoseStain: 2738,
  PPG1048_5_CoffeeRose: 2739,
  PPG1048_6_ChocolateSparkle: 2740,
  PPG1048_7_Gooseberry: 2741,
  PPG1049_1_SnowyMount: 2742,
  PPG1049_2_SweetBianca: 2743,
  PPG1049_3_Nostalgia: 2744,
  PPG1049_4_LightheartedRose: 2745,
  PPG1049_5_MauveMadness: 2746,
  PPG1049_6_Cabernet: 2747,
  PPG1049_7_RedRedWine: 2748,
  PPG1050_1_BarePink: 2749,
  PPG1050_2_PinkPail: 2750,
  PPG1050_3_LoveInAMist: 2751,
  PPG1050_4_MadagascarPink: 2752,
  PPG1050_5_BriarRose: 2753,
  PPG1050_6_HeartsContent: 2754,
  PPG1050_7_Magenta: 2755,
  PPG1051_1_CozyCottage: 2756,
  PPG1051_2_PinkCardoon: 2757,
  PPG1051_3_StrawberryMousse: 2758,
  PPG1051_4_PinkClayPot: 2759,
  PPG1051_5_Cranberry: 2760,
  PPG1051_6_Grenadine: 2761,
  PPG1051_7_Apple_A_Day: 2762,
  PPG1052_1_GingerCream: 2763,
  PPG1052_2_BrandyAlexander: 2764,
  PPG1052_3_Strawflower: 2765,
  PPG1052_4_FloralTapestry: 2766,
  PPG1052_5_HorizonGlow: 2767,
  PPG1052_6_MesaRed: 2768,
  PPG1052_7_RubyLips: 2769,
  PPG1053_1_CowsMilk: 2770,
  PPG1053_2_ShangriLa: 2771,
  PPG1053_3_PowderedPetals: 2772,
  PPG1053_4_RadiantRouge: 2773,
  PPG1053_5_BrandySnaps: 2774,
  PPG1053_6_ClayRidge: 2775,
  PPG1053_7_BurgundyWine: 2776,
  PPG1054_1_WinterWedding: 2777,
  PPG1054_2_SweetTruffle: 2778,
  PPG1054_3_Whirligig: 2779,
  PPG1054_4_TeaTime: 2780,
  PPG1054_5_TawnyMushroom: 2781,
  PPG1054_6_OakwoodBrown: 2782,
  PPG1054_7_ChocolateEclair: 2783,
  PPG1055_1_FreshDough: 2784,
  PPG1055_2_HawaiianShell: 2785,
  PPG1055_3_RoseHip: 2786,
  PPG1055_4_Pepperberry: 2787,
  PPG1055_5_CinnamonDiamonds: 2788,
  PPG1055_6_BarnDoor: 2789,
  PPG1055_7_Bordeaux: 2790,
  PPG1056_1_SeaAnemone: 2791,
  PPG1056_2_Romeo: 2792,
  PPG1056_3_AshesOfRoses: 2793,
  PPG1056_4_RaffiaCream: 2794,
  PPG1056_5_EarthRose: 2795,
  PPG1056_6_FireWeed: 2796,
  PPG1056_7_BrickDust: 2797,
  PPG1057_1_MacadamiaNut: 2798,
  PPG1057_2_CoolMelon: 2799,
  PPG1057_3_RosePetal: 2800,
  PPG1057_4_CoralCove: 2801,
  PPG1057_5_ChiliPepper: 2802,
  PPG1057_6_SiennaRed: 2803,
  PPG1057_7_BurningBush: 2804,
  PPG1058_1_Potpourri: 2805,
  PPG1058_2_CameoPeach: 2806,
  PPG1058_3_TangyTaffy: 2807,
  PPG1058_4_MesaPink: 2808,
  PPG1058_5_Sunstone: 2809,
  PPG1058_6_PizzaPie: 2810,
  PPG1058_7_AutumnRidge: 2811,
  PPG1059_1_ApricotCream: 2812,
  PPG1059_2_BirthdayCake: 2813,
  PPG1059_3_Reindeer: 2814,
  PPG1059_4_Parfait: 2815,
  PPG1059_5_FerrisWheel: 2816,
  PPG1059_6_CanyonStone: 2817,
  PPG1059_7_SweetSpiceberry: 2818,
  PPG1060_1_WinterPeach: 2819,
  PPG1060_2_ChinaSilk: 2820,
  PPG1060_3_KangarooPaw: 2821,
  PPG1060_4_VelveteenCrush: 2822,
  PPG1060_5_BedfordBrown: 2823,
  PPG1060_6_RaspberryTruffle: 2824,
  PPG1060_7_WarmMahogany: 2825,
  PPG1061_1_IrishCream: 2826,
  PPG1061_2_WistfulBeige: 2827,
  PPG1061_3_BelleOfTheBall: 2828,
  PPG1061_4_JustRosey: 2829,
  PPG1061_5_CappucinoBombe: 2830,
  PPG1061_6_SafariBrown: 2831,
  PPG1061_7_Bigfoot: 2832,
  PPG1062_1_ButterIcing: 2833,
  PPG1062_2_CoralCream: 2834,
  PPG1062_3_GingerShortbread: 2835,
  PPG1062_4_Sandpaper: 2836,
  PPG1062_5_BigCypress: 2837,
  PPG1062_6_AppleBrownBetty: 2838,
  PPG1062_7_WarmWassail: 2839,
  PPG1063_1_PoloTan: 2840,
  PPG1063_2_SpiceCookie: 2841,
  PPG1063_3_PaleCoral: 2842,
  PPG1063_4_GeorgiaPeach: 2843,
  PPG1063_5_OrangeEssential: 2844,
  PPG1063_6_CrushedCinnamon: 2845,
  PPG1063_7_AncientCopper: 2846,
  PPG1064_1_Aubergine: 2847,
  PPG1064_2_PinkChablis: 2848,
  PPG1064_3_TexasRose: 2849,
  PPG1064_4_PeachBeige: 2850,
  PPG1064_5_HollandTile: 2851,
  PPG1064_6_SaharaSun: 2852,
  PPG1064_7_RumRaisin: 2853,
  PPG1065_1_ChantillyLace: 2854,
  PPG1065_2_Fiesta: 2855,
  PPG1065_3_Honeysweet: 2856,
  PPG1065_4_SweetPeach: 2857,
  PPG1065_5_LongWeekend: 2858,
  PPG1065_6_Cinnabar: 2859,
  PPG1065_7_CedarChest: 2860,
  PPG1066_1_SiestaSands: 2861,
  PPG1066_2_SlightlyPeach: 2862,
  PPG1066_3_CoolCantaloupe: 2863,
  PPG1066_4_Adorable: 2864,
  PPG1066_5_CopperTrail: 2865,
  PPG1066_6_Amaretto: 2866,
  PPG1066_7_BakedBean: 2867,
  PPG1067_1_PineHutch: 2868,
  PPG1067_2_Boardwalk: 2869,
  PPG1067_3_AuNaturel: 2870,
  PPG1067_4_Thankfully: 2871,
  PPG1067_5_CopperBeech: 2872,
  PPG1067_6_WarmUp: 2873,
  PPG1067_7_BurledRedwood: 2874,
  PPG1068_1_SweetGardenia: 2875,
  PPG1068_2_Sablewood: 2876,
  PPG1068_3_SultanSand: 2877,
  PPG1068_4_LazySummer: 2878,
  PPG1068_5_TerrazzoTan: 2879,
  PPG1068_6_Nutmeg: 2880,
  PPG1068_7_SpicedCider: 2881,
  PPG1069_1_Nosegay: 2882,
  PPG1069_2_Scotchtone: 2883,
  PPG1069_3_Starfish: 2884,
  PPG1069_4_OrangeMaple: 2885,
  PPG1069_5_HoneyGraham: 2886,
  PPG1069_6_FoxfireBrown: 2887,
  PPG1069_7_CinnamonSpice: 2888,
  PPG1070_1_CanyonPeach: 2889,
  PPG1070_2_BlushBeige: 2890,
  PPG1070_3_BeachVibes: 2891,
  PPG1070_4_ClayFire: 2892,
  PPG1070_5_HitchingPost: 2893,
  PPG1070_6_GingerSpice: 2894,
  PPG1070_7_CinnamonStick: 2895,
  PPG1071_1_SouthPeak: 2896,
  PPG1071_2_Enjoy: 2897,
  PPG1071_3_ChampagneWishes: 2898,
  PPG1071_4_CinnamonIce: 2899,
  PPG1071_5_CoolClay: 2900,
  PPG1071_6_PrairieFire: 2901,
  PPG1071_7_SpicedCinnamon: 2902,
  PPG1072_1_AlmondRoca: 2903,
  PPG1072_2_SandyBeach: 2904,
  PPG1072_3_WildRice: 2905,
  PPG1072_4_TaupeTapestry: 2906,
  PPG1072_5_TatteredTeddy: 2907,
  PPG1072_6_SuedeLeather: 2908,
  PPG1072_7_BirdHouseBrown: 2909,
  PPG1073_1_LotusPetal: 2910,
  PPG1073_2_MaltedMilk: 2911,
  PPG1073_3_PaleTaupe: 2912,
  PPG1073_4_Pueblo: 2913,
  PPG1073_5_Tanglewood: 2914,
  PPG1073_6_DerbyBrown: 2915,
  PPG1073_7_Fudge: 2916,
  PPG1074_1_PearlsAndLace: 2917,
  PPG1074_2_MoroccanMoonlight: 2918,
  PPG1074_3_BermudaSand: 2919,
  PPG1074_4_Notorious: 2920,
  PPG1074_5_PepperedPecan: 2921,
  PPG1074_6_CaramelizedWalnut: 2922,
  PPG1074_7_LittleBear: 2923,
  PPG1075_1_LinenRuffle: 2924,
  PPG1075_2_AlleyCat: 31097,
  PPG1075_2_AlmondMilk: 2925,
  PPG1075_3_CasualElegance: 2926,
  PPG1075_4_Thumper: 2927,
  PPG1075_5_RanchMink: 2928,
  PPG1075_6_PoppyPods: 2929,
  PPG1075_7_FudgeTruffle: 2930,
  PPG1076_1_FuzzyUnicorn: 2931,
  PPG1076_2_Ash: 2932,
  PPG1076_3_GottaHaveIt: 2933,
  PPG1076_4_CuppaCoffee: 2934,
  PPG1076_5_Locomotion: 2935,
  PPG1076_6_Warrior: 2936,
  PPG1076_7_GroundCoffee: 2937,
  PPG1077_1_BerkshireLace: 2938,
  PPG1077_2_Sandpiper: 2939,
  PPG1077_3_Persuasion: 2940,
  PPG1077_4_WeatheredWood: 2941,
  PPG1077_5_ChocolateMoment: 2942,
  PPG1077_6_SaltedPretzel: 2943,
  PPG1077_7_CoffeeHouse: 2944,
  PPG1078_1_CreamPuff: 2945,
  PPG1078_2_WaterChestnut: 2946,
  PPG1078_3_Comfort: 2947,
  PPG1078_4_Kangaroo: 2948,
  PPG1078_5_Confidence: 2949,
  PPG1078_6_CocoaDelight: 2950,
  PPG1078_7_ChocolateRipple: 2951,
  PPG1079_1_StringOfPearls: 2952,
  PPG1079_2_StoneHarbor: 2953,
  PPG1079_3_CocoaCream: 2954,
  PPG1079_4_Transcend: 2955,
  PPG1079_5_Cocoloco: 2956,
  PPG1079_6_CaravelBrown: 2957,
  PPG1079_7_Molasses: 2958,
  PPG1080_1_OatmealCookie: 2959,
  PPG1080_2_PumpkinCream: 2960,
  PPG1080_3_NutmegGlow: 2961,
  PPG1080_4_SiestaDreams: 2962,
  PPG1080_5_WheatToast: 2963,
  PPG1080_6_CinnamonCrunch: 2964,
  PPG1080_7_SlipperyStone: 2965,
  PPG1081_1_ElegantIvory: 2966,
  PPG1081_2_BeachyKeen: 2967,
  PPG1081_3_MyLove: 2968,
  PPG1081_4_CinnamonFrost: 2969,
  PPG1081_5_FireDust: 2970,
  PPG1081_6_CinnamonTwist: 2971,
  PPG1081_7_CopperPot: 2972,
  PPG1082_1_Honeysuckle: 2973,
  PPG1082_2_Shoreland: 2974,
  PPG1082_3_IceCreamCone: 2975,
  PPG1082_4_WeatheredSandstone: 2976,
  PPG1082_5_Doeskin: 2977,
  PPG1082_6_CowboyHat: 2978,
  PPG1082_7_Ginger: 2979,
  PPG1083_1_Percale: 2980,
  PPG1083_2_EuroLinen: 2981,
  PPG1083_3_OakBuff: 2982,
  PPG1083_4_MalibuDune: 2983,
  PPG1083_5_CheddarBiscuit: 2984,
  PPG1083_6_CaramelKiss: 2985,
  PPG1083_7_Bourbon: 2986,
  PPG1084_1_SugarSoap: 2987,
  PPG1084_2_OnionPowder: 2988,
  PPG1084_3_Sourdough: 2989,
  PPG1084_4_HappyTrails: 2990,
  PPG1084_5_CoffeeKiss: 2991,
  PPG1084_6_CocoaPecan: 2992,
  PPG1084_7_MapleSyrup: 2993,
  PPG1085_1_BlankCanvas: 2994,
  PPG1085_2_BoneWhite: 2995,
  PPG1085_3_SeriouslySand: 2996,
  PPG1085_4_BestBeige: 2997,
  PPG1085_5_SauteedMushroom: 2998,
  PPG1085_6_HatBoxBrown: 2999,
  PPG1085_7_FigBranches: 3000,
  PPG1086_1_Horseradish: 3001,
  PPG1086_2_BrandiedPears: 3002,
  PPG1086_3_AlmondCream: 3003,
  PPG1086_4_PonyTail: 3004,
  PPG1086_5_EarthyOcher: 3005,
  PPG1086_6_CoffeeWithCream: 3006,
  PPG1086_7_CocoaCupcake: 3007,
  PPG1087_1_MadonnaLily: 3008,
  PPG1087_2_Pearl: 3009,
  PPG1087_3_AntiqueParchment: 3010,
  PPG1087_4_Chalkware: 3011,
  PPG1087_5_CrackerBitz: 3012,
  PPG1087_6_BreadBasket: 3013,
  PPG1087_7_ChewyCaramel: 3014,
  PPG1088_1_AngelFood: 3015,
  PPG1088_2_Ethereal: 3016,
  PPG1088_3_SugaredPears: 3017,
  PPG1088_4_SplashOfHoney: 3018,
  PPG1088_5_Outback: 3019,
  PPG1088_6_CoolCopper: 3020,
  PPG1088_7_SaharaSplendor: 3021,
  PPG1089_1_PitaBread: 3022,
  PPG1089_2_MagnoliaSpray: 3023,
  PPG1089_3_ChaiTeaLatte: 3024,
  PPG1089_4_FaintFawn: 3025,
  PPG1089_5_BleachedMaple: 3026,
  PPG1089_6_HoneyHaven: 3027,
  PPG1089_7_CaramelizedPecan: 3028,
  PPG1090_1_MagnoliaBlossom: 3029,
  PPG1090_2_SpiceIsNice: 3030,
  PPG1090_3_HoneyBunny: 3031,
  PPG1090_4_DropsOfHoney: 3032,
  PPG1090_5_GoodLife: 3033,
  PPG1090_6_Allegro: 3034,
  PPG1090_7_SugarMaple: 3035,
  PPG1091_1_Candlewick: 3036,
  PPG1091_2_CrescentMoon: 3037,
  PPG1091_3_Limitless: 3038,
  PPG1091_4_Halo: 3039,
  PPG1091_5_MoreMaple: 3040,
  PPG1091_6_DownToEarth: 31098,
  PPG1091_6_TanYourHide: 3041,
  PPG1091_7_LookAtMe: 3042,
  PPG1092_1_QueenAnnesLace: 3043,
  PPG1092_2_MesaBeige: 3044,
  PPG1092_3_TuscanBread: 3045,
  PPG1092_4_CraftsmanGold: 3046,
  PPG1092_5_WelcomeHome: 3047,
  PPG1092_6_ItWorks: 3048,
  PPG1092_7_WeatheredWicker: 3049,
  PPG1093_1_PerfectSolution: 3050,
  PPG1093_2_Soleil: 3051,
  PPG1093_3_Hearth: 3052,
  PPG1093_4_Somber: 3053,
  PPG1093_5_Antiquity: 3054,
  PPG1093_6_TangledTwine: 3055,
  PPG1093_7_TattleTan: 3056,
  PPG1094_1_Irresistible: 3057,
  PPG1094_2_Loofah: 3058,
  PPG1094_3_BirchBeige: 3059,
  PPG1094_4_Crepe: 3060,
  PPG1094_5_GoldenGranola: 3061,
  PPG1094_6_Imagine: 3062,
  PPG1094_7_MolassesCookie: 3063,
  PPG1095_1_ParchmentPaper: 3064,
  PPG1095_2_GlazedPears: 3065,
  PPG1095_3_AlmondBrittle: 3066,
  PPG1095_4_GoldenEcru: 3067,
  PPG1095_5_ApplesauceCake: 3068,
  PPG1095_6_Chicory: 3069,
  PPG1095_7_ShakerPeg: 3070,
  PPG1096_1_InstantRelief: 3071,
  PPG1096_2_MoroccoSand: 3072,
  PPG1096_3_CookieDough: 3073,
  PPG1096_4_RealSimple: 3074,
  PPG1096_5_CreamyCaramel: 3075,
  PPG1096_6_TimberBeam: 3076,
  PPG1096_7_SeasonedAcorn: 3077,
  PPG1097_1_ColdFoam: 3078,
  PPG1097_2_SouthernBreeze: 3079,
  PPG1097_3_ToastedAlmond: 3080,
  PPG1097_4_DustyTrail: 3081,
  PPG1097_5_StonyCreek: 3082,
  PPG1097_6_RainBarrel: 3083,
  PPG1097_7_OliveWood: 3084,
  PPG1098_1_MilkPaint: 3085,
  PPG1098_2_HeavyCream: 3086,
  PPG1098_3_SandFossil: 3087,
  PPG1098_4_SpicedVinegar: 3088,
  PPG1098_5_Jute: 3089,
  PPG1098_6_Tweed: 3090,
  PPG1098_7_MuddyRiver: 3091,
  PPG1099_1_AlwaysAlmond: 3092,
  PPG1099_2_VanillaLove: 3093,
  PPG1099_3_LovelyLinen: 3094,
  PPG1099_4_SubtleSuede: 3095,
  PPG1099_5_ToastedSesame: 3096,
  PPG1099_6_IcedCappuccino: 3097,
  PPG1099_7_FavoriteFudge: 3098,
  PPG11_01_Demeter: 3099,
  PPG11_02_TaintedGold: 3100,
  PPG11_03_Grassroots: 3101,
  PPG11_04_CountryStyle: 3102,
  PPG11_05_OldTimesSake: 3103,
  PPG11_06_SafariScene: 3104,
  PPG11_07_Gobbledygook: 3105,
  PPG11_08_OliveOrchard: 3106,
  PPG11_09_MistyMoor: 3107,
  PPG11_10_InTheDale: 3108,
  PPG11_11_TotallyTickled: 3109,
  PPG11_12_SecretScribbles: 3110,
  PPG11_13_SparrowSong: 3111,
  PPG11_14_LeafyRomaine: 3112,
  PPG11_15_WistfulWalk: 3113,
  PPG11_16_SpinachSalad: 3114,
  PPG11_17_MossyGold: 3115,
  PPG11_18_FoggyBeach: 3116,
  PPG11_19_DistantValley: 3117,
  PPG11_20_ScottishMoor: 3118,
  PPG11_21_Breezeway: 3119,
  PPG11_22_NorthernLandscape: 3120,
  PPG11_23_Edamame: 3121,
  PPG11_24_SmokeySage: 3122,
  PPG11_25_PlungePool: 3123,
  PPG11_26_Wilderness: 3124,
  PPG11_27_Safari: 3125,
  PPG11_28_OnlyOregano: 3126,
  PPG11_29_GreenGrayMist: 3127,
  PPG11_30_LivelyIvy: 3128,
  PPG11_31_ThimbleberryLeaf: 3129,
  PPG11_32_Tapenade: 3130,
  PPG1100_1_MotherOfPearl: 3131,
  PPG1100_2_AdobeWhite: 3132,
  PPG1100_3_BakedBread: 3133,
  PPG1100_4_SailorsKnot: 3134,
  PPG1100_5_SweetSparrow: 3135,
  PPG1100_6_TwistedTail: 3136,
  PPG1100_7_PaddleWheel: 3137,
  PPG1101_1_ChinaWhite: 3138,
  PPG1101_2_SugarCookie: 3139,
  PPG1101_3_Stylish: 3140,
  PPG1101_4_RockCliffs: 3141,
  PPG1101_5_BearHug: 3142,
  PPG1101_6_LeatherLoafers: 3143,
  PPG1101_7_Lemur: 3144,
  PPG1102_1_EnduringIce: 3145,
  PPG1102_2_FossilStone: 3146,
  PPG1102_3_DancingDolphin: 3147,
  PPG1102_4_PrairieDust: 3148,
  PPG1102_5_SaddleSoap: 3149,
  PPG1102_6_Woodbridge: 3150,
  PPG1102_7_PineCone: 3151,
  PPG1103_1_IvoryTower: 3152,
  PPG1103_2_AlmondPaste: 3153,
  PPG1103_3_SoftSuede: 3154,
  PPG1103_4_EarthyCane: 3155,
  PPG1103_5_Rattan: 3156,
  PPG1103_6_WoolTweed: 3157,
  PPG1103_7_TwigBasket: 3158,
  PPG1104_1_WhiteRock: 3159,
  PPG1104_2_AbbeyWhite: 3160,
  PPG1104_3_DesertedBeach: 3161,
  PPG1104_4_SandyPail: 3162,
  PPG1104_5_CoolCamel: 3163,
  PPG1104_6_RusticRanch: 3164,
  PPG1104_7_Outrigger: 3165,
  PPG1105_1_CreamyWhite: 3166,
  PPG1105_2_FuzzySheep: 3167,
  PPG1105_3_CaramelizedPears: 3168,
  PPG1105_4_Foothills: 3169,
  PPG1105_5_AppalachianTrail: 3170,
  PPG1105_6_BuffaloHide: 3171,
  PPG1105_7_GracefulGazelle: 3172,
  PPG1106_1_MaidenHair: 3173,
  PPG1106_2_Upbeat: 3174,
  PPG1106_3_AutumnGlow: 3175,
  PPG1106_4_TurnersYellow: 3176,
  PPG1106_5_ButterscotchBliss: 3177,
  PPG1106_6_AmarettoSours: 3178,
  PPG1106_7_ButterscotchRipple: 3179,
  PPG1107_1_Minimal: 3180,
  PPG1107_2_Joyful: 3181,
  PPG1107_3_TurningOakleaf: 3182,
  PPG1107_4_Demeter: 3183,
  PPG1107_5_TropicalSiesta: 3184,
  PPG1107_6_GloriousGold: 3185,
  PPG1107_7_GoldenField: 3186,
  PPG1108_1_OysterCracker: 3187,
  PPG1108_2_SilkStar: 3188,
  PPG1108_3_ButterCookie: 3189,
  PPG1108_4_WaywardWind: 3190,
  PPG1108_5_SpicyMustard: 3191,
  PPG1108_6_ShutterBug: 3192,
  PPG1108_7_Obsession: 3193,
  PPG1109_1_SlicesOfHappy: 3194,
  PPG1109_2_StarBright: 3195,
  PPG1109_3_TwinkleToes: 3196,
  PPG1109_4_CitrusYellow: 3197,
  PPG1109_5_SplitPeaSoup: 3198,
  PPG1109_6_WoolenMittens: 3199,
  PPG1109_7_AutumnFestival: 3200,
  PPG1110_1_SeptemberMorn: 3201,
  PPG1110_2_SubtleSunshine: 3202,
  PPG1110_3_SereneScene: 3203,
  PPG1110_4_SecretSafari: 3204,
  PPG1110_5_Gremlin: 3205,
  PPG1110_6_OffTheGrid: 3206,
  PPG1110_7_PeasPlease: 3207,
  PPG1111_1_PrairieWinds: 3208,
  PPG1111_2_Bamboo: 3209,
  PPG1111_3_Safari: 3210,
  PPG1111_3_SafariGreen: 31099,
  PPG1111_4_Nettle: 3211,
  PPG1111_5_PineappleSage: 3212,
  PPG1111_6_PickledOkra: 3213,
  PPG1111_7_SphagnumMoss: 3214,
  PPG1112_1_LittleLamb: 3215,
  PPG1112_2_CozyCream: 3216,
  PPG1112_3_OnlyOatmeal: 3217,
  PPG1112_4_BeachDune: 3218,
  PPG1112_5_WoolenVest: 3219,
  PPG1112_6_WillowTree: 3220,
  PPG1112_7_RussianOlive: 3221,
  PPG1113_1_IMissYou: 3222,
  PPG1113_2_SilverSage: 3223,
  PPG1113_3_NorthernLandscape: 3224,
  PPG1113_4_GreenGrayMist: 3225,
  PPG1113_5_SweetAnnie: 3226,
  PPG1113_6_GreenBriar: 3227,
  PPG1113_7_OliveGreen: 3228,
  PPG1114_1_Featherstone: 3229,
  PPG1114_2_RiverReed: 3230,
  PPG1114_3_CanaryGrass: 3231,
  PPG1114_4_CressGreen: 3232,
  PPG1114_5_PeaSoup: 3233,
  PPG1114_6_BronzeGreen: 3234,
  PPG1114_7_AutumnFern: 3235,
  PPG1115_1_ReallyRain: 3236,
  PPG1115_2_SageSplash: 3237,
  PPG1115_3_SlowDance: 3238,
  PPG1115_4_SageSplendor: 3239,
  PPG1115_5_PineTrail: 3240,
  PPG1115_6_PaidInFull: 3241,
  PPG1115_7_GratefullyGrass: 3242,
  PPG1116_1_JustPerfect: 3243,
  PPG1116_2_MoreMelon: 3244,
  PPG1116_3_ForgiveQuickly: 3245,
  PPG1116_4_MistyMoor: 3246,
  PPG1116_5_GraciousGlow: 3247,
  PPG1116_6_LoveliestLeaves: 3248,
  PPG1116_7_FrogsLegs: 3249,
  PPG1117_1_DelicateDaisy: 3250,
  PPG1117_2_Awareness: 3251,
  PPG1117_3_Charming: 3252,
  PPG1117_4_FloralBouquet: 3253,
  PPG1117_5_BeachBag: 3254,
  PPG1117_6_DoNotDisturb: 3255,
  PPG1117_7_EnoughIsEnough: 3256,
  PPG1118_1_MoreMint: 3257,
  PPG1118_2_AprilShowers: 3258,
  PPG1118_3_TrueToYou: 3259,
  PPG1118_4_Jitterbug: 3260,
  PPG1118_5_AlwaysApple: 3261,
  PPG1118_6_VintageVibe: 3262,
  PPG1118_7_Lucky: 3263,
  PPG1119_1_MagicalMelon: 3264,
  PPG1119_2_FountainFrolic: 3265,
  PPG1119_3_BeachGrass: 3266,
  PPG1119_4_DancingKite: 3267,
  PPG1119_5_FancyFlirt: 3268,
  PPG1119_6_GoldenGrass: 3269,
  PPG1119_7_GladeGreen: 3270,
  PPG1120_1_MentalNote: 3271,
  PPG1120_2_Gratitude: 3272,
  PPG1120_3_GreatJoy: 3273,
  PPG1120_4_PistachioPudding: 3274,
  PPG1120_5_Harmonious: 3275,
  PPG1120_6_LusciousLime: 3276,
  PPG1120_7_MintLeaves: 3277,
  PPG1121_1_Milkweed: 3278,
  PPG1121_2_LimeSpritz: 3279,
  PPG1121_3_PaleMossGreen: 3280,
  PPG1121_4_QuakingGrass: 3281,
  PPG1121_5_Guacamole: 3282,
  PPG1121_6_MossPointGreen: 3283,
  PPG1121_7_GlobeArtichoke: 3284,
  PPG1122_1_WhiteSmoke: 3285,
  PPG1122_2_LimeWash: 3286,
  PPG1122_3_PicklingSpice: 3287,
  PPG1122_4_BahiaGrass: 3288,
  PPG1122_5_Dill: 3289,
  PPG1122_6_Oregano: 3290,
  PPG1122_7_Oakmoss: 3291,
  PPG1123_1_Ageless: 3292,
  PPG1123_2_MagicalStardust: 3293,
  PPG1123_3_WildWheat: 3294,
  PPG1123_4_OnlyOlive: 3295,
  PPG1123_5_Envy: 3296,
  PPG1123_6_PlayingHooky: 3297,
  PPG1123_7_RustlingLeaves: 3298,
  PPG1124_1_TouchOfLime: 3299,
  PPG1124_2_PaleVista: 3300,
  PPG1124_3_FrostyPine: 3301,
  PPG1124_4_LightSage: 3302,
  PPG1124_5_CavernMoss: 3303,
  PPG1124_6_DarkSage: 3304,
  PPG1124_7_GrapeLeaves: 3305,
  PPG1125_1_RainCloud: 3306,
  PPG1125_2_WhiteSage: 3307,
  PPG1125_3_WhisperingPine: 3308,
  PPG1125_4_OliveSprig: 3309,
  PPG1125_5_Hemlock: 3310,
  PPG1125_6_ToyTankGreen: 3311,
  PPG1125_7_Pinetop: 3312,
  PPG1126_1_SterlingShadow: 3313,
  PPG1126_2_TwilightTwist: 3314,
  PPG1126_3_PinchOfPistachio: 3315,
  PPG1126_4_SideKick: 3316,
  PPG1126_5_ZebraGrass: 3317,
  PPG1126_6_PineGarland: 3318,
  PPG1126_7_AllAboutOlive: 3319,
  PPG1127_1_LimeDaiquiri: 3320,
  PPG1127_2_LiberatedLime: 3321,
  PPG1127_3_MerryMusic: 3322,
  PPG1127_4_Gargoyle: 3323,
  PPG1127_5_Shebang: 3324,
  PPG1127_6_WinningTicket: 3325,
  PPG1127_7_FreshBasil: 3326,
  PPG1128_1_Anonymous: 3327,
  PPG1128_2_FrivolousFolly: 3328,
  PPG1128_3_LifeLesson: 3329,
  PPG1128_4_Balsam: 3330,
  PPG1128_5_GreenTeaLeaf: 3331,
  PPG1128_6_ThymeGreen: 3332,
  PPG1128_7_CastleStone: 3333,
  PPG1129_1_CloudyDay: 3334,
  PPG1129_2_FallingStar: 3335,
  PPG1129_3_Castaway: 3336,
  PPG1129_4_CoastalCrush: 3337,
  PPG1129_5_FarmFresh: 3338,
  PPG1129_6_LotteryWinnings: 3339,
  PPG1129_7_EvergreenBoughs: 3340,
  PPG1130_1_SummerRain: 3341,
  PPG1130_2_MintWafer: 3342,
  PPG1130_3_StAugustine: 3343,
  PPG1130_4_LimeTaffy: 3344,
  PPG1130_5_PearCactus: 3345,
  PPG1130_6_MossRing: 3346,
  PPG1130_7_MountainForest: 3347,
  PPG1131_1_GreenWhisper: 3348,
  PPG1131_2_HerbalMist: 3349,
  PPG1131_3_Dreamcatcher: 3350,
  PPG1131_4_FrenchMarket: 3351,
  PPG1131_5_ChattyCricket: 3352,
  PPG1131_6_SucculentLeaves: 3353,
  PPG1131_7_CloverLeaf: 3354,
  PPG1132_1_ClairDeLune: 3355,
  PPG1132_2_Solitaire: 3356,
  PPG1132_3_TaffyTwist: 3357,
  PPG1132_4_GrandGusto: 3358,
  PPG1132_5_Plumosa: 3359,
  PPG1132_6_MallardGreen: 3360,
  PPG1132_7_Brunswick: 3361,
  PPG1133_1_Icicle: 3362,
  PPG1133_2_Tenderness: 3363,
  PPG1133_3_Limelight: 3364,
  PPG1133_4_SilverLeaf: 3365,
  PPG1133_5_SlateGreen: 3366,
  PPG1133_6_PaintedTurtle: 3367,
  PPG1133_7_RoyalHunterGreen: 3368,
  PPG1134_1_HydrangeaFloret: 3369,
  PPG1134_2_TidalFoam: 3370,
  PPG1134_3_PineFrost: 3371,
  PPG1134_4_PineWhisper: 3372,
  PPG1134_5_BirchForest: 3373,
  PPG1134_6_EnglishIvy: 3374,
  PPG1134_7_PineForest: 3375,
  PPG1135_1_PoeticLicense: 3376,
  PPG1135_2_MorningRush: 3377,
  PPG1135_3_SecretCrush: 3378,
  PPG1135_4_AquamarineDream: 3379,
  PPG1135_5_ParadiseFound: 3380,
  PPG1135_6_CalabashClash: 3381,
  PPG1135_7_Obligation: 3382,
  PPG1136_1_SeaPearl: 3383,
  PPG1136_2_Rainsong: 3384,
  PPG1136_3_MorningBreeze: 3385,
  PPG1136_4_BlueShamrock: 3386,
  PPG1136_5_SpruceShade: 3387,
  PPG1136_6_DwarfSpruce: 3388,
  PPG1136_7_DarkGreenVelvet: 3389,
  PPG1137_1_SpringRain: 3390,
  PPG1137_2_NorthernLights: 3391,
  PPG1137_3_Waterscape: 3392,
  PPG1137_4_Copenhagen: 3393,
  PPG1137_5_SilverLaurel: 3394,
  PPG1137_6_SalalLeaves: 3395,
  PPG1137_7_BlackSpruce: 3396,
  PPG1138_1_CactusBlossom: 3397,
  PPG1138_2_Geyser: 3398,
  PPG1138_3_CrystalOasis: 3399,
  PPG1138_4_Donnegal: 3400,
  PPG1138_5_PineRidge: 3401,
  PPG1138_6_ChristmasIvy: 3402,
  PPG1138_7_MidnightClover: 3403,
  PPG1139_1_SummerBreeze: 3404,
  PPG1139_2_MaltedMint: 3405,
  PPG1139_3_GreenSilk: 3406,
  PPG1139_4_Catnip: 3407,
  PPG1139_5_Sheffield: 3408,
  PPG1139_6_CountryClub: 3409,
  PPG1139_7_BilliardGreen: 3410,
  PPG1140_1_Echo: 3411,
  PPG1140_2_SweetNothings: 3412,
  PPG1140_3_Tarreyton: 3413,
  PPG1140_4_KeyLargo: 3414,
  PPG1140_5_DerbyGreen: 3415,
  PPG1140_6_Pinehurst: 3416,
  PPG1140_7_PeacockGreen: 3417,
  PPG1141_1_IceFloe: 3418,
  PPG1141_2_GreenWave: 3419,
  PPG1141_3_Cassiopeia: 3420,
  PPG1141_4_CaribbeanGreen: 3421,
  PPG1141_5_TreasureIsle: 3422,
  PPG1141_6_Carlisle: 3423,
  PPG1141_7_DeepVeridian: 3424,
  PPG1142_1_PeacefulNight: 3425,
  PPG1142_2_BigSky: 3426,
  PPG1142_3_VeridianGreen: 3427,
  PPG1142_4_PitterPatter: 3428,
  PPG1142_5_Catalina: 3429,
  PPG1142_6_JerichoJade: 3430,
  PPG1142_7_EmpressTeal: 3431,
  PPG1143_1_DelicateMist: 3432,
  PPG1143_2_BlueLullaby: 3433,
  PPG1143_3_SeaSprite: 3434,
  PPG1143_4_ParakeetPete: 3435,
  PPG1143_5_Yucca: 3436,
  PPG1143_6_SmokyEmerald: 3437,
  PPG1143_7_HollyLeaf: 3438,
  PPG1144_1_MorningFog: 3439,
  PPG1144_2_ThunderBay: 3440,
  PPG1144_3_BabblingBrook: 3441,
  PPG1144_4_HollyGlen: 3442,
  PPG1144_5_GreenGranite: 3443,
  PPG1144_6_EveningEmerald: 3444,
  PPG1144_7_CrystalBall: 3445,
  PPG1145_1_RainDrop: 3446,
  PPG1145_2_JackFrost: 3447,
  PPG1145_3_CavePearl: 3448,
  PPG1145_4_BlueWillow: 3449,
  PPG1145_5_Scarborough: 3450,
  PPG1145_6_JuniperBerry: 3451,
  PPG1145_7_NightWatch: 3452,
  PPG1146_1_MildMint: 3453,
  PPG1146_2_SpringMist: 3454,
  PPG1146_3_JulepGreen: 3455,
  PPG1146_4_FrostyGlade: 3456,
  PPG1146_5_Palmetto: 3457,
  PPG1146_6_LuckyShamrock: 3458,
  PPG1146_7_EmeraldPool: 3459,
  PPG1147_1_CameoGreen: 3460,
  PPG1147_2_MountainDew: 3461,
  PPG1147_3_MistyAqua: 3462,
  PPG1147_4_AquaFiesta: 3463,
  PPG1147_5_TealBayou: 3464,
  PPG1147_6_JadeJewel: 3465,
  PPG1147_7_TahitianTreat: 3466,
  PPG1148_1_MeadowsweetMist: 3467,
  PPG1148_2_PistachioCream: 3468,
  PPG1148_3_CosmicRays: 3469,
  PPG1148_4_LazyRiver: 3470,
  PPG1148_5_CathedralGlass: 3471,
  PPG1148_6_ViningIvy: 3472,
  PPG1148_7_DeepEmerald: 3473,
  PPG1149_1_AlpineBlue: 3474,
  PPG1149_2_HighSierra: 3475,
  PPG1149_3_ScandinavianSky: 3476,
  PPG1149_4_MountainStream: 3477,
  PPG1149_5_Baritone: 3478,
  PPG1149_6_AzaleaLeaf: 3479,
  PPG1149_7_BlueBayberry: 3480,
  PPG1150_1_AquaSparkle: 3481,
  PPG1150_2_WaterLily: 3482,
  PPG1150_3_EvergladeMist: 3483,
  PPG1150_4_KingstonAqua: 3484,
  PPG1150_5_AcapulcoCliffs: 3485,
  PPG1150_6_Bermuda: 3486,
  PPG1150_7_CaribbeanSplash: 3487,
  PPG1151_1_Beachcomber: 3488,
  PPG1151_2_Embellishment: 3489,
  PPG1151_3_MidsummersDream: 3490,
  PPG1151_4_CrystalLake: 3491,
  PPG1151_5_AquaBlue: 3492,
  PPG1151_6_Adventure: 3493,
  PPG1151_7_JamaicanDream: 3494,
  PPG1152_1_SubtleBlue: 3495,
  PPG1152_2_Breakwater: 3496,
  PPG1152_3_Graceful: 3497,
  PPG1152_4_Americana: 3498,
  PPG1152_5_GraniteFalls: 3499,
  PPG1152_6_Brigade: 3500,
  PPG1152_7_ShimmeringSea: 3501,
  PPG1153_1_IceCastles: 3502,
  PPG1153_2_Artemesia: 3503,
  PPG1153_3_BlueSmoke: 3504,
  PPG1153_4_Chambray: 3505,
  PPG1153_5_ChalkyBlue: 3506,
  PPG1153_6_SilentNight: 3507,
  PPG1153_7_SailorsCoat: 3508,
  PPG1154_1_ShootingStar: 3509,
  PPG1154_2_Aloof: 3510,
  PPG1154_3_DartmoorMist: 3511,
  PPG1154_4_Twinkle: 3512,
  PPG1154_5_SereneStream: 3513,
  PPG1154_6_PrussianBlue: 3514,
  PPG1154_7_RegattaBay: 3515,
  PPG1155_1_SummerShower: 3516,
  PPG1155_2_Prelude: 3517,
  PPG1155_3_SimplyElegant: 3518,
  PPG1155_4_Constellation: 3519,
  PPG1155_5_DresdenDream: 3520,
  PPG1155_6_CanyonBlue: 3521,
  PPG1155_7_BlueLava: 3522,
  PPG1156_1_AustrianIce: 3523,
  PPG1156_2_BitOfHeaven: 3524,
  PPG1156_3_AlwaysBlue: 3525,
  PPG1156_4_AmericanAnthem: 3526,
  PPG1156_5_SmokeBlue: 3527,
  PPG1156_6_MountainLake: 3528,
  PPG1156_7_CelestialBlue: 3529,
  PPG1157_1_Glassine: 3530,
  PPG1157_2_BluePearl: 3531,
  PPG1157_3_Sonata: 3532,
  PPG1157_4_Arabella: 3533,
  PPG1157_5_Vanity: 3534,
  PPG1157_6_CosmicDust: 3535,
  PPG1157_7_BlueFlame: 3536,
  PPG1158_1_BabysBreath: 3537,
  PPG1158_2_MagicWand: 3538,
  PPG1158_3_BlueBows: 3539,
  PPG1158_4_SereneSea: 3540,
  PPG1158_5_Cosmopolitan: 3541,
  PPG1158_6_BlueOasis: 3542,
  PPG1158_7_StunningSapphire: 3543,
  PPG1159_1_Filigree: 3544,
  PPG1159_2_CalmSea: 3545,
  PPG1159_3_HeavenlyBlue: 3546,
  PPG1159_4_WaldenPond: 3547,
  PPG1159_5_StormyRidge: 3548,
  PPG1159_6_Animation: 3549,
  PPG1159_7_SingingTheBlues: 3550,
  PPG1160_1_HarborMist: 3551,
  PPG1160_2_Magical: 3552,
  PPG1160_3_Rendezvous: 3553,
  PPG1160_4_Kaleidoscope: 3554,
  PPG1160_5_BlueBeads: 3555,
  PPG1160_6_ChinesePorcelain: 3556,
  PPG1160_7_BlueTang: 3557,
  PPG1161_1_Cityscape: 3558,
  PPG1161_2_CEstLaVie: 3559,
  PPG1161_3_Everlasting: 3560,
  PPG1161_4_BluePromise: 3561,
  PPG1161_5_ShipsHarbor: 3562,
  PPG1161_6_StarryNight: 3563,
  PPG1161_7_BrilliantBlue: 3564,
  PPG1162_1_HarborLight: 3565,
  PPG1162_2_Stratosphere: 3566,
  PPG1162_3_BlueThistle: 3567,
  PPG1162_4_AlaskanBlue: 3568,
  PPG1162_5_ShrinkingViolet: 3569,
  PPG1162_6_TeenyBikini: 3570,
  PPG1162_7_Dragonfly: 3571,
  PPG1163_1_ElusiveBlue: 3572,
  PPG1163_2_MemoryLane: 3573,
  PPG1163_3_PageantSong: 3574,
  PPG1163_4_SterlingSilver: 3575,
  PPG1163_5_SilverBlueberry: 3576,
  PPG1163_6_BlueFjord: 3577,
  PPG1163_7_BlueberryPie: 3578,
  PPG1164_1_Windswept: 3579,
  PPG1164_2_Iceberg: 3580,
  PPG1164_3_BlusteryDay: 3581,
  PPG1164_4_Dreamy: 3582,
  PPG1164_5_BlueberryMuffin: 3583,
  PPG1164_6_BlueCloud: 3584,
  PPG1164_7_AnnapolisBlue: 3585,
  PPG1165_1_JanuaryDawn: 3586,
  PPG1165_2_TwinkleBlue: 3587,
  PPG1165_3_NorthernExposure: 3588,
  PPG1165_4_Innuendo: 3589,
  PPG1165_5_EveningHush: 3590,
  PPG1165_6_StainedGlass: 3591,
  PPG1165_7_VictoryBlue: 3592,
  PPG1166_1_BrightStar: 3593,
  PPG1166_2_AsterPetal: 3594,
  PPG1166_3_BlueOpal: 3595,
  PPG1166_4_FreshViolet: 3596,
  PPG1166_5_Kimono: 3597,
  PPG1166_6_BlueOdyssey: 3598,
  PPG1166_7_DaringIndigo: 3599,
  PPG1167_1_ArcticDawn: 3600,
  PPG1167_2_WindsorHaze: 3601,
  PPG1167_3_Debonaire: 3602,
  PPG1167_4_LovelyLilac: 3603,
  PPG1167_5_SkysailBlue: 3604,
  PPG1167_6_BlueberryPatch: 3605,
  PPG1167_7_BlueJewel: 3606,
  PPG1168_1_MoonLily: 3607,
  PPG1168_2_CumberlandFog: 3608,
  PPG1168_3_PaleViolet: 3609,
  PPG1168_4_LilacTime: 3610,
  PPG1168_5_VioletAura: 3611,
  PPG1168_6_GrapeHaze: 3612,
  PPG1168_7_EgyptianViolet: 3613,
  PPG1169_1_WindsweptBeach: 3614,
  PPG1169_2_RareOrchid: 3615,
  PPG1169_3_GlacierPearl: 3616,
  PPG1169_4_TimelessLilac: 3617,
  PPG1169_5_VioletVerbena: 3618,
  PPG1169_6_GreatGrape: 3619,
  PPG1169_7_RoyalHyacinth: 3620,
  PPG1170_1_WaterIris: 3621,
  PPG1170_2_MonetsLavender: 3622,
  PPG1170_3_VioletShadow: 3623,
  PPG1170_4_SpringLilac: 3624,
  PPG1170_5_FreshLavender: 3625,
  PPG1170_6_WildWisteria: 3626,
  PPG1170_7_RomanViolet: 3627,
  PPG1171_1_SilentDelight: 3628,
  PPG1171_2_LittleDipper: 3629,
  PPG1171_3_IrradiantIris: 3630,
  PPG1171_4_Cosmic: 3631,
  PPG1171_5_CottonFlannel: 3632,
  PPG1171_6_OldMillBlue: 3633,
  PPG1171_7_Chinaberry: 3634,
  PPG1172_1_SnowStorm: 3635,
  PPG1172_2_WinterMorn: 3636,
  PPG1172_3_JamSession: 3637,
  PPG1172_4_AshGrove: 3638,
  PPG1172_5_TinLizzie: 3639,
  PPG1172_6_Silverado: 3640,
  PPG1172_7_Blackberry: 3641,
  PPG1173_1_VioletEcho: 3642,
  PPG1173_2_FebruaryFrost: 3643,
  PPG1173_3_FrostedLilac: 3644,
  PPG1173_4_Silverberry: 3645,
  PPG1173_5_PurpleSurf: 3646,
  PPG1173_6_PlumShade: 3647,
  PPG1173_7_MagicSpell: 3648,
  PPG1174_1_OrchidBlossom: 3649,
  PPG1174_2_VioletWhimsey: 3650,
  PPG1174_3_SilverChalice: 3651,
  PPG1174_4_Cloudberry: 3652,
  PPG1174_5_SmokyGrape: 3653,
  PPG1174_6_PurpleRain: 3654,
  PPG1174_7_RoyalIndigo: 3655,
  PPG1175_1_VioletHush: 3656,
  PPG1175_2_PaleOrchid: 3657,
  PPG1175_3_LavenderHaze: 3658,
  PPG1175_4_WildLilac: 3659,
  PPG1175_5_FrenchViolet: 3660,
  PPG1175_6_PurpleGrapes: 3661,
  PPG1175_7_ImperialPurple: 3662,
  PPG1176_1_Peekaboo: 3663,
  PPG1176_2_OrchidLane: 3664,
  PPG1176_3_DuskyLilac: 3665,
  PPG1176_4_PurpleEssence: 3666,
  PPG1176_5_VioletEclipse: 3667,
  PPG1176_6_Mirabella: 3668,
  PPG1176_7_PerfectlyPurple: 3669,
  PPG1177_1_OrchidPetal: 3670,
  PPG1177_2_LittleLilac: 3671,
  PPG1177_3_ShyViolet: 3672,
  PPG1177_4_LavishLavender: 3673,
  PPG1177_5_PalePlum: 3674,
  PPG1177_6_GrapeJelly: 3675,
  PPG1177_7_PansyPetal: 3676,
  PPG1178_1_LavenderTwilight: 3677,
  PPG1178_2_WineFrost: 3678,
  PPG1178_3_PaleMauve: 3679,
  PPG1178_4_SoftAmethyst: 3680,
  PPG1178_5_PalisadeOrchid: 3681,
  PPG1178_6_BlackberryJam: 3682,
  PPG1178_7_RoyalPlum: 3683,
  PPG1179_1_MistyMorn: 3684,
  PPG1179_2_SmokyOrchid: 3685,
  PPG1179_3_SilverMauve: 3686,
  PPG1179_4_RoseMarble: 3687,
  PPG1179_5_Ashberry: 3688,
  PPG1179_6_VictorianPlum: 3689,
  PPG1179_7_LovePotion: 3690,
  PPG1180_1_VioletVapor: 3691,
  PPG1180_2_RajahRose: 3692,
  PPG1180_3_SummerClover: 3693,
  PPG1180_4_LightMulberry: 3694,
  PPG1180_5_MauveMagic: 3695,
  PPG1180_6_FloweringRaspberry: 3696,
  PPG1180_7_MagicMagenta: 3697,
  PPG1181_1_CandyMix: 3698,
  PPG1181_2_BrittanysBow: 3699,
  PPG1181_3_MountainLaurel: 3700,
  PPG1181_4_TickledPink: 3701,
  PPG1181_5_RoseGlory: 3702,
  PPG1181_6_ParisPink: 3703,
  PPG1181_7_PanamaRose: 3704,
  PPG1182_1_FullBloom: 3705,
  PPG1182_2_Taffy: 3706,
  PPG1182_3_PalePrimrose: 3707,
  PPG1182_4_GardenParty: 3708,
  PPG1182_5_Primrose: 3709,
  PPG1182_6_GeraniumPink: 3710,
  PPG1182_7_FuchsiaFlock: 3711,
  PPG1183_1_Ballerina: 3712,
  PPG1183_2_Beauteous: 3713,
  PPG1183_3_RoseMelody: 3714,
  PPG1183_4_Brandywine: 3715,
  PPG1183_5_Razzberries: 3716,
  PPG1183_6_CherryPink: 3717,
  PPG1183_7_HeartsDesire: 3718,
  PPG1184_1_Gaiety: 3719,
  PPG1184_2_PleasingPink: 3720,
  PPG1184_3_PowderRose: 3721,
  PPG1184_4_PinkPunch: 3722,
  PPG1184_5_CherryBrandy: 3723,
  PPG1184_6_KennysKiss: 3724,
  PPG1184_7_CaliforniaWine: 3725,
  PPG1185_1_Fresco: 3726,
  PPG1185_2_KendallRose: 3727,
  PPG1185_3_PreciousPink: 3728,
  PPG1185_4_PrimroseGarden: 3729,
  PPG1185_5_BleedingHeart: 3730,
  PPG1185_6_CranberrySplash: 3731,
  PPG1185_7_CalypsoBerry: 3732,
  PPG1186_1_LoversKnot: 3733,
  PPG1186_2_PinkySwear: 3734,
  PPG1186_3_JaguarRose: 3735,
  PPG1186_4_PinkFlambe: 3736,
  PPG1186_5_Obsessed: 3737,
  PPG1186_6_SalsaDiane: 3738,
  PPG1186_7_RedLicorice: 3739,
  PPG1187_1_ScentedValentine: 3740,
  PPG1187_2_Adorbs: 3741,
  PPG1187_3_SilverStrawberry: 3742,
  PPG1187_4_RiverRouge: 3743,
  PPG1187_5_RedCedar: 3744,
  PPG1187_6_Bonfire: 3745,
  PPG1187_7_RedGumball: 3746,
  PPG1188_1_BurstYourBubble: 3747,
  PPG1188_2_FrostedTulip: 3748,
  PPG1188_3_Rosewine: 3749,
  PPG1188_4_SalmonPink: 3750,
  PPG1188_5_SiestaRose: 3751,
  PPG1188_6_Briquette: 3752,
  PPG1188_7_BurntRed: 3753,
  PPG1189_1_FloralLinen: 3754,
  PPG1189_2_PinkSangria: 3755,
  PPG1189_3_RosePink: 3756,
  PPG1189_4_RivieraRose: 3757,
  PPG1189_5_SmokedSalmon: 3758,
  PPG1189_6_WetCoral: 3759,
  PPG1189_7_TeaberryBlossom: 3760,
  PPG1190_1_LimogePink: 3761,
  PPG1190_2_BalletSlipper: 3762,
  PPG1190_3_SoniaRose: 3763,
  PPG1190_4_SoftSalmon: 3764,
  PPG1190_5_Cranapple: 3765,
  PPG1190_6_Firecracker: 3766,
  PPG1190_7_RumPunch: 3767,
  PPG1191_1_SummerLily: 3768,
  PPG1191_2_PeachTone: 3769,
  PPG1191_3_PeachAsh: 3770,
  PPG1191_4_CoralBlush: 3771,
  PPG1191_5_Freckles: 3772,
  PPG1191_6_CajunSpice: 3773,
  PPG1191_7_GlowingFirelight: 3774,
  PPG1192_1_ChampagneIce: 3775,
  PPG1192_2_Peachskin: 3776,
  PPG1192_3_ChicPeach: 3777,
  PPG1192_4_NewClay: 3778,
  PPG1192_5_OpalFire: 3779,
  PPG1192_6_SummerSunset: 3780,
  PPG1192_7_Tabasco: 3781,
  PPG1193_1_ScallopedShell: 3782,
  PPG1193_2_FlamingoPeach: 3783,
  PPG1193_3_CameoRose: 3784,
  PPG1193_4_SweetAngel: 3785,
  PPG1193_5_CoralSerenade: 3786,
  PPG1193_6_RusticPottery: 3787,
  PPG1193_7_CinnamonStone: 3788,
  PPG1194_1_JasmineFlower: 3789,
  PPG1194_2_LaMinuet: 3790,
  PPG1194_3_Ambrosia: 3791,
  PPG1194_4_SweetSheba: 3792,
  PPG1194_5_WarmWelcome: 3793,
  PPG1194_6_ClayPot: 3794,
  PPG1194_7_OrangeVermillion: 3795,
  PPG1195_1_PaleEcru: 3796,
  PPG1195_2_PeachEverlasting: 3797,
  PPG1195_3_MelonPink: 3798,
  PPG1195_4_CrabBisque: 3799,
  PPG1195_5_CoralSilk: 3800,
  PPG1195_6_IndianaClay: 3801,
  PPG1195_7_FieldPoppy: 3802,
  PPG1196_1_Peachtree: 3803,
  PPG1196_2_MelonIce: 3804,
  PPG1196_3_Dreamsicle: 3805,
  PPG1196_4_ShrimpBoat: 3806,
  PPG1196_5_CopperRiver: 3807,
  PPG1196_6_ChineseLantern: 3808,
  PPG1196_7_OrangePoppy: 3809,
  PPG1197_1_TangeloCream: 3810,
  PPG1197_2_LightPeach: 3811,
  PPG1197_3_Bisque: 3812,
  PPG1197_4_ShrimpToast: 3813,
  PPG1197_5_OrangeMarmalade: 3814,
  PPG1197_6_FallLeaf: 3815,
  PPG1197_7_CarmelizedOrange: 3816,
  PPG1198_1_PecanSandie: 3817,
  PPG1198_2_BuddingPeach: 3818,
  PPG1198_3_CitrusSachet: 3819,
  PPG1198_4_OrangeLiqueur: 3820,
  PPG1198_5_CarrotCake: 3821,
  PPG1198_6_TigerTail: 3822,
  PPG1198_7_SesameCrunch: 3823,
  PPG1199_1_Alyssa: 3824,
  PPG1199_2_PeachShortcake: 3825,
  PPG1199_3_SpicedOrange: 3826,
  PPG1199_4_HushPuppy: 3827,
  PPG1199_5_CinnamonBrandy: 3828,
  PPG1199_6_BrownClay: 3829,
  PPG1199_7_FragrantCloves: 3830,
  PPG12_01_CornSilk: 3831,
  PPG12_02_CordonBleu: 3832,
  PPG12_03_SunSalutation: 3833,
  PPG12_04_BulletinBoard: 3834,
  PPG12_05_WinterWheat: 3835,
  PPG12_06_Lira: 3836,
  PPG12_07_WavesOfGrain: 3837,
  PPG12_08_BoldButterscotch: 3838,
  PPG12_09_RiceCake: 3839,
  PPG12_10_Millet: 3840,
  PPG12_11_AntiqueCream: 3841,
  PPG12_12_TrueBlonde: 3842,
  PPG12_13_CamelTan: 3843,
  PPG12_14_CraftsmanGold: 3844,
  PPG12_15_Hearth: 3845,
  PPG12_16_DesertCamel: 3846,
  PPG12_17_TuscanSun: 3847,
  PPG12_18_Hayloft: 3848,
  PPG12_19_Antiquity: 3849,
  PPG12_20_CanvasSatchel: 3850,
  PPG12_21_Foothills: 3851,
  PPG12_22_AppalachianTrail: 3852,
  PPG12_23_TurningOakleaf: 3853,
  PPG12_24_GatheringField: 3854,
  PPG12_25_ToTheRescue: 3855,
  PPG12_26_AssateagueSand: 3856,
  PPG12_27_Soleil: 3857,
  PPG12_28_AtTheBeach: 3858,
  PPG12_29_FamilyTies: 3859,
  PPG12_30_Baguette: 3860,
  PPG12_31_NeutralBeige: 3861,
  PPG12_32_SandcastleSymphony: 3862,
  PPG1200_1_ChinaDoll: 3863,
  PPG1200_2_SourpatchPeach: 3864,
  PPG1200_3_Siesta: 3865,
  PPG1200_4_OrangeClay: 3866,
  PPG1200_5_GeorgianLeather: 3867,
  PPG1200_6_GingerRoot: 3868,
  PPG1200_7_Mincemeat: 3869,
  PPG1201_1_UptownTaupe: 3870,
  PPG1201_2_TeaBiscuit: 3871,
  PPG1201_3_PeachDarling: 3872,
  PPG1201_4_GentleDoe: 3873,
  PPG1201_5_PumpkinPatch: 3874,
  PPG1201_6_Gingerbread: 3875,
  PPG1201_7_LuckyPenny: 3876,
  PPG1202_1_VanillaTan: 3877,
  PPG1202_2_PeachSurprise: 3878,
  PPG1202_3_CrispWonTon: 3879,
  PPG1202_4_CaramelIce: 3880,
  PPG1202_5_BuffaloTrail: 3881,
  PPG1202_6_PoloPony: 3882,
  PPG1202_7_GingerBeer: 3883,
  PPG1203_1_SpunCotton: 3884,
  PPG1203_2_Mimosa: 3885,
  PPG1203_3_PeachDip: 3886,
  PPG1203_4_GingerPeach: 3887,
  PPG1203_5_Zing: 3888,
  PPG1203_6_Goldfish: 3889,
  PPG1203_7_Cornucopia: 3890,
  PPG1204_1_SpiceIvory: 3891,
  PPG1204_2_VanillaWafer: 3892,
  PPG1204_3_CreamyCustard: 3893,
  PPG1204_4_Doodle: 3894,
  PPG1204_5_ChunkOfCheddar: 3895,
  PPG1204_6_GoldenOpportunity: 3896,
  PPG1204_7_MangoMargarita: 3897,
  PPG1205_1_CombedCotton: 3898,
  PPG1205_2_SoftCream: 3899,
  PPG1205_3_BarelyButter: 3900,
  PPG1205_4_HoneyBee: 3901,
  PPG1205_5_EveningGlow: 3902,
  PPG1205_6_HoneyPot: 3903,
  PPG1205_7_FallGold: 3904,
  PPG1206_1_LotusFlower: 3905,
  PPG1206_2_SilkSails: 3906,
  PPG1206_3_ShinySilk: 3907,
  PPG1206_4_Sawdust: 3908,
  PPG1206_5_SpicedButternut: 3909,
  PPG1206_6_FuzzyNavel: 3910,
  PPG1206_7_Rise_N_Shine: 3911,
  PPG1206_7_RiseNShine: 31100,
  PPG1207_1_CandlelitBeige: 3912,
  PPG1207_2_GoldenMushroom: 3913,
  PPG1207_3_HoneyBeige: 3914,
  PPG1207_4_ToffeeCrunch: 3915,
  PPG1207_5_LionsMane: 3916,
  PPG1207_6_Allspice: 3917,
  PPG1207_7_CiderToddy: 3918,
  PPG1208_1_Accolade: 3919,
  PPG1208_2_SpiceDelight: 3920,
  PPG1208_3_BelgianWaffle: 3921,
  PPG1208_4_GoldBuff: 3922,
  PPG1208_5_BrownMustard: 3923,
  PPG1208_6_MayanTreasure: 3924,
  PPG1208_7_GothicGold: 3925,
  PPG1209_1_SatinWeave: 3926,
  PPG1209_2_Sausalito: 3927,
  PPG1209_3_DustyYellow: 3928,
  PPG1209_4_YukonGold: 3929,
  PPG1209_5_YellowConeflower: 3930,
  PPG1209_6_BrassMesh: 3931,
  PPG1209_7_MeccaGold: 3932,
  PPG1210_1_CrispCandlelight: 3933,
  PPG1210_2_GentleGlow: 3934,
  PPG1210_3_Visionary: 3935,
  PPG1210_4_MaybeMaui: 3936,
  PPG1210_5_BrightIdea: 3937,
  PPG1210_6_VaVaVoom: 3938,
  PPG1210_7_CurrySauce: 3939,
  PPG1211_1_GoodGraces: 3940,
  PPG1211_2_HeavenlyHaze: 3941,
  PPG1211_3_EasyOnTheEyes: 3942,
  PPG1211_4_TwinkleLittleStar: 3943,
  PPG1211_5_Firelight: 3944,
  PPG1211_6_BeachParty: 3945,
  PPG1211_7_BeDaring: 3946,
  PPG1212_1_CapriCream: 3947,
  PPG1212_2_BananaPudding: 3948,
  PPG1212_3_Sunbeam: 3949,
  PPG1212_4_LazyDaizy: 3950,
  PPG1212_5_CitrusPunch: 3951,
  PPG1212_6_AcornSquash: 3952,
  PPG1212_7_Flirtatious: 3953,
  PPG1213_1_SailCloth: 3954,
  PPG1213_2_BlondeBeauty: 3955,
  PPG1213_3_Butter: 3956,
  PPG1213_4_GoldenStraw: 3957,
  PPG1213_5_Calabash: 3958,
  PPG1213_6_DillyDally: 3959,
  PPG1213_7_CrushedPineapple: 3960,
  PPG1214_1_CakeBatter: 3961,
  PPG1214_2_GoldenFleece: 3962,
  PPG1214_3_BananaBrulee: 3963,
  PPG1214_4_ButterflyBush: 3964,
  PPG1214_5_ForsythiaBlossom: 3965,
  PPG1214_6_GoldenHour: 3966,
  PPG1214_7_Yarrow: 3967,
  PPG1215_1_ClearYellow: 3968,
  PPG1215_2_BrightLaughter: 3969,
  PPG1215_3_PineappleDelight: 3970,
  PPG1215_4_CanaryYellow: 3971,
  PPG1215_5_GoldenYarrow: 3972,
  PPG1215_6_GrassDaisy: 3973,
  PPG1215_7_Pollination: 3974,
  PPG1216_1_MorningFog: 31101,
  PPG1216_1_MorningGlow: 3975,
  PPG1216_2_CoolYellow: 3976,
  PPG1216_3_SpringBlossom: 3977,
  PPG1216_4_LemonPepper: 3978,
  PPG1216_5_FreshLemonade: 3979,
  PPG1216_6_CitrusSpice: 3980,
  PPG1216_7_GoneGiddy: 3981,
  PPG1217_1_Giggle: 3982,
  PPG1217_2_LimitedLime: 3983,
  PPG1217_3_HipHop: 3984,
  PPG1217_4_MermaidTears: 3985,
  PPG1217_5_LimeSplash: 3986,
  PPG1217_6_GreenGecko: 3987,
  PPG1217_7_SlapHappy: 3988,
  PPG1218_1_OhDahling: 3989,
  PPG1218_2_MysticMelon: 3990,
  PPG1218_3_LivelyLaugh: 3991,
  PPG1218_4_ForceOfNature: 3992,
  PPG1218_5_Parachute: 3993,
  PPG1218_6_MachineGreen: 3994,
  PPG1218_7_BeYourself: 3995,
  PPG1219_1_PlainAndSimple: 3996,
  PPG1219_2_Daydream: 3997,
  PPG1219_3_Curious: 3998,
  PPG1219_4_GoodyGumdrop: 3999,
  PPG1219_5_BoogieBlast: 4000,
  PPG1219_6_Hopscotch: 4001,
  PPG1219_7_Lichen: 4002,
  PPG1220_1_Memoir: 4003,
  PPG1220_2_PassionatePause: 4004,
  PPG1220_3_LotsOfBubbles: 4005,
  PPG1220_4_HighHopes: 4006,
  PPG1220_5_CleanNCrisp: 4007,
  PPG1220_6_GlowWorm: 4008,
  PPG1220_7_Mojo: 4009,
  PPG1221_1_AloeEssence: 4010,
  PPG1221_2_QuietRain: 4011,
  PPG1221_3_MellowMint: 4012,
  PPG1221_4_Faith: 4013,
  PPG1221_5_LivinLarge: 4014,
  PPG1221_6_BeSpontaneous: 4015,
  PPG1221_7_FunkyFrog: 4016,
  PPG1222_1_LimeMeringue: 4017,
  PPG1222_2_HoneydewMelon: 4018,
  PPG1222_3_AloeVera: 4019,
  PPG1222_4_LettuceAlone: 4020,
  PPG1222_5_LimeGreen: 4021,
  PPG1222_6_Asparagus: 4022,
  PPG1222_7_AntiqueMoss: 4023,
  PPG1223_1_GreenTease: 4024,
  PPG1223_2_LilyPond: 4025,
  PPG1223_3_LimeFlip: 4026,
  PPG1223_4_BleachedSpruce: 4027,
  PPG1223_5_HeartyHosta: 4028,
  PPG1223_6_GrassyMeadow: 4029,
  PPG1223_7_AntiqueGreen: 4030,
  PPG1224_1_AlaskanMist: 4031,
  PPG1224_2_SpearmintStick: 4032,
  PPG1224_3_ChilledMint: 4033,
  PPG1224_4_LantanaLime: 4034,
  PPG1224_5_AlmostAloe: 4035,
  PPG1224_6_CelerySprig: 4036,
  PPG1224_7_GreenPear: 4037,
  PPG1225_1_HintOfMint: 4038,
  PPG1225_2_DewmistDelight: 4039,
  PPG1225_3_Applemint: 4040,
  PPG1225_4_LimeSorbet: 4041,
  PPG1225_5_MayApple: 4042,
  PPG1225_6_BermudaGrass: 4043,
  PPG1225_7_LeapFrog: 4044,
  PPG1226_1_TintOfGreen: 4045,
  PPG1226_2_PeppermintPatty: 4046,
  PPG1226_3_SpriteTwist: 4047,
  PPG1226_4_HeathGreen: 4048,
  PPG1226_5_GardenMint: 4049,
  PPG1226_6_BasilPesto: 4050,
  PPG1226_7_BlarneyStone: 4051,
  PPG1227_1_SeaMist: 4052,
  PPG1227_2_SweetPea: 4053,
  PPG1227_3_MountainMint: 4054,
  PPG1227_4_CrystalGem: 4055,
  PPG1227_5_AragonGreen: 4056,
  PPG1227_6_Beanstalk: 4057,
  PPG1227_7_GreenGloss: 4058,
  PPG1228_1_MaggiesMagic: 4059,
  PPG1228_2_JadeSpell: 4060,
  PPG1228_3_FloweringCactus: 4061,
  PPG1228_4_GreenBalloon: 4062,
  PPG1228_5_LaurelWreath: 4063,
  PPG1228_6_Leprechaun: 4064,
  PPG1228_7_IvyLeague: 4065,
  PPG1229_1_Wintergreen: 4066,
  PPG1229_2_WintergreenMint: 4067,
  PPG1229_3_AlmostAqua: 4068,
  PPG1229_4_TropicalTide: 4069,
  PPG1229_5_Aloha: 4070,
  PPG1229_6_CongoGreen: 4071,
  PPG1229_7_CarolinaGreen: 4072,
  PPG1230_1_TropicalDream: 4073,
  PPG1230_2_Serendipity: 4074,
  PPG1230_3_Whirlpool: 4075,
  PPG1230_4_PaleJade: 4076,
  PPG1230_5_JewelWeed: 4077,
  PPG1230_6_MiamiJade: 4078,
  PPG1230_7_MedievalForest: 4079,
  PPG1231_1_HallowedHush: 4080,
  PPG1231_2_SwanLake: 4081,
  PPG1231_3_Minerva: 4082,
  PPG1231_4_TropicalHoliday: 4083,
  PPG1231_5_ArtesianWell: 4084,
  PPG1231_6_AzureTide: 4085,
  PPG1231_7_RomanticIsle: 4086,
  PPG1232_1_IceBlue: 4087,
  PPG1232_2_Cascade: 4088,
  PPG1232_3_SilentRipple: 4089,
  PPG1232_4_IsleRoyale: 4090,
  PPG1232_5_TintOfTurquoise: 4091,
  PPG1232_6_GrecianIsle: 4092,
  PPG1232_7_TorridTurquoise: 4093,
  PPG1233_1_FreeSpirit: 4094,
  PPG1233_2_Seaspray: 4095,
  PPG1233_3_PaleSeafoam: 4096,
  PPG1233_4_SeascapeGreen: 4097,
  PPG1233_5_TropicalSplash: 4098,
  PPG1233_6_MontegoBay: 4099,
  PPG1233_7_RivieraParadise: 4100,
  PPG1234_1_AquaTint: 4101,
  PPG1234_2_Plateau: 4102,
  PPG1234_3_AquaWhisper: 4103,
  PPG1234_4_FlingGreen: 4104,
  PPG1234_5_BiscayBay: 4105,
  PPG1234_6_SeaFantasy: 4106,
  PPG1234_7_HypnoticSea: 4107,
  PPG1235_1_KissMeKate: 4108,
  PPG1235_2_BluePhlox: 4109,
  PPG1235_3_Galactica: 4110,
  PPG1235_4_IdyllicIsle: 4111,
  PPG1235_5_BlueCalypso: 4112,
  PPG1235_6_SafeHarbor: 4113,
  PPG1235_7_BiminiBlue: 4114,
  PPG1236_1_Breathless: 4115,
  PPG1236_2_EnchantedEvening: 4116,
  PPG1236_3_SurfsUp: 4117,
  PPG1236_4_OceanCruise: 4118,
  PPG1236_5_HighDive: 4119,
  PPG1236_6_JamaicanSea: 4120,
  PPG1236_7_MediterraneanBlue: 4121,
  PPG1237_1_Bashful: 4122,
  PPG1237_2_DiamondBlue: 4123,
  PPG1237_3_Ariel: 4124,
  PPG1237_4_HorizonHaze: 4125,
  PPG1237_5_MysticBlue: 4126,
  PPG1237_6_Bellflower: 4127,
  PPG1237_7_Neptune: 4128,
  PPG1238_1_Airy: 4129,
  PPG1238_2_Goddess: 4130,
  PPG1238_3_FlemishBlue: 4131,
  PPG1238_4_HarborSky: 4132,
  PPG1238_5_Hush_A_Bye: 4133,
  PPG1238_5_HushABye: 31102,
  PPG1238_6_BluePaisley: 4134,
  PPG1238_7_PortAuPrince: 4135,
  PPG1239_1_Wavecrest: 4136,
  PPG1239_2_DucksEggBlue: 4137,
  PPG1239_3_WindsorWay: 4138,
  PPG1239_4_SalemBlue: 4139,
  PPG1239_5_QuietNight: 4140,
  PPG1239_6_NorthSea: 4141,
  PPG1239_7_RaveRegatta: 4142,
  PPG1240_1_OceanBreeze: 4143,
  PPG1240_2_NiagaraFalls: 4144,
  PPG1240_3_Songbird: 4145,
  PPG1240_4_XavierBlue: 4146,
  PPG1240_5_Sorcerer: 4147,
  PPG1240_6_NewportBlue: 4148,
  PPG1240_7_CobaltGlaze: 4149,
  PPG1241_1_FirstLight: 4150,
  PPG1241_2_VitaminSea: 4151,
  PPG1241_3_SweetDreams: 4152,
  PPG1241_4_Windjammer: 4153,
  PPG1241_5_MagicalMerlin: 4154,
  PPG1241_6_ElectricBlue: 4155,
  PPG1241_7_CobaltStone: 4156,
  PPG1242_1_FirstFrost: 4157,
  PPG1242_2_TouchOfBlue: 4158,
  PPG1242_3_VivaLaBleu: 4159,
  PPG1242_4_Overcast: 4160,
  PPG1242_5_KingTriton: 4161,
  PPG1242_6_Planetarium: 4162,
  PPG1242_7_SuddenlySapphire: 4163,
  PPG1243_1_SweetIllusion: 4164,
  PPG1243_2_HauntingHue: 4165,
  PPG1243_3_SetSail: 4166,
  PPG1243_4_VictoriaBlue: 4167,
  PPG1243_5_BlueDart: 4168,
  PPG1243_6_RoyalPlume: 4169,
  PPG1243_7_RainbowBright: 4170,
  PPG1244_1_Abyss: 4171,
  PPG1244_2_BlueSilk: 4172,
  PPG1244_3_Valor: 4173,
  PPG1244_4_BoudoirBlue: 4174,
  PPG1244_5_BlueberryPopover: 4175,
  PPG1244_6_NocturneShade: 4176,
  PPG1244_7_FlorentineLapis: 4177,
  PPG1245_1_OrchidWhisper: 4178,
  PPG1245_2_PaleLilac: 4179,
  PPG1245_3_SweetEmily: 4180,
  PPG1245_4_LilacSachet: 4181,
  PPG1245_5_BlueHyacinth: 4182,
  PPG1245_6_KingsRobe: 4183,
  PPG1245_7_CrushedVelvet: 4184,
  PPG1246_1_VioletIce: 4185,
  PPG1246_2_WeepingWisteria: 4186,
  PPG1246_3_GlobeThistle: 4187,
  PPG1246_4_FrenchLilac: 4188,
  PPG1246_5_MysticIris: 4189,
  PPG1246_6_VioletsAreBlue: 4190,
  PPG1246_7_BlueCalico: 4191,
  PPG1247_1_OrchidMist: 4192,
  PPG1247_2_GuardianAngel: 4193,
  PPG1247_3_MistyViolet: 4194,
  PPG1247_4_PurpleDragon: 4195,
  PPG1247_5_GrapeArbor: 4196,
  PPG1247_6_PurpleRhapsody: 4197,
  PPG1247_7_Eggplant: 4198,
  PPG1248_1_Coronation: 4199,
  PPG1248_2_IrisIsle: 4200,
  PPG1248_3_VelvetScarf: 4201,
  PPG1248_4_LilacBreeze: 4202,
  PPG1248_5_Puturple: 4203,
  PPG1248_6_MagicCarpet: 4204,
  PPG1248_7_ReignOverMe: 4205,
  PPG1249_1_VioletVogue: 4206,
  PPG1249_2_LavenderVista: 4207,
  PPG1249_3_GrapeGlimmer: 4208,
  PPG1249_4_WindsorPurple: 4209,
  PPG1249_5_PurpleStatice: 4210,
  PPG1249_6_GrapePopsicle: 4211,
  PPG1249_7_CleopatrasGown: 4212,
  PPG1250_1_AngoraPink: 4213,
  PPG1250_2_LilacFrost: 4214,
  PPG1250_3_SyrianViolet: 4215,
  PPG1250_4_SeaLavender: 4216,
  PPG1250_5_PlumPerfect: 4217,
  PPG1250_6_BellHeather: 4218,
  PPG1250_7_RoyalLilac: 4219,
  PPG1251_1_DreamDust: 4220,
  PPG1251_2_Tiara: 4221,
  PPG1251_3_SonoraRose: 4222,
  PPG1251_4_PinkPeony: 4223,
  PPG1251_5_MoorlandHeather: 4224,
  PPG1251_6_MulberryBush: 4225,
  PPG1251_7_GrapeJuice: 4226,
  PPG1252_1_LavenderPearl: 4227,
  PPG1252_2_HeavenSent: 4228,
  PPG1252_3_DesertDawn: 4229,
  PPG1252_4_SweetAlyssum: 4230,
  PPG1252_5_ChateauRose: 4231,
  PPG1252_6_DaphneRose: 4232,
  PPG1252_7_BermudaOnion: 4233,
  PPG13_01_PomegranatePunch: 4234,
  PPG13_02_CherokeeRed: 4235,
  PPG13_02_FallingwaterRed: 31103,
  PPG13_03_BurgundyWine: 4236,
  PPG13_04_Merlot: 4237,
  PPG13_05_OldBurgundy: 4238,
  PPG13_06_Chianti: 4239,
  PPG13_07_EnchantingEggplant: 4240,
  PPG13_08_PositivelyPurple: 4241,
  PPG13_09_CrushedTomatoes: 4242,
  PPG13_10_CandyApple: 4243,
  PPG13_11_MadeiraRed: 4244,
  PPG13_12_CrazedCranberry: 4245,
  PPG13_13_RoastedPepper: 4246,
  PPG13_14_HeartsAfire: 4247,
  PPG13_15_BingeWatch: 4248,
  PPG13_16_Blaze: 4249,
  PPG13_17_PurpleParlor: 4250,
  PPG13_18_PinotNoir: 4251,
  PPG13_19_PurpleDusk: 4252,
  PPG13_20_PageantPansy: 4253,
  PPG13_21_Blackberry: 4254,
  PPG13_22_Silverado: 4255,
  PPG13_23_AmethystHaze: 4256,
  PPG13_24_MagicDust: 4257,
  PPG13_25_DaringIndigo: 4258,
  PPG13_26_BlueLava: 4259,
  PPG13_27_PlymouthBlue: 4260,
  PPG13_28_CaribbeanHoliday: 4261,
  PPG13_29_AntiqueSlate: 4262,
  PPG13_30_SeaGlass: 4263,
  PPG13_31_StillSearching: 4264,
  PPG13_32_EmeraldCity: 4265,
  PPG14_01_ShadowTaupe: 4266,
  PPG14_02_NutShell: 4267,
  PPG14_03_Seagull: 4268,
  PPG14_04_CityStreet: 4269,
  PPG14_05_DarkAsNight: 4270,
  PPG14_06_WinterFeather: 4271,
  PPG14_07_ScotchMist: 4272,
  PPG14_08_Horseradish: 4273,
  PPG14_09_RockCliffs: 4274,
  PPG14_10_SummerWheat: 4275,
  PPG14_11_Static: 4276,
  PPG14_12_JewelWhite: 4277,
  PPG14_13_OysterShell: 4278,
  PPG14_14_SummerSuede: 4279,
  PPG14_15_FrenchCream: 4280,
  PPG14_16_WinterMood: 4281,
  PPG14_17_Armadillo: 4282,
  PPG14_18_Gaia: 4283,
  PPG14_19_AlpacaWool: 4284,
  PPG14_20_Purity: 4285,
  PPG14_21_WheatSheaf: 4286,
  PPG14_22_BoneWhite: 4287,
  PPG14_23_Edelweiss: 4288,
  PPG14_24_DogwoodBlossom: 4289,
  PPG14_25_FishermansNet: 4290,
  PPG14_26_Hideaway: 4291,
  PPG14_27_TrueKhaki: 4292,
  PPG14_28_Aldabra: 4293,
  PPG14_29_MothGray: 4294,
  PPG14_30_GrayBeige: 4295,
  PPG14_31_Paraffin: 4296,
  PPG14_32_OstrichFeather: 4297,
  PPG15_01_MaisonDeCampagne: 4298,
  PPG15_02_AppleButter: 4299,
  PPG15_03_BroncoBrown: 4300,
  PPG15_04_YosemiteTrailhead: 4301,
  PPG15_05_MacaroonCream: 4302,
  PPG15_06_WhiteChip: 4303,
  PPG15_07_YorkIvory: 4304,
  PPG15_08_BurntIvory: 4305,
  PPG15_09_Antelope: 4306,
  PPG15_10_PetalumaDust: 4307,
  PPG15_11_Rabbit: 4308,
  PPG15_12_Kangaroo: 4309,
  PPG15_13_ChocolateTruffle: 4310,
  PPG15_14_Leather: 4311,
  PPG15_15_CoffeeKiss: 4312,
  PPG15_16_BestBeige: 4313,
  PPG15_17_ElephantGray: 4314,
  PPG15_18_Introspective: 4315,
  PPG15_19_RapidRock: 4316,
  PPG15_20_GhostShip: 4317,
  PPG15_21_Curlew: 4318,
  PPG15_22_Pumpernickel: 4319,
  PPG15_23_Chestnut: 4320,
  PPG15_24_FrenchToast: 4321,
  PPG15_25_Stonington: 4322,
  PPG15_26_ToastedAlmond: 4323,
  PPG15_27_BotanyBeige: 4324,
  PPG15_28_GreatGray: 4325,
  PPG15_29_ElCapitan: 4326,
  PPG15_30_RoastedChestnut: 4327,
  PPG15_31_BeigeTellin: 4328,
  PPG15_32_Portabella: 4329,
  PPG16_01_SombreroTan: 4330,
  PPG16_02_SummerSpice: 4331,
  PPG16_03_BurningSand: 4332,
  PPG16_04_Capuccino: 4333,
  PPG16_05_CaramelSugar: 4334,
  PPG16_06_RedRockFalls: 4335,
  PPG16_07_SouthernWood: 4336,
  PPG16_08_AntiqueMahogany: 4337,
  PPG16_09_LinenTint: 4338,
  PPG16_10_Hummus: 4339,
  PPG16_11_ApolloGold: 4340,
  PPG16_12_ItalianSaffron: 4341,
  PPG16_13_PumpkinSpice: 4342,
  PPG16_14_BranMuffin: 4343,
  PPG16_15_BrownBasket: 4344,
  PPG16_16_TreasureHunt: 4345,
  PPG16_17_TudorBeige: 4346,
  PPG16_18_CoveredWagon: 4347,
  PPG16_19_Broomstick: 4348,
  PPG16_20_BronzeEucalyptus: 4349,
  PPG16_21_FreshPraline: 4350,
  PPG16_22_Chaparral: 4351,
  PPG16_23_TampicoBrown: 4352,
  PPG16_24_ChocolateCroissant: 4353,
  PPG16_25_MapleGranola: 4354,
  PPG16_26_ClayFire: 4355,
  PPG16_27_CopperTrail: 4356,
  PPG16_28_CrushedCinnamon: 4357,
  PPG16_29_HuntClubRed: 4358,
  PPG16_30_MutedCopper: 4359,
  PPG16_31_RichClay: 4360,
  PPG16_32_RedClay: 4361,
  PPG17_01_Suenos: 4362,
  PPG17_02_Cenote: 4363,
  PPG17_03_HaciendaTalavera: 4364,
  PPG17_04_Kimono: 4365,
  PPG17_05_BlueCalico: 4366,
  PPG17_06_MagicalMoment: 4367,
  PPG17_07_CrowningGlory: 4368,
  PPG17_08_HeatherGlen: 4369,
  PPG17_09_FlorentinePink: 4370,
  PPG17_10_TuttiFrutti: 4371,
  PPG17_11_Cerise: 4372,
  PPG17_12_Granada: 4373,
  PPG17_13_BurntRed: 4374,
  PPG17_14_BleedingHeart: 4375,
  PPG17_15_RusticPottery: 4376,
  PPG17_16_CandyCorn: 4377,
  PPG17_17_Mariposa: 4378,
  PPG17_18_SolDeYucatan: 4379,
  PPG17_19_OroDeMaya: 4380,
  PPG17_20_Tesoros: 4381,
  PPG17_21_SorbeteDeMelon: 4382,
  PPG17_22_Dynamo: 4383,
  PPG17_23_Cazuela: 4384,
  PPG17_24_CopperPenny: 4385,
  PPG17_25_GotTheGiggles: 4386,
  PPG17_26_WillowHerb: 4387,
  PPG17_27_FernGlow: 4388,
  PPG17_28_LeafMeBe: 4389,
  PPG17_29_SanJuanSpritz: 4390,
  PPG17_30_DinnerMint: 4391,
  PPG17_31_CaribbeanCrush: 4392,
  PPG17_32_TealWeMeetAgain: 4393,
  PPG18_01_CrumbCookie: 4394,
  PPG18_02_RiverRock: 4395,
  PPG18_03_GreyMauve: 4396,
  PPG18_04_Luxurious: 4397,
  PPG18_05_Awakening: 4398,
  PPG18_06_MexicaliRose: 4399,
  PPG18_07_LusciousLilac: 4400,
  PPG18_08_SmokyQuartz: 4401,
  PPG18_09_GarlicClove: 4402,
  PPG18_10_LotusPetal: 4403,
  PPG18_11_PastelPaper: 4404,
  PPG18_12_GranddadsGirl: 4405,
  PPG18_13_BeigeLlama: 4406,
  PPG18_14_SpiceBeige: 4407,
  PPG18_15_ShrimpSalad: 4408,
  PPG18_16_SalmonEggs: 4409,
  PPG18_17_JustBlush: 4410,
  PPG18_18_RoseBlush: 4411,
  PPG18_19_CrushedRoses: 4412,
  PPG18_20_Thornberry: 4413,
  PPG18_21_MoodyMauve: 4414,
  PPG18_22_MakeMineMauve: 4415,
  PPG18_23_BerriesAndCream: 4416,
  PPG18_24_PurpleCabbage: 4417,
  PPG18_25_Belleek: 4418,
  PPG18_26_PeachBrick: 4419,
  PPG18_27_PeachBeauty: 4420,
  PPG18_28_Adorable: 4421,
  PPG18_29_Emberglo: 4422,
  PPG18_30_LushRose: 4423,
  PPG18_31_RaspberryRipple: 4424,
  PPG18_32_BerryPicking: 4425,
};

const DMC_PaintSpare_Colors = {
  Beige: 143,
  Beige1: 190,
  CharcoalGray: 145,
  Clay: 191,
  Cream: 147,
  Gray: 152,
  Gray1: 202,
  Linen: 155,
  Moonshine: 158,
  SatinSilver: 164,
  Slate: 166,
  Slate1: 195,
  TH1: 137,
  TH2: 167,
  TH3: 138,
  TH4: 168,
  TH5: 139,
  White: 188,
  White1: 207,
  WhiteBright: 189,
  Wicker: 201,
};

const DMC_PlyGem = {
  PlyGem_AutumnBeige: 4587,
  PlyGem_Black: 1998,
  PlyGem_BlackwatchGreen: 4541,
  PlyGem_Blue: 4542,
  Plygem_Briarwood: 4652,
  PlyGem_Briarwood: 1999,
  PlyGem_Brown: 4543,
  PlyGem_CharcoalGray: 2000,
  PlyGem_ClassicCream: 4588,
  PlyGem_CoastalBlue: 184,
  PlyGem_DarkBerry: 4544,
  PlyGem_DarkBronze: 2001,
  PlyGem_DarkNavy: 4545,
  PlyGem_DarkSpruce: 4546,
  PlyGem_DoverWhite: 2002,
  PlyGem_Flint: 4589,
  PlyGem_GeorgianGray: 4590,
  PlyGem_Granite: 10786,
  PlyGem_Gray: 4547,
  PlyGem_Green: 4548,
  PlyGem_HeritageLinen: 4591,
  PlyGem_IrishThistle: 4592,
  PlyGem_IslandPearl: 4593,
  PlyGem_MasticAlmond: 4549,
  PlyGem_MasticAlpineForest: 4550,
  PlyGem_MasticAutumnHarvest: 4551,
  PlyGem_MasticBrandyWood: 4552,
  PlyGem_MasticBrunswick: 2102,
  PlyGem_MasticCameo: 2085,
  PlyGem_MasticCapeGrey: 4553,
  PlyGem_MasticCedar: 4554,
  PlyGem_MasticColonialYellow: 10763,
  PlyGem_MasticCornSilk: 4555,
  Plygem_MasticDarkBronze: 21105,
  PlyGem_MasticDeepCavern: 4556,
  PlyGem_MasticDeepGranite: 4557,
  PlyGem_MasticDesertSand: 2103,
  PlyGem_MasticEnglishWedgewood: 2104,
  PlyGem_MasticEverest: 2086,
  PlyGem_MasticHarborGray: 4558,
  PlyGem_MasticLakeshoreFern: 10764,
  PlyGem_MasticLinen: 2087,
  PlyGem_MasticMistyShadow: 2088,
  PlyGem_MasticModernIron: 2089,
  PlyGem_MasticMontanaSuede: 2105,
  PlyGem_MasticNaturalSlate: 4559,
  PlyGem_MasticNewportBay: 4560,
  PlyGem_MasticPebblestoneClay: 2090,
  PlyGem_MasticPortsmouthBlue: 4561,
  PlyGem_MasticQuietWillow: 2091,
  PlyGem_MasticRedBrick: 4562,
  PlyGem_MasticRedCedar: 4563,
  PlyGem_MasticRockHarbor: 4564,
  PlyGem_MasticRuggedCanyon: 4565,
  PlyGem_MasticRussetRed: 2092,
  PlyGem_MasticSage: 4566,
  PlyGem_MasticSandtone: 4567,
  PlyGem_MasticScottishThistle510: 2106,
  PlyGem_MasticSilverGrey: 4568,
  Plygem_MasticTerraBronze: 21106,
  PlyGem_MasticTerraCotta: 4569,
  PlyGem_MasticTimber: 4570,
  PlyGem_MasticTuscanOlive: 4571,
  PlyGem_MasticVictorianGrey: 2107,
  PlyGem_MasticWalnut: 4572,
  PlyGem_MasticWhite: 2093,
  PlyGem_MasticWicker: 4573,
  PlyGem_MittenBP_Ash: 2108,
  PlyGem_MusketBrown: 2003,
  PlyGem_NaturalAlmond: 2004,
  PlyGem_PebblestoneClay: 4574,
  PlyGem_Peppercorn: 4575,
  Plygem_Pewter: 4653,
  PlyGem_Red: 4576,
  PlyGem_RichMocha: 4594,
  Plygem_Sagebrook: 4654,
  PlyGem_SandDollar: 4577,
  PlyGem_Sandstone: 2005,
  PlyGem_Sandtone: 4595,
  PlyGem_SandyTan: 2006,
  PlyGem_SavannahBlue: 4596,
  PlyGem_SilverMist: 4597,
  PlyGem_SouthernCypress: 4598,
  PlyGem_SpanishMoss: 4578,
  PlyGem_SpanishOlive: 4599,
  PlyGem_StoneMountainClay: 2007,
  PlyGem_SW_EvergreenFog: 4579,
  PlyGem_SW_GaleForce: 4580,
  PlyGem_SW_UrbanBronze: 4581,
  Plygem_Teak: 4655,
  PlyGem_TerraBronze: 2008,
  PlyGem_TerraBrown: 4582,
  PlyGem_Terratone: 2009,
  Plygem_TwilightShadow: 4656,
  PlyGem_VineyardRed: 4583,
  Plygem_VintageDublin: 10556,
  Plygem_Wedgewood: 4657,
  PlyGem_WhisperingTimber: 4584,
  PlyGem_White: 2010,
  PlyGem_Wicker: 2011,
  PlyGem_Winestone: 4585,
  PlyGem_WoodlandRetreat: 4586,
};

const DMC_Richwood = {
  Richwood_Black: 185,
  Richwood_SpanishMoss: 186,
};

const DMC_Rollex = {
  Rollex_Acorn: 31104,
  Rollex_Almond: 31105,
  Rollex_Almond5: 40,
  Rollex_BarnRed: 31106,
  Rollex_Black: 31107,
  Rollex_BlueGranite: 31108,
  Rollex_Brandywine: 31109,
  Rollex_BrightWhite: 41,
  Rollex_Bronze: 31110,
  Rollex_Brown: 31111,
  Rollex_Cactus: 31112,
  Rollex_Canvas: 31113,
  Rollex_Carmel: 31114,
  Rollex_Clay: 31115,
  Rollex_Cobblestone: 31116,
  Rollex_CottageWhite: 31117,
  Rollex_DeepBrown: 31118,
  Rollex_EveningGray: 31119,
  Rollex_Fieldstone: 31120,
  Rollex_ForestGreen: 31121,
  Rollex_Frost: 31122,
  Rollex_Heather: 31123,
  Rollex_Ivory: 31124,
  Rollex_Longwood: 31125,
  Rollex_Mist: 31126,
  Rollex_Mocha: 31127,
  Rollex_Musket: 31128,
  Rollex_NorwegianWood: 31129,
  Rollex_PacificBlue: 31130,
  Rollex_RainwareWhite: 31131,
  Rollex_Sage: 31132,
  Rollex_Sandcastle: 31133,
  Rollex_SeaBreeze: 31134,
  Rollex_Shell: 31135,
  Rollex_Skyline: 31136,
  Rollex_Snowmist: 31137,
  Rollex_Stone: 31138,
  Rollex_Sungold: 31139,
};

const DMC_RoyalBuilding = {
  Royal_Almond: 10806,
  Royal_AlmostMidnight: 11191,
  Royal_AntiqueBrown: 10807,
  Royal_AspenWhite: 11192,
  Royal_Beige: 10808,
  Royal_Black: 10809,
  Royal_BlueGray: 11028,
  Royal_Bone: 11193,
  Royal_BrownStone: 11029,
  Royal_BurgundyRed: 11030,
  Royal_Cactus: 10810,
  Royal_Canyon: 11194,
  Royal_Carbon: 11195,
  Royal_Cashmere: 10811,
  Royal_Charcoal: 10812,
  Royal_Chocolate: 10813,
  Royal_ClassicBlue: 11031,
  Royal_Clay: 10814,
  Royal_CommercialBrown: 10815,
  Royal_CountryBeige: 11196,
  Royal_Cypress: 11032,
  Royal_Driftwood: 11197,
  Royal_Eclipse: 11033,
  Royal_Espresso: 11198,
  Royal_Flagstone: 11034,
  Royal_ForestGreen: 10816,
  Royal_FrenchRoast: 11035,
  Royal_Granite: 11036,
  Royal_Graphite: 11199,
  Royal_Gray: 10817,
  Royal_Greystone: 11200,
  Royal_HarvardSlate: 11037,
  Royal_Heather: 11038,
  Royal_HeritageBlue: 11039,
  Royal_Indigo: 11201,
  Royal_Ironstone: 10818,
  Royal_Ivory: 10819,
  Royal_LighthouseRed: 11202,
  Royal_Linen: 10820,
  Royal_MarineBlue: 11040,
  Royal_MediumBrown: 10821,
  Royal_MetropolitanGray: 11203,
  Royal_MidnightBlue: 11041,
  Royal_MidnightSurf: 11042,
  Royal_Mocha: 11204,
  Royal_Moss: 10822,
  Royal_MusketBrown: 11043,
  Royal_Nantucket: 11205,
  Royal_Oceanside: 11206,
  Royal_Paintable: 11044,
  Royal_Pearl: 11207,
  Royal_PebbleClay: 10823,
  Royal_Platinum: 11045,
  Royal_Polaris: 11208,
  Royal_Redwood: 11046,
  Royal_Regatta: 11209,
  Royal_Riverway: 11047,
  Royal_Rockslide: 11048,
  Royal_Rye: 11210,
  Royal_Saddle: 11211,
  Royal_Sand: 10824,
  Royal_Sandstone: 10825,
  Royal_Shamrock: 11049,
  Royal_SilverMist: 11050,
  Royal_Slate: 11212,
  Royal_SmokyAsh: 11213,
  Royal_SoftMaple: 11051,
  Royal_Spruce: 11214,
  Royal_Sterling: 11052,
  Royal_StoneHarbor: 11215,
  Royal_Storm: 11053,
  Royal_StormCloud: 11054,
  Royal_Timber: 10826,
  Royal_ToastedAlmond: 11055,
  Royal_TreatedCedar: 11056,
  Royal_TreeMoss: 11057,
  Royal_TuxedoGrey: 11058,
  Royal_UniversalBrown: 10827,
  Royal_UrbanBronze: 11059,
  Royal_VintageCream: 11060,
  Royal_Walnut: 11061,
  Royal_WeatheredGray: 11062,
  Royal_Wedgewood: 11063,
  Royal_Wheat: 11216,
  Royal_White: 10828,
  Royal_Wicker: 10829,
  Royal_Wineberry: 11064,
};

const DMC_Schell_Colors = {
  Schell_AspenWhite: 2016,
  Schell_Black: 2017,
  Schell_BrightWhite: 2018,
  Schell_Clay: 2019,
  Schell_Driftwood: 2020,
  Schell_Greystone: 2021,
  Schell_Indigo: 2022,
  Schell_MidnightBlue: 2023,
  Schell_Polaris: 2024,
  Schell_White: 2025,
};

const DMC_SherwinWilliams = {
  HGSW_0024_CurioGray: 4658,
  HGSW_0026_RachelPink: 4659,
  HGSW_0045_AntiquarianBrown: 4660,
  HGSW_0048_BunglehouseBlue: 4661,
  HGSW_0053_Porcelain: 4662,
  HGSW_0060_Alexandrite: 4663,
  HGSW_0068_CopenBlue: 4664,
  HGSW_1013_Gooseberrie: 4665,
  HGSW_1014_VictoriaRose: 4666,
  HGSW_1015_RoseePink: 4667,
  HGSW_1016_IrresistibleKiss: 4668,
  HGSW_1017_PliePink: 4669,
  HGSW_1021_Framboise: 4670,
  HGSW_1022_SaskatoonBerry: 4671,
  HGSW_1023_HeartsContent: 4672,
  HGSW_1024_CherishedPink: 4673,
  HGSW_1025_RaspberryCreme: 4674,
  HGSW_1031_Cerise: 4675,
  HGSW_1033_VeryCherry: 4676,
  HGSW_1034_DreamingPink: 4677,
  HGSW_1035_SakuraPetal: 4678,
  HGSW_1036_CabbageRoses: 4679,
  HGSW_1037_Priscilla: 4680,
  HGSW_1046_GetPinked: 4681,
  HGSW_1047_EnchantingPink: 4682,
  HGSW_1052_ShowStopper: 4683,
  HGSW_1053_CandyHeart: 4684,
  HGSW_1054_RobustPink: 4685,
  HGSW_1055_Amaryllis: 4686,
  HGSW_1056_EverythingPink: 4687,
  HGSW_1057_CachetPink: 4688,
  HGSW_1061_RemingtonRed: 4689,
  HGSW_1062_RedTanager: 4690,
  HGSW_1064_BloomingCoral: 4691,
  HGSW_1065_DishyCoral: 4692,
  HGSW_1066_SweetyPink: 4693,
  HGSW_1067_PrettiestPink: 4694,
  HGSW_1071_VictoriousRed: 4695,
  HGSW_1072_RubyRedSlippers: 4696,
  HGSW_1074_CoralReef: 4697,
  HGSW_1075_CoralOdyssey: 4698,
  HGSW_1076_IndulgentPeach: 4699,
  HGSW_1077_CoralPerfection: 4700,
  HGSW_1081_ScotchBonnetPepper: 4701,
  HGSW_1082_Peppery: 4702,
  HGSW_1084_LeiFlower: 4703,
  HGSW_1085_ModernCoral: 4704,
  HGSW_1086_FloraFauna: 4705,
  HGSW_1087_AndromedaPink: 4706,
  HGSW_1092_RowanBerries: 4707,
  HGSW_1093_KnockoutOrange: 4708,
  HGSW_1094_PinkRanunculus: 4709,
  HGSW_1095_ClassicCoral: 4710,
  HGSW_1096_SweetAsAPeach: 4711,
  HGSW_1097_PeachArtemesia: 4712,
  HGSW_1103_RobustOrange: 4713,
  HGSW_1104_Emberglow: 4714,
  HGSW_1105_PeachPreserves: 4715,
  HGSW_1111_OptimisticOrange: 4716,
  HGSW_1116_PowderPeach: 4717,
  HGSW_1117_ProvincialPeach: 4718,
  HGSW_1121_PumpkinCurry: 4719,
  HGSW_1122_CopperPlaya: 4720,
  HGSW_1123_OutgoingOrange: 4721,
  HGSW_1125_SignetMarigold: 4722,
  HGSW_1126_PaleApricot: 4723,
  HGSW_1127_PeachSabayon: 4724,
  HGSW_1134_HeirloomCarrot: 4725,
  HGSW_1135_AniseOrange: 4726,
  HGSW_1136_FragrantNectarine: 4727,
  HGSW_1137_BountifulPeach: 4728,
  HGSW_1152_HeritageGold: 4729,
  HGSW_1153_AmeliasWings: 4730,
  HGSW_1154_MellowMango: 4731,
  HGSW_1155_FreshForsythia: 4732,
  HGSW_1157_SpringNectar: 4733,
  HGSW_1161_ModYellow: 4734,
  HGSW_1162_SummerSunflower: 4735,
  HGSW_1163_GeographicYellow: 4736,
  HGSW_1164_Afternoon: 4737,
  HGSW_1165_Flutterbye: 4738,
  HGSW_1167_StonewyckeIvory: 4739,
  HGSW_1171_GeometricYellow: 4740,
  HGSW_1172_GlitteratiGold: 4741,
  HGSW_1173_PalladianGold: 4742,
  HGSW_1174_UntamedYellow: 4743,
  HGSW_1175_Outrigger: 4744,
  HGSW_1177_LemonChiffonade: 4745,
  HGSW_1181_Cadence: 4746,
  HGSW_1182_GriffinGold: 4747,
  HGSW_1183_DutchTulip: 4748,
  HGSW_1184_DaffodilHill: 4749,
  HGSW_1185_YellowShell: 4750,
  HGSW_1186_LiltingLily: 4751,
  HGSW_1187_TintOfHoney: 4752,
  HGSW_1196_ButterUp: 4753,
  HGSW_1197_CottonTwill: 4754,
  HGSW_1201_AubussonGold: 4755,
  HGSW_1202_GoldMarket: 4756,
  HGSW_1204_SimplyJoyful: 4757,
  HGSW_1206_Solaria: 4758,
  HGSW_1212_DashingGold: 4759,
  HGSW_1213_Instigate: 4760,
  HGSW_1214_GoldDoubloons: 4761,
  HGSW_1215_DottyYellow: 4762,
  HGSW_1216_YellowSongbird: 4763,
  HGSW_1217_BlanchedYellow: 4764,
  HGSW_1221_LimeBlast: 4765,
  HGSW_1222_Alchemist: 4766,
  HGSW_1223_GameChanger: 4767,
  HGSW_1224_GingerWasabi: 4768,
  HGSW_1227_LemonMintLeaf: 4769,
  HGSW_1231_AloeGreenTea: 4770,
  HGSW_1232_Venomous: 4771,
  HGSW_1233_Fernwood: 4772,
  HGSW_1235_Frolic: 4773,
  HGSW_1236_Limelite: 4774,
  HGSW_1237_WhiteCitrus: 4775,
  HGSW_1241_GreenVerge: 4776,
  HGSW_1243_Parakeet: 4777,
  HGSW_1244_Plankton: 4778,
  HGSW_1245_FieldsGreens: 4779,
  HGSW_1246_SoftAvocado: 4780,
  HGSW_1247_SpringBuds: 4781,
  HGSW_1261_RainforestCanopy: 4782,
  HGSW_1262_LandscapePalm: 4783,
  HGSW_1263_OrganicGreen: 4784,
  HGSW_1264_EastlandGreen: 4785,
  HGSW_1265_OwensGreen: 4786,
  HGSW_1266_GreenSavvy: 4787,
  HGSW_1281_PottersShed: 4788,
  HGSW_1283_WelshGreen: 4789,
  HGSW_1284_MoodyGreen: 4790,
  HGSW_1285_HeatherGreen: 4791,
  HGSW_1286_PotteryGlaze: 4792,
  HGSW_1287_MistedMint: 4793,
  HGSW_1291_DaringJade: 4794,
  HGSW_1293_TenderSeedling: 4795,
  HGSW_1294_CohesiveGreen: 4796,
  HGSW_1295_Homegrown: 4797,
  HGSW_1296_CucumberChutney: 4798,
  HGSW_1297_GreenWhimsy: 4799,
  HGSW_1302_GreenEscarpment: 4800,
  HGSW_1303_TropicalCay: 4801,
  HGSW_1304_CotswoldGreen: 4802,
  HGSW_1305_TigerEyes: 4803,
  HGSW_1306_Refresh: 4804,
  HGSW_1307_Aqueous: 4805,
  HGSW_1312_MerryTeal: 4806,
  HGSW_1314_CooledBlue: 4807,
  HGSW_1315_GeyserMist: 4808,
  HGSW_1316_CoastalAqua: 4809,
  HGSW_1317_TameTeal: 4810,
  HGSW_1321_DeepBlueOcean: 4811,
  HGSW_1322_FederatedBlue: 4812,
  HGSW_1323_PursuitOfTeal: 4813,
  HGSW_1324_ForeAndAft: 4814,
  HGSW_1325_BlueMacaroon: 4815,
  HGSW_1326_BlueIris: 4816,
  HGSW_1327_Swimming: 4817,
  HGSW_1331_BlueNile: 4818,
  HGSW_1332_RightAsRain: 4819,
  HGSW_1333_SeptemberSkies: 4820,
  HGSW_1334_RaptureBlue: 4821,
  HGSW_1335_BreezyAqua: 4822,
  HGSW_1336_Cay: 4823,
  HGSW_1341_Amalfi: 4824,
  HGSW_1343_BlueBicycle: 4825,
  HGSW_1344_AboveTheWaves: 4826,
  HGSW_1345_VintageAqua: 4827,
  HGSW_1346_LapidaryBlue: 4828,
  HGSW_1347_GalacticLite: 4829,
  HGSW_1351_ConvergentBlue: 4830,
  HGSW_1352_AdriaticAzure: 4831,
  HGSW_1353_Capri: 4832,
  HGSW_1354_TealEndeavor: 4833,
  HGSW_1356_GlacierBasin: 4834,
  HGSW_1357_SolarSail: 4835,
  HGSW_1361_JayBlue: 4836,
  HGSW_1362_BlueAzores: 4837,
  HGSW_1363_SomethingBorrowed: 4838,
  HGSW_1364_NorthHollandBlue: 4839,
  HGSW_1365_BlueDiscovery: 4840,
  HGSW_1366_RivuletPath: 4841,
  HGSW_1367_SnowMountain: 4842,
  HGSW_1372_BlueClematis: 4843,
  HGSW_1373_OrionBlue: 4844,
  HGSW_1374_StoneMountainBlue: 4845,
  HGSW_1376_SomethingBlue: 4846,
  HGSW_1377_ArialView: 4847,
  HGSW_1382_ArrestingBlue: 4848,
  HGSW_1383_Scanda: 4849,
  HGSW_1385_SuffolkBlue: 4850,
  HGSW_1386_BlissfulBlue: 4851,
  HGSW_1387_Icebreaker: 4852,
  HGSW_1391_DelftPottery: 4853,
  HGSW_1392_VitalBlue: 4854,
  HGSW_1394_PembrokeBlue: 4855,
  HGSW_1395_SweetLavender: 4856,
  HGSW_1396_CelestialSkies: 4857,
  HGSW_1397_Melodious: 4858,
  HGSW_1401_Quark: 4859,
  HGSW_1402_LavenderFields: 4860,
  HGSW_1403_PurplePeonies: 4861,
  HGSW_1404_GentryViolet: 4862,
  HGSW_1405_Bedazzled: 4863,
  HGSW_1407_GalaxyPurple: 4864,
  HGSW_1411_Amethystina: 4865,
  HGSW_1412_VioletObsession: 4866,
  HGSW_1413_Serenade: 4867,
  HGSW_1415_BeverlyLilac: 4868,
  HGSW_1416_VioletCache: 4869,
  HGSW_1417_PurplePotential: 4870,
  HGSW_1421_ImpulsivePurple: 4871,
  HGSW_1422_OpulantPurple: 4872,
  HGSW_1423_AlliumBlooms: 4873,
  HGSW_1425_Magical: 4874,
  HGSW_1426_HazeyPurple: 4875,
  HGSW_1427_LilacFrost: 4876,
  HGSW_1431_Anthology: 4877,
  HGSW_1432_PrettyPurple: 4878,
  HGSW_1434_VioletRoyale: 4879,
  HGSW_1435_PurpleRegalia: 4880,
  HGSW_1436_EuphoricLilac: 4881,
  HGSW_1437_MattePurple: 4882,
  HGSW_1441_TricornBlack: 4883,
  HGSW_1443_NevermoreGrey: 4884,
  HGSW_1445_MorningFog: 4885,
  HGSW_1446_Latitude: 4886,
  HGSW_1447_OlympusWhite: 4887,
  HGSW_1452_JaggedGranite: 4888,
  HGSW_1453_SteelyGray: 4889,
  HGSW_1454_Monochrome: 4890,
  HGSW_1456_StoneEagle: 4891,
  HGSW_1457_Icicle: 4892,
  HGSW_1461_NoLimits: 4893,
  HGSW_1462_WebGray: 4894,
  HGSW_1463_Software: 4895,
  HGSW_1464_FlannelGrey: 4896,
  HGSW_1465_ContemporaryGrey: 4897,
  HGSW_1466_Online: 4898,
  HGSW_1467_GrayScreen: 4899,
  HGSW_1472_SlateTile: 4900,
  HGSW_1473_PortsmouthLanding: 4901,
  HGSW_1474_CobblestoneArch: 4902,
  HGSW_1475_SteelPiling: 4903,
  HGSW_1476_GreySanctuary: 4904,
  HGSW_1477_GlacialStream: 4905,
  HGSW_1481_Carbonized: 4906,
  HGSW_1482_GrizzleGray: 4907,
  HGSW_1483_ArmitageGrey: 4908,
  HGSW_1484_KatabaticWinds: 4909,
  HGSW_1485_EssexGrey: 4910,
  HGSW_1486_Windstorm: 4911,
  HGSW_1487_Passive: 4912,
  HGSW_1491_Peppercorn: 4913,
  HGSW_1492_ThunderClap: 4914,
  HGSW_1494_Pussywillow: 4915,
  HGSW_1495_ModernistGray: 4916,
  HGSW_1496_StoneIsle: 4917,
  HGSW_1501_RockBottom: 4918,
  HGSW_1502_ObsidianGlass: 4919,
  HGSW_1503_TimeAndSpace: 4920,
  HGSW_1504_Fossilized: 4921,
  HGSW_1505_Wormwood: 4922,
  HGSW_1506_MagneticGray: 4923,
  HGSW_1507_LaplandIce: 4924,
  HGSW_1668_PineappleCream: 4925,
  HGSW_2023_RubyLane: 4926,
  HGSW_2024_PlumeriaBlossom: 4927,
  HGSW_2025_MythicMauve: 4928,
  HGSW_2026_MauveRose: 4929,
  HGSW_2027_DowningPink: 4930,
  HGSW_2032_Passionate: 4931,
  HGSW_2033_RussetPink: 4932,
  HGSW_2034_MochaMauve: 4933,
  HGSW_2035_FrenchHeather: 4934,
  HGSW_2036_AllisonsPink: 4935,
  HGSW_2037_MadAboutPink: 4936,
  HGSW_2042_Impulsive: 4937,
  HGSW_2043_Redbud: 4938,
  HGSW_2044_MamasKisses: 4939,
  HGSW_2045_MemorableRose: 4940,
  HGSW_2046_LotusFlower: 4941,
  HGSW_2047_CharmingPink: 4942,
  HGSW_2051_WoodlandStrawberry: 4943,
  HGSW_2053_RuddyRose: 4944,
  HGSW_2054_PoseyPink: 4945,
  HGSW_2055_RomanticMauve: 4946,
  HGSW_2057_ShimmeryPink: 4947,
  HGSW_2061_Fireweed: 4948,
  HGSW_2062_BurntScarlet: 4949,
  HGSW_2064_Coralbelle: 4950,
  HGSW_2065_PeekabooCoral: 4951,
  HGSW_2066_MellowCoral: 4952,
  HGSW_2067_Romance: 4953,
  HGSW_2071_FiredBrick: 4954,
  HGSW_2073_NouveauRed: 4955,
  HGSW_2074_PinkCinnamon: 4956,
  HGSW_2075_SalmonRiverRun: 4957,
  HGSW_2076_PinkGlamour: 4958,
  HGSW_2077_QuaintPeche: 4959,
  HGSW_2081_LustreRed: 4960,
  HGSW_2083_BronwynRust: 4961,
  HGSW_2085_PavePeach: 4962,
  HGSW_2086_PeachMaison: 4963,
  HGSW_2087_CandiedPeach: 4964,
  HGSW_2092_WarmSienna: 4965,
  HGSW_2093_TerracottaPot: 4966,
  HGSW_2094_HeatheredOrange: 4967,
  HGSW_2095_SundriedTerra: 4968,
  HGSW_2096_CountrysideBlush: 4969,
  HGSW_2097_GreccoPeach: 4970,
  HGSW_2101_CopperMountain: 4971,
  HGSW_2103_Armagnac: 4972,
  HGSW_2104_StudioCopper: 4973,
  HGSW_2105_OrangePatina: 4974,
  HGSW_2106_TintedApricot: 4975,
  HGSW_2107_HalifaxOrange: 4976,
  HGSW_2113_ElegantOrange: 4977,
  HGSW_2114_Harvested: 4978,
  HGSW_2115_ShinyPenny: 4979,
  HGSW_2116_SonyaOrange: 4980,
  HGSW_2117_FreshPeach: 4981,
  HGSW_2121_CopperKettle: 4982,
  HGSW_2126_HoneyedGinger: 4983,
  HGSW_2127_CashmereGlow: 4984,
  HGSW_2131_BourbonButterscotch: 4985,
  HGSW_2132_EssentialGold: 4986,
  HGSW_2133_Honeycomb: 4987,
  HGSW_2135_Tetragold: 4988,
  HGSW_2136_TrellisYellow: 4989,
  HGSW_2137_CameoCreme: 4990,
  HGSW_2141_FrenchMustard: 4991,
  HGSW_2142_LunaGold: 4992,
  HGSW_2143_CelebrationGold: 4993,
  HGSW_2144_AnjouPear: 4994,
  HGSW_2146_DoyleGold: 4995,
  HGSW_2152_SmokeyTopaz: 4996,
  HGSW_2153_ButcherPaper: 4997,
  HGSW_2155_TotallyTan: 4998,
  HGSW_2157_BackToBasics: 4999,
  HGSW_2161_QuirkyGold: 5000,
  HGSW_2162_BoscPear: 5001,
  HGSW_2167_Napery: 5002,
  HGSW_2171_RelicBronze: 5003,
  HGSW_2172_Chamois: 5004,
  HGSW_2173_ManneredGold: 5005,
  HGSW_2174_GrecianGold: 5006,
  HGSW_2175_RestrainedGold: 5007,
  HGSW_2176_Blonde: 5008,
  HGSW_2177_Ivoire: 5009,
  HGSW_2182_Cardboard: 5010,
  HGSW_2183_Baguette: 5011,
  HGSW_2184_HandcraftedBrown: 5012,
  HGSW_2185_Camelback: 5013,
  HGSW_2186_WholeWheat: 5014,
  HGSW_2187_BelievableBuff: 5015,
  HGSW_2191_Antiquarium: 5016,
  HGSW_2192_Hazellwood: 5017,
  HGSW_2194_PiecesOfEight: 5018,
  HGSW_2195_EtruscanGold: 5019,
  HGSW_2196_Honeygold: 5020,
  HGSW_2197_GleefulYellow: 5021,
  HGSW_2202_YellowLichen: 5022,
  HGSW_2203_GoldenMystery: 5023,
  HGSW_2204_Antiquity: 5024,
  HGSW_2205_IndependentGold: 5025,
  HGSW_2206_MossVine: 5026,
  HGSW_2207_LucentYellow: 5027,
  HGSW_2211_AdmiralBronze: 5028,
  HGSW_2213_RainforestFloor: 5029,
  HGSW_2214_OlivineCrystal: 5030,
  HGSW_2215_MythicGreen: 5031,
  HGSW_2216_WheatGrass: 5032,
  HGSW_2217_AncestralGold: 5033,
  HGSW_2221_SaguaroCactus: 5034,
  HGSW_2222_RuralGreen: 5035,
  HGSW_2223_GreenGumTree: 5036,
  HGSW_2225_AvocadoFruit: 5037,
  HGSW_2226_HeartsOfPalm: 5038,
  HGSW_2227_RiceFields: 5039,
  HGSW_2232_NaturalHabitat: 5040,
  HGSW_2233_MountainMoss: 5041,
  HGSW_2234_RyegrassSeed: 5042,
  HGSW_2235_NapaCabbage: 5043,
  HGSW_2236_Kiwifruit: 5044,
  HGSW_2237_Celery: 5045,
  HGSW_2241_BackNine: 5046,
  HGSW_2242_GardenSpot: 5047,
  HGSW_2243_IntoTheGreen: 5048,
  HGSW_2244_TremontGarden: 5049,
  HGSW_2247_CucumberWater: 5050,
  HGSW_2251_TeeShot: 5051,
  HGSW_2252_ForresterGreen: 5052,
  HGSW_2254_ChatfieldGreen: 5053,
  HGSW_2255_Haven: 5054,
  HGSW_2256_MelancholoyMint: 5055,
  HGSW_2257_TwinklyGreen: 5056,
  HGSW_2262_MatchPlay: 5057,
  HGSW_2263_BackcountryGreen: 5058,
  HGSW_2264_ItalianBasil: 5059,
  HGSW_2265_CoastalSeaglass: 5060,
  HGSW_2266_BotanyGreen: 5061,
  HGSW_2267_MellowMint: 5062,
  HGSW_2271_FreshArugala: 5063,
  HGSW_2272_ChoppedCilantro: 5064,
  HGSW_2273_SugarSnapPea: 5065,
  HGSW_2275_NurtureGreen: 5066,
  HGSW_2276_CommunityGarden: 5067,
  HGSW_2277_ModMint: 5068,
  HGSW_2281_WildernessTrail: 5069,
  HGSW_2283_Cultivar: 5070,
  HGSW_2284_WeatheringCopper: 5071,
  HGSW_2285_Restful: 5072,
  HGSW_2286_PalePatina: 5073,
  HGSW_2287_MistOnTheMoors: 5074,
  HGSW_2291_GreenTartan: 5075,
  HGSW_2292_Jadepool: 5076,
  HGSW_2295_VarigatedVinca: 5077,
  HGSW_2296_Aloe: 5078,
  HGSW_2297_Breaktime: 5079,
  HGSW_2301_BucolicGreen: 5080,
  HGSW_2302_Cloverfields: 5081,
  HGSW_2304_ComposedTeal: 5082,
  HGSW_2305_SaltMarshes: 5083,
  HGSW_2306_CeladonPottery: 5084,
  HGSW_2307_Waterscape: 5085,
  HGSW_2311_EmeraldShore: 5086,
  HGSW_2312_IslandTime: 5087,
  HGSW_2313_BaysideBlue: 5088,
  HGSW_2314_DrizzlingRain: 5089,
  HGSW_2315_WornTurquoise: 5090,
  HGSW_2316_Watery: 5091,
  HGSW_2317_Tidewater: 5092,
  HGSW_2321_SonoranTeal: 5093,
  HGSW_2322_TurquoiseCay: 5094,
  HGSW_2323_Cloudburst: 5095,
  HGSW_2324_ReflectingPool: 5096,
  HGSW_2327_MintToBe: 5097,
  HGSW_2331_OceansideBlue: 5098,
  HGSW_2332_BarrierReef: 5099,
  HGSW_2333_Beachcomber: 5100,
  HGSW_2334_ElCaribe: 5101,
  HGSW_2336_CoolLaguna: 5102,
  HGSW_2337_PristineSkies: 5103,
  HGSW_2341_TresBlue: 5104,
  HGSW_2342_MermaidsTale: 5105,
  HGSW_2343_SplendorBlue: 5106,
  HGSW_2344_SwimmingHole: 5107,
  HGSW_2345_InfinityFalls: 5108,
  HGSW_2347_CaughtInTheRain: 5109,
  HGSW_2351_Aqualuxe: 5110,
  HGSW_2352_HighlandLoch: 5111,
  HGSW_2353_ManitouBlue: 5112,
  HGSW_2354_OpenSeas: 5113,
  HGSW_2355_Seafarer: 5114,
  HGSW_2357_CrescentBlue: 5115,
  HGSW_2361_NarragansettNavy: 5116,
  HGSW_2362_GeorgianBay: 5117,
  HGSW_2363_EbbTide: 5118,
  HGSW_2365_ResoluteBlue: 5119,
  HGSW_2366_ColdRiver: 5120,
  HGSW_2367_CrystalStream: 5121,
  HGSW_2371_LongHorizon: 5122,
  HGSW_2372_EarthwiseBlue: 5123,
  HGSW_2373_BluePatchwork: 5124,
  HGSW_2375_SoulSeeker: 5125,
  HGSW_2376_Contemplative: 5126,
  HGSW_2382_Denim: 5127,
  HGSW_2383_SportyBlue: 5128,
  HGSW_2385_NotableHue: 5129,
  HGSW_2386_HonestBlue: 5130,
  HGSW_2387_TeenseyBubbles: 5131,
  HGSW_2391_CourtlyBlue: 5132,
  HGSW_2393_SearchingBlue: 5133,
  HGSW_2394_FragrantLavender: 5134,
  HGSW_2395_BlueSlumber: 5135,
  HGSW_2397_IcelandicBlue: 5136,
  HGSW_2401_PurpleMidnight: 5137,
  HGSW_2402_RococcoViolet: 5138,
  HGSW_2403_PurpleThrush: 5139,
  HGSW_2405_DippedInViolet: 5140,
  HGSW_2406_CandiedLavender: 5141,
  HGSW_2407_OrchidBrite: 5142,
  HGSW_2411_AmethystGlass: 5143,
  HGSW_2412_VioletTwilight: 5144,
  HGSW_2413_PurplePeacock: 5145,
  HGSW_2415_AshViolet: 5146,
  HGSW_2416_TwirlingGirl: 5147,
  HGSW_2417_SplashOfLilac: 5148,
  HGSW_2423_TarasViolet: 5149,
  HGSW_2424_BerryCreme: 5150,
  HGSW_2425_WisteriaTree: 5151,
  HGSW_2426_PixiePlum: 5152,
  HGSW_2427_SugarPlumbed: 5153,
  HGSW_2431_GrownUpGrape: 5154,
  HGSW_2432_PrincipalGrape: 5155,
  HGSW_2433_PlumDandy: 5156,
  HGSW_2435_Thistle: 5157,
  HGSW_2436_FurtiveMauve: 5158,
  HGSW_2437_Plumscicle: 5159,
  HGSW_2441_SeaOtter: 5160,
  HGSW_2442_Tynewood: 5161,
  HGSW_2443_Mink: 5162,
  HGSW_2444_HighlandGrey: 5163,
  HGSW_2445_IntuitiveGray: 5164,
  HGSW_2447_Grayish: 5165,
  HGSW_2451_Sealskin: 5166,
  HGSW_2457_BasaltPowder: 5167,
  HGSW_2461_WellbredBrown: 5168,
  HGSW_2462_StoneStatue: 5169,
  HGSW_2463_ElegantTaupe: 5170,
  HGSW_2465_FunctionalGray: 5171,
  HGSW_2466_RequisiteGray: 5172,
  HGSW_2467_Alpaca: 5173,
  HGSW_2472_WeatherWorn: 5174,
  HGSW_2474_TerminalTaupe: 5175,
  HGSW_2475_PerfectGreige: 5176,
  HGSW_2476_AdleyGrey: 5177,
  HGSW_2477_GhostPines: 5178,
  HGSW_2481_VanDykeBrown: 5179,
  HGSW_2482_Elemental: 5180,
  HGSW_2483_VirtualTaupe: 5181,
  HGSW_2484_PebblePathway: 5182,
  HGSW_2485_GristmillGreige: 5183,
  HGSW_2486_BalancedBeige: 5184,
  HGSW_2487_AccessibleBeige: 5185,
  HGSW_2491_TurkishCoffee: 5186,
  HGSW_2492_TikiHut: 5187,
  HGSW_2493_FalconTaupe: 5188,
  HGSW_2495_LambskinBeige: 5189,
  HGSW_2496_BungalowBeige: 5190,
  HGSW_2497_CalicoCream: 5191,
  HGSW_2501_DarkBronzetone: 5192,
  HGSW_2503_CaribouBrown: 5193,
  HGSW_2504_TruffleOil: 5194,
  HGSW_2506_LinwoodSands: 5195,
  HGSW_2735_Rockweed: 5196,
  HGSW_3011_BlackberryBramble: 5197,
  HGSW_3012_Ravenwood: 5198,
  HGSW_3013_PlumDelia: 5199,
  HGSW_3015_MaevesMauve: 5200,
  HGSW_3016_SweetenedPlum: 5201,
  HGSW_3017_PersianPearl: 5202,
  HGSW_3021_RougeRemix: 5203,
  HGSW_3022_KingsIslandBrown: 5204,
  HGSW_3024_CocoaBerrie: 5205,
  HGSW_3025_HenleyPlum: 5206,
  HGSW_3026_ArtsyPink: 5207,
  HGSW_3027_WhiteTruffle: 5208,
  HGSW_3031_IgneousRock: 5209,
  HGSW_3032_CocoaIsland: 5210,
  HGSW_3034_RoanChestnut: 5211,
  HGSW_3035_EmergingTaupe: 5212,
  HGSW_3036_SweetBeige: 5213,
  HGSW_3037_SoftPutty: 5214,
  HGSW_3041_DyingEmber: 5215,
  HGSW_3043_CanyonArroyo: 5216,
  HGSW_3044_RuggedCoast: 5217,
  HGSW_3046_SashaySand: 5218,
  HGSW_3047_PinkPhenomenon: 5219,
  HGSW_3051_TavernOak: 5220,
  HGSW_3052_ReindeerHerd: 5221,
  HGSW_3054_FieryHue: 5222,
  HGSW_3055_IntimateTan: 5223,
  HGSW_3056_ClassicBeige: 5224,
  HGSW_3057_MaltedMilk: 5225,
  HGSW_3061_BackInTheSaddle: 5226,
  HGSW_3062_BrevityBrown: 5227,
  HGSW_3063_WoodsyHollow: 5228,
  HGSW_3064_RelaxedVibe: 5229,
  HGSW_3065_BalticBirch: 5230,
  HGSW_3066_SocialCall: 5231,
  HGSW_3071_MocaJava: 5232,
  HGSW_3072_Aspinwall: 5233,
  HGSW_3073_RusticStoneware: 5234,
  HGSW_3074_Ledgestone: 5235,
  HGSW_3075_SereneTan: 5236,
  HGSW_3077_SimplifyBeige: 5237,
  HGSW_3081_JumpingJava: 5238,
  HGSW_3082_CobbleBrown: 5239,
  HGSW_3083_WoodVessel: 5240,
  HGSW_3084_MarketMushroom: 5241,
  HGSW_3085_UtterlyBeige: 5242,
  HGSW_3086_DiverseBeige: 5243,
  HGSW_3087_RealistBeige: 5244,
  HGSW_3091_MutedMahogany: 5245,
  HGSW_3092_ReclaimedWood: 5246,
  HGSW_3093_BambooFiber: 5247,
  HGSW_3094_AdirondackChair: 5248,
  HGSW_3095_TweedJacket: 5249,
  HGSW_3096_StrawTote: 5250,
  HGSW_3097_HitTheBeach: 5251,
  HGSW_3101_BrownAptitude: 5252,
  HGSW_3102_AnorakBrown: 5253,
  HGSW_3104_HuntGather: 5254,
  HGSW_3105_BombayBeach: 5255,
  HGSW_3106_FamiliarBeige: 5256,
  HGSW_3107_LightweightBeige: 5257,
  HGSW_3111_Kaffee: 5258,
  HGSW_3113_Portabello: 5259,
  HGSW_3115_SandsOfTime: 5260,
  HGSW_3116_CommonThread: 5261,
  HGSW_3117_SandDollar: 5262,
  HGSW_3121_ZaharaBrown: 5263,
  HGSW_3125_TrailsideTan: 5264,
  HGSW_3127_LaidbackBeige: 5265,
  HGSW_3134_CraggyDesert: 5266,
  HGSW_3136_Almeria: 5267,
  HGSW_3137_Almondine: 5268,
  HGSW_3141_HawkeyeBrown: 5269,
  HGSW_3143_Hopsack: 5270,
  HGSW_3144_ToastedOat: 5271,
  HGSW_3145_Latte: 5272,
  HGSW_3146_NomadicDesert: 5273,
  HGSW_3147_KilimBeige: 5274,
  HGSW_3151_CommonGrounds: 5275,
  HGSW_3152_Kilndried: 5276,
  HGSW_3153_SorrentoValley: 5277,
  HGSW_3155_TangledTan: 5278,
  HGSW_3156_ClothStone: 5279,
  HGSW_3157_VanillaSugar: 5280,
  HGSW_3162_OldTowne: 5281,
  HGSW_3163_TranquilTan: 5282,
  HGSW_3164_DromedaryCamel: 5283,
  HGSW_3165_FlaxSeed: 5284,
  HGSW_3166_DiamondWeave: 5285,
  HGSW_3167_AridSands: 5286,
  HGSW_3171_PinewoodForest: 5287,
  HGSW_3172_ScottishOak: 5288,
  HGSW_3173_DapperTan: 5289,
  HGSW_3176_Macadamia: 5290,
  HGSW_3177_SofterTan: 5291,
  HGSW_3182_OldeGold: 5292,
  HGSW_3183_QuiverTan: 5293,
  HGSW_3184_CarrolltonKhaki: 5294,
  HGSW_3185_UniversalKhaki: 5295,
  HGSW_3186_RelaxedKhaki: 5296,
  HGSW_3187_Unravelled: 5297,
  HGSW_3192_Artefact: 5298,
  HGSW_3193_Burlap: 5299,
  HGSW_3194_BalancedTan: 5300,
  HGSW_3195_HarmonicTan: 5301,
  HGSW_3196_Ecru: 5302,
  HGSW_3197_Netsuke: 5303,
  HGSW_3201_CattailReed: 5304,
  HGSW_3202_OvenBaked: 5305,
  HGSW_3203_ArroyoValley: 5306,
  HGSW_3204_ElkRun: 5307,
  HGSW_3206_TexasTumbleweed: 5308,
  HGSW_3207_Pulpwood: 5309,
  HGSW_3211_OliveTapas: 5310,
  HGSW_3212_HighTea: 5311,
  HGSW_3213_LodgepolePine: 5312,
  HGSW_3214_Fenland: 5313,
  HGSW_3215_FavoriteTan: 5314,
  HGSW_3216_WhiteRamie: 5315,
  HGSW_3221_Subterranean: 5316,
  HGSW_3222_Cocoon: 5317,
  HGSW_3225_Chatroom: 5318,
  HGSW_3226_WindsweptCliff: 5319,
  HGSW_3227_SedateGray: 5320,
  HGSW_3231_VineyardVine: 5321,
  HGSW_3233_ConduitGrey: 5322,
  HGSW_3235_SvelteSage: 5323,
  HGSW_3237_AncientMarble: 5324,
  HGSW_3241_UrbanGarden: 5325,
  HGSW_3242_GerminatingGreen: 5326,
  HGSW_3243_LichenLiverwort: 5327,
  HGSW_3245_ClarySage: 5328,
  HGSW_3246_SoftenedGreen: 5329,
  HGSW_3247_LiveableGreen: 5330,
  HGSW_3251_CorianderOlive: 5331,
  HGSW_3252_FreshBalsam: 5332,
  HGSW_3253_PrivilegeGreen: 5333,
  HGSW_3255_CoastalPlain: 5334,
  HGSW_3256_Contented: 5335,
  HGSW_3257_FilmyGreen: 5336,
  HGSW_3261_Shadegrown: 5337,
  HGSW_3263_FarmToTable: 5338,
  HGSW_3264_HuntersPointe: 5339,
  HGSW_3265_EscapeGray: 5340,
  HGSW_3266_WoodyRosemary: 5341,
  HGSW_3267_TurningPointe: 5342,
  HGSW_3271_BatterseaBronze: 5343,
  HGSW_3273_StationGray: 5344,
  HGSW_3274_MarshGrasses: 5345,
  HGSW_3275_RareGray: 5346,
  HGSW_3276_PhantomForest: 5347,
  HGSW_3277_PlayItCool: 5348,
  HGSW_3282_WoodlandLichen: 5349,
  HGSW_3283_Retreat: 5350,
  HGSW_3284_Thorntree: 5351,
  HGSW_3286_ComfortGray: 5352,
  HGSW_3287_SeaSalt: 5353,
  HGSW_3291_Jasper: 5354,
  HGSW_3292_GreenPasture: 5355,
  HGSW_3293_ValiantBlue: 5356,
  HGSW_3294_BlueSeagrass: 5357,
  HGSW_3295_DesertLake: 5358,
  HGSW_3296_RiceTerrace: 5359,
  HGSW_3301_Oceanus: 5360,
  HGSW_3302_Riverway: 5361,
  HGSW_3303_TreeSwallow: 5362,
  HGSW_3304_AquaReservoir: 5363,
  HGSW_3305_InterestingAqua: 5364,
  HGSW_3306_RacingTheRain: 5365,
  HGSW_3307_TradewindBlue: 5366,
  HGSW_3311_Archipelago: 5367,
  HGSW_3313_Aquamarined: 5368,
  HGSW_3314_MarinePark: 5369,
  HGSW_3315_Groundwater: 5370,
  HGSW_3316_FalklandBlue: 5371,
  HGSW_3317_DelicateDelia: 5372,
  HGSW_3321_BlueMidnight: 5373,
  HGSW_3322_BlueMystery: 5374,
  HGSW_3323_NordicBleu: 5375,
  HGSW_3324_Debonair: 5376,
  HGSW_3325_BlueMountaintop: 5377,
  HGSW_3326_FreshIdea: 5378,
  HGSW_3327_CrispBlue: 5379,
  HGSW_3331_DarkNight: 5380,
  HGSW_3332_TempestSkies: 5381,
  HGSW_3334_SomersetGrey: 5382,
  HGSW_3335_SilverShadows: 5383,
  HGSW_3336_SilverSalvia: 5384,
  HGSW_3337_Watermarked: 5385,
  HGSW_3341_SpectralIndigo: 5386,
  HGSW_3342_SeaCreature: 5387,
  HGSW_3343_BlueJasmine: 5388,
  HGSW_3344_ByTheSea: 5389,
  HGSW_3345_BehindBlueEyes: 5390,
  HGSW_3346_TranquilVibe: 5391,
  HGSW_3347_MoonlitPath: 5392,
  HGSW_3351_Naval: 5393,
  HGSW_3352_NorthernPike: 5394,
  HGSW_3353_BracingBlue: 5395,
  HGSW_3355_Aleutian: 5396,
  HGSW_3356_OceansSide: 5397,
  HGSW_3357_Upward: 5398,
  HGSW_3362_SweepingRock: 5399,
  HGSW_3363_StormCloud: 5400,
  HGSW_3364_BabblingBrooke: 5401,
  HGSW_3365_SeaIslandCotton: 5402,
  HGSW_3366_Krypton: 5403,
  HGSW_3367_NorthStar: 5404,
  HGSW_3372_MercuryPeak: 5405,
  HGSW_3373_SpecialGray: 5406,
  HGSW_3374_ChilledPurple: 5407,
  HGSW_3376_HeavenSent: 5408,
  HGSW_3377_ChaseTheMoonlite: 5409,
  HGSW_3381_WildRide: 5410,
  HGSW_3382_StunningShade: 5411,
  HGSW_3383_SensuousGray: 5412,
  HGSW_3384_ArtfulTwist: 5413,
  HGSW_3385_FaunaPop: 5414,
  HGSW_3391_OceanicTrench: 5415,
  HGSW_3392_ShadowHue: 5416,
  HGSW_3393_SmokyPurple: 5417,
  HGSW_3394_GreatGreige: 5418,
  HGSW_3395_DreamInPurple: 5419,
  HGSW_3396_Refracted: 5420,
  HGSW_3397_GossamerSilk: 5421,
  HGSW_3401_PlumBrown: 5422,
  HGSW_3402_ExpressivePlum: 5423,
  HGSW_3404_HandsomePlum: 5424,
  HGSW_3405_OneFineDay: 5425,
  HGSW_3406_HighNote: 5426,
  HGSW_3407_SensitiveTint: 5427,
  HGSW_3411_WineryRed: 5428,
  HGSW_3412_DurablePlum: 5429,
  HGSW_3413_CoirFibre: 5430,
  HGSW_3415_Coopersmith: 5431,
  HGSW_3416_HintOfCrimson: 5432,
  HGSW_3417_ChasteMauve: 5433,
  HGSW_3421_FertileSoil: 5434,
  HGSW_3422_Ranchland: 5435,
  HGSW_3423_AlderBranch: 5436,
  HGSW_3424_WovenLinen: 5437,
  HGSW_3425_FeltedGray: 5438,
  HGSW_3426_ArchitecturalGray: 5439,
  HGSW_3431_Otter: 5440,
  HGSW_3432_LessBrown: 5441,
  HGSW_3433_BenevolentBeige: 5442,
  HGSW_3435_TrulyTaupe: 5443,
  HGSW_3436_TemperateTaupe: 5444,
  HGSW_3437_HandspunYarn: 5445,
  HGSW_3441_Foothills: 5446,
  HGSW_3442_CoastlineTan: 5447,
  HGSW_3443_Domaine: 5448,
  HGSW_3445_StoneLion: 5449,
  HGSW_3446_Loggia: 5450,
  HGSW_3451_Sable: 5451,
  HGSW_3452_ResortTan: 5452,
  HGSW_3454_Outerbanks: 5453,
  HGSW_3455_KhakiShade: 5454,
  HGSW_3457_MaisonBlanche: 5455,
  HGSW_3462_Quagmire: 5456,
  HGSW_3464_StackedStone: 5457,
  HGSW_3465_FalseCreekGreige: 5458,
  HGSW_3466_AnewGray: 5459,
  HGSW_3467_AgreeableGray: 5460,
  HGSW_3471_BlackFox: 5461,
  HGSW_3472_Aviatrix: 5462,
  HGSW_3473_Dovetail: 5463,
  HGSW_3475_DorianGray: 5464,
  HGSW_3476_MindfulGray: 5465,
  HGSW_3477_ReposeGray: 5466,
  HGSW_3481_UrbaneBronze: 5467,
  HGSW_3482_Porpoise: 5468,
  HGSW_3483_Anonymous: 5469,
  HGSW_3484_CurlingWillow: 5470,
  HGSW_3485_IntellectualGray: 5471,
  HGSW_3487_WintersweetGrey: 5472,
  HGSW_3492_FundamentalBrown: 5473,
  HGSW_3493_AdaptiveShade: 5474,
  HGSW_3494_WaterburyClay: 5475,
  HGSW_3497_UsefulGray: 5476,
  HGSW_3502_Habitat: 5477,
  HGSW_3505_Intertwined: 5478,
  HGSW_3506_MuslinBolt: 5479,
  HGSW_3507_OysterBar: 5480,
  HGSW_4001_FundamentalWhite: 5481,
  HGSW_4002_WhiteGallery: 5482,
  HGSW_4003_WhiteBatten: 5483,
  HGSW_4004_IconicWhite: 5484,
  HGSW_4005_ExtraWhite: 5485,
  HGSW_4006_PureWhite: 5486,
  HGSW_4007_OrigamiWhite: 5487,
  HGSW_4011_AestheticWhite: 5488,
  HGSW_4012_NaturalChoice: 5489,
  HGSW_4013_WhiteDuck: 5490,
  HGSW_4014_ShojiWhite: 5491,
  HGSW_4017_NeutralWhite: 5492,
  HGSW_4018_CanvasTan: 5493,
  HGSW_4019_NaturalTan: 5494,
  HGSW_4020_DotToDot: 5495,
  HGSW_4023_IncredibleWhite: 5496,
  HGSW_4024_EiderWhite: 5497,
  HGSW_4025_BelgianWhite: 5498,
  HGSW_4026_OxfordWhite: 5499,
  HGSW_4027_WhiteCotton: 5500,
  HGSW_4028_Citilite: 5501,
  HGSW_4030_GreekVilla: 5502,
  HGSW_4031_Alabaster: 5503,
  HGSW_4032_DoverWhite: 5504,
  HGSW_4033_Creamy: 5505,
  HGSW_4034_MilkBloom: 5506,
  HGSW_4035_SaltCrystal: 5507,
  HGSW_4037_Monogramme: 5508,
  HGSW_4038_Vanillin: 5509,
  HGSW_4040_CapeIvory: 5510,
  HGSW_4042_CreamedWhite: 5511,
  HGSW_4043_PureLinen: 5512,
  HGSW_4044_DivineWhite: 5513,
  HGSW_4045_HimalayanSalt: 5514,
  HGSW_4046_NavajoWhite: 5515,
  HGSW_4047_AntiqueWhite: 5516,
  HGSW_4048_Muslin: 5517,
  HGSW_4049_CasualWhite: 5518,
  HGSW_4050_TalcPowder: 5519,
  HGSW_4051_WhiteCore: 5520,
  HGSW_4052_BohemianLace: 5521,
  HGSW_4053_Storyteller: 5522,
  HGSW_4054_MercerWhite: 5523,
  HGSW_4055_TimelessWhite: 5524,
  HGSW_4056_SterlingWhite: 5525,
  HGSW_4057_NebulousWhite: 5526,
  HGSW_4058_IcyBreeze: 5527,
  HGSW_4059_CeleryRoot: 5528,
  HGSW_4060_Nuance: 5529,
  HGSW_4061_RareRadiant: 5530,
  HGSW_4062_Snowbound: 5531,
  HGSW_4063_Marshmallow: 5532,
  HGSW_4067_NiceWhite: 5533,
  HGSW_4069_IbisWhite: 5534,
  HGSW_4071_GorgeousWhite: 5535,
  HGSW_4072_IntricateIvory: 5536,
  HGSW_4073_ChoiceCream: 5537,
  HGSW_4074_SoftlyWhite: 5538,
  HGSW_4075_Downy: 5539,
  HGSW_6001_Grayish: 5540,
  HGSW_6003_ProperGray: 5541,
  HGSW_6004_Mink: 5542,
  HGSW_6005_Folkstone: 5543,
  HGSW_6006_BlackBean: 5544,
  HGSW_6009_Imagine: 5545,
  HGSW_6010_FlexibleGray: 5546,
  HGSW_6011_Chinchilla: 5547,
  HGSW_6012_BrowseBrown: 5548,
  HGSW_6013_BitterChocolate: 5549,
  HGSW_6015_VaguelyMauve: 5550,
  HGSW_6016_ChaiseMauve: 5551,
  HGSW_6017_Intuitive: 5552,
  HGSW_6018_Enigma: 5553,
  HGSW_6019_PoetryPlum: 5554,
  HGSW_6020_Marooned: 5555,
  HGSW_6022_Breathless: 5556,
  HGSW_6023_InsightfulRose: 5557,
  HGSW_6024_DressyRose: 5558,
  HGSW_6025_Socialite: 5559,
  HGSW_6026_RiverRouge: 5560,
  HGSW_6027_Cordovan: 5561,
  HGSW_6029_WhiteTruffle: 5562,
  HGSW_6030_ArtisticTaupe: 5563,
  HGSW_6031_Glamour: 5564,
  HGSW_6033_BateauBrown: 5565,
  HGSW_6034_DarkAuburn: 5566,
  HGSW_6036_Angora: 5567,
  HGSW_6037_TemperateTaupe: 5568,
  HGSW_6038_TrulyTaupe: 5569,
  HGSW_6039_PoisedTaupe: 5570,
  HGSW_6040_Nutshell: 5571,
  HGSW_6041_Otter: 5572,
  HGSW_6043_UnfussyBeige: 5573,
  HGSW_6044_Doeskin: 5574,
  HGSW_6045_EmergingTaupe: 5575,
  HGSW_6047_HotCocoa: 5576,
  HGSW_6048_TerraBrun: 5577,
  HGSW_6049_GorgeousWhite: 5578,
  HGSW_6050_AbaloneShell: 5579,
  HGSW_6051_SashaySand: 5580,
  HGSW_6053_ReddenedEarth: 5581,
  HGSW_6055_FieryBrown: 5582,
  HGSW_6057_MaltedMilk: 5583,
  HGSW_6058_LikeableSand: 5584,
  HGSW_6059_InterfaceTan: 5585,
  HGSW_6061_Tanbark: 5586,
  HGSW_6062_VintageLeather: 5587,
  HGSW_6063_NiceWhite: 5588,
  HGSW_6065_BonaFideBeige: 5589,
  HGSW_6066_SandTrap: 5590,
  HGSW_6067_Mocha: 5591,
  HGSW_6068_BrevityBrown: 5592,
  HGSW_6069_FrenchRoast: 5593,
  HGSW_6071_PopularGray: 5594,
  HGSW_6072_VersatileGray: 5595,
  HGSW_6073_PerfectGreige: 5596,
  HGSW_6075_GarretGray: 5597,
  HGSW_6076_TurkishCoffee: 5598,
  HGSW_6078_RealistBeige: 5599,
  HGSW_6079_DiverseBeige: 5600,
  HGSW_6080_UtterlyBeige: 5601,
  HGSW_6081_DownHome: 5602,
  HGSW_6082_CobbleBrown: 5603,
  HGSW_6083_Sable: 5604,
  HGSW_6085_SimplifyBeige: 5605,
  HGSW_6087_TrustyTan: 5606,
  HGSW_6088_Nuthatch: 5607,
  HGSW_6089_Grounded: 5608,
  HGSW_6090_Java: 5609,
  HGSW_6092_LightweightBeige: 5610,
  HGSW_6093_FamiliarBeige: 5611,
  HGSW_6094_SensationalSand: 5612,
  HGSW_6096_JuteBrown: 5613,
  HGSW_6097_SturdyBrown: 5614,
  HGSW_6099_SandDollar: 5615,
  HGSW_6100_PracticalBeige: 5616,
  HGSW_6101_SandsOfTime: 5617,
  HGSW_6102_Portabello: 5618,
  HGSW_6104_Kaffee: 5619,
  HGSW_6105_DivineWhite: 5620,
  HGSW_6106_KilimBeige: 5621,
  HGSW_6107_NomadicDesert: 5622,
  HGSW_6108_Latte: 5623,
  HGSW_6109_Hopsack: 5624,
  HGSW_6111_CoconutHusk: 5625,
  HGSW_6113_InteractiveCream: 5626,
  HGSW_6115_TotallyTan: 5627,
  HGSW_6116_TatamiTan: 5628,
  HGSW_6117_SmokeyTopaz: 5629,
  HGSW_6119_AntiqueWhite: 5630,
  HGSW_6120_BelievableBuff: 5631,
  HGSW_6121_WholeWheat: 5632,
  HGSW_6122_Camelback: 5633,
  HGSW_6123_Baguette: 5634,
  HGSW_6124_Cardboard: 5635,
  HGSW_6126_NavajoWhite: 5636,
  HGSW_6127_Ivoire: 5637,
  HGSW_6128_Blonde: 5638,
  HGSW_6129_RestrainedGold: 5639,
  HGSW_6130_ManneredGold: 5640,
  HGSW_6131_Chamois: 5641,
  HGSW_6132_RelicBronze: 5642,
  HGSW_6133_Muslin: 5643,
  HGSW_6134_Netsuke: 5644,
  HGSW_6135_Ecru: 5645,
  HGSW_6136_HarmonicTan: 5646,
  HGSW_6137_Burlap: 5647,
  HGSW_6138_Artifact: 5648,
  HGSW_6140_ModerateWhite: 5649,
  HGSW_6141_SofterTan: 5650,
  HGSW_6142_Macadamia: 5651,
  HGSW_6144_DapperTan: 5652,
  HGSW_6145_ThatchBrown: 5653,
  HGSW_6146_Umber: 5654,
  HGSW_6148_WoolSkein: 5655,
  HGSW_6149_RelaxedKhaki: 5656,
  HGSW_6150_UniversalKhaki: 5657,
  HGSW_6151_QuiverTan: 5658,
  HGSW_6152_SuperiorBronze: 5659,
  HGSW_6154_Nacre: 5660,
  HGSW_6156_Ramie: 5661,
  HGSW_6157_FavoriteTan: 5662,
  HGSW_6158_Sawdust: 5663,
  HGSW_6159_HighTea: 5664,
  HGSW_6160_BestBronze: 5665,
  HGSW_6162_AncientMarble: 5666,
  HGSW_6164_SvelteSage: 5667,
  HGSW_6165_ConnectedGray: 5668,
  HGSW_6167_GardenGate: 5669,
  HGSW_6169_SedateGray: 5670,
  HGSW_6170_TechnoGray: 5671,
  HGSW_6171_Chatroom: 5672,
  HGSW_6173_Cocoon: 5673,
  HGSW_6176_LiveableGreen: 5674,
  HGSW_6177_SoftenedGreen: 5675,
  HGSW_6178_ClarySage: 5676,
  HGSW_6179_Artichoke: 5677,
  HGSW_6180_Oakmoss: 5678,
  HGSW_6181_SecretGarden: 5679,
  HGSW_6182_EtherealWhite: 5680,
  HGSW_6183_ConservativeGray: 5681,
  HGSW_6184_AustereGray: 5682,
  HGSW_6185_EscapeGray: 5683,
  HGSW_6186_DriedThyme: 5684,
  HGSW_6188_Shadegrown: 5685,
  HGSW_6190_FilmyGreen: 5686,
  HGSW_6191_Contented: 5687,
  HGSW_6192_CoastalPlain: 5688,
  HGSW_6193_PrivilegeGreen: 5689,
  HGSW_6194_Basil: 5690,
  HGSW_6195_RockGarden: 5691,
  HGSW_6197_AloofGray: 5692,
  HGSW_6198_SensibleHue: 5693,
  HGSW_6199_RareGray: 5694,
  HGSW_6200_LinkGray: 5695,
  HGSW_6202_CastIron: 5696,
  HGSW_6204_SeaSalt: 5697,
  HGSW_6205_ComfortGray: 5698,
  HGSW_6207_Retreat: 5699,
  HGSW_6208_PewterGreen: 5700,
  HGSW_6212_Quietude: 5701,
  HGSW_6213_HalcyonGreen: 5702,
  HGSW_6214_Underseas: 5703,
  HGSW_6215_RockyRiver: 5704,
  HGSW_6216_Jasper: 5705,
  HGSW_6218_Tradewind: 5706,
  HGSW_6219_Rain: 5707,
  HGSW_6220_InterestingAqua: 5708,
  HGSW_6221_MoodyBlue: 5709,
  HGSW_6222_Riverway: 5710,
  HGSW_6223_StillWater: 5711,
  HGSW_6224_MountainAir: 5712,
  HGSW_6225_SleepyBlue: 5713,
  HGSW_6226_LanguidBlue: 5714,
  HGSW_6227_Meditative: 5715,
  HGSW_6228_Refuge: 5716,
  HGSW_6230_Rainstorm: 5717,
  HGSW_6232_Misty: 5718,
  HGSW_6233_SamovarSilver: 5719,
  HGSW_6234_UncertainGray: 5720,
  HGSW_6236_GraysHarbor: 5721,
  HGSW_6237_DarkNight: 5722,
  HGSW_6238_Icicle: 5723,
  HGSW_6239_Upward: 5724,
  HGSW_6240_WindyBlue: 5725,
  HGSW_6241_Aleutian: 5726,
  HGSW_6242_BracingBlue: 5727,
  HGSW_6243_Distance: 5728,
  HGSW_6244_Naval: 5729,
  HGSW_6246_NorthStar: 5730,
  HGSW_6247_Krypton: 5731,
  HGSW_6248_Jubilee: 5732,
  HGSW_6249_StormCloud: 5733,
  HGSW_6250_GranitePeak: 5734,
  HGSW_6252_IceCube: 5735,
  HGSW_6253_OlympusWhite: 5736,
  HGSW_6254_LazyGray: 5737,
  HGSW_6255_MorningFog: 5738,
  HGSW_6256_SeriousGray: 5739,
  HGSW_6258_TricornBlack: 5740,
  HGSW_6260_UniqueGray: 5741,
  HGSW_6261_SwankyGray: 5742,
  HGSW_6262_MysteriousMauve: 5743,
  HGSW_6263_ExclusivePlum: 5744,
  HGSW_6264_Midnight: 5745,
  HGSW_6265_QuixoticPlum: 5746,
  HGSW_6267_SensitiveTint: 5747,
  HGSW_6268_VeiledViolet: 5748,
  HGSW_6269_BeguilingMauve: 5749,
  HGSW_6271_ExpressivePlum: 5750,
  HGSW_6272_PlumBrown: 5751,
  HGSW_6274_Destiny: 5752,
  HGSW_6275_FashionableGray: 5753,
  HGSW_6277_SpecialGray: 5754,
  HGSW_6278_CloakGray: 5755,
  HGSW_6281_Wallflower: 5756,
  HGSW_6282_MauveFinery: 5757,
  HGSW_6283_Thistle: 5758,
  HGSW_6284_PlumDandy: 5759,
  HGSW_6285_GrapeHarvest: 5760,
  HGSW_6286_MatureGrape: 5761,
  HGSW_6295_Demure: 5762,
  HGSW_6296_FadingRose: 5763,
  HGSW_6297_RoseEmbroidery: 5764,
  HGSW_6298_Concerto: 5765,
  HGSW_6302_Innocence: 5766,
  HGSW_6303_RoseColored: 5767,
  HGSW_6304_PressedFlower: 5768,
  HGSW_6305_RamblingRose: 5769,
  HGSW_6306_Cordial: 5770,
  HGSW_6309_CharmingPink: 5771,
  HGSW_6310_LotusFlower: 5772,
  HGSW_6311_MemorableRose: 5773,
  HGSW_6312_Redbud: 5774,
  HGSW_6313_KirschRed: 5775,
  HGSW_6316_RosyOutlook: 5776,
  HGSW_6318_ResoundingRose: 5777,
  HGSW_6319_Reddish: 5778,
  HGSW_6321_RedBay: 5779,
  HGSW_6323_Romance: 5780,
  HGSW_6324_MellowCoral: 5781,
  HGSW_6325_ConstantCoral: 5782,
  HGSW_6327_BoldBrick: 5783,
  HGSW_6328_Fireweed: 5784,
  HGSW_6330_QuaintPeche: 5785,
  HGSW_6331_SmokySalmon: 5786,
  HGSW_6332_CoralIsland: 5787,
  HGSW_6333_Foxy: 5788,
  HGSW_6335_FiredBrick: 5789,
  HGSW_6337_SpunSugar: 5790,
  HGSW_6338_WarmingPeach: 5791,
  HGSW_6339_Persimmon: 5792,
  HGSW_6340_BakedClay: 5793,
  HGSW_6342_SpicyHue: 5794,
  HGSW_6344_PeachFuzz: 5795,
  HGSW_6345_SumptuousPeach: 5796,
  HGSW_6346_FameOrange: 5797,
  HGSW_6347_Chrysanthemum: 5798,
  HGSW_6348_Reynard: 5799,
  HGSW_6349_Pennywise: 5800,
  HGSW_6350_IntricateIvory: 5801,
  HGSW_6351_SweetOrange: 5802,
  HGSW_6352_SoftApricot: 5803,
  HGSW_6353_ChivalryCopper: 5804,
  HGSW_6354_Armagnac: 5805,
  HGSW_6356_CopperMountain: 5806,
  HGSW_6357_ChoiceCream: 5807,
  HGSW_6358_Creamery: 5808,
  HGSW_6359_Sociable: 5809,
  HGSW_6360_FolksyGold: 5810,
  HGSW_6361_Autumnal: 5811,
  HGSW_6365_CachetCream: 5812,
  HGSW_6366_AmbitiousAmber: 5813,
  HGSW_6371_Vanillin: 5814,
  HGSW_6372_InvitingIvory: 5815,
  HGSW_6373_Harvester: 5816,
  HGSW_6375_Honeycomb: 5817,
  HGSW_6376_GoldCoast: 5818,
  HGSW_6377_Butterscotch: 5819,
  HGSW_6380_HumbleGold: 5820,
  HGSW_6381_AnjouPear: 5821,
  HGSW_6382_CeremonialGold: 5822,
  HGSW_6383_GoldenRule: 5823,
  HGSW_6384_CutTheMustard: 5824,
  HGSW_6385_DoverWhite: 5825,
  HGSW_6386_Napery: 5826,
  HGSW_6390_BoscPear: 5827,
  HGSW_6391_GallantGold: 5828,
  HGSW_6393_ConvivialYellow: 5829,
  HGSW_6394_Sequin: 5830,
  HGSW_6395_Alchemy: 5831,
  HGSW_6397_Nankeen: 5832,
  HGSW_6398_SconceGold: 5833,
  HGSW_6400_LucentYellow: 5834,
  HGSW_6401_IndependentGold: 5835,
  HGSW_6402_Antiquity: 5836,
  HGSW_6403_EscapadeGold: 5837,
  HGSW_6404_Grandiose: 5838,
  HGSW_6407_AncestralGold: 5839,
  HGSW_6408_WheatGrass: 5840,
  HGSW_6409_EdgyGold: 5841,
  HGSW_6410_Brassy: 5842,
  HGSW_6412_EminentBronze: 5843,
  HGSW_6414_RicePaddy: 5844,
  HGSW_6415_HeartsOfPalm: 5845,
  HGSW_6417_TupeloTree: 5846,
  HGSW_6418_RuralGreen: 5847,
  HGSW_6419_Saguaro: 5848,
  HGSW_6421_Celery: 5849,
  HGSW_6422_Shagreen: 5850,
  HGSW_6423_Ryegrass: 5851,
  HGSW_6424_TansyGreen: 5852,
  HGSW_6425_RelentlessOlive: 5853,
  HGSW_6428_Honeydew: 5854,
  HGSW_6431_Leapfrog: 5855,
  HGSW_6432_GardenSpot: 5856,
  HGSW_6433_Inverness: 5857,
  HGSW_6435_GratifyingGreen: 5858,
  HGSW_6436_BonsaiTint: 5859,
  HGSW_6437_Haven: 5860,
  HGSW_6439_Greenfield: 5861,
  HGSW_6440_Courtyard: 5862,
  HGSW_6442_SupremeGreen: 5863,
  HGSW_6443_Relish: 5864,
  HGSW_6444_LoungeGreen: 5865,
  HGSW_6445_GardenGrove: 5866,
  HGSW_6446_Arugula: 5867,
  HGSW_6449_TopiaryTint: 5868,
  HGSW_6450_EasyGreen: 5869,
  HGSW_6451_NurtureGreen: 5870,
  HGSW_6452_Inland: 5871,
  HGSW_6453_Cilantro: 5872,
  HGSW_6454_Shamrock: 5873,
  HGSW_6456_SlowGreen: 5874,
  HGSW_6457_KindGreen: 5875,
  HGSW_6458_Restful: 5876,
  HGSW_6459_Jadite: 5877,
  HGSW_6461_IsleOfPines: 5878,
  HGSW_6463_Breaktime: 5879,
  HGSW_6464_Aloe: 5880,
  HGSW_6465_Spearmint: 5881,
  HGSW_6467_KendalGreen: 5882,
  HGSW_6468_HuntClub: 5883,
  HGSW_6470_Waterscape: 5884,
  HGSW_6471_Hazel: 5885,
  HGSW_6472_Composed: 5886,
  HGSW_6474_RagingSea: 5887,
  HGSW_6475_CountrySquire: 5888,
  HGSW_6477_Tidewater: 5889,
  HGSW_6478_Watery: 5890,
  HGSW_6479_Drizzle: 5891,
  HGSW_6480_Lagoon: 5892,
  HGSW_6481_GreenBay: 5893,
  HGSW_6482_CapeVerde: 5894,
  HGSW_6484_MeanderBlue: 5895,
  HGSW_6486_ReflectingPool: 5896,
  HGSW_6487_Cloudburst: 5897,
  HGSW_6488_GrandCanal: 5898,
  HGSW_6489_ReallyTeal: 5899,
  HGSW_6491_OpenAir: 5900,
  HGSW_6492_Jetstream: 5901,
  HGSW_6493_Ebbtide: 5902,
  HGSW_6494_Lakeshore: 5903,
  HGSW_6495_GreatFalls: 5904,
  HGSW_6496_Oceanside: 5905,
  HGSW_6498_ByteBlue: 5906,
  HGSW_6500_OpenSeas: 5907,
  HGSW_6501_ManitouBlue: 5908,
  HGSW_6502_LochBlue: 5909,
  HGSW_6503_Bosporus: 5910,
  HGSW_6505_Atmospheric: 5911,
  HGSW_6506_VastSky: 5912,
  HGSW_6507_ResoluteBlue: 5913,
  HGSW_6508_SecureBlue: 5914,
  HGSW_6509_GeorgianBay: 5915,
  HGSW_6510_LoyalBlue: 5916,
  HGSW_6513_TakeFive: 5917,
  HGSW_6514_Respite: 5918,
  HGSW_6515_LeisureBlue: 5919,
  HGSW_6516_DownPour: 5920,
  HGSW_6517_Regatta: 5921,
  HGSW_6519_HintingBlue: 5922,
  HGSW_6520_HonestBlue: 5923,
  HGSW_6521_NotableHue: 5924,
  HGSW_6522_SportyBlue: 5925,
  HGSW_6523_Denim: 5926,
  HGSW_6526_Icelandic: 5927,
  HGSW_6527_BlissfulBlue: 5928,
  HGSW_6528_Cosmos: 5929,
  HGSW_6529_Scanda: 5930,
  HGSW_6530_RevelBlue: 5931,
  HGSW_6533_MildBlue: 5932,
  HGSW_6535_Solitude: 5933,
  HGSW_6536_SearchingBlue: 5934,
  HGSW_6538_Dignified: 5935,
  HGSW_6540_StarryNight: 5936,
  HGSW_6541_Daydream: 5937,
  HGSW_6542_VesperViolet: 5938,
  HGSW_6543_SoulfulBlue: 5939,
  HGSW_6544_Mesmerize: 5940,
  HGSW_6545_MajesticPurple: 5941,
  HGSW_6547_SilverPeony: 5942,
  HGSW_6548_GrapeMist: 5943,
  HGSW_6549_AshViolet: 5944,
  HGSW_6550_Mythical: 5945,
  HGSW_6551_PurplePassage: 5946,
  HGSW_6552_Dewberry: 5947,
  HGSW_6554_LiteLavender: 5948,
  HGSW_6555_Enchant: 5949,
  HGSW_6556_ObiLilac: 5950,
  HGSW_6557_WoodViolet: 5951,
  HGSW_6561_Teaberry: 5952,
  HGSW_6562_Irresistible: 5953,
  HGSW_6563_Rosebay: 5954,
  HGSW_6564_RedClover: 5955,
  HGSW_6565_GrandeurPlum: 5956,
  HGSW_6566_Framboise: 5957,
  HGSW_6570_HautePink: 5958,
  HGSW_6571_Cyclamen: 5959,
  HGSW_6572_RubyShade: 5960,
  HGSW_6573_Juneberry: 5961,
  HGSW_6575_Priscilla: 5962,
  HGSW_6576_AzaleaFlower: 5963,
  HGSW_6577_JaipurPink: 5964,
  HGSW_6578_Tuberose: 5965,
  HGSW_6579_GalaPink: 5966,
  HGSW_6580_Cerise: 5967,
  HGSW_6582_ImpatiensPetal: 5968,
  HGSW_6583_InThePink: 5969,
  HGSW_6589_Alyssum: 5970,
  HGSW_6590_Loveable: 5971,
  HGSW_6591_Amaryllis: 5972,
  HGSW_6592_Grenadine: 5973,
  HGSW_6593_CoralBells: 5974,
  HGSW_6596_BellaPink: 5975,
  HGSW_6597_Hopeful: 5976,
  HGSW_6598_DishyCoral: 5977,
  HGSW_6599_Begonia: 5978,
  HGSW_6601_Tanager: 5979,
  HGSW_6603_Oleander: 5980,
  HGSW_6604_YouthfulCoral: 5981,
  HGSW_6605_Charisma: 5982,
  HGSW_6606_CoralReef: 5983,
  HGSW_6608_RaveRed: 5984,
  HGSW_6610_KoralKicks: 5985,
  HGSW_6611_Jovial: 5986,
  HGSW_6612_RavishingCoral: 5987,
  HGSW_6613_LeiFlower: 5988,
  HGSW_6615_Peppery: 5989,
  HGSW_6617_Blushing: 5990,
  HGSW_6618_CosmeticPeach: 5991,
  HGSW_6619_Sockeye: 5992,
  HGSW_6620_Rejuvenate: 5993,
  HGSW_6621_Emotional: 5994,
  HGSW_6622_HeartyOrange: 5995,
  HGSW_6626_Sunset: 5996,
  HGSW_6627_Emberglow: 5997,
  HGSW_6628_RobustOrange: 5998,
  HGSW_6631_NaivePeach: 5999,
  HGSW_6632_NeighborlyPeach: 6000,
  HGSW_6638_FlatteringPeach: 6001,
  HGSW_6639_AvidApricot: 6002,
  HGSW_6641_OutgoingOrange: 6003,
  HGSW_6642_RhumbaOrange: 6004,
  HGSW_6643_Yam: 6005,
  HGSW_6652_Flan: 6006,
  HGSW_6653_DeliciousMelon: 6007,
  HGSW_6654_SurpriseAmber: 6008,
  HGSW_6655_AdventureOrange: 6009,
  HGSW_6666_EnjoyableYellow: 6010,
  HGSW_6668_Sunrise: 6011,
  HGSW_6669_Yarrow: 6012,
  HGSW_6670_GoldCrest: 6013,
  HGSW_6673_BananaCream: 6014,
  HGSW_6675_Afternoon: 6015,
  HGSW_6676_Butterfield: 6016,
  HGSW_6677_Goldenrod: 6017,
  HGSW_6678_Sunflower: 6018,
  HGSW_6680_FriendlyYellow: 6019,
  HGSW_6681_ButterUp: 6020,
  HGSW_6686_LemonChiffon: 6021,
  HGSW_6688_Solaria: 6022,
  HGSW_6689_Overjoy: 6023,
  HGSW_6691_GlitzyGold: 6024,
  HGSW_6692_Auric: 6025,
  HGSW_6693_Lily: 6026,
  HGSW_6694_GladYellow: 6027,
  HGSW_6695_Midday: 6028,
  HGSW_6696_QuiltGold: 6029,
  HGSW_6697_Nugget: 6030,
  HGSW_6698_KingdomGold: 6031,
  HGSW_6699_CrispyGold: 6032,
  HGSW_6701_Moonraker: 6033,
  HGSW_6702_LivelyYellow: 6034,
  HGSW_6703_Frolic: 6035,
  HGSW_6704_HepGreen: 6036,
  HGSW_6705_HighStrung: 6037,
  HGSW_6706_OffbeatGreen: 6038,
  HGSW_6708_Springtime: 6039,
  HGSW_6709_Gleeful: 6040,
  HGSW_6710_MelangeGreen: 6041,
  HGSW_6711_Parakeet: 6042,
  HGSW_6713_Verdant: 6043,
  HGSW_6730_Romaine: 6044,
  HGSW_6731_Picnic: 6045,
  HGSW_6732_OrganicGreen: 6046,
  HGSW_6733_Grasshopper: 6047,
  HGSW_6734_Espalier: 6048,
  HGSW_6736_JocularGreen: 6049,
  HGSW_6737_Kiwi: 6050,
  HGSW_6738_Vegan: 6051,
  HGSW_6739_EcoGreen: 6052,
  HGSW_6741_Derbyshire: 6053,
  HGSW_6743_MintCondition: 6054,
  HGSW_6744_RecliningGreen: 6055,
  HGSW_6745_LarkGreen: 6056,
  HGSW_6746_Julep: 6057,
  HGSW_6748_Greens: 6058,
  HGSW_6750_Waterfall: 6059,
  HGSW_6751_Refresh: 6060,
  HGSW_6752_Larchmere: 6061,
  HGSW_6753_JargonJade: 6062,
  HGSW_6754_Ionian: 6063,
  HGSW_6757_TameTeal: 6064,
  HGSW_6758_Aqueduct: 6065,
  HGSW_6759_CooledBlue: 6066,
  HGSW_6761_ThermalSpring: 6067,
  HGSW_6764_Swimming: 6068,
  HGSW_6765_Spa: 6069,
  HGSW_6766_Mariner: 6070,
  HGSW_6767_Aquarium: 6071,
  HGSW_6768_Gulfstream: 6072,
  HGSW_6769_MaxiTeal: 6073,
  HGSW_6772_Cay: 6074,
  HGSW_6773_RaptureBlue: 6075,
  HGSW_6774_Freshwater: 6076,
  HGSW_6775_Briny: 6077,
  HGSW_6776_BlueNile: 6078,
  HGSW_6778_AviaryBlue: 6079,
  HGSW_6779_LiquidBlue: 6080,
  HGSW_6780_Nautilus: 6081,
  HGSW_6781_JamaicaBay: 6082,
  HGSW_6783_Amalfi: 6083,
  HGSW_6785_QuenchBlue: 6084,
  HGSW_6786_Cloudless: 6085,
  HGSW_6787_Fountain: 6086,
  HGSW_6788_Capri: 6087,
  HGSW_6789_BlueMosque: 6088,
  HGSW_6790_AdriaticSea: 6089,
  HGSW_6792_MinorBlue: 6090,
  HGSW_6793_Bluebell: 6091,
  HGSW_6794_Flyway: 6092,
  HGSW_6795_MajorBlue: 6093,
  HGSW_6796_BluePlate: 6094,
  HGSW_6797_JayBlue: 6095,
  HGSW_6799_Soar: 6096,
  HGSW_6800_SomethingBlue: 6097,
  HGSW_6801_RegaleBlue: 6098,
  HGSW_6802_Jacaranda: 6099,
  HGSW_6803_Danube: 6100,
  HGSW_6806_RhythmicBlue: 6101,
  HGSW_6807_WondrousBlue: 6102,
  HGSW_6808_Celestial: 6103,
  HGSW_6809_Lobelia: 6104,
  HGSW_6810_Lupine: 6105,
  HGSW_6811_HonorableBlue: 6106,
  HGSW_6813_WishfulBlue: 6107,
  HGSW_6815_AwesomeViolet: 6108,
  HGSW_6816_Dahlia: 6109,
  HGSW_6817_Gentian: 6110,
  HGSW_6818_ValiantViolet: 6111,
  HGSW_6820_InspiredLilac: 6112,
  HGSW_6821_PotentiallyPurple: 6113,
  HGSW_6822_Wisteria: 6114,
  HGSW_6823_BravePurple: 6115,
  HGSW_6824_Forgetmenot: 6116,
  HGSW_6825_IzmirPurple: 6117,
  HGSW_6827_Elation: 6118,
  HGSW_6828_RhapsodyLilac: 6119,
  HGSW_6829_Magical: 6120,
  HGSW_6830_Kismet: 6121,
  HGSW_6831_Clematis: 6122,
  HGSW_6832_ImpulsivePurple: 6123,
  HGSW_6834_Spangle: 6124,
  HGSW_6835_EuphoricLilac: 6125,
  HGSW_6836_NovelLilac: 6126,
  HGSW_6837_Baroness: 6127,
  HGSW_6838_VigorousViolet: 6128,
  HGSW_6839_KimonoViolet: 6129,
  HGSW_6883_RaucousOrange: 6130,
  HGSW_6900_OptimisticYellow: 6131,
  HGSW_6901_Daffodil: 6132,
  HGSW_6903_Cheerful: 6133,
  HGSW_6908_FunYellow: 6134,
  HGSW_6910_Daisy: 6135,
  HGSW_6911_ConfidentYellow: 6136,
  HGSW_6913_FunkyYellow: 6137,
  HGSW_6914_EyeCatching: 6138,
  HGSW_6915_Citronella: 6139,
  HGSW_6988_BohemianBlack: 6140,
  HGSW_6990_Caviar: 6141,
  HGSW_7000_IbisWhite: 6142,
  HGSW_7001_Marshmallow: 6143,
  HGSW_7002_Downy: 6144,
  HGSW_7003_ToqueWhite: 6145,
  HGSW_7004_Snowbound: 6146,
  HGSW_7005_PureWhite: 6147,
  HGSW_7006_ExtraWhite: 6148,
  HGSW_7007_CeilingBrightWhite: 6149,
  HGSW_7008_Alabaster: 6150,
  HGSW_7009_PearlyWhite: 6151,
  HGSW_7010_WhiteDuck: 6152,
  HGSW_7011_NaturalChoice: 6153,
  HGSW_7012_Creamy: 6154,
  HGSW_7014_EiderWhite: 6155,
  HGSW_7015_ReposeGray: 6156,
  HGSW_7016_MindfulGray: 6157,
  HGSW_7017_DorianGray: 6158,
  HGSW_7018_Dovetail: 6159,
  HGSW_7019_GauntletGray: 6160,
  HGSW_7020_BlackFox: 6161,
  HGSW_7022_Alpaca: 6162,
  HGSW_7023_RequisiteGray: 6163,
  HGSW_7024_FunctionalGray: 6164,
  HGSW_7025_Backdrop: 6165,
  HGSW_7026_Griffin: 6166,
  HGSW_7027_HickorySmoke: 6167,
  HGSW_7028_IncredibleWhite: 6168,
  HGSW_7029_AgreeableGray: 6169,
  HGSW_7030_AnewGray: 6170,
  HGSW_7031_MegaGreige: 6171,
  HGSW_7033_BrainstormBronze: 6172,
  HGSW_7035_AestheticWhite: 6173,
  HGSW_7036_AccessibleBeige: 6174,
  HGSW_7037_BalancedBeige: 6175,
  HGSW_7038_TonyTaupe: 6176,
  HGSW_7039_VirtualTaupe: 6177,
  HGSW_7040_Smokehouse: 6178,
  HGSW_7041_VanDykeBrown: 6179,
  HGSW_7042_ShojiWhite: 6180,
  HGSW_7043_WorldlyGray: 6181,
  HGSW_7045_IntellectualGray: 6182,
  HGSW_7046_Anonymous: 6183,
  HGSW_7047_Porpoise: 6184,
  HGSW_7048_UrbaneBronze: 6185,
  HGSW_7049_Nuance: 6186,
  HGSW_7050_UsefulGray: 6187,
  HGSW_7053_AdaptiveShade: 6188,
  HGSW_7054_OakLeafBrown: 6189,
  HGSW_7057_SilverStrand: 6190,
  HGSW_7058_MagneticGray: 6191,
  HGSW_7059_UnusualGray: 6192,
  HGSW_7060_AttitudeGray: 6193,
  HGSW_7061_NightOwl: 6194,
  HGSW_7062_RockBottom: 6195,
  HGSW_7063_NebulousWhite: 6196,
  HGSW_7064_Passive: 6197,
  HGSW_7065_Argos: 6198,
  HGSW_7066_GrayMatters: 6199,
  HGSW_7067_Cityscape: 6200,
  HGSW_7068_GrizzleGray: 6201,
  HGSW_7069_IronOre: 6202,
  HGSW_7071_GrayScreen: 6203,
  HGSW_7072_Online: 6204,
  HGSW_7073_NetworkGray: 6205,
  HGSW_7074_Software: 6206,
  HGSW_7075_WebGray: 6207,
  HGSW_7076_Cyberspace: 6208,
  HGSW_7080_QuestGray: 6209,
  HGSW_7081_SensuousGray: 6210,
  HGSW_7082_StunningShade: 6211,
  HGSW_7083_Darkroom: 6212,
  HGSW_7102_WhiteFlour: 6213,
  HGSW_7104_CottonWhite: 6214,
  HGSW_7504_KeystoneGray: 6215,
  HGSW_7505_ManorHouse: 6216,
  HGSW_7506_Loggia: 6217,
  HGSW_7507_StoneLion: 6218,
  HGSW_7508_TavernTaupe: 6219,
  HGSW_7509_TikiHut: 6220,
  HGSW_7511_BungalowBeige: 6221,
  HGSW_7512_PavilionBeige: 6222,
  HGSW_7513_Sanderling: 6223,
  HGSW_7514_Foothills: 6224,
  HGSW_7515_HomesteadBrown: 6225,
  HGSW_7517_RiversEdge: 6226,
  HGSW_7526_MaisonBlanche: 6227,
  HGSW_7529_SandBeach: 6228,
  HGSW_7531_CanvasTan: 6229,
  HGSW_7533_KhakiShade: 6230,
  HGSW_7534_Outerbanks: 6231,
  HGSW_7542_Naturel: 6232,
  HGSW_7543_AvenueTan: 6233,
  HGSW_7544_Fenland: 6234,
  HGSW_7545_Pier: 6235,
  HGSW_7550_ResortTan: 6236,
  HGSW_7551_GreekVilla: 6237,
  HGSW_7555_Patience: 6238,
  HGSW_7556_Creme: 6239,
  HGSW_7558_MediciIvory: 6240,
  HGSW_7559_DecorWhite: 6241,
  HGSW_7562_RomanColumn: 6242,
  HGSW_7564_PolarBear: 6243,
  HGSW_7565_OysterBar: 6244,
  HGSW_7566_WesthighlandWhite: 6245,
  HGSW_7567_NaturalTan: 6246,
  HGSW_7568_NeutralGround: 6247,
  HGSW_7569_Stucco: 6248,
  HGSW_7570_EgretWhite: 6249,
  HGSW_7571_CasaBlanca: 6250,
  HGSW_7572_LotusPod: 6251,
  HGSW_7578_Borscht: 6252,
  HGSW_7586_StolenKiss: 6253,
  HGSW_7588_ShowStopper: 6254,
  HGSW_7589_HabaneroChile: 6255,
  HGSW_7591_RedBarn: 6256,
  HGSW_7600_Bolero: 6257,
  HGSW_7602_IndigoBatik: 6258,
  HGSW_7621_Silvermist: 6259,
  HGSW_7624_SlateTile: 6260,
  HGSW_7636_OrigamiWhite: 6261,
  HGSW_7638_JoggingPath: 6262,
  HGSW_7639_EtherealMood: 6263,
  HGSW_7641_CollonadeGray: 6264,
  HGSW_7643_Pussywillow: 6265,
  HGSW_7646_FirstStar: 6266,
  HGSW_7652_MineralDeposit: 6267,
  HGSW_7657_Tinsmith: 6268,
  HGSW_7659_Gris: 6269,
  HGSW_7660_EarlGrey: 6270,
  HGSW_7661_Reflection: 6271,
  HGSW_7663_MonorailSilver: 6272,
  HGSW_7664_SteelyGray: 6273,
  HGSW_7665_WallStreet: 6274,
  HGSW_7674_Peppercorn: 6275,
  HGSW_7675_Sealskin: 6276,
  HGSW_7688_Sundew: 6277,
  HGSW_7693_Stonebriar: 6278,
  HGSW_7694_DromedaryCamel: 6279,
  HGSW_7701_CavernClay: 6280,
  HGSW_7702_SpicedCider: 6281,
  HGSW_7709_CopperPot: 6282,
  HGSW_7719_FrescoCream: 6283,
  HGSW_7727_KoiPond: 6284,
  HGSW_7734_OliveGrove: 6285,
  HGSW_7740_MessengerBag: 6286,
  HGSW_7745_MuddledBasil: 6287,
  HGSW_7747_RecycledGlass: 6288,
  HGSW_7757_HighReflectiveWhite: 6289,
  HGSW_9001_AudreysBlush: 6290,
  HGSW_9002_CarleysRose: 6291,
  HGSW_9003_RitasRouge: 6292,
  HGSW_9004_CoralRose: 6293,
  HGSW_9005_CoralClay: 6294,
  HGSW_9006_RojoDust: 6295,
  HGSW_9007_MelosoMelon: 6296,
  HGSW_9010_WindsweptCanyon: 6297,
  HGSW_9011_SunBleachedOchre: 6298,
  HGSW_9012_PolvoDeOro: 6299,
  HGSW_9013_OldenAmber: 6300,
  HGSW_9014_PollenPowder: 6301,
  HGSW_9017_SunnyVeranda: 6302,
  HGSW_9018_HoneyBees: 6303,
  HGSW_9019_GoldenPlumeria: 6304,
  HGSW_9020_RayoDeSol: 6305,
  HGSW_9024_VintageGold: 6306,
  HGSW_9025_CorianderPowder: 6307,
  HGSW_9026_TarnishedTrumpet: 6308,
  HGSW_9027_PaleMoss: 6309,
  HGSW_9028_DustedOlive: 6310,
  HGSW_9029_CoolAvocado: 6311,
  HGSW_9031_Primavera: 6312,
  HGSW_9033_OhPistachio: 6313,
  HGSW_9035_FrostedEmerald: 6314,
  HGSW_9036_RetroMint: 6315,
  HGSW_9037_BabyBokChoy: 6316,
  HGSW_9038_CucuzzaVerde: 6317,
  HGSW_9039_Broccoflower: 6318,
  HGSW_9040_ResedaGreen: 6319,
  HGSW_9041_ParisianPatina: 6320,
  HGSW_9043_Aquastone: 6321,
  HGSW_9044_LittleBlueBox: 6322,
  HGSW_9045_BoraBoraShore: 6323,
  HGSW_9046_GentleAquamarine: 6324,
  HGSW_9047_AfterTheRain: 6325,
  HGSW_9049_SkyFall: 6326,
  HGSW_9050_VintageVessel: 6327,
  HGSW_9051_Aquaverde: 6328,
  HGSW_9054_LittleBoyBlu: 6329,
  HGSW_9056_FrenchMoire: 6330,
  HGSW_9057_Aquitaine: 6331,
  HGSW_9058_SecretCove: 6332,
  HGSW_9059_SilkenPeacock: 6333,
  HGSW_9060_ConnorsLakefront: 6334,
  HGSW_9061_RestAssured: 6335,
  HGSW_9066_Agapanthus: 6336,
  HGSW_9072_DriedLavender: 6337,
  HGSW_9075_BerryCream: 6338,
  HGSW_9078_CocoaBerry: 6339,
  HGSW_9079_VelvetyChestnut: 6340,
  HGSW_9080_HushedAuburn: 6341,
  HGSW_9081_RedendPoint: 6342,
  HGSW_9082_ChocolatePowder: 6343,
  HGSW_9083_DustedTruffle: 6344,
  HGSW_9084_CocoaWhip: 6345,
  HGSW_9085_TouchOfSand: 6346,
  HGSW_9086_CoolBeige: 6347,
  HGSW_9087_SmokyBeige: 6348,
  HGSW_9088_Utaupeia: 6349,
  HGSW_9089_LlamaWool: 6350,
  HGSW_9090_Caraibe: 6351,
  HGSW_9091_Halfcaff: 6352,
  HGSW_9092_IcedMocha: 6353,
  HGSW_9094_PlayaArenoso: 6354,
  HGSW_9096_BeigeIntenso: 6355,
  HGSW_9100_UmberRust: 6356,
  HGSW_9101_AuNaturale: 6357,
  HGSW_9102_Quinoa: 6358,
  HGSW_9104_WovenWicker: 6359,
  HGSW_9108_DoubleLatte: 6360,
  HGSW_9109_NaturalLinen: 6361,
  HGSW_9110_Malabar: 6362,
  HGSW_9111_AntlerVelvet: 6363,
  HGSW_9113_Mudslide: 6364,
  HGSW_9114_FallenLeaves: 6365,
  HGSW_9115_CowboyBoots: 6366,
  HGSW_9117_UrbanJungle: 6367,
  HGSW_9118_TarnishedTreasure: 6368,
  HGSW_9119_DirtyMartini: 6369,
  HGSW_9120_TumblinTumbleweed: 6370,
  HGSW_9122_DriedEdamame: 6371,
  HGSW_9123_BarroVerde: 6372,
  HGSW_9124_VerdeMarron: 6373,
  HGSW_9125_OlivaOscuro: 6374,
  HGSW_9130_EvergreenFog: 6375,
  HGSW_9131_CornwallSlate: 6376,
  HGSW_9132_AcaciaHaze: 6377,
  HGSW_9133_JasperStone: 6378,
  HGSW_9134_Delft: 6379,
  HGSW_9135_Whirlpool: 6380,
  HGSW_9136_Lullaby: 6381,
  HGSW_9137_NieblaAzul: 6382,
  HGSW_9138_Stardew: 6383,
  HGSW_9139_Debonair: 6384,
  HGSW_9140_BlusterySky: 6385,
  HGSW_9141_Waterloo: 6386,
  HGSW_9142_MoscowMidnight: 6387,
  HGSW_9143_Cadet: 6388,
  HGSW_9144_Moonmist: 6389,
  HGSW_9145_SleepyHollow: 6390,
  HGSW_9146_FadedFlaxflower: 6391,
  HGSW_9147_FavoriteJeans: 6392,
  HGSW_9148_SmokyAzurite: 6393,
  HGSW_9149_InkyBlue: 6394,
  HGSW_9150_EndlessSea: 6395,
  HGSW_9152_LetItRain: 6396,
  HGSW_9153_MoonlitOrchid: 6397,
  HGSW_9155_SlateViolet: 6398,
  HGSW_9156_GrisMorado: 6399,
  HGSW_9157_AutumnOrchid: 6400,
  HGSW_9159_AugerShell: 6401,
  HGSW_9162_AfricanGray: 6402,
  HGSW_9163_TinLizzie: 6403,
  HGSW_9164_IllusiveGreen: 6404,
  HGSW_9166_DriftOfMist: 6405,
  HGSW_9167_PolishedConcrete: 6406,
  HGSW_9169_ChaturaGray: 6407,
  HGSW_9171_FeltedWool: 6408,
  HGSW_9172_StudioClay: 6409,
  HGSW_9174_MothWing: 6410,
  HGSW_9176_DressBlues: 6411,
  HGSW_9177_SaltyDog: 6412,
  SW_0001_MulberrySilk: 280,
  SW_0002_ChelseaMauve: 281,
  SW_0003_CabbageRose: 282,
  SW_0004_RoseBrocade: 283,
  SW_0005_DeepestMauve: 284,
  SW_0006_ToileRed: 285,
  SW_0007_DecorousAmber: 286,
  SW_0008_CajunRed: 287,
  SW_0009_EastlakeGold: 288,
  SW_0010_Wickerwork: 289,
  SW_0011_CrewelTan: 290,
  SW_0012_EmpireGold: 291,
  SW_0013_MajolicaGreen: 292,
  SW_0014_SheratonSage: 293,
  SW_0015_GalleryGreen: 294,
  SW_0016_BilliardGreen: 295,
  SW_0017_Calico: 296,
  SW_0018_TealStencil: 297,
  SW_0019_FestoonAqua: 298,
  SW_0020_PeacockPlume: 299,
  SW_0021_QueenAnneLilac: 300,
  SW_0022_PatchworkPlum: 301,
  SW_0023_PewterTankard: 302,
  SW_0024_CurioGray: 259,
  SW_0025_Rosedust: 303,
  SW_0026_RachelPink: 304,
  SW_0027_AristocratPeach: 305,
  SW_0028_CaenStone: 306,
  SW_0029_Acanthus: 307,
  SW_0030_ColonialYellow: 308,
  SW_0031_DutchTileBlue: 309,
  SW_0032_NeedlepointNavy: 310,
  SW_0033_RembrandtRuby: 311,
  SW_0034_RoycroftRose: 312,
  SW_0035_IndianWhite: 313,
  SW_0036_BuckramBinding: 314,
  SW_0037_MorrisRoomGrey: 315,
  SW_0038_LibraryPewter: 316,
  SW_0039_PortraitTone: 317,
  SW_0040_RoycroftAdobe: 318,
  SW_0041_DardHunterGreen: 319,
  SW_0042_RuskinRoomGreen: 320,
  SW_0043_PeristyleBrass: 321,
  SW_0044_HubbardSquash: 322,
  SW_0045_AntiquarianBrown: 323,
  SW_0046_WhiteHyacinth: 324,
  SW_0047_StudioBlueGreen: 325,
  SW_0048_BunglehouseBlue: 326,
  SW_0049_SilverGray: 327,
  SW_0050_ClassicLightBuff: 328,
  SW_0051_ClassicIvory: 329,
  SW_0052_PearlGray: 330,
  SW_0053_Porcelain: 331,
  SW_0054_TwilightGray: 68,
  SW_0055_LightFrenchGray: 69,
  SW_0056_ClassicSand: 332,
  SW_0057_ChineseRed: 333,
  SW_0058_JazzAgeCoral: 334,
  SW_0059_Frostwork: 335,
  SW_0060_Alexandrite: 336,
  SW_0061_SalonRose: 337,
  SW_0062_StudioMauve: 338,
  SW_0063_BlueSky: 339,
  SW_0064_BluePeacock: 340,
  SW_0065_VogueGreen: 341,
  SW_0066_CascadeGreen: 342,
  SW_0067_BelvedereCream: 343,
  SW_0068_CopenBlue: 344,
  SW_0069_RoseTan: 345,
  SW_0070_PinkShadow: 346,
  SW_0071_Orchid: 347,
  SW_0072_DeepMaroon: 348,
  SW_0073_Chartreuse: 349,
  SW_0074_RadiantLilac: 350,
  SW_0075_HolidayTurquoise: 351,
  SW_0076_Appleblossom: 352,
  SW_0077_ClassicFrenchGray: 353,
  SW_0078_SunbeamYellow: 354,
  SW_0079_PinkyBeige: 355,
  SW_0080_PinkFlamingo: 356,
  SW_1015_SkylineSteel: 234,
  SW_1030_SculptureGray: 1731,
  SW_1666_VenetianYellow: 357,
  SW_1667_IcyLemonade: 358,
  SW_1668_PineappleCream: 359,
  SW_2704_Merlot: 360,
  SW_2735_Rockweed: 361,
  SW_2739_CharcoalBlue: 362,
  SW_2740_MineralGray: 363,
  SW_2801_RookwoodDarkRed: 364,
  SW_2802_RookwoodRed: 365,
  SW_2803_RookwoodTerraCotta: 366,
  SW_2804_RenwickRoseBeige: 367,
  SW_2805_RenwickBeige: 368,
  SW_2806_RookwoodBrown: 369,
  SW_2807_RookwoodMediumBrown: 370,
  SW_2808_RookwoodDarkBrown: 371,
  SW_2809_RookwoodShutterGreen: 71,
  SW_2810_RookwoodSashGreen: 372,
  SW_2811_RookwoodBlueGreen: 373,
  SW_2812_RookwoodJade: 374,
  SW_2813_DowningStraw: 375,
  SW_2814_RookwoodAntiqueGold: 376,
  SW_2815_RenwickOlive: 377,
  SW_2816_RookwoodDarkGreen: 378,
  SW_2817_RookwoodAmber: 379,
  SW_2818_RenwickHeather: 380,
  SW_2819_DowningSlate: 381,
  SW_2820_DowningEarth: 382,
  SW_2821_DowningStone: 383,
  SW_2822_DowningSand: 260,
  SW_2823_RookwoodClay: 384,
  SW_2824_RenwickGoldenOak: 385,
  SW_2825_ColonialRevivalSeaGreen: 20660,
  SW_2826_ColonialRevivalGreenStone: 386,
  SW_2827_ColonialRevivalStone: 387,
  SW_2828_ColonialRevivalTan: 388,
  SW_2829_ClassicalWhite: 389,
  SW_2831_ClassicalGold: 390,
  SW_2832_ColonialRevivalGray: 391,
  SW_2833_RoycroftVellum: 392,
  SW_2834_BirdseyeMaple: 393,
  SW_2835_CraftsmanBrown: 394,
  SW_2836_QuartersawnOak: 395,
  SW_2837_AuroraBrown: 396,
  SW_2838_PolishedMahogany: 397,
  SW_2839_RoycroftCopperRed: 398,
  SW_2840_HammeredSilver: 154,
  SW_2841_WeatheredShingle: 399,
  SW_2842_RoycroftSuede: 400,
  SW_2843_RoycroftBrass: 401,
  SW_2844_RoycroftMistGray: 261,
  SW_2845_BunglehouseGray: 402,
  SW_2846_RoycroftBronzeGreen: 403,
  SW_2847_RoycroftBottleGreen: 404,
  SW_2848_RoycroftPewter: 405,
  SW_2849_WestchesterGray: 406,
  SW_2850_ChelseaGray: 407,
  SW_2851_SageGreenLight: 408,
  SW_2852_PlymouthGreen: 20661,
  SW_2853_NewColonialYellow: 409,
  SW_2854_CaribbeanCoral: 410,
  SW_2855_SycamoreTan: 411,
  SW_2856_FairfaxBrown: 412,
  SW_2857_PeaceYellow: 413,
  SW_2858_HarvestGold: 414,
  SW_2859_Beige: 415,
  SW_2860_Sage: 416,
  SW_2861_Avocado: 417,
  SW_2862_BurmaJade: 20662,
  SW_2863_PowderBlue: 418,
  SW_2864_StratfordBlue: 20663,
  SW_2865_ClassicalYellow: 419,
  SW_2901_WineCountry: 20664,
  SW_2902_Elderberry: 20665,
  SW_2903_Pomegranate: 20666,
  SW_2904_PoppyFlower: 20667,
  SW_2905_Carmine: 20668,
  SW_2906_CrimsonRed: 20669,
  SW_2907_Scarlet: 20670,
  SW_2908_Cardinal: 20671,
  SW_2909_Redwing: 20672,
  SW_2910_RedDoor: 20673,
  SW_2911_PompeiiRed: 20674,
  SW_2912_Chanticleer: 20675,
  SW_2913_ClassyRed: 20676,
  SW_2914_Vermilion: 20677,
  SW_2916_RedPrairie: 20678,
  SW_2917_ClayPot: 20679,
  SW_2920_MonarchGold: 20680,
  SW_2921_Carmel: 20681,
  SW_2923_BrambleBush: 20682,
  SW_2924_WoodsyBrown: 20683,
  SW_2926_IronGate: 20684,
  SW_2927_Weathervane: 20685,
  SW_2929_GardenPath: 20686,
  SW_2930_MarshFern: 20687,
  SW_2932_PerennialGreen: 20688,
  SW_2933_Greenhouse: 20689,
  SW_2934_Clover: 20690,
  SW_2935_EnglishIvy: 20691,
  SW_2936_BlackEmerald: 20692,
  SW_2937_TabrizTeal: 20693,
  SW_2938_MosaicTile: 20694,
  SW_2939_BlueHill: 20695,
  SW_2940_Bridgeport: 20696,
  SW_2941_BlueGrotto: 20697,
  SW_2942_LibertyBlue: 20698,
  SW_3022_BlackAlder: 4426,
  SW_3063_Charcoal: 1754,
  SW_3079_Stone: 4492,
  SW_6000_Snowfall: 420,
  SW_6001_Grayish: 153,
  SW_6002_EssentialGray: 421,
  SW_6003_ProperGray: 422,
  SW_6004_Mink: 423,
  SW_6005_Folkstone: 424,
  SW_6006_BlackBean: 72,
  SW_6007_SmartWhite: 425,
  SW_6008_IndividualWhite: 426,
  SW_6009_Imagine: 73,
  SW_6010_FlexibleGray: 427,
  SW_6011_Chinchilla: 428,
  SW_6012_BrowseBrown: 429,
  SW_6013_BitterChocolate: 430,
  SW_6014_QuartzWhite: 20699,
  SW_6015_VaguelyMauve: 431,
  SW_6016_ChaiseMauve: 432,
  SW_6017_Intuitive: 433,
  SW_6018_Enigma: 434,
  SW_6019_PoetryPlum: 435,
  SW_6020_Marooned: 436,
  SW_6021_DreamyWhite: 437,
  SW_6022_Breathless: 438,
  SW_6023_InsightfulRose: 439,
  SW_6024_DressyRose: 440,
  SW_6025_Socialite: 441,
  SW_6026_RiverRouge: 442,
  SW_6027_Cordovan: 443,
  SW_6028_CulturedPearl: 444,
  SW_6029_WhiteTruffle: 445,
  SW_6030_ArtisticTaupe: 446,
  SW_6031_Glamour: 447,
  SW_6032_DutchCocoa: 448,
  SW_6033_BateauBrown: 449,
  SW_6034_ArrestingAuburn: 450,
  SW_6035_GauzyWhite: 451,
  SW_6036_Angora: 452,
  SW_6037_TemperateTaupe: 453,
  SW_6038_TrulyTaupe: 454,
  SW_6039_PoisedTaupe: 455,
  SW_6040_LessBrown: 74,
  SW_6041_Otter: 456,
  SW_6042_HushWhite: 457,
  SW_6043_UnfussyBeige: 458,
  SW_6044_Doeskin: 459,
  SW_6045_EmergingTaupe: 460,
  SW_6046_SwingBrown: 461,
  SW_6047_HotCocoa: 462,
  SW_6048_TerraBrun: 463,
  SW_6049_GorgeousWhite: 464,
  SW_6050_AbaloneShell: 465,
  SW_6051_SashaySand: 466,
  SW_6052_Sandbank: 467,
  SW_6053_ReddenedEarth: 468,
  SW_6054_CanyonClay: 469,
  SW_6055_FieryBrown: 470,
  SW_6056_PoliteWhite: 471,
  SW_6057_MaltedMilk: 472,
  SW_6058_LikeableSand: 473,
  SW_6059_InterfaceTan: 474,
  SW_6060_MoroccanBrown: 475,
  SW_6061_Tanbark: 476,
  SW_6062_RuggedBrown: 477,
  SW_6063_NiceWhite: 478,
  SW_6064_Reticence: 479,
  SW_6065_BonaFideBeige: 480,
  SW_6066_SandTrap: 481,
  SW_6067_Mocha: 482,
  SW_6068_BrevityBrown: 483,
  SW_6069_FrenchRoast: 484,
  SW_6070_HeronPlume: 485,
  SW_6071_PopularGray: 486,
  SW_6072_VersatileGray: 487,
  SW_6073_PerfectGreige: 488,
  SW_6074_SpaldingGray: 489,
  SW_6075_GarretGray: 490,
  SW_6076_TurkishCoffee: 491,
  SW_6077_EverydayWhite: 492,
  SW_6078_RealistBeige: 493,
  SW_6079_DiverseBeige: 494,
  SW_6080_UtterlyBeige: 495,
  SW_6081_DownHome: 496,
  SW_6082_CobbleBrown: 497,
  SW_6083_Sable: 498,
  SW_6084_ModestWhite: 499,
  SW_6085_SimplifyBeige: 500,
  SW_6086_SandDune: 501,
  SW_6087_TrustyTan: 502,
  SW_6088_Nuthatch: 503,
  SW_6089_Grounded: 504,
  SW_6090_Java: 505,
  SW_6091_ReliableWhite: 506,
  SW_6092_LightweightBeige: 507,
  SW_6093_FamiliarBeige: 508,
  SW_6094_SensationalSand: 509,
  SW_6095_Toasty: 510,
  SW_6096_JuteBrown: 511,
  SW_6097_SturdyBrown: 512,
  SW_6098_PacerWhite: 513,
  SW_6099_SandDollar: 514,
  SW_6100_PracticalBeige: 515,
  SW_6101_SandsofTime: 516,
  SW_6102_Portabello: 517,
  SW_6103_TeaChest: 518,
  SW_6104_Kaffee: 519,
  SW_6105_DivineWhite: 520,
  SW_6106_KilimBeige: 521,
  SW_6107_NomadicDesert: 522,
  SW_6108_Latte: 523,
  SW_6109_Hopsack: 524,
  SW_6110_SteadyBrown: 525,
  SW_6111_CoconutHusk: 526,
  SW_6112_Biscuit: 527,
  SW_6113_InteractiveCream: 528,
  SW_6114_Bagel: 529,
  SW_6115_TotallyTan: 530,
  SW_6116_TatamiTan: 531,
  SW_6117_SmokeyTopaz: 532,
  SW_6118_LeatherBound: 533,
  SW_6119_AntiqueWhite: 534,
  SW_6120_BelievableBuff: 535,
  SW_6121_WholeWheat: 536,
  SW_6122_Camelback: 537,
  SW_6123_Baguette: 538,
  SW_6124_Cardboard: 539,
  SW_6125_CraftPaper: 540,
  SW_6126_NavajoWhite: 541,
  SW_6127_Ivoire: 542,
  SW_6128_Blonde: 543,
  SW_6129_RestrainedGold: 544,
  SW_6130_ManneredGold: 545,
  SW_6131_Chamois: 546,
  SW_6132_RelicBronze: 547,
  SW_6133_Muslin: 548,
  SW_6134_Netsuke: 549,
  SW_6135_Ecru: 550,
  SW_6136_HarmonicTan: 551,
  SW_6137_Burlap: 552,
  SW_6138_Artifact: 553,
  SW_6139_MossyGold: 554,
  SW_6140_ModerateWhite: 555,
  SW_6141_SofterTan: 556,
  SW_6142_Macadamia: 557,
  SW_6143_BasketBeige: 558,
  SW_6144_DapperTan: 559,
  SW_6145_ThatchBrown: 560,
  SW_6146_Umber: 561,
  SW_6147_PandaWhite: 562,
  SW_6148_WoolSkein: 563,
  SW_6149_RelaxedKhaki: 564,
  SW_6150_UniversalKhaki: 565,
  SW_6151_QuiverTan: 566,
  SW_6152_SuperiorBronze: 567,
  SW_6153_ProtegeBronze: 568,
  SW_6154_Nacre: 569,
  SW_6155_RiceGrain: 570,
  SW_6156_Ramie: 571,
  SW_6157_FavoriteTan: 572,
  SW_6158_Sawdust: 573,
  SW_6159_HighTea: 574,
  SW_6160_BestBronze: 575,
  SW_6161_NonchalantWhite: 576,
  SW_6162_AncientMarble: 577,
  SW_6163_Grassland: 578,
  SW_6164_SvelteSage: 579,
  SW_6165_ConnectedGray: 580,
  SW_6166_Eclipse: 581,
  SW_6167_GardenGate: 582,
  SW_6168_ModerneWhite: 583,
  SW_6169_SedateGray: 584,
  SW_6170_TechnoGray: 585,
  SW_6171_Chatroom: 586,
  SW_6172_Hardware: 587,
  SW_6173_Cocoon: 588,
  SW_6174_Andiron: 589,
  SW_6175_Sagey: 590,
  SW_6176_LiveableGreen: 591,
  SW_6177_SoftenedGreen: 592,
  SW_6178_ClarySage: 593,
  SW_6179_Artichoke: 594,
  SW_6180_Oakmoss: 595,
  SW_6181_SecretGarden: 596,
  SW_6182_EtherealWhite: 597,
  SW_6183_ConservativeGray: 598,
  SW_6184_AustereGray: 262,
  SW_6185_EscapeGray: 599,
  SW_6186_DriedThyme: 600,
  SW_6187_Rosemary: 601,
  SW_6188_ShadeGrown: 602,
  SW_6189_Opaline: 603,
  SW_6190_FilmyGreen: 604,
  SW_6191_Contented: 605,
  SW_6192_CoastalPlain: 606,
  SW_6193_PrivilegeGreen: 607,
  SW_6194_Basil: 608,
  SW_6195_RockGarden: 609,
  SW_6196_FrostyWhite: 610,
  SW_6197_AloofGray: 611,
  SW_6198_SensibleHue: 612,
  SW_6199_RareGray: 613,
  SW_6200_LinkGray: 614,
  SW_6201_Thunderous: 615,
  SW_6202_CastIron: 616,
  SW_6203_SpareWhite: 617,
  SW_6204_SeaSalt: 618,
  SW_6205_ComfortGray: 619,
  SW_6206_OysterBay: 620,
  SW_6207_Retreat: 621,
  SW_6208_PewterGreen: 75,
  SW_6209_RipeOlive: 622,
  SW_6210_WindowPane: 623,
  SW_6211_Rainwashed: 624,
  SW_6212_Quietude: 625,
  SW_6213_HalcyonGreen: 626,
  SW_6214_Underseas: 627,
  SW_6215_RockyRiver: 628,
  SW_6216_Jasper: 629,
  SW_6217_Topsail: 630,
  SW_6218_Tradewind: 631,
  SW_6219_Rain: 632,
  SW_6220_InterestingAqua: 633,
  SW_6221_MoodyBlue: 634,
  SW_6222_Riverway: 635,
  SW_6223_StillWater: 636,
  SW_6224_MountainAir: 159,
  SW_6225_SleepyBlue: 637,
  SW_6226_LanguidBlue: 638,
  SW_6227_Meditative: 639,
  SW_6228_Refuge: 640,
  SW_6229_TempeStar: 641,
  SW_6230_Rainstorm: 263,
  SW_6231_RockCandy: 642,
  SW_6232_Misty: 643,
  SW_6233_SamovarSilver: 644,
  SW_6234_UncertainGray: 645,
  SW_6235_FoggyDay: 76,
  SW_6236_GraysHarbor: 204,
  SW_6237_DarkNight: 646,
  SW_6238_Icicle: 647,
  SW_6239_Upward: 648,
  SW_6240_WindyBlue: 649,
  SW_6241_Aleutian: 650,
  SW_6242_BracingBlue: 651,
  SW_6243_Distance: 652,
  SW_6244_Naval: 653,
  SW_6245_Quicksilver: 654,
  SW_6246_NorthStar: 655,
  SW_6247_Krypton: 656,
  SW_6248_Jubilee: 657,
  SW_6249_StormCloud: 658,
  SW_6250_GranitePeak: 659,
  SW_6251_Outerspace: 660,
  SW_6252_IceCube: 661,
  SW_6253_OlympusWhite: 662,
  SW_6254_LazyGray: 79,
  SW_6255_MorningFog: 663,
  SW_6256_SeriousGray: 664,
  SW_6257_Gibraltar: 151,
  SW_6258_TricornBlack: 169,
  SW_6259_SpatialWhite: 665,
  SW_6260_UniqueGray: 666,
  SW_6261_SwankyGray: 667,
  SW_6262_MysteriousMauve: 668,
  SW_6263_ExclusivePlum: 669,
  SW_6264_Midnight: 670,
  SW_6265_QuixoticPlum: 671,
  SW_6266_DiscreetWhite: 20700,
  SW_6267_SensitiveTint: 672,
  SW_6268_VeiledViolet: 673,
  SW_6269_BeguilingMauve: 674,
  SW_6270_Soulmate: 675,
  SW_6271_ExpressivePlum: 676,
  SW_6272_PlumBrown: 677,
  SW_6273_NouvelleWhite: 20701,
  SW_6274_Destiny: 678,
  SW_6275_FashionableGray: 679,
  SW_6276_MysticalShade: 680,
  SW_6277_SpecialGray: 681,
  SW_6278_CloakGray: 682,
  SW_6279_BlackSwan: 683,
  SW_6280_MauveTinge: 20702,
  SW_6281_Wallflower: 684,
  SW_6282_MauveFinery: 685,
  SW_6283_Thistle: 686,
  SW_6284_PlumDandy: 687,
  SW_6285_GrapeHarvest: 688,
  SW_6286_MatureGrape: 689,
  SW_6287_WhiteBeet: 20703,
  SW_6288_Rosebud: 690,
  SW_6289_Delightful: 691,
  SW_6290_Rose: 692,
  SW_6291_MossRose: 693,
  SW_6292_BerryBush: 694,
  SW_6293_FabulousGrape: 695,
  SW_6294_RoseOfSharon: 20704,
  SW_6295_Demure: 696,
  SW_6296_FadingRose: 697,
  SW_6297_RoseEmbroidery: 698,
  SW_6298_Concerto: 699,
  SW_6299_AgedWine: 700,
  SW_6300_Burgundy: 701,
  SW_6301_PatientWhite: 20705,
  SW_6302_Innocence: 702,
  SW_6303_RoseColored: 703,
  SW_6304_PressedFlower: 704,
  SW_6305_RamblingRose: 705,
  SW_6306_Cordial: 706,
  SW_6307_FineWine: 707,
  SW_6308_PossiblyPink: 20706,
  SW_6309_CharmingPink: 708,
  SW_6310_LotusFlower: 709,
  SW_6311_MemorableRose: 710,
  SW_6312_Redbud: 711,
  SW_6313_KirschRed: 712,
  SW_6314_LuxuriousRed: 713,
  SW_6315_WhiteDogwood: 20707,
  SW_6316_RosyOutlook: 714,
  SW_6317_GraciousRose: 715,
  SW_6318_ResoundingRose: 716,
  SW_6319_Reddish: 717,
  SW_6320_BravadoRed: 718,
  SW_6321_RedBay: 719,
  SW_6322_IntimateWhite: 720,
  SW_6323_Romance: 721,
  SW_6324_MellowCoral: 722,
  SW_6325_ConstantCoral: 723,
  SW_6326_HennaShade: 724,
  SW_6327_BoldBrick: 725,
  SW_6328_Fireweed: 726,
  SW_6329_FaintCoral: 727,
  SW_6330_QuaintPeche: 728,
  SW_6331_SmokySalmon: 729,
  SW_6332_CoralIsland: 730,
  SW_6333_Foxy: 731,
  SW_6334_FlowerPot: 732,
  SW_6335_FiredBrick: 733,
  SW_6336_NearlyPeach: 734,
  SW_6337_SpunSugar: 735,
  SW_6338_WarmingPeach: 736,
  SW_6339_Persimmon: 737,
  SW_6340_BakedClay: 738,
  SW_6341_RedCent: 739,
  SW_6342_SpicyHue: 740,
  SW_6343_AlluringWhite: 741,
  SW_6344_PeachFuzz: 742,
  SW_6345_SumptuousPeach: 743,
  SW_6346_FameOrange: 744,
  SW_6347_Chrysanthemum: 745,
  SW_6348_Reynard: 746,
  SW_6349_Pennywise: 747,
  SW_6350_IntricateIvory: 748,
  SW_6351_SweetOrange: 749,
  SW_6352_SoftApricot: 750,
  SW_6353_ChivalryCopper: 751,
  SW_6354_Armagnac: 752,
  SW_6355_Truepenny: 753,
  SW_6356_CopperMountain: 754,
  SW_6357_ChoiceCream: 755,
  SW_6358_Creamery: 756,
  SW_6359_Sociable: 757,
  SW_6360_FolksyGold: 758,
  SW_6361_Autumnal: 759,
  SW_6362_Tigereye: 760,
  SW_6363_Gingery: 761,
  SW_6364_Eggwhite: 762,
  SW_6365_CachetCream: 763,
  SW_6366_AmbitiousAmber: 764,
  SW_6367_VivaGold: 765,
  SW_6368_BakeliteGold: 766,
  SW_6369_Tassel: 767,
  SW_6370_SaucyGold: 768,
  SW_6371_Vanillin: 769,
  SW_6372_InvitingIvory: 770,
  SW_6373_Harvester: 771,
  SW_6374_Torchlight: 772,
  SW_6375_Honeycomb: 773,
  SW_6376_GoldCoast: 774,
  SW_6377_Butterscotch: 775,
  SW_6378_CrispLinen: 776,
  SW_6379_JerseyCream: 777,
  SW_6380_HumbleGold: 778,
  SW_6381_AnjouPear: 779,
  SW_6382_CeremonialGold: 780,
  SW_6383_GoldenRule: 781,
  SW_6384_CuttheMustard: 782,
  SW_6385_DoverWhite: 148,
  SW_6386_Napery: 783,
  SW_6387_CompatibleCream: 784,
  SW_6388_GoldenFleece: 785,
  SW_6389_Butternut: 786,
  SW_6390_BoscPear: 787,
  SW_6391_GallantGold: 788,
  SW_6392_VitalYellow: 789,
  SW_6393_ConvivialYellow: 790,
  SW_6394_Sequin: 791,
  SW_6395_Alchemy: 792,
  SW_6396_DifferentGold: 793,
  SW_6397_Nankeen: 794,
  SW_6398_SconceGold: 795,
  SW_6399_Chamomile: 796,
  SW_6400_LucentYellow: 797,
  SW_6401_IndependentGold: 798,
  SW_6402_Antiquity: 799,
  SW_6403_EscapadeGold: 800,
  SW_6404_Grandiose: 801,
  SW_6405_FerventBrass: 802,
  SW_6406_IonicIvory: 803,
  SW_6407_AncestralGold: 804,
  SW_6408_WheatGrass: 805,
  SW_6409_EdgyGold: 806,
  SW_6410_Brassy: 807,
  SW_6411_BengalGrass: 808,
  SW_6412_EminentBronze: 809,
  SW_6413_RestorationIvory: 810,
  SW_6414_RicePaddy: 811,
  SW_6415_HeartsofPalm: 812,
  SW_6416_SassyGreen: 813,
  SW_6417_TupeloTree: 814,
  SW_6418_RuralGreen: 815,
  SW_6419_Saguaro: 816,
  SW_6420_QueenAnnesLace: 817,
  SW_6421_Celery: 818,
  SW_6422_Shagreen: 819,
  SW_6423_Ryegrass: 820,
  SW_6424_TansyGreen: 821,
  SW_6425_RelentlessOlive: 822,
  SW_6426_BasqueGreen: 823,
  SW_6427_Sprout: 824,
  SW_6428_Honeydew: 825,
  SW_6429_BaizeGreen: 826,
  SW_6430_GreatGreen: 827,
  SW_6431_Leapfrog: 828,
  SW_6432_GardenSpot: 829,
  SW_6433_Inverness: 830,
  SW_6434_SpinachWhite: 831,
  SW_6435_GratifyingGreen: 832,
  SW_6436_BonsaiTint: 833,
  SW_6437_Haven: 834,
  SW_6438_Dill: 835,
  SW_6439_Greenfield: 836,
  SW_6440_Courtyard: 837,
  SW_6441_WhiteMint: 838,
  SW_6442_SupremeGreen: 839,
  SW_6443_Relish: 840,
  SW_6444_LoungeGreen: 841,
  SW_6445_GardenGrove: 842,
  SW_6446_Arugula: 843,
  SW_6447_Evergreens: 844,
  SW_6448_Greening: 20708,
  SW_6449_TopiaryTint: 845,
  SW_6450_EasyGreen: 846,
  SW_6451_NurtureGreen: 847,
  SW_6452_Inland: 848,
  SW_6453_Cilantro: 849,
  SW_6454_Shamrock: 850,
  SW_6455_FleetingGreen: 851,
  SW_6456_SlowGreen: 852,
  SW_6457_KindGreen: 853,
  SW_6458_Restful: 854,
  SW_6459_Jadite: 855,
  SW_6460_KaleGreen: 856,
  SW_6461_IsleofPines: 857,
  SW_6462_GreenTrance: 858,
  SW_6463_Breaktime: 859,
  SW_6464_Aloe: 860,
  SW_6465_Spearmint: 861,
  SW_6466_Grandview: 862,
  SW_6467_KendalGreen: 863,
  SW_6468_HuntClub: 864,
  SW_6469_Dewy: 20709,
  SW_6470_Waterscape: 865,
  SW_6471_Hazel: 866,
  SW_6472_Composed: 867,
  SW_6473_SurfGreen: 868,
  SW_6474_RagingSea: 869,
  SW_6475_CountrySquire: 870,
  SW_6476_Glimmer: 871,
  SW_6477_Tidewater: 872,
  SW_6478_Watery: 873,
  SW_6479_Drizzle: 874,
  SW_6480_Lagoon: 875,
  SW_6481_GreenBay: 876,
  SW_6482_CapeVerde: 877,
  SW_6483_BuoyantBlue: 20710,
  SW_6484_MeanderBlue: 878,
  SW_6485_Raindrop: 879,
  SW_6486_ReflectingPool: 880,
  SW_6487_Cloudburst: 881,
  SW_6488_GrandCanal: 882,
  SW_6489_ReallyTeal: 883,
  SW_6490_TimidBlue: 20711,
  SW_6491_OpenAir: 884,
  SW_6492_Jetstream: 885,
  SW_6493_Ebbtide: 886,
  SW_6494_Lakeshore: 887,
  SW_6495_GreatFalls: 888,
  SW_6496_Oceanside: 889,
  SW_6497_BlueHorizon: 890,
  SW_6498_ByteBlue: 891,
  SW_6499_Stream: 892,
  SW_6500_OpenSeas: 893,
  SW_6501_ManitouBlue: 894,
  SW_6502_LochBlue: 895,
  SW_6503_Bosporus: 896,
  SW_6504_SkyHigh: 897,
  SW_6505_Atmospheric: 898,
  SW_6506_VastSky: 899,
  SW_6507_ResoluteBlue: 900,
  SW_6508_SecureBlue: 901,
  SW_6509_GeorgianBay: 902,
  SW_6510_LoyalBlue: 903,
  SW_6511_Snowdrop: 904,
  SW_6512_Balmy: 905,
  SW_6513_TakeFive: 906,
  SW_6514_Respite: 907,
  SW_6515_LeisureBlue: 908,
  SW_6516_DownPour: 909,
  SW_6517_Regatta: 910,
  SW_6518_SkiSlope: 20712,
  SW_6519_HintingBlue: 911,
  SW_6520_HonestBlue: 912,
  SW_6521_NotableHue: 913,
  SW_6522_SportyBlue: 914,
  SW_6523_Denim: 915,
  SW_6524_Commodore: 916,
  SW_6525_RarifiedAir: 917,
  SW_6526_Icelandic: 918,
  SW_6527_BlissfulBlue: 919,
  SW_6528_Cosmos: 920,
  SW_6529_Scanda: 921,
  SW_6530_RevelBlue: 922,
  SW_6531_Indigo: 923,
  SW_6532_AuraWhite: 20713,
  SW_6533_MildBlue: 924,
  SW_6534_Icy: 925,
  SW_6535_Solitude: 926,
  SW_6536_SearchingBlue: 927,
  SW_6537_LuxeBlue: 928,
  SW_6538_Dignified: 929,
  SW_6539_SoothingWhite: 20714,
  SW_6540_StarryNight: 930,
  SW_6541_Daydream: 931,
  SW_6542_VesperViolet: 932,
  SW_6543_SoulfulBlue: 933,
  SW_6544_Mesmerize: 934,
  SW_6545_MajesticPurple: 935,
  SW_6546_CloudNine: 20715,
  SW_6547_SilverPeony: 936,
  SW_6548_GrapeMist: 937,
  SW_6549_AshViolet: 938,
  SW_6550_Mythical: 939,
  SW_6551_PurplePassage: 940,
  SW_6552_Dewberry: 941,
  SW_6553_HeavenlyWhite: 20716,
  SW_6554_LiteLavender: 942,
  SW_6555_Enchant: 943,
  SW_6556_ObiLilac: 944,
  SW_6557_WoodViolet: 945,
  SW_6558_Plummy: 946,
  SW_6559_ConcordGrape: 947,
  SW_6560_VenusPink: 20717,
  SW_6561_Teaberry: 948,
  SW_6562_Irresistible: 949,
  SW_6563_Rosebay: 950,
  SW_6564_RedClover: 951,
  SW_6565_GrandeurPlum: 952,
  SW_6566_Framboise: 953,
  SW_6567_Anemone: 20718,
  SW_6568_LightheartedPink: 954,
  SW_6569_Childlike: 955,
  SW_6570_HautePink: 956,
  SW_6571_Cyclamen: 957,
  SW_6572_RubyShade: 958,
  SW_6573_Juneberry: 959,
  SW_6574_Rosily: 20719,
  SW_6575_Priscilla: 960,
  SW_6576_AzaleaFlower: 961,
  SW_6577_JaipurPink: 962,
  SW_6578_Tuberose: 963,
  SW_6579_GalaPink: 964,
  SW_6580_Cerise: 965,
  SW_6581_Verbena: 20720,
  SW_6582_ImpatiensPetal: 966,
  SW_6583_InthePink: 967,
  SW_6584_Cheery: 968,
  SW_6585_ComingupRoses: 969,
  SW_6586_Heartfelt: 970,
  SW_6587_Valentine: 971,
  SW_6588_DiminutivePink: 20721,
  SW_6589_Alyssum: 972,
  SW_6590_Loveable: 973,
  SW_6591_Amaryllis: 974,
  SW_6592_Grenadine: 975,
  SW_6593_CoralBells: 976,
  SW_6594_Poinsettia: 977,
  SW_6595_AmourPink: 20722,
  SW_6596_BellaPink: 978,
  SW_6597_Hopeful: 979,
  SW_6598_DishyCoral: 980,
  SW_6599_Begonia: 981,
  SW_6600_EnticingRed: 982,
  SW_6601_Tanager: 983,
  SW_6602_Angelic: 20723,
  SW_6603_Oleander: 984,
  SW_6604_YouthfulCoral: 985,
  SW_6605_Charisma: 986,
  SW_6606_CoralReef: 987,
  SW_6607_RedTomato: 988,
  SW_6608_RaveRed: 989,
  SW_6609_TouchingWhite: 20724,
  SW_6610_KoralKicks: 990,
  SW_6611_Jovial: 991,
  SW_6612_RavishingCoral: 992,
  SW_6613_LeiFlower: 993,
  SW_6614_QuiteCoral: 994,
  SW_6615_Peppery: 995,
  SW_6616_FeatherWhite: 20725,
  SW_6617_Blushing: 996,
  SW_6618_CosmeticPeach: 997,
  SW_6619_Sockeye: 998,
  SW_6620_Rejuvenate: 999,
  SW_6621_Emotional: 1000,
  SW_6622_HeartyOrange: 1001,
  SW_6623_TeasingPeach: 20726,
  SW_6624_PeachBlossom: 1002,
  SW_6625_CertainPeach: 1003,
  SW_6626_Sunset: 1004,
  SW_6627_Emberglow: 1005,
  SW_6628_RobustOrange: 1006,
  SW_6629_Jalapeno: 1007,
  SW_6630_Posy: 20727,
  SW_6631_NaivePeach: 1008,
  SW_6632_NeighborlyPeach: 1009,
  SW_6633_InventiveOrange: 1010,
  SW_6634_CopperHarbor: 1011,
  SW_6635_DeterminedOrange: 1012,
  SW_6636_HuskyOrange: 1013,
  SW_6637_Organza: 20728,
  SW_6638_FlatteringPeach: 1014,
  SW_6639_AvidApricot: 1015,
  SW_6640_Tangerine: 1016,
  SW_6641_OutgoingOrange: 1017,
  SW_6642_RhumbaOrange: 1018,
  SW_6643_Yam: 1019,
  SW_6644_Champagne: 1020,
  SW_6645_Frangipane: 20729,
  SW_6646_OrangeBlast: 20730,
  SW_6647_ExcitingOrange: 20731,
  SW_6648_Kumquat: 20732,
  SW_6649_Tango: 20733,
  SW_6650_MarquisOrange: 20734,
  SW_6651_CherishCream: 20735,
  SW_6652_Flan: 1021,
  SW_6653_DeliciousMelon: 1022,
  SW_6654_SurpriseAmber: 1023,
  SW_6655_AdventureOrange: 1024,
  SW_6656_Serape: 1025,
  SW_6657_AmberWave: 1026,
  SW_6658_WelcomeWhite: 1027,
  SW_6659_CaptivatingCream: 1028,
  SW_6660_HoneyBlush: 1029,
  SW_6661_Papaya: 1030,
  SW_6662_SummerDay: 1031,
  SW_6663_SaffronThread: 1032,
  SW_6664_Marigold: 1033,
  SW_6665_Gardenia: 1034,
  SW_6666_EnjoyableYellow: 1035,
  SW_6667_Afterglow: 1036,
  SW_6668_Sunrise: 1037,
  SW_6669_Yarrow: 1038,
  SW_6670_GoldCrest: 1039,
  SW_6671_Curry: 1040,
  SW_6672_MorningSun: 1041,
  SW_6673_BananaCream: 1042,
  SW_6674_Jonquil: 1043,
  SW_6675_Afternoon: 1044,
  SW_6676_Butterfield: 1045,
  SW_6677_Goldenrod: 1046,
  SW_6678_Sunflower: 1047,
  SW_6679_FullMoon: 1048,
  SW_6680_FriendlyYellow: 1049,
  SW_6681_ButterUp: 1050,
  SW_6682_JuneDay: 1051,
  SW_6683_Bee: 1052,
  SW_6684_Brittlebush: 1053,
  SW_6685_Trinket: 1054,
  SW_6686_LemonChiffon: 1055,
  SW_6687_LanternLight: 1056,
  SW_6688_Solaria: 1057,
  SW_6689_Overjoy: 1058,
  SW_6690_GambolGold: 1059,
  SW_6691_GlitzyGold: 1060,
  SW_6692_Auric: 1061,
  SW_6693_Lily: 1062,
  SW_6694_GladYellow: 1063,
  SW_6695_Midday: 1064,
  SW_6696_QuiltGold: 1065,
  SW_6697_Nugget: 1066,
  SW_6698_KingdomGold: 1067,
  SW_6699_CrispyGold: 1068,
  SW_6700_Daybreak: 1069,
  SW_6701_Moonraker: 1070,
  SW_6702_LivelyYellow: 1071,
  SW_6703_Frolic: 1072,
  SW_6704_HepGreen: 1073,
  SW_6705_HighStrung: 1074,
  SW_6706_OffbeatGreen: 1075,
  SW_6707_Narcissus: 20736,
  SW_6708_Springtime: 1076,
  SW_6709_Gleeful: 1077,
  SW_6710_MelangeGreen: 1078,
  SW_6711_Parakeet: 1079,
  SW_6712_LuauGreen: 1080,
  SW_6713_Verdant: 1081,
  SW_6714_Citrine: 20737,
  SW_6715_LimeGranita: 1082,
  SW_6716_DancingGreen: 1083,
  SW_6717_LimeRickey: 1084,
  SW_6718_OvertGreen: 1085,
  SW_6719_Gecko: 1086,
  SW_6720_Paradise: 1087,
  SW_6721_EnlightenedLime: 20738,
  SW_6722_Cucumber: 1088,
  SW_6723_Jardin: 1089,
  SW_6724_MesclunGreen: 1090,
  SW_6725_Pickle: 1091,
  SW_6726_TalipotPalm: 1092,
  SW_6727_Houseplant: 1093,
  SW_6728_WhiteWillow: 20739,
  SW_6729_Lacewing: 1094,
  SW_6730_Romaine: 1095,
  SW_6731_Picnic: 1096,
  SW_6732_OrganicGreen: 1097,
  SW_6733_Grasshopper: 1098,
  SW_6734_Espalier: 1099,
  SW_6735_Minted: 20740,
  SW_6736_JocularGreen: 1100,
  SW_6737_Kiwi: 1101,
  SW_6738_Vegan: 1102,
  SW_6739_EcoGreen: 1103,
  SW_6740_Kilkenny: 1104,
  SW_6741_Derbyshire: 1105,
  SW_6742_LighterMint: 20741,
  SW_6743_MintCondition: 1106,
  SW_6744_RecliningGreen: 1107,
  SW_6745_LarkGreen: 1108,
  SW_6746_Julep: 1109,
  SW_6747_Argyle: 1110,
  SW_6748_Greens: 1111,
  SW_6749_EmbellishedBlue: 1112,
  SW_6750_Waterfall: 1113,
  SW_6751_Refresh: 1114,
  SW_6752_Larchmere: 1115,
  SW_6753_JargonJade: 1116,
  SW_6754_Ionian: 1117,
  SW_6755_Starboard: 1118,
  SW_6756_CrystalClear: 20742,
  SW_6757_TameTeal: 1119,
  SW_6758_Aqueduct: 1120,
  SW_6759_CooledBlue: 1121,
  SW_6760_Rivulet: 1122,
  SW_6761_ThermalSpring: 1123,
  SW_6762_Poseidon: 1124,
  SW_6763_RetiringBlue: 20743,
  SW_6764_Swimming: 1125,
  SW_6765_Spa: 1126,
  SW_6766_Mariner: 1127,
  SW_6767_Aquarium: 1128,
  SW_6768_Gulfstream: 1129,
  SW_6769_MaxiTeal: 1130,
  SW_6770_Bubble: 20744,
  SW_6771_BatheBlue: 1131,
  SW_6772_Cay: 1132,
  SW_6773_RaptureBlue: 1133,
  SW_6774_Freshwater: 1134,
  SW_6775_Briny: 1135,
  SW_6776_BlueNile: 1136,
  SW_6777_Carefree: 20745,
  SW_6778_AviaryBlue: 1137,
  SW_6779_LiquidBlue: 1138,
  SW_6780_Nautilus: 1139,
  SW_6781_JamaicaBay: 1140,
  SW_6782_Cruising: 1141,
  SW_6783_Amalfi: 1142,
  SW_6784_BravoBlue: 1143,
  SW_6785_QuenchBlue: 1144,
  SW_6786_Cloudless: 1145,
  SW_6787_Fountain: 1146,
  SW_6788_Capri: 1147,
  SW_6789_BlueMosque: 1148,
  SW_6790_AdriaticSea: 1149,
  SW_6791_LaurensSurprise: 20746,
  SW_6792_MinorBlue: 1150,
  SW_6793_Bluebell: 1151,
  SW_6794_Flyway: 1152,
  SW_6795_MajorBlue: 1153,
  SW_6796_BluePlate: 1154,
  SW_6797_JayBlue: 1155,
  SW_6798_Iceberg: 1156,
  SW_6799_Soar: 1157,
  SW_6800_SomethingBlue: 1158,
  SW_6801_RegaleBlue: 1159,
  SW_6802_Jacaranda: 1160,
  SW_6803_Danube: 1161,
  SW_6804_DignityBlue: 1162,
  SW_6805_GlassBead: 20747,
  SW_6806_RhythmicBlue: 1163,
  SW_6807_WondrousBlue: 1164,
  SW_6808_Celestial: 1165,
  SW_6809_Lobelia: 1166,
  SW_6810_Lupine: 1167,
  SW_6811_HonorableBlue: 1168,
  SW_6812_WhiteIris: 20748,
  SW_6813_WishfulBlue: 1169,
  SW_6814_Breathtaking: 1170,
  SW_6815_AwesomeViolet: 1171,
  SW_6816_Dahlia: 1172,
  SW_6817_Gentian: 1173,
  SW_6818_ValiantViolet: 1174,
  SW_6819_MinuetWhite: 20749,
  SW_6820_InspiredLilac: 1175,
  SW_6821_PotentiallyPurple: 1176,
  SW_6822_Wisteria: 1177,
  SW_6823_BravePurple: 1178,
  SW_6824_ForgetMeNot: 1179,
  SW_6825_IzmirPurple: 1180,
  SW_6826_WhimsicalWhite: 20750,
  SW_6827_Elation: 1181,
  SW_6828_RhapsodyLilac: 1182,
  SW_6829_Magical: 1183,
  SW_6830_Kismet: 1184,
  SW_6831_Clematis: 1185,
  SW_6832_ImpulsivePurple: 1186,
  SW_6833_WhiteLilac: 20751,
  SW_6834_Spangle: 1187,
  SW_6835_EuphoricLilac: 1188,
  SW_6836_NovelLilac: 1189,
  SW_6837_Baroness: 1190,
  SW_6838_VigorousViolet: 1191,
  SW_6839_KimonoViolet: 1192,
  SW_6840_ExuberantPink: 1193,
  SW_6841_Dynamo: 1194,
  SW_6842_ForwardFuchsia: 1195,
  SW_6843_Hot: 1196,
  SW_6844_MerryPink: 20752,
  SW_6845_ChildsPlay: 20753,
  SW_6846_ProminentPink: 20754,
  SW_6847_IcePlant: 20755,
  SW_6848_PanachePink: 20756,
  SW_6849_Partytime: 20757,
  SW_6850_VivaciousPink: 20758,
  SW_6851_Hibiscus: 20759,
  SW_6852_DesirePink: 20760,
  SW_6853_FussyPink: 20761,
  SW_6854_ImpatientPink: 20762,
  SW_6855_DragonFruit: 1197,
  SW_6856_ReveriePink: 20763,
  SW_6857_PinkMoment: 20764,
  SW_6858_ZanyPink: 20765,
  SW_6859_FeverishPink: 20766,
  SW_6860_ErosPink: 1198,
  SW_6861_Radish: 1199,
  SW_6862_CherriesJubilee: 1200,
  SW_6863_LustyRed: 20767,
  SW_6864_CherryTomato: 20768,
  SW_6865_GypsyRed: 20769,
  SW_6866_Heartthrob: 1201,
  SW_6867_Fireworks: 20770,
  SW_6868_RealRed: 1202,
  SW_6869_Stop: 1203,
  SW_6870_Ablaze: 20771,
  SW_6871_PositiveRed: 1204,
  SW_6872_Gaiety: 20772,
  SW_6873_CoralBead: 20773,
  SW_6874_ArdentCoral: 20774,
  SW_6875_Gladiola: 20775,
  SW_6876_ComicalCoral: 1205,
  SW_6877_InnerChild: 20776,
  SW_6878_AnimatedCoral: 20777,
  SW_6879_Daring: 20778,
  SW_6880_EnergeticOrange: 20779,
  SW_6881_Cayenne: 1206,
  SW_6882_Daredevil: 20780,
  SW_6883_RaucousOrange: 1207,
  SW_6884_ObstinateOrange: 1208,
  SW_6885_KnockoutOrange: 1209,
  SW_6886_Invigorate: 1210,
  SW_6887_Navel: 1211,
  SW_6888_PizazzPeach: 20781,
  SW_6889_StirringOrange: 20782,
  SW_6890_OsageOrange: 1212,
  SW_6891_Mandarin: 20783,
  SW_6892_Carnival: 1213,
  SW_6893_KidsStuff: 20784,
  SW_6894_ForcefulOrange: 20785,
  SW_6895_LaughingOrange: 20786,
  SW_6896_Sole: 1214,
  SW_6897_Sundance: 20787,
  SW_6898_SocialButterfly: 20788,
  SW_6899_Nasturtium: 20789,
  SW_6900_OptimisticYellow: 160,
  SW_6901_Daffodil: 1215,
  SW_6902_DecisiveYellow: 1216,
  SW_6903_Cheerful: 1217,
  SW_6904_GustoGold: 1218,
  SW_6905_Goldfinch: 1219,
  SW_6906_Citrus: 20790,
  SW_6907_Forsythia: 1220,
  SW_6908_FunYellow: 1221,
  SW_6909_LemonTwist: 1222,
  SW_6910_Daisy: 1223,
  SW_6911_ConfidentYellow: 1224,
  SW_6912_GlistenYellow: 20791,
  SW_6913_FunkyYellow: 1225,
  SW_6914_EyeCatching: 1226,
  SW_6915_Citronella: 1227,
  SW_6916_Impetuous: 20792,
  SW_6917_NervyHue: 20793,
  SW_6918_HumorousGreen: 1228,
  SW_6919_Fusion: 20794,
  SW_6920_CenterStage: 1229,
  SW_6921_ElectricLime: 1230,
  SW_6922_OutrageousGreen: 20795,
  SW_6923_FestivalGreen: 20796,
  SW_6924_DirectGreen: 1231,
  SW_6925_Envy: 1232,
  SW_6926_LuckyGreen: 1233,
  SW_6927_Greenbelt: 1234,
  SW_6928_GreenVibes: 1235,
  SW_6929_WittyGreen: 20797,
  SW_6930_LaudableLime: 20798,
  SW_6931_JollyGreen: 20799,
  SW_6932_SpiritedGreen: 20800,
  SW_6933_CleanGreen: 20801,
  SW_6934_RallyGreen: 20802,
  SW_6935_StraightforwardGreen: 20803,
  SW_6936_Aquatint: 20804,
  SW_6937_TantalizingTeal: 1236,
  SW_6938_Synergy: 20805,
  SW_6939_Turquish: 20806,
  SW_6940_Biscay: 20807,
  SW_6941_NiftyTurquoise: 1237,
  SW_6942_Splashy: 1238,
  SW_6943_IntenseTeal: 1239,
  SW_6944_PoolBlue: 20808,
  SW_6945_Belize: 20809,
  SW_6946_Surfer: 20810,
  SW_6947_TempoTeal: 20811,
  SW_6948_BlueBauble: 20812,
  SW_6949_SlickBlue: 20813,
  SW_6950_Calypso: 1240,
  SW_6951_CoteDAzur: 20814,
  SW_6952_BlueClick: 20815,
  SW_6953_CandidBlue: 20816,
  SW_6954_ResonantBlue: 20817,
  SW_6955_Impromptu: 20818,
  SW_6956_BlueRefrain: 20819,
  SW_6957_Undercool: 1241,
  SW_6958_DynamicBlue: 1242,
  SW_6959_BlueChip: 1243,
  SW_6960_BewitchingBlue: 20820,
  SW_6961_BlueBeyond: 20821,
  SW_6962_Dazzle: 20822,
  SW_6963_Sapphire: 20823,
  SW_6964_PulsatingBlue: 20824,
  SW_6965_HyperBlue: 1244,
  SW_6966_Blueblood: 1245,
  SW_6967_FrankBlue: 1246,
  SW_6968_HyacinthTint: 1247,
  SW_6969_Indulgent: 20825,
  SW_6970_VentureViolet: 20826,
  SW_6971_MorningGlory: 1248,
  SW_6972_JoyfulLilac: 20827,
  SW_6973_FreeSpirit: 1249,
  SW_6974_PlumBlossom: 20828,
  SW_6975_LavishLavender: 20829,
  SW_6976_VanityPink: 20830,
  SW_6977_Queenly: 20831,
  SW_6978_DramaViolet: 20832,
  SW_6979_VerveViolet: 20833,
  SW_6980_GutsyGrape: 20834,
  SW_6981_PassionatePurple: 1250,
  SW_6982_AfricanViolet: 1251,
  SW_6983_FullyPurple: 1252,
  SW_6984_WorkoutGreen: 20835,
  SW_6985_GreenJewel: 20836,
  SW_6986_ActiveGreen: 20837,
  SW_6987_JitterbugJade: 1253,
  SW_6988_BohemianBlack: 1254,
  SW_6989_Domino: 1255,
  SW_6990_Caviar: 180,
  SW_6991_BlackMagic: 1256,
  SW_6992_Inkwell: 1257,
  SW_6993_BlackofNight: 1258,
  SW_6994_Greenblack: 237,
  SW_6995_Superwhite: 20838,
  SW_7000_IbisWhite: 1259,
  SW_7001_Marshmallow: 1260,
  SW_7002_Downy: 1261,
  SW_7003_ToqueWhite: 238,
  SW_7004_Snowbound: 245,
  SW_7005_PureWhite: 239,
  SW_7006_ExtraWhite: 149,
  SW_7007_CeilingBrightWhite: 1262,
  SW_7008_Alabaster: 1263,
  SW_7009_PearlyWhite: 1264,
  SW_7010_WhiteDuck: 1265,
  SW_7011_NaturalChoice: 86,
  SW_7012_Creamy: 1266,
  SW_7013_IvoryLace: 1267,
  SW_7014_EiderWhite: 264,
  SW_7015_ReposeGray: 87,
  SW_7016_MindfulGray: 265,
  SW_7017_DorianGray: 1268,
  SW_7018_Dovetail: 1269,
  SW_7019_GauntletGray: 181,
  SW_7020_BlackFox: 88,
  SW_7021_SimpleWhite: 1270,
  SW_7022_Alpaca: 89,
  SW_7023_RequisiteGray: 1271,
  SW_7024_FunctionalGray: 1272,
  SW_7025_Backdrop: 228,
  SW_7026_Griffin: 1273,
  SW_7027_WellBredBrown: 1274,
  SW_7028_IncredibleWhite: 1275,
  SW_7029_AgreeableGray: 1276,
  SW_7030_AnewGray: 1277,
  SW_7031_MegaGreige: 1278,
  SW_7032_WarmStone: 182,
  SW_7033_BrainstormBronze: 1279,
  SW_7034_StatusBronze: 1280,
  SW_7035_AestheticWhite: 1281,
  SW_7036_AccessibleBeige: 240,
  SW_7037_BalancedBeige: 213,
  SW_7038_TonyTaupe: 1282,
  SW_7039_VirtualTaupe: 1283,
  SW_7040_Smokehouse: 1284,
  SW_7041_VanDykeBrown: 1285,
  SW_7042_ShojiWhite: 1286,
  SW_7043_WorldlyGray: 266,
  SW_7044_AmazingGray: 94,
  SW_7045_IntellectualGray: 267,
  SW_7046_Anonymous: 1287,
  SW_7047_Porpoise: 229,
  SW_7048_UrbaneBronze: 1288,
  SW_7049_Nuance: 1289,
  SW_7050_UsefulGray: 1290,
  SW_7051_AnalyticalGray: 1291,
  SW_7052_GrayArea: 1292,
  SW_7053_AdaptiveShade: 1293,
  SW_7054_SuitableBrown: 1294,
  SW_7055_EnduringBronze: 1295,
  SW_7056_ReservedWhite: 221,
  SW_7057_SilverStrand: 1296,
  SW_7058_MagneticGray: 1297,
  SW_7059_UnusualGray: 1298,
  SW_7060_AttitudeGray: 268,
  SW_7061_NightOwl: 1299,
  SW_7062_RockBottom: 1300,
  SW_7063_NebulousWhite: 1301,
  SW_7064_Passive: 1302,
  SW_7065_Argos: 269,
  SW_7066_GrayMatters: 97,
  SW_7067_Cityscape: 230,
  SW_7068_GrizzleGray: 214,
  SW_7069_IronOre: 1303,
  SW_7070_SiteWhite: 1304,
  SW_7071_GrayScreen: 1305,
  SW_7072_Online: 1306,
  SW_7073_NetworkGray: 1307,
  SW_7074_Software: 1308,
  SW_7075_WebGray: 1309,
  SW_7076_Cyberspace: 1310,
  SW_7077_OriginalWhite: 1311,
  SW_7078_MinuteMauve: 1312,
  SW_7079_Ponder: 1313,
  SW_7080_QuestGray: 1314,
  SW_7081_SensuousGray: 1315,
  SW_7082_StunningShade: 1316,
  SW_7083_Darkroom: 1317,
  SW_7100_ArcadeWhite: 1318,
  SW_7101_Futon: 1319,
  SW_7102_WhiteFlour: 1320,
  SW_7103_Whitetail: 1321,
  SW_7104_CottonWhite: 1322,
  SW_7105_Paperwhite: 1323,
  SW_7106_HoniedWhite: 1324,
  SW_7107_FancyPink: 20839,
  SW_7108_PinkVibernum: 20840,
  SW_7109_YoungAtHeart: 20841,
  SW_7110_CosmeticBlush: 20842,
  SW_7111_LaurelPink: 20843,
  SW_7112_Pinkish: 20844,
  SW_7113_Roseate: 20845,
  SW_7114_PalishPeach: 20846,
  SW_7115_ConchShell: 20847,
  SW_7116_ALaMode: 20848,
  SW_7117_MelonTint: 20849,
  SW_7118_FrenchVanilla: 20850,
  SW_7119_VenetianLace: 20851,
  SW_7120_DollopOfCream: 20852,
  SW_7121_Corona: 20853,
  SW_7122_LemonDrop: 20854,
  SW_7123_YellowBeam: 20855,
  SW_7124_CrescentMoon: 20856,
  SW_7125_GlitteryYellow: 20857,
  SW_7126_PearlOnion: 20858,
  SW_7127_AppleSlice: 20859,
  SW_7128_GreenGlaze: 20860,
  SW_7129_OperaGlass: 20861,
  SW_7130_Aquacade: 20862,
  SW_7131_Brooklet: 20863,
  SW_7132_WaterSquirt: 20864,
  SW_7133_FarawayBlue: 20865,
  SW_7134_TibetanSky: 20866,
  SW_7135_Twinkle: 20867,
  SW_7136_ChapeauViolet: 20868,
  SW_7137_VioletVignette: 20869,
  SW_7138_LavendarWisp: 1802,
  SW_7139_LadysSlipper: 20870,
  SW_7140_Snowberry: 20871,
  SW_7141_FeatheryLilac: 20872,
  SW_7459_Clay: 1755,
  SW_7501_ThresholdTaupe: 1325,
  SW_7502_DryDock: 1326,
  SW_7503_SticksAndStones: 1327,
  SW_7504_KeystoneGray: 1328,
  SW_7505_ManorHouse: 1329,
  SW_7506_Loggia: 1330,
  SW_7507_StoneLion: 1331,
  SW_7508_TavernTaupe: 1332,
  SW_7509_TikiHut: 1333,
  SW_7510_ChateauBrown: 1334,
  SW_7511_BungalowBeige: 1335,
  SW_7512_PavilionBeige: 1336,
  SW_7513_Sanderling: 1337,
  SW_7514_Foothills: 1338,
  SW_7515_HomesteadBrown: 1339,
  SW_7516_KestrelWhite: 1340,
  SW_7517_ChinaDoll: 1341,
  SW_7518_BeachHouse: 1342,
  SW_7519_MexicanSand: 1343,
  SW_7520_PlantationShutters: 1344,
  SW_7521_DormerBrown: 1345,
  SW_7522_Meadowlark: 1346,
  SW_7523_BurnishedBrandy: 1347,
  SW_7524_DhurrieBeige: 1348,
  SW_7525_TreeBranch: 1349,
  SW_7526_MaisonBlanche: 1350,
  SW_7527_NantucketDune: 1351,
  SW_7528_WindsorGreige: 1352,
  SW_7529_SandBeach: 1353,
  SW_7530_BarcelonaBeige: 1354,
  SW_7531_CanvasTan: 1355,
  SW_7532_UrbanPutty: 1356,
  SW_7533_KhakiShade: 1357,
  SW_7534_Outerbanks: 1358,
  SW_7535_SandyRidge: 1359,
  SW_7536_BittersweetStem: 1360,
  SW_7537_IrishCream: 1361,
  SW_7538_Tamarind: 1362,
  SW_7539_CorkWedge: 1363,
  SW_7540_ArtisanTan: 1364,
  SW_7541_GrecianIvory: 1365,
  SW_7542_Naturel: 1366,
  SW_7543_AvenueTan: 1367,
  SW_7544_Fenland: 1368,
  SW_7545_Pier: 1369,
  SW_7546_PrairieGrass: 1370,
  SW_7547_Sandbar: 1371,
  SW_7548_Portico: 270,
  SW_7549_StudioTaupe: 1372,
  SW_7550_ResortTan: 1373,
  SW_7551_GreekVilla: 1374,
  SW_7552_BauhausBuff: 1375,
  SW_7553_FragileBeauty: 1376,
  SW_7554_SteamedMilk: 1377,
  SW_7555_Patience: 1378,
  SW_7556_Creme: 1379,
  SW_7557_SummerWhite: 1380,
  SW_7558_MediciIvory: 1381,
  SW_7559_DecorWhite: 1382,
  SW_7560_ImpressiveIvory: 1383,
  SW_7561_LemonMeringue: 1384,
  SW_7562_RomanColumn: 1385,
  SW_7563_RestfulWhite: 1386,
  SW_7564_PolarBear: 1387,
  SW_7565_OysterBar: 1388,
  SW_7566_WesthighlandWhite: 1389,
  SW_7567_NaturalTan: 100,
  SW_7568_NeutralGround: 1390,
  SW_7569_Stucco: 1391,
  SW_7570_EgretWhite: 1392,
  SW_7571_CasaBlanca: 1393,
  SW_7572_LotusPod: 1394,
  SW_7573_EagletBeige: 1395,
  SW_7574_EchelonEcru: 1396,
  SW_7575_Chopsticks: 1397,
  SW_7576_Damsel: 20873,
  SW_7577_Blackberry: 1398,
  SW_7578_Borscht: 1399,
  SW_7579_Alaea: 1400,
  SW_7580_Carnelian: 1401,
  SW_7581_Rosettee: 20874,
  SW_7582_Salute: 1402,
  SW_7583_WildCurrant: 1403,
  SW_7584_RedTheatre: 1404,
  SW_7585_SunDriedTomato: 1405,
  SW_7586_StolenKiss: 1406,
  SW_7587_AntiqueRed: 1407,
  SW_7588_ShowStopper: 1408,
  SW_7589_HabaneroChile: 1409,
  SW_7590_RedObsession: 20875,
  SW_7591_RedBarn: 1410,
  SW_7592_CrabbyApple: 1411,
  SW_7593_RusticRed: 1412,
  SW_7594_CarriageDoor: 1413,
  SW_7595_Sommelier: 1414,
  SW_7596_OnlyNatural: 1415,
  SW_7597_TrekTan: 20876,
  SW_7598_SierraRedwood: 1416,
  SW_7599_BrickPaver: 1417,
  SW_7600_Bolero: 1418,
  SW_7601_DocksideBlue: 1419,
  SW_7602_IndigoBatik: 1420,
  SW_7603_Poolhouse: 1421,
  SW_7604_SmokyBlue: 1422,
  SW_7605_GaleForce: 1423,
  SW_7606_BlueCruise: 1424,
  SW_7607_SantoriniBlue: 1425,
  SW_7608_Adrift: 1426,
  SW_7609_GeorgianRevivalBlue: 1427,
  SW_7610_TurkishTile: 1428,
  SW_7611_TranquilAqua: 1429,
  SW_7612_MountainStream: 1430,
  SW_7613_AquaSphere: 1431,
  SW_7614_StBarts: 1432,
  SW_7615_SeaSerpent: 1433,
  SW_7616_Breezy: 1434,
  SW_7617_Mediterranean: 101,
  SW_7618_DeepSeaDive: 1435,
  SW_7619_Labradorite: 102,
  SW_7620_Seaworthy: 1436,
  SW_7621_Silvermist: 246,
  SW_7622_HomburgGray: 1437,
  SW_7623_Cascades: 1438,
  SW_7624_SlateTile: 1439,
  SW_7625_MountEtna: 1440,
  SW_7626_ZurichWhite: 1441,
  SW_7627_WhiteHeron: 1442,
  SW_7628_WindfreshWhite: 1443,
  SW_7629_Grapy: 1444,
  SW_7630_Raisin: 1445,
  SW_7631_CityLoft: 1446,
  SW_7632_ModernGray: 1447,
  SW_7633_TaupeTone: 1448,
  SW_7634_Pediment: 161,
  SW_7635_Palisade: 1449,
  SW_7636_OrigamiWhite: 1450,
  SW_7637_OysterWhite: 271,
  SW_7638_JoggingPath: 1451,
  SW_7639_EtherealMood: 1452,
  SW_7640_FawnBrindle: 1453,
  SW_7641_ColonnadeGray: 1454,
  SW_7642_Pavestone: 1455,
  SW_7643_Pussywillow: 241,
  SW_7644_GatewayGray: 272,
  SW_7645_ThunderGray: 1456,
  SW_7646_FirstStar: 1457,
  SW_7647_CrushedIce: 1458,
  SW_7648_BigChill: 1459,
  SW_7649_Silverplate: 1460,
  SW_7650_EllieGray: 1461,
  SW_7651_FrontPorch: 1462,
  SW_7652_MineralDeposit: 1463,
  SW_7653_Silverpointe: 1464,
  SW_7654_Lattice: 1465,
  SW_7655_StampedConcrete: 1466,
  SW_7656_Rhinestone: 1467,
  SW_7657_Tinsmith: 1468,
  SW_7658_GrayClouds: 273,
  SW_7659_Gris: 1469,
  SW_7660_EarlGrey: 1470,
  SW_7661_Reflection: 1471,
  SW_7662_EveningShadow: 1472,
  SW_7663_MonorailSilver: 1473,
  SW_7664_SteelyGray: 1474,
  SW_7665_WallStreet: 1475,
  SW_7666_FleurdeSel: 1476,
  SW_7667_Zircon: 1477,
  SW_7668_MarchWind: 157,
  SW_7669_SummitGray: 1478,
  SW_7670_GrayShingle: 1479,
  SW_7671_OntheRocks: 1480,
  SW_7672_KnittingNeedles: 1481,
  SW_7673_PewterCast: 274,
  SW_7674_Peppercorn: 275,
  SW_7675_Sealskin: 165,
  SW_7676_PaperLantern: 1482,
  SW_7677_GoldVessel: 1483,
  SW_7678_CottageCream: 1484,
  SW_7679_GoldenGate: 1485,
  SW_7680_Lanyard: 1486,
  SW_7681_TeaLight: 1487,
  SW_7682_BeesWax: 1488,
  SW_7683_Buff: 1489,
  SW_7684_ConcordBuff: 1490,
  SW_7685_WhiteRaisin: 1491,
  SW_7686_Hinoki: 1492,
  SW_7687_AugustMoon: 1493,
  SW_7688_Sundew: 1494,
  SW_7689_RowHouseTan: 1495,
  SW_7690_TownhallTan: 1496,
  SW_7691_PaleYellow: 1497,
  SW_7692_CupolaYellow: 1498,
  SW_7693_Stonebriar: 1499,
  SW_7694_DromedaryCamel: 1500,
  SW_7695_MesaTan: 1501,
  SW_7696_ToastedPineNut: 1502,
  SW_7697_Safari: 1503,
  SW_7698_StrawHarvest: 1504,
  SW_7699_RusticCity: 1505,
  SW_7700_OldeWorldGold: 1506,
  SW_7701_CavernClay: 1507,
  SW_7702_SpicedCider: 1508,
  SW_7703_EarthenJug: 1509,
  SW_7704_TowerTan: 1510,
  SW_7705_WheatPenny: 1511,
  SW_7706_CreoleCottage: 20877,
  SW_7707_CopperWire: 1512,
  SW_7708_RusticAdobe: 20878,
  SW_7709_CopperPot: 1513,
  SW_7710_Brandywine: 1514,
  SW_7711_Pueblo: 1515,
  SW_7712_TownhouseTan: 1516,
  SW_7713_TawnyTan: 1517,
  SW_7714_OakBarrel: 1518,
  SW_7715_PotteryUrn: 1519,
  SW_7716_Croissant: 1520,
  SW_7717_LigonierTan: 1521,
  SW_7718_OakCreek: 1522,
  SW_7719_FrescoCream: 1523,
  SW_7720_DeerValley: 1524,
  SW_7721_CrescentCream: 1525,
  SW_7722_Travertine: 1526,
  SW_7723_ColonyBuff: 1527,
  SW_7724_Canoe: 1528,
  SW_7725_Yearling: 1529,
  SW_7726_LemonVerbena: 1530,
  SW_7727_KoiPond: 1531,
  SW_7728_GreenSprout: 1532,
  SW_7729_Edamame: 1533,
  SW_7730_Forestwood: 1534,
  SW_7731_SanAntonioSage: 1535,
  SW_7732_Lemongrass: 1536,
  SW_7733_BambooShoot: 1537,
  SW_7734_OliveGrove: 1538,
  SW_7735_PalmLeaf: 1539,
  SW_7736_GardenSage: 1540,
  SW_7737_MeadowTrail: 1541,
  SW_7738_CargoPants: 1542,
  SW_7739_HerbalWash: 1543,
  SW_7740_MessengerBag: 1544,
  SW_7741_WillowTree: 1545,
  SW_7742_AgateGreen: 1546,
  SW_7743_MountainRoad: 1547,
  SW_7744_Zeus: 1548,
  SW_7745_MuddledBasil: 1549,
  SW_7746_RushingRiver: 1550,
  SW_7747_RecycledGlass: 1551,
  SW_7748_GreenEarth: 1552,
  SW_7749_LaurelWoods: 1553,
  SW_7750_OlympicRange: 1554,
  SW_7757_HighReflectiveWhite: 1555,
  SW_8917_ShellWhite: 1556,
  SW_9001_AudreysBlush: 1557,
  SW_9002_CarleysRose: 1558,
  SW_9003_RitasRouge: 1559,
  SW_9004_CoralRose: 1560,
  SW_9005_CoralClay: 1561,
  SW_9006_RojoDust: 1562,
  SW_9007_MelonMeloso: 1563,
  SW_9008_BelliniFizz: 1564,
  SW_9009_SubduedSienna: 1565,
  SW_9010_WindsweptCanyon: 1566,
  SW_9011_SunBleachedOchre: 1567,
  SW_9012_PolvodeOro: 1568,
  SW_9013_OldenAmber: 1569,
  SW_9014_PollenPowder: 1570,
  SW_9015_TheyCallItMellow: 1571,
  SW_9016_LaLunaAmarilla: 1572,
  SW_9017_SunnyVeranda: 1573,
  SW_9018_HoneyBees: 1574,
  SW_9019_GoldenPlumeria: 1575,
  SW_9020_RayodeSol: 1576,
  SW_9021_NaplesYellow: 1577,
  SW_9022_YellowBird: 1578,
  SW_9023_DakotaWheat: 1579,
  SW_9024_VintageGold: 1580,
  SW_9025_CorianderPowder: 1581,
  SW_9026_TarnishedTrumpet: 1582,
  SW_9027_PaleMoss: 1583,
  SW_9028_DustedOlive: 1584,
  SW_9029_CoolAvocado: 1585,
  SW_9030_LimonFresco: 1586,
  SW_9031_Primavera: 1587,
  SW_9032_StayinLime: 1588,
  SW_9033_OhPistachio: 1589,
  SW_9034_SeawashedGlass: 1590,
  SW_9035_FrostedEmerald: 1591,
  SW_9036_RetroMint: 1592,
  SW_9037_BabyBokChoy: 1593,
  SW_9038_CucuzzaVerde: 1594,
  SW_9039_Broccoflower: 1595,
  SW_9040_ResedaGreen: 1596,
  SW_9041_ParisianPatina: 1597,
  SW_9042_Verdigreen: 1598,
  SW_9043_Aquastone: 1599,
  SW_9044_LittleBlueBox: 1600,
  SW_9045_BoraBoraShore: 1601,
  SW_9046_GentleAquamarine: 1602,
  SW_9047_AfterTheRain: 1603,
  SW_9048_Surfin: 1604,
  SW_9049_SkyFall: 1605,
  SW_9050_VintageVessel: 1606,
  SW_9051_Aquaverde: 1607,
  SW_9052_BlitheBlue: 1608,
  SW_9053_AguaFria: 1609,
  SW_9054_LittleBoyBlu: 1610,
  SW_9055_BillowyBreeze: 1611,
  SW_9056_FrenchMoire: 1612,
  SW_9057_Aquitaine: 1613,
  SW_9058_SecretCove: 1614,
  SW_9059_SilkenPeacock: 1615,
  SW_9060_ConnorsLakefront: 1616,
  SW_9061_RestAssured: 1617,
  SW_9062_BluebirdFeather: 1618,
  SW_9063_PorchCeiling: 1619,
  SW_9064_BluesyNote: 1620,
  SW_9065_PerfectPeriwinkle: 1621,
  SW_9066_Agapanthus: 1622,
  SW_9067_ForeverLilac: 1623,
  SW_9068_BerryFrappe: 1624,
  SW_9069_VeriBerri: 1625,
  SW_9070_BabyBlueEyes: 1626,
  SW_9071_DyersWoad: 1627,
  SW_9072_DriedLavender: 1628,
  SW_9073_DustyHeather: 1629,
  SW_9074_GentleGrape: 1630,
  SW_9075_BerryCream: 1631,
  SW_9076_RubyViolet: 1632,
  SW_9077_RosalinePearl: 1633,
  SW_9078_CocoaBerry: 1634,
  SW_9079_VelvetyChestnut: 1635,
  SW_9080_HushedAuburn: 1636,
  SW_9081_RedendPoint: 1637,
  SW_9082_ChocolatePowder: 1638,
  SW_9083_DustedTruffle: 1639,
  SW_9084_CocoaWhip: 1640,
  SW_9085_TouchofSand: 1641,
  SW_9086_CoolBeige: 1642,
  SW_9087_SmokyBeige: 1643,
  SW_9088_Utaupeia: 1644,
  SW_9089_LlamaWool: 1645,
  SW_9090_Caraibe: 1646,
  SW_9091_HalfCaff: 1647,
  SW_9092_IcedMocha: 1648,
  SW_9093_NearlyBrown: 1649,
  SW_9094_PlayaArenosa: 1650,
  SW_9095_GingerRoot: 1651,
  SW_9096_BeigeIntenso: 1652,
  SW_9097_SoftFawn: 1653,
  SW_9098_BakedCookie: 1654,
  SW_9099_SaddleUp: 1655,
  SW_9100_UmberRust: 1656,
  SW_9101_TresNaturale: 1657,
  SW_9102_Quinoa: 1658,
  SW_9103_Farro: 1659,
  SW_9104_WovenWicker: 1660,
  SW_9105_AlmondRoca: 1661,
  SW_9106_ElCaramelo: 1662,
  SW_9107_UberUmber: 1663,
  SW_9108_DoubleLatte: 1664,
  SW_9109_NaturalLinen: 1665,
  SW_9110_Malabar: 156,
  SW_9111_AntlerVelvet: 1666,
  SW_9112_SongThrush: 1667,
  SW_9113_Mudslide: 1668,
  SW_9114_FallenLeaves: 1669,
  SW_9115_CowboyBoots: 1670,
  SW_9116_SerengetiGrass: 1671,
  SW_9117_UrbanJungle: 1672,
  SW_9118_TarnishedTreasure: 1673,
  SW_9119_DirtyMartini: 1674,
  SW_9120_TumblinTumbleweed: 1675,
  SW_9121_SawgrassBasket: 1676,
  SW_9122_DriedEdamame: 1677,
  SW_9123_BarroVerde: 1678,
  SW_9124_VerdeMarron: 1679,
  SW_9125_OlivaOscuro: 1680,
  SW_9126_HonedSoapstone: 104,
  SW_9127_AtEaseSoldier: 1681,
  SW_9128_GreenOnyx: 1682,
  SW_9129_JadeDragon: 1683,
  SW_9130_EvergreenFog: 276,
  SW_9131_CornwallSlate: 146,
  SW_9132_AcaciaHaze: 1684,
  SW_9133_JasperStone: 1685,
  SW_9134_Delft: 1686,
  SW_9135_Whirlpool: 1687,
  SW_9136_Lullaby: 1688,
  SW_9137_NieblaAzul: 1689,
  SW_9138_Stardew: 1690,
  SW_9139_Debonair: 1691,
  SW_9140_BlusterySky: 1692,
  SW_9141_Waterloo: 170,
  SW_9142_MoscowMidnight: 1693,
  SW_9143_Cadet: 277,
  SW_9144_Moonmist: 1694,
  SW_9145_SleepyHollow: 1695,
  SW_9146_FadedFlaxflower: 1696,
  SW_9147_FavoriteJeans: 150,
  SW_9148_SmokyAzurite: 1697,
  SW_9149_InkyBlue: 1698,
  SW_9150_EndlessSea: 1699,
  SW_9151_Daphne: 1700,
  SW_9152_LetItRain: 1701,
  SW_9153_MoonlitOrchid: 1702,
  SW_9154_PerleNoir: 162,
  SW_9155_SlateViolet: 1703,
  SW_9156_GrisMorado: 1704,
  SW_9157_AutumnOrchid: 1705,
  SW_9158_Coquina: 1706,
  SW_9159_AugerShell: 1707,
  SW_9160_Armadillo: 1708,
  SW_9161_Dustblu: 1709,
  SW_9162_AfricanGray: 1710,
  SW_9163_TinLizzie: 222,
  SW_9164_IllusiveGreen: 1711,
  SW_9165_GossamerVeil: 1712,
  SW_9166_DriftOfMist: 1713,
  SW_9167_PolishedConcrete: 1714,
  SW_9168_ElephantEar: 107,
  SW_9169_ChaturaGray: 1715,
  SW_9170_Acier: 1716,
  SW_9171_FeltedWool: 278,
  SW_9172_StudioClay: 1717,
  SW_9173_Shiitake: 1718,
  SW_9174_MothWing: 1719,
  SW_9175_DeepForestBrown: 1720,
  SW_9176_DressBlues: 1721,
  SW_9177_SaltyDog: 1722,
  SW_9178_IntheNavy: 1723,
  SW_9179_AnchorsAweigh: 1724,
  SW_9180_AgedWhite: 1725,
  SW_9182_RojoMarron: 1726,
  SW_9183_DarkClove: 1727,
  SW_9184_FoxhallGreen: 1728,
  SW_9185_MareaBaja: 1729,
  SW_9186_Caramelized: 1730,
  SW_9500_Ultrawhite: 20879,
  SW_9501_OatMilk: 20880,
  SW_9502_Arrowroote: 20881,
  SW_9503_Cheviot: 20882,
  SW_9504_ColdFoam: 4463,
  SW_9505_FrostBite: 20883,
  SW_9506_WarmWinter: 20884,
  SW_9507_CreamAndSugar: 20885,
  SW_9508_NaturalWool: 20886,
  SW_9509_SteamedChai: 20887,
  SW_9510_PeaceOfMind: 20888,
  SW_9511_WarmOats: 20889,
  SW_9512_ThreadedLoom: 20890,
  SW_9513_SleepyOwlet: 20891,
  SW_9514_ZincLuster: 20892,
  SW_9515_Tungsten: 20893,
  SW_9516_Accolade: 20894,
  SW_9517_Outrigger: 20895,
  SW_9518_Featherstone: 20896,
  SW_9519_CountryTweed: 10805,
  SW_9520_Nocturne: 20897,
  SW_9521_SimpleStone: 20898,
  SW_9522_Meander: 20899,
  SW_9523_CanalStreet: 20900,
  SW_9524_CrookedRiver: 20901,
  SW_9525_HiddenTrail: 20902,
  SW_9526_WoolenMittens: 20903,
  SW_9527_WornKhaki: 20904,
  SW_9528_Vintage: 20905,
  SW_9529_TwigBasket: 20906,
  SW_9530_Momentum: 20907,
  SW_9531_StoneGuardians: 20908,
  SW_9532_EarthyOchre: 20909,
  SW_9533_RattanPalm: 20910,
  SW_9534_RiverReed: 20911,
  SW_9535_Nettle: 20912,
  SW_9536_LambsWool: 20913,
  SW_9537_SugaredAlmond: 20914,
  SW_9538_TangledTwine: 20915,
  SW_9539_ShakerPeg: 20916,
  SW_9540_TimberBeam: 20917,
  SW_9541_WhiteSnow: 2130,
  SW_9542_NaturalWhite: 20918,
  SW_9543_Gypsum: 2131,
  SW_9544_Dashing: 20919,
  SW_9545_Ghosted: 20920,
  SW_9546_LunarLite: 20921,
  SW_9547_Vessel: 20922,
  SW_9548_SweaterWeather: 20923,
  SW_9549_TouchOfGrey: 20924,
  SW_9550_Mercurial: 20925,
  SW_9551_SkippingRocks: 20926,
  SW_9552_Antimony: 20927,
  SW_9553_Allegory: 1803,
  SW_9554_GoingGrey: 20928,
  SW_9555_StormWarning: 20929,
  SW_9556_IntrepidGrey: 20930,
  SW_9557_Autonomous: 20931,
  SW_9558_Castlegate: 20932,
  SW_9559_ScatteredShowers: 20933,
  SW_9560_NightOut: 20934,
  SW_9561_GuildGrey: 20935,
  SW_9562_Fortitude: 20936,
  SW_9563_Bedrock: 20937,
  SW_9564_BeforeTheStorm: 20938,
  SW_9565_ForgedSteel: 11424,
  SW_9566_GreyHeron: 20939,
  SW_9567_Viaduct: 20940,
  SW_9568_SmoothStone: 20941,
  SW_9569_Alloy: 20942,
  SW_9570_Ironclad: 20943,
  SW_9571_Solstice: 20944,
  SW_9572_WarmPewter: 20945,
  SW_9573_Hibernate: 20946,
  SW_9574_HulettOre: 20947,
  SW_9575_Metropolis: 20948,
  SW_9576_Whirlwind: 20949,
  SW_9577_SoftSuede: 20950,
  SW_9578_Restoration: 20951,
  SW_9579_TimelessTaupe: 20952,
  SW_9580_CrackedPepper: 1804,
  SW_9581_Cotton: 20953,
  SW_9582_WhiteSand: 20954,
  SW_9583_Sanctuary: 20955,
  SW_9584_Mortar: 20956,
  SW_9585_Sunbleached: 20957,
  SW_9586_WhiteSesame: 4464,
  SW_9587_Mushroom: 20958,
  SW_9588_HighSierra: 20959,
  SW_9589_Limewash: 20960,
  SW_9590_TaupeOfTheMorning: 20961,
  SW_9591_Whisper: 4462,
  SW_9592_Illusion: 20962,
  SW_9593_LauristonStone: 20963,
  SW_9594_Settlement: 20964,
  SW_9595_Braintree: 20965,
  SW_9596_Pachyderm: 20966,
  SW_9597_WesternReserve: 20967,
  SW_9598_SolitarySlate: 20968,
  SW_9599_Limestone: 20969,
  SW_9600_Armory: 20970,
  SW_9601_Symmetry: 20971,
  SW_9602_StudioBeige: 20972,
  SW_9603_QuarryStone: 20973,
  SW_9604_TeaLeaf: 20974,
  SW_9605_Clove: 20975,
  SW_9606_SlumberSloth: 20976,
  SW_9607_Tanglewood: 20977,
  SW_9608_Habitat: 20978,
  SW_9609_Landmark: 20979,
  SW_9610_StonyCreek: 20980,
  SW_9611_Minimalist: 20981,
  SW_9612_PerfectKhaki: 20982,
  SW_9613_Terrain: 20983,
  SW_9614_CarriageStone: 20984,
  SW_9615_Prospect: 20985,
  SW_9616_Dumpling: 20986,
  SW_9617_Beachcomber: 20987,
  SW_9618_Woodbridge: 20988,
  SW_9619_Teakwood: 20989,
  SW_9620_Prelude: 20990,
  SW_9621_CleanSlate: 20991,
  SW_9622_WhiteSail: 20992,
  SW_9623_Snowbelt: 20993,
  SW_9624_WinsomeGrey: 20994,
  SW_9625_GreyMist: 20995,
  SW_9626_GlacierBay: 20996,
  SW_9627_PacificFog: 20997,
  SW_9628_WinterWalk: 20998,
  SW_9629_Constellation: 20999,
  SW_9630_Moorstone: 21000,
  SW_9631_Mantra: 21001,
  SW_9632_Serenely: 21002,
  SW_9633_SilverLake: 21003,
  SW_9634_MorningAtSea: 21004,
  SW_9635_Stargazer: 10584,
  SW_9636_Windchill: 21005,
  SW_9637_Mineral: 21006,
  SW_9638_Breakwater: 21007,
  SW_9639_RainCloud: 21008,
  SW_9640_SeaMariner: 21009,
  SW_9641_DewDrop: 21010,
  SW_9642_SilverTippedSage: 21011,
  SW_9643_Eventide: 21012,
  SW_9644_Portsmouth: 21013,
  SW_9645_BigDipper: 21014,
  SW_9646_Create: 21015,
  SW_9647_SoftSage: 21016,
  SW_9648_FrostedFern: 21017,
  SW_9649_Willowleaf: 21018,
  SW_9650_Succulent: 6574,
  SW_9651_SeaSpray: 21019,
  SW_9652_HazelGaze: 21020,
  SW_9653_ForeverGreen: 21021,
  SW_9654_Taiga: 21022,
  SW_9655_MountainPass: 21023,
  SW_9656_PineFrost: 21024,
  SW_9657_Piedmont: 21025,
  SW_9658_FreshEucalyptus: 21026,
  SW_9659_Marine: 21027,
  SW_9660_Tarragon: 10635,
  SW_9661_RadiantDawn: 21028,
  SW_9662_FreshZest: 21029,
  SW_9663_Honeypot: 21030,
  SW_9664_SunSalutation: 21031,
  SW_9665_SunnySideUp: 21032,
  SW_9666_BarelyPear: 21033,
  SW_9667_Carambola: 21034,
  SW_9668_WildLime: 21035,
  SW_9669_GladeGreen: 21036,
  SW_9670_Olivetone: 21037,
  SW_9671_Serendipity: 21038,
  SW_9672_Wavecrest: 21039,
  SW_9673_Valleyview: 21040,
  SW_9674_Leaflet: 21041,
  SW_9675_Westhaven: 21042,
  SW_9676_GreenGlimpse: 21043,
  SW_9677_Kingston: 21044,
  SW_9678_HollyGlen: 21045,
  SW_9679_Juniper: 21046,
  SW_9680_NightWatch: 21047,
  SW_9681_Rainsong: 21048,
  SW_9682_SilentRipple: 21049,
  SW_9683_Lakeside: 10585,
  SW_9684_AzureTide: 10678,
  SW_9685_AfterTheStorm: 4465,
  SW_9686_Opalescent: 21050,
  SW_9687_BlueIris: 21051,
  SW_9688_ModernLavender: 21052,
  SW_9689_RipeBerry: 21053,
  SW_9690_MountainFig: 21054,
  SW_9691_Crystalline: 21055,
  SW_9692_CottonCandy: 21056,
  SW_9693_RosePink: 21057,
  SW_9694_WildPoppy: 21058,
  SW_9695_Beetroot: 21059,
  SW_9696_PalePink: 21060,
  SW_9697_LotusPetal: 21061,
  SW_9698_Corallite: 21062,
  SW_9699_StoneFruit: 21063,
  SW_9700_FullBloom: 21064,
};

const DMC_Superior = {
  Superior_Almond: 10551,
  Superior_Black: 10552,
  Superior_Clay: 10553,
  Superior_White: 10554,
};

const DMC_SystemColors = {
  Black: 0,
  Blue: 1,
  Brown: 2,
  Cream: 3,
  Dark_Blue: 4,
  Dark_Brown: 5,
  Dark_Cream: 6,
  Dark_Green: 7,
  Dark_Orange: 8,
  Dark_Purple: 9,
  Dark_Red: 10,
  Dark_Turquoise: 11,
  Dark_Yellow: 12,
  Darkest_Blue: 2262,
  Darkest_Brown: 2263,
  Darkest_Cream: 2264,
  Darkest_Green: 2265,
  Darkest_Orange: 2266,
  Darkest_Purple: 2267,
  Darkest_Red: 2268,
  Darkest_Turquoise: 2269,
  Darkest_Yellow: 2270,
  Gray40: 13,
  Gray55: 14,
  Gray70: 15,
  Gray80: 16,
  Gray90: 17,
  Green: 18,
  Light_Blue: 19,
  Light_Brown: 20,
  Light_Cream: 21,
  Light_Green: 22,
  Light_Orange: 23,
  Light_Purple: 24,
  Light_Red: 25,
  Light_Turquoise: 26,
  Light_Yellow: 27,
  Orange: 28,
  Pink: 29,
  Purple: 30,
  Red: 31,
  Turquoise: 32,
  Very_Dark_Turquoise: 2015,
  White: 33,
  Yellow: 34,
};

const DMC_ThermaTru = {
  TT_Alpine: 1792,
  TT_ArcticIce: 10765,
  TT_Cabernet: 1793,
  TT_Canyon: 10766,
  TT_Chestnut: 1794,
  TT_Cypress: 1795,
  TT_Elk: 10767,
  TT_Estuary: 10768,
  TT_GoldenWheat: 10769,
  TT_Granite: 1796,
  TT_Indigo: 1797,
  TT_NaturalOak: 10658,
  TT_Obsidian: 10770,
  TT_Onyx: 1798,
  TT_Peregrine: 10771,
  TT_RubyRed: 1799,
};

const DMC_TimberTech = {
  TimberTech_AntiqueLeather: 10975,
  TimberTech_Brownstone: 10545,
  TimberTech_CoconutHusk: 36292,
  TimberTech_DarkCocoa: 11363,
  TimberTech_DarkTeak: 10976,
  TimberTech_Kona: 10546,
  TimberTech_SeaSaltGray: 36293,
  TimberTech_SlateGray: 10547,
};

const DMC_UnionCorrugating = {
  UC_ArticWhite: 2238,
  UC_BarnRed: 2239,
  UC_Black: 2240,
  UC_Burgundy: 2241,
  UC_BurnishedSlate: 2242,
  UC_CharcoalGray: 2243,
  UC_Clay: 2244,
  UC_CocoaBrown: 2245,
  UC_CopperMetallic: 2246,
  UC_Evergreen: 2247,
  UC_GalleryBlue: 2248,
  UC_Ivory: 2249,
  UC_LightBrown: 2250,
  UC_LightStone: 2251,
  UC_MarineGreen: 2252,
  UC_PatriotRed: 2253,
  UC_PearlGray: 2254,
  UC_RoyalBlue: 2255,
  UC_SaharaTan: 2256,
  UC_White: 2257,
};

const DMC_Valspar = {
  Valspar_1001_WesternSandstone: 33435,
  Valspar_1002_MarchIce: 33436,
  Valspar_1003_MarchBreeze: 33437,
  Valspar_1004_CosmicPink: 33438,
  Valspar_1005_RaspberrySorbet: 33439,
  Valspar_10059A_RichChocolate: 1887,
  Valspar_1006_PinkPlunge: 33440,
  Valspar_1007_MagicWand: 33441,
  Valspar_1008_PinkOdyssey: 33442,
  Valspar_1009_PinkMist: 33443,
  Valspar_1010_VelvetBeret: 33444,
  Valspar_1011_PurplePhantom: 33445,
  Valspar_10118_AntiqueBurgundy: 1888,
  Valspar_1012_GleefulJoy: 33446,
  Valspar_1013_FancyPansy: 33447,
  Valspar_1014_PlayfulPetal: 33448,
  Valspar_1016_PurpleValley: 33449,
  Valspar_1017_PurpleHills: 33450,
  Valspar_1018_IrisBlossom: 33451,
  Valspar_1019_OrchidHouse: 33452,
  Valspar_1020_PurplingDawn: 33453,
  Valspar_1022_SweetCurrant: 33454,
  Valspar_102285_SeaUrchin: 33455,
  Valspar_102286_LavenderBlaze: 33456,
  Valspar_102287_VoodooViolet: 33457,
  Valspar_102288_PinkPony: 33458,
  Valspar_102289_Dragonflies: 33459,
  Valspar_102290_MadAboutMagenta: 33460,
  Valspar_102291_PinkLemonade: 33461,
  Valspar_102292_FlowerPower: 33462,
  Valspar_102293_MagentaManicure: 33463,
  Valspar_102294_PinkDiamond: 33464,
  Valspar_102295_DoubleBubble: 33465,
  Valspar_102296_ShePouts: 33466,
  Valspar_102297_Piglet: 33467,
  Valspar_102298_SweetCaroline: 33468,
  Valspar_102299_ConBrio: 33469,
  Valspar_1023_SimplePlum: 33470,
  Valspar_102300_CandyKisses: 33471,
  Valspar_102301_PoutyPink: 33472,
  Valspar_102302_PlanetFever: 33473,
  Valspar_102303_PetalSoft: 33474,
  Valspar_102304_TropicalParadise: 33475,
  Valspar_102305_SteelheadRedd: 33476,
  Valspar_102306_Peachy: 33477,
  Valspar_102307_ShrimpShell: 33478,
  Valspar_102308_CinnamonSunset: 33479,
  Valspar_102309_NeonCloud: 33480,
  Valspar_102310_SweetOrange: 33481,
  Valspar_102311_HeirloomTomato: 33482,
  Valspar_102312_SilkTeddy: 33483,
  Valspar_102313_OrangeZest: 33484,
  Valspar_102314_StorybookSundown: 33485,
  Valspar_102315_Semifreddo: 33486,
  Valspar_102316_OffTheLeashOrange: 33487,
  Valspar_102317_FirstOfFall: 33488,
  Valspar_102318_SherbetPop: 33489,
  Valspar_102319_RipeCantaloupe: 33490,
  Valspar_102320_DarlingClementine: 33491,
  Valspar_102321_Pignoli: 33492,
  Valspar_102322_OrangeMarmalade: 33493,
  Valspar_102323_SunflowerField: 33494,
  Valspar_102324_ChaChaCha: 33495,
  Valspar_102325_JustDucky: 33496,
  Valspar_102326_PencilMeIn: 33497,
  Valspar_102327_Popcorn: 33498,
  Valspar_102328_GlowingReviews: 33499,
  Valspar_102329_KernelOfTruth: 33500,
  Valspar_102330_CreamPuff: 33501,
  Valspar_102331_BeesKnees: 33502,
  Valspar_102332_Bonjour: 33503,
  Valspar_102333_Swallowtail: 33504,
  Valspar_102334_BacklitLemon: 33505,
  Valspar_102335_IlluminateMe: 33506,
  Valspar_102336_DaintyDaisy: 33507,
  Valspar_102337_HiveDelight: 33508,
  Valspar_102338_NectarOfTheGoddess: 33509,
  Valspar_102339_ShermansKeyLime: 33510,
  Valspar_102340_LimeDrop: 33511,
  Valspar_102341_SugarLeaves: 33512,
  Valspar_102342_Chia: 33513,
  Valspar_102343_GreenMamba: 33514,
  Valspar_102344_VintageChartreuse: 33515,
  Valspar_102345_FrostyMargarita: 33516,
  Valspar_102346_GreenCurry: 33517,
  Valspar_102347_AbsintheDreams: 33518,
  Valspar_102348_GreenReflection: 33519,
  Valspar_102349_FreshMown: 33520,
  Valspar_102350_PoolTable: 33521,
  Valspar_102351_LimeFizz: 33522,
  Valspar_102352_LeprechaunLaugh: 33523,
  Valspar_102353_AlwaysGreener: 33524,
  Valspar_102354_RefreshingGreen: 33525,
  Valspar_102355_JoltOfGreen: 33526,
  Valspar_102356_GreenerGrass: 33527,
  Valspar_102357_CuddleBug: 33528,
  Valspar_102358_CleanGreen: 33529,
  Valspar_102359_BilliardTable: 33530,
  Valspar_102360_WoollyMint: 33531,
  Valspar_102361_TurquoiseTwist: 33532,
  Valspar_102362_ShadowsOfTime: 33533,
  Valspar_102363_SkyBlueView: 33534,
  Valspar_102364_DipInThePool: 33535,
  Valspar_102365_SantoriniSeascape: 33536,
  Valspar_102366_InTheShallows: 33537,
  Valspar_102367_SettingSail: 33538,
  Valspar_102368_LightsAtSea: 33539,
  Valspar_102369_HighAltitude: 33540,
  Valspar_102370_UtopiaBeckons: 33541,
  Valspar_102371_TotallyTeal: 33542,
  Valspar_102372_AmbientLight: 33543,
  Valspar_102373_BlueFiesta: 33544,
  Valspar_102374_AmazingSky: 33545,
  Valspar_102375_BabymoonBlue: 33546,
  Valspar_102376_Waterslide: 33547,
  Valspar_102377_BlueToTheBone: 33548,
  Valspar_102378_FreshDawn: 33549,
  Valspar_102379_NaxosSky: 33550,
  Valspar_102380_JourneyIntoNight: 33551,
  Valspar_102381_LadyInWaiting: 33552,
  Valspar_102382_Infinity: 33553,
  Valspar_102383_BlueLobster: 33554,
  Valspar_102384_LingerieBlue: 33555,
  Valspar_102385_BffBlue: 33556,
  Valspar_102386_BlueOnBlue: 33557,
  Valspar_102387_FrostySnowCap: 33558,
  Valspar_102388_DelphiniumCorsage: 33559,
  Valspar_102389_Blueprint: 33560,
  Valspar_102390_Tourmaline: 33561,
  Valspar_102391_PaulaLovesParis: 33562,
  Valspar_102392_Zydeco: 33563,
  Valspar_102393_Beribboned: 33564,
  Valspar_102394_SafeHaven: 33565,
  Valspar_102395_DemonBlue: 33566,
  Valspar_102396_OrchidShimmer: 33567,
  Valspar_102397_LivelyLilac: 33568,
  Valspar_102398_MeadowThistle: 33569,
  Valspar_102399_IzzysMittens: 33570,
  Valspar_102400_VivaciousViolet: 33571,
  Valspar_102401_PurpleSplendor: 33572,
  Valspar_102402_WisteriaWhisper: 33573,
  Valspar_102403_PrivateLabelPink: 33574,
  Valspar_102404_TranquilDusk: 33575,
  Valspar_102405_APlumJob: 33576,
  Valspar_102406_CaliLily: 33577,
  Valspar_102407_BurntOrchid: 33578,
  Valspar_102408_DogRose: 33579,
  Valspar_102409_PinkGems: 33580,
  Valspar_102410_Amelia: 33581,
  Valspar_102411_BossyPantsPink: 33582,
  Valspar_102412_BerryPretty: 33583,
  Valspar_102413_RubyNights: 33584,
  Valspar_102414_CakePop: 33585,
  Valspar_102415_FairyFloss: 33586,
  Valspar_102416_PinkIcing: 33587,
  Valspar_102417_SiannaRose: 33588,
  Valspar_102418_ViveLamour: 33589,
  Valspar_102419_PickledBeet: 33590,
  Valspar_102420_PinkBangles: 33591,
  Valspar_102421_PeelnEatShrimp: 33592,
  Valspar_102422_FaintOfHeart: 33593,
  Valspar_102423_FlightOfFancy: 33594,
  Valspar_102424_CherryKisses: 33595,
  Valspar_102425_RushingRed: 33596,
  Valspar_102426_BunnyEars: 33597,
  Valspar_102427_RuffledParasol: 33598,
  Valspar_102428_CrushedGrapefruit: 33599,
  Valspar_102429_MarmaladeMagic: 33600,
  Valspar_102430_DressedToTheNines: 33601,
  Valspar_102431_PomegranateSeeds: 33602,
  Valspar_102432_PinkSoap: 33603,
  Valspar_102433_PrettyInPeach: 33604,
  Valspar_102434_VenetianPlaster: 33605,
  Valspar_102435_RosyPashmina: 33606,
  Valspar_102436_AutumnIvy: 33607,
  Valspar_102437_RedMaple: 33608,
  Valspar_102438_VintagePeach: 33609,
  Valspar_102439_WordOfMouth: 33610,
  Valspar_102440_PeachSquared: 33611,
  Valspar_102441_Ciao: 33612,
  Valspar_102442_ApricotMocha: 33613,
  Valspar_102443_SlyFox: 33614,
  Valspar_102444_BlushingPeach: 33615,
  Valspar_102445_CoralWisp: 33616,
  Valspar_102446_PlayfulPeach: 33617,
  Valspar_102447_LateBloomer: 33618,
  Valspar_102448_HotWings: 33619,
  Valspar_102449_OpeningNight: 33620,
  Valspar_102450_LightAndFluffy: 33621,
  Valspar_102451_MumsTheWord: 33622,
  Valspar_102452_FrostingOnTheCake: 33623,
  Valspar_102453_TawnyDaylily: 33624,
  Valspar_102454_CaramelizedPeach: 33625,
  Valspar_102455_TortoiseshellSpecs: 33626,
  Valspar_102456_BeyondThePale: 33627,
  Valspar_102457_Tutu: 33628,
  Valspar_102458_Tulle: 33629,
  Valspar_102459_NiceTan: 33630,
  Valspar_102460_BronzeStorm: 33631,
  Valspar_102461_CaramelKisses: 33632,
  Valspar_102462_VanillaFrancaise: 33633,
  Valspar_102463_TangerineSilk: 33634,
  Valspar_102464_BronzeBlush: 33635,
  Valspar_102465_BaDumChing: 33636,
  Valspar_102466_HintOfCaramel: 33637,
  Valspar_102467_SimplySienna: 33638,
  Valspar_102468_MorningBlossom: 33639,
  Valspar_102469_BurnishedGold: 33640,
  Valspar_102470_KingsRansom: 33641,
  Valspar_102471_JazzBrass: 33642,
  Valspar_102472_SweetMulledCider: 33643,
  Valspar_102473_HarvestHome: 33644,
  Valspar_102474_GlowHome: 33645,
  Valspar_102475_CreamOfCauliflower: 33646,
  Valspar_102476_MontanaWheatField: 33647,
  Valspar_102477_BalesOfBrown: 33648,
  Valspar_102478_WheatToast: 33649,
  Valspar_102479_BuddyBuddy: 33650,
  Valspar_102480_LemonBars: 33651,
  Valspar_102481_HalcyonDays: 33652,
  Valspar_102482_GiltTrip: 33653,
  Valspar_102483_GoldenTiger: 33654,
  Valspar_102484_StoneGround: 33655,
  Valspar_102485_ButterSyrup: 33656,
  Valspar_102486_BananaSplit: 33657,
  Valspar_102487_Eggnog: 33658,
  Valspar_102488_ButteredUp: 33659,
  Valspar_102489_SenseOfWonder: 33660,
  Valspar_102490_Strawflower: 33661,
  Valspar_102491_GoldenOchre: 33662,
  Valspar_102492_DearMelissa: 33663,
  Valspar_102493_FloatLikeAButterfly: 33664,
  Valspar_102494_SweetCorn: 33665,
  Valspar_102495_Buzzworthy: 33666,
  Valspar_102496_NewEnglandAutumn: 33667,
  Valspar_102497_Brazen: 33668,
  Valspar_102498_SubtleGlow: 33669,
  Valspar_102499_Beignet: 33670,
  Valspar_102500_StrawHat: 33671,
  Valspar_102501_Excitable: 33672,
  Valspar_102502_SpontaneousSprig: 33673,
  Valspar_102503_NaturalEvolution: 33674,
  Valspar_102504_KelseysCurls: 33675,
  Valspar_102505_PapyrusPlant: 33676,
  Valspar_102506_FurtherAfield: 33677,
  Valspar_102507_SlenderStem: 33678,
  Valspar_102508_ScottishMoss: 33679,
  Valspar_102509_JumpingJuniper: 33680,
  Valspar_102510_Endive: 33681,
  Valspar_102511_CeleryHeart: 33682,
  Valspar_102512_GreenCitrine: 33683,
  Valspar_102513_SummerMoss: 33684,
  Valspar_102514_ParrotFeather: 33685,
  Valspar_102515_FicklePickle: 33686,
  Valspar_102516_EtherealOne: 33687,
  Valspar_102517_SunlitLeaf: 33688,
  Valspar_102518_CreamySpinaci: 33689,
  Valspar_102519_GoldenGreen: 33690,
  Valspar_102520_Stem: 33691,
  Valspar_102521_FarmFresh: 33692,
  Valspar_102522_FernShadow: 33693,
  Valspar_102523_CoolCucumber: 33694,
  Valspar_102524_GreenAlmond: 33695,
  Valspar_102525_Terrarium: 33696,
  Valspar_102526_CurlyGrass: 33697,
  Valspar_102527_FreshCilantro: 33698,
  Valspar_102528_WhiffOfGreen: 33699,
  Valspar_102529_CatWoman: 33700,
  Valspar_102530_FavaBean: 33701,
  Valspar_102531_BavarianHops: 33702,
  Valspar_102532_HerbesDeProvence: 33703,
  Valspar_102533_LoireValley: 33704,
  Valspar_102534_SpringJoy: 33705,
  Valspar_102535_FreshwaterGreen: 33706,
  Valspar_102536_GreenEggsCam: 33707,
  Valspar_102537_FrogPrince: 33708,
  Valspar_102538_Hinterlands: 33709,
  Valspar_102539_PrivetHedge: 33710,
  Valspar_102540_GrasshopperPie: 33711,
  Valspar_102541_CucumberCrush: 33712,
  Valspar_102542_DriedBasil: 33713,
  Valspar_102543_ScottishHighlands: 33714,
  Valspar_102544_GreenMantle: 33715,
  Valspar_102545_EmeraldTemple: 33716,
  Valspar_102546_WitchsBrew: 33717,
  Valspar_102547_CoolJuniper: 33718,
  Valspar_102548_PatinaHue: 33719,
  Valspar_102549_HarmonyInGreen: 33720,
  Valspar_102550_LeapingLizard: 33721,
  Valspar_102551_ForestShadows: 33722,
  Valspar_102552_OceanSilk: 33723,
  Valspar_102553_SeaInspired: 33724,
  Valspar_102554_FloatYourBoat: 33725,
  Valspar_102555_Intracoastal: 33726,
  Valspar_102556_AussieSurf: 33727,
  Valspar_102557_BreatheDeeply: 33728,
  Valspar_102558_TouchOfFrost: 33729,
  Valspar_102559_Brilliante: 33730,
  Valspar_102560_ElectroChill: 33731,
  Valspar_102561_EnchantedIsle: 33732,
  Valspar_102562_AmazonDrift: 33733,
  Valspar_102563_PlanetEarth: 33734,
  Valspar_102564_RingBoxBlue: 33735,
  Valspar_102565_ClearCove: 33736,
  Valspar_102566_Aquamarine: 33737,
  Valspar_102567_CrestingWaves: 33738,
  Valspar_102568_PoseidonsCastle: 33739,
  Valspar_102569_FishTale: 33740,
  Valspar_102570_HaikuBlue: 33741,
  Valspar_102571_Droplet: 33742,
  Valspar_102572_CeruleanSkies: 33743,
  Valspar_102573_SmokyMountainSpring: 33744,
  Valspar_102574_OceanReef: 33745,
  Valspar_102575_BanksonLake: 33746,
  Valspar_102576_MorningGlory: 33747,
  Valspar_102577_SoothingBlue: 33748,
  Valspar_102578_MosaicBlue: 33749,
  Valspar_102579_BlueChiffon: 33750,
  Valspar_102580_Rickrack: 33751,
  Valspar_102581_OceanRadiance: 33752,
  Valspar_102582_BlueBouquet: 33753,
  Valspar_102583_NewPrince: 33754,
  Valspar_102584_Boutonniere: 33755,
  Valspar_102585_CrispFrenchBlue: 33756,
  Valspar_102586_CottageByTheSea: 33757,
  Valspar_102587_GulfCoast: 33758,
  Valspar_102588_ChapelChoir: 33759,
  Valspar_102589_DecemberSolstice: 33760,
  Valspar_102590_21stCenturyBlue: 33761,
  Valspar_102591_BlueTopaz: 33762,
  Valspar_102592_LakeHenry: 33763,
  Valspar_102593_BackOfBeyond: 33764,
  Valspar_102594_SerendipityBlue: 33765,
  Valspar_102595_PatricksPerfectDay: 33766,
  Valspar_102596_Tribute: 33767,
  Valspar_102597_EsteroSky: 33768,
  Valspar_102598_InTheMood: 33769,
  Valspar_102599_CravinCobalt: 33770,
  Valspar_102600_CacheBlue: 33771,
  Valspar_102601_PrestigeBlue: 33772,
  Valspar_102602_DoubleDenim: 33773,
  Valspar_102603_BooBlue: 33774,
  Valspar_102604_BlueberryFestival: 33775,
  Valspar_102605_KatesRing: 33776,
  Valspar_102606_BlueRomance: 33777,
  Valspar_102607_PeriwinkleDream: 33778,
  Valspar_102608_WingsOfPegasus: 33779,
  Valspar_102609_Violetta: 33780,
  Valspar_102610_SmokyViolet: 33781,
  Valspar_102611_EpicAdventure: 33782,
  Valspar_102612_LoveCrystal: 33783,
  Valspar_102613_CarouselPurple: 33784,
  Valspar_102614_CanopyBed: 33785,
  Valspar_102615_LavenderBlue: 33786,
  Valspar_102616_BlueBatik: 33787,
  Valspar_102617_DeepOceanFloor: 33788,
  Valspar_102618_PalePurple: 33789,
  Valspar_102619_MyMona: 33790,
  Valspar_102620_ReallyRomantic: 33791,
  Valspar_102621_FieldsOfProvence: 33792,
  Valspar_102622_PurpleSuede: 33793,
  Valspar_102623_DriedLilacs: 33794,
  Valspar_102624_EternalMoonrise: 33795,
  Valspar_102625_Mischief: 33796,
  Valspar_102626_LilacBlossom: 33797,
  Valspar_102627_RomanticHoliday: 33798,
  Valspar_102628_Plummy: 33799,
  Valspar_102629_RipeMulberry: 33800,
  Valspar_102630_SleepyKisses: 33801,
  Valspar_102631_ScentedSoap: 33802,
  Valspar_102632_TwilightBloom: 33803,
  Valspar_102633_Pinterested: 33804,
  Valspar_102634_PurpleSunset: 33805,
  Valspar_102635_RoyalVelvet: 33806,
  Valspar_102636_BarelyBerry: 33807,
  Valspar_102637_PocketfulOfPromise: 33808,
  Valspar_102638_MediterraneanSunset: 33809,
  Valspar_102639_VioletDusk: 33810,
  Valspar_102640_MauvingUp: 33811,
  Valspar_102641_Merlot: 33812,
  Valspar_102642_WideEyed: 33813,
  Valspar_102643_PinkPampas: 33814,
  Valspar_102644_PinkCocoaCupcake: 33815,
  Valspar_102645_TwiceShy: 33816,
  Valspar_102646_TaffetaDarling: 33817,
  Valspar_102647_MaroonRover: 33818,
  Valspar_102648_GentleKiss: 33819,
  Valspar_102649_CanyonHush: 33820,
  Valspar_102650_PinkCocoa: 33821,
  Valspar_102651_CeremonialOchre: 33822,
  Valspar_102652_CranberryFoule: 33823,
  Valspar_102653_MoltenSulphur: 33824,
  Valspar_102654_Pinkwash: 33825,
  Valspar_102655_ApricotBlush: 33826,
  Valspar_102656_TerraCottaBlush: 33827,
  Valspar_102657_BurnishedApricot: 33828,
  Valspar_102658_AgedBourbon: 33829,
  Valspar_102659_TwoCents: 33830,
  Valspar_102660_BareNecessity: 33831,
  Valspar_102661_PrettyRascal: 33832,
  Valspar_102662_SweetBeige: 33833,
  Valspar_102663_BelfryBrick: 33834,
  Valspar_102664_FreckleFace: 33835,
  Valspar_102665_ChocolateBonbon: 33836,
  Valspar_102666_PinkBeach: 33837,
  Valspar_102667_RenaissanceFresco: 33838,
  Valspar_102668_AdobeVillage: 33839,
  Valspar_102669_FadedRedwood: 33840,
  Valspar_102670_WalkingStick: 33841,
  Valspar_102671_RidingBoots: 33842,
  Valspar_102672_SirenSong: 33843,
  Valspar_102673_FreshBaked: 33844,
  Valspar_102674_EmeryBoard: 33845,
  Valspar_102675_Dockside: 33846,
  Valspar_102676_BrownieScout: 33847,
  Valspar_102677_Incognito: 33848,
  Valspar_102678_SevenVeils: 33849,
  Valspar_102679_CinnamonFoam: 33850,
  Valspar_102680_MapleTan: 33851,
  Valspar_102681_CinnamonScone: 33852,
  Valspar_102682_GingerbreadBrick: 33853,
  Valspar_102683_ChateauMantle: 33854,
  Valspar_102684_CozyCoverlet: 33855,
  Valspar_102685_SoBaja: 33856,
  Valspar_102686_KeyWester: 33857,
  Valspar_102687_FreckledNose: 33858,
  Valspar_102688_MustLoveDogs: 33859,
  Valspar_102689_Valise: 33860,
  Valspar_102690_SeriousMoonlight: 33861,
  Valspar_102691_GroupHug: 33862,
  Valspar_102692_WovenJute: 33863,
  Valspar_102693_SassafrasTea: 33864,
  Valspar_102694_BrownButton: 33865,
  Valspar_102695_FreshRoe: 33866,
  Valspar_102696_Peachfizz: 33867,
  Valspar_102697_SilkenStockings: 33868,
  Valspar_102698_UncommonCoir: 33869,
  Valspar_102699_Corky: 33870,
  Valspar_102700_NomNom: 33871,
  Valspar_102701_LeatherLace: 33872,
  Valspar_102702_FuzzyScruff: 33873,
  Valspar_102703_SpicedLatte: 33874,
  Valspar_102704_Toasty: 33875,
  Valspar_102705_AncientFresco: 33876,
  Valspar_102706_HorsingAround: 33877,
  Valspar_102707_PoloPony: 33878,
  Valspar_102708_Bubbly: 33879,
  Valspar_102709_TouchOfTan: 33880,
  Valspar_102710_Moraine: 33881,
  Valspar_102711_HawkFeather: 33882,
  Valspar_102712_CaramelSuede: 33883,
  Valspar_102713_VintageCaramel: 33884,
  Valspar_102714_PureAlmond: 33885,
  Valspar_102715_PaintedAsh: 33886,
  Valspar_102716_WholeGrain: 33887,
  Valspar_102717_LionsSlumber: 33888,
  Valspar_102718_Mandolin: 33889,
  Valspar_102719_Derby: 33890,
  Valspar_102720_Candelabra: 33891,
  Valspar_102721_OatsAndHoney: 33892,
  Valspar_102722_Prairie: 33893,
  Valspar_102723_CreoleMustard: 33894,
  Valspar_102724_FieldsOfGlory: 33895,
  Valspar_102725_JoshuaTree: 33896,
  Valspar_102726_FilteredLight: 33897,
  Valspar_102727_GoldenRetriever: 33898,
  Valspar_102728_CasualKhaki: 33899,
  Valspar_102729_ModernAvocado: 33900,
  Valspar_102730_BranchingOutOlive: 33901,
  Valspar_102731_FlorentineDream: 33902,
  Valspar_102732_Quill: 33903,
  Valspar_102733_GardenRain: 33904,
  Valspar_102734_FarSideOfTheMountain: 33905,
  Valspar_102735_Ecosystem: 33906,
  Valspar_102736_OliveBoat: 33907,
  Valspar_102737_BlueCheeseOlive: 33908,
  Valspar_102738_AsianSilk: 33909,
  Valspar_102739_WildHillside: 33910,
  Valspar_102740_BotanicalBeauty: 33911,
  Valspar_102741_SummerValley: 33912,
  Valspar_102742_CrocodileStyle: 33913,
  Valspar_102743_TuscanHills: 33914,
  Valspar_102744_WhiteMoss: 33915,
  Valspar_102745_TeaParty: 33916,
  Valspar_102746_GreenWillow: 33917,
  Valspar_102747_FondOfFronds: 33918,
  Valspar_102748_GreekOregano: 33919,
  Valspar_102749_MountainMoss: 33920,
  Valspar_102750_GardenMint: 33921,
  Valspar_102751_Succulent: 33922,
  Valspar_102752_StormyDay: 33923,
  Valspar_102753_AgreeableGreen: 33924,
  Valspar_102754_NatureLover: 33925,
  Valspar_102755_HauteGreen: 33926,
  Valspar_102756_ApothecaryJar: 33927,
  Valspar_102757_CottageCharm: 33928,
  Valspar_102758_SighOfRelief: 33929,
  Valspar_102759_SilverEucalyptus: 33930,
  Valspar_102760_Privet: 33931,
  Valspar_102761_Thunderbolt: 33932,
  Valspar_102762_AlpinePeak: 33933,
  Valspar_102763_FountainFoam: 33934,
  Valspar_102764_GrayEmbrace: 33935,
  Valspar_102765_AtlanticFoam: 33936,
  Valspar_102766_ZincBlue: 33937,
  Valspar_102767_JadeSea: 33938,
  Valspar_102768_SoftHaze: 33939,
  Valspar_102769_TakeAHike: 33940,
  Valspar_102770_MistyDreams: 33941,
  Valspar_102771_AprilRain: 33942,
  Valspar_102772_PacificPalisades: 33943,
  Valspar_102773_Prehistoric: 33944,
  Valspar_102774_PearlyJade: 33945,
  Valspar_102775_CoolMint: 33946,
  Valspar_102776_BotanicalBliss: 33947,
  Valspar_102777_GinBerry: 33948,
  Valspar_102778_ClassicDamask: 33949,
  Valspar_102779_MidsummerNight: 33950,
  Valspar_102780_SnowInJune: 33951,
  Valspar_102781_LakesideFind: 33952,
  Valspar_102782_WildLife: 33953,
  Valspar_102783_FogBlue: 33954,
  Valspar_102784_ShipShape: 33955,
  Valspar_102785_Riverbend: 33956,
  Valspar_102786_BlueBottle: 33957,
  Valspar_102787_HatchlingBlue: 33958,
  Valspar_102788_WarmBreezes: 33959,
  Valspar_102789_GrandBoulevard: 33960,
  Valspar_102790_SultryBay: 33961,
  Valspar_102791_CathedralView: 33962,
  Valspar_102792_NeededEscape: 33963,
  Valspar_102793_GrandEntrance: 33964,
  Valspar_102794_SebastianInlet: 33965,
  Valspar_102795_MySkiff: 33966,
  Valspar_102796_NightMasque: 33967,
  Valspar_102797_RuggedTeal: 33968,
  Valspar_102798_BlownGlass: 33969,
  Valspar_102799_Shhh: 33970,
  Valspar_1028_HuntingBoots: 33971,
  Valspar_102800_WinterMoss: 33972,
  Valspar_102801_BrocadeBlue: 33973,
  Valspar_102802_OlBlueEyes: 33974,
  Valspar_102803_NightSwim: 33975,
  Valspar_102804_SkinnyDippin: 33976,
  Valspar_102805_SailingOnTheBay: 33977,
  Valspar_102806_DejaBlue: 33978,
  Valspar_102807_BlueNuthatch: 33979,
  Valspar_102808_PlayMeAMelody: 33980,
  Valspar_102809_AmIBlue: 33981,
  Valspar_102810_SoftBlue: 33982,
  Valspar_102811_RichPorcelainBlue: 33983,
  Valspar_102812_BlueLuna: 33984,
  Valspar_102813_CoolCustomer: 33985,
  Valspar_102814_FolkBlue: 33986,
  Valspar_102815_DeepPacific: 33987,
  Valspar_102816_Icy: 33988,
  Valspar_102817_ArcticCircle: 33989,
  Valspar_102818_GlacierBay: 33990,
  Valspar_102819_LakeOkoboji: 33991,
  Valspar_102820_MoodyTeal: 33992,
  Valspar_102821_IndigoGoGo: 33993,
  Valspar_102822_Dreamstress: 33994,
  Valspar_102823_FadedIndigo: 33995,
  Valspar_102824_RuffledFeathers: 33996,
  Valspar_102825_PorcelainVase: 33997,
  Valspar_102826_GoddessOfTheNile: 33998,
  Valspar_102827_MidnightSonata: 33999,
  Valspar_102828_LondonLights: 34000,
  Valspar_102829_CityOfLights: 34001,
  Valspar_102830_BarkingCreek: 34002,
  Valspar_102831_MorrisBlue: 34003,
  Valspar_102832_BlueMarble: 34004,
  Valspar_102833_MykonosReflection: 34005,
  Valspar_102834_WhiteLightning: 34006,
  Valspar_102835_SnowFlurries: 34007,
  Valspar_102836_BlueEcho: 34008,
  Valspar_102837_NorwegianNight: 34009,
  Valspar_102838_TwinkleTwinkle: 34010,
  Valspar_102839_BlueFedora: 34011,
  Valspar_102840_WispySkies: 34012,
  Valspar_102841_BottleflyWings: 34013,
  Valspar_102842_BottlenoseDolphin: 34014,
  Valspar_102843_Statuary: 34015,
  Valspar_102844_Chrome: 34016,
  Valspar_102845_SootyLashes: 34017,
  Valspar_102846_RockyShelter: 34018,
  Valspar_102847_Tinman: 34019,
  Valspar_102848_Tomcat: 34020,
  Valspar_102849_HarpStrings: 34021,
  Valspar_102850_CloudMountain: 34022,
  Valspar_102851_DecoGray: 34023,
  Valspar_102852_ShallowSkies: 34024,
  Valspar_102853_MadeInTheShade: 34025,
  Valspar_102854_ToTheTarmac: 34026,
  Valspar_102855_PondFrost: 34027,
  Valspar_102856_WheelsUp: 34028,
  Valspar_102857_GothamCity: 34029,
  Valspar_102858_MrKitty: 34030,
  Valspar_102859_StatelyGraystone: 34031,
  Valspar_102860_GlenPlaid: 34032,
  Valspar_102861_KittyWhiskers: 34033,
  Valspar_102862_FourWheelGray: 34034,
  Valspar_102863_Magpie: 34035,
  Valspar_102864_SilverThistleDown: 34036,
  Valspar_102865_StillLifeInGray: 34037,
  Valspar_102866_BlackHeron: 34038,
  Valspar_102867_SilverBonnet: 34039,
  Valspar_102868_ClassicGrayscale: 34040,
  Valspar_102869_PortlandTwilight: 34041,
  Valspar_102870_NewYorkCityWinter: 34042,
  Valspar_102871_SculptingClay: 34043,
  Valspar_102872_CatchOfTheDay: 34044,
  Valspar_102873_MoonShot: 34045,
  Valspar_102874_TabbyCatGray: 34046,
  Valspar_102875_Caviar: 34047,
  Valspar_102876_MoonShadow: 34048,
  Valspar_102877_Apollo: 34049,
  Valspar_102878_Ganymede: 34050,
  Valspar_102879_FeatherQuill: 34051,
  Valspar_102880_NatureWalk: 34052,
  Valspar_102881_SoftPanther: 34053,
  Valspar_102882_BelugaSong: 34054,
  Valspar_102883_WhisperSoft: 34055,
  Valspar_102884_FriskyWhiskers: 34056,
  Valspar_102885_AshlandHeights: 34057,
  Valspar_102886_Wetbar: 34058,
  Valspar_102887_BlackCurrant: 34059,
  Valspar_102888_OrchidBlush: 34060,
  Valspar_102889_PukaShell: 34061,
  Valspar_102890_RosyLinen: 34062,
  Valspar_102891_FoggyMauve: 34063,
  Valspar_102892_GrayGrape: 34064,
  Valspar_102893_SoulSearching: 34065,
  Valspar_102894_MindOfHerOwn: 34066,
  Valspar_102895_DuskInTheValley: 34067,
  Valspar_102896_OysterBay: 34068,
  Valspar_102897_MysticalGray: 34069,
  Valspar_102898_MinkSuede: 34070,
  Valspar_102899_NightSkyscraper: 34071,
  Valspar_1029_ThornyBrush: 34072,
  Valspar_102900_NanasPearls: 34073,
  Valspar_102901_PinkChantilly: 34074,
  Valspar_102902_CathedralMorning: 34075,
  Valspar_102903_EmbarrassedShadow: 34076,
  Valspar_102904_CocoaBerry: 34077,
  Valspar_102905_ChristmasPudding: 34078,
  Valspar_102906_RomanticWhite: 34079,
  Valspar_102907_RabbitsFoot: 34080,
  Valspar_102908_BoardwalkSashay: 34081,
  Valspar_102909_PickOfTheLitter: 34082,
  Valspar_102910_CreamyMocha: 34083,
  Valspar_102911_RueBourbon: 34084,
  Valspar_102912_BasketOfBobbins: 34085,
  Valspar_102913_Windmill: 34086,
  Valspar_102914_TurningTables: 34087,
  Valspar_102915_StateOfMind: 34088,
  Valspar_102916_GatewayArch: 34089,
  Valspar_102917_MomentousOccasion: 34090,
  Valspar_102918_SafariMap: 34091,
  Valspar_102919_WarmAlpaca: 34092,
  Valspar_102920_Panko: 34093,
  Valspar_102921_PuppyLove: 34094,
  Valspar_102922_Nest: 34095,
  Valspar_102923_IfATreeFell: 34096,
  Valspar_102924_CappuccinoFoam: 34097,
  Valspar_102925_CookieDough: 34098,
  Valspar_102926_TailoredTan: 34099,
  Valspar_102927_FashionDistrict: 34100,
  Valspar_102928_ChocolateMilk: 34101,
  Valspar_102929_Buckeye: 34102,
  Valspar_102930_GentleSlumber: 34103,
  Valspar_102931_ManillaRope: 34104,
  Valspar_102932_ShaggyDog: 34105,
  Valspar_102933_GentryGray: 34106,
  Valspar_102934_Cavern: 34107,
  Valspar_102935_ChocolateDiamonds: 34108,
  Valspar_102936_VanderbiltBeach: 34109,
  Valspar_102937_BeachDune: 34110,
  Valspar_102938_SandyTrail: 34111,
  Valspar_102939_SmokyTopaz: 34112,
  Valspar_102940_Skylark: 34113,
  Valspar_102941_Gondola: 34114,
  Valspar_102942_GentleShadows: 34115,
  Valspar_102943_SoftPelican: 34116,
  Valspar_102944_Counterpoint: 34117,
  Valspar_102945_OysterShoal: 34118,
  Valspar_102946_StoneTerrace: 34119,
  Valspar_102947_Crater: 34120,
  Valspar_102948_MercuryGlass: 34121,
  Valspar_102949_DolphinAtPlay: 34122,
  Valspar_102950_StreamlinedGray: 34123,
  Valspar_102951_Lionfish: 34124,
  Valspar_102952_NutsAndBolts: 34125,
  Valspar_102953_WhaleWatching: 34126,
  Valspar_102954_ShadyLady: 34127,
  Valspar_102955_MistyHarbor: 34128,
  Valspar_102956_SteampunkGray: 34129,
  Valspar_102957_WaveGoodbye: 34130,
  Valspar_102958_SteeleBlue: 34131,
  Valspar_102959_Passageway: 34132,
  Valspar_102960_Northbound: 34133,
  Valspar_102961_NewNorth: 34134,
  Valspar_102962_DriftwoodBlues: 34135,
  Valspar_102963_CottageDoor: 34136,
  Valspar_102964_FlannelGray: 34137,
  Valspar_102965_CadetSong: 34138,
  Valspar_102966_SundaySky: 34139,
  Valspar_102967_WindblownBlue: 34140,
  Valspar_102968_LagoonReflection: 34141,
  Valspar_102969_PearlGray: 34142,
  Valspar_102970_BlueThunder: 34143,
  Valspar_102971_MountainMidnight: 34144,
  Valspar_102972_CalmCoolAndCollected: 34145,
  Valspar_102973_ThreeWishes: 34146,
  Valspar_102974_RockSolid: 34147,
  Valspar_102975_PipeDream: 34148,
  Valspar_102976_TheNorthWindBlows: 34149,
  Valspar_102977_ModelT: 34150,
  Valspar_102978_SlowDown: 34151,
  Valspar_102979_LimestonePath: 34152,
  Valspar_102980_KnightsbridgeMist: 34153,
  Valspar_102981_InTheShadows: 34154,
  Valspar_102982_VictorianTapestry: 34155,
  Valspar_102983_FaitAccompli: 34156,
  Valspar_102984_GhostStory: 34157,
  Valspar_102985_ChileanSeaBass: 34158,
  Valspar_102986_GrayGreenLinen: 34159,
  Valspar_102987_DuskyParakeet: 34160,
  Valspar_102988_Campground: 34161,
  Valspar_102989_VintageFrame: 34162,
  Valspar_102990_Transparent: 34163,
  Valspar_102991_RecycledGlass: 34164,
  Valspar_102992_IrishMoor: 34165,
  Valspar_102993_GraciousGray: 34166,
  Valspar_102994_SageSlate: 34167,
  Valspar_102995_JapaneseSeaweed: 34168,
  Valspar_102996_StageWhisper: 34169,
  Valspar_102997_MistyMemory: 34170,
  Valspar_102998_SimpleGray: 34171,
  Valspar_102999_Rigani: 34172,
  Valspar_1030_ChannelSealGray: 34173,
  Valspar_103000_ThamesFog: 34174,
  Valspar_103001_GreenishGray: 34175,
  Valspar_103002_BarestHush: 34176,
  Valspar_103003_ZenPebble: 34177,
  Valspar_103004_BuildingBlock: 34178,
  Valspar_103005_WorldsAway: 34179,
  Valspar_103006_SecretMission: 34180,
  Valspar_103007_TimberGreen: 34181,
  Valspar_103008_SecludedBeach: 34182,
  Valspar_103009_RipplingStone: 34183,
  Valspar_103010_SeineAndSensibility: 34184,
  Valspar_103011_SageTheDay: 34185,
  Valspar_103012_PinePeak: 34186,
  Valspar_103013_GatorTail: 34187,
  Valspar_103014_SheepskinRug: 34188,
  Valspar_103015_SeaGrape: 34189,
  Valspar_103016_OdeToJoy: 34190,
  Valspar_103017_ChurchillDowns: 34191,
  Valspar_103018_WeatheredPlank: 34192,
  Valspar_103019_MidnightForest: 34193,
  Valspar_103020_NewReam: 34194,
  Valspar_103021_BridalWreath: 34195,
  Valspar_103022_SantasBeard: 34196,
  Valspar_103023_WeddingCake: 34197,
  Valspar_103024_GauzyWhite: 34198,
  Valspar_103025_WingsOfAnAngel: 34199,
  Valspar_103026_BubbleBath: 34200,
  Valspar_103027_SoftWool: 34201,
  Valspar_103028_WoolyLamb: 34202,
  Valspar_103029_StarMagnolia: 34203,
  Valspar_103030_PearlyGates: 34204,
  Valspar_103031_Permafrost: 34205,
  Valspar_103032_Snowflake: 34206,
  Valspar_103033_FriendlyGhost: 34207,
  Valspar_103034_WhisperSoftly: 34208,
  Valspar_103035_CanterburyCream: 34209,
  Valspar_103036_DairyBelle: 34210,
  Valspar_103037_OpenArms: 34211,
  Valspar_103038_BiscuitCrumbs: 34212,
  Valspar_103039_NavyBean: 34213,
  Valspar_103040_NiceAndEasy: 34214,
  Valspar_103041_DanceOfTheGoddesses: 34215,
  Valspar_103042_HumbleBeginnings: 34216,
  Valspar_103043_Thundersnow: 34217,
  Valspar_103044_ModernGray: 34218,
  Valspar_103045_CoolVapor: 34219,
  Valspar_103046_DirtyMartini: 34220,
  Valspar_103047_Atmospheric: 34221,
  Valspar_103048_DoubleScoop: 34222,
  Valspar_103049_GentleLamb: 34223,
  Valspar_103050_FossilWhite: 34224,
  Valspar_103051_WarmOatmeal: 34225,
  Valspar_103052_CannelliniBeans: 34226,
  Valspar_103053_OverTheMoon: 34227,
  Valspar_103054_WestchesterWhite: 34228,
  Valspar_103055_MinkFrost: 34229,
  Valspar_103056_LavenderSand: 34230,
  Valspar_103057_PinkPlumeria: 34231,
  Valspar_103058_MadAboutYou: 34232,
  Valspar_103059_SatinTeddy: 34233,
  Valspar_103060_StormyPlum: 34234,
  Valspar_103061_TrolleyDash: 34235,
  Valspar_103062_AzaleaPot: 34236,
  Valspar_103063_CopperCanyon: 34237,
  Valspar_103064_HeirloomApricot: 34238,
  Valspar_103065_HardyClay: 34239,
  Valspar_103066_SoftSkills: 34240,
  Valspar_103067_TanSuede: 34241,
  Valspar_103068_OldPlaster: 34242,
  Valspar_103069_Goldfinch: 34243,
  Valspar_103070_DeviledEggs: 34244,
  Valspar_103071_TurboTan: 34245,
  Valspar_103072_MeltedButter: 34246,
  Valspar_103073_TookieBird: 34247,
  Valspar_103074_ArtichokeMist: 34248,
  Valspar_103075_FriendlyFrog: 34249,
  Valspar_103076_FreshPeas: 34250,
  Valspar_103077_GeekChic: 34251,
  Valspar_103078_GreenwichGreen: 34252,
  Valspar_103079_CoolRunnings: 34253,
  Valspar_103080_SalonGreen: 34254,
  Valspar_103081_RainforestRetreat: 34255,
  Valspar_103082_Zen: 34256,
  Valspar_103083_FavoriteSweater: 34257,
  Valspar_103084_VelvetCurtains: 34258,
  Valspar_103085_Adorbs: 34259,
  Valspar_103086_BlueJayCrest: 34260,
  Valspar_103087_MattOnMonday: 34261,
  Valspar_103088_GulfStreamBlue: 34262,
  Valspar_103089_NordicNoir: 34263,
  Valspar_103090_ElliottBay: 34264,
  Valspar_103091_BlueTulle: 34265,
  Valspar_103092_AuroraBorealis: 34266,
  Valspar_103093_SunriseOverTahiti: 34267,
  Valspar_103094_OohLaLa: 34268,
  Valspar_103095_ThrillRide: 34269,
  Valspar_103096_PowerTie: 34270,
  Valspar_103097_MermaidCheeks: 34271,
  Valspar_103098_ShellPink: 34272,
  Valspar_103099_Rambutan: 34273,
  Valspar_1031_WoolCoat: 34274,
  Valspar_103100_RipePeach: 34275,
  Valspar_103101_Flamenco: 34276,
  Valspar_103102_CopperCloud: 34277,
  Valspar_103103_HaciendaDelSol: 34278,
  Valspar_103104_SleekOtter: 34279,
  Valspar_103105_DestinedForGreatness: 34280,
  Valspar_103106_EtruscanBronze: 34281,
  Valspar_103107_CobblerShop: 34282,
  Valspar_103108_ArlingtonBronze: 34283,
  Valspar_103109_HomeBrew: 34284,
  Valspar_103110_GoldenPagoda: 34285,
  Valspar_103111_Frickles: 34286,
  Valspar_103112_ManzanillaOlive: 34287,
  Valspar_103113_SpringAhead: 34288,
  Valspar_103114_WhirledPeas: 34289,
  Valspar_103115_QuietWaters: 34290,
  Valspar_103116_NewPatina: 34291,
  Valspar_103117_NataliesChalkboard: 34292,
  Valspar_103118_IdyllicIsland: 34293,
  Valspar_103119_DancingPeacock: 34294,
  Valspar_103120_PolarIce: 34295,
  Valspar_103121_BlueBolero: 34296,
  Valspar_103122_Copacabana: 34297,
  Valspar_103123_BlueBirdMorning: 34298,
  Valspar_103124_LeftBankBlue: 34299,
  Valspar_103125_JimbosJersey: 34300,
  Valspar_103126_PleinAir: 34301,
  Valspar_103127_BlueMagpie: 34302,
  Valspar_103128_SeptemberAster: 34303,
  Valspar_103129_DeepestPeriwinkle: 34304,
  Valspar_103130_LycheeBerry: 34305,
  Valspar_103131_SeaFanFuchsia: 34306,
  Valspar_103132_InnocentPink: 34307,
  Valspar_103133_HeartsAfire: 34308,
  Valspar_103134_Lovestruck: 34309,
  Valspar_103135_ThaiChili: 34310,
  Valspar_103136_FleecyDreams: 34311,
  Valspar_103137_PinchOfClove: 34312,
  Valspar_103138_NobodyButBen: 34313,
  Valspar_103139_VanillaIcedCoffee: 34314,
  Valspar_103140_JackO: 34315,
  Valspar_103141_CurlyWillow: 34316,
  Valspar_103142_GildedAge: 34317,
  Valspar_103143_MellowMoment: 34318,
  Valspar_103144_SunbakedStraw: 34319,
  Valspar_103145_EdgyGreen: 34320,
  Valspar_103146_RipePear: 34321,
  Valspar_103147_EarlySprout: 34322,
  Valspar_103148_NouveauGreen: 34323,
  Valspar_103149_FrozenMarguerita: 34324,
  Valspar_103150_FairAndSquare: 34325,
  Valspar_103151_HalfwayGreen: 34326,
  Valspar_103152_Kale: 34327,
  Valspar_103153_EasygoingGreen: 34328,
  Valspar_103154_FriendlyFairway: 34329,
  Valspar_103155_GardenDistrict: 34330,
  Valspar_103156_NurseryWall: 34331,
  Valspar_103157_ForeverTeal: 34332,
  Valspar_103158_DoverSurf: 34333,
  Valspar_103159_UrbanOasis: 34334,
  Valspar_103160_OpenSkies: 34335,
  Valspar_103161_HydrangeaBlue: 34336,
  Valspar_103162_PalaceIntrigue: 34337,
  Valspar_103163_EndlessBlue: 34338,
  Valspar_103164_BabyBoots: 34339,
  Valspar_103165_NightFever: 34340,
  Valspar_103166_FairiesInAmerica: 34341,
  Valspar_103167_RaspberryTruffle: 34342,
  Valspar_103168_StoneAge: 34343,
  Valspar_103169_SpeckledEggs: 34344,
  Valspar_103170_Caliente: 34345,
  Valspar_103171_DesertAtDusk: 34346,
  Valspar_103172_PeachFuzz: 34347,
  Valspar_103173_Rootstock: 34348,
  Valspar_103174_Oktoberfest: 34349,
  Valspar_103175_LusciousLatte: 34350,
  Valspar_103176_GreenAsABean: 34351,
  Valspar_103177_FeathersOfADove: 34352,
  Valspar_103178_AncientWonder: 34353,
  Valspar_103179_TuscanRooftops: 34354,
  Valspar_103180_BlackEyedPeach: 34355,
  Valspar_103181_HoneyBronze: 34356,
  Valspar_103182_CrushedNutmeg: 34357,
  Valspar_103183_Cupcake: 34358,
  Valspar_103184_CafeAuLait: 34359,
  Valspar_103185_NaturalHabitat: 34360,
  Valspar_103186_HazelnutParfait: 34361,
  Valspar_103187_SweetTreat: 34362,
  Valspar_103188_BrownHen: 34363,
  Valspar_103189_Voluptuous: 34364,
  Valspar_103190_Borneo: 34365,
  Valspar_103191_Diplomatic: 34366,
  Valspar_103192_AutumnBark: 34367,
  Valspar_103193_RawPeanut: 34368,
  Valspar_103194_CharLatte: 34369,
  Valspar_103195_Calfskin: 34370,
  Valspar_103196_HeyHoney: 34371,
  Valspar_103197_Ragtop: 34372,
  Valspar_103198_PackedSand: 34373,
  Valspar_103199_MyPiazza: 34374,
  Valspar_1032_SeagullBeach: 34375,
  Valspar_103200_CinnamonMocha: 34376,
  Valspar_103201_ElegantEarth: 34377,
  Valspar_103202_BrownOwl: 34378,
  Valspar_103203_DancingBear: 34379,
  Valspar_103204_SoClose: 34380,
  Valspar_103205_WesternWear: 34381,
  Valspar_103206_SouthHaven: 34382,
  Valspar_103207_CloakOfMystery: 34383,
  Valspar_103208_Halogen: 34384,
  Valspar_103209_ChocolateCreamPie: 34385,
  Valspar_103210_PuppyPaws: 34386,
  Valspar_103211_AdobeDusk: 34387,
  Valspar_103212_OrangePekoe: 34388,
  Valspar_103213_RoastedCashew: 34389,
  Valspar_103214_PlushTan: 34390,
  Valspar_103215_Sweet: 34391,
  Valspar_103216_Fermata: 34392,
  Valspar_103217_WispOfCocoa: 34393,
  Valspar_103218_Watusi: 34394,
  Valspar_103219_SliceOfBrioche: 34395,
  Valspar_103220_CedarRidge: 34396,
  Valspar_103221_LightBronzer: 34397,
  Valspar_103222_DuneView: 34398,
  Valspar_103223_ReleaseTheHounds: 34399,
  Valspar_103224_JungleBeat: 34400,
  Valspar_103225_WildMustardSeed: 34401,
  Valspar_103226_CashmereWrap: 34402,
  Valspar_103227_AuContraire: 34403,
  Valspar_103228_Felicia: 34404,
  Valspar_103229_WarmHeart: 34405,
  Valspar_103230_SwissLivery: 34406,
  Valspar_103231_ApricotFroth: 34407,
  Valspar_103232_AncientLabyrinth: 34408,
  Valspar_103233_ShepherdsGreen: 34409,
  Valspar_103234_MedianGreen: 34410,
  Valspar_103235_BraveNewTeal: 34411,
  Valspar_103236_ElNino: 34412,
  Valspar_103237_BistroNapkin: 34413,
  Valspar_103238_ScarletTanager: 34414,
  Valspar_103239_HintOfCream: 34415,
  Valspar_103240_PeachPosey: 34416,
  Valspar_103241_Virtuoso: 34417,
  Valspar_103242_BathingBeauty: 34418,
  Valspar_103243_SassyOlive: 34419,
  Valspar_103244_SrslyBlue: 34420,
  Valspar_103245_WarmShale: 34421,
  Valspar_103246_ElectricSky: 34422,
  Valspar_103247_JamJar: 34423,
  Valspar_103248_WelcomingWhite: 34424,
  Valspar_103249_RubyPetals: 34425,
  Valspar_103250_PatricianPurple: 34426,
  Valspar_103251_MountainHideaway: 34427,
  Valspar_103252_QueenAnne: 34428,
  Valspar_103253_BeachBreeze: 34429,
  Valspar_103254_ArtisanBlue: 34430,
  Valspar_103255_TurkishTile: 34431,
  Valspar_103256_SeedCathedral: 34432,
  Valspar_103257_VeiledVinyl: 34433,
  Valspar_103258_AutumnMeadow: 34434,
  Valspar_103259_BlushingLilac: 34435,
  Valspar_103260_CooingDoves: 34436,
  Valspar_103261_ApricotSouffle: 34437,
  Valspar_103262_MorningOnTheMoor: 34438,
  Valspar_103263_HattersPlush: 34439,
  Valspar_103264_LidoDeck: 34440,
  Valspar_103265_SuededGray: 34441,
  Valspar_103266_SapphireEarrings: 34442,
  Valspar_103267_FrostedOrchid: 34443,
  Valspar_103268_PompeiiRed: 34444,
  Valspar_103269_MushroomRisotto: 34445,
  Valspar_103270_BarestCeladon: 34446,
  Valspar_103271_SunValleyVista: 34447,
  Valspar_103272_SafariGreen: 34448,
  Valspar_103273_HickoryChips: 34449,
  Valspar_103274_LemonFennel: 34450,
  Valspar_103275_MarrakechMile: 34451,
  Valspar_103276_TempestsTeapot: 34452,
  Valspar_103277_DantesCardigan: 34453,
  Valspar_103278_RockyCliff: 34454,
  Valspar_103279_PopOfPoppy: 34455,
  Valspar_103280_CacheOfCamel: 34456,
  Valspar_103281_ColdPressed: 34457,
  Valspar_103282_Yam: 34458,
  Valspar_103283_DarkChocolate: 34459,
  Valspar_103284_BlueEnergy: 34460,
  Valspar_103285_Barometer: 34461,
  Valspar_103286_SeaSwirl: 34462,
  Valspar_103287_JadeCameo: 34463,
  Valspar_103288_AncientRelic: 34464,
  Valspar_103289_ScenicView: 34465,
  Valspar_103290_TealTonic: 34466,
  Valspar_103291_Watershed: 34467,
  Valspar_103292_DeepSeaDive: 34468,
  Valspar_103293_WhitingCottage: 34469,
  Valspar_103294_LarkWing: 34470,
  Valspar_103295_AndrewsHoodie: 34471,
  Valspar_103296_NavalNight: 34472,
  Valspar_103297_AraGlen: 34473,
  Valspar_103298_LimeWashed: 34474,
  Valspar_103299_MediterraneanDusk: 34475,
  Valspar_1033_WarmFog: 34476,
  Valspar_103300_FineChina: 34477,
  Valspar_103301_NewAgeGreen: 34478,
  Valspar_103302_BleuClair: 34479,
  Valspar_103303_ArabianNights: 34480,
  Valspar_103304_BlueDusk: 34481,
  Valspar_103305_MoonGarden: 34482,
  Valspar_103306_SwagBagSilver: 34483,
  Valspar_103307_LemonMeringue: 34484,
  Valspar_103308_SeptemberSea: 34485,
  Valspar_103309_SunlitSea: 34486,
  Valspar_103310_SeaCrest: 34487,
  Valspar_103311_BigSkyCountry: 34488,
  Valspar_103312_GauzyCalico: 34489,
  Valspar_103313_EtherealBlue: 34490,
  Valspar_103314_JulietBlue: 34491,
  Valspar_103315_ParisGray: 34492,
  Valspar_103316_CarriageWheel: 34493,
  Valspar_103317_DeepDesertShadow: 34494,
  Valspar_103318_Opalescence: 34495,
  Valspar_103319_TidepoolWonder: 34496,
  Valspar_103320_MidnightTeal: 34497,
  Valspar_103321_BreathOfGreen: 34498,
  Valspar_103322_Aristocratic: 34499,
  Valspar_103323_BuoyantBlue: 34500,
  Valspar_103324_FingalsCave: 34501,
  Valspar_103325_BlueCashmere: 34502,
  Valspar_103326_MountainBoulder: 34503,
  Valspar_103327_ClayFigurine: 34504,
  Valspar_103328_AngoraWhisper: 34505,
  Valspar_103329_BallroomSlippers: 34506,
  Valspar_103330_ChanceOfShowers: 34507,
  Valspar_103331_KevinsStang: 34508,
  Valspar_103332_SummerStorm: 34509,
  Valspar_103333_Chivalry: 34510,
  Valspar_103334_VersatileBlue: 34511,
  Valspar_103335_CubeFarm: 34512,
  Valspar_103336_VintageBoots: 34513,
  Valspar_103337_EarthyBeige: 34514,
  Valspar_103338_OldSoul: 34515,
  Valspar_103339_RiffinOnGreen: 34516,
  Valspar_103340_CoolSeaAir: 34517,
  Valspar_103341_BlueTea: 34518,
  Valspar_103342_NewMornFog: 34519,
  Valspar_103343_BlueDriftwood: 34520,
  Valspar_103344_DarkAndStormyNight: 34521,
  Valspar_103345_GorgeousGraphite: 34522,
  Valspar_103346_Weathervane: 34523,
  Valspar_103347_MoonRock: 34524,
  Valspar_103348_Passionate: 34525,
  Valspar_103349_FireAgate: 34526,
  Valspar_103350_UrbanAuburn: 34527,
  Valspar_103351_GingerSnap: 34528,
  Valspar_103352_EarthFriendly: 34529,
  Valspar_103353_RhinoTusk: 34530,
  Valspar_103354_RusticWicker: 34531,
  Valspar_103355_AfricanSavannah: 34532,
  Valspar_103356_AcaciaTree: 34533,
  Valspar_103357_DorianGray: 34534,
  Valspar_103358_TragicJuliet: 34535,
  Valspar_103359_WineCask: 34536,
  Valspar_103360_FiresideChat: 34537,
  Valspar_103361_NewMexicoMesa: 34538,
  Valspar_103362_Gentility: 34539,
  Valspar_103363_SunDrenched: 34540,
  Valspar_103364_GobiGold: 34541,
  Valspar_103365_SaharaSun: 34542,
  Valspar_103366_GoldenMoss: 34543,
  Valspar_103367_GrayMatter: 34544,
  Valspar_103368_Intrigue: 34545,
  Valspar_103369_ToastedBeige: 34546,
  Valspar_103370_SiennaSky: 34547,
  Valspar_103371_LibraryCard: 34548,
  Valspar_103372_HagarShores: 34549,
  Valspar_103373_ChestnutDressing: 34550,
  Valspar_103374_YellowLab: 34551,
  Valspar_103375_ShiftingSands: 34552,
  Valspar_103376_Saucy: 34553,
  Valspar_103377_SwankyGray: 34554,
  Valspar_103378_FairyBubbles: 34555,
  Valspar_103379_DuskySand: 34556,
  Valspar_103380_AlpacaMittens: 34557,
  Valspar_103381_ElafonisiBeach: 34558,
  Valspar_103382_Baguette: 34559,
  Valspar_103383_AgedIvory: 34560,
  Valspar_103384_OberonOnTheBeach: 34561,
  Valspar_103385_RoseOfTexas: 34562,
  Valspar_103386_LightBamboo: 34563,
  Valspar_103387_SleepingInn: 34564,
  Valspar_103388_Subtle: 34565,
  Valspar_103389_MostDelicate: 34566,
  Valspar_103390_SoftWarm: 34567,
  Valspar_103391_CandleLight: 34568,
  Valspar_103392_MilkAndHoney: 34569,
  Valspar_103393_Manna: 34570,
  Valspar_103394_SandSculpture: 34571,
  Valspar_103395_Sundrop: 34572,
  Valspar_103396_Lantern: 34573,
  Valspar_103397_PartyIce: 34574,
  Valspar_103398_NattiesCami: 34575,
  Valspar_103399_AngelsSigh: 34576,
  Valspar_1034_VeryBerry: 34577,
  Valspar_103400_SheerBlouse: 34578,
  Valspar_103401_PerfectCrust: 34579,
  Valspar_103402_Nougat: 34580,
  Valspar_103403_PalestSatin: 34581,
  Valspar_103404_ChampagneToast: 34582,
  Valspar_103405_NaturalSoap: 34583,
  Valspar_103406_VanillaPudding: 34584,
  Valspar_103407_GravelDrive: 34585,
  Valspar_103408_Mystere: 34586,
  Valspar_103409_WovenCashmere: 34587,
  Valspar_103410_MistyMink: 34588,
  Valspar_103411_SnugAsABug: 34589,
  Valspar_103412_WoolenSox: 34590,
  Valspar_103413_ElkAntler: 34591,
  Valspar_103414_Buttermilk: 34592,
  Valspar_103415_InForTheNight: 34593,
  Valspar_103416_DadsSlippers: 34594,
  Valspar_103417_MichiganAvenue: 34595,
  Valspar_103418_HeatherBay: 34596,
  Valspar_103419_PoetryInMotion: 34597,
  Valspar_103420_PromNight: 34598,
  Valspar_103421_ChocolateOatmeal: 34599,
  Valspar_103422_CocoaDust: 34600,
  Valspar_103423_BrownBunny: 34601,
  Valspar_103424_MyGuineaPig: 34602,
  Valspar_103425_KilnClay: 34603,
  Valspar_103426_BarrelAged: 34604,
  Valspar_103427_ChainLink: 34605,
  Valspar_103428_UrbanLift: 34606,
  Valspar_103429_UluruSunset: 34607,
  Valspar_103430_AndysDeck: 34608,
  Valspar_103431_ArcticTundra: 34609,
  Valspar_103432_CafeAmericaine: 34610,
  Valspar_103433_RoscoeVillage: 34611,
  Valspar_103434_Tweedy: 34612,
  Valspar_103435_LandOfNod: 34613,
  Valspar_103436_RamblinMan: 34614,
  Valspar_103437_Snakeskin: 34615,
  Valspar_103438_AshenViolet: 34616,
  Valspar_103439_OneDozen: 34617,
  Valspar_103440_DeeplyDeanna: 34618,
  Valspar_103441_LavaCake: 34619,
  Valspar_103442_MiddleEarth: 34620,
  Valspar_103443_PottingSoil: 34621,
  Valspar_103444_GardenLoam: 34622,
  Valspar_103445_VillaOliva: 34623,
  Valspar_103446_AbsoluteOlive: 34624,
  Valspar_103447_Merman: 34625,
  Valspar_103448_EtherealDance: 34626,
  Valspar_103449_HolidayVelvet: 34627,
  Valspar_103450_Zephyr: 34628,
  Valspar_103451_BijouTeal: 34629,
  Valspar_103452_PuddleJumper: 34630,
  Valspar_103453_DevonGreen: 34631,
  Valspar_103454_Capers: 34632,
  Valspar_103455_Urbane: 34633,
  Valspar_103456_OliveToTheMax: 34634,
  Valspar_103457_NewToile: 34635,
  Valspar_103458_FlatteringBlue: 34636,
  Valspar_103459_CatsPajamas: 34637,
  Valspar_103460_InTheDeepEnd: 34638,
  Valspar_103461_BrimmingOver: 34639,
  Valspar_103462_ExplorerGreen: 34640,
  Valspar_103463_Bushel: 34641,
  Valspar_103464_ZiplineGreen: 34642,
  Valspar_103465_EpicGreen: 34643,
  Valspar_103466_CrossCountry: 34644,
  Valspar_103467_ColdSnap: 34645,
  Valspar_103468_CatsAndDogs: 34646,
  Valspar_103469_RobinsPride: 34647,
  Valspar_103470_SweetestDamask: 34648,
  Valspar_103471_VerdantRetreat: 34649,
  Valspar_103472_Fanfare: 34650,
  Valspar_103473_SereneScene: 34651,
  Valspar_103474_Mossy: 34652,
  Valspar_103475_Garnish: 34653,
  Valspar_103476_BlackHillsGold: 34654,
  Valspar_103477_Offshore: 34655,
  Valspar_103478_Drenched: 34656,
  Valspar_103479_BarestHintOfBlue: 34657,
  Valspar_103480_ScottishHeath: 34658,
  Valspar_103481_HearthFrost: 34659,
  Valspar_103482_BuddingGreen: 34660,
  Valspar_103483_DustyGreen: 34661,
  Valspar_103484_Understory: 34662,
  Valspar_103485_SmokyLight: 34663,
  Valspar_103486_ShakenOrStirred: 34664,
  Valspar_103487_DawnsEarlyLight: 34665,
  Valspar_103488_HorizonGray: 34666,
  Valspar_103489_BareMinimum: 34667,
  Valspar_103490_OldSterling: 34668,
  Valspar_103491_StatueOfLiberty: 34669,
  Valspar_103492_Kilimanjaro: 34670,
  Valspar_103493_HealthyWealthyAndWise: 34671,
  Valspar_103494_HalfMoon: 34672,
  Valspar_103495_Constellation: 34673,
  Valspar_103496_Understated: 34674,
  Valspar_103497_GentleGray: 34675,
  Valspar_103498_CatalystGray: 34676,
  Valspar_103499_BeachHouseBlue: 34677,
  Valspar_1035_RoseDust: 34678,
  Valspar_103500_SonnetGray: 34679,
  Valspar_103501_Stratosphere: 34680,
  Valspar_103502_BottleGlass: 34681,
  Valspar_103503_NewBabySmell: 34682,
  Valspar_103504_PansFlute: 34683,
  Valspar_103505_Upstate: 34684,
  Valspar_103506_CremeDeLaCreme: 34685,
  Valspar_103507_Hazy: 34686,
  Valspar_103508_SalvagedSilk: 34687,
  Valspar_103509_HappyGoLucky: 34688,
  Valspar_103510_MoroccanModerne: 34689,
  Valspar_103511_PoolTile: 34690,
  Valspar_103512_TouchOfSpring: 34691,
  Valspar_103513_JasmineRice: 34692,
  Valspar_103514_PassingShadow: 34693,
  Valspar_103515_Grasscloth: 34694,
  Valspar_103516_BareMarket: 34695,
  Valspar_103517_BedsideManner: 34696,
  Valspar_103518_WinterWonderland: 34697,
  Valspar_103519_AListBlue: 34698,
  Valspar_103520_FlockOfSeagulls: 34699,
  Valspar_103521_PatinaGray: 34700,
  Valspar_103522_BreezyDay: 34701,
  Valspar_103523_GreenMotif: 34702,
  Valspar_103524_Sleepy: 34703,
  Valspar_103525_AfternoonNap: 34704,
  Valspar_103526_ChoppedAlmonds: 34705,
  Valspar_103527_WetSeal: 34706,
  Valspar_103528_HeronWing: 34707,
  Valspar_103529_BlueGoblin: 34708,
  Valspar_103530_Skyfall: 34709,
  Valspar_103531_Artful: 34710,
  Valspar_103532_SilverMoss: 34711,
  Valspar_103533_SecretRetreat: 34712,
  Valspar_103534_BarristerGray: 34713,
  Valspar_103535_IntoTheWild: 34714,
  Valspar_103536_PatricksEyes: 34715,
  Valspar_103537_DeepSpaceEcho: 34716,
  Valspar_103538_RiskReward: 34717,
  Valspar_103539_MaritimeHush: 34718,
  Valspar_103540_DeepThoughts: 34719,
  Valspar_103541_GrayFlannelSuit: 34720,
  Valspar_103542_PondLeaves: 34721,
  Valspar_103543_FatCat: 34722,
  Valspar_103544_SeaGrove: 34723,
  Valspar_103545_GingersGrotto: 34724,
  Valspar_103546_Architect: 34725,
  Valspar_1036_BerryTwist: 34726,
  Valspar_1037_PinkFrenzy: 34727,
  Valspar_1038_PinkQuartz: 34728,
  Valspar_1044_LilacLane: 34729,
  Valspar_1045_Cascadia: 34730,
  Valspar_1053_PlumLegacy: 34731,
  Valspar_1054_DustyLavender: 34732,
  Valspar_1057_WinterSunrise: 34733,
  Valspar_1058_MysticTaupe: 34734,
  Valspar_1059_SummerSparrow: 34735,
  Valspar_1060_SoftRabbitBrown: 34736,
  Valspar_1061_DuskyHyacinth: 34737,
  Valspar_1063_NapaDawn: 34738,
  Valspar_1065_FrostyBerry: 34739,
  Valspar_1066_PositivelyPink: 34740,
  Valspar_1067_HushedRose: 34741,
  Valspar_1068_PinkDestiny: 34742,
  Valspar_1069_UtterlyPink: 34743,
  Valspar_1070_PurpleDavenport: 34744,
  Valspar_1071_PurpleStripe: 34745,
  Valspar_1072_LaLaLove: 34746,
  Valspar_1087_LilacLace: 34747,
  Valspar_1089_RoamingPony: 34748,
  Valspar_1090_LilacGray: 34749,
  Valspar_1091_BerryFrost: 34750,
  Valspar_1092_BerryCream: 34751,
  Valspar_1093_AncestralHaze: 34752,
  Valspar_1094_BerryBlush: 34753,
  Valspar_1095_HintOfCherry: 34754,
  Valspar_1096_IcedBerry: 34755,
  Valspar_1097_HarmoniousRose: 34756,
  Valspar_1098_SweetPink: 34757,
  Valspar_1099_PixieDust: 34758,
  Valspar_1100_Plumberry: 34759,
  Valspar_1101_SoLongShadow: 34760,
  Valspar_1102_QuiltedHeart: 34761,
  Valspar_1103_LoftyDelight: 34762,
  Valspar_1104_DreamyMemory: 34763,
  Valspar_1105_LuckyYou: 34764,
  Valspar_1112_PurpleEarth: 34765,
  Valspar_1113_SmokedMulberry: 34766,
  Valspar_1114_MellowMauve: 34767,
  Valspar_1115_BedroomPlum: 34768,
  Valspar_1116_LilacBuds: 34769,
  Valspar_1118_PianoBrown: 34770,
  Valspar_1119_Marron: 34771,
  Valspar_1120_IrishTea: 34772,
  Valspar_1121_CherryTaupe: 34773,
  Valspar_1122_Lovebug: 34774,
  Valspar_1123_RosarioRidge: 34775,
  Valspar_1125_SoCharming: 34776,
  Valspar_1127_PinkFlutter: 34777,
  Valspar_1128_RosyCheeks: 34778,
  Valspar_1129_PinkRibbon: 34779,
  Valspar_1147_QuartzPink: 34780,
  Valspar_1148_RichChocolate: 34781,
  Valspar_1149_BerryBrandy: 34782,
  Valspar_1150_ForestTrail: 34783,
  Valspar_1151_MauveBlush: 34784,
  Valspar_1152_DamaskDunes: 34785,
  Valspar_1153_TenderShell: 34786,
  Valspar_1154_WhippedStrawberry: 34787,
  Valspar_1155_PassionPink: 34788,
  Valspar_1156_PoppyField: 34789,
  Valspar_1157_SweetSixteen: 34790,
  Valspar_1158_WarmPink: 34791,
  Valspar_1160_BakedBahama: 34792,
  Valspar_1161_PrettyPeony: 34793,
  Valspar_1169_SugarplumDance: 34794,
  Valspar_1170_FragrantOrchid: 34795,
  Valspar_1171_BerryTaffy: 34796,
  Valspar_1172_BrownPlum: 34797,
  Valspar_1173_Fruitwood: 34798,
  Valspar_1174_CherryMocha: 34799,
  Valspar_1175_CameoPink: 34800,
  Valspar_1176_BombayPink: 34801,
  Valspar_1177_BarelyPink: 34802,
  Valspar_1178_SmokedAlmond: 34803,
  Valspar_1180_SouthernRoad: 34804,
  Valspar_1181_AdobeGlow: 34805,
  Valspar_1182_SunsetCurtains: 34806,
  Valspar_1183_HoneysuckleDelight: 34807,
  Valspar_1185_RougeRed: 34808,
  Valspar_1186_PowderPeach: 34809,
  Valspar_1187_AntiqueCoral: 34810,
  Valspar_1190_SiennaDust: 34811,
  Valspar_1191_ReflectingRose: 34812,
  Valspar_1192_SecondBlush: 34813,
  Valspar_1193_PromPink: 34814,
  Valspar_1194_HelloDolly: 34815,
  Valspar_1195_ArtDecoPink: 34816,
  Valspar_1197_HighCountryRose: 34817,
  Valspar_1198_EdwardianRose: 34818,
  Valspar_1207_SweetPastel: 34819,
  Valspar_1208_PottersRock: 34820,
  Valspar_1209_ApacheClay: 34821,
  Valspar_1210_CanyonEarth: 34822,
  Valspar_1211_NakedClay: 34823,
  Valspar_1212_RodeoDust: 34824,
  Valspar_1214_BlazeOrange: 34825,
  Valspar_1215_SweetMelon: 34826,
  Valspar_1216_PeachBurst: 34827,
  Valspar_1217_PeachPunch: 34828,
  Valspar_1218_PeachWhisper: 34829,
  Valspar_1222_DoricPink: 34830,
  Valspar_1223_NanasRose: 34831,
  Valspar_1224_SweetyPie: 34832,
  Valspar_1225_OhSoPink: 34833,
  Valspar_1226_MutedRed: 34834,
  Valspar_1227_SpanishRoseShadow: 34835,
  Valspar_1228_RomanticRose: 34836,
  Valspar_1229_RosettiPink: 34837,
  Valspar_1231_DelicatePinkRose: 34838,
  Valspar_1232_RedHenna: 34839,
  Valspar_1233_SavannahRed: 34840,
  Valspar_1234_NewHavenRose: 34841,
  Valspar_1235_GilmanRose: 34842,
  Valspar_1236_SoftPink: 34843,
  Valspar_1237_RosyGlow: 34844,
  Valspar_1239_ClayDusk: 34845,
  Valspar_1240_WesternRidge: 34846,
  Valspar_1241_OhSoRed: 34847,
  Valspar_1243_ClassicRed: 34848,
  Valspar_1245_CutRuby: 34849,
  Valspar_1247_JazzyRed: 34850,
  Valspar_1249_MagiciansCloak: 34851,
  Valspar_1251_RedBliss: 34852,
  Valspar_1254_HeirloomRed: 34853,
  Valspar_1256_SpanishTile: 34854,
  Valspar_1257_Stoic: 34855,
  Valspar_1258_BerryBrown: 34856,
  Valspar_1261_ScarletSun: 34857,
  Valspar_1262_BrownVelvet: 34858,
  Valspar_1263_FabulousRed: 34859,
  Valspar_1264_QuiteRed: 34860,
  Valspar_1265_PoshRed: 34861,
  Valspar_1266_RoyalGarnet: 34862,
  Valspar_1267_AncientBurgundy: 34863,
  Valspar_1269_AntiqueBurgundy: 34864,
  Valspar_1270_RareWine: 34865,
  Valspar_1273_SantaFeSpirit: 34866,
  Valspar_1274_AutumnEnchantment: 34867,
  Valspar_1275_CoralPassion: 34868,
  Valspar_1276_PoppyPetal: 34869,
  Valspar_1277_SimplyCoral: 34870,
  Valspar_1278_CoralMist: 34871,
  Valspar_1279_ApricotIce: 34872,
  Valspar_1280_DeepRose: 34873,
  Valspar_1281_PlayfulPink: 34874,
  Valspar_1282_StrawberryPink: 34875,
  Valspar_1284_TulipPetal: 34876,
  Valspar_1286_ToastedCranberry: 34877,
  Valspar_1287_CubanPlaza: 34878,
  Valspar_1288_CoralBanks: 34879,
  Valspar_1290_FaithfulRose: 34880,
  Valspar_1291_TulipPink: 34881,
  Valspar_1292_RememberMeRed: 34882,
  Valspar_1293_PajaritoRed: 34883,
  Valspar_1294_RosySandstone: 34884,
  Valspar_1296_SemiPrecious: 34885,
  Valspar_1297_Harmony: 34886,
  Valspar_1298_NovemberFoliage: 34887,
  Valspar_1304_AutumnBlaze: 34888,
  Valspar_1305_OrangeSlice: 34889,
  Valspar_1306_RipeMelon: 34890,
  Valspar_1308_WhippedPeach: 34891,
  Valspar_1309_PeachKiss: 34892,
  Valspar_1311_SonoraRose: 34893,
  Valspar_1312_HoneysuckleRose: 34894,
  Valspar_1314_CamillePink: 34895,
  Valspar_1316_DecadentRed: 34896,
  Valspar_1318_Rhapsody: 34897,
  Valspar_1319_VintageCoral: 34898,
  Valspar_1320_SalmonRun: 34899,
  Valspar_1321_SpringLinen: 34900,
  Valspar_1322_RustedEarth: 34901,
  Valspar_1326_ShyTime: 34902,
  Valspar_1327_MorningGlow: 34903,
  Valspar_1331_GlamorousTaupe: 34904,
  Valspar_1332_BadlandsTaupe: 34905,
  Valspar_1333_ChampagneGlee: 34906,
  Valspar_1334_AutumnGlimmer: 34907,
  Valspar_1335_OrangePecan: 34908,
  Valspar_1336_WarmCider: 34909,
  Valspar_1337_SassyPeach: 34910,
  Valspar_1338_CoralGable: 34911,
  Valspar_1345_SnowPa: 34912,
  Valspar_1346_TropicalNut: 34913,
  Valspar_1347_FlorentineClay: 34914,
  Valspar_1348_TerraEarth: 34915,
  Valspar_1350_SweetMarmalade: 34916,
  Valspar_1351_PaleSatinPeach: 34917,
  Valspar_1352_ChocolateCherry: 34918,
  Valspar_1353_DeepClayRed: 34919,
  Valspar_1354_KitchenTerraCotta: 34920,
  Valspar_1355_ArizonaDust: 34921,
  Valspar_1357_SubtlePeach: 34922,
  Valspar_1358_BrooklynBrownstone: 34923,
  Valspar_1359_SeaLionBrown: 34924,
  Valspar_1360_NavajoHorizon: 34925,
  Valspar_1361_AdirondackPath: 34926,
  Valspar_1362_SandStorm: 34927,
  Valspar_1363_Balance: 34928,
  Valspar_1370_TerraCottaRed: 34929,
  Valspar_1371_FlamencoPink: 34930,
  Valspar_1372_DesertRose: 34931,
  Valspar_1373_CoralReef: 34932,
  Valspar_1374_CrystalCoral: 34933,
  Valspar_1375_ChampagnePink: 34934,
  Valspar_1376_BearClaw: 34935,
  Valspar_1377_CloveBud: 34936,
  Valspar_1378_Laredo: 34937,
  Valspar_1379_Sandbar: 34938,
  Valspar_1380_SpecialPeach: 34939,
  Valspar_1381_CapeSands: 34940,
  Valspar_1382_ItalianRoast: 34941,
  Valspar_1384_CoffeeGelato: 34942,
  Valspar_1385_ViennaBeige: 34943,
  Valspar_1386_MesaSand: 34944,
  Valspar_1388_DeepWalnut: 34945,
  Valspar_1389_BrownBark: 34946,
  Valspar_1390_Fudgecicle: 34947,
  Valspar_1392_DustBunny: 34948,
  Valspar_1393_BungalowWhite: 34949,
  Valspar_1407_CopperHide: 34950,
  Valspar_1411_SubtleSuede: 34951,
  Valspar_1413_TerraCottaTrail: 34952,
  Valspar_1414_DesertCarnation: 34953,
  Valspar_1415_MojaveSunset: 34954,
  Valspar_1418_BostonLegacy: 34955,
  Valspar_1419_ZanzibarSpice: 34956,
  Valspar_1420_DeltaSandbar: 34957,
  Valspar_1421_FreeWheeling: 34958,
  Valspar_1422_GalleryGrey: 34959,
  Valspar_1423_VanillaSteam: 34960,
  Valspar_1434_PeachEncounter: 34961,
  Valspar_1438_SweetCardamom: 34962,
  Valspar_1440_SouthernPeach: 34963,
  Valspar_1441_FrenchCream: 34964,
  Valspar_1447_SimplySubtlePink: 34965,
  Valspar_1449_ScentedCandle: 34966,
  Valspar_1450_TemperedAllspice: 34967,
  Valspar_1451_TimberDust: 34968,
  Valspar_1452_CleanSweep: 34969,
  Valspar_1455_PumpkinButter: 34970,
  Valspar_1456_OrangeToffee: 34971,
  Valspar_1457_CantaloupeSmile: 34972,
  Valspar_1458_WhippedApricot: 34973,
  Valspar_1460_CarrotCake: 34974,
  Valspar_1461_BrushedOrange: 34975,
  Valspar_1462_TangerineCream: 34976,
  Valspar_1463_OrangeMousse: 34977,
  Valspar_1464_ChampagneOrange: 34978,
  Valspar_1465_OrangeSparkle: 34979,
  Valspar_1466_CattleDrive: 34980,
  Valspar_1467_Longhorn: 34981,
  Valspar_1468_PeachIceCream: 34982,
  Valspar_1471_SweetSand: 34983,
  Valspar_1472_RusticEarth: 34984,
  Valspar_1473_RusticOak: 34985,
  Valspar_1477_CakeBatter: 34986,
  Valspar_1479_MilkChocolate: 34987,
  Valspar_1480_WoodlandStone: 34988,
  Valspar_1481_MesaTumbleweed: 34989,
  Valspar_1482_DesertFortress: 34990,
  Valspar_1483_RivieraDune: 34991,
  Valspar_1484_MonarchWing: 34992,
  Valspar_1502_NaturalCork: 34993,
  Valspar_1503_StandingStill: 34994,
  Valspar_1504_CafeMiel: 34995,
  Valspar_1505_FriendlyTan: 34996,
  Valspar_1506_MapleLeaf: 34997,
  Valspar_1507_StrawberryMalt: 34998,
  Valspar_1508_SumatraBlend: 34999,
  Valspar_1510_FaintMaple: 35000,
  Valspar_1512_RoastedCoffee: 35001,
  Valspar_1520_WesternBrown: 35002,
  Valspar_1523_IslandOrange: 35003,
  Valspar_1531_OrangeFruit: 35004,
  Valspar_1532_CabinPlank: 35005,
  Valspar_1535_RedOchre: 35006,
  Valspar_1537_CowboySuede: 35007,
  Valspar_1538_RussetRed: 35008,
  Valspar_1540_SoulChocolate: 35009,
  Valspar_1542_MilkToast: 35010,
  Valspar_1543_TagsaleLinen: 35011,
  Valspar_1544_OrangeGlow: 35012,
  Valspar_1549_ChampagneTickle: 35013,
  Valspar_1550_HazelnutCoffee: 35014,
  Valspar_1551_ToffeeCream: 35015,
  Valspar_1553_AlmondButter: 35016,
  Valspar_1554_PeachButter: 35017,
  Valspar_1555_AlmondCream: 35018,
  Valspar_1558_SpunGold: 35019,
  Valspar_1561_NaturalSheepskin: 35020,
  Valspar_1562_WoodenWagon: 35021,
  Valspar_1563_TenderTwig: 35022,
  Valspar_1564_SturdyBronze: 35023,
  Valspar_1565_PalePowder: 35024,
  Valspar_1569_DarkToast: 35025,
  Valspar_1570_ChangingSeasons: 35026,
  Valspar_1571_WarmBuff: 35027,
  Valspar_1572_WheatToast: 35028,
  Valspar_1573_SavouryBeige: 35029,
  Valspar_1575_Chickadee: 35030,
  Valspar_1576_GoldenButter: 35031,
  Valspar_1578_PeachTickle: 35032,
  Valspar_1579_CreamyOat: 35033,
  Valspar_1580_RoastedChestnut: 35034,
  Valspar_1581_AfternoonTea: 35035,
  Valspar_1582_PeachTea: 35036,
  Valspar_1583_Croissant: 35037,
  Valspar_1584_ApricotMousse: 35038,
  Valspar_1587_ButternutTree: 35039,
  Valspar_1588_Frankincense: 35040,
  Valspar_1589_FragrantCoriander: 35041,
  Valspar_1590_AmberWaves: 35042,
  Valspar_1591_FrenchPastry: 35043,
  Valspar_1592_ChestnutBeach: 35044,
  Valspar_1593_GleamingTan: 35045,
  Valspar_1594_PaleBlush: 35046,
  Valspar_1596_BreadBasket: 35047,
  Valspar_1597_SubtleBlush: 35048,
  Valspar_1598_MonasMane: 35049,
  Valspar_1599_MochaSyrup: 35050,
  Valspar_1600_DoeEyes: 35051,
  Valspar_1601_MooseMousse: 35052,
  Valspar_1602_Hopsack: 35053,
  Valspar_1603_CreamInMyCoffee: 35054,
  Valspar_1604_GoldAbundance: 35055,
  Valspar_1606_GoldenPromise: 35056,
  Valspar_1607_HoneyGlaze: 35057,
  Valspar_1608_Sunglow: 35058,
  Valspar_1615_CoconutScent: 35059,
  Valspar_1616_AmberSienna: 35060,
  Valspar_1617_AutumnSpice: 35061,
  Valspar_1618_ImperialGold: 35062,
  Valspar_1620_PumpkinPieOhMy: 35063,
  Valspar_1621_SimplePleasures: 35064,
  Valspar_1622_BrilliantOak: 35065,
  Valspar_1623_LeatherSatchel: 35066,
  Valspar_1624_CornerCafe: 35067,
  Valspar_1625_YoungAtHeart: 35068,
  Valspar_1627_KabukiClay: 35069,
  Valspar_1629_UniversalUmber: 35070,
  Valspar_1630_AuLaitOle: 35071,
  Valspar_1631_Leatherbound: 35072,
  Valspar_1632_HolmesCream: 35073,
  Valspar_1633_LovelyBluff: 35074,
  Valspar_1634_GoldenTreasure: 35075,
  Valspar_1635_GoldenSpell: 35076,
  Valspar_1646_PoseidonsGold: 35077,
  Valspar_1647_SafariSun: 35078,
  Valspar_1649_DelightfulMoon: 35079,
  Valspar_1650_WarmSunshine: 35080,
  Valspar_1651_EveningSun: 35081,
  Valspar_1654_BuckskinPony: 35082,
  Valspar_1655_PalominoPony: 35083,
  Valspar_1656_HazyYellow: 35084,
  Valspar_1657_EstateVanilla: 35085,
  Valspar_1658_MuddyMississippi: 35086,
  Valspar_1659_CrunchGranola: 35087,
  Valspar_1660_RiverOak: 35088,
  Valspar_1661_SandyCove: 35089,
  Valspar_1662_Gardenia: 35090,
  Valspar_1674_Cuddle: 35091,
  Valspar_1676_GardenOchre: 35092,
  Valspar_1678_Ambitious: 35093,
  Valspar_1679_VerandaYellow: 35094,
  Valspar_1680_SweetTreats: 35095,
  Valspar_1681_SoftCandlelight: 35096,
  Valspar_1682_CamelRide: 35097,
  Valspar_1684_LewisGold: 35098,
  Valspar_1685_CloudySunset: 35099,
  Valspar_1686_Capricious: 35100,
  Valspar_1687_PaleMaize: 35101,
  Valspar_1688_MagicLamp: 35102,
  Valspar_1690_CarawaySeed: 35103,
  Valspar_1693_ShaniasLace: 35104,
  Valspar_1700_MustardGlaze: 35105,
  Valspar_1701_SweetLemon: 35106,
  Valspar_1702_AmberPearl: 35107,
  Valspar_1703_LateDaySun: 35108,
  Valspar_1704_PecanCream: 35109,
  Valspar_1705_LemonCream: 35110,
  Valspar_1706_BugleCall: 35111,
  Valspar_1707_PiratesTreasure: 35112,
  Valspar_1708_GoldenChime: 35113,
  Valspar_1709_LazySun: 35114,
  Valspar_1710_Shoreline: 35115,
  Valspar_1713_CaramelGold: 35116,
  Valspar_1717_IvoryEssence: 35117,
  Valspar_1718_GrecianHelmet: 35118,
  Valspar_1721_WetlandClay: 35119,
  Valspar_1722_CountryCharm: 35120,
  Valspar_1723_RattanBasket: 35121,
  Valspar_1729_SummerMorning: 35122,
  Valspar_1731_FallMeadow: 35123,
  Valspar_1732_IslandSun: 35124,
  Valspar_1736_Corduroy: 35125,
  Valspar_1737_EarthenSienna: 35126,
  Valspar_1738_HarpswellGreen: 35127,
  Valspar_1739_HoneysuckleBeige: 35128,
  Valspar_1740_HomeyCream: 35129,
  Valspar_1745_TweedJacket: 35130,
  Valspar_1746_BakedScone: 35131,
  Valspar_1748_TwilightJungle: 35132,
  Valspar_1749_WinterDelta: 35133,
  Valspar_1750_WildMushroom: 35134,
  Valspar_1751_FreshlyBaked: 35135,
  Valspar_1752_LightRaffia: 35136,
  Valspar_1753_CozyWhite: 35137,
  Valspar_1754_Tangy: 35138,
  Valspar_1755_SweetMustard: 35139,
  Valspar_1756_TopBanana: 35140,
  Valspar_1757_ChickeryChick: 35141,
  Valspar_1764_LemonButter: 35142,
  Valspar_1765_YellowBliss: 35143,
  Valspar_1766_GoldenAvocado: 35144,
  Valspar_1767_DylanVelvet: 35145,
  Valspar_1768_SwiftlyGreen: 35146,
  Valspar_1770_CanaryDiamond: 35147,
  Valspar_1773_Swampwater: 35148,
  Valspar_1774_DesertGrass: 35149,
  Valspar_1775_DryLeaf: 35150,
  Valspar_1776_AncientScroll: 35151,
  Valspar_1778_Stampede: 35152,
  Valspar_1780_Rugged: 35153,
  Valspar_1786_PumpkinSquash: 35154,
  Valspar_1788_CaramelToffee: 35155,
  Valspar_1792_SwissChocolate: 35156,
  Valspar_1793_Sunspark: 35157,
  Valspar_1796_FancySuede: 35158,
  Valspar_1798_PaleCordovan: 35159,
  Valspar_1799_CowboyHat: 35160,
  Valspar_1806_AutumnSurprise: 35161,
  Valspar_1807_ToffeeGlaze: 35162,
  Valspar_1808_SiennaRed: 35163,
  Valspar_1809_DarkEarth: 35164,
  Valspar_1811_Plink: 35165,
  Valspar_1812_BerriesGalore: 35166,
  Valspar_1813_CosmicBerry: 35167,
  Valspar_1814_WhitePepper: 35168,
  Valspar_1815_WinterCalm: 35169,
  Valspar_1817_CadetGray: 35170,
  Valspar_1818_CinderFox: 35171,
  Valspar_1822_MidsummerTwilight: 35172,
  Valspar_1823_NativeLilac: 35173,
  Valspar_1824_ClassicalViolet: 35174,
  Valspar_1825_PurpleFury: 35175,
  Valspar_1838_LavenderMoon: 35176,
  Valspar_1839_SimplyLavender: 35177,
  Valspar_1840_LavenderQuartz: 35178,
  Valspar_1841_PurpleGala: 35179,
  Valspar_1842_PlumBurst: 35180,
  Valspar_1843_SonicPlum: 35181,
  Valspar_1844_ModestSilver: 35182,
  Valspar_1845_LondonCoach: 35183,
  Valspar_1849_BlackRaisin: 35184,
  Valspar_1850_GentleViolet: 35185,
  Valspar_1863_LavenderEscape: 35186,
  Valspar_1864_PurpleFreedom: 35187,
  Valspar_1865_SweetViolet: 35188,
  Valspar_1866_PositivelyPurple: 35189,
  Valspar_1867_KarmicGrape: 35190,
  Valspar_1868_PurpleMist: 35191,
  Valspar_1869_WhippedPlum: 35192,
  Valspar_1870_PurpleWhisper: 35193,
  Valspar_1873_Rollick: 35194,
  Valspar_1874_SeashellGray: 35195,
  Valspar_1875_FilteredShade: 35196,
  Valspar_1876_RockyBluffs: 35197,
  Valspar_1878_RuggedSuede: 35198,
  Valspar_1879_SemiSweet: 35199,
  Valspar_1880_WisteriaSnow: 35200,
  Valspar_1881_OrchidAsh: 35201,
  Valspar_1882_MistyMorningDew: 35202,
  Valspar_1884_SeattleHaze: 35203,
  Valspar_1885_DarkNight: 35204,
  Valspar_1894_Heartsong: 35205,
  Valspar_1895_EnchantedEvening: 35206,
  Valspar_1896_BedtimeStory: 35207,
  Valspar_1901_SassyViolet: 35208,
  Valspar_1902_SimplyPurple: 35209,
  Valspar_1903_PurpleFrenzy: 35210,
  Valspar_1904_TemperedGray: 35211,
  Valspar_1905_UrbanSunrise: 35212,
  Valspar_1906_HazyStratus: 35213,
  Valspar_1907_GreySuit: 35214,
  Valspar_1908_OceanStorm: 35215,
  Valspar_1912_AcierTint: 35216,
  Valspar_1913_WindowScreen: 35217,
  Valspar_1914_PacificCoast: 35218,
  Valspar_1915_MidnightShadow: 35219,
  Valspar_1917_NovellaBlue: 35220,
  Valspar_1918_Lovebirds: 35221,
  Valspar_1919_SplendidBlue: 35222,
  Valspar_1920_VerandaBlue: 35223,
  Valspar_1921_AtlanticSchooner: 35224,
  Valspar_1928_SuperNova: 35225,
  Valspar_1929_TwilightMist: 35226,
  Valspar_1932_BlueShock: 35227,
  Valspar_1934_PolarStar: 35228,
  Valspar_1935_Gravity: 35229,
  Valspar_1936_Metropolis: 35230,
  Valspar_1937_VesselGray: 35231,
  Valspar_1938_HighSpeedSteel: 35232,
  Valspar_1939_MuskegGrey: 35233,
  Valspar_1940_TinselBeam: 35234,
  Valspar_1941_GlacierMist: 35235,
  Valspar_1942_BlissfulBlue: 35236,
  Valspar_1943_GrayLavender: 35237,
  Valspar_1944_ThunderingClouds: 35238,
  Valspar_1945_MotorCityBlue: 35239,
  Valspar_1946_BlueRaindrop: 35240,
  Valspar_1947_Sailboat: 35241,
  Valspar_1948_CoventryBlue: 35242,
  Valspar_1949_OfficeBlue: 35243,
  Valspar_1951_MountainRiver: 35244,
  Valspar_1952_Moonbeam: 35245,
  Valspar_1953_Serenity: 35246,
  Valspar_1954_Promise: 35247,
  Valspar_1955_MysteriousBlue: 35248,
  Valspar_1961_HighSeas: 35249,
  Valspar_1962_Someday: 35250,
  Valspar_1964_SilverLeaf: 35251,
  Valspar_1965_Voyage: 35252,
  Valspar_1966_DrizzlingMist: 35253,
  Valspar_1967_ElephantGray: 35254,
  Valspar_1968_Crucible: 35255,
  Valspar_1969_Hematite: 35256,
  Valspar_1970_SilverDusk: 35257,
  Valspar_1971_PalisadeBlue: 35258,
  Valspar_1972_BlueSkylights: 35259,
  Valspar_1973_RoyalGray: 35260,
  Valspar_1974_RetroColonialBlue: 35261,
  Valspar_1982_Dewdrop: 35262,
  Valspar_1983_UtterlyBlue: 35263,
  Valspar_1988_BlueMist: 35264,
  Valspar_1989_GentleWind: 35265,
  Valspar_1990_Bluish: 35266,
  Valspar_1991_Skyscape: 35267,
  Valspar_1992_BlueTango: 35268,
  Valspar_1993_PeekABooBlue: 35269,
  Valspar_1994_Pelican: 35270,
  Valspar_1995_AutumnFog: 35271,
  Valspar_1996_WinterFlannel: 35272,
  Valspar_1997_Sharkfin: 35273,
  Valspar_1998_IronFrost: 35274,
  Valspar_1999_Blindfold: 35275,
  Valspar_2000_GhostShip: 35276,
  Valspar_2001_SharkLoop: 35277,
  Valspar_2002_EveningEclipse: 35278,
  Valspar_2003_MagnetDapple: 35279,
  Valspar_2004_SmokyPitch: 35280,
  Valspar_2005_NightView: 35281,
  Valspar_20057C_DesertCarnation: 1889,
  Valspar_20059A_BostonLegacy: 1890,
  Valspar_2006_IceRinkBlue: 35282,
  Valspar_2008_MemorybookBlue: 35283,
  Valspar_20087C_CafeMiel: 1891,
  Valspar_2009_Nostalgia: 35284,
  Valspar_2010_BountifulBlue: 35285,
  Valspar_2011_DeepTwilightBlue: 35286,
  Valspar_2012_AirKiss: 35287,
  Valspar_2013_Escape: 35288,
  Valspar_2014_Breezy: 35289,
  Valspar_2015_BlueEyes: 35290,
  Valspar_2019_PerfectlyBlue: 35291,
  Valspar_2021_SeaFrolic: 35292,
  Valspar_2022_BlueBurst: 35293,
  Valspar_2023_CosmicBlue: 35294,
  Valspar_2024_BayWaves: 35295,
  Valspar_2025_PolishedSilver: 35296,
  Valspar_2026_StoneMasonGray: 35297,
  Valspar_2027_CityStorm: 35298,
  Valspar_2028_AlmostCharcoal: 35299,
  Valspar_2029_MutedEbony: 35300,
  Valspar_2030_RisingTide: 35301,
  Valspar_2031_LighthouseShadows: 35302,
  Valspar_2032_SilverFox: 35303,
  Valspar_2033_PulitzerBlue: 35304,
  Valspar_2034_CornflowerBlue: 35305,
  Valspar_2035_DutchLicorice: 35306,
  Valspar_2036_PaleFlowers: 35307,
  Valspar_2037_NorthernSkyBlue: 35308,
  Valspar_2038_SummerhouseBlue: 35309,
  Valspar_2039_Brookside: 35310,
  Valspar_2040_CelebrationBlue: 35311,
  Valspar_2042_SummerBreeze: 35312,
  Valspar_2048_Skywriter: 35313,
  Valspar_2049_SonicSky: 35314,
  Valspar_2050_Billow: 35315,
  Valspar_2053_Noir: 35316,
  Valspar_2054_GothamGray: 35317,
  Valspar_2058_IndigoCloth: 35318,
  Valspar_2061_ChimneySmoke: 35319,
  Valspar_2062_SumptuousPurple: 35320,
  Valspar_2065_IndigoStreamer: 35321,
  Valspar_2069_EnchantedNavy: 35322,
  Valspar_2070_JazzyBlue: 35323,
  Valspar_2073_DarkKettleBlack: 35324,
  Valspar_2074_BlueCoal: 35325,
  Valspar_2076_NewportGray: 35326,
  Valspar_2080_SpiritBlue: 35327,
  Valspar_2081_WaterFountain: 35328,
  Valspar_2082_RollingSea: 35329,
  Valspar_2083_DeepBlueSea: 35330,
  Valspar_2085_GreyBrook: 35331,
  Valspar_2086_BlueTwilight: 35332,
  Valspar_2087_AcademyGray: 35333,
  Valspar_2088_RelaxedNavy: 35334,
  Valspar_2089_CobaltCannon: 35335,
  Valspar_2091_NorthernSky: 35336,
  Valspar_2092_BlueArrow: 35337,
  Valspar_2093_CafeBlue: 35338,
  Valspar_2094_NorthernJuniper: 35339,
  Valspar_2095_SlateCourt: 35340,
  Valspar_2096_LamentBlue: 35341,
  Valspar_2097_HighNoon: 35342,
  Valspar_2098_LucyBlue: 35343,
  Valspar_2099_FloodTide: 35344,
  Valspar_2100_SkySpace: 35345,
  Valspar_2101_PerfectStorm: 35346,
  Valspar_2103_IceSculpture: 35347,
  Valspar_2104_TidalBasin: 35348,
  Valspar_2105_RushingRapids: 35349,
  Valspar_2106_BlueChina: 35350,
  Valspar_2111_OceanSigh: 35351,
  Valspar_2112_PoolParty: 35352,
  Valspar_2113_WishingWell: 35353,
  Valspar_2114_WinterInParis: 35354,
  Valspar_2115_SmokeInfusion: 35355,
  Valspar_2116_SeafoamStorm: 35356,
  Valspar_2117_Beguile: 35357,
  Valspar_2118_CoastalDusk: 35358,
  Valspar_2119_SableCalm: 35359,
  Valspar_2120_DistantValley: 35360,
  Valspar_2121_SparklingLake: 35361,
  Valspar_2123_SecludedGarden: 35362,
  Valspar_2124_VillaBlue: 35363,
  Valspar_2132_TropicalMist: 35364,
  Valspar_2133_SurfSpray: 35365,
  Valspar_2134_TidalWave: 35366,
  Valspar_2135_SeaSerenade: 35367,
  Valspar_2136_AquaDance: 35368,
  Valspar_2137_NightScape: 35369,
  Valspar_2138_Crystalline: 35370,
  Valspar_2139_Misty: 35371,
  Valspar_2140_SummerSplash: 35372,
  Valspar_2141_FiestaBlue: 35373,
  Valspar_2144_QuietMint: 35374,
  Valspar_2146_SpringSpirits: 35375,
  Valspar_2147_CottageLatticeGreen: 35376,
  Valspar_2148_LushSage: 35377,
  Valspar_2152_AprilThicket: 35378,
  Valspar_2153_GreenWater: 35379,
  Valspar_2156_AquaticEdge: 35380,
  Valspar_2161_ShadyPalm: 35381,
  Valspar_2168_RiverMist: 35382,
  Valspar_2169_AngelicBlue: 35383,
  Valspar_2170_InfinityPool: 35384,
  Valspar_2171_Rapids: 35385,
  Valspar_2172_ExoticSea: 35386,
  Valspar_2173_BayTeal: 35387,
  Valspar_2179_Flora: 35388,
  Valspar_2180_PirateCoast: 35389,
  Valspar_2181_GardenFlower: 35390,
  Valspar_2184_BlueridgeFir: 35391,
  Valspar_2185_CanadianFir: 35392,
  Valspar_2187_TranquilBay: 35393,
  Valspar_2189_SpaGreen: 35394,
  Valspar_2195_GoneFishing: 35395,
  Valspar_2196_TropicalOasis: 35396,
  Valspar_2198_IcyBlue: 35397,
  Valspar_2199_OutOfTheBlue: 35398,
  Valspar_2200_BeachSparkle: 35399,
  Valspar_2207_SecretMoss: 35400,
  Valspar_2208_MurkySage: 35401,
  Valspar_2209_QuakingBog: 35402,
  Valspar_2210_Luna: 35403,
  Valspar_2211_SparklingSage: 35404,
  Valspar_2219_CoolBluegrass: 35405,
  Valspar_2220_HangingVine: 35406,
  Valspar_2221_BilliardRoom: 35407,
  Valspar_2231_Bayside: 35408,
  Valspar_2232_TurquoiseTint: 35409,
  Valspar_2233_BlueTurquoise: 35410,
  Valspar_2235_NotreDame: 35411,
  Valspar_2236_GraniteDust: 35412,
  Valspar_2237_WetPavement: 35413,
  Valspar_2238_PorcelainShale: 35414,
  Valspar_2239_SableEvening: 35415,
  Valspar_2241_WeddingMint: 35416,
  Valspar_2242_GreenTrellis: 35417,
  Valspar_2243_IrishPaddock: 35418,
  Valspar_2244_GinkgoTree: 35419,
  Valspar_2245_Treeline: 35420,
  Valspar_2246_MintyDelight: 35421,
  Valspar_2247_AloeVera: 35422,
  Valspar_2248_SpearmintHaze: 35423,
  Valspar_2252_SeaBreath: 35424,
  Valspar_2253_CrystalAqua: 35425,
  Valspar_2254_BayMist: 35426,
  Valspar_2255_Swim: 35427,
  Valspar_2256_TidalTeal: 35428,
  Valspar_2257_FishStory: 35429,
  Valspar_2259_Frosty: 35430,
  Valspar_2260_SeaWave: 35431,
  Valspar_2261_Seafarer: 35432,
  Valspar_2262_LagunaGreen: 35433,
  Valspar_2263_TropicalHideaway: 35434,
  Valspar_2265_StonyPath: 35435,
  Valspar_2266_CoastalJetty: 35436,
  Valspar_2267_GrayExpose: 35437,
  Valspar_2268_LeadCast: 35438,
  Valspar_2269_Wetlands: 35439,
  Valspar_2270_GlowingGreen: 35440,
  Valspar_2271_MellowSpring: 35441,
  Valspar_2272_GreenGarlands: 35442,
  Valspar_2273_LeafyRise: 35443,
  Valspar_2274_NorthernGlen: 35444,
  Valspar_2275_BoughsOfPine: 35445,
  Valspar_2276_CrocodileDreams: 35446,
  Valspar_2277_KissOfMint: 35447,
  Valspar_2278_RollingGlen: 35448,
  Valspar_2279_Meadowgrass: 35449,
  Valspar_2280_PlazaGreen: 35450,
  Valspar_2281_MixedwoodLeaf: 35451,
  Valspar_2282_MysticSea: 35452,
  Valspar_2283_LakeBreeze: 35453,
  Valspar_2284_GentleWave: 35454,
  Valspar_2285_TwilightMeadow: 35455,
  Valspar_2286_DreamyTeal: 35456,
  Valspar_2289_AquaGlow: 35457,
  Valspar_2290_Nautical: 35458,
  Valspar_2291_SimplyAqua: 35459,
  Valspar_2292_TantalizingTeal: 35460,
  Valspar_2293_SeaSwell: 35461,
  Valspar_2295_BaySands: 35462,
  Valspar_2296_SandySage: 35463,
  Valspar_2297_SweetCarolina: 35464,
  Valspar_2298_Ironclad: 35465,
  Valspar_2300_PaleOakGrove: 35466,
  Valspar_2306_PaleTidepool: 35467,
  Valspar_2307_JadedLime: 35468,
  Valspar_2308_HeartlandFrosty: 35469,
  Valspar_2309_GreenGoddess: 35470,
  Valspar_2310_SpringLeaves: 35471,
  Valspar_2311_FieldTimeGreen: 35472,
  Valspar_2312_MintWhisper: 35473,
  Valspar_2318_Sprinkle: 35474,
  Valspar_2319_AquaticMist: 35475,
  Valspar_2320_FreshMist: 35476,
  Valspar_2321_BlackEvergreen: 35477,
  Valspar_2322_PacificPleasure: 35478,
  Valspar_2323_RogueBlue: 35479,
  Valspar_2324_DeepestRiver: 35480,
  Valspar_2326_NorthernHemisphere: 35481,
  Valspar_2327_GreenSuede: 35482,
  Valspar_2328_ArtisanGreen: 35483,
  Valspar_2331_ForestCanopy: 35484,
  Valspar_2333_PitchCobalt: 35485,
  Valspar_2334_DeepRiverGreen: 35486,
  Valspar_2335_PeacockHouse: 35487,
  Valspar_2338_ElegantSilk: 35488,
  Valspar_2341_NocturnalGreen: 35489,
  Valspar_2343_VeryBlack: 35490,
  Valspar_2344_EvergladeDeck: 35491,
  Valspar_2348_StainedGlass: 35492,
  Valspar_2354_TeaStain: 35493,
  Valspar_2359_OliveSmudge: 35494,
  Valspar_2360_AncientOlive: 35495,
  Valspar_2361_MintFrost: 35496,
  Valspar_2363_BlanchedThyme: 35497,
  Valspar_2364_NativeHenna: 35498,
  Valspar_2365_Tarragon: 35499,
  Valspar_2367_PrairieWillow: 35500,
  Valspar_2368_ZenGarden: 35501,
  Valspar_2369_GloamingGreen: 35502,
  Valspar_2370_CoolGreen: 35503,
  Valspar_2371_GracefulGreen: 35504,
  Valspar_2372_IcyMint: 35505,
  Valspar_2373_MintGala: 35506,
  Valspar_2374_GreenSupreme: 35507,
  Valspar_2375_Kelp: 35508,
  Valspar_2376_Salamander: 35509,
  Valspar_2377_DeepMint: 35510,
  Valspar_2381_LavishGreen: 35511,
  Valspar_2382_NewMeadow: 35512,
  Valspar_2383_TropicalRainforest: 35513,
  Valspar_2384_GildedLinen: 35514,
  Valspar_2386_GraySilt: 35515,
  Valspar_2387_TornadoWatch: 35516,
  Valspar_2388_MossyAura: 35517,
  Valspar_2390_Panacea: 35518,
  Valspar_2391_ParisMint: 35519,
  Valspar_2392_SumptuousSage: 35520,
  Valspar_2393_BriskOlive: 35521,
  Valspar_2394_GardenOfParadise: 35522,
  Valspar_2395_CandiedLime: 35523,
  Valspar_2408_UltraGreen: 35524,
  Valspar_2409_BeachBlanket: 35525,
  Valspar_2410_SeaTreasure: 35526,
  Valspar_2411_SpearmintBurst: 35527,
  Valspar_2412_Divot: 35528,
  Valspar_2413_CosmicGreen: 35529,
  Valspar_2414_SeptemberFog: 35530,
  Valspar_2415_Frappe: 35531,
  Valspar_2417_Artichoke: 35532,
  Valspar_2418_Empire: 35533,
  Valspar_2419_TurkishCoffee: 35534,
  Valspar_2420_SpringReflection: 35535,
  Valspar_2427_TimidAbsinthe: 35536,
  Valspar_2428_MildEvergreen: 35537,
  Valspar_2429_EvergladeGlen: 35538,
  Valspar_2430_FiddleheadFern: 35539,
  Valspar_2431_PalmLeaf: 35540,
  Valspar_2438_DelicateFrost: 35541,
  Valspar_2439_MinosEye: 35542,
  Valspar_2440_GreenGala: 35543,
  Valspar_2441_GreenShimmer: 35544,
  Valspar_2442_GreenGalore: 35545,
  Valspar_2443_Spinach: 35546,
  Valspar_2444_SnowedIn: 35547,
  Valspar_2445_SoulfulGrey: 35548,
  Valspar_2446_AshenGray: 35549,
  Valspar_2447_AspenGray: 35550,
  Valspar_2448_MountainSmoke: 35551,
  Valspar_2462_MintMist: 35552,
  Valspar_2463_SprigOfMint: 35553,
  Valspar_2469_SummerSigh: 35554,
  Valspar_2470_GardenSprout: 35555,
  Valspar_2471_Greenscape: 35556,
  Valspar_2472_JauntyGreen: 35557,
  Valspar_2473_Greenway: 35558,
  Valspar_2474_Asiago: 35559,
  Valspar_2475_VillaGrey: 35560,
  Valspar_2476_SmokedOyster: 35561,
  Valspar_2477_CoastalVilla: 35562,
  Valspar_2478_Seine: 35563,
  Valspar_2481_BrownBuzz: 35564,
  Valspar_2482_Oakmoss: 35565,
  Valspar_2483_DustyOlive: 35566,
  Valspar_2484_RipeOlive: 35567,
  Valspar_2485_SummersEnd: 35568,
  Valspar_2487_LeafBud: 35569,
  Valspar_2488_HerbCornucopia: 35570,
  Valspar_2489_JalapenoJelly: 35571,
  Valspar_2490_OrganicGarden: 35572,
  Valspar_2491_GreenJalapeno: 35573,
  Valspar_2498_GreenMist: 35574,
  Valspar_2500_LushMeadow: 35575,
  Valspar_250008_AntiqueBuff: 35576,
  Valspar_250010_CrispCotton: 35577,
  Valspar_250012_DoverWhite: 35578,
  Valspar_250014_HighHideWhite: 35579,
  Valspar_250030_ShellWhite: 35580,
  Valspar_2502_SpringLime: 35581,
  Valspar_2503_Awakening: 35582,
  Valspar_2504_WarmPutty: 35583,
  Valspar_2505_Oatbran: 35584,
  Valspar_2506_IvoryBrown: 35585,
  Valspar_2507_StoneManor: 35586,
  Valspar_2508_SafariBeige: 35587,
  Valspar_2509_RoastedSepia: 35588,
  Valspar_2511_LunarTide: 35589,
  Valspar_2512_BayouShade: 35590,
  Valspar_2515_CityArboretum: 35591,
  Valspar_2516_TemperedSage: 35592,
  Valspar_2517_ParlourSage: 35593,
  Valspar_2519_ThrowRug: 35594,
  Valspar_2520_OliveRush: 35595,
  Valspar_2522_WhippedMint: 35596,
  Valspar_2528_AppleSlice: 35597,
  Valspar_2529_SpringGlow: 35598,
  Valspar_2530_SpringLawn: 35599,
  Valspar_2531_Celery: 35600,
  Valspar_2538_WildHawk: 35601,
  Valspar_2541_FennelSplash: 35602,
  Valspar_2542_WitheredMoss: 35603,
  Valspar_2543_GoldInfusion: 35604,
  Valspar_2544_RollingPrairie: 35605,
  Valspar_2545_MountainOlive: 35606,
  Valspar_2546_GreenHighland: 35607,
  Valspar_2547_PlumPassion: 35608,
  Valspar_2548_OliveMarinade: 35609,
  Valspar_2549_NewAvocado: 35610,
  Valspar_2550_GildedPesto: 35611,
  Valspar_2551_CrushedOregano: 35612,
  Valspar_2553_Grasshopper: 35613,
  Valspar_2554_FreshPear: 35614,
  Valspar_2555_SonicLime: 35615,
  Valspar_2556_Temptation: 35616,
  Valspar_2557_Martian: 35617,
  Valspar_2560_FluorescentLime: 35618,
  Valspar_2566_SoftStones: 35619,
  Valspar_2568_Sandalwood: 35620,
  Valspar_2569_PrairieFoliage: 35621,
  Valspar_2570_Daybreak: 35622,
  Valspar_2571_DakotaTrail: 35623,
  Valspar_2572_Epic: 35624,
  Valspar_2573_DryEarth: 35625,
  Valspar_2574_CarawayShield: 35626,
  Valspar_2575_ValenciaMoss: 35627,
  Valspar_2576_DesertFlower: 35628,
  Valspar_2577_HeartOfPalm: 35629,
  Valspar_2583_Gleeful: 35630,
  Valspar_2586_ParsleySprig: 35631,
  Valspar_2587_Asparagus: 35632,
  Valspar_2588_LimeKiss: 35633,
  Valspar_2591_SafariBrown: 35634,
  Valspar_2592_SassyGreen: 35635,
  Valspar_2596_Wilderness: 35636,
  Valspar_2598_VegasGreen: 35637,
  Valspar_2599_LimeTwist: 35638,
  Valspar_2603_DeepEarth: 35639,
  Valspar_2608_LusciousGreen: 35640,
  Valspar_2611_FiredEarth: 35641,
  Valspar_2613_FreshHoneysuckle: 1892,
  Valspar_2616_AgedPine: 35642,
  Valspar_2617_FourLeafClover: 35643,
  Valspar_2618_BrightParrot: 35644,
  Valspar_2625_MosaicPink: 35645,
  Valspar_2629_CinemaScreen: 35646,
  Valspar_2630_HeirloomPink: 35647,
  Valspar_2631_CrushedOut: 35648,
  Valspar_2634_Naivete: 35649,
  Valspar_2644_BallroomBelle: 35650,
  Valspar_2645_ClayAngel: 35651,
  Valspar_2646_BermudaSand: 35652,
  Valspar_2648_QuailEgg: 35653,
  Valspar_2649_CourtyardTan: 35654,
  Valspar_2650_CreamDelight: 35655,
  Valspar_2652_SwissCoffee: 35656,
  Valspar_2653_AbalonePink: 35657,
  Valspar_2655_NightLight: 35658,
  Valspar_2657_AntiqueWhite: 35659,
  Valspar_2658_CameoWhite: 35660,
  Valspar_2664_Statuesque: 35661,
  Valspar_2665_DuJour: 35662,
  Valspar_2666_DoveWhite: 35663,
  Valspar_2667_PaleBloom: 35664,
  Valspar_2669_ParlourTaupe: 35665,
  Valspar_2670_Drumskin: 35666,
  Valspar_2672_Frolic: 35667,
  Valspar_2676_PolarWhite: 35668,
  Valspar_2680_Unforgettable: 35669,
  Valspar_2684_LemonEdge: 35670,
  Valspar_2689_IvoryLace: 35671,
  Valspar_2692_MaltedMilk: 35672,
  Valspar_2693_WinterDawn: 35673,
  Valspar_2694_FragileBlue: 35674,
  Valspar_2695_BlueKiss: 35675,
  Valspar_2697_Prudence: 35676,
  Valspar_2698_WhiteSash: 35677,
  Valspar_2700_SheerLight: 35678,
  Valspar_2702_SandstoneGray: 35679,
  Valspar_2703_SilverDust: 35680,
  Valspar_2704_SoftSilk: 35681,
  Valspar_2706_MorningLake: 35682,
  Valspar_2709_AngelTouch: 35683,
  Valspar_2710_LilacMuse: 35684,
  Valspar_2711_TsunamiSky: 35685,
  Valspar_2712_FluffySlippers: 35686,
  Valspar_2713_GrayOpal: 35687,
  Valspar_2716_GrayShimmer: 35688,
  Valspar_2724_BetsysLinen: 35689,
  Valspar_2728_Stillness: 35690,
  Valspar_2735_Acropolis: 35691,
  Valspar_2741_WispyWhite: 35692,
  Valspar_2742_CoolGray: 35693,
  Valspar_2744_Salute: 35694,
  Valspar_2749_SummerGray: 35695,
  Valspar_2750_BlizzardFog: 35696,
  Valspar_2755_ParamountWhite: 35697,
  Valspar_2757_UltraWhite: 35698,
  Valspar_2759_BistroWhite: 35699,
  Valspar_2760_CitySteam: 35700,
  Valspar_2761_PolishedIvory: 35701,
  Valspar_2763_DivineCream: 35702,
  Valspar_2764_TottensInlet: 35703,
  Valspar_2921_TeaBiscuit: 1893,
  Valspar_2926_GoldPlate: 1894,
  Valspar_30037B_LeatherSatchel: 1895,
  Valspar_3374_Tattletale: 1896,
  Valspar_3405_SilverSaber: 1897,
  Valspar_40031C_RockyBluffs: 1898,
  Valspar_40042A_OmbraGray: 1899,
  Valspar_40052B_HighSpeedSteel: 1900,
  Valspar_50032C_BlackenedPine: 1901,
  Valspar_50044B_JekyllSansSouci: 1902,
  Valspar_50053A_Luna: 1903,
  Valspar_50053C_JekyllGrandDining: 1904,
  Valspar_50061A_CometDust: 1905,
  Valspar_50061C_GraniteDust: 1906,
  Valspar_50062B_PorcelainShale: 1907,
  Valspar_50081C_LyndhurstCastle: 1908,
  Valspar_50102_PitchedCobalt: 1909,
  Valspar_60032B_Empire: 1910,
  Valspar_60042C_EnglishTeaParty: 1911,
  Valspar_60093_MontanaMoss: 1912,
  Valspar_700559_HeritageGray: 35704,
  Valspar_700562_InYourDreams: 35705,
  Valspar_700565_IcingOnTheCake: 35706,
  Valspar_700568_PinkBangles: 35707,
  Valspar_700571_DashOfPink: 35708,
  Valspar_700574_CrushedGrapefruit: 35709,
  Valspar_700577_SteelheadRedd: 35710,
  Valspar_700580_FierySky: 35711,
  Valspar_700583_SandyPeppers: 35712,
  Valspar_700586_BonfireGlow: 35713,
  Valspar_700589_AmethystIce: 35714,
  Valspar_700592_RipeBanana: 35715,
  Valspar_700595_IlluminateMe: 35716,
  Valspar_700598_SimonSays: 35717,
  Valspar_700601_SethsSmile: 35718,
  Valspar_700604_Nectar: 35719,
  Valspar_700607_CabanaGlow: 35720,
  Valspar_700610_EastOfTheSun: 35721,
  Valspar_700613_WildDaffodil: 35722,
  Valspar_700616_PursuitOfHappiness: 35723,
  Valspar_700619_PickledPeppers: 35724,
  Valspar_700622_LaVida: 35725,
  Valspar_700625_Perennial: 35726,
  Valspar_700628_Beacon: 35727,
  Valspar_700631_LaughingLiam: 35728,
  Valspar_700634_Tomatillo: 35729,
  Valspar_700637_MasterGardener: 35730,
  Valspar_700640_SunlitMeadow: 35731,
  Valspar_700643_Verde: 35732,
  Valspar_700646_AppleJade: 35733,
  Valspar_700649_Matcha: 35734,
  Valspar_700652_VintageChartreuse: 35735,
  Valspar_700655_SunnyLime: 35736,
  Valspar_700658_PlusUltra: 35737,
  Valspar_700661_Pishposh: 35738,
  Valspar_700664_Comtesse: 35739,
  Valspar_700667_RefreshingGreen: 35740,
  Valspar_700670_EmeraldEnchantment: 35741,
  Valspar_700673_ShadowsOfTime: 35742,
  Valspar_700676_LaterGator: 35743,
  Valspar_700679_TotallyTeal: 35744,
  Valspar_700682_TheCrowdRoars: 35745,
  Valspar_700685_BestOfBothWorlds: 35746,
  Valspar_700688_BayouSerenade: 35747,
  Valspar_700691_PinkPizzazz: 35748,
  Valspar_700694_PinchMeImDreaming: 35749,
  Valspar_700697_LaissezFaire: 35750,
  Valspar_700700_OpenBook: 35751,
  Valspar_700703_OhSoVo: 35752,
  Valspar_700706_LadyInWaiting: 35753,
  Valspar_700709_MomentOfGrace: 35754,
  Valspar_700712_BffBlue: 35755,
  Valspar_700715_PatAPep: 35756,
  Valspar_700718_BiroBlue: 35757,
  Valspar_700721_DenasDelight: 35758,
  Valspar_700724_WildBlueYonder: 35759,
  Valspar_700727_Picasso: 35760,
  Valspar_700730_InTheNick: 35761,
  Valspar_700733_StrongWill: 35762,
  Valspar_700736_Slipstream: 35763,
  Valspar_700739_CobaltGlow: 35764,
  Valspar_700742_MiracleAtWrigley: 35765,
  Valspar_700745_OnButterflyWings: 35766,
  Valspar_700748_Organza: 35767,
  Valspar_700751_Dulcinea: 35768,
  Valspar_700754_Eventide: 35769,
  Valspar_700757_Beloved: 35770,
  Valspar_700760_FieldsOfHeather: 35771,
  Valspar_700763_Plush: 35772,
  Valspar_700766_BlueEmber: 35773,
  Valspar_700769_MerlinsRobes: 35774,
  Valspar_700772_HeartsAflutter: 35775,
  Valspar_700775_WillOTheWisp: 35776,
  Valspar_700778_PurpleHibiscus: 35777,
  Valspar_700781_Purpleheart: 35778,
  Valspar_700784_Bravo: 35779,
  Valspar_700787_PerfectPout: 35780,
  Valspar_700790_Glorious: 35781,
  Valspar_700793_MonCherAmi: 35782,
  Valspar_700796_FireBreathingDragon: 35783,
  Valspar_700799_ConBrio: 35784,
  Valspar_700802_PetalPower: 35785,
  Valspar_700805_ElizaJane: 35786,
  Valspar_700808_CatNose: 35787,
  Valspar_700811_CandyFloss: 35788,
  Valspar_700814_StrawberryMoon: 35789,
  Valspar_700817_TroutPout: 35790,
  Valspar_700820_TresBien: 35791,
  Valspar_700823_ScarletButter: 35792,
  Valspar_700826_PinkSoap: 35793,
  Valspar_700829_PrettyInPeach: 35794,
  Valspar_700832_VenetianPlaster: 35795,
  Valspar_700835_RosyPashmina: 35796,
  Valspar_700838_AutumnIvy: 35797,
  Valspar_700841_RedMaple: 35798,
  Valspar_700844_SmokedPaprika: 35799,
  Valspar_700847_PeachesAndCream: 35800,
  Valspar_700850_Peanut: 35801,
  Valspar_700853_MeltingSunset: 35802,
  Valspar_700856_FiresideChat: 35803,
  Valspar_700859_GlazedGinger: 35804,
  Valspar_700862_SassySassafras: 35805,
  Valspar_700865_HomewardBound: 35806,
  Valspar_700868_BonfireToffee: 35807,
  Valspar_700871_Shetland: 35808,
  Valspar_700874_SweetAndSour: 35809,
  Valspar_700877_Impala: 35810,
  Valspar_700880_DulceDeLeche: 35811,
  Valspar_700883_VintageLincoln: 35812,
  Valspar_700886_SpunMoonbeams: 35813,
  Valspar_700889_HampsteadHeath: 35814,
  Valspar_700892_Umbra: 35815,
  Valspar_700895_Grappa: 35816,
  Valspar_700898_TupeloHoney: 35817,
  Valspar_700901_Gingerbread: 35818,
  Valspar_700904_Komodo: 35819,
  Valspar_700907_Brazen: 35820,
  Valspar_700910_HomeBrew: 35821,
  Valspar_700913_Ginseng: 35822,
  Valspar_700916_KelseysCurls: 35823,
  Valspar_700919_PapyrusPlant: 35824,
  Valspar_700922_FurtherAfield: 35825,
  Valspar_700925_SlenderStem: 35826,
  Valspar_700928_ScottishMoss: 35827,
  Valspar_700931_SleepyHamlet: 35828,
  Valspar_700934_MeadowMorn: 35829,
  Valspar_700937_PressedOlives: 35830,
  Valspar_700940_OrigamiClover: 35831,
  Valspar_700943_LeapsAndBounds: 35832,
  Valspar_700946_CarpathianDawn: 35833,
  Valspar_700949_NobleEric: 35834,
  Valspar_700952_PinkIvory: 35835,
  Valspar_700955_LavenderKnoll: 35836,
  Valspar_700958_CoolPeridot: 35837,
  Valspar_700961_LuckBeALady: 35838,
  Valspar_700964_WhippedPistachio: 35839,
  Valspar_700967_SnippedChive: 35840,
  Valspar_700970_Catnip: 35841,
  Valspar_700973_ShepherdsGreen: 35842,
  Valspar_700976_MintIntermezzo: 35843,
  Valspar_700979_GreenGrapes: 35844,
  Valspar_700982_FrostedSage: 35845,
  Valspar_700985_GreenEyedLady: 35846,
  Valspar_700988_KingTheo: 35847,
  Valspar_700991_LaurelWreath: 35848,
  Valspar_700994_JeremysJourney: 35849,
  Valspar_700997_LuminousMist: 35850,
  Valspar_701000_Fescue: 35851,
  Valspar_701003_WaveRunner: 35852,
  Valspar_701006_CarnivalGlass: 35853,
  Valspar_701009_TouchOfFrost: 35854,
  Valspar_701012_ToadstoolTeal: 35855,
  Valspar_701015_HaikuBlue: 35856,
  Valspar_701018_Droplet: 35857,
  Valspar_701021_CeruleanSkies: 35858,
  Valspar_701024_DeepWater: 35859,
  Valspar_701027_Aloha: 35860,
  Valspar_701030_Forever: 35861,
  Valspar_701033_FreshDawn: 35862,
  Valspar_701036_BrightAndBreezy: 35863,
  Valspar_701039_GossamerThreads: 35864,
  Valspar_701042_OceanHorizon: 35865,
  Valspar_701045_BlueNebula: 35866,
  Valspar_701048_ParrotFlight: 35867,
  Valspar_701051_DeepAtlantic: 35868,
  Valspar_701054_EasyBreezy: 35869,
  Valspar_701057_NeptunesCastle: 35870,
  Valspar_701060_Aster: 35871,
  Valspar_701063_BlueRidgeMist: 35872,
  Valspar_701066_BlueSpirit: 35873,
  Valspar_701069_JesterBlue: 35874,
  Valspar_701072_MarianaTrench: 35875,
  Valspar_701075_QuietNook: 35876,
  Valspar_701078_DeepUniverse: 35877,
  Valspar_701081_BackOfBeyond: 35878,
  Valspar_701084_SoundWaves: 35879,
  Valspar_701087_AngelSol: 35880,
  Valspar_701090_SoulBlue: 35881,
  Valspar_701093_Cornwall: 35882,
  Valspar_701096_Chintz: 35883,
  Valspar_701099_CapeCod: 35884,
  Valspar_701102_BlueberryFestival: 35885,
  Valspar_701105_Bandana: 35886,
  Valspar_701108_KatesRing: 35887,
  Valspar_701111_BlueberryIce: 35888,
  Valspar_701114_BluePrism: 35889,
  Valspar_701117_Moonglow: 35890,
  Valspar_701120_ParadiseFound: 35891,
  Valspar_701123_Peyton: 35892,
  Valspar_701126_MoroccanResort: 35893,
  Valspar_701129_Encore: 35894,
  Valspar_701132_LoveCrystal: 35895,
  Valspar_701135_CarouselPurple: 35896,
  Valspar_701138_CanopyBed: 35897,
  Valspar_701141_WatercolorGrape: 35898,
  Valspar_701144_BonVivant: 35899,
  Valspar_701147_PinkDiamond: 35900,
  Valspar_701150_ShadedPrimrose: 35901,
  Valspar_701153_ThaiChili: 35902,
  Valspar_701156_Awe: 35903,
  Valspar_701159_PinkCashmere: 35904,
  Valspar_701162_MadAboutMaddie: 35905,
  Valspar_701165_HomeAndHearth: 35906,
  Valspar_701168_MistyLoch: 35907,
  Valspar_701171_SunsweptSand: 35908,
  Valspar_701174_Nougat: 35909,
  Valspar_701177_FelineFrolic: 35910,
  Valspar_701180_MyChai: 35911,
  Valspar_701183_Grizzly: 35912,
  Valspar_701186_FuzzyScruff: 35913,
  Valspar_701189_SandstoneCliff: 35914,
  Valspar_701192_CrumblingCork: 35915,
  Valspar_701195_MiddleEarth: 35916,
  Valspar_701198_PalePurple: 35917,
  Valspar_701201_PocketfulOfPosies: 35918,
  Valspar_701204_Nankeen: 35919,
  Valspar_701207_TurboTan: 35920,
  Valspar_701210_JacobsLadder: 35921,
  Valspar_701213_WarmNutmeg: 35922,
  Valspar_701216_Teak: 35923,
  Valspar_701219_CoconutHusk: 35924,
  Valspar_701222_CreminiMushroom: 35925,
  Valspar_701225_GentleFawn: 35926,
  Valspar_701228_MoreCowbell: 35927,
  Valspar_701231_CastellHarlech: 35928,
  Valspar_701234_SandMountain: 35929,
  Valspar_701237_ElDorado: 35930,
  Valspar_701240_Retrofit: 35931,
  Valspar_701243_HoneyMoon: 35932,
  Valspar_701246_PeasantBread: 35933,
  Valspar_701249_WagonTrain: 35934,
  Valspar_701252_Consomme: 35935,
  Valspar_701255_FamilyTree: 35936,
  Valspar_701258_OrganicStyle: 35937,
  Valspar_701261_HuntingJacket: 35938,
  Valspar_701264_MeadowDew: 35939,
  Valspar_701267_MarshGrass: 35940,
  Valspar_701270_Grow: 35941,
  Valspar_701273_GardenGlory: 35942,
  Valspar_701276_SwanDance: 35943,
  Valspar_701279_GreekOregano: 35944,
  Valspar_701282_DreamGrass: 35945,
  Valspar_701285_PlatinumSage: 35946,
  Valspar_701288_GoodToGrow: 35947,
  Valspar_701291_SweetPeaInAPod: 35948,
  Valspar_701294_AutumnGrove: 35949,
  Valspar_701297_VineyardView: 35950,
  Valspar_701300_SeaTurtle: 35951,
  Valspar_701303_CremeDeMenthe: 35952,
  Valspar_701306_NewGrowth: 35953,
  Valspar_701309_Archisa: 35954,
  Valspar_701312_FieldsAfar: 35955,
  Valspar_701315_PrairieSage: 35956,
  Valspar_701318_DriedBayLeaf: 35957,
  Valspar_701321_OliveDrab: 35958,
  Valspar_701324_HerbGarland: 35959,
  Valspar_701327_BlushOfHyacinth: 35960,
  Valspar_701330_CalmCupid: 35961,
  Valspar_701333_PurpleSunset: 35962,
  Valspar_701336_PlummyRouge: 35963,
  Valspar_701339_SweetClover: 35964,
  Valspar_701342_CoolPine: 35965,
  Valspar_701345_SolsticeBreeze: 35966,
  Valspar_701348_AppleBlossomGreen: 35967,
  Valspar_701351_ApothecaryJar: 35968,
  Valspar_701354_BuddingGreen: 35969,
  Valspar_701357_SalonGreen: 35970,
  Valspar_701360_OpalFire: 35971,
  Valspar_701363_OceanFroth: 35972,
  Valspar_701366_BogFog: 35973,
  Valspar_701369_BlueFescue: 35974,
  Valspar_701372_SaltySea: 35975,
  Valspar_701375_SherwoodForest: 35976,
  Valspar_701378_PhoenixTears: 35977,
  Valspar_701381_Mallard: 35978,
  Valspar_701384_Wintergreen: 35979,
  Valspar_701387_JuniperMist: 35980,
  Valspar_701390_JadeSea: 35981,
  Valspar_701393_RenewBlue: 35982,
  Valspar_701396_MidsummerNight: 35983,
  Valspar_701399_BlueBottle: 35984,
  Valspar_701402_WildLife: 35985,
  Valspar_701405_FogBlue: 35986,
  Valspar_701408_GrandPrix: 35987,
  Valspar_701411_BlownGlass: 35988,
  Valspar_701414_Artiste: 35989,
  Valspar_701417_SeaStar: 35990,
  Valspar_701420_WindsweptClouds: 35991,
  Valspar_701423_LaidBackBlue: 35992,
  Valspar_701426_LowTide: 35993,
  Valspar_701429_LongWater: 35994,
  Valspar_701432_BahamaBreezes: 35995,
  Valspar_701435_SummerRain: 35996,
  Valspar_701438_ArcticSunrise: 35997,
  Valspar_701441_WinterTwilight: 35998,
  Valspar_701444_PeacockBlues: 35999,
  Valspar_701447_DragonsLair: 36000,
  Valspar_701450_DeepGalaxy: 36001,
  Valspar_701453_Windchill: 36002,
  Valspar_701456_CrispCollar: 36003,
  Valspar_701459_BareMinimum: 36004,
  Valspar_701462_Dreamstress: 36005,
  Valspar_701465_Providence: 36006,
  Valspar_701468_EasyOnTheEyes: 36007,
  Valspar_701471_TimesCurrent: 36008,
  Valspar_701474_QuietRain: 36009,
  Valspar_701477_Penelope: 36010,
  Valspar_701480_BrushStroke: 36011,
  Valspar_701483_CryMeARiver: 36012,
  Valspar_701486_IndigoDreams: 36013,
  Valspar_701489_SapphireEarbobs: 36014,
  Valspar_701492_Nightfall: 36015,
  Valspar_701495_Kindness: 36016,
  Valspar_701498_PeriWink: 36017,
  Valspar_701501_BonnieBlue: 36018,
  Valspar_701504_HouseOfOwen: 36019,
  Valspar_701507_PuttinOnTheRitz: 36020,
  Valspar_701510_AlpineForgetMeNot: 36021,
  Valspar_701513_Skyline: 36022,
  Valspar_701516_DaybreakBeckons: 36023,
  Valspar_701519_AStitchInTime: 36024,
  Valspar_701522_SoulSister: 36025,
  Valspar_701525_Macaw: 36026,
  Valspar_701528_ShadowMountain: 36027,
  Valspar_701531_WhenWorldsCollide: 36028,
  Valspar_701534_Emperor: 36029,
  Valspar_701537_RoseSugar: 36030,
  Valspar_701540_ApricotBlush: 36031,
  Valspar_701543_NectarineSpice: 36032,
  Valspar_701546_Charmed: 36033,
  Valspar_701549_JeMApelleMissy: 36034,
  Valspar_701552_FarmFreshEggs: 36035,
  Valspar_701555_MarshmallowCocoa: 36036,
  Valspar_701558_SafariMap: 36037,
  Valspar_701561_Teddy: 36038,
  Valspar_701564_WispOfCocoa: 36039,
  Valspar_701567_VanillaIcedCoffee: 36040,
  Valspar_701570_WovenJute: 36041,
  Valspar_701573_SaharaDust: 36042,
  Valspar_701576_TanglewoodPark: 36043,
  Valspar_701579_MishMosh: 36044,
  Valspar_701582_Fiddlesticks: 36045,
  Valspar_701585_CuppaTea: 36046,
  Valspar_701588_HauteHickory: 36047,
  Valspar_701591_VillageLane: 36048,
  Valspar_701594_ClassicKhaki: 36049,
  Valspar_701597_HazyEarth: 36050,
  Valspar_701600_CoyoteWild: 36051,
  Valspar_701603_FrontierParadise: 36052,
  Valspar_701606_JungleBeat: 36053,
  Valspar_701609_WhisperSoft: 36054,
  Valspar_701612_FriskyWhiskers: 36055,
  Valspar_701615_StormRollingIn: 36056,
  Valspar_701618_NightOnTheMoors: 36057,
  Valspar_701621_DoubleInfinity: 36058,
  Valspar_701624_BlackCurrant: 36059,
  Valspar_701627_SheepskinRug: 36060,
  Valspar_701630_OdeToJoy: 36061,
  Valspar_701633_WeatheredPlank: 36062,
  Valspar_701636_MidnightForest: 36063,
  Valspar_701639_FreshArtichoke: 36064,
  Valspar_701642_SnowOnThePines: 36065,
  Valspar_701645_DanceWithTheWind: 36066,
  Valspar_701648_EarthFriendly: 36067,
  Valspar_701651_FreshLeaf: 36068,
  Valspar_701654_BrusselsSprouts: 36069,
  Valspar_701657_GrassyCliff: 36070,
  Valspar_701660_TrellisClimber: 36071,
  Valspar_701663_GossamerGreen: 36072,
  Valspar_701666_SnakeCharmer: 36073,
  Valspar_701669_SoothingSage: 36074,
  Valspar_701672_BladeOfGrass: 36075,
  Valspar_701675_GoodEarth: 36076,
  Valspar_701678_PrivateAffair: 36077,
  Valspar_701681_WoodPigeon: 36078,
  Valspar_701684_SeineAndSensibility: 36079,
  Valspar_701687_SageTheDay: 36080,
  Valspar_701690_GlassPebble: 36081,
  Valspar_701693_GentleSoul: 36082,
  Valspar_701696_MotherNature: 36083,
  Valspar_701699_GreenTurquoise: 36084,
  Valspar_701702_Gargoyle: 36085,
  Valspar_701705_ThaiBasil: 36086,
  Valspar_701708_HydePark: 36087,
  Valspar_701711_WharfWind: 36088,
  Valspar_701714_BrandenburgGate: 36089,
  Valspar_701717_LightPatina: 36090,
  Valspar_701720_SprigOfSage: 36091,
  Valspar_701723_WarmEucalyptus: 36092,
  Valspar_701726_GhostStory: 36093,
  Valspar_701729_MistyMemory: 36094,
  Valspar_701732_SimpleGray: 36095,
  Valspar_701735_Rigani: 36096,
  Valspar_701738_BlushOfMorn: 36097,
  Valspar_701741_HazyIris: 36098,
  Valspar_701744_SunPainter: 36099,
  Valspar_701747_SunriseOverTahiti: 36100,
  Valspar_701750_NoblesseOblige: 36101,
  Valspar_701753_RecycledGlass: 36102,
  Valspar_701756_ChileanSeaBass: 36103,
  Valspar_701759_GrayGreenLinen: 36104,
  Valspar_701762_DuskyParakeet: 36105,
  Valspar_701765_Campground: 36106,
  Valspar_701768_SeasideFog: 36107,
  Valspar_701771_CalmCoolAndCollected: 36108,
  Valspar_701774_ThreeWishes: 36109,
  Valspar_701777_IrishMoor: 36110,
  Valspar_701780_GraciousGray: 36111,
  Valspar_701783_SageSlate: 36112,
  Valspar_701786_SevenSisters: 36113,
  Valspar_701789_DreamWeaver: 36114,
  Valspar_701792_SheerElegance: 36115,
  Valspar_701795_Adieu: 36116,
  Valspar_701798_CambridgeLily: 36117,
  Valspar_701801_Skyscraper: 36118,
  Valspar_701804_AdriftAtSea: 36119,
  Valspar_701807_CoolTide: 36120,
  Valspar_701810_DegasBlue: 36121,
  Valspar_701813_Jolene: 36122,
  Valspar_701816_SundaySky: 36123,
  Valspar_701819_MilkyWay: 36124,
  Valspar_701822_WindblownBlue: 36125,
  Valspar_701825_LagoonReflection: 36126,
  Valspar_701828_PearlGray: 36127,
  Valspar_701831_BlueThunder: 36128,
  Valspar_701834_MountainMidnight: 36129,
  Valspar_701837_Annabelle: 36130,
  Valspar_701840_CatsMeow: 36131,
  Valspar_701843_ShaleBlue: 36132,
  Valspar_701846_CottageDoor: 36133,
  Valspar_701849_FlannelGray: 36134,
  Valspar_701852_CadetSong: 36135,
  Valspar_701855_ColdAsIce: 36136,
  Valspar_701858_Elevation: 36137,
  Valspar_701861_SoftShore: 36138,
  Valspar_701864_Impressionist: 36139,
  Valspar_701867_Hobgoblin: 36140,
  Valspar_701870_MindOfHerOwn: 36141,
  Valspar_701873_DuskInTheValley: 36142,
  Valspar_701876_OysterBay: 36143,
  Valspar_701879_MysticalGray: 36144,
  Valspar_701882_MinkSuede: 36145,
  Valspar_701885_NightSkyscraper: 36146,
  Valspar_701888_MattOnMonday: 36147,
  Valspar_701891_InTheDeepBlueSea: 36148,
  Valspar_701894_SpunSugar: 36149,
  Valspar_701897_Hibernate: 36150,
  Valspar_701900_BlueLuna: 36151,
  Valspar_701903_SnowFlurries: 36152,
  Valspar_701906_BlueEcho: 36153,
  Valspar_701909_HighlandWinds: 36154,
  Valspar_701912_MountNirvana: 36155,
  Valspar_701915_MoonlightStroll: 36156,
  Valspar_701918_Statuary: 36157,
  Valspar_701921_DolphinAtPlay: 36158,
  Valspar_701924_StreamlinedGray: 36159,
  Valspar_701927_Lionfish: 36160,
  Valspar_701930_NutsAndBolts: 36161,
  Valspar_701933_WhaleWatching: 36162,
  Valspar_701936_Respite: 36163,
  Valspar_701939_Foghorn: 36164,
  Valspar_701942_AMonthOfSundays: 36165,
  Valspar_701945_Pandemonium: 36166,
  Valspar_701948_PurpleFunk: 36167,
  Valspar_701951_CoalTipple: 36168,
  Valspar_701954_DowningStreet: 36169,
  Valspar_701957_LondonCalling: 36170,
  Valspar_701960_Pebbles: 36171,
  Valspar_701963_TitaniumMan: 36172,
  Valspar_701966_PalaceWalls: 36173,
  Valspar_701969_Horseshoe: 36174,
  Valspar_701972_Forge: 36175,
  Valspar_701975_Nevermore: 36176,
  Valspar_701978_OrchidBlush: 36177,
  Valspar_701981_PukaShell: 36178,
  Valspar_701984_RosyLinen: 36179,
  Valspar_701987_SoulSearching: 36180,
  Valspar_701990_PinkChantilly: 36181,
  Valspar_701993_CathedralMorning: 36182,
  Valspar_701996_EmbarrassedShadow: 36183,
  Valspar_701999_Monkeypod: 36184,
  Valspar_702002_CocoaBerry: 36185,
  Valspar_702005_ChristmasPudding: 36186,
  Valspar_702008_Thoroughfare: 36187,
  Valspar_702011_DuskyMorn: 36188,
  Valspar_702014_BoardwalkSashay: 36189,
  Valspar_702017_PickOfTheLitter: 36190,
  Valspar_702020_RabbitsFoot: 36191,
  Valspar_702023_CreamyMocha: 36192,
  Valspar_702026_RueBourbon: 36193,
  Valspar_702029_Windmill: 36194,
  Valspar_702032_StateOfMind: 36195,
  Valspar_702035_GatewayArch: 36196,
  Valspar_702038_MomentousOccasion: 36197,
  Valspar_702041_MoonShadow: 36198,
  Valspar_702044_WindyCity: 36199,
  Valspar_702047_CrystalNoir: 36200,
  Valspar_702050_BittersweetMolasses: 36201,
  Valspar_702053_ModernGray: 36202,
  Valspar_702056_TabbyCatGray: 36203,
  Valspar_702059_Magpie: 36204,
  Valspar_702062_Slush: 36205,
  Valspar_702065_MoonShot: 36206,
  Valspar_702068_CatchOfTheDay: 36207,
  Valspar_702071_QuietInterlude: 36208,
  Valspar_702074_LuxeGray: 36209,
  Valspar_702077_GentleShadows: 36210,
  Valspar_702080_SoftPelican: 36211,
  Valspar_702083_Counterpoint: 36212,
  Valspar_702086_OysterShoal: 36213,
  Valspar_702089_StoneTerrace: 36214,
  Valspar_702092_Gondola: 36215,
  Valspar_702095_AgedParchment: 36216,
  Valspar_702098_BeachDune: 36217,
  Valspar_702101_PerfectBackdrop: 36218,
  Valspar_702104_Koala: 36219,
  Valspar_702107_ChocolateMilk: 36220,
  Valspar_702110_Groundbreaking: 36221,
  Valspar_702113_Buckeye: 36222,
  Valspar_702116_CappuccinoFoam: 36223,
  Valspar_702119_CookieDough: 36224,
  Valspar_702122_BostonBrownBread: 36225,
  Valspar_702125_Aerodynamic: 36226,
  Valspar_702128_RockyMountainMist: 36227,
  Valspar_702131_GrayMorn: 36228,
  Valspar_702134_RockyShelter: 36229,
  Valspar_702137_SleepyKitten: 36230,
  Valspar_702140_GroundTruth: 36231,
  Valspar_702143_Arrowhead: 36232,
  Valspar_702146_ElephantInTheRoom: 36233,
  Valspar_702149_Ganymede: 36234,
  Valspar_702152_FeatherQuill: 36235,
  Valspar_702155_NatureWalk: 36236,
  Valspar_702158_SoftPanther: 36237,
  Valspar_702161_Tomcat: 36238,
  Valspar_702164_Artemis: 36239,
  Valspar_702167_TimberGreen: 36240,
  Valspar_702170_GooseFeathers: 36241,
  Valspar_702173_WetConcrete: 36242,
  Valspar_702176_AskMeAnything: 36243,
  Valspar_702179_GracefulGray: 36244,
  Valspar_702182_BigApple: 36245,
  Valspar_702185_EbonyKeys: 36246,
  Valspar_702188_MrKitty: 36247,
  Valspar_702191_WorldsAway: 36248,
  Valspar_702194_SilverThistleDown: 36249,
  Valspar_702197_Caviar: 36250,
  Valspar_702200_MaisOui: 36251,
  Valspar_702203_BottleflyWings: 36252,
  Valspar_702206_Chrome: 36253,
  Valspar_702209_DecoGray: 36254,
  Valspar_702212_BottlenoseDolphin: 36255,
  Valspar_702215_SootyLashes: 36256,
  Valspar_702218_Highlights: 36257,
  Valspar_702221_Seersucker: 36258,
  Valspar_702224_GraniteFog: 36259,
  Valspar_702227_StormySkies: 36260,
  Valspar_702230_DeepChannel: 36261,
  Valspar_702233_PlotTwist: 36262,
  Valspar_702236_Tuxedo: 36263,
  Valspar_702239_HoneyLocust: 36264,
  Valspar_702242_Halogen: 36265,
  Valspar_702245_ApricotWhisper: 36266,
  Valspar_702248_SoftSpoken: 36267,
  Valspar_702251_WhiteWool: 36268,
  Valspar_702254_WoodlandWildflower: 36269,
  Valspar_702257_Barley: 36270,
  Valspar_702260_PetalSmoke: 36271,
  Valspar_702263_Teapot: 36272,
  Valspar_702266_TellMeASecret: 36273,
  Valspar_702269_Tambourine: 36274,
  Valspar_702272_SteppingStone: 36275,
  Valspar_702275_Northbound: 36276,
  Valspar_702278_Visionary: 36277,
  Valspar_702281_IvoryKeys: 36278,
  Valspar_702284_ThousandShells: 36279,
  Valspar_702287_Gosling: 36280,
  Valspar_702290_Ewe: 36281,
  Valspar_702293_Cravat: 36282,
  Valspar_702296_Sunbeam: 36283,
  Valspar_702299_MorningBreeze: 36284,
  Valspar_702302_SantasBeard: 36285,
  Valspar_702305_CuddleDown: 36286,
  Valspar_702308_FreshwaterPearls: 36287,
  Valspar_702311_WarmMilk: 36288,
  Valspar_702314_Abel: 36289,
  Valspar_702317_LineDried: 36290,
  Valspar_702320_LionOfHadrian: 36291,
  Valspar_AR1326_PresidentialSuite: 1913,
  Valspar_AR721_LibertyBell: 1914,
  Valspar_CI59_MinkStole: 1915,
  Valspar_EB113_Coir: 1916,
  Valspar_EB281_Calico: 1917,
  Valspar_EE2017A_BareValley: 1918,
  Valspar_EE2020B_DryRiverbed: 1919,
  Valspar_EE2022C_AncientBog: 1920,
  Valspar_EE2043B_StarDust: 1921,
  Valspar_EE2104A_Downpour: 1922,
  Valspar_LA309A_PaintedLavender: 1923,
  Valspar_WV37008_BeachHouse: 1924,
};

const DMC_Variform = {
  Variform_AutumnBeige: 26071,
  Variform_Bayou: 26072,
  Variform_Briarwood: 26073,
  Variform_CabinCedar: 26074,
  Variform_ClassicCream: 26075,
  Variform_CottageGray: 26076,
  Variform_DeepBrunswick: 26077,
  Variform_Flint: 26078,
  Variform_GeorgianGray: 215,
  Variform_Hazelnut: 26079,
  Variform_HeritageLinen: 26080,
  Variform_IrishThistle: 26081,
  Variform_IslandPearl: 26082,
  Variform_MediterraneanPalm: 26083,
  Variform_MusketBrown: 26084,
  Variform_NaturalAlmond: 26085,
  Variform_OldDublin: 26086,
  Variform_Pewter: 26087,
  Variform_RichMocha: 26088,
  Variform_Sagebrook: 26089,
  Variform_SandyTan: 26090,
  Variform_SavannahBlue: 26091,
  Variform_SedonaRed: 26092,
  Variform_SilverMist: 216,
  Variform_SouthernCypress: 26093,
  Variform_StoneMountainClay: 26094,
  Variform_Teak: 26095,
  Variform_TwilightShadow: 26096,
  Variform_Wedgewood: 26097,
};

const DMC_Waudena = {
  Waudena_AbbeyStone: 6517,
  Waudena_ArcticBlue: 26098,
  Waudena_ArtisanBrown: 6518,
  Waudena_BeachHouse: 6519,
  Waudena_Bonfire: 6520,
  Waudena_Cherry: 26099,
  Waudena_ClassicWhite: 6521,
  Waudena_Clay: 26100,
  Waudena_Courtyard: 6522,
  Waudena_CrumbCake: 6523,
  Waudena_DarkBronze: 26101,
  Waudena_DarkOak: 26102,
  Waudena_Daydream: 6524,
  Waudena_Fern: 6525,
  Waudena_FlannelGray: 6526,
  Waudena_FlowerPower: 6527,
  Waudena_ForestGreen: 26103,
  Waudena_FreeSpirit: 6528,
  Waudena_FrenchManor: 6529,
  Waudena_GardenGate: 6530,
  Waudena_GatheringPlace: 6531,
  Waudena_GroovyGreen: 6532,
  Waudena_Gunmetal: 26104,
  Waudena_HappyDays: 6533,
  Waudena_HearthStone: 6534,
  Waudena_HeartOfGold: 6535,
  Waudena_Heirloom: 6536,
  Waudena_Homespun: 6537,
  Waudena_HorizonGray: 6538,
  Waudena_IvoryCream: 26105,
  Waudena_IvyLeague: 6539,
  Waudena_Keepsake: 6540,
  Waudena_Lakeshore: 6541,
  Waudena_LightOak: 26106,
  Waudena_Linen: 6542,
  Waudena_Noble: 6543,
  Waudena_OffTheRecord: 6544,
  Waudena_OldWorld: 6545,
  Waudena_OxfordWhite: 6546,
  Waudena_ParkAvenue: 6547,
  Waudena_PeacefulPorch: 6548,
  Waudena_PeaceNLove: 6549,
  Waudena_PicketFence: 6550,
  Waudena_QuietNook: 6551,
  Waudena_RedVelvet: 6552,
  Waudena_RoyalBrown: 26107,
  Waudena_RubyRed: 6553,
  Waudena_ShiplapWhite: 6554,
  Waudena_SoulfulBlue: 6555,
  Waudena_SummerDay: 6556,
  Waudena_Symphony: 6557,
  Waudena_Tan: 26108,
  Waudena_TerraBronze: 26109,
  Waudena_Traditions: 6558,
  Waudena_Veranda: 6559,
  Waudena_Wanderlust: 6560,
  Waudena_White: 26110,
  Waudena_WindsorCastle: 6561,
};

const DMC_WausauSupply = {
  Wausau_AgedPewter: 11488,
  Wausau_BlackWalnut: 11489,
  Wausau_BlueGray: 11490,
  Wausau_Brownstone: 11491,
  Wausau_Cottonwood: 11492,
  Wausau_Cypress: 11493,
  Wausau_Eclipse: 11494,
  Wausau_Flagstone: 11495,
  Wausau_Granite: 11496,
  Wausau_GrayMoss: 11497,
  Wausau_HarvardSlate: 11498,
  Wausau_Heather: 11499,
  Wausau_HeritageBlue: 11500,
  Wausau_Ironstone: 11501,
  Wausau_Linen: 11502,
  Wausau_MarineBlue: 11503,
  Wausau_MidnightSurf: 11504,
  Wausau_MountainAsh: 11505,
  Wausau_PebbleClay: 11506,
  Wausau_Redwood: 11507,
  Wausau_Riverway: 11508,
  Wausau_Rockslide: 11509,
  Wausau_RoyalWhite: 11510,
  Wausau_RusticGray: 11511,
  Wausau_Sand: 11512,
  Wausau_SedonaShadow: 11513,
  Wausau_Shamrock: 11514,
  Wausau_SilverMist: 11515,
  Wausau_SoftMaple: 11516,
  Wausau_Sterling: 11517,
  Wausau_Stonehedge: 11518,
  Wausau_Storm: 11519,
  Wausau_ToastedAlmond: 11520,
  Wausau_TreeMoss: 11521,
  Wausau_UrbanBronze: 11522,
  Wausau_VintageCream: 11523,
  Wausau_Walnut: 11524,
  Wausau_WeatheredGray: 11525,
  Wausau_Wedgewood: 11526,
  Wausau_Wicker: 11527,
};

const DMC_WayneDalton = {
  WD_Almond: 1732,
  WD_Black: 10772,
  WD_Brown: 1733,
  WD_Clay: 2258,
  WD_DesertTan: 1734,
  WD_Gray: 1735,
  WD_Green: 1736,
  WD_Sandstone: 10773,
  WD_Taupe: 1737,
  WD_White: 1738,
};

const DMC_Weatherables = {
  Weatherables_Khaki: 2259,
  Weatherables_Tan: 2260,
  Weatherables_White: 2261,
};

const DMC_Westlake = {
  Westlake_AspenWhite: 10415,
  Westlake_Black: 10983,
  Westlake_BlueGray: 2630,
  Westlake_Bone: 10416,
  Westlake_Brownstone: 2631,
  Westlake_BurgundyRed: 36294,
  Westlake_Canyon: 10493,
  Westlake_Carbon: 10497,
  Westlake_ClassicBlue: 36295,
  Westlake_Clay: 10417,
  Westlake_Cocoa: 2632,
  Westlake_CountryBeige: 10418,
  Westlake_Cypress: 2633,
  Westlake_Driftwood: 10419,
  Westlake_Espresso: 10498,
  Westlake_Flagstone: 2634,
  Westlake_ForestGreen: 36296,
  Westlake_FrenchRoast: 10980,
  Westlake_Granite: 2635,
  Westlake_Graphite: 10499,
  Westlake_Greystone: 10420,
  Westlake_HarvardSlate: 2636,
  Westlake_Heather: 2637,
  Westlake_HeritageBlue: 2638,
  Westlake_Indigo: 10500,
  Westlake_Ironstone: 2639,
  Westlake_LighthouseRed: 10501,
  Westlake_Linen: 2640,
  Westlake_MarineBlue: 2641,
  Westlake_MetropolitanGray: 10494,
  Westlake_MidnightBlue: 10586,
  Westlake_MidnightSurf: 2642,
  Westlake_Mocha: 10421,
  Westlake_MusketBrown: 10981,
  Westlake_Nantucket: 10422,
  Westlake_Oceanside: 10495,
  Westlake_Paintable: 36297,
  Westlake_Pearl: 10423,
  Westlake_PebbleClay: 2643,
  Westlake_Peppercorn: 10502,
  Westlake_Platinum: 10984,
  Westlake_Polaris: 10424,
  Westlake_Redwood: 2644,
  Westlake_Regatta: 10503,
  Westlake_Riverway: 2645,
  Westlake_Rockslide: 2646,
  Westlake_Rye: 10425,
  Westlake_Saddle: 10426,
  Westlake_Sand: 2647,
  Westlake_Shamrock: 2648,
  Westlake_SilverMist: 2649,
  Westlake_Slate: 10504,
  Westlake_SmokyAsh: 10496,
  Westlake_SoftMaple: 2650,
  Westlake_Spruce: 10505,
  Westlake_Sterling: 2651,
  Westlake_StoneHarbor: 10506,
  Westlake_Storm: 2652,
  Westlake_StormCloud: 36298,
  Westlake_ToastedAlmond: 2653,
  Westlake_TreatedCedar: 36299,
  Westlake_TreeMoss: 2654,
  Westlake_TuxedoGrey: 10985,
  Westlake_UrbanBronze: 2655,
  Westlake_VintageCream: 2656,
  Westlake_Walnut: 2657,
  Westlake_WeatheredGray: 2658,
  Westlake_Wedgewood: 2659,
  Westlake_Wheat: 10427,
  Westlake_White: 2660,
  Westlake_Wicker: 2661,
  Westlake_Wineberry: 36300,
};

const DMC_Window_AAF = {
  AAF_AlmondIvory_GD016A: 9529,
  AAF_AmberGold_E42TM: 9530,
  AAF_AnodicBronze_GY114A: 9531,
  AAF_AnodicBronze_GY125A: 9532,
  AAF_AnodicChampagne_GY276A: 9533,
  AAF_AnodicClear_GY221A: 9534,
  AAF_AnodicDarkGrey_GL213A: 9535,
  AAF_AnodicFrenchChampagne_GX207A: 9536,
  AAF_AnodicNatural_GY235A: 9537,
  AAF_AnodicNatural_YY223A: 9538,
  AAF_AnodicNaturalMerlin_GY243A: 9539,
  AAF_AnodicNaturalSilk_GY242A: 9540,
  AAF_AnodicNighthawk_GY244A: 9541,
  AAF_AnodicOffWhite_GD227A: 9542,
  AAF_AnodicPrecisBlackInk_GN21BA: 9543,
  AAF_AnodicSaintsBronze_GY101A: 9544,
  AAF_AnodicSilverGrey_GL237A: 9545,
  AAF_AnodicSlateGrey_GY218A: 9546,
  AAF_AnodicSlateGrey_YY218A: 9547,
  AAF_AnodicStellarBronze_YY253A: 9548,
  AAF_AnotecDarkGrey_260_7538M: 9549,
  AAF_AnotecDarkGrey_272_51275: 9550,
  AAF_AnotecMidBronze_272_51014: 9551,
  AAF_AnotecOffWhite_260_2181M: 9552,
  AAF_AnotecSilverGrey_272_51272: 9553,
  AAF_AnthraciteIn_GY144A: 9554,
  AAF_AntigraffitiBlack_910_9024S: 9555,
  AAF_APOGrey_260_32786: 9556,
  AAF_ApoGrey_272_32786: 9557,
  AAF_ApoGrey_GL107A: 9558,
  AAF_APOGreyScylla_901_36612: 9559,
  AAF_ApolloGrey_E66NM: 9560,
  AAF_ApplianceWhite_90Z_1341S: 9561,
  AAF_ArcticWhite_900_58851: 9562,
  AAF_ArcticWhite_90Z_1342S: 9563,
  AAF_AsteroidPearl_8Y270A: 9564,
  AAF_AsteroidPearl_GY270A: 9565,
  AAF_AsteroidPearl_YY270A: 9566,
  AAF_Atlante_YY293A: 9567,
  AAF_AzCustomBlack_GN215A: 9568,
  AAF_AztecBlack_901_82757: 9569,
  AAF_AztecSilver_901_85040: 9570,
  AAF_AztecSilver_E68NL: 9571,
  AAF_AzurePearl_8Y205A: 9572,
  AAF_Barley_272_3089G: 9573,
  AAF_Barley_GD007A: 9574,
  AAF_Basalt_260_7473S: 9575,
  AAF_Basalt_272_7865M: 9576,
  AAF_Basalt_40X_7475M: 9577,
  AAF_Basalt_906_7645F: 9578,
  AAF_Basalt_90E_7723Z: 9579,
  AAF_Basalt_GP208A: 9580,
  AAF_BeachouseYellow_8E219A: 9581,
  AAF_BeachSand_GY234A: 9582,
  AAF_Beige_MM110A: 9583,
  AAF_BerryGrey_272_7262G: 9584,
  AAF_BerryGrey_272_88362: 9585,
  AAF_BistroOrange_MF014A: 9586,
  AAF_Black_260_9132G: 9587,
  AAF_Black_272_9090G: 9588,
  AAF_Black_40X_9204M: 9589,
  AAF_Black_8N202A: 9590,
  AAF_Black_GN150A: 9591,
  AAF_BlackAce_906_9116F: 9592,
  AAF_BlackNightSky_260_9128S: 9593,
  AAF_BlackNightSky_260_9129M: 9594,
  AAF_BlackNightSky_272_19268: 9595,
  AAF_BlackNightSky_272_19319: 9596,
  AAF_BlackNightSky_90E_9190Z: 9597,
  AAF_BlackNightSky_959_81878: 9598,
  AAF_BlackOnyx_GY042A: 9599,
  AAF_BlackPearl_YY242A: 9600,
  AAF_BlackSarouk_935_51146: 9601,
  AAF_BlackScylla_901_50003: 9602,
  AAF_BlazeBlue_265_5268G: 9603,
  AAF_BlazeBlue_984_19941: 9604,
  AAF_BlazeBlue_MJ034A: 9605,
  AAF_Blue_8J207A: 9606,
  AAF_BlueHammer_901_85159: 9607,
  AAF_BlueLightPearl_971_5209Q: 9608,
  AAF_BlueRidge_272_88480: 9609,
  AAF_BlueRidge_GJ221A: 9610,
  AAF_BlueRidge_GQ121A: 9611,
  AAF_BlueSuedeShoes_906_5178K: 9612,
  AAF_Blush_E64RL: 9613,
  AAF_BoldAsBrass_E58TL: 9614,
  AAF_BondiBlue_GJ045A: 9615,
  AAF_BondiBlue_YJ046A: 9616,
  AAF_BoundaryBrown_GM103A: 9617,
  AAF_BowralBrown_102_2727: 9618,
  AAF_Boysenberry_8H214A: 9619,
  AAF_BoysenberryPrl_YY24EA: 9620,
  AAF_BrightSilver_MW201T: 9621,
  AAF_BrightSilverMetallic_961_51491: 9622,
  AAF_BrightWhite_260_84636: 9623,
  AAF_BrightWhite_272_84636: 9624,
  AAF_BrightWhite_GA030A: 9625,
  AAF_BrilliantYellow_GE087A: 9626,
  AAF_BrilliantYellow_YE087A: 9627,
  AAF_BronzeMonument_E30TL: 9628,
  AAF_BronzePearl_8Y220A: 9629,
  AAF_BronzePearl_8Y225A: 9630,
  AAF_BronzePearl_YY225A: 9631,
  AAF_BronzePrl_YY26FA: 9632,
  AAF_BronzeRich_YW260G: 9633,
  AAF_BubblyPearl_260_8229Q: 9634,
  AAF_BurnishedCopper_906_8185K: 9635,
  AAF_BurnishedGold_E80GB: 9636,
  AAF_BurntSienna_E29TM: 9637,
  AAF_Bushland_GK203A: 9638,
  AAF_Bushland_GS103A: 9639,
  AAF_BwsAnodicDarkGreyL_S_GL247A: 9640,
  AAF_Cabernet_E36RL: 9641,
  AAF_CanolaCream_272_81796: 9642,
  AAF_Canon_YY287A: 9643,
  AAF_CanvasCloth_900_7327M: 9644,
  AAF_CanvasCloth_90Z_7327M: 9645,
  AAF_CapriOlivePrl_YY29FA: 9646,
  AAF_ChalkUSA_900_73713: 9647,
  AAF_ChalkUSA_90Z_1343G: 9648,
  AAF_Champagne_40A_7302Q: 9649,
  AAF_ChampagneKinetic_900_3059K: 9650,
  AAF_ChampagneKinetic_90T_3059K: 9651,
  AAF_ChampagneKinetic_971_3059K: 9652,
  AAF_ChampagnePearl_8Y276A: 9653,
  AAF_ChampagnePearl_YY276A: 9654,
  AAF_ChampagneRich_YW277G: 9655,
  AAF_Charcoal_260_88351: 9656,
  AAF_Charcoal_272_88351: 9657,
  AAF_Charcoal_272_9086G: 9658,
  AAF_Charcoal_40X_7297M: 9659,
  AAF_Charcoal_GL035A: 9660,
  AAF_Charcoal_GL180A: 9661,
  AAF_Charcoal_YL238A: 9662,
  AAF_CharcoalLowSheen_8L290A: 9663,
  AAF_CharcoalMetallic_971_18796: 9664,
  AAF_CharcoalMetallic_GM019A: 9665,
  AAF_CharcoalPearl_GY237A: 9666,
  AAF_CharcoalPearl_YY237A: 9667,
  AAF_CitiPearl_971_88471: 9668,
  AAF_CitiPearl_GL211A: 9669,
  AAF_CitiPearl_YY245A: 9670,
  AAF_CitrusDelightPrl_YY23GA: 9671,
  AAF_Claret_GG142A: 9672,
  AAF_ClassicCream_260_2095S: 9673,
  AAF_ClassicCream_260_84732: 9674,
  AAF_ClassicCream_272_2095S: 9675,
  AAF_ClassicCream_GD245A: 9676,
  AAF_ClassicCream_GU145A: 9677,
  AAF_ClassicHawthornGreen_272_33709: 9678,
  AAF_ClassicWhite_260_1228G: 9679,
  AAF_ClassicWhite_272_81880: 9680,
  AAF_Coin_40A_7289Q: 9681,
  AAF_Copper_961_4137Q: 9682,
  AAF_CopperCoin_E56RL: 9683,
  AAF_CopperCoinPearl_90T_4350Q: 9684,
  AAF_CopperKinetic_971_7183K: 9685,
  AAF_CopperMetallicKinetic_900_7183K: 9686,
  AAF_CopperMetallicKinetic_90T_7183K: 9687,
  AAF_CopperOre_90E_6413Z: 9688,
  AAF_CopperPearl_8Y204A: 9689,
  AAF_CopperPenny_YY22AA: 9690,
  AAF_CoralBlack_GN016A: 9691,
  AAF_CoralBlack_GN063A: 9692,
  AAF_Corsican_YK248A: 9693,
  AAF_CottageGreen_260_6304M: 9694,
  AAF_CottageGreen_260_84219: 9695,
  AAF_CottageGreen_272_84219: 9696,
  AAF_CottageGreen_GK274A: 9697,
  AAF_CottageGreen_GS174A: 9698,
  AAF_Cove_260_6250S: 9699,
  AAF_Cove_260_6252M: 9700,
  AAF_Cove_GD274A: 9701,
  AAF_CrystalMintPearl_8Y223A: 9702,
  AAF_CustomBlack_GN248A: 9703,
  AAF_CwcBlack_GN216A: 9704,
  AAF_DarkBronze_8Y224A: 9705,
  AAF_DarkBronze_906_8184K: 9706,
  AAF_DarkViolet_984_51926: 9707,
  AAF_DeepBronzePearl_260_8228Q: 9708,
  AAF_DeepBrunswickGreen_260_6134G: 9709,
  AAF_DeepBrunswickGreen_272_6134G: 9710,
  AAF_DeepBrunswickGreen_MK017A: 9711,
  AAF_DeepOcean_260_5125S: 9712,
  AAF_DeepOcean_260_5267M: 9713,
  AAF_DeepOcean_272_5125S: 9714,
  AAF_DeepOcean_GJ203A: 9715,
  AAF_DeepOcean_GQ103A: 9716,
  AAF_DeepOcean_YJ200A: 9717,
  AAF_DeepPool_MK002A: 9718,
  AAF_DesertDream_8M201A: 9719,
  AAF_DesertHaze_E59RM: 9720,
  AAF_DiamondLight_E87CB: 9721,
  AAF_Doeskin_260_32516: 9722,
  AAF_Doeskin_GD188A: 9723,
  AAF_Domain_GD230A: 9724,
  AAF_Driftwood_YL258A: 9725,
  AAF_Dune_260_3087S: 9726,
  AAF_Dune_260_7558M: 9727,
  AAF_Dune_272_3087S: 9728,
  AAF_Dune_GL252A: 9729,
  AAF_Dune_GP152A: 9730,
  AAF_Ebony_E26TM: 9731,
  AAF_Ebony_YN201A: 9732,
  AAF_EmeraldForest_YY283A: 9733,
  AAF_EnduraBronze_YY248A: 9734,
  AAF_EnzianBlue_YJ028A: 9735,
  AAF_EssentialSilverPearl_260_3146Q: 9736,
  AAF_Estate_GM247A: 9737,
  AAF_EternalSilver_YW100C: 9738,
  AAF_EternityBronzePearl_900_88393: 9739,
  AAF_EternityBronzePearl_90T_8356Q: 9740,
  AAF_EternityChainPearl_900_89119: 9741,
  AAF_EternityChainPearl_90T_7761Q: 9742,
  AAF_EternityCharcoalPearl_900_88394: 9743,
  AAF_EternityCharcoalPearl_90T_7762Q: 9744,
  AAF_EternityCitiSilverPearl_900_7024Q: 9745,
  AAF_EternityCitiSilverPearl_90T_7024Q: 9746,
  AAF_EternityLinenPearl_900_1138Q: 9747,
  AAF_EternityLinenPearl_90T_1138Q: 9748,
  AAF_EternityNickelPearl_900_88395: 9749,
  AAF_EternityNickelPearl_90T_7763Q: 9750,
  AAF_EternityPewterPearl_900_88396: 9751,
  AAF_EternityPewterPearl_90T_7764Q: 9752,
  AAF_EternitySilver_900_7160K: 9753,
  AAF_EternitySilver_90T_7160K: 9754,
  AAF_EternityStarPearl_900_7005F: 9755,
  AAF_EternityTitaniumPearl_900_87728: 9756,
  AAF_EternityTitaniumPearl_90T_7765Q: 9757,
  AAF_EveningHaze_260_3168M: 9758,
  AAF_EveningHaze_260_3175S: 9759,
  AAF_EveningHaze_272_3055S: 9760,
  AAF_EveningHaze_GM235A: 9761,
  AAF_EveningHaze_GT135A: 9762,
  AAF_FlameRed_984_19959: 9763,
  AAF_FlameRed_MG071A: 9764,
  AAF_FlamingRed_MG045A: 9765,
  AAF_FlatWhite_906_1200F: 9766,
  AAF_FrenchBlue_984_32725: 9767,
  AAF_FrenchBlue_MJ067A: 9768,
  AAF_GlowPearl_260_7471Q: 9769,
  AAF_GoldenTouch_906_8182K: 9770,
  AAF_GoldOdyssey_E78GL: 9771,
  AAF_GoldPearl_8Y221A: 9772,
  AAF_GoldPearl_906_2221K: 9773,
  AAF_GoldPearl_971_96604: 9774,
  AAF_GoldPearl_YY217A: 9775,
  AAF_GraphiteSarouk_935_51677: 9776,
  AAF_GreenPacifica_8K217A: 9777,
  AAF_GreenTea_906_6197K: 9778,
  AAF_GreyHammer_901_85184: 9779,
  AAF_GreyNurse_260_50060: 9780,
  AAF_Gully_260_8233S: 9781,
  AAF_Gully_260_8235M: 9782,
  AAF_Gully_GM242A: 9783,
  AAF_GunBarrel_E25TL: 9784,
  AAF_GunmetalKinetic_971_8115K: 9785,
  AAF_HamersleyBrown_GM100A: 9786,
  AAF_HammersleyBrown_260_84657: 9787,
  AAF_HardyReef_8J215A: 9788,
  AAF_Harvest_GD215A: 9789,
  AAF_HawthornGreen_GK030A: 9790,
  AAF_Headland_GG219A: 9791,
  AAF_Headland_GV119A: 9792,
  AAF_HeritageGreen_GK044A: 9793,
  AAF_HoneyMyrtle_8E207A: 9794,
  AAF_HorizonWhiteScylla_901_51608: 9795,
  AAF_HyperBlack_8N209A: 9796,
  AAF_HyperCharcoal_8L210A: 9797,
  AAF_HyperCoin_8Y211A: 9798,
  AAF_HyperWhite_8A210A: 9799,
  AAF_IntensityCoast_900_5233S: 9800,
  AAF_IntensityCoast_90N_5233S: 9801,
  AAF_IntensityDesert_900_4227S: 9802,
  AAF_IntensityDesert_90N_4227S: 9803,
  AAF_IntensityEvergreen_900_6005S: 9804,
  AAF_IntensityEvergreen_90N_6005S: 9805,
  AAF_IntensityFlame_900_4007G: 9806,
  AAF_IntensityFlame_90N_4007G: 9807,
  AAF_IntensityLeaf_900_6167S: 9808,
  AAF_IntensityLeaf_90N_6167S: 9809,
  AAF_IntensityMoonlight_900_2004S: 9810,
  AAF_IntensityMoonlight_90N_2004S: 9811,
  AAF_IntensityReef_900_5011G: 9812,
  AAF_IntensityReef_90N_5011G: 9813,
  AAF_IntensityStorm_900_89584: 9814,
  AAF_IntensityStorm_90N_5365S: 9815,
  AAF_IntensitySummer_900_4008G: 9816,
  AAF_IntensitySunshine_900_2084G: 9817,
  AAF_IntensitySunshine_90N_2084G: 9818,
  AAF_InterstateGreenPrl_YY21GA: 9819,
  AAF_Ironstone_260_7257S: 9820,
  AAF_Ironstone_260_7556M: 9821,
  AAF_Ironstone_272_7257S: 9822,
  AAF_Ironstone_GL236A: 9823,
  AAF_Ironstone_GP136A: 9824,
  AAF_Ivory_8D212A: 9825,
  AAF_JamaicanChocolate_E35TM: 9826,
  AAF_Jasper_260_8122S: 9827,
  AAF_Jasper_260_8252M: 9828,
  AAF_Jasper_272_8122S: 9829,
  AAF_Jasper_GM214A: 9830,
  AAF_Jasper_GT114A: 9831,
  AAF_Jasper_YT214A: 9832,
  AAF_Jaybird_GJ174A: 9833,
  AAF_Jaybird_YJ175A: 9834,
  AAF_JetPearl_260_9144Q: 9835,
  AAF_Kalahari_E53RM: 9836,
  AAF_Latte_YY298A: 9837,
  AAF_LawnGreen_MK038A: 9838,
  AAF_LemonYellow_984_32120: 9839,
  AAF_LemonYellow_ME068A: 9840,
  AAF_LightGrey_272_7263G: 9841,
  AAF_LightGreyScylla_901_50766: 9842,
  AAF_LightLichenPrl_YY24GA: 9843,
  AAF_Lobster_GG155A: 9844,
  AAF_Lobster_YG054A: 9845,
  AAF_Lobster_YG154A: 9846,
  AAF_Loft_GM236A: 9847,
  AAF_LoftIn_GT136A: 9848,
  AAF_LuxeBronze_YY240A: 9849,
  AAF_LuxeBronzePearl_YY255A: 9850,
  AAF_LycraStrip_GK063A: 9851,
  AAF_LycraStrip_YK063A: 9852,
  AAF_Macchiato_E36TL: 9853,
  AAF_Magnatite_90E_7725Z: 9854,
  AAF_Magnolia_272_32658: 9855,
  AAF_Magnolia_GD025A: 9856,
  AAF_Mangrove_260_6251M: 9857,
  AAF_Mangrove_260_6262S: 9858,
  AAF_Mangrove_GK277A: 9859,
  AAF_MannexBlack_901_32679: 9860,
  AAF_MannexSilverLodePearl_901_7034Z: 9861,
  AAF_MannexSuede_901_37543: 9862,
  AAF_MannexWhite_901_33641: 9863,
  AAF_ManorRed_260_4134S: 9864,
  AAF_ManorRed_260_4292M: 9865,
  AAF_ManorRed_272_4134S: 9866,
  AAF_ManorRed_GG262A: 9867,
  AAF_ManorRed_GV162A: 9868,
  AAF_MANORRED_GV262A: 9869,
  AAF_MarbleBlack_YN166A: 9870,
  AAF_MaroochySand_E74GM: 9871,
  AAF_MedallionBronze_E44TL: 9872,
  AAF_MediumBronze_906_8183k: 9873,
  AAF_MercurySilver_GW003K: 9874,
  AAF_Merlot_E35RM: 9875,
  AAF_MetallicLustre_GW215A: 9876,
  AAF_MetropolisBronze_971_59003: 9877,
  AAF_MetropolisSilverGlow_971_84623: 9878,
  AAF_MetropolisStorm_971_84684: 9879,
  AAF_Minky_8L227A: 9880,
  AAF_Mistletoe_265_6292G: 9881,
  AAF_Mistletoe_984_51040: 9882,
  AAF_MonacoStone_E65TL: 9883,
  AAF_Monument_260_9066M: 9884,
  AAF_Monument_260_9067S: 9885,
  AAF_Monument_272_9067S: 9886,
  AAF_Monument_40X_8148M: 9887,
  AAF_Monument_8L244A: 9888,
  AAF_Monument_906_9171F: 9889,
  AAF_Monument_90E_7724Z: 9890,
  AAF_Monument_90Z_7307S: 9891,
  AAF_Monument_90Z_8189M: 9892,
  AAF_Monument_959_9066M: 9893,
  AAF_Monument_GL229A: 9894,
  AAF_Monument_GP129A: 9895,
  AAF_Monument_YL264A: 9896,
  AAF_MonumentmkII_YP182A: 9897,
  AAF_Moonbeam_E74NB: 9898,
  AAF_MotherOfPearl_971_84678: 9899,
  AAF_Mystic_GY236A: 9900,
  AAF_Natural_971_89119: 9901,
  AAF_NaturalBronze_90E_8341Z: 9902,
  AAF_NaturalSilver_906_7365K: 9903,
  AAF_Navy_984_50282: 9904,
  AAF_Navy_MJ011A: 9905,
  AAF_Nickel_971_88360: 9906,
  AAF_NightSky_GN121A: 9907,
  AAF_NightSky_GN231A: 9908,
  AAF_NobelSilverPearl_GY119A: 9909,
  AAF_NobelSilverPearl_YX136A: 9910,
  AAF_NobelSilverPearl_YY268A: 9911,
  AAF_NotreDame_260_36672: 9912,
  AAF_NotreDame_272_36672: 9913,
  AAF_NotreDame_GL040A: 9914,
  AAF_NotreDameScylla_901_50223: 9915,
  AAF_NuanceSilverPearl_GW104C: 9916,
  AAF_OffWhite_260_3149S: 9917,
  AAF_OffWhite_272_33732: 9918,
  AAF_OffWhite_GA211A: 9919,
  AAF_OldePewter_260_50243: 9920,
  AAF_OldePewter_272_50243: 9921,
  AAF_OldePewter_GL175A: 9922,
  AAF_OldePewter_YL275A: 9923,
  AAF_Onyx_971_52052: 9924,
  AAF_OrangeX15_265_4293G: 9925,
  AAF_OrangeX15_984_51439: 9926,
  AAF_OutbackRed_8G212A: 9927,
  AAF_Oyster_260_36858: 9928,
  AAF_Oyster_272_36858: 9929,
  AAF_OysterGrey_GL258A: 9930,
  AAF_PacificAvenue_YY288A: 9931,
  AAF_PaleEucalypt_260_6127S: 9932,
  AAF_PaleEucalypt_260_6303M: 9933,
  AAF_PaleEucalypt_GK236A: 9934,
  AAF_PaleEucalypt_GS136A: 9935,
  AAF_PalladiumCoin_E87CL: 9936,
  AAF_PalladiumSilverPearl_GY184C: 9937,
  AAF_PallidSky_YY281A: 9938,
  AAF_PandemoniumSilver_971_7004F: 9939,
  AAF_PantherPearl_8Y212A: 9940,
  AAF_Paperbark_260_3135S: 9941,
  AAF_Paperbark_260_3174M: 9942,
  AAF_Paperbark_272_3088S: 9943,
  AAF_Paperbark_GD214A: 9944,
  AAF_Paperbark_GU114A: 9945,
  AAF_PapyrusWhite_GA018A: 9946,
  AAF_PatinaPearl_8Y207A: 9947,
  AAF_PearlWhite_260_1229G: 9948,
  AAF_PearlWhite_272_1114G: 9949,
  AAF_PearlWhite_GA029A: 9950,
  AAF_PearlWhite_GA078A: 9951,
  AAF_PearlWhite_YA074A: 9952,
  AAF_PearlWhite_YA078A: 9953,
  AAF_PearlWhite_YA278A: 9954,
  AAF_Pewter_971_88202: 9955,
  AAF_PewterPearl_GY199A: 9956,
  AAF_PistachioPearl_YY20GA: 9957,
  AAF_Platinum_E87CM: 9958,
  AAF_PlatypusKinetic_971_7214K: 9959,
  AAF_PommelBlue_984_51034: 9960,
  AAF_PortlandStone_E60TM: 9961,
  AAF_Pottery_GM175A: 9962,
  AAF_PrecisChampagneShimmer_YY24NA: 9963,
  AAF_PrecisDarkBronze_GY20BA: 9964,
  AAF_PrecisGoldenTouch_YY25BA: 9965,
  AAF_PrecisMediumBronze_YY23NA: 9966,
  AAF_PrecisNaturalShimmer_GY21AA: 9967,
  AAF_PrecisTMBlackInk_YN21BA: 9968,
  AAF_PrecisTMDarkBronze_YY20BA: 9969,
  AAF_PrecisTMNaturalShimmer_YY25AA: 9970,
  AAF_PrecisTMPacificBlue_YY23BA: 9971,
  AAF_PrecisTMPureGold_YY22BA: 9972,
  AAF_PrecisTMSunstoneBronze_YY21BA: 9973,
  AAF_PrecisVintageSilver_YY22NA: 9974,
  AAF_Primrose_260_84365: 9975,
  AAF_Primrose_272_84365: 9976,
  AAF_Primrose_GD031A: 9977,
  AAF_Primrose_GD037A: 9978,
  AAF_Primrose_YD037A: 9979,
  AAF_PropellerPearl_260_8230Q: 9980,
  AAF_Prosecco_E70RM: 9981,
  AAF_QuartzPearlLowSheen_8Y216A: 9982,
  AAF_RAL1001Beige_101_2521: 9983,
  AAF_RAL1003SignalYellow_102_5616: 9984,
  AAF_RAL1007DaffodilYellow_102_6678: 9985,
  AAF_RAL1013OysterWhite_102_5619: 9986,
  AAF_RAL1014Ivory_102_5620: 9987,
  AAF_RAL1015LightIvory_102_6668: 9988,
  AAF_RAL1018ZincYellow_102_6631: 9989,
  AAF_RAL1019GreyBeige_102_5637: 9990,
  AAF_RAL1021RapeYellow_102_5653: 9991,
  AAF_RAL1023TrafficYellow_120_5603: 9992,
  AAF_RAL1035PearlBeige_102_6258: 9993,
  AAF_RAL2000YellowOrange_102_6287: 9994,
  AAF_RAL2002Butorange_102_8021: 9995,
  AAF_RAL2003PastelOrange_102_5622: 9996,
  AAF_RAL2008BrightRedOrange_102_5636: 9997,
  AAF_RAL3000FlameRed_102_5623: 9998,
  AAF_RAL3001SignalRed_102_6681: 9999,
  AAF_RAL3002CarmineRed_102_5635: 10000,
  AAF_RAL3003RubyRed_102_6645: 10001,
  AAF_RAL3005WineRed_102_5617: 10002,
  AAF_RAL3009OxideRed_102_5647: 10003,
  AAF_RAL3011BrownRed_102_5630: 10004,
  AAF_RAL3012BeigeRed_100_0311: 10005,
  AAF_RAL3020TrafficRed_102_6685: 10006,
  AAF_RAL4010Telemagenta_102_7862: 10007,
  AAF_RAL4011PurplePearl_100_3296: 10008,
  AAF_RAL5002UltramarineBlue_102_6629: 10009,
  AAF_RAL5003SapphieBlie_102_6659: 10010,
  AAF_RAL5005SignalBlue_102_5655: 10011,
  AAF_RAL5010GentianBlue_102_6657: 10012,
  AAF_RAL5012LightBlue_102_6642: 10013,
  AAF_RAL5013CobaltBlue_102_6660: 10014,
  AAF_RAL5015SkyBlue_102_6637: 10015,
  AAF_RAL5017TrafficBlue_102_6674: 10016,
  AAF_RAL5019CapriBlue_102_6317: 10017,
  AAF_RAL5020OceanBlue_100_0588: 10018,
  AAF_RAL5021WaterBlue_102_6319: 10019,
  AAF_RAL6002LeafGreen_120_5611: 10020,
  AAF_RAL6003OliveGreen_102_5627: 10021,
  AAF_RAL6005MossGreen_102_6627: 10022,
  AAF_RAL6009FirGreen_102_6628: 10023,
  AAF_RAL6010GrassGreen_102_6326: 10024,
  AAF_RAL6011ResedaGreen_102_5615: 10025,
  AAF_RAL6014YellowOlive_102_6328: 10026,
  AAF_RAL6018Green_102_3801: 10027,
  AAF_RAL6024TrafficGreen_102_6332: 10028,
  AAF_RAL7001SilverGrey_102_6366: 10029,
  AAF_RAL7004SignalGrey_102_6369: 10030,
  AAF_RAL7005MouseGrey_102_5634: 10031,
  AAF_RAL7006BeigeGrey_102_2207: 10032,
  AAF_RAL7011IronGrey_102_6676: 10033,
  AAF_RAL7012BasaltGrey_102_6371: 10034,
  AAF_RAL7015SlateGrey_102_6373: 10035,
  AAF_RAL7016AnthraciteGrey_102_6374: 10036,
  AAF_RAL7021BlackGrey_102_5643: 10037,
  AAF_RAL7022UmbraGrey_102_5633: 10038,
  AAF_RAL7024GraphiteGrey_102_6375: 10039,
  AAF_RAL7030StoneGrey_102_5649: 10040,
  AAF_RAL7031BlueGrey_102_6664: 10041,
  AAF_RAL7032GreyB27_100_4732: 10042,
  AAF_RAL7032GreyRipple_100_3717: 10043,
  AAF_RAL7035LightGrey_100_3719: 10044,
  AAF_RAL7035LightGreyRipple_100_3711: 10045,
  AAF_RAL7036PlatinumGrey_102_5659: 10046,
  AAF_RAL7037DustyGrey_102_6378: 10047,
  AAF_RAL7038AgateGrey_102_6633: 10048,
  AAF_RAL7039QuartzGrey_102_6683: 10049,
  AAF_RAL7040WindowGrey_102_6634: 10050,
  AAF_RAL7042TrafficGreyA_102_6379: 10051,
  AAF_RAL7043TrafficGreyB_102_6650: 10052,
  AAF_RAL7044SilkGrey_102_5650: 10053,
  AAF_RAL7045TeleGrey1_102_6662: 10054,
  AAF_RAL7046Telegray2_102_6632: 10055,
  AAF_RAL7047Telegray4_102_6658: 10056,
  AAF_RAL7048MouseGreyPearl_103_1082: 10057,
  AAF_RAL8004CopperBrown_102_6666: 10058,
  AAF_RAL8014SepiaBrown_102_5654: 10059,
  AAF_RAL8017ChocolateBrown_102_6654: 10060,
  AAF_RAL8019GreyBrown_102_6648: 10061,
  AAF_RAL8028TerraBrown_120_5487: 10062,
  AAF_RAL9001Cream_102_6391: 10063,
  AAF_RAL9002GreyWhite_102_6671: 10064,
  AAF_RAL9003SignalWhite_102_4983: 10065,
  AAF_RAL9004SignalBlack_102_5657: 10066,
  AAF_RAL9005JetBlack_102_7013: 10067,
  AAF_RAL9006MattSilver_100_3317: 10068,
  AAF_RAL9006SilverGloss_100_3295: 10069,
  AAF_RAL9007MetallicGrey_100_3306: 10070,
  AAF_RAL9010PureWhite_102_1880: 10071,
  AAF_RAL9011GraphiteBlack_102_6393: 10072,
  AAF_RAL9016TrafficWhite_101_9786: 10073,
  AAF_RAL9016TrafficWhite_102_6394: 10074,
  AAF_RAL9018PapyrusWhite_102_6396: 10075,
  AAF_RAL9023PearlDarkGrey_102_6431: 10076,
  AAF_RedBrownScylla_901_85473: 10077,
  AAF_RedBushApple_8M214A: 10078,
  AAF_RedEmperor_971_4205Q: 10079,
  AAF_RippleApoGrey_ML463A: 10080,
  AAF_RippleBlack_MN427A: 10081,
  AAF_RippleBlackLeather_EN432A: 10082,
  AAF_RippleGraphite_EY422A: 10083,
  AAF_RippleGreyNurse_EL422A: 10084,
  AAF_RippleGypsyBeige_MD453A: 10085,
  AAF_RippleN42StormGrey_ML421A: 10086,
  AAF_RippleNotreDame_ML444A: 10087,
  AAF_RippleRal7035_ML435A: 10088,
  AAF_RippleRal9002_MA424A: 10089,
  AAF_RippleWhite_MA494A: 10090,
  AAF_RippleX15Orange_MF406A: 10091,
  AAF_Rivergum_GD042A: 10092,
  AAF_RivergumBeige_272_36991: 10093,
  AAF_Riversand_260_3193M: 10094,
  AAF_Riversand_959_36656: 10095,
  AAF_Riversand_GM204A: 10096,
  AAF_RojoRock_8M213A: 10097,
  AAF_RojoRock_GM298A: 10098,
  AAF_RoseberryGrey_GL015A: 10099,
  AAF_Rouge_YY285A: 10100,
  AAF_SableApoGrey_ML307A: 10101,
  AAF_SableAsteroid_GN271A: 10102,
  AAF_SableAsteroid_YY371A: 10103,
  AAF_SableBass_GN297A: 10104,
  AAF_SableBass_YY397A: 10105,
  AAF_SableBlack_GN341A: 10106,
  AAF_SableBrillance_GL277A: 10107,
  AAF_SableBrilliance_YY377A: 10108,
  AAF_SableCoreTen_GX350A: 10109,
  AAF_SableCoreTen_YX350A: 10110,
  AAF_SableGildedGreen_YY380A: 10111,
  AAF_SableGreyNurse_GL320A: 10112,
  AAF_SableGreyNurse_ML320A: 10113,
  AAF_SableMediumBronze_GY366A: 10114,
  AAF_SableMediumBronze_YY366A: 10115,
  AAF_SableSagraGreen_YY345A: 10116,
  AAF_SableSilver_GY301A: 10117,
  AAF_SableSilverTexture_YY301A: 10118,
  AAF_SafetyYellow_265_2162G: 10119,
  AAF_SafetyYellow_984_2015G: 10120,
  AAF_SafetyYellow_ME096A: 10121,
  AAF_Sage_YY296A: 10122,
  AAF_SagePearl_YY28FA: 10123,
  AAF_Sandbank_GM216A: 10124,
  AAF_SandbankIn_GT116A: 10125,
  AAF_Sandstone_8A237A: 10126,
  AAF_Sandstone_GL281A: 10127,
  AAF_SanskritPearl_YY25GA: 10128,
  AAF_SchoolInkPearl_YY22GA: 10129,
  AAF_Scintillation_906_8186K: 10130,
  AAF_SeaBreeze_E67TM: 10131,
  AAF_SeafoamPearl_YY269A: 10132,
  AAF_SeaStorm_8L216A: 10133,
  AAF_Sensation_GF049A: 10134,
  AAF_Sensation_YF049A: 10135,
  AAF_ShaleGrey_260_7557M: 10136,
  AAF_ShaleGrey_260_83246: 10137,
  AAF_ShaleGrey_272_83246: 10138,
  AAF_ShaleGrey_GL284A: 10139,
  AAF_ShaleGrey_GP184A: 10140,
  AAF_Shamrock_GK043A: 10141,
  AAF_Shamrock_YK043A: 10142,
  AAF_SharpSilverKinetic_971_7238K: 10143,
  AAF_ShimmeringChampagne_906_3116K: 10144,
  AAF_ShojiWhite_260_84682: 10145,
  AAF_ShojiWhite_272_84682: 10146,
  AAF_ShojiWhite_GA160A: 10147,
  AAF_SignalRed_265_4294G: 10148,
  AAF_SignalRed_984_50735: 10149,
  AAF_SignalRed_MG036A: 10150,
  AAF_SignalRed90_GG040A: 10151,
  AAF_Silver_40A_7273Q: 10152,
  AAF_SilverGrey_ML194A: 10153,
  AAF_SilverKinetic_971_7043K: 10154,
  AAF_SilverPearl_YY230A: 10155,
  AAF_SilverReef_YY365A: 10156,
  AAF_SilverRich_YW209G: 10157,
  AAF_SilverSarouk_935_84874: 10158,
  AAF_SimpsonClay_8G200A: 10159,
  AAF_SkybridgePearl_YY291A: 10160,
  AAF_SlatePearlLowSheen_8Y213A: 10161,
  AAF_SmokeyQuartz_E60TB: 10162,
  AAF_SmoothOnyx_E25TB: 10163,
  AAF_SnowDust_GA228A: 10164,
  AAF_Sorcerer_YJ254A: 10165,
  AAF_SovereignGold_E78GM: 10166,
  AAF_SpaceBlue_984_19990: 10167,
  AAF_SpaceBlue_MJ008A: 10168,
  AAF_SpanishEyes_YY279A: 10169,
  AAF_SpecialWhite_100_3270: 10170,
  AAF_SpecialWhite_MA042A: 10171,
  AAF_StarDust_E70NM: 10172,
  AAF_StarryNightPearl_260_9139Q: 10173,
  AAF_Steel_971_57127: 10174,
  AAF_SteelPearlLowSheen_8Y215A: 10175,
  AAF_StellaGrey_E78NM: 10176,
  AAF_StElmosFireKinetic_971_7208K: 10177,
  AAF_StfNewDarkBeige_GZ306A: 10178,
  AAF_StoneBeige_260_32538: 10179,
  AAF_StoneBeige_GD247A: 10180,
  AAF_StoneBeigeScylla_901_85474: 10181,
  AAF_StoneGrey_260_78126: 10182,
  AAF_StoneGrey_272_78126: 10183,
  AAF_StormFront_GL249A: 10184,
  AAF_StormGreyN42_GL060A: 10185,
  AAF_StormGreyScylla_901_50183: 10186,
  AAF_StreetwiseSilver_910_7049Q: 10187,
  AAF_Stromboli_GK148A: 10188,
  AAF_SubtleBlue_906_5177K: 10189,
  AAF_SummerMaize_E82GM: 10190,
  AAF_SupremeSilverPearl_260_7466Q: 10191,
  AAF_Surfmist_260_1137S: 10192,
  AAF_Surfmist_260_3167M: 10193,
  AAF_Surfmist_272_1137S: 10194,
  AAF_Surfmist_40X_1182S: 10195,
  AAF_Surfmist_90E_1330Z: 10196,
  AAF_Surfmist_959_84758: 10197,
  AAF_Surfmist_GA236A: 10198,
  AAF_Surfmist_GB136A: 10199,
  AAF_Surfmist_YA236A: 10200,
  AAF_SurfPearlLowSheen_8Y208A: 10201,
  AAF_SwordPearl_260_7468Q: 10202,
  AAF_Talc_900_84682: 10203,
  AAF_Talc_90Z_1344S: 10204,
  AAF_TanninPearl_YY173A: 10205,
  AAF_Terrain_260_8232S: 10206,
  AAF_Terrain_260_8234M: 10207,
  AAF_Terrain_GM243A: 10208,
  AAF_TexturaDeepOcean_GJ301A: 10209,
  AAF_TexturaDune_GL352A: 10210,
  AAF_TexturaIronstone_GL336A: 10211,
  AAF_TexturaJasper_GM314A: 10212,
  AAF_TexturaMonument_GL329A: 10213,
  AAF_TexturaPaperbark_GD314A: 10214,
  AAF_TexturaPrimrose_GD331A: 10215,
  AAF_TexturaSilver_GN305A: 10216,
  AAF_TexturaSilver_GY35LA: 10217,
  AAF_TexturaSurfmist_GA336A: 10218,
  AAF_TexturaWoodlandGrey_GL333A: 10219,
  AAF_TitaniumPearl_8Y263A: 10220,
  AAF_TitaniumPearl_YY263A: 10221,
  AAF_TorresBlue_GJ215A: 10222,
  AAF_ToyotaWhite040_GA019A: 10223,
  AAF_TransformerGrey_984_32186: 10224,
  AAF_TransformerGrey_GL031A: 10225,
  AAF_TreasuredSilverPearl_GW103C: 10226,
  AAF_TreasuredSilverPearl_GW103K: 10227,
  AAF_TrophyPearl_260_7470Q: 10228,
  AAF_TurquoiseSea_8K218A: 10229,
  AAF_TuscanRed_E47RL: 10230,
  AAF_TyphoonPearl_260_7469Q: 10231,
  AAF_UltraBlack_GN261A: 10232,
  AAF_UltraSilver_GY070A: 10233,
  AAF_UrbanPearl_260_7467Q: 10234,
  AAF_VelocityGreen_910_33709: 10235,
  AAF_VintageSilver_906_7377K: 10236,
  AAF_ViperGreen_GK051A: 10237,
  AAF_ViperGreen_YK051A: 10238,
  AAF_Wallaby_260_7474S: 10239,
  AAF_Wallaby_260_7476M: 10240,
  AAF_Wallaby_GL210A: 10241,
  AAF_WeatheredCopper_272_33724: 10242,
  AAF_WeatheredSteel_90E_8340Z: 10243,
  AAF_Wedgewood_272_50279: 10244,
  AAF_Wedgewood_MJ180A: 10245,
  AAF_WetlandFern_YY289A: 10246,
  AAF_White_260_1139S: 10247,
  AAF_White_272_1139S: 10248,
  AAF_White_40X_1157S: 10249,
  AAF_White_8A202A: 10250,
  AAF_White_910_19143: 10251,
  AAF_White_961_32312: 10252,
  AAF_White_GA113A: 10253,
  AAF_White_GA124A: 10254,
  AAF_WhiteBirch_260_2057G: 10255,
  AAF_WhiteBirch_272_37131: 10256,
  AAF_WhiteBirch_GA057A: 10257,
  AAF_WhiteBirch_YA057A: 10258,
  AAF_WhiteBirchGloss_101_6355: 10259,
  AAF_WhiteFlatMatt_YA25BA: 10260,
  AAF_WhiteMatt_103_1710: 10261,
  AAF_Wilderness_272_84224: 10262,
  AAF_Wilderness_GK289A: 10263,
  AAF_WILDERNESS_GK289A: 10264,
  AAF_Wilderness_GS189A: 10265,
  AAF_Windspray_260_7256S: 10266,
  AAF_Windspray_260_7559M: 10267,
  AAF_Windspray_272_7256S: 10268,
  AAF_Windspray_GL266A: 10269,
  AAF_Windspray_GP166A: 10270,
  AAF_WineberryPrl_YY21EA: 10271,
  AAF_Wizard_GJ054A: 10272,
  AAF_WoodlandGrey_260_6255S: 10273,
  AAF_WoodlandGrey_260_6256M: 10274,
  AAF_WoodlandGrey_272_7255S: 10275,
  AAF_WoodlandGrey_959_51698: 10276,
  AAF_WoodlandGrey_GL205A: 10277,
  AAF_WoodlandGrey_GP105A: 10278,
  AAF_X15Orange_MF035A: 10279,
  AAF_XtremeBlack_964_56970: 10280,
  AAF_XtremeChampagne_964_7302Q: 10281,
  AAF_XtremeCharcoal_964_7297M: 10282,
  AAF_XtremeCoin_964_7289S: 10283,
  AAF_XtremeSilver_964_7273Q: 10284,
  AAF_XtremeWhite_964_1157M: 10285,
  AAF_YellowGold_265_2188G: 10286,
  AAF_YellowGold_984_33617: 10287,
  AAF_YellowGold_ME038A: 10288,
  AAF_ZeusBlack_900_88702: 10289,
  AAF_ZeusBlack_90Z_9202M: 10290,
  AAF_ZeusCharcoal_900_87732: 10291,
  AAF_ZeusCharcoal_90Z_7766S: 10292,
  AAF_ZeusDarkGrey_900_51275: 10293,
  AAF_ZeusDarkGrey_90Z_7767M: 10294,
  AAF_ZeusGrey_900_88416: 10295,
  AAF_ZeusGrey_90Z_7768S: 10296,
  AAF_ZeusLunarEclipse_900_87734: 10297,
  AAF_ZeusLunarEclipse_90Z_9203S: 10298,
  AAF_ZeusLunarGrey_900_88417: 10299,
  AAF_ZeusLunarGrey_90Z_7769M: 10300,
  AAF_ZeusSilverGrey_900_51272: 10301,
  AAF_ZeusSilverGrey_90Z_7770M: 10302,
  AAF_ZeusTimberland_900_7315S: 10303,
  AAF_ZeusTimberland_90Z_7315S: 10304,
  AAF_ZeusWhite_900_1110G: 10305,
  AAF_ZeusWhite_90Z_1110G: 10306,
};

const DMC_Window_AMSCO = {
  AMSCO_Black: 10383,
  AMSCO_Bronze: 10384,
  AMSCO_Brown: 10385,
  AMSCO_Clay: 10386,
  AMSCO_Cream: 10387,
  AMSCO_DarkBrown: 10388,
  AMSCO_ForestGreen: 10389,
  AMSCO_Gray: 10390,
  AMSCO_Green: 10391,
  AMSCO_Olive: 10392,
  AMSCO_Red: 10393,
  AMSCO_Silver: 10394,
  AMSCO_Taupe: 10395,
  AMSCO_White: 10396,
};

const DMC_Window_AllTemp = {
  Adobe: 4459,
  Black: 10706,
  Sandstone: 4460,
  White: 4461,
};

const DMC_Window_Alliance = {
  Alliance_ArcticBlue: 10787,
  Alliance_Black: 10788,
  Alliance_Clay: 10789,
  Alliance_DarkBronze: 10790,
  Alliance_ForestGreen: 10791,
  Alliance_GunMetal: 10792,
  Alliance_IvoryCream: 10793,
  Alliance_RoyalBrown: 10794,
  Alliance_Tan: 10795,
  Alliance_TerraBronze: 10796,
  Alliance_White: 10797,
};

const DMC_Window_Andersen = {
  Window_Andersen_Black: 11486,
  Window_Andersen_White: 11487,
};

const DMC_Window_Anderson = {
  Black: 10774,
  Canvas: 10775,
  DarkBronze: 10776,
  ForestGreen: 10777,
  Sandtone: 10778,
  Terratone: 10779,
  White: 10780,
};

const DMC_Window_Atrium = {
  Atrium_Almond: 10900,
  Atrium_Black: 10901,
  Atrium_BrickRed: 10902,
  Atrium_Bronze: 10903,
  Atrium_Clay: 10904,
  Atrium_DarkChocolate: 10905,
  Atrium_Gray: 10906,
  Atrium_HunterGreen: 10907,
  Atrium_Tan: 10908,
  Atrium_Terratone: 10909,
  Atrium_White: 10910,
};

const DMC_Window_Cascade = {
  Cascade_Almond: 10649,
  Cascade_Black: 10650,
  Cascade_Bronze: 10651,
  Cascade_Clay: 10652,
  Cascade_White: 10653,
};

const DMC_Window_Colors = {
  Black: 242,
  Bronze: 1801,
  DesertSand: 243,
  Taupe: 1981,
  White: 244,
};

const DMC_Window_Elevate = {
  Elevate_Black: 4487,
  Elevate_Bronze: 4488,
  Elevate_Khaki: 4489,
  Elevate_Taupe: 4490,
  Elevate_White: 4491,
};

const DMC_Window_Gerkin = {
  Gerkin_Midnight: 10654,
  Gerkin_Sandstone: 10655,
  Gerkin_Tan: 10656,
  Gerkin_White: 10657,
};

const DMC_Window_Harvey = {
  Harvey_Almond: 10659,
  Harvey_Black: 10670,
  Harvey_Bronze: 10671,
  Harvey_Cranberry: 10672,
  Harvey_DarkBronze: 10673,
  Harvey_ForestGreen: 10674,
  Harvey_Ivory: 10675,
  Harvey_MatteBlack: 10676,
  Harvey_WedgewoodBlue: 10677,
  Harvey_White: 10660,
};

const DMC_Window_HoffmanWeber = {
  HW_Black: 10629,
  HW_Bronze: 10630,
  HW_Clay: 10631,
  HW_Sandstone: 10632,
  HW_White: 10633,
};

const DMC_Window_JeldWen = {
  Almond: 10701,
  Black: 10702,
  Bronze: 10703,
  DesertSand: 10704,
  White: 10705,
};

const DMC_Window_Lindsay = {
  AnthraciteGrayLaminate: 2109,
  BlackLaminate: 2110,
  BrickRed510: 2111,
  BronzeLaminate: 2112,
  Buttercream712: 2113,
  Clay: 2114,
  Clay145: 2115,
  CreamWhite100: 2116,
  LindsayBronze9001: 2117,
  LindsayEarthtone9003: 2118,
  LindsayGreen9002: 2119,
  LindsaySandstone9004: 2120,
  MidnightBlack201: 2121,
  MountainRidge: 2122,
  Parchment: 2123,
  RoyalBrown905: 2124,
  Sandstone: 2125,
  SilverMetallicLaminate: 2126,
  StormGray310: 2127,
  Terratone9005: 2128,
  White: 2129,
};

const DMC_Window_MGM = {
  MGM_Black: 11420,
  MGM_Bronze: 11421,
  MGM_Earthtone: 11422,
  MGM_Tan: 11423,
  MGM_White: 10879,
};

const DMC_Window_MI = {
  Almond: 4634,
  AntiqueBrown: 6440,
  Black: 4635,
  Bronze: 4636,
  Clay: 4637,
  Cocoa: 4638,
  Cream: 4639,
  Earthtone: 6441,
  ForestGreen: 4640,
  MysticGray: 6442,
  PaintersWhite: 6443,
  RoyalBrown: 6444,
  Sandstone: 6445,
  Silver: 4641,
  Tan: 6446,
  VintageLinen: 6447,
  White: 4642,
};

const DMC_Window_Marvin = {
  Marvin_Bronze: 10950,
  Marvin_Cashmere: 10951,
  Marvin_Ebony: 10952,
  Marvin_Gunmetal: 10953,
  Marvin_PaintedDesignerBlack: 21108,
  Marvin_PaintedDesignerWhite: 21109,
  Marvin_PebbleGray: 10954,
  Marvin_StoneWhite: 10955,
};

const DMC_Window_MidwayWindows = {
  Midway_ArcticBlue: 11442,
  Midway_Black: 11443,
  Midway_Clay: 11444,
  Midway_DarkBronze: 11445,
  Midway_ForestGreen: 11446,
  Midway_Gunmetal: 11447,
  Midway_IvoryCream: 11448,
  Midway_RoyalBrown: 11449,
  Midway_Tan: 11450,
  Midway_TerraBronze: 11451,
  Midway_White: 11452,
};

const DMC_Window_Milgard = {
  Adobe: 4427,
  Almond: 4428,
  Black: 4429,
  Bronze: 4430,
  White: 4431,
};

const DMC_Window_PGT = {
  Black: 4466,
  Bronze: 4467,
  ClearAnodize: 4468,
  White: 4469,
};

const DMC_Window_Pella = {
  Pella_Alum_Almond: 6422,
  Pella_Alum_Black: 6423,
  Pella_Alum_BrickRed: 6424,
  Pella_Alum_Brown: 6425,
  Pella_Alum_ClassicWhite: 6426,
  Pella_Alum_Fossil: 6427,
  Pella_Alum_HarfordGreen: 6428,
  Pella_Alum_IronOre: 6429,
  Pella_Alum_Portobello: 6430,
  Pella_Alum_Putty: 6431,
  Pella_Alum_White: 6432,
  Pella_Alum_WolfGray: 6433,
  Pella_Black: 6417,
  Pella_Brown: 6418,
  Pella_MorningSkyGray: 6419,
  Pella_Tan: 6420,
  Pella_White: 6421,
};

const DMC_Window_PlyGem = {
  Adobe: 2012,
  Almond: 2040,
  Beige: 2041,
  Black: 2042,
  Bronze: 2043,
  Clay: 2044,
  DarkBronze: 2045,
  DoveGrey: 2046,
  Sand: 2047,
  TerraBeige: 2013,
  White: 2014,
};

const DMC_Window_Prime = {
  Prime_Adobe: 10967,
  Prime_Almond: 10968,
  Prime_Black: 10969,
  Prime_Brown: 10970,
  Prime_CranberryRed: 10971,
  Prime_Green: 10972,
  Prime_Silver: 10973,
  Prime_White: 10974,
};

const DMC_Window_Reliabilt = {
  Reliabilt_Black: 11354,
  Reliabilt_BrickRed: 11355,
  Reliabilt_Bronze: 11356,
  Reliabilt_Clay: 11357,
  Reliabilt_DarkChocolate: 11358,
  Reliabilt_Gray: 11359,
  Reliabilt_HunterGreen: 11360,
  Reliabilt_Tan: 11361,
  Reliabilt_Terratone: 11362,
};

const DMC_Window_Silverline = {
  Beige: 1749,
  Black: 1750,
  DarkBronze: 1751,
  Sandstone: 1752,
  White: 1753,
};

const DMC_Window_United = {
  United_AnthraciteGrey: 10454,
  United_Beige: 10455,
  United_Black: 10456,
  United_BrickRed: 10457,
  United_Bronze: 10458,
  United_Clay: 10459,
  United_Gray: 10460,
  United_Green: 10461,
  United_Sable: 10462,
  United_White: 10463,
};

const DMC_Window_Westlake = {
  Clay: 6414,
  Pebblestone: 6415,
  Tan: 10781,
  White: 6416,
};

const DMC_Window_WinDor = {
  Beige: 6434,
  BeigeCoated: 6435,
  Bronze: 6436,
  JetBlack: 6437,
  TaupeCoated: 6438,
  White: 6439,
};

const DMC_Window_Windsor = {
  Windsor_Black: 10864,
  Windsor_Cinnamon: 10880,
  Windsor_Clay: 10865,
  Windsor_DarkBronze: 10866,
  Windsor_Ivory: 10867,
  Windsor_White: 10868,
};

const DMC_Window_YKK = {
  YKK_Black: 11217,
  YKK_Bronze: 11218,
  YKK_Stone: 11219,
  YKK_Tan: 11220,
  YKK_White: 11221,
};

const DMC_WolfHomeProducts = {
  WHP_White: 11340,
};

const DMC_Wood_ChamClad = {
  Wood_ChamClad_6001_BeachwoodGrey: 10830,
  Wood_ChamClad_6020_SunbleachedOak: 10831,
  Wood_ChamClad_6036_Toffee: 10832,
  Wood_ChamClad_6045_BarrelOak: 10833,
  Wood_ChamClad_6046_CinnamonWalnut: 10834,
  Wood_ChamClad_6050_SugarMaple: 10835,
  Wood_ChamClad_6088_BlueRiver: 10836,
  Wood_ChamClad_6105_Sandlewood: 10837,
  Wood_ChamClad_7010_Honey: 10838,
  Wood_ChamClad_7027_HarvestWalnut: 10839,
  Wood_ChamClad_7080_RockyMountainOak: 10840,
  Wood_ChamClad_7081_ManhattanNaturalOak: 10841,
  Wood_ChamClad_CanadianPine: 11364,
  Wood_ChamClad_Cypress: 11365,
  Wood_ChamClad_WhiteOak: 11366,
};

const DMC_Wood_Fiberon = {
  Fiberon_BeachHouse: 11319,
  Fiberon_Bungalow: 11320,
  Fiberon_Cabana: 11321,
  Fiberon_Cabin: 11322,
  Fiberon_Cottage: 11323,
  Fiberon_TuscanVilla: 11324,
};

const DMC_Wood_LUX = {
  Wood_LUX_Charwood: 10842,
  Wood_LUX_Cypress: 10843,
  Wood_LUX_WhiteOak: 10844,
};

const DMC_Wood_Messmers = {
  Wood_Messmers_CapeCodGray: 10845,
  Wood_Messmers_CharcoalGray: 10881,
  Wood_Messmers_ColoradoBrown: 11409,
  Wood_Messmers_DarkWalnut: 11410,
  Wood_Messmers_DriftwoodGray: 10846,
  Wood_Messmers_LakesideBrown: 11411,
  Wood_Messmers_MissionOak: 11412,
  Wood_Messmers_Natural: 11413,
  Wood_Messmers_NaturalCedar: 11414,
  Wood_Messmers_NaturalPineFir: 11415,
  Wood_Messmers_NaturalRedwood: 11416,
  Wood_Messmers_NavajoRed: 11417,
  Wood_Messmers_OakBrown: 11418,
  Wood_Messmers_OxfordBrown: 10847,
  Wood_Messmers_SequioaRed: 11419,
};

const DMC_Wood_MicroProSienna = {
  Wood_MicroProSienna_PressureTreatedWood: 11065,
};

const DMC_Wood_OldMasters = {
  Wood_OldMasters_AgedOak: 10848,
  Wood_OldMasters_AmericanWalnut: 11066,
  Wood_OldMasters_CarbonBlack: 10849,
  Wood_OldMasters_DarkWalnut: 10850,
  Wood_OldMasters_Espresso: 10851,
  Wood_OldMasters_FruitWood: 10852,
  Wood_OldMasters_NaturalWalnut: 11067,
  Wood_OldMasters_Provincial: 10853,
  Wood_OldMasters_SpanishOak: 10854,
  Wood_OldMasters_SpecialWalnut: 10855,
  Wood_OldMasters_WeatheredWood: 10856,
};

const DMC_Wood_Olympic = {
  Wood_Olympic_CanyonBrown: 10882,
  Wood_Olympic_Cedar: 10883,
  Wood_Olympic_HoneyGold: 10884,
  Wood_Olympic_Redwood: 10885,
};

const DMC_Wood_PittsburghStains = {
  Wood_Pittsburgh_Ginger: 21110,
  Wood_Pittsburgh_GingerBrown: 10960,
  Wood_Pittsburgh_Mink: 10961,
};

const DMC_Wood_ProWood = {
  ProWood_PressureTreatedSouthernYellowPine: 11068,
};

const DMC_Wood_Varathane = {
  Wood_Varathane_AmericanWalnut: 10886,
  Wood_Varathane_Black: 10887,
  Wood_Varathane_Briarsmoke: 10888,
  Wood_Varathane_CarbonGray: 10889,
  Wood_Varathane_Cherrywood: 10890,
  Wood_Varathane_Cognac: 10891,
  Wood_Varathane_DarkWalnut: 10892,
  Wood_Varathane_GoldenOak: 10893,
  Wood_Varathane_Hickory: 10894,
  Wood_Varathane_JetBlack: 10895,
  Wood_Varathane_Kona: 10896,
  Wood_Varathane_Mahogany: 10897,
  Wood_Varathane_MidnightBlue: 10898,
  Wood_Varathane_WeatheredGray: 10899,
};

const DMC_Wood_WayneDalton = {
  Wood_WD_Beachwood: 10857,
  Wood_WD_Black: 10858,
  Wood_WD_CarbonOak: 10859,
  Wood_WD_Cedar: 10860,
  Wood_WD_MediumOak: 10861,
};

export const DMC: {
  AlscoMetals: typeof DMC_AlscoMetals;
  Alside: typeof DMC_Alside;
  Ascend: typeof DMC_Ascend;
  Behr: typeof DMC_Behr;
  BenjaminMoore: typeof DMC_BenjaminMoore;
  BuildersEdge: typeof DMC_BuildersEdge;
  CHI_Colors: typeof DMC_CHI_Colors;
  Certainteed: typeof DMC_Certainteed;
  Concrete_SherwinWilliams: typeof DMC_Concrete_SherwinWilliams;
  DiamondKote: typeof DMC_DiamondKote;
  Dulux: typeof DMC_Dulux;
  DunnEdwards: typeof DMC_DunnEdwards;
  DuraSeal_Stains: typeof DMC_DuraSeal_Stains;
  FloridaPaints: typeof DMC_FloridaPaints;
  FoundrySiding: typeof DMC_FoundrySiding;
  Garaga: typeof DMC_Garaga;
  Garage_Amarr: typeof DMC_Garage_Amarr;
  Garage_Clopay: typeof DMC_Garage_Clopay;
  Garage_Colors: typeof DMC_Garage_Colors;
  Garage_DoorLink: typeof DMC_Garage_DoorLink;
  Garage_GeneralDoors: typeof DMC_Garage_GeneralDoors;
  Garage_Hormann: typeof DMC_Garage_Hormann;
  Garage_Martin: typeof DMC_Garage_Martin;
  Garage_OverheadDoor: typeof DMC_Garage_OverheadDoor;
  Garage_Windsor: typeof DMC_Garage_Windsor;
  GeorgiaPacific: typeof DMC_GeorgiaPacific;
  Glidden: typeof DMC_Glidden;
  Grout_ProVia: typeof DMC_Grout_ProVia;
  GutterHelp: typeof DMC_GutterHelp;
  HaasDoor: typeof DMC_HaasDoor;
  Harris: typeof DMC_Harris;
  JamesHardie: typeof DMC_JamesHardie;
  KellyMoore: typeof DMC_KellyMoore;
  LP_SmartSide: typeof DMC_LP_SmartSide;
  Lonestar: typeof DMC_Lonestar;
  MW_SherwinWilliamsStains: typeof DMC_MW_SherwinWilliamsStains;
  Masonite: typeof DMC_Masonite;
  McCormick: typeof DMC_McCormick;
  MetalPowder_Colors: typeof DMC_MetalPowder_Colors;
  Metal_ABC: typeof DMC_Metal_ABC;
  Metal_ACM: typeof DMC_Metal_ACM;
  Metal_AE: typeof DMC_Metal_AE;
  Metal_AFCORail: typeof DMC_Metal_AFCORail;
  Metal_ASC: typeof DMC_Metal_ASC;
  Metal_Amerimax: typeof DMC_Metal_Amerimax;
  Metal_BandA: typeof DMC_Metal_BandA;
  Metal_BerridgeColors: typeof DMC_Metal_BerridgeColors;
  Metal_CMG: typeof DMC_Metal_CMG;
  Metal_CascadiaMetals: typeof DMC_Metal_CascadiaMetals;
  Metal_CentralStatesColors: typeof DMC_Metal_CentralStatesColors;
  Metal_ColorKlad: typeof DMC_Metal_ColorKlad;
  Metal_Colors: typeof DMC_Metal_Colors;
  Metal_DrexelColors: typeof DMC_Metal_DrexelColors;
  Metal_Englert: typeof DMC_Metal_Englert;
  Metal_Everlast: typeof DMC_Metal_Everlast;
  Metal_Fabral: typeof DMC_Metal_Fabral;
  Metal_HomeRail: typeof DMC_Metal_HomeRail;
  Metal_JetMetals: typeof DMC_Metal_JetMetals;
  Metal_MBCI: typeof DMC_Metal_MBCI;
  Metal_McElroy: typeof DMC_Metal_McElroy;
  Metal_MetalRoofingSystems: typeof DMC_Metal_MetalRoofingSystems;
  Metal_Mueller: typeof DMC_Metal_Mueller;
  Metal_PAC: typeof DMC_Metal_PAC;
  Metal_ProSnap: typeof DMC_Metal_ProSnap;
  Metal_ProVia: typeof DMC_Metal_ProVia;
  Metal_Scheffield: typeof DMC_Metal_Scheffield;
  Metal_SchellColors: typeof DMC_Metal_SchellColors;
  Metal_Sentriclad: typeof DMC_Metal_Sentriclad;
  Metal_SpectraPro: typeof DMC_Metal_SpectraPro;
  Metal_WesternStatesColors: typeof DMC_Metal_WesternStatesColors;
  MidAmerica: typeof DMC_MidAmerica;
  Monier: typeof DMC_Monier;
  Mortar_GeneralShale: typeof DMC_Mortar_GeneralShale;
  Norandex: typeof DMC_Norandex;
  Olympic: typeof DMC_Olympic;
  Omega_Stucco: typeof DMC_Omega_Stucco;
  PPG: typeof DMC_PPG;
  PaintSpare_Colors: typeof DMC_PaintSpare_Colors;
  PlyGem: typeof DMC_PlyGem;
  Richwood: typeof DMC_Richwood;
  Rollex: typeof DMC_Rollex;
  RoyalBuilding: typeof DMC_RoyalBuilding;
  Schell_Colors: typeof DMC_Schell_Colors;
  SherwinWilliams: typeof DMC_SherwinWilliams;
  Superior: typeof DMC_Superior;
  SystemColors: typeof DMC_SystemColors;
  ThermaTru: typeof DMC_ThermaTru;
  TimberTech: typeof DMC_TimberTech;
  UnionCorrugating: typeof DMC_UnionCorrugating;
  Valspar: typeof DMC_Valspar;
  Variform: typeof DMC_Variform;
  Waudena: typeof DMC_Waudena;
  WausauSupply: typeof DMC_WausauSupply;
  WayneDalton: typeof DMC_WayneDalton;
  Weatherables: typeof DMC_Weatherables;
  Westlake: typeof DMC_Westlake;
  Window_AAF: typeof DMC_Window_AAF;
  Window_AMSCO: typeof DMC_Window_AMSCO;
  Window_AllTemp: typeof DMC_Window_AllTemp;
  Window_Alliance: typeof DMC_Window_Alliance;
  Window_Andersen: typeof DMC_Window_Andersen;
  Window_Anderson: typeof DMC_Window_Anderson;
  Window_Atrium: typeof DMC_Window_Atrium;
  Window_Cascade: typeof DMC_Window_Cascade;
  Window_Colors: typeof DMC_Window_Colors;
  Window_Elevate: typeof DMC_Window_Elevate;
  Window_Gerkin: typeof DMC_Window_Gerkin;
  Window_Harvey: typeof DMC_Window_Harvey;
  Window_HoffmanWeber: typeof DMC_Window_HoffmanWeber;
  Window_JeldWen: typeof DMC_Window_JeldWen;
  Window_Lindsay: typeof DMC_Window_Lindsay;
  Window_MGM: typeof DMC_Window_MGM;
  Window_MI: typeof DMC_Window_MI;
  Window_Marvin: typeof DMC_Window_Marvin;
  Window_MidwayWindows: typeof DMC_Window_MidwayWindows;
  Window_Milgard: typeof DMC_Window_Milgard;
  Window_PGT: typeof DMC_Window_PGT;
  Window_Pella: typeof DMC_Window_Pella;
  Window_PlyGem: typeof DMC_Window_PlyGem;
  Window_Prime: typeof DMC_Window_Prime;
  Window_Reliabilt: typeof DMC_Window_Reliabilt;
  Window_Silverline: typeof DMC_Window_Silverline;
  Window_United: typeof DMC_Window_United;
  Window_Westlake: typeof DMC_Window_Westlake;
  Window_WinDor: typeof DMC_Window_WinDor;
  Window_Windsor: typeof DMC_Window_Windsor;
  Window_YKK: typeof DMC_Window_YKK;
  WolfHomeProducts: typeof DMC_WolfHomeProducts;
  Wood_ChamClad: typeof DMC_Wood_ChamClad;
  Wood_Fiberon: typeof DMC_Wood_Fiberon;
  Wood_LUX: typeof DMC_Wood_LUX;
  Wood_Messmers: typeof DMC_Wood_Messmers;
  Wood_MicroProSienna: typeof DMC_Wood_MicroProSienna;
  Wood_OldMasters: typeof DMC_Wood_OldMasters;
  Wood_Olympic: typeof DMC_Wood_Olympic;
  Wood_PittsburghStains: typeof DMC_Wood_PittsburghStains;
  Wood_ProWood: typeof DMC_Wood_ProWood;
  Wood_Varathane: typeof DMC_Wood_Varathane;
  Wood_WayneDalton: typeof DMC_Wood_WayneDalton;
} = {
  AlscoMetals: DMC_AlscoMetals,
  Alside: DMC_Alside,
  Ascend: DMC_Ascend,
  Behr: DMC_Behr,
  BenjaminMoore: DMC_BenjaminMoore,
  BuildersEdge: DMC_BuildersEdge,
  CHI_Colors: DMC_CHI_Colors,
  Certainteed: DMC_Certainteed,
  Concrete_SherwinWilliams: DMC_Concrete_SherwinWilliams,
  DiamondKote: DMC_DiamondKote,
  Dulux: DMC_Dulux,
  DunnEdwards: DMC_DunnEdwards,
  DuraSeal_Stains: DMC_DuraSeal_Stains,
  FloridaPaints: DMC_FloridaPaints,
  FoundrySiding: DMC_FoundrySiding,
  Garaga: DMC_Garaga,
  Garage_Amarr: DMC_Garage_Amarr,
  Garage_Clopay: DMC_Garage_Clopay,
  Garage_Colors: DMC_Garage_Colors,
  Garage_DoorLink: DMC_Garage_DoorLink,
  Garage_GeneralDoors: DMC_Garage_GeneralDoors,
  Garage_Hormann: DMC_Garage_Hormann,
  Garage_Martin: DMC_Garage_Martin,
  Garage_OverheadDoor: DMC_Garage_OverheadDoor,
  Garage_Windsor: DMC_Garage_Windsor,
  GeorgiaPacific: DMC_GeorgiaPacific,
  Glidden: DMC_Glidden,
  Grout_ProVia: DMC_Grout_ProVia,
  GutterHelp: DMC_GutterHelp,
  HaasDoor: DMC_HaasDoor,
  Harris: DMC_Harris,
  JamesHardie: DMC_JamesHardie,
  KellyMoore: DMC_KellyMoore,
  LP_SmartSide: DMC_LP_SmartSide,
  Lonestar: DMC_Lonestar,
  MW_SherwinWilliamsStains: DMC_MW_SherwinWilliamsStains,
  Masonite: DMC_Masonite,
  McCormick: DMC_McCormick,
  MetalPowder_Colors: DMC_MetalPowder_Colors,
  Metal_ABC: DMC_Metal_ABC,
  Metal_ACM: DMC_Metal_ACM,
  Metal_AE: DMC_Metal_AE,
  Metal_AFCORail: DMC_Metal_AFCORail,
  Metal_ASC: DMC_Metal_ASC,
  Metal_Amerimax: DMC_Metal_Amerimax,
  Metal_BandA: DMC_Metal_BandA,
  Metal_BerridgeColors: DMC_Metal_BerridgeColors,
  Metal_CMG: DMC_Metal_CMG,
  Metal_CascadiaMetals: DMC_Metal_CascadiaMetals,
  Metal_CentralStatesColors: DMC_Metal_CentralStatesColors,
  Metal_ColorKlad: DMC_Metal_ColorKlad,
  Metal_Colors: DMC_Metal_Colors,
  Metal_DrexelColors: DMC_Metal_DrexelColors,
  Metal_Englert: DMC_Metal_Englert,
  Metal_Everlast: DMC_Metal_Everlast,
  Metal_Fabral: DMC_Metal_Fabral,
  Metal_HomeRail: DMC_Metal_HomeRail,
  Metal_JetMetals: DMC_Metal_JetMetals,
  Metal_MBCI: DMC_Metal_MBCI,
  Metal_McElroy: DMC_Metal_McElroy,
  Metal_MetalRoofingSystems: DMC_Metal_MetalRoofingSystems,
  Metal_Mueller: DMC_Metal_Mueller,
  Metal_PAC: DMC_Metal_PAC,
  Metal_ProSnap: DMC_Metal_ProSnap,
  Metal_ProVia: DMC_Metal_ProVia,
  Metal_Scheffield: DMC_Metal_Scheffield,
  Metal_SchellColors: DMC_Metal_SchellColors,
  Metal_Sentriclad: DMC_Metal_Sentriclad,
  Metal_SpectraPro: DMC_Metal_SpectraPro,
  Metal_WesternStatesColors: DMC_Metal_WesternStatesColors,
  MidAmerica: DMC_MidAmerica,
  Monier: DMC_Monier,
  Mortar_GeneralShale: DMC_Mortar_GeneralShale,
  Norandex: DMC_Norandex,
  Olympic: DMC_Olympic,
  Omega_Stucco: DMC_Omega_Stucco,
  PPG: DMC_PPG,
  PaintSpare_Colors: DMC_PaintSpare_Colors,
  PlyGem: DMC_PlyGem,
  Richwood: DMC_Richwood,
  Rollex: DMC_Rollex,
  RoyalBuilding: DMC_RoyalBuilding,
  Schell_Colors: DMC_Schell_Colors,
  SherwinWilliams: DMC_SherwinWilliams,
  Superior: DMC_Superior,
  SystemColors: DMC_SystemColors,
  ThermaTru: DMC_ThermaTru,
  TimberTech: DMC_TimberTech,
  UnionCorrugating: DMC_UnionCorrugating,
  Valspar: DMC_Valspar,
  Variform: DMC_Variform,
  Waudena: DMC_Waudena,
  WausauSupply: DMC_WausauSupply,
  WayneDalton: DMC_WayneDalton,
  Weatherables: DMC_Weatherables,
  Westlake: DMC_Westlake,
  Window_AAF: DMC_Window_AAF,
  Window_AMSCO: DMC_Window_AMSCO,
  Window_AllTemp: DMC_Window_AllTemp,
  Window_Alliance: DMC_Window_Alliance,
  Window_Andersen: DMC_Window_Andersen,
  Window_Anderson: DMC_Window_Anderson,
  Window_Atrium: DMC_Window_Atrium,
  Window_Cascade: DMC_Window_Cascade,
  Window_Colors: DMC_Window_Colors,
  Window_Elevate: DMC_Window_Elevate,
  Window_Gerkin: DMC_Window_Gerkin,
  Window_Harvey: DMC_Window_Harvey,
  Window_HoffmanWeber: DMC_Window_HoffmanWeber,
  Window_JeldWen: DMC_Window_JeldWen,
  Window_Lindsay: DMC_Window_Lindsay,
  Window_MGM: DMC_Window_MGM,
  Window_MI: DMC_Window_MI,
  Window_Marvin: DMC_Window_Marvin,
  Window_MidwayWindows: DMC_Window_MidwayWindows,
  Window_Milgard: DMC_Window_Milgard,
  Window_PGT: DMC_Window_PGT,
  Window_Pella: DMC_Window_Pella,
  Window_PlyGem: DMC_Window_PlyGem,
  Window_Prime: DMC_Window_Prime,
  Window_Reliabilt: DMC_Window_Reliabilt,
  Window_Silverline: DMC_Window_Silverline,
  Window_United: DMC_Window_United,
  Window_Westlake: DMC_Window_Westlake,
  Window_WinDor: DMC_Window_WinDor,
  Window_Windsor: DMC_Window_Windsor,
  Window_YKK: DMC_Window_YKK,
  WolfHomeProducts: DMC_WolfHomeProducts,
  Wood_ChamClad: DMC_Wood_ChamClad,
  Wood_Fiberon: DMC_Wood_Fiberon,
  Wood_LUX: DMC_Wood_LUX,
  Wood_Messmers: DMC_Wood_Messmers,
  Wood_MicroProSienna: DMC_Wood_MicroProSienna,
  Wood_OldMasters: DMC_Wood_OldMasters,
  Wood_Olympic: DMC_Wood_Olympic,
  Wood_PittsburghStains: DMC_Wood_PittsburghStains,
  Wood_ProWood: DMC_Wood_ProWood,
  Wood_Varathane: DMC_Wood_Varathane,
  Wood_WayneDalton: DMC_Wood_WayneDalton,
};
